webpackJsonp([1],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(820);


/***/ },
/* 1 */,
/* 2 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(1004);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(1006);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(1003);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(167);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(167);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1023), __esModule: true };

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React       = __webpack_require__(1);
	var Interpolate = __webpack_require__(1463);
	var translator  = __webpack_require__(86);
	var extend      = __webpack_require__(26);
	
	var PropTypes = React.PropTypes;
	
	var translatorType = PropTypes.shape({
	  getLocale:        PropTypes.func,
	  onLocaleChange:   PropTypes.func,
	  offLocaleChange:  PropTypes.func,
	  translate:        PropTypes.func
	});
	
	var keyType = PropTypes.oneOfType([
	  PropTypes.string,
	  PropTypes.arrayOf(PropTypes.string)
	]);
	
	var Translate = React.createClass({
	  displayName: 'Translate',
	
	  contextTypes: {
	    translator: translatorType,
	    scope: keyType
	  },
	
	  propTypes: {
	    locale: PropTypes.string,
	    count:  PropTypes.number,
	    content: keyType,
	    scope: keyType,
	    attributes: PropTypes.object,
	    with: PropTypes.object
	  },
	
	  statics: {
	    textContentComponents: ['title', 'option', 'textarea']
	  },
	
	  getDefaultProps: function() {
	    return { component: 'span' };
	  },
	
	  getInitialState: function() {
	    return { locale: this.getTranslator().getLocale() };
	  },
	
	  getTranslator: function() {
	    return this.context.translator || translator;
	  },
	
	  componentDidMount: function() {
	    if (!this.props.locale) {
	      this.getTranslator().onLocaleChange(this.localeChanged);
	    }
	  },
	
	  componentWillUnmount: function() {
	    if (!this.props.locale) {
	      this.getTranslator().offLocaleChange(this.localeChanged);
	    }
	  },
	
	  localeChanged: function(newLocale) {
	    this.setState({ locale: newLocale });
	  },
	
	  render: function() {
	    var props           = extend({}, this.props);
	    var translator      = this.getTranslator();
	    var textContent     = Translate.textContentComponents.indexOf(props.component) > -1;
	    var interpolate     = textContent || props.unsafe === true;
	    var interpolations  = props.with;
	
	    var attributeKey;
	
	    var attributeTranslationOptions = extend(
	      { locale: this.state.locale, scope: this.context.scope },
	      props,
	      interpolations,
	      { interpolate: true }
	    );
	
	    var contentTranslationOptions = extend(
	      {},
	      attributeTranslationOptions,
	      { interpolate: interpolate }
	    );
	
	    delete props.locale;
	    delete props.scope;
	    delete props.count;
	    delete props.with;
	    delete props.fallback;
	
	    if (props.attributes) {
	      for (var name in props.attributes) {
	        attributeKey = props.attributes[name];
	
	        if (attributeKey) {
	          props[name] = translator.translate(attributeKey, attributeTranslationOptions);
	        }
	      }
	
	      delete props.attributes;
	    }
	
	    if (props.content) {
	      var translation      = translator.translate(props.content, contentTranslationOptions);
	      var interpolateProps = extend({}, props, { with: interpolations });
	
	      delete interpolateProps.content;
	      delete interpolateProps.children;
	
	      return React.createElement(Interpolate, interpolateProps, translation);
	    } else {
	      var component = props.component;
	
	      delete props.component;
	      delete props.unsafe;
	
	      return React.createElement(component, props);
	    }
	  }
	});
	
	module.exports = Translate;
	
	module.exports.translate = function(key, options) {
	  return React.createElement(Translate, extend({}, options, { content: key }));
	};
	
	module.exports.translatorType = translatorType;
	
	module.exports.getLocale = translator.getLocale.bind(translator);
	module.exports.setLocale = translator.setLocale.bind(translator);
	module.exports.onLocaleChange = translator.onLocaleChange.bind(translator);
	module.exports.offLocaleChange = translator.offLocaleChange.bind(translator);
	module.exports.registerTranslations = translator.registerTranslations.bind(translator);
	
	function withTranslations(DecoratedComponent, translations) {
	  if (!translations) {
	    return function(decoratedComponent) {
	      return withTranslations(decoratedComponent, DecoratedComponent);
	    };
	  }
	
	  var displayName =
	    DecoratedComponent.displayName ||
	    DecoratedComponent.name ||
	    'Component';
	
	  for (var locale in translations) {
	    var localeTranslations = translations[locale];
	    var scopedTranslations = {};
	
	    scopedTranslations[displayName] = localeTranslations;
	
	    translator.registerTranslations(locale, scopedTranslations);
	  }
	
	  return React.createClass({
	    displayName: displayName + 'WithTranslations',
	
	    childContextTypes: {
	      scope: keyType
	    },
	
	    getChildContext: function() {
	      return {
	        scope: displayName
	      };
	    },
	
	    render: function() {
	      return React.createElement(DecoratedComponent, this.props);
	    }
	  });
	}
	
	module.exports.withTranslations = withTranslations;


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    if (Object.getOwnPropertyNames) {
	        return (Object.getOwnPropertyNames(obj).length === 0);
	    } else {
	        var k;
	        for (k in obj) {
	            if (obj.hasOwnProperty(k)) {
	                return false;
	            }
	        }
	        return true;
	    }
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null,
	        rfc2822         : false,
	        weekdayMismatch : false
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.weekdayMismatch &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i = 0; i < momentProperties.length; i++) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    this._dayOfMonthOrdinalParseLenient = new RegExp(
	        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	            '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    ss : '%d seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid() && !isNaN(value)) {
	        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	        }
	        else {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	        }
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function mod(n, x) {
	    return ((n % x) + x) % x;
	}
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	function daysInMonth(year, month) {
	    if (isNaN(year) || isNaN(month)) {
	        return NaN;
	    }
	    var modMonth = mod(month, 12);
	    year += (month - modMonth) / 12;
	    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return isArray(this._months) ? this._months :
	            this._months['standalone'];
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return isArray(this._monthsShort) ? this._monthsShort :
	            this._monthsShort['standalone'];
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    // can't just apply() to create a date:
	    // https://stackoverflow.com/q/181348
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    // the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return isArray(this._weekdays) ? this._weekdays :
	            this._weekdays['standalone'];
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('k',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	addRegexToken('kk', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['k', 'kk'], function (input, array, config) {
	    var kInput = toInt(input);
	    array[HOUR] = kInput === 24 ? 0 : kInput;
	});
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return globalLocale;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            var aliasedRequire = require;
	            __webpack_require__(1345)("./" + name);
	            getSetGlobalLocale(oldLocale);
	        } catch (e) {}
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	        else {
	            if ((typeof console !==  'undefined') && console.warn) {
	                //warn user if arguments are passed but the locale could not be set
	                console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
	            }
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var locale, parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                locale = loadLocale(config.parentLocale);
	                if (locale != null) {
	                    parentConfig = locale._config;
	                } else {
	                    if (!localeFamilies[config.parentLocale]) {
	                        localeFamilies[config.parentLocale] = [];
	                    }
	                    localeFamilies[config.parentLocale].push({
	                        name: name,
	                        config: config
	                    });
	                    return null;
	                }
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, tmpLocale, parentConfig = baseConfig;
	        // MERGE
	        tmpLocale = loadLocale(name);
	        if (tmpLocale != null) {
	            parentConfig = tmpLocale._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear != null) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	
	    // check for mismatching day of week
	    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	        getParsingFlags(config).weekdayMismatch = true;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	    var result = [
	        untruncateYear(yearStr),
	        defaultLocaleMonthsShort.indexOf(monthStr),
	        parseInt(dayStr, 10),
	        parseInt(hourStr, 10),
	        parseInt(minuteStr, 10)
	    ];
	
	    if (secondStr) {
	        result.push(parseInt(secondStr, 10));
	    }
	
	    return result;
	}
	
	function untruncateYear(yearStr) {
	    var year = parseInt(yearStr, 10);
	    if (year <= 49) {
	        return 2000 + year;
	    } else if (year <= 999) {
	        return 1900 + year;
	    }
	    return year;
	}
	
	function preprocessRFC2822(s) {
	    // Remove comments and folding whitespace and replace multiple-spaces with a single space
	    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
	}
	
	function checkWeekday(weekdayStr, parsedInput, config) {
	    if (weekdayStr) {
	        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	        if (weekdayProvided !== weekdayActual) {
	            getParsingFlags(config).weekdayMismatch = true;
	            config._isValid = false;
	            return false;
	        }
	    }
	    return true;
	}
	
	var obsOffsets = {
	    UT: 0,
	    GMT: 0,
	    EDT: -4 * 60,
	    EST: -5 * 60,
	    CDT: -5 * 60,
	    CST: -6 * 60,
	    MDT: -6 * 60,
	    MST: -7 * 60,
	    PDT: -7 * 60,
	    PST: -8 * 60
	};
	
	function calculateOffset(obsOffset, militaryOffset, numOffset) {
	    if (obsOffset) {
	        return obsOffsets[obsOffset];
	    } else if (militaryOffset) {
	        // the only allowed military tz is Z
	        return 0;
	    } else {
	        var hm = parseInt(numOffset, 10);
	        var m = hm % 100, h = (hm - m) / 100;
	        return h * 60 + m;
	    }
	}
	
	// date and time from ref 2822 format
	function configFromRFC2822(config) {
	    var match = rfc2822.exec(preprocessRFC2822(config._i));
	    if (match) {
	        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	        if (!checkWeekday(match[1], parsedArray, config)) {
	            return;
	        }
	
	        config._a = parsedArray;
	        config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	        config._d = createUTCDate.apply(null, config._a);
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	        getParsingFlags(config).rfc2822 = true;
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    configFromRFC2822(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    // Final attempt, use Input Fallback
	    hooks.createFromInputFallback(config);
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// constant that refers to the RFC 2822 form
	hooks.RFC_2822 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	    if (config._f === hooks.RFC_2822) {
	        configFromRFC2822(config);
	        return;
	    }
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (isUndefined(input)) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (isObject(input)) {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	function isDurationValid(m) {
	    for (var key in m) {
	        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	            return false;
	        }
	    }
	
	    var unitHasDecimal = false;
	    for (var i = 0; i < ordering.length; ++i) {
	        if (m[ordering[i]]) {
	            if (unitHasDecimal) {
	                return false; // only allow non-integers for smallest unit
	            }
	            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                unitHasDecimal = true;
	            }
	        }
	    }
	
	    return true;
	}
	
	function isValid$1() {
	    return this._isValid;
	}
	
	function createInvalid$1() {
	    return createDuration(NaN);
	}
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    this._isValid = isDurationValid(normalizedInput);
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible to translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime, keepMinutes) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16 && !keepMinutes) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm, false, true);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	createDuration.invalid = createInvalid$1;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    switch (units) {
	        case 'year': output = monthDiff(this, that) / 12; break;
	        case 'month': output = monthDiff(this, that); break;
	        case 'quarter': output = monthDiff(this, that) / 3; break;
	        case 'second': output = (this - that) / 1e3; break; // 1000
	        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	        default: output = this - that;
	    }
	
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString(keepOffset) {
	    if (!this.isValid()) {
	        return null;
	    }
	    var utc = keepOffset !== true;
	    var m = utc ? this.clone().utc() : this;
	    if (m.year() < 0 || m.year() > 9999) {
	        return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	    if (isFunction(Date.prototype.toISOString)) {
	        // native implementation is ~50x faster, use it when we can
	        if (utc) {
	            return this.toDate().toISOString();
	        } else {
	            return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	        }
	    }
	    return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$2 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    return isStrict ?
	      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	      locale._dayOfMonthOrdinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0]);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$2;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	proto.quarter = proto.quarters = getSetQuarter;
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	proto.hour = proto.hours = getSetHour;
	proto.minute = proto.minutes = getSetMinute;
	proto.second = proto.seconds = getSetSecond;
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function clone$1 () {
	    return createDuration(this);
	}
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this.isValid() ? this[units + 's']() : NaN;
	}
	
	function makeGetter(name) {
	    return function () {
	        return this.isValid() ? this._data[name] : NaN;
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    ss: 44,         // a few seconds to seconds
	    s : 45,         // seconds to minute
	    m : 45,         // minutes to hour
	    h : 22,         // hours to day
	    d : 26,         // days to month
	    M : 11          // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds <= thresholds.ss && ['s', seconds]  ||
	            seconds < thresholds.s   && ['ss', seconds] ||
	            minutes <= 1             && ['m']           ||
	            minutes < thresholds.m   && ['mm', minutes] ||
	            hours   <= 1             && ['h']           ||
	            hours   < thresholds.h   && ['hh', hours]   ||
	            days    <= 1             && ['d']           ||
	            days    < thresholds.d   && ['dd', days]    ||
	            months  <= 1             && ['M']           ||
	            months  < thresholds.M   && ['MM', months]  ||
	            years   <= 1             && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    if (threshold === 's') {
	        thresholds.ss = limit - 1;
	    }
	    return true;
	}
	
	function humanize (withSuffix) {
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function sign(x) {
	    return ((x > 0) - (x < 0)) || +x;
	}
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    var totalSign = total < 0 ? '-' : '';
	    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	    return totalSign + 'P' +
	        (Y ? ymSign + Y + 'Y' : '') +
	        (M ? ymSign + M + 'M' : '') +
	        (D ? daysSign + D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? hmsSign + h + 'H' : '') +
	        (m ? hmsSign + m + 'M' : '') +
	        (s ? hmsSign + s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.isValid        = isValid$1;
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.clone          = clone$1;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.21.0';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	// currently HTML5 input type only supports 24-hour formats
	hooks.HTML5_FMT = {
	    DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	    DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	    DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	    DATE: 'YYYY-MM-DD',                             // <input type="date" />
	    TIME: 'HH:mm',                                  // <input type="time" />
	    TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	    TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	    WEEK: 'YYYY-[W]WW',                             // <input type="week" />
	    MONTH: 'YYYY-MM'                                // <input type="month" />
	};
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(318)(module)))

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(19);
	var core = __webpack_require__(77);
	var hide = __webpack_require__(52);
	var redefine = __webpack_require__(53);
	var ctx = __webpack_require__(67);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.proxyCounterpart = proxyCounterpart;
	
	var _counterpart = __webpack_require__(86);
	
	var _counterpart2 = _interopRequireDefault(_counterpart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function proxyCounterpart(translationKey) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	  try {
	    var translateOptions = options || { fallback: '' };
	
	    return _counterpart2.default.translate(translationKey, translateOptions);
	  } catch (e) {
	    return '';
	  }
	}

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SalaryPaymentStatusConstants = exports.SalaryTypeConstants = exports.UserSettingsConstants = exports.FaqService = exports.WorkingEnvironmentPageService = exports.InsurancesPageService = exports.LoyaltyPointService = exports.LogotypeService = exports.AgreementDraftService = exports.IncomeStatementService = exports.TaxService = exports.CouponService = exports.SupplierLedgerService = exports.WorkerService = exports.Utils = exports.InfoService = exports.EmploymentCertificateService = exports.CustomerService = exports.CountryService = exports.TaxkeyService = exports.CurrenciesService = exports.PaymentRequestService = exports.InvoiceCopyService = exports.InvoiceService = exports.BankIdService = exports.UserService = undefined;
	
	var _userService = __webpack_require__(800);
	
	var _userService2 = _interopRequireDefault(_userService);
	
	var _bankIdService = __webpack_require__(754);
	
	var _bankIdService2 = _interopRequireDefault(_bankIdService);
	
	var _invoiceService = __webpack_require__(220);
	
	var _invoiceService2 = _interopRequireDefault(_invoiceService);
	
	var _invoiceCopyService = __webpack_require__(775);
	
	var _invoiceCopyService2 = _interopRequireDefault(_invoiceCopyService);
	
	var _paymentRequestService = __webpack_require__(785);
	
	var _paymentRequestService2 = _interopRequireDefault(_paymentRequestService);
	
	var _currenciesService = __webpack_require__(346);
	
	var _currenciesService2 = _interopRequireDefault(_currenciesService);
	
	var _taxkeyService = __webpack_require__(119);
	
	var _taxkeyService2 = _interopRequireDefault(_taxkeyService);
	
	var _countryService = __webpack_require__(759);
	
	var _countryService2 = _interopRequireDefault(_countryService);
	
	var _customerService = __webpack_require__(218);
	
	var _customerService2 = _interopRequireDefault(_customerService);
	
	var _employmentCertificateService = __webpack_require__(764);
	
	var _employmentCertificateService2 = _interopRequireDefault(_employmentCertificateService);
	
	var _infoService = __webpack_require__(772);
	
	var _infoService2 = _interopRequireDefault(_infoService);
	
	var _utils = __webpack_require__(29);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _workerService = __webpack_require__(802);
	
	var _workerService2 = _interopRequireDefault(_workerService);
	
	var _supplierLedgerService = __webpack_require__(350);
	
	var _supplierLedgerService2 = _interopRequireDefault(_supplierLedgerService);
	
	var _couponService = __webpack_require__(761);
	
	var _couponService2 = _interopRequireDefault(_couponService);
	
	var _taxService = __webpack_require__(796);
	
	var _taxService2 = _interopRequireDefault(_taxService);
	
	var _incomeStatementService = __webpack_require__(769);
	
	var _incomeStatementService2 = _interopRequireDefault(_incomeStatementService);
	
	var _agreementDraftService = __webpack_require__(750);
	
	var _agreementDraftService2 = _interopRequireDefault(_agreementDraftService);
	
	var _logotypeService = __webpack_require__(782);
	
	var _logotypeService2 = _interopRequireDefault(_logotypeService);
	
	var _loyaltyPointService = __webpack_require__(783);
	
	var _loyaltyPointService2 = _interopRequireDefault(_loyaltyPointService);
	
	var _insurancesPageService = __webpack_require__(774);
	
	var _insurancesPageService2 = _interopRequireDefault(_insurancesPageService);
	
	var _workingEnvironmentPageService = __webpack_require__(804);
	
	var _workingEnvironmentPageService2 = _interopRequireDefault(_workingEnvironmentPageService);
	
	var _faqService = __webpack_require__(766);
	
	var _faqService2 = _interopRequireDefault(_faqService);
	
	var _settingsConstants = __webpack_require__(798);
	
	var _settingsConstants2 = _interopRequireDefault(_settingsConstants);
	
	var _salaryTypeConstants = __webpack_require__(791);
	
	var _salaryTypeConstants2 = _interopRequireDefault(_salaryTypeConstants);
	
	var _salaryPaymentStatusConstants = __webpack_require__(790);
	
	var _salaryPaymentStatusConstants2 = _interopRequireDefault(_salaryPaymentStatusConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.UserService = _userService2.default;
	exports.BankIdService = _bankIdService2.default;
	exports.InvoiceService = _invoiceService2.default;
	exports.InvoiceCopyService = _invoiceCopyService2.default;
	exports.PaymentRequestService = _paymentRequestService2.default;
	exports.CurrenciesService = _currenciesService2.default;
	exports.TaxkeyService = _taxkeyService2.default;
	exports.CountryService = _countryService2.default;
	exports.CustomerService = _customerService2.default;
	exports.EmploymentCertificateService = _employmentCertificateService2.default;
	exports.InfoService = _infoService2.default;
	exports.Utils = _utils2.default;
	exports.WorkerService = _workerService2.default;
	exports.SupplierLedgerService = _supplierLedgerService2.default;
	exports.CouponService = _couponService2.default;
	exports.TaxService = _taxService2.default;
	exports.IncomeStatementService = _incomeStatementService2.default;
	exports.AgreementDraftService = _agreementDraftService2.default;
	exports.LogotypeService = _logotypeService2.default;
	exports.LoyaltyPointService = _loyaltyPointService2.default;
	exports.InsurancesPageService = _insurancesPageService2.default;
	exports.WorkingEnvironmentPageService = _workingEnvironmentPageService2.default;
	exports.FaqService = _faqService2.default;
	exports.UserSettingsConstants = _settingsConstants2.default;
	exports.SalaryTypeConstants = _salaryTypeConstants2.default;
	exports.SalaryPaymentStatusConstants = _salaryPaymentStatusConstants2.default;

/***/ },
/* 12 */,
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Freshchat = exports.PayTermsPicker = exports.EmailCapture = exports.CloseModal = exports.SelectBox = exports.Profession = exports.ToggleDisplay = exports.ToolTip = exports.ExceededWorkingHoursModal = exports.ConfirmModal = exports.CountryPicker = exports.PrivacyPolicy = exports.GeneralTerms = exports.InputField = exports.DatepickerRange = exports.ValidationError = exports.GeneralError = exports.SpinnerButton = exports.Spinner = undefined;
	
	var _spinner = __webpack_require__(57);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _spinnerButton = __webpack_require__(97);
	
	var _spinnerButton2 = _interopRequireDefault(_spinnerButton);
	
	var _generalError = __webpack_require__(63);
	
	var _generalError2 = _interopRequireDefault(_generalError);
	
	var _validationError = __webpack_require__(747);
	
	var _validationError2 = _interopRequireDefault(_validationError);
	
	var _datepickerRange = __webpack_require__(117);
	
	var _datepickerRange2 = _interopRequireDefault(_datepickerRange);
	
	var _inputField = __webpack_require__(330);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var _generalTermsContainer = __webpack_require__(690);
	
	var _generalTermsContainer2 = _interopRequireDefault(_generalTermsContainer);
	
	var _privacyPolicy = __webpack_require__(719);
	
	var _privacyPolicy2 = _interopRequireDefault(_privacyPolicy);
	
	var _countryPicker = __webpack_require__(684);
	
	var _countryPicker2 = _interopRequireDefault(_countryPicker);
	
	var _confirmModal = __webpack_require__(683);
	
	var _confirmModal2 = _interopRequireDefault(_confirmModal);
	
	var _exceededWorkingHoursModal = __webpack_require__(686);
	
	var _exceededWorkingHoursModal2 = _interopRequireDefault(_exceededWorkingHoursModal);
	
	var _tooltip = __webpack_require__(745);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _toggleDisplay = __webpack_require__(744);
	
	var _toggleDisplay2 = _interopRequireDefault(_toggleDisplay);
	
	var _profession = __webpack_require__(720);
	
	var _profession2 = _interopRequireDefault(_profession);
	
	var _selectBox = __webpack_require__(726);
	
	var _selectBox2 = _interopRequireDefault(_selectBox);
	
	var _closeModal = __webpack_require__(325);
	
	var _closeModal2 = _interopRequireDefault(_closeModal);
	
	var _emailCapture = __webpack_require__(324);
	
	var _emailCapture2 = _interopRequireDefault(_emailCapture);
	
	var _payTerms = __webpack_require__(717);
	
	var _payTerms2 = _interopRequireDefault(_payTerms);
	
	var _freshchat = __webpack_require__(746);
	
	var _freshchat2 = _interopRequireDefault(_freshchat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Spinner = _spinner2.default;
	exports.SpinnerButton = _spinnerButton2.default;
	exports.GeneralError = _generalError2.default;
	exports.ValidationError = _validationError2.default;
	exports.DatepickerRange = _datepickerRange2.default;
	exports.InputField = _inputField2.default;
	exports.GeneralTerms = _generalTermsContainer2.default;
	exports.PrivacyPolicy = _privacyPolicy2.default;
	exports.CountryPicker = _countryPicker2.default;
	exports.ConfirmModal = _confirmModal2.default;
	exports.ExceededWorkingHoursModal = _exceededWorkingHoursModal2.default;
	exports.ToolTip = _tooltip2.default;
	exports.ToggleDisplay = _toggleDisplay2.default;
	exports.Profession = _profession2.default;
	exports.SelectBox = _selectBox2.default;
	exports.CloseModal = _closeModal2.default;
	exports.EmailCapture = _emailCapture2.default;
	exports.PayTermsPicker = _payTerms2.default;
	exports.Freshchat = _freshchat2.default;

/***/ },
/* 14 */,
/* 15 */,
/* 16 */
[1580, 24],
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(661);

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1015), __esModule: true };

/***/ },
/* 19 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 20 */,
/* 21 */,
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1019), __esModule: true };

/***/ },
/* 23 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 24 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 25 */
141,
/* 26 */,
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(22);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 28 */
[1639, 184, 111, 19],
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(167);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 06/04/16.
	 */
	
	var Utils = function () {
	  function Utils() {
	    (0, _classCallCheck3.default)(this, Utils);
	  }
	
	  (0, _createClass3.default)(Utils, null, [{
	    key: 'truncateName',
	    value: function truncateName(name, maxLength) {
	      var max, nameLength;
	
	      max = maxLength || 8;
	      nameLength = name.length;
	
	      if (nameLength > max) {
	        return name.substring(0, max) + '...';
	      } else {
	        return name;
	      }
	    }
	  }, {
	    key: 'formatDate',
	    value: function formatDate(date) {
	      var m = (0, _moment2.default)(date);
	
	      if (m.isValid()) {
	        return m.format('YYYY-MM-DD');
	      } else {
	        return '-';
	      }
	    }
	  }, {
	    key: 'amountWithCurrency',
	    value: function amountWithCurrency(amount, currencyId) {
	      switch (currencyId) {
	        case 1:
	          return amount + ' ' + (0, _proxyCounterpart.proxyCounterpart)('SEK');
	        case 2:
	          return amount + ' ' + (0, _proxyCounterpart.proxyCounterpart)('EURO_SHORT');
	        case 3:
	          return (0, _proxyCounterpart.proxyCounterpart)('DOLLAR_SHORT') + ' ' + amount;
	        default:
	          return amount + ' ' + (0, _proxyCounterpart.proxyCounterpart)('SEK');
	      }
	    }
	
	    /**
	     * Convert API data into object with value and valid status
	     * for InputField-component
	     *
	     * @param data
	     * @returns {{}}
	     */
	
	  }, {
	    key: 'getInputValueObjects',
	    value: function getInputValueObjects(data) {
	      var inputValues = {};
	
	      for (var i in data) {
	        if ((0, _typeof3.default)(data[i]) === 'object' && data[i] !== null) {
	          for (var j in data[i]) {
	            inputValues[j] = {
	              value: data[i][j],
	              valid: true
	            };
	          }
	        } else {
	          inputValues[i] = {
	            value: data[i],
	            valid: true
	          };
	        }
	      }
	
	      return inputValues;
	    }
	  }, {
	    key: 'getPostParams',
	    value: function getPostParams(inputValues) {
	      var params = {};
	
	      for (var i in inputValues) {
	        params[i] = inputValues[i].value;
	      }
	
	      return params;
	    }
	  }, {
	    key: 'validateInputValues',
	    value: function validateInputValues(inputValues) {
	      for (var i in inputValues) {
	        if (!inputValues[i].valid) {
	          return false;
	        }
	      }
	
	      return true;
	    }
	  }, {
	    key: 'isInt',
	    value: function isInt(value) {
	      var x;
	      if (isNaN(value)) {
	        return false;
	      }
	      x = parseFloat(value);
	      return (x | 0) === x;
	    }
	  }, {
	    key: 'isNumeric',
	    value: function isNumeric(n) {
	      return !isNaN(parseFloat(n)) && isFinite(n);
	    }
	  }, {
	    key: 'getLineBreaks',
	    value: function getLineBreaks(text) {
	      if (text === null) {
	        return '';
	      }
	
	      return text.replace(/(?:\r\n|\r|\n)/g, '<br/>');
	    }
	
	    // Copied from http://locutus.io/php/xml/utf8_decode/
	
	  }, {
	    key: 'utf8Decode',
	    value: function utf8Decode(strData) {
	      var tmpArr = [];
	      var i = 0;
	      var c1 = 0;
	      var seqlen = 0;
	
	      strData += '';
	
	      while (i < strData.length) {
	        c1 = strData.charCodeAt(i) & 0xFF;
	        seqlen = 0;
	
	        // http://en.wikipedia.org/wiki/UTF-8#Codepage_layout
	        if (c1 <= 0xBF) {
	          c1 = c1 & 0x7F;
	          seqlen = 1;
	        } else if (c1 <= 0xDF) {
	          c1 = c1 & 0x1F;
	          seqlen = 2;
	        } else if (c1 <= 0xEF) {
	          c1 = c1 & 0x0F;
	          seqlen = 3;
	        } else {
	          c1 = c1 & 0x07;
	          seqlen = 4;
	        }
	
	        for (var ai = 1; ai < seqlen; ++ai) {
	          c1 = c1 << 0x06 | strData.charCodeAt(ai + i) & 0x3F;
	        }
	
	        if (seqlen === 4) {
	          c1 -= 0x10000;
	          tmpArr.push(String.fromCharCode(0xD800 | c1 >> 10 & 0x3FF));
	          tmpArr.push(String.fromCharCode(0xDC00 | c1 & 0x3FF));
	        } else {
	          tmpArr.push(String.fromCharCode(c1));
	        }
	
	        i += seqlen;
	      }
	
	      return tmpArr.join('');
	    }
	  }, {
	    key: 'isValidChecksum',
	    value: function isValidChecksum(vatNumber) {
	      if (/[^0-9-\s]+/.test(vatNumber)) return false;
	
	      var nCheck = 0;
	      var nDigit = 0;
	      var cDigit = 0;
	      var bEven = false;
	      vatNumber = vatNumber.replace(/\D/g, '');
	
	      for (var n = vatNumber.length - 1; n >= 0; n--) {
	        cDigit = vatNumber.charAt(n);
	        nDigit = parseInt(cDigit, 10);
	
	        if (bEven) {
	          if ((nDigit *= 2) > 9) nDigit -= 9;
	        }
	
	        nCheck += nDigit;
	        bEven = !bEven;
	      }
	
	      return nCheck % 10 === 0;
	    }
	  }, {
	    key: 'numberToOneDecimal',
	    value: function numberToOneDecimal(value) {
	      return Math.round(value * 10) / 10;
	    }
	  }, {
	    key: 'floor',
	    value: function floor(value) {
	      return Math.floor(value);
	    }
	  }, {
	    key: 'numberWithSpaces',
	    value: function numberWithSpaces(value) {
	      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
	    }
	  }]);
	  return Utils;
	}();
	
	Utils.normalizeVatNumber = function (vatNumber) {
	  return vatNumber.replace(/[^0-9]/, '');
	};
	
	Utils.isVatNumber = function (vatNumber) {
	  vatNumber = vatNumber.replace(/[^0-9]/, '');
	
	  if (vatNumber.length === 10) {
	    var month = vatNumber.substring(2, 4);
	    return Utils.isValidChecksum(vatNumber) && month >= 20;
	  }
	  return false;
	};
	
	Utils.containsAtSign = function (value) {
	  if (value) return value.includes('@');
	
	  return false;
	};
	
	Utils.isValidEinvoiceAddress = function (value) {
	  if (!value) {
	    return false;
	  }
	
	  var characters = value.replace(/ /g, '').length;
	  return characters >= 10 && characters <= 50 && !Utils.containsAtSign(value);
	};
	
	exports.default = Utils;

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1465);
	


/***/ },
/* 31 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.5.3' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 32 */
[1591, 23],
/* 33 */
[1611, 16, 415, 81, 32],
/* 34 */
[1633, 80],
/* 35 */,
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var DOMProperty = __webpack_require__(135);
	var ReactDOMComponentFlags = __webpack_require__(602);
	
	var invariant = __webpack_require__(15);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 38 */
[1634, 78],
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(48);
	var core = __webpack_require__(31);
	var ctx = __webpack_require__(83);
	var hide = __webpack_require__(93);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && key in exports) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.5';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Gets the value at `key`, unless `key` is "__proto__".
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function safeGet(object, key) {
	    return key == '__proto__'
	      ? undefined
	      : object[key];
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	
	        return result;
	      }
	
	      if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	
	        return result;
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(318)(module)))

/***/ },
/* 41 */,
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PendingRequestEntity = function PendingRequestEntity(promise, cancel) {
	  (0, _classCallCheck3.default)(this, PendingRequestEntity);
	
	  this.promise = promise;
	  this.cancel = cancel;
	};
	
	exports.default = PendingRequestEntity;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setUserId = setUserId;
	exports.setTaxId = setTaxId;
	exports.setSaveVacationPay = setSaveVacationPay;
	exports.setAmount = setAmount;
	exports.setCustomerEntity = setCustomerEntity;
	exports.setCustomerId = setCustomerId;
	exports.setCouponId = setCouponId;
	exports.setCoupon = setCoupon;
	exports.clearCoupon = clearCoupon;
	exports.setCurrencyId = setCurrencyId;
	exports.setCurrencyName = setCurrencyName;
	exports.setCurrencyAmount = setCurrencyAmount;
	exports.setSpecification = setSpecification;
	exports.setInvoiceDate = setInvoiceDate;
	exports.setInvoiceUser = setInvoiceUser;
	exports.setSendToEmail = setSendToEmail;
	exports.setSendToEmailSecondary = setSendToEmailSecondary;
	exports.setSendToEmailBool = setSendToEmailBool;
	exports.setCompanyPhone = setCompanyPhone;
	exports.setEinvoiceAddress = setEinvoiceAddress;
	exports.setPoNumber = setPoNumber;
	exports.setTaxKeyId = setTaxKeyId;
	exports.setInvoiceId = setInvoiceId;
	exports.setExpressPayment = setExpressPayment;
	exports.setSupplierLedger = setSupplierLedger;
	exports.setSubmitted = setSubmitted;
	exports.setValid = setValid;
	exports.setPosting = setPosting;
	exports.setPostError = setPostError;
	exports.setAmountIncVat = setAmountIncVat;
	exports.setLockAmountDistribution = setLockAmountDistribution;
	exports.setInitializing = setInitializing;
	exports.setAmountAfterHsd = setAmountAfterHsd;
	exports.clear = clear;
	exports.setRot = setRot;
	exports.setRut = setRut;
	exports.setManualInvoiceCalc = setManualInvoiceCalc;
	exports.setDisplayDates = setDisplayDates;
	exports.setDisplayHours = setDisplayHours;
	exports.setPreReport = setPreReport;
	exports.setPreReportedAt = setPreReportedAt;
	exports.setTermsAccepted = setTermsAccepted;
	exports.setLoggedInInvoiceUserTaxKeys = setLoggedInInvoiceUserTaxKeys;
	exports.setLoggedInInvoiceUserTaxKeyId = setLoggedInInvoiceUserTaxKeyId;
	exports.setMessageType = setMessageType;
	exports.setSurveyAnswers = setSurveyAnswers;
	
	var _actionTypes = __webpack_require__(362);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function setUserId(id) {
	  return {
	    type: types.SET_USER_ID,
	    payload: id
	  };
	} /**
	   * Created by eriksundqvist on 24/05/16.
	   */
	function setTaxId(id) {
	  return {
	    type: types.SET_TAX_ID,
	    payload: id
	  };
	}
	
	function setSaveVacationPay(bool) {
	  return {
	    type: types.SET_SAVE_VACATION_PAY,
	    payload: bool
	  };
	}
	
	function setAmount(amount) {
	  return {
	    type: types.SET_AMOUNT,
	    payload: amount
	  };
	}
	
	function setCustomerEntity(customerEntity) {
	  return {
	    type: types.SET_CUSTOMER_ENTITY,
	    payload: customerEntity
	  };
	}
	
	function setCustomerId(customerId) {
	  return {
	    type: types.SET_CUSTOMER_ID,
	    payload: customerId
	  };
	}
	
	function setCouponId(couponId) {
	  return {
	    type: types.SET_COUPON_ID,
	    payload: couponId
	  };
	}
	
	function setCoupon(coupon) {
	  return {
	    type: types.SET_COUPON,
	    payload: coupon
	  };
	}
	
	function clearCoupon() {
	  return {
	    type: types.CLEAR_COUPON
	  };
	}
	
	function setCurrencyId(currencyId) {
	  return {
	    type: types.SET_CURRENCY_ID,
	    payload: currencyId
	  };
	}
	
	function setCurrencyName(currencyName) {
	  return {
	    type: types.SET_CURRENCY_NAME,
	    payload: currencyName
	  };
	}
	
	function setCurrencyAmount(currencyAmount) {
	  return {
	    type: types.SET_CURRENCY_AMOUNT,
	    payload: currencyAmount
	  };
	}
	
	function setSpecification(specification) {
	  return {
	    type: types.SET_SPECIFICATION,
	    payload: specification
	  };
	}
	
	function setInvoiceDate(invoiceDate) {
	  return {
	    type: types.SET_INVOICEDATE,
	    payload: invoiceDate
	  };
	}
	
	function setInvoiceUser(invoiceUser) {
	  return {
	    type: types.SET_INVOICEUSER,
	    payload: invoiceUser
	  };
	}
	
	function setSendToEmail(email) {
	  return {
	    type: types.SET_SEND_TO_EMAIL,
	    payload: email.trim()
	  };
	}
	
	function setSendToEmailSecondary(email) {
	  return {
	    type: types.SET_SEND_TO_EMAIL_SECONDARY,
	    payload: email.trim()
	  };
	}
	
	function setSendToEmailBool(sendToEmailBool) {
	  return {
	    type: types.SET_SEND_TO_EMAIL_BOOL,
	    payload: sendToEmailBool
	  };
	}
	
	function setCompanyPhone(companyPhone) {
	  return {
	    type: types.SET_COMPANY_PHONE,
	    payload: companyPhone
	  };
	}
	
	function setEinvoiceAddress(einvoice) {
	  return {
	    type: types.SET_EINVOICE_ADDRESS,
	    payload: einvoice.trim()
	  };
	}
	
	function setPoNumber(poNumber) {
	  return {
	    type: types.SET_PO_NUMBER,
	    payload: poNumber.trim()
	  };
	}
	
	function setTaxKeyId(taxkeyId) {
	  return {
	    type: types.SET_TAX_KEY_ID,
	    payload: taxkeyId
	  };
	}
	
	function setInvoiceId(invoiceId) {
	  return {
	    type: types.SET_INVOICE_ID,
	    payload: invoiceId
	  };
	}
	
	function setExpressPayment(expressPayment) {
	  return {
	    type: types.SET_EXPRESS_PAYMENT,
	    payload: expressPayment
	  };
	}
	
	function setSupplierLedger(supplierLedger) {
	  return {
	    type: types.SET_SUPPLIER_LEDGER,
	    payload: supplierLedger
	  };
	}
	
	function setSubmitted(submitted) {
	  return {
	    type: types.SET_SUBMITTED,
	    payload: submitted
	  };
	}
	
	function setValid(valid) {
	  return {
	    type: types.SET_VALID,
	    payload: valid
	  };
	}
	
	function setPosting(posting) {
	  return {
	    type: types.SET_POSTING,
	    payload: posting
	  };
	}
	
	function setPostError(postError) {
	  return {
	    type: types.SET_POST_ERROR,
	    payload: postError
	  };
	}
	
	function setAmountIncVat(amountIncVat) {
	  return {
	    type: types.SET_AMOUNT_INC_VAT,
	    payload: amountIncVat
	  };
	}
	
	function setLockAmountDistribution(lockAmountDistribution) {
	  return {
	    type: types.SET_LOCK_AMOUNT_DISTRIBUTION,
	    payload: lockAmountDistribution
	  };
	}
	
	function setInitializing(initializing) {
	  return {
	    type: types.SET_INITIALIZING,
	    payload: initializing
	  };
	}
	
	function setAmountAfterHsd(amountAfterHsd) {
	  return {
	    type: types.SET_AMOUNT_AFTER_HSD,
	    payload: amountAfterHsd
	  };
	}
	
	function clear() {
	  return {
	    type: types.CLEAR
	  };
	}
	
	function setRot(rot, data, apartmentNumber, cooperativeApartmentRegistrationNumber, accommodationType) {
	  return {
	    type: types.SET_ROT,
	    payload: { rot: rot, data: data, apartmentNumber: apartmentNumber, cooperativeApartmentRegistrationNumber: cooperativeApartmentRegistrationNumber, accommodationType: accommodationType }
	  };
	}
	
	function setRut(rut) {
	  return {
	    type: types.SET_RUT,
	    payload: rut
	  };
	}
	
	function setManualInvoiceCalc(manualInvoiceCalc) {
	  return {
	    type: types.SET_MANUAL_INVOICE_CALC,
	    payload: manualInvoiceCalc
	  };
	}
	
	function setDisplayDates(displayDates) {
	  return {
	    type: types.SET_DISPLAY_DATES,
	    payload: displayDates
	  };
	}
	
	function setDisplayHours(displayHours) {
	  return {
	    type: types.SET_DISPLAY_HOURS,
	    payload: displayHours
	  };
	}
	
	function setPreReport(preReport) {
	  return {
	    type: types.SET_PREREPORT,
	    payload: preReport
	  };
	}
	
	function setPreReportedAt(preReportedAt) {
	  return {
	    type: types.SET_PREREPORTED_AT,
	    payload: preReportedAt
	  };
	}
	
	function setTermsAccepted(termsAccepted) {
	  return {
	    type: types.SET_TERMSACCEPTED,
	    payload: termsAccepted
	  };
	}
	
	function setLoggedInInvoiceUserTaxKeys(taxkeys) {
	  return {
	    type: types.SET_LOGGED_IN_INVOICE_USER_TAXKEYS,
	    payload: taxkeys
	  };
	}
	
	function setLoggedInInvoiceUserTaxKeyId(taxkeyId) {
	  return {
	    type: types.SET_LOGGED_IN_INVOICE_USER_TAXKEY_ID,
	    payload: taxkeyId
	  };
	}
	
	function setMessageType(messageType) {
	  return {
	    type: types.SET_MESSAGE_TYPE,
	    payload: messageType
	  };
	}
	
	function setSurveyAnswers(answers, status) {
	  return {
	    type: types.SET_SURVEY_ANSWERS,
	    payload: {
	      questions_and_answers: '[' + answers + ']',
	      status: status ? 'ok' : 'failed'
	    }
	  };
	}

/***/ },
/* 44 */
[1639, 245, 172, 48],
/* 45 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1411);


/***/ },
/* 47 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Autogenerated by build/webpack.config.js
	// Do not change this file directly.
	
	var apiUrl = exports.apiUrl = 'https://api-se.staging.ffdev.se/';
	var eidUrl = exports.eidUrl = 'https://eid-se.backend-dev.ffdev.se';
	var frontUrl = exports.frontUrl = 'https://frilansweb.flywheelstaging.com';
	var sentryDsn = exports.sentryDsn = 'https://ad415c4b0b8b41ecb3b7703bea0047a3@sentry.io/127654';
	var appUrl = exports.appUrl = 'account-web.staging.ffdev.se';
	var appEnv = exports.appEnv = 'staging';
	var version = exports.version = 'undefined';

/***/ },
/* 48 */
19,
/* 49 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.vat = undefined;
	exports.getVatById = getVatById;
	exports.reformatInputValue = reformatInputValue;
	exports.hasExceededWorkingHours = hasExceededWorkingHours;
	exports.getTotalHours = getTotalHours;
	exports.checkWorkingHoursInRange = checkWorkingHoursInRange;
	exports.isWithinSevenDayPeriod = isWithinSevenDayPeriod;
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vat = exports.vat = [{ 'id': 1, 'value': 25 }, { 'id': 2, 'value': 12 }, { 'id': 3, 'value': 6 }, { 'id': 4, 'value': 0 }];
	
	function getVatById(id) {
	  for (var i = 0; i < vat.length; i++) {
	    if (id === vat[i]['id']) {
	      return vat[i]['value'];
	    }
	  }
	}
	
	function reformatInputValue(amount) {
	  amount = amount.replace(/ /g, '');
	  amount = amount.replace(',', '.');
	  if (amount.length === 0) amount = null;
	  return amount;
	}
	
	function hasExceededWorkingHours(dates) {
	  for (var index = 0; index < dates.length; index++) {
	    var untilDateRange;
	
	    if (index < dates.length - 7) {
	      untilDateRange = index + 7;
	    } else {
	      untilDateRange = dates.length;
	    }
	
	    var range = dates.slice(index, untilDateRange);
	    var totalHours = getTotalHours(range);
	
	    if (checkWorkingHoursInRange(range)) {
	      return true;
	    }
	
	    if (totalHours >= 48) {
	      for (var i = 0; i < untilDateRange; i++) {
	        var dateRange = dates.slice(0, i + 1);
	        if (checkWorkingHoursInRange(dateRange)) {
	          return true;
	        }
	      }
	    }
	  }
	
	  return false;
	}
	
	function getTotalHours(range) {
	  return range.reduce(function (previousValue, date) {
	    return parseFloat(previousValue) + parseFloat(date.workHours);
	  }, 0);
	}
	
	function checkWorkingHoursInRange(range) {
	  if (!range.length) {
	    return false;
	  }
	  var withinSevenDayPeriod = isWithinSevenDayPeriod(range[0], range[range.length - 1]);
	
	  var totalHours = getTotalHours(range);
	
	  return totalHours >= 48 && withinSevenDayPeriod;
	}
	
	function isWithinSevenDayPeriod(firstDate, secondDate) {
	  var sixDaysInMilliseconds = 518400000;
	  return (0, _moment2.default)(secondDate.displayDate).valueOf() - (0, _moment2.default)(firstDate.displayDate).valueOf() <= sixDaysInMilliseconds;
	}

/***/ },
/* 51 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 52 */
[1595, 33, 107, 32],
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(19);
	var hide = __webpack_require__(52);
	var has = __webpack_require__(51);
	var SRC = __webpack_require__(111)('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(77).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9);
	var fails = __webpack_require__(23);
	var defined = __webpack_require__(78);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ },
/* 55 */,
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(323);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  typeof document.createElement -> undefined
	 */
	function isStandardBrowserEnv() {
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined' &&
	    typeof document.createElement === 'function'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object' && !isArray(obj)) {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Spinner = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spinner = __webpack_require__(1306);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 16/03/16.
	 */
	
	var Spinner = exports.Spinner = function (_React$Component) {
	  (0, _inherits3.default)(Spinner, _React$Component);
	
	  function Spinner() {
	    (0, _classCallCheck3.default)(this, Spinner);
	    return (0, _possibleConstructorReturn3.default)(this, (Spinner.__proto__ || (0, _getPrototypeOf2.default)(Spinner)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Spinner, [{
	    key: 'render',
	    value: function render() {
	      var sizeStyles = {};
	
	      if (this.props.size) {
	        sizeStyles = {
	          width: this.props.size,
	          height: this.props.size,
	          borderWidth: Math.round(this.props.size / 10)
	        };
	      }
	
	      return _react2.default.createElement('div', { className: _spinner2.default.spinner, style: sizeStyles });
	    }
	  }]);
	  return Spinner;
	}(_react2.default.Component);
	
	exports.default = Spinner;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calculateRotAmount = calculateRotAmount;
	exports.calculateRutAmount = calculateRutAmount;
	exports.getLowHourlySalaryAmount = getLowHourlySalaryAmount;
	exports.removeCurrencyFromAmount = removeCurrencyFromAmount;
	exports.toMoney = toMoney;
	exports.amountInclVat = amountInclVat;
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ROT_FRACTION = 0.7; /**
	                         * Created by eriksundqvist on 21/10/16.
	                         */
	
	var RUT_FRACTION = 0.5;
	
	function calculateRotAmount(value) {
	  return value * ROT_FRACTION;
	}
	
	function calculateRutAmount(value) {
	  return value * RUT_FRACTION;
	}
	
	function getLowHourlySalaryAmount(user) {
	  var birthdate = String(user.socialSecurityNr).substring(0, 8);
	  var age = (0, _moment2.default)().diff(birthdate, 'years');
	
	  switch (true) {
	    case age < 17:
	      return 96.5;
	    case age < 18:
	      return 107;
	    case age < 19:
	      return 111;
	    case age < 20:
	      return 120;
	    default:
	      return 134;
	  }
	}
	
	function removeCurrencyFromAmount(amountWithCurrency) {
	  var billAmount = amountWithCurrency.replace(',', '.');
	  billAmount = billAmount.match(/\d*.?\d{1,2}/);
	  if (billAmount !== null) {
	    billAmount = Number(billAmount.join(''));
	  } else {
	    billAmount = 0;
	  }
	  return billAmount;
	}
	
	// Rounds to 2 decimals by default. Omits decimals if the result is an integer.
	function toMoney(value) {
	  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
	
	  var rounded = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
	  if (parseInt(rounded) === rounded) {
	    return rounded;
	  } else {
	    return rounded.toFixed(decimals);
	  }
	}
	
	function amountInclVat(amount, vat) {
	  return amount + amount * (vat / 100);
	}

/***/ },
/* 59 */
24,
/* 60 */
[1613, 152, 107, 62, 81, 51, 415, 32],
/* 61 */
[1616, 51, 38, 268],
/* 62 */
[1632, 151, 78],
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GeneralError = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _ravenJs = __webpack_require__(287);
	
	var _ravenJs2 = _interopRequireDefault(_ravenJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'p',
	  { className: 'error' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'GENERAL_ERROR' })
	); /**
	    * Created by staffanrantzow on 12/04/16.
	    */
	
	var GeneralError = exports.GeneralError = function (_React$Component) {
	  (0, _inherits3.default)(GeneralError, _React$Component);
	
	  function GeneralError() {
	    (0, _classCallCheck3.default)(this, GeneralError);
	    return (0, _possibleConstructorReturn3.default)(this, (GeneralError.__proto__ || (0, _getPrototypeOf2.default)(GeneralError)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(GeneralError, [{
	    key: 'render',
	    value: function render() {
	      _ravenJs2.default.captureMessage('General Error');
	      return _ref;
	    }
	  }]);
	  return GeneralError;
	}(_react2.default.Component);
	
	exports.default = GeneralError;

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NotAuthenticated = exports.Authenticated = exports.LogoutLink = exports.authenticationService = undefined;
	
	var _app = __webpack_require__(806);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _authentication = __webpack_require__(90);
	
	var _authentication2 = _interopRequireDefault(_authentication);
	
	var _logout = __webpack_require__(809);
	
	var _logout2 = _interopRequireDefault(_logout);
	
	var _authenticatedContainer = __webpack_require__(807);
	
	var _authenticatedContainer2 = _interopRequireDefault(_authenticatedContainer);
	
	var _notAuthenticatedContainer = __webpack_require__(810);
	
	var _notAuthenticatedContainer2 = _interopRequireDefault(_notAuthenticatedContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.authenticationService = _authentication2.default;
	
	// Components
	
	
	// Services
	
	exports.LogoutLink = _logout2.default;
	exports.Authenticated = _authenticatedContainer2.default;
	exports.NotAuthenticated = _notAuthenticatedContainer2.default;
	exports.default = _app2.default;

/***/ },
/* 65 */
[1611, 74, 388, 247, 75],
/* 66 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 67 */
[1590, 45],
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(23);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ },
/* 69 */,
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.APIResult = undefined;
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meta = function Meta(count, currentPage, perPage, total, totalPages) {
	  (0, _classCallCheck3.default)(this, Meta);
	
	  this.count = count;
	  this.currentPage = currentPage;
	  this.perPage = perPage;
	  this.total = total;
	  this.totalPages = totalPages;
	};
	
	var APIResult = exports.APIResult = function APIResult(collection, meta) {
	  (0, _classCallCheck3.default)(this, APIResult);
	
	  this.collection = collection;
	  this.meta = new Meta(meta.pagination.page.items, meta.pagination.page.number, meta.pagination.page.size, meta.pagination.items, meta.pagination.pages);
	};

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1026), __esModule: true };

/***/ },
/* 73 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ },
/* 74 */
[1580, 59],
/* 75 */
[1591, 98],
/* 76 */
[1583, 67, 151, 38, 34, 253],
/* 77 */
31,
/* 78 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 79 */
[1619, 9, 77, 23],
/* 80 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 81 */
[1635, 24],
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25),
	    _assign = __webpack_require__(26);
	
	var CallbackQueue = __webpack_require__(600);
	var PooledClass = __webpack_require__(115);
	var ReactFeatureFlags = __webpack_require__(605);
	var ReactReconciler = __webpack_require__(136);
	var Transaction = __webpack_require__(199);
	
	var invariant = __webpack_require__(15);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 83 */
[1590, 143],
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(436);
	var $export = __webpack_require__(9);
	var shared = __webpack_require__(184)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(439))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(32)) {
	  var LIBRARY = __webpack_require__(103);
	  var global = __webpack_require__(19);
	  var fails = __webpack_require__(23);
	  var $export = __webpack_require__(9);
	  var $typed = __webpack_require__(186);
	  var $buffer = __webpack_require__(274);
	  var ctx = __webpack_require__(67);
	  var anInstance = __webpack_require__(101);
	  var propertyDesc = __webpack_require__(107);
	  var hide = __webpack_require__(52);
	  var redefineAll = __webpack_require__(108);
	  var toInteger = __webpack_require__(80);
	  var toLength = __webpack_require__(34);
	  var toIndex = __webpack_require__(434);
	  var toAbsoluteIndex = __webpack_require__(110);
	  var toPrimitive = __webpack_require__(81);
	  var has = __webpack_require__(51);
	  var classof = __webpack_require__(150);
	  var isObject = __webpack_require__(24);
	  var toObject = __webpack_require__(38);
	  var isArrayIter = __webpack_require__(260);
	  var create = __webpack_require__(104);
	  var getPrototypeOf = __webpack_require__(61);
	  var gOPN = __webpack_require__(105).f;
	  var getIterFn = __webpack_require__(277);
	  var uid = __webpack_require__(111);
	  var wks = __webpack_require__(28);
	  var createArrayMethod = __webpack_require__(76);
	  var createArrayIncludes = __webpack_require__(173);
	  var speciesConstructor = __webpack_require__(185);
	  var ArrayIterators = __webpack_require__(278);
	  var Iterators = __webpack_require__(125);
	  var $iterDetect = __webpack_require__(179);
	  var setSpecies = __webpack_require__(109);
	  var arrayFill = __webpack_require__(252);
	  var arrayCopyWithin = __webpack_require__(407);
	  var $DP = __webpack_require__(33);
	  var $GOPD = __webpack_require__(60);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var extend  = __webpack_require__(1297);
	var isArray = __webpack_require__(660).isArray;
	var isDate  = __webpack_require__(660).isDate;
	var sprintf = __webpack_require__(1541).sprintf;
	var events  = __webpack_require__(447);
	var except  = __webpack_require__(448);
	
	var strftime = __webpack_require__(1276);
	
	var translationScope = 'counterpart';
	
	function isString(val) {
	  return typeof val === 'string' || Object.prototype.toString.call(val) === '[object String]';
	}
	
	function isFunction(val) {
	  return typeof val === 'function' || Object.prototype.toString.call(val) === '[object Function]';
	}
	
	function isPlainObject(val) {
	  //Deal with older browsers (IE8) that don't return [object Null] in this case.
	  if (val === null) {
	    return false;
	  }
	  return Object.prototype.toString.call(val) === '[object Object]';
	}
	
	function isSymbol(key) {
	  return isString(key) && key[0] === ':';
	}
	
	function hasOwnProp(obj, key) {
	  return Object.prototype.hasOwnProperty.call(obj, key);
	}
	
	function getEntry(translations, keys) {
	  return keys.reduce(function(result, key) {
	    if (isPlainObject(result) && hasOwnProp(result, key)) {
	      return result[key];
	    } else {
	      return null;
	    }
	  }, translations);
	}
	
	function Counterpart() {
	  this._registry = {
	    locale: 'en',
	    interpolate: true,
	    fallbackLocales: [],
	    scope: null,
	    translations: {},
	    interpolations: {},
	    normalizedKeys: {},
	    separator: '.',
	    keepTrailingDot: false,
	    keyTransformer: function(key) { return key; }
	  };
	
	  this.registerTranslations('en', __webpack_require__(1275));
	  this.setMaxListeners(0);
	}
	
	extend(Counterpart.prototype, events.EventEmitter.prototype);
	
	Counterpart.prototype.getLocale = function() {
	  return this._registry.locale;
	};
	
	Counterpart.prototype.setLocale = function(value) {
	  var previous = this._registry.locale;
	
	  if (previous != value) {
	    this._registry.locale = value;
	    this.emit('localechange', value, previous);
	  }
	
	  return previous;
	};
	
	Counterpart.prototype.getFallbackLocale = function() {
	  return this._registry.fallbackLocales;
	};
	
	Counterpart.prototype.setFallbackLocale = function(value) {
	  var previous = this._registry.fallbackLocales;
	  this._registry.fallbackLocales = [].concat(value || []);
	  return previous;
	};
	
	Counterpart.prototype.getAvailableLocales = function() {
	  return this._registry.availableLocales || Object.keys(this._registry.translations);
	};
	
	Counterpart.prototype.setAvailableLocales = function(value) {
	  var previous = this.getAvailableLocales();
	  this._registry.availableLocales = value;
	  return previous;
	};
	
	Counterpart.prototype.getSeparator = function() {
	  return this._registry.separator;
	};
	
	Counterpart.prototype.setSeparator = function(value) {
	  var previous = this._registry.separator;
	  this._registry.separator = value;
	  return previous;
	};
	
	Counterpart.prototype.setInterpolate = function(value) {
	  var previous = this._registry.interpolate;
	  this._registry.interpolate = value;
	  return previous;
	};
	
	Counterpart.prototype.getInterpolate = function() {
	  return this._registry.interpolate;
	};
	
	Counterpart.prototype.setKeyTransformer = function(value) {
	  var previous = this._registry.keyTransformer;
	  this._registry.keyTransformer = value;
	  return previous;
	};
	
	Counterpart.prototype.getKeyTransformer = function() {
	  return this._registry.keyTransformer;
	};
	
	Counterpart.prototype.registerTranslations = function(locale, data) {
	  var translations = {};
	  translations[locale] = data;
	  extend(true, this._registry.translations, translations);
	  return translations;
	};
	
	Counterpart.prototype.registerInterpolations = function(data) {
	  return extend(true, this._registry.interpolations, data);
	};
	
	Counterpart.prototype.onLocaleChange =
	Counterpart.prototype.addLocaleChangeListener = function(callback) {
	  this.addListener('localechange', callback);
	};
	
	Counterpart.prototype.offLocaleChange =
	Counterpart.prototype.removeLocaleChangeListener = function(callback) {
	  this.removeListener('localechange', callback);
	};
	
	Counterpart.prototype.onTranslationNotFound =
	Counterpart.prototype.addTranslationNotFoundListener = function(callback) {
	  this.addListener('translationnotfound', callback);
	};
	
	Counterpart.prototype.offTranslationNotFound =
	Counterpart.prototype.removeTranslationNotFoundListener = function(callback) {
	  this.removeListener('translationnotfound', callback);
	};
	
	Counterpart.prototype.translate = function(key, options) {
	  if (!isArray(key) && !isString(key) || !key.length) {
	    throw new Error('invalid argument: key');
	  }
	
	  if (isSymbol(key)) {
	    key = key.substr(1);
	  }
	
	  key = this._registry.keyTransformer(key, options);
	
	  options = extend(true, {}, options);
	
	  var locale = options.locale || this._registry.locale;
	  delete options.locale;
	
	  var scope = options.scope || this._registry.scope;
	  delete options.scope;
	
	  var separator = options.separator || this._registry.separator;
	  delete options.separator;
	
	  var fallbackLocales = [].concat(options.fallbackLocale || this._registry.fallbackLocales);
	  delete options.fallbackLocale;
	
	  var keys = this._normalizeKeys(locale, scope, key, separator);
	
	  var entry = getEntry(this._registry.translations, keys);
	
	  if (entry === null) {
	    this.emit('translationnotfound', locale, key, options.fallback, scope);
	
	    if (options.fallback) {
	      entry = this._fallback(locale, scope, key, options.fallback, options);
	    }
	  }
	
	  if (entry === null && fallbackLocales.length > 0 && fallbackLocales.indexOf(locale) === -1) {
	    for (var ix in fallbackLocales) {
	      var fallbackLocale = fallbackLocales[ix];
	      var fallbackKeys = this._normalizeKeys(fallbackLocale, scope, key, separator);
	      entry = getEntry(this._registry.translations, fallbackKeys);
	
	      if (entry) {
	        locale = fallbackLocale;
	        break;
	      }
	    }
	  }
	
	  if (entry === null) {
	    entry = 'missing translation: ' + keys.join(separator);
	  }
	
	  entry = this._pluralize(locale, entry, options.count);
	
	  if (this._registry.interpolate !== false && options.interpolate !== false) {
	    entry = this._interpolate(entry, options);
	  }
	
	  return entry;
	};
	
	Counterpart.prototype.localize = function(object, options) {
	  if (!isDate(object)) {
	    throw new Error('invalid argument: object must be a date');
	  }
	
	  options = extend(true, {}, options);
	
	  var locale  = options.locale  || this._registry.locale;
	  var scope   = options.scope   || translationScope;
	  var type    = options.type    || 'datetime';
	  var format  = options.format  || 'default';
	
	  options = { locale: locale, scope: scope, interpolate: false };
	  format  = this.translate(['formats', type, format], extend(true, {}, options));
	
	  return strftime(object, format, this.translate('names', options));
	};
	
	Counterpart.prototype._pluralize = function(locale, entry, count) {
	  if (typeof entry !== 'object' || entry === null || typeof count !== 'number') {
	    return entry;
	  }
	
	  var pluralizeFunc = this.translate('pluralize', { locale: locale, scope: translationScope });
	
	  if (Object.prototype.toString.call(pluralizeFunc) !== '[object Function]') {
	    return pluralizeFunc;
	  }
	
	  return pluralizeFunc(entry, count);
	};
	
	Counterpart.prototype.withLocale = function(locale, callback, context) {
	  var previous = this._registry.locale;
	  this._registry.locale = locale;
	  var result = callback.call(context);
	  this._registry.locale = previous;
	  return result;
	};
	
	Counterpart.prototype.withScope = function(scope, callback, context) {
	  var previous = this._registry.scope;
	  this._registry.scope = scope;
	  var result = callback.call(context);
	  this._registry.scope = previous;
	  return result;
	};
	
	Counterpart.prototype.withSeparator = function(separator, callback, context) {
	  var previous = this.setSeparator(separator);
	  var result = callback.call(context);
	  this.setSeparator(previous);
	  return result;
	};
	
	Counterpart.prototype._normalizeKeys = function(locale, scope, key, separator) {
	  var keys = [];
	
	  keys = keys.concat(this._normalizeKey(locale, separator));
	  keys = keys.concat(this._normalizeKey(scope, separator));
	  keys = keys.concat(this._normalizeKey(key, separator));
	
	  return keys;
	};
	
	Counterpart.prototype._normalizeKey = function(key, separator) {
	  this._registry.normalizedKeys[separator] = this._registry.normalizedKeys[separator] || {};
	
	  this._registry.normalizedKeys[separator][key] = this._registry.normalizedKeys[separator][key] || (function(key) {
	    if (isArray(key)) {
	      var normalizedKeyArray = key.map(function(k) { return this._normalizeKey(k, separator); }.bind(this));
	
	      return [].concat.apply([], normalizedKeyArray);
	    } else {
	      if (typeof key === 'undefined' || key === null) {
	        return [];
	      }
	
	      var keys = key.split(separator);
	
	      for (var i = keys.length - 1; i >= 0; i--) {
	        if (keys[i] === '') {
	          keys.splice(i, 1);
	
	          if (this._registry.keepTrailingDot === true && i == keys.length) {
	            keys[keys.length - 1] += '' + separator;
	          }
	        }
	      }
	
	      return keys;
	    }
	  }.bind(this))(key);
	
	  return this._registry.normalizedKeys[separator][key];
	};
	
	Counterpart.prototype._interpolate = function(entry, values) {
	  if (typeof entry !== 'string') {
	    return entry;
	  }
	
	  return sprintf(entry, extend({}, this._registry.interpolations, values));
	};
	
	Counterpart.prototype._resolve = function(locale, scope, object, subject, options) {
	  options = options || {};
	
	  if (options.resolve === false) {
	    return subject;
	  }
	
	  var result;
	
	  if (isSymbol(subject)) {
	    result = this.translate(subject, extend({}, options, { locale: locale, scope: scope }));
	  } else if (isFunction(subject)) {
	    var dateOrTime;
	
	    if (options.object) {
	      dateOrTime = options.object;
	      delete options.object;
	    } else {
	      dateOrTime = object;
	    }
	
	    result = this._resolve(locale, scope, object, subject(dateOrTime, options));
	  } else {
	    result = subject;
	  }
	
	  return /^missing translation:/.test(result) ? null : result;
	};
	
	Counterpart.prototype._fallback = function(locale, scope, object, subject, options) {
	  options = except(options, 'fallback');
	
	  if (isArray(subject)) {
	    for (var i = 0, ii = subject.length; i < ii; i++) {
	      var result = this._resolve(locale, scope, object, subject[i], options);
	
	      if (result) {
	        return result;
	      }
	    }
	
	    return null;
	  } else {
	    return this._resolve(locale, scope, object, subject, options);
	  }
	};
	
	var instance = new Counterpart();
	
	function translate() {
	  return instance.translate.apply(instance, arguments);
	}
	
	extend(translate, instance, {
	  Instance: Counterpart,
	  Translator: Counterpart
	});
	
	module.exports = translate;


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(26);
	
	var PooledClass = __webpack_require__(115);
	
	var emptyFunction = __webpack_require__(55);
	var warning = __webpack_require__(21);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else if (typeof event.returnValue !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 88 */,
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _i18n = __webpack_require__(361);
	
	var _reactCookie = __webpack_require__(594);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	var _counterpart = __webpack_require__(86);
	
	var _counterpart2 = _interopRequireDefault(_counterpart);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CookieUtils = function () {
	  function CookieUtils() {
	    (0, _classCallCheck3.default)(this, CookieUtils);
	  }
	
	  (0, _createClass3.default)(CookieUtils, null, [{
	    key: 'cookieDomain',
	    value: function cookieDomain() {
	      var domainParts = location.hostname.split('.');
	      if (domainParts.length > 2) {
	        domainParts.shift();
	      }
	      return domainParts.join('.');
	    }
	  }, {
	    key: 'setLanguageFromCookie',
	    value: function setLanguageFromCookie(store) {
	      var ffLanguage = _reactCookie2.default.load('ff_language');
	      if (typeof ffLanguage !== 'undefined' && ffLanguage !== _counterpart2.default.getLocale()) {
	        ffLanguage = this.availableLangiages.includes(ffLanguage) ? ffLanguage : 'se';
	        store.dispatch((0, _i18n.changeLanguage)(ffLanguage));
	        this.setHtmlLangFromStore(ffLanguage);
	      }
	    }
	  }, {
	    key: 'setHtmlLangFromStore',
	    value: function setHtmlLangFromStore(lang) {
	      var htmlLang = lang === 'se' ? 'sv' : 'en';
	      document.documentElement.lang = htmlLang;
	    }
	  }, {
	    key: 'setLanguageCookie',
	    value: function setLanguageCookie(lang) {
	      _reactCookie2.default.save('ff_language', lang, {
	        domain: this.cookieDomain(),
	        expires: (0, _moment2.default)().add(24, 'hours').toDate()
	      });
	    }
	  }, {
	    key: 'setNameCookie',
	    value: function setNameCookie(name) {
	      _reactCookie2.default.save('ff_name', name, {
	        domain: this.cookieDomain(),
	        expires: (0, _moment2.default)().add(24, 'hours').toDate()
	      });
	    }
	  }, {
	    key: 'setHidePhoneNumberModalCookie',
	    value: function setHidePhoneNumberModalCookie() {
	      _reactCookie2.default.save('ff_hide_phone_number', true, {
	        domain: this.cookieDomain(),
	        expires: (0, _moment2.default)().add(24, 'hours').toDate()
	      });
	    }
	  }, {
	    key: 'getHidePhoneNumberModalCookie',
	    value: function getHidePhoneNumberModalCookie() {
	      return _reactCookie2.default.load('ff_hide_phone_number');
	    }
	  }, {
	    key: 'setRegisterAssignmentToolVisited',
	    value: function setRegisterAssignmentToolVisited() {
	      _reactCookie2.default.save('ff_register_visited', true);
	    }
	  }, {
	    key: 'getRegisterAssignmentToolVisited',
	    value: function getRegisterAssignmentToolVisited() {
	      return _reactCookie2.default.load('ff_register_visited');
	    }
	  }, {
	    key: 'setInfoBannerClosed',
	    value: function setInfoBannerClosed(text) {
	      _reactCookie2.default.save('ff_info_banner_closed', text);
	    }
	  }, {
	    key: 'getInfoBannerClosed',
	    value: function getInfoBannerClosed(text) {
	      return _reactCookie2.default.load('ff_info_banner_closed') === text;
	    }
	  }, {
	    key: 'removeNameCookie',
	    value: function removeNameCookie() {
	      _reactCookie2.default.remove('ff_name', { domain: this.cookieDomain() });
	    }
	  }, {
	    key: 'updateNameCookie',
	    value: function updateNameCookie() {
	      var ffName = _reactCookie2.default.load('ff_name');
	      if (ffName !== 'undefined') {
	        this.setNameCookie(ffName);
	      }
	    }
	  }]);
	  return CookieUtils;
	}();
	
	CookieUtils.availableLangiages = ['se', 'en'];
	exports.default = CookieUtils;

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AuthenticationService = undefined;
	
	var _stringify = __webpack_require__(166);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _promise = __webpack_require__(72);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(17);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _context = __webpack_require__(222);
	
	var _context2 = _interopRequireDefault(_context);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _actions = __webpack_require__(805);
	
	var _index = __webpack_require__(822);
	
	var _replaceBackendUri = __webpack_require__(788);
	
	var _taxkeyService = __webpack_require__(119);
	
	var _taxkeyService2 = _interopRequireDefault(_taxkeyService);
	
	var _store = __webpack_require__(92);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _index2 = __webpack_require__(164);
	
	var _localStorageStore = __webpack_require__(352);
	
	var _cookieUtils = __webpack_require__(89);
	
	var _cookieUtils2 = _interopRequireDefault(_cookieUtils);
	
	var _pendingRequestEntity = __webpack_require__(42);
	
	var _pendingRequestEntity2 = _interopRequireDefault(_pendingRequestEntity);
	
	var _variables = __webpack_require__(47);
	
	var variables = _interopRequireWildcard(_variables);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuthenticationService = exports.AuthenticationService = function () {
	  function AuthenticationService() {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, AuthenticationService);
	
	    this._requestInterceptor = function (config) {
	      if (_this.store.isEmpty) {
	        return config;
	      }
	
	      config.headers['Authorization'] = 'Bearer ' + _this.oauthToken.accessToken;
	
	      return config;
	    };
	
	    this._responseInterceptor = function (error) {
	      if (_this.shouldRefreshToken(_this.oauthToken, error) && !_this.hasRefreshedToken(error)) {
	        return _this.refreshToken().then(function (response) {
	          return (0, _axios2.default)(error.config);
	        });
	      }
	      return _promise2.default.reject(error);
	    };
	
	    this.shouldRefreshToken = function (token, error) {
	      var noResponse = error.response === undefined;
	      var unauthorized = !noResponse && (error.response.status || null) === 401;
	
	      if (error.config !== undefined && (0, _stringify2.default)(error.config.url).indexOf(variables.apiUrl) === -1) {
	        return false;
	      }
	
	      return token !== null && (noResponse || unauthorized);
	    };
	
	    this.hasRefreshedToken = function (error) {
	      try {
	        var responseJson = JSON.parse(error.response.config.data);
	        if (responseJson.grant_type === 'refresh_token') {
	          _context2.default.store.dispatch((0, _index.setReauthenticationStatus)('fail'));
	          _this._refreshTokenPromise = null;
	          _this.logout();
	          return true;
	        }
	      } catch (e) {
	        return false;
	      }
	      return false;
	    };
	
	    this.store = new _localStorageStore.LocalStorageStore();
	    this.oauthToken = this.store.getOauth();
	    this._refreshTokenPromise = null;
	
	    _axios2.default.defaults.headers.common['Accept'] = 'application/vnd.api.v2+json';
	    _axios2.default.interceptors.request.use(_replaceBackendUri.replaceBackendUri);
	  }
	
	  (0, _createClass3.default)(AuthenticationService, [{
	    key: 'logout',
	    value: function logout() {
	      this.clearUserInfo();
	      _store.history.push('/login');
	    }
	  }, {
	    key: 'logoutWithoutRedirect',
	    value: function logoutWithoutRedirect() {
	      this.clearUserInfo();
	    }
	  }, {
	    key: 'clearUserInfo',
	    value: function clearUserInfo() {
	      this.oauthToken = null;
	      this.store.reset();
	      _cookieUtils2.default.removeNameCookie();
	      _frilansFinans.UserService.clearUser();
	      _store2.default.dispatch((0, _index2.clearUser)());
	    }
	  }, {
	    key: 'login',
	    value: function login(identity, password) {
	      var _this2 = this;
	
	      return _axios2.default.post('backend://auth', {
	        'grant_type': 'password',
	        'username': identity,
	        'password': password,
	        'scope': 'client'
	      }).then(function (response) {
	        return _this2._onSuccessfulAuthentication(response.data);
	      }, function (response) {
	        return _this2._onFailedAuthentication(response);
	      });
	    }
	  }, {
	    key: 'sendMagicLoginLink',
	    value: function sendMagicLoginLink(identity, password) {
	      return _axios2.default.post('backend://email-login-links', {
	        'data': {
	          'attributes': {
	            'username': identity,
	            'password': password
	          }
	        }
	      }).then(function (response) {
	        return response;
	      });
	    }
	  }, {
	    key: 'linkLogin',
	    value: function linkLogin(token) {
	      var _this3 = this;
	
	      return _axios2.default.post('backend://token-login/' + token).then(function (response) {
	        return _this3._onSuccessfulAuthentication(response.data);
	      }).catch(function (error) {
	        return error.response;
	      });
	    }
	  }, {
	    key: 'eidLinkLogin',
	    value: function eidLinkLogin(code) {
	      var _this4 = this;
	
	      return _axios2.default.post(variables.eidUrl + '/exchange', {
	        'code': code
	      }).then(function (response) {
	        return _this4._onSuccessfulAuthentication({
	          'access_token': response.data.access_token,
	          'expires_in': 604800,
	          'refresh_token': response.data.access_token
	        });
	      }).catch(function (error) {
	        return error.response;
	      });
	    }
	  }, {
	    key: 'eidLinkRegister',
	    value: function eidLinkRegister(code) {
	      var _this5 = this;
	
	      return _axios2.default.post(variables.eidUrl + '/create', {
	        'code': code
	      }).then(function (response) {
	        return _this5._onSuccessfulAuthentication({
	          'access_token': response.data.access_token,
	          'expires_in': 604800,
	          'refresh_token': response.data.access_token
	        });
	      }).catch(function (error) {
	        return error.response;
	      });
	    }
	  }, {
	    key: 'loginWithBankId',
	    value: function loginWithBankId(sessionId, createUser) {
	      var _this6 = this;
	
	      var pendingRequest = new _pendingRequestEntity2.default();
	
	      var params = {
	        'grant_type': 'bankid',
	        'session_id': sessionId,
	        'scope': 'client'
	      };
	
	      if (createUser) {
	        params.create_user = 'true';
	      }
	
	      pendingRequest.promise = _axios2.default.post('backend://auth', params, {
	        cancelToken: new _axios2.default.CancelToken(function executor(c) {
	          pendingRequest.cancel = c;
	        })
	      }).then(function (response) {
	        return _this6._onSuccessfulAuthentication(response.data);
	      }, function (response) {
	        return _this6._onFailedAuthentication(response);
	      });
	
	      return pendingRequest;
	    }
	  }, {
	    key: 'getUser',
	    value: function getUser() {
	      var _this7 = this;
	
	      _frilansFinans.UserService.get().promise.then(function (user) {
	        _taxkeyService2.default.get(user.id);
	
	        if (typeof _this7.routerCallback === 'function') {
	          _this7.routerCallback(user);
	        }
	      }, function (error) {
	        return console.log(error);
	      });
	    }
	
	    /**
	     * Inject a request interceptor
	     *
	     * This interceptor handles injecting the oauth token into the proper requests
	     *
	     * @param config
	     * @returns {*}
	     * @private
	     */
	
	
	    /**
	     *
	     * @param response
	     * @returns {*}
	     * @private
	     */
	
	  }, {
	    key: 'refreshToken',
	    value: function refreshToken() {
	      var _this8 = this;
	
	      if (this._refreshTokenPromise !== null) {
	        return this._refreshTokenPromise;
	      }
	
	      this._refreshTokenPromise = _axios2.default.post('backend://auth', {
	        'grant_type': 'refresh_token',
	        'refresh_token': this.oauthToken.refreshToken
	      }).then(function (response) {
	        var token = response.data;
	
	        _this8.oauthToken = {
	          accessToken: token.access_token,
	          expiresIn: token.expires_in,
	          refreshToken: token.refresh_token
	        };
	
	        _this8.store.persist(_this8.oauthToken);
	        _this8._refreshTokenPromise = null;
	        _cookieUtils2.default.updateNameCookie();
	      }).catch(function (e) {
	        _context2.default.store.dispatch((0, _index.setReauthenticationStatus)('fail'));
	        _this8._refreshTokenPromise = null;
	        _this8.logout();
	        throw e;
	      });
	
	      return this._refreshTokenPromise;
	    }
	
	    /**
	     * Handle a successful authentication
	     *
	     * @param token
	     * @private
	     */
	
	  }, {
	    key: '_onSuccessfulAuthentication',
	    value: function _onSuccessfulAuthentication(token) {
	      this.oauthToken = {
	        accessToken: token.access_token,
	        expiresIn: token.expires_in,
	        refreshToken: token.refresh_token
	      };
	
	      this.store.persist(this.oauthToken);
	      _context2.default.store.dispatch((0, _actions.loginSuccess)());
	      this.getUser();
	      return token;
	    }
	
	    /**
	     * Handle a authentication failure
	     *
	     * @param error
	     * @returns {Promise}
	     * @private
	     */
	
	  }, {
	    key: '_onFailedAuthentication',
	    value: function _onFailedAuthentication(error) {
	      _context2.default.store.dispatch((0, _actions.loginFailure)());
	      return _promise2.default.reject(error.response);
	    }
	
	    /**
	     * Used by the token login view to login with query parameters
	     */
	
	  }, {
	    key: 'tokenLogin',
	    value: function tokenLogin(accessToken, expiresIn) {
	      this.oauthToken = {
	        accessToken: accessToken,
	        expiresIn: expiresIn,
	        refreshToken: null
	      };
	
	      this.store.persist(this.oauthToken);
	    }
	  }, {
	    key: 'setRouterCallback',
	    value: function setRouterCallback(callback) {
	      this.routerCallback = callback;
	    }
	  }, {
	    key: 'isAuthenticated',
	    get: function get() {
	      return !this.store.isEmpty;
	    }
	  }]);
	  return AuthenticationService;
	}();
	
	exports.default = new AuthenticationService();

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _frilansFinans = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InvoiceValidator = function () {
	  function InvoiceValidator() {
	    (0, _classCallCheck3.default)(this, InvoiceValidator);
	  }
	
	  (0, _createClass3.default)(InvoiceValidator, null, [{
	    key: 'validateSpecification',
	    value: function validateSpecification(specification) {
	      return specification.length > 4;
	    }
	  }, {
	    key: 'validateCustomer',
	    value: function validateCustomer(customerId) {
	      return _frilansFinans.Utils.isInt(parseInt(customerId)) && parseInt(customerId) > 0;
	    }
	  }, {
	    key: 'validateInvoiceDate',
	    value: function validateInvoiceDate(invoiceDate) {
	      return invoiceDate.length > 0;
	    }
	  }, {
	    key: 'validatePhoneNumberSwedish',
	    value: function validatePhoneNumberSwedish(phonenumber) {
	      if (!phonenumber) {
	        return true;
	      }
	
	      return this.validatePhoneNumberSwedishStrict(phonenumber);
	    }
	  }, {
	    key: 'validatePhoneNumberSwedishStrict',
	    value: function validatePhoneNumberSwedishStrict(phonenumber) {
	      if (!phonenumber) {
	        return false;
	      }
	
	      var normalized = phonenumber.toString().replace('(0)', '').replace(/\D+/gi, '');
	      var re = /^(07|467|\+467)(0|2|3|6|9)\d{7}$/;
	
	      return re.test(normalized);
	    }
	  }, {
	    key: 'validateApartmentNumber',
	    value: function validateApartmentNumber(number) {
	      return _frilansFinans.Utils.isNumeric(number) && number.length === 4;
	    }
	  }, {
	    key: 'validateHsd',
	    value: function validateHsd(rot, data, accommodationType, apartmentNumber, cooperativeApartmentRegistrationNumber) {
	      if (rot) {
	        if (accommodationType === 'house' && data.length < 4) {
	          return false;
	        }
	
	        if (accommodationType === 'apartment' && (!this.validateApartmentNumber(apartmentNumber) || !_frilansFinans.Utils.isVatNumber(cooperativeApartmentRegistrationNumber))) {
	          return false;
	        }
	
	        return true;
	      } else {
	        return true;
	      }
	    }
	
	    /**
	     * Validates the sendToEmail property.
	     * If sendToEmail is undefined it means it hasn't been
	     * added to the params and the invoice should be send by letter.
	     * In that case this is valid.
	     *
	     * @param sendToEmail
	     * @returns {boolean}
	     */
	
	  }, {
	    key: 'validateSendToEmail',
	    value: function validateSendToEmail(sendToEmail) {
	      if (typeof sendToEmail === 'undefined' || sendToEmail === '') {
	        return true;
	      }
	
	      return this.validateEmail(sendToEmail);
	    }
	  }, {
	    key: 'validateEmail',
	    value: function validateEmail(email) {
	      /*eslint-disable */
	      var re = /^(([^<>()\[\]\\.,;:\s@"äöå]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([åäöa-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	      /*eslint-enable */
	
	      var validEmail = re.test(email);
	
	      return validEmail;
	    }
	  }, {
	    key: 'validateSendToEinvoiceAddress',
	    value: function validateSendToEinvoiceAddress(sendToEinvoiceAddress) {
	      if (!sendToEinvoiceAddress) {
	        return true;
	      }
	      return _frilansFinans.Utils.isValidEinvoiceAddress(sendToEinvoiceAddress);
	    }
	  }, {
	    key: 'validateAmount',
	    value: function validateAmount(amount) {
	      return _frilansFinans.Utils.isNumeric(amount) && amount !== 0;
	    }
	  }, {
	    key: 'validatePositiveAmount',
	    value: function validatePositiveAmount(invoiceusers) {
	      var isPositive = true;
	      invoiceusers.forEach(function (invoiceuser) {
	        if (invoiceuser.gross < 0) {
	          isPositive = false;
	        }
	      });
	      return isPositive;
	    }
	  }, {
	    key: 'validateMaxHours',
	    value: function validateMaxHours(invoiceDate) {
	      return invoiceDate.find(function (date) {
	        return date.hours > 24;
	      }) === undefined;
	    }
	  }, {
	    key: 'validateInvoicing',
	    value: function validateInvoicing(invoice) {
	      if (invoice.message_type === 'email') {
	        return this.validateEmail(invoice.send_to_email);
	      }
	      if (invoice.message_type === 'sms') {
	        return this.validatePhoneNumberSwedishStrict(invoice.company_phone);
	      }
	      if (invoice.message_type === 'e-invoice') {
	        return _frilansFinans.Utils.isValidEinvoiceAddress(invoice.e_invoice_address);
	      }
	      return true;
	    }
	
	    /**
	     * Validates all added fields of an invoice
	     *
	     * @param invoice has the post reqest format for all params
	     * @returns {*}
	     */
	
	  }, {
	    key: 'invoiceIsValid',
	    value: function invoiceIsValid(invoice) {
	      // TODO: Add all coming functions to this condition
	      var hsdValidate = true;
	
	      if (invoice.hsd !== undefined) {
	        var hsd = invoice.hsd;
	        hsdValidate = this.validateHsd(hsd.rot, hsd.data, hsd.accommodation_type, hsd.apartment_number, hsd.cooperative_apartment_registration_number);
	      }
	
	      return this.validateSpecification(invoice.specification) && this.validateCustomer(invoice.company_id) && this.validateInvoiceDate(invoice.invoicedate) && this.validateSendToEmail(invoice.send_to_email) && this.validateSendToEinvoiceAddress(invoice.e_invoice_address) && this.validatePhoneNumberSwedish(invoice.company_phone) && hsdValidate && this.validateAmount(invoice.amount) && this.validatePositiveAmount(invoice.invoiceuser) && this.validateMaxHours(invoice.invoicedate) && this.validateInvoicing(invoice);
	    }
	  }]);
	  return InvoiceValidator;
	}(); /**
	      * Created by staffanrantzow on 08/11/16.
	      */
	
	exports.default = InvoiceValidator;

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.history = undefined;
	
	var _createBrowserHistory = __webpack_require__(283);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _configureStore = __webpack_require__(821);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	var _reactRouter = __webpack_require__(20);
	
	var _reactRouterRedux = __webpack_require__(137);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var browserHistory = (0, _reactRouter.useRouterHistory)(_createBrowserHistory2.default)({
	  basename: ("")
	});
	
	var initialState = window.__INITIAL_STATE__;
	var store = (0, _configureStore2.default)(initialState, browserHistory);
	var history = (0, _reactRouterRedux.syncHistoryWithStore)(browserHistory, store, {
	  selectLocationState: function selectLocationState(state) {
	    return state.router;
	  }
	});
	
	exports.default = store;
	exports.history = history;

/***/ },
/* 93 */
[1595, 65, 147, 75],
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(28)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(52)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ },
/* 95 */
[1606, 111, 24, 51, 33, 23],
/* 96 */,
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SpinnerButton = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SpinnerButton = __webpack_require__(1305);
	
	var _SpinnerButton2 = _interopRequireDefault(_SpinnerButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 16/03/16.
	 */
	
	var SpinnerButton = exports.SpinnerButton = function (_React$Component) {
	  (0, _inherits3.default)(SpinnerButton, _React$Component);
	
	  function SpinnerButton(props) {
	    (0, _classCallCheck3.default)(this, SpinnerButton);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SpinnerButton.__proto__ || (0, _getPrototypeOf2.default)(SpinnerButton)).call(this, props));
	
	    _this.callCallback = _this.callCallback.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(SpinnerButton, [{
	    key: 'callCallback',
	    value: function callCallback(e) {
	      if (!this.props.loading && typeof this.props.callback === 'function') {
	        this.props.callback(e);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var classes = this.props.classes + ' ' + _SpinnerButton2.default.spinnerButton;
	
	      if (this.props.loading) {
	        classes += ' ' + _SpinnerButton2.default.show;
	      }
	
	      if (this.props.graySpinner === 'true') {
	        classes += ' ' + _SpinnerButton2.default.spinnerButtonGray;
	      }
	
	      return _react2.default.createElement(
	        'button',
	        { id: this.props.id, type: this.props.type ? this.props.type : 'submit',
	          className: classes,
	          onClick: this.callCallback,
	          disabled: this.props.disabled },
	        _react2.default.createElement(
	          'span',
	          { id: 'spinner-text', className: _SpinnerButton2.default.spinnerText },
	          this.props.text
	        ),
	        _react2.default.createElement(
	          'span',
	          { id: 'spinner-element', className: _SpinnerButton2.default.spinnerElement },
	          _react2.default.createElement('span', { className: _SpinnerButton2.default.spinner })
	        )
	      );
	    }
	  }]);
	  return SpinnerButton;
	}(_react2.default.Component);
	
	exports.default = SpinnerButton;

/***/ },
/* 98 */
23,
/* 99 */
51,
/* 100 */
[1632, 238, 235],
/* 101 */
/***/ function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ },
/* 102 */
[1594, 67, 418, 260, 16, 34, 277],
/* 103 */
/***/ function(module, exports) {

	module.exports = false;


/***/ },
/* 104 */
[1610, 16, 424, 256, 268, 255, 258],
/* 105 */
[1615, 426, 256],
/* 106 */
[1618, 426, 256],
/* 107 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(53);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(19);
	var dP = __webpack_require__(33);
	var DESCRIPTORS = __webpack_require__(32);
	var SPECIES = __webpack_require__(28)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ },
/* 110 */
[1631, 80],
/* 111 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */
[1662, 25],
/* 116 */,
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DatepickerRange = undefined;
	
	var _assign = __webpack_require__(22);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDatepicker = __webpack_require__(1385);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _reactRedux = __webpack_require__(12);
	
	var _datepickerRange = __webpack_require__(828);
	
	var _reducer = __webpack_require__(358);
	
	var _reactRouterRedux = __webpack_require__(137);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(1299); /**
	                                                        * Created by staffanrantzow on 22/03/16.
	                                                        */
	
	var _ref = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'DATE_COMPARE_ERROR' });
	
	var DatepickerRange = exports.DatepickerRange = function (_React$Component) {
	  (0, _inherits3.default)(DatepickerRange, _React$Component);
	
	  function DatepickerRange(props) {
	    (0, _classCallCheck3.default)(this, DatepickerRange);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (DatepickerRange.__proto__ || (0, _getPrototypeOf2.default)(DatepickerRange)).call(this, props));
	
	    _this.componentWillMount = function () {
	      var _this$props$location$ = _this.props.location.query,
	          startDate = _this$props$location$.startDate,
	          endDate = _this$props$location$.endDate;
	
	      _this.props.changeStartDate(startDate || _reducer.initialState.dateFilter.startDate);
	      _this.props.changeEndDate(endDate || _reducer.initialState.dateFilter.endDate);
	    };
	
	    _this.updateEndDate = _this.updateEndDate.bind(_this);
	    _this.updateStartDate = _this.updateStartDate.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(DatepickerRange, [{
	    key: 'updateStartDate',
	    value: function updateStartDate(startDate) {
	      this.replaceQuery(startDate.format('YYYY-MM-DD'), this.props.dateFilter.endDate);
	      this.props.changeStartDate(startDate);
	      this.removeFocus();
	    }
	  }, {
	    key: 'updateEndDate',
	    value: function updateEndDate(endDate) {
	      this.replaceQuery(this.props.dateFilter.startDate, endDate.format('YYYY-MM-DD'));
	      this.props.changeEndDate(endDate);
	      this.removeFocus();
	    }
	  }, {
	    key: 'replaceQuery',
	    value: function replaceQuery(startDate, endDate) {
	      this.props.replace({
	        pathname: this.props.location.pathname,
	        query: (0, _assign2.default)({}, this.props.location.query, {
	          startDate: startDate, endDate: endDate
	        })
	      });
	    }
	  }, {
	    key: 'removeFocus',
	    value: function removeFocus() {
	      setTimeout(function () {
	        document.activeElement.blur();
	      }, 0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var showErrorClass = !this.props.dateFilter.error ? 'datepicker-error' : 'error show';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'datepicker-range' },
	        _react2.default.createElement(_reactDatepicker2.default, {
	          selected: (0, _moment2.default)(this.props.dateFilter.startDate),
	          onChange: this.updateStartDate,
	          placeholderText: (0, _proxyCounterpart.proxyCounterpart)('FROM'),
	          className: 'date-picker',
	          dateFormat: 'YYYY-MM-DD',
	          fixedHeight: true,
	          popperPlacement: 'bottom-start'
	        }),
	        _react2.default.createElement(_reactDatepicker2.default, {
	          selected: (0, _moment2.default)(this.props.dateFilter.endDate),
	          onChange: this.updateEndDate,
	          placeholderText: (0, _proxyCounterpart.proxyCounterpart)('TO'),
	          className: 'date-picker',
	          dateFormat: 'YYYY-MM-DD',
	          fixedHeight: true,
	          popperPlacement: 'bottom-start'
	        }),
	        _react2.default.createElement(
	          'p',
	          { className: showErrorClass },
	          _ref
	        )
	      );
	    }
	  }]);
	  return DatepickerRange;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    dateFilter: state.filters.dateFilter,
	    location: state.router.locationBeforeTransitions
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    changeStartDate: function changeStartDate(date) {
	      return dispatch((0, _datepickerRange.changeStartDate)(date));
	    },
	    changeEndDate: function changeEndDate(date) {
	      return dispatch((0, _datepickerRange.changeEndDate)(date));
	    },
	    replace: function replace(url) {
	      return dispatch((0, _reactRouterRedux.replace)(url));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DatepickerRange);

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _utils = __webpack_require__(29);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 15/04/16.
	 */
	
	var Service = function () {
	  function Service() {
	    (0, _classCallCheck3.default)(this, Service);
	  }
	
	  (0, _createClass3.default)(Service, [{
	    key: 'fixDate',
	
	
	    /**
	     * Set end-date to one day later.
	     */
	    value: function fixDate(dateFilter) {
	      var start, end;
	
	      start = (0, _moment2.default)(dateFilter.startDate).startOf('day').format();
	      end = (0, _moment2.default)(dateFilter.endDate).add(1, 'days').startOf('day').format();
	
	      return {
	        startDate: start,
	        endDate: end
	      };
	    }
	  }, {
	    key: 'getFilterDate',
	    value: function getFilterDate(dateFilter, column) {
	      if (dateFilter) {
	        var dates = this.fixDate(dateFilter);
	
	        return '?filter[' + column + '][' + encodeURIComponent('>=') + '][]=' + _utils2.default.formatDate(dates.startDate) + ('&filter[' + column + '][' + encodeURIComponent('<=') + '][]=' + _utils2.default.formatDate(dates.endDate));
	      }
	      return '?';
	    }
	  }]);
	  return Service;
	}();
	
	exports.default = Service;

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(72);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getIterator2 = __webpack_require__(18);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _taxkeyEntity = __webpack_require__(797);
	
	var _taxkeyEntity2 = _interopRequireDefault(_taxkeyEntity);
	
	var _axios = __webpack_require__(17);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _store = __webpack_require__(92);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _index = __webpack_require__(839);
	
	var _index2 = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TaxkeyService = function () {
	  function TaxkeyService() {
	    (0, _classCallCheck3.default)(this, TaxkeyService);
	  }
	
	  (0, _createClass3.default)(TaxkeyService, [{
	    key: 'hydrate',
	    value: function hydrate(taxkey) {
	      return new _taxkeyEntity2.default(taxkey.id, taxkey.attributes.active, taxkey.attributes.taxkey_name, taxkey.attributes.taxkey_value, taxkey.attributes.tax_amount, taxkey.attributes.payroll_tax, taxkey.attributes.fee, taxkey.attributes.fee_express, +taxkey.attributes.discount);
	    }
	  }, {
	    key: 'hydrateCollection',
	    value: function hydrateCollection(data) {
	      var taxkeys = [];
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var taxkey = _step.value;
	
	          taxkeys.push(this.hydrate(taxkey));
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return taxkeys;
	    }
	  }, {
	    key: 'storeTaxkeys',
	    value: function storeTaxkeys(data) {
	      var taxkeyData = [];
	
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var obj = _step2.value;
	
	          taxkeyData.push(obj);
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      var taxkeys = this.hydrateCollection(taxkeyData);
	
	      _store2.default.dispatch((0, _index.setTaxkeys)(taxkeys));
	      _store2.default.dispatch((0, _index2.setLoggedInInvoiceUserTaxKeys)(taxkeys));
	    }
	  }, {
	    key: 'getWorkersTaxkeys',
	    value: function getWorkersTaxkeys(workerIds) {
	      var _this = this;
	
	      return _axios2.default.get('backend://workers/taxkeys?workerids=' + workerIds).then(function (response) {
	        return response.data.map(function (item) {
	          return {
	            userId: item.user_id,
	            taxkeys: _this.hydrateCollection(item.taxkeys)
	          };
	        });
	      });
	    }
	  }, {
	    key: 'getWorkerTaxkeys',
	    value: function getWorkerTaxkeys(workerId) {
	      var _this2 = this;
	
	      return _axios2.default.get('backend://workers/' + workerId + '/taxkeys').then(function (response) {
	        return _this2.hydrateCollection(response.data.data);
	      });
	    }
	  }, {
	    key: 'get',
	    value: function get(userId) {
	      var _this3 = this;
	
	      if (localStorage.getItem('oauth')) {
	        return _axios2.default.get('backend://users/' + userId + '/taxkeys').then(function (response) {
	          _this3.storeTaxkeys(response.data.data);
	        });
	      }
	
	      return _promise2.default.resolve();
	    }
	  }]);
	  return TaxkeyService;
	}(); /**
	      * Created by staffanrantzow on 14/06/16.
	      */
	
	exports.default = new TaxkeyService();

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(1000);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ },
/* 121 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 122 */
[1618, 397, 237],
/* 123 */
[1634, 235],
/* 124 */
[1652, 1052, 239],
/* 125 */
121,
/* 126 */
[1625, 33, 51, 28],
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9);
	var defined = __webpack_require__(78);
	var fails = __webpack_require__(23);
	var spaces = __webpack_require__(272);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ },
/* 128 */
[1636, 24],
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(1277);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },
/* 130 */,
/* 131 */,
/* 132 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 133 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.clone = clone;
	exports.addMonths = addMonths;
	exports.isSameDay = isSameDay;
	exports.isDayBefore = isDayBefore;
	exports.isDayAfter = isDayAfter;
	exports.isPastDay = isPastDay;
	exports.isFutureDay = isFutureDay;
	exports.isDayBetween = isDayBetween;
	exports.addDayToRange = addDayToRange;
	exports.isDayInRange = isDayInRange;
	exports.getWeekNumber = getWeekNumber;
	/**
	 * Clone a date object.
	 *
	 * @export
	 * @param  {Date} d The date to clone
	 * @return {Date} The cloned date
	 */
	function clone(d) {
	  return new Date(d.getTime());
	}
	
	/**
	 * Return `d` as a new date with `n` months added.
	 *
	 * @export
	 * @param {[type]} d
	 * @param {[type]} n
	 */
	function addMonths(d, n) {
	  var newDate = clone(d);
	  newDate.setMonth(d.getMonth() + n);
	  return newDate;
	}
	
	/**
	 * Return `true` if two dates are the same day, ignoring the time.
	 *
	 * @export
	 * @param  {Date}  d1
	 * @param  {Date}  d2
	 * @return {Boolean}
	 */
	function isSameDay(d1, d2) {
	  if (!d1 || !d2) {
	    return false;
	  }
	  return d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
	}
	
	/**
	 * Returns `true` if the first day is before the second day.
	 *
	 * @export
	 * @param {Date} d1
	 * @param {Date} d2
	 * @returns {Boolean}
	 */
	function isDayBefore(d1, d2) {
	  var day1 = clone(d1).setHours(0, 0, 0, 0);
	  var day2 = clone(d2).setHours(0, 0, 0, 0);
	  return day1 < day2;
	}
	
	/**
	 * Returns `true` if the first day is after the second day.
	 *
	 * @export
	 * @param {Date} d1
	 * @param {Date} d2
	 * @returns {Boolean}
	 */
	function isDayAfter(d1, d2) {
	  var day1 = clone(d1).setHours(0, 0, 0, 0);
	  var day2 = clone(d2).setHours(0, 0, 0, 0);
	  return day1 > day2;
	}
	
	/**
	 * Return `true` if a day is in the past, e.g. yesterday or any day
	 * before yesterday.
	 *
	 * @export
	 * @param  {Date}  d
	 * @return {Boolean}
	 */
	function isPastDay(d) {
	  var today = new Date();
	  today.setHours(0, 0, 0, 0);
	  return isDayBefore(d, today);
	}
	
	/**
	 * Return `true` if a day is in the future, e.g. tomorrow or any day
	 * after tomorrow.
	 *
	 * @export
	 * @param  {Date}  d
	 * @return {Boolean}
	 */
	function isFutureDay(d) {
	  var tomorrow = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
	  tomorrow.setHours(0, 0, 0, 0);
	  return d >= tomorrow;
	}
	
	/**
	 * Return `true` if day `d` is between days `d1` and `d2`,
	 * without including them.
	 *
	 * @export
	 * @param  {Date}  d
	 * @param  {Date}  d1
	 * @param  {Date}  d2
	 * @return {Boolean}
	 */
	function isDayBetween(d, d1, d2) {
	  var date = clone(d);
	  date.setHours(0, 0, 0, 0);
	  return isDayAfter(date, d1) && isDayBefore(date, d2) || isDayAfter(date, d2) && isDayBefore(date, d1);
	}
	
	/**
	 * Add a day to a range and return a new range. A range is an object with
	 * `from` and `to` days.
	 *
	 * @export
	 * @param {Date} day
	 * @param {Object} range
	 * @return {Object} Returns a new range object
	 */
	function addDayToRange(day) {
	  var range = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { from: null, to: null };
	  var from = range.from,
	      to = range.to;
	
	  if (!from) {
	    from = day;
	  } else if (from && to && isSameDay(from, to) && isSameDay(day, from)) {
	    from = null;
	    to = null;
	  } else if (to && isDayBefore(day, from)) {
	    from = day;
	  } else if (to && isSameDay(day, to)) {
	    from = day;
	    to = day;
	  } else {
	    to = day;
	    if (isDayBefore(to, from)) {
	      to = from;
	      from = day;
	    }
	  }
	
	  return { from: from, to: to };
	}
	
	/**
	 * Return `true` if a day is included in a range of days.
	 *
	 * @export
	 * @param  {Date}  day
	 * @param  {Object}  range
	 * @return {Boolean}
	 */
	function isDayInRange(day, range) {
	  var from = range.from,
	      to = range.to;
	
	  return from && isSameDay(day, from) || to && isSameDay(day, to) || from && to && isDayBetween(day, from, to);
	}
	
	/**
	 * Return the year's week number (as per ISO, i.e. with the week starting from monday)
	 * for the given day.
	 *
	 * @export
	 * @param {Date} day
	 * @returns {Number}
	 */
	function getWeekNumber(day) {
	  var date = clone(day);
	  date.setHours(0, 0, 0);
	  date.setDate(date.getDate() + 4 - (date.getDay() || 7));
	  return Math.ceil(((date - new Date(date.getFullYear(), 0, 1)) / 8.64e7 + 1) / 7);
	}
	
	exports.default = {
	  addDayToRange: addDayToRange,
	  addMonths: addMonths,
	  clone: clone,
	  getWeekNumber: getWeekNumber,
	  isDayAfter: isDayAfter,
	  isDayBefore: isDayBefore,
	  isDayBetween: isDayBetween,
	  isDayInRange: isDayInRange,
	  isFutureDay: isFutureDay,
	  isPastDay: isPastDay,
	  isSameDay: isSameDay
	};
	//# sourceMappingURL=DateUtils.js.map

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(293);
	var setInnerHTML = __webpack_require__(201);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(301);
	var setTextContent = __webpack_require__(617);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var invariant = __webpack_require__(15);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(1434);
	var ReactInstrumentation = __webpack_require__(70);
	
	var warning = __webpack_require__(21);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
	  ) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */
45,
/* 144 */
66,
/* 145 */
[1594, 83, 391, 389, 74, 171, 250],
/* 146 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 147 */
107,
/* 148 */
[1625, 65, 99, 44],
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1057);
	var global = __webpack_require__(48);
	var hide = __webpack_require__(93);
	var Iterators = __webpack_require__(121);
	var TO_STRING_TAG = __webpack_require__(44)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ },
/* 150 */
[1586, 66, 28],
/* 151 */
[1598, 66],
/* 152 */
146,
/* 153 */,
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports._curry = exports.bsSizes = exports.bsStyles = exports.bsClass = undefined;
	
	var _entries = __webpack_require__(1005);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _extends2 = __webpack_require__(27);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.prefix = prefix;
	exports.getClassSet = getClassSet;
	exports.splitBsProps = splitBsProps;
	exports.splitBsPropsAndOmit = splitBsPropsAndOmit;
	exports.addStyle = addStyle;
	
	var _invariant = __webpack_require__(35);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StyleConfig = __webpack_require__(1384);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function curry(fn) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var last = args[args.length - 1];
	    if (typeof last === 'function') {
	      return fn.apply(undefined, args);
	    }
	    return function (Component) {
	      return fn.apply(undefined, args.concat([Component]));
	    };
	  };
	} // TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.
	
	function prefix(props, variant) {
	  !(props.bsClass != null) ?  false ? (0, _invariant2['default'])(false, 'A `bsClass` prop is required for this component') : (0, _invariant2['default'])(false) : void 0;
	  return props.bsClass + (variant ? '-' + variant : '');
	}
	
	var bsClass = exports.bsClass = curry(function (defaultClass, Component) {
	  var propTypes = Component.propTypes || (Component.propTypes = {});
	  var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	
	  propTypes.bsClass = _propTypes2['default'].string;
	  defaultProps.bsClass = defaultClass;
	
	  return Component;
	});
	
	var bsStyles = exports.bsStyles = curry(function (styles, defaultStyle, Component) {
	  if (typeof defaultStyle !== 'string') {
	    Component = defaultStyle;
	    defaultStyle = undefined;
	  }
	
	  var existing = Component.STYLES || [];
	  var propTypes = Component.propTypes || {};
	
	  styles.forEach(function (style) {
	    if (existing.indexOf(style) === -1) {
	      existing.push(style);
	    }
	  });
	
	  var propType = _propTypes2['default'].oneOf(existing);
	
	  // expose the values on the propType function for documentation
	  Component.STYLES = propType._values = existing;
	
	  Component.propTypes = (0, _extends3['default'])({}, propTypes, {
	    bsStyle: propType
	  });
	
	  if (defaultStyle !== undefined) {
	    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	    defaultProps.bsStyle = defaultStyle;
	  }
	
	  return Component;
	});
	
	var bsSizes = exports.bsSizes = curry(function (sizes, defaultSize, Component) {
	  if (typeof defaultSize !== 'string') {
	    Component = defaultSize;
	    defaultSize = undefined;
	  }
	
	  var existing = Component.SIZES || [];
	  var propTypes = Component.propTypes || {};
	
	  sizes.forEach(function (size) {
	    if (existing.indexOf(size) === -1) {
	      existing.push(size);
	    }
	  });
	
	  var values = [];
	  existing.forEach(function (size) {
	    var mappedSize = _StyleConfig.SIZE_MAP[size];
	    if (mappedSize && mappedSize !== size) {
	      values.push(mappedSize);
	    }
	
	    values.push(size);
	  });
	
	  var propType = _propTypes2['default'].oneOf(values);
	  propType._values = values;
	
	  // expose the values on the propType function for documentation
	  Component.SIZES = existing;
	
	  Component.propTypes = (0, _extends3['default'])({}, propTypes, {
	    bsSize: propType
	  });
	
	  if (defaultSize !== undefined) {
	    if (!Component.defaultProps) {
	      Component.defaultProps = {};
	    }
	    Component.defaultProps.bsSize = defaultSize;
	  }
	
	  return Component;
	});
	
	function getClassSet(props) {
	  var _classes;
	
	  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);
	
	  if (props.bsSize) {
	    var bsSize = _StyleConfig.SIZE_MAP[props.bsSize] || props.bsSize;
	    classes[prefix(props, bsSize)] = true;
	  }
	
	  if (props.bsStyle) {
	    classes[prefix(props, props.bsStyle)] = true;
	  }
	
	  return classes;
	}
	
	function getBsProps(props) {
	  return {
	    bsClass: props.bsClass,
	    bsSize: props.bsSize,
	    bsStyle: props.bsStyle,
	    bsRole: props.bsRole
	  };
	}
	
	function isBsProp(propName) {
	  return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
	}
	
	function splitBsProps(props) {
	  var elementProps = {};
	  (0, _entries2['default'])(props).forEach(function (_ref) {
	    var propName = _ref[0],
	        propValue = _ref[1];
	
	    if (!isBsProp(propName)) {
	      elementProps[propName] = propValue;
	    }
	  });
	
	  return [getBsProps(props), elementProps];
	}
	
	function splitBsPropsAndOmit(props, omittedPropNames) {
	  var isOmittedProp = {};
	  omittedPropNames.forEach(function (propName) {
	    isOmittedProp[propName] = true;
	  });
	
	  var elementProps = {};
	  (0, _entries2['default'])(props).forEach(function (_ref2) {
	    var propName = _ref2[0],
	        propValue = _ref2[1];
	
	    if (!isBsProp(propName) && !isOmittedProp[propName]) {
	      elementProps[propName] = propValue;
	    }
	  });
	
	  return [getBsProps(props), elementProps];
	}
	
	/**
	 * Add a style variant to a Component. Mutates the propTypes of the component
	 * in order to validate the new variant.
	 */
	function addStyle(Component) {
	  for (var _len2 = arguments.length, styleVariant = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    styleVariant[_key2 - 1] = arguments[_key2];
	  }
	
	  bsStyles(styleVariant, Component);
	}
	
	var _curry = exports._curry = curry;

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var EventPluginRegistry = __webpack_require__(294);
	var EventPluginUtils = __webpack_require__(295);
	var ReactErrorUtils = __webpack_require__(299);
	
	var accumulateInto = __webpack_require__(611);
	var forEachAccumulated = __webpack_require__(612);
	var invariant = __webpack_require__(15);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(155);
	var EventPluginUtils = __webpack_require__(295);
	
	var accumulateInto = __webpack_require__(611);
	var forEachAccumulated = __webpack_require__(612);
	var warning = __webpack_require__(21);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 157 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(87);
	
	var getEventTarget = __webpack_require__(304);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(308);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function elementType(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  if (propType !== 'function' && propType !== 'string') {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(elementType);

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ErrorMessage = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ErrorMessage = exports.ErrorMessage = function (_React$Component) {
	  (0, _inherits3.default)(ErrorMessage, _React$Component);
	
	  function ErrorMessage() {
	    (0, _classCallCheck3.default)(this, ErrorMessage);
	    return (0, _possibleConstructorReturn3.default)(this, (ErrorMessage.__proto__ || (0, _getPrototypeOf2.default)(ErrorMessage)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ErrorMessage, [{
	    key: 'marginTop',
	    value: function marginTop() {
	      return this.props.marginTop ? { marginTop: this.props.marginTop + 'px' } : null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.show && this.props.errorMessage) {
	        return _react2.default.createElement(
	          'div',
	          {
	            className: 'error-message-without-border',
	            style: this.marginTop() },
	          _react2.default.createElement(
	            'span',
	            null,
	            this.props.errorMessage
	          )
	        );
	      }
	      return null;
	    }
	  }]);
	  return ErrorMessage;
	}(_react2.default.Component);
	
	exports.default = ErrorMessage;

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Ellipsis = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Ellipsis = exports.Ellipsis = function (_React$Component) {
	  (0, _inherits3.default)(Ellipsis, _React$Component);
	
	  function Ellipsis() {
	    (0, _classCallCheck3.default)(this, Ellipsis);
	    return (0, _possibleConstructorReturn3.default)(this, (Ellipsis.__proto__ || (0, _getPrototypeOf2.default)(Ellipsis)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Ellipsis, [{
	    key: 'getFillColor',
	    value: function getFillColor() {
	      switch (this.props.colorSchema) {
	        case 'primary':
	          return '#00587c';
	        default:
	          return '#000000';
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var fill = this.props.fill ? '' : ' 9c-0.827 0-1.5 0.673-1.5 1.5s0.673 1.5 1.5 1.5 1.5-0.673 1.5-1.5c0-0.827-0.673-1.5-1.5-1.5z';
	
	      return _react2.default.createElement(
	        'svg',
	        { width: '20', height: '20', viewBox: '0 0 20 20' },
	        _react2.default.createElement('path', { d: 'M2.5 13c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5 2.5 1.122 2.5 2.5-1.122 2.5-2.5 2.5z' + (fill ? 'M2.5' + fill : ''),
	          fill: this.getFillColor() }),
	        _react2.default.createElement('path', { d: 'M9.5 13c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5 2.5 1.122 2.5 2.5-1.122 2.5-2.5 2.5z' + (fill ? 'M9.5' + fill : ''),
	          fill: this.getFillColor() }),
	        _react2.default.createElement('path', { d: 'M16.5 13c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5 2.5 1.122 2.5 2.5-1.122 2.5-2.5 2.5z' + (fill ? 'M16.5' + fill : ''),
	          fill: this.getFillColor() })
	      );
	    }
	  }]);
	  return Ellipsis;
	}(_react2.default.Component);
	
	exports.default = Ellipsis;

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ModalContainer = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(30);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _close = __webpack_require__(213);
	
	var _close2 = _interopRequireDefault(_close);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalContainer = exports.ModalContainer = function (_React$Component) {
	  (0, _inherits3.default)(ModalContainer, _React$Component);
	
	  function ModalContainer(props) {
	    (0, _classCallCheck3.default)(this, ModalContainer);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ModalContainer.__proto__ || (0, _getPrototypeOf2.default)(ModalContainer)).call(this, props));
	
	    _this.reject = _this.reject.bind(_this);
	    _this.renderHeaderSlot = _this.renderHeaderSlot.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(ModalContainer, [{
	    key: 'reject',
	    value: function reject() {
	      this.props.callback(false);
	    }
	  }, {
	    key: 'renderHeaderSlot',
	    value: function renderHeaderSlot() {
	      if (this.props.headerSlot) {
	        return this.props.headerSlot;
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderCloseButton',
	    value: function renderCloseButton() {
	      if (!this.props.hideClose) {
	        return _react2.default.createElement(_close2.default, {
	          color: '#000000',
	          classes: 'new-modal-close',
	          callback: this.reject
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var defaultClass = this.props.shrink ? 'new-modal pre-wrap' : 'new-modal cover-mobile pre-wrap';
	      var wideClass = this.props.wide ? ' new-modal-wide' : '';
	      var customClasses = ' ' + this.props.classes;
	
	      var titleClass = 'new-modal-header-title-container';
	      var titleMargin = this.props.titleMargin ? ' title-margin' : '';
	
	      return _react2.default.createElement(
	        _reactModal2.default,
	        {
	          className: '' + defaultClass + wideClass + customClasses,
	          contentLabel: '',
	          isOpen: this.props.isOpen
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'new-modal-header' },
	          _react2.default.createElement(
	            'div',
	            { className: '' + titleClass + titleMargin },
	            _react2.default.createElement(_reactTranslateComponent2.default, { className: 'modal-title', content: this.props.title }),
	            this.renderCloseButton()
	          ),
	          this.renderHeaderSlot()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'new-modal-body' },
	          this.props.children
	        )
	      );
	    }
	  }]);
	  return ModalContainer;
	}(_react2.default.Component);
	
	exports.default = ModalContainer;

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(18);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.reset = reset;
	exports.setBanks = setBanks;
	exports.setSelectedBank = setSelectedBank;
	exports.setClearingNumber = setClearingNumber;
	exports.setClearingNumberIsValid = setClearingNumberIsValid;
	exports.setClearingNumberSuppressError = setClearingNumberSuppressError;
	exports.setClearingNumberErrorMessage = setClearingNumberErrorMessage;
	exports.setAccountNumber = setAccountNumber;
	exports.setAccountNumberIsValid = setAccountNumberIsValid;
	exports.setAccountNumberSuppressError = setAccountNumberSuppressError;
	exports.setAccountNumberErrorMessage = setAccountNumberErrorMessage;
	exports.setBank = setBank;
	exports.fetchBanks = fetchBanks;
	exports.syncBankInfoFromUser = syncBankInfoFromUser;
	exports.identifyBank = identifyBank;
	
	var _lodash = __webpack_require__(40);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _actionTypes = __webpack_require__(356);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _bankService = __webpack_require__(756);
	
	var _bankService2 = _interopRequireDefault(_bankService);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function reset() {
	  return {
	    type: types.RESET
	  };
	}
	
	function setBanks(payload) {
	  return {
	    type: types.SET_BANKS,
	    payload: payload
	  };
	}
	
	function setSelectedBank(payload) {
	  return {
	    type: types.SET_SELECTED_BANK,
	    payload: payload
	  };
	}
	
	function setClearingNumber(payload) {
	  return {
	    type: types.SET_CLEARING_NUMBER,
	    payload: payload
	  };
	}
	
	function setClearingNumberIsValid(payload) {
	  return {
	    type: types.SET_CLEARING_NUMBER_IS_VALID,
	    payload: payload
	  };
	}
	
	function setClearingNumberSuppressError(payload) {
	  return {
	    type: types.SET_CLEARING_NUMBER_SUPPRESS_ERROR,
	    payload: payload
	  };
	}
	
	function setClearingNumberErrorMessage(payload) {
	  return {
	    type: types.SET_CLEARING_NUMBER_ERROR_MESSAGE,
	    payload: payload
	  };
	}
	
	function setAccountNumber(payload) {
	  return {
	    type: types.SET_ACCOUNT_NUMBER,
	    payload: payload
	  };
	}
	
	function setAccountNumberIsValid(payload) {
	  return {
	    type: types.SET_ACCOUNT_NUMBER_IS_VALID,
	    payload: payload
	  };
	}
	
	function setAccountNumberSuppressError(payload) {
	  return {
	    type: types.SET_ACCOUNT_NUMBER_SUPPRESS_ERROR,
	    payload: payload
	  };
	}
	
	function setAccountNumberErrorMessage(payload) {
	  return {
	    type: types.SET_ACCOUNT_NUMBER_ERROR_MESSAGE,
	    payload: payload
	  };
	}
	
	function setBank(bank) {
	  return function (dispatch) {
	    if (bank === 'NORDEA_PERSON') {
	      dispatch(setClearingNumber('3300'));
	    }
	
	    dispatch(setSelectedBank(bank));
	  };
	}
	
	function fetchBanks() {
	  return function (dispatch) {
	    _bankService2.default.get().promise.then(function (banks) {
	      dispatch(setBanks(banks));
	    });
	  };
	}
	
	function syncBankInfoFromUser() {
	  return function (dispatch, getState) {
	    var state = getState();
	    if (state.user.internationalAccount === 'on') {
	      dispatch(setSelectedBank('IBAN'));
	      dispatch(setClearingNumber(state.user.bic));
	      dispatch(setAccountNumber(state.user.iban));
	    } else {
	      var hasBank = state.user.accountClearingNr || state.user.accountNr;
	      var hasChangedAccountNr = state.bankInfo.accountNumber.value && state.user.accountNr !== state.bankInfo.accountNumber.value;
	      var hasChangedClearingNr = state.bankInfo.clearingNumber.value && state.user.accountClearingNr !== state.bankInfo.clearingNumber.value;
	      var hasSelectedBank = state.bankInfo.selectedBank !== 'INITIAL';
	      if (hasBank && !hasChangedAccountNr && !hasChangedClearingNr && !hasSelectedBank) {
	        dispatch(setSelectedBank(identifyBank(state.user.accountClearingNr, state.bankInfo.banks)));
	        dispatch(setClearingNumber(state.user.accountClearingNr));
	        dispatch(setAccountNumber(state.user.accountNr));
	      }
	    }
	  };
	}
	
	function identifyBank(clearingNumber, banks) {
	  if (_lodash2.default.isEmpty(clearingNumber)) {
	    return 'INITIAL';
	  }
	
	  // There is some overlap in ff_banks, so that it is not possible to find
	  // the Nordea personnummer account in the list.
	  if (clearingNumber === '3300') {
	    return 'NORDEA_PERSON';
	  }
	
	  var bank = findBankByClearingNumber(clearingNumber, banks);
	
	  if (bank) {
	    if (_lodash2.default.includes([1, 4, 5, 6, 9, 12, 14, 39, 46], bank.id)) {
	      return 'NORDEA_KONTO';
	    }
	
	    if (_lodash2.default.includes([10, 13], bank.id)) {
	      return 'NORDEA_PERSON';
	    }
	
	    if (_lodash2.default.includes([15, 24, 25], bank.id)) {
	      return 'SEB';
	    }
	
	    if (_lodash2.default.includes([16], bank.id)) {
	      return 'HANDELSBANKEN';
	    }
	
	    if (_lodash2.default.includes([17, 18], bank.id)) {
	      return 'SWEDBANK';
	    }
	  }
	
	  return 'OTHER';
	}
	
	function findBankByClearingNumber(clearingNumber, banks) {
	  if (clearingNumber.length > 4) {
	    clearingNumber = clearingNumber.slice(0, 4);
	  }
	
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = (0, _getIterator3.default)(banks), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var bank = _step.value;
	
	      if (_lodash2.default.inRange(clearingNumber, bank.clrMin, bank.clrMax + 1)) {
	        return bank;
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return null;
	}

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setUser = setUser;
	exports.setUserImageSrc = setUserImageSrc;
	exports.clearUser = clearUser;
	exports.setSocialSecurityNr = setSocialSecurityNr;
	
	var _actionTypes = __webpack_require__(373);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function setUser(user) {
	  return {
	    type: types.SET_USER,
	    payload: user
	  };
	}
	
	function setUserImageSrc(imageSrc) {
	  return {
	    type: types.SET_IMAGE_SRC,
	    payload: imageSrc
	  };
	}
	
	function clearUser() {
	  return {
	    type: types.CLEAR_USER
	  };
	}
	
	function setSocialSecurityNr(socialSecurityNr) {
	  return {
	    type: types.SET_SOCIAL_SECURITY_NUMBER,
	    payload: socialSecurityNr
	  };
	}

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'span',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, {
	    content: 'NO_BANK_ID' }),
	  '\xA0'
	);
	
	var LoginBottomElement = function (_Component) {
	  (0, _inherits3.default)(LoginBottomElement, _Component);
	
	  function LoginBottomElement() {
	    (0, _classCallCheck3.default)(this, LoginBottomElement);
	    return (0, _possibleConstructorReturn3.default)(this, (LoginBottomElement.__proto__ || (0, _getPrototypeOf2.default)(LoginBottomElement)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LoginBottomElement, [{
	    key: 'renderTitleText',
	    value: function renderTitleText() {
	      if (this.props.isBankID) {
	        return _ref;
	      }
	      return null;
	    }
	  }, {
	    key: 'renderText',
	    value: function renderText() {
	      if (this.props.isLogin) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'login-row-child justify-center' },
	          this.renderTitleText(),
	          _react2.default.createElement(_reactTranslateComponent2.default, {
	            id: this.props.isBankID ? 'EMAIL' : 'BANKID',
	            className: 'active-link-text',
	            content: this.props.isBankID ? 'LOG_IN_WITH_EMAIL_LINK' : 'LOG_IN_WITH_BANKID_LINK',
	            onClick: this.props.handleClick
	          })
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'login-row-child justify-center',
	          onClick: this.props.handleClick
	        },
	        this.renderTitleText(),
	        _react2.default.createElement(_reactTranslateComponent2.default, {
	          id: this.props.isBankID ? 'EMAIL' : 'BANKID',
	          className: 'active-link-text',
	          content: this.props.isBankID ? 'CREATE_ACCOUNT_WITHOUT_BANKID' : 'CREATE_ACCOUNT_WITH_BANKID',
	          onClick: this.props.handleClick
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'login-row-container margin' },
	        this.renderText()
	      );
	    }
	  }]);
	  return LoginBottomElement;
	}(_react.Component);
	
	exports.default = LoginBottomElement;

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1017), __esModule: true };

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(1009);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(1008);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 168 */
[1586, 144, 44],
/* 169 */
/***/ function(module, exports) {

	module.exports = true;


/***/ },
/* 170 */
[1610, 74, 1046, 237, 244, 236, 387],
/* 171 */
[1633, 246],
/* 172 */
111,
/* 173 */
[1582, 62, 34, 110],
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(19);
	var $export = __webpack_require__(9);
	var redefine = __webpack_require__(53);
	var redefineAll = __webpack_require__(108);
	var meta = __webpack_require__(95);
	var forOf = __webpack_require__(102);
	var anInstance = __webpack_require__(101);
	var isObject = __webpack_require__(24);
	var fails = __webpack_require__(23);
	var $iterDetect = __webpack_require__(179);
	var setToStringTag = __webpack_require__(126);
	var inheritIfRequired = __webpack_require__(259);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var hide = __webpack_require__(52);
	var redefine = __webpack_require__(53);
	var fails = __webpack_require__(23);
	var defined = __webpack_require__(78);
	var wks = __webpack_require__(28);
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	  var fns = exec(defined, SYMBOL, ''[KEY]);
	  var strfn = fns[0];
	  var rxfn = fns[1];
	  if (fails(function () {
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  })) {
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(16);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ },
/* 177 */
[1600, 66],
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(24);
	var cof = __webpack_require__(66);
	var MATCH = __webpack_require__(28)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ },
/* 179 */
[1605, 28],
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(103) || !__webpack_require__(23)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(19)[K];
	});


/***/ },
/* 181 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 182 */
[1622, 9, 45, 67, 102],
/* 183 */
[1623, 9],
/* 184 */
[1627, 19],
/* 185 */
[1628, 16, 45, 28],
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(19);
	var hide = __webpack_require__(52);
	var uid = __webpack_require__(111);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ },
/* 187 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	module.exports = exports['default'];

/***/ },
/* 188 */,
/* 189 */,
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enGb = moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enGb;
	
	})));


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sv = moment.defineLocale('sv', {
	    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : 'för %s sedan',
	        s : 'några sekunder',
	        ss : '%d sekunder',
	        m : 'en minut',
	        mm : '%d minuter',
	        h : 'en timme',
	        hh : '%d timmar',
	        d : 'en dag',
	        dd : '%d dagar',
	        M : 'en månad',
	        MM : '%d månader',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'e' :
	            (b === 1) ? 'a' :
	            (b === 2) ? 'a' :
	            (b === 3) ? 'e' : 'e';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sv;
	
	})));


/***/ },
/* 192 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.filter(function (f) {
	    return f != null;
	  }).reduce(function (acc, f) {
	    if (typeof f !== 'function') {
	      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
	    }
	
	    if (acc === null) {
	      return f;
	    }
	
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      f.apply(this, args);
	    };
	  }, null);
	}
	
	exports['default'] = createChainedFunction;
	module.exports = exports['default'];

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.cancelEvent = cancelEvent;
	exports.getFirstDayOfMonth = getFirstDayOfMonth;
	exports.getDaysInMonth = getDaysInMonth;
	exports.getModifiersFromProps = getModifiersFromProps;
	exports.getFirstDayOfWeekFromProps = getFirstDayOfWeekFromProps;
	exports.isRangeOfDates = isRangeOfDates;
	exports.getMonthsDiff = getMonthsDiff;
	exports.getWeekArray = getWeekArray;
	exports.startOfMonth = startOfMonth;
	exports.getDayNodes = getDayNodes;
	exports.nodeListToArray = nodeListToArray;
	exports.hasOwnProp = hasOwnProp;
	
	var _DateUtils = __webpack_require__(133);
	
	var _LocaleUtils = __webpack_require__(194);
	
	var _classNames = __webpack_require__(195);
	
	var _classNames2 = _interopRequireDefault(_classNames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function cancelEvent(e) {
	  e.preventDefault();
	  e.stopPropagation();
	}
	
	function getFirstDayOfMonth(d) {
	  return new Date(d.getFullYear(), d.getMonth(), 1, 12);
	}
	
	function getDaysInMonth(d) {
	  var resultDate = getFirstDayOfMonth(d);
	
	  resultDate.setMonth(resultDate.getMonth() + 1);
	  resultDate.setDate(resultDate.getDate() - 1);
	
	  return resultDate.getDate();
	}
	
	function getModifiersFromProps(props) {
	  var modifiers = _extends({}, props.modifiers);
	  if (props.selectedDays) {
	    modifiers[props.classNames.selected] = props.selectedDays;
	  }
	  if (props.disabledDays) {
	    modifiers[props.classNames.disabled] = props.disabledDays;
	  }
	  return modifiers;
	}
	
	function getFirstDayOfWeekFromProps(props) {
	  var firstDayOfWeek = props.firstDayOfWeek,
	      _props$locale = props.locale,
	      locale = _props$locale === undefined ? 'en' : _props$locale,
	      _props$localeUtils = props.localeUtils,
	      localeUtils = _props$localeUtils === undefined ? {} : _props$localeUtils;
	
	  if (!isNaN(firstDayOfWeek)) {
	    return firstDayOfWeek;
	  }
	  if (localeUtils.getFirstDayOfWeek) {
	    return localeUtils.getFirstDayOfWeek(locale);
	  }
	  return 0;
	}
	
	function isRangeOfDates(value) {
	  return !!(value && value.from && value.to);
	}
	
	function getMonthsDiff(d1, d2) {
	  return d2.getMonth() - d1.getMonth() + 12 * (d2.getFullYear() - d1.getFullYear());
	}
	
	function getWeekArray(d) {
	  var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _LocaleUtils.getFirstDayOfWeek)();
	  var fixedWeeks = arguments[2];
	
	  var daysInMonth = getDaysInMonth(d);
	  var dayArray = [];
	
	  var week = [];
	  var weekArray = [];
	
	  for (var i = 1; i <= daysInMonth; i += 1) {
	    dayArray.push(new Date(d.getFullYear(), d.getMonth(), i, 12));
	  }
	
	  dayArray.forEach(function (day) {
	    if (week.length > 0 && day.getDay() === firstDayOfWeek) {
	      weekArray.push(week);
	      week = [];
	    }
	    week.push(day);
	    if (dayArray.indexOf(day) === dayArray.length - 1) {
	      weekArray.push(week);
	    }
	  });
	
	  // unshift days to start the first week
	  var firstWeek = weekArray[0];
	  for (var _i = 7 - firstWeek.length; _i > 0; _i -= 1) {
	    var outsideDate = (0, _DateUtils.clone)(firstWeek[0]);
	    outsideDate.setDate(firstWeek[0].getDate() - 1);
	    firstWeek.unshift(outsideDate);
	  }
	
	  // push days until the end of the last week
	  var lastWeek = weekArray[weekArray.length - 1];
	  for (var _i2 = lastWeek.length; _i2 < 7; _i2 += 1) {
	    var _outsideDate = (0, _DateUtils.clone)(lastWeek[lastWeek.length - 1]);
	    _outsideDate.setDate(lastWeek[lastWeek.length - 1].getDate() + 1);
	    lastWeek.push(_outsideDate);
	  }
	
	  // add extra weeks to reach 6 weeks
	  if (fixedWeeks && weekArray.length < 6) {
	    var lastExtraWeek = void 0;
	
	    for (var _i3 = weekArray.length; _i3 < 6; _i3 += 1) {
	      lastExtraWeek = weekArray[weekArray.length - 1];
	      var lastDay = lastExtraWeek[lastExtraWeek.length - 1];
	      var extraWeek = [];
	
	      for (var j = 0; j < 7; j += 1) {
	        var _outsideDate2 = (0, _DateUtils.clone)(lastDay);
	        _outsideDate2.setDate(lastDay.getDate() + j + 1);
	        extraWeek.push(_outsideDate2);
	      }
	
	      weekArray.push(extraWeek);
	    }
	  }
	
	  return weekArray;
	}
	
	function startOfMonth(d) {
	  var newDate = (0, _DateUtils.clone)(d);
	  newDate.setDate(1);
	  newDate.setHours(12, 0, 0, 0); // always set noon to avoid time zone issues
	  return newDate;
	}
	
	function getDayNodes(node, classNames) {
	  var outsideClassName = void 0;
	  if (classNames === _classNames2.default) {
	    // When using CSS modules prefix the modifier as required by the BEM syntax
	    outsideClassName = classNames.day + '--' + classNames.outside;
	  } else {
	    outsideClassName = '' + classNames.outside;
	  }
	  var dayQuery = classNames.day.replace(/ /g, '.');
	  var outsideDayQuery = outsideClassName.replace(/ /g, '.');
	  var selector = '.' + dayQuery + ':not(.' + outsideDayQuery + ')';
	  return node.querySelectorAll(selector);
	}
	
	function nodeListToArray(nodeList) {
	  return Array.prototype.slice.call(nodeList, 0);
	}
	
	function hasOwnProp(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	//# sourceMappingURL=Helpers.js.map

/***/ },
/* 194 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatDay = formatDay;
	exports.formatMonthTitle = formatMonthTitle;
	exports.formatWeekdayShort = formatWeekdayShort;
	exports.formatWeekdayLong = formatWeekdayLong;
	exports.getFirstDayOfWeek = getFirstDayOfWeek;
	exports.getMonths = getMonths;
	var WEEKDAYS_LONG = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	
	var WEEKDAYS_SHORT = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
	
	var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	
	function formatDay(day) {
	  return day.toDateString();
	}
	
	function formatMonthTitle(d) {
	  return MONTHS[d.getMonth()] + ' ' + d.getFullYear();
	}
	
	function formatWeekdayShort(i) {
	  return WEEKDAYS_SHORT[i];
	}
	
	function formatWeekdayLong(i) {
	  return WEEKDAYS_LONG[i];
	}
	
	function getFirstDayOfWeek() {
	  return 0;
	}
	
	function getMonths() {
	  return MONTHS;
	}
	
	exports.default = {
	  formatDay: formatDay,
	  formatMonthTitle: formatMonthTitle,
	  formatWeekdayShort: formatWeekdayShort,
	  formatWeekdayLong: formatWeekdayLong,
	  getFirstDayOfWeek: getFirstDayOfWeek,
	  getMonths: getMonths
	};
	//# sourceMappingURL=LocaleUtils.js.map

/***/ },
/* 195 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Proxy object to map classnames when css modules are not used
	
	exports.default = {
	  container: 'DayPicker',
	  wrapper: 'DayPicker-wrapper',
	  interactionDisabled: 'DayPicker--interactionDisabled',
	  months: 'DayPicker-Months',
	  month: 'DayPicker-Month',
	
	  navBar: 'DayPicker-NavBar',
	  navButtonPrev: 'DayPicker-NavButton DayPicker-NavButton--prev',
	  navButtonNext: 'DayPicker-NavButton DayPicker-NavButton--next',
	  navButtonInteractionDisabled: 'DayPicker-NavButton--interactionDisabled',
	
	  caption: 'DayPicker-Caption',
	  weekdays: 'DayPicker-Weekdays',
	  weekdaysRow: 'DayPicker-WeekdaysRow',
	  weekday: 'DayPicker-Weekday',
	  body: 'DayPicker-Body',
	  week: 'DayPicker-Week',
	  weekNumber: 'DayPicker-WeekNumber',
	  day: 'DayPicker-Day',
	  footer: 'DayPicker-Footer',
	  todayButton: 'DayPicker-TodayButton',
	
	  // default modifiers
	  today: 'today',
	  selected: 'selected',
	  disabled: 'disabled',
	  outside: 'outside'
	};
	//# sourceMappingURL=classNames.js.map

/***/ },
/* 196 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LEFT = exports.LEFT = 37;
	var UP = exports.UP = 38;
	var RIGHT = exports.RIGHT = 39;
	var DOWN = exports.DOWN = 40;
	var ENTER = exports.ENTER = 13;
	var SPACE = exports.SPACE = 32;
	var ESC = exports.ESC = 27;
	var TAB = exports.TAB = 9;
	//# sourceMappingURL=keys.js.map

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(26);
	
	var EventPluginRegistry = __webpack_require__(294);
	var ReactEventEmitterMixin = __webpack_require__(1426);
	var ViewportMetrics = __webpack_require__(610);
	
	var getVendorPrefixedEventName = __webpack_require__(1459);
	var isEventSupported = __webpack_require__(305);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(158);
	var ViewportMetrics = __webpack_require__(610);
	
	var getEventModifierState = __webpack_require__(303);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var invariant = __webpack_require__(15);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 200 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(49);
	var DOMNamespaces = __webpack_require__(293);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(301);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (componentOrElement) {
	  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
	};
	
	var _reactDom = __webpack_require__(46);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ownerDocument = __webpack_require__(279);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 203 */,
/* 204 */,
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*!
	                                                                                                                                                                                                                                                                                Copyright (c) 2018 Jed Watson.
	                                                                                                                                                                                                                                                                                Licensed under the MIT License (MIT), see
	                                                                                                                                                                                                                                                                                http://jedwatson.github.io/react-select
	                                                                                                                                                                                                                                                                              */
	
	
	var _reactInputAutosize = __webpack_require__(1462);
	
	var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);
	
	var _classnames = __webpack_require__(37);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(46);
	
	var _defaultArrowRenderer = __webpack_require__(641);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(642);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(312);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(313);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Option = __webpack_require__(639);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _Value = __webpack_require__(640);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var stringifyValue = function stringifyValue(value) {
		return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
	};
	
	var stringOrNode = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]);
	var stringOrNumber = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
	
	var instanceId = 1;
	
	var shouldShowValue = function shouldShowValue(state, props) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		if (!inputValue) return true;
	
		if (!onSelectResetsInput) {
			return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
		}
	
		return false;
	};
	
	var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
	};
	
	/**
	 * Retrieve a value from the given options and valueKey
	 * @param {String|Number|Array} value	- the selected value(s)
	 * @param {Object}		 props	- the Select component's props (or nextProps)
	 */
	var expandValue = function expandValue(value, props) {
		var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
		if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
		var options = props.options,
		    valueKey = props.valueKey;
	
		if (!options) return;
		for (var i = 0; i < options.length; i++) {
			if (String(options[i][valueKey]) === String(value)) return options[i];
		}
	};
	
	var handleRequired = function handleRequired(value, multi) {
		if (!value) return true;
		return multi ? value.length === 0 : Object.keys(value).length === 0;
	};
	
	var Select = function (_React$Component) {
		_inherits(Select, _React$Component);
	
		function Select(props) {
			_classCallCheck(this, Select);
	
			var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));
	
			['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
				return _this[fn] = _this[fn].bind(_this);
			});
	
			_this.state = {
				inputValue: '',
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false,
				required: false
			};
			return _this;
		}
	
		_createClass(Select, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
				var valueArray = this.getValueArray(this.props.value);
	
				if (this.props.required) {
					this.setState({
						required: handleRequired(valueArray[0], this.props.multi)
					});
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
					console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
				}
				if (this.props.autoFocus || this.props.autofocus) {
					this.focus();
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var valueArray = this.getValueArray(nextProps.value, nextProps);
	
				if (nextProps.required) {
					this.setState({
						required: handleRequired(valueArray[0], nextProps.multi)
					});
				} else if (this.props.required) {
					// Used to be required but it's not any more
					this.setState({ required: false });
				}
	
				if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
					this.setState({ inputValue: this.handleInputValueChange('') });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				// focus to the selected option
				if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
					var focusedOptionNode = (0, _reactDom.findDOMNode)(this.focused);
					var menuNode = (0, _reactDom.findDOMNode)(this.menu);
	
					var scrollTop = menuNode.scrollTop;
					var scrollBottom = scrollTop + menuNode.offsetHeight;
					var optionTop = focusedOptionNode.offsetTop;
					var optionBottom = optionTop + focusedOptionNode.offsetHeight;
	
					if (scrollTop > optionTop || scrollBottom < optionBottom) {
						menuNode.scrollTop = focusedOptionNode.offsetTop;
					}
	
					// We still set hasScrolledToOption to true even if we didn't
					// actually need to scroll, as we've still confirmed that the
					// option is in view.
					this.hasScrolledToOption = true;
				} else if (!this.state.isOpen) {
					this.hasScrolledToOption = false;
				}
	
				if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
					this._scrollToFocusedOptionOnUpdate = false;
					var focusedDOM = (0, _reactDom.findDOMNode)(this.focused);
					var menuDOM = (0, _reactDom.findDOMNode)(this.menu);
					var focusedRect = focusedDOM.getBoundingClientRect();
					var menuRect = menuDOM.getBoundingClientRect();
					if (focusedRect.bottom > menuRect.bottom) {
						menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
					} else if (focusedRect.top < menuRect.top) {
						menuDOM.scrollTop = focusedDOM.offsetTop;
					}
				}
				if (this.props.scrollMenuIntoView && this.menuContainer) {
					var menuContainerRect = this.menuContainer.getBoundingClientRect();
					if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
						window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
					}
				}
				if (prevProps.disabled !== this.props.disabled) {
					this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
					this.closeMenu();
				}
				if (prevState.isOpen !== this.state.isOpen) {
					this.toggleTouchOutsideEvent(this.state.isOpen);
					var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
					handler && handler();
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.toggleTouchOutsideEvent(false);
			}
		}, {
			key: 'toggleTouchOutsideEvent',
			value: function toggleTouchOutsideEvent(enabled) {
				if (enabled) {
					if (!document.addEventListener && document.attachEvent) {
						document.attachEvent('ontouchstart', this.handleTouchOutside);
					} else {
						document.addEventListener('touchstart', this.handleTouchOutside);
					}
				} else {
					if (!document.removeEventListener && document.detachEvent) {
						document.detachEvent('ontouchstart', this.handleTouchOutside);
					} else {
						document.removeEventListener('touchstart', this.handleTouchOutside);
					}
				}
			}
		}, {
			key: 'handleTouchOutside',
			value: function handleTouchOutside(event) {
				// handle touch outside on ios to dismiss menu
				if (this.wrapper && !this.wrapper.contains(event.target)) {
					this.closeMenu();
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				if (!this.input) return;
				this.input.focus();
			}
		}, {
			key: 'blurInput',
			value: function blurInput() {
				if (!this.input) return;
				this.input.blur();
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchEndClearValue',
			value: function handleTouchEndClearValue(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Clear the value
				this.clearValue(event);
			}
		}, {
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (event.target.tagName === 'INPUT') {
					if (!this.state.isFocused) {
						this._openAfterFocus = this.props.openOnClick;
						this.focus();
					} else if (!this.state.isOpen) {
						this.setState({
							isOpen: true,
							isPseudoFocused: false
						});
					}
	
					return;
				}
	
				// prevent default event handlers
				event.preventDefault();
	
				// for the non-searchable select, toggle the menu
				if (!this.props.searchable) {
					// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
					this.focus();
					return this.setState({
						isOpen: !this.state.isOpen
					});
				}
	
				if (this.state.isFocused) {
					// On iOS, we can get into a state where we think the input is focused but it isn't really,
					// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
					// Call focus() again here to be safe.
					this.focus();
	
					var input = this.input;
					var toOpen = true;
	
					if (typeof input.getInput === 'function') {
						// Get the actual DOM input if the ref is an <AutosizeInput /> component
						input = input.getInput();
					}
	
					// clears the value so that the cursor will be at the end of input when the component re-renders
					input.value = '';
	
					if (this._focusAfterClear) {
						toOpen = false;
						this._focusAfterClear = false;
					}
	
					// if the input is focused, ensure the menu is open
					this.setState({
						isOpen: toOpen,
						isPseudoFocused: false,
						focusedOption: null
					});
				} else {
					// otherwise, focus the input and open the menu
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
					this.setState({ focusedOption: null });
				}
			}
		}, {
			key: 'handleMouseDownOnArrow',
			value: function handleMouseDownOnArrow(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (this.state.isOpen) {
					// prevent default event handlers
					event.stopPropagation();
					event.preventDefault();
					// close the menu
					this.closeMenu();
				} else {
					// If the menu isn't open, let the event bubble to the main handleMouseDown
					this.setState({
						isOpen: true
					});
				}
			}
		}, {
			key: 'handleMouseDownOnMenu',
			value: function handleMouseDownOnMenu(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.stopPropagation();
				event.preventDefault();
	
				this._openAfterFocus = true;
				this.focus();
			}
		}, {
			key: 'closeMenu',
			value: function closeMenu() {
				if (this.props.onCloseResetsInput) {
					this.setState({
						inputValue: this.handleInputValueChange(''),
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				} else {
					this.setState({
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				}
				this.hasScrolledToOption = false;
			}
		}, {
			key: 'handleInputFocus',
			value: function handleInputFocus(event) {
				if (this.props.disabled) return;
	
				var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
				toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.
	
				if (this.props.onFocus) {
					this.props.onFocus(event);
				}
	
				this.setState({
					isFocused: true,
					isOpen: !!toOpen
				});
	
				this._focusAfterClear = false;
				this._openAfterFocus = false;
			}
		}, {
			key: 'handleInputBlur',
			value: function handleInputBlur(event) {
				// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
				if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
					this.focus();
					return;
				}
	
				if (this.props.onBlur) {
					this.props.onBlur(event);
				}
				var onBlurredState = {
					isFocused: false,
					isOpen: false,
					isPseudoFocused: false
				};
				if (this.props.onBlurResetsInput) {
					onBlurredState.inputValue = this.handleInputValueChange('');
				}
				this.setState(onBlurredState);
			}
		}, {
			key: 'handleInputChange',
			value: function handleInputChange(event) {
				var newInputValue = event.target.value;
	
				if (this.state.inputValue !== event.target.value) {
					newInputValue = this.handleInputValueChange(newInputValue);
				}
	
				this.setState({
					inputValue: newInputValue,
					isOpen: true,
					isPseudoFocused: false
				});
			}
		}, {
			key: 'setInputValue',
			value: function setInputValue(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				this.setState({
					inputValue: newValue
				});
			}
		}, {
			key: 'handleInputValueChange',
			value: function handleInputValueChange(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					// Note: != used deliberately here to catch undefined and null
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				return newValue;
			}
		}, {
			key: 'handleKeyDown',
			value: function handleKeyDown(event) {
				if (this.props.disabled) return;
	
				if (typeof this.props.onInputKeyDown === 'function') {
					this.props.onInputKeyDown(event);
					if (event.defaultPrevented) {
						return;
					}
				}
	
				switch (event.keyCode) {
					case 8:
						// backspace
						if (!this.state.inputValue && this.props.backspaceRemoves) {
							event.preventDefault();
							this.popValue();
						}
						break;
					case 9:
						// tab
						if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
							break;
						}
						event.preventDefault();
						this.selectFocusedOption();
						break;
					case 13:
						// enter
						event.preventDefault();
						event.stopPropagation();
						if (this.state.isOpen) {
							this.selectFocusedOption();
						} else {
							this.focusNextOption();
						}
						break;
					case 27:
						// escape
						event.preventDefault();
						if (this.state.isOpen) {
							this.closeMenu();
							event.stopPropagation();
						} else if (this.props.clearable && this.props.escapeClearsValue) {
							this.clearValue(event);
							event.stopPropagation();
						}
						break;
					case 32:
						// space
						if (this.props.searchable) {
							break;
						}
						event.preventDefault();
						if (!this.state.isOpen) {
							this.focusNextOption();
							break;
						}
						event.stopPropagation();
						this.selectFocusedOption();
						break;
					case 38:
						// up
						event.preventDefault();
						this.focusPreviousOption();
						break;
					case 40:
						// down
						event.preventDefault();
						this.focusNextOption();
						break;
					case 33:
						// page up
						event.preventDefault();
						this.focusPageUpOption();
						break;
					case 34:
						// page down
						event.preventDefault();
						this.focusPageDownOption();
						break;
					case 35:
						// end key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusEndOption();
						break;
					case 36:
						// home key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusStartOption();
						break;
					case 46:
						// delete
						if (!this.state.inputValue && this.props.deleteRemoves) {
							event.preventDefault();
							this.popValue();
						}
						break;
				}
			}
		}, {
			key: 'handleValueClick',
			value: function handleValueClick(option, event) {
				if (!this.props.onValueClick) return;
				this.props.onValueClick(option, event);
			}
		}, {
			key: 'handleMenuScroll',
			value: function handleMenuScroll(event) {
				if (!this.props.onMenuScrollToBottom) return;
				var target = event.target;
	
				if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
					this.props.onMenuScrollToBottom();
				}
			}
		}, {
			key: 'getOptionLabel',
			value: function getOptionLabel(op) {
				return op[this.props.labelKey];
			}
	
			/**
	   * Turns a value into an array from the given options
	   * @param {String|Number|Array} value		- the value of the select input
	   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
	   * @returns	{Array}	the value of the select represented in an array
	   */
	
		}, {
			key: 'getValueArray',
			value: function getValueArray(value) {
				var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	
				/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
				var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
				if (props.multi) {
					if (typeof value === 'string') {
						value = value.split(props.delimiter);
					}
					if (!Array.isArray(value)) {
						if (value === null || value === undefined) return [];
						value = [value];
					}
					return value.map(function (value) {
						return expandValue(value, props);
					}).filter(function (i) {
						return i;
					});
				}
				var expandedValue = expandValue(value, props);
				return expandedValue ? [expandedValue] : [];
			}
		}, {
			key: 'setValue',
			value: function setValue(value) {
				var _this2 = this;
	
				if (this.props.autoBlur) {
					this.blurInput();
				}
				if (this.props.required) {
					var required = handleRequired(value, this.props.multi);
					this.setState({ required: required });
				}
				if (this.props.simpleValue && value) {
					value = this.props.multi ? value.map(function (i) {
						return i[_this2.props.valueKey];
					}).join(this.props.delimiter) : value[this.props.valueKey];
				}
				if (this.props.onChange) {
					this.props.onChange(value);
				}
			}
		}, {
			key: 'selectValue',
			value: function selectValue(value) {
				var _this3 = this;
	
				// NOTE: we actually add/set the value in a callback to make sure the
				// input value is empty to avoid styling issues in Chrome
				if (this.props.closeOnSelect) {
					this.hasScrolledToOption = false;
				}
				var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
				if (this.props.multi) {
					this.setState({
						focusedIndex: null,
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect
					}, function () {
						var valueArray = _this3.getValueArray(_this3.props.value);
						if (valueArray.some(function (i) {
							return i[_this3.props.valueKey] === value[_this3.props.valueKey];
						})) {
							_this3.removeValue(value);
						} else {
							_this3.addValue(value);
						}
					});
				} else {
					this.setState({
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect,
						isPseudoFocused: this.state.isFocused
					}, function () {
						_this3.setValue(value);
					});
				}
			}
		}, {
			key: 'addValue',
			value: function addValue(value) {
				var valueArray = this.getValueArray(this.props.value);
				var visibleOptions = this._visibleOptions.filter(function (val) {
					return !val.disabled;
				});
				var lastValueIndex = visibleOptions.indexOf(value);
				this.setValue(valueArray.concat(value));
				if (visibleOptions.length - 1 === lastValueIndex) {
					// the last option was selected; focus the second-last one
					this.focusOption(visibleOptions[lastValueIndex - 1]);
				} else if (visibleOptions.length > lastValueIndex) {
					// focus the option below the selected one
					this.focusOption(visibleOptions[lastValueIndex + 1]);
				}
			}
		}, {
			key: 'popValue',
			value: function popValue() {
				var valueArray = this.getValueArray(this.props.value);
				if (!valueArray.length) return;
				if (valueArray[valueArray.length - 1].clearableValue === false) return;
				this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
			}
		}, {
			key: 'removeValue',
			value: function removeValue(value) {
				var _this4 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				this.setValue(valueArray.filter(function (i) {
					return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
				}));
				this.focus();
			}
		}, {
			key: 'clearValue',
			value: function clearValue(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, ignore it.
				if (event && event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.preventDefault();
	
				this.setValue(this.getResetValue());
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false
				}, this.focus);
	
				this._focusAfterClear = true;
			}
		}, {
			key: 'getResetValue',
			value: function getResetValue() {
				if (this.props.resetValue !== undefined) {
					return this.props.resetValue;
				} else if (this.props.multi) {
					return [];
				} else {
					return null;
				}
			}
		}, {
			key: 'focusOption',
			value: function focusOption(option) {
				this.setState({
					focusedOption: option
				});
			}
		}, {
			key: 'focusNextOption',
			value: function focusNextOption() {
				this.focusAdjacentOption('next');
			}
		}, {
			key: 'focusPreviousOption',
			value: function focusPreviousOption() {
				this.focusAdjacentOption('previous');
			}
		}, {
			key: 'focusPageUpOption',
			value: function focusPageUpOption() {
				this.focusAdjacentOption('page_up');
			}
		}, {
			key: 'focusPageDownOption',
			value: function focusPageDownOption() {
				this.focusAdjacentOption('page_down');
			}
		}, {
			key: 'focusStartOption',
			value: function focusStartOption() {
				this.focusAdjacentOption('start');
			}
		}, {
			key: 'focusEndOption',
			value: function focusEndOption() {
				this.focusAdjacentOption('end');
			}
		}, {
			key: 'focusAdjacentOption',
			value: function focusAdjacentOption(dir) {
				var options = this._visibleOptions.map(function (option, index) {
					return { option: option, index: index };
				}).filter(function (option) {
					return !option.option.disabled;
				});
				this._scrollToFocusedOptionOnUpdate = true;
				if (!this.state.isOpen) {
					var newState = {
						focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
						isOpen: true
					};
					if (this.props.onSelectResetsInput) {
						newState.inputValue = '';
					}
					this.setState(newState);
					return;
				}
				if (!options.length) return;
				var focusedIndex = -1;
				for (var i = 0; i < options.length; i++) {
					if (this._focusedOption === options[i].option) {
						focusedIndex = i;
						break;
					}
				}
				if (dir === 'next' && focusedIndex !== -1) {
					focusedIndex = (focusedIndex + 1) % options.length;
				} else if (dir === 'previous') {
					if (focusedIndex > 0) {
						focusedIndex = focusedIndex - 1;
					} else {
						focusedIndex = options.length - 1;
					}
				} else if (dir === 'start') {
					focusedIndex = 0;
				} else if (dir === 'end') {
					focusedIndex = options.length - 1;
				} else if (dir === 'page_up') {
					var potentialIndex = focusedIndex - this.props.pageSize;
					if (potentialIndex < 0) {
						focusedIndex = 0;
					} else {
						focusedIndex = potentialIndex;
					}
				} else if (dir === 'page_down') {
					var _potentialIndex = focusedIndex + this.props.pageSize;
					if (_potentialIndex > options.length - 1) {
						focusedIndex = options.length - 1;
					} else {
						focusedIndex = _potentialIndex;
					}
				}
	
				if (focusedIndex === -1) {
					focusedIndex = 0;
				}
	
				this.setState({
					focusedIndex: options[focusedIndex].index,
					focusedOption: options[focusedIndex].option
				});
			}
		}, {
			key: 'getFocusedOption',
			value: function getFocusedOption() {
				return this._focusedOption;
			}
		}, {
			key: 'selectFocusedOption',
			value: function selectFocusedOption() {
				if (this._focusedOption) {
					return this.selectValue(this._focusedOption);
				}
			}
		}, {
			key: 'renderLoading',
			value: function renderLoading() {
				if (!this.props.isLoading) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
					_react2.default.createElement('span', { className: 'Select-loading' })
				);
			}
		}, {
			key: 'renderValue',
			value: function renderValue(valueArray, isOpen) {
				var _this5 = this;
	
				var renderLabel = this.props.valueRenderer || this.getOptionLabel;
				var ValueComponent = this.props.valueComponent;
				if (!valueArray.length) {
					var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
					return showPlaceholder ? _react2.default.createElement(
						'div',
						{ className: 'Select-placeholder' },
						this.props.placeholder
					) : null;
				}
				var onClick = this.props.onValueClick ? this.handleValueClick : null;
				if (this.props.multi) {
					return valueArray.map(function (value, i) {
						return _react2.default.createElement(
							ValueComponent,
							{
								disabled: _this5.props.disabled || value.clearableValue === false,
								id: _this5._instancePrefix + '-value-' + i,
								instancePrefix: _this5._instancePrefix,
								key: 'value-' + i + '-' + value[_this5.props.valueKey],
								onClick: onClick,
								onRemove: _this5.removeValue,
								placeholder: _this5.props.placeholder,
								value: value
							},
							renderLabel(value, i),
							_react2.default.createElement(
								'span',
								{ className: 'Select-aria-only' },
								'\xA0'
							)
						);
					});
				} else if (shouldShowValue(this.state, this.props)) {
					if (isOpen) onClick = null;
					return _react2.default.createElement(
						ValueComponent,
						{
							disabled: this.props.disabled,
							id: this._instancePrefix + '-value-item',
							instancePrefix: this._instancePrefix,
							onClick: onClick,
							placeholder: this.props.placeholder,
							value: valueArray[0]
						},
						renderLabel(valueArray[0])
					);
				}
			}
		}, {
			key: 'renderInput',
			value: function renderInput(valueArray, focusedOptionIndex) {
				var _classNames,
				    _this6 = this;
	
				var className = (0, _classnames2.default)('Select-input', this.props.inputProps.className);
				var isOpen = this.state.isOpen;
	
				var ariaOwns = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));
	
				var value = this.state.inputValue;
				if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
					// it hides input value when it is not focused and was not reset on select
					value = '';
				}
	
				var inputProps = _extends({}, this.props.inputProps, {
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-describedby': this.props['aria-describedby'],
					'aria-expanded': '' + isOpen,
					'aria-haspopup': '' + isOpen,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					'aria-owns': ariaOwns,
					className: className,
					onBlur: this.handleInputBlur,
					onChange: this.handleInputChange,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref) {
						return _this6.input = _ref;
					},
					role: 'combobox',
					required: this.state.required,
					tabIndex: this.props.tabIndex,
					value: value
				});
	
				if (this.props.inputRenderer) {
					return this.props.inputRenderer(inputProps);
				}
	
				if (this.props.disabled || !this.props.searchable) {
					var divProps = _objectWithoutProperties(this.props.inputProps, []);
	
					var _ariaOwns = (0, _classnames2.default)(_defineProperty({}, this._instancePrefix + '-list', isOpen));
					return _react2.default.createElement('div', _extends({}, divProps, {
						'aria-expanded': isOpen,
						'aria-owns': _ariaOwns,
						'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
						'aria-disabled': '' + this.props.disabled,
						'aria-label': this.props['aria-label'],
						'aria-labelledby': this.props['aria-labelledby'],
						className: className,
						onBlur: this.handleInputBlur,
						onFocus: this.handleInputFocus,
						ref: function ref(_ref2) {
							return _this6.input = _ref2;
						},
						role: 'combobox',
						style: { border: 0, width: 1, display: 'inline-block' },
						tabIndex: this.props.tabIndex || 0
					}));
				}
	
				if (this.props.autosize) {
					return _react2.default.createElement(_reactInputAutosize2.default, _extends({ id: this.props.id }, inputProps, { minWidth: '5' }));
				}
				return _react2.default.createElement(
					'div',
					{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
					_react2.default.createElement('input', _extends({ id: this.props.id }, inputProps))
				);
			}
		}, {
			key: 'renderClear',
			value: function renderClear() {
				var valueArray = this.getValueArray(this.props.value);
				if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
				var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
				var clear = this.props.clearRenderer();
	
				return _react2.default.createElement(
					'span',
					{
						'aria-label': ariaLabel,
						className: 'Select-clear-zone',
						onMouseDown: this.clearValue,
						onTouchEnd: this.handleTouchEndClearValue,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						title: ariaLabel
					},
					clear
				);
			}
		}, {
			key: 'renderArrow',
			value: function renderArrow() {
				if (!this.props.arrowRenderer) return;
	
				var onMouseDown = this.handleMouseDownOnArrow;
				var isOpen = this.state.isOpen;
				var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });
	
				if (!arrow) {
					return null;
				}
	
				return _react2.default.createElement(
					'span',
					{
						className: 'Select-arrow-zone',
						onMouseDown: onMouseDown
					},
					arrow
				);
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions(excludeOptions) {
				var filterValue = this.state.inputValue;
				var options = this.props.options || [];
				if (this.props.filterOptions) {
					// Maintain backwards compatibility with boolean attribute
					var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _defaultFilterOptions2.default;
	
					return filterOptions(options, filterValue, excludeOptions, {
						filterOption: this.props.filterOption,
						ignoreAccents: this.props.ignoreAccents,
						ignoreCase: this.props.ignoreCase,
						labelKey: this.props.labelKey,
						matchPos: this.props.matchPos,
						matchProp: this.props.matchProp,
						trimFilter: this.props.trimFilter,
						valueKey: this.props.valueKey
					});
				} else {
					return options;
				}
			}
		}, {
			key: 'onOptionRef',
			value: function onOptionRef(ref, isFocused) {
				if (isFocused) {
					this.focused = ref;
				}
			}
		}, {
			key: 'renderMenu',
			value: function renderMenu(options, valueArray, focusedOption) {
				if (options && options.length) {
					return this.props.menuRenderer({
						focusedOption: focusedOption,
						focusOption: this.focusOption,
						inputValue: this.state.inputValue,
						instancePrefix: this._instancePrefix,
						labelKey: this.props.labelKey,
						onFocus: this.focusOption,
						onOptionRef: this.onOptionRef,
						onSelect: this.selectValue,
						optionClassName: this.props.optionClassName,
						optionComponent: this.props.optionComponent,
						optionRenderer: this.props.optionRenderer || this.getOptionLabel,
						options: options,
						removeValue: this.removeValue,
						selectValue: this.selectValue,
						valueArray: valueArray,
						valueKey: this.props.valueKey
					});
				} else if (this.props.noResultsText) {
					return _react2.default.createElement(
						'div',
						{ className: 'Select-noresults' },
						this.props.noResultsText
					);
				} else {
					return null;
				}
			}
		}, {
			key: 'renderHiddenField',
			value: function renderHiddenField(valueArray) {
				var _this7 = this;
	
				if (!this.props.name) return;
				if (this.props.joinValues) {
					var value = valueArray.map(function (i) {
						return stringifyValue(i[_this7.props.valueKey]);
					}).join(this.props.delimiter);
					return _react2.default.createElement('input', {
						disabled: this.props.disabled,
						name: this.props.name,
						ref: function ref(_ref3) {
							return _this7.value = _ref3;
						},
						type: 'hidden',
						value: value
					});
				}
				return valueArray.map(function (item, index) {
					return _react2.default.createElement('input', {
						disabled: _this7.props.disabled,
						key: 'hidden.' + index,
						name: _this7.props.name,
						ref: 'value' + index,
						type: 'hidden',
						value: stringifyValue(item[_this7.props.valueKey])
					});
				});
			}
		}, {
			key: 'getFocusableOptionIndex',
			value: function getFocusableOptionIndex(selectedOption) {
				var options = this._visibleOptions;
				if (!options.length) return null;
	
				var valueKey = this.props.valueKey;
				var focusedOption = this.state.focusedOption || selectedOption;
				if (focusedOption && !focusedOption.disabled) {
					var focusedOptionIndex = -1;
					options.some(function (option, index) {
						var isOptionEqual = option[valueKey] === focusedOption[valueKey];
						if (isOptionEqual) {
							focusedOptionIndex = index;
						}
						return isOptionEqual;
					});
					if (focusedOptionIndex !== -1) {
						return focusedOptionIndex;
					}
				}
	
				for (var i = 0; i < options.length; i++) {
					if (!options[i].disabled) return i;
				}
				return null;
			}
		}, {
			key: 'renderOuter',
			value: function renderOuter(options, valueArray, focusedOption) {
				var _this8 = this;
	
				var menu = this.renderMenu(options, valueArray, focusedOption);
				if (!menu) {
					return null;
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref5) {
							return _this8.menuContainer = _ref5;
						}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
					_react2.default.createElement(
						'div',
						{
							className: 'Select-menu',
							id: this._instancePrefix + '-list',
							onMouseDown: this.handleMouseDownOnMenu,
							onScroll: this.handleMenuScroll,
							ref: function ref(_ref4) {
								return _this8.menu = _ref4;
							},
							role: 'listbox',
							style: this.props.menuStyle,
							tabIndex: -1
						},
						menu
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this9 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
				var isOpen = this.state.isOpen;
				if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
				var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);
	
				var focusedOption = null;
				if (focusedOptionIndex !== null) {
					focusedOption = this._focusedOption = options[focusedOptionIndex];
				} else {
					focusedOption = this._focusedOption = null;
				}
				var className = (0, _classnames2.default)('Select', this.props.className, {
					'has-value': valueArray.length,
					'is-clearable': this.props.clearable,
					'is-disabled': this.props.disabled,
					'is-focused': this.state.isFocused,
					'is-loading': this.props.isLoading,
					'is-open': isOpen,
					'is-pseudo-focused': this.state.isPseudoFocused,
					'is-searchable': this.props.searchable,
					'Select--multi': this.props.multi,
					'Select--rtl': this.props.rtl,
					'Select--single': !this.props.multi
				});
	
				var removeMessage = null;
				if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
					removeMessage = _react2.default.createElement(
						'span',
						{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
						this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
					);
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref7) {
							return _this9.wrapper = _ref7;
						},
						className: className,
						style: this.props.wrapperStyle },
					this.renderHiddenField(valueArray),
					_react2.default.createElement(
						'div',
						{ ref: function ref(_ref6) {
								return _this9.control = _ref6;
							},
							className: 'Select-control',
							onKeyDown: this.handleKeyDown,
							onMouseDown: this.handleMouseDown,
							onTouchEnd: this.handleTouchEnd,
							onTouchMove: this.handleTouchMove,
							onTouchStart: this.handleTouchStart,
							style: this.props.style
						},
						_react2.default.createElement(
							'span',
							{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
							this.renderValue(valueArray, isOpen),
							this.renderInput(valueArray, focusedOptionIndex)
						),
						removeMessage,
						this.renderLoading(),
						this.renderClear(),
						this.renderArrow()
					),
					isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
				);
			}
		}]);
	
		return Select;
	}(_react2.default.Component);
	
	Select.propTypes = {
		'aria-describedby': _propTypes2.default.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
		'aria-label': _propTypes2.default.string, // aria label (for assistive tech)
		'aria-labelledby': _propTypes2.default.string, // html id of an element that should be used as the label (for assistive tech)
		arrowRenderer: _propTypes2.default.func, // create the drop-down caret element
		autoBlur: _propTypes2.default.bool, // automatically blur the component when an option is selected
		autoFocus: _propTypes2.default.bool, // autofocus the component on mount
		autofocus: _propTypes2.default.bool, // deprecated; use autoFocus instead
		autosize: _propTypes2.default.bool, // whether to enable autosizing or not
		backspaceRemoves: _propTypes2.default.bool, // whether backspace removes an item if there is no text input
		backspaceToRemoveMessage: _propTypes2.default.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
		className: _propTypes2.default.string, // className for the outer element
		clearAllText: stringOrNode, // title for the "clear" control when multi: true
		clearRenderer: _propTypes2.default.func, // create clearable x element
		clearValueText: stringOrNode, // title for the "clear" control
		clearable: _propTypes2.default.bool, // should it be possible to reset value
		closeOnSelect: _propTypes2.default.bool, // whether to close the menu when a value is selected
		deleteRemoves: _propTypes2.default.bool, // whether delete removes an item if there is no text input
		delimiter: _propTypes2.default.string, // delimiter to use to join multiple values for the hidden field value
		disabled: _propTypes2.default.bool, // whether the Select is disabled or not
		escapeClearsValue: _propTypes2.default.bool, // whether escape clears the value when the menu is closed
		filterOption: _propTypes2.default.func, // method to filter a single option (option, filterString)
		filterOptions: _propTypes2.default.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
		id: _propTypes2.default.string, // html id to set on the input element for accessibility or tests
		ignoreAccents: _propTypes2.default.bool, // whether to strip diacritics when filtering
		ignoreCase: _propTypes2.default.bool, // whether to perform case-insensitive filtering
		inputProps: _propTypes2.default.object, // custom attributes for the Input
		inputRenderer: _propTypes2.default.func, // returns a custom input component
		instanceId: _propTypes2.default.string, // set the components instanceId
		isLoading: _propTypes2.default.bool, // whether the Select is loading externally or not (such as options being loaded)
		joinValues: _propTypes2.default.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
		labelKey: _propTypes2.default.string, // path of the label value in option objects
		matchPos: _propTypes2.default.string, // (any|start) match the start or entire string when filtering
		matchProp: _propTypes2.default.string, // (any|label|value) which option property to filter on
		menuBuffer: _propTypes2.default.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
		menuContainerStyle: _propTypes2.default.object, // optional style to apply to the menu container
		menuRenderer: _propTypes2.default.func, // renders a custom menu with options
		menuStyle: _propTypes2.default.object, // optional style to apply to the menu
		multi: _propTypes2.default.bool, // multi-value input
		name: _propTypes2.default.string, // generates a hidden <input /> tag with this field name for html forms
		noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
		onBlur: _propTypes2.default.func, // onBlur handler: function (event) {}
		onBlurResetsInput: _propTypes2.default.bool, // whether input is cleared on blur
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onClose: _propTypes2.default.func, // fires when the menu is closed
		onCloseResetsInput: _propTypes2.default.bool, // whether input is cleared when menu is closed through the arrow
		onFocus: _propTypes2.default.func, // onFocus handler: function (event) {}
		onInputChange: _propTypes2.default.func, // onInputChange handler: function (inputValue) {}
		onInputKeyDown: _propTypes2.default.func, // input keyDown handler: function (event) {}
		onMenuScrollToBottom: _propTypes2.default.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
		onOpen: _propTypes2.default.func, // fires when the menu is opened
		onSelectResetsInput: _propTypes2.default.bool, // whether input is cleared on select (works only for multiselect)
		onValueClick: _propTypes2.default.func, // onClick handler for value labels: function (value, event) {}
		openOnClick: _propTypes2.default.bool, // boolean to control opening the menu when the control is clicked
		openOnFocus: _propTypes2.default.bool, // always open options menu on focus
		optionClassName: _propTypes2.default.string, // additional class(es) to apply to the <Option /> elements
		optionComponent: _propTypes2.default.func, // option component to render in dropdown
		optionRenderer: _propTypes2.default.func, // optionRenderer: function (option) {}
		options: _propTypes2.default.array, // array of options
		pageSize: _propTypes2.default.number, // number of entries to page when using page up/down keys
		placeholder: stringOrNode, // field placeholder, displayed when there's no value
		removeSelected: _propTypes2.default.bool, // whether the selected option is removed from the dropdown on multi selects
		required: _propTypes2.default.bool, // applies HTML5 required attribute when needed
		resetValue: _propTypes2.default.any, // value to use when you clear the control
		rtl: _propTypes2.default.bool, // set to true in order to use react-select in right-to-left direction
		scrollMenuIntoView: _propTypes2.default.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
		searchable: _propTypes2.default.bool, // whether to enable searching feature or not
		simpleValue: _propTypes2.default.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
		style: _propTypes2.default.object, // optional style to apply to the control
		tabIndex: stringOrNumber, // optional tab index of the control
		tabSelectsValue: _propTypes2.default.bool, // whether to treat tabbing out while focused to be value selection
		trimFilter: _propTypes2.default.bool, // whether to trim whitespace around filter value
		value: _propTypes2.default.any, // initial field value
		valueComponent: _propTypes2.default.func, // value component to render
		valueKey: _propTypes2.default.string, // path of the label value in option objects
		valueRenderer: _propTypes2.default.func, // valueRenderer: function (option) {}
		wrapperStyle: _propTypes2.default.object // optional style to apply to the component wrapper
	};
	
	Select.defaultProps = {
		arrowRenderer: _defaultArrowRenderer2.default,
		autosize: true,
		backspaceRemoves: true,
		backspaceToRemoveMessage: 'Press backspace to remove {label}',
		clearable: true,
		clearAllText: 'Clear all',
		clearRenderer: _defaultClearRenderer2.default,
		clearValueText: 'Clear value',
		closeOnSelect: true,
		deleteRemoves: true,
		delimiter: ',',
		disabled: false,
		escapeClearsValue: true,
		filterOptions: _defaultFilterOptions2.default,
		ignoreAccents: true,
		ignoreCase: true,
		inputProps: {},
		isLoading: false,
		joinValues: false,
		labelKey: 'label',
		matchPos: 'any',
		matchProp: 'any',
		menuBuffer: 0,
		menuRenderer: _defaultMenuRenderer2.default,
		multi: false,
		noResultsText: 'No results found',
		onBlurResetsInput: true,
		onCloseResetsInput: true,
		onSelectResetsInput: true,
		openOnClick: true,
		optionComponent: _Option2.default,
		pageSize: 5,
		placeholder: 'Select...',
		removeSelected: true,
		required: false,
		rtl: false,
		scrollMenuIntoView: true,
		searchable: true,
		simpleValue: false,
		tabSelectsValue: true,
		trimFilter: true,
		valueComponent: _Value2.default,
		valueKey: 'value'
	};
	
	exports.default = Select;

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(129);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _reactDom = __webpack_require__(46);
	
	var _classnames = __webpack_require__(37);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	module.exports = (0, _createReactClass2.default)({
	  displayName: 'Tab',
	
	  propTypes: {
	    className: _propTypes2.default.string,
	    id: _propTypes2.default.string,
	    focus: _propTypes2.default.bool,
	    selected: _propTypes2.default.bool,
	    disabled: _propTypes2.default.bool,
	    activeTabClassName: _propTypes2.default.string,
	    disabledTabClassName: _propTypes2.default.string,
	    panelId: _propTypes2.default.string,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object, _propTypes2.default.string])
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      focus: false,
	      selected: false,
	      id: null,
	      panelId: null,
	      activeTabClassName: 'ReactTabs__Tab--selected',
	      disabledTabClassName: 'ReactTabs__Tab--disabled'
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this.checkFocus();
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.checkFocus();
	  },
	  checkFocus: function checkFocus() {
	    if (this.props.selected && this.props.focus) {
	      (0, _reactDom.findDOMNode)(this).focus();
	    }
	  },
	  render: function render() {
	    var _cx;
	
	    var _props = this.props,
	        selected = _props.selected,
	        disabled = _props.disabled,
	        panelId = _props.panelId,
	        activeTabClassName = _props.activeTabClassName,
	        disabledTabClassName = _props.disabledTabClassName,
	        className = _props.className,
	        children = _props.children,
	        id = _props.id,
	        attributes = _objectWithoutProperties(_props, ['selected', 'disabled', 'panelId', 'activeTabClassName', 'disabledTabClassName', 'className', 'children', 'id']);
	
	    delete attributes.focus;
	
	    return _react2.default.createElement(
	      'li',
	      _extends({}, attributes, {
	        className: (0, _classnames2.default)('ReactTabs__Tab', className, (_cx = {}, _defineProperty(_cx, activeTabClassName, selected), _defineProperty(_cx, disabledTabClassName, disabled), _cx)),
	        role: 'tab',
	        id: id,
	        'aria-selected': selected ? 'true' : 'false',
	        'aria-disabled': disabled ? 'true' : 'false',
	        'aria-controls': panelId,
	        tabIndex: selected ? '0' : null
	      }),
	      children
	    );
	  }
	});

/***/ },
/* 207 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 208 */,
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(56);
	var normalizeHeaderName = __webpack_require__(675);
	
	var PROTECTION_PREFIX = /^\)\]\}',?\n/;
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(319);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(319);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      data = data.replace(PROTECTION_PREFIX, '');
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMehtodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(132)))

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InvoiceTableShowMore = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _reactRouter = __webpack_require__(20);
	
	var _pencil = __webpack_require__(216);
	
	var _pencil2 = _interopRequireDefault(_pencil);
	
	var _eye = __webpack_require__(214);
	
	var _eye2 = _interopRequireDefault(_eye);
	
	var _document = __webpack_require__(734);
	
	var _document2 = _interopRequireDefault(_document);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_pencil2.default, { colorSchema: 'primary' });
	
	var _ref2 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'EDIT_INVOICE' });
	
	var _ref3 = _react2.default.createElement(_eye2.default, { colorSchema: 'primary' });
	
	var _ref4 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PDF' });
	
	var _ref5 = _react2.default.createElement(_document2.default, { colorSchema: 'primary' });
	
	var _ref6 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_OVERVIEW' });
	
	var InvoiceTableShowMore = exports.InvoiceTableShowMore = function (_React$Component) {
	  (0, _inherits3.default)(InvoiceTableShowMore, _React$Component);
	
	  function InvoiceTableShowMore(props) {
	    (0, _classCallCheck3.default)(this, InvoiceTableShowMore);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (InvoiceTableShowMore.__proto__ || (0, _getPrototypeOf2.default)(InvoiceTableShowMore)).call(this, props));
	
	    _this.renderEdit = _this.renderEdit.bind(_this);
	    _this.renderPdf = _this.renderPdf.bind(_this);
	    _this.renderInvoiceRoute = _this.renderInvoiceRoute.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(InvoiceTableShowMore, [{
	    key: 'renderEdit',
	    value: function renderEdit() {
	      if (this.props.invoice.approvalStatus === 1) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'table-show-more-list-item' },
	          _ref,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/invoice-tool/' + this.props.invoice.id },
	            _ref2
	          )
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'renderPdf',
	    value: function renderPdf() {
	      return this.props.invoice.pdfLink ? _react2.default.createElement(
	        'div',
	        { className: 'table-show-more-list-item' },
	        _ref3,
	        _react2.default.createElement(
	          'a',
	          { href: this.props.invoice.pdfLink, target: '_blank' },
	          _ref4
	        )
	      ) : null;
	    }
	  }, {
	    key: 'renderInvoiceRoute',
	    value: function renderInvoiceRoute() {
	      return this.props.invoiceRoute ? _react2.default.createElement(
	        'div',
	        { className: 'table-show-more-list-item' },
	        _ref5,
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: this.props.invoiceRoute },
	          _ref6
	        )
	      ) : null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'table-show-more-list' },
	        this.renderEdit(),
	        this.renderPdf(),
	        this.renderInvoiceRoute()
	      );
	    }
	  }]);
	  return InvoiceTableShowMore;
	}(_react2.default.Component);
	
	exports.default = InvoiceTableShowMore;

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ArrowDown = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ArrowDown = exports.ArrowDown = function (_React$Component) {
	  (0, _inherits3.default)(ArrowDown, _React$Component);
	
	  function ArrowDown() {
	    (0, _classCallCheck3.default)(this, ArrowDown);
	    return (0, _possibleConstructorReturn3.default)(this, (ArrowDown.__proto__ || (0, _getPrototypeOf2.default)(ArrowDown)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ArrowDown, [{
	    key: 'getStrokeColor',
	    value: function getStrokeColor() {
	      switch (this.props.color) {
	        case 'primary':
	          return '#00587c';
	        case 'blue-light':
	          return '#b2cdd7';
	        case 'white':
	          return '#ffffff';
	        default:
	          return '#000000';
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var stroke = typeof this.props.color === 'undefined' ? '#00587c' : this.getStrokeColor();
	
	      return _react2.default.createElement(
	        'svg',
	        {
	          version: '1.1',
	          xmlns: 'http://www.w3.org/2000/svg',
	          width: this.props.width || '20',
	          height: this.props.height || '12',
	          viewBox: '0 0 20 12',
	          fill: 'none'
	        },
	        _react2.default.createElement('path', {
	          d: 'M1.5 1.5L10 10L14.25 5.75L18.5 1.5',
	          stroke: stroke,
	          strokeWidth: '3', strokeLinecap: 'round', strokeLinejoin: 'round'
	        })
	      );
	    }
	  }]);
	  return ArrowDown;
	}(_react2.default.Component);
	
	exports.default = ArrowDown;

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Check = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Check = exports.Check = function (_React$Component) {
	  (0, _inherits3.default)(Check, _React$Component);
	
	  function Check() {
	    (0, _classCallCheck3.default)(this, Check);
	    return (0, _possibleConstructorReturn3.default)(this, (Check.__proto__ || (0, _getPrototypeOf2.default)(Check)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Check, [{
	    key: 'getFillColor',
	    value: function getFillColor() {
	      switch (this.props.colorSchema) {
	        case 'primary':
	          return '#00587c';
	        case 'green-profile':
	          return '#53AD99';
	        case 'white':
	          return '#ffffff';
	        default:
	          return '#000000';
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var fill = this.getFillColor();
	
	      return _react2.default.createElement(
	        'svg',
	        {
	          version: '1.1',
	          xmlns: 'http://www.w3.org/2000/svg',
	          width: this.props.width || '20',
	          height: this.props.height || '20',
	          viewBox: '0 0 20 20',
	          className: this.props.classes
	        },
	        _react2.default.createElement('path', {
	          d: 'M5.5 17.5c-0.128 0-0.256-0.049-0.354-0.146l-5-5c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l4.646 4.646 13.646-13.646c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-14 14c-0.098 0.098-0.226 0.146-0.354 0.146z',
	          fill: fill
	        })
	      );
	    }
	  }]);
	  return Check;
	}(_react2.default.Component);
	
	exports.default = Check;

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Close = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Close = exports.Close = function (_React$Component) {
	  (0, _inherits3.default)(Close, _React$Component);
	
	  function Close() {
	    (0, _classCallCheck3.default)(this, Close);
	    return (0, _possibleConstructorReturn3.default)(this, (Close.__proto__ || (0, _getPrototypeOf2.default)(Close)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Close, [{
	    key: 'render',
	    value: function render() {
	      var stroke = this.props.color === 'primary' ? '#00587c' : this.props.color;
	
	      var containerClass = this.props.classes || '';
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: containerClass,
	          onClick: this.props.callback },
	        _react2.default.createElement(
	          'svg',
	          {
	            version: '1.1',
	            xmlns: 'http://www.w3.org/2000/svg',
	            width: this.props.width || '24',
	            height: this.props.height || '24',
	            viewBox: '0 0 24 24',
	            fill: 'none'
	          },
	          _react2.default.createElement('path', { d: 'M22 2L2 22M2 2L22 22',
	            stroke: stroke,
	            strokeWidth: '4', strokeLinecap: 'round' })
	        )
	      );
	    }
	  }]);
	  return Close;
	}(_react2.default.Component);
	
	exports.default = Close;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Eye = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Eye = exports.Eye = function (_React$Component) {
	  (0, _inherits3.default)(Eye, _React$Component);
	
	  function Eye() {
	    (0, _classCallCheck3.default)(this, Eye);
	    return (0, _possibleConstructorReturn3.default)(this, (Eye.__proto__ || (0, _getPrototypeOf2.default)(Eye)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Eye, [{
	    key: 'render',
	    value: function render() {
	      var fill = this.props.colorSchema === 'primary' ? '#00587c' : '#000000';
	
	      return _react2.default.createElement(
	        'svg',
	        {
	          version: '1.1',
	          xmlns: 'http://www.w3.org/2000/svg',
	          width: this.props.width || '23',
	          height: this.props.height || '16',
	          viewBox: '0 0 23 16'
	        },
	        _react2.default.createElement('path', { d: 'M11.2501 9.25C11.9131 9.25 12.549 8.98661 13.0179 ' + '8.51777C13.4867 8.04893 13.7501 7.41304 13.7501 6.75C13.7501 ' + '6.08696 13.4867 5.45107 13.0179 4.98223C12.549 4.51339 11.9131 ' + '4.25 11.2501 4.25C11.211 4.25 11.1767 4.25937 11.1388 4.26133C11.2592 ' + '4.59309 11.2826 4.95234 11.2061 5.2969C11.1295 5.64147 10.9563 5.95706 ' + '10.7067 6.20664C10.4572 6.45622 10.1416 6.62944 9.797 6.70596C9.45244 ' + '6.78248 9.09319 6.75914 8.76143 6.63867C8.76143 6.67773 8.7501 6.71211 ' + '8.7501 6.75C8.7501 7.0783 8.81476 7.40339 8.9404 7.70671C9.06604 8.01002 ' + '9.25019 8.28562 9.48233 8.51777C9.95117 8.98661 10.5871 9.25 11.2501 ' + '9.25ZM22.3642 7.42969C20.2458 3.29648 16.0521 0.5 11.2501 0.5C6.44815 ' + '0.5 2.25323 3.29844 0.136038 7.43008C0.0466796 7.60684 0.00012207 7.80213 ' + '0.00012207 8.0002C0.00012207 8.19826 0.0466796 8.39355 0.136038 8.57031C2.2544 ' + '12.7035 6.44815 15.5 11.2501 15.5C16.0521 15.5 20.247 12.7016 22.3642 ' + '8.56992C22.4535 8.39316 22.5001 8.19787 22.5001 7.9998C22.5001 7.80174 ' + '22.4535 7.60645 22.3642 7.42969ZM11.2501 1.75C12.239 1.75 13.2057 2.04324 ' + '14.028 2.59265C14.8502 3.14206 15.4911 3.92295 15.8695 4.83658C16.2479 ' + '5.75021 16.347 6.75555 16.154 7.72545C15.9611 8.69536 15.4849 9.58627 ' + '14.7856 10.2855C14.0864 10.9848 13.1955 11.461 12.2256 11.6539C11.2556 ' + '11.8469 10.2503 11.7478 9.33668 11.3694C8.42305 10.991 7.64216 10.3501 ' + '7.09275 9.52785C6.54335 8.7056 6.2501 7.73891 6.2501 6.75C6.25155 5.42436 ' + '6.7788 4.15343 7.71617 3.21606C8.65353 2.2787 9.92446 1.75145 11.2501 ' + '1.75ZM11.2501 14.25C7.05635 14.25 3.22432 11.8551 1.2501 8C2.36042 5.82028 ' + '4.13607 4.05079 6.31963 2.94805C5.5044 4.00352 5.0001 5.31133 5.0001 ' + '6.75C5.0001 8.4076 5.65858 9.99732 6.83068 11.1694C8.00279 12.3415 9.5925 ' + '13 11.2501 13C12.9077 13 14.4974 12.3415 15.6695 11.1694C16.8416 9.99732 ' + '17.5001 8.4076 17.5001 6.75C17.5001 5.31133 16.9958 4.00352 16.1806 ' + '2.94805C18.3641 4.05079 20.1398 5.82028 21.2501 8C19.2763 11.8551 ' + '15.4439 14.25 11.2501 14.25Z',
	          fill: fill })
	      );
	    }
	  }]);
	  return Eye;
	}(_react2.default.Component);
	
	exports.default = Eye;

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Heart = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Heart = exports.Heart = function (_React$Component) {
	  (0, _inherits3.default)(Heart, _React$Component);
	
	  function Heart() {
	    (0, _classCallCheck3.default)(this, Heart);
	    return (0, _possibleConstructorReturn3.default)(this, (Heart.__proto__ || (0, _getPrototypeOf2.default)(Heart)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Heart, [{
	    key: 'render',
	    value: function render() {
	      var fill = this.props.colorSchema === 'primary' ? '#00587c' : '#000000';
	
	      return _react2.default.createElement(
	        'svg',
	        {
	          version: '1.1',
	          xmlns: 'http://www.w3.org/2000/svg',
	          width: this.props.width || '20',
	          height: this.props.height || '20',
	          viewBox: '0 0 20 20'
	        },
	        _react2.default.createElement('path', {
	          d: 'M9.5 19c-0.084 ' + '0-0.167-0.021-0.243-0.063-0.094-0.052-2.326-1.301-4.592-3.347-1.341-1.21-2.411-' + '2.448-3.183-3.68-0.984-1.571-1.482-3.139-1.482-4.66 ' + '0-2.895 2.355-5.25 5.25-5.25 0.98 0 2.021 0.367 2.931 1.034 0.532 0.39 0.985 0.86 1.319 1.359 0.334-0.499 ' + '0.787-0.969 1.319-1.359 0.91-0.667 1.951-1.034 2.931-1.034 2.895 0 5.25 2.355 5.25 5.25 0 1.521-0.499 ' + '3.089-1.482 4.66-0.771 1.232-1.842 2.47-3.182 3.68-2.266 2.046-4.498 3.295-4.592 3.347-0.076 0.042-0.159 ' + '0.063-0.243 0.063zM5.25 3c-2.343 0-4.25 1.907-4.25 4.25 0 3.040 2.35 5.802 4.321 7.585 1.76 1.592 3.544 ' + '2.708 4.179 3.087 0.635-0.379 2.419-1.495 4.179-3.087 1.971-1.782 4.321-4.545 4.321-7.585 ' + '0-2.343-1.907-4.25-4.25-4.25-1.703 0-3.357 1.401-3.776 2.658-0.068 0.204-0.259 0.342-0.474 ' + '0.342s-0.406-0.138-0.474-0.342c-0.419-1.257-2.073-2.658-3.776-2.658z',
	          fill: fill
	        })
	      );
	    }
	  }]);
	  return Heart;
	}(_react2.default.Component);
	
	exports.default = Heart;

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Pencil = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Pencil = exports.Pencil = function (_React$Component) {
	  (0, _inherits3.default)(Pencil, _React$Component);
	
	  function Pencil() {
	    (0, _classCallCheck3.default)(this, Pencil);
	    return (0, _possibleConstructorReturn3.default)(this, (Pencil.__proto__ || (0, _getPrototypeOf2.default)(Pencil)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Pencil, [{
	    key: 'render',
	    value: function render() {
	      var fill = this.props.colorSchema === 'primary' ? '#00587c' : '#000000';
	
	      return _react2.default.createElement(
	        'svg',
	        {
	          version: '1.1',
	          xmlns: 'http://www.w3.org/2000/svg',
	          width: this.props.width || '20',
	          height: this.props.height || '20',
	          viewBox: '0 0 20 20'
	        },
	        _react2.default.createElement('path', {
	          d: 'M3.5 17c-0.13 0-0.258-0.051-0.354-0.147-0.137-0.137-0.183-0.342-0.116-0.524l2' + '-5.5c0.025-0.069 0.065-0.131 0.116-0.183l10.5-10.5c0.195-0.195 0.512-0.195' + ' 0.707 0l3.5 3.5c0.195 0.195 0.195 0.512 0 0.707l-10.5 10.5c-0.052 0.052-0.114' + ' 0.091-0.183 0.116l-5.5 2c-0.056 0.020-0.113 0.030-0.171 0.030zM5.932 11.275l-1.596' + ' 4.389 4.389-1.596 10.068-10.068-2.793-2.793-10.068 10.068z',
	          fill: fill }),
	        _react2.default.createElement('path', {
	          d: 'M17.5 20h-16c-0.827 0-1.5-0.673-1.5-1.5v-16c0-0.827 0.673-1.5 1.5-1.5h10c0.276 0' + ' 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-10c-0.276 0-0.5 0.224-0.5 0.5v16c0 0.276 0.224' + ' 0.5 0.5 0.5h16c0.276 0 0.5-0.224 0.5-0.5v-10c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5' + ' 0.5v10c0 0.827-0.673 1.5-1.5 1.5z',
	          fill: fill })
	      );
	    }
	  }]);
	  return Pencil;
	}(_react2.default.Component);
	
	exports.default = Pencil;

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 12/04/16.
	 */
	
	var AddressEntity = function AddressEntity(city, co, country, street, zip) {
	  (0, _classCallCheck3.default)(this, AddressEntity);
	
	  this.city = city;
	  this.co = co;
	  this.country = country;
	  this.street = street;
	  this.zip = zip;
	};
	
	exports.default = AddressEntity;

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(18);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(17);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _customerEntity = __webpack_require__(347);
	
	var _customerEntity2 = _interopRequireDefault(_customerEntity);
	
	var _addressEntity = __webpack_require__(217);
	
	var _addressEntity2 = _interopRequireDefault(_addressEntity);
	
	var _http = __webpack_require__(71);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _pendingRequestEntity = __webpack_require__(42);
	
	var _pendingRequestEntity2 = _interopRequireDefault(_pendingRequestEntity);
	
	var _customerConstants = __webpack_require__(763);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CustomerService = function () {
	  function CustomerService() {
	    (0, _classCallCheck3.default)(this, CustomerService);
	  }
	
	  (0, _createClass3.default)(CustomerService, [{
	    key: 'hydrate',
	    value: function hydrate(customer) {
	      var emails = customer.attributes.billing_emails;
	      var primaryBillingEmail = emails[0] || '';
	      var secondaryBillingEmail = emails[1] || '';
	
	      return new _customerEntity2.default(customer.id, customer.attributes.contact, customer.attributes.email, customer.attributes.name, customer.attributes.phone, primaryBillingEmail, secondaryBillingEmail, customer.attributes.user_id, customer.attributes.vatnr, new _addressEntity2.default(customer.attributes.city, customer.attributes.co, customer.attributes.country, customer.attributes.street, customer.attributes.zip), customer.attributes.pay_terms, customer.attributes.message_type || 'email', customer.attributes.e_invoice_address || '', customer.attributes.po_number || '');
	    }
	  }, {
	    key: 'hydrateCollection',
	    value: function hydrateCollection(data) {
	      var customers = [];
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var customer = _step.value;
	
	          customers.push(this.hydrate(customer));
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return customers;
	    }
	  }, {
	    key: 'extractParams',
	    value: function extractParams(params) {
	      return {
	        data: {
	          attributes: {
	            city: params.city,
	            co: params.co,
	            contact: params.contact,
	            country: params.country,
	            email: params.email,
	            name: params.name,
	            phone: params.phone,
	            send_to_email: params.sendToEmail,
	            send_to_email_secondary: params.sendToEmailSecondary,
	            street: params.street,
	            user_id: params.userId,
	            vatnr: params.vatNr,
	            zip: params.zip,
	            pay_terms: params.payTerms
	          }
	        }
	      };
	    }
	  }, {
	    key: 'getError',
	    value: function getError(error) {
	      var status = (error.response || { status: 200 }).status;
	
	      if (status === 422) {
	        var errorMessages = [];
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = (0, _getIterator3.default)(error.response.data.errors), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var _error = _step2.value;
	
	            if (_error.detail.hasOwnProperty('errors')) {
	              if (_error.detail.errors.hasOwnProperty('country') && _error.detail.errors.country === 'required') {
	                errorMessages.push((0, _proxyCounterpart.proxyCounterpart)('COUNTRY_ERROR'));
	              }
	              if (_error.detail.errors.hasOwnProperty('vatnr') && _error.detail.errors.vatnr === 'requiredunless:country,sweden') {
	                errorMessages.push((0, _proxyCounterpart.proxyCounterpart)('ORG_NR_ERROR'));
	              }
	              if (_error.detail.errors.hasOwnProperty('contact') && _error.detail.errors.contact === 'max:30') {
	                errorMessages.push((0, _proxyCounterpart.proxyCounterpart)('CONTACT_MAX_ERROR'));
	              }
	              if (_error.detail.errors.hasOwnProperty('id') && _error.detail.errors.id === 'notfound:invoice,company_id,pre_report,1') {
	                errorMessages.push((0, _proxyCounterpart.proxyCounterpart)('CANT_DELETE_COMPANY_WITH_PREREPORT_INVOICES'));
	              }
	              if (_error.detail.errors.hasOwnProperty('send_to_email') && _error.detail.errors.send_to_email === 'email') {
	                errorMessages.push((0, _proxyCounterpart.proxyCounterpart)('INVALID_EMAIL'));
	              }
	              if (_error.detail.errors.hasOwnProperty('phone') && _error.detail.errors.phone === 'phonenumber') {
	                errorMessages.push((0, _proxyCounterpart.proxyCounterpart)('INVALID_PHONE_NUMBER'));
	              }
	            }
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	
	        if (errorMessages.length > 0) {
	          return errorMessages;
	        }
	      }
	
	      return false;
	    }
	  }, {
	    key: 'getById',
	    value: function getById(id) {
	      var _this = this;
	
	      var pendingRequest = new _pendingRequestEntity2.default();
	      pendingRequest.promise = _axios2.default.get('backend://user/companies/' + id, {
	        cancelToken: new _axios2.default.CancelToken(function executor(c) {
	          pendingRequest.cancel = c;
	        })
	      }).then(function (response) {
	        return _this.hydrate(response.data.data);
	      });
	
	      return pendingRequest;
	    }
	  }, {
	    key: 'get',
	    value: function get(userId, page, size, searchValue) {
	      var _this2 = this;
	
	      var pendingRequest = new _pendingRequestEntity2.default();
	      pendingRequest.promise = _axios2.default.get('backend://users/' + userId + '/companies', {
	        params: {
	          'page[number]': page || 1,
	          'sort': 'name',
	          'page[size]': size || 20,
	          'filter[name][*]': searchValue || ''
	        },
	        cancelToken: new _axios2.default.CancelToken(function executor(c) {
	          pendingRequest.cancel = c;
	        })
	      }).then(function (response) {
	        var customers = _this2.hydrateCollection(response.data.data);
	        /*
	        response.data.meta = {
	        pagination: {
	          count: 6,
	          current_page: 1,
	          per_page: 25,
	          total: 6,
	          total_pages: 1
	        }
	        };
	        */
	        return new _http.APIResult(customers, response.data.meta);
	      });
	
	      return pendingRequest;
	    }
	  }, {
	    key: 'update',
	    value: function update(id, params) {
	      var _this3 = this;
	
	      return _axios2.default.put('backend://user/companies/' + id, this.extractParams(params)).then(function (response) {
	        return _this3.hydrate(response.data.data);
	      });
	    }
	  }, {
	    key: 'updateBillingEmails',
	    value: function updateBillingEmails(id, params) {
	      var requestData = { data: { attributes: {} } };
	      var emails = [];
	
	      if (params.sendToEmail) {
	        var firstEmail = {
	          type_id: _customerConstants.billingEmailType,
	          email: params.sendToEmail
	        };
	        emails.push(firstEmail);
	      }
	
	      if (params.sendToEmailSecondary) {
	        var secondaryEmail = {
	          type_id: _customerConstants.billingEmailType,
	          email: params.sendToEmailSecondary
	        };
	        emails.push(secondaryEmail);
	      }
	
	      requestData.data.attributes = { emails: emails };
	      return _axios2.default.patch('backend://user/companies/' + id + '/emails', requestData);
	    }
	  }, {
	    key: 'post',
	    value: function post(params) {
	      var _this4 = this;
	
	      var p = this.extractParams(params);
	      p.user_id = 1; // TEMP SOLUTION
	
	      return _axios2.default.post('backend://user/companies', p).then(function (response) {
	        return _this4.hydrate(response.data.data);
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(id) {
	      return _axios2.default.delete('backend://user/companies/' + id);
	    }
	  }, {
	    key: 'updateMessaging',
	    value: function updateMessaging(data) {
	      var companyId = data.company_id;
	      var type = data.message_type;
	      var attributes = {
	        message_type: type
	      };
	
	      if (type === 'email') {
	        attributes.send_to_email = data.send_to_email;
	      }
	
	      if (type === 'sms') {
	        attributes.phone = data.company_phone;
	      }
	
	      if (type === 'e-invoice') {
	        attributes.po_number = data.po_number;
	        attributes.e_invoice_address = data.e_invoice_address;
	      }
	
	      var payload = {
	        data: { attributes: attributes }
	      };
	
	      return _axios2.default.put('backend://user/companies/' + companyId, payload);
	    }
	  }]);
	  return CustomerService;
	}(); /**
	      * Created by staffanrantzow on 05/04/16.
	      */
	
	exports.default = new CustomerService();

/***/ },
/* 219 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var paidPaymentStatus = exports.paidPaymentStatus = 2;
	var creditedPaymentStatus = exports.creditedPaymentStatus = 4;
	
	var paidByFileCategory = exports.paidByFileCategory = 1;
	var paidManuallyCategory = exports.paidManuallyCategory = 2;
	var paidInCashCategory = exports.paidInCashCategory = 3;
	var creditCategory = exports.creditCategory = 4;

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(18);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _axios = __webpack_require__(17);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _invoiceEntity = __webpack_require__(777);
	
	var _invoiceEntity2 = _interopRequireDefault(_invoiceEntity);
	
	var _invoiceCalculationEntity = __webpack_require__(776);
	
	var _invoiceCalculationEntity2 = _interopRequireDefault(_invoiceCalculationEntity);
	
	var _customerEntity = __webpack_require__(347);
	
	var _customerEntity2 = _interopRequireDefault(_customerEntity);
	
	var _addressEntity = __webpack_require__(217);
	
	var _addressEntity2 = _interopRequireDefault(_addressEntity);
	
	var _http = __webpack_require__(71);
	
	var _service = __webpack_require__(118);
	
	var _service2 = _interopRequireDefault(_service);
	
	var _utils = __webpack_require__(29);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _currenciesService = __webpack_require__(346);
	
	var _currenciesService2 = _interopRequireDefault(_currenciesService);
	
	var _invoicePostEntity = __webpack_require__(779);
	
	var _invoicePostEntity2 = _interopRequireDefault(_invoicePostEntity);
	
	var _invoiceDateEntity = __webpack_require__(348);
	
	var _invoiceDateEntity2 = _interopRequireDefault(_invoiceDateEntity);
	
	var _invoiceHsdEntity = __webpack_require__(778);
	
	var _invoiceHsdEntity2 = _interopRequireDefault(_invoiceHsdEntity);
	
	var _invoiceUserService = __webpack_require__(780);
	
	var _invoiceUserService2 = _interopRequireDefault(_invoiceUserService);
	
	var _salaryService = __webpack_require__(349);
	
	var _salaryService2 = _interopRequireDefault(_salaryService);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _supplierLedgerService = __webpack_require__(350);
	
	var _supplierLedgerService2 = _interopRequireDefault(_supplierLedgerService);
	
	var _pendingRequestEntity = __webpack_require__(42);
	
	var _pendingRequestEntity2 = _interopRequireDefault(_pendingRequestEntity);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 05/04/16.
	 */
	
	var InvoiceService = function (_Service) {
	  (0, _inherits3.default)(InvoiceService, _Service);
	
	  function InvoiceService() {
	    (0, _classCallCheck3.default)(this, InvoiceService);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (InvoiceService.__proto__ || (0, _getPrototypeOf2.default)(InvoiceService)).call(this));
	
	    _this.requests = [];
	    return _this;
	  }
	
	  /**
	   *
	   * @param data the invoices
	   * @param included included data for each invoice (include=invoicesdates)
	   * @returns {Array}
	   */
	
	
	  (0, _createClass3.default)(InvoiceService, [{
	    key: 'hydrateCollection',
	    value: function hydrateCollection(data, included) {
	      var invoices = [];
	
	      for (var i = 0; i < data.length; i++) {
	        invoices.push(this.hydrate(data[i], included));
	      }
	
	      return invoices;
	    }
	  }, {
	    key: 'hydrateCustomer',
	    value: function hydrateCustomer(invoice) {
	      var attr = invoice.attributes;
	
	      return new _customerEntity2.default(attr.company_id, attr.company_contact, attr.company_email, attr.company_name, attr.company_phone, attr.send_to_email, attr.send_to_email_secondary, attr.user_id, attr.company_vat, new _addressEntity2.default(attr.company_city, attr.company_co, attr.company_country, attr.company_street, attr.company_zip));
	    }
	  }, {
	    key: 'hydrate',
	    value: function hydrate(invoice) {
	      var included = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	      var attr = invoice.attributes;
	      var currencyEntity = null;
	      var invoiceUsers = [];
	      var invoiceDates = [];
	      var invoiceHours = 0;
	      var pdfLink = null;
	      var salaries = [];
	      var calculation = {};
	      var users = {};
	      var loyaltyPoints = 0;
	      var hsd = null;
	
	      // Loop through the included data and store it correctly
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(included), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var inc = _step.value;
	
	          if (inc.type === 'invoice-users' && parseInt(inc.attributes.invoice_id) === parseInt(invoice.id)) {
	            invoiceUsers.push(_invoiceUserService2.default.hydrate(inc));
	          }
	          if (inc.type === 'invoice-dates' && parseInt(inc.attributes.invoice_id) === parseInt(invoice.id)) {
	            invoiceDates.push(this.hydrateInvoiceDates(inc));
	            invoiceHours += inc.attributes.hours;
	          }
	          if (inc.type === 'currencies') {
	            currencyEntity = _currenciesService2.default.hydrate(inc);
	          }
	
	          if (inc.type === 'pdf' && ((((invoice.relationships || {}).pdf || {}).data || {}).id || '') === inc.id) {
	            pdfLink = inc.attributes.url;
	          }
	
	          if (inc.type === 'salaries' && parseInt(inc.attributes.invoice_id) === parseInt(invoice.id)) {
	            var salaryEntity = _salaryService2.default.hydrate(inc, '');
	
	            if (salaryEntity.isRegular()) {
	              salaryEntity.taxAgencySalary = this.getTaxAgencySalary(included, salaryEntity);
	            }
	
	            if (salaryEntity.paymentStatus !== _frilansFinans.SalaryPaymentStatusConstants.NOT_APPROVED_STATUS) {
	              salaries.push(salaryEntity);
	            }
	          }
	
	          if (inc.type === 'calculation' && inc.id === invoice.relationships.calculation.data.id) {
	            calculation = inc.attributes;
	          }
	          if (inc.type === 'users' && inc.id === invoice.relationships.users.data[0].id) {
	            users = inc.attributes;
	          }
	
	          if (inc.type === 'loyalty-points' && invoice.relationships.loyaltypoints.data.length && inc.id === invoice.relationships.loyaltypoints.data[0].id) {
	            loyaltyPoints = +inc.attributes.amount * +inc.attributes.factor;
	          }
	
	          if (inc.type === 'hsds') {
	            hsd = inc.attributes;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return new _invoiceEntity2.default(invoice.id, attr.allowance, attr.amount, attr.approval_status, attr.created_at, attr.currency_amount, attr.currency_name, attr.currency_exchange_rate, attr.currency_id, attr.expense, attr.full_payment_date_time, attr.gross, attr.has_credit_errand, attr.invoice_number, loyaltyPoints, attr.net, attr.payment_status, attr.pre_report, attr.pre_reported_at, attr.send_to_email, attr.sent, attr.specification, attr.status, attr.supplier_ledger_date_time, attr.tax_id, attr.tax_percent, attr.travel, attr.user_id, this.hydrateCustomer(invoice), currencyEntity, invoiceHours, invoiceUsers, pdfLink, hsd, attr.display_dates, attr.display_hours, salaries, invoiceDates, calculation, attr.ocr, attr.uuid, users, attr.message_type, attr.emails, attr.e_invoice_address, attr.po_number, attr.company_phone);
	    }
	  }, {
	    key: 'getTaxAgencySalary',
	    value: function getTaxAgencySalary(included, salary) {
	      var taxAgencySalaries = included.filter(function (inc) {
	        return inc.type === 'tax-agency-salaries' && salary.userId === inc.attributes.user_id;
	      });
	
	      if (taxAgencySalaries) {
	        return taxAgencySalaries[0];
	      }
	
	      return null;
	    }
	  }, {
	    key: 'hydrateInvoiceCalculation',
	    value: function hydrateInvoiceCalculation(data, included) {
	      var invoiceCalculation = {};
	      invoiceCalculation.amount = data.attributes.amount;
	      invoiceCalculation.amountIncludingVat = data.attributes.amount_including_vat;
	      invoiceCalculation.amountAfterHsd = data.attributes.amount_after_household_service_deduction;
	      invoiceCalculation.invoiceCalculations = [];
	      if (included !== undefined) {
	        for (var i = 0; i < included.length; i++) {
	          var a = included[i].attributes;
	          switch (included[i].type) {
	            case 'invoice-calculation-workers':
	              invoiceCalculation.invoiceCalculations.push(new _invoiceCalculationEntity2.default(a.allowance, a.amount, a.expense, a.fee, a.gross, a.invoice_value, a.itp, a.itp_tax, a.net, a.payroll_tax, a.salary_total, a.tax, a.to_pay, a.total_payroll_tax, a.travel, a.vacation_gross, a.vacation_net, a.vacation_payroll_tax, data.attributes.vat, included[i].id));
	              break;
	          }
	        }
	      }
	
	      return invoiceCalculation;
	    }
	  }, {
	    key: 'hydrateInvoiceDatesCollection',
	    value: function hydrateInvoiceDatesCollection(data) {
	      var invoiceDates = [];
	      for (var i = 0; i < data.length; i++) {
	        invoiceDates.push(this.hydrateInvoiceDates(data[i]));
	      }
	      return invoiceDates;
	    }
	  }, {
	    key: 'hydrateInvoiceDates',
	    value: function hydrateInvoiceDates(data) {
	      data = data.attributes;
	      return new _invoiceDateEntity2.default(data.date, data.hours, data.invoice_id);
	    }
	  }, {
	    key: 'hydrateHsd',
	    value: function hydrateHsd(data) {
	      if (data) {
	        data = data.attributes;
	        return new _invoiceHsdEntity2.default(data.rot, data.rut, data.data, data.apartment_number, data.cooperative_apartment_registration_number, data.accommodation_type);
	      }
	
	      return {};
	    }
	  }, {
	    key: 'hydrateInvoiceWithUsers',
	    value: function hydrateInvoiceWithUsers(data, included) {
	      data = data.attributes;
	      var usersData = this.parseIncludedData(included, 'invoice-users');
	      var datesData = this.parseIncludedData(included, 'invoice-dates');
	      var hsdData = this.parseIncludedData(included, 'hsds');
	      return new _invoicePostEntity2.default(data.specification, data.user_id, data.tax_id, data.company_id, data.currency_id, data.currency_name, data.amount, _invoiceUserService2.default.hydrateCollection(usersData, data.user_id), this.hydrateInvoiceDatesCollection(datesData), data.pre_report, data.pre_reported_at, data.created_at, this.hydrateHsd(hsdData[0]), data.send_to_email, data.e_invoice_address ? data.e_invoice_address : '', data.display_dates, data.display_hours, data.coupon_id, data.currency_amount, data.message_type);
	    }
	  }, {
	    key: 'lockInvoice',
	    value: function lockInvoice(invoiceId) {
	      return _axios2.default.post('backend://invoices/' + invoiceId + '/lock', {}).then(function (response) {
	        return response;
	      });
	    }
	  }, {
	    key: 'post',
	    value: function post(params) {
	      var data = {
	        data: {
	          attributes: params
	        }
	      };
	      return _axios2.default.request({
	        url: 'backend://invoices',
	        method: 'POST',
	        data: data
	      });
	    }
	  }, {
	    key: 'update',
	    value: function update(params, invoiceId) {
	      var data = {
	        data: {
	          attributes: params
	        }
	      };
	      return _axios2.default.request({
	        url: 'backend://invoices/' + invoiceId,
	        method: 'PATCH',
	        data: data
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(id) {
	      return _axios2.default.delete('backend://invoices/' + id);
	    }
	  }, {
	    key: 'parseIncludedData',
	    value: function parseIncludedData(data, type) {
	      var parsedData = [];
	      for (var i = 0; i < data.length; i++) {
	        if (data[i].type === type) {
	          parsedData.push(data[i]);
	        }
	      }
	      return parsedData;
	    }
	  }, {
	    key: 'getPreReportFilter',
	    value: function getPreReportFilter(preReport) {
	      if (_utils2.default.isInt(preReport)) {
	        return '&filter[pre_report]=' + preReport;
	      }
	
	      return '';
	    }
	  }, {
	    key: 'getActiveFilter',
	    value: function getActiveFilter(active) {
	      if (active) {
	        return '&filter[active]=' + active;
	      }
	
	      return '';
	    }
	  }, {
	    key: 'getCurrentFilter',
	    value: function getCurrentFilter(current) {
	      if (current) {
	        return '&filter[current]=1';
	      }
	
	      return '';
	    }
	  }, {
	    key: 'getPaidFilter',
	    value: function getPaidFilter(paid) {
	      if (paid === true) {
	        return '&filter[paid]=1';
	      }
	
	      if (paid === false) {
	        return '&filter[unPaidOrPartiallyPaid]=1';
	      }
	
	      return '';
	    }
	  }, {
	    key: 'getSupplierLedgersForInvoice',
	    value: function getSupplierLedgersForInvoice(invoiceId) {
	      return _axios2.default.get('backend://invoices/' + invoiceId + '/supplier-ledgers?include=appendixfiles', {
	        params: {
	          'page[size]': 100
	        }
	      }).then(function (response) {
	        return _supplierLedgerService2.default.hydrateCollection(response.data.data, response.data.included);
	      });
	    }
	  }, {
	    key: 'getById',
	    value: function getById(id) {
	      var _this2 = this;
	
	      return _axios2.default.get('backend://invoices/' + id + '?include=invoicedates,invoiceusers,currency,pdf,hsd,salaries,taxagencysalaries,loyaltypoints').then(function (response) {
	        return _this2.hydrate(response.data.data, response.data.included);
	      });
	    }
	  }, {
	    key: 'getByUuid',
	    value: function getByUuid(uuid) {
	      var _this3 = this;
	
	      var includes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	      return _axios2.default.get('backend://invoices/uuid/' + uuid + '?include=' + includes.join(',')).then(function (response) {
	        return _this3.hydrate(response.data.data, response.data.included);
	      });
	    }
	  }, {
	    key: 'get',
	    value: function get(userId, dateFilter, page, preReport, active, size, paid, current) {
	      var _this4 = this;
	
	      // if we look for preReported invoices we don't care about date period
	      var filter = preReport ? '?' : this.getFilterDate(dateFilter, 'created_at');
	      var preReportFilter = this.getPreReportFilter(preReport);
	      var activeFilter = this.getActiveFilter(active);
	      var paidFilter = this.getPaidFilter(paid);
	      var currentFilter = this.getCurrentFilter(current);
	
	      var pendingRequest = new _pendingRequestEntity2.default();
	
	      pendingRequest.promise = _axios2.default.get('backend://users/' + userId + '/invoices' + filter + preReportFilter + activeFilter + currentFilter + paidFilter + '&sort=-created_at', {
	        params: {
	          'page[number]': page || 1,
	          'page[size]': size || 3,
	          'include': 'invoicedates,currency,pdf,loyaltypoints,salaries'
	        },
	        cancelToken: new _axios2.default.CancelToken(function executor(c) {
	          pendingRequest.cancel = c;
	        })
	      }).then(function (response) {
	        var invoices = _this4.hydrateCollection(response.data.data, response.data.included);
	        return new _http.APIResult(invoices, response.data.meta);
	      });
	
	      return pendingRequest;
	    }
	  }, {
	    key: 'getForEmployerCertificates',
	    value: function getForEmployerCertificates(dateFilter, page, size) {
	      var _this5 = this;
	
	      var filter = this.getFilterDate(dateFilter, 'created_at');
	      var pendingRequest = new _pendingRequestEntity2.default();
	      pendingRequest.promise = _axios2.default.get('backend://invoices' + filter + '&filter[eligibleForEmploymentCertificate]=true' + '&sort=-created_at', {
	        params: {
	          'page[number]': page || 1,
	          'page[size]': size || 3,
	          'include': 'invoicedates,currency,invoiceusers,salaries'
	        },
	        cancelToken: new _axios2.default.CancelToken(function executor(c) {
	          pendingRequest.cancel = c;
	        })
	      }).then(function (response) {
	        var invoices = _this5.hydrateCollection(response.data.data, response.data.included);
	        return new _http.APIResult(invoices, response.data.meta);
	      });
	
	      return pendingRequest;
	    }
	  }, {
	    key: 'getInvoiceByIdIncludeUsersDates',
	    value: function getInvoiceByIdIncludeUsersDates(id) {
	      var _this6 = this;
	
	      return _axios2.default.get('backend://invoices/' + id, {
	        params: {
	          'include': 'invoiceusers,invoicedates,hsd'
	        }
	      }).then(function (response) {
	        return _this6.hydrateInvoiceWithUsers(response.data.data, response.data.included);
	      });
	    }
	  }, {
	    key: 'getLastTwelveMonths',
	    value: function getLastTwelveMonths() {
	      var _this7 = this;
	
	      var startMonth = new Date().getMonth() + 2;
	      var startYear = new Date().getFullYear() - 1;
	
	      var start = (0, _moment2.default)(startYear + '-' + startMonth + '-01');
	      var end = (0, _moment2.default)().format();
	
	      var filter = '?filter[created_at][>][]=' + _utils2.default.formatDate(start) + '&filter[created_at][<][]=' + _utils2.default.formatDate(end);
	
	      var pendingRequest = new _pendingRequestEntity2.default();
	
	      pendingRequest.promise = _axios2.default.get('backend://invoices' + filter + '&include=invoicedates,currency', {
	        params: {
	          'page[number]': 1,
	          'page[size]': 1000
	        },
	        cancelToken: new _axios2.default.CancelToken(function executor(c) {
	          pendingRequest.cancel = c;
	        })
	      }).then(function (response) {
	        var invoices = _this7.hydrateCollection(response.data.data, response.data.included);
	        return new _http.APIResult(invoices, response.data.meta);
	      });
	
	      return pendingRequest;
	    }
	  }, {
	    key: 'getInvoiceCalculation',
	    value: function getInvoiceCalculation(calculatorPostEntity) {
	      var _this8 = this;
	
	      this.requests.push(calculatorPostEntity);
	      var numRequests = this.requests.length;
	      return _axios2.default.post('backend://invoicecalculations', {
	        data: {
	          attributes: calculatorPostEntity
	        }
	      }).then(function (response) {
	        if (numRequests === _this8.requests.length) {
	          return _this8.hydrateInvoiceCalculation(response.data.data, response.data.included);
	        } else {
	          console.log('Ignored invoice calculation request');
	        }
	      });
	    }
	  }, {
	    key: 'unlockInvoice',
	    value: function unlockInvoice(invoiceId) {
	      return _axios2.default.delete('backend://invoices/' + invoiceId + '/lock');
	    }
	  }]);
	  return InvoiceService;
	}(_service2.default);
	
	exports.default = new InvoiceService();

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by eriksundqvist on 11/10/16.
	 */
	var InvoiceUserEntity = function InvoiceUserEntity(travel, co, street, zip, city, country, invoiceId, userId, allowance, taxkeyId, total, firstName, lastName, accountClearingNumber, accountNumber, salaryPayedDate, expressPayment, taxkeyName, saveVacationPay, saveItp, itpRate, calculation, gross, net, taxkeys) {
	  (0, _classCallCheck3.default)(this, InvoiceUserEntity);
	
	  this.travel = travel;
	  this.co = co;
	  this.street = street;
	  this.zip = zip;
	  this.city = city;
	  this.country = country;
	  this.invoiceId = invoiceId;
	  this.userId = userId;
	  this.allowance = allowance;
	  this.taxkeyId = taxkeyId;
	  this.total = total;
	  this.firstName = firstName;
	  this.lastName = lastName;
	  this.accountClearingNumber = accountClearingNumber;
	  this.accountNumber = accountNumber;
	  this.salaryPayedDate = salaryPayedDate;
	  this.expressPayment = expressPayment;
	  this.taxkeyName = taxkeyName;
	  this.saveVacationPay = saveVacationPay;
	  this.saveItp = saveItp;
	  this.itpRate = itpRate;
	  this.calculation = calculation;
	  this.gross = gross;
	  this.net = net;
	  this.taxkeys = taxkeys;
	};
	
	exports.default = InvoiceUserEntity;

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(22);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Context = function () {
	  function Context() {
	    (0, _classCallCheck3.default)(this, Context);
	
	    this._endpoints = {
	      token: 'https://ff-lumen-api-dev.herokuapp.com/auth/accesstoken'
	    };
	
	    this._routes = {
	      login: '/login',
	      home: '/'
	    };
	
	    this._store = null;
	  }
	
	  (0, _createClass3.default)(Context, [{
	    key: 'store',
	    get: function get() {
	      return this._store;
	    },
	    set: function set(store) {
	      this._store = store;
	    }
	  }, {
	    key: 'endpoints',
	    get: function get() {
	      return this._endpoints;
	    },
	    set: function set(endpoints) {
	      this._endpoints = (0, _assign2.default)({}, this.endpoints, endpoints);
	    }
	  }, {
	    key: 'routes',
	    get: function get() {
	      return this._routes;
	    },
	    set: function set(routes) {
	      this._routes = (0, _assign2.default)({}, this.routes, routes);
	    }
	  }]);
	  return Context;
	}();
	
	exports.default = new Context();

/***/ },
/* 223 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CHANGE_END_DATE = exports.CHANGE_END_DATE = 'datepicker-range:end';
	var CHANGE_START_DATE = exports.CHANGE_START_DATE = 'datepicker-range:start';

/***/ },
/* 224 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Created by staffanrantzow on 17/03/16.
	 */
	
	var OPEN_MAIN_MENU = exports.OPEN_MAIN_MENU = 'main-menu:open';
	var CLOSE_MAIN_MENU = exports.CLOSE_MAIN_MENU = 'main-menu:close';

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setHideFooter = setHideFooter;
	exports.setShowFooter = setShowFooter;
	exports.setHideHeader = setHideHeader;
	exports.setShowHeader = setShowHeader;
	
	var _actionTypes = __webpack_require__(372);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function setHideFooter() {
	  return {
	    type: types.SET_HIDE_FOOTER
	  };
	}
	
	function setShowFooter() {
	  return {
	    type: types.SET_SHOW_FOOTER
	  };
	}
	
	function setHideHeader() {
	  return {
	    type: types.SET_HIDE_HEADER
	  };
	}
	
	function setShowHeader() {
	  return {
	    type: types.SET_SHOW_HEADER
	  };
	}

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VAT = exports.EXPRESS_NOT_ROT_RUT = exports.EXPRESS = exports.ROT_RUT = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(30);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _frilansFinans = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ROT_RUT = exports.ROT_RUT = 'rr'; /**
	                                       * Created by staffanrantzow on 08/11/16.
	                                       */
	
	var EXPRESS = exports.EXPRESS = 'express';
	var EXPRESS_NOT_ROT_RUT = exports.EXPRESS_NOT_ROT_RUT = 'express_not_rot_rut';
	var VAT = exports.VAT = 'vat';
	
	var _ref = _react2.default.createElement(
	  'h2',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ROT_RUT' })
	);
	
	var _ref2 = _react2.default.createElement(
	  'h2',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'EXPRESS_PAYMENT' })
	);
	
	var _ref3 = _react2.default.createElement(
	  'h2',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ALERT' })
	);
	
	var _ref4 = _react2.default.createElement(
	  'h2',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'VAT' })
	);
	
	var ReadMoreModal = function (_React$Component) {
	  (0, _inherits3.default)(ReadMoreModal, _React$Component);
	
	  function ReadMoreModal(props) {
	    (0, _classCallCheck3.default)(this, ReadMoreModal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ReadMoreModal.__proto__ || (0, _getPrototypeOf2.default)(ReadMoreModal)).call(this, props));
	
	    _this.state = {
	      open: true
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(ReadMoreModal, [{
	    key: 'createMarkup',
	    value: function createMarkup(html) {
	      return { __html: html };
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      switch (this.props.text) {
	        case ROT_RUT:
	          return _react2.default.createElement(
	            'div',
	            null,
	            _ref,
	            _react2.default.createElement('p', { dangerouslySetInnerHTML: this.createMarkup(_frilansFinans.Utils.getLineBreaks((0, _proxyCounterpart.proxyCounterpart)('RUT_ROT_INFO'))) })
	          );
	        case EXPRESS:
	          return _react2.default.createElement(
	            'div',
	            null,
	            _ref2,
	            _react2.default.createElement('p', { dangerouslySetInnerHTML: this.createMarkup(_frilansFinans.Utils.getLineBreaks((0, _proxyCounterpart.proxyCounterpart)('EXPRESS_PAYMENT_INFO'))) })
	          );
	        case EXPRESS_NOT_ROT_RUT:
	          return _react2.default.createElement(
	            'div',
	            null,
	            _ref3,
	            _react2.default.createElement('p', { dangerouslySetInnerHTML: this.createMarkup(_frilansFinans.Utils.getLineBreaks((0, _proxyCounterpart.proxyCounterpart)('EXPRESS_PAYMENT_NOT_ROT_RUT'))) })
	          );
	        case VAT:
	          return _react2.default.createElement(
	            'div',
	            null,
	            _ref4,
	            _react2.default.createElement('p', { dangerouslySetInnerHTML: this.createMarkup(_frilansFinans.Utils.getLineBreaks((0, _proxyCounterpart.proxyCounterpart)('VAT_INFO'))) })
	          );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactModal2.default,
	        {
	          className: 'modal',
	          contentLabel: '',
	          isOpen: this.state.open,
	          onRequestClose: this.props.close },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-content read-more-modal' },
	          _react2.default.createElement('button', { className: 'close', onClick: this.props.close }),
	          this.renderContent()
	        )
	      );
	    }
	  }]);
	  return ReadMoreModal;
	}(_react2.default.Component);
	
	exports.default = ReadMoreModal;

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(40);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _utils = __webpack_require__(29);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WorkDateHelper = function () {
	  function WorkDateHelper() {
	    (0, _classCallCheck3.default)(this, WorkDateHelper);
	  }
	
	  (0, _createClass3.default)(WorkDateHelper, [{
	    key: 'formatDisplayDate',
	    value: function formatDisplayDate(startDate, endDate) {
	      var displayDate = _utils2.default.formatDate(startDate);
	      if (+startDate !== +endDate) {
	        displayDate += ' — ' + _utils2.default.formatDate(endDate);
	      }
	
	      return displayDate;
	    }
	  }, {
	    key: 'parseWorkDates',
	    value: function parseWorkDates(workDates) {
	      var selectedDays = [];
	      var newSelectedDays = true;
	      var currentStartDate = void 0;
	
	      workDates = _lodash2.default.orderBy(workDates, 'date', 'asc');
	
	      for (var i = 0; i < workDates.length; i++) {
	        if (newSelectedDays) {
	          currentStartDate = workDates[i].date;
	        }
	        var thisDate = workDates[i].date;
	
	        var nextDate = workDates[i + 1] ? workDates[i + 1].date : null;
	        nextDate = nextDate ? (0, _moment2.default)(nextDate).clone().subtract(1, 'day') : null;
	
	        if (newSelectedDays) {
	          var startDate = (0, _moment2.default)(currentStartDate).toDate();
	          var endDate = (0, _moment2.default)(thisDate).toDate();
	
	          selectedDays.push({
	            startDate: startDate,
	            endDate: endDate,
	            workHours: workDates[i].hours,
	            startDateString: thisDate.replace(/-/g, '')
	          });
	        } else {
	          selectedDays[selectedDays.length - 1].endDate = (0, _moment2.default)(thisDate).toDate();
	        }
	
	        if (!nextDate) {
	          break;
	        }
	
	        newSelectedDays = true;
	      }
	
	      for (var _i = 0; _i < selectedDays.length; _i++) {
	        selectedDays[_i].displayDate = this.formatDisplayDate(selectedDays[_i].startDate, selectedDays[_i].endDate);
	
	        var daysDiff = _moment2.default.duration((0, _moment2.default)(selectedDays[_i].endDate).diff(selectedDays[_i].startDate)).days() + 1;
	
	        selectedDays[_i].totalHoursForPeriod = daysDiff * selectedDays[_i].workHours;
	      }
	
	      return _lodash2.default.orderBy(selectedDays, 'startDateString', 'asc');
	    }
	  }]);
	  return WorkDateHelper;
	}(); /**
	      * Created by eriksundqvist on 17/10/16.
	      */
	
	exports.default = new WorkDateHelper();

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChangePassword = undefined;
	
	var _assign = __webpack_require__(22);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _components = __webpack_require__(13);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _confirmEmail = __webpack_require__(988);
	
	var _confirmEmail2 = _interopRequireDefault(_confirmEmail);
	
	var _changePassword = __webpack_require__(1308);
	
	var _changePassword2 = _interopRequireDefault(_changePassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 16/03/16.
	 */
	
	var _ref = _react2.default.createElement(
	  'p',
	  { className: 'error show' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PASSWORD_NOT_EQUAL' })
	);
	
	var _ref2 = _react2.default.createElement(_components.GeneralError, null);
	
	var _ref3 = _react2.default.createElement(
	  'p',
	  { className: 'info' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SETTINGS_UPDATED' })
	);
	
	var _ref4 = _react2.default.createElement(
	  'h2',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CHANGE_PASSWORD' })
	);
	
	var _ref5 = _react2.default.createElement(_confirmEmail2.default, null);
	
	var _ref6 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PASSWORD_ERROR' });
	
	var ChangePassword = exports.ChangePassword = function (_Component) {
	  (0, _inherits3.default)(ChangePassword, _Component);
	
	  function ChangePassword(props) {
	    (0, _classCallCheck3.default)(this, ChangePassword);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ChangePassword.__proto__ || (0, _getPrototypeOf2.default)(ChangePassword)).call(this, props));
	
	    _this.state = {
	      formValues: {
	        password: {},
	        repeatPassword: {},
	        currentPassword: {}
	      },
	      errorMessage: null,
	      passwordNotEqual: false,
	      posting: false,
	      postError: false,
	      updated: false,
	      showErrorWithoutBlur: false
	    };
	
	    _this.onSubmit = _this.onSubmit.bind(_this);
	    _this.callback = _this.callback.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(ChangePassword, [{
	    key: 'callback',
	    value: function callback(name, values) {
	      var _this2 = this;
	
	      var tempFormValues = this.state.formValues;
	
	      (0, _assign2.default)(tempFormValues[name], values);
	      this.setState({ formValues: tempFormValues }, function () {
	        if (_this2.state.showErrorWithoutBlur) {
	          _this2.validatePassword();
	        }
	      });
	    }
	  }, {
	    key: 'validatePassword',
	    value: function validatePassword() {
	      var equal = this.state.formValues.password.value === this.state.formValues.repeatPassword.value;
	
	      this.setState({
	        passwordNotEqual: !equal
	      });
	
	      return equal;
	    }
	  }, {
	    key: 'updateUser',
	    value: function updateUser() {
	      var params = {
	        password: this.state.formValues.password.value,
	        currentPassword: this.state.formValues.currentPassword.value
	      };
	
	      _frilansFinans.UserService.update(params).then(this.handleSuccess.bind(this)).catch(this.handleError.bind(this));
	
	      this.setState({
	        posting: true,
	        updated: false,
	        postError: false
	      });
	    }
	  }, {
	    key: 'handleSuccess',
	    value: function handleSuccess() {
	      this.setState({
	        posting: false,
	        updated: true,
	        postError: false
	      });
	    }
	  }, {
	    key: 'handleError',
	    value: function handleError(error) {
	      var errors = _frilansFinans.UserService.getError(error);
	
	      this.setState({
	        posting: false,
	        updated: false,
	        postError: true,
	        errorMessage: errors
	      });
	    }
	  }, {
	    key: 'onSubmit',
	    value: function onSubmit(e) {
	      var _this3 = this;
	
	      e.preventDefault();
	
	      this.setState({ showErrorWithoutBlur: true }, function () {
	        if (_frilansFinans.Utils.validateInputValues(_this3.state.formValues) && _this3.validatePassword()) {
	          _this3.setState({
	            loading: true
	          }, _this3.updateUser);
	        }
	      });
	    }
	  }, {
	    key: 'disabled',
	    value: function disabled() {
	      return !this.props.emailConfirmed;
	    }
	  }, {
	    key: 'renderError',
	    value: function renderError() {
	      if (this.state.passwordNotEqual) {
	        return _ref;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'renderPostError',
	    value: function renderPostError() {
	      if (this.state.postError) {
	        if (!this.state.errorMessage) {
	          return _ref2;
	        } else {
	          return _react2.default.createElement(
	            'div',
	            null,
	            this.state.errorMessage.map(function (error, i) {
	              return _react2.default.createElement(
	                'p',
	                { className: 'error', key: i },
	                error
	              );
	            })
	          );
	        }
	      }
	    }
	  }, {
	    key: 'renderPostSuccess',
	    value: function renderPostSuccess() {
	      if (!this.state.posting && this.state.updated) {
	        return _ref3;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'change-password' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-6 col-sm-8' },
	            _ref4,
	            _ref5,
	            _react2.default.createElement(
	              'p',
	              { className: _changePassword2.default['text-body'] },
	              _ref6
	            ),
	            _react2.default.createElement(
	              'form',
	              { action: '', noValidate: true },
	              _react2.default.createElement(_components.InputField, { type: 'password', name: 'currentPassword',
	                placeholder: (0, _proxyCounterpart.proxyCounterpart)('CURRENT_PASSWORD'), callback: this.callback,
	                required: 'true', errorMessage: (0, _proxyCounterpart.proxyCounterpart)('PASSWORD_ERROR'),
	                disabled: this.disabled().toString(),
	                showErrorWithoutBlur: this.state.showErrorWithoutBlur }),
	              _react2.default.createElement(_components.InputField, { type: 'password', name: 'password',
	                placeholder: (0, _proxyCounterpart.proxyCounterpart)('NEW_PASSWORD'), callback: this.callback,
	                required: 'true', minLength: '5', validationType: 'passwordRegistration',
	                disabled: this.disabled().toString(),
	                errorMessage: (0, _proxyCounterpart.proxyCounterpart)('PASSWORD_ERROR'),
	                showErrorWithoutBlur: this.state.showErrorWithoutBlur }),
	              _react2.default.createElement(_components.InputField, { type: 'password', name: 'repeatPassword',
	                placeholder: (0, _proxyCounterpart.proxyCounterpart)('REPEAT_PASSWORD'), callback: this.callback,
	                required: 'true', minLength: '5', validationType: 'passwordRegistration',
	                disabled: this.disabled().toString(),
	                errorMessage: (0, _proxyCounterpart.proxyCounterpart)('PASSWORD_ERROR'),
	                showErrorWithoutBlur: this.state.showErrorWithoutBlur }),
	              this.renderError(),
	              this.renderPostSuccess(),
	              this.renderPostError(),
	              _react2.default.createElement(
	                'div',
	                { className: 'button-wrapper' },
	                _react2.default.createElement(_components.SpinnerButton, { text: (0, _proxyCounterpart.proxyCounterpart)('SAVE_SETTINGS'),
	                  loading: this.state.posting,
	                  classes: 'btn',
	                  disabled: this.disabled(),
	                  callback: this.onSubmit })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return ChangePassword;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    emailConfirmed: state.user.emailConfirmed
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ChangePassword);

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OwnEmployment = undefined;
	
	var _assign = __webpack_require__(22);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _uploadLogotype = __webpack_require__(989);
	
	var _uploadLogotype2 = _interopRequireDefault(_uploadLogotype);
	
	var _components = __webpack_require__(13);
	
	var _frilansFinans = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_components.GeneralError, null);
	
	var _ref2 = _react2.default.createElement(_components.GeneralError, null);
	
	var _ref3 = _react2.default.createElement(
	  'h2',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'EMPLOYMENT_INVOICE' })
	);
	
	var _ref4 = _react2.default.createElement(
	  'h3',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ROT_RUT' }),
	  _react2.default.createElement(
	    'a',
	    {
	      href: 'https://www.frilansfinans.se/fragor-och-svar/rut-och-rot-avdrag/',
	      target: '_blank'
	    },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'OWN_EMPLOYMENT_READ_MORE' })
	  )
	);
	
	var _ref5 = _react2.default.createElement(
	  'label',
	  { htmlFor: 'displayHsd' },
	  _react2.default.createElement('span', null),
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ACTIVATE_ROT_RUT' })
	);
	
	var OwnEmployment = exports.OwnEmployment = function (_React$Component) {
	  (0, _inherits3.default)(OwnEmployment, _React$Component);
	
	  function OwnEmployment(props, context) {
	    (0, _classCallCheck3.default)(this, OwnEmployment);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (OwnEmployment.__proto__ || (0, _getPrototypeOf2.default)(OwnEmployment)).call(this, props, context));
	
	    _this.deleteLogotype = function (e) {
	      _this.setState({
	        renderLogotypeDeleteConfirmModal: true
	      });
	      e.preventDefault();
	    };
	
	    _this.state = {
	      showErrorWithoutBlur: false,
	      user: _this.getUserObject(context.user),
	      logotype: null,
	      posting: false,
	      updated: false,
	      postError: false,
	      postLogotypeError: false,
	      renderLogotypeDeleteConfirmModal: false,
	      logotypePreview: false,
	      message: null,
	      logotypeDeleted: false
	    };
	
	    _this.callback = _this.callback.bind(_this);
	    _this.submitForm = _this.submitForm.bind(_this);
	    _this.clickSubmit = _this.clickSubmit.bind(_this);
	    _this.handleSuccess = _this.handleSuccess.bind(_this);
	    _this.handleError = _this.handleError.bind(_this);
	    _this.setLogotype = _this.setLogotype.bind(_this);
	    _this.deleteLogotype = _this.deleteLogotype.bind(_this);
	    _this.closeModal = _this.closeModal.bind(_this);
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleLogotypeSuccess = _this.handleLogotypeSuccess.bind(_this);
	    _this.handleLogotypeError = _this.handleLogotypeError.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(OwnEmployment, [{
	    key: 'getUserObject',
	    value: function getUserObject(user) {
	      var userObj = _frilansFinans.Utils.getInputValueObjects(user);
	
	      return {
	        id: userObj.id,
	        professionTitle: userObj.professionTitle,
	        professionID: userObj.professionId,
	        displayHsd: userObj.displayHsd,
	        saveITP: userObj.saveITP,
	        itpRate: userObj.itpRate,
	        saveVacationPay: userObj.saveVacationPay,
	        defaultTaxkeyId: userObj.defaultTaxkeyId,
	        receiveSmsNotifications: userObj.receiveSmsNotifications,
	        receiveEmailNotifications: userObj.receiveEmailNotifications,
	        imageSrc: userObj.imageSrc,
	        socialSecurityNr: userObj.socialSecurityNr
	      };
	    }
	  }, {
	    key: 'setLogotype',
	    value: function setLogotype(logotype) {
	      this.setState({ logotype: logotype });
	    }
	  }, {
	    key: 'callback',
	    value: function callback(name, values) {
	      var tempFormValues = this.state.user;
	
	      (0, _assign2.default)(tempFormValues[name], values);
	      this.setState({ user: tempFormValues });
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(e) {
	      var name = void 0;
	      var values = {};
	
	      name = e.target.name;
	      values[name] = {
	        value: e.target.checked
	      };
	
	      this.callback(name, values[name]);
	    }
	
	    /**
	     * Required function when you have the checked attribute on a checkbox
	     */
	
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {}
	  }, {
	    key: 'submitForm',
	    value: function submitForm() {
	      var user = this.state.user;
	      var params = _frilansFinans.Utils.getPostParams(user);
	      params.professionId = user.professionTitle.id ? parseInt(user.professionTitle.id) : user.professionId;
	
	      _frilansFinans.UserService.update(params).then(this.handleSuccess).catch(this.handleError);
	
	      this.setState({
	        posting: true,
	        updated: false,
	        postError: false
	      });
	    }
	  }, {
	    key: 'submitLogotypeAndForm',
	    value: function submitLogotypeAndForm(callback) {
	      var reader = new FileReader();
	      var self = this;
	
	      reader.onload = function (e) {
	        _frilansFinans.LogotypeService.post({
	          'user_id': self.state.user.id.value,
	          'image': e.target.result
	        }).then(self.handleLogotypeSuccess).catch(self.handleLogotypeError).then(function () {
	          if (typeof callback === 'function') {
	            callback();
	          }
	        });
	      };
	
	      reader.readAsDataURL(this.state.logotype);
	    }
	  }, {
	    key: 'clickSubmit',
	    value: function clickSubmit(e) {
	      e.preventDefault();
	
	      if (_frilansFinans.Utils.validateInputValues(this.state.user)) {
	        if (this.state.logotype) {
	          this.submitLogotypeAndForm(this.submitForm);
	        } else {
	          this.submitForm();
	        }
	      } else {
	        this.setState({ showErrorWithoutBlur: true });
	      }
	    }
	  }, {
	    key: 'handleSuccess',
	    value: function handleSuccess() {
	      this.setState({
	        posting: false,
	        updated: true,
	        postError: false
	      });
	
	      this.showMessage('SETTINGS_UPDATED');
	    }
	  }, {
	    key: 'handleError',
	    value: function handleError() {
	      this.setState({
	        posting: false,
	        updated: false,
	        postError: true
	      });
	    }
	  }, {
	    key: 'handleLogotypeSuccess',
	    value: function handleLogotypeSuccess() {
	      this.setState({
	        logotype: null,
	        logotypePreview: false,
	        logotypeDeleted: false
	      });
	    }
	  }, {
	    key: 'handleLogotypeError',
	    value: function handleLogotypeError() {
	      this.setState({
	        postLogotypeError: true
	      });
	    }
	  }, {
	    key: 'renderSuccessMessage',
	    value: function renderSuccessMessage() {
	      if (this.state.message != null) {
	        return _react2.default.createElement(
	          'p',
	          { className: 'info' },
	          _react2.default.createElement(_reactTranslateComponent2.default, { content: this.state.message })
	        );
	      }
	    }
	  }, {
	    key: 'showMessage',
	    value: function showMessage(message) {
	      this.setState({
	        message: message
	      });
	    }
	  }, {
	    key: 'renderLogotypeDeleteConfirmModal',
	    value: function renderLogotypeDeleteConfirmModal() {
	      if (this.state.renderLogotypeDeleteConfirmModal) {
	        return _react2.default.createElement(_components.ConfirmModal, {
	          callback: this.closeModal,
	          message: (0, _proxyCounterpart.proxyCounterpart)('SETTINGS_CONFIRM_LOGOTYPE_DELETE')
	        });
	      }
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal(confirm) {
	      var _this2 = this;
	
	      if (confirm) {
	        _frilansFinans.LogotypeService.delete({
	          'user_id': this.state.user.id.value
	        }).then(function () {
	          _this2.setState({
	            logotype: null,
	            logotypeDeleted: true
	          });
	
	          _this2.showMessage('SETTINGS_LOGOTYPE_DELETED');
	        }).catch(this.handleLogotypeError);
	      }
	
	      this.setState({
	        renderLogotypeDeleteConfirmModal: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var postError, postLogotypeError, imageSrc;
	
	      postError = this.state.postError ? _ref : false;
	      postLogotypeError = this.state.postError ? _ref2 : false;
	      imageSrc = this.state.user.imageSrc ? this.state.user.imageSrc.value : false;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'own-employment' },
	        _ref3,
	        _react2.default.createElement(
	          'form',
	          null,
	          _react2.default.createElement(_components.Profession, { value: this.state.user.professionTitle.value || '', name: 'professionTitle',
	            showErrorWithoutBlur: this.state.showErrorWithoutBlur, callback: this.callback }),
	          _react2.default.createElement(
	            'div',
	            { className: 'section' },
	            _ref4,
	            _react2.default.createElement(
	              'div',
	              { className: 'styled-wrapper right' },
	              _react2.default.createElement('input', { id: 'displayHsd', type: 'checkbox', name: 'displayHsd', onChange: this.onChange,
	                value: this.state.user.displayHsd.value,
	                checked: this.state.user.displayHsd.value, onClick: this.handleClick }),
	              _ref5
	            )
	          ),
	          _react2.default.createElement(_uploadLogotype2.default, { imageSrc: imageSrc, setLogotype: this.setLogotype,
	            deleteLogotype: this.deleteLogotype, logotypePreview: this.state.logotypePreview,
	            logotypeDeleted: this.state.logotypeDeleted }),
	          this.renderSuccessMessage(),
	          postError,
	          postLogotypeError,
	          _react2.default.createElement(
	            'div',
	            { className: 'button-wrapper' },
	            _react2.default.createElement(_components.SpinnerButton, { text: (0, _proxyCounterpart.proxyCounterpart)('SAVE_SETTINGS'),
	              loading: this.state.posting, type: 'button', classes: 'btn', callback: this.clickSubmit })
	          )
	        ),
	        this.renderLogotypeDeleteConfirmModal()
	      );
	    }
	  }]);
	  return OwnEmployment;
	}(_react2.default.Component);
	
	OwnEmployment.contextTypes = {
	  user: _react.PropTypes.object.isRequired
	};
	exports.default = OwnEmployment;

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PersonalInfo = undefined;
	
	var _assign = __webpack_require__(22);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _components = __webpack_require__(13);
	
	var _index = __webpack_require__(164);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'p',
	  { className: 'info' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SETTINGS_UPDATED' })
	);
	
	var _ref2 = _react2.default.createElement(_components.GeneralError, null);
	
	var _ref3 = _react2.default.createElement(
	  'h2',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PERSONAL_INFO' })
	);
	
	var _ref4 = _react2.default.createElement(
	  'p',
	  { className: 'large-margin' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SETTINGS_TEXT' })
	);
	
	var _ref5 = _react2.default.createElement('div', null);
	
	var PersonalInfo = exports.PersonalInfo = function (_React$Component) {
	  (0, _inherits3.default)(PersonalInfo, _React$Component);
	
	  function PersonalInfo(props) {
	    (0, _classCallCheck3.default)(this, PersonalInfo);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PersonalInfo.__proto__ || (0, _getPrototypeOf2.default)(PersonalInfo)).call(this, props));
	
	    _this.state = {
	      showErrorWithoutBlur: false,
	      posting: false,
	      user: props.user ? _this.getUserObject(props.user) : null,
	      userUpdated: false,
	      postError: false
	    };
	
	    _this.callback = _this.callback.bind(_this);
	    _this.submitForm = _this.submitForm.bind(_this);
	    _this.clickSubmit = _this.clickSubmit.bind(_this);
	    _this.handleSuccess = _this.handleSuccess.bind(_this);
	    _this.handleError = _this.handleError.bind(_this);
	    _this.setCountry = _this.setCountry.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(PersonalInfo, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!this.state.user) {
	        this.setState({
	          user: this.getUserObject(nextProps.user)
	        });
	      }
	    }
	  }, {
	    key: 'getUserObject',
	    value: function getUserObject(user) {
	      var userObj = _frilansFinans.Utils.getInputValueObjects(user);
	
	      return {
	        firstName: userObj.firstName,
	        lastName: userObj.lastName,
	        email: userObj.email,
	        street: userObj.street,
	        zip: userObj.zip,
	        city: userObj.city,
	        co: userObj.co,
	        country: userObj.country,
	        cellphone: userObj.cellphone,
	        socialSecurityNr: userObj.socialSecurityNr,
	        receiveSmsNotifications: userObj.receiveSmsNotifications,
	        receiveEmailNotifications: userObj.receiveEmailNotifications
	      };
	    }
	  }, {
	    key: 'setCountry',
	    value: function setCountry(country) {
	      this.callback('country', { value: country, valid: true });
	    }
	  }, {
	    key: 'callback',
	    value: function callback(name, values) {
	      this.setState({ user: this.getUserState(name, values) });
	    }
	  }, {
	    key: 'getUserState',
	    value: function getUserState(name, values) {
	      var tempFormValues = this.state.user;
	      (0, _assign2.default)(tempFormValues[name], values);
	      return tempFormValues;
	    }
	  }, {
	    key: 'submitForm',
	    value: function submitForm() {
	      var params = _frilansFinans.Utils.getPostParams(this.state.user);
	      _frilansFinans.UserService.update(params).then(this.handleSuccess).catch(this.handleError);
	
	      this.setState({
	        posting: true,
	        userUpdated: false,
	        postError: false
	      });
	    }
	  }, {
	    key: 'handleSuccess',
	    value: function handleSuccess(user) {
	      _frilansFinans.TaxkeyService.get(user.id);
	
	      this.setState({
	        posting: false,
	        userUpdated: true,
	        postError: false
	      });
	    }
	  }, {
	    key: 'handleError',
	    value: function handleError(error) {
	      var userState = this.state.user;
	
	      if (_frilansFinans.UserService.hasErrorFor('social_security_number', error)) {
	        this.props.setSocialSecurityNr('');
	        userState = this.getUserState('socialSecurityNr', { value: '', valid: false });
	      }
	
	      var errors = _frilansFinans.UserService.getError(error);
	
	      this.setState({
	        showErrorWithoutBlur: false,
	        posting: false,
	        userUpdated: false,
	        postError: true,
	        errorMessage: errors,
	        user: userState
	      });
	    }
	  }, {
	    key: 'clickSubmit',
	    value: function clickSubmit(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	
	      this.setState({ showErrorWithoutBlur: true }, function () {
	        if (_frilansFinans.Utils.validateInputValues(_this2.state.user)) {
	          _this2.submitForm();
	          _this2.props.setSocialSecurityNr(_this2.state.user.socialSecurityNr.value);
	        }
	      });
	    }
	  }, {
	    key: 'renderPostSuccess',
	    value: function renderPostSuccess() {
	      return _ref;
	    }
	  }, {
	    key: 'renderPostError',
	    value: function renderPostError() {
	      if (this.state.postError) {
	        if (!this.state.errorMessage) {
	          return _ref2;
	        } else {
	          return _react2.default.createElement(
	            'div',
	            null,
	            this.state.errorMessage.map(function (error, i) {
	              return _react2.default.createElement(
	                'p',
	                { className: 'error', key: i },
	                error
	              );
	            })
	          );
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.user.firstName) {
	        var userUpdated = this.state.userUpdated ? this.renderPostSuccess() : false;
	        var disableSocialSecurityNr = void 0;
	        if (this.props.user === undefined) {
	          disableSocialSecurityNr = 'false';
	        } else {
	          disableSocialSecurityNr = this.props.user.socialSecurityNr ? 'true' : 'false';
	        }
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'personal-info' },
	          _ref3,
	          _ref4,
	          _react2.default.createElement(
	            'form',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'form-row' },
	              _react2.default.createElement(_components.InputField, { type: 'text', name: 'firstName', value: this.state.user.firstName.value,
	                placeholder: (0, _proxyCounterpart.proxyCounterpart)('FIRST_NAME'), callback: this.callback,
	                required: 'true', minLength: '2', errorMessage: (0, _proxyCounterpart.proxyCounterpart)('FIRST_NAME_ERROR'),
	                showErrorWithoutBlur: this.state.showErrorWithoutBlur }),
	              _react2.default.createElement(_components.InputField, { type: 'text', name: 'lastName', value: this.state.user.lastName.value,
	                placeholder: (0, _proxyCounterpart.proxyCounterpart)('LAST_NAME'), callback: this.callback,
	                required: 'true', minLength: '2', errorMessage: (0, _proxyCounterpart.proxyCounterpart)('LAST_NAME_ERROR'),
	                showErrorWithoutBlur: this.state.showErrorWithoutBlur })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-row' },
	              _react2.default.createElement(_components.InputField, { type: 'email', name: 'email', value: this.state.user.email.value,
	                placeholder: (0, _proxyCounterpart.proxyCounterpart)('EMAIL'), callback: this.callback,
	                required: 'true', minLength: '3', errorMessage: (0, _proxyCounterpart.proxyCounterpart)('EMAIL_ERROR'),
	                showErrorWithoutBlur: this.state.showErrorWithoutBlur }),
	              _react2.default.createElement(_components.InputField, { type: 'text', name: 'street', value: this.state.user.street.value,
	                placeholder: (0, _proxyCounterpart.proxyCounterpart)('ADDRESS'), callback: this.callback,
	                required: 'true', minLength: '3', errorMessage: (0, _proxyCounterpart.proxyCounterpart)('ADDRESS_ERROR'),
	                showErrorWithoutBlur: this.state.showErrorWithoutBlur })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-row' },
	              _react2.default.createElement(_components.InputField, { type: 'text', name: 'zip', value: this.state.user.zip.value,
	                placeholder: (0, _proxyCounterpart.proxyCounterpart)('POSTAL_CODE'), callback: this.callback,
	                required: 'true', minLength: '3', errorMessage: (0, _proxyCounterpart.proxyCounterpart)('POSTAL_CODE_ERROR'),
	                showErrorWithoutBlur: this.state.showErrorWithoutBlur }),
	              _react2.default.createElement(_components.InputField, { type: 'text', name: 'city', value: this.state.user.city.value,
	                placeholder: (0, _proxyCounterpart.proxyCounterpart)('CITY'), callback: this.callback,
	                required: 'true', minLength: '2', maxLength: '40', errorMessage: (0, _proxyCounterpart.proxyCounterpart)('CITY_ERROR'),
	                showErrorWithoutBlur: this.state.showErrorWithoutBlur })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-row' },
	              _react2.default.createElement(_components.InputField, { type: 'text', name: 'co', value: this.state.user.co.value,
	                placeholder: (0, _proxyCounterpart.proxyCounterpart)('CO'), callback: this.callback,
	                required: 'true', minLength: '0', errorMessage: (0, _proxyCounterpart.proxyCounterpart)('CO_ERROR'),
	                showErrorWithoutBlur: this.state.showErrorWithoutBlur }),
	              _react2.default.createElement(_components.CountryPicker, {
	                setCountry: this.setCountry,
	                countryName: this.state.user.country.value,
	                showErrorWithoutBlur: this.state.showErrorWithoutBlur
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-row' },
	              _react2.default.createElement(_components.InputField, { type: 'tel', name: 'cellphone', value: this.state.user.cellphone.value,
	                placeholder: (0, _proxyCounterpart.proxyCounterpart)('TELEPHONE_NR'), callback: this.callback,
	                required: 'true', minLength: '8', errorMessage: (0, _proxyCounterpart.proxyCounterpart)('TELEPHONE_ERROR'),
	                showErrorWithoutBlur: this.state.showErrorWithoutBlur }),
	              _react2.default.createElement(_components.InputField, { type: 'text', validationType: 'personalNumber',
	                name: 'socialSecurityNr', value: this.props.user === undefined ? '' : this.props.user.socialSecurityNr,
	                placeholder: (0, _proxyCounterpart.proxyCounterpart)('PERSONAL_NUMBER'),
	                disabled: disableSocialSecurityNr,
	                callback: this.callback,
	                required: 'true', minLength: '3', errorMessage: (0, _proxyCounterpart.proxyCounterpart)('PERSONAL_NUMBER_ERROR'),
	                showErrorWithoutBlur: this.state.showErrorWithoutBlur })
	            ),
	            userUpdated,
	            this.renderPostError(),
	            _react2.default.createElement(
	              'div',
	              { className: 'button-wrapper' },
	              _react2.default.createElement(_components.SpinnerButton, { text: (0, _proxyCounterpart.proxyCounterpart)('SAVE_SETTINGS'),
	                loading: this.state.posting, classes: 'btn', type: 'button', callback: this.clickSubmit })
	            )
	          )
	        );
	      } else {
	        return _ref5;
	      }
	    }
	  }]);
	  return PersonalInfo;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    setSocialSecurityNr: function setSocialSecurityNr(socialSecurityNr) {
	      return dispatch((0, _index.setSocialSecurityNr)(socialSecurityNr));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PersonalInfo);

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _lodash = __webpack_require__(40);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _bankInfo = __webpack_require__(163);
	
	var _ssnvalidator = __webpack_require__(377);
	
	var _ssnvalidator2 = _interopRequireDefault(_ssnvalidator);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _selectBank = __webpack_require__(994);
	
	var _selectBank2 = _interopRequireDefault(_selectBank);
	
	var _clearingNumberField = __webpack_require__(993);
	
	var _clearingNumberField2 = _interopRequireDefault(_clearingNumberField);
	
	var _accountNumberField = __webpack_require__(990);
	
	var _accountNumberField2 = _interopRequireDefault(_accountNumberField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BankInfoForm = function (_React$Component) {
	  (0, _inherits3.default)(BankInfoForm, _React$Component);
	
	  function BankInfoForm(props) {
	    (0, _classCallCheck3.default)(this, BankInfoForm);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (BankInfoForm.__proto__ || (0, _getPrototypeOf2.default)(BankInfoForm)).call(this, props));
	
	    _this.changedBank = _this.changedBank.bind(_this);
	
	    _this.changedClearingNumber = _this.changedClearingNumber.bind(_this);
	    _this.blurredClearingNumber = _this.blurredClearingNumber.bind(_this);
	    _this.validateClearingNumber = _this.validateClearingNumber.bind(_this);
	
	    _this.changedAccountNumber = _this.changedAccountNumber.bind(_this);
	    _this.blurredAccountNumber = _this.blurredAccountNumber.bind(_this);
	    _this.validateAccountNumber = _this.validateAccountNumber.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(BankInfoForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.fetchBanks();
	
	      if (this.props.syncBankInfo) {
	        this.props.syncBankInfoFromUser();
	      }
	
	      this.props.setClearingNumberIsValid(this.validateClearingNumber(this.props));
	      this.props.setAccountNumberIsValid(this.validateAccountNumber(this.props));
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.bankInfo.clearingNumber.value !== nextProps.bankInfo.clearingNumber.value) {
	        this.props.setClearingNumberIsValid(this.validateClearingNumber(nextProps));
	
	        if (nextProps.bankInfo.selectedBank === 'OTHER') {
	          var identifiedBank = (0, _bankInfo.identifyBank)(nextProps.bankInfo.clearingNumber.value, nextProps.bankInfo.banks);
	
	          if (identifiedBank !== 'INITIAL') {
	            this.props.setSelectedBank(identifiedBank);
	          }
	        }
	      }
	
	      if (this.props.bankInfo.accountNumber.value !== nextProps.bankInfo.accountNumber.value) {
	        this.props.setAccountNumberIsValid(this.validateAccountNumber(nextProps));
	      }
	
	      if (this.props.bankInfo.selectedBank !== nextProps.bankInfo.selectedBank) {
	        this.props.setClearingNumberIsValid(this.validateClearingNumber(nextProps));
	        this.props.setAccountNumberIsValid(this.validateAccountNumber(nextProps));
	      }
	    }
	  }, {
	    key: 'resetFields',
	    value: function resetFields() {
	      this.props.setClearingNumber('');
	      this.props.setClearingNumberSuppressError(true);
	      this.props.setAccountNumber('');
	      this.props.setAccountNumberSuppressError(true);
	    }
	  }, {
	    key: 'changedBank',
	    value: function changedBank(value) {
	      this.resetFields();
	      this.props.setSelectedBank(value);
	    }
	  }, {
	    key: 'changedClearingNumber',
	    value: function changedClearingNumber(value) {
	      this.props.setClearingNumber(value);
	    }
	  }, {
	    key: 'blurredClearingNumber',
	    value: function blurredClearingNumber(value) {
	      this.props.setClearingNumberIsValid(this.validateClearingNumber(this.props));
	      this.props.setClearingNumberSuppressError(false);
	    }
	  }, {
	    key: 'validateClearingNumber',
	    value: function validateClearingNumber(props) {
	      var value = props.bankInfo.clearingNumber.value;
	      var isValid = false;
	      var errorMessage = (0, _proxyCounterpart.proxyCounterpart)('CLEARING_NR_ERROR_' + props.bankInfo.selectedBank);
	      this.props.setClearingNumberErrorMessage(errorMessage);
	
	      switch (props.bankInfo.selectedBank) {
	        case 'HANDELSBANKEN':
	          isValid = new RegExp('^6[\\d]{3}$').test(value);
	          break;
	        case 'NORDEA_PERSON':
	          isValid = new RegExp('^3300$').test(value);
	          break;
	        case 'NORDEA_KONTO':
	          isValid = new RegExp('^[\\d]{4}$').test(value);
	          break;
	        case 'SWEDBANK':
	          var allowFifth = value.startsWith('8');
	          if (allowFifth) {
	            isValid = new RegExp('^8[\\d]{4}$').test(value);
	          } else {
	            isValid = new RegExp('^7[\\d]{3}$').test(value);
	          }
	          break;
	        case 'SEB':
	          isValid = new RegExp('^[\\d]{4}$').test(value);
	          break;
	        case 'IBAN':
	          isValid = new RegExp('^([a-zA-Z]){4}([a-zA-Z]){2}([0-9a-zA-Z]){2}([0-9a-zA-Z]{3})?$').test(value);
	          break;
	        case 'OTHER':
	          isValid = new RegExp('^[\\d]{4}$').test(value);
	          break;
	        default:
	          isValid = false;
	      }
	
	      // Lets see, if the identified bank matches the selected one.
	      if (isValid && props.bankInfo.selectedBank !== 'IBAN') {
	        var identifiedBank = (0, _bankInfo.identifyBank)(value, this.props.bankInfo.banks);
	        isValid = props.bankInfo.selectedBank === identifiedBank;
	      }
	
	      return isValid;
	    }
	  }, {
	    key: 'changedAccountNumber',
	    value: function changedAccountNumber(value) {
	      this.props.setAccountNumber(value);
	    }
	  }, {
	    key: 'blurredAccountNumber',
	    value: function blurredAccountNumber(value) {
	      this.props.setAccountNumberIsValid(this.validateAccountNumber(this.props));
	      this.props.setAccountNumberSuppressError(false);
	    }
	  }, {
	    key: 'validateAccountNumber',
	    value: function validateAccountNumber(props) {
	      var value = props.bankInfo.accountNumber.value;
	      var clearingNumber = props.bankInfo.clearingNumber.value;
	      var isValid = false;
	      var errorMessage = (0, _proxyCounterpart.proxyCounterpart)('ACCOUNT_NR_ERROR_' + props.bankInfo.selectedBank);
	      this.props.setAccountNumberErrorMessage(errorMessage);
	
	      switch (props.bankInfo.selectedBank) {
	        case 'HANDELSBANKEN':
	          isValid = new RegExp('^[\\d]{9}$').test(value);
	          break;
	        case 'NORDEA_PERSON':
	          isValid = _ssnvalidator2.default.validateSSN(value) || false;
	          if (isValid) {
	            isValid = new RegExp('^[\\d]{10}$').test(value);
	          }
	          break;
	        case 'NORDEA_KONTO':
	          isValid = new RegExp('^[\\d]{7}$').test(value);
	          // Allow 10 digits for certain clearing numbers
	          if (!isValid && _lodash2.default.inRange(clearingNumber, 9500, 9547 + 1) || _lodash2.default.inRange(clearingNumber, 9960, 9969 + 1)) {
	            isValid = new RegExp('^[\\d]{10}$').test(value);
	          }
	          break;
	        case 'SWEDBANK':
	          var allowFifth = clearingNumber.startsWith('8');
	          if (allowFifth) {
	            isValid = new RegExp('^[\\d]{7}([\\d]{1,3})?$').test(value);
	          } else {
	            isValid = new RegExp('^[\\d]{7}$').test(value);
	          }
	          break;
	        case 'SEB':
	          isValid = new RegExp('^[\\d]{7}$').test(value);
	          break;
	        case 'IBAN':
	          isValid = new RegExp('^[A-Z][A-Z][A-Z\\d]*$').test(value);
	          break;
	        case 'OTHER':
	          // Require 10 digits for certain clearing numbers
	          if (_lodash2.default.inRange(clearingNumber, 9300, 9349 + 1) || _lodash2.default.inRange(clearingNumber, 9570, 9579 + 1)) {
	            isValid = new RegExp('^[\\d]{10}$').test(value);
	          } else {
	            isValid = new RegExp('^[\\d]{7}$').test(value);
	          }
	          break;
	        default:
	          isValid = false;
	      }
	
	      return isValid;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'bank-form' },
	        _react2.default.createElement(_selectBank2.default, {
	          value: this.props.bankInfo.selectedBank,
	          changed: this.changedBank
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-row' },
	          _react2.default.createElement(_clearingNumberField2.default, {
	            value: this.props.bankInfo.clearingNumber.value,
	            isValid: this.props.bankInfo.clearingNumber.isValid,
	            suppressError: this.props.bankInfo.clearingNumber.suppressError,
	            errorMessage: this.props.bankInfo.clearingNumber.errorMessage,
	            selectedBank: this.props.bankInfo.selectedBank,
	            changed: this.changedClearingNumber,
	            blurred: this.blurredClearingNumber
	          }),
	          _react2.default.createElement(_accountNumberField2.default, {
	            value: this.props.bankInfo.accountNumber.value,
	            isValid: this.props.bankInfo.accountNumber.isValid,
	            suppressError: this.props.bankInfo.accountNumber.suppressError,
	            errorMessage: this.props.bankInfo.accountNumber.errorMessage,
	            selectedBank: this.props.bankInfo.selectedBank,
	            changed: this.changedAccountNumber,
	            blurred: this.blurredAccountNumber
	          })
	        )
	      );
	    }
	  }]);
	  return BankInfoForm;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(_ref) {
	  var bankInfo = _ref.bankInfo;
	  return {
	    bankInfo: bankInfo,
	    isValid: bankInfo.clearingNumber.isValid && bankInfo.accountNumber.isValid
	  };
	};
	
	var mapDispatchToProps = {
	  fetchBanks: _bankInfo.fetchBanks,
	  setSelectedBank: _bankInfo.setSelectedBank,
	  setClearingNumber: _bankInfo.setClearingNumber,
	  setClearingNumberIsValid: _bankInfo.setClearingNumberIsValid,
	  setClearingNumberSuppressError: _bankInfo.setClearingNumberSuppressError,
	  setClearingNumberErrorMessage: _bankInfo.setClearingNumberErrorMessage,
	  setAccountNumber: _bankInfo.setAccountNumber,
	  setAccountNumberIsValid: _bankInfo.setAccountNumberIsValid,
	  setAccountNumberSuppressError: _bankInfo.setAccountNumberSuppressError,
	  setAccountNumberErrorMessage: _bankInfo.setAccountNumberErrorMessage,
	  syncBankInfoFromUser: _bankInfo.syncBankInfoFromUser
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BankInfoForm);

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(27);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(22);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getIterator2 = __webpack_require__(18);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _lodash = __webpack_require__(40);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _bankInfo = __webpack_require__(163);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _itp_vacation = __webpack_require__(991);
	
	var _itp_vacation2 = _interopRequireDefault(_itp_vacation);
	
	var _notification = __webpack_require__(992);
	
	var _notification2 = _interopRequireDefault(_notification);
	
	var _components = __webpack_require__(13);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _bankInfoForm = __webpack_require__(231);
	
	var _bankInfoForm2 = _interopRequireDefault(_bankInfoForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'p',
	  { className: 'info' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SETTINGS_UPDATED' })
	);
	
	var _ref2 = _react2.default.createElement(_components.GeneralError, null);
	
	var _ref3 = _react2.default.createElement(
	  'h2',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SALARY_SETTINGS_TITLE' })
	);
	
	var _ref4 = _react2.default.createElement(
	  'div',
	  { className: 'section' },
	  _react2.default.createElement(
	    'h3',
	    null,
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'BANK_INFO_TITLE' })
	  ),
	  _react2.default.createElement(_bankInfoForm2.default, null)
	);
	
	var _ref5 = _react2.default.createElement(
	  'h3',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INCOME_TAX' })
	);
	
	var BankInfo = function (_React$Component) {
	  (0, _inherits3.default)(BankInfo, _React$Component);
	
	  function BankInfo(props, context) {
	    (0, _classCallCheck3.default)(this, BankInfo);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (BankInfo.__proto__ || (0, _getPrototypeOf2.default)(BankInfo)).call(this, props, context));
	
	    _this.state = {
	      posting: false,
	      postError: false,
	      errorMessage: '',
	      user: _this.getUserObject(context.user),
	      taxkeyOptions: [{
	        disabled: true,
	        value: '',
	        key: (0, _proxyCounterpart.proxyCounterpart)('CALC_KEY') }].concat(_this.prepareTaxKeys(props.taxkeys)),
	      selectedTaxkey: context.user.defaultTaxkeyId,
	      showErrorWithoutBlur: false
	    };
	
	    _this.callback = _this.callback.bind(_this);
	    _this.clickedSubmit = _this.clickedSubmit.bind(_this);
	    _this.disableITP = _this.disableITP.bind(_this);
	    _this.getBankAccountFields = _this.getBankAccountFields.bind(_this);
	    _this.handleSuccess = _this.handleSuccess.bind(_this);
	    _this.handleError = _this.handleError.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(BankInfo, [{
	    key: 'getUserObject',
	    value: function getUserObject(user) {
	      var userObj = _frilansFinans.Utils.getInputValueObjects(user);
	
	      return {
	        id: userObj.id,
	        professionTitle: userObj.professionTitle,
	        professionID: userObj.professionId,
	        displayHsd: userObj.displayHsd,
	        canChangeItp: userObj.canChangeItp,
	        saveITP: userObj.saveITP,
	        itpRate: userObj.itpRate,
	        saveVacationPay: userObj.saveVacationPay,
	        defaultTaxkeyId: userObj.defaultTaxkeyId,
	        receiveSmsNotifications: userObj.receiveSmsNotifications,
	        receiveEmailNotifications: userObj.receiveEmailNotifications,
	        imageSrc: userObj.imageSrc,
	        socialSecurityNr: userObj.socialSecurityNr
	      };
	    }
	  }, {
	    key: 'prepareTaxKeys',
	    value: function prepareTaxKeys(taxkeys) {
	      var taxKeyArray = [];
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(taxkeys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var taxkey = _step.value;
	
	          var taxKeyName = taxkey.taxkeyName;
	
	          if (taxkey.payrollTax === 19.73) {
	            taxKeyName = taxkey.taxAmount + '%, 19-23 ' + (0, _proxyCounterpart.proxyCounterpart)('YEARS');
	          }
	          taxKeyArray.push({
	            key: taxKeyName,
	            value: taxkey.id
	          });
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return taxKeyArray;
	    }
	  }, {
	    key: 'callback',
	    value: function callback(name, values) {
	      var tempFormValues = this.state.user;
	
	      (0, _assign2.default)(tempFormValues[name], values);
	      this.setState({ user: tempFormValues });
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      nextState.taxkeyOptions = [{
	        disabled: true,
	        value: '',
	        key: (0, _proxyCounterpart.proxyCounterpart)('CALC_KEY') }].concat(this.prepareTaxKeys(nextProps.taxkeys));
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.reset();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // We need to wait till banks are loaded, because it has to identify the
	      // bank by selecting it from the list by the clearing number in redux.
	      if (!_lodash2.default.isEqual(this.props.bankInfo.banks, nextProps.bankInfo.banks)) {
	        this.props.syncBankInfoFromUser();
	      }
	    }
	  }, {
	    key: 'disableITP',
	    value: function disableITP() {
	      return !this.state.user.canChangeItp.value && !this.state.user.saveITP.value;
	    }
	  }, {
	    key: 'handleSuccess',
	    value: function handleSuccess() {
	      this.setState({
	        posting: false,
	        userUpdated: true,
	        postError: false
	      });
	    }
	  }, {
	    key: 'handleError',
	    value: function handleError(error) {
	      var errors = _frilansFinans.UserService.getError(error);
	
	      this.setState({
	        posting: false,
	        userUpdated: false,
	        postError: true,
	        errorMessage: errors
	      });
	    }
	  }, {
	    key: 'getBankAccountFields',
	    value: function getBankAccountFields() {
	      if (this.props.bankInfo.selectedBank === 'IBAN') {
	        return {
	          internationalAccount: 'on',
	          bic: this.props.bankInfo.clearingNumber.value,
	          iban: this.props.bankInfo.accountNumber.value
	        };
	      }
	
	      return {
	        internationalAccount: 'off',
	        accountClearingNr: this.props.bankInfo.clearingNumber.value,
	        accountNr: this.props.bankInfo.accountNumber.value
	      };
	    }
	  }, {
	    key: 'stripBankFields',
	    value: function stripBankFields(user) {
	      var cleanUser = (0, _extends3.default)({}, user);
	      delete cleanUser.internationalAccount;
	      delete cleanUser.accountClearingNr;
	      delete cleanUser.accountNr;
	      return cleanUser;
	    }
	  }, {
	    key: 'clickedSubmit',
	    value: function clickedSubmit(event) {
	      event.preventDefault();
	      this.props.setClearingNumberSuppressError(false);
	      this.props.setAccountNumberSuppressError(false);
	
	      if (_frilansFinans.Utils.validateInputValues(this.stripBankFields(this.state.user))) {
	        if (this.props.isValid) {
	          this.submitForm();
	        }
	      } else {
	        this.setState({ showErrorWithoutBlur: true });
	      }
	    }
	  }, {
	    key: 'submitForm',
	    value: function submitForm() {
	      var bankParams = this.getBankAccountFields();
	      var params = _frilansFinans.Utils.getPostParams(this.state.user);
	      (0, _assign2.default)(params, bankParams);
	      delete params.canChangeItp;
	      params.defaultTaxkeyId = parseInt(params.defaultTaxkeyId);
	
	      _frilansFinans.UserService.update(params).then(this.handleSuccess).catch(this.handleError);
	
	      this.setState({
	        posting: true,
	        userUpdated: false,
	        postError: false
	      });
	    }
	  }, {
	    key: 'renderPostSuccess',
	    value: function renderPostSuccess() {
	      return _ref;
	    }
	  }, {
	    key: 'renderPostError',
	    value: function renderPostError() {
	      if (!this.state.errorMessage) {
	        return _ref2;
	      } else {
	        return _react2.default.createElement(
	          'div',
	          null,
	          this.state.errorMessage.map(function (error, i) {
	            return _react2.default.createElement(
	              'p',
	              { className: 'error', key: i },
	              error
	            );
	          })
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'bank-info' },
	        _ref3,
	        _ref4,
	        _react2.default.createElement(
	          'div',
	          { className: 'section' },
	          _ref5,
	          _react2.default.createElement(_components.SelectBox, { name: 'defaultTaxkeyId', options: this.state.taxkeyOptions,
	            callback: this.callback, errorMessage: (0, _proxyCounterpart.proxyCounterpart)('CALC_KEY_ERROR'),
	            required: 'true', value: this.state.selectedTaxkey,
	            showErrorWithoutBlur: this.state.showErrorWithoutBlur })
	        ),
	        _react2.default.createElement(_itp_vacation2.default, { callback: this.callback,
	          disableITP: this.disableITP(),
	          values: {
	            canChangeItp: this.state.user.canChangeItp,
	            saveITP: this.state.user.saveITP,
	            itpRate: this.state.user.itpRate,
	            saveVacationPay: this.state.user.saveVacationPay
	          },
	          showErrorWithoutBlur: this.state.showErrorWithoutBlur
	        }),
	        _react2.default.createElement(_notification2.default, { callback: this.callback,
	          values: {
	            receiveSmsNotifications: this.state.user.receiveSmsNotifications,
	            receiveEmailNotifications: this.state.user.receiveEmailNotifications
	          }
	        }),
	        this.state.userUpdated && this.renderPostSuccess(),
	        this.state.postError && this.renderPostError(),
	        _react2.default.createElement(
	          'div',
	          { className: 'button-wrapper' },
	          _react2.default.createElement(_components.SpinnerButton, {
	            text: (0, _proxyCounterpart.proxyCounterpart)('SAVE_SETTINGS'),
	            loading: this.state.posting,
	            classes: 'btn',
	            type: 'button',
	            callback: this.clickedSubmit })
	        )
	      );
	    }
	  }]);
	  return BankInfo;
	}(_react2.default.Component);
	
	BankInfo.contextTypes = {
	  user: _react.PropTypes.object.isRequired,
	  taxkeys: _react.PropTypes.array.isRequired
	};
	
	
	var mapStateToProps = function mapStateToProps(_ref6) {
	  var bankInfo = _ref6.bankInfo,
	      user = _ref6.user,
	      taxkeys = _ref6.taxkeys;
	  return {
	    bankInfo: bankInfo,
	    user: user,
	    isValid: bankInfo.clearingNumber.isValid && bankInfo.accountNumber.isValid,
	    taxkeys: taxkeys
	  };
	};
	
	var mapDispatchToProps = {
	  setClearingNumberSuppressError: _bankInfo.setClearingNumberSuppressError,
	  setAccountNumberSuppressError: _bankInfo.setAccountNumberSuppressError,
	  reset: _bankInfo.reset,
	  syncBankInfoFromUser: _bankInfo.syncBankInfoFromUser
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BankInfo);

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1024), __esModule: true };

/***/ },
/* 234 */
101,
/* 235 */
78,
/* 236 */
[1592, 59, 48],
/* 237 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 238 */
[1598, 144],
/* 239 */
[1604, 169, 39, 401, 93, 99, 121, 1043, 148, 396, 44],
/* 240 */
[1606, 172, 59, 99, 65, 98],
/* 241 */
[1608, 143],
/* 242 */
181,
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(93);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ },
/* 244 */
[1626, 245, 172],
/* 245 */
[1627, 48],
/* 246 */
80,
/* 247 */
[1635, 59],
/* 248 */
[1637, 48, 31, 169, 249, 65],
/* 249 */
[1638, 44],
/* 250 */
[1640, 168, 44, 121, 31],
/* 251 */
/***/ function(module, exports) {



/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(38);
	var toAbsoluteIndex = __webpack_require__(110);
	var toLength = __webpack_require__(34);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ },
/* 253 */
[1585, 1076],
/* 254 */
[1589, 33, 107],
/* 255 */
[1592, 24, 19],
/* 256 */
237,
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(28)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ },
/* 258 */
[1596, 19],
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(24);
	var setPrototypeOf = __webpack_require__(267).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ },
/* 260 */
[1599, 125, 28],
/* 261 */
[1603, 104, 107, 126, 52, 28],
/* 262 */
[1604, 103, 9, 53, 52, 51, 125, 261, 126, 61, 28],
/* 263 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ },
/* 264 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ },
/* 265 */
[1607, 19, 273, 66],
/* 266 */
[1608, 45],
/* 267 */
[1624, 24, 16, 67, 60],
/* 268 */
[1626, 184, 111],
/* 269 */
[1629, 80, 78],
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(178);
	var defined = __webpack_require__(78);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(80);
	var defined = __webpack_require__(78);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ },
/* 272 */
/***/ function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ },
/* 273 */
[1630, 67, 416, 258, 255, 19, 66],
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(19);
	var DESCRIPTORS = __webpack_require__(32);
	var LIBRARY = __webpack_require__(103);
	var $typed = __webpack_require__(186);
	var hide = __webpack_require__(52);
	var redefineAll = __webpack_require__(108);
	var fails = __webpack_require__(23);
	var anInstance = __webpack_require__(101);
	var toInteger = __webpack_require__(80);
	var toLength = __webpack_require__(34);
	var toIndex = __webpack_require__(434);
	var gOPN = __webpack_require__(105).f;
	var dP = __webpack_require__(33).f;
	var arrayFill = __webpack_require__(252);
	var setToStringTag = __webpack_require__(126);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(19);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ },
/* 276 */
[1637, 19, 77, 103, 435, 33],
/* 277 */
[1640, 150, 28, 125, 77],
/* 278 */
[1642, 94, 419, 125, 62, 262],
/* 279 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ownerDocument;
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	module.exports = exports["default"];

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(187);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  // HTML DOM and SVG DOM may have different support levels,
	  // so we need to check on context instead of a document root element.
	  return _inDOM2.default ? function (context, node) {
	    if (context.contains) {
	      return context.contains(node);
	    } else if (context.compareDocumentPosition) {
	      return context === node || !!(context.compareDocumentPosition(node) & 16);
	    } else {
	      return fallback(context, node);
	    }
	  } : fallback;
	}();
	
	function fallback(context, node) {
	  if (node) do {
	    if (node === context) return true;
	  } while (node = node.parentNode);
	
	  return false;
	}
	module.exports = exports['default'];

/***/ },
/* 281 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWindow;
	function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	}
	module.exports = exports["default"];

/***/ },
/* 282 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Enforces a single instance of the Raven client, and the
	 * main entry point for Raven. If you are a consumer of the
	 * Raven library, you SHOULD load this file (vs raven.js).
	 **/
	
	var RavenConstructor = __webpack_require__(1353);
	
	// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
	var _window =
	  typeof window !== 'undefined'
	    ? window
	    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	var _Raven = _window.Raven;
	
	var Raven = new RavenConstructor();
	
	/*
	 * Allow multiple versions of Raven to be installed.
	 * Strip Raven from the global context and returns the instance.
	 *
	 * @return {Raven}
	 */
	Raven.noConflict = function() {
	  _window.Raven = _Raven;
	  return Raven;
	};
	
	Raven.afterLoad();
	
	module.exports = Raven;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var stringify = __webpack_require__(583);
	
	var _window =
	  typeof window !== 'undefined'
	    ? window
	    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	function isObject(what) {
	  return typeof what === 'object' && what !== null;
	}
	
	// Yanked from https://git.io/vS8DV re-used under CC0
	// with some tiny modifications
	function isError(value) {
	  switch ({}.toString.call(value)) {
	    case '[object Error]':
	      return true;
	    case '[object Exception]':
	      return true;
	    case '[object DOMException]':
	      return true;
	    default:
	      return value instanceof Error;
	  }
	}
	
	function isErrorEvent(value) {
	  return supportsErrorEvent() && {}.toString.call(value) === '[object ErrorEvent]';
	}
	
	function isUndefined(what) {
	  return what === void 0;
	}
	
	function isFunction(what) {
	  return typeof what === 'function';
	}
	
	function isPlainObject(what) {
	  return Object.prototype.toString.call(what) === '[object Object]';
	}
	
	function isString(what) {
	  return Object.prototype.toString.call(what) === '[object String]';
	}
	
	function isArray(what) {
	  return Object.prototype.toString.call(what) === '[object Array]';
	}
	
	function isEmptyObject(what) {
	  if (!isPlainObject(what)) return false;
	
	  for (var _ in what) {
	    if (what.hasOwnProperty(_)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	function supportsErrorEvent() {
	  try {
	    new ErrorEvent(''); // eslint-disable-line no-new
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function supportsFetch() {
	  if (!('fetch' in _window)) return false;
	
	  try {
	    new Headers(); // eslint-disable-line no-new
	    new Request(''); // eslint-disable-line no-new
	    new Response(); // eslint-disable-line no-new
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	// Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
	// https://caniuse.com/#feat=referrer-policy
	// It doesn't. And it throw exception instead of ignoring this parameter...
	// REF: https://github.com/getsentry/raven-js/issues/1233
	function supportsReferrerPolicy() {
	  if (!supportsFetch()) return false;
	
	  try {
	    // eslint-disable-next-line no-new
	    new Request('pickleRick', {
	      referrerPolicy: 'origin'
	    });
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function supportsPromiseRejectionEvent() {
	  return typeof PromiseRejectionEvent === 'function';
	}
	
	function wrappedCallback(callback) {
	  function dataCallback(data, original) {
	    var normalizedData = callback(data) || data;
	    if (original) {
	      return original(normalizedData) || normalizedData;
	    }
	    return normalizedData;
	  }
	
	  return dataCallback;
	}
	
	function each(obj, callback) {
	  var i, j;
	
	  if (isUndefined(obj.length)) {
	    for (i in obj) {
	      if (hasKey(obj, i)) {
	        callback.call(null, i, obj[i]);
	      }
	    }
	  } else {
	    j = obj.length;
	    if (j) {
	      for (i = 0; i < j; i++) {
	        callback.call(null, i, obj[i]);
	      }
	    }
	  }
	}
	
	function objectMerge(obj1, obj2) {
	  if (!obj2) {
	    return obj1;
	  }
	  each(obj2, function(key, value) {
	    obj1[key] = value;
	  });
	  return obj1;
	}
	
	/**
	 * This function is only used for react-native.
	 * react-native freezes object that have already been sent over the
	 * js bridge. We need this function in order to check if the object is frozen.
	 * So it's ok that objectFrozen returns false if Object.isFrozen is not
	 * supported because it's not relevant for other "platforms". See related issue:
	 * https://github.com/getsentry/react-native-sentry/issues/57
	 */
	function objectFrozen(obj) {
	  if (!Object.isFrozen) {
	    return false;
	  }
	  return Object.isFrozen(obj);
	}
	
	function truncate(str, max) {
	  return !max || str.length <= max ? str : str.substr(0, max) + '\u2026';
	}
	
	/**
	 * hasKey, a better form of hasOwnProperty
	 * Example: hasKey(MainHostObject, property) === true/false
	 *
	 * @param {Object} host object to check property
	 * @param {string} key to check
	 */
	function hasKey(object, key) {
	  return Object.prototype.hasOwnProperty.call(object, key);
	}
	
	function joinRegExp(patterns) {
	  // Combine an array of regular expressions and strings into one large regexp
	  // Be mad.
	  var sources = [],
	    i = 0,
	    len = patterns.length,
	    pattern;
	
	  for (; i < len; i++) {
	    pattern = patterns[i];
	    if (isString(pattern)) {
	      // If it's a string, we need to escape it
	      // Taken from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
	      sources.push(pattern.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1'));
	    } else if (pattern && pattern.source) {
	      // If it's a regexp already, we want to extract the source
	      sources.push(pattern.source);
	    }
	    // Intentionally skip other cases
	  }
	  return new RegExp(sources.join('|'), 'i');
	}
	
	function urlencode(o) {
	  var pairs = [];
	  each(o, function(key, value) {
	    pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
	  });
	  return pairs.join('&');
	}
	
	// borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
	// intentionally using regex and not <a/> href parsing trick because React Native and other
	// environments where DOM might not be available
	function parseUrl(url) {
	  if (typeof url !== 'string') return {};
	  var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
	
	  // coerce to undefined values to empty string so we don't get 'undefined'
	  var query = match[6] || '';
	  var fragment = match[8] || '';
	  return {
	    protocol: match[2],
	    host: match[4],
	    path: match[5],
	    relative: match[5] + query + fragment // everything minus origin
	  };
	}
	function uuid4() {
	  var crypto = _window.crypto || _window.msCrypto;
	
	  if (!isUndefined(crypto) && crypto.getRandomValues) {
	    // Use window.crypto API if available
	    // eslint-disable-next-line no-undef
	    var arr = new Uint16Array(8);
	    crypto.getRandomValues(arr);
	
	    // set 4 in byte 7
	    arr[3] = (arr[3] & 0xfff) | 0x4000;
	    // set 2 most significant bits of byte 9 to '10'
	    arr[4] = (arr[4] & 0x3fff) | 0x8000;
	
	    var pad = function(num) {
	      var v = num.toString(16);
	      while (v.length < 4) {
	        v = '0' + v;
	      }
	      return v;
	    };
	
	    return (
	      pad(arr[0]) +
	      pad(arr[1]) +
	      pad(arr[2]) +
	      pad(arr[3]) +
	      pad(arr[4]) +
	      pad(arr[5]) +
	      pad(arr[6]) +
	      pad(arr[7])
	    );
	  } else {
	    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
	    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
	      var r = (Math.random() * 16) | 0,
	        v = c === 'x' ? r : (r & 0x3) | 0x8;
	      return v.toString(16);
	    });
	  }
	}
	
	/**
	 * Given a child DOM element, returns a query-selector statement describing that
	 * and its ancestors
	 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
	 * @param elem
	 * @returns {string}
	 */
	function htmlTreeAsString(elem) {
	  /* eslint no-extra-parens:0*/
	  var MAX_TRAVERSE_HEIGHT = 5,
	    MAX_OUTPUT_LEN = 80,
	    out = [],
	    height = 0,
	    len = 0,
	    separator = ' > ',
	    sepLength = separator.length,
	    nextStr;
	
	  while (elem && height++ < MAX_TRAVERSE_HEIGHT) {
	    nextStr = htmlElementAsString(elem);
	    // bail out if
	    // - nextStr is the 'html' element
	    // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
	    //   (ignore this limit if we are on the first iteration)
	    if (
	      nextStr === 'html' ||
	      (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)
	    ) {
	      break;
	    }
	
	    out.push(nextStr);
	
	    len += nextStr.length;
	    elem = elem.parentNode;
	  }
	
	  return out.reverse().join(separator);
	}
	
	/**
	 * Returns a simple, query-selector representation of a DOM element
	 * e.g. [HTMLElement] => input#foo.btn[name=baz]
	 * @param HTMLElement
	 * @returns {string}
	 */
	function htmlElementAsString(elem) {
	  var out = [],
	    className,
	    classes,
	    key,
	    attr,
	    i;
	
	  if (!elem || !elem.tagName) {
	    return '';
	  }
	
	  out.push(elem.tagName.toLowerCase());
	  if (elem.id) {
	    out.push('#' + elem.id);
	  }
	
	  className = elem.className;
	  if (className && isString(className)) {
	    classes = className.split(/\s+/);
	    for (i = 0; i < classes.length; i++) {
	      out.push('.' + classes[i]);
	    }
	  }
	  var attrWhitelist = ['type', 'name', 'title', 'alt'];
	  for (i = 0; i < attrWhitelist.length; i++) {
	    key = attrWhitelist[i];
	    attr = elem.getAttribute(key);
	    if (attr) {
	      out.push('[' + key + '="' + attr + '"]');
	    }
	  }
	  return out.join('');
	}
	
	/**
	 * Returns true if either a OR b is truthy, but not both
	 */
	function isOnlyOneTruthy(a, b) {
	  return !!(!!a ^ !!b);
	}
	
	/**
	 * Returns true if both parameters are undefined
	 */
	function isBothUndefined(a, b) {
	  return isUndefined(a) && isUndefined(b);
	}
	
	/**
	 * Returns true if the two input exception interfaces have the same content
	 */
	function isSameException(ex1, ex2) {
	  if (isOnlyOneTruthy(ex1, ex2)) return false;
	
	  ex1 = ex1.values[0];
	  ex2 = ex2.values[0];
	
	  if (ex1.type !== ex2.type || ex1.value !== ex2.value) return false;
	
	  // in case both stacktraces are undefined, we can't decide so default to false
	  if (isBothUndefined(ex1.stacktrace, ex2.stacktrace)) return false;
	
	  return isSameStacktrace(ex1.stacktrace, ex2.stacktrace);
	}
	
	/**
	 * Returns true if the two input stack trace interfaces have the same content
	 */
	function isSameStacktrace(stack1, stack2) {
	  if (isOnlyOneTruthy(stack1, stack2)) return false;
	
	  var frames1 = stack1.frames;
	  var frames2 = stack2.frames;
	
	  // Exit early if frame count differs
	  if (frames1.length !== frames2.length) return false;
	
	  // Iterate through every frame; bail out if anything differs
	  var a, b;
	  for (var i = 0; i < frames1.length; i++) {
	    a = frames1[i];
	    b = frames2[i];
	    if (
	      a.filename !== b.filename ||
	      a.lineno !== b.lineno ||
	      a.colno !== b.colno ||
	      a['function'] !== b['function']
	    )
	      return false;
	  }
	  return true;
	}
	
	/**
	 * Polyfill a method
	 * @param obj object e.g. `document`
	 * @param name method name present on object e.g. `addEventListener`
	 * @param replacement replacement function
	 * @param track {optional} record instrumentation to an array
	 */
	function fill(obj, name, replacement, track) {
	  var orig = obj[name];
	  obj[name] = replacement(orig);
	  obj[name].__raven__ = true;
	  obj[name].__orig__ = orig;
	  if (track) {
	    track.push([obj, name, orig]);
	  }
	}
	
	/**
	 * Join values in array
	 * @param input array of values to be joined together
	 * @param delimiter string to be placed in-between values
	 * @returns {string}
	 */
	function safeJoin(input, delimiter) {
	  if (!isArray(input)) return '';
	
	  var output = [];
	
	  for (var i = 0; i < input.length; i++) {
	    try {
	      output.push(String(input[i]));
	    } catch (e) {
	      output.push('[value cannot be serialized]');
	    }
	  }
	
	  return output.join(delimiter);
	}
	
	// Default Node.js REPL depth
	var MAX_SERIALIZE_EXCEPTION_DEPTH = 3;
	// 50kB, as 100kB is max payload size, so half sounds reasonable
	var MAX_SERIALIZE_EXCEPTION_SIZE = 50 * 1024;
	var MAX_SERIALIZE_KEYS_LENGTH = 40;
	
	function utf8Length(value) {
	  return ~-encodeURI(value).split(/%..|./).length;
	}
	
	function jsonSize(value) {
	  return utf8Length(JSON.stringify(value));
	}
	
	function serializeValue(value) {
	  var maxLength = 40;
	
	  if (typeof value === 'string') {
	    return value.length <= maxLength ? value : value.substr(0, maxLength - 1) + '\u2026';
	  } else if (
	    typeof value === 'number' ||
	    typeof value === 'boolean' ||
	    typeof value === 'undefined'
	  ) {
	    return value;
	  }
	
	  var type = Object.prototype.toString.call(value);
	
	  // Node.js REPL notation
	  if (type === '[object Object]') return '[Object]';
	  if (type === '[object Array]') return '[Array]';
	  if (type === '[object Function]')
	    return value.name ? '[Function: ' + value.name + ']' : '[Function]';
	
	  return value;
	}
	
	function serializeObject(value, depth) {
	  if (depth === 0) return serializeValue(value);
	
	  if (isPlainObject(value)) {
	    return Object.keys(value).reduce(function(acc, key) {
	      acc[key] = serializeObject(value[key], depth - 1);
	      return acc;
	    }, {});
	  } else if (Array.isArray(value)) {
	    return value.map(function(val) {
	      return serializeObject(val, depth - 1);
	    });
	  }
	
	  return serializeValue(value);
	}
	
	function serializeException(ex, depth, maxSize) {
	  if (!isPlainObject(ex)) return ex;
	
	  depth = typeof depth !== 'number' ? MAX_SERIALIZE_EXCEPTION_DEPTH : depth;
	  maxSize = typeof depth !== 'number' ? MAX_SERIALIZE_EXCEPTION_SIZE : maxSize;
	
	  var serialized = serializeObject(ex, depth);
	
	  if (jsonSize(stringify(serialized)) > maxSize) {
	    return serializeException(ex, depth - 1);
	  }
	
	  return serialized;
	}
	
	function serializeKeysForMessage(keys, maxLength) {
	  if (typeof keys === 'number' || typeof keys === 'string') return keys.toString();
	  if (!Array.isArray(keys)) return '';
	
	  keys = keys.filter(function(key) {
	    return typeof key === 'string';
	  });
	  if (keys.length === 0) return '[object has no keys]';
	
	  maxLength = typeof maxLength !== 'number' ? MAX_SERIALIZE_KEYS_LENGTH : maxLength;
	  if (keys[0].length >= maxLength) return keys[0];
	
	  for (var usedKeys = keys.length; usedKeys > 0; usedKeys--) {
	    var serialized = keys.slice(0, usedKeys).join(', ');
	    if (serialized.length > maxLength) continue;
	    if (usedKeys === keys.length) return serialized;
	    return serialized + '\u2026';
	  }
	
	  return '';
	}
	
	module.exports = {
	  isObject: isObject,
	  isError: isError,
	  isErrorEvent: isErrorEvent,
	  isUndefined: isUndefined,
	  isFunction: isFunction,
	  isPlainObject: isPlainObject,
	  isString: isString,
	  isArray: isArray,
	  isEmptyObject: isEmptyObject,
	  supportsErrorEvent: supportsErrorEvent,
	  supportsFetch: supportsFetch,
	  supportsReferrerPolicy: supportsReferrerPolicy,
	  supportsPromiseRejectionEvent: supportsPromiseRejectionEvent,
	  wrappedCallback: wrappedCallback,
	  each: each,
	  objectMerge: objectMerge,
	  truncate: truncate,
	  objectFrozen: objectFrozen,
	  hasKey: hasKey,
	  joinRegExp: joinRegExp,
	  urlencode: urlencode,
	  uuid4: uuid4,
	  htmlTreeAsString: htmlTreeAsString,
	  htmlElementAsString: htmlElementAsString,
	  isSameException: isSameException,
	  isSameStacktrace: isSameStacktrace,
	  parseUrl: parseUrl,
	  fill: fill,
	  safeJoin: safeJoin,
	  serializeException: serializeException,
	  serializeKeysForMessage: serializeKeysForMessage
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 289 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 290 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = compareObjects;
	function compareObjects(objA, objB) {
	  var keys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	  if (objA === objB) {
	    return false;
	  }
	
	  var aKeys = Object.keys(objA);
	  var bKeys = Object.keys(objB);
	
	  if (aKeys.length !== bKeys.length) {
	    return true;
	  }
	
	  var keysMap = {};
	  var i = void 0,
	      len = void 0;
	
	  for (i = 0, len = keys.length; i < len; i++) {
	    keysMap[keys[i]] = true;
	  }
	
	  for (i = 0, len = aKeys.length; i < len; i++) {
	    var key = aKeys[i];
	    var aValue = objA[key];
	    var bValue = objB[key];
	
	    if (aValue === bValue) {
	      continue;
	    }
	
	    if (!keysMap[key] || aValue === null || bValue === null || (typeof aValue === 'undefined' ? 'undefined' : _typeof(aValue)) !== 'object' || (typeof bValue === 'undefined' ? 'undefined' : _typeof(bValue)) !== 'object') {
	      return true;
	    }
	
	    var aValueKeys = Object.keys(aValue);
	    var bValueKeys = Object.keys(bValue);
	
	    if (aValueKeys.length !== bValueKeys.length) {
	      return true;
	    }
	
	    for (var n = 0, length = aValueKeys.length; n < length; n++) {
	      var aValueKey = aValueKeys[n];
	
	      if (aValue[aValueKey] !== bValue[aValueKey]) {
	        return true;
	      }
	    }
	  }
	
	  return false;
	}

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dayMatchesModifier = dayMatchesModifier;
	exports.getModifiersForDay = getModifiersForDay;
	
	var _DateUtils = __webpack_require__(133);
	
	var _Helpers = __webpack_require__(193);
	
	/**
	 * Return `true` if a date matches the specified modifier.
	 *
	 * @export
	 * @param {Date} day
	 * @param {Any} modifier
	 * @return {Boolean}
	 */
	function dayMatchesModifier(day, modifier) {
	  if (!modifier) {
	    return false;
	  }
	  var arr = Array.isArray(modifier) ? modifier : [modifier];
	  return arr.some(function (mod) {
	    if (!mod) {
	      return false;
	    }
	    if (mod instanceof Date) {
	      return (0, _DateUtils.isSameDay)(day, mod);
	    }
	    if ((0, _Helpers.isRangeOfDates)(mod)) {
	      return (0, _DateUtils.isDayInRange)(day, mod);
	    }
	    if (mod.after && mod.before && (0, _DateUtils.isDayAfter)(mod.before, mod.after)) {
	      return (0, _DateUtils.isDayAfter)(day, mod.after) && (0, _DateUtils.isDayBefore)(day, mod.before);
	    }
	    if (mod.after && mod.before && ((0, _DateUtils.isDayAfter)(mod.after, mod.before) || (0, _DateUtils.isSameDay)(mod.after, mod.before))) {
	      return (0, _DateUtils.isDayAfter)(day, mod.after) || (0, _DateUtils.isDayBefore)(day, mod.before);
	    }
	    if (mod.after) {
	      return (0, _DateUtils.isDayAfter)(day, mod.after);
	    }
	    if (mod.before) {
	      return (0, _DateUtils.isDayBefore)(day, mod.before);
	    }
	    if (mod.daysOfWeek) {
	      return mod.daysOfWeek.some(function (dayOfWeek) {
	        return day.getDay() === dayOfWeek;
	      });
	    }
	    if (typeof mod === 'function') {
	      return mod(day);
	    }
	    return false;
	  });
	}
	
	/**
	 * Return the modifiers matching the given day for the given
	 * object of modifiers.
	 *
	 * @export
	 * @param {Date} day
	 * @param {Object} [modifiersObj={}]
	 * @return {Array}
	 */
	function getModifiersForDay(day) {
	  var modifiersObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  return Object.keys(modifiersObj).reduce(function (modifiers, modifierName) {
	    var value = modifiersObj[modifierName];
	    if (dayMatchesModifier(day, value)) {
	      modifiers.push(modifierName);
	    }
	    return modifiers;
	  }, []);
	}
	
	exports.default = { dayMatchesModifier: dayMatchesModifier, getModifiersForDay: getModifiersForDay };
	//# sourceMappingURL=ModifiersUtils.js.map

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(134);
	var Danger = __webpack_require__(1403);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactInstrumentation = __webpack_require__(70);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(301);
	var setInnerHTML = __webpack_require__(201);
	var setTextContent = __webpack_require__(617);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: { toIndex: update.toIndex, content: update.content.toString() }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 293 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var invariant = __webpack_require__(15);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var ReactErrorUtils = __webpack_require__(299);
	
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(21);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 296 */
1522,
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var React = __webpack_require__(139);
	var ReactPropTypesSecret = __webpack_require__(1432);
	
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(21);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: React.PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var invariant = __webpack_require__(15);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = func.bind(null, a);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      // $FlowFixMe https://github.com/facebook/flow/issues/2336
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var ReactCurrentOwner = __webpack_require__(88);
	var ReactInstanceMap = __webpack_require__(157);
	var ReactInstrumentation = __webpack_require__(70);
	var ReactUpdates = __webpack_require__(82);
	
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(21);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 301 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 302 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 303 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 304 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(49);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 306 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(26);
	
	var emptyFunction = __webpack_require__(55);
	var warning = __webpack_require__(21);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 308 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createChainableTypeChecker;
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	// Mostly taken from ReactPropTypes.
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
	      }
	
	      return null;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	      args[_key - 6] = arguments[_key];
	    }
	
	    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}

/***/ },
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stripDiacritics = __webpack_require__(643);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	var _trim = __webpack_require__(1514);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isValid = function isValid(value) {
		return typeof value !== 'undefined' && value !== null && value !== '';
	};
	
	var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
		if (props.ignoreAccents) {
			filterValue = (0, _stripDiacritics2.default)(filterValue);
		}
	
		if (props.ignoreCase) {
			filterValue = filterValue.toLowerCase();
		}
	
		if (props.trimFilter) {
			filterValue = (0, _trim2.default)(filterValue);
		}
	
		if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
			return i[props.valueKey];
		});
	
		return options.filter(function (option) {
			if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
			if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
			if (!filterValue) return true;
	
			var value = option[props.valueKey];
			var label = option[props.labelKey];
			var hasValue = isValid(value);
			var hasLabel = isValid(label);
	
			if (!hasValue && !hasLabel) {
				return false;
			}
	
			var valueTest = hasValue ? String(value) : null;
			var labelTest = hasLabel ? String(label) : null;
	
			if (props.ignoreAccents) {
				if (valueTest && props.matchProp !== 'label') valueTest = (0, _stripDiacritics2.default)(valueTest);
				if (labelTest && props.matchProp !== 'value') labelTest = (0, _stripDiacritics2.default)(labelTest);
			}
	
			if (props.ignoreCase) {
				if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
				if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
			}
	
			return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
		});
	};
	
	exports.default = filterOptions;

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classnames = __webpack_require__(37);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var menuRenderer = function menuRenderer(_ref) {
		var focusedOption = _ref.focusedOption,
		    focusOption = _ref.focusOption,
		    inputValue = _ref.inputValue,
		    instancePrefix = _ref.instancePrefix,
		    onFocus = _ref.onFocus,
		    onOptionRef = _ref.onOptionRef,
		    onSelect = _ref.onSelect,
		    optionClassName = _ref.optionClassName,
		    optionComponent = _ref.optionComponent,
		    optionRenderer = _ref.optionRenderer,
		    options = _ref.options,
		    removeValue = _ref.removeValue,
		    selectValue = _ref.selectValue,
		    valueArray = _ref.valueArray,
		    valueKey = _ref.valueKey;
	
		var Option = optionComponent;
	
		return options.map(function (option, i) {
			var isSelected = valueArray && valueArray.some(function (x) {
				return x[valueKey] === option[valueKey];
			});
			var isFocused = option === focusedOption;
			var optionClass = (0, _classnames2.default)(optionClassName, {
				'Select-option': true,
				'is-selected': isSelected,
				'is-focused': isFocused,
				'is-disabled': option.disabled
			});
	
			return _react2.default.createElement(
				Option,
				{
					className: optionClass,
					focusOption: focusOption,
					inputValue: inputValue,
					instancePrefix: instancePrefix,
					isDisabled: option.disabled,
					isFocused: isFocused,
					isSelected: isSelected,
					key: 'option-' + i + '-' + option[valueKey],
					onFocus: onFocus,
					onSelect: onSelect,
					option: option,
					optionIndex: i,
					ref: function ref(_ref2) {
						onOptionRef(_ref2, isFocused);
					},
					removeValue: removeValue,
					selectValue: selectValue
				},
				optionRenderer(option, i, inputValue)
			);
		});
	};
	
	menuRenderer.propTypes = {
		focusOption: _propTypes2.default.func,
		focusedOption: _propTypes2.default.object,
		inputValue: _propTypes2.default.string,
		instancePrefix: _propTypes2.default.string,
		onFocus: _propTypes2.default.func,
		onOptionRef: _propTypes2.default.func,
		onSelect: _propTypes2.default.func,
		optionClassName: _propTypes2.default.string,
		optionComponent: _propTypes2.default.func,
		optionRenderer: _propTypes2.default.func,
		options: _propTypes2.default.array,
		removeValue: _propTypes2.default.func,
		selectValue: _propTypes2.default.func,
		valueArray: _propTypes2.default.array,
		valueKey: _propTypes2.default.string
	};
	
	exports.default = menuRenderer;

/***/ },
/* 314 */,
/* 315 */,
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1cdeb219a65a39d4d39dfdad5e472f1c.png";

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! VelocityJS.org (1.5.0). (C) 2014 Julian Shapiro. MIT @license: en.wikipedia.org/wiki/MIT_License */
	
	/*************************
	 Velocity jQuery Shim
	 *************************/
	
	/*! VelocityJS.org jQuery Shim (1.0.1). (C) 2014 The jQuery Foundation. MIT @license: en.wikipedia.org/wiki/MIT_License. */
	
	/* This file contains the jQuery functions that Velocity relies on, thereby removing Velocity's dependency on a full copy of jQuery, and allowing it to work in any environment. */
	/* These shimmed functions are only used if jQuery isn't present. If both this shim and jQuery are loaded, Velocity defaults to jQuery proper. */
	/* Browser support: Using this shim instead of jQuery proper removes support for IE8. */
	
	(function(window) {
		"use strict";
		/***************
		 Setup
		 ***************/
	
		/* If jQuery is already loaded, there's no point in loading this shim. */
		if (window.jQuery) {
			return;
		}
	
		/* jQuery base. */
		var $ = function(selector, context) {
			return new $.fn.init(selector, context);
		};
	
		/********************
		 Private Methods
		 ********************/
	
		/* jQuery */
		$.isWindow = function(obj) {
			/* jshint eqeqeq: false */
			return obj && obj === obj.window;
		};
	
		/* jQuery */
		$.type = function(obj) {
			if (!obj) {
				return obj + "";
			}
	
			return typeof obj === "object" || typeof obj === "function" ?
					class2type[toString.call(obj)] || "object" :
					typeof obj;
		};
	
		/* jQuery */
		$.isArray = Array.isArray || function(obj) {
			return $.type(obj) === "array";
		};
	
		/* jQuery */
		function isArraylike(obj) {
			var length = obj.length,
					type = $.type(obj);
	
			if (type === "function" || $.isWindow(obj)) {
				return false;
			}
	
			if (obj.nodeType === 1 && length) {
				return true;
			}
	
			return type === "array" || length === 0 || typeof length === "number" && length > 0 && (length - 1) in obj;
		}
	
		/***************
		 $ Methods
		 ***************/
	
		/* jQuery: Support removed for IE<9. */
		$.isPlainObject = function(obj) {
			var key;
	
			if (!obj || $.type(obj) !== "object" || obj.nodeType || $.isWindow(obj)) {
				return false;
			}
	
			try {
				if (obj.constructor &&
						!hasOwn.call(obj, "constructor") &&
						!hasOwn.call(obj.constructor.prototype, "isPrototypeOf")) {
					return false;
				}
			} catch (e) {
				return false;
			}
	
			for (key in obj) {
			}
	
			return key === undefined || hasOwn.call(obj, key);
		};
	
		/* jQuery */
		$.each = function(obj, callback, args) {
			var value,
					i = 0,
					length = obj.length,
					isArray = isArraylike(obj);
	
			if (args) {
				if (isArray) {
					for (; i < length; i++) {
						value = callback.apply(obj[i], args);
	
						if (value === false) {
							break;
						}
					}
				} else {
					for (i in obj) {
						if (!obj.hasOwnProperty(i)) {
							continue;
						}
						value = callback.apply(obj[i], args);
	
						if (value === false) {
							break;
						}
					}
				}
	
			} else {
				if (isArray) {
					for (; i < length; i++) {
						value = callback.call(obj[i], i, obj[i]);
	
						if (value === false) {
							break;
						}
					}
				} else {
					for (i in obj) {
						if (!obj.hasOwnProperty(i)) {
							continue;
						}
						value = callback.call(obj[i], i, obj[i]);
	
						if (value === false) {
							break;
						}
					}
				}
			}
	
			return obj;
		};
	
		/* Custom */
		$.data = function(node, key, value) {
			/* $.getData() */
			if (value === undefined) {
				var getId = node[$.expando],
						store = getId && cache[getId];
	
				if (key === undefined) {
					return store;
				} else if (store) {
					if (key in store) {
						return store[key];
					}
				}
				/* $.setData() */
			} else if (key !== undefined) {
				var setId = node[$.expando] || (node[$.expando] = ++$.uuid);
	
				cache[setId] = cache[setId] || {};
				cache[setId][key] = value;
	
				return value;
			}
		};
	
		/* Custom */
		$.removeData = function(node, keys) {
			var id = node[$.expando],
					store = id && cache[id];
	
			if (store) {
				// Cleanup the entire store if no keys are provided.
				if (!keys) {
					delete cache[id];
				} else {
					$.each(keys, function(_, key) {
						delete store[key];
					});
				}
			}
		};
	
		/* jQuery */
		$.extend = function() {
			var src, copyIsArray, copy, name, options, clone,
					target = arguments[0] || {},
					i = 1,
					length = arguments.length,
					deep = false;
	
			if (typeof target === "boolean") {
				deep = target;
	
				target = arguments[i] || {};
				i++;
			}
	
			if (typeof target !== "object" && $.type(target) !== "function") {
				target = {};
			}
	
			if (i === length) {
				target = this;
				i--;
			}
	
			for (; i < length; i++) {
				if ((options = arguments[i])) {
					for (name in options) {
						if (!options.hasOwnProperty(name)) {
							continue;
						}
						src = target[name];
						copy = options[name];
	
						if (target === copy) {
							continue;
						}
	
						if (deep && copy && ($.isPlainObject(copy) || (copyIsArray = $.isArray(copy)))) {
							if (copyIsArray) {
								copyIsArray = false;
								clone = src && $.isArray(src) ? src : [];
	
							} else {
								clone = src && $.isPlainObject(src) ? src : {};
							}
	
							target[name] = $.extend(deep, clone, copy);
	
						} else if (copy !== undefined) {
							target[name] = copy;
						}
					}
				}
			}
	
			return target;
		};
	
		/* jQuery 1.4.3 */
		$.queue = function(elem, type, data) {
			function $makeArray(arr, results) {
				var ret = results || [];
	
				if (arr) {
					if (isArraylike(Object(arr))) {
						/* $.merge */
						(function(first, second) {
							var len = +second.length,
									j = 0,
									i = first.length;
	
							while (j < len) {
								first[i++] = second[j++];
							}
	
							if (len !== len) {
								while (second[j] !== undefined) {
									first[i++] = second[j++];
								}
							}
	
							first.length = i;
	
							return first;
						})(ret, typeof arr === "string" ? [arr] : arr);
					} else {
						[].push.call(ret, arr);
					}
				}
	
				return ret;
			}
	
			if (!elem) {
				return;
			}
	
			type = (type || "fx") + "queue";
	
			var q = $.data(elem, type);
	
			if (!data) {
				return q || [];
			}
	
			if (!q || $.isArray(data)) {
				q = $.data(elem, type, $makeArray(data));
			} else {
				q.push(data);
			}
	
			return q;
		};
	
		/* jQuery 1.4.3 */
		$.dequeue = function(elems, type) {
			/* Custom: Embed element iteration. */
			$.each(elems.nodeType ? [elems] : elems, function(i, elem) {
				type = type || "fx";
	
				var queue = $.queue(elem, type),
						fn = queue.shift();
	
				if (fn === "inprogress") {
					fn = queue.shift();
				}
	
				if (fn) {
					if (type === "fx") {
						queue.unshift("inprogress");
					}
	
					fn.call(elem, function() {
						$.dequeue(elem, type);
					});
				}
			});
		};
	
		/******************
		 $.fn Methods
		 ******************/
	
		/* jQuery */
		$.fn = $.prototype = {
			init: function(selector) {
				/* Just return the element wrapped inside an array; don't proceed with the actual jQuery node wrapping process. */
				if (selector.nodeType) {
					this[0] = selector;
	
					return this;
				} else {
					throw new Error("Not a DOM node.");
				}
			},
			offset: function() {
				/* jQuery altered code: Dropped disconnected DOM node checking. */
				var box = this[0].getBoundingClientRect ? this[0].getBoundingClientRect() : {top: 0, left: 0};
	
				return {
					top: box.top + (window.pageYOffset || document.scrollTop || 0) - (document.clientTop || 0),
					left: box.left + (window.pageXOffset || document.scrollLeft || 0) - (document.clientLeft || 0)
				};
			},
			position: function() {
				/* jQuery */
				function offsetParentFn(elem) {
					var offsetParent = elem.offsetParent;
	
					while (offsetParent && (offsetParent.nodeName.toLowerCase() !== "html" && offsetParent.style && offsetParent.style.position.toLowerCase() === "static")) {
						offsetParent = offsetParent.offsetParent;
					}
	
					return offsetParent || document;
				}
	
				/* Zepto */
				var elem = this[0],
						offsetParent = offsetParentFn(elem),
						offset = this.offset(),
						parentOffset = /^(?:body|html)$/i.test(offsetParent.nodeName) ? {top: 0, left: 0} : $(offsetParent).offset();
	
				offset.top -= parseFloat(elem.style.marginTop) || 0;
				offset.left -= parseFloat(elem.style.marginLeft) || 0;
	
				if (offsetParent.style) {
					parentOffset.top += parseFloat(offsetParent.style.borderTopWidth) || 0;
					parentOffset.left += parseFloat(offsetParent.style.borderLeftWidth) || 0;
				}
	
				return {
					top: offset.top - parentOffset.top,
					left: offset.left - parentOffset.left
				};
			}
		};
	
		/**********************
		 Private Variables
		 **********************/
	
		/* For $.data() */
		var cache = {};
		$.expando = "velocity" + (new Date().getTime());
		$.uuid = 0;
	
		/* For $.queue() */
		var class2type = {},
				hasOwn = class2type.hasOwnProperty,
				toString = class2type.toString;
	
		var types = "Boolean Number String Function Array Date RegExp Object Error".split(" ");
		for (var i = 0; i < types.length; i++) {
			class2type["[object " + types[i] + "]"] = types[i].toLowerCase();
		}
	
		/* Makes $(node) possible, without having to call init. */
		$.fn.init.prototype = $.fn;
	
		/* Globalize Velocity onto the window, and assign its Utilities property. */
		window.Velocity = {Utilities: $};
	})(window);
	
	/******************
	 Velocity.js
	 ******************/
	
	(function(factory) {
		"use strict";
		/* CommonJS module. */
		if (typeof module === "object" && typeof module.exports === "object") {
			module.exports = factory();
			/* AMD module. */
		} else if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			/* Browser globals. */
		} else {
			factory();
		}
	}(function() {
		"use strict";
		return function(global, window, document, undefined) {
	
			/***************
			 Summary
			 ***************/
	
			/*
			 - CSS: CSS stack that works independently from the rest of Velocity.
			 - animate(): Core animation method that iterates over the targeted elements and queues the incoming call onto each element individually.
			 - Pre-Queueing: Prepare the element for animation by instantiating its data cache and processing the call's options.
			 - Queueing: The logic that runs once the call has reached its point of execution in the element's $.queue() stack.
			 Most logic is placed here to avoid risking it becoming stale (if the element's properties have changed).
			 - Pushing: Consolidation of the tween data followed by its push onto the global in-progress calls container.
			 - tick(): The single requestAnimationFrame loop responsible for tweening all in-progress calls.
			 - completeCall(): Handles the cleanup process for each Velocity call.
			 */
	
			/*********************
			 Helper Functions
			 *********************/
	
			/* IE detection. Gist: https://gist.github.com/julianshapiro/9098609 */
			var IE = (function() {
				if (document.documentMode) {
					return document.documentMode;
				} else {
					for (var i = 7; i > 4; i--) {
						var div = document.createElement("div");
	
						div.innerHTML = "<!--[if IE " + i + "]><span></span><![endif]-->";
	
						if (div.getElementsByTagName("span").length) {
							div = null;
	
							return i;
						}
					}
				}
	
				return undefined;
			})();
	
			/* rAF shim. Gist: https://gist.github.com/julianshapiro/9497513 */
			var rAFShim = (function() {
				var timeLast = 0;
	
				return window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function(callback) {
					var timeCurrent = (new Date()).getTime(),
							timeDelta;
	
					/* Dynamically set delay on a per-tick basis to match 60fps. */
					/* Technique by Erik Moller. MIT license: https://gist.github.com/paulirish/1579671 */
					timeDelta = Math.max(0, 16 - (timeCurrent - timeLast));
					timeLast = timeCurrent + timeDelta;
	
					return setTimeout(function() {
						callback(timeCurrent + timeDelta);
					}, timeDelta);
				};
			})();
	
			var performance = (function() {
				var perf = window.performance || {};
	
				if (typeof perf.now !== "function") {
					var nowOffset = perf.timing && perf.timing.navigationStart ? perf.timing.navigationStart : (new Date()).getTime();
	
					perf.now = function() {
						return (new Date()).getTime() - nowOffset;
					};
				}
				return perf;
			})();
	
			/* Array compacting. Copyright Lo-Dash. MIT License: https://github.com/lodash/lodash/blob/master/LICENSE.txt */
			function compactSparseArray(array) {
				var index = -1,
						length = array ? array.length : 0,
						result = [];
	
				while (++index < length) {
					var value = array[index];
	
					if (value) {
						result.push(value);
					}
				}
	
				return result;
			}
	
			/**
			 * Shim for "fixing" IE's lack of support (IE < 9) for applying slice
			 * on host objects like NamedNodeMap, NodeList, and HTMLCollection
			 * (technically, since host objects have been implementation-dependent,
			 * at least before ES2015, IE hasn't needed to work this way).
			 * Also works on strings, fixes IE < 9 to allow an explicit undefined
			 * for the 2nd argument (as in Firefox), and prevents errors when
			 * called on other DOM objects.
			 */
			var _slice = (function() {
				var slice = Array.prototype.slice;
	
				try {
					// Can't be used with DOM elements in IE < 9
					slice.call(document.documentElement);
					return slice;
				} catch (e) { // Fails in IE < 9
	
					// This will work for genuine arrays, array-like objects, 
					// NamedNodeMap (attributes, entities, notations),
					// NodeList (e.g., getElementsByTagName), HTMLCollection (e.g., childNodes),
					// and will not fail on other DOM objects (as do DOM elements in IE < 9)
					return function(begin, end) {
						var len = this.length;
	
						if (typeof begin !== "number") {
							begin = 0;
						}
						// IE < 9 gets unhappy with an undefined end argument
						if (typeof end !== "number") {
							end = len;
						}
						// For native Array objects, we use the native slice function
						if (this.slice) {
							return slice.call(this, begin, end);
						}
						// For array like object we handle it ourselves.
						var i,
								cloned = [],
								// Handle negative value for "begin"
								start = (begin >= 0) ? begin : Math.max(0, len + begin),
								// Handle negative value for "end"
								upTo = end < 0 ? len + end : Math.min(end, len),
								// Actual expected size of the slice
								size = upTo - start;
	
						if (size > 0) {
							cloned = new Array(size);
							if (this.charAt) {
								for (i = 0; i < size; i++) {
									cloned[i] = this.charAt(start + i);
								}
							} else {
								for (i = 0; i < size; i++) {
									cloned[i] = this[start + i];
								}
							}
						}
						return cloned;
					};
				}
			})();
	
			/* .indexOf doesn't exist in IE<9 */
			var _inArray = (function() {
				if (Array.prototype.includes) {
					return function(arr, val) {
						return arr.includes(val);
					};
				}
				if (Array.prototype.indexOf) {
					return function(arr, val) {
						return arr.indexOf(val) >= 0;
					};
				}
				return function(arr, val) {
					for (var i = 0; i < arr.length; i++) {
						if (arr[i] === val) {
							return true;
						}
					}
					return false;
				};
			});
	
			function sanitizeElements(elements) {
				/* Unwrap jQuery/Zepto objects. */
				if (Type.isWrapped(elements)) {
					elements = _slice.call(elements);
					/* Wrap a single element in an array so that $.each() can iterate with the element instead of its node's children. */
				} else if (Type.isNode(elements)) {
					elements = [elements];
				}
	
				return elements;
			}
	
			var Type = {
				isNumber: function(variable) {
					return (typeof variable === "number");
				},
				isString: function(variable) {
					return (typeof variable === "string");
				},
				isArray: Array.isArray || function(variable) {
					return Object.prototype.toString.call(variable) === "[object Array]";
				},
				isFunction: function(variable) {
					return Object.prototype.toString.call(variable) === "[object Function]";
				},
				isNode: function(variable) {
					return variable && variable.nodeType;
				},
				/* Determine if variable is an array-like wrapped jQuery, Zepto or similar element, or even a NodeList etc. */
				/* NOTE: HTMLFormElements also have a length. */
				isWrapped: function(variable) {
					return variable
							&& variable !== window
							&& Type.isNumber(variable.length)
							&& !Type.isString(variable)
							&& !Type.isFunction(variable)
							&& !Type.isNode(variable)
							&& (variable.length === 0 || Type.isNode(variable[0]));
				},
				isSVG: function(variable) {
					return window.SVGElement && (variable instanceof window.SVGElement);
				},
				isEmptyObject: function(variable) {
					for (var name in variable) {
						if (variable.hasOwnProperty(name)) {
							return false;
						}
					}
	
					return true;
				}
			};
	
			/*****************
			 Dependencies
			 *****************/
	
			var $,
					isJQuery = false;
	
			if (global.fn && global.fn.jquery) {
				$ = global;
				isJQuery = true;
			} else {
				$ = window.Velocity.Utilities;
			}
	
			if (IE <= 8 && !isJQuery) {
				throw new Error("Velocity: IE8 and below require jQuery to be loaded before Velocity.");
			} else if (IE <= 7) {
				/* Revert to jQuery's $.animate(), and lose Velocity's extra features. */
				jQuery.fn.velocity = jQuery.fn.animate;
	
				/* Now that $.fn.velocity is aliased, abort this Velocity declaration. */
				return;
			}
	
			/*****************
			 Constants
			 *****************/
	
			var DURATION_DEFAULT = 400,
					EASING_DEFAULT = "swing";
	
			/*************
			 State
			 *************/
	
			var Velocity = {
				/* Container for page-wide Velocity state data. */
				State: {
					/* Detect mobile devices to determine if mobileHA should be turned on. */
					isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent),
					/* The mobileHA option's behavior changes on older Android devices (Gingerbread, versions 2.3.3-2.3.7). */
					isAndroid: /Android/i.test(window.navigator.userAgent),
					isGingerbread: /Android 2\.3\.[3-7]/i.test(window.navigator.userAgent),
					isChrome: window.chrome,
					isFirefox: /Firefox/i.test(window.navigator.userAgent),
					/* Create a cached element for re-use when checking for CSS property prefixes. */
					prefixElement: document.createElement("div"),
					/* Cache every prefix match to avoid repeating lookups. */
					prefixMatches: {},
					/* Cache the anchor used for animating window scrolling. */
					scrollAnchor: null,
					/* Cache the browser-specific property names associated with the scroll anchor. */
					scrollPropertyLeft: null,
					scrollPropertyTop: null,
					/* Keep track of whether our RAF tick is running. */
					isTicking: false,
					/* Container for every in-progress call to Velocity. */
					calls: [],
					delayedElements: {
						count: 0
					}
				},
				/* Velocity's custom CSS stack. Made global for unit testing. */
				CSS: {/* Defined below. */},
				/* A shim of the jQuery utility functions used by Velocity -- provided by Velocity's optional jQuery shim. */
				Utilities: $,
				/* Container for the user's custom animation redirects that are referenced by name in place of the properties map argument. */
				Redirects: {/* Manually registered by the user. */},
				Easings: {/* Defined below. */},
				/* Attempt to use ES6 Promises by default. Users can override this with a third-party promises library. */
				Promise: window.Promise,
				/* Velocity option defaults, which can be overriden by the user. */
				defaults: {
					queue: "",
					duration: DURATION_DEFAULT,
					easing: EASING_DEFAULT,
					begin: undefined,
					complete: undefined,
					progress: undefined,
					display: undefined,
					visibility: undefined,
					loop: false,
					delay: false,
					mobileHA: true,
					/* Advanced: Set to false to prevent property values from being cached between consecutive Velocity-initiated chain calls. */
					_cacheValues: true,
					/* Advanced: Set to false if the promise should always resolve on empty element lists. */
					promiseRejectEmpty: true
				},
				/* A design goal of Velocity is to cache data wherever possible in order to avoid DOM requerying. Accordingly, each element has a data cache. */
				init: function(element) {
					$.data(element, "velocity", {
						/* Store whether this is an SVG element, since its properties are retrieved and updated differently than standard HTML elements. */
						isSVG: Type.isSVG(element),
						/* Keep track of whether the element is currently being animated by Velocity.
						 This is used to ensure that property values are not transferred between non-consecutive (stale) calls. */
						isAnimating: false,
						/* A reference to the element's live computedStyle object. Learn more here: https://developer.mozilla.org/en/docs/Web/API/window.getComputedStyle */
						computedStyle: null,
						/* Tween data is cached for each animation on the element so that data can be passed across calls --
						 in particular, end values are used as subsequent start values in consecutive Velocity calls. */
						tweensContainer: null,
						/* The full root property values of each CSS hook being animated on this element are cached so that:
						 1) Concurrently-animating hooks sharing the same root can have their root values' merged into one while tweening.
						 2) Post-hook-injection root values can be transferred over to consecutively chained Velocity calls as starting root values. */
						rootPropertyValueCache: {},
						/* A cache for transform updates, which must be manually flushed via CSS.flushTransformCache(). */
						transformCache: {}
					});
				},
				/* A parallel to jQuery's $.css(), used for getting/setting Velocity's hooked CSS properties. */
				hook: null, /* Defined below. */
				/* Velocity-wide animation time remapping for testing purposes. */
				mock: false,
				version: {major: 1, minor: 5, patch: 1},
				/* Set to 1 or 2 (most verbose) to output debug info to console. */
				debug: false,
				/* Use rAF high resolution timestamp when available */
				timestamp: true,
				/* Pause all animations */
				pauseAll: function(queueName) {
					var currentTime = (new Date()).getTime();
	
					$.each(Velocity.State.calls, function(i, activeCall) {
	
						if (activeCall) {
	
							/* If we have a queueName and this call is not on that queue, skip */
							if (queueName !== undefined && ((activeCall[2].queue !== queueName) || (activeCall[2].queue === false))) {
								return true;
							}
	
							/* Set call to paused */
							activeCall[5] = {
								resume: false
							};
						}
					});
	
					/* Pause timers on any currently delayed calls */
					$.each(Velocity.State.delayedElements, function(k, element) {
						if (!element) {
							return;
						}
						pauseDelayOnElement(element, currentTime);
					});
				},
				/* Resume all animations */
				resumeAll: function(queueName) {
					var currentTime = (new Date()).getTime();
	
					$.each(Velocity.State.calls, function(i, activeCall) {
	
						if (activeCall) {
	
							/* If we have a queueName and this call is not on that queue, skip */
							if (queueName !== undefined && ((activeCall[2].queue !== queueName) || (activeCall[2].queue === false))) {
								return true;
							}
	
							/* Set call to resumed if it was paused */
							if (activeCall[5]) {
								activeCall[5].resume = true;
							}
						}
					});
					/* Resume timers on any currently delayed calls */
					$.each(Velocity.State.delayedElements, function(k, element) {
						if (!element) {
							return;
						}
						resumeDelayOnElement(element, currentTime);
					});
				}
			};
	
			/* Retrieve the appropriate scroll anchor and property name for the browser: https://developer.mozilla.org/en-US/docs/Web/API/Window.scrollY */
			if (window.pageYOffset !== undefined) {
				Velocity.State.scrollAnchor = window;
				Velocity.State.scrollPropertyLeft = "pageXOffset";
				Velocity.State.scrollPropertyTop = "pageYOffset";
			} else {
				Velocity.State.scrollAnchor = document.documentElement || document.body.parentNode || document.body;
				Velocity.State.scrollPropertyLeft = "scrollLeft";
				Velocity.State.scrollPropertyTop = "scrollTop";
			}
	
			/* Shorthand alias for jQuery's $.data() utility. */
			function Data(element) {
				/* Hardcode a reference to the plugin name. */
				var response = $.data(element, "velocity");
	
				/* jQuery <=1.4.2 returns null instead of undefined when no match is found. We normalize this behavior. */
				return response === null ? undefined : response;
			}
	
			/**************
			 Delay Timer
			 **************/
	
			function pauseDelayOnElement(element, currentTime) {
				/* Check for any delay timers, and pause the set timeouts (while preserving time data)
				 to be resumed when the "resume" command is issued */
				var data = Data(element);
				if (data && data.delayTimer && !data.delayPaused) {
					data.delayRemaining = data.delay - currentTime + data.delayBegin;
					data.delayPaused = true;
					clearTimeout(data.delayTimer.setTimeout);
				}
			}
	
			function resumeDelayOnElement(element, currentTime) {
				/* Check for any paused timers and resume */
				var data = Data(element);
				if (data && data.delayTimer && data.delayPaused) {
					/* If the element was mid-delay, re initiate the timeout with the remaining delay */
					data.delayPaused = false;
					data.delayTimer.setTimeout = setTimeout(data.delayTimer.next, data.delayRemaining);
				}
			}
	
	
	
			/**************
			 Easing
			 **************/
	
			/* Step easing generator. */
			function generateStep(steps) {
				return function(p) {
					return Math.round(p * steps) * (1 / steps);
				};
			}
	
			/* Bezier curve function generator. Copyright Gaetan Renaudeau. MIT License: http://en.wikipedia.org/wiki/MIT_License */
			function generateBezier(mX1, mY1, mX2, mY2) {
				var NEWTON_ITERATIONS = 4,
						NEWTON_MIN_SLOPE = 0.001,
						SUBDIVISION_PRECISION = 0.0000001,
						SUBDIVISION_MAX_ITERATIONS = 10,
						kSplineTableSize = 11,
						kSampleStepSize = 1.0 / (kSplineTableSize - 1.0),
						float32ArraySupported = "Float32Array" in window;
	
				/* Must contain four arguments. */
				if (arguments.length !== 4) {
					return false;
				}
	
				/* Arguments must be numbers. */
				for (var i = 0; i < 4; ++i) {
					if (typeof arguments[i] !== "number" || isNaN(arguments[i]) || !isFinite(arguments[i])) {
						return false;
					}
				}
	
				/* X values must be in the [0, 1] range. */
				mX1 = Math.min(mX1, 1);
				mX2 = Math.min(mX2, 1);
				mX1 = Math.max(mX1, 0);
				mX2 = Math.max(mX2, 0);
	
				var mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
	
				function A(aA1, aA2) {
					return 1.0 - 3.0 * aA2 + 3.0 * aA1;
				}
				function B(aA1, aA2) {
					return 3.0 * aA2 - 6.0 * aA1;
				}
				function C(aA1) {
					return 3.0 * aA1;
				}
	
				function calcBezier(aT, aA1, aA2) {
					return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
				}
	
				function getSlope(aT, aA1, aA2) {
					return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
				}
	
				function newtonRaphsonIterate(aX, aGuessT) {
					for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
						var currentSlope = getSlope(aGuessT, mX1, mX2);
	
						if (currentSlope === 0.0) {
							return aGuessT;
						}
	
						var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
						aGuessT -= currentX / currentSlope;
					}
	
					return aGuessT;
				}
	
				function calcSampleValues() {
					for (var i = 0; i < kSplineTableSize; ++i) {
						mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
					}
				}
	
				function binarySubdivide(aX, aA, aB) {
					var currentX, currentT, i = 0;
	
					do {
						currentT = aA + (aB - aA) / 2.0;
						currentX = calcBezier(currentT, mX1, mX2) - aX;
						if (currentX > 0.0) {
							aB = currentT;
						} else {
							aA = currentT;
						}
					} while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
	
					return currentT;
				}
	
				function getTForX(aX) {
					var intervalStart = 0.0,
							currentSample = 1,
							lastSample = kSplineTableSize - 1;
	
					for (; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample) {
						intervalStart += kSampleStepSize;
					}
	
					--currentSample;
	
					var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]),
							guessForT = intervalStart + dist * kSampleStepSize,
							initialSlope = getSlope(guessForT, mX1, mX2);
	
					if (initialSlope >= NEWTON_MIN_SLOPE) {
						return newtonRaphsonIterate(aX, guessForT);
					} else if (initialSlope === 0.0) {
						return guessForT;
					} else {
						return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize);
					}
				}
	
				var _precomputed = false;
	
				function precompute() {
					_precomputed = true;
					if (mX1 !== mY1 || mX2 !== mY2) {
						calcSampleValues();
					}
				}
	
				var f = function(aX) {
					if (!_precomputed) {
						precompute();
					}
					if (mX1 === mY1 && mX2 === mY2) {
						return aX;
					}
					if (aX === 0) {
						return 0;
					}
					if (aX === 1) {
						return 1;
					}
	
					return calcBezier(getTForX(aX), mY1, mY2);
				};
	
				f.getControlPoints = function() {
					return [{x: mX1, y: mY1}, {x: mX2, y: mY2}];
				};
	
				var str = "generateBezier(" + [mX1, mY1, mX2, mY2] + ")";
				f.toString = function() {
					return str;
				};
	
				return f;
			}
	
			/* Runge-Kutta spring physics function generator. Adapted from Framer.js, copyright Koen Bok. MIT License: http://en.wikipedia.org/wiki/MIT_License */
			/* Given a tension, friction, and duration, a simulation at 60FPS will first run without a defined duration in order to calculate the full path. A second pass
			 then adjusts the time delta -- using the relation between actual time and duration -- to calculate the path for the duration-constrained animation. */
			var generateSpringRK4 = (function() {
				function springAccelerationForState(state) {
					return (-state.tension * state.x) - (state.friction * state.v);
				}
	
				function springEvaluateStateWithDerivative(initialState, dt, derivative) {
					var state = {
						x: initialState.x + derivative.dx * dt,
						v: initialState.v + derivative.dv * dt,
						tension: initialState.tension,
						friction: initialState.friction
					};
	
					return {dx: state.v, dv: springAccelerationForState(state)};
				}
	
				function springIntegrateState(state, dt) {
					var a = {
						dx: state.v,
						dv: springAccelerationForState(state)
					},
							b = springEvaluateStateWithDerivative(state, dt * 0.5, a),
							c = springEvaluateStateWithDerivative(state, dt * 0.5, b),
							d = springEvaluateStateWithDerivative(state, dt, c),
							dxdt = 1.0 / 6.0 * (a.dx + 2.0 * (b.dx + c.dx) + d.dx),
							dvdt = 1.0 / 6.0 * (a.dv + 2.0 * (b.dv + c.dv) + d.dv);
	
					state.x = state.x + dxdt * dt;
					state.v = state.v + dvdt * dt;
	
					return state;
				}
	
				return function springRK4Factory(tension, friction, duration) {
	
					var initState = {
						x: -1,
						v: 0,
						tension: null,
						friction: null
					},
							path = [0],
							time_lapsed = 0,
							tolerance = 1 / 10000,
							DT = 16 / 1000,
							have_duration, dt, last_state;
	
					tension = parseFloat(tension) || 500;
					friction = parseFloat(friction) || 20;
					duration = duration || null;
	
					initState.tension = tension;
					initState.friction = friction;
	
					have_duration = duration !== null;
	
					/* Calculate the actual time it takes for this animation to complete with the provided conditions. */
					if (have_duration) {
						/* Run the simulation without a duration. */
						time_lapsed = springRK4Factory(tension, friction);
						/* Compute the adjusted time delta. */
						dt = time_lapsed / duration * DT;
					} else {
						dt = DT;
					}
	
					while (true) {
						/* Next/step function .*/
						last_state = springIntegrateState(last_state || initState, dt);
						/* Store the position. */
						path.push(1 + last_state.x);
						time_lapsed += 16;
						/* If the change threshold is reached, break. */
						if (!(Math.abs(last_state.x) > tolerance && Math.abs(last_state.v) > tolerance)) {
							break;
						}
					}
	
					/* If duration is not defined, return the actual time required for completing this animation. Otherwise, return a closure that holds the
					 computed path and returns a snapshot of the position according to a given percentComplete. */
					return !have_duration ? time_lapsed : function(percentComplete) {
						return path[ (percentComplete * (path.length - 1)) | 0 ];
					};
				};
			}());
	
			/* jQuery easings. */
			Velocity.Easings = {
				linear: function(p) {
					return p;
				},
				swing: function(p) {
					return 0.5 - Math.cos(p * Math.PI) / 2;
				},
				/* Bonus "spring" easing, which is a less exaggerated version of easeInOutElastic. */
				spring: function(p) {
					return 1 - (Math.cos(p * 4.5 * Math.PI) * Math.exp(-p * 6));
				}
			};
	
			/* CSS3 and Robert Penner easings. */
			$.each(
					[
						["ease", [0.25, 0.1, 0.25, 1.0]],
						["ease-in", [0.42, 0.0, 1.00, 1.0]],
						["ease-out", [0.00, 0.0, 0.58, 1.0]],
						["ease-in-out", [0.42, 0.0, 0.58, 1.0]],
						["easeInSine", [0.47, 0, 0.745, 0.715]],
						["easeOutSine", [0.39, 0.575, 0.565, 1]],
						["easeInOutSine", [0.445, 0.05, 0.55, 0.95]],
						["easeInQuad", [0.55, 0.085, 0.68, 0.53]],
						["easeOutQuad", [0.25, 0.46, 0.45, 0.94]],
						["easeInOutQuad", [0.455, 0.03, 0.515, 0.955]],
						["easeInCubic", [0.55, 0.055, 0.675, 0.19]],
						["easeOutCubic", [0.215, 0.61, 0.355, 1]],
						["easeInOutCubic", [0.645, 0.045, 0.355, 1]],
						["easeInQuart", [0.895, 0.03, 0.685, 0.22]],
						["easeOutQuart", [0.165, 0.84, 0.44, 1]],
						["easeInOutQuart", [0.77, 0, 0.175, 1]],
						["easeInQuint", [0.755, 0.05, 0.855, 0.06]],
						["easeOutQuint", [0.23, 1, 0.32, 1]],
						["easeInOutQuint", [0.86, 0, 0.07, 1]],
						["easeInExpo", [0.95, 0.05, 0.795, 0.035]],
						["easeOutExpo", [0.19, 1, 0.22, 1]],
						["easeInOutExpo", [1, 0, 0, 1]],
						["easeInCirc", [0.6, 0.04, 0.98, 0.335]],
						["easeOutCirc", [0.075, 0.82, 0.165, 1]],
						["easeInOutCirc", [0.785, 0.135, 0.15, 0.86]]
					], function(i, easingArray) {
				Velocity.Easings[easingArray[0]] = generateBezier.apply(null, easingArray[1]);
			});
	
			/* Determine the appropriate easing type given an easing input. */
			function getEasing(value, duration) {
				var easing = value;
	
				/* The easing option can either be a string that references a pre-registered easing,
				 or it can be a two-/four-item array of integers to be converted into a bezier/spring function. */
				if (Type.isString(value)) {
					/* Ensure that the easing has been assigned to jQuery's Velocity.Easings object. */
					if (!Velocity.Easings[value]) {
						easing = false;
					}
				} else if (Type.isArray(value) && value.length === 1) {
					easing = generateStep.apply(null, value);
				} else if (Type.isArray(value) && value.length === 2) {
					/* springRK4 must be passed the animation's duration. */
					/* Note: If the springRK4 array contains non-numbers, generateSpringRK4() returns an easing
					 function generated with default tension and friction values. */
					easing = generateSpringRK4.apply(null, value.concat([duration]));
				} else if (Type.isArray(value) && value.length === 4) {
					/* Note: If the bezier array contains non-numbers, generateBezier() returns false. */
					easing = generateBezier.apply(null, value);
				} else {
					easing = false;
				}
	
				/* Revert to the Velocity-wide default easing type, or fall back to "swing" (which is also jQuery's default)
				 if the Velocity-wide default has been incorrectly modified. */
				if (easing === false) {
					if (Velocity.Easings[Velocity.defaults.easing]) {
						easing = Velocity.defaults.easing;
					} else {
						easing = EASING_DEFAULT;
					}
				}
	
				return easing;
			}
	
			/*****************
			 CSS Stack
			 *****************/
	
			/* The CSS object is a highly condensed and performant CSS stack that fully replaces jQuery's.
			 It handles the validation, getting, and setting of both standard CSS properties and CSS property hooks. */
			/* Note: A "CSS" shorthand is aliased so that our code is easier to read. */
			var CSS = Velocity.CSS = {
				/*************
				 RegEx
				 *************/
	
				RegEx: {
					isHex: /^#([A-f\d]{3}){1,2}$/i,
					/* Unwrap a property value's surrounding text, e.g. "rgba(4, 3, 2, 1)" ==> "4, 3, 2, 1" and "rect(4px 3px 2px 1px)" ==> "4px 3px 2px 1px". */
					valueUnwrap: /^[A-z]+\((.*)\)$/i,
					wrappedValueAlreadyExtracted: /[0-9.]+ [0-9.]+ [0-9.]+( [0-9.]+)?/,
					/* Split a multi-value property into an array of subvalues, e.g. "rgba(4, 3, 2, 1) 4px 3px 2px 1px" ==> [ "rgba(4, 3, 2, 1)", "4px", "3px", "2px", "1px" ]. */
					valueSplit: /([A-z]+\(.+\))|(([A-z0-9#-.]+?)(?=\s|$))/ig
				},
				/************
				 Lists
				 ************/
	
				Lists: {
					colors: ["fill", "stroke", "stopColor", "color", "backgroundColor", "borderColor", "borderTopColor", "borderRightColor", "borderBottomColor", "borderLeftColor", "outlineColor"],
					transformsBase: ["translateX", "translateY", "scale", "scaleX", "scaleY", "skewX", "skewY", "rotateZ"],
					transforms3D: ["transformPerspective", "translateZ", "scaleZ", "rotateX", "rotateY"],
					units: [
						"%", // relative
						"em", "ex", "ch", "rem", // font relative
						"vw", "vh", "vmin", "vmax", // viewport relative
						"cm", "mm", "Q", "in", "pc", "pt", "px", // absolute lengths
						"deg", "grad", "rad", "turn", // angles
						"s", "ms" // time
					],
					colorNames: {
						"aliceblue": "240,248,255",
						"antiquewhite": "250,235,215",
						"aquamarine": "127,255,212",
						"aqua": "0,255,255",
						"azure": "240,255,255",
						"beige": "245,245,220",
						"bisque": "255,228,196",
						"black": "0,0,0",
						"blanchedalmond": "255,235,205",
						"blueviolet": "138,43,226",
						"blue": "0,0,255",
						"brown": "165,42,42",
						"burlywood": "222,184,135",
						"cadetblue": "95,158,160",
						"chartreuse": "127,255,0",
						"chocolate": "210,105,30",
						"coral": "255,127,80",
						"cornflowerblue": "100,149,237",
						"cornsilk": "255,248,220",
						"crimson": "220,20,60",
						"cyan": "0,255,255",
						"darkblue": "0,0,139",
						"darkcyan": "0,139,139",
						"darkgoldenrod": "184,134,11",
						"darkgray": "169,169,169",
						"darkgrey": "169,169,169",
						"darkgreen": "0,100,0",
						"darkkhaki": "189,183,107",
						"darkmagenta": "139,0,139",
						"darkolivegreen": "85,107,47",
						"darkorange": "255,140,0",
						"darkorchid": "153,50,204",
						"darkred": "139,0,0",
						"darksalmon": "233,150,122",
						"darkseagreen": "143,188,143",
						"darkslateblue": "72,61,139",
						"darkslategray": "47,79,79",
						"darkturquoise": "0,206,209",
						"darkviolet": "148,0,211",
						"deeppink": "255,20,147",
						"deepskyblue": "0,191,255",
						"dimgray": "105,105,105",
						"dimgrey": "105,105,105",
						"dodgerblue": "30,144,255",
						"firebrick": "178,34,34",
						"floralwhite": "255,250,240",
						"forestgreen": "34,139,34",
						"fuchsia": "255,0,255",
						"gainsboro": "220,220,220",
						"ghostwhite": "248,248,255",
						"gold": "255,215,0",
						"goldenrod": "218,165,32",
						"gray": "128,128,128",
						"grey": "128,128,128",
						"greenyellow": "173,255,47",
						"green": "0,128,0",
						"honeydew": "240,255,240",
						"hotpink": "255,105,180",
						"indianred": "205,92,92",
						"indigo": "75,0,130",
						"ivory": "255,255,240",
						"khaki": "240,230,140",
						"lavenderblush": "255,240,245",
						"lavender": "230,230,250",
						"lawngreen": "124,252,0",
						"lemonchiffon": "255,250,205",
						"lightblue": "173,216,230",
						"lightcoral": "240,128,128",
						"lightcyan": "224,255,255",
						"lightgoldenrodyellow": "250,250,210",
						"lightgray": "211,211,211",
						"lightgrey": "211,211,211",
						"lightgreen": "144,238,144",
						"lightpink": "255,182,193",
						"lightsalmon": "255,160,122",
						"lightseagreen": "32,178,170",
						"lightskyblue": "135,206,250",
						"lightslategray": "119,136,153",
						"lightsteelblue": "176,196,222",
						"lightyellow": "255,255,224",
						"limegreen": "50,205,50",
						"lime": "0,255,0",
						"linen": "250,240,230",
						"magenta": "255,0,255",
						"maroon": "128,0,0",
						"mediumaquamarine": "102,205,170",
						"mediumblue": "0,0,205",
						"mediumorchid": "186,85,211",
						"mediumpurple": "147,112,219",
						"mediumseagreen": "60,179,113",
						"mediumslateblue": "123,104,238",
						"mediumspringgreen": "0,250,154",
						"mediumturquoise": "72,209,204",
						"mediumvioletred": "199,21,133",
						"midnightblue": "25,25,112",
						"mintcream": "245,255,250",
						"mistyrose": "255,228,225",
						"moccasin": "255,228,181",
						"navajowhite": "255,222,173",
						"navy": "0,0,128",
						"oldlace": "253,245,230",
						"olivedrab": "107,142,35",
						"olive": "128,128,0",
						"orangered": "255,69,0",
						"orange": "255,165,0",
						"orchid": "218,112,214",
						"palegoldenrod": "238,232,170",
						"palegreen": "152,251,152",
						"paleturquoise": "175,238,238",
						"palevioletred": "219,112,147",
						"papayawhip": "255,239,213",
						"peachpuff": "255,218,185",
						"peru": "205,133,63",
						"pink": "255,192,203",
						"plum": "221,160,221",
						"powderblue": "176,224,230",
						"purple": "128,0,128",
						"red": "255,0,0",
						"rosybrown": "188,143,143",
						"royalblue": "65,105,225",
						"saddlebrown": "139,69,19",
						"salmon": "250,128,114",
						"sandybrown": "244,164,96",
						"seagreen": "46,139,87",
						"seashell": "255,245,238",
						"sienna": "160,82,45",
						"silver": "192,192,192",
						"skyblue": "135,206,235",
						"slateblue": "106,90,205",
						"slategray": "112,128,144",
						"snow": "255,250,250",
						"springgreen": "0,255,127",
						"steelblue": "70,130,180",
						"tan": "210,180,140",
						"teal": "0,128,128",
						"thistle": "216,191,216",
						"tomato": "255,99,71",
						"turquoise": "64,224,208",
						"violet": "238,130,238",
						"wheat": "245,222,179",
						"whitesmoke": "245,245,245",
						"white": "255,255,255",
						"yellowgreen": "154,205,50",
						"yellow": "255,255,0"
					}
				},
				/************
				 Hooks
				 ************/
	
				/* Hooks allow a subproperty (e.g. "boxShadowBlur") of a compound-value CSS property
				 (e.g. "boxShadow: X Y Blur Spread Color") to be animated as if it were a discrete property. */
				/* Note: Beyond enabling fine-grained property animation, hooking is necessary since Velocity only
				 tweens properties with single numeric values; unlike CSS transitions, Velocity does not interpolate compound-values. */
				Hooks: {
					/********************
					 Registration
					 ********************/
	
					/* Templates are a concise way of indicating which subproperties must be individually registered for each compound-value CSS property. */
					/* Each template consists of the compound-value's base name, its constituent subproperty names, and those subproperties' default values. */
					templates: {
						"textShadow": ["Color X Y Blur", "black 0px 0px 0px"],
						"boxShadow": ["Color X Y Blur Spread", "black 0px 0px 0px 0px"],
						"clip": ["Top Right Bottom Left", "0px 0px 0px 0px"],
						"backgroundPosition": ["X Y", "0% 0%"],
						"transformOrigin": ["X Y Z", "50% 50% 0px"],
						"perspectiveOrigin": ["X Y", "50% 50%"]
					},
					/* A "registered" hook is one that has been converted from its template form into a live,
					 tweenable property. It contains data to associate it with its root property. */
					registered: {
						/* Note: A registered hook looks like this ==> textShadowBlur: [ "textShadow", 3 ],
						 which consists of the subproperty's name, the associated root property's name,
						 and the subproperty's position in the root's value. */
					},
					/* Convert the templates into individual hooks then append them to the registered object above. */
					register: function() {
						/* Color hooks registration: Colors are defaulted to white -- as opposed to black -- since colors that are
						 currently set to "transparent" default to their respective template below when color-animated,
						 and white is typically a closer match to transparent than black is. An exception is made for text ("color"),
						 which is almost always set closer to black than white. */
						for (var i = 0; i < CSS.Lists.colors.length; i++) {
							var rgbComponents = (CSS.Lists.colors[i] === "color") ? "0 0 0 1" : "255 255 255 1";
							CSS.Hooks.templates[CSS.Lists.colors[i]] = ["Red Green Blue Alpha", rgbComponents];
						}
	
						var rootProperty,
								hookTemplate,
								hookNames;
	
						/* In IE, color values inside compound-value properties are positioned at the end the value instead of at the beginning.
						 Thus, we re-arrange the templates accordingly. */
						if (IE) {
							for (rootProperty in CSS.Hooks.templates) {
								if (!CSS.Hooks.templates.hasOwnProperty(rootProperty)) {
									continue;
								}
								hookTemplate = CSS.Hooks.templates[rootProperty];
								hookNames = hookTemplate[0].split(" ");
	
								var defaultValues = hookTemplate[1].match(CSS.RegEx.valueSplit);
	
								if (hookNames[0] === "Color") {
									/* Reposition both the hook's name and its default value to the end of their respective strings. */
									hookNames.push(hookNames.shift());
									defaultValues.push(defaultValues.shift());
	
									/* Replace the existing template for the hook's root property. */
									CSS.Hooks.templates[rootProperty] = [hookNames.join(" "), defaultValues.join(" ")];
								}
							}
						}
	
						/* Hook registration. */
						for (rootProperty in CSS.Hooks.templates) {
							if (!CSS.Hooks.templates.hasOwnProperty(rootProperty)) {
								continue;
							}
							hookTemplate = CSS.Hooks.templates[rootProperty];
							hookNames = hookTemplate[0].split(" ");
	
							for (var j in hookNames) {
								if (!hookNames.hasOwnProperty(j)) {
									continue;
								}
								var fullHookName = rootProperty + hookNames[j],
										hookPosition = j;
	
								/* For each hook, register its full name (e.g. textShadowBlur) with its root property (e.g. textShadow)
								 and the hook's position in its template's default value string. */
								CSS.Hooks.registered[fullHookName] = [rootProperty, hookPosition];
							}
						}
					},
					/*****************************
					 Injection and Extraction
					 *****************************/
	
					/* Look up the root property associated with the hook (e.g. return "textShadow" for "textShadowBlur"). */
					/* Since a hook cannot be set directly (the browser won't recognize it), style updating for hooks is routed through the hook's root property. */
					getRoot: function(property) {
						var hookData = CSS.Hooks.registered[property];
	
						if (hookData) {
							return hookData[0];
						} else {
							/* If there was no hook match, return the property name untouched. */
							return property;
						}
					},
					getUnit: function(str, start) {
						var unit = (str.substr(start || 0, 5).match(/^[a-z%]+/) || [])[0] || "";
	
						if (unit && _inArray(CSS.Lists.units, unit)) {
							return unit;
						}
						return "";
					},
					fixColors: function(str) {
						return str.replace(/(rgba?\(\s*)?(\b[a-z]+\b)/g, function($0, $1, $2) {
							if (CSS.Lists.colorNames.hasOwnProperty($2)) {
								return ($1 ? $1 : "rgba(") + CSS.Lists.colorNames[$2] + ($1 ? "" : ",1)");
							}
							return $1 + $2;
						});
					},
					/* Convert any rootPropertyValue, null or otherwise, into a space-delimited list of hook values so that
					 the targeted hook can be injected or extracted at its standard position. */
					cleanRootPropertyValue: function(rootProperty, rootPropertyValue) {
						/* If the rootPropertyValue is wrapped with "rgb()", "clip()", etc., remove the wrapping to normalize the value before manipulation. */
						if (CSS.RegEx.valueUnwrap.test(rootPropertyValue)) {
							rootPropertyValue = rootPropertyValue.match(CSS.RegEx.valueUnwrap)[1];
						}
	
						/* If rootPropertyValue is a CSS null-value (from which there's inherently no hook value to extract),
						 default to the root's default value as defined in CSS.Hooks.templates. */
						/* Note: CSS null-values include "none", "auto", and "transparent". They must be converted into their
						 zero-values (e.g. textShadow: "none" ==> textShadow: "0px 0px 0px black") for hook manipulation to proceed. */
						if (CSS.Values.isCSSNullValue(rootPropertyValue)) {
							rootPropertyValue = CSS.Hooks.templates[rootProperty][1];
						}
	
						return rootPropertyValue;
					},
					/* Extracted the hook's value from its root property's value. This is used to get the starting value of an animating hook. */
					extractValue: function(fullHookName, rootPropertyValue) {
						var hookData = CSS.Hooks.registered[fullHookName];
	
						if (hookData) {
							var hookRoot = hookData[0],
									hookPosition = hookData[1];
	
							rootPropertyValue = CSS.Hooks.cleanRootPropertyValue(hookRoot, rootPropertyValue);
	
							/* Split rootPropertyValue into its constituent hook values then grab the desired hook at its standard position. */
							return rootPropertyValue.toString().match(CSS.RegEx.valueSplit)[hookPosition];
						} else {
							/* If the provided fullHookName isn't a registered hook, return the rootPropertyValue that was passed in. */
							return rootPropertyValue;
						}
					},
					/* Inject the hook's value into its root property's value. This is used to piece back together the root property
					 once Velocity has updated one of its individually hooked values through tweening. */
					injectValue: function(fullHookName, hookValue, rootPropertyValue) {
						var hookData = CSS.Hooks.registered[fullHookName];
	
						if (hookData) {
							var hookRoot = hookData[0],
									hookPosition = hookData[1],
									rootPropertyValueParts,
									rootPropertyValueUpdated;
	
							rootPropertyValue = CSS.Hooks.cleanRootPropertyValue(hookRoot, rootPropertyValue);
	
							/* Split rootPropertyValue into its individual hook values, replace the targeted value with hookValue,
							 then reconstruct the rootPropertyValue string. */
							rootPropertyValueParts = rootPropertyValue.toString().match(CSS.RegEx.valueSplit);
							rootPropertyValueParts[hookPosition] = hookValue;
							rootPropertyValueUpdated = rootPropertyValueParts.join(" ");
	
							return rootPropertyValueUpdated;
						} else {
							/* If the provided fullHookName isn't a registered hook, return the rootPropertyValue that was passed in. */
							return rootPropertyValue;
						}
					}
				},
				/*******************
				 Normalizations
				 *******************/
	
				/* Normalizations standardize CSS property manipulation by pollyfilling browser-specific implementations (e.g. opacity)
				 and reformatting special properties (e.g. clip, rgba) to look like standard ones. */
				Normalizations: {
					/* Normalizations are passed a normalization target (either the property's name, its extracted value, or its injected value),
					 the targeted element (which may need to be queried), and the targeted property value. */
					registered: {
						clip: function(type, element, propertyValue) {
							switch (type) {
								case "name":
									return "clip";
									/* Clip needs to be unwrapped and stripped of its commas during extraction. */
								case "extract":
									var extracted;
	
									/* If Velocity also extracted this value, skip extraction. */
									if (CSS.RegEx.wrappedValueAlreadyExtracted.test(propertyValue)) {
										extracted = propertyValue;
									} else {
										/* Remove the "rect()" wrapper. */
										extracted = propertyValue.toString().match(CSS.RegEx.valueUnwrap);
	
										/* Strip off commas. */
										extracted = extracted ? extracted[1].replace(/,(\s+)?/g, " ") : propertyValue;
									}
	
									return extracted;
									/* Clip needs to be re-wrapped during injection. */
								case "inject":
									return "rect(" + propertyValue + ")";
							}
						},
						blur: function(type, element, propertyValue) {
							switch (type) {
								case "name":
									return Velocity.State.isFirefox ? "filter" : "-webkit-filter";
								case "extract":
									var extracted = parseFloat(propertyValue);
	
									/* If extracted is NaN, meaning the value isn't already extracted. */
									if (!(extracted || extracted === 0)) {
										var blurComponent = propertyValue.toString().match(/blur\(([0-9]+[A-z]+)\)/i);
	
										/* If the filter string had a blur component, return just the blur value and unit type. */
										if (blurComponent) {
											extracted = blurComponent[1];
											/* If the component doesn't exist, default blur to 0. */
										} else {
											extracted = 0;
										}
									}
	
									return extracted;
									/* Blur needs to be re-wrapped during injection. */
								case "inject":
									/* For the blur effect to be fully de-applied, it needs to be set to "none" instead of 0. */
									if (!parseFloat(propertyValue)) {
										return "none";
									} else {
										return "blur(" + propertyValue + ")";
									}
							}
						},
						/* <=IE8 do not support the standard opacity property. They use filter:alpha(opacity=INT) instead. */
						opacity: function(type, element, propertyValue) {
							if (IE <= 8) {
								switch (type) {
									case "name":
										return "filter";
									case "extract":
										/* <=IE8 return a "filter" value of "alpha(opacity=\d{1,3})".
										 Extract the value and convert it to a decimal value to match the standard CSS opacity property's formatting. */
										var extracted = propertyValue.toString().match(/alpha\(opacity=(.*)\)/i);
	
										if (extracted) {
											/* Convert to decimal value. */
											propertyValue = extracted[1] / 100;
										} else {
											/* When extracting opacity, default to 1 since a null value means opacity hasn't been set. */
											propertyValue = 1;
										}
	
										return propertyValue;
									case "inject":
										/* Opacified elements are required to have their zoom property set to a non-zero value. */
										element.style.zoom = 1;
	
										/* Setting the filter property on elements with certain font property combinations can result in a
										 highly unappealing ultra-bolding effect. There's no way to remedy this throughout a tween, but dropping the
										 value altogether (when opacity hits 1) at leasts ensures that the glitch is gone post-tweening. */
										if (parseFloat(propertyValue) >= 1) {
											return "";
										} else {
											/* As per the filter property's spec, convert the decimal value to a whole number and wrap the value. */
											return "alpha(opacity=" + parseInt(parseFloat(propertyValue) * 100, 10) + ")";
										}
								}
								/* With all other browsers, normalization is not required; return the same values that were passed in. */
							} else {
								switch (type) {
									case "name":
										return "opacity";
									case "extract":
										return propertyValue;
									case "inject":
										return propertyValue;
								}
							}
						}
					},
					/*****************************
					 Batched Registrations
					 *****************************/
	
					/* Note: Batched normalizations extend the CSS.Normalizations.registered object. */
					register: function() {
	
						/*****************
						 Transforms
						 *****************/
	
						/* Transforms are the subproperties contained by the CSS "transform" property. Transforms must undergo normalization
						 so that they can be referenced in a properties map by their individual names. */
						/* Note: When transforms are "set", they are actually assigned to a per-element transformCache. When all transform
						 setting is complete complete, CSS.flushTransformCache() must be manually called to flush the values to the DOM.
						 Transform setting is batched in this way to improve performance: the transform style only needs to be updated
						 once when multiple transform subproperties are being animated simultaneously. */
						/* Note: IE9 and Android Gingerbread have support for 2D -- but not 3D -- transforms. Since animating unsupported
						 transform properties results in the browser ignoring the *entire* transform string, we prevent these 3D values
						 from being normalized for these browsers so that tweening skips these properties altogether
						 (since it will ignore them as being unsupported by the browser.) */
						if ((!IE || IE > 9) && !Velocity.State.isGingerbread) {
							/* Note: Since the standalone CSS "perspective" property and the CSS transform "perspective" subproperty
							 share the same name, the latter is given a unique token within Velocity: "transformPerspective". */
							CSS.Lists.transformsBase = CSS.Lists.transformsBase.concat(CSS.Lists.transforms3D);
						}
	
						for (var i = 0; i < CSS.Lists.transformsBase.length; i++) {
							/* Wrap the dynamically generated normalization function in a new scope so that transformName's value is
							 paired with its respective function. (Otherwise, all functions would take the final for loop's transformName.) */
							(function() {
								var transformName = CSS.Lists.transformsBase[i];
	
								CSS.Normalizations.registered[transformName] = function(type, element, propertyValue) {
									switch (type) {
										/* The normalized property name is the parent "transform" property -- the property that is actually set in CSS. */
										case "name":
											return "transform";
											/* Transform values are cached onto a per-element transformCache object. */
										case "extract":
											/* If this transform has yet to be assigned a value, return its null value. */
											if (Data(element) === undefined || Data(element).transformCache[transformName] === undefined) {
												/* Scale CSS.Lists.transformsBase default to 1 whereas all other transform properties default to 0. */
												return /^scale/i.test(transformName) ? 1 : 0;
												/* When transform values are set, they are wrapped in parentheses as per the CSS spec.
												 Thus, when extracting their values (for tween calculations), we strip off the parentheses. */
											}
											return Data(element).transformCache[transformName].replace(/[()]/g, "");
										case "inject":
											var invalid = false;
	
											/* If an individual transform property contains an unsupported unit type, the browser ignores the *entire* transform property.
											 Thus, protect users from themselves by skipping setting for transform values supplied with invalid unit types. */
											/* Switch on the base transform type; ignore the axis by removing the last letter from the transform's name. */
											switch (transformName.substr(0, transformName.length - 1)) {
												/* Whitelist unit types for each transform. */
												case "translate":
													invalid = !/(%|px|em|rem|vw|vh|\d)$/i.test(propertyValue);
													break;
													/* Since an axis-free "scale" property is supported as well, a little hack is used here to detect it by chopping off its last letter. */
												case "scal":
												case "scale":
													/* Chrome on Android has a bug in which scaled elements blur if their initial scale
													 value is below 1 (which can happen with forcefeeding). Thus, we detect a yet-unset scale property
													 and ensure that its first value is always 1. More info: http://stackoverflow.com/questions/10417890/css3-animations-with-transform-causes-blurred-elements-on-webkit/10417962#10417962 */
													if (Velocity.State.isAndroid && Data(element).transformCache[transformName] === undefined && propertyValue < 1) {
														propertyValue = 1;
													}
	
													invalid = !/(\d)$/i.test(propertyValue);
													break;
												case "skew":
													invalid = !/(deg|\d)$/i.test(propertyValue);
													break;
												case "rotate":
													invalid = !/(deg|\d)$/i.test(propertyValue);
													break;
											}
	
											if (!invalid) {
												/* As per the CSS spec, wrap the value in parentheses. */
												Data(element).transformCache[transformName] = "(" + propertyValue + ")";
											}
	
											/* Although the value is set on the transformCache object, return the newly-updated value for the calling code to process as normal. */
											return Data(element).transformCache[transformName];
									}
								};
							})();
						}
	
						/*************
						 Colors
						 *************/
	
						/* Since Velocity only animates a single numeric value per property, color animation is achieved by hooking the individual RGBA components of CSS color properties.
						 Accordingly, color values must be normalized (e.g. "#ff0000", "red", and "rgb(255, 0, 0)" ==> "255 0 0 1") so that their components can be injected/extracted by CSS.Hooks logic. */
						for (var j = 0; j < CSS.Lists.colors.length; j++) {
							/* Wrap the dynamically generated normalization function in a new scope so that colorName's value is paired with its respective function.
							 (Otherwise, all functions would take the final for loop's colorName.) */
							(function() {
								var colorName = CSS.Lists.colors[j];
	
								/* Note: In IE<=8, which support rgb but not rgba, color properties are reverted to rgb by stripping off the alpha component. */
								CSS.Normalizations.registered[colorName] = function(type, element, propertyValue) {
									switch (type) {
										case "name":
											return colorName;
											/* Convert all color values into the rgb format. (Old IE can return hex values and color names instead of rgb/rgba.) */
										case "extract":
											var extracted;
	
											/* If the color is already in its hookable form (e.g. "255 255 255 1") due to having been previously extracted, skip extraction. */
											if (CSS.RegEx.wrappedValueAlreadyExtracted.test(propertyValue)) {
												extracted = propertyValue;
											} else {
												var converted,
														colorNames = {
															black: "rgb(0, 0, 0)",
															blue: "rgb(0, 0, 255)",
															gray: "rgb(128, 128, 128)",
															green: "rgb(0, 128, 0)",
															red: "rgb(255, 0, 0)",
															white: "rgb(255, 255, 255)"
														};
	
												/* Convert color names to rgb. */
												if (/^[A-z]+$/i.test(propertyValue)) {
													if (colorNames[propertyValue] !== undefined) {
														converted = colorNames[propertyValue];
													} else {
														/* If an unmatched color name is provided, default to black. */
														converted = colorNames.black;
													}
													/* Convert hex values to rgb. */
												} else if (CSS.RegEx.isHex.test(propertyValue)) {
													converted = "rgb(" + CSS.Values.hexToRgb(propertyValue).join(" ") + ")";
													/* If the provided color doesn't match any of the accepted color formats, default to black. */
												} else if (!(/^rgba?\(/i.test(propertyValue))) {
													converted = colorNames.black;
												}
	
												/* Remove the surrounding "rgb/rgba()" string then replace commas with spaces and strip
												 repeated spaces (in case the value included spaces to begin with). */
												extracted = (converted || propertyValue).toString().match(CSS.RegEx.valueUnwrap)[1].replace(/,(\s+)?/g, " ");
											}
	
											/* So long as this isn't <=IE8, add a fourth (alpha) component if it's missing and default it to 1 (visible). */
											if ((!IE || IE > 8) && extracted.split(" ").length === 3) {
												extracted += " 1";
											}
	
											return extracted;
										case "inject":
											/* If we have a pattern then it might already have the right values */
											if (/^rgb/.test(propertyValue)) {
												return propertyValue;
											}
	
											/* If this is IE<=8 and an alpha component exists, strip it off. */
											if (IE <= 8) {
												if (propertyValue.split(" ").length === 4) {
													propertyValue = propertyValue.split(/\s+/).slice(0, 3).join(" ");
												}
												/* Otherwise, add a fourth (alpha) component if it's missing and default it to 1 (visible). */
											} else if (propertyValue.split(" ").length === 3) {
												propertyValue += " 1";
											}
	
											/* Re-insert the browser-appropriate wrapper("rgb/rgba()"), insert commas, and strip off decimal units
											 on all values but the fourth (R, G, and B only accept whole numbers). */
											return (IE <= 8 ? "rgb" : "rgba") + "(" + propertyValue.replace(/\s+/g, ",").replace(/\.(\d)+(?=,)/g, "") + ")";
									}
								};
							})();
						}
	
						/**************
						 Dimensions
						 **************/
						function augmentDimension(name, element, wantInner) {
							var isBorderBox = CSS.getPropertyValue(element, "boxSizing").toString().toLowerCase() === "border-box";
	
							if (isBorderBox === (wantInner || false)) {
								/* in box-sizing mode, the CSS width / height accessors already give the outerWidth / outerHeight. */
								var i,
										value,
										augment = 0,
										sides = name === "width" ? ["Left", "Right"] : ["Top", "Bottom"],
										fields = ["padding" + sides[0], "padding" + sides[1], "border" + sides[0] + "Width", "border" + sides[1] + "Width"];
	
								for (i = 0; i < fields.length; i++) {
									value = parseFloat(CSS.getPropertyValue(element, fields[i]));
									if (!isNaN(value)) {
										augment += value;
									}
								}
								return wantInner ? -augment : augment;
							}
							return 0;
						}
						function getDimension(name, wantInner) {
							return function(type, element, propertyValue) {
								switch (type) {
									case "name":
										return name;
									case "extract":
										return parseFloat(propertyValue) + augmentDimension(name, element, wantInner);
									case "inject":
										return (parseFloat(propertyValue) - augmentDimension(name, element, wantInner)) + "px";
								}
							};
						}
						CSS.Normalizations.registered.innerWidth = getDimension("width", true);
						CSS.Normalizations.registered.innerHeight = getDimension("height", true);
						CSS.Normalizations.registered.outerWidth = getDimension("width");
						CSS.Normalizations.registered.outerHeight = getDimension("height");
					}
				},
				/************************
				 CSS Property Names
				 ************************/
	
				Names: {
					/* Camelcase a property name into its JavaScript notation (e.g. "background-color" ==> "backgroundColor").
					 Camelcasing is used to normalize property names between and across calls. */
					camelCase: function(property) {
						return property.replace(/-(\w)/g, function(match, subMatch) {
							return subMatch.toUpperCase();
						});
					},
					/* For SVG elements, some properties (namely, dimensional ones) are GET/SET via the element's HTML attributes (instead of via CSS styles). */
					SVGAttribute: function(property) {
						var SVGAttributes = "width|height|x|y|cx|cy|r|rx|ry|x1|x2|y1|y2";
	
						/* Certain browsers require an SVG transform to be applied as an attribute. (Otherwise, application via CSS is preferable due to 3D support.) */
						if (IE || (Velocity.State.isAndroid && !Velocity.State.isChrome)) {
							SVGAttributes += "|transform";
						}
	
						return new RegExp("^(" + SVGAttributes + ")$", "i").test(property);
					},
					/* Determine whether a property should be set with a vendor prefix. */
					/* If a prefixed version of the property exists, return it. Otherwise, return the original property name.
					 If the property is not at all supported by the browser, return a false flag. */
					prefixCheck: function(property) {
						/* If this property has already been checked, return the cached value. */
						if (Velocity.State.prefixMatches[property]) {
							return [Velocity.State.prefixMatches[property], true];
						} else {
							var vendors = ["", "Webkit", "Moz", "ms", "O"];
	
							for (var i = 0, vendorsLength = vendors.length; i < vendorsLength; i++) {
								var propertyPrefixed;
	
								if (i === 0) {
									propertyPrefixed = property;
								} else {
									/* Capitalize the first letter of the property to conform to JavaScript vendor prefix notation (e.g. webkitFilter). */
									propertyPrefixed = vendors[i] + property.replace(/^\w/, function(match) {
										return match.toUpperCase();
									});
								}
	
								/* Check if the browser supports this property as prefixed. */
								if (Type.isString(Velocity.State.prefixElement.style[propertyPrefixed])) {
									/* Cache the match. */
									Velocity.State.prefixMatches[property] = propertyPrefixed;
	
									return [propertyPrefixed, true];
								}
							}
	
							/* If the browser doesn't support this property in any form, include a false flag so that the caller can decide how to proceed. */
							return [property, false];
						}
					}
				},
				/************************
				 CSS Property Values
				 ************************/
	
				Values: {
					/* Hex to RGB conversion. Copyright Tim Down: http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb */
					hexToRgb: function(hex) {
						var shortformRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
								longformRegex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
								rgbParts;
	
						hex = hex.replace(shortformRegex, function(m, r, g, b) {
							return r + r + g + g + b + b;
						});
	
						rgbParts = longformRegex.exec(hex);
	
						return rgbParts ? [parseInt(rgbParts[1], 16), parseInt(rgbParts[2], 16), parseInt(rgbParts[3], 16)] : [0, 0, 0];
					},
					isCSSNullValue: function(value) {
						/* The browser defaults CSS values that have not been set to either 0 or one of several possible null-value strings.
						 Thus, we check for both falsiness and these special strings. */
						/* Null-value checking is performed to default the special strings to 0 (for the sake of tweening) or their hook
						 templates as defined as CSS.Hooks (for the sake of hook injection/extraction). */
						/* Note: Chrome returns "rgba(0, 0, 0, 0)" for an undefined color whereas IE returns "transparent". */
						return (!value || /^(none|auto|transparent|(rgba\(0, ?0, ?0, ?0\)))$/i.test(value));
					},
					/* Retrieve a property's default unit type. Used for assigning a unit type when one is not supplied by the user. */
					getUnitType: function(property) {
						if (/^(rotate|skew)/i.test(property)) {
							return "deg";
						} else if (/(^(scale|scaleX|scaleY|scaleZ|alpha|flexGrow|flexHeight|zIndex|fontWeight)$)|((opacity|red|green|blue|alpha)$)/i.test(property)) {
							/* The above properties are unitless. */
							return "";
						} else {
							/* Default to px for all other properties. */
							return "px";
						}
					},
					/* HTML elements default to an associated display type when they're not set to display:none. */
					/* Note: This function is used for correctly setting the non-"none" display value in certain Velocity redirects, such as fadeIn/Out. */
					getDisplayType: function(element) {
						var tagName = element && element.tagName.toString().toLowerCase();
	
						if (/^(b|big|i|small|tt|abbr|acronym|cite|code|dfn|em|kbd|strong|samp|var|a|bdo|br|img|map|object|q|script|span|sub|sup|button|input|label|select|textarea)$/i.test(tagName)) {
							return "inline";
						} else if (/^(li)$/i.test(tagName)) {
							return "list-item";
						} else if (/^(tr)$/i.test(tagName)) {
							return "table-row";
						} else if (/^(table)$/i.test(tagName)) {
							return "table";
						} else if (/^(tbody)$/i.test(tagName)) {
							return "table-row-group";
							/* Default to "block" when no match is found. */
						} else {
							return "block";
						}
					},
					/* The class add/remove functions are used to temporarily apply a "velocity-animating" class to elements while they're animating. */
					addClass: function(element, className) {
						if (element) {
							if (element.classList) {
								element.classList.add(className);
							} else if (Type.isString(element.className)) {
								// Element.className is around 15% faster then set/getAttribute
								element.className += (element.className.length ? " " : "") + className;
							} else {
								// Work around for IE strict mode animating SVG - and anything else that doesn't behave correctly - the same way jQuery does it
								var currentClass = element.getAttribute(IE <= 7 ? "className" : "class") || "";
	
								element.setAttribute("class", currentClass + (currentClass ? " " : "") + className);
							}
						}
					},
					removeClass: function(element, className) {
						if (element) {
							if (element.classList) {
								element.classList.remove(className);
							} else if (Type.isString(element.className)) {
								// Element.className is around 15% faster then set/getAttribute
								// TODO: Need some jsperf tests on performance - can we get rid of the regex and maybe use split / array manipulation?
								element.className = element.className.toString().replace(new RegExp("(^|\\s)" + className.split(" ").join("|") + "(\\s|$)", "gi"), " ");
							} else {
								// Work around for IE strict mode animating SVG - and anything else that doesn't behave correctly - the same way jQuery does it
								var currentClass = element.getAttribute(IE <= 7 ? "className" : "class") || "";
	
								element.setAttribute("class", currentClass.replace(new RegExp("(^|\s)" + className.split(" ").join("|") + "(\s|$)", "gi"), " "));
							}
						}
					}
				},
				/****************************
				 Style Getting & Setting
				 ****************************/
	
				/* The singular getPropertyValue, which routes the logic for all normalizations, hooks, and standard CSS properties. */
				getPropertyValue: function(element, property, rootPropertyValue, forceStyleLookup) {
					/* Get an element's computed property value. */
					/* Note: Retrieving the value of a CSS property cannot simply be performed by checking an element's
					 style attribute (which only reflects user-defined values). Instead, the browser must be queried for a property's
					 *computed* value. You can read more about getComputedStyle here: https://developer.mozilla.org/en/docs/Web/API/window.getComputedStyle */
					function computePropertyValue(element, property) {
						/* When box-sizing isn't set to border-box, height and width style values are incorrectly computed when an
						 element's scrollbars are visible (which expands the element's dimensions). Thus, we defer to the more accurate
						 offsetHeight/Width property, which includes the total dimensions for interior, border, padding, and scrollbar.
						 We subtract border and padding to get the sum of interior + scrollbar. */
						var computedValue = 0;
	
						/* IE<=8 doesn't support window.getComputedStyle, thus we defer to jQuery, which has an extensive array
						 of hacks to accurately retrieve IE8 property values. Re-implementing that logic here is not worth bloating the
						 codebase for a dying browser. The performance repercussions of using jQuery here are minimal since
						 Velocity is optimized to rarely (and sometimes never) query the DOM. Further, the $.css() codepath isn't that slow. */
						if (IE <= 8) {
							computedValue = $.css(element, property); /* GET */
							/* All other browsers support getComputedStyle. The returned live object reference is cached onto its
							 associated element so that it does not need to be refetched upon every GET. */
						} else {
							/* Browsers do not return height and width values for elements that are set to display:"none". Thus, we temporarily
							 toggle display to the element type's default value. */
							var toggleDisplay = false;
	
							if (/^(width|height)$/.test(property) && CSS.getPropertyValue(element, "display") === 0) {
								toggleDisplay = true;
								CSS.setPropertyValue(element, "display", CSS.Values.getDisplayType(element));
							}
	
							var revertDisplay = function() {
								if (toggleDisplay) {
									CSS.setPropertyValue(element, "display", "none");
								}
							};
	
							if (!forceStyleLookup) {
								if (property === "height" && CSS.getPropertyValue(element, "boxSizing").toString().toLowerCase() !== "border-box") {
									var contentBoxHeight = element.offsetHeight - (parseFloat(CSS.getPropertyValue(element, "borderTopWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "borderBottomWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingTop")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingBottom")) || 0);
									revertDisplay();
	
									return contentBoxHeight;
								} else if (property === "width" && CSS.getPropertyValue(element, "boxSizing").toString().toLowerCase() !== "border-box") {
									var contentBoxWidth = element.offsetWidth - (parseFloat(CSS.getPropertyValue(element, "borderLeftWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "borderRightWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingLeft")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingRight")) || 0);
									revertDisplay();
	
									return contentBoxWidth;
								}
							}
	
							var computedStyle;
	
							/* For elements that Velocity hasn't been called on directly (e.g. when Velocity queries the DOM on behalf
							 of a parent of an element its animating), perform a direct getComputedStyle lookup since the object isn't cached. */
							if (Data(element) === undefined) {
								computedStyle = window.getComputedStyle(element, null); /* GET */
								/* If the computedStyle object has yet to be cached, do so now. */
							} else if (!Data(element).computedStyle) {
								computedStyle = Data(element).computedStyle = window.getComputedStyle(element, null); /* GET */
								/* If computedStyle is cached, use it. */
							} else {
								computedStyle = Data(element).computedStyle;
							}
	
							/* IE and Firefox do not return a value for the generic borderColor -- they only return individual values for each border side's color.
							 Also, in all browsers, when border colors aren't all the same, a compound value is returned that Velocity isn't setup to parse.
							 So, as a polyfill for querying individual border side colors, we just return the top border's color and animate all borders from that value. */
							if (property === "borderColor") {
								property = "borderTopColor";
							}
	
							/* IE9 has a bug in which the "filter" property must be accessed from computedStyle using the getPropertyValue method
							 instead of a direct property lookup. The getPropertyValue method is slower than a direct lookup, which is why we avoid it by default. */
							if (IE === 9 && property === "filter") {
								computedValue = computedStyle.getPropertyValue(property); /* GET */
							} else {
								computedValue = computedStyle[property];
							}
	
							/* Fall back to the property's style value (if defined) when computedValue returns nothing,
							 which can happen when the element hasn't been painted. */
							if (computedValue === "" || computedValue === null) {
								computedValue = element.style[property];
							}
	
							revertDisplay();
						}
	
						/* For top, right, bottom, and left (TRBL) values that are set to "auto" on elements of "fixed" or "absolute" position,
						 defer to jQuery for converting "auto" to a numeric value. (For elements with a "static" or "relative" position, "auto" has the same
						 effect as being set to 0, so no conversion is necessary.) */
						/* An example of why numeric conversion is necessary: When an element with "position:absolute" has an untouched "left"
						 property, which reverts to "auto", left's value is 0 relative to its parent element, but is often non-zero relative
						 to its *containing* (not parent) element, which is the nearest "position:relative" ancestor or the viewport (and always the viewport in the case of "position:fixed"). */
						if (computedValue === "auto" && /^(top|right|bottom|left)$/i.test(property)) {
							var position = computePropertyValue(element, "position"); /* GET */
	
							/* For absolute positioning, jQuery's $.position() only returns values for top and left;
							 right and bottom will have their "auto" value reverted to 0. */
							/* Note: A jQuery object must be created here since jQuery doesn't have a low-level alias for $.position().
							 Not a big deal since we're currently in a GET batch anyway. */
							if (position === "fixed" || (position === "absolute" && /top|left/i.test(property))) {
								/* Note: jQuery strips the pixel unit from its returned values; we re-add it here to conform with computePropertyValue's behavior. */
								computedValue = $(element).position()[property] + "px"; /* GET */
							}
						}
	
						return computedValue;
					}
	
					var propertyValue;
	
					/* If this is a hooked property (e.g. "clipLeft" instead of the root property of "clip"),
					 extract the hook's value from a normalized rootPropertyValue using CSS.Hooks.extractValue(). */
					if (CSS.Hooks.registered[property]) {
						var hook = property,
								hookRoot = CSS.Hooks.getRoot(hook);
	
						/* If a cached rootPropertyValue wasn't passed in (which Velocity always attempts to do in order to avoid requerying the DOM),
						 query the DOM for the root property's value. */
						if (rootPropertyValue === undefined) {
							/* Since the browser is now being directly queried, use the official post-prefixing property name for this lookup. */
							rootPropertyValue = CSS.getPropertyValue(element, CSS.Names.prefixCheck(hookRoot)[0]); /* GET */
						}
	
						/* If this root has a normalization registered, peform the associated normalization extraction. */
						if (CSS.Normalizations.registered[hookRoot]) {
							rootPropertyValue = CSS.Normalizations.registered[hookRoot]("extract", element, rootPropertyValue);
						}
	
						/* Extract the hook's value. */
						propertyValue = CSS.Hooks.extractValue(hook, rootPropertyValue);
	
						/* If this is a normalized property (e.g. "opacity" becomes "filter" in <=IE8) or "translateX" becomes "transform"),
						 normalize the property's name and value, and handle the special case of transforms. */
						/* Note: Normalizing a property is mutually exclusive from hooking a property since hook-extracted values are strictly
						 numerical and therefore do not require normalization extraction. */
					} else if (CSS.Normalizations.registered[property]) {
						var normalizedPropertyName,
								normalizedPropertyValue;
	
						normalizedPropertyName = CSS.Normalizations.registered[property]("name", element);
	
						/* Transform values are calculated via normalization extraction (see below), which checks against the element's transformCache.
						 At no point do transform GETs ever actually query the DOM; initial stylesheet values are never processed.
						 This is because parsing 3D transform matrices is not always accurate and would bloat our codebase;
						 thus, normalization extraction defaults initial transform values to their zero-values (e.g. 1 for scaleX and 0 for translateX). */
						if (normalizedPropertyName !== "transform") {
							normalizedPropertyValue = computePropertyValue(element, CSS.Names.prefixCheck(normalizedPropertyName)[0]); /* GET */
	
							/* If the value is a CSS null-value and this property has a hook template, use that zero-value template so that hooks can be extracted from it. */
							if (CSS.Values.isCSSNullValue(normalizedPropertyValue) && CSS.Hooks.templates[property]) {
								normalizedPropertyValue = CSS.Hooks.templates[property][1];
							}
						}
	
						propertyValue = CSS.Normalizations.registered[property]("extract", element, normalizedPropertyValue);
					}
	
					/* If a (numeric) value wasn't produced via hook extraction or normalization, query the DOM. */
					if (!/^[\d-]/.test(propertyValue)) {
						/* For SVG elements, dimensional properties (which SVGAttribute() detects) are tweened via
						 their HTML attribute values instead of their CSS style values. */
						var data = Data(element);
	
						if (data && data.isSVG && CSS.Names.SVGAttribute(property)) {
							/* Since the height/width attribute values must be set manually, they don't reflect computed values.
							 Thus, we use use getBBox() to ensure we always get values for elements with undefined height/width attributes. */
							if (/^(height|width)$/i.test(property)) {
								/* Firefox throws an error if .getBBox() is called on an SVG that isn't attached to the DOM. */
								try {
									propertyValue = element.getBBox()[property];
								} catch (error) {
									propertyValue = 0;
								}
								/* Otherwise, access the attribute value directly. */
							} else {
								propertyValue = element.getAttribute(property);
							}
						} else {
							propertyValue = computePropertyValue(element, CSS.Names.prefixCheck(property)[0]); /* GET */
						}
					}
	
					/* Since property lookups are for animation purposes (which entails computing the numeric delta between start and end values),
					 convert CSS null-values to an integer of value 0. */
					if (CSS.Values.isCSSNullValue(propertyValue)) {
						propertyValue = 0;
					}
	
					if (Velocity.debug >= 2) {
						console.log("Get " + property + ": " + propertyValue);
					}
	
					return propertyValue;
				},
				/* The singular setPropertyValue, which routes the logic for all normalizations, hooks, and standard CSS properties. */
				setPropertyValue: function(element, property, propertyValue, rootPropertyValue, scrollData) {
					var propertyName = property;
	
					/* In order to be subjected to call options and element queueing, scroll animation is routed through Velocity as if it were a standard CSS property. */
					if (property === "scroll") {
						/* If a container option is present, scroll the container instead of the browser window. */
						if (scrollData.container) {
							scrollData.container["scroll" + scrollData.direction] = propertyValue;
							/* Otherwise, Velocity defaults to scrolling the browser window. */
						} else {
							if (scrollData.direction === "Left") {
								window.scrollTo(propertyValue, scrollData.alternateValue);
							} else {
								window.scrollTo(scrollData.alternateValue, propertyValue);
							}
						}
					} else {
						/* Transforms (translateX, rotateZ, etc.) are applied to a per-element transformCache object, which is manually flushed via flushTransformCache().
						 Thus, for now, we merely cache transforms being SET. */
						if (CSS.Normalizations.registered[property] && CSS.Normalizations.registered[property]("name", element) === "transform") {
							/* Perform a normalization injection. */
							/* Note: The normalization logic handles the transformCache updating. */
							CSS.Normalizations.registered[property]("inject", element, propertyValue);
	
							propertyName = "transform";
							propertyValue = Data(element).transformCache[property];
						} else {
							/* Inject hooks. */
							if (CSS.Hooks.registered[property]) {
								var hookName = property,
										hookRoot = CSS.Hooks.getRoot(property);
	
								/* If a cached rootPropertyValue was not provided, query the DOM for the hookRoot's current value. */
								rootPropertyValue = rootPropertyValue || CSS.getPropertyValue(element, hookRoot); /* GET */
	
								propertyValue = CSS.Hooks.injectValue(hookName, propertyValue, rootPropertyValue);
								property = hookRoot;
							}
	
							/* Normalize names and values. */
							if (CSS.Normalizations.registered[property]) {
								propertyValue = CSS.Normalizations.registered[property]("inject", element, propertyValue);
								property = CSS.Normalizations.registered[property]("name", element);
							}
	
							/* Assign the appropriate vendor prefix before performing an official style update. */
							propertyName = CSS.Names.prefixCheck(property)[0];
	
							/* A try/catch is used for IE<=8, which throws an error when "invalid" CSS values are set, e.g. a negative width.
							 Try/catch is avoided for other browsers since it incurs a performance overhead. */
							if (IE <= 8) {
								try {
									element.style[propertyName] = propertyValue;
								} catch (error) {
									if (Velocity.debug) {
										console.log("Browser does not support [" + propertyValue + "] for [" + propertyName + "]");
									}
								}
								/* SVG elements have their dimensional properties (width, height, x, y, cx, etc.) applied directly as attributes instead of as styles. */
								/* Note: IE8 does not support SVG elements, so it's okay that we skip it for SVG animation. */
							} else {
								var data = Data(element);
	
								if (data && data.isSVG && CSS.Names.SVGAttribute(property)) {
									/* Note: For SVG attributes, vendor-prefixed property names are never used. */
									/* Note: Not all CSS properties can be animated via attributes, but the browser won't throw an error for unsupported properties. */
									element.setAttribute(property, propertyValue);
								} else {
									element.style[propertyName] = propertyValue;
								}
							}
	
							if (Velocity.debug >= 2) {
								console.log("Set " + property + " (" + propertyName + "): " + propertyValue);
							}
						}
					}
	
					/* Return the normalized property name and value in case the caller wants to know how these values were modified before being applied to the DOM. */
					return [propertyName, propertyValue];
				},
				/* To increase performance by batching transform updates into a single SET, transforms are not directly applied to an element until flushTransformCache() is called. */
				/* Note: Velocity applies transform properties in the same order that they are chronogically introduced to the element's CSS styles. */
				flushTransformCache: function(element) {
					var transformString = "",
							data = Data(element);
	
					/* Certain browsers require that SVG transforms be applied as an attribute. However, the SVG transform attribute takes a modified version of CSS's transform string
					 (units are dropped and, except for skewX/Y, subproperties are merged into their master property -- e.g. scaleX and scaleY are merged into scale(X Y). */
					if ((IE || (Velocity.State.isAndroid && !Velocity.State.isChrome)) && data && data.isSVG) {
						/* Since transform values are stored in their parentheses-wrapped form, we use a helper function to strip out their numeric values.
						 Further, SVG transform properties only take unitless (representing pixels) values, so it's okay that parseFloat() strips the unit suffixed to the float value. */
						var getTransformFloat = function(transformProperty) {
							return parseFloat(CSS.getPropertyValue(element, transformProperty));
						};
	
						/* Create an object to organize all the transforms that we'll apply to the SVG element. To keep the logic simple,
						 we process *all* transform properties -- even those that may not be explicitly applied (since they default to their zero-values anyway). */
						var SVGTransforms = {
							translate: [getTransformFloat("translateX"), getTransformFloat("translateY")],
							skewX: [getTransformFloat("skewX")], skewY: [getTransformFloat("skewY")],
							/* If the scale property is set (non-1), use that value for the scaleX and scaleY values
							 (this behavior mimics the result of animating all these properties at once on HTML elements). */
							scale: getTransformFloat("scale") !== 1 ? [getTransformFloat("scale"), getTransformFloat("scale")] : [getTransformFloat("scaleX"), getTransformFloat("scaleY")],
							/* Note: SVG's rotate transform takes three values: rotation degrees followed by the X and Y values
							 defining the rotation's origin point. We ignore the origin values (default them to 0). */
							rotate: [getTransformFloat("rotateZ"), 0, 0]
						};
	
						/* Iterate through the transform properties in the user-defined property map order.
						 (This mimics the behavior of non-SVG transform animation.) */
						$.each(Data(element).transformCache, function(transformName) {
							/* Except for with skewX/Y, revert the axis-specific transform subproperties to their axis-free master
							 properties so that they match up with SVG's accepted transform properties. */
							if (/^translate/i.test(transformName)) {
								transformName = "translate";
							} else if (/^scale/i.test(transformName)) {
								transformName = "scale";
							} else if (/^rotate/i.test(transformName)) {
								transformName = "rotate";
							}
	
							/* Check that we haven't yet deleted the property from the SVGTransforms container. */
							if (SVGTransforms[transformName]) {
								/* Append the transform property in the SVG-supported transform format. As per the spec, surround the space-delimited values in parentheses. */
								transformString += transformName + "(" + SVGTransforms[transformName].join(" ") + ")" + " ";
	
								/* After processing an SVG transform property, delete it from the SVGTransforms container so we don't
								 re-insert the same master property if we encounter another one of its axis-specific properties. */
								delete SVGTransforms[transformName];
							}
						});
					} else {
						var transformValue,
								perspective;
	
						/* Transform properties are stored as members of the transformCache object. Concatenate all the members into a string. */
						$.each(Data(element).transformCache, function(transformName) {
							transformValue = Data(element).transformCache[transformName];
	
							/* Transform's perspective subproperty must be set first in order to take effect. Store it temporarily. */
							if (transformName === "transformPerspective") {
								perspective = transformValue;
								return true;
							}
	
							/* IE9 only supports one rotation type, rotateZ, which it refers to as "rotate". */
							if (IE === 9 && transformName === "rotateZ") {
								transformName = "rotate";
							}
	
							transformString += transformName + transformValue + " ";
						});
	
						/* If present, set the perspective subproperty first. */
						if (perspective) {
							transformString = "perspective" + perspective + " " + transformString;
						}
					}
	
					CSS.setPropertyValue(element, "transform", transformString);
				}
			};
	
			/* Register hooks and normalizations. */
			CSS.Hooks.register();
			CSS.Normalizations.register();
	
			/* Allow hook setting in the same fashion as jQuery's $.css(). */
			Velocity.hook = function(elements, arg2, arg3) {
				var value;
	
				elements = sanitizeElements(elements);
	
				$.each(elements, function(i, element) {
					/* Initialize Velocity's per-element data cache if this element hasn't previously been animated. */
					if (Data(element) === undefined) {
						Velocity.init(element);
					}
	
					/* Get property value. If an element set was passed in, only return the value for the first element. */
					if (arg3 === undefined) {
						if (value === undefined) {
							value = CSS.getPropertyValue(element, arg2);
						}
						/* Set property value. */
					} else {
						/* sPV returns an array of the normalized propertyName/propertyValue pair used to update the DOM. */
						var adjustedSet = CSS.setPropertyValue(element, arg2, arg3);
	
						/* Transform properties don't automatically set. They have to be flushed to the DOM. */
						if (adjustedSet[0] === "transform") {
							Velocity.CSS.flushTransformCache(element);
						}
	
						value = adjustedSet;
					}
				});
	
				return value;
			};
	
			/*****************
			 Animation
			 *****************/
	
			var animate = function() {
				var opts;
	
				/******************
				 Call Chain
				 ******************/
	
				/* Logic for determining what to return to the call stack when exiting out of Velocity. */
				function getChain() {
					/* If we are using the utility function, attempt to return this call's promise. If no promise library was detected,
					 default to null instead of returning the targeted elements so that utility function's return value is standardized. */
					if (isUtility) {
						return promiseData.promise || null;
						/* Otherwise, if we're using $.fn, return the jQuery-/Zepto-wrapped element set. */
					} else {
						return elementsWrapped;
					}
				}
	
				/*************************
				 Arguments Assignment
				 *************************/
	
				/* To allow for expressive CoffeeScript code, Velocity supports an alternative syntax in which "elements" (or "e"), "properties" (or "p"), and "options" (or "o")
				 objects are defined on a container object that's passed in as Velocity's sole argument. */
				/* Note: Some browsers automatically populate arguments with a "properties" object. We detect it by checking for its default "names" property. */
				var syntacticSugar = (arguments[0] && (arguments[0].p || (($.isPlainObject(arguments[0].properties) && !arguments[0].properties.names) || Type.isString(arguments[0].properties)))),
						/* Whether Velocity was called via the utility function (as opposed to on a jQuery/Zepto object). */
						isUtility,
						/* When Velocity is called via the utility function ($.Velocity()/Velocity()), elements are explicitly
						 passed in as the first parameter. Thus, argument positioning varies. We normalize them here. */
						elementsWrapped,
						argumentIndex;
	
				var elements,
						propertiesMap,
						options;
	
				/* Detect jQuery/Zepto elements being animated via the $.fn method. */
				if (Type.isWrapped(this)) {
					isUtility = false;
	
					argumentIndex = 0;
					elements = this;
					elementsWrapped = this;
					/* Otherwise, raw elements are being animated via the utility function. */
				} else {
					isUtility = true;
	
					argumentIndex = 1;
					elements = syntacticSugar ? (arguments[0].elements || arguments[0].e) : arguments[0];
				}
	
				/***************
				 Promises
				 ***************/
	
				var promiseData = {
					promise: null,
					resolver: null,
					rejecter: null
				};
	
				/* If this call was made via the utility function (which is the default method of invocation when jQuery/Zepto are not being used), and if
				 promise support was detected, create a promise object for this call and store references to its resolver and rejecter methods. The resolve
				 method is used when a call completes naturally or is prematurely stopped by the user. In both cases, completeCall() handles the associated
				 call cleanup and promise resolving logic. The reject method is used when an invalid set of arguments is passed into a Velocity call. */
				/* Note: Velocity employs a call-based queueing architecture, which means that stopping an animating element actually stops the full call that
				 triggered it -- not that one element exclusively. Similarly, there is one promise per call, and all elements targeted by a Velocity call are
				 grouped together for the purposes of resolving and rejecting a promise. */
				if (isUtility && Velocity.Promise) {
					promiseData.promise = new Velocity.Promise(function(resolve, reject) {
						promiseData.resolver = resolve;
						promiseData.rejecter = reject;
					});
				}
	
				if (syntacticSugar) {
					propertiesMap = arguments[0].properties || arguments[0].p;
					options = arguments[0].options || arguments[0].o;
				} else {
					propertiesMap = arguments[argumentIndex];
					options = arguments[argumentIndex + 1];
				}
	
				elements = sanitizeElements(elements);
	
				if (!elements) {
					if (promiseData.promise) {
						if (!propertiesMap || !options || options.promiseRejectEmpty !== false) {
							promiseData.rejecter();
						} else {
							promiseData.resolver();
						}
					}
					return;
				}
	
				/* The length of the element set (in the form of a nodeList or an array of elements) is defaulted to 1 in case a
				 single raw DOM element is passed in (which doesn't contain a length property). */
				var elementsLength = elements.length,
						elementsIndex = 0;
	
				/***************************
				 Argument Overloading
				 ***************************/
	
				/* Support is included for jQuery's argument overloading: $.animate(propertyMap [, duration] [, easing] [, complete]).
				 Overloading is detected by checking for the absence of an object being passed into options. */
				/* Note: The stop/finish/pause/resume actions do not accept animation options, and are therefore excluded from this check. */
				if (!/^(stop|finish|finishAll|pause|resume)$/i.test(propertiesMap) && !$.isPlainObject(options)) {
					/* The utility function shifts all arguments one position to the right, so we adjust for that offset. */
					var startingArgumentPosition = argumentIndex + 1;
	
					options = {};
	
					/* Iterate through all options arguments */
					for (var i = startingArgumentPosition; i < arguments.length; i++) {
						/* Treat a number as a duration. Parse it out. */
						/* Note: The following RegEx will return true if passed an array with a number as its first item.
						 Thus, arrays are skipped from this check. */
						if (!Type.isArray(arguments[i]) && (/^(fast|normal|slow)$/i.test(arguments[i]) || /^\d/.test(arguments[i]))) {
							options.duration = arguments[i];
							/* Treat strings and arrays as easings. */
						} else if (Type.isString(arguments[i]) || Type.isArray(arguments[i])) {
							options.easing = arguments[i];
							/* Treat a function as a complete callback. */
						} else if (Type.isFunction(arguments[i])) {
							options.complete = arguments[i];
						}
					}
				}
	
				/*********************
				 Action Detection
				 *********************/
	
				/* Velocity's behavior is categorized into "actions": Elements can either be specially scrolled into view,
				 or they can be started, stopped, paused, resumed, or reversed . If a literal or referenced properties map is passed in as Velocity's
				 first argument, the associated action is "start". Alternatively, "scroll", "reverse", "pause", "resume" or "stop" can be passed in 
				 instead of a properties map. */
				var action;
	
				switch (propertiesMap) {
					case "scroll":
						action = "scroll";
						break;
	
					case "reverse":
						action = "reverse";
						break;
	
					case "pause":
	
						/*******************
						 Action: Pause
						 *******************/
	
						var currentTime = (new Date()).getTime();
	
						/* Handle delay timers */
						$.each(elements, function(i, element) {
							pauseDelayOnElement(element, currentTime);
						});
	
						/* Pause and Resume are call-wide (not on a per element basis). Thus, calling pause or resume on a 
						 single element will cause any calls that containt tweens for that element to be paused/resumed
						 as well. */
	
						/* Iterate through all calls and pause any that contain any of our elements */
						$.each(Velocity.State.calls, function(i, activeCall) {
	
							var found = false;
							/* Inactive calls are set to false by the logic inside completeCall(). Skip them. */
							if (activeCall) {
								/* Iterate through the active call's targeted elements. */
								$.each(activeCall[1], function(k, activeElement) {
									var queueName = (options === undefined) ? "" : options;
	
									if (queueName !== true && (activeCall[2].queue !== queueName) && !(options === undefined && activeCall[2].queue === false)) {
										return true;
									}
	
									/* Iterate through the calls targeted by the stop command. */
									$.each(elements, function(l, element) {
										/* Check that this call was applied to the target element. */
										if (element === activeElement) {
	
											/* Set call to paused */
											activeCall[5] = {
												resume: false
											};
	
											/* Once we match an element, we can bounce out to the next call entirely */
											found = true;
											return false;
										}
									});
	
									/* Proceed to check next call if we have already matched */
									if (found) {
										return false;
									}
								});
							}
	
						});
	
						/* Since pause creates no new tweens, exit out of Velocity. */
						return getChain();
	
					case "resume":
	
						/*******************
						 Action: Resume
						 *******************/
	
						/* Handle delay timers */
						$.each(elements, function(i, element) {
							resumeDelayOnElement(element, currentTime);
						});
	
						/* Pause and Resume are call-wide (not on a per elemnt basis). Thus, calling pause or resume on a 
						 single element will cause any calls that containt tweens for that element to be paused/resumed
						 as well. */
	
						/* Iterate through all calls and pause any that contain any of our elements */
						$.each(Velocity.State.calls, function(i, activeCall) {
							var found = false;
							/* Inactive calls are set to false by the logic inside completeCall(). Skip them. */
							if (activeCall) {
								/* Iterate through the active call's targeted elements. */
								$.each(activeCall[1], function(k, activeElement) {
									var queueName = (options === undefined) ? "" : options;
	
									if (queueName !== true && (activeCall[2].queue !== queueName) && !(options === undefined && activeCall[2].queue === false)) {
										return true;
									}
	
									/* Skip any calls that have never been paused */
									if (!activeCall[5]) {
										return true;
									}
	
									/* Iterate through the calls targeted by the stop command. */
									$.each(elements, function(l, element) {
										/* Check that this call was applied to the target element. */
										if (element === activeElement) {
	
											/* Flag a pause object to be resumed, which will occur during the next tick. In
											 addition, the pause object will at that time be deleted */
											activeCall[5].resume = true;
	
											/* Once we match an element, we can bounce out to the next call entirely */
											found = true;
											return false;
										}
									});
	
									/* Proceed to check next call if we have already matched */
									if (found) {
										return false;
									}
								});
							}
	
						});
	
						/* Since resume creates no new tweens, exit out of Velocity. */
						return getChain();
	
					case "finish":
					case "finishAll":
					case "stop":
						/*******************
						 Action: Stop
						 *******************/
	
						/* Clear the currently-active delay on each targeted element. */
						$.each(elements, function(i, element) {
							if (Data(element) && Data(element).delayTimer) {
								/* Stop the timer from triggering its cached next() function. */
								clearTimeout(Data(element).delayTimer.setTimeout);
	
								/* Manually call the next() function so that the subsequent queue items can progress. */
								if (Data(element).delayTimer.next) {
									Data(element).delayTimer.next();
								}
	
								delete Data(element).delayTimer;
							}
	
							/* If we want to finish everything in the queue, we have to iterate through it
							 and call each function. This will make them active calls below, which will
							 cause them to be applied via the duration setting. */
							if (propertiesMap === "finishAll" && (options === true || Type.isString(options))) {
								/* Iterate through the items in the element's queue. */
								$.each($.queue(element, Type.isString(options) ? options : ""), function(_, item) {
									/* The queue array can contain an "inprogress" string, which we skip. */
									if (Type.isFunction(item)) {
										item();
									}
								});
	
								/* Clearing the $.queue() array is achieved by resetting it to []. */
								$.queue(element, Type.isString(options) ? options : "", []);
							}
						});
	
						var callsToStop = [];
	
						/* When the stop action is triggered, the elements' currently active call is immediately stopped. The active call might have
						 been applied to multiple elements, in which case all of the call's elements will be stopped. When an element
						 is stopped, the next item in its animation queue is immediately triggered. */
						/* An additional argument may be passed in to clear an element's remaining queued calls. Either true (which defaults to the "fx" queue)
						 or a custom queue string can be passed in. */
						/* Note: The stop command runs prior to Velocity's Queueing phase since its behavior is intended to take effect *immediately*,
						 regardless of the element's current queue state. */
	
						/* Iterate through every active call. */
						$.each(Velocity.State.calls, function(i, activeCall) {
							/* Inactive calls are set to false by the logic inside completeCall(). Skip them. */
							if (activeCall) {
								/* Iterate through the active call's targeted elements. */
								$.each(activeCall[1], function(k, activeElement) {
									/* If true was passed in as a secondary argument, clear absolutely all calls on this element. Otherwise, only
									 clear calls associated with the relevant queue. */
									/* Call stopping logic works as follows:
									 - options === true --> stop current default queue calls (and queue:false calls), including remaining queued ones.
									 - options === undefined --> stop current queue:"" call and all queue:false calls.
									 - options === false --> stop only queue:false calls.
									 - options === "custom" --> stop current queue:"custom" call, including remaining queued ones (there is no functionality to only clear the currently-running queue:"custom" call). */
									var queueName = (options === undefined) ? "" : options;
	
									if (queueName !== true && (activeCall[2].queue !== queueName) && !(options === undefined && activeCall[2].queue === false)) {
										return true;
									}
	
									/* Iterate through the calls targeted by the stop command. */
									$.each(elements, function(l, element) {
										/* Check that this call was applied to the target element. */
										if (element === activeElement) {
											/* Optionally clear the remaining queued calls. If we're doing "finishAll" this won't find anything,
											 due to the queue-clearing above. */
											if (options === true || Type.isString(options)) {
												/* Iterate through the items in the element's queue. */
												$.each($.queue(element, Type.isString(options) ? options : ""), function(_, item) {
													/* The queue array can contain an "inprogress" string, which we skip. */
													if (Type.isFunction(item)) {
														/* Pass the item's callback a flag indicating that we want to abort from the queue call.
														 (Specifically, the queue will resolve the call's associated promise then abort.)  */
														item(null, true);
													}
												});
	
												/* Clearing the $.queue() array is achieved by resetting it to []. */
												$.queue(element, Type.isString(options) ? options : "", []);
											}
	
											if (propertiesMap === "stop") {
												/* Since "reverse" uses cached start values (the previous call's endValues), these values must be
												 changed to reflect the final value that the elements were actually tweened to. */
												/* Note: If only queue:false animations are currently running on an element, it won't have a tweensContainer
												 object. Also, queue:false animations can't be reversed. */
												var data = Data(element);
												if (data && data.tweensContainer && queueName !== false) {
													$.each(data.tweensContainer, function(m, activeTween) {
														activeTween.endValue = activeTween.currentValue;
													});
												}
	
												callsToStop.push(i);
											} else if (propertiesMap === "finish" || propertiesMap === "finishAll") {
												/* To get active tweens to finish immediately, we forcefully shorten their durations to 1ms so that
												 they finish upon the next rAf tick then proceed with normal call completion logic. */
												activeCall[2].duration = 1;
											}
										}
									});
								});
							}
						});
	
						/* Prematurely call completeCall() on each matched active call. Pass an additional flag for "stop" to indicate
						 that the complete callback and display:none setting should be skipped since we're completing prematurely. */
						if (propertiesMap === "stop") {
							$.each(callsToStop, function(i, j) {
								completeCall(j, true);
							});
	
							if (promiseData.promise) {
								/* Immediately resolve the promise associated with this stop call since stop runs synchronously. */
								promiseData.resolver(elements);
							}
						}
	
						/* Since we're stopping, and not proceeding with queueing, exit out of Velocity. */
						return getChain();
	
					default:
						/* Treat a non-empty plain object as a literal properties map. */
						if ($.isPlainObject(propertiesMap) && !Type.isEmptyObject(propertiesMap)) {
							action = "start";
	
							/****************
							 Redirects
							 ****************/
	
							/* Check if a string matches a registered redirect (see Redirects above). */
						} else if (Type.isString(propertiesMap) && Velocity.Redirects[propertiesMap]) {
							opts = $.extend({}, options);
	
							var durationOriginal = opts.duration,
									delayOriginal = opts.delay || 0;
	
							/* If the backwards option was passed in, reverse the element set so that elements animate from the last to the first. */
							if (opts.backwards === true) {
								elements = $.extend(true, [], elements).reverse();
							}
	
							/* Individually trigger the redirect for each element in the set to prevent users from having to handle iteration logic in their redirect. */
							$.each(elements, function(elementIndex, element) {
								/* If the stagger option was passed in, successively delay each element by the stagger value (in ms). Retain the original delay value. */
								if (parseFloat(opts.stagger)) {
									opts.delay = delayOriginal + (parseFloat(opts.stagger) * elementIndex);
								} else if (Type.isFunction(opts.stagger)) {
									opts.delay = delayOriginal + opts.stagger.call(element, elementIndex, elementsLength);
								}
	
								/* If the drag option was passed in, successively increase/decrease (depending on the presense of opts.backwards)
								 the duration of each element's animation, using floors to prevent producing very short durations. */
								if (opts.drag) {
									/* Default the duration of UI pack effects (callouts and transitions) to 1000ms instead of the usual default duration of 400ms. */
									opts.duration = parseFloat(durationOriginal) || (/^(callout|transition)/.test(propertiesMap) ? 1000 : DURATION_DEFAULT);
	
									/* For each element, take the greater duration of: A) animation completion percentage relative to the original duration,
									 B) 75% of the original duration, or C) a 200ms fallback (in case duration is already set to a low value).
									 The end result is a baseline of 75% of the redirect's duration that increases/decreases as the end of the element set is approached. */
									opts.duration = Math.max(opts.duration * (opts.backwards ? 1 - elementIndex / elementsLength : (elementIndex + 1) / elementsLength), opts.duration * 0.75, 200);
								}
	
								/* Pass in the call's opts object so that the redirect can optionally extend it. It defaults to an empty object instead of null to
								 reduce the opts checking logic required inside the redirect. */
								Velocity.Redirects[propertiesMap].call(element, element, opts || {}, elementIndex, elementsLength, elements, promiseData.promise ? promiseData : undefined);
							});
	
							/* Since the animation logic resides within the redirect's own code, abort the remainder of this call.
							 (The performance overhead up to this point is virtually non-existant.) */
							/* Note: The jQuery call chain is kept intact by returning the complete element set. */
							return getChain();
						} else {
							var abortError = "Velocity: First argument (" + propertiesMap + ") was not a property map, a known action, or a registered redirect. Aborting.";
	
							if (promiseData.promise) {
								promiseData.rejecter(new Error(abortError));
							} else if (window.console) {
								console.log(abortError);
							}
	
							return getChain();
						}
				}
	
				/**************************
				 Call-Wide Variables
				 **************************/
	
				/* A container for CSS unit conversion ratios (e.g. %, rem, and em ==> px) that is used to cache ratios across all elements
				 being animated in a single Velocity call. Calculating unit ratios necessitates DOM querying and updating, and is therefore
				 avoided (via caching) wherever possible. This container is call-wide instead of page-wide to avoid the risk of using stale
				 conversion metrics across Velocity animations that are not immediately consecutively chained. */
				var callUnitConversionData = {
					lastParent: null,
					lastPosition: null,
					lastFontSize: null,
					lastPercentToPxWidth: null,
					lastPercentToPxHeight: null,
					lastEmToPx: null,
					remToPx: null,
					vwToPx: null,
					vhToPx: null
				};
	
				/* A container for all the ensuing tween data and metadata associated with this call. This container gets pushed to the page-wide
				 Velocity.State.calls array that is processed during animation ticking. */
				var call = [];
	
				/************************
				 Element Processing
				 ************************/
	
				/* Element processing consists of three parts -- data processing that cannot go stale and data processing that *can* go stale (i.e. third-party style modifications):
				 1) Pre-Queueing: Element-wide variables, including the element's data storage, are instantiated. Call options are prepared. If triggered, the Stop action is executed.
				 2) Queueing: The logic that runs once this call has reached its point of execution in the element's $.queue() stack. Most logic is placed here to avoid risking it becoming stale.
				 3) Pushing: Consolidation of the tween data followed by its push onto the global in-progress calls container.
				 `elementArrayIndex` allows passing index of the element in the original array to value functions.
				 If `elementsIndex` were used instead the index would be determined by the elements' per-element queue.
				 */
				function processElement(element, elementArrayIndex) {
	
					/*************************
					 Part I: Pre-Queueing
					 *************************/
	
					/***************************
					 Element-Wide Variables
					 ***************************/
	
					var /* The runtime opts object is the extension of the current call's options and Velocity's page-wide option defaults. */
							opts = $.extend({}, Velocity.defaults, options),
							/* A container for the processed data associated with each property in the propertyMap.
							 (Each property in the map produces its own "tween".) */
							tweensContainer = {},
							elementUnitConversionData;
	
					/******************
					 Element Init
					 ******************/
	
					if (Data(element) === undefined) {
						Velocity.init(element);
					}
	
					/******************
					 Option: Delay
					 ******************/
	
					/* Since queue:false doesn't respect the item's existing queue, we avoid injecting its delay here (it's set later on). */
					/* Note: Velocity rolls its own delay function since jQuery doesn't have a utility alias for $.fn.delay()
					 (and thus requires jQuery element creation, which we avoid since its overhead includes DOM querying). */
					if (parseFloat(opts.delay) && opts.queue !== false) {
						$.queue(element, opts.queue, function(next, clearQueue) {
							if (clearQueue === true) {
								/* Do not continue with animation queueing. */
								return true;
							}
	
							/* This is a flag used to indicate to the upcoming completeCall() function that this queue entry was initiated by Velocity. See completeCall() for further details. */
							Velocity.velocityQueueEntryFlag = true;
	
							/* The ensuing queue item (which is assigned to the "next" argument that $.queue() automatically passes in) will be triggered after a setTimeout delay.
							 The setTimeout is stored so that it can be subjected to clearTimeout() if this animation is prematurely stopped via Velocity's "stop" command, and
							 delayBegin/delayTime is used to ensure we can "pause" and "resume" a tween that is still mid-delay. */
	
							/* Temporarily store delayed elements to facilite access for global pause/resume */
							var callIndex = Velocity.State.delayedElements.count++;
							Velocity.State.delayedElements[callIndex] = element;
	
							var delayComplete = (function(index) {
								return function() {
									/* Clear the temporary element */
									Velocity.State.delayedElements[index] = false;
	
									/* Finally, issue the call */
									next();
								};
							})(callIndex);
	
	
							Data(element).delayBegin = (new Date()).getTime();
							Data(element).delay = parseFloat(opts.delay);
							Data(element).delayTimer = {
								setTimeout: setTimeout(next, parseFloat(opts.delay)),
								next: delayComplete
							};
						});
					}
	
					/*********************
					 Option: Duration
					 *********************/
	
					/* Support for jQuery's named durations. */
					switch (opts.duration.toString().toLowerCase()) {
						case "fast":
							opts.duration = 200;
							break;
	
						case "normal":
							opts.duration = DURATION_DEFAULT;
							break;
	
						case "slow":
							opts.duration = 600;
							break;
	
						default:
							/* Remove the potential "ms" suffix and default to 1 if the user is attempting to set a duration of 0 (in order to produce an immediate style change). */
							opts.duration = parseFloat(opts.duration) || 1;
					}
	
					/************************
					 Global Option: Mock
					 ************************/
	
					if (Velocity.mock !== false) {
						/* In mock mode, all animations are forced to 1ms so that they occur immediately upon the next rAF tick.
						 Alternatively, a multiplier can be passed in to time remap all delays and durations. */
						if (Velocity.mock === true) {
							opts.duration = opts.delay = 1;
						} else {
							opts.duration *= parseFloat(Velocity.mock) || 1;
							opts.delay *= parseFloat(Velocity.mock) || 1;
						}
					}
	
					/*******************
					 Option: Easing
					 *******************/
	
					opts.easing = getEasing(opts.easing, opts.duration);
	
					/**********************
					 Option: Callbacks
					 **********************/
	
					/* Callbacks must functions. Otherwise, default to null. */
					if (opts.begin && !Type.isFunction(opts.begin)) {
						opts.begin = null;
					}
	
					if (opts.progress && !Type.isFunction(opts.progress)) {
						opts.progress = null;
					}
	
					if (opts.complete && !Type.isFunction(opts.complete)) {
						opts.complete = null;
					}
	
					/*********************************
					 Option: Display & Visibility
					 *********************************/
	
					/* Refer to Velocity's documentation (VelocityJS.org/#displayAndVisibility) for a description of the display and visibility options' behavior. */
					/* Note: We strictly check for undefined instead of falsiness because display accepts an empty string value. */
					if (opts.display !== undefined && opts.display !== null) {
						opts.display = opts.display.toString().toLowerCase();
	
						/* Users can pass in a special "auto" value to instruct Velocity to set the element to its default display value. */
						if (opts.display === "auto") {
							opts.display = Velocity.CSS.Values.getDisplayType(element);
						}
					}
	
					if (opts.visibility !== undefined && opts.visibility !== null) {
						opts.visibility = opts.visibility.toString().toLowerCase();
					}
	
					/**********************
					 Option: mobileHA
					 **********************/
	
					/* When set to true, and if this is a mobile device, mobileHA automatically enables hardware acceleration (via a null transform hack)
					 on animating elements. HA is removed from the element at the completion of its animation. */
					/* Note: Android Gingerbread doesn't support HA. If a null transform hack (mobileHA) is in fact set, it will prevent other tranform subproperties from taking effect. */
					/* Note: You can read more about the use of mobileHA in Velocity's documentation: VelocityJS.org/#mobileHA. */
					opts.mobileHA = (opts.mobileHA && Velocity.State.isMobile && !Velocity.State.isGingerbread);
	
					/***********************
					 Part II: Queueing
					 ***********************/
	
					/* When a set of elements is targeted by a Velocity call, the set is broken up and each element has the current Velocity call individually queued onto it.
					 In this way, each element's existing queue is respected; some elements may already be animating and accordingly should not have this current Velocity call triggered immediately. */
					/* In each queue, tween data is processed for each animating property then pushed onto the call-wide calls array. When the last element in the set has had its tweens processed,
					 the call array is pushed to Velocity.State.calls for live processing by the requestAnimationFrame tick. */
					function buildQueue(next) {
						var data, lastTweensContainer;
	
						/*******************
						 Option: Begin
						 *******************/
	
						/* The begin callback is fired once per call -- not once per elemenet -- and is passed the full raw DOM element set as both its context and its first argument. */
						if (opts.begin && elementsIndex === 0) {
							/* We throw callbacks in a setTimeout so that thrown errors don't halt the execution of Velocity itself. */
							try {
								opts.begin.call(elements, elements);
							} catch (error) {
								setTimeout(function() {
									throw error;
								}, 1);
							}
						}
	
						/*****************************************
						 Tween Data Construction (for Scroll)
						 *****************************************/
	
						/* Note: In order to be subjected to chaining and animation options, scroll's tweening is routed through Velocity as if it were a standard CSS property animation. */
						if (action === "scroll") {
							/* The scroll action uniquely takes an optional "offset" option -- specified in pixels -- that offsets the targeted scroll position. */
							var scrollDirection = (/^x$/i.test(opts.axis) ? "Left" : "Top"),
									scrollOffset = parseFloat(opts.offset) || 0,
									scrollPositionCurrent,
									scrollPositionCurrentAlternate,
									scrollPositionEnd;
	
							/* Scroll also uniquely takes an optional "container" option, which indicates the parent element that should be scrolled --
							 as opposed to the browser window itself. This is useful for scrolling toward an element that's inside an overflowing parent element. */
							if (opts.container) {
								/* Ensure that either a jQuery object or a raw DOM element was passed in. */
								if (Type.isWrapped(opts.container) || Type.isNode(opts.container)) {
									/* Extract the raw DOM element from the jQuery wrapper. */
									opts.container = opts.container[0] || opts.container;
									/* Note: Unlike other properties in Velocity, the browser's scroll position is never cached since it so frequently changes
									 (due to the user's natural interaction with the page). */
									scrollPositionCurrent = opts.container["scroll" + scrollDirection]; /* GET */
	
									/* $.position() values are relative to the container's currently viewable area (without taking into account the container's true dimensions
									 -- say, for example, if the container was not overflowing). Thus, the scroll end value is the sum of the child element's position *and*
									 the scroll container's current scroll position. */
									scrollPositionEnd = (scrollPositionCurrent + $(element).position()[scrollDirection.toLowerCase()]) + scrollOffset; /* GET */
									/* If a value other than a jQuery object or a raw DOM element was passed in, default to null so that this option is ignored. */
								} else {
									opts.container = null;
								}
							} else {
								/* If the window itself is being scrolled -- not a containing element -- perform a live scroll position lookup using
								 the appropriate cached property names (which differ based on browser type). */
								scrollPositionCurrent = Velocity.State.scrollAnchor[Velocity.State["scrollProperty" + scrollDirection]]; /* GET */
								/* When scrolling the browser window, cache the alternate axis's current value since window.scrollTo() doesn't let us change only one value at a time. */
								scrollPositionCurrentAlternate = Velocity.State.scrollAnchor[Velocity.State["scrollProperty" + (scrollDirection === "Left" ? "Top" : "Left")]]; /* GET */
	
								/* Unlike $.position(), $.offset() values are relative to the browser window's true dimensions -- not merely its currently viewable area --
								 and therefore end values do not need to be compounded onto current values. */
								scrollPositionEnd = $(element).offset()[scrollDirection.toLowerCase()] + scrollOffset; /* GET */
							}
	
							/* Since there's only one format that scroll's associated tweensContainer can take, we create it manually. */
							tweensContainer = {
								scroll: {
									rootPropertyValue: false,
									startValue: scrollPositionCurrent,
									currentValue: scrollPositionCurrent,
									endValue: scrollPositionEnd,
									unitType: "",
									easing: opts.easing,
									scrollData: {
										container: opts.container,
										direction: scrollDirection,
										alternateValue: scrollPositionCurrentAlternate
									}
								},
								element: element
							};
	
							if (Velocity.debug) {
								console.log("tweensContainer (scroll): ", tweensContainer.scroll, element);
							}
	
							/******************************************
							 Tween Data Construction (for Reverse)
							 ******************************************/
	
							/* Reverse acts like a "start" action in that a property map is animated toward. The only difference is
							 that the property map used for reverse is the inverse of the map used in the previous call. Thus, we manipulate
							 the previous call to construct our new map: use the previous map's end values as our new map's start values. Copy over all other data. */
							/* Note: Reverse can be directly called via the "reverse" parameter, or it can be indirectly triggered via the loop option. (Loops are composed of multiple reverses.) */
							/* Note: Reverse calls do not need to be consecutively chained onto a currently-animating element in order to operate on cached values;
							 there is no harm to reverse being called on a potentially stale data cache since reverse's behavior is simply defined
							 as reverting to the element's values as they were prior to the previous *Velocity* call. */
						} else if (action === "reverse") {
							data = Data(element);
	
							/* Abort if there is no prior animation data to reverse to. */
							if (!data) {
								return;
							}
	
							if (!data.tweensContainer) {
								/* Dequeue the element so that this queue entry releases itself immediately, allowing subsequent queue entries to run. */
								$.dequeue(element, opts.queue);
	
								return;
							} else {
								/*********************
								 Options Parsing
								 *********************/
	
								/* If the element was hidden via the display option in the previous call,
								 revert display to "auto" prior to reversal so that the element is visible again. */
								if (data.opts.display === "none") {
									data.opts.display = "auto";
								}
	
								if (data.opts.visibility === "hidden") {
									data.opts.visibility = "visible";
								}
	
								/* If the loop option was set in the previous call, disable it so that "reverse" calls aren't recursively generated.
								 Further, remove the previous call's callback options; typically, users do not want these to be refired. */
								data.opts.loop = false;
								data.opts.begin = null;
								data.opts.complete = null;
	
								/* Since we're extending an opts object that has already been extended with the defaults options object,
								 we remove non-explicitly-defined properties that are auto-assigned values. */
								if (!options.easing) {
									delete opts.easing;
								}
	
								if (!options.duration) {
									delete opts.duration;
								}
	
								/* The opts object used for reversal is an extension of the options object optionally passed into this
								 reverse call plus the options used in the previous Velocity call. */
								opts = $.extend({}, data.opts, opts);
	
								/*************************************
								 Tweens Container Reconstruction
								 *************************************/
	
								/* Create a deepy copy (indicated via the true flag) of the previous call's tweensContainer. */
								lastTweensContainer = $.extend(true, {}, data ? data.tweensContainer : null);
	
								/* Manipulate the previous tweensContainer by replacing its end values and currentValues with its start values. */
								for (var lastTween in lastTweensContainer) {
									/* In addition to tween data, tweensContainers contain an element property that we ignore here. */
									if (lastTweensContainer.hasOwnProperty(lastTween) && lastTween !== "element") {
										var lastStartValue = lastTweensContainer[lastTween].startValue;
	
										lastTweensContainer[lastTween].startValue = lastTweensContainer[lastTween].currentValue = lastTweensContainer[lastTween].endValue;
										lastTweensContainer[lastTween].endValue = lastStartValue;
	
										/* Easing is the only option that embeds into the individual tween data (since it can be defined on a per-property basis).
										 Accordingly, every property's easing value must be updated when an options object is passed in with a reverse call.
										 The side effect of this extensibility is that all per-property easing values are forcefully reset to the new value. */
										if (!Type.isEmptyObject(options)) {
											lastTweensContainer[lastTween].easing = opts.easing;
										}
	
										if (Velocity.debug) {
											console.log("reverse tweensContainer (" + lastTween + "): " + JSON.stringify(lastTweensContainer[lastTween]), element);
										}
									}
								}
	
								tweensContainer = lastTweensContainer;
							}
	
							/*****************************************
							 Tween Data Construction (for Start)
							 *****************************************/
	
						} else if (action === "start") {
	
							/*************************
							 Value Transferring
							 *************************/
	
							/* If this queue entry follows a previous Velocity-initiated queue entry *and* if this entry was created
							 while the element was in the process of being animated by Velocity, then this current call is safe to use
							 the end values from the prior call as its start values. Velocity attempts to perform this value transfer
							 process whenever possible in order to avoid requerying the DOM. */
							/* If values aren't transferred from a prior call and start values were not forcefed by the user (more on this below),
							 then the DOM is queried for the element's current values as a last resort. */
							/* Note: Conversely, animation reversal (and looping) *always* perform inter-call value transfers; they never requery the DOM. */
	
							data = Data(element);
	
							/* The per-element isAnimating flag is used to indicate whether it's safe (i.e. the data isn't stale)
							 to transfer over end values to use as start values. If it's set to true and there is a previous
							 Velocity call to pull values from, do so. */
							if (data && data.tweensContainer && data.isAnimating === true) {
								lastTweensContainer = data.tweensContainer;
							}
	
							/***************************
							 Tween Data Calculation
							 ***************************/
	
							/* This function parses property data and defaults endValue, easing, and startValue as appropriate. */
							/* Property map values can either take the form of 1) a single value representing the end value,
							 or 2) an array in the form of [ endValue, [, easing] [, startValue] ].
							 The optional third parameter is a forcefed startValue to be used instead of querying the DOM for
							 the element's current value. Read Velocity's docmentation to learn more about forcefeeding: VelocityJS.org/#forcefeeding */
							var parsePropertyValue = function(valueData, skipResolvingEasing) {
								var endValue, easing, startValue;
	
								/* If we have a function as the main argument then resolve it first, in case it returns an array that needs to be split */
								if (Type.isFunction(valueData)) {
									valueData = valueData.call(element, elementArrayIndex, elementsLength);
								}
	
								/* Handle the array format, which can be structured as one of three potential overloads:
								 A) [ endValue, easing, startValue ], B) [ endValue, easing ], or C) [ endValue, startValue ] */
								if (Type.isArray(valueData)) {
									/* endValue is always the first item in the array. Don't bother validating endValue's value now
									 since the ensuing property cycling logic does that. */
									endValue = valueData[0];
	
									/* Two-item array format: If the second item is a number, function, or hex string, treat it as a
									 start value since easings can only be non-hex strings or arrays. */
									if ((!Type.isArray(valueData[1]) && /^[\d-]/.test(valueData[1])) || Type.isFunction(valueData[1]) || CSS.RegEx.isHex.test(valueData[1])) {
										startValue = valueData[1];
										/* Two or three-item array: If the second item is a non-hex string easing name or an array, treat it as an easing. */
									} else if ((Type.isString(valueData[1]) && !CSS.RegEx.isHex.test(valueData[1]) && Velocity.Easings[valueData[1]]) || Type.isArray(valueData[1])) {
										easing = skipResolvingEasing ? valueData[1] : getEasing(valueData[1], opts.duration);
	
										/* Don't bother validating startValue's value now since the ensuing property cycling logic inherently does that. */
										startValue = valueData[2];
									} else {
										startValue = valueData[1] || valueData[2];
									}
									/* Handle the single-value format. */
								} else {
									endValue = valueData;
								}
	
								/* Default to the call's easing if a per-property easing type was not defined. */
								if (!skipResolvingEasing) {
									easing = easing || opts.easing;
								}
	
								/* If functions were passed in as values, pass the function the current element as its context,
								 plus the element's index and the element set's size as arguments. Then, assign the returned value. */
								if (Type.isFunction(endValue)) {
									endValue = endValue.call(element, elementArrayIndex, elementsLength);
								}
	
								if (Type.isFunction(startValue)) {
									startValue = startValue.call(element, elementArrayIndex, elementsLength);
								}
	
								/* Allow startValue to be left as undefined to indicate to the ensuing code that its value was not forcefed. */
								return [endValue || 0, easing, startValue];
							};
	
							var fixPropertyValue = function(property, valueData) {
								/* In case this property is a hook, there are circumstances where we will intend to work on the hook's root property and not the hooked subproperty. */
								var rootProperty = CSS.Hooks.getRoot(property),
										rootPropertyValue = false,
										/* Parse out endValue, easing, and startValue from the property's data. */
										endValue = valueData[0],
										easing = valueData[1],
										startValue = valueData[2],
										pattern;
	
								/**************************
								 Start Value Sourcing
								 **************************/
	
								/* Other than for the dummy tween property, properties that are not supported by the browser (and do not have an associated normalization) will
								 inherently produce no style changes when set, so they are skipped in order to decrease animation tick overhead.
								 Property support is determined via prefixCheck(), which returns a false flag when no supported is detected. */
								/* Note: Since SVG elements have some of their properties directly applied as HTML attributes,
								 there is no way to check for their explicit browser support, and so we skip skip this check for them. */
								if ((!data || !data.isSVG) && rootProperty !== "tween" && CSS.Names.prefixCheck(rootProperty)[1] === false && CSS.Normalizations.registered[rootProperty] === undefined) {
									if (Velocity.debug) {
										console.log("Skipping [" + rootProperty + "] due to a lack of browser support.");
									}
									return;
								}
	
								/* If the display option is being set to a non-"none" (e.g. "block") and opacity (filter on IE<=8) is being
								 animated to an endValue of non-zero, the user's intention is to fade in from invisible, thus we forcefeed opacity
								 a startValue of 0 if its startValue hasn't already been sourced by value transferring or prior forcefeeding. */
								if (((opts.display !== undefined && opts.display !== null && opts.display !== "none") || (opts.visibility !== undefined && opts.visibility !== "hidden")) && /opacity|filter/.test(property) && !startValue && endValue !== 0) {
									startValue = 0;
								}
	
								/* If values have been transferred from the previous Velocity call, extract the endValue and rootPropertyValue
								 for all of the current call's properties that were *also* animated in the previous call. */
								/* Note: Value transferring can optionally be disabled by the user via the _cacheValues option. */
								if (opts._cacheValues && lastTweensContainer && lastTweensContainer[property]) {
									if (startValue === undefined) {
										startValue = lastTweensContainer[property].endValue + lastTweensContainer[property].unitType;
									}
	
									/* The previous call's rootPropertyValue is extracted from the element's data cache since that's the
									 instance of rootPropertyValue that gets freshly updated by the tweening process, whereas the rootPropertyValue
									 attached to the incoming lastTweensContainer is equal to the root property's value prior to any tweening. */
									rootPropertyValue = data.rootPropertyValueCache[rootProperty];
									/* If values were not transferred from a previous Velocity call, query the DOM as needed. */
								} else {
									/* Handle hooked properties. */
									if (CSS.Hooks.registered[property]) {
										if (startValue === undefined) {
											rootPropertyValue = CSS.getPropertyValue(element, rootProperty); /* GET */
											/* Note: The following getPropertyValue() call does not actually trigger a DOM query;
											 getPropertyValue() will extract the hook from rootPropertyValue. */
											startValue = CSS.getPropertyValue(element, property, rootPropertyValue);
											/* If startValue is already defined via forcefeeding, do not query the DOM for the root property's value;
											 just grab rootProperty's zero-value template from CSS.Hooks. This overwrites the element's actual
											 root property value (if one is set), but this is acceptable since the primary reason users forcefeed is
											 to avoid DOM queries, and thus we likewise avoid querying the DOM for the root property's value. */
										} else {
											/* Grab this hook's zero-value template, e.g. "0px 0px 0px black". */
											rootPropertyValue = CSS.Hooks.templates[rootProperty][1];
										}
										/* Handle non-hooked properties that haven't already been defined via forcefeeding. */
									} else if (startValue === undefined) {
										startValue = CSS.getPropertyValue(element, property); /* GET */
									}
								}
	
								/**************************
								 Value Data Extraction
								 **************************/
	
								var separatedValue,
										endValueUnitType,
										startValueUnitType,
										operator = false;
	
								/* Separates a property value into its numeric value and its unit type. */
								var separateValue = function(property, value) {
									var unitType,
											numericValue;
	
									numericValue = (value || "0")
											.toString()
											.toLowerCase()
											/* Match the unit type at the end of the value. */
											.replace(/[%A-z]+$/, function(match) {
												/* Grab the unit type. */
												unitType = match;
	
												/* Strip the unit type off of value. */
												return "";
											});
	
									/* If no unit type was supplied, assign one that is appropriate for this property (e.g. "deg" for rotateZ or "px" for width). */
									if (!unitType) {
										unitType = CSS.Values.getUnitType(property);
									}
	
									return [numericValue, unitType];
								};
	
								if (startValue !== endValue && Type.isString(startValue) && Type.isString(endValue)) {
									pattern = "";
									var iStart = 0, // index in startValue
											iEnd = 0, // index in endValue
											aStart = [], // array of startValue numbers
											aEnd = [], // array of endValue numbers
											inCalc = 0, // Keep track of being inside a "calc()" so we don't duplicate it
											inRGB = 0, // Keep track of being inside an RGB as we can't use fractional values
											inRGBA = 0; // Keep track of being inside an RGBA as we must pass fractional for the alpha channel
	
									startValue = CSS.Hooks.fixColors(startValue);
									endValue = CSS.Hooks.fixColors(endValue);
									while (iStart < startValue.length && iEnd < endValue.length) {
										var cStart = startValue[iStart],
												cEnd = endValue[iEnd];
	
										if (/[\d\.-]/.test(cStart) && /[\d\.-]/.test(cEnd)) {
											var tStart = cStart, // temporary character buffer
													tEnd = cEnd, // temporary character buffer
													dotStart = ".", // Make sure we can only ever match a single dot in a decimal
													dotEnd = "."; // Make sure we can only ever match a single dot in a decimal
	
											while (++iStart < startValue.length) {
												cStart = startValue[iStart];
												if (cStart === dotStart) {
													dotStart = ".."; // Can never match two characters
												} else if (!/\d/.test(cStart)) {
													break;
												}
												tStart += cStart;
											}
											while (++iEnd < endValue.length) {
												cEnd = endValue[iEnd];
												if (cEnd === dotEnd) {
													dotEnd = ".."; // Can never match two characters
												} else if (!/\d/.test(cEnd)) {
													break;
												}
												tEnd += cEnd;
											}
											var uStart = CSS.Hooks.getUnit(startValue, iStart), // temporary unit type
													uEnd = CSS.Hooks.getUnit(endValue, iEnd); // temporary unit type
	
											iStart += uStart.length;
											iEnd += uEnd.length;
											if (uStart === uEnd) {
												// Same units
												if (tStart === tEnd) {
													// Same numbers, so just copy over
													pattern += tStart + uStart;
												} else {
													// Different numbers, so store them
													pattern += "{" + aStart.length + (inRGB ? "!" : "") + "}" + uStart;
													aStart.push(parseFloat(tStart));
													aEnd.push(parseFloat(tEnd));
												}
											} else {
												// Different units, so put into a "calc(from + to)" and animate each side to/from zero
												var nStart = parseFloat(tStart),
														nEnd = parseFloat(tEnd);
	
												pattern += (inCalc < 5 ? "calc" : "") + "("
														+ (nStart ? "{" + aStart.length + (inRGB ? "!" : "") + "}" : "0") + uStart
														+ " + "
														+ (nEnd ? "{" + (aStart.length + (nStart ? 1 : 0)) + (inRGB ? "!" : "") + "}" : "0") + uEnd
														+ ")";
												if (nStart) {
													aStart.push(nStart);
													aEnd.push(0);
												}
												if (nEnd) {
													aStart.push(0);
													aEnd.push(nEnd);
												}
											}
										} else if (cStart === cEnd) {
											pattern += cStart;
											iStart++;
											iEnd++;
											// Keep track of being inside a calc()
											if (inCalc === 0 && cStart === "c"
													|| inCalc === 1 && cStart === "a"
													|| inCalc === 2 && cStart === "l"
													|| inCalc === 3 && cStart === "c"
													|| inCalc >= 4 && cStart === "("
													) {
												inCalc++;
											} else if ((inCalc && inCalc < 5)
													|| inCalc >= 4 && cStart === ")" && --inCalc < 5) {
												inCalc = 0;
											}
											// Keep track of being inside an rgb() / rgba()
											if (inRGB === 0 && cStart === "r"
													|| inRGB === 1 && cStart === "g"
													|| inRGB === 2 && cStart === "b"
													|| inRGB === 3 && cStart === "a"
													|| inRGB >= 3 && cStart === "("
													) {
												if (inRGB === 3 && cStart === "a") {
													inRGBA = 1;
												}
												inRGB++;
											} else if (inRGBA && cStart === ",") {
												if (++inRGBA > 3) {
													inRGB = inRGBA = 0;
												}
											} else if ((inRGBA && inRGB < (inRGBA ? 5 : 4))
													|| inRGB >= (inRGBA ? 4 : 3) && cStart === ")" && --inRGB < (inRGBA ? 5 : 4)) {
												inRGB = inRGBA = 0;
											}
										} else {
											inCalc = 0;
											// TODO: changing units, fixing colours
											break;
										}
									}
									if (iStart !== startValue.length || iEnd !== endValue.length) {
										if (Velocity.debug) {
											console.error("Trying to pattern match mis-matched strings [\"" + endValue + "\", \"" + startValue + "\"]");
										}
										pattern = undefined;
									}
									if (pattern) {
										if (aStart.length) {
											if (Velocity.debug) {
												console.log("Pattern found \"" + pattern + "\" -> ", aStart, aEnd, "[" + startValue + "," + endValue + "]");
											}
											startValue = aStart;
											endValue = aEnd;
											endValueUnitType = startValueUnitType = "";
										} else {
											pattern = undefined;
										}
									}
								}
	
								if (!pattern) {
									/* Separate startValue. */
									separatedValue = separateValue(property, startValue);
									startValue = separatedValue[0];
									startValueUnitType = separatedValue[1];
	
									/* Separate endValue, and extract a value operator (e.g. "+=", "-=") if one exists. */
									separatedValue = separateValue(property, endValue);
									endValue = separatedValue[0].replace(/^([+-\/*])=/, function(match, subMatch) {
										operator = subMatch;
	
										/* Strip the operator off of the value. */
										return "";
									});
									endValueUnitType = separatedValue[1];
	
									/* Parse float values from endValue and startValue. Default to 0 if NaN is returned. */
									startValue = parseFloat(startValue) || 0;
									endValue = parseFloat(endValue) || 0;
	
									/***************************************
									 Property-Specific Value Conversion
									 ***************************************/
	
									/* Custom support for properties that don't actually accept the % unit type, but where pollyfilling is trivial and relatively foolproof. */
									if (endValueUnitType === "%") {
										/* A %-value fontSize/lineHeight is relative to the parent's fontSize (as opposed to the parent's dimensions),
										 which is identical to the em unit's behavior, so we piggyback off of that. */
										if (/^(fontSize|lineHeight)$/.test(property)) {
											/* Convert % into an em decimal value. */
											endValue = endValue / 100;
											endValueUnitType = "em";
											/* For scaleX and scaleY, convert the value into its decimal format and strip off the unit type. */
										} else if (/^scale/.test(property)) {
											endValue = endValue / 100;
											endValueUnitType = "";
											/* For RGB components, take the defined percentage of 255 and strip off the unit type. */
										} else if (/(Red|Green|Blue)$/i.test(property)) {
											endValue = (endValue / 100) * 255;
											endValueUnitType = "";
										}
									}
								}
	
								/***************************
								 Unit Ratio Calculation
								 ***************************/
	
								/* When queried, the browser returns (most) CSS property values in pixels. Therefore, if an endValue with a unit type of
								 %, em, or rem is animated toward, startValue must be converted from pixels into the same unit type as endValue in order
								 for value manipulation logic (increment/decrement) to proceed. Further, if the startValue was forcefed or transferred
								 from a previous call, startValue may also not be in pixels. Unit conversion logic therefore consists of two steps:
								 1) Calculating the ratio of %/em/rem/vh/vw relative to pixels
								 2) Converting startValue into the same unit of measurement as endValue based on these ratios. */
								/* Unit conversion ratios are calculated by inserting a sibling node next to the target node, copying over its position property,
								 setting values with the target unit type then comparing the returned pixel value. */
								/* Note: Even if only one of these unit types is being animated, all unit ratios are calculated at once since the overhead
								 of batching the SETs and GETs together upfront outweights the potential overhead
								 of layout thrashing caused by re-querying for uncalculated ratios for subsequently-processed properties. */
								/* Todo: Shift this logic into the calls' first tick instance so that it's synced with RAF. */
								var calculateUnitRatios = function() {
	
									/************************
									 Same Ratio Checks
									 ************************/
	
									/* The properties below are used to determine whether the element differs sufficiently from this call's
									 previously iterated element to also differ in its unit conversion ratios. If the properties match up with those
									 of the prior element, the prior element's conversion ratios are used. Like most optimizations in Velocity,
									 this is done to minimize DOM querying. */
									var sameRatioIndicators = {
										myParent: element.parentNode || document.body, /* GET */
										position: CSS.getPropertyValue(element, "position"), /* GET */
										fontSize: CSS.getPropertyValue(element, "fontSize") /* GET */
									},
											/* Determine if the same % ratio can be used. % is based on the element's position value and its parent's width and height dimensions. */
											samePercentRatio = ((sameRatioIndicators.position === callUnitConversionData.lastPosition) && (sameRatioIndicators.myParent === callUnitConversionData.lastParent)),
											/* Determine if the same em ratio can be used. em is relative to the element's fontSize. */
											sameEmRatio = (sameRatioIndicators.fontSize === callUnitConversionData.lastFontSize);
	
									/* Store these ratio indicators call-wide for the next element to compare against. */
									callUnitConversionData.lastParent = sameRatioIndicators.myParent;
									callUnitConversionData.lastPosition = sameRatioIndicators.position;
									callUnitConversionData.lastFontSize = sameRatioIndicators.fontSize;
	
									/***************************
									 Element-Specific Units
									 ***************************/
	
									/* Note: IE8 rounds to the nearest pixel when returning CSS values, thus we perform conversions using a measurement
									 of 100 (instead of 1) to give our ratios a precision of at least 2 decimal values. */
									var measurement = 100,
											unitRatios = {};
	
									if (!sameEmRatio || !samePercentRatio) {
										var dummy = data && data.isSVG ? document.createElementNS("http://www.w3.org/2000/svg", "rect") : document.createElement("div");
	
										Velocity.init(dummy);
										sameRatioIndicators.myParent.appendChild(dummy);
	
										/* To accurately and consistently calculate conversion ratios, the element's cascaded overflow and box-sizing are stripped.
										 Similarly, since width/height can be artificially constrained by their min-/max- equivalents, these are controlled for as well. */
										/* Note: Overflow must be also be controlled for per-axis since the overflow property overwrites its per-axis values. */
										$.each(["overflow", "overflowX", "overflowY"], function(i, property) {
											Velocity.CSS.setPropertyValue(dummy, property, "hidden");
										});
										Velocity.CSS.setPropertyValue(dummy, "position", sameRatioIndicators.position);
										Velocity.CSS.setPropertyValue(dummy, "fontSize", sameRatioIndicators.fontSize);
										Velocity.CSS.setPropertyValue(dummy, "boxSizing", "content-box");
	
										/* width and height act as our proxy properties for measuring the horizontal and vertical % ratios. */
										$.each(["minWidth", "maxWidth", "width", "minHeight", "maxHeight", "height"], function(i, property) {
											Velocity.CSS.setPropertyValue(dummy, property, measurement + "%");
										});
										/* paddingLeft arbitrarily acts as our proxy property for the em ratio. */
										Velocity.CSS.setPropertyValue(dummy, "paddingLeft", measurement + "em");
	
										/* Divide the returned value by the measurement to get the ratio between 1% and 1px. Default to 1 since working with 0 can produce Infinite. */
										unitRatios.percentToPxWidth = callUnitConversionData.lastPercentToPxWidth = (parseFloat(CSS.getPropertyValue(dummy, "width", null, true)) || 1) / measurement; /* GET */
										unitRatios.percentToPxHeight = callUnitConversionData.lastPercentToPxHeight = (parseFloat(CSS.getPropertyValue(dummy, "height", null, true)) || 1) / measurement; /* GET */
										unitRatios.emToPx = callUnitConversionData.lastEmToPx = (parseFloat(CSS.getPropertyValue(dummy, "paddingLeft")) || 1) / measurement; /* GET */
	
										sameRatioIndicators.myParent.removeChild(dummy);
									} else {
										unitRatios.emToPx = callUnitConversionData.lastEmToPx;
										unitRatios.percentToPxWidth = callUnitConversionData.lastPercentToPxWidth;
										unitRatios.percentToPxHeight = callUnitConversionData.lastPercentToPxHeight;
									}
	
									/***************************
									 Element-Agnostic Units
									 ***************************/
	
									/* Whereas % and em ratios are determined on a per-element basis, the rem unit only needs to be checked
									 once per call since it's exclusively dependant upon document.body's fontSize. If this is the first time
									 that calculateUnitRatios() is being run during this call, remToPx will still be set to its default value of null,
									 so we calculate it now. */
									if (callUnitConversionData.remToPx === null) {
										/* Default to browsers' default fontSize of 16px in the case of 0. */
										callUnitConversionData.remToPx = parseFloat(CSS.getPropertyValue(document.body, "fontSize")) || 16; /* GET */
									}
	
									/* Similarly, viewport units are %-relative to the window's inner dimensions. */
									if (callUnitConversionData.vwToPx === null) {
										callUnitConversionData.vwToPx = parseFloat(window.innerWidth) / 100; /* GET */
										callUnitConversionData.vhToPx = parseFloat(window.innerHeight) / 100; /* GET */
									}
	
									unitRatios.remToPx = callUnitConversionData.remToPx;
									unitRatios.vwToPx = callUnitConversionData.vwToPx;
									unitRatios.vhToPx = callUnitConversionData.vhToPx;
	
									if (Velocity.debug >= 1) {
										console.log("Unit ratios: " + JSON.stringify(unitRatios), element);
									}
									return unitRatios;
								};
	
								/********************
								 Unit Conversion
								 ********************/
	
								/* The * and / operators, which are not passed in with an associated unit, inherently use startValue's unit. Skip value and unit conversion. */
								if (/[\/*]/.test(operator)) {
									endValueUnitType = startValueUnitType;
									/* If startValue and endValue differ in unit type, convert startValue into the same unit type as endValue so that if endValueUnitType
									 is a relative unit (%, em, rem), the values set during tweening will continue to be accurately relative even if the metrics they depend
									 on are dynamically changing during the course of the animation. Conversely, if we always normalized into px and used px for setting values, the px ratio
									 would become stale if the original unit being animated toward was relative and the underlying metrics change during the animation. */
									/* Since 0 is 0 in any unit type, no conversion is necessary when startValue is 0 -- we just start at 0 with endValueUnitType. */
								} else if ((startValueUnitType !== endValueUnitType) && startValue !== 0) {
									/* Unit conversion is also skipped when endValue is 0, but *startValueUnitType* must be used for tween values to remain accurate. */
									/* Note: Skipping unit conversion here means that if endValueUnitType was originally a relative unit, the animation won't relatively
									 match the underlying metrics if they change, but this is acceptable since we're animating toward invisibility instead of toward visibility,
									 which remains past the point of the animation's completion. */
									if (endValue === 0) {
										endValueUnitType = startValueUnitType;
									} else {
										/* By this point, we cannot avoid unit conversion (it's undesirable since it causes layout thrashing).
										 If we haven't already, we trigger calculateUnitRatios(), which runs once per element per call. */
										elementUnitConversionData = elementUnitConversionData || calculateUnitRatios();
	
										/* The following RegEx matches CSS properties that have their % values measured relative to the x-axis. */
										/* Note: W3C spec mandates that all of margin and padding's properties (even top and bottom) are %-relative to the *width* of the parent element. */
										var axis = (/margin|padding|left|right|width|text|word|letter/i.test(property) || /X$/.test(property) || property === "x") ? "x" : "y";
	
										/* In order to avoid generating n^2 bespoke conversion functions, unit conversion is a two-step process:
										 1) Convert startValue into pixels. 2) Convert this new pixel value into endValue's unit type. */
										switch (startValueUnitType) {
											case "%":
												/* Note: translateX and translateY are the only properties that are %-relative to an element's own dimensions -- not its parent's dimensions.
												 Velocity does not include a special conversion process to account for this behavior. Therefore, animating translateX/Y from a % value
												 to a non-% value will produce an incorrect start value. Fortunately, this sort of cross-unit conversion is rarely done by users in practice. */
												startValue *= (axis === "x" ? elementUnitConversionData.percentToPxWidth : elementUnitConversionData.percentToPxHeight);
												break;
	
											case "px":
												/* px acts as our midpoint in the unit conversion process; do nothing. */
												break;
	
											default:
												startValue *= elementUnitConversionData[startValueUnitType + "ToPx"];
										}
	
										/* Invert the px ratios to convert into to the target unit. */
										switch (endValueUnitType) {
											case "%":
												startValue *= 1 / (axis === "x" ? elementUnitConversionData.percentToPxWidth : elementUnitConversionData.percentToPxHeight);
												break;
	
											case "px":
												/* startValue is already in px, do nothing; we're done. */
												break;
	
											default:
												startValue *= 1 / elementUnitConversionData[endValueUnitType + "ToPx"];
										}
									}
								}
	
								/*********************
								 Relative Values
								 *********************/
	
								/* Operator logic must be performed last since it requires unit-normalized start and end values. */
								/* Note: Relative *percent values* do not behave how most people think; while one would expect "+=50%"
								 to increase the property 1.5x its current value, it in fact increases the percent units in absolute terms:
								 50 points is added on top of the current % value. */
								switch (operator) {
									case "+":
										endValue = startValue + endValue;
										break;
	
									case "-":
										endValue = startValue - endValue;
										break;
	
									case "*":
										endValue = startValue * endValue;
										break;
	
									case "/":
										endValue = startValue / endValue;
										break;
								}
	
								/**************************
								 tweensContainer Push
								 **************************/
	
								/* Construct the per-property tween object, and push it to the element's tweensContainer. */
								tweensContainer[property] = {
									rootPropertyValue: rootPropertyValue,
									startValue: startValue,
									currentValue: startValue,
									endValue: endValue,
									unitType: endValueUnitType,
									easing: easing
								};
								if (pattern) {
									tweensContainer[property].pattern = pattern;
								}
	
								if (Velocity.debug) {
									console.log("tweensContainer (" + property + "): " + JSON.stringify(tweensContainer[property]), element);
								}
							};
	
							/* Create a tween out of each property, and append its associated data to tweensContainer. */
							for (var property in propertiesMap) {
	
								if (!propertiesMap.hasOwnProperty(property)) {
									continue;
								}
								/* The original property name's format must be used for the parsePropertyValue() lookup,
								 but we then use its camelCase styling to normalize it for manipulation. */
								var propertyName = CSS.Names.camelCase(property),
										valueData = parsePropertyValue(propertiesMap[property]);
	
								/* Find shorthand color properties that have been passed a hex string. */
								/* Would be quicker to use CSS.Lists.colors.includes() if possible */
								if (_inArray(CSS.Lists.colors, propertyName)) {
									/* Parse the value data for each shorthand. */
									var endValue = valueData[0],
											easing = valueData[1],
											startValue = valueData[2];
	
									if (CSS.RegEx.isHex.test(endValue)) {
										/* Convert the hex strings into their RGB component arrays. */
										var colorComponents = ["Red", "Green", "Blue"],
												endValueRGB = CSS.Values.hexToRgb(endValue),
												startValueRGB = startValue ? CSS.Values.hexToRgb(startValue) : undefined;
	
										/* Inject the RGB component tweens into propertiesMap. */
										for (var i = 0; i < colorComponents.length; i++) {
											var dataArray = [endValueRGB[i]];
	
											if (easing) {
												dataArray.push(easing);
											}
	
											if (startValueRGB !== undefined) {
												dataArray.push(startValueRGB[i]);
											}
	
											fixPropertyValue(propertyName + colorComponents[i], dataArray);
										}
										/* If we have replaced a shortcut color value then don't update the standard property name */
										continue;
									}
								}
								fixPropertyValue(propertyName, valueData);
							}
	
							/* Along with its property data, store a reference to the element itself onto tweensContainer. */
							tweensContainer.element = element;
						}
	
						/*****************
						 Call Push
						 *****************/
	
						/* Note: tweensContainer can be empty if all of the properties in this call's property map were skipped due to not
						 being supported by the browser. The element property is used for checking that the tweensContainer has been appended to. */
						if (tweensContainer.element) {
							/* Apply the "velocity-animating" indicator class. */
							CSS.Values.addClass(element, "velocity-animating");
	
							/* The call array houses the tweensContainers for each element being animated in the current call. */
							call.push(tweensContainer);
	
							data = Data(element);
	
							if (data) {
								/* Store the tweensContainer and options if we're working on the default effects queue, so that they can be used by the reverse command. */
								if (opts.queue === "") {
	
									data.tweensContainer = tweensContainer;
									data.opts = opts;
								}
	
								/* Switch on the element's animating flag. */
								data.isAnimating = true;
							}
	
							/* Once the final element in this call's element set has been processed, push the call array onto
							 Velocity.State.calls for the animation tick to immediately begin processing. */
							if (elementsIndex === elementsLength - 1) {
								/* Add the current call plus its associated metadata (the element set and the call's options) onto the global call container.
								 Anything on this call container is subjected to tick() processing. */
								Velocity.State.calls.push([call, elements, opts, null, promiseData.resolver, null, 0]);
	
								/* If the animation tick isn't running, start it. (Velocity shuts it off when there are no active calls to process.) */
								if (Velocity.State.isTicking === false) {
									Velocity.State.isTicking = true;
	
									/* Start the tick loop. */
									tick();
								}
							} else {
								elementsIndex++;
							}
						}
					}
	
					/* When the queue option is set to false, the call skips the element's queue and fires immediately. */
					if (opts.queue === false) {
						/* Since this buildQueue call doesn't respect the element's existing queue (which is where a delay option would have been appended),
						 we manually inject the delay property here with an explicit setTimeout. */
						if (opts.delay) {
	
							/* Temporarily store delayed elements to facilitate access for global pause/resume */
							var callIndex = Velocity.State.delayedElements.count++;
							Velocity.State.delayedElements[callIndex] = element;
	
							var delayComplete = (function(index) {
								return function() {
									/* Clear the temporary element */
									Velocity.State.delayedElements[index] = false;
	
									/* Finally, issue the call */
									buildQueue();
								};
							})(callIndex);
	
							Data(element).delayBegin = (new Date()).getTime();
							Data(element).delay = parseFloat(opts.delay);
							Data(element).delayTimer = {
								setTimeout: setTimeout(buildQueue, parseFloat(opts.delay)),
								next: delayComplete
							};
						} else {
							buildQueue();
						}
						/* Otherwise, the call undergoes element queueing as normal. */
						/* Note: To interoperate with jQuery, Velocity uses jQuery's own $.queue() stack for queuing logic. */
					} else {
						$.queue(element, opts.queue, function(next, clearQueue) {
							/* If the clearQueue flag was passed in by the stop command, resolve this call's promise. (Promises can only be resolved once,
							 so it's fine if this is repeatedly triggered for each element in the associated call.) */
							if (clearQueue === true) {
								if (promiseData.promise) {
									promiseData.resolver(elements);
								}
	
								/* Do not continue with animation queueing. */
								return true;
							}
	
							/* This flag indicates to the upcoming completeCall() function that this queue entry was initiated by Velocity.
							 See completeCall() for further details. */
							Velocity.velocityQueueEntryFlag = true;
	
							buildQueue(next);
						});
					}
	
					/*********************
					 Auto-Dequeuing
					 *********************/
	
					/* As per jQuery's $.queue() behavior, to fire the first non-custom-queue entry on an element, the element
					 must be dequeued if its queue stack consists *solely* of the current call. (This can be determined by checking
					 for the "inprogress" item that jQuery prepends to active queue stack arrays.) Regardless, whenever the element's
					 queue is further appended with additional items -- including $.delay()'s or even $.animate() calls, the queue's
					 first entry is automatically fired. This behavior contrasts that of custom queues, which never auto-fire. */
					/* Note: When an element set is being subjected to a non-parallel Velocity call, the animation will not begin until
					 each one of the elements in the set has reached the end of its individually pre-existing queue chain. */
					/* Note: Unfortunately, most people don't fully grasp jQuery's powerful, yet quirky, $.queue() function.
					 Lean more here: http://stackoverflow.com/questions/1058158/can-somebody-explain-jquery-queue-to-me */
					if ((opts.queue === "" || opts.queue === "fx") && $.queue(element)[0] !== "inprogress") {
						$.dequeue(element);
					}
				}
	
				/**************************
				 Element Set Iteration
				 **************************/
	
				/* If the "nodeType" property exists on the elements variable, we're animating a single element.
				 Place it in an array so that $.each() can iterate over it. */
				$.each(elements, function(i, element) {
					/* Ensure each element in a set has a nodeType (is a real element) to avoid throwing errors. */
					if (Type.isNode(element)) {
						processElement(element, i);
					}
				});
	
				/******************
				 Option: Loop
				 ******************/
	
				/* The loop option accepts an integer indicating how many times the element should loop between the values in the
				 current call's properties map and the element's property values prior to this call. */
				/* Note: The loop option's logic is performed here -- after element processing -- because the current call needs
				 to undergo its queue insertion prior to the loop option generating its series of constituent "reverse" calls,
				 which chain after the current call. Two reverse calls (two "alternations") constitute one loop. */
				opts = $.extend({}, Velocity.defaults, options);
				opts.loop = parseInt(opts.loop, 10);
				var reverseCallsCount = (opts.loop * 2) - 1;
	
				if (opts.loop) {
					/* Double the loop count to convert it into its appropriate number of "reverse" calls.
					 Subtract 1 from the resulting value since the current call is included in the total alternation count. */
					for (var x = 0; x < reverseCallsCount; x++) {
						/* Since the logic for the reverse action occurs inside Queueing and therefore this call's options object
						 isn't parsed until then as well, the current call's delay option must be explicitly passed into the reverse
						 call so that the delay logic that occurs inside *Pre-Queueing* can process it. */
						var reverseOptions = {
							delay: opts.delay,
							progress: opts.progress
						};
	
						/* If a complete callback was passed into this call, transfer it to the loop redirect's final "reverse" call
						 so that it's triggered when the entire redirect is complete (and not when the very first animation is complete). */
						if (x === reverseCallsCount - 1) {
							reverseOptions.display = opts.display;
							reverseOptions.visibility = opts.visibility;
							reverseOptions.complete = opts.complete;
						}
	
						animate(elements, "reverse", reverseOptions);
					}
				}
	
				/***************
				 Chaining
				 ***************/
	
				/* Return the elements back to the call chain, with wrapped elements taking precedence in case Velocity was called via the $.fn. extension. */
				return getChain();
			};
	
			/* Turn Velocity into the animation function, extended with the pre-existing Velocity object. */
			Velocity = $.extend(animate, Velocity);
			/* For legacy support, also expose the literal animate method. */
			Velocity.animate = animate;
	
			/**************
			 Timing
			 **************/
	
			/* Ticker function. */
			var ticker = window.requestAnimationFrame || rAFShim;
	
			/* Inactive browser tabs pause rAF, which results in all active animations immediately sprinting to their completion states when the tab refocuses.
			 To get around this, we dynamically switch rAF to setTimeout (which the browser *doesn't* pause) when the tab loses focus. We skip this for mobile
			 devices to avoid wasting battery power on inactive tabs. */
			/* Note: Tab focus detection doesn't work on older versions of IE, but that's okay since they don't support rAF to begin with. */
			if (!Velocity.State.isMobile && document.hidden !== undefined) {
				var updateTicker = function() {
					/* Reassign the rAF function (which the global tick() function uses) based on the tab's focus state. */
					if (document.hidden) {
						ticker = function(callback) {
							/* The tick function needs a truthy first argument in order to pass its internal timestamp check. */
							return setTimeout(function() {
								callback(true);
							}, 16);
						};
	
						/* The rAF loop has been paused by the browser, so we manually restart the tick. */
						tick();
					} else {
						ticker = window.requestAnimationFrame || rAFShim;
					}
				};
	
				/* Page could be sitting in the background at this time (i.e. opened as new tab) so making sure we use correct ticker from the start */
				updateTicker();
	
				/* And then run check again every time visibility changes */
				document.addEventListener("visibilitychange", updateTicker);
			}
	
			/************
			 Tick
			 ************/
	
			/* Note: All calls to Velocity are pushed to the Velocity.State.calls array, which is fully iterated through upon each tick. */
			function tick(timestamp) {
				/* An empty timestamp argument indicates that this is the first tick occurence since ticking was turned on.
				 We leverage this metadata to fully ignore the first tick pass since RAF's initial pass is fired whenever
				 the browser's next tick sync time occurs, which results in the first elements subjected to Velocity
				 calls being animated out of sync with any elements animated immediately thereafter. In short, we ignore
				 the first RAF tick pass so that elements being immediately consecutively animated -- instead of simultaneously animated
				 by the same Velocity call -- are properly batched into the same initial RAF tick and consequently remain in sync thereafter. */
				if (timestamp) {
					/* We normally use RAF's high resolution timestamp but as it can be significantly offset when the browser is
					 under high stress we give the option for choppiness over allowing the browser to drop huge chunks of frames.
					 We use performance.now() and shim it if it doesn't exist for when the tab is hidden. */
					var timeCurrent = Velocity.timestamp && timestamp !== true ? timestamp : performance.now();
	
					/********************
					 Call Iteration
					 ********************/
	
					var callsLength = Velocity.State.calls.length;
	
					/* To speed up iterating over this array, it is compacted (falsey items -- calls that have completed -- are removed)
					 when its length has ballooned to a point that can impact tick performance. This only becomes necessary when animation
					 has been continuous with many elements over a long period of time; whenever all active calls are completed, completeCall() clears Velocity.State.calls. */
					if (callsLength > 10000) {
						Velocity.State.calls = compactSparseArray(Velocity.State.calls);
						callsLength = Velocity.State.calls.length;
					}
	
					/* Iterate through each active call. */
					for (var i = 0; i < callsLength; i++) {
						/* When a Velocity call is completed, its Velocity.State.calls entry is set to false. Continue on to the next call. */
						if (!Velocity.State.calls[i]) {
							continue;
						}
	
						/************************
						 Call-Wide Variables
						 ************************/
	
						var callContainer = Velocity.State.calls[i],
								call = callContainer[0],
								opts = callContainer[2],
								timeStart = callContainer[3],
								firstTick = !timeStart,
								tweenDummyValue = null,
								pauseObject = callContainer[5],
								millisecondsEllapsed = callContainer[6];
	
	
	
						/* If timeStart is undefined, then this is the first time that this call has been processed by tick().
						 We assign timeStart now so that its value is as close to the real animation start time as possible.
						 (Conversely, had timeStart been defined when this call was added to Velocity.State.calls, the delay
						 between that time and now would cause the first few frames of the tween to be skipped since
						 percentComplete is calculated relative to timeStart.) */
						/* Further, subtract 16ms (the approximate resolution of RAF) from the current time value so that the
						 first tick iteration isn't wasted by animating at 0% tween completion, which would produce the
						 same style value as the element's current value. */
						if (!timeStart) {
							timeStart = Velocity.State.calls[i][3] = timeCurrent - 16;
						}
	
						/* If a pause object is present, skip processing unless it has been set to resume */
						if (pauseObject) {
							if (pauseObject.resume === true) {
								/* Update the time start to accomodate the paused completion amount */
								timeStart = callContainer[3] = Math.round(timeCurrent - millisecondsEllapsed - 16);
	
								/* Remove pause object after processing */
								callContainer[5] = null;
							} else {
								continue;
							}
						}
	
						millisecondsEllapsed = callContainer[6] = timeCurrent - timeStart;
	
						/* The tween's completion percentage is relative to the tween's start time, not the tween's start value
						 (which would result in unpredictable tween durations since JavaScript's timers are not particularly accurate).
						 Accordingly, we ensure that percentComplete does not exceed 1. */
						var percentComplete = Math.min((millisecondsEllapsed) / opts.duration, 1);
	
						/**********************
						 Element Iteration
						 **********************/
	
						/* For every call, iterate through each of the elements in its set. */
						for (var j = 0, callLength = call.length; j < callLength; j++) {
							var tweensContainer = call[j],
									element = tweensContainer.element;
	
							/* Check to see if this element has been deleted midway through the animation by checking for the
							 continued existence of its data cache. If it's gone, or the element is currently paused, skip animating this element. */
							if (!Data(element)) {
								continue;
							}
	
							var transformPropertyExists = false;
	
							/**********************************
							 Display & Visibility Toggling
							 **********************************/
	
							/* If the display option is set to non-"none", set it upfront so that the element can become visible before tweening begins.
							 (Otherwise, display's "none" value is set in completeCall() once the animation has completed.) */
							if (opts.display !== undefined && opts.display !== null && opts.display !== "none") {
								if (opts.display === "flex") {
									var flexValues = ["-webkit-box", "-moz-box", "-ms-flexbox", "-webkit-flex"];
	
									$.each(flexValues, function(i, flexValue) {
										CSS.setPropertyValue(element, "display", flexValue);
									});
								}
	
								CSS.setPropertyValue(element, "display", opts.display);
							}
	
							/* Same goes with the visibility option, but its "none" equivalent is "hidden". */
							if (opts.visibility !== undefined && opts.visibility !== "hidden") {
								CSS.setPropertyValue(element, "visibility", opts.visibility);
							}
	
							/************************
							 Property Iteration
							 ************************/
	
							/* For every element, iterate through each property. */
							for (var property in tweensContainer) {
								/* Note: In addition to property tween data, tweensContainer contains a reference to its associated element. */
								if (tweensContainer.hasOwnProperty(property) && property !== "element") {
									var tween = tweensContainer[property],
											currentValue,
											/* Easing can either be a pre-genereated function or a string that references a pre-registered easing
											 on the Velocity.Easings object. In either case, return the appropriate easing *function*. */
											easing = Type.isString(tween.easing) ? Velocity.Easings[tween.easing] : tween.easing;
	
									/******************************
									 Current Value Calculation
									 ******************************/
	
									if (Type.isString(tween.pattern)) {
										var patternReplace = percentComplete === 1 ?
												function($0, index, round) {
													var result = tween.endValue[index];
	
													return round ? Math.round(result) : result;
												} :
												function($0, index, round) {
													var startValue = tween.startValue[index],
															tweenDelta = tween.endValue[index] - startValue,
															result = startValue + (tweenDelta * easing(percentComplete, opts, tweenDelta));
	
													return round ? Math.round(result) : result;
												};
	
										currentValue = tween.pattern.replace(/{(\d+)(!)?}/g, patternReplace);
									} else if (percentComplete === 1) {
										/* If this is the last tick pass (if we've reached 100% completion for this tween),
										 ensure that currentValue is explicitly set to its target endValue so that it's not subjected to any rounding. */
										currentValue = tween.endValue;
									} else {
										/* Otherwise, calculate currentValue based on the current delta from startValue. */
										var tweenDelta = tween.endValue - tween.startValue;
	
										currentValue = tween.startValue + (tweenDelta * easing(percentComplete, opts, tweenDelta));
										/* If no value change is occurring, don't proceed with DOM updating. */
									}
									if (!firstTick && (currentValue === tween.currentValue)) {
										continue;
									}
	
									tween.currentValue = currentValue;
	
									/* If we're tweening a fake 'tween' property in order to log transition values, update the one-per-call variable so that
									 it can be passed into the progress callback. */
									if (property === "tween") {
										tweenDummyValue = currentValue;
									} else {
										/******************
										 Hooks: Part I
										 ******************/
										var hookRoot;
	
										/* For hooked properties, the newly-updated rootPropertyValueCache is cached onto the element so that it can be used
										 for subsequent hooks in this call that are associated with the same root property. If we didn't cache the updated
										 rootPropertyValue, each subsequent update to the root property in this tick pass would reset the previous hook's
										 updates to rootPropertyValue prior to injection. A nice performance byproduct of rootPropertyValue caching is that
										 subsequently chained animations using the same hookRoot but a different hook can use this cached rootPropertyValue. */
										if (CSS.Hooks.registered[property]) {
											hookRoot = CSS.Hooks.getRoot(property);
	
											var rootPropertyValueCache = Data(element).rootPropertyValueCache[hookRoot];
	
											if (rootPropertyValueCache) {
												tween.rootPropertyValue = rootPropertyValueCache;
											}
										}
	
										/*****************
										 DOM Update
										 *****************/
	
										/* setPropertyValue() returns an array of the property name and property value post any normalization that may have been performed. */
										/* Note: To solve an IE<=8 positioning bug, the unit type is dropped when setting a property value of 0. */
										var adjustedSetData = CSS.setPropertyValue(element, /* SET */
												property,
												tween.currentValue + (IE < 9 && parseFloat(currentValue) === 0 ? "" : tween.unitType),
												tween.rootPropertyValue,
												tween.scrollData);
	
										/*******************
										 Hooks: Part II
										 *******************/
	
										/* Now that we have the hook's updated rootPropertyValue (the post-processed value provided by adjustedSetData), cache it onto the element. */
										if (CSS.Hooks.registered[property]) {
											/* Since adjustedSetData contains normalized data ready for DOM updating, the rootPropertyValue needs to be re-extracted from its normalized form. ?? */
											if (CSS.Normalizations.registered[hookRoot]) {
												Data(element).rootPropertyValueCache[hookRoot] = CSS.Normalizations.registered[hookRoot]("extract", null, adjustedSetData[1]);
											} else {
												Data(element).rootPropertyValueCache[hookRoot] = adjustedSetData[1];
											}
										}
	
										/***************
										 Transforms
										 ***************/
	
										/* Flag whether a transform property is being animated so that flushTransformCache() can be triggered once this tick pass is complete. */
										if (adjustedSetData[0] === "transform") {
											transformPropertyExists = true;
										}
	
									}
								}
							}
	
							/****************
							 mobileHA
							 ****************/
	
							/* If mobileHA is enabled, set the translate3d transform to null to force hardware acceleration.
							 It's safe to override this property since Velocity doesn't actually support its animation (hooks are used in its place). */
							if (opts.mobileHA) {
								/* Don't set the null transform hack if we've already done so. */
								if (Data(element).transformCache.translate3d === undefined) {
									/* All entries on the transformCache object are later concatenated into a single transform string via flushTransformCache(). */
									Data(element).transformCache.translate3d = "(0px, 0px, 0px)";
	
									transformPropertyExists = true;
								}
							}
	
							if (transformPropertyExists) {
								CSS.flushTransformCache(element);
							}
						}
	
						/* The non-"none" display value is only applied to an element once -- when its associated call is first ticked through.
						 Accordingly, it's set to false so that it isn't re-processed by this call in the next tick. */
						if (opts.display !== undefined && opts.display !== "none") {
							Velocity.State.calls[i][2].display = false;
						}
						if (opts.visibility !== undefined && opts.visibility !== "hidden") {
							Velocity.State.calls[i][2].visibility = false;
						}
	
						/* Pass the elements and the timing data (percentComplete, msRemaining, timeStart, tweenDummyValue) into the progress callback. */
						if (opts.progress) {
							opts.progress.call(callContainer[1],
									callContainer[1],
									percentComplete,
									Math.max(0, (timeStart + opts.duration) - timeCurrent),
									timeStart,
									tweenDummyValue);
						}
	
						/* If this call has finished tweening, pass its index to completeCall() to handle call cleanup. */
						if (percentComplete === 1) {
							completeCall(i);
						}
					}
				}
	
				/* Note: completeCall() sets the isTicking flag to false when the last call on Velocity.State.calls has completed. */
				if (Velocity.State.isTicking) {
					ticker(tick);
				}
			}
	
			/**********************
			 Call Completion
			 **********************/
	
			/* Note: Unlike tick(), which processes all active calls at once, call completion is handled on a per-call basis. */
			function completeCall(callIndex, isStopped) {
				/* Ensure the call exists. */
				if (!Velocity.State.calls[callIndex]) {
					return false;
				}
	
				/* Pull the metadata from the call. */
				var call = Velocity.State.calls[callIndex][0],
						elements = Velocity.State.calls[callIndex][1],
						opts = Velocity.State.calls[callIndex][2],
						resolver = Velocity.State.calls[callIndex][4];
	
				var remainingCallsExist = false;
	
				/*************************
				 Element Finalization
				 *************************/
	
				for (var i = 0, callLength = call.length; i < callLength; i++) {
					var element = call[i].element;
	
					/* If the user set display to "none" (intending to hide the element), set it now that the animation has completed. */
					/* Note: display:none isn't set when calls are manually stopped (via Velocity("stop"). */
					/* Note: Display gets ignored with "reverse" calls and infinite loops, since this behavior would be undesirable. */
					if (!isStopped && !opts.loop) {
						if (opts.display === "none") {
							CSS.setPropertyValue(element, "display", opts.display);
						}
	
						if (opts.visibility === "hidden") {
							CSS.setPropertyValue(element, "visibility", opts.visibility);
						}
					}
	
					/* If the element's queue is empty (if only the "inprogress" item is left at position 0) or if its queue is about to run
					 a non-Velocity-initiated entry, turn off the isAnimating flag. A non-Velocity-initiatied queue entry's logic might alter
					 an element's CSS values and thereby cause Velocity's cached value data to go stale. To detect if a queue entry was initiated by Velocity,
					 we check for the existence of our special Velocity.queueEntryFlag declaration, which minifiers won't rename since the flag
					 is assigned to jQuery's global $ object and thus exists out of Velocity's own scope. */
					var data = Data(element);
	
					if (opts.loop !== true && ($.queue(element)[1] === undefined || !/\.velocityQueueEntryFlag/i.test($.queue(element)[1]))) {
						/* The element may have been deleted. Ensure that its data cache still exists before acting on it. */
						if (data) {
							data.isAnimating = false;
							/* Clear the element's rootPropertyValueCache, which will become stale. */
							data.rootPropertyValueCache = {};
	
							var transformHAPropertyExists = false;
							/* If any 3D transform subproperty is at its default value (regardless of unit type), remove it. */
							$.each(CSS.Lists.transforms3D, function(i, transformName) {
								var defaultValue = /^scale/.test(transformName) ? 1 : 0,
										currentValue = data.transformCache[transformName];
	
								if (data.transformCache[transformName] !== undefined && new RegExp("^\\(" + defaultValue + "[^.]").test(currentValue)) {
									transformHAPropertyExists = true;
	
									delete data.transformCache[transformName];
								}
							});
	
							/* Mobile devices have hardware acceleration removed at the end of the animation in order to avoid hogging the GPU's memory. */
							if (opts.mobileHA) {
								transformHAPropertyExists = true;
								delete data.transformCache.translate3d;
							}
	
							/* Flush the subproperty removals to the DOM. */
							if (transformHAPropertyExists) {
								CSS.flushTransformCache(element);
							}
	
							/* Remove the "velocity-animating" indicator class. */
							CSS.Values.removeClass(element, "velocity-animating");
						}
					}
	
					/*********************
					 Option: Complete
					 *********************/
	
					/* Complete is fired once per call (not once per element) and is passed the full raw DOM element set as both its context and its first argument. */
					/* Note: Callbacks aren't fired when calls are manually stopped (via Velocity("stop"). */
					if (!isStopped && opts.complete && !opts.loop && (i === callLength - 1)) {
						/* We throw callbacks in a setTimeout so that thrown errors don't halt the execution of Velocity itself. */
						try {
							opts.complete.call(elements, elements);
						} catch (error) {
							setTimeout(function() {
								throw error;
							}, 1);
						}
					}
	
					/**********************
					 Promise Resolving
					 **********************/
	
					/* Note: Infinite loops don't return promises. */
					if (resolver && opts.loop !== true) {
						resolver(elements);
					}
	
					/****************************
					 Option: Loop (Infinite)
					 ****************************/
	
					if (data && opts.loop === true && !isStopped) {
						/* If a rotateX/Y/Z property is being animated by 360 deg with loop:true, swap tween start/end values to enable
						 continuous iterative rotation looping. (Otherise, the element would just rotate back and forth.) */
						$.each(data.tweensContainer, function(propertyName, tweenContainer) {
							if (/^rotate/.test(propertyName) && ((parseFloat(tweenContainer.startValue) - parseFloat(tweenContainer.endValue)) % 360 === 0)) {
								var oldStartValue = tweenContainer.startValue;
	
								tweenContainer.startValue = tweenContainer.endValue;
								tweenContainer.endValue = oldStartValue;
							}
	
							if (/^backgroundPosition/.test(propertyName) && parseFloat(tweenContainer.endValue) === 100 && tweenContainer.unitType === "%") {
								tweenContainer.endValue = 0;
								tweenContainer.startValue = 100;
							}
						});
	
						Velocity(element, "reverse", {loop: true, delay: opts.delay});
					}
	
					/***************
					 Dequeueing
					 ***************/
	
					/* Fire the next call in the queue so long as this call's queue wasn't set to false (to trigger a parallel animation),
					 which would have already caused the next call to fire. Note: Even if the end of the animation queue has been reached,
					 $.dequeue() must still be called in order to completely clear jQuery's animation queue. */
					if (opts.queue !== false) {
						$.dequeue(element, opts.queue);
					}
				}
	
				/************************
				 Calls Array Cleanup
				 ************************/
	
				/* Since this call is complete, set it to false so that the rAF tick skips it. This array is later compacted via compactSparseArray().
				 (For performance reasons, the call is set to false instead of being deleted from the array: http://www.html5rocks.com/en/tutorials/speed/v8/) */
				Velocity.State.calls[callIndex] = false;
	
				/* Iterate through the calls array to determine if this was the final in-progress animation.
				 If so, set a flag to end ticking and clear the calls array. */
				for (var j = 0, callsLength = Velocity.State.calls.length; j < callsLength; j++) {
					if (Velocity.State.calls[j] !== false) {
						remainingCallsExist = true;
	
						break;
					}
				}
	
				if (remainingCallsExist === false) {
					/* tick() will detect this flag upon its next iteration and subsequently turn itself off. */
					Velocity.State.isTicking = false;
	
					/* Clear the calls array so that its length is reset. */
					delete Velocity.State.calls;
					Velocity.State.calls = [];
				}
			}
	
			/******************
			 Frameworks
			 ******************/
	
			/* Both jQuery and Zepto allow their $.fn object to be extended to allow wrapped elements to be subjected to plugin calls.
			 If either framework is loaded, register a "velocity" extension pointing to Velocity's core animate() method.  Velocity
			 also registers itself onto a global container (window.jQuery || window.Zepto || window) so that certain features are
			 accessible beyond just a per-element scope. This master object contains an .animate() method, which is later assigned to $.fn
			 (if jQuery or Zepto are present). Accordingly, Velocity can both act on wrapped DOM elements and stand alone for targeting raw DOM elements. */
			global.Velocity = Velocity;
	
			if (global !== window) {
				/* Assign the element function to Velocity's core animate() method. */
				global.fn.velocity = animate;
				/* Assign the object function's defaults to Velocity's global defaults object. */
				global.fn.velocity.defaults = Velocity.defaults;
			}
	
			/***********************
			 Packaged Redirects
			 ***********************/
	
			/* slideUp, slideDown */
			$.each(["Down", "Up"], function(i, direction) {
				Velocity.Redirects["slide" + direction] = function(element, options, elementsIndex, elementsSize, elements, promiseData) {
					var opts = $.extend({}, options),
							begin = opts.begin,
							complete = opts.complete,
							inlineValues = {},
							computedValues = {height: "", marginTop: "", marginBottom: "", paddingTop: "", paddingBottom: ""};
	
					if (opts.display === undefined) {
						/* Show the element before slideDown begins and hide the element after slideUp completes. */
						/* Note: Inline elements cannot have dimensions animated, so they're reverted to inline-block. */
						opts.display = (direction === "Down" ? (Velocity.CSS.Values.getDisplayType(element) === "inline" ? "inline-block" : "block") : "none");
					}
	
					opts.begin = function() {
						/* If the user passed in a begin callback, fire it now. */
						if (elementsIndex === 0 && begin) {
							begin.call(elements, elements);
						}
	
						/* Cache the elements' original vertical dimensional property values so that we can animate back to them. */
						for (var property in computedValues) {
							if (!computedValues.hasOwnProperty(property)) {
								continue;
							}
							inlineValues[property] = element.style[property];
	
							/* For slideDown, use forcefeeding to animate all vertical properties from 0. For slideUp,
							 use forcefeeding to start from computed values and animate down to 0. */
							var propertyValue = CSS.getPropertyValue(element, property);
							computedValues[property] = (direction === "Down") ? [propertyValue, 0] : [0, propertyValue];
						}
	
						/* Force vertical overflow content to clip so that sliding works as expected. */
						inlineValues.overflow = element.style.overflow;
						element.style.overflow = "hidden";
					};
	
					opts.complete = function() {
						/* Reset element to its pre-slide inline values once its slide animation is complete. */
						for (var property in inlineValues) {
							if (inlineValues.hasOwnProperty(property)) {
								element.style[property] = inlineValues[property];
							}
						}
	
						/* If the user passed in a complete callback, fire it now. */
						if (elementsIndex === elementsSize - 1) {
							if (complete) {
								complete.call(elements, elements);
							}
							if (promiseData) {
								promiseData.resolver(elements);
							}
						}
					};
	
					Velocity(element, computedValues, opts);
				};
			});
	
			/* fadeIn, fadeOut */
			$.each(["In", "Out"], function(i, direction) {
				Velocity.Redirects["fade" + direction] = function(element, options, elementsIndex, elementsSize, elements, promiseData) {
					var opts = $.extend({}, options),
							complete = opts.complete,
							propertiesMap = {opacity: (direction === "In") ? 1 : 0};
	
					/* Since redirects are triggered individually for each element in the animated set, avoid repeatedly triggering
					 callbacks by firing them only when the final element has been reached. */
					if (elementsIndex !== 0) {
						opts.begin = null;
					}
					if (elementsIndex !== elementsSize - 1) {
						opts.complete = null;
					} else {
						opts.complete = function() {
							if (complete) {
								complete.call(elements, elements);
							}
							if (promiseData) {
								promiseData.resolver(elements);
							}
						};
					}
	
					/* If a display was passed in, use it. Otherwise, default to "none" for fadeOut or the element-specific default for fadeIn. */
					/* Note: We allow users to pass in "null" to skip display setting altogether. */
					if (opts.display === undefined) {
						opts.display = (direction === "In" ? "auto" : "none");
					}
	
					Velocity(this, propertiesMap, opts);
				};
			});
	
			return Velocity;
		}((window.jQuery || window.Zepto || window), window, (window ? window.document : undefined));
	}));
	
	/******************
	 Known Issues
	 ******************/
	
	/* The CSS spec mandates that the translateX/Y/Z transforms are %-relative to the element itself -- not its parent.
	 Velocity, however, doesn't make this distinction. Thus, converting to or from the % unit with these subproperties
	 will produce an inaccurate conversion value. The same issue exists with the cx/cy attributes of SVG circles and ellipses. */


/***/ },
/* 318 */,
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(56);
	var settle = __webpack_require__(667);
	var buildURL = __webpack_require__(670);
	var parseHeaders = __webpack_require__(676);
	var isURLSameOrigin = __webpack_require__(674);
	var createError = __webpack_require__(322);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(669);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED'));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(672);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        if (request.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ },
/* 320 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ },
/* 321 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(666);
	
	/**
	 * Create an Error with the specified message, config, error code, and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, response);
	};


/***/ },
/* 323 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _lodash = __webpack_require__(40);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _reactModal = __webpack_require__(30);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _reactRedux = __webpack_require__(12);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _components = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_components.GeneralError, null);
	
	var _ref2 = _react2.default.createElement(
	  'h2',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'EMAIL_MODAL_TITLE' })
	);
	
	var _ref3 = _react2.default.createElement(
	  'p',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'EMAIL_MODAL_TEXT' })
	);
	
	var EmailCapture = function (_React$Component) {
	  (0, _inherits3.default)(EmailCapture, _React$Component);
	
	  function EmailCapture(props) {
	    (0, _classCallCheck3.default)(this, EmailCapture);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (EmailCapture.__proto__ || (0, _getPrototypeOf2.default)(EmailCapture)).call(this, props));
	
	    var open = false;
	
	    if (!_lodash2.default.isEmpty(_this.props.user) && _lodash2.default.isEmpty(_this.props.user.email)) {
	      open = true;
	    }
	
	    _this.state = {
	      open: open,
	      loading: false,
	      showErrorWithoutBlur: false,
	      email: { valid: false, value: '' },
	      activateSubmitButton: false
	    };
	
	    _this.callback = _this.callback.bind(_this);
	    _this.submit = _this.submit.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(EmailCapture, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.user.email !== this.props.user.email) {
	        if (!_lodash2.default.isEmpty(nextProps.user) && _lodash2.default.isEmpty(nextProps.user.email)) {
	          this.setState({
	            open: true
	          });
	        } else {
	          this.setState({
	            open: false
	          });
	        }
	      }
	    }
	  }, {
	    key: 'callback',
	    value: function callback(name, values) {
	      this.setState({ email: values, activateSubmitButton: !!values.valid });
	    }
	  }, {
	    key: 'confirmationWithEmailGtmEvent',
	    value: function confirmationWithEmailGtmEvent(params) {
	      if (window.dataLayer) {
	        window.dataLayer.push({
	          'event': 'emailConfirmation',
	          'userData': {
	            'email': params.email
	          }
	        });
	      }
	    }
	  }, {
	    key: 'submit',
	    value: function submit(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	
	      if (this.state.email.valid) {
	        this.setState({ loading: true });
	
	        var params = { email: this.state.email.value };
	        _frilansFinans.UserService.update(params).then(function () {
	          _this2.setState({
	            loading: false,
	            error: false
	          });
	          _this2.confirmationWithEmailGtmEvent(params);
	        }).catch(function (error) {
	          var errors = _frilansFinans.UserService.getError(error);
	
	          _this2.setState({
	            loading: false,
	            error: true,
	            errorMessage: errors
	          });
	        });
	      }
	    }
	  }, {
	    key: 'renderError',
	    value: function renderError() {
	      if (this.state.error) {
	        if (!this.state.errorMessage) {
	          return _ref;
	        } else {
	          return _react2.default.createElement(
	            'div',
	            null,
	            this.state.errorMessage.map(function (error, i) {
	              return _react2.default.createElement(
	                'p',
	                { className: 'error', key: i },
	                error
	              );
	            })
	          );
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactModal2.default,
	        {
	          className: 'modal-pop-complete-information',
	          contentLabel: '',
	          isOpen: this.state.open },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-left-column' },
	          _ref2,
	          _ref3,
	          _react2.default.createElement(_components.InputField, {
	            type: 'text',
	            inputMode: 'email',
	            validationType: 'email',
	            name: 'email',
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('EMAIL'),
	            callback: this.callback,
	            required: 'true',
	            minLength: '3',
	            errorMessage: (0, _proxyCounterpart.proxyCounterpart)('EMAIL_ERROR'),
	            showErrorWithoutBlur: this.state.showErrorWithoutBlur }),
	          this.renderError(),
	          _react2.default.createElement(
	            'div',
	            { className: 'button-holder' },
	            _react2.default.createElement(_components.SpinnerButton, {
	              text: (0, _proxyCounterpart.proxyCounterpart)('SAVE'),
	              loading: this.state.loading,
	              classes: 'btn cover',
	              callback: this.submit,
	              disabled: !this.state.activateSubmitButton
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-right-column' },
	          _react2.default.createElement('img', { src: (0, _proxyCounterpart.proxyCounterpart)('EMAIL_MODAL_IMAGE') })
	        )
	      );
	    }
	  }]);
	  return EmailCapture;
	}(_react2.default.Component);
	
	function mapStateToProps(state) {
	  return {
	    user: state.user
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(EmailCapture);

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(30);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _spinner = __webpack_require__(57);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_spinner.Spinner, null);
	
	var _ref2 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CLOSE' });
	
	var CloseModal = function (_React$Component) {
	  (0, _inherits3.default)(CloseModal, _React$Component);
	
	  function CloseModal() {
	    (0, _classCallCheck3.default)(this, CloseModal);
	    return (0, _possibleConstructorReturn3.default)(this, (CloseModal.__proto__ || (0, _getPrototypeOf2.default)(CloseModal)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CloseModal, [{
	    key: 'createMarkup',
	    value: function createMarkup(html) {
	      return { __html: html };
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var content = _ref;
	
	      if (this.props.headline && this.props.body) {
	        content = _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h2',
	            null,
	            this.props.headline
	          ),
	          _react2.default.createElement('p', { dangerouslySetInnerHTML: this.createMarkup(_frilansFinans.Utils.getLineBreaks(this.props.body)) })
	        );
	      }
	
	      return content;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactModal2.default,
	        {
	          className: 'modal',
	          contentLabel: '',
	          isOpen: true,
	          onRequestClose: this.props.close },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-content confirm-modal' },
	          _react2.default.createElement('button', { className: 'close', onClick: this.props.close }),
	          this.renderContent(),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn', onClick: this.props.close },
	            _ref2
	          )
	        )
	      );
	    }
	  }]);
	  return CloseModal;
	}(_react2.default.Component);
	
	exports.default = CloseModal;

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(20);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActivityDasboardButton = function (_React$Component) {
	  (0, _inherits3.default)(ActivityDasboardButton, _React$Component);
	
	  function ActivityDasboardButton() {
	    (0, _classCallCheck3.default)(this, ActivityDasboardButton);
	    return (0, _possibleConstructorReturn3.default)(this, (ActivityDasboardButton.__proto__ || (0, _getPrototypeOf2.default)(ActivityDasboardButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ActivityDasboardButton, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactRouter.Link,
	        {
	          to: this.props.link,
	          className: 'dashboard-button ' + this.props.buttonStyle,
	          target: this.props.openTab ? '_blank' : '_self'
	        },
	        _react2.default.createElement('img', { className: 'dashboard-button-icon ' + this.props.buttonStyle, src: this.props.icon }),
	        _react2.default.createElement(_reactTranslateComponent2.default, {
	          className: 'dashboard-button-text ' + this.props.buttonStyle,
	          content: this.props.title
	        })
	      );
	    }
	  }]);
	  return ActivityDasboardButton;
	}(_react2.default.Component);
	
	exports.default = ActivityDasboardButton;

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CountryPicker = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _velocityAnimate = __webpack_require__(317);
	
	var _velocityAnimate2 = _interopRequireDefault(_velocityAnimate);
	
	var _arrowDown = __webpack_require__(211);
	
	var _arrowDown2 = _interopRequireDefault(_arrowDown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 15/03/16.
	 */
	
	var _ref = _react2.default.createElement(
	  'span',
	  { className: 'selected' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SWEDEN' }),
	  _react2.default.createElement(
	    'span',
	    { className: 'ml-10' },
	    _react2.default.createElement(_arrowDown2.default, { width: '15px', height: '10px', color: 'blue-light' })
	  )
	);
	
	var _ref2 = _react2.default.createElement(
	  'li',
	  { role: 'menuitem' },
	  _react2.default.createElement(
	    'a',
	    { href: 'https://www.invoicery.dk/' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'DENMARK' })
	  )
	);
	
	var _ref3 = _react2.default.createElement(
	  'li',
	  { role: 'menuitem' },
	  _react2.default.createElement(
	    'a',
	    { href: 'https://www.frilansfinans.fi/' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'FINLAND' })
	  )
	);
	
	var _ref4 = _react2.default.createElement(
	  'li',
	  { role: 'menuitem' },
	  _react2.default.createElement(
	    'a',
	    { href: 'https://www.frilansfrance.fr/' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'FRANCE' })
	  )
	);
	
	var _ref5 = _react2.default.createElement(
	  'li',
	  { role: 'menuitem' },
	  _react2.default.createElement(
	    'a',
	    { href: 'https://www.frilansfinans.no' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'NORWAY' })
	  )
	);
	
	var _ref6 = _react2.default.createElement(
	  'li',
	  { role: 'menuitem' },
	  _react2.default.createElement(
	    'a',
	    { href: '#' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SWEDEN' })
	  )
	);
	
	var _ref7 = _react2.default.createElement(
	  'li',
	  { role: 'menuitem' },
	  _react2.default.createElement(
	    'a',
	    { href: 'https://www.invoicery.co.uk/' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'UK' })
	  )
	);
	
	var CountryPicker = exports.CountryPicker = function (_React$Component) {
	  (0, _inherits3.default)(CountryPicker, _React$Component);
	
	  function CountryPicker(props) {
	    (0, _classCallCheck3.default)(this, CountryPicker);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (CountryPicker.__proto__ || (0, _getPrototypeOf2.default)(CountryPicker)).call(this, props));
	
	    _this.state = {
	      menuOpen: false
	    };
	
	    _this.handleMenuToggle = _this.handleMenuToggle.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(CountryPicker, [{
	    key: 'handleMenuToggle',
	    value: function handleMenuToggle() {
	      var _this2 = this;
	
	      this.setState({
	        menuOpen: !this.state.menuOpen
	      }, function () {
	        if (_this2.state.menuOpen) {
	          (0, _velocityAnimate2.default)(_this2.refs.menu, 'slideDown', { duration: 200 });
	        } else {
	          (0, _velocityAnimate2.default)(_this2.refs.menu, 'slideUp', { duration: 200 });
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'ul',
	        { className: 'select-list hide-tablet', role: 'menu', onClick: this.handleMenuToggle },
	        _react2.default.createElement(
	          'li',
	          null,
	          _ref,
	          _react2.default.createElement(
	            'ul',
	            { className: 'select-list-sub country-menu', role: 'menu', 'aria-hidden': 'true', ref: 'menu' },
	            _ref2,
	            _ref3,
	            _ref4,
	            _ref5,
	            _ref6,
	            _ref7
	          )
	        )
	      );
	    }
	  }]);
	  return CountryPicker;
	}(_react2.default.Component);
	
	exports.default = CountryPicker;

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LocalePicker = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _localeListItem = __webpack_require__(693);
	
	var _localeListItem2 = _interopRequireDefault(_localeListItem);
	
	var _reactRedux = __webpack_require__(12);
	
	var _velocityAnimate = __webpack_require__(317);
	
	var _velocityAnimate2 = _interopRequireDefault(_velocityAnimate);
	
	var _arrowDown = __webpack_require__(211);
	
	var _arrowDown2 = _interopRequireDefault(_arrowDown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'span',
	  { className: 'ml-10' },
	  _react2.default.createElement(_arrowDown2.default, { width: '15px', height: '10px', color: 'blue-light' })
	); /**
	    * Created by staffanrantzow on 15/03/16.
	    */
	
	var LocalePicker = exports.LocalePicker = function (_React$Component) {
	  (0, _inherits3.default)(LocalePicker, _React$Component);
	
	  function LocalePicker(props) {
	    (0, _classCallCheck3.default)(this, LocalePicker);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (LocalePicker.__proto__ || (0, _getPrototypeOf2.default)(LocalePicker)).call(this, props));
	
	    _this.state = {
	      menuOpen: false
	    };
	
	    _this.handleMenuToggle = _this.handleMenuToggle.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(LocalePicker, [{
	    key: 'handleMenuToggle',
	    value: function handleMenuToggle() {
	      var _this2 = this;
	
	      this.setState({
	        menuOpen: !this.state.menuOpen
	      }, function () {
	        if (_this2.state.menuOpen) {
	          (0, _velocityAnimate2.default)(_this2.refs.menu, 'slideDown', { duration: 200 });
	        } else {
	          (0, _velocityAnimate2.default)(_this2.refs.menu, 'slideUp', { duration: 200 });
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var selectedLanguageClassNames = 'sprite-image flag flag-' + this.props.selectedLocale;
	
	      return _react2.default.createElement(
	        'ul',
	        { className: 'select-list lang-menu hide-tablet', role: 'menu', onClick: this.handleMenuToggle },
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'selected' },
	            _react2.default.createElement('span', { className: selectedLanguageClassNames }),
	            _ref
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'select-list-sub', role: 'menu', 'aria-hidden': 'true', ref: 'menu' },
	            this.props.locales.map(function (locale) {
	              return _react2.default.createElement(_localeListItem2.default, { lang: locale, key: locale });
	            })
	          )
	        )
	      );
	    }
	  }]);
	  return LocalePicker;
	}(_react2.default.Component);
	
	function mapStateToProps(state) {
	  return {
	    selectedLocale: state.i18n.locale
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(LocalePicker);

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _lodash = __webpack_require__(40);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _errorMessage = __webpack_require__(160);
	
	var _errorMessage2 = _interopRequireDefault(_errorMessage);
	
	var _inputFieldSimple = __webpack_require__(1301);
	
	var _inputFieldSimple2 = _interopRequireDefault(_inputFieldSimple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InputFieldSimple = function (_React$Component) {
	  (0, _inherits3.default)(InputFieldSimple, _React$Component);
	
	  function InputFieldSimple(props) {
	    (0, _classCallCheck3.default)(this, InputFieldSimple);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (InputFieldSimple.__proto__ || (0, _getPrototypeOf2.default)(InputFieldSimple)).call(this, props));
	
	    _this.state = {
	      value: _this.props.value ? _this.props.value : ''
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(InputFieldSimple, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value || this.state.value !== nextProps.value) {
	        this.setState({ value: nextProps.value });
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(event) {
	      event.preventDefault();
	      var value = event.target.value;
	      this.setState({ value: value });
	      this.props.changed(value);
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(event) {
	      event.preventDefault();
	      var value = event.target.value;
	
	      if (_lodash2.default.isFunction(this.props.blurred)) {
	        this.props.blurred(value);
	      }
	    }
	  }, {
	    key: 'getClasses',
	    value: function getClasses(name) {
	      var globalClasses = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	      var classes = _inputFieldSimple2.default[name];
	
	      if (this.props.showError) {
	        classes += ' ' + _inputFieldSimple2.default['is-error'];
	      }
	
	      if (!_lodash2.default.isEmpty(globalClasses)) {
	        classes += ' ' + globalClasses.join(' ');
	      }
	
	      return classes;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.isVisible) {
	        return false;
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: this.getClasses('wrapper', ['form-row-item']) },
	        _react2.default.createElement(
	          'label',
	          {
	            className: this.getClasses('label'),
	            htmlFor: this.props.name },
	          this.props.label
	        ),
	        _react2.default.createElement('input', {
	          ref: this.props.element,
	          className: this.getClasses('input'),
	          type: this.props.type,
	          name: this.props.name,
	          value: this.state.value,
	          placeholder: this.props.placeholder,
	          disabled: this.props.isDisabled,
	          onChange: this.onChange,
	          onBlur: this.onBlur }),
	        _react2.default.createElement(_errorMessage2.default, { show: this.props.showError, errorMessage: this.props.errorMessage, marginTop: 15 })
	      );
	    }
	  }]);
	  return InputFieldSimple;
	}(_react2.default.Component);
	
	exports.default = InputFieldSimple;

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InputField = undefined;
	
	var _extends2 = __webpack_require__(27);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fieldValidator = __webpack_require__(697);
	
	var _fieldValidator2 = _interopRequireDefault(_fieldValidator);
	
	var _inputField = __webpack_require__(1302);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var _eye = __webpack_require__(214);
	
	var _eye2 = _interopRequireDefault(_eye);
	
	var _shutEye = __webpack_require__(741);
	
	var _shutEye2 = _interopRequireDefault(_shutEye);
	
	var _errorMessage = __webpack_require__(160);
	
	var _errorMessage2 = _interopRequireDefault(_errorMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 16/03/16.
	 */
	
	var _ref = _react2.default.createElement(_eye2.default, null);
	
	var _ref2 = _react2.default.createElement(_shutEye2.default, null);
	
	var InputField = exports.InputField = function (_React$Component) {
	  (0, _inherits3.default)(InputField, _React$Component);
	
	  function InputField(props) {
	    (0, _classCallCheck3.default)(this, InputField);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (InputField.__proto__ || (0, _getPrototypeOf2.default)(InputField)).call(this, props));
	
	    _this.state = {
	      value: _this.props.value ? _this.props.value : '',
	      valid: false,
	      validationType: _this.props.validationType,
	      type: _this.props.type,
	      required: _this.props.required === 'true',
	      minLength: _this.props.minLength ? parseInt(_this.props.minLength) : 0,
	      maxLength: _this.props.maxLength ? parseInt(_this.props.maxLength) : 0,
	      isBlurred: false,
	      disabled: _this.props.disabled === 'true',
	      showErrorWithoutBlur: _this.props.showErrorWithoutBlur,
	      showPassword: false
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    _this.showPassword = _this.showPassword.bind(_this);
	    _this.renderShowPasswordIcon = _this.renderShowPasswordIcon.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(InputField, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.validate();
	    }
	
	    /**
	     * Called when user clicks the submit button
	     * @param nextProps
	     */
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.showErrorWithoutBlur !== this.props.showErrorWithoutBlur) {
	        this.validate();
	      }
	      if (nextProps.value !== this.props.value) {
	        this.setState({
	          value: nextProps.value
	        });
	      }
	      if (nextProps.minLength !== this.props.minLength) {
	        this.setState({ minLength: nextProps.minLength ? parseInt(nextProps.minLength) : 0 }, this.validate);
	      }
	      if (nextProps.maxLength !== this.props.maxLength) {
	        this.setState({ maxLength: nextProps.maxLength ? parseInt(nextProps.maxLength) : 0 }, this.validate);
	      }
	      if (nextProps.required !== this.props.required) {
	        this.setState({ required: nextProps.required === 'true' }, this.validate);
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      this.setState({ value: e.target.value }, function () {
	        if (!this.state.valid || this.state.isBlurred || this.state.showErrorWithoutBlur) {
	          this.validate();
	        }
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur() {
	      this.setState({ isBlurred: true }, function () {
	        this.validate();
	      });
	    }
	  }, {
	    key: 'validate',
	    value: function validate() {
	      var _this2 = this;
	
	      var isValid = _fieldValidator2.default.validate(this.state);
	      this.setState({ valid: isValid }, function () {
	        _this2.sendValueToParent();
	      });
	    }
	
	    /**
	     * Send value to parent Component
	     */
	
	  }, {
	    key: 'sendValueToParent',
	    value: function sendValueToParent() {
	      this.props.callback(this.props.name, {
	        value: this.state.value,
	        valid: this.state.valid
	      });
	    }
	  }, {
	    key: 'shouldShowError',
	    value: function shouldShowError() {
	      return !this.state.valid && (this.state.isBlurred || this.props.showErrorWithoutBlur);
	    }
	  }, {
	    key: 'showPassword',
	    value: function showPassword() {
	      var showPassword = !this.state.showPassword;
	      var type = showPassword ? 'text' : 'password';
	      this.setState({
	        showPassword: showPassword,
	        type: type
	      });
	    }
	  }, {
	    key: 'renderShowPasswordIcon',
	    value: function renderShowPasswordIcon() {
	      if (this.props.showPasswordIcon) {
	        return _react2.default.createElement(
	          'span',
	          {
	            className: 'input-icon',
	            onClick: this.showPassword
	          },
	          this.state.showPassword ? _ref : _ref2
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var classes, opts;
	
	      classes = 'input-wrapper ' + (this.props.classes || '');
	      opts = {};
	
	      if (this.props.disabled === 'true') {
	        opts['disabled'] = 'disabled';
	      }
	      if (this.state.required) {
	        opts['required'] = 'required';
	      }
	
	      if (this.shouldShowError()) {
	        classes += ' ' + _inputField2.default['validation-error'];
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: classes },
	        _react2.default.createElement(
	          'div',
	          { className: 'input-password-container' },
	          this.renderShowPasswordIcon(),
	          _react2.default.createElement('input', (0, _extends3.default)({
	            type: this.state.type,
	            id: this.props.name,
	            name: this.props.name,
	            value: this.state.value,
	            onChange: this.onChange,
	            onBlur: this.onBlur,
	            onKeyUp: this.props.onKeyUp,
	            onClick: this.props.onClick,
	            inputMode: this.props.inputMode ? this.props.inputMode : 'text'
	          }, opts)),
	          _react2.default.createElement('label', { htmlFor: this.props.name, placeholder: this.props.placeholder, alt: this.props.placeholder })
	        ),
	        _react2.default.createElement(_errorMessage2.default, { show: this.shouldShowError(), errorMessage: this.props.errorMessage })
	      );
	    }
	  }]);
	  return InputField;
	}(_react2.default.Component);
	
	exports.default = InputField;

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InvoiceActivityStatus = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _utils = __webpack_require__(29);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _frilansFinans = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 17/03/16.
	 */
	
	var _ref = _react2.default.createElement('div', { className: 'invoice-activity-status-step-circle' });
	
	var InvoiceActivityStatus = exports.InvoiceActivityStatus = function (_React$Component) {
	  (0, _inherits3.default)(InvoiceActivityStatus, _React$Component);
	
	  function InvoiceActivityStatus() {
	    (0, _classCallCheck3.default)(this, InvoiceActivityStatus);
	    return (0, _possibleConstructorReturn3.default)(this, (InvoiceActivityStatus.__proto__ || (0, _getPrototypeOf2.default)(InvoiceActivityStatus)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(InvoiceActivityStatus, [{
	    key: 'getSteps',
	    value: function getSteps() {
	      var salaryPaid = this.getSalaryPaid();
	      var invoicePaid = this.getInvoicePaid();
	
	      var steps = [{ type: 'salary', complete: salaryPaid, denied: false }, { type: 'invoice', complete: invoicePaid, denied: false }];
	
	      if (this.isInvoicePaidBeforeSalary(invoicePaid, salaryPaid) || this.isWaitingForPayment() && !salaryPaid) {
	        steps = steps.reverse();
	      }
	      steps.unshift({
	        type: 'approval',
	        complete: this.isWaitingForPayment() || this.isApproved(),
	        denied: this.isNotApproved()
	      });
	
	      return steps;
	    }
	  }, {
	    key: 'getInvoicePaid',
	    value: function getInvoicePaid() {
	      var formattedDate = _utils2.default.formatDate(this.props.invoice.fullPaymentDateTime);
	      return formattedDate !== '-' ? formattedDate : 0;
	    }
	  }, {
	    key: 'getSalaryPaid',
	    value: function getSalaryPaid() {
	      var _this2 = this;
	
	      var salaries = this.props.invoice.salaries;
	      if (salaries.length) {
	        var salary = salaries.find(function (salary) {
	          return salary.typeId === _frilansFinans.SalaryTypeConstants.REGULAR_TYPE && salary.userId === +_this2.props.user.id;
	        });
	        if (salary) {
	          var formattedDate = _utils2.default.formatDate(salary.paidAt);
	
	          return formattedDate !== '-' ? formattedDate : 0;
	        }
	      }
	      return 0;
	    }
	  }, {
	    key: 'getSalaryPlannedPaymentAt',
	    value: function getSalaryPlannedPaymentAt() {
	      var _this3 = this;
	
	      var salaries = this.props.invoice.salaries;
	      if (salaries.length) {
	        var salary = salaries.find(function (salary) {
	          return salary.typeId === _frilansFinans.SalaryTypeConstants.REGULAR_TYPE && salary.userId === +_this3.props.user.id;
	        });
	        if (salary) {
	          var formattedDate = _utils2.default.formatDate(salary.plannedPaymentAt);
	
	          return formattedDate !== '-' ? formattedDate : 0;
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'isInvoicePaidBeforeSalary',
	    value: function isInvoicePaidBeforeSalary(invoicePaid, salaryPaid) {
	      if (isNaN(Date.parse(invoicePaid)) || invoicePaid === 0) {
	        return false;
	      }
	
	      if (isNaN(Date.parse(salaryPaid)) || salaryPaid === 0) {
	        return true;
	      }
	
	      return new Date(invoicePaid) < new Date(salaryPaid);
	    }
	  }, {
	    key: 'isAwaitingApproval',
	    value: function isAwaitingApproval() {
	      return this.props.invoice.approvalStatus === 1;
	    }
	  }, {
	    key: 'isApproved',
	    value: function isApproved() {
	      return this.props.invoice.approvalStatus === 2;
	    }
	  }, {
	    key: 'isNotApproved',
	    value: function isNotApproved() {
	      return this.props.invoice.approvalStatus === 3;
	    }
	  }, {
	    key: 'isWaitingForPayment',
	    value: function isWaitingForPayment() {
	      return this.props.invoice.approvalStatus === 4;
	    }
	  }, {
	    key: 'renderStepIcon',
	    value: function renderStepIcon(complete) {
	      var denied = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (denied) {
	        return this.renderDeniedIcon();
	      }
	
	      if (complete) {
	        return this.renderApprovedIcon();
	      }
	
	      return this.renderCircle();
	    }
	  }, {
	    key: 'renderApprovedIcon',
	    value: function renderApprovedIcon() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'invoice-activity-status-step-circle approved' },
	        _react2.default.createElement(
	          'div',
	          { className: 'invoice-activity-status-step-circle-icon' },
	          _react2.default.createElement('img', { src: __webpack_require__(1554) })
	        )
	      );
	    }
	  }, {
	    key: 'renderDeniedIcon',
	    value: function renderDeniedIcon() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'invoice-activity-status-step-circle denied' },
	        _react2.default.createElement(
	          'div',
	          { className: 'invoice-activity-status-step-circle-icon' },
	          _react2.default.createElement('img', { src: __webpack_require__(1561) })
	        )
	      );
	    }
	  }, {
	    key: 'renderCircle',
	    value: function renderCircle() {
	      return _ref;
	    }
	  }, {
	    key: 'renderStatusText',
	    value: function renderStatusText() {
	      if (this.isAwaitingApproval()) {
	        return 'WAIT_JUDGEMENT';
	      }
	
	      if (this.isApproved()) {
	        return 'APPROVED';
	      }
	
	      if (this.isNotApproved()) {
	        return 'NOT_APPROVED';
	      }
	
	      if (this.isWaitingForPayment()) {
	        return 'APPROVED_WITH_RES';
	      }
	
	      return '';
	    }
	  }, {
	    key: 'renderStepText',
	    value: function renderStepText(step, i) {
	      if (step.type === 'salary') {
	        return this.renderCompleteStepText(step, 'SALARY_PAYMENT', i);
	      }
	      if (step.type === 'invoice') {
	        return this.renderCompleteStepText(step, 'INVOICE_PAYMENT', i);
	      }
	
	      return this.renderCompleteStepText(step, this.renderStatusText(), i);
	    }
	  }, {
	    key: 'renderCompleteStepText',
	    value: function renderCompleteStepText(step, translate, i) {
	      return _react2.default.createElement(
	        'div',
	        { key: i, className: 'invoice-activity-status-text' },
	        _react2.default.createElement(
	          'p',
	          { className: 'invoice-activity-status-text-title ' },
	          _react2.default.createElement(_reactTranslateComponent2.default, { content: translate })
	        ),
	        this.renderSubtitle(step)
	      );
	    }
	  }, {
	    key: 'renderSubtitle',
	    value: function renderSubtitle(step) {
	      if (step.type === 'salary') {
	        if (step.complete) {
	          return this.renderSubtitleText('PAID', step.complete);
	        } else if (this.getSalaryPlannedPaymentAt()) {
	          return this.renderSubtitleText('EXPECTED_TO', this.getSalaryPlannedPaymentAt());
	        }
	        return false;
	      }
	
	      if (step.type === 'invoice') {
	        return step.complete ? this.renderSubtitleText('INVOICE_PAID', this.props.invoice.fullPaymentDateTime) : false;
	      }
	
	      return step.complete ? this.renderSubtitleText('ORDER_APPROVED', this.props.invoice.sent) : false;
	    }
	  }, {
	    key: 'renderSubtitleText',
	    value: function renderSubtitleText(translate, date) {
	      return _react2.default.createElement(
	        'p',
	        { className: 'invoice-activity-status-text-subtitle' },
	        _react2.default.createElement(_reactTranslateComponent2.default, { content: translate, date: _utils2.default.formatDate(date) })
	      );
	    }
	  }, {
	    key: 'renderStep',
	    value: function renderStep(step, i) {
	      var lineStyle = step.complete ? 'green' : 'dotted';
	      var stepClass = i === 0 ? ' first' : '';
	      var line = i !== 0 ? _react2.default.createElement('div', { className: 'invoice-activity-status-step-line ' + lineStyle }) : null;
	      return _react2.default.createElement(
	        'div',
	        { key: i, className: 'invoice-activity-status-step' + stepClass },
	        line,
	        this.renderStepIcon(step.complete, step.denied)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var steps = this.getSteps();
	      var renderSteps = steps.map(function (step, i) {
	        return _this4.renderStep(step, i);
	      });
	      var renderStepText = steps.map(function (step, i) {
	        return _this4.renderStepText(step, i);
	      });
	      return _react2.default.createElement(
	        'div',
	        { className: 'invoice-activity-status-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'invoice-activity-status-steps' + (this.props.containerStyle || '') },
	          renderSteps
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'invoice-activity-status-text-container' },
	          renderStepText
	        )
	      );
	    }
	  }]);
	  return InvoiceActivityStatus;
	}(_react2.default.Component);
	
	exports.default = InvoiceActivityStatus;

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InvoiceDetailsAmount = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _invoiceToolHelper = __webpack_require__(50);
	
	var _amountHelper = __webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_reactTranslateComponent2.default, { className: 'invoice-details-amount-title', content: 'AMOUNT_TO_BILL_HSD_ROT_EXCL_VAT' });
	
	var _ref2 = _react2.default.createElement(_reactTranslateComponent2.default, { className: 'invoice-details-amount-title', content: 'AMOUNT_TO_BILL_HSD_RUT_EXCL_VAT' });
	
	var _ref3 = _react2.default.createElement(_reactTranslateComponent2.default, { className: 'invoice-details-title', content: 'INVOICE_DETAILS_INVOICE_AMOUNT' });
	
	var _ref4 = _react2.default.createElement(_reactTranslateComponent2.default, { className: 'invoice-details-amount-title', content: 'INVOICE_AMOUNT' });
	
	var _ref5 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CURRENCY' });
	
	var _ref6 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'VAT' });
	
	var _ref7 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'AMOUNT_INCL_VAT' });
	
	var InvoiceDetailsAmount = exports.InvoiceDetailsAmount = function (_React$Component) {
	  (0, _inherits3.default)(InvoiceDetailsAmount, _React$Component);
	
	  function InvoiceDetailsAmount() {
	    (0, _classCallCheck3.default)(this, InvoiceDetailsAmount);
	    return (0, _possibleConstructorReturn3.default)(this, (InvoiceDetailsAmount.__proto__ || (0, _getPrototypeOf2.default)(InvoiceDetailsAmount)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(InvoiceDetailsAmount, [{
	    key: 'getAmountInclVat',
	    value: function getAmountInclVat() {
	      return (0, _amountHelper.amountInclVat)(this.props.invoice.currencyAmount, (0, _invoiceToolHelper.getVatById)(this.props.invoice.taxId));
	    }
	  }, {
	    key: 'renderTaxDeductionPart',
	    value: function renderTaxDeductionPart(invoice) {
	      var taxDeduction = invoice.hsd;
	      if (taxDeduction) {
	        if (taxDeduction.rot) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'invoice-details-amount-details purple-background' },
	            _ref,
	            _react2.default.createElement(
	              'div',
	              { className: 'invoice-details-amount-title' },
	              (0, _amountHelper.toMoney)((0, _amountHelper.calculateRotAmount)(invoice.currencyAmount)) + ' ' + invoice.currencyName
	            )
	          );
	        }
	
	        if (taxDeduction.rut) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'invoice-details-amount-details purple-background' },
	            _ref2,
	            _react2.default.createElement(
	              'div',
	              { className: 'invoice-details-amount-title' },
	              (0, _amountHelper.toMoney)((0, _amountHelper.calculateRutAmount)(invoice.currencyAmount)) + ' ' + invoice.currencyName
	            )
	          );
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var invoice = this.props.invoice;
	
	      if (invoice) {
	        var amount = (0, _amountHelper.toMoney)(invoice.currencyAmount) + ' ' + invoice.currencyName;
	        var _amountInclVat = (0, _amountHelper.toMoney)(this.getAmountInclVat(invoice)) + ' ' + invoice.currencyName;
	        return _react2.default.createElement(
	          'div',
	          { className: 'invoice-details-part-container' },
	          _ref3,
	          _react2.default.createElement(
	            'div',
	            { className: 'invoice-details-amount-container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'invoice-details-amount-details' },
	              _ref4,
	              _react2.default.createElement(
	                'div',
	                { className: 'invoice-details-amount-title' },
	                amount
	              )
	            ),
	            this.renderTaxDeductionPart(invoice),
	            _react2.default.createElement(
	              'div',
	              { className: 'invoice-details-amount-details light' },
	              _react2.default.createElement(
	                'div',
	                { className: 'invoice-details-amount-details-subgroup' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'invoice-details-amount-subtitle' },
	                  _ref5,
	                  ': ' + invoice.currencyName
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'invoice-details-amount-subtitle' },
	                  _ref6,
	                  ': ',
	                  (0, _invoiceToolHelper.getVatById)(invoice.taxId),
	                  '%'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'invoice-details-amount-subtitle' },
	                _ref7,
	                ': ',
	                _amountInclVat
	              )
	            )
	          )
	        );
	      }
	      return null;
	    }
	  }]);
	  return InvoiceDetailsAmount;
	}(_react2.default.Component);
	
	exports.default = InvoiceDetailsAmount;

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InvoiceDetailsDates = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement('div', { className: 'invoice-details-date-divider' });
	
	var _ref2 = _react2.default.createElement(_reactTranslateComponent2.default, { className: 'invoice-details-title', content: 'INVOICE_DETAILS_WORK_DATES' });
	
	var InvoiceDetailsDates = exports.InvoiceDetailsDates = function (_React$Component) {
	  (0, _inherits3.default)(InvoiceDetailsDates, _React$Component);
	
	  function InvoiceDetailsDates() {
	    (0, _classCallCheck3.default)(this, InvoiceDetailsDates);
	    return (0, _possibleConstructorReturn3.default)(this, (InvoiceDetailsDates.__proto__ || (0, _getPrototypeOf2.default)(InvoiceDetailsDates)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(InvoiceDetailsDates, [{
	    key: 'renderInvoiceDates',
	    value: function renderInvoiceDates() {
	      var invoiceDates = [];
	      this.props.invoice.invoiceDates.forEach(function (date) {
	        invoiceDates.push(_react2.default.createElement(
	          'div',
	          {
	            key: date.date,
	            className: 'invoice-details-date-container'
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'invoice-details-date' },
	            date.date
	          ),
	          _ref,
	          _react2.default.createElement(
	            'div',
	            { className: 'invoice-details-date' },
	            date.hours
	          )
	        ));
	      });
	      return invoiceDates;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var invoice = this.props.invoice;
	      if (invoice) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'invoice-details-part-container' },
	          _ref2,
	          _react2.default.createElement(
	            'div',
	            { className: 'invoice-details-border-container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'invoice-details-dates' },
	              this.renderInvoiceDates()
	            )
	          )
	        );
	      }
	      return null;
	    }
	  }]);
	  return InvoiceDetailsDates;
	}(_react2.default.Component);
	
	exports.default = InvoiceDetailsDates;

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InvoiceDetailsInvoicing = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _customerColumn = __webpack_require__(699);
	
	var _customerColumn2 = _interopRequireDefault(_customerColumn);
	
	var _invoicingColumn = __webpack_require__(700);
	
	var _invoicingColumn2 = _interopRequireDefault(_invoicingColumn);
	
	var _invoiceActivityStatus = __webpack_require__(331);
	
	var _invoiceActivityStatus2 = _interopRequireDefault(_invoiceActivityStatus);
	
	var _showMoreInvoice = __webpack_require__(210);
	
	var _showMoreInvoice2 = _interopRequireDefault(_showMoreInvoice);
	
	var _ellipsis = __webpack_require__(161);
	
	var _ellipsis2 = _interopRequireDefault(_ellipsis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'invoice-details-title' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_STATUS' })
	);
	
	var _ref2 = _react2.default.createElement('div', { className: 'invoice-details-column-divider' });
	
	var InvoiceDetailsInvoicing = exports.InvoiceDetailsInvoicing = function (_React$Component) {
	  (0, _inherits3.default)(InvoiceDetailsInvoicing, _React$Component);
	
	  function InvoiceDetailsInvoicing(props) {
	    (0, _classCallCheck3.default)(this, InvoiceDetailsInvoicing);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (InvoiceDetailsInvoicing.__proto__ || (0, _getPrototypeOf2.default)(InvoiceDetailsInvoicing)).call(this, props));
	
	    _this.state = {
	      showMoreList: {
	        show: false
	      }
	    };
	
	    _this.description = _this.description.bind(_this);
	    _this.title = _this.title.bind(_this);
	    _this.toggleShowMoreList = _this.toggleShowMoreList.bind(_this);
	    _this.resetShowMoreList = _this.resetShowMoreList.bind(_this);
	    _this.handleClickOutside = _this.handleClickOutside.bind(_this);
	    _this.renderShowMore = _this.renderShowMore.bind(_this);
	    _this.setWrapperRef = _this.setWrapperRef.bind(_this);
	    _this.renderActivityStatus = _this.renderActivityStatus.bind(_this);
	    _this.showShowMoreButton = _this.showShowMoreButton.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(InvoiceDetailsInvoicing, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('mousedown', this.handleClickOutside);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('mousedown', this.handleClickOutside);
	    }
	  }, {
	    key: 'setWrapperRef',
	    value: function setWrapperRef(node) {
	      this.wrapperRef = node;
	    }
	  }, {
	    key: 'description',
	    value: function description() {
	      return this.props.description ? _react2.default.createElement(_reactTranslateComponent2.default, {
	        className: 'invoice-details-title-description large',
	        content: this.props.description
	      }) : null;
	    }
	  }, {
	    key: 'title',
	    value: function title() {
	      return this.props.title ? _react2.default.createElement(_reactTranslateComponent2.default, {
	        className: 'invoice-details-title large',
	        content: this.props.title
	      }) : _react2.default.createElement(_reactTranslateComponent2.default, {
	        className: 'invoice-details-title large',
	        content: 'INVOICE_DETAILS_ORDER_NUMBER',
	        ordernumber: this.props.title ? null : this.props.invoice.id
	      });
	    }
	  }, {
	    key: 'toggleShowMoreList',
	    value: function toggleShowMoreList() {
	      this.setState({
	        showMoreList: {
	          show: !this.state.showMoreList.show
	        }
	      });
	    }
	  }, {
	    key: 'resetShowMoreList',
	    value: function resetShowMoreList() {
	      this.setState({
	        showMoreList: {
	          invoiceId: null,
	          show: false
	        }
	      });
	    }
	  }, {
	    key: 'handleClickOutside',
	    value: function handleClickOutside(event) {
	      if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
	        this.resetShowMoreList();
	      }
	    }
	  }, {
	    key: 'showShowMoreButton',
	    value: function showShowMoreButton() {
	      return !this.props.isReviewModal && this.props.invoice.approvalStatus === 1 && this.props.invoice.pdfLink;
	    }
	  }, {
	    key: 'renderShowMoreButton',
	    value: function renderShowMoreButton() {
	      if (this.showShowMoreButton()) {
	        return _react2.default.createElement(
	          'div',
	          {
	            ref: this.setWrapperRef,
	            className: 'invoice-details-more',
	            onClick: this.toggleShowMoreList
	          },
	          this.renderShowMore(),
	          _react2.default.createElement(_ellipsis2.default, {
	            colorSchema: 'primary',
	            fill: this.state.showMoreList.show
	          })
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'renderShowMore',
	    value: function renderShowMore() {
	      if (this.state.showMoreList.show) {
	        return _react2.default.createElement(_showMoreInvoice2.default, {
	          invoice: this.props.invoice,
	          user: this.props.user
	        });
	      }
	    }
	  }, {
	    key: 'renderActivityStatus',
	    value: function renderActivityStatus(invoice, user) {
	      return !this.props.isReviewModal ? _react2.default.createElement(
	        'div',
	        { className: 'invoice-view-activity-status-container' },
	        _ref,
	        _react2.default.createElement(_invoiceActivityStatus2.default, {
	          invoice: invoice,
	          user: user
	        })
	      ) : null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var invoice = this.props.invoice;
	      var user = this.props.user;
	      if (invoice && user) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'invoice-details-part-container' },
	          this.title(),
	          this.description(),
	          _react2.default.createElement(
	            'div',
	            { className: 'invoice-details-wrapper' + (this.showShowMoreButton() ? '' : ' pt-20') },
	            this.renderShowMoreButton(),
	            _react2.default.createElement(
	              'div',
	              { className: 'invoice-details-row-container' },
	              _react2.default.createElement(_customerColumn2.default, {
	                showMoreIsVisible: this.showShowMoreButton(),
	                invoice: invoice
	              }),
	              _ref2,
	              _react2.default.createElement(_invoicingColumn2.default, {
	                showMoreIsVisible: this.showShowMoreButton(),
	                invoice: invoice
	              })
	            ),
	            this.renderActivityStatus(invoice, user)
	          )
	        );
	      }
	      return null;
	    }
	  }]);
	  return InvoiceDetailsInvoicing;
	}(_react2.default.Component);
	
	exports.default = InvoiceDetailsInvoicing;

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InvoiceDetailsOutlays = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _supplierLedgersTable = __webpack_require__(378);
	
	var _supplierLedgersTable2 = _interopRequireDefault(_supplierLedgersTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'invoice-details-border-container' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_DETAILS_NO_DEDUCTIONS' })
	);
	
	var _ref2 = _react2.default.createElement(_reactTranslateComponent2.default, { className: 'invoice-details-title', content: 'INVOICE_DETAILS_DEDUCTION' });
	
	var InvoiceDetailsOutlays = exports.InvoiceDetailsOutlays = function (_React$Component) {
	  (0, _inherits3.default)(InvoiceDetailsOutlays, _React$Component);
	
	  function InvoiceDetailsOutlays() {
	    (0, _classCallCheck3.default)(this, InvoiceDetailsOutlays);
	    return (0, _possibleConstructorReturn3.default)(this, (InvoiceDetailsOutlays.__proto__ || (0, _getPrototypeOf2.default)(InvoiceDetailsOutlays)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(InvoiceDetailsOutlays, [{
	    key: 'renderOutlaysTable',
	    value: function renderOutlaysTable() {
	      if (this.props.outlays.length) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'invoice-details-expenses' },
	          _react2.default.createElement(_supplierLedgersTable2.default, {
	            supplierLedgers: this.props.outlays,
	            showDetailColumns: this.props.showDetailColumns,
	            hideOrderNumber: true
	          })
	        );
	      }
	
	      return _ref;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'invoice-details-part-container' },
	        _ref2,
	        this.renderOutlaysTable()
	      );
	    }
	  }]);
	  return InvoiceDetailsOutlays;
	}(_react2.default.Component);
	
	exports.default = InvoiceDetailsOutlays;

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InvoiceDetailsSpecification = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_reactTranslateComponent2.default, { className: 'invoice-details-title', content: 'INVOICE_DETAILS_SPECIFICATION' });
	
	var InvoiceDetailsSpecification = exports.InvoiceDetailsSpecification = function (_React$Component) {
	  (0, _inherits3.default)(InvoiceDetailsSpecification, _React$Component);
	
	  function InvoiceDetailsSpecification() {
	    (0, _classCallCheck3.default)(this, InvoiceDetailsSpecification);
	    return (0, _possibleConstructorReturn3.default)(this, (InvoiceDetailsSpecification.__proto__ || (0, _getPrototypeOf2.default)(InvoiceDetailsSpecification)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(InvoiceDetailsSpecification, [{
	    key: 'render',
	    value: function render() {
	      var invoice = this.props.invoice;
	      if (invoice) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'invoice-details-part-container' },
	          _ref,
	          _react2.default.createElement(
	            'div',
	            { className: 'invoice-details-border-container' },
	            invoice.specification
	          )
	        );
	      }
	      return null;
	    }
	  }]);
	  return InvoiceDetailsSpecification;
	}(_react2.default.Component);
	
	exports.default = InvoiceDetailsSpecification;

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InfoBoxList = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _frilansFinans = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 15/03/16.
	 */
	
	var InfoBoxList = exports.InfoBoxList = function (_React$Component) {
	  (0, _inherits3.default)(InfoBoxList, _React$Component);
	
	  function InfoBoxList(props) {
	    (0, _classCallCheck3.default)(this, InfoBoxList);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (InfoBoxList.__proto__ || (0, _getPrototypeOf2.default)(InfoBoxList)).call(this, props));
	
	    _this.state = {
	      info: [],
	      pendingRequest: null
	    };
	
	    _this.renderBox = _this.renderBox.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(InfoBoxList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetch();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.pendingRequest && this.state.pendingRequest.cancel) {
	        this.state.pendingRequest.cancel();
	      }
	    }
	  }, {
	    key: 'fetch',
	    value: function fetch() {
	      var _this2 = this;
	
	      var pendingRequest = _frilansFinans.InfoService.get();
	      pendingRequest.promise.then(function (response) {
	        _this2.setState({
	          info: response
	        });
	      });
	
	      this.setState({
	        pendingRequest: pendingRequest
	      });
	    }
	  }, {
	    key: 'createMarkup',
	    value: function createMarkup(html) {
	      return { __html: html };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var boxes = this.state.info.map(this.renderBox);
	      return _react2.default.createElement(
	        'span',
	        null,
	        boxes
	      );
	    }
	  }, {
	    key: 'renderBox',
	    value: function renderBox(info, key) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'info-box', key: key },
	        _react2.default.createElement(
	          'h2',
	          null,
	          info.title
	        ),
	        _react2.default.createElement('div', { dangerouslySetInnerHTML: this.createMarkup(_frilansFinans.Utils.getLineBreaks(info.text)) })
	      );
	    }
	  }]);
	  return InfoBoxList;
	}(_react2.default.Component);
	
	exports.default = InfoBoxList;

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RegisteredOrdersTable = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _orderRow = __webpack_require__(721);
	
	var _orderRow2 = _interopRequireDefault(_orderRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RegisteredOrdersTable = exports.RegisteredOrdersTable = function (_React$Component) {
	  (0, _inherits3.default)(RegisteredOrdersTable, _React$Component);
	
	  function RegisteredOrdersTable(props) {
	    (0, _classCallCheck3.default)(this, RegisteredOrdersTable);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (RegisteredOrdersTable.__proto__ || (0, _getPrototypeOf2.default)(RegisteredOrdersTable)).call(this, props));
	
	    _this.state = {
	      showMoreList: {
	        invoiceId: null,
	        show: false
	      }
	    };
	
	    _this.setShowMoreList = _this.setShowMoreList.bind(_this);
	    _this.resetShowMoreList = _this.resetShowMoreList.bind(_this);
	    _this.renderOrderRows = _this.renderOrderRows.bind(_this);
	    _this.removeInvoiceFromState = _this.removeInvoiceFromState.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(RegisteredOrdersTable, [{
	    key: 'setShowMoreList',
	    value: function setShowMoreList(invoiceId) {
	      var invoiceIdSet = this.state.showMoreList.invoiceId === invoiceId;
	      this.setState({
	        showMoreList: {
	          invoiceId: invoiceIdSet ? null : invoiceId,
	          show: !invoiceIdSet
	        }
	      });
	    }
	  }, {
	    key: 'resetShowMoreList',
	    value: function resetShowMoreList() {
	      this.setState({
	        showMoreList: {
	          invoiceId: null,
	          show: false
	        }
	      });
	    }
	  }, {
	    key: 'removeInvoiceFromState',
	    value: function removeInvoiceFromState(invoiceId) {
	      this.setState({
	        showMoreList: {
	          invoiceId: null,
	          show: false
	        }
	      });
	      this.props.removeInvoiceFromState(invoiceId);
	    }
	  }, {
	    key: 'renderOrderRows',
	    value: function renderOrderRows() {
	      var _this2 = this;
	
	      var orderRows = [];
	
	      this.props.invoices.forEach(function (invoice) {
	        orderRows.push(_react2.default.createElement(_orderRow2.default, {
	          key: invoice.id,
	          invoice: invoice,
	          user: _this2.props.user,
	          removeInvoiceFromState: _this2.removeInvoiceFromState,
	          toggleShowMoreList: _this2.setShowMoreList,
	          resetShowMoreList: _this2.resetShowMoreList,
	          showMoreList: _this2.state.showMoreList
	        }));
	      });
	
	      return orderRows;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'registered-orders-table' },
	        this.renderOrderRows()
	      );
	    }
	  }]);
	  return RegisteredOrdersTable;
	}(_react2.default.Component);
	
	exports.default = RegisteredOrdersTable;

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EnvelopeOpen = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EnvelopeOpen = exports.EnvelopeOpen = function (_React$Component) {
	  (0, _inherits3.default)(EnvelopeOpen, _React$Component);
	
	  function EnvelopeOpen() {
	    (0, _classCallCheck3.default)(this, EnvelopeOpen);
	    return (0, _possibleConstructorReturn3.default)(this, (EnvelopeOpen.__proto__ || (0, _getPrototypeOf2.default)(EnvelopeOpen)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(EnvelopeOpen, [{
	    key: 'render',
	    value: function render() {
	      var fill = this.props.colorSchema === 'primary' ? '#00587c' : '#000000';
	
	      return _react2.default.createElement(
	        'svg',
	        {
	          version: '1.1',
	          xmlns: 'http://www.w3.org/2000/svg',
	          width: this.props.width || '20',
	          height: this.props.height || '20',
	          viewBox: '0 0 20 20'
	        },
	        _react2.default.createElement('path', {
	          d: 'M17.907 5.552l-7.293-4.457c-0.304-0.186-0.7-0.288-1.114-0.288s-0.81 0.102-1.114 0.288l-7.293 4.457c-0.623 0.381-1.093 1.218-1.093 1.948v9c0 0.827 0.673 1.5 1.5 1.5h16c0.827 0 1.5-0.673 1.5-1.5v-9c0-0.73-0.47-1.567-1.093-1.948zM1.614 6.405l7.293-4.457c0.147-0.090 0.363-0.142 0.593-0.142s0.445 0.052 0.593 0.142l7.293 4.457c0.155 0.095 0.304 0.266 0.416 0.459l-7.747 5.165c-0.29 0.193-0.819 0.193-1.109 0l-7.747-5.165c0.112-0.194 0.261-0.365 0.416-0.459zM17.5 17h-16c-0.276 0-0.5-0.224-0.5-0.5v-8.566l7.391 4.927c0.311 0.207 0.71 0.311 1.109 0.311s0.798-0.104 1.109-0.311l7.391-4.927v8.566c0 0.276-0.224 0.5-0.5 0.5z',
	          fill: fill
	        })
	      );
	    }
	  }]);
	  return EnvelopeOpen;
	}(_react2.default.Component);
	
	exports.default = EnvelopeOpen;

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ShieldCheck = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ShieldCheck = exports.ShieldCheck = function (_React$Component) {
	  (0, _inherits3.default)(ShieldCheck, _React$Component);
	
	  function ShieldCheck() {
	    (0, _classCallCheck3.default)(this, ShieldCheck);
	    return (0, _possibleConstructorReturn3.default)(this, (ShieldCheck.__proto__ || (0, _getPrototypeOf2.default)(ShieldCheck)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ShieldCheck, [{
	    key: 'render',
	    value: function render() {
	      var fill = this.props.colorSchema === 'primary' ? '#00587c' : '#000000';
	
	      return _react2.default.createElement(
	        'svg',
	        {
	          version: '1.1',
	          xmlns: 'http://www.w3.org/2000/svg',
	          width: this.props.width || '20',
	          height: this.props.height || '20',
	          viewBox: '0 0 20 20'
	        },
	        _react2.default.createElement('path', {
	          d: 'M9.5 20c-0.053 0-0.107-0.009-0.158-0.026-1.839-0.613-4.147-2.651-5.88-5.193-1.579-2.316-3.462-6.154-3.462-11.282 0-0.276 0.224-0.5 0.5-0.5 2.814 0 7.238-1.926 8.723-2.916 0.168-0.112 0.387-0.112 0.555 0 1.485 0.99 5.909 2.916 8.723 2.916 0.276 0 0.5 0.224 0.5 0.5 0 5.128-1.883 8.965-3.462 11.282-1.733 2.541-4.041 4.58-5.88 5.193-0.051 0.017-0.105 0.026-0.158 0.026zM1.006 3.984c0.113 4.631 1.832 8.108 3.282 10.235 1.769 2.594 3.856 4.23 5.212 4.751 1.356-0.521 3.443-2.156 5.212-4.751 1.45-2.127 3.169-5.604 3.282-10.235-1.628-0.102-3.442-0.662-4.73-1.14-1.418-0.525-2.849-1.193-3.764-1.751-0.915 0.558-2.346 1.226-3.764 1.751-1.289 0.477-3.102 1.038-4.73 1.14z',
	          fill: fill
	        }),
	        _react2.default.createElement('path', {
	          d: 'M8.5 12.5c-0.128 0-0.256-0.049-0.354-0.146l-2-2c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l1.646 1.646 4.646-4.646c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-5 5c-0.098 0.098-0.226 0.146-0.354 0.146z',
	          fill: fill
	        })
	      );
	    }
	  }]);
	  return ShieldCheck;
	}(_react2.default.Component);
	
	exports.default = ShieldCheck;

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Umbrella = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Umbrella = exports.Umbrella = function (_React$Component) {
	  (0, _inherits3.default)(Umbrella, _React$Component);
	
	  function Umbrella() {
	    (0, _classCallCheck3.default)(this, Umbrella);
	    return (0, _possibleConstructorReturn3.default)(this, (Umbrella.__proto__ || (0, _getPrototypeOf2.default)(Umbrella)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Umbrella, [{
	    key: 'render',
	    value: function render() {
	      var fill = this.props.colorSchema === 'primary' ? '#00587c' : '#000000';
	
	      return _react2.default.createElement(
	        'svg',
	        {
	          version: '1.1',
	          xmlns: 'http://www.w3.org/2000/svg',
	          width: this.props.width || '20',
	          height: this.props.height || '20',
	          viewBox: '0 0 20 20'
	        },
	        _react2.default.createElement('path', {
	          d: 'M15.51 3.49c-1.605-1.605-3.74-2.49-6.010-2.49s-4.405 0.884-6.010 2.49-2.49 3.74-2.49 6.010c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-0.827 0.673-1.5 1.5-1.5s1.5 0.673 1.5 1.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-0.827 0.673-1.5 1.5-1.5s1.5 0.673 1.5 1.5v8c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5c0 0.827 0.673 1.5 1.5 1.5s1.5-0.673 1.5-1.5v-8c0-0.827 0.673-1.5 1.5-1.5s1.5 0.673 1.5 1.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-0.827 0.673-1.5 1.5-1.5s1.5 0.673 1.5 1.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-2.27-0.884-4.405-2.49-6.010zM15.5 7c-0.817 0-1.544 0.394-2 1.002-0.456-0.608-1.183-1.002-2-1.002s-1.544 0.394-2 1.002c-0.456-0.608-1.183-1.002-2-1.002s-1.544 0.394-2 1.002c-0.456-0.608-1.183-1.002-2-1.002-0.422 0-0.819 0.105-1.168 0.29 0.945-3.060 3.801-5.29 7.168-5.29s6.222 2.23 7.168 5.29c-0.349-0.185-0.746-0.29-1.168-0.29z',
	          fill: fill
	        })
	      );
	    }
	  }]);
	  return Umbrella;
	}(_react2.default.Component);
	
	exports.default = Umbrella;

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.User = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var User = exports.User = function (_React$Component) {
	  (0, _inherits3.default)(User, _React$Component);
	
	  function User() {
	    (0, _classCallCheck3.default)(this, User);
	    return (0, _possibleConstructorReturn3.default)(this, (User.__proto__ || (0, _getPrototypeOf2.default)(User)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(User, [{
	    key: 'getFillColor',
	    value: function getFillColor() {
	      switch (this.props.colorSchema) {
	        case 'primary':
	          return '#00587c';
	        case 'green-profile':
	          return '#53AD99';
	        case 'white':
	          return '#ffffff';
	        default:
	          return '#000000';
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var fill = this.getFillColor();
	
	      return _react2.default.createElement(
	        'svg',
	        {
	          version: '1.1',
	          xmlns: 'http://www.w3.org/2000/svg',
	          width: this.props.width || '20',
	          height: this.props.height || '20',
	          viewBox: '0 0 20 20',
	          className: this.props.classes
	        },
	        _react2.default.createElement('path', {
	          d: 'M9.5 11c-3.033 0-5.5-2.467-5.5-5.5s2.467-5.5 5.5-5.5 5.5 2.467 5.5 5.5-2.467 5.5-5.5 5.5zM9.5 1c-2.481 0-4.5 2.019-4.5 4.5s2.019 4.5 4.5 4.5c2.481 0 4.5-2.019 4.5-4.5s-2.019-4.5-4.5-4.5z',
	          fill: fill
	        }),
	        _react2.default.createElement('path', {
	          d: 'M17.5 20h-16c-0.827 0-1.5-0.673-1.5-1.5 0-0.068 0.014-1.685 1.225-3.3 0.705-0.94 1.67-1.687 2.869-2.219 1.464-0.651 3.283-0.981 5.406-0.981s3.942 0.33 5.406 0.981c1.199 0.533 2.164 1.279 2.869 2.219 1.211 1.615 1.225 3.232 1.225 3.3 0 0.827-0.673 1.5-1.5 1.5zM9.5 13c-3.487 0-6.060 0.953-7.441 2.756-1.035 1.351-1.058 2.732-1.059 2.746 0 0.274 0.224 0.498 0.5 0.498h16c0.276 0 0.5-0.224 0.5-0.5-0-0.012-0.023-1.393-1.059-2.744-1.382-1.803-3.955-2.756-7.441-2.756z',
	          fill: fill
	        })
	      );
	    }
	  }]);
	  return User;
	}(_react2.default.Component);
	
	exports.default = User;

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(18);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _axios = __webpack_require__(17);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _service = __webpack_require__(118);
	
	var _service2 = _interopRequireDefault(_service);
	
	var _agreementWrapperEntity = __webpack_require__(752);
	
	var _agreementWrapperEntity2 = _interopRequireDefault(_agreementWrapperEntity);
	
	var _agreementEntity = __webpack_require__(751);
	
	var _agreementEntity2 = _interopRequireDefault(_agreementEntity);
	
	var _http = __webpack_require__(71);
	
	var _pendingRequestEntity = __webpack_require__(42);
	
	var _pendingRequestEntity2 = _interopRequireDefault(_pendingRequestEntity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 21/09/16.
	 */
	
	var AgreementService = function (_Service) {
	  (0, _inherits3.default)(AgreementService, _Service);
	
	  function AgreementService() {
	    (0, _classCallCheck3.default)(this, AgreementService);
	    return (0, _possibleConstructorReturn3.default)(this, (AgreementService.__proto__ || (0, _getPrototypeOf2.default)(AgreementService)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AgreementService, [{
	    key: 'hydrateAgreement',
	    value: function hydrateAgreement(agreement) {
	      return new _agreementEntity2.default(agreement.id, agreement.attributes.created_at, agreement.attributes.invoice_id, agreement.attributes.text, agreement.attributes.type_id, agreement.attributes.pdf_url);
	    }
	  }, {
	    key: 'hydrateWrapper',
	    value: function hydrateWrapper(agreement, condition) {
	      return new _agreementWrapperEntity2.default(this.hydrateAgreement(agreement), new _agreementEntity2.default(condition.id, condition.attributes.created_at, condition.attributes.invoice_id, condition.attributes.text, condition.attributes.type_id, condition.attributes.pdf_url));
	    }
	  }, {
	    key: 'hydrateCollection',
	    value: function hydrateCollection(data) {
	      var agreements = [];
	      var conditions = [];
	      var returnArr = [];
	
	      // Separate agreements from conditions
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var agreement = _step.value;
	
	          if (agreement.attributes.type_id === 1) {
	            agreements.push(agreement);
	          } else if (agreement.attributes.type_id === 2) {
	            conditions.push(agreement);
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(agreements), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var _agreement = _step2.value;
	          var _iteratorNormalCompletion3 = true;
	          var _didIteratorError3 = false;
	          var _iteratorError3 = undefined;
	
	          try {
	            for (var _iterator3 = (0, _getIterator3.default)(conditions), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	              var condition = _step3.value;
	
	              if (_agreement.attributes.invoice_id === condition.attributes.invoice_id) {
	                returnArr.push(this.hydrateWrapper(_agreement, condition));
	              }
	            }
	          } catch (err) {
	            _didIteratorError3 = true;
	            _iteratorError3 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                _iterator3.return();
	              }
	            } finally {
	              if (_didIteratorError3) {
	                throw _iteratorError3;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      return returnArr;
	    }
	  }, {
	    key: 'getById',
	    value: function getById(id) {
	      var _this2 = this;
	
	      return _axios2.default.get('backend://agreements/' + id).then(function (response) {
	        return _this2.hydrateAgreement(response.data.data);
	      });
	    }
	  }, {
	    key: 'get',
	    value: function get(dateFilter, page, userid) {
	      var _this3 = this;
	
	      var filter = this.getFilterDate(dateFilter, 'created_at');
	      var pendingRequest = new _pendingRequestEntity2.default();
	      var userRoute = userid ? 'users/' + userid + '/' : '';
	      pendingRequest.promise = _axios2.default.get('backend://' + userRoute + 'agreements?filter[with_approved_type_status_invoice]' + filter, { params: {
	          'page[number]': page || 1,
	          'page[size]': 10,
	          'sort': '-invoice_id'
	        },
	        cancelToken: new _axios2.default.CancelToken(function executor(c) {
	          pendingRequest.cancel = c;
	        })
	      }).then(function (response) {
	        var agreements = _this3.hydrateCollection(response.data.data);
	        return new _http.APIResult(agreements, response.data.meta);
	      });
	
	      return pendingRequest;
	    }
	  }]);
	  return AgreementService;
	}(_service2.default);
	
	exports.default = new AgreementService();

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by eriksundqvist on 08/11/16.
	 */
	
	var CalculatorPostEntity = function CalculatorPostEntity(amount, vat, rot, rut, workers, expenses) {
	  (0, _classCallCheck3.default)(this, CalculatorPostEntity);
	
	  this.amount = amount;
	  this.vat = vat;
	  this.rot = rot;
	  this.rut = rut;
	  this.workers = workers;
	  this.expenses = expenses;
	};
	
	exports.default = CalculatorPostEntity;

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by eriksundqvist on 08/11/16.
	 */
	var CalculatorWorkerEntity = function CalculatorWorkerEntity(amount, fee, tax,
	/*eslint-disable */
	payroll_tax,
	/*eslint-enable */
	allowance, travel, vacation, itp, id, net, gross) {
	  (0, _classCallCheck3.default)(this, CalculatorWorkerEntity);
	
	  this.amount = amount;
	  this.fee = fee;
	  this.tax = tax;
	  /*eslint-disable */
	  this.payroll_tax = payroll_tax;
	  /*eslint-enable */
	  this.allowance = allowance;
	  this.travel = travel;
	  this.vacation = vacation;
	  this.itp = itp;
	  this.id = id;
	  this.net = net;
	  this.gross = gross;
	};
	
	exports.default = CalculatorWorkerEntity;

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(72);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getIterator2 = __webpack_require__(18);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(17);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _http = __webpack_require__(71);
	
	var _currencyEntity = __webpack_require__(762);
	
	var _currencyEntity2 = _interopRequireDefault(_currencyEntity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CurrenciesService = function () {
	  function CurrenciesService() {
	    (0, _classCallCheck3.default)(this, CurrenciesService);
	
	    this.currencies = null;
	  }
	
	  (0, _createClass3.default)(CurrenciesService, [{
	    key: 'hydrate',
	    value: function hydrate(currency) {
	      var attr = currency.attributes;
	
	      return new _currencyEntity2.default(currency.id, attr.active, attr.code, attr.exchange_rate, attr.name, attr.standard, attr.updated_at);
	    }
	  }, {
	    key: 'hydrateCollection',
	    value: function hydrateCollection(data) {
	      var currencies = [];
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var currency = _step.value;
	
	          currencies.push(this.hydrate(currency));
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return currencies;
	    }
	  }, {
	    key: 'get',
	    value: function get() {
	      if (this.currencies) {
	        return _promise2.default.resolve(this.currencies);
	      } else {
	        return this.fetchCurrencies();
	      }
	    }
	  }, {
	    key: 'fetchCurrencies',
	    value: function fetchCurrencies() {
	      var _this = this;
	
	      return _axios2.default.get('backend://currencies').then(function (response) {
	        var currencies = _this.hydrateCollection(response.data.data);
	        return new _http.APIResult(currencies, response.data.meta);
	      });
	    }
	  }]);
	  return CurrenciesService;
	}(); /**
	      * Created by staffanrantzow on 19/04/16.
	      */
	
	exports.default = new CurrenciesService();

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 12/04/16.
	 */
	
	var CustomerEntity = function CustomerEntity(id, contact, email, name, phone, sendToEmail, sendToEmailSecondary, userId, vatNr, address, payTerms, messageType, eInvoiceAddress, poNumber) {
	  (0, _classCallCheck3.default)(this, CustomerEntity);
	
	  this.id = id;
	  this.contact = contact;
	  this.email = email;
	  this.name = name;
	  this.phone = phone;
	  this.sendToEmail = sendToEmail;
	  this.sendToEmailSecondary = sendToEmailSecondary;
	  this.userId = userId;
	  this.vatNr = vatNr;
	  this.address = address;
	  this.payTerms = payTerms;
	  this.messageType = messageType;
	  this.eInvoiceAddress = eInvoiceAddress;
	  this.poNumber = poNumber;
	};
	
	exports.default = CustomerEntity;

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by eriksundqvist on 12/10/16.
	 */
	var InvoiceDateEntity = function InvoiceDateEntity(date, hours, invoiceId) {
	  (0, _classCallCheck3.default)(this, InvoiceDateEntity);
	
	  this.date = date;
	  this.hours = hours;
	  this.invoiceId = invoiceId;
	};
	
	exports.default = InvoiceDateEntity;

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(18);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _axios = __webpack_require__(17);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _salaryEntity = __webpack_require__(789);
	
	var _salaryEntity2 = _interopRequireDefault(_salaryEntity);
	
	var _http = __webpack_require__(71);
	
	var _service = __webpack_require__(118);
	
	var _service2 = _interopRequireDefault(_service);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _invoiceDateEntity = __webpack_require__(348);
	
	var _invoiceDateEntity2 = _interopRequireDefault(_invoiceDateEntity);
	
	var _pendingRequestEntity = __webpack_require__(42);
	
	var _pendingRequestEntity2 = _interopRequireDefault(_pendingRequestEntity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SalaryService = function (_Service) {
	  (0, _inherits3.default)(SalaryService, _Service);
	
	  function SalaryService() {
	    (0, _classCallCheck3.default)(this, SalaryService);
	    return (0, _possibleConstructorReturn3.default)(this, (SalaryService.__proto__ || (0, _getPrototypeOf2.default)(SalaryService)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SalaryService, [{
	    key: 'hydrateCollection',
	
	
	    /**
	     *
	     * @param data the salaries
	     * @param included included data for each salary (include=invoice,invoicesdates)
	     * @returns {Array}
	     */
	    value: function hydrateCollection(data, included) {
	      var salaries = [];
	
	      for (var i = 0; i < data.length; i++) {
	        salaries.push(this.hydrate(data[i], included));
	      }
	
	      return salaries;
	    }
	  }, {
	    key: 'hydrate',
	    value: function hydrate(salary) {
	      var included = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	      var attr = salary.attributes;
	      var invoiceDates = [];
	      var invoice = [];
	      var taxAgencySalary = null;
	      var companyName = '';
	
	      // Loop through the included data and store it correctly
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(included), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var inc = _step.value;
	
	          var salaryInvoiceId = parseInt(salary.attributes.invoice_id);
	
	          if (inc.type === 'invoices' && parseInt(inc.id) === salaryInvoiceId) {
	            invoice.push(inc);
	            companyName = inc.attributes.company_name;
	          }
	          if (inc.type === 'invoice-dates' && parseInt(inc.attributes.invoice_id) === salaryInvoiceId) {
	            invoiceDates.push(this.hydrateInvoiceDates(inc));
	          }
	          if (inc.type === 'tax-agency-salary' && parseInt(inc.attributes.invoice_id) === salaryInvoiceId + 1 && parseInt(inc.attributes.type_id) === salary.typeId) {
	            taxAgencySalary = inc;
	          }
	        }
	
	        // Sort invoice dates
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      invoiceDates.sort(function (a, b) {
	        return a.date - b.date;
	      });
	
	      return new _salaryEntity2.default(salary.id, attr.allowance, attr.category_id, attr.type_id, attr.created_at, attr.gross_amount, attr.gross_old, attr.invoice_id, attr.net_amount, attr.paid_at, attr.payment_status, attr.planned_payment_at, attr.resent_status, attr.tax_amount, attr.taxkey_id, attr.to_pay, attr.travel, attr.user_id, companyName, attr.specification_pdf_url, invoice, invoiceDates, taxAgencySalary);
	    }
	  }, {
	    key: 'hydrateInvoiceDates',
	    value: function hydrateInvoiceDates(data) {
	      data = data.attributes;
	      return new _invoiceDateEntity2.default(data.date, data.hours, data.invoice_id);
	    }
	  }, {
	    key: 'getFilterCategory',
	    value: function getFilterCategory() {
	      return 'filter[category_id][<]=5';
	    }
	  }, {
	    key: 'getFilterType',
	    value: function getFilterType() {
	      var types = [_frilansFinans.SalaryTypeConstants.REGULAR_TYPE, _frilansFinans.SalaryTypeConstants.VACATION_TYPE, _frilansFinans.SalaryTypeConstants.EXPENSE_TYPE, _frilansFinans.SalaryTypeConstants.EXPENSE_TRAVEL_TYPE, _frilansFinans.SalaryTypeConstants.SICK_PAYMENT_TYPE, _frilansFinans.SalaryTypeConstants.KRONOFOGDEN_PAYMENT_TYPE, _frilansFinans.SalaryTypeConstants.TRAVEL_ALLOWANCE_PAYMENT_TYPE];
	      return 'filter[type_id][in]=' + types.join(',');
	    }
	  }, {
	    key: 'getSums',
	    value: function getSums(userId, dateFilter) {
	      var filter = this.getFilterDate(dateFilter, 'paid_at') + '&' + this.getFilterCategory() + '&' + this.getFilterType();
	      var pendingRequest = new _pendingRequestEntity2.default();
	      pendingRequest.promise = _axios2.default.get('backend://users/' + userId + '/salary-sums' + filter, {
	        cancelToken: new _axios2.default.CancelToken(function executor(c) {
	          pendingRequest.cancel = c;
	        })
	      }).then(function (response) {
	        return response.data.data.attributes;
	      });
	      return pendingRequest;
	    }
	  }, {
	    key: 'createSalarySpecification',
	    value: function createSalarySpecification(salaryIds) {
	      var pendingRequest = new _pendingRequestEntity2.default();
	      pendingRequest.promise = _axios2.default.post('backend://salary-specifications', {
	        data: {
	          attributes: {
	            salary_ids: salaryIds
	          }
	        }
	      }).then(function (response) {
	        return response.data.data.attributes;
	      });
	      return pendingRequest;
	    }
	  }, {
	    key: 'get',
	    value: function get(userId, page, size, dateFilter, sort) {
	      var _this2 = this;
	
	      var filter = this.getFilterDate(dateFilter, 'paid_at') + '&' + this.getFilterCategory() + '&' + this.getFilterType();
	      var pendingRequest = new _pendingRequestEntity2.default();
	      var url = 'backend://users/' + userId + '/salaries' + filter + '&filter[not_tax_agency_salary]=1&include=invoice,invoice.invoicedates,taxagencysalary';
	
	      pendingRequest.promise = _axios2.default.get(url, {
	        params: {
	          'page[number]': page || 1,
	          'page[size]': size || 25,
	          'sort': sort || ''
	        },
	        cancelToken: new _axios2.default.CancelToken(function executor(c) {
	          pendingRequest.cancel = c;
	        })
	      }).then(function (response) {
	        var salaries = _this2.hydrateCollection(response.data.data, response.data.included);
	        return new _http.APIResult(salaries, response.data.meta);
	      });
	      return pendingRequest;
	    }
	  }]);
	  return SalaryService;
	}(_service2.default); /**
	                       * Created by staffanrantzow on 14/06/16.
	                       */
	
	exports.default = new SalaryService();

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(72);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getIterator2 = __webpack_require__(18);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _axios = __webpack_require__(17);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _supplierLedgerEntity = __webpack_require__(793);
	
	var _supplierLedgerEntity2 = _interopRequireDefault(_supplierLedgerEntity);
	
	var _supplierLedgerTypeEntity = __webpack_require__(794);
	
	var _supplierLedgerTypeEntity2 = _interopRequireDefault(_supplierLedgerTypeEntity);
	
	var _http = __webpack_require__(71);
	
	var _service = __webpack_require__(118);
	
	var _service2 = _interopRequireDefault(_service);
	
	var _pendingRequestEntity = __webpack_require__(42);
	
	var _pendingRequestEntity2 = _interopRequireDefault(_pendingRequestEntity);
	
	var _invoiceToolHelper = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SupplierLedgerService = function (_Service) {
	  (0, _inherits3.default)(SupplierLedgerService, _Service);
	
	  function SupplierLedgerService() {
	    (0, _classCallCheck3.default)(this, SupplierLedgerService);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SupplierLedgerService.__proto__ || (0, _getPrototypeOf2.default)(SupplierLedgerService)).call(this));
	
	    _this.types = null;
	    return _this;
	  }
	
	  (0, _createClass3.default)(SupplierLedgerService, [{
	    key: 'hydrateType',
	    value: function hydrateType(type) {
	      var attr = type.attributes;
	
	      return new _supplierLedgerTypeEntity2.default(type.id, attr.active, attr.display_name, attr.display_order, attr.is_rot_rut, attr.specify_date, attr.tax_id);
	    }
	  }, {
	    key: 'hydrateTypeCollection',
	    value: function hydrateTypeCollection(data) {
	      var types = [];
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var type = _step.value;
	
	          types.push(this.hydrateType(type));
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return types;
	    }
	  }, {
	    key: 'hydrate',
	    value: function hydrate(deduction) {
	      var included = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	      var attr = deduction.attributes;
	      var file = false;
	
	      if (included.length && included[0].type === 'files') {
	        file = included.find(function (inc) {
	          return parseInt(inc.attributes.fileable_id) === parseInt(deduction.id);
	        }) || false;
	      }
	
	      return new _supplierLedgerEntity2.default(deduction.id, attr.amount, attr.arrived_date, attr.created_at, attr.expense_id, attr.invoice_id, attr.invoice_item_id, attr.payed_date, attr.status, attr.supplier_invoice_account, attr.supplier_invoice_nr, attr.supplier_invoice_ut, attr.supplier_ledger_type_id, attr.supplier_name, attr.tax_id, attr.tax_percent, attr.type_id, attr.user_id_authorization, attr.user_id_creator, file);
	    }
	  }, {
	    key: 'hydrateCollection',
	    value: function hydrateCollection(data, included) {
	      var deductions = [];
	
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var deduction = _step2.value;
	
	          deductions.push(this.hydrate(deduction, included));
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      return deductions;
	    }
	  }, {
	    key: 'getById',
	    value: function getById(id) {
	      var _this2 = this;
	
	      return _axios2.default.get('backend://supplier-ledgers/' + id + '?include=appendixfiles').then(function (response) {
	        return _this2.hydrate(response.data.data, response.data.included);
	      });
	    }
	  }, {
	    key: 'get',
	    value: function get(userId, page, dateFilter, assigned) {
	      var _this3 = this;
	
	      var filter = this.getFilterDate(dateFilter, 'created_at');
	      var pendingRequest = new _pendingRequestEntity2.default();
	
	      var params = {
	        'page[number]': page || 1,
	        'page[size]': 25,
	        'sort': '-created_at'
	      };
	
	      if (assigned) {
	        params['filter[assigned]'] = 1;
	      };
	
	      pendingRequest.promise = _axios2.default.get('backend://users/' + userId + '/supplier-ledgers' + filter, {
	        params: params,
	        cancelToken: new _axios2.default.CancelToken(function executor(c) {
	          pendingRequest.cancel = c;
	        })
	      }).then(function (response) {
	        var deductions = _this3.hydrateCollection(response.data.data);
	        return new _http.APIResult(deductions, response.data.meta);
	      });
	
	      return pendingRequest;
	    }
	  }, {
	    key: 'getForInvoice',
	    value: function getForInvoice(invoiceId) {
	      var _this4 = this;
	
	      return _axios2.default.get('backend://supplier-ledgers?filter[invoice_id]=' + invoiceId).then(function (response) {
	        var supplierLedgers = _this4.hydrateCollection(response.data.data);
	        return new _http.APIResult(supplierLedgers, response.data.meta);
	      });
	    }
	  }, {
	    key: 'getTypes',
	    value: function getTypes() {
	      var _this5 = this;
	
	      if (this.types) {
	        return new _promise2.default(function (resolve) {
	          return resolve(_this5.types);
	        });
	      }
	      return _axios2.default.get('backend://supplier-ledger-types?filter[active]=1').then(function (response) {
	        _this5.types = _this5.hydrateTypeCollection(response.data.data);
	        return _this5.types;
	      });
	    }
	  }, {
	    key: 'extractParams',
	    value: function extractParams(params, userId) {
	      return {
	        data: {
	          attributes: {
	            supplier_name: params.supplierName,
	            tax_id: params.taxId,
	            supplier_ledger_type_id: params.supplierLedgerTypeId,
	            amount: 100 * params.amount / (100 + (0, _invoiceToolHelper.getVatById)(params.taxId)),
	            user_id: userId
	          }
	        }
	      };
	    }
	  }, {
	    key: 'post',
	    value: function post(params, userId) {
	      var _this6 = this;
	
	      return _axios2.default.post('backend://supplier-ledgers', this.extractParams(params, userId)).then(function (response) {
	        return _this6.hydrate(response.data.data);
	      });
	    }
	  }, {
	    key: 'postFile',
	    value: function postFile(params, supplierLedgerId) {
	      var data = {
	        data: {
	          attributes: params
	        }
	      };
	      var url = 'backend://supplier-ledgers/' + supplierLedgerId + '/appendix-files';
	      return _axios2.default.post(url, data);
	    }
	  }]);
	  return SupplierLedgerService;
	}(_service2.default); /**
	                       * Created by staffanrantzow on 05/04/16.
	                       */
	
	exports.default = new SupplierLedgerService();

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _reactCookie = __webpack_require__(594);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CookieItpUtils = function () {
	  function CookieItpUtils() {
	    (0, _classCallCheck3.default)(this, CookieItpUtils);
	  }
	
	  (0, _createClass3.default)(CookieItpUtils, null, [{
	    key: 'cookieDomain',
	    value: function cookieDomain() {
	      var domainParts = location.hostname.split('.');
	      if (domainParts.length > 2) {
	        domainParts.shift();
	      }
	      return domainParts.join('.');
	    }
	  }, {
	    key: 'getItpCookie',
	    value: function getItpCookie(name) {
	      var ffItpOne = _reactCookie2.default.load(name);
	      return ffItpOne !== undefined;
	    }
	  }, {
	    key: 'setItpCookie',
	    value: function setItpCookie(name) {
	      _reactCookie2.default.save(name, 'true', {
	        domain: this.cookieDomain(),
	        expires: (0, _moment2.default)().add(90, 'days').toDate()
	      });
	    }
	  }]);
	  return CookieItpUtils;
	}();
	
	exports.default = CookieItpUtils;

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LocalStorageStore = exports.CookieStore = undefined;
	
	var _stringify = __webpack_require__(166);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Fallback on Cookies if Local Storage isn't supported.
	 * Which it isn't in Safari private mode
	 */
	var CookieStore = exports.CookieStore = function () {
	  function CookieStore() {
	    (0, _classCallCheck3.default)(this, CookieStore);
	  }
	
	  (0, _createClass3.default)(CookieStore, null, [{
	    key: 'create',
	    value: function create(token) {
	      document.cookie = 'oauth=' + (0, _stringify2.default)(token);
	    }
	  }, {
	    key: 'read',
	    value: function read() {
	      var nameEQ = 'oauth=';
	      var ca = document.cookie.split(';');
	      for (var i = 0; i < ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0) === ' ') {
	          c = c.substring(1, c.length);
	        }
	
	        if (c.indexOf(nameEQ) === 0) {
	          return JSON.parse(c.substring(nameEQ.length, c.length));
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {
	      this.create('');
	    }
	  }]);
	  return CookieStore;
	}();
	
	var LocalStorageStore = exports.LocalStorageStore = function () {
	  function LocalStorageStore() {
	    (0, _classCallCheck3.default)(this, LocalStorageStore);
	  }
	
	  (0, _createClass3.default)(LocalStorageStore, [{
	    key: 'persist',
	    value: function persist(token) {
	      try {
	        localStorage.setItem('oauth', (0, _stringify2.default)(token));
	      } catch (e) {
	        CookieStore.create(token);
	        console.log(e);
	      }
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      CookieStore.remove();
	      localStorage.removeItem('oauth');
	    }
	  }, {
	    key: 'getOauth',
	    value: function getOauth() {
	      var oauth = void 0;
	
	      try {
	        oauth = localStorage.getItem('oauth');
	      } catch (e) {
	        console.log(e);
	      }
	
	      if (oauth) {
	        try {
	          return JSON.parse(oauth);
	        } catch (e) {
	          return null;
	        }
	      }
	
	      var cookieOuath = CookieStore.read();
	
	      return cookieOuath === '' ? null : cookieOuath;
	    }
	  }, {
	    key: 'isEmpty',
	    get: function get() {
	      var oauth = void 0;
	
	      try {
	        oauth = localStorage.getItem('oauth');
	      } catch (e) {
	        console.log(e);
	        return false;
	      }
	
	      if (!oauth) {
	        oauth = CookieStore.read();
	      }
	
	      if (oauth) {
	        return false;
	      } else {
	        return true;
	      }
	    }
	  }]);
	  return LocalStorageStore;
	}();

/***/ },
/* 353 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_REAUTHENTICATION_STATUS = exports.SET_REAUTHENTICATION_STATUS = 'reauthentication-status:set';

/***/ },
/* 354 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_SOCIAL_SECURITY_NR = exports.SET_SOCIAL_SECURITY_NR = 'bank-id:set-social-security-nr';
	var SET_EMAIL = exports.SET_EMAIL = 'bank-id:set-email';
	var SET_IN_PROGRESS = exports.SET_IN_PROGRESS = 'bank-id:set-in-progress';
	var SET_LOGIN_SUCCEEDED = exports.SET_LOGIN_SUCCEEDED = 'bank-id:set-login-succeeded';
	var SET_ERROR = exports.SET_ERROR = 'bank-id:set-error';
	var SET_AUTH_TYPE = exports.SET_AUTH_TYPE = 'bank-id:set-auth-type';
	var SET_ENTITY = exports.SET_ENTITY = 'bank-id:set-entity';
	var SET_CREATE_ON_AUTH = exports.SET_CREATE_ON_AUTH = 'bank-id:set-create-on-auth';

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setSocialSecurityNr = setSocialSecurityNr;
	exports.setEmail = setEmail;
	exports.setInProgress = setInProgress;
	exports.setLoginSucceeded = setLoginSucceeded;
	exports.setError = setError;
	exports.setAuthType = setAuthType;
	exports.setEntity = setEntity;
	exports.setCreateOnAuth = setCreateOnAuth;
	exports.startTimer = startTimer;
	exports.checkTimeout = checkTimeout;
	exports.requestLogin = requestLogin;
	exports.tryToLogin = tryToLogin;
	exports.cancel = cancel;
	exports.clearError = clearError;
	exports.startComputerApp = startComputerApp;
	
	var _lodash = __webpack_require__(40);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRouterRedux = __webpack_require__(137);
	
	var _actionTypes = __webpack_require__(354);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _authentication = __webpack_require__(64);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function setSocialSecurityNr(socialSecurityNr) {
	  return {
	    type: types.SET_SOCIAL_SECURITY_NR,
	    payload: socialSecurityNr
	  };
	}
	
	function setEmail(email) {
	  return {
	    type: types.SET_EMAIL,
	    payload: email
	  };
	}
	
	function setInProgress(bool) {
	  return {
	    type: types.SET_IN_PROGRESS,
	    payload: bool
	  };
	}
	
	function setLoginSucceeded(bool) {
	  return {
	    type: types.SET_LOGIN_SUCCEEDED,
	    payload: bool
	  };
	}
	
	function setError(error) {
	  return {
	    type: types.SET_ERROR,
	    payload: error
	  };
	}
	
	function setAuthType(authType) {
	  return {
	    type: types.SET_AUTH_TYPE,
	    payload: authType
	  };
	}
	
	function setEntity(data) {
	  return {
	    type: types.SET_ENTITY,
	    payload: data
	  };
	}
	
	function setCreateOnAuth(bool) {
	  return {
	    type: types.SET_CREATE_ON_AUTH,
	    payload: bool
	  };
	}
	
	// Thunks
	
	var TIMEOUT = 60;
	var DELAY = 500;
	
	var pendingRequest = void 0,
	    timer = void 0,
	    startedAt = void 0;
	
	function startTimer() {
	  return function (dispatch) {
	    startedAt = new Date();
	    timer = setInterval(function () {
	      return dispatch(checkTimeout());
	    }, DELAY);
	  };
	}
	
	function checkTimeout() {
	  return function (dispatch) {
	    var done = (new Date() - startedAt) / 1000 > TIMEOUT;
	
	    if (done) {
	      dispatch(cancel());
	    }
	  };
	}
	
	function requestLogin() {
	  return function (dispatch, getState) {
	    var _getState = getState(),
	        bankId = _getState.bankId;
	
	    var ssnr = bankId.authType === 'MOBILE' ? bankId.socialSecurityNr : '';
	    var email = bankId.authType === 'MOBILE' ? bankId.email : '';
	    pendingRequest = _frilansFinans.BankIdService.requestLogin(ssnr, email);
	    dispatch(setInProgress(true));
	    dispatch(startTimer());
	    pendingRequest.promise.then(function (entity) {
	      if (entity) {
	        dispatch(setEntity(entity));
	        dispatch(startComputerApp(entity));
	        dispatch(tryToLogin());
	      }
	    }).catch(function (error) {
	      error = _frilansFinans.BankIdService.getErrors(error);
	      dispatch(setError(error));
	      dispatch(cancel());
	    });
	  };
	}
	
	function tryToLogin(sessionId) {
	  return function (dispatch, getState) {
	    var _getState2 = getState(),
	        bankId = _getState2.bankId;
	
	    if (!bankId.inProgress) {
	      dispatch(setError({ key: 'CANCELLED' }));
	      return;
	    }
	
	    pendingRequest = _authentication.authenticationService.loginWithBankId(bankId.entity.sessionId, bankId.createOnAuth);
	
	    pendingRequest.promise.then(function (entity) {
	      dispatch(setInProgress(false));
	      dispatch(setLoginSucceeded(true));
	      dispatch((0, _reactRouterRedux.push)('/activities'));
	    }).catch(function (error) {
	      if (error && error.status) {
	        switch (error.status) {
	          case 412:
	            _lodash2.default.delay(function () {
	              dispatch(tryToLogin());
	            }, DELAY);
	            break;
	          case 404:
	            dispatch(setInProgress(false));
	            dispatch(setError({ key: 'BANKID_USER_NOT_FOUND', keep: true }));
	            dispatch((0, _reactRouterRedux.push)('/register?tab=' + bankId.authType));
	            break;
	          case 403:
	            dispatch(setError({ key: 'BANKID_LOGIN_FAILED', keep: false }));
	            dispatch(cancel());
	            break;
	          case 400:
	            dispatch(setError({ key: 'CANCELLED', keep: true }));
	            dispatch(cancel());
	            break;
	          default:
	            dispatch(setError(error));
	            dispatch(cancel());
	            break;
	        }
	      } else {
	        dispatch(setError({ key: 'GENERAL_ERROR' }));
	        dispatch(cancel());
	      }
	    });
	  };
	}
	
	function cancel() {
	  return function (dispatch) {
	    clearTimeout(timer);
	    dispatch(setInProgress(false));
	
	    if (pendingRequest && pendingRequest.cancel) {
	      pendingRequest.cancel('CANCELLED');
	    }
	  };
	}
	
	function clearError() {
	  var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	  return function (dispatch, getState) {
	    var _getState3 = getState(),
	        bankId = _getState3.bankId;
	
	    if (force || bankId.error !== null && !bankId.error.keep) {
	      dispatch(setError(null));
	    }
	  };
	}
	
	// Open BankID app on computers
	function startComputerApp(entity) {
	  return function (dispatch) {
	    if (entity.autostart) {
	      document.location.href = entity.autostart;
	    }
	  };
	}

/***/ },
/* 356 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var RESET = exports.RESET = 'bank-info:reset';
	var SET_BANKS = exports.SET_BANKS = 'bank-info:set-banks';
	var SET_SELECTED_BANK = exports.SET_SELECTED_BANK = 'bank-info:set-selected-bank';
	
	var SET_CLEARING_NUMBER = exports.SET_CLEARING_NUMBER = 'bank-info:set-clearing-number';
	var SET_CLEARING_NUMBER_IS_VALID = exports.SET_CLEARING_NUMBER_IS_VALID = 'bank-info:set-clearing-number-is-valid';
	var SET_CLEARING_NUMBER_SUPPRESS_ERROR = exports.SET_CLEARING_NUMBER_SUPPRESS_ERROR = 'bank-info:set-clearing-number-suppress-error';
	var SET_CLEARING_NUMBER_ERROR_MESSAGE = exports.SET_CLEARING_NUMBER_ERROR_MESSAGE = 'bank-info:set-clearing-number-error-message';
	
	var SET_ACCOUNT_NUMBER = exports.SET_ACCOUNT_NUMBER = 'bank-info:set-account-number';
	var SET_ACCOUNT_NUMBER_IS_VALID = exports.SET_ACCOUNT_NUMBER_IS_VALID = 'bank-info:set-account-number-is-valid';
	var SET_ACCOUNT_NUMBER_SUPPRESS_ERROR = exports.SET_ACCOUNT_NUMBER_SUPPRESS_ERROR = 'bank-info:set-account-number-suppress-error';
	var SET_ACCOUNT_NUMBER_ERROR_MESSAGE = exports.SET_ACCOUNT_NUMBER_ERROR_MESSAGE = 'bank-info:set-account-number-error-message';

/***/ },
/* 357 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_CURRENCIES = exports.SET_CURRENCIES = 'currencies:set-currencies';
	var FETCH_CURRENCIES = exports.FETCH_CURRENCIES = 'currencies:fetch-currencies';
	var FETCH_CURRENCIES_SUCCESS = exports.FETCH_CURRENCIES_SUCCESS = 'currencies:fetch-currencies-success';
	var FETCH_CURRENCIES_FAIL = exports.FETCH_CURRENCIES_FAIL = 'currencies:fetch-currencies-fail';
	var ERROR_CURRENCIES = exports.ERROR_CURRENCIES = 'currencies:error-currencies';

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _assign = __webpack_require__(22);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.changeDate = changeDate;
	
	var _actionTypes = __webpack_require__(223);
	
	var type = _interopRequireWildcard(_actionTypes);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = exports.initialState = {
	  dateFilter: {
	    startDate: (0, _moment2.default)().subtract(30, 'days').format('YYYY-MM-DD'),
	    endDate: (0, _moment2.default)().format('YYYY-MM-DD'),
	    error: false
	  }
	};
	
	function changeDate() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case type.CHANGE_START_DATE:
	      return (0, _assign2.default)({}, state.dateFilter, {
	        startDate: action.payload,
	        error: !validateDate(action.payload, state.dateFilter.endDate)
	      });
	
	    case type.CHANGE_END_DATE:
	      return (0, _assign2.default)({}, state.dateFilter, {
	        endDate: action.payload,
	        error: !validateDate(state.dateFilter.startDate, action.payload)
	      });
	
	    default:
	      return state;
	  }
	};
	
	function validateDate(start, end) {
	  return start && end && start <= end;
	}

/***/ },
/* 359 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_ENTITY = exports.SET_ENTITY = 'general-terms:set-entity';

/***/ },
/* 360 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CHANGE_LOCALE = exports.CHANGE_LOCALE = 'locale:change';
	var CHANGE_COUNTRY = exports.CHANGE_COUNTRY = 'locale:country';

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.changeLanguage = changeLanguage;
	
	var _actionTypes = __webpack_require__(360);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _counterpart = __webpack_require__(86);
	
	var _counterpart2 = _interopRequireDefault(_counterpart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function changeLanguage(locale) {
	  // todo: not sure this is the right place
	  _counterpart2.default.setLocale(locale);
	
	  return {
	    type: types.CHANGE_LOCALE,
	    payload: locale
	  };
	}

/***/ },
/* 362 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Created by eriksundqvist on 24/05/16.
	 */
	var SET_USER_ID = exports.SET_USER_ID = 'invoice:set-user-id';
	var SET_TAX_ID = exports.SET_TAX_ID = 'invoice:set-tax-id';
	var SET_SAVE_VACATION_PAY = exports.SET_SAVE_VACATION_PAY = 'invoice:set-save-vacation-pay';
	var SET_CUSTOMER_ENTITY = exports.SET_CUSTOMER_ENTITY = 'invoice:set-company-id';
	var SET_COUPON_ID = exports.SET_COUPON_ID = 'invoice:set-coupon-id';
	var SET_COUPON = exports.SET_COUPON = 'invoice:set-coupon';
	var CLEAR_COUPON = exports.CLEAR_COUPON = 'invoice:clear-coupon';
	var SET_CURRENCY_ID = exports.SET_CURRENCY_ID = 'invoice:set-currency-id';
	var SET_CURRENCY_NAME = exports.SET_CURRENCY_NAME = 'invoice:set-currency-name';
	var SET_CURRENCY_AMOUNT = exports.SET_CURRENCY_AMOUNT = 'invoice:set-currency-amount';
	var SET_AMOUNT = exports.SET_AMOUNT = 'invoice:set-amount';
	var SET_SPECIFICATION = exports.SET_SPECIFICATION = 'invoice:set-specification';
	var SET_INVOICEDATE = exports.SET_INVOICEDATE = 'invoice:set-invoice-date';
	var SET_INVOICEUSER = exports.SET_INVOICEUSER = 'invoice:set-invoice-user';
	var SET_SEND_TO_EMAIL = exports.SET_SEND_TO_EMAIL = 'invoice:set-send-to-email';
	var SET_SEND_TO_EMAIL_SECONDARY = exports.SET_SEND_TO_EMAIL_SECONDARY = 'invoice:set-send-to-email-secondary';
	var SET_SEND_TO_EMAIL_BOOL = exports.SET_SEND_TO_EMAIL_BOOL = 'invoice:set-send-to-email-bool';
	var SET_COMPANY_PHONE = exports.SET_COMPANY_PHONE = 'invoice:set-company-phone';
	var SET_EINVOICE_ADDRESS = exports.SET_EINVOICE_ADDRESS = 'invoice:set-einvoice-address';
	var SET_PO_NUMBER = exports.SET_PO_NUMBER = 'invoice:set-po-number';
	var SET_TAX_KEY_ID = exports.SET_TAX_KEY_ID = 'invoice:set-tax-key-id';
	var SET_EXPRESS_PAYMENT = exports.SET_EXPRESS_PAYMENT = 'invoice:set-express-payment';
	var SET_INVOICE_ID = exports.SET_INVOICE_ID = 'invoice:set-invoice-id';
	var SET_CUSTOMER_ID = exports.SET_CUSTOMER_ID = 'invoice:set-customer-id';
	var SET_SUBMITTED = exports.SET_SUBMITTED = 'invoice:set-submitted';
	var SET_VALID = exports.SET_VALID = 'invoice:set-valid';
	var SET_POSTING = exports.SET_POSTING = 'invoice:set-posting';
	var SET_POST_ERROR = exports.SET_POST_ERROR = 'invoice:set-post-error';
	var SET_SUPPLIER_LEDGER = exports.SET_SUPPLIER_LEDGER = 'invoice:set-supplier-ledger';
	var CLEAR = exports.CLEAR = 'invoice:clear';
	var SET_AMOUNT_INC_VAT = exports.SET_AMOUNT_INC_VAT = 'invoice:set-amount-inc-vat';
	var SET_LOCK_AMOUNT_DISTRIBUTION = exports.SET_LOCK_AMOUNT_DISTRIBUTION = 'invoice:set-lock-amount-distribution';
	var SET_INITIALIZING = exports.SET_INITIALIZING = 'invoice:set-initializing';
	var SET_AMOUNT_AFTER_HSD = exports.SET_AMOUNT_AFTER_HSD = 'invoice:set-amount-after-hsd';
	var SET_ROT = exports.SET_ROT = 'invoice:set-rot';
	var SET_RUT = exports.SET_RUT = 'invoice:set-rut';
	var SET_MANUAL_INVOICE_CALC = exports.SET_MANUAL_INVOICE_CALC = 'invoice:set-manual-invoice-calc';
	var SET_DISPLAY_DATES = exports.SET_DISPLAY_DATES = 'invoice:set-display-dates';
	var SET_DISPLAY_HOURS = exports.SET_DISPLAY_HOURS = 'invoice:set-display-hours';
	var SET_PREREPORT = exports.SET_PREREPORT = 'invoice:set-prereport';
	var SET_PREREPORTED_AT = exports.SET_PREREPORTED_AT = 'invoice:set-prereported-at';
	var SET_TERMSACCEPTED = exports.SET_TERMSACCEPTED = 'invoice:set-termsaccepted';
	var SET_LOGGED_IN_INVOICE_USER_TAXKEYS = exports.SET_LOGGED_IN_INVOICE_USER_TAXKEYS = 'invoice:set-logged-in-invoice-user-taxkeys';
	var SET_LOGGED_IN_INVOICE_USER_TAXKEY_ID = exports.SET_LOGGED_IN_INVOICE_USER_TAXKEY_ID = 'invoice:set-logged-in-invoice-user-taxkey-id';
	var SET_MESSAGE_TYPE = exports.SET_MESSAGE_TYPE = 'invoice:set-message-type';
	var SET_SURVEY_ANSWERS = exports.SET_SURVEY_ANSWERS = 'invoice:set-survey-answers';

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.processInvoiceUser = processInvoiceUser;
	exports.renderExtraInvoicingRows = renderExtraInvoicingRows;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function processInvoiceUser(invoiceUser, allInvoiceUsers) {
	  if (allInvoiceUsers.length === 0) {
	    allInvoiceUsers.push(invoiceUser);
	    return allInvoiceUsers;
	  }
	
	  for (var i = 0; i < allInvoiceUsers.length; i++) {
	    if (allInvoiceUsers[i].userId === invoiceUser.userId || invoiceUser.userId === null) {
	      allInvoiceUsers[i].taxkeyId = invoiceUser.taxkeyId ? invoiceUser.taxkeyId : allInvoiceUsers[i].taxkeyId;
	      allInvoiceUsers[i].total = invoiceUser.total ? invoiceUser.total : allInvoiceUsers[i].total;
	      allInvoiceUsers[i].saveVacationPay = invoiceUser.saveVacationPay ? invoiceUser.saveVacationPay : allInvoiceUsers[i].saveVacationPay;
	      allInvoiceUsers[i].saveItp = invoiceUser.saveItp ? invoiceUser.saveItp : allInvoiceUsers[i].saveItp;
	      allInvoiceUsers[i].allowance = invoiceUser.allowance ? invoiceUser.allowance : allInvoiceUsers[i].allowance;
	      allInvoiceUsers[i].travel = invoiceUser.travel ? invoiceUser.travel : allInvoiceUsers[i].travel;
	    }
	  }
	
	  return allInvoiceUsers;
	}
	
	var _ref = _react2.default.createElement(
	  'b',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'TO' }),
	  ': '
	);
	
	var _ref2 = _react2.default.createElement(
	  'b',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'COPY' }),
	  ': '
	);
	
	var _ref3 = _react2.default.createElement(
	  'b',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'TO' }),
	  ': '
	);
	
	var _ref4 = _react2.default.createElement(
	  'b',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'TO' }),
	  ': '
	);
	
	var _ref5 = _react2.default.createElement(
	  'b',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PO_NUMBER' }),
	  ': '
	);
	
	function renderExtraInvoicingRows(invoice) {
	  switch (invoice.messageType) {
	    case 'email':
	      var to = _react2.default.createElement(
	        'div',
	        { className: 'invoice-details-row' },
	        _ref,
	        invoice.billingEmails[0]
	      );
	      var copy = invoice.billingEmails[1] ? _react2.default.createElement(
	        'div',
	        { className: 'invoice-details-row' },
	        _ref2,
	        invoice.billingEmails[1]
	      ) : null;
	      return _react2.default.createElement(
	        'div',
	        null,
	        to,
	        copy
	      );
	    case 'sms':
	      return _react2.default.createElement(
	        'div',
	        { className: 'invoice-details-row' },
	        _ref3,
	        invoice.companyPhone
	      );
	    case 'e-invoice':
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'invoice-details-row' },
	          _ref4,
	          invoice.eInvoiceEmail
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'invoice-details-row' },
	          _ref5,
	          invoice.poNumber
	        )
	      );
	    default:
	      return null;
	  }
	}

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.openMenu = openMenu;
	exports.closeMenu = closeMenu;
	
	var _actionTypes = __webpack_require__(224);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function openMenu() {
	  return {
	    type: types.OPEN_MAIN_MENU
	  };
	} /**
	   * Created by staffanrantzow on 17/03/16.
	   */
	
	function closeMenu() {
	  return {
	    type: types.CLOSE_MAIN_MENU
	  };
	}

/***/ },
/* 365 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_INVOICE = exports.SET_INVOICE = 'payment:set-invoice';
	var FETCH_INVOICE = exports.FETCH_INVOICE = 'payment:fetch-invoice';
	var FETCH_INVOICE_SUCCESS = exports.FETCH_INVOICE_SUCCESS = 'payment:fetch-invoice-success';
	var FETCH_INVOICE_FAIL = exports.FETCH_INVOICE_FAIL = 'payment:fetch-invoice-fail';
	var ERROR_INVOICE = exports.ERROR_INVOICE = 'payment:error-invoice';
	var CREATE_PAYMENT_REQUEST = exports.CREATE_PAYMENT_REQUEST = 'payment:create-payment-request';
	var SET_PAYMENT_REQUEST = exports.SET_PAYMENT_REQUEST = 'payment:set-payment-request';
	var ERROR_PAYMENT_REQUEST = exports.ERROR_PAYMENT_REQUEST = 'payment:error-payment-request';
	var CREATING_INVOICE_EMAIL = exports.CREATING_INVOICE_EMAIL = 'payment:creating-invoice-email';
	var SUCCESS_INVOICE_EMAIL = exports.SUCCESS_INVOICE_EMAIL = 'payment:success-invoice-email';
	var ERROR_INVOICE_EMAIL = exports.ERROR_INVOICE_EMAIL = 'payment:error-invoice-email';
	var SET_STATUS = exports.SET_STATUS = 'payment:set-status';

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLatestPaymentRequest = exports.createInvoiceEmail = exports.createPaymentRequest = exports.fetchInvoice = exports.setStatus = undefined;
	
	var _actionTypes = __webpack_require__(365);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _axios = __webpack_require__(17);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var setStatus = exports.setStatus = function setStatus(status) {
	  return {
	    type: types.SET_STATUS,
	    payload: status
	  };
	};
	
	var fetchInvoice = exports.fetchInvoice = function fetchInvoice(uuid, includes) {
	  return function (dispatch) {
	    dispatch({ type: types.FETCH_INVOICE });
	    return _frilansFinans.InvoiceService.getByUuid(uuid, includes).then(function (invoice) {
	      dispatch({ type: types.SET_INVOICE, payload: invoice });
	      return invoice;
	    }, function (error) {
	      dispatch({ type: types.ERROR_INVOICE, payload: error });
	    });
	  };
	};
	
	var createPaymentRequest = exports.createPaymentRequest = function createPaymentRequest(uuid) {
	  return function (dispatch) {
	    dispatch({ type: types.CREATE_PAYMENT_REQUEST });
	
	    return _frilansFinans.PaymentRequestService.create(uuid).then(function (paymentRequest) {
	      dispatch({ type: types.SET_PAYMENT_REQUEST, payload: paymentRequest });
	    }, function (error) {
	      dispatch({ type: types.ERROR_PAYMENT_REQUEST, payload: error });
	    });
	  };
	};
	
	var createInvoiceEmail = exports.createInvoiceEmail = function createInvoiceEmail(email) {
	  return function (dispatch, getState) {
	    dispatch({ type: types.CREATING_INVOICE_EMAIL });
	
	    var _getState = getState(),
	        payment = _getState.payment;
	
	    var uuid = payment.invoice.data.uuid;
	
	    return _axios2.default.post('backend://invoices/uuid/' + uuid + '/email', { data: { attributes: { email: email } } }).then(function (response) {
	      dispatch({ type: types.SUCCESS_INVOICE_EMAIL });
	    }, function (error) {
	      dispatch({ type: types.ERROR_INVOICE_EMAIL, payload: error });
	    });
	  };
	};
	
	var getLatestPaymentRequest = exports.getLatestPaymentRequest = function getLatestPaymentRequest(email) {
	  return function (dispatch, getState) {
	    // dispatch({type: types.CREATING_INVOICE_EMAIL});
	    var _getState2 = getState(),
	        payment = _getState2.payment;
	
	    var uuid = payment.invoice.data.uuid;
	
	    return _axios2.default.get('backend://payment-request/' + uuid).then(function (response) {
	      dispatch({ type: types.SET_PAYMENT_REQUEST, payload: response.data.data.attributes });
	    }, function (error) {
	      dispatch({ type: types.ERROR_PAYMENT_REQUEST, payload: error });
	    });
	  };
	};

/***/ },
/* 367 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_INVOICE_PAGE = exports.SET_INVOICE_PAGE = 'scrollposition:set-invoice-page';
	var SET_PREREGISTERED_INVOICE_PAGE = exports.SET_PREREGISTERED_INVOICE_PAGE = 'scrollposition:set-preregistered-invoice-page';
	var SET_SCROLL_POSITION = exports.SET_SCROLL_POSITION = 'scrollposition:set';
	var CLEAR_SCROLL_POSITION = exports.CLEAR_SCROLL_POSITION = 'scrollposition:clear';

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setInvoicePage = setInvoicePage;
	exports.setPreregisteredInvoicePage = setPreregisteredInvoicePage;
	exports.setScrollPosition = setScrollPosition;
	exports.clear = clear;
	
	var _actionTypes = __webpack_require__(367);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function setInvoicePage(invoice) {
	  return {
	    type: types.SET_INVOICE_PAGE,
	    payload: invoice
	  };
	}
	
	function setPreregisteredInvoicePage(preregisteredInvoice) {
	  return {
	    type: types.SET_PREREGISTERED_INVOICE_PAGE,
	    payload: preregisteredInvoice
	  };
	}
	
	function setScrollPosition(scrollPosition) {
	  return {
	    type: types.SET_SCROLL_POSITION,
	    payload: scrollPosition
	  };
	}
	
	function clear() {
	  return {
	    type: types.CLEAR_SCROLL_POSITION
	  };
	}

/***/ },
/* 369 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_SUPPLIER_LEDGER_TYPES = exports.SET_SUPPLIER_LEDGER_TYPES = 'supplier-ledger-types:set';

/***/ },
/* 370 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_TAXKEYS = exports.SET_TAXKEYS = 'taxkeys:set';

/***/ },
/* 371 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_STATUS = exports.SET_STATUS = 'timer:set-status';

/***/ },
/* 372 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_HIDE_FOOTER = exports.SET_HIDE_FOOTER = 'footer:set-hide-footer';
	var SET_SHOW_FOOTER = exports.SET_SHOW_FOOTER = 'footer:set-show-footer';
	var SET_HIDE_HEADER = exports.SET_HIDE_HEADER = 'header:set-hide-header';
	var SET_SHOW_HEADER = exports.SET_SHOW_HEADER = 'header:set-show-header';

/***/ },
/* 373 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_USER = exports.SET_USER = 'user:set';
	var SET_IMAGE_SRC = exports.SET_IMAGE_SRC = 'user:set-image-src';
	var CLEAR_USER = exports.CLEAR_USER = 'user:clear';
	var SET_SOCIAL_SECURITY_NUMBER = exports.SET_SOCIAL_SECURITY_NUMBER = 'user:set-social-security-number';

/***/ },
/* 374 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_VALIDATION_ERRORS = exports.SET_VALIDATION_ERRORS = 'validation-errors:set';
	var CLEAR_VALIDATION_ERRORS = exports.CLEAR_VALIDATION_ERRORS = 'validation-errors:clear';

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setValidationErrors = setValidationErrors;
	exports.clearValidationErrors = clearValidationErrors;
	
	var _actionTypes = __webpack_require__(374);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function setValidationErrors(errors) {
	  return {
	    type: actionTypes.SET_VALIDATION_ERRORS,
	    payload: errors
	  };
	}
	
	function clearValidationErrors() {
	  return {
	    type: actionTypes.CLEAR_VALIDATION_ERRORS
	  };
	}

/***/ },
/* 376 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var selectById = exports.selectById = function selectById(entities, id) {
	  return entities.find(function (entity) {
	    return +entity.id === +id;
	  }) || null;
	};

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SSNValidator = function () {
	  function SSNValidator() {
	    (0, _classCallCheck3.default)(this, SSNValidator);
	  }
	
	  (0, _createClass3.default)(SSNValidator, null, [{
	    key: 'luhnAlgorithm',
	    value: function luhnAlgorithm(val) {
	      var ssn = val.replace(/\D/g, '').split('').reverse().slice(0, 10);
	
	      if (ssn.length !== 10) {
	        return false;
	      }
	
	      var sum = ssn.map(function (n) {
	        return Number(n);
	      }).reduce(function (previous, current, index) {
	        if (index % 2) current *= 2;
	        if (current > 9) current -= 9;
	        return previous + current;
	      });
	      return sum % 10 === 0;
	    }
	  }, {
	    key: 'cleanSSN',
	    value: function cleanSSN(value) {
	      var patternSSN = /^\d{6}(\d{2})?[-]?\d{4}$/;
	
	      if (!patternSSN.test(value)) {
	        return null;
	      }
	
	      if (typeof value === 'number' && value !== undefined) {
	        value = value.toString();
	      } else if (typeof value !== 'string' && typeof value !== 'number' || value === undefined) {
	        return null;
	      }
	      value = value.replace(/\D/g, '');
	
	      switch (value.length) {
	        case 10:
	          return value;
	        case 12:
	          return value.substring(2);
	        default:
	          return null;
	      }
	    }
	  }, {
	    key: 'splitSSN',
	    value: function splitSSN(value) {
	      return value.match(/.{1,2}/g);
	    }
	  }, {
	    key: 'validateSSN',
	    value: function validateSSN(ssn) {
	      ssn = this.cleanSSN(ssn);
	      if (!ssn) {
	        return null;
	      }
	
	      var splitSSn = this.splitSSN(ssn);
	      if (splitSSn[2] > 31 && splitSSn[2] < 60) {
	        return null;
	      }
	
	      if (splitSSn[1] > 12) {
	        return null;
	      }
	
	      if (!this.luhnAlgorithm(ssn)) {
	        return null;
	      }
	      return ssn;
	    }
	  }]);
	  return SSNValidator;
	}();
	
	exports.default = SSNValidator;

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _supplierLedgerRow = __webpack_require__(883);
	
	var _supplierLedgerRow2 = _interopRequireDefault(_supplierLedgerRow);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'th',
	  { className: 'col-ordernr' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ORDER_NR' })
	); /**
	    * Created by staffanrantzow on 28/10/16.
	    */
	
	var _ref2 = _react2.default.createElement(
	  'th',
	  { className: 'col-arrived' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ARRIVED' })
	);
	
	var _ref3 = _react2.default.createElement(
	  'th',
	  { className: 'col-status' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'STATUS' })
	);
	
	var _ref4 = _react2.default.createElement(
	  'th',
	  { className: 'col-paid' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PAID_DATE' })
	);
	
	var _ref5 = _react2.default.createElement(
	  'th',
	  { className: 'col-levid' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'LEV_ID' })
	);
	
	var _ref6 = _react2.default.createElement(
	  'th',
	  { className: 'col-supplier' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SUPPLIER' })
	);
	
	var _ref7 = _react2.default.createElement(
	  'th',
	  { className: 'col-sum' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SUM' })
	);
	
	var SupplierLedgersTable = function (_React$Component) {
	  (0, _inherits3.default)(SupplierLedgersTable, _React$Component);
	
	  function SupplierLedgersTable() {
	    (0, _classCallCheck3.default)(this, SupplierLedgersTable);
	    return (0, _possibleConstructorReturn3.default)(this, (SupplierLedgersTable.__proto__ || (0, _getPrototypeOf2.default)(SupplierLedgersTable)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SupplierLedgersTable, [{
	    key: 'renderRow',
	    value: function renderRow(s, i) {
	      return _react2.default.createElement(_supplierLedgerRow2.default, {
	        supplierLedger: s,
	        hideOrderNumber: this.props.hideOrderNumber,
	        showDetailColumns: this.props.showDetailColumns,
	        key: i });
	    }
	  }, {
	    key: 'renderOrderNumberTh',
	    value: function renderOrderNumberTh() {
	      if (!this.props.hideOrderNumber) {
	        return _ref;
	      }
	    }
	  }, {
	    key: 'renderDetailsArrived',
	    value: function renderDetailsArrived() {
	      if (this.props.showDetailColumns) {
	        return _ref2;
	      }
	    }
	  }, {
	    key: 'renderDetailsStatus',
	    value: function renderDetailsStatus() {
	      if (this.props.showDetailColumns) {
	        return _ref3;
	      }
	    }
	  }, {
	    key: 'renderDetailsPaid',
	    value: function renderDetailsPaid() {
	      if (this.props.showDetailColumns) {
	        return _ref4;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'table-wrapper preview-section' },
	        _react2.default.createElement(
	          'table',
	          { className: 'standard-table slim' },
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _ref5,
	              _ref6,
	              this.renderOrderNumberTh(),
	              this.renderDetailsArrived(),
	              this.renderDetailsStatus(),
	              this.renderDetailsPaid(),
	              _ref7
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            this.props.supplierLedgers.map(this.renderRow.bind(this))
	          )
	        )
	      );
	    }
	  }]);
	  return SupplierLedgersTable;
	}(_react2.default.Component);
	
	exports.default = SupplierLedgersTable;

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'vertical-horizontal-align' },
	  _react2.default.createElement(_components.Spinner, { size: 100 })
	);
	
	var SpinnerPage = function SpinnerPage() {
	  return _ref;
	};
	
	exports.default = SpinnerPage;

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SaveVacationOptions = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _vacationInformationButton = __webpack_require__(905);
	
	var _vacationInformationButton2 = _interopRequireDefault(_vacationInformationButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, {
	    className: 'invoicing-vacation-title',
	    content: 'VACATION_PAY'
	  }),
	  _react2.default.createElement(_vacationInformationButton2.default, null)
	);
	
	var _ref2 = _react2.default.createElement(_vacationInformationButton2.default, null);
	
	var _ref3 = _react2.default.createElement('span', null);
	
	var _ref4 = _react2.default.createElement('span', null);
	
	var SaveVacationOptions = exports.SaveVacationOptions = function (_React$Component) {
	  (0, _inherits3.default)(SaveVacationOptions, _React$Component);
	
	  function SaveVacationOptions(props) {
	    (0, _classCallCheck3.default)(this, SaveVacationOptions);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SaveVacationOptions.__proto__ || (0, _getPrototypeOf2.default)(SaveVacationOptions)).call(this, props));
	
	    _this.state = {};
	
	    _this.changeSaveVacation = _this.changeSaveVacation.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(SaveVacationOptions, [{
	    key: 'changeSaveVacation',
	    value: function changeSaveVacation(event) {
	      var saveVacation = parseInt(event.target.value);
	      this.setState({
	        saveVacation: saveVacation
	      });
	
	      this.props.callback('saveVacationPay', {
	        value: !!saveVacation,
	        valid: true
	      });
	    }
	  }, {
	    key: 'renderTitle',
	    value: function renderTitle() {
	      if (this.props.hideTitle) {
	        return null;
	      }
	
	      return _ref;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var firstAlternativeValue = this.props.reverseButtonOrder ? 1 : 0;
	      var secondAlternativeValue = this.props.reverseButtonOrder ? 0 : 1;
	      var firstAlternativeText = this.props.reverseButtonOrder ? _react2.default.createElement(
	        'span',
	        null,
	        (0, _proxyCounterpart.proxyCounterpart)('COMPLETE_INFORMATION_ORDER_TOOL_INVOICING_INFO_SAVE_VACATION'),
	        _ref2
	      ) : _react2.default.createElement(
	        'span',
	        null,
	        (0, _proxyCounterpart.proxyCounterpart)('COMPLETE_INFORMATION_ORDER_TOOL_INVOICING_INFO_PAY_VACATION')
	      );
	      var secondAlternativeText = this.props.reverseButtonOrder ? _react2.default.createElement(
	        'span',
	        null,
	        (0, _proxyCounterpart.proxyCounterpart)('MODAL_SAVE_VACATION_INVOICING_INFO_CONTINUE_AS_IT_IS')
	      ) : _react2.default.createElement(
	        'span',
	        null,
	        (0, _proxyCounterpart.proxyCounterpart)('COMPLETE_INFORMATION_ORDER_TOOL_INVOICING_INFO_SAVE_VACATION'),
	        ' *'
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'input-row-column' },
	        this.renderTitle(),
	        _react2.default.createElement(
	          'span',
	          { className: 'invoicing-vacation-option' },
	          _react2.default.createElement('input', {
	            id: 'save-vacation-alt-false',
	            type: 'radio',
	            name: 'save-vacation',
	            value: firstAlternativeValue,
	            checked: this.state.saveVacation === firstAlternativeValue,
	            onChange: this.changeSaveVacation
	          }),
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'save-vacation-alt-false' },
	            _ref3,
	            firstAlternativeText
	          )
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'invoicing-vacation-option' },
	          _react2.default.createElement('input', {
	            id: 'save-vacation-alt-true',
	            type: 'radio',
	            name: 'save-vacation',
	            value: secondAlternativeValue,
	            checked: this.state.saveVacation === secondAlternativeValue,
	            onChange: this.changeSaveVacation
	          }),
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'save-vacation-alt-true' },
	            _ref4,
	            secondAlternativeText
	          )
	        )
	      );
	    }
	  }]);
	  return SaveVacationOptions;
	}(_react2.default.Component);
	
	exports.default = SaveVacationOptions;

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(12);
	
	var _index = __webpack_require__(43);
	
	var _supplierLedgerList = __webpack_require__(921);
	
	var _supplierLedgerList2 = _interopRequireDefault(_supplierLedgerList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    supplierLedger: state.invoice.supplierLedger
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    setSupplierLedger: function setSupplierLedger(supplierLedger) {
	      return dispatch((0, _index.setSupplierLedger)(supplierLedger));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_supplierLedgerList2.default);

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _spinnerPage = __webpack_require__(379);
	
	var _spinnerPage2 = _interopRequireDefault(_spinnerPage);
	
	var _paymentError = __webpack_require__(977);
	
	var _paymentError2 = _interopRequireDefault(_paymentError);
	
	var _paymentPaid = __webpack_require__(979);
	
	var _paymentPaid2 = _interopRequireDefault(_paymentPaid);
	
	var _paymentStart = __webpack_require__(980);
	
	var _paymentStart2 = _interopRequireDefault(_paymentStart);
	
	var _paymentCancel = __webpack_require__(383);
	
	var _paymentCancel2 = _interopRequireDefault(_paymentCancel);
	
	var _paymentCredit = __webpack_require__(976);
	
	var _paymentCredit2 = _interopRequireDefault(_paymentCredit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  SpinnerPage: _spinnerPage2.default,
	  PaymentError: _paymentError2.default,
	  PaymentPaid: _paymentPaid2.default,
	  PaymentStart: _paymentStart2.default,
	  PaymentCancel: _paymentCancel2.default,
	  PaymentCredit: _paymentCredit2.default
	};

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref2 = _react2.default.createElement(
	  'header',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PAYMENT_CANCEL_TITLE' })
	);
	
	var _ref3 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PAYMENT_CANCEL_TRY_AGAIN' });
	
	var PaymentCancel = function PaymentCancel(_ref) {
	  var payment = _ref.payment;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'payment-page' },
	    _ref2,
	    _react2.default.createElement(
	      'section',
	      null,
	      _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: (0, _proxyCounterpart.proxyCounterpart)('PAYMENT_CANCEL_MESSAGE') } }),
	      _react2.default.createElement(
	        'a',
	        { className: 'btn', href: '/payment/' + payment.invoice.data.uuid },
	        _ref3
	      )
	    )
	  );
	};
	
	exports.default = PaymentCancel;

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _promise = __webpack_require__(72);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);
	    return new _promise2.default(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);
	          var value = info.value;
	        } catch (error) {
	          reject(error);
	          return;
	        }
	
	        if (info.done) {
	          resolve(value);
	        } else {
	          return _promise2.default.resolve(value).then(function (value) {
	            step("next", value);
	          }, function (err) {
	            step("throw", err);
	          });
	        }
	      }
	
	      return step("next");
	    });
	  };
	};

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(1001);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(18);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1010);


/***/ },
/* 387 */
[1596, 48],
/* 388 */
[1597, 75, 98, 236],
/* 389 */
[1599, 121, 44],
/* 390 */
[1600, 144],
/* 391 */
[1602, 74],
/* 392 */
[1605, 44],
/* 393 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 394 */
[1613, 146, 147, 100, 247, 99, 388, 75],
/* 395 */
[1615, 397, 237],
/* 396 */
[1616, 99, 123, 244],
/* 397 */
[1617, 99, 100, 1032, 244],
/* 398 */
[1619, 39, 31, 98],
/* 399 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ },
/* 400 */
[1621, 74, 59, 241],
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(93);


/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(48);
	var core = __webpack_require__(31);
	var dP = __webpack_require__(65);
	var DESCRIPTORS = __webpack_require__(75);
	var SPECIES = __webpack_require__(44)('species');
	
	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ },
/* 403 */
[1628, 74, 143, 44],
/* 404 */
[1630, 83, 1041, 387, 236, 48, 144],
/* 405 */
[1636, 59],
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(66);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(38);
	var toAbsoluteIndex = __webpack_require__(110);
	var toLength = __webpack_require__(34);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ },
/* 408 */
[1581, 102],
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(45);
	var toObject = __webpack_require__(38);
	var IObject = __webpack_require__(151);
	var toLength = __webpack_require__(34);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(45);
	var isObject = __webpack_require__(24);
	var invoke = __webpack_require__(416);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ },
/* 411 */
[1587, 33, 104, 108, 67, 101, 102, 262, 419, 109, 32, 95, 128],
/* 412 */
[1588, 150, 408],
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(108);
	var getWeak = __webpack_require__(95).getWeak;
	var anObject = __webpack_require__(16);
	var isObject = __webpack_require__(24);
	var anInstance = __webpack_require__(101);
	var forOf = __webpack_require__(102);
	var createArrayMethod = __webpack_require__(76);
	var $has = __webpack_require__(51);
	var validate = __webpack_require__(128);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(177);
	var isObject = __webpack_require__(24);
	var toLength = __webpack_require__(34);
	var ctx = __webpack_require__(67);
	var IS_CONCAT_SPREADABLE = __webpack_require__(28)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ },
/* 415 */
[1597, 32, 23, 255],
/* 416 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ },
/* 417 */
[1601, 24],
/* 418 */
[1602, 16],
/* 419 */
393,
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(264);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ },
/* 421 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ },
/* 422 */
/***/ function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ },
/* 423 */
[1609, 106, 181, 152, 38, 151, 23],
/* 424 */
[1612, 33, 16, 106, 32],
/* 425 */
[1614, 62, 105],
/* 426 */
[1617, 51, 62, 173, 268],
/* 427 */
[1620, 106, 62, 152],
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(105);
	var gOPS = __webpack_require__(181);
	var anObject = __webpack_require__(16);
	var Reflect = __webpack_require__(19).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(19).parseFloat;
	var $trim = __webpack_require__(127).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(272) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(19).parseInt;
	var $trim = __webpack_require__(127).trim;
	var ws = __webpack_require__(272);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ },
/* 431 */
399,
/* 432 */
[1621, 16, 24, 266],
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(34);
	var repeat = __webpack_require__(271);
	var defined = __webpack_require__(78);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(80);
	var toLength = __webpack_require__(34);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ },
/* 435 */
[1638, 28],
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(411);
	var validate = __webpack_require__(128);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(174)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(32) && /./g.flags != 'g') __webpack_require__(33).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(176)
	});


/***/ },
/* 438 */
[1651, 411, 128, 174],
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var each = __webpack_require__(76)(0);
	var redefine = __webpack_require__(53);
	var meta = __webpack_require__(95);
	var assign = __webpack_require__(423);
	var weak = __webpack_require__(413);
	var isObject = __webpack_require__(24);
	var fails = __webpack_require__(23);
	var validate = __webpack_require__(128);
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var tmp = {};
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(174)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ },
/* 440 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	  __locale: "en",
	  days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
	  abbreviated_days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	  months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	  abbreviated_months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	  am: 'AM',
	  pm: 'PM'
	};


/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(187);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var on = function on() {};
	if (_inDOM2.default) {
	  on = function () {
	
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, function (e) {
	        e = e || window.event;
	        e.target = e.target || e.srcElement;
	        e.currentTarget = node;
	        handler.call(node, e);
	      });
	    };
	  }();
	}
	
	exports.default = on;
	module.exports = exports['default'];

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = offset;
	
	var _contains = __webpack_require__(280);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _isWindow = __webpack_require__(281);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	var _ownerDocument = __webpack_require__(279);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function offset(node) {
	  var doc = (0, _ownerDocument2.default)(node),
	      win = (0, _isWindow2.default)(doc),
	      docElem = doc && doc.documentElement,
	      box = { top: 0, left: 0, height: 0, width: 0 };
	
	  if (!doc) return;
	
	  // Make sure it's not a disconnected DOM node
	  if (!(0, _contains2.default)(docElem, node)) return box;
	
	  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect();
	
	  // IE8 getBoundingClientRect doesn't support width & height
	  box = {
	    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
	    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
	    width: (box.width == null ? node.offsetWidth : box.width) || 0,
	    height: (box.height == null ? node.offsetHeight : box.height) || 0
	  };
	
	  return box;
	}
	module.exports = exports['default'];

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = scrollTop;
	
	var _isWindow = __webpack_require__(281);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow2.default)(node);
	
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	}
	module.exports = exports['default'];

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = style;
	
	var _camelizeStyle = __webpack_require__(446);
	
	var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);
	
	var _hyphenateStyle = __webpack_require__(1293);
	
	var _hyphenateStyle2 = _interopRequireDefault(_hyphenateStyle);
	
	var _getComputedStyle2 = __webpack_require__(1288);
	
	var _getComputedStyle3 = _interopRequireDefault(_getComputedStyle2);
	
	var _removeStyle = __webpack_require__(1289);
	
	var _removeStyle2 = _interopRequireDefault(_removeStyle);
	
	var _properties = __webpack_require__(445);
	
	var _isTransform = __webpack_require__(1290);
	
	var _isTransform2 = _interopRequireDefault(_isTransform);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function style(node, property, value) {
	  var css = '';
	  var transforms = '';
	  var props = property;
	
	  if (typeof property === 'string') {
	    if (value === undefined) {
	      return node.style[(0, _camelizeStyle2.default)(property)] || (0, _getComputedStyle3.default)(node).getPropertyValue((0, _hyphenateStyle2.default)(property));
	    } else {
	      (props = {})[property] = value;
	    }
	  }
	
	  Object.keys(props).forEach(function (key) {
	    var value = props[key];
	    if (!value && value !== 0) {
	      (0, _removeStyle2.default)(node, (0, _hyphenateStyle2.default)(key));
	    } else if ((0, _isTransform2.default)(key)) {
	      transforms += key + '(' + value + ') ';
	    } else {
	      css += (0, _hyphenateStyle2.default)(key) + ': ' + value + ';';
	    }
	  });
	
	  if (transforms) {
	    css += _properties.transform + ': ' + transforms + ';';
	  }
	
	  node.style.cssText += ';' + css;
	}
	module.exports = exports['default'];

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;
	
	var _inDOM = __webpack_require__(187);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transform = 'transform';
	var prefix = void 0,
	    transitionEnd = void 0,
	    animationEnd = void 0;
	var transitionProperty = void 0,
	    transitionDuration = void 0,
	    transitionTiming = void 0,
	    transitionDelay = void 0;
	var animationName = void 0,
	    animationDuration = void 0,
	    animationTiming = void 0,
	    animationDelay = void 0;
	
	if (_inDOM2.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	
	
	  exports.transform = transform = prefix + '-' + transform;
	  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
	  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
	  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
	  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';
	
	  exports.animationName = animationName = prefix + '-animation-name';
	  exports.animationDuration = animationDuration = prefix + '-animation-duration';
	  exports.animationTiming = animationTiming = prefix + '-animation-delay';
	  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
	}
	
	exports.transform = transform;
	exports.transitionProperty = transitionProperty;
	exports.transitionTiming = transitionTiming;
	exports.transitionDelay = transitionDelay;
	exports.transitionDuration = transitionDuration;
	exports.transitionEnd = transitionEnd;
	exports.animationName = animationName;
	exports.animationDuration = animationDuration;
	exports.animationTiming = animationTiming;
	exports.animationDelay = animationDelay;
	exports.animationEnd = animationEnd;
	exports.default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	
	  var vendorMap = {
	    O: function O(e) {
	      return 'o' + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return 'webkit' + e;
	    },
	    ms: function ms(e) {
	      return 'MS' + e;
	    }
	  };
	
	  var vendors = Object.keys(vendorMap);
	
	  var transitionEnd = void 0,
	      animationEnd = void 0;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + 'TransitionProperty' in style) {
	      prefix = '-' + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	
	  style = null;
	
	  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
	}

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = camelizeStyleName;
	
	var _camelize = __webpack_require__(1291);
	
	var _camelize2 = _interopRequireDefault(_camelize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var msPattern = /^-ms-/; /**
	                          * Copyright 2014-2015, Facebook, Inc.
	                          * All rights reserved.
	                          * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
	                          */
	function camelizeStyleName(string) {
	  return (0, _camelize2.default)(string.replace(msPattern, 'ms-'));
	}
	module.exports = exports['default'];

/***/ },
/* 447 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var ap      = Array.prototype;
	var concat  = ap.concat;
	var slice   = ap.slice;
	var indexOf = __webpack_require__(1332);
	
	function except(object) {
	  var result = {};
	  var keys = concat.apply(ap, slice.call(arguments, 1));
	
	  for (var key in object) {
	    if (indexOf(keys, key) === -1) {
	      result[key] = object[key];
	    }
	  }
	
	  return result;
	}
	
	module.exports = except;


/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(55);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 450 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 451 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Format DOM attributes to an associative array.
	 *
	 * @param  {NamedNodeMap} - The list of attributes.
	 * @return {Object}       - The object of attributes.
	 */
	function formatAttributes(attributes) {
	    var result = {};
	    var attribute;
	
	    // NamedNodeMap is array-like
	    for (var i = 0, len = attributes.length; i < len; i++) {
	        attribute = attributes[i];
	        result[attribute.name] = attribute.value;
	    }
	
	    return result;
	}
	
	/**
	 * Format the browser DOM nodes to mimic the output of `htmlparser2.parseDOM()`.
	 *
	 * @param  {NodeList} nodes        - The DOM nodes.
	 * @param  {Object}   [parentObj]  - The formatted parent node.
	 * @param  {String}   [directive]  - The directive.
	 * @return {Object}                - The formatted DOM object.
	 */
	function formatDOM(nodes, parentObj, directive) {
	    parentObj = parentObj || null;
	
	    var result = [];
	    var node;
	    var prevNode;
	    var nodeObj;
	
	    // NodeList is array-like
	    for (var i = 0, len = nodes.length; i < len; i++) {
	        node = nodes[i];
	        // reset
	        nodeObj = {
	            next: null,
	            prev: result[i - 1] || null,
	            parent: parentObj
	        };
	
	        // set the next node for the previous node (if applicable)
	        prevNode = result[i - 1];
	        if (prevNode) {
	            prevNode.next = nodeObj;
	        }
	
	        // set the node name if it's not "#text" or "#comment"
	        // e.g., "div"
	        if (node.nodeName.indexOf('#') !== 0) {
	            nodeObj.name = node.nodeName.toLowerCase();
	
	            // also, nodes of type "tag" have "attribs"
	            nodeObj.attribs = {}; // default
	            if (node.attributes && node.attributes.length) {
	                nodeObj.attribs = formatAttributes(node.attributes);
	            }
	        }
	
	        // set the node type
	        // e.g., "tag"
	        switch (node.nodeType) {
	            // 1 = element
	            case 1:
	                if (nodeObj.name === 'script' || nodeObj.name === 'style') {
	                    nodeObj.type = nodeObj.name;
	                } else {
	                    nodeObj.type = 'tag';
	                }
	                // recursively format the children
	                nodeObj.children = formatDOM(node.childNodes, nodeObj);
	                break;
	                // 2 = attribute
	                // 3 = text
	            case 3:
	                nodeObj.type = 'text';
	                nodeObj.data = node.nodeValue;
	                break;
	                // 8 = comment
	            case 8:
	                nodeObj.type = 'comment';
	                nodeObj.data = node.nodeValue;
	                break;
	            default:
	                break;
	        }
	
	        result.push(nodeObj);
	    }
	
	    if (directive) {
	        result.unshift({
	            name: directive.substring(0, directive.indexOf(' ')).toLowerCase(),
	            data: directive,
	            type: 'directive',
	            next: result[0] ? result[0] : null,
	            prev: null,
	            parent: parentObj
	        });
	
	        if (result[1]) {
	            result[1].prev = result[0];
	        }
	    }
	
	    return result;
	}
	
	/**
	 * Detect IE with or without version.
	 *
	 * @param  {Number} [version] - The IE version to detect.
	 * @return {Boolean}          - Whether IE or the version has been detected.
	 */
	function isIE(version) {
	    if (version) {
	        return document.documentMode === version;
	    }
	    return /(MSIE |Trident\/|Edge\/)/.test(navigator.userAgent);
	}
	
	/**
	 * Export utilities.
	 */
	module.exports = {
	    formatAttributes: formatAttributes,
	    formatDOM: formatDOM,
	    isIE: isIE
	};


/***/ },
/* 460 */
/***/ function(module, exports) {

	'use strict';
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Convert a string to camel case.
	 *
	 * @param  {String} string - The string.
	 * @return {String}
	 */
	function camelCase(string) {
	    if (typeof string !== 'string') { // null is an object
	        throw new TypeError('First argument must be a string');
	    }
	    if(string.indexOf('-') < 0) {
	        return string;
	    }
	    return string.toLowerCase().replace(_hyphenPattern, function(_, character) {
	        return character.toUpperCase();
	    });
	}
	
	/**
	 * Swap key with value in an object.
	 *
	 * @param  {Object}   obj        - The object.
	 * @param  {Function} [override] - The override method.
	 * @return {Object}              - The inverted object.
	 */
	function invertObject(obj, override) {
	    if (typeof obj !== 'object' || !obj) { // null is an object
	        throw new TypeError('First argument must be an object');
	    }
	
	    var key;
	    var value;
	    var isOverridePresent = typeof override === 'function';
	    var overrides = {};
	    var result = {};
	
	    for (key in obj) {
	        value = obj[key];
	
	        if (isOverridePresent) {
	            overrides = override(key, value);
	            if (overrides && overrides.length === 2) {
	                result[overrides[0]] = overrides[1];
	                continue;
	            }
	        }
	
	        if (typeof value === 'string') {
	            result[value] = key;
	        }
	    }
	
	    return result;
	}
	
	/**
	 * Export utilties.
	 */
	module.exports = {
	    camelCase: camelCase,
	    invertObject: invertObject
	};


/***/ },
/* 461 */
/***/ function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object),
	    nativeMax = Math.max;
	
	/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
	var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    assignValue(object, key, newValue === undefined ? source[key] : newValue);
	  }
	  return object;
	}
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Assigns own enumerable string keyed properties of source objects to the
	 * destination object. Source objects are applied from left to right.
	 * Subsequent sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object` and is loosely based on
	 * [`Object.assign`](https://mdn.io/Object/assign).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assignIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assign({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var assign = createAssigner(function(object, source) {
	  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
	    copyObject(source, keys(source), object);
	    return;
	  }
	  for (var key in source) {
	    if (hasOwnProperty.call(source, key)) {
	      assignValue(object, key, source[key]);
	    }
	  }
	});
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = assign;


/***/ },
/* 462 */,
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var af = moment.defineLocale('af', {
	    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	    meridiemParse: /vm|nm/i,
	    isPM : function (input) {
	        return /^nm$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'vm' : 'VM';
	        } else {
	            return isLower ? 'nm' : 'NM';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Vandag om] LT',
	        nextDay : '[Môre om] LT',
	        nextWeek : 'dddd [om] LT',
	        lastDay : '[Gister om] LT',
	        lastWeek : '[Laas] dddd [om] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'oor %s',
	        past : '%s gelede',
	        s : '\'n paar sekondes',
	        ss : '%d sekondes',
	        m : '\'n minuut',
	        mm : '%d minute',
	        h : '\'n uur',
	        hh : '%d ure',
	        d : '\'n dag',
	        dd : '%d dae',
	        M : '\'n maand',
	        MM : '%d maande',
	        y : '\'n jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	    },
	    week : {
	        dow : 1, // Maandag is die eerste dag van die week.
	        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	    }
	});
	
	return af;
	
	})));


/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arDz = moment.defineLocale('ar-dz', {
	    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        ss : '%d ثانية',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 4  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arDz;
	
	})));


/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arKw = moment.defineLocale('ar-kw', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        ss : '%d ثانية',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arKw;
	
	})));


/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '1',
	    '2': '2',
	    '3': '3',
	    '4': '4',
	    '5': '5',
	    '6': '6',
	    '7': '7',
	    '8': '8',
	    '9': '9',
	    '0': '0'
	}, pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	}, plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	}, pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	}, months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var arLy = moment.defineLocale('ar-ly', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        ss : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arLy;
	
	})));


/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arMa = moment.defineLocale('ar-ma', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        ss : '%d ثانية',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arMa;
	
	})));


/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	}, numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	
	var arSa = moment.defineLocale('ar-sa', {
	    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        ss : '%d ثانية',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arSa;
	
	})));


/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arTn = moment.defineLocale('ar-tn', {
	    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        ss : '%d ثانية',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return arTn;
	
	})));


/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	}, numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	}, pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	}, plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	}, pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	}, months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var ar = moment.defineLocale('ar', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        ss : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ar;
	
	})));


/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '-inci',
	    5: '-inci',
	    8: '-inci',
	    70: '-inci',
	    80: '-inci',
	    2: '-nci',
	    7: '-nci',
	    20: '-nci',
	    50: '-nci',
	    3: '-üncü',
	    4: '-üncü',
	    100: '-üncü',
	    6: '-ncı',
	    9: '-uncu',
	    10: '-uncu',
	    30: '-uncu',
	    60: '-ıncı',
	    90: '-ıncı'
	};
	
	var az = moment.defineLocale('az', {
	    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[sabah saat] LT',
	        nextWeek : '[gələn həftə] dddd [saat] LT',
	        lastDay : '[dünən] LT',
	        lastWeek : '[keçən həftə] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s əvvəl',
	        s : 'birneçə saniyyə',
	        ss : '%d saniyə',
	        m : 'bir dəqiqə',
	        mm : '%d dəqiqə',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir il',
	        yy : '%d il'
	    },
	    meridiemParse: /gecə|səhər|gündüz|axşam/,
	    isPM : function (input) {
	        return /^(gündüz|axşam)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'gecə';
	        } else if (hour < 12) {
	            return 'səhər';
	        } else if (hour < 17) {
	            return 'gündüz';
	        } else {
	            return 'axşam';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '-ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return az;
	
	})));


/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	        'dd': 'дзень_дні_дзён',
	        'MM': 'месяц_месяцы_месяцаў',
	        'yy': 'год_гады_гадоў'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвіліна' : 'хвіліну';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'гадзіна' : 'гадзіну';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	
	var be = moment.defineLocale('be', {
	    months : {
	        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	    },
	    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays : {
	        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	    },
	    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сёння ў] LT',
	        nextDay: '[Заўтра ў] LT',
	        lastDay: '[Учора ў] LT',
	        nextWeek: function () {
	            return '[У] dddd [ў] LT';
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'праз %s',
	        past : '%s таму',
	        s : 'некалькі секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithPlural,
	        hh : relativeTimeWithPlural,
	        d : 'дзень',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночы|раніцы|дня|вечара/,
	    isPM : function (input) {
	        return /^(дня|вечара)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночы';
	        } else if (hour < 12) {
	            return 'раніцы';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечара';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return be;
	
	})));


/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var bg = moment.defineLocale('bg', {
	    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Днес в] LT',
	        nextDay : '[Утре в] LT',
	        nextWeek : 'dddd [в] LT',
	        lastDay : '[Вчера в] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'след %s',
	        past : 'преди %s',
	        s : 'няколко секунди',
	        ss : '%d секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дни',
	        M : 'месец',
	        MM : '%d месеца',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bg;
	
	})));


/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var bm = moment.defineLocale('bm', {
	    months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
	    monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	    weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	    weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	    weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'MMMM [tile] D [san] YYYY',
	        LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bi lɛrɛ] LT',
	        nextDay : '[Sini lɛrɛ] LT',
	        nextWeek : 'dddd [don lɛrɛ] LT',
	        lastDay : '[Kunu lɛrɛ] LT',
	        lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s kɔnɔ',
	        past : 'a bɛ %s bɔ',
	        s : 'sanga dama dama',
	        ss : 'sekondi %d',
	        m : 'miniti kelen',
	        mm : 'miniti %d',
	        h : 'lɛrɛ kelen',
	        hh : 'lɛrɛ %d',
	        d : 'tile kelen',
	        dd : 'tile %d',
	        M : 'kalo kelen',
	        MM : 'kalo %d',
	        y : 'san kelen',
	        yy : 'san %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return bm;
	
	})));


/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	},
	numberMap = {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	};
	
	var bn = moment.defineLocale('bn', {
	    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm সময়',
	        LTS : 'A h:mm:ss সময়',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm সময়',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	    },
	    calendar : {
	        sameDay : '[আজ] LT',
	        nextDay : '[আগামীকাল] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[গতকাল] LT',
	        lastWeek : '[গত] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s পরে',
	        past : '%s আগে',
	        s : 'কয়েক সেকেন্ড',
	        ss : '%d সেকেন্ড',
	        m : 'এক মিনিট',
	        mm : '%d মিনিট',
	        h : 'এক ঘন্টা',
	        hh : '%d ঘন্টা',
	        d : 'এক দিন',
	        dd : '%d দিন',
	        M : 'এক মাস',
	        MM : '%d মাস',
	        y : 'এক বছর',
	        yy : '%d বছর'
	    },
	    preparse: function (string) {
	        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'রাত';
	        } else if (hour < 10) {
	            return 'সকাল';
	        } else if (hour < 17) {
	            return 'দুপুর';
	        } else if (hour < 20) {
	            return 'বিকাল';
	        } else {
	            return 'রাত';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bn;
	
	})));


/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '༡',
	    '2': '༢',
	    '3': '༣',
	    '4': '༤',
	    '5': '༥',
	    '6': '༦',
	    '7': '༧',
	    '8': '༨',
	    '9': '༩',
	    '0': '༠'
	},
	numberMap = {
	    '༡': '1',
	    '༢': '2',
	    '༣': '3',
	    '༤': '4',
	    '༥': '5',
	    '༦': '6',
	    '༧': '7',
	    '༨': '8',
	    '༩': '9',
	    '༠': '0'
	};
	
	var bo = moment.defineLocale('bo', {
	    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[དི་རིང] LT',
	        nextDay : '[སང་ཉིན] LT',
	        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	        lastDay : '[ཁ་སང] LT',
	        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ལ་',
	        past : '%s སྔན་ལ',
	        s : 'ལམ་སང',
	        ss : '%d སྐར་ཆ།',
	        m : 'སྐར་མ་གཅིག',
	        mm : '%d སྐར་མ',
	        h : 'ཆུ་ཚོད་གཅིག',
	        hh : '%d ཆུ་ཚོད',
	        d : 'ཉིན་གཅིག',
	        dd : '%d ཉིན་',
	        M : 'ཟླ་བ་གཅིག',
	        MM : '%d ཟླ་བ',
	        y : 'ལོ་གཅིག',
	        yy : '%d ལོ'
	    },
	    preparse: function (string) {
	        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'མཚན་མོ';
	        } else if (hour < 10) {
	            return 'ཞོགས་ཀས';
	        } else if (hour < 17) {
	            return 'ཉིན་གུང';
	        } else if (hour < 20) {
	            return 'དགོང་དག';
	        } else {
	            return 'མཚན་མོ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bo;
	
	})));


/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithMutation(number, withoutSuffix, key) {
	    var format = {
	        'mm': 'munutenn',
	        'MM': 'miz',
	        'dd': 'devezh'
	    };
	    return number + ' ' + mutation(format[key], number);
	}
	function specialMutationForYears(number) {
	    switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	    }
	}
	function lastNumber(number) {
	    if (number > 9) {
	        return lastNumber(number % 10);
	    }
	    return number;
	}
	function mutation(text, number) {
	    if (number === 2) {
	        return softMutation(text);
	    }
	    return text;
	}
	function softMutation(text) {
	    var mutationTable = {
	        'm': 'v',
	        'b': 'v',
	        'd': 'z'
	    };
	    if (mutationTable[text.charAt(0)] === undefined) {
	        return text;
	    }
	    return mutationTable[text.charAt(0)] + text.substring(1);
	}
	
	var br = moment.defineLocale('br', {
	    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h[e]mm A',
	        LTS : 'h[e]mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [a viz] MMMM YYYY',
	        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	    },
	    calendar : {
	        sameDay : '[Hiziv da] LT',
	        nextDay : '[Warc\'hoazh da] LT',
	        nextWeek : 'dddd [da] LT',
	        lastDay : '[Dec\'h da] LT',
	        lastWeek : 'dddd [paset da] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'a-benn %s',
	        past : '%s \'zo',
	        s : 'un nebeud segondennoù',
	        ss : '%d eilenn',
	        m : 'ur vunutenn',
	        mm : relativeTimeWithMutation,
	        h : 'un eur',
	        hh : '%d eur',
	        d : 'un devezh',
	        dd : relativeTimeWithMutation,
	        M : 'ur miz',
	        MM : relativeTimeWithMutation,
	        y : 'ur bloaz',
	        yy : specialMutationForYears
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	    ordinal : function (number) {
	        var output = (number === 1) ? 'añ' : 'vet';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return br;
	
	})));


/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'ss':
	            if (number === 1) {
	                result += 'sekunda';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sekunde';
	            } else {
	                result += 'sekundi';
	            }
	            return result;
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var bs = moment.defineLocale('bs', {
	    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        ss     : translate,
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bs;
	
	})));


/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ca = moment.defineLocale('ca', {
	    months : {
	        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	        isFormat: /D[oD]?(\s)+MMMM/
	    },
	    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [de] YYYY',
	        ll : 'D MMM YYYY',
	        LLL : 'D MMMM [de] YYYY [a les] H:mm',
	        lll : 'D MMM YYYY, H:mm',
	        LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
	        llll : 'ddd D MMM YYYY, H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextDay : function () {
	            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastDay : function () {
	            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'd\'aquí %s',
	        past : 'fa %s',
	        s : 'uns segons',
	        ss : '%d segons',
	        m : 'un minut',
	        mm : '%d minuts',
	        h : 'una hora',
	        hh : '%d hores',
	        d : 'un dia',
	        dd : '%d dies',
	        M : 'un mes',
	        MM : '%d mesos',
	        y : 'un any',
	        yy : '%d anys'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal : function (number, period) {
	        var output = (number === 1) ? 'r' :
	            (number === 2) ? 'n' :
	            (number === 3) ? 'r' :
	            (number === 4) ? 't' : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ca;
	
	})));


/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	    monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            } else {
	                return result + 'sekundami';
	            }
	            break;
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	    }
	}
	
	var cs = moment.defineLocale('cs', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParse : (function (months, monthsShort) {
	        var i, _monthsParse = [];
	        for (i = 0; i < 12; i++) {
	            // use custom parser to solve problem with July (červenec)
	            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	        }
	        return _monthsParse;
	    }(months, monthsShort)),
	    shortMonthsParse : (function (monthsShort) {
	        var i, _shortMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	        }
	        return _shortMonthsParse;
	    }(monthsShort)),
	    longMonthsParse : (function (months) {
	        var i, _longMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	        }
	        return _longMonthsParse;
	    }(months)),
	    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm',
	        l : 'D. M. YYYY'
	    },
	    calendar : {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'před %s',
	        s : translate,
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cs;
	
	})));


/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cv = moment.defineLocale('cv', {
	    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	    },
	    calendar : {
	        sameDay: '[Паян] LT [сехетре]',
	        nextDay: '[Ыран] LT [сехетре]',
	        lastDay: '[Ӗнер] LT [сехетре]',
	        nextWeek: '[Ҫитес] dddd LT [сехетре]',
	        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (output) {
	            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	            return output + affix;
	        },
	        past : '%s каялла',
	        s : 'пӗр-ик ҫеккунт',
	        ss : '%d ҫеккунт',
	        m : 'пӗр минут',
	        mm : '%d минут',
	        h : 'пӗр сехет',
	        hh : '%d сехет',
	        d : 'пӗр кун',
	        dd : '%d кун',
	        M : 'пӗр уйӑх',
	        MM : '%d уйӑх',
	        y : 'пӗр ҫул',
	        yy : '%d ҫул'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	    ordinal : '%d-мӗш',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return cv;
	
	})));


/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cy = moment.defineLocale('cy', {
	    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    // time formats are the same as en-gb
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Heddiw am] LT',
	        nextDay: '[Yfory am] LT',
	        nextWeek: 'dddd [am] LT',
	        lastDay: '[Ddoe am] LT',
	        lastWeek: 'dddd [diwethaf am] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'mewn %s',
	        past: '%s yn ôl',
	        s: 'ychydig eiliadau',
	        ss: '%d eiliad',
	        m: 'munud',
	        mm: '%d munud',
	        h: 'awr',
	        hh: '%d awr',
	        d: 'diwrnod',
	        dd: '%d diwrnod',
	        M: 'mis',
	        MM: '%d mis',
	        y: 'blwyddyn',
	        yy: '%d flynedd'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	    ordinal: function (number) {
	        var b = number,
	            output = '',
	            lookup = [
	                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	        if (b > 20) {
	            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                output = 'fed'; // not 30ain, 70ain or 90ain
	            } else {
	                output = 'ain';
	            }
	        } else if (b > 0) {
	            output = lookup[b];
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cy;
	
	})));


/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var da = moment.defineLocale('da', {
	    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay : '[i dag kl.] LT',
	        nextDay : '[i morgen kl.] LT',
	        nextWeek : 'på dddd [kl.] LT',
	        lastDay : '[i går kl.] LT',
	        lastWeek : '[i] dddd[s kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'få sekunder',
	        ss : '%d sekunder',
	        m : 'et minut',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dage',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'et år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return da;
	
	})));


/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deAt = moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        ss : '%d Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deAt;
	
	})));


/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deCh = moment.defineLocale('de-ch', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        ss : '%d Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deCh;
	
	})));


/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var de = moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        ss : '%d Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return de;
	
	})));


/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'ޖެނުއަރީ',
	    'ފެބްރުއަރީ',
	    'މާރިޗު',
	    'އޭޕްރީލު',
	    'މޭ',
	    'ޖޫން',
	    'ޖުލައި',
	    'އޯގަސްޓު',
	    'ސެޕްޓެމްބަރު',
	    'އޮކްޓޯބަރު',
	    'ނޮވެމްބަރު',
	    'ޑިސެމްބަރު'
	], weekdays = [
	    'އާދިއްތަ',
	    'ހޯމަ',
	    'އަންގާރަ',
	    'ބުދަ',
	    'ބުރާސްފަތި',
	    'ހުކުރު',
	    'ހޮނިހިރު'
	];
	
	var dv = moment.defineLocale('dv', {
	    months : months,
	    monthsShort : months,
	    weekdays : weekdays,
	    weekdaysShort : weekdays,
	    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	    longDateFormat : {
	
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/M/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /މކ|މފ/,
	    isPM : function (input) {
	        return 'މފ' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'މކ';
	        } else {
	            return 'މފ';
	        }
	    },
	    calendar : {
	        sameDay : '[މިއަދު] LT',
	        nextDay : '[މާދަމާ] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[އިއްޔެ] LT',
	        lastWeek : '[ފާއިތުވި] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ތެރޭގައި %s',
	        past : 'ކުރިން %s',
	        s : 'ސިކުންތުކޮޅެއް',
	        ss : 'd% ސިކުންތު',
	        m : 'މިނިޓެއް',
	        mm : 'މިނިޓު %d',
	        h : 'ގަޑިއިރެއް',
	        hh : 'ގަޑިއިރު %d',
	        d : 'ދުވަހެއް',
	        dd : 'ދުވަސް %d',
	        M : 'މަހެއް',
	        MM : 'މަސް %d',
	        y : 'އަހަރެއް',
	        yy : 'އަހަރު %d'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 7,  // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return dv;
	
	})));


/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	
	var el = moment.defineLocale('el', {
	    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return this._monthsNominativeEl;
	        } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM : function (input) {
	        return ((input + '').toLowerCase()[0] === 'μ');
	    },
	    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendarEl : {
	        sameDay : '[Σήμερα {}] LT',
	        nextDay : '[Αύριο {}] LT',
	        nextWeek : 'dddd [{}] LT',
	        lastDay : '[Χθες {}] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    calendar : function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	    },
	    relativeTime : {
	        future : 'σε %s',
	        past : '%s πριν',
	        s : 'λίγα δευτερόλεπτα',
	        ss : '%d δευτερόλεπτα',
	        m : 'ένα λεπτό',
	        mm : '%d λεπτά',
	        h : 'μία ώρα',
	        hh : '%d ώρες',
	        d : 'μία μέρα',
	        dd : '%d μέρες',
	        M : 'ένας μήνας',
	        MM : '%d μήνες',
	        y : 'ένας χρόνος',
	        yy : '%d χρόνια'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4st is the first week of the year.
	    }
	});
	
	return el;
	
	})));


/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enAu = moment.defineLocale('en-au', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enAu;
	
	})));


/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enCa = moment.defineLocale('en-ca', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'YYYY-MM-DD',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	return enCa;
	
	})));


/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enIe = moment.defineLocale('en-ie', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enIe;
	
	})));


/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enIl = moment.defineLocale('en-il', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	return enIl;
	
	})));


/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enNz = moment.defineLocale('en-nz', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enNz;
	
	})));


/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eo = moment.defineLocale('eo', {
	    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D[-a de] MMMM, YYYY',
	        LLL : 'D[-a de] MMMM, YYYY HH:mm',
	        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	    },
	    meridiemParse: /[ap]\.t\.m/i,
	    isPM: function (input) {
	        return input.charAt(0).toLowerCase() === 'p';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'p.t.m.' : 'P.T.M.';
	        } else {
	            return isLower ? 'a.t.m.' : 'A.T.M.';
	        }
	    },
	    calendar : {
	        sameDay : '[Hodiaŭ je] LT',
	        nextDay : '[Morgaŭ je] LT',
	        nextWeek : 'dddd [je] LT',
	        lastDay : '[Hieraŭ je] LT',
	        lastWeek : '[pasinta] dddd [je] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'post %s',
	        past : 'antaŭ %s',
	        s : 'sekundoj',
	        ss : '%d sekundoj',
	        m : 'minuto',
	        mm : '%d minutoj',
	        h : 'horo',
	        hh : '%d horoj',
	        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	        dd : '%d tagoj',
	        M : 'monato',
	        MM : '%d monatoj',
	        y : 'jaro',
	        yy : '%d jaroj'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}a/,
	    ordinal : '%da',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eo;
	
	})));


/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	    monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	var esDo = moment.defineLocale('es-do', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	    monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	    monthsParse: monthsParse,
	    longMonthsParse: monthsParse,
	    shortMonthsParse: monthsParse,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        ss : '%d segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return esDo;
	
	})));


/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	    monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var esUs = moment.defineLocale('es-us', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'MM/DD/YYYY',
	        LL : 'MMMM [de] D [de] YYYY',
	        LLL : 'MMMM [de] D [de] YYYY h:mm A',
	        LLLL : 'dddd, MMMM [de] D [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        ss : '%d segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return esUs;
	
	})));


/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	    monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	var es = moment.defineLocale('es', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsRegex : monthsRegex,
	    monthsShortRegex : monthsRegex,
	    monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	    monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        ss : '%d segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return es;
	
	})));


/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	        'ss': [number + 'sekundi', number + 'sekundit'],
	        'm' : ['ühe minuti', 'üks minut'],
	        'mm': [number + ' minuti', number + ' minutit'],
	        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	        'hh': [number + ' tunni', number + ' tundi'],
	        'd' : ['ühe päeva', 'üks päev'],
	        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	        'MM': [number + ' kuu', number + ' kuud'],
	        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	        'yy': [number + ' aasta', number + ' aastat']
	    };
	    if (withoutSuffix) {
	        return format[key][2] ? format[key][2] : format[key][1];
	    }
	    return isFuture ? format[key][0] : format[key][1];
	}
	
	var et = moment.defineLocale('et', {
	    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	    longDateFormat : {
	        LT   : 'H:mm',
	        LTS : 'H:mm:ss',
	        L    : 'DD.MM.YYYY',
	        LL   : 'D. MMMM YYYY',
	        LLL  : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[Täna,] LT',
	        nextDay  : '[Homme,] LT',
	        nextWeek : '[Järgmine] dddd LT',
	        lastDay  : '[Eile,] LT',
	        lastWeek : '[Eelmine] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s pärast',
	        past   : '%s tagasi',
	        s      : processRelativeTime,
	        ss     : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : '%d päeva',
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return et;
	
	})));


/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eu = moment.defineLocale('eu', {
	    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY[ko] MMMM[ren] D[a]',
	        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	        l : 'YYYY-M-D',
	        ll : 'YYYY[ko] MMM D[a]',
	        lll : 'YYYY[ko] MMM D[a] HH:mm',
	        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	    },
	    calendar : {
	        sameDay : '[gaur] LT[etan]',
	        nextDay : '[bihar] LT[etan]',
	        nextWeek : 'dddd LT[etan]',
	        lastDay : '[atzo] LT[etan]',
	        lastWeek : '[aurreko] dddd LT[etan]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s barru',
	        past : 'duela %s',
	        s : 'segundo batzuk',
	        ss : '%d segundo',
	        m : 'minutu bat',
	        mm : '%d minutu',
	        h : 'ordu bat',
	        hh : '%d ordu',
	        d : 'egun bat',
	        dd : '%d egun',
	        M : 'hilabete bat',
	        MM : '%d hilabete',
	        y : 'urte bat',
	        yy : '%d urte'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eu;
	
	})));


/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '۱',
	    '2': '۲',
	    '3': '۳',
	    '4': '۴',
	    '5': '۵',
	    '6': '۶',
	    '7': '۷',
	    '8': '۸',
	    '9': '۹',
	    '0': '۰'
	}, numberMap = {
	    '۱': '1',
	    '۲': '2',
	    '۳': '3',
	    '۴': '4',
	    '۵': '5',
	    '۶': '6',
	    '۷': '7',
	    '۸': '8',
	    '۹': '9',
	    '۰': '0'
	};
	
	var fa = moment.defineLocale('fa', {
	    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /قبل از ظهر|بعد از ظهر/,
	    isPM: function (input) {
	        return /بعد از ظهر/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'قبل از ظهر';
	        } else {
	            return 'بعد از ظهر';
	        }
	    },
	    calendar : {
	        sameDay : '[امروز ساعت] LT',
	        nextDay : '[فردا ساعت] LT',
	        nextWeek : 'dddd [ساعت] LT',
	        lastDay : '[دیروز ساعت] LT',
	        lastWeek : 'dddd [پیش] [ساعت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'در %s',
	        past : '%s پیش',
	        s : 'چند ثانیه',
	        ss : 'ثانیه d%',
	        m : 'یک دقیقه',
	        mm : '%d دقیقه',
	        h : 'یک ساعت',
	        hh : '%d ساعت',
	        d : 'یک روز',
	        dd : '%d روز',
	        M : 'یک ماه',
	        MM : '%d ماه',
	        y : 'یک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/[۰-۹]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}م/,
	    ordinal : '%dم',
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return fa;
	
	})));


/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	    numbersFuture = [
	        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	        numbersPast[7], numbersPast[8], numbersPast[9]
	    ];
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'ss':
	            return isFuture ? 'sekunnin' : 'sekuntia';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(number, isFuture) {
	    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	}
	
	var fi = moment.defineLocale('fi', {
	    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'Do MMMM[ta] YYYY',
	        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l : 'D.M.YYYY',
	        ll : 'Do MMM YYYY',
	        lll : 'Do MMM YYYY, [klo] HH.mm',
	        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar : {
	        sameDay : '[tänään] [klo] LT',
	        nextDay : '[huomenna] [klo] LT',
	        nextWeek : 'dddd [klo] LT',
	        lastDay : '[eilen] [klo] LT',
	        lastWeek : '[viime] dddd[na] [klo] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s päästä',
	        past : '%s sitten',
	        s : translate,
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fi;
	
	})));


/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fo = moment.defineLocale('fo', {
	    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D. MMMM, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Í dag kl.] LT',
	        nextDay : '[Í morgin kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[Í gjár kl.] LT',
	        lastWeek : '[síðstu] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'um %s',
	        past : '%s síðani',
	        s : 'fá sekund',
	        ss : '%d sekundir',
	        m : 'ein minutt',
	        mm : '%d minuttir',
	        h : 'ein tími',
	        hh : '%d tímar',
	        d : 'ein dagur',
	        dd : '%d dagar',
	        M : 'ein mánaði',
	        MM : '%d mánaðir',
	        y : 'eitt ár',
	        yy : '%d ár'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fo;
	
	})));


/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCa = moment.defineLocale('fr-ca', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        ss : '%d secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    }
	});
	
	return frCa;
	
	})));


/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCh = moment.defineLocale('fr-ch', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        ss : '%d secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return frCh;
	
	})));


/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fr = moment.defineLocale('fr', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        ss : '%d secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // TODO: Return 'e' when day of month > 1. Move this case inside
	            // block for masculine words below.
	            // See https://github.com/moment/moment/issues/3375
	            case 'D':
	                return number + (number === 1 ? 'er' : '');
	
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fr;
	
	})));


/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	    monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	var fy = moment.defineLocale('fy', {
	    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[hjoed om] LT',
	        nextDay: '[moarn om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[juster om] LT',
	        lastWeek: '[ôfrûne] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'oer %s',
	        past : '%s lyn',
	        s : 'in pear sekonden',
	        ss : '%d sekonden',
	        m : 'ien minút',
	        mm : '%d minuten',
	        h : 'ien oere',
	        hh : '%d oeren',
	        d : 'ien dei',
	        dd : '%d dagen',
	        M : 'ien moanne',
	        MM : '%d moannen',
	        y : 'ien jier',
	        yy : '%d jierren'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fy;
	
	})));


/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	];
	
	var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	var gd = moment.defineLocale('gd', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParseExact : true,
	    weekdays : weekdays,
	    weekdaysShort : weekdaysShort,
	    weekdaysMin : weekdaysMin,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[An-diugh aig] LT',
	        nextDay : '[A-màireach aig] LT',
	        nextWeek : 'dddd [aig] LT',
	        lastDay : '[An-dè aig] LT',
	        lastWeek : 'dddd [seo chaidh] [aig] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ann an %s',
	        past : 'bho chionn %s',
	        s : 'beagan diogan',
	        ss : '%d diogan',
	        m : 'mionaid',
	        mm : '%d mionaidean',
	        h : 'uair',
	        hh : '%d uairean',
	        d : 'latha',
	        dd : '%d latha',
	        M : 'mìos',
	        MM : '%d mìosan',
	        y : 'bliadhna',
	        yy : '%d bliadhna'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	    ordinal : function (number) {
	        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gd;
	
	})));


/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var gl = moment.defineLocale('gl', {
	    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        lastDay : function () {
	            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	        },
	        lastWeek : function () {
	            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (str) {
	            if (str.indexOf('un') === 0) {
	                return 'n' + str;
	            }
	            return 'en ' + str;
	        },
	        past : 'hai %s',
	        s : 'uns segundos',
	        ss : '%d segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'unha hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gl;
	
	})));


/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['thodde secondanim', 'thodde second'],
	        'ss': [number + ' secondanim', number + ' second'],
	        'm': ['eka mintan', 'ek minute'],
	        'mm': [number + ' mintanim', number + ' mintam'],
	        'h': ['eka horan', 'ek hor'],
	        'hh': [number + ' horanim', number + ' hor'],
	        'd': ['eka disan', 'ek dis'],
	        'dd': [number + ' disanim', number + ' dis'],
	        'M': ['eka mhoinean', 'ek mhoino'],
	        'MM': [number + ' mhoineanim', number + ' mhoine'],
	        'y': ['eka vorsan', 'ek voros'],
	        'yy': [number + ' vorsanim', number + ' vorsam']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var gomLatn = moment.defineLocale('gom-latn', {
	    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'A h:mm [vazta]',
	        LTS : 'A h:mm:ss [vazta]',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY A h:mm [vazta]',
	        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	    },
	    calendar : {
	        sameDay: '[Aiz] LT',
	        nextDay: '[Faleam] LT',
	        nextWeek: '[Ieta to] dddd[,] LT',
	        lastDay: '[Kal] LT',
	        lastWeek: '[Fatlo] dddd[,] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s',
	        past : '%s adim',
	        s : processRelativeTime,
	        ss : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // the ordinal 'er' only applies to day of the month
	            case 'D':
	                return number + 'er';
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	            case 'w':
	            case 'W':
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    },
	    meridiemParse: /rati|sokalli|donparam|sanje/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'rati') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'sokalli') {
	            return hour;
	        } else if (meridiem === 'donparam') {
	            return hour > 12 ? hour : hour + 12;
	        } else if (meridiem === 'sanje') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'rati';
	        } else if (hour < 12) {
	            return 'sokalli';
	        } else if (hour < 16) {
	            return 'donparam';
	        } else if (hour < 20) {
	            return 'sanje';
	        } else {
	            return 'rati';
	        }
	    }
	});
	
	return gomLatn;
	
	})));


/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	        '1': '૧',
	        '2': '૨',
	        '3': '૩',
	        '4': '૪',
	        '5': '૫',
	        '6': '૬',
	        '7': '૭',
	        '8': '૮',
	        '9': '૯',
	        '0': '૦'
	    },
	    numberMap = {
	        '૧': '1',
	        '૨': '2',
	        '૩': '3',
	        '૪': '4',
	        '૫': '5',
	        '૬': '6',
	        '૭': '7',
	        '૮': '8',
	        '૯': '9',
	        '૦': '0'
	    };
	
	var gu = moment.defineLocale('gu', {
	    months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
	    monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
	    weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	    weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	    longDateFormat: {
	        LT: 'A h:mm વાગ્યે',
	        LTS: 'A h:mm:ss વાગ્યે',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	        LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
	    },
	    calendar: {
	        sameDay: '[આજ] LT',
	        nextDay: '[કાલે] LT',
	        nextWeek: 'dddd, LT',
	        lastDay: '[ગઇકાલે] LT',
	        lastWeek: '[પાછલા] dddd, LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%s મા',
	        past: '%s પેહલા',
	        s: 'અમુક પળો',
	        ss: '%d સેકંડ',
	        m: 'એક મિનિટ',
	        mm: '%d મિનિટ',
	        h: 'એક કલાક',
	        hh: '%d કલાક',
	        d: 'એક દિવસ',
	        dd: '%d દિવસ',
	        M: 'એક મહિનો',
	        MM: '%d મહિનો',
	        y: 'એક વર્ષ',
	        yy: '%d વર્ષ'
	    },
	    preparse: function (string) {
	        return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	    meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'રાત') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'સવાર') {
	            return hour;
	        } else if (meridiem === 'બપોર') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'સાંજ') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'રાત';
	        } else if (hour < 10) {
	            return 'સવાર';
	        } else if (hour < 17) {
	            return 'બપોર';
	        } else if (hour < 20) {
	            return 'સાંજ';
	        } else {
	            return 'રાત';
	        }
	    },
	    week: {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return gu;
	
	})));


/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var he = moment.defineLocale('he', {
	    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [ב]MMMM YYYY',
	        LLL : 'D [ב]MMMM YYYY HH:mm',
	        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	        l : 'D/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[היום ב־]LT',
	        nextDay : '[מחר ב־]LT',
	        nextWeek : 'dddd [בשעה] LT',
	        lastDay : '[אתמול ב־]LT',
	        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'בעוד %s',
	        past : 'לפני %s',
	        s : 'מספר שניות',
	        ss : '%d שניות',
	        m : 'דקה',
	        mm : '%d דקות',
	        h : 'שעה',
	        hh : function (number) {
	            if (number === 2) {
	                return 'שעתיים';
	            }
	            return number + ' שעות';
	        },
	        d : 'יום',
	        dd : function (number) {
	            if (number === 2) {
	                return 'יומיים';
	            }
	            return number + ' ימים';
	        },
	        M : 'חודש',
	        MM : function (number) {
	            if (number === 2) {
	                return 'חודשיים';
	            }
	            return number + ' חודשים';
	        },
	        y : 'שנה',
	        yy : function (number) {
	            if (number === 2) {
	                return 'שנתיים';
	            } else if (number % 10 === 0 && number !== 10) {
	                return number + ' שנה';
	            }
	            return number + ' שנים';
	        }
	    },
	    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM : function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        } else if (hour < 10) {
	            return 'בבוקר';
	        } else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        } else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        } else {
	            return 'בערב';
	        }
	    }
	});
	
	return he;
	
	})));


/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	},
	numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var hi = moment.defineLocale('hi', {
	    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm बजे',
	        LTS : 'A h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[कल] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[कल] LT',
	        lastWeek : '[पिछले] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s में',
	        past : '%s पहले',
	        s : 'कुछ ही क्षण',
	        ss : '%d सेकंड',
	        m : 'एक मिनट',
	        mm : '%d मिनट',
	        h : 'एक घंटा',
	        hh : '%d घंटे',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महीने',
	        MM : '%d महीने',
	        y : 'एक वर्ष',
	        yy : '%d वर्ष'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सुबह') {
	            return hour;
	        } else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        } else if (hour < 10) {
	            return 'सुबह';
	        } else if (hour < 17) {
	            return 'दोपहर';
	        } else if (hour < 20) {
	            return 'शाम';
	        } else {
	            return 'रात';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hi;
	
	})));


/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'ss':
	            if (number === 1) {
	                result += 'sekunda';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sekunde';
	            } else {
	                result += 'sekundi';
	            }
	            return result;
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var hr = moment.defineLocale('hr', {
	    months : {
	        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	    },
	    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        ss     : translate,
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hr;
	
	})));


/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate(number, withoutSuffix, key, isFuture) {
	    var num = number;
	    switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'ss':
	            return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(isFuture) {
	    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	}
	
	var hu = moment.defineLocale('hu', {
	    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY.MM.DD.',
	        LL : 'YYYY. MMMM D.',
	        LLL : 'YYYY. MMMM D. H:mm',
	        LLLL : 'YYYY. MMMM D., dddd H:mm'
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        } else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar : {
	        sameDay : '[ma] LT[-kor]',
	        nextDay : '[holnap] LT[-kor]',
	        nextWeek : function () {
	            return week.call(this, true);
	        },
	        lastDay : '[tegnap] LT[-kor]',
	        lastWeek : function () {
	            return week.call(this, false);
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s múlva',
	        past : '%s',
	        s : translate,
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return hu;
	
	})));


/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var hyAm = moment.defineLocale('hy-am', {
	    months : {
	        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	    },
	    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY թ.',
	        LLL : 'D MMMM YYYY թ., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	    },
	    calendar : {
	        sameDay: '[այսօր] LT',
	        nextDay: '[վաղը] LT',
	        lastDay: '[երեկ] LT',
	        nextWeek: function () {
	            return 'dddd [օրը ժամը] LT';
	        },
	        lastWeek: function () {
	            return '[անցած] dddd [օրը ժամը] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s հետո',
	        past : '%s առաջ',
	        s : 'մի քանի վայրկյան',
	        ss : '%d վայրկյան',
	        m : 'րոպե',
	        mm : '%d րոպե',
	        h : 'ժամ',
	        hh : '%d ժամ',
	        d : 'օր',
	        dd : '%d օր',
	        M : 'ամիս',
	        MM : '%d ամիս',
	        y : 'տարի',
	        yy : '%d տարի'
	    },
	    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	    isPM: function (input) {
	        return /^(ցերեկվա|երեկոյան)$/.test(input);
	    },
	    meridiem : function (hour) {
	        if (hour < 4) {
	            return 'գիշերվա';
	        } else if (hour < 12) {
	            return 'առավոտվա';
	        } else if (hour < 17) {
	            return 'ցերեկվա';
	        } else {
	            return 'երեկոյան';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hyAm;
	
	})));


/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var id = moment.defineLocale('id', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'siang';
	        } else if (hours < 19) {
	            return 'sore';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Besok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kemarin pukul] LT',
	        lastWeek : 'dddd [lalu pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lalu',
	        s : 'beberapa detik',
	        ss : '%d detik',
	        m : 'semenit',
	        mm : '%d menit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return id;
	
	})));


/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(n) {
	    if (n % 100 === 11) {
	        return true;
	    } else if (n % 10 === 1) {
	        return false;
	    }
	    return true;
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'ss':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
	            }
	            return result + 'sekúnda';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	    }
	}
	
	var is = moment.defineLocale('is', {
	    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	    },
	    calendar : {
	        sameDay : '[í dag kl.] LT',
	        nextDay : '[á morgun kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[í gær kl.] LT',
	        lastWeek : '[síðasta] dddd [kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'eftir %s',
	        past : 'fyrir %s síðan',
	        s : translate,
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : 'klukkustund',
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return is;
	
	})));


/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var it = moment.defineLocale('it', {
	    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Oggi alle] LT',
	        nextDay: '[Domani alle] LT',
	        nextWeek: 'dddd [alle] LT',
	        lastDay: '[Ieri alle] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[la scorsa] dddd [alle] LT';
	                default:
	                    return '[lo scorso] dddd [alle] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	        },
	        past : '%s fa',
	        s : 'alcuni secondi',
	        ss : '%d secondi',
	        m : 'un minuto',
	        mm : '%d minuti',
	        h : 'un\'ora',
	        hh : '%d ore',
	        d : 'un giorno',
	        dd : '%d giorni',
	        M : 'un mese',
	        MM : '%d mesi',
	        y : 'un anno',
	        yy : '%d anni'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return it;
	
	})));


/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ja = moment.defineLocale('ja', {
	    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日 HH:mm dddd',
	        l : 'YYYY/MM/DD',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日 HH:mm dddd'
	    },
	    meridiemParse: /午前|午後/i,
	    isPM : function (input) {
	        return input === '午後';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        } else {
	            return '午後';
	        }
	    },
	    calendar : {
	        sameDay : '[今日] LT',
	        nextDay : '[明日] LT',
	        nextWeek : '[来週]dddd LT',
	        lastDay : '[昨日] LT',
	        lastWeek : '[前週]dddd LT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}日/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s後',
	        past : '%s前',
	        s : '数秒',
	        ss : '%d秒',
	        m : '1分',
	        mm : '%d分',
	        h : '1時間',
	        hh : '%d時間',
	        d : '1日',
	        dd : '%d日',
	        M : '1ヶ月',
	        MM : '%dヶ月',
	        y : '1年',
	        yy : '%d年'
	    }
	});
	
	return ja;
	
	})));


/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var jv = moment.defineLocale('jv', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /enjing|siyang|sonten|ndalu/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'enjing') {
	            return hour;
	        } else if (meridiem === 'siyang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'enjing';
	        } else if (hours < 15) {
	            return 'siyang';
	        } else if (hours < 19) {
	            return 'sonten';
	        } else {
	            return 'ndalu';
	        }
	    },
	    calendar : {
	        sameDay : '[Dinten puniko pukul] LT',
	        nextDay : '[Mbenjang pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kala wingi pukul] LT',
	        lastWeek : 'dddd [kepengker pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'wonten ing %s',
	        past : '%s ingkang kepengker',
	        s : 'sawetawis detik',
	        ss : '%d detik',
	        m : 'setunggal menit',
	        mm : '%d menit',
	        h : 'setunggal jam',
	        hh : '%d jam',
	        d : 'sedinten',
	        dd : '%d dinten',
	        M : 'sewulan',
	        MM : '%d wulan',
	        y : 'setaun',
	        yy : '%d taun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return jv;
	
	})));


/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ka = moment.defineLocale('ka', {
	    months : {
	        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	    },
	    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	    weekdays : {
	        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	        isFormat: /(წინა|შემდეგ)/
	    },
	    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[დღეს] LT[-ზე]',
	        nextDay : '[ხვალ] LT[-ზე]',
	        lastDay : '[გუშინ] LT[-ზე]',
	        nextWeek : '[შემდეგ] dddd LT[-ზე]',
	        lastWeek : '[წინა] dddd LT-ზე',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                s.replace(/ი$/, 'ში') :
	                s + 'ში';
	        },
	        past : function (s) {
	            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                return s.replace(/(ი|ე)$/, 'ის უკან');
	            }
	            if ((/წელი/).test(s)) {
	                return s.replace(/წელი$/, 'წლის უკან');
	            }
	        },
	        s : 'რამდენიმე წამი',
	        ss : '%d წამი',
	        m : 'წუთი',
	        mm : '%d წუთი',
	        h : 'საათი',
	        hh : '%d საათი',
	        d : 'დღე',
	        dd : '%d დღე',
	        M : 'თვე',
	        MM : '%d თვე',
	        y : 'წელი',
	        yy : '%d წელი'
	    },
	    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	    ordinal : function (number) {
	        if (number === 0) {
	            return number;
	        }
	        if (number === 1) {
	            return number + '-ლი';
	        }
	        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	            return 'მე-' + number;
	        }
	        return number + '-ე';
	    },
	    week : {
	        dow : 1,
	        doy : 7
	    }
	});
	
	return ka;
	
	})));


/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    0: '-ші',
	    1: '-ші',
	    2: '-ші',
	    3: '-ші',
	    4: '-ші',
	    5: '-ші',
	    6: '-шы',
	    7: '-ші',
	    8: '-ші',
	    9: '-шы',
	    10: '-шы',
	    20: '-шы',
	    30: '-шы',
	    40: '-шы',
	    50: '-ші',
	    60: '-шы',
	    70: '-ші',
	    80: '-ші',
	    90: '-шы',
	    100: '-ші'
	};
	
	var kk = moment.defineLocale('kk', {
	    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгін сағат] LT',
	        nextDay : '[Ертең сағат] LT',
	        nextWeek : 'dddd [сағат] LT',
	        lastDay : '[Кеше сағат] LT',
	        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ішінде',
	        past : '%s бұрын',
	        s : 'бірнеше секунд',
	        ss : '%d секунд',
	        m : 'бір минут',
	        mm : '%d минут',
	        h : 'бір сағат',
	        hh : '%d сағат',
	        d : 'бір күн',
	        dd : '%d күн',
	        M : 'бір ай',
	        MM : '%d ай',
	        y : 'бір жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kk;
	
	})));


/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var km = moment.defineLocale('km', {
	    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	        nextDay: '[ស្អែក ម៉ោង] LT',
	        nextWeek: 'dddd [ម៉ោង] LT',
	        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%sទៀត',
	        past: '%sមុន',
	        s: 'ប៉ុន្មានវិនាទី',
	        ss: '%d វិនាទី',
	        m: 'មួយនាទី',
	        mm: '%d នាទី',
	        h: 'មួយម៉ោង',
	        hh: '%d ម៉ោង',
	        d: 'មួយថ្ងៃ',
	        dd: '%d ថ្ងៃ',
	        M: 'មួយខែ',
	        MM: '%d ខែ',
	        y: 'មួយឆ្នាំ',
	        yy: '%d ឆ្នាំ'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return km;
	
	})));


/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '೧',
	    '2': '೨',
	    '3': '೩',
	    '4': '೪',
	    '5': '೫',
	    '6': '೬',
	    '7': '೭',
	    '8': '೮',
	    '9': '೯',
	    '0': '೦'
	},
	numberMap = {
	    '೧': '1',
	    '೨': '2',
	    '೩': '3',
	    '೪': '4',
	    '೫': '5',
	    '೬': '6',
	    '೭': '7',
	    '೮': '8',
	    '೯': '9',
	    '೦': '0'
	};
	
	var kn = moment.defineLocale('kn', {
	    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[ಇಂದು] LT',
	        nextDay : '[ನಾಳೆ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ನಿನ್ನೆ] LT',
	        lastWeek : '[ಕೊನೆಯ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ನಂತರ',
	        past : '%s ಹಿಂದೆ',
	        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	        ss : '%d ಸೆಕೆಂಡುಗಳು',
	        m : 'ಒಂದು ನಿಮಿಷ',
	        mm : '%d ನಿಮಿಷ',
	        h : 'ಒಂದು ಗಂಟೆ',
	        hh : '%d ಗಂಟೆ',
	        d : 'ಒಂದು ದಿನ',
	        dd : '%d ದಿನ',
	        M : 'ಒಂದು ತಿಂಗಳು',
	        MM : '%d ತಿಂಗಳು',
	        y : 'ಒಂದು ವರ್ಷ',
	        yy : '%d ವರ್ಷ'
	    },
	    preparse: function (string) {
	        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ರಾತ್ರಿ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	            return hour;
	        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ಸಂಜೆ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ರಾತ್ರಿ';
	        } else if (hour < 10) {
	            return 'ಬೆಳಿಗ್ಗೆ';
	        } else if (hour < 17) {
	            return 'ಮಧ್ಯಾಹ್ನ';
	        } else if (hour < 20) {
	            return 'ಸಂಜೆ';
	        } else {
	            return 'ರಾತ್ರಿ';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	    ordinal : function (number) {
	        return number + 'ನೇ';
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kn;
	
	})));


/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ko = moment.defineLocale('ko', {
	    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'YYYY.MM.DD.',
	        LL : 'YYYY년 MMMM D일',
	        LLL : 'YYYY년 MMMM D일 A h:mm',
	        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	        l : 'YYYY.MM.DD.',
	        ll : 'YYYY년 MMMM D일',
	        lll : 'YYYY년 MMMM D일 A h:mm',
	        llll : 'YYYY년 MMMM D일 dddd A h:mm'
	    },
	    calendar : {
	        sameDay : '오늘 LT',
	        nextDay : '내일 LT',
	        nextWeek : 'dddd LT',
	        lastDay : '어제 LT',
	        lastWeek : '지난주 dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s 후',
	        past : '%s 전',
	        s : '몇 초',
	        ss : '%d초',
	        m : '1분',
	        mm : '%d분',
	        h : '한 시간',
	        hh : '%d시간',
	        d : '하루',
	        dd : '%d일',
	        M : '한 달',
	        MM : '%d달',
	        y : '일 년',
	        yy : '%d년'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '일';
	            case 'M':
	                return number + '월';
	            case 'w':
	            case 'W':
	                return number + '주';
	            default:
	                return number;
	        }
	    },
	    meridiemParse : /오전|오후/,
	    isPM : function (token) {
	        return token === '오후';
	    },
	    meridiem : function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    }
	});
	
	return ko;
	
	})));


/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    0: '-чү',
	    1: '-чи',
	    2: '-чи',
	    3: '-чү',
	    4: '-чү',
	    5: '-чи',
	    6: '-чы',
	    7: '-чи',
	    8: '-чи',
	    9: '-чу',
	    10: '-чу',
	    20: '-чы',
	    30: '-чу',
	    40: '-чы',
	    50: '-чү',
	    60: '-чы',
	    70: '-чи',
	    80: '-чи',
	    90: '-чу',
	    100: '-чү'
	};
	
	var ky = moment.defineLocale('ky', {
	    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгүн саат] LT',
	        nextDay : '[Эртең саат] LT',
	        nextWeek : 'dddd [саат] LT',
	        lastDay : '[Кече саат] LT',
	        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ичинде',
	        past : '%s мурун',
	        s : 'бирнече секунд',
	        ss : '%d секунд',
	        m : 'бир мүнөт',
	        mm : '%d мүнөт',
	        h : 'бир саат',
	        hh : '%d саат',
	        d : 'бир күн',
	        dd : '%d күн',
	        M : 'бир ай',
	        MM : '%d ай',
	        y : 'бир жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ky;
	
	})));


/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eng Minutt', 'enger Minutt'],
	        'h': ['eng Stonn', 'enger Stonn'],
	        'd': ['een Dag', 'engem Dag'],
	        'M': ['ee Mount', 'engem Mount'],
	        'y': ['ee Joer', 'engem Joer']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	function processFutureTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'a ' + string;
	    }
	    return 'an ' + string;
	}
	function processPastTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'viru ' + string;
	    }
	    return 'virun ' + string;
	}
	/**
	 * Returns true if the word before the given number loses the '-n' ending.
	 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	 *
	 * @param number {integer}
	 * @returns {boolean}
	 */
	function eifelerRegelAppliesToNumber(number) {
	    number = parseInt(number, 10);
	    if (isNaN(number)) {
	        return false;
	    }
	    if (number < 0) {
	        // Negative Number --> always true
	        return true;
	    } else if (number < 10) {
	        // Only 1 digit
	        if (4 <= number && number <= 7) {
	            return true;
	        }
	        return false;
	    } else if (number < 100) {
	        // 2 digits
	        var lastDigit = number % 10, firstDigit = number / 10;
	        if (lastDigit === 0) {
	            return eifelerRegelAppliesToNumber(firstDigit);
	        }
	        return eifelerRegelAppliesToNumber(lastDigit);
	    } else if (number < 10000) {
	        // 3 or 4 digits --> recursively check first digit
	        while (number >= 10) {
	            number = number / 10;
	        }
	        return eifelerRegelAppliesToNumber(number);
	    } else {
	        // Anything larger than 4 digits: recursively check first n-3 digits
	        number = number / 1000;
	        return eifelerRegelAppliesToNumber(number);
	    }
	}
	
	var lb = moment.defineLocale('lb', {
	    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm [Auer]',
	        LTS: 'H:mm:ss [Auer]',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm [Auer]',
	        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	    },
	    calendar: {
	        sameDay: '[Haut um] LT',
	        sameElse: 'L',
	        nextDay: '[Muer um] LT',
	        nextWeek: 'dddd [um] LT',
	        lastDay: '[Gëschter um] LT',
	        lastWeek: function () {
	            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	            switch (this.day()) {
	                case 2:
	                case 4:
	                    return '[Leschten] dddd [um] LT';
	                default:
	                    return '[Leschte] dddd [um] LT';
	            }
	        }
	    },
	    relativeTime : {
	        future : processFutureTime,
	        past : processPastTime,
	        s : 'e puer Sekonnen',
	        ss : '%d Sekonnen',
	        m : processRelativeTime,
	        mm : '%d Minutten',
	        h : processRelativeTime,
	        hh : '%d Stonnen',
	        d : processRelativeTime,
	        dd : '%d Deeg',
	        M : processRelativeTime,
	        MM : '%d Méint',
	        y : processRelativeTime,
	        yy : '%d Joer'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lb;
	
	})));


/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var lo = moment.defineLocale('lo', {
	    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	    isPM: function (input) {
	        return input === 'ຕອນແລງ';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ຕອນເຊົ້າ';
	        } else {
	            return 'ຕອນແລງ';
	        }
	    },
	    calendar : {
	        sameDay : '[ມື້ນີ້ເວລາ] LT',
	        nextDay : '[ມື້ອື່ນເວລາ] LT',
	        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ອີກ %s',
	        past : '%sຜ່ານມາ',
	        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	        ss : '%d ວິນາທີ' ,
	        m : '1 ນາທີ',
	        mm : '%d ນາທີ',
	        h : '1 ຊົ່ວໂມງ',
	        hh : '%d ຊົ່ວໂມງ',
	        d : '1 ມື້',
	        dd : '%d ມື້',
	        M : '1 ເດືອນ',
	        MM : '%d ເດືອນ',
	        y : '1 ປີ',
	        yy : '%d ປີ'
	    },
	    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	    ordinal : function (number) {
	        return 'ທີ່' + number;
	    }
	});
	
	return lo;
	
	})));


/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'ss' : 'sekundė_sekundžių_sekundes',
	    'm' : 'minutė_minutės_minutę',
	    'mm': 'minutės_minučių_minutes',
	    'h' : 'valanda_valandos_valandą',
	    'hh': 'valandos_valandų_valandas',
	    'd' : 'diena_dienos_dieną',
	    'dd': 'dienos_dienų_dienas',
	    'M' : 'mėnuo_mėnesio_mėnesį',
	    'MM': 'mėnesiai_mėnesių_mėnesius',
	    'y' : 'metai_metų_metus',
	    'yy': 'metai_metų_metus'
	};
	function translateSeconds(number, withoutSuffix, key, isFuture) {
	    if (withoutSuffix) {
	        return 'kelios sekundės';
	    } else {
	        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	    }
	}
	function translateSingular(number, withoutSuffix, key, isFuture) {
	    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	}
	function special(number) {
	    return number % 10 === 0 || (number > 10 && number < 20);
	}
	function forms(key) {
	    return units[key].split('_');
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    if (number === 1) {
	        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	    } else if (withoutSuffix) {
	        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	    } else {
	        if (isFuture) {
	            return result + forms(key)[1];
	        } else {
	            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	        }
	    }
	}
	var lt = moment.defineLocale('lt', {
	    months : {
	        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	    },
	    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	    weekdays : {
	        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	        isFormat: /dddd HH:mm/
	    },
	    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY [m.] MMMM D [d.]',
	        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY [m.] MMMM D [d.]',
	        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	    },
	    calendar : {
	        sameDay : '[Šiandien] LT',
	        nextDay : '[Rytoj] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[Vakar] LT',
	        lastWeek : '[Praėjusį] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'po %s',
	        past : 'prieš %s',
	        s : translateSeconds,
	        ss : translate,
	        m : translateSingular,
	        mm : translate,
	        h : translateSingular,
	        hh : translate,
	        d : translateSingular,
	        dd : translate,
	        M : translateSingular,
	        MM : translate,
	        y : translateSingular,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	    ordinal : function (number) {
	        return number + '-oji';
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lt;
	
	})));


/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'h': 'stundas_stundām_stunda_stundas'.split('_'),
	    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	    'd': 'dienas_dienām_diena_dienas'.split('_'),
	    'dd': 'dienas_dienām_diena_dienas'.split('_'),
	    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'y': 'gada_gadiem_gads_gadi'.split('_'),
	    'yy': 'gada_gadiem_gads_gadi'.split('_')
	};
	/**
	 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	 */
	function format(forms, number, withoutSuffix) {
	    if (withoutSuffix) {
	        // E.g. "21 minūte", "3 minūtes".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	    } else {
	        // E.g. "21 minūtes" as in "pēc 21 minūtes".
	        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	    }
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    return number + ' ' + format(units[key], number, withoutSuffix);
	}
	function relativeTimeWithSingular(number, withoutSuffix, key) {
	    return format(units[key], number, withoutSuffix);
	}
	function relativeSeconds(number, withoutSuffix) {
	    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	}
	
	var lv = moment.defineLocale('lv', {
	    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY.',
	        LL : 'YYYY. [gada] D. MMMM',
	        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	    },
	    calendar : {
	        sameDay : '[Šodien pulksten] LT',
	        nextDay : '[Rīt pulksten] LT',
	        nextWeek : 'dddd [pulksten] LT',
	        lastDay : '[Vakar pulksten] LT',
	        lastWeek : '[Pagājušā] dddd [pulksten] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'pēc %s',
	        past : 'pirms %s',
	        s : relativeSeconds,
	        ss : relativeTimeWithPlural,
	        m : relativeTimeWithSingular,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithSingular,
	        hh : relativeTimeWithPlural,
	        d : relativeTimeWithSingular,
	        dd : relativeTimeWithPlural,
	        M : relativeTimeWithSingular,
	        MM : relativeTimeWithPlural,
	        y : relativeTimeWithSingular,
	        yy : relativeTimeWithPlural
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lv;
	
	})));


/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        ss: ['sekund', 'sekunda', 'sekundi'],
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mjesec', 'mjeseca', 'mjeseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var me = moment.defineLocale('me', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sjutra u] LT',
	
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedjelje] [u] LT',
	                '[prošlog] [ponedjeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srijede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'nekoliko sekundi',
	        ss     : translator.translate,
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mjesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return me;
	
	})));


/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mi = moment.defineLocale('mi', {
	    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [i] HH:mm',
	        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	    },
	    calendar: {
	        sameDay: '[i teie mahana, i] LT',
	        nextDay: '[apopo i] LT',
	        nextWeek: 'dddd [i] LT',
	        lastDay: '[inanahi i] LT',
	        lastWeek: 'dddd [whakamutunga i] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'i roto i %s',
	        past: '%s i mua',
	        s: 'te hēkona ruarua',
	        ss: '%d hēkona',
	        m: 'he meneti',
	        mm: '%d meneti',
	        h: 'te haora',
	        hh: '%d haora',
	        d: 'he ra',
	        dd: '%d ra',
	        M: 'he marama',
	        MM: '%d marama',
	        y: 'he tau',
	        yy: '%d tau'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mi;
	
	})));


/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mk = moment.defineLocale('mk', {
	    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Денес во] LT',
	        nextDay : '[Утре во] LT',
	        nextWeek : '[Во] dddd [во] LT',
	        lastDay : '[Вчера во] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'после %s',
	        past : 'пред %s',
	        s : 'неколку секунди',
	        ss : '%d секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дена',
	        M : 'месец',
	        MM : '%d месеци',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mk;
	
	})));


/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ml = moment.defineLocale('ml', {
	    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm -നു',
	        LTS : 'A h:mm:ss -നു',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm -നു',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	    },
	    calendar : {
	        sameDay : '[ഇന്ന്] LT',
	        nextDay : '[നാളെ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ഇന്നലെ] LT',
	        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s കഴിഞ്ഞ്',
	        past : '%s മുൻപ്',
	        s : 'അൽപ നിമിഷങ്ങൾ',
	        ss : '%d സെക്കൻഡ്',
	        m : 'ഒരു മിനിറ്റ്',
	        mm : '%d മിനിറ്റ്',
	        h : 'ഒരു മണിക്കൂർ',
	        hh : '%d മണിക്കൂർ',
	        d : 'ഒരു ദിവസം',
	        dd : '%d ദിവസം',
	        M : 'ഒരു മാസം',
	        MM : '%d മാസം',
	        y : 'ഒരു വർഷം',
	        yy : '%d വർഷം'
	    },
	    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'രാത്രി';
	        } else if (hour < 12) {
	            return 'രാവിലെ';
	        } else if (hour < 17) {
	            return 'ഉച്ച കഴിഞ്ഞ്';
	        } else if (hour < 20) {
	            return 'വൈകുന്നേരം';
	        } else {
	            return 'രാത്രി';
	        }
	    }
	});
	
	return ml;
	
	})));


/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	},
	numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	function relativeTimeMr(number, withoutSuffix, string, isFuture)
	{
	    var output = '';
	    if (withoutSuffix) {
	        switch (string) {
	            case 's': output = 'काही सेकंद'; break;
	            case 'ss': output = '%d सेकंद'; break;
	            case 'm': output = 'एक मिनिट'; break;
	            case 'mm': output = '%d मिनिटे'; break;
	            case 'h': output = 'एक तास'; break;
	            case 'hh': output = '%d तास'; break;
	            case 'd': output = 'एक दिवस'; break;
	            case 'dd': output = '%d दिवस'; break;
	            case 'M': output = 'एक महिना'; break;
	            case 'MM': output = '%d महिने'; break;
	            case 'y': output = 'एक वर्ष'; break;
	            case 'yy': output = '%d वर्षे'; break;
	        }
	    }
	    else {
	        switch (string) {
	            case 's': output = 'काही सेकंदां'; break;
	            case 'ss': output = '%d सेकंदां'; break;
	            case 'm': output = 'एका मिनिटा'; break;
	            case 'mm': output = '%d मिनिटां'; break;
	            case 'h': output = 'एका तासा'; break;
	            case 'hh': output = '%d तासां'; break;
	            case 'd': output = 'एका दिवसा'; break;
	            case 'dd': output = '%d दिवसां'; break;
	            case 'M': output = 'एका महिन्या'; break;
	            case 'MM': output = '%d महिन्यां'; break;
	            case 'y': output = 'एका वर्षा'; break;
	            case 'yy': output = '%d वर्षां'; break;
	        }
	    }
	    return output.replace(/%d/i, number);
	}
	
	var mr = moment.defineLocale('mr', {
	    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm वाजता',
	        LTS : 'A h:mm:ss वाजता',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm वाजता',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[उद्या] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[काल] LT',
	        lastWeek: '[मागील] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future: '%sमध्ये',
	        past: '%sपूर्वी',
	        s: relativeTimeMr,
	        ss: relativeTimeMr,
	        m: relativeTimeMr,
	        mm: relativeTimeMr,
	        h: relativeTimeMr,
	        hh: relativeTimeMr,
	        d: relativeTimeMr,
	        dd: relativeTimeMr,
	        M: relativeTimeMr,
	        MM: relativeTimeMr,
	        y: relativeTimeMr,
	        yy: relativeTimeMr
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात्री') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सकाळी') {
	            return hour;
	        } else if (meridiem === 'दुपारी') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'सायंकाळी') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात्री';
	        } else if (hour < 10) {
	            return 'सकाळी';
	        } else if (hour < 17) {
	            return 'दुपारी';
	        } else if (hour < 20) {
	            return 'सायंकाळी';
	        } else {
	            return 'रात्री';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mr;
	
	})));


/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var msMy = moment.defineLocale('ms-my', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        ss : '%d saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return msMy;
	
	})));


/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ms = moment.defineLocale('ms', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        ss : '%d saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ms;
	
	})));


/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mt = moment.defineLocale('mt', {
	    months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
	    monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	    weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
	    weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	    weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Illum fil-]LT',
	        nextDay : '[Għada fil-]LT',
	        nextWeek : 'dddd [fil-]LT',
	        lastDay : '[Il-bieraħ fil-]LT',
	        lastWeek : 'dddd [li għadda] [fil-]LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'f’ %s',
	        past : '%s ilu',
	        s : 'ftit sekondi',
	        ss : '%d sekondi',
	        m : 'minuta',
	        mm : '%d minuti',
	        h : 'siegħa',
	        hh : '%d siegħat',
	        d : 'ġurnata',
	        dd : '%d ġranet',
	        M : 'xahar',
	        MM : '%d xhur',
	        y : 'sena',
	        yy : '%d sni'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mt;
	
	})));


/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '၁',
	    '2': '၂',
	    '3': '၃',
	    '4': '၄',
	    '5': '၅',
	    '6': '၆',
	    '7': '၇',
	    '8': '၈',
	    '9': '၉',
	    '0': '၀'
	}, numberMap = {
	    '၁': '1',
	    '၂': '2',
	    '၃': '3',
	    '၄': '4',
	    '၅': '5',
	    '၆': '6',
	    '၇': '7',
	    '၈': '8',
	    '၉': '9',
	    '၀': '0'
	};
	
	var my = moment.defineLocale('my', {
	    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ယနေ.] LT [မှာ]',
	        nextDay: '[မနက်ဖြန်] LT [မှာ]',
	        nextWeek: 'dddd LT [မှာ]',
	        lastDay: '[မနေ.က] LT [မှာ]',
	        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'လာမည့် %s မှာ',
	        past: 'လွန်ခဲ့သော %s က',
	        s: 'စက္ကန်.အနည်းငယ်',
	        ss : '%d စက္ကန့်',
	        m: 'တစ်မိနစ်',
	        mm: '%d မိနစ်',
	        h: 'တစ်နာရီ',
	        hh: '%d နာရီ',
	        d: 'တစ်ရက်',
	        dd: '%d ရက်',
	        M: 'တစ်လ',
	        MM: '%d လ',
	        y: 'တစ်နှစ်',
	        yy: '%d နှစ်'
	    },
	    preparse: function (string) {
	        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return my;
	
	})));


/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nb = moment.defineLocale('nb', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[forrige] dddd [kl.] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'noen sekunder',
	        ss : '%d sekunder',
	        m : 'ett minutt',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dager',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nb;
	
	})));


/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	},
	numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var ne = moment.defineLocale('ne', {
	    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'Aको h:mm बजे',
	        LTS : 'Aको h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, Aको h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'राति') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'बिहान') {
	            return hour;
	        } else if (meridiem === 'दिउँसो') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'साँझ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 3) {
	            return 'राति';
	        } else if (hour < 12) {
	            return 'बिहान';
	        } else if (hour < 16) {
	            return 'दिउँसो';
	        } else if (hour < 20) {
	            return 'साँझ';
	        } else {
	            return 'राति';
	        }
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[भोलि] LT',
	        nextWeek : '[आउँदो] dddd[,] LT',
	        lastDay : '[हिजो] LT',
	        lastWeek : '[गएको] dddd[,] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sमा',
	        past : '%s अगाडि',
	        s : 'केही क्षण',
	        ss : '%d सेकेण्ड',
	        m : 'एक मिनेट',
	        mm : '%d मिनेट',
	        h : 'एक घण्टा',
	        hh : '%d घण्टा',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महिना',
	        MM : '%d महिना',
	        y : 'एक बर्ष',
	        yy : '%d बर्ष'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ne;
	
	})));


/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nlBe = moment.defineLocale('nl-be', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        ss : '%d seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nlBe;
	
	})));


/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nl = moment.defineLocale('nl', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        ss : '%d seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nl;
	
	})));


/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nn = moment.defineLocale('nn', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[I dag klokka] LT',
	        nextDay: '[I morgon klokka] LT',
	        nextWeek: 'dddd [klokka] LT',
	        lastDay: '[I går klokka] LT',
	        lastWeek: '[Føregåande] dddd [klokka] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s sidan',
	        s : 'nokre sekund',
	        ss : '%d sekund',
	        m : 'eit minutt',
	        mm : '%d minutt',
	        h : 'ein time',
	        hh : '%d timar',
	        d : 'ein dag',
	        dd : '%d dagar',
	        M : 'ein månad',
	        MM : '%d månader',
	        y : 'eit år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nn;
	
	})));


/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '੧',
	    '2': '੨',
	    '3': '੩',
	    '4': '੪',
	    '5': '੫',
	    '6': '੬',
	    '7': '੭',
	    '8': '੮',
	    '9': '੯',
	    '0': '੦'
	},
	numberMap = {
	    '੧': '1',
	    '੨': '2',
	    '੩': '3',
	    '੪': '4',
	    '੫': '5',
	    '੬': '6',
	    '੭': '7',
	    '੮': '8',
	    '੯': '9',
	    '੦': '0'
	};
	
	var paIn = moment.defineLocale('pa-in', {
	    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm ਵਜੇ',
	        LTS : 'A h:mm:ss ਵਜੇ',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	    },
	    calendar : {
	        sameDay : '[ਅਜ] LT',
	        nextDay : '[ਕਲ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ਕਲ] LT',
	        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ਵਿੱਚ',
	        past : '%s ਪਿਛਲੇ',
	        s : 'ਕੁਝ ਸਕਿੰਟ',
	        ss : '%d ਸਕਿੰਟ',
	        m : 'ਇਕ ਮਿੰਟ',
	        mm : '%d ਮਿੰਟ',
	        h : 'ਇੱਕ ਘੰਟਾ',
	        hh : '%d ਘੰਟੇ',
	        d : 'ਇੱਕ ਦਿਨ',
	        dd : '%d ਦਿਨ',
	        M : 'ਇੱਕ ਮਹੀਨਾ',
	        MM : '%d ਮਹੀਨੇ',
	        y : 'ਇੱਕ ਸਾਲ',
	        yy : '%d ਸਾਲ'
	    },
	    preparse: function (string) {
	        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ਰਾਤ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ਸਵੇਰ') {
	            return hour;
	        } else if (meridiem === 'ਦੁਪਹਿਰ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ਸ਼ਾਮ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ਰਾਤ';
	        } else if (hour < 10) {
	            return 'ਸਵੇਰ';
	        } else if (hour < 17) {
	            return 'ਦੁਪਹਿਰ';
	        } else if (hour < 20) {
	            return 'ਸ਼ਾਮ';
	        } else {
	            return 'ਰਾਤ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return paIn;
	
	})));


/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	    monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural(n) {
	    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	}
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'ss':
	            return result + (plural(number) ? 'sekundy' : 'sekund');
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	    }
	}
	
	var pl = moment.defineLocale('pl', {
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return monthsNominative;
	        } else if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W niedzielę o] LT';
	
	                case 2:
	                    return '[We wtorek o] LT';
	
	                case 3:
	                    return '[W środę o] LT';
	
	                case 6:
	                    return '[W sobotę o] LT';
	
	                default:
	                    return '[W] dddd [o] LT';
	            }
	        },
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : '%s temu',
	        s : 'kilka sekund',
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : '1 dzień',
	        dd : '%d dni',
	        M : 'miesiąc',
	        MM : translate,
	        y : 'rok',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pl;
	
	})));


/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ptBr = moment.defineLocale('pt-br', {
	    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
	    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'poucos segundos',
	        ss : '%d segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº'
	});
	
	return ptBr;
	
	})));


/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var pt = moment.defineLocale('pt', {
	    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
	    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'segundos',
	        ss : '%d segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pt;
	
	})));


/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	            'ss': 'secunde',
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	        separator = ' ';
	    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	        separator = ' de ';
	    }
	    return number + separator + format[key];
	}
	
	var ro = moment.defineLocale('ro', {
	    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'peste %s',
	        past : '%s în urmă',
	        s : 'câteva secunde',
	        ss : relativeTimeWithPlural,
	        m : 'un minut',
	        mm : relativeTimeWithPlural,
	        h : 'o oră',
	        hh : relativeTimeWithPlural,
	        d : 'o zi',
	        dd : relativeTimeWithPlural,
	        M : 'o lună',
	        MM : relativeTimeWithPlural,
	        y : 'un an',
	        yy : relativeTimeWithPlural
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ro;
	
	})));


/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        'hh': 'час_часа_часов',
	        'dd': 'день_дня_дней',
	        'MM': 'месяц_месяца_месяцев',
	        'yy': 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ru = moment.defineLocale('ru', {
	    months : {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort : {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays : {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., H:mm',
	        LLLL : 'dddd, D MMMM YYYY г., H:mm'
	    },
	    calendar : {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'через %s',
	        past : '%s назад',
	        s : 'несколько секунд',
	        ss : relativeTimeWithPlural,
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'час',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM : function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ru;
	
	})));


/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوري',
	    'فيبروري',
	    'مارچ',
	    'اپريل',
	    'مئي',
	    'جون',
	    'جولاءِ',
	    'آگسٽ',
	    'سيپٽمبر',
	    'آڪٽوبر',
	    'نومبر',
	    'ڊسمبر'
	];
	var days = [
	    'آچر',
	    'سومر',
	    'اڱارو',
	    'اربع',
	    'خميس',
	    'جمع',
	    'ڇنڇر'
	];
	
	var sd = moment.defineLocale('sd', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[اڄ] LT',
	        nextDay : '[سڀاڻي] LT',
	        nextWeek : 'dddd [اڳين هفتي تي] LT',
	        lastDay : '[ڪالهه] LT',
	        lastWeek : '[گزريل هفتي] dddd [تي] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s پوء',
	        past : '%s اڳ',
	        s : 'چند سيڪنڊ',
	        ss : '%d سيڪنڊ',
	        m : 'هڪ منٽ',
	        mm : '%d منٽ',
	        h : 'هڪ ڪلاڪ',
	        hh : '%d ڪلاڪ',
	        d : 'هڪ ڏينهن',
	        dd : '%d ڏينهن',
	        M : 'هڪ مهينو',
	        MM : '%d مهينا',
	        y : 'هڪ سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sd;
	
	})));


/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var se = moment.defineLocale('se', {
	    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'MMMM D. [b.] YYYY',
	        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[otne ti] LT',
	        nextDay: '[ihttin ti] LT',
	        nextWeek: 'dddd [ti] LT',
	        lastDay: '[ikte ti] LT',
	        lastWeek: '[ovddit] dddd [ti] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s geažes',
	        past : 'maŋit %s',
	        s : 'moadde sekunddat',
	        ss: '%d sekunddat',
	        m : 'okta minuhta',
	        mm : '%d minuhtat',
	        h : 'okta diimmu',
	        hh : '%d diimmut',
	        d : 'okta beaivi',
	        dd : '%d beaivvit',
	        M : 'okta mánnu',
	        MM : '%d mánut',
	        y : 'okta jahki',
	        yy : '%d jagit'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return se;
	
	})));


/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	/*jshint -W100*/
	var si = moment.defineLocale('si', {
	    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'a h:mm',
	        LTS : 'a h:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY MMMM D',
	        LLL : 'YYYY MMMM D, a h:mm',
	        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	    },
	    calendar : {
	        sameDay : '[අද] LT[ට]',
	        nextDay : '[හෙට] LT[ට]',
	        nextWeek : 'dddd LT[ට]',
	        lastDay : '[ඊයේ] LT[ට]',
	        lastWeek : '[පසුගිය] dddd LT[ට]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sකින්',
	        past : '%sකට පෙර',
	        s : 'තත්පර කිහිපය',
	        ss : 'තත්පර %d',
	        m : 'මිනිත්තුව',
	        mm : 'මිනිත්තු %d',
	        h : 'පැය',
	        hh : 'පැය %d',
	        d : 'දිනය',
	        dd : 'දින %d',
	        M : 'මාසය',
	        MM : 'මාස %d',
	        y : 'වසර',
	        yy : 'වසර %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	    ordinal : function (number) {
	        return number + ' වැනි';
	    },
	    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	    isPM : function (input) {
	        return input === 'ප.ව.' || input === 'පස් වරු';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'ප.ව.' : 'පස් වරු';
	        } else {
	            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	        }
	    }
	});
	
	return si;
	
	})));


/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	    monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'sekundy' : 'sekúnd');
	            } else {
	                return result + 'sekundami';
	            }
	            break;
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	    }
	}
	
	var sk = moment.defineLocale('sk', {
	    months : months,
	    monthsShort : monthsShort,
	    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[dnes o] LT',
	        nextDay: '[zajtra o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	            }
	        },
	        lastDay: '[včera o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'pred %s',
	        s : translate,
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sk;
	
	})));


/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'ss':
	            if (number === 1) {
	                result += withoutSuffix ? 'sekundo' : 'sekundi';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	            } else {
	                result += withoutSuffix || isFuture ? 'sekund' : 'sekund';
	            }
	            return result;
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}
	
	var sl = moment.defineLocale('sl', {
	    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danes ob] LT',
	        nextDay  : '[jutri ob] LT',
	
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay  : '[včeraj ob] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'čez %s',
	        past   : 'pred %s',
	        s      : processRelativeTime,
	        ss     : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : processRelativeTime,
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sl;
	
	})));


/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sq = moment.defineLocale('sq', {
	    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /PD|MD/,
	    isPM: function (input) {
	        return input.charAt(0) === 'M';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        return hours < 12 ? 'PD' : 'MD';
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Sot në] LT',
	        nextDay : '[Nesër në] LT',
	        nextWeek : 'dddd [në] LT',
	        lastDay : '[Dje në] LT',
	        lastWeek : 'dddd [e kaluar në] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'në %s',
	        past : '%s më parë',
	        s : 'disa sekonda',
	        ss : '%d sekonda',
	        m : 'një minutë',
	        mm : '%d minuta',
	        h : 'një orë',
	        hh : '%d orë',
	        d : 'një ditë',
	        dd : '%d ditë',
	        M : 'një muaj',
	        MM : '%d muaj',
	        y : 'një vit',
	        yy : '%d vite'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sq;
	
	})));


/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        ss: ['секунда', 'секунде', 'секунди'],
	        m: ['један минут', 'једне минуте'],
	        mm: ['минут', 'минуте', 'минута'],
	        h: ['један сат', 'једног сата'],
	        hh: ['сат', 'сата', 'сати'],
	        dd: ['дан', 'дана', 'дана'],
	        MM: ['месец', 'месеца', 'месеци'],
	        yy: ['година', 'године', 'година']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var srCyrl = moment.defineLocale('sr-cyrl', {
	    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[данас у] LT',
	        nextDay: '[сутра у] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	            }
	        },
	        lastDay  : '[јуче у] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[прошле] [недеље] [у] LT',
	                '[прошлог] [понедељка] [у] LT',
	                '[прошлог] [уторка] [у] LT',
	                '[прошле] [среде] [у] LT',
	                '[прошлог] [четвртка] [у] LT',
	                '[прошлог] [петка] [у] LT',
	                '[прошле] [суботе] [у] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past   : 'пре %s',
	        s      : 'неколико секунди',
	        ss     : translator.translate,
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'дан',
	        dd     : translator.translate,
	        M      : 'месец',
	        MM     : translator.translate,
	        y      : 'годину',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return srCyrl;
	
	})));


/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        ss: ['sekunda', 'sekunde', 'sekundi'],
	        m: ['jedan minut', 'jedne minute'],
	        mm: ['minut', 'minute', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mesec', 'meseca', 'meseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var sr = moment.defineLocale('sr', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedelje] [u] LT',
	                '[prošlog] [ponedeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'pre %s',
	        s      : 'nekoliko sekundi',
	        ss     : translator.translate,
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sr;
	
	})));


/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ss = moment.defineLocale('ss', {
	    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Namuhla nga] LT',
	        nextDay : '[Kusasa nga] LT',
	        nextWeek : 'dddd [nga] LT',
	        lastDay : '[Itolo nga] LT',
	        lastWeek : 'dddd [leliphelile] [nga] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'nga %s',
	        past : 'wenteka nga %s',
	        s : 'emizuzwana lomcane',
	        ss : '%d mzuzwana',
	        m : 'umzuzu',
	        mm : '%d emizuzu',
	        h : 'lihora',
	        hh : '%d emahora',
	        d : 'lilanga',
	        dd : '%d emalanga',
	        M : 'inyanga',
	        MM : '%d tinyanga',
	        y : 'umnyaka',
	        yy : '%d iminyaka'
	    },
	    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'ekuseni';
	        } else if (hours < 15) {
	            return 'emini';
	        } else if (hours < 19) {
	            return 'entsambama';
	        } else {
	            return 'ebusuku';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ekuseni') {
	            return hour;
	        } else if (meridiem === 'emini') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	            if (hour === 0) {
	                return 0;
	            }
	            return hour + 12;
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : '%d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ss;
	
	})));


/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sw = moment.defineLocale('sw', {
	    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[leo saa] LT',
	        nextDay : '[kesho saa] LT',
	        nextWeek : '[wiki ijayo] dddd [saat] LT',
	        lastDay : '[jana] LT',
	        lastWeek : '[wiki iliyopita] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s baadaye',
	        past : 'tokea %s',
	        s : 'hivi punde',
	        ss : 'sekunde %d',
	        m : 'dakika moja',
	        mm : 'dakika %d',
	        h : 'saa limoja',
	        hh : 'masaa %d',
	        d : 'siku moja',
	        dd : 'masiku %d',
	        M : 'mwezi mmoja',
	        MM : 'miezi %d',
	        y : 'mwaka mmoja',
	        yy : 'miaka %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sw;
	
	})));


/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '௧',
	    '2': '௨',
	    '3': '௩',
	    '4': '௪',
	    '5': '௫',
	    '6': '௬',
	    '7': '௭',
	    '8': '௮',
	    '9': '௯',
	    '0': '௦'
	}, numberMap = {
	    '௧': '1',
	    '௨': '2',
	    '௩': '3',
	    '௪': '4',
	    '௫': '5',
	    '௬': '6',
	    '௭': '7',
	    '௮': '8',
	    '௯': '9',
	    '௦': '0'
	};
	
	var ta = moment.defineLocale('ta', {
	    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, HH:mm',
	        LLLL : 'dddd, D MMMM YYYY, HH:mm'
	    },
	    calendar : {
	        sameDay : '[இன்று] LT',
	        nextDay : '[நாளை] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[நேற்று] LT',
	        lastWeek : '[கடந்த வாரம்] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s இல்',
	        past : '%s முன்',
	        s : 'ஒரு சில விநாடிகள்',
	        ss : '%d விநாடிகள்',
	        m : 'ஒரு நிமிடம்',
	        mm : '%d நிமிடங்கள்',
	        h : 'ஒரு மணி நேரம்',
	        hh : '%d மணி நேரம்',
	        d : 'ஒரு நாள்',
	        dd : '%d நாட்கள்',
	        M : 'ஒரு மாதம்',
	        MM : '%d மாதங்கள்',
	        y : 'ஒரு வருடம்',
	        yy : '%d ஆண்டுகள்'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}வது/,
	    ordinal : function (number) {
	        return number + 'வது';
	    },
	    preparse: function (string) {
	        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // refer http://ta.wikipedia.org/s/1er1
	    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 2) {
	            return ' யாமம்';
	        } else if (hour < 6) {
	            return ' வைகறை';  // வைகறை
	        } else if (hour < 10) {
	            return ' காலை'; // காலை
	        } else if (hour < 14) {
	            return ' நண்பகல்'; // நண்பகல்
	        } else if (hour < 18) {
	            return ' எற்பாடு'; // எற்பாடு
	        } else if (hour < 22) {
	            return ' மாலை'; // மாலை
	        } else {
	            return ' யாமம்';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'யாமம்') {
	            return hour < 2 ? hour : hour + 12;
	        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	            return hour;
	        } else if (meridiem === 'நண்பகல்') {
	            return hour >= 10 ? hour : hour + 12;
	        } else {
	            return hour + 12;
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ta;
	
	})));


/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var te = moment.defineLocale('te', {
	    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[నేడు] LT',
	        nextDay : '[రేపు] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[నిన్న] LT',
	        lastWeek : '[గత] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s లో',
	        past : '%s క్రితం',
	        s : 'కొన్ని క్షణాలు',
	        ss : '%d సెకన్లు',
	        m : 'ఒక నిమిషం',
	        mm : '%d నిమిషాలు',
	        h : 'ఒక గంట',
	        hh : '%d గంటలు',
	        d : 'ఒక రోజు',
	        dd : '%d రోజులు',
	        M : 'ఒక నెల',
	        MM : '%d నెలలు',
	        y : 'ఒక సంవత్సరం',
	        yy : '%d సంవత్సరాలు'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}వ/,
	    ordinal : '%dవ',
	    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'రాత్రి') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ఉదయం') {
	            return hour;
	        } else if (meridiem === 'మధ్యాహ్నం') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'సాయంత్రం') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'రాత్రి';
	        } else if (hour < 10) {
	            return 'ఉదయం';
	        } else if (hour < 17) {
	            return 'మధ్యాహ్నం';
	        } else if (hour < 20) {
	            return 'సాయంత్రం';
	        } else {
	            return 'రాత్రి';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return te;
	
	})));


/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tet = moment.defineLocale('tet', {
	    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Ohin iha] LT',
	        nextDay: '[Aban iha] LT',
	        nextWeek: 'dddd [iha] LT',
	        lastDay: '[Horiseik iha] LT',
	        lastWeek: 'dddd [semana kotuk] [iha] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'iha %s',
	        past : '%s liuba',
	        s : 'minutu balun',
	        ss : 'minutu %d',
	        m : 'minutu ida',
	        mm : 'minutu %d',
	        h : 'oras ida',
	        hh : 'oras %d',
	        d : 'loron ida',
	        dd : 'loron %d',
	        M : 'fulan ida',
	        MM : 'fulan %d',
	        y : 'tinan ida',
	        yy : 'tinan %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tet;
	
	})));


/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    0: '-ум',
	    1: '-ум',
	    2: '-юм',
	    3: '-юм',
	    4: '-ум',
	    5: '-ум',
	    6: '-ум',
	    7: '-ум',
	    8: '-ум',
	    9: '-ум',
	    10: '-ум',
	    12: '-ум',
	    13: '-ум',
	    20: '-ум',
	    30: '-юм',
	    40: '-ум',
	    50: '-ум',
	    60: '-ум',
	    70: '-ум',
	    80: '-ум',
	    90: '-ум',
	    100: '-ум'
	};
	
	var tg = moment.defineLocale('tg', {
	    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
	    weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	    weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Имрӯз соати] LT',
	        nextDay : '[Пагоҳ соати] LT',
	        lastDay : '[Дирӯз соати] LT',
	        nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
	        lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'баъди %s',
	        past : '%s пеш',
	        s : 'якчанд сония',
	        m : 'як дақиқа',
	        mm : '%d дақиқа',
	        h : 'як соат',
	        hh : '%d соат',
	        d : 'як рӯз',
	        dd : '%d рӯз',
	        M : 'як моҳ',
	        MM : '%d моҳ',
	        y : 'як сол',
	        yy : '%d сол'
	    },
	    meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'шаб') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'субҳ') {
	            return hour;
	        } else if (meridiem === 'рӯз') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'бегоҳ') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'шаб';
	        } else if (hour < 11) {
	            return 'субҳ';
	        } else if (hour < 16) {
	            return 'рӯз';
	        } else if (hour < 19) {
	            return 'бегоҳ';
	        } else {
	            return 'шаб';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	    ordinal: function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1th is the first week of the year.
	    }
	});
	
	return tg;
	
	})));


/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var th = moment.defineLocale('th', {
	    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY เวลา H:mm',
	        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        } else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar : {
	        sameDay : '[วันนี้ เวลา] LT',
	        nextDay : '[พรุ่งนี้ เวลา] LT',
	        nextWeek : 'dddd[หน้า เวลา] LT',
	        lastDay : '[เมื่อวานนี้ เวลา] LT',
	        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'อีก %s',
	        past : '%sที่แล้ว',
	        s : 'ไม่กี่วินาที',
	        ss : '%d วินาที',
	        m : '1 นาที',
	        mm : '%d นาที',
	        h : '1 ชั่วโมง',
	        hh : '%d ชั่วโมง',
	        d : '1 วัน',
	        dd : '%d วัน',
	        M : '1 เดือน',
	        MM : '%d เดือน',
	        y : '1 ปี',
	        yy : '%d ปี'
	    }
	});
	
	return th;
	
	})));


/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tlPh = moment.defineLocale('tl-ph', {
	    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'MM/D/YYYY',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY HH:mm',
	        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: 'LT [ngayong araw]',
	        nextDay: '[Bukas ng] LT',
	        nextWeek: 'LT [sa susunod na] dddd',
	        lastDay: 'LT [kahapon]',
	        lastWeek: 'LT [noong nakaraang] dddd',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'sa loob ng %s',
	        past : '%s ang nakalipas',
	        s : 'ilang segundo',
	        ss : '%d segundo',
	        m : 'isang minuto',
	        mm : '%d minuto',
	        h : 'isang oras',
	        hh : '%d oras',
	        d : 'isang araw',
	        dd : '%d araw',
	        M : 'isang buwan',
	        MM : '%d buwan',
	        y : 'isang taon',
	        yy : '%d taon'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlPh;
	
	})));


/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	function translateFuture(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'leS' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'waQ' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'nem' :
	    time + ' pIq';
	    return time;
	}
	
	function translatePast(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'Hu’' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'wen' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'ben' :
	    time + ' ret';
	    return time;
	}
	
	function translate(number, withoutSuffix, string, isFuture) {
	    var numberNoun = numberAsNoun(number);
	    switch (string) {
	        case 'ss':
	            return numberNoun + ' lup';
	        case 'mm':
	            return numberNoun + ' tup';
	        case 'hh':
	            return numberNoun + ' rep';
	        case 'dd':
	            return numberNoun + ' jaj';
	        case 'MM':
	            return numberNoun + ' jar';
	        case 'yy':
	            return numberNoun + ' DIS';
	    }
	}
	
	function numberAsNoun(number) {
	    var hundred = Math.floor((number % 1000) / 100),
	    ten = Math.floor((number % 100) / 10),
	    one = number % 10,
	    word = '';
	    if (hundred > 0) {
	        word += numbersNouns[hundred] + 'vatlh';
	    }
	    if (ten > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	    }
	    if (one > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	    }
	    return (word === '') ? 'pagh' : word;
	}
	
	var tlh = moment.defineLocale('tlh', {
	    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[DaHjaj] LT',
	        nextDay: '[wa’leS] LT',
	        nextWeek: 'LLL',
	        lastDay: '[wa’Hu’] LT',
	        lastWeek: 'LLL',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : translateFuture,
	        past : translatePast,
	        s : 'puS lup',
	        ss : translate,
	        m : 'wa’ tup',
	        mm : translate,
	        h : 'wa’ rep',
	        hh : translate,
	        d : 'wa’ jaj',
	        dd : translate,
	        M : 'wa’ jar',
	        MM : translate,
	        y : 'wa’ DIS',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlh;
	
	})));


/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	var suffixes = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	
	var tr = moment.defineLocale('tr', {
	    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[yarın saat] LT',
	        nextWeek : '[gelecek] dddd [saat] LT',
	        lastDay : '[dün] LT',
	        lastWeek : '[geçen] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s önce',
	        s : 'birkaç saniye',
	        ss : '%d saniye',
	        m : 'bir dakika',
	        mm : '%d dakika',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir yıl',
	        yy : '%d yıl'
	    },
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'Do':
	            case 'DD':
	                return number;
	            default:
	                if (number === 0) {  // special case for zero
	                    return number + '\'ıncı';
	                }
	                var a = number % 10,
	                    b = number % 100 - a,
	                    c = number >= 100 ? 100 : null;
	                return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tr;
	
	})));


/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	// This is currently too difficult (maybe even impossible) to add.
	var tzl = moment.defineLocale('tzl', {
	    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM [dallas] YYYY',
	        LLL : 'D. MMMM [dallas] YYYY HH.mm',
	        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	    },
	    meridiemParse: /d\'o|d\'a/i,
	    isPM : function (input) {
	        return 'd\'o' === input.toLowerCase();
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'd\'o' : 'D\'O';
	        } else {
	            return isLower ? 'd\'a' : 'D\'A';
	        }
	    },
	    calendar : {
	        sameDay : '[oxhi à] LT',
	        nextDay : '[demà à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[ieiri à] LT',
	        lastWeek : '[sür el] dddd [lasteu à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'osprei %s',
	        past : 'ja%s',
	        s : processRelativeTime,
	        ss : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['viensas secunds', '\'iensas secunds'],
	        'ss': [number + ' secunds', '' + number + ' secunds'],
	        'm': ['\'n míut', '\'iens míut'],
	        'mm': [number + ' míuts', '' + number + ' míuts'],
	        'h': ['\'n þora', '\'iensa þora'],
	        'hh': [number + ' þoras', '' + number + ' þoras'],
	        'd': ['\'n ziua', '\'iensa ziua'],
	        'dd': [number + ' ziuas', '' + number + ' ziuas'],
	        'M': ['\'n mes', '\'iens mes'],
	        'MM': [number + ' mesen', '' + number + ' mesen'],
	        'y': ['\'n ar', '\'iens ar'],
	        'yy': [number + ' ars', '' + number + ' ars']
	    };
	    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	}
	
	return tzl;
	
	})));


/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzmLatn = moment.defineLocale('tzm-latn', {
	    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[asdkh g] LT',
	        nextDay: '[aska g] LT',
	        nextWeek: 'dddd [g] LT',
	        lastDay: '[assant g] LT',
	        lastWeek: 'dddd [g] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dadkh s yan %s',
	        past : 'yan %s',
	        s : 'imik',
	        ss : '%d imik',
	        m : 'minuḍ',
	        mm : '%d minuḍ',
	        h : 'saɛa',
	        hh : '%d tassaɛin',
	        d : 'ass',
	        dd : '%d ossan',
	        M : 'ayowr',
	        MM : '%d iyyirn',
	        y : 'asgas',
	        yy : '%d isgasn'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzmLatn;
	
	})));


/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzm = moment.defineLocale('tzm', {
	    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	        nextWeek: 'dddd [ⴴ] LT',
	        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	        lastWeek: 'dddd [ⴴ] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	        past : 'ⵢⴰⵏ %s',
	        s : 'ⵉⵎⵉⴽ',
	        ss : '%d ⵉⵎⵉⴽ',
	        m : 'ⵎⵉⵏⵓⴺ',
	        mm : '%d ⵎⵉⵏⵓⴺ',
	        h : 'ⵙⴰⵄⴰ',
	        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	        d : 'ⴰⵙⵙ',
	        dd : '%d oⵙⵙⴰⵏ',
	        M : 'ⴰⵢoⵓⵔ',
	        MM : '%d ⵉⵢⵢⵉⵔⵏ',
	        y : 'ⴰⵙⴳⴰⵙ',
	        yy : '%d ⵉⵙⴳⴰⵙⵏ'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzm;
	
	})));


/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js language configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ugCn = moment.defineLocale('ug-cn', {
	    months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	        '_'
	    ),
	    monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	        '_'
	    ),
	    weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	        '_'
	    ),
	    weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	    weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'YYYY-MM-DD',
	        LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	        LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	        LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
	    },
	    meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (
	            meridiem === 'يېرىم كېچە' ||
	            meridiem === 'سەھەر' ||
	            meridiem === 'چۈشتىن بۇرۇن'
	        ) {
	            return hour;
	        } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	            return hour + 12;
	        } else {
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return 'يېرىم كېچە';
	        } else if (hm < 900) {
	            return 'سەھەر';
	        } else if (hm < 1130) {
	            return 'چۈشتىن بۇرۇن';
	        } else if (hm < 1230) {
	            return 'چۈش';
	        } else if (hm < 1800) {
	            return 'چۈشتىن كېيىن';
	        } else {
	            return 'كەچ';
	        }
	    },
	    calendar: {
	        sameDay: '[بۈگۈن سائەت] LT',
	        nextDay: '[ئەتە سائەت] LT',
	        nextWeek: '[كېلەركى] dddd [سائەت] LT',
	        lastDay: '[تۆنۈگۈن] LT',
	        lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%s كېيىن',
	        past: '%s بۇرۇن',
	        s: 'نەچچە سېكونت',
	        ss: '%d سېكونت',
	        m: 'بىر مىنۇت',
	        mm: '%d مىنۇت',
	        h: 'بىر سائەت',
	        hh: '%d سائەت',
	        d: 'بىر كۈن',
	        dd: '%d كۈن',
	        M: 'بىر ئاي',
	        MM: '%d ئاي',
	        y: 'بىر يىل',
	        yy: '%d يىل'
	    },
	
	    dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '-كۈنى';
	            case 'w':
	            case 'W':
	                return number + '-ھەپتە';
	            default:
	                return number;
	        }
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week: {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow: 1, // Monday is the first day of the week.
	        doy: 7 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ugCn;
	
	})));


/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	        'dd': 'день_дні_днів',
	        'MM': 'місяць_місяці_місяців',
	        'yy': 'рік_роки_років'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвилина' : 'хвилину';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'година' : 'годину';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	function weekdaysCaseReplace(m, format) {
	    var weekdays = {
	        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	    };
	
	    if (!m) {
	        return weekdays['nominative'];
	    }
	
	    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	        'accusative' :
	        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	            'genitive' :
	            'nominative');
	    return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
	    return function () {
	        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	    };
	}
	
	var uk = moment.defineLocale('uk', {
	    months : {
	        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	    },
	    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	    weekdays : weekdaysCaseReplace,
	    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY р.',
	        LLL : 'D MMMM YYYY р., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	    },
	    calendar : {
	        sameDay: processHoursFunction('[Сьогодні '),
	        nextDay: processHoursFunction('[Завтра '),
	        lastDay: processHoursFunction('[Вчора '),
	        nextWeek: processHoursFunction('[У] dddd ['),
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past : '%s тому',
	        s : 'декілька секунд',
	        ss : relativeTimeWithPlural,
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'годину',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'місяць',
	        MM : relativeTimeWithPlural,
	        y : 'рік',
	        yy : relativeTimeWithPlural
	    },
	    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	    meridiemParse: /ночі|ранку|дня|вечора/,
	    isPM: function (input) {
	        return /^(дня|вечора)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночі';
	        } else if (hour < 12) {
	            return 'ранку';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечора';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uk;
	
	})));


/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوری',
	    'فروری',
	    'مارچ',
	    'اپریل',
	    'مئی',
	    'جون',
	    'جولائی',
	    'اگست',
	    'ستمبر',
	    'اکتوبر',
	    'نومبر',
	    'دسمبر'
	];
	var days = [
	    'اتوار',
	    'پیر',
	    'منگل',
	    'بدھ',
	    'جمعرات',
	    'جمعہ',
	    'ہفتہ'
	];
	
	var ur = moment.defineLocale('ur', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[آج بوقت] LT',
	        nextDay : '[کل بوقت] LT',
	        nextWeek : 'dddd [بوقت] LT',
	        lastDay : '[گذشتہ روز بوقت] LT',
	        lastWeek : '[گذشتہ] dddd [بوقت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s بعد',
	        past : '%s قبل',
	        s : 'چند سیکنڈ',
	        ss : '%d سیکنڈ',
	        m : 'ایک منٹ',
	        mm : '%d منٹ',
	        h : 'ایک گھنٹہ',
	        hh : '%d گھنٹے',
	        d : 'ایک دن',
	        dd : '%d دن',
	        M : 'ایک ماہ',
	        MM : '%d ماہ',
	        y : 'ایک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ur;
	
	})));


/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uzLatn = moment.defineLocale('uz-latn', {
	    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bugun soat] LT [da]',
	        nextDay : '[Ertaga] LT [da]',
	        nextWeek : 'dddd [kuni soat] LT [da]',
	        lastDay : '[Kecha soat] LT [da]',
	        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Yaqin %s ichida',
	        past : 'Bir necha %s oldin',
	        s : 'soniya',
	        ss : '%d soniya',
	        m : 'bir daqiqa',
	        mm : '%d daqiqa',
	        h : 'bir soat',
	        hh : '%d soat',
	        d : 'bir kun',
	        dd : '%d kun',
	        M : 'bir oy',
	        MM : '%d oy',
	        y : 'bir yil',
	        yy : '%d yil'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uzLatn;
	
	})));


/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uz = moment.defineLocale('uz', {
	    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бугун соат] LT [да]',
	        nextDay : '[Эртага] LT [да]',
	        nextWeek : 'dddd [куни соат] LT [да]',
	        lastDay : '[Кеча соат] LT [да]',
	        lastWeek : '[Утган] dddd [куни соат] LT [да]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Якин %s ичида',
	        past : 'Бир неча %s олдин',
	        s : 'фурсат',
	        ss : '%d фурсат',
	        m : 'бир дакика',
	        mm : '%d дакика',
	        h : 'бир соат',
	        hh : '%d соат',
	        d : 'бир кун',
	        dd : '%d кун',
	        M : 'бир ой',
	        MM : '%d ой',
	        y : 'бир йил',
	        yy : '%d йил'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return uz;
	
	})));


/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var vi = moment.defineLocale('vi', {
	    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /sa|ch/i,
	    isPM : function (input) {
	        return /^ch$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'sa' : 'SA';
	        } else {
	            return isLower ? 'ch' : 'CH';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [năm] YYYY',
	        LLL : 'D MMMM [năm] YYYY HH:mm',
	        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	        l : 'DD/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hôm nay lúc] LT',
	        nextDay: '[Ngày mai lúc] LT',
	        nextWeek: 'dddd [tuần tới lúc] LT',
	        lastDay: '[Hôm qua lúc] LT',
	        lastWeek: 'dddd [tuần rồi lúc] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s tới',
	        past : '%s trước',
	        s : 'vài giây',
	        ss : '%d giây' ,
	        m : 'một phút',
	        mm : '%d phút',
	        h : 'một giờ',
	        hh : '%d giờ',
	        d : 'một ngày',
	        dd : '%d ngày',
	        M : 'một tháng',
	        MM : '%d tháng',
	        y : 'một năm',
	        yy : '%d năm'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return vi;
	
	})));


/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var xPseudo = moment.defineLocale('x-pseudo', {
	    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[T~ódá~ý át] LT',
	        nextDay : '[T~ómó~rró~w át] LT',
	        nextWeek : 'dddd [át] LT',
	        lastDay : '[Ý~ést~érdá~ý át] LT',
	        lastWeek : '[L~ást] dddd [át] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'í~ñ %s',
	        past : '%s á~gó',
	        s : 'á ~féw ~sécó~ñds',
	        ss : '%d s~écóñ~ds',
	        m : 'á ~míñ~úté',
	        mm : '%d m~íñú~tés',
	        h : 'á~ñ hó~úr',
	        hh : '%d h~óúrs',
	        d : 'á ~dáý',
	        dd : '%d d~áýs',
	        M : 'á ~móñ~th',
	        MM : '%d m~óñt~hs',
	        y : 'á ~ýéár',
	        yy : '%d ý~éárs'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return xPseudo;
	
	})));


/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var yo = moment.defineLocale('yo', {
	    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Ònì ni] LT',
	        nextDay : '[Ọ̀la ni] LT',
	        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	        lastDay : '[Àna ni] LT',
	        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ní %s',
	        past : '%s kọjá',
	        s : 'ìsẹjú aayá die',
	        ss :'aayá %d',
	        m : 'ìsẹjú kan',
	        mm : 'ìsẹjú %d',
	        h : 'wákati kan',
	        hh : 'wákati %d',
	        d : 'ọjọ́ kan',
	        dd : 'ọjọ́ %d',
	        M : 'osù kan',
	        MM : 'osù %d',
	        y : 'ọdún kan',
	        yy : 'ọdún %d'
	    },
	    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	    ordinal : 'ọjọ́ %d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return yo;
	
	})));


/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhCn = moment.defineLocale('zh-cn', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日Ah点mm分',
	        LLLL : 'YYYY年M月D日ddddAh点mm分',
	        l : 'YYYY/M/D',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' ||
	                meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        } else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s内',
	        past : '%s前',
	        s : '几秒',
	        ss : '%d 秒',
	        m : '1 分钟',
	        mm : '%d 分钟',
	        h : '1 小时',
	        hh : '%d 小时',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 个月',
	        MM : '%d 个月',
	        y : '1 年',
	        yy : '%d 年'
	    },
	    week : {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return zhCn;
	
	})));


/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhHk = moment.defineLocale('zh-hk', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日dddd HH:mm',
	        l : 'YYYY/M/D',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        ss : '%d 秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhHk;
	
	})));


/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhTw = moment.defineLocale('zh-tw', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日dddd HH:mm',
	        l : 'YYYY/M/D',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        ss : '%d 秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhTw;
	
	})));


/***/ },
/* 583 */
/***/ function(module, exports) {

	/*
	 json-stringify-safe
	 Like JSON.stringify, but doesn't throw on circular references.
	
	 Originally forked from https://github.com/isaacs/json-stringify-safe
	 version 5.0.1 on 3/8/2017 and modified to handle Errors serialization
	 and IE8 compatibility. Tests for this are in test/vendor.
	
	 ISC license: https://github.com/isaacs/json-stringify-safe/blob/master/LICENSE
	*/
	
	exports = module.exports = stringify;
	exports.getSerialize = serializer;
	
	function indexOf(haystack, needle) {
	  for (var i = 0; i < haystack.length; ++i) {
	    if (haystack[i] === needle) return i;
	  }
	  return -1;
	}
	
	function stringify(obj, replacer, spaces, cycleReplacer) {
	  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces);
	}
	
	// https://github.com/ftlabs/js-abbreviate/blob/fa709e5f139e7770a71827b1893f22418097fbda/index.js#L95-L106
	function stringifyError(value) {
	  var err = {
	    // These properties are implemented as magical getters and don't show up in for in
	    stack: value.stack,
	    message: value.message,
	    name: value.name
	  };
	
	  for (var i in value) {
	    if (Object.prototype.hasOwnProperty.call(value, i)) {
	      err[i] = value[i];
	    }
	  }
	
	  return err;
	}
	
	function serializer(replacer, cycleReplacer) {
	  var stack = [];
	  var keys = [];
	
	  if (cycleReplacer == null) {
	    cycleReplacer = function(key, value) {
	      if (stack[0] === value) {
	        return '[Circular ~]';
	      }
	      return '[Circular ~.' + keys.slice(0, indexOf(stack, value)).join('.') + ']';
	    };
	  }
	
	  return function(key, value) {
	    if (stack.length > 0) {
	      var thisPos = indexOf(stack, this);
	      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
	      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
	
	      if (~indexOf(stack, value)) {
	        value = cycleReplacer.call(this, key, value);
	      }
	    } else {
	      stack.push(value);
	    }
	
	    return replacer == null
	      ? value instanceof Error ? stringifyError(value) : value
	      : replacer.call(this, key, value);
	  };
	}


/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1358).default;

/***/ },
/* 585 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var INPUT_FOCUSED = 'INPUT_FOCUSED';
	var INPUT_BLURRED = 'INPUT_BLURRED';
	var INPUT_CHANGED = 'INPUT_CHANGED';
	var UPDATE_FOCUSED_SUGGESTION = 'UPDATE_FOCUSED_SUGGESTION';
	var RESET_FOCUSED_SUGGESTION = 'RESET_FOCUSED_SUGGESTION';
	var REVEAL_SUGGESTIONS = 'REVEAL_SUGGESTIONS';
	var CLOSE_SUGGESTIONS = 'CLOSE_SUGGESTIONS';
	
	var inputFocused = function inputFocused(shouldRenderSuggestions) {
	  return {
	    type: INPUT_FOCUSED,
	    shouldRenderSuggestions: shouldRenderSuggestions
	  };
	};
	
	var inputBlurred = function inputBlurred(shouldRenderSuggestions) {
	  return {
	    type: INPUT_BLURRED,
	    shouldRenderSuggestions: shouldRenderSuggestions
	  };
	};
	
	var inputChanged = function inputChanged(shouldRenderSuggestions) {
	  return {
	    type: INPUT_CHANGED,
	    shouldRenderSuggestions: shouldRenderSuggestions
	  };
	};
	
	var updateFocusedSuggestion = function updateFocusedSuggestion(sectionIndex, suggestionIndex, prevValue) {
	  return {
	    type: UPDATE_FOCUSED_SUGGESTION,
	    sectionIndex: sectionIndex,
	    suggestionIndex: suggestionIndex,
	    prevValue: prevValue
	  };
	};
	
	var resetFocusedSuggestion = function resetFocusedSuggestion() {
	  var shouldResetValueBeforeUpDown = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	  return {
	    type: RESET_FOCUSED_SUGGESTION,
	    shouldResetValueBeforeUpDown: shouldResetValueBeforeUpDown
	  };
	};
	
	var revealSuggestions = function revealSuggestions() {
	  return {
	    type: REVEAL_SUGGESTIONS
	  };
	};
	
	var closeSuggestions = function closeSuggestions() {
	  return {
	    type: CLOSE_SUGGESTIONS
	  };
	};
	
	var actionCreators = exports.actionCreators = {
	  inputFocused: inputFocused,
	  inputBlurred: inputBlurred,
	  inputChanged: inputChanged,
	  updateFocusedSuggestion: updateFocusedSuggestion,
	  resetFocusedSuggestion: resetFocusedSuggestion,
	  revealSuggestions: revealSuggestions,
	  closeSuggestions: closeSuggestions
	};
	
	var reducer = function reducer(state, action) {
	  switch (action.type) {
	    case INPUT_FOCUSED:
	      return _extends({}, state, {
	        isFocused: true,
	        isCollapsed: !action.shouldRenderSuggestions
	      });
	
	    case INPUT_BLURRED:
	      return _extends({}, state, {
	        isFocused: false,
	        focusedSectionIndex: null,
	        focusedSuggestionIndex: null,
	        valueBeforeUpDown: null,
	        isCollapsed: !action.shouldRenderSuggestions
	      });
	
	    case INPUT_CHANGED:
	      return _extends({}, state, {
	        focusedSectionIndex: null,
	        focusedSuggestionIndex: null,
	        valueBeforeUpDown: null,
	        isCollapsed: !action.shouldRenderSuggestions
	      });
	
	    case UPDATE_FOCUSED_SUGGESTION:
	      {
	        var sectionIndex = action.sectionIndex,
	            suggestionIndex = action.suggestionIndex,
	            prevValue = action.prevValue;
	        var valueBeforeUpDown = state.valueBeforeUpDown;
	
	
	        if (suggestionIndex === null) {
	          valueBeforeUpDown = null;
	        } else if (valueBeforeUpDown === null && typeof prevValue !== 'undefined') {
	          valueBeforeUpDown = prevValue;
	        }
	
	        return _extends({}, state, {
	          focusedSectionIndex: sectionIndex,
	          focusedSuggestionIndex: suggestionIndex,
	          valueBeforeUpDown: valueBeforeUpDown
	        });
	      }
	
	    case RESET_FOCUSED_SUGGESTION:
	      {
	        return _extends({}, state, {
	          focusedSectionIndex: null,
	          focusedSuggestionIndex: null,
	          valueBeforeUpDown: action.shouldResetValueBeforeUpDown ? null : state.valueBeforeUpDown
	        });
	      }
	
	    case REVEAL_SUGGESTIONS:
	      return _extends({}, state, {
	        isCollapsed: false
	      });
	
	    case CLOSE_SUGGESTIONS:
	      return _extends({}, state, {
	        focusedSectionIndex: null,
	        focusedSuggestionIndex: null,
	        valueBeforeUpDown: null,
	        isCollapsed: true
	      });
	
	    default:
	      return state;
	  }
	};
	
	exports.default = reducer;

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = connectAdvanced;
	
	var _hoistNonReactStatics = __webpack_require__(1359);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(35);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _Subscription = __webpack_require__(1368);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _PropTypes = __webpack_require__(588);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var hotReloadingVersion = 0;
	var dummyState = {};
	function noop() {}
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory) {
	  var _contextTypes, _childContextTypes;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$getDisplayName = _ref.getDisplayName,
	      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
	    return 'ConnectAdvanced(' + name + ')';
	  } : _ref$getDisplayName,
	      _ref$methodName = _ref.methodName,
	      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
	      _ref$renderCountProp = _ref.renderCountProp,
	      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
	      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
	      _ref$storeKey = _ref.storeKey,
	      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
	      _ref$withRef = _ref.withRef,
	      withRef = _ref$withRef === undefined ? false : _ref$withRef,
	      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);
	
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant2.default)(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	
	    var displayName = getDisplayName(wrappedComponentName);
	
	    var selectorFactoryOptions = _extends({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
	
	        (0, _invariant2.default)(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));
	
	        _this.initSelector();
	        _this.initSubscription();
	        return _this;
	      }
	
	      Connect.prototype.getChildContext = function getChildContext() {
	        var _ref2;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return;
	
	        // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
	        return this.wrappedInstance;
	      };
	
	      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      Connect.prototype.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      Connect.prototype.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return;
	
	        // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription2.default(this.store, parentSub, this.onStateChange.bind(this));
	
	        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      Connect.prototype.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      Connect.prototype.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
	        // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	        var withExtras = _extends({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      Connect.prototype.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        var _this2 = this;
	
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector();
	
	          // If any connected descendants don't hot reload (and resubscribe in the process), their
	          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
	          // listeners, this does mean that the old versions of connected descendants will still be
	          // notified of state changes; however, their onStateChange function is a no-op so this
	          // isn't a huge deal.
	          var oldListeners = [];
	
	          if (this.subscription) {
	            oldListeners = this.subscription.listeners.get();
	            this.subscription.tryUnsubscribe();
	          }
	          this.initSubscription();
	          if (shouldHandleStateChanges) {
	            this.subscription.trySubscribe();
	            oldListeners.forEach(function (listener) {
	              return _this2.subscription.listeners.subscribe(listener);
	            });
	          }
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = __webpack_require__(589);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	}
	
	// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	}
	
	// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    };
	
	    // allow detectFactoryAndVerify to get ownProps
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject2.default)(props, displayName, methodName);
	
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = undefined;
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subscriptionShape = exports.subscriptionShape = _propTypes2.default.shape({
	  trySubscribe: _propTypes2.default.func.isRequired,
	  tryUnsubscribe: _propTypes2.default.func.isRequired,
	  notifyNestedSubs: _propTypes2.default.func.isRequired,
	  isSubscribed: _propTypes2.default.func.isRequired
	});
	
	var storeShape = exports.storeShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  getState: _propTypes2.default.func.isRequired
	});

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = __webpack_require__(189);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(289);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject2.default)(value)) {
	    (0, _warning2.default)(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
	  }
	}

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(27);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(37);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Transition = __webpack_require__(1476);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Show the component; triggers the fade in or fade out animation
	   */
	  'in': _propTypes2['default'].bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is faded out
	   */
	  unmountOnExit: _propTypes2['default'].bool,
	
	  /**
	   * Run the fade in animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _propTypes2['default'].bool,
	
	  /**
	   * Duration of the fade animation in milliseconds, to ensure that finishing
	   * callbacks are fired even if the original browser transition end events are
	   * canceled
	   */
	  timeout: _propTypes2['default'].number,
	
	  /**
	   * Callback fired before the component fades in
	   */
	  onEnter: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component starts to fade in
	   */
	  onEntering: _propTypes2['default'].func,
	  /**
	   * Callback fired after the has component faded in
	   */
	  onEntered: _propTypes2['default'].func,
	  /**
	   * Callback fired before the component fades out
	   */
	  onExit: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component starts to fade out
	   */
	  onExiting: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component has faded out
	   */
	  onExited: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  'in': false,
	  timeout: 300,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  transitionAppear: false
	};
	
	var Fade = function (_React$Component) {
	  (0, _inherits3['default'])(Fade, _React$Component);
	
	  function Fade() {
	    (0, _classCallCheck3['default'])(this, Fade);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Fade.prototype.render = function render() {
	    return _react2['default'].createElement(_Transition2['default'], (0, _extends3['default'])({}, this.props, {
	      className: (0, _classnames2['default'])(this.props.className, 'fade'),
	      enteredClassName: 'in',
	      enteringClassName: 'in'
	    }));
	  };
	
	  return Fade;
	}(_react2['default'].Component);
	
	Fade.propTypes = propTypes;
	Fade.defaultProps = defaultProps;
	
	exports['default'] = Fade;
	module.exports = exports['default'];

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(73);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _uncontrollable = __webpack_require__(654);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TAB = 'tab';
	var PANE = 'pane';
	
	var idPropType = _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]);
	
	var propTypes = {
	  /**
	   * HTML id attribute, required if no `generateChildId` prop
	   * is specified.
	   */
	  id: function id(props) {
	    var error = null;
	
	    if (!props.generateChildId) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      error = idPropType.apply(undefined, [props].concat(args));
	
	      if (!error && !props.id) {
	        error = new Error('In order to properly initialize Tabs in a way that is accessible ' + 'to assistive technologies (such as screen readers) an `id` or a ' + '`generateChildId` prop to TabContainer is required');
	      }
	    }
	
	    return error;
	  },
	
	
	  /**
	   * A function that takes an `eventKey` and `type` and returns a unique id for
	   * child tab `<NavItem>`s and `<TabPane>`s. The function _must_ be a pure
	   * function, meaning it should always return the _same_ id for the same set
	   * of inputs. The default value requires that an `id` to be set for the
	   * `<TabContainer>`.
	   *
	   * The `type` argument will either be `"tab"` or `"pane"`.
	   *
	   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
	   */
	  generateChildId: _propTypes2['default'].func,
	
	  /**
	   * A callback fired when a tab is selected.
	   *
	   * @controllable activeKey
	   */
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * The `eventKey` of the currently active tab.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _propTypes2['default'].any
	};
	
	var childContextTypes = {
	  $bs_tabContainer: _propTypes2['default'].shape({
	    activeKey: _propTypes2['default'].any,
	    onSelect: _propTypes2['default'].func.isRequired,
	    getTabId: _propTypes2['default'].func.isRequired,
	    getPaneId: _propTypes2['default'].func.isRequired
	  })
	};
	
	var TabContainer = function (_React$Component) {
	  (0, _inherits3['default'])(TabContainer, _React$Component);
	
	  function TabContainer() {
	    (0, _classCallCheck3['default'])(this, TabContainer);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  TabContainer.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        activeKey = _props.activeKey,
	        onSelect = _props.onSelect,
	        generateChildId = _props.generateChildId,
	        id = _props.id;
	
	
	    var getId = generateChildId || function (key, type) {
	      return id ? id + '-' + type + '-' + key : null;
	    };
	
	    return {
	      $bs_tabContainer: {
	        activeKey: activeKey,
	        onSelect: onSelect,
	        getTabId: function getTabId(key) {
	          return getId(key, TAB);
	        },
	        getPaneId: function getPaneId(key) {
	          return getId(key, PANE);
	        }
	      }
	    };
	  };
	
	  TabContainer.prototype.render = function render() {
	    var _props2 = this.props,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['children']);
	
	
	    delete props.generateChildId;
	    delete props.onSelect;
	    delete props.activeKey;
	
	    return _react2['default'].cloneElement(_react2['default'].Children.only(children), props);
	  };
	
	  return TabContainer;
	}(_react2['default'].Component);
	
	TabContainer.propTypes = propTypes;
	TabContainer.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _uncontrollable2['default'])(TabContainer, { activeKey: 'onSelect' });
	module.exports = exports['default'];

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(27);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(73);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(37);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(159);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(154);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	
	  /**
	   * Sets a default animation strategy for all children `<TabPane>`s. Use
	   * `false` to disable, `true` to enable the default `<Fade>` animation or any
	   * `<Transition>` component.
	   */
	  animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	
	  /**
	   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount tabs (remove it from the DOM) when they are no longer visible
	   */
	  unmountOnExit: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  componentClass: 'div',
	  animation: true,
	  mountOnEnter: false,
	  unmountOnExit: false
	};
	
	var contextTypes = {
	  $bs_tabContainer: _propTypes2['default'].shape({
	    activeKey: _propTypes2['default'].any
	  })
	};
	
	var childContextTypes = {
	  $bs_tabContent: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	    activeKey: _propTypes2['default'].any,
	    mountOnEnter: _propTypes2['default'].bool,
	    unmountOnExit: _propTypes2['default'].bool,
	    onPaneEnter: _propTypes2['default'].func.isRequired,
	    onPaneExited: _propTypes2['default'].func.isRequired,
	    exiting: _propTypes2['default'].bool.isRequired
	  })
	};
	
	var TabContent = function (_React$Component) {
	  (0, _inherits3['default'])(TabContent, _React$Component);
	
	  function TabContent(props, context) {
	    (0, _classCallCheck3['default'])(this, TabContent);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handlePaneEnter = _this.handlePaneEnter.bind(_this);
	    _this.handlePaneExited = _this.handlePaneExited.bind(_this);
	
	    // Active entries in state will be `null` unless `animation` is set. Need
	    // to track active child in case keys swap and the active child changes
	    // but the active key does not.
	    _this.state = {
	      activeKey: null,
	      activeChild: null
	    };
	    return _this;
	  }
	
	  TabContent.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        bsClass = _props.bsClass,
	        animation = _props.animation,
	        mountOnEnter = _props.mountOnEnter,
	        unmountOnExit = _props.unmountOnExit;
	
	
	    var stateActiveKey = this.state.activeKey;
	    var containerActiveKey = this.getContainerActiveKey();
	
	    var activeKey = stateActiveKey != null ? stateActiveKey : containerActiveKey;
	    var exiting = stateActiveKey != null && stateActiveKey !== containerActiveKey;
	
	    return {
	      $bs_tabContent: {
	        bsClass: bsClass,
	        animation: animation,
	        activeKey: activeKey,
	        mountOnEnter: mountOnEnter,
	        unmountOnExit: unmountOnExit,
	        onPaneEnter: this.handlePaneEnter,
	        onPaneExited: this.handlePaneExited,
	        exiting: exiting
	      }
	    };
	  };
	
	  TabContent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (!nextProps.animation && this.state.activeChild) {
	      this.setState({ activeKey: null, activeChild: null });
	    }
	  };
	
	  TabContent.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.isUnmounted = true;
	  };
	
	  TabContent.prototype.handlePaneEnter = function handlePaneEnter(child, childKey) {
	    if (!this.props.animation) {
	      return false;
	    }
	
	    // It's possible that this child should be transitioning out.
	    if (childKey !== this.getContainerActiveKey()) {
	      return false;
	    }
	
	    this.setState({
	      activeKey: childKey,
	      activeChild: child
	    });
	
	    return true;
	  };
	
	  TabContent.prototype.handlePaneExited = function handlePaneExited(child) {
	    // This might happen as everything is unmounting.
	    if (this.isUnmounted) {
	      return;
	    }
	
	    this.setState(function (_ref) {
	      var activeChild = _ref.activeChild;
	
	      if (activeChild !== child) {
	        return null;
	      }
	
	      return {
	        activeKey: null,
	        activeChild: null
	      };
	    });
	  };
	
	  TabContent.prototype.getContainerActiveKey = function getContainerActiveKey() {
	    var tabContainer = this.context.$bs_tabContainer;
	    return tabContainer && tabContainer.activeKey;
	  };
	
	  TabContent.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        className = _props2.className,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['componentClass', 'className']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation', 'mountOnEnter', 'unmountOnExit']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(bsProps, 'content'))
	    }));
	  };
	
	  return TabContent;
	}(_react2['default'].Component);
	
	TabContent.propTypes = propTypes;
	TabContent.defaultProps = defaultProps;
	TabContent.contextTypes = contextTypes;
	TabContent.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('tab', TabContent);
	module.exports = exports['default'];

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Iterates through children that are typically specified as `props.children`,
	 * but only maps over children that are "valid components".
	 *
	 * The mapFunction provided index will be normalised to the components mapped,
	 * so an invalid component would not increase the index.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @return {object} Object containing the ordered map of results.
	 */
	function map(children, func, context) {
	  var index = 0;
	
	  return _react2['default'].Children.map(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return child;
	    }
	
	    return func.call(context, child, index++);
	  });
	}
	
	/**
	 * Iterates through children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for context.
	 */
	// TODO: This module should be ElementChildren, and should use named exports.
	
	function forEach(children, func, context) {
	  var index = 0;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    func.call(context, child, index++);
	  });
	}
	
	/**
	 * Count the number of "valid components" in the Children container.
	 *
	 * @param {?*} children Children tree container.
	 * @returns {number}
	 */
	function count(children) {
	  var result = 0;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    ++result;
	  });
	
	  return result;
	}
	
	/**
	 * Finds children that are typically specified as `props.children`,
	 * but only iterates over children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @returns {array} of children that meet the func return statement
	 */
	function filter(children, func, context) {
	  var index = 0;
	  var result = [];
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result.push(child);
	    }
	  });
	
	  return result;
	}
	
	function find(children, func, context) {
	  var index = 0;
	  var result = undefined;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = child;
	    }
	  });
	
	  return result;
	}
	
	function every(children, func, context) {
	  var index = 0;
	  var result = true;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!result) {
	      return;
	    }
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (!func.call(context, child, index++)) {
	      result = false;
	    }
	  });
	
	  return result;
	}
	
	function some(children, func, context) {
	  var index = 0;
	  var result = false;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = true;
	    }
	  });
	
	  return result;
	}
	
	function toArray(children) {
	  var result = [];
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    result.push(child);
	  });
	
	  return result;
	}
	
	exports['default'] = {
	  map: map,
	  forEach: forEach,
	  count: count,
	  find: find,
	  filter: filter,
	  every: every,
	  some: some,
	  toArray: toArray
	};
	module.exports = exports['default'];

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.load = load;
	exports.select = select;
	exports.save = save;
	exports.remove = remove;
	exports.setRawCookie = setRawCookie;
	exports.plugToRequest = plugToRequest;
	
	var _cookie = __webpack_require__(1012);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	var _objectAssign = __webpack_require__(26);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _isNode = __webpack_require__(1333);
	
	var _isNode2 = _interopRequireDefault(_isNode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _rawCookie = {};
	var _res = undefined;
	
	function _isResWritable() {
	  return _res && !_res.headersSent;
	}
	
	function load(name, doNotParse, opt) {
	  var cookies = _isNode2.default ? _rawCookie : _cookie2.default.parse(document.cookie, opt);
	  var cookieVal = cookies && cookies[name];
	
	  if (typeof doNotParse === 'undefined') {
	    doNotParse = !cookieVal || cookieVal[0] !== '{' && cookieVal[0] !== '[';
	  }
	
	  if (!doNotParse) {
	    try {
	      cookieVal = JSON.parse(cookieVal);
	    } catch (e) {
	      // Not serialized object
	    }
	  }
	
	  return cookieVal;
	}
	
	function select(regex) {
	  var cookies = _isNode2.default ? _rawCookie : _cookie2.default.parse(document.cookie);
	
	  if (!cookies) {
	    return {};
	  }
	
	  if (!regex) {
	    return cookies;
	  }
	
	  return Object.keys(cookies).reduce(function (accumulator, name) {
	    if (!regex.test(name)) {
	      return accumulator;
	    }
	
	    var newCookie = {};
	    newCookie[name] = cookies[name];
	    return (0, _objectAssign2.default)({}, accumulator, newCookie);
	  }, {});
	}
	
	function save(name, val, opt) {
	  _rawCookie[name] = val;
	
	  // allow you to work with cookies as objects.
	  if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
	    _rawCookie[name] = JSON.stringify(val);
	  }
	
	  // Cookies only work in the browser
	  if (!_isNode2.default) {
	    document.cookie = _cookie2.default.serialize(name, _rawCookie[name], opt);
	  }
	
	  if (_isResWritable() && _res.cookie) {
	    var expressOpt = _extends({}, opt);
	    if (expressOpt.maxAge) {
	      // the standard for maxAge is seconds but express uses milliseconds
	      expressOpt.maxAge = opt.maxAge * 1000;
	    }
	
	    _res.cookie(name, val, opt);
	  }
	}
	
	function remove(name, opt) {
	  delete _rawCookie[name];
	
	  if (typeof opt === 'undefined') {
	    opt = {};
	  } else if (typeof opt === 'string') {
	    // Will be deprecated in future versions
	    opt = { path: opt };
	  } else {
	    // Prevent mutation of opt below
	    opt = (0, _objectAssign2.default)({}, opt);
	  }
	
	  if (typeof document !== 'undefined') {
	    opt.expires = new Date(1970, 1, 1, 0, 0, 1);
	    opt.maxAge = 0;
	    document.cookie = _cookie2.default.serialize(name, '', opt);
	  }
	
	  if (_isResWritable() && _res.clearCookie) {
	    _res.clearCookie(name, opt);
	  }
	}
	
	function setRawCookie(rawCookie) {
	  if (rawCookie) {
	    _rawCookie = _cookie2.default.parse(rawCookie);
	  } else {
	    _rawCookie = {};
	  }
	}
	
	function plugToRequest(req, res) {
	  if (req.cookie) {
	    _rawCookie = req.cookie;
	  } else if (req.cookies) {
	    _rawCookie = req.cookies;
	  } else if (req.headers && req.headers.cookie) {
	    setRawCookie(req.headers.cookie);
	  } else {
	    _rawCookie = {};
	  }
	
	  _res = res;
	
	  return function unplug() {
	    _res = null;
	    _rawCookie = {};
	  };
	}
	
	exports.default = {
	  setRawCookie: setRawCookie,
	  load: load,
	  select: select,
	  save: save,
	  remove: remove,
	  plugToRequest: plugToRequest
	};

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classNames = __webpack_require__(195);
	
	var _classNames2 = _interopRequireDefault(_classNames);
	
	var _keys = __webpack_require__(196);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Navbar = function (_Component) {
	  _inherits(Navbar, _Component);
	
	  function Navbar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Navbar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Navbar.__proto__ || Object.getPrototypeOf(Navbar)).call.apply(_ref, [this].concat(args))), _this), _this.handleNextClick = function () {
	      if (_this.props.onNextClick) {
	        _this.props.onNextClick();
	      }
	    }, _this.handlePreviousClick = function () {
	      if (_this.props.onPreviousClick) {
	        _this.props.onPreviousClick();
	      }
	    }, _this.handleNextKeyDown = function (e) {
	      if (e.keyCode !== _keys.ENTER && e.keyCode !== _keys.SPACE) {
	        return;
	      }
	      e.preventDefault();
	      _this.handleNextClick();
	    }, _this.handlePreviousKeyDown = function (e) {
	      if (e.keyCode !== _keys.ENTER && e.keyCode !== _keys.SPACE) {
	        return;
	      }
	      e.preventDefault();
	      _this.handlePreviousClick();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Navbar, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return nextProps.labels !== this.props.labels || nextProps.dir !== this.props.dir || this.props.showPreviousButton !== nextProps.showPreviousButton || this.props.showNextButton !== nextProps.showNextButton;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          classNames = _props.classNames,
	          className = _props.className,
	          showPreviousButton = _props.showPreviousButton,
	          showNextButton = _props.showNextButton,
	          labels = _props.labels,
	          dir = _props.dir;
	
	
	      var previousClickHandler = void 0;
	      var nextClickHandler = void 0;
	      var previousKeyDownHandler = void 0;
	      var nextKeyDownHandler = void 0;
	      var shouldShowPrevious = void 0;
	      var shouldShowNext = void 0;
	
	      if (dir === 'rtl') {
	        previousClickHandler = this.handleNextClick;
	        nextClickHandler = this.handlePreviousClick;
	        previousKeyDownHandler = this.handleNextKeyDown;
	        nextKeyDownHandler = this.handlePreviousKeyDown;
	        shouldShowNext = showPreviousButton;
	        shouldShowPrevious = showNextButton;
	      } else {
	        previousClickHandler = this.handlePreviousClick;
	        nextClickHandler = this.handleNextClick;
	        previousKeyDownHandler = this.handlePreviousKeyDown;
	        nextKeyDownHandler = this.handleNextKeyDown;
	        shouldShowNext = showNextButton;
	        shouldShowPrevious = showPreviousButton;
	      }
	
	      var previousClassName = shouldShowPrevious ? classNames.navButtonPrev : classNames.navButtonPrev + ' ' + classNames.navButtonInteractionDisabled;
	
	      var nextClassName = shouldShowNext ? classNames.navButtonNext : classNames.navButtonNext + ' ' + classNames.navButtonInteractionDisabled;
	
	      var previousButton = _react2.default.createElement('span', {
	        tabIndex: '0',
	        role: 'button',
	        'aria-label': labels.previousMonth,
	        key: 'previous',
	        className: previousClassName,
	        onKeyDown: shouldShowPrevious ? previousKeyDownHandler : undefined,
	        onClick: shouldShowPrevious ? previousClickHandler : undefined
	      });
	
	      var nextButton = _react2.default.createElement('span', {
	        tabIndex: '0',
	        role: 'button',
	        'aria-label': labels.nextMonth,
	        key: 'right',
	        className: nextClassName,
	        onKeyDown: shouldShowNext ? nextKeyDownHandler : undefined,
	        onClick: shouldShowNext ? nextClickHandler : undefined
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className || classNames.navBar },
	        dir === 'rtl' ? [nextButton, previousButton] : [previousButton, nextButton]
	      );
	    }
	  }]);
	
	  return Navbar;
	}(_react.Component);
	
	Navbar.defaultProps = {
	  classNames: _classNames2.default,
	  dir: 'ltr',
	  labels: {
	    previousMonth: 'Previous Month',
	    nextMonth: 'Next Month'
	  },
	  showPreviousButton: true,
	  showNextButton: true
	};
	exports.default = Navbar;
	Navbar.propTypes =  false ? {
	  classNames: _propTypes2.default.shape({
	    navBar: _propTypes2.default.string.isRequired,
	    navButtonPrev: _propTypes2.default.string.isRequired,
	    navButtonNext: _propTypes2.default.string.isRequired
	  }),
	  className: _propTypes2.default.string,
	  showPreviousButton: _propTypes2.default.bool,
	  showNextButton: _propTypes2.default.bool,
	  onPreviousClick: _propTypes2.default.func,
	  onNextClick: _propTypes2.default.func,
	  dir: _propTypes2.default.string,
	  labels: _propTypes2.default.shape({
	    previousMonth: _propTypes2.default.string.isRequired,
	    nextMonth: _propTypes2.default.string.isRequired
	  })
	} : {};
	//# sourceMappingURL=Navbar.js.map

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Weekday = function (_Component) {
	  _inherits(Weekday, _Component);
	
	  function Weekday() {
	    _classCallCheck(this, Weekday);
	
	    return _possibleConstructorReturn(this, (Weekday.__proto__ || Object.getPrototypeOf(Weekday)).apply(this, arguments));
	  }
	
	  _createClass(Weekday, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props !== nextProps;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          weekday = _props.weekday,
	          className = _props.className,
	          weekdaysLong = _props.weekdaysLong,
	          weekdaysShort = _props.weekdaysShort,
	          localeUtils = _props.localeUtils,
	          locale = _props.locale;
	
	      var title = void 0;
	      if (weekdaysLong) {
	        title = weekdaysLong[weekday];
	      } else {
	        title = localeUtils.formatWeekdayLong(weekday, locale);
	      }
	      var content = void 0;
	      if (weekdaysShort) {
	        content = weekdaysShort[weekday];
	      } else {
	        content = localeUtils.formatWeekdayShort(weekday, locale);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: className, role: 'columnheader' },
	        _react2.default.createElement(
	          'abbr',
	          { title: title },
	          content
	        )
	      );
	    }
	  }]);
	
	  return Weekday;
	}(_react.Component);
	
	exports.default = Weekday;
	Weekday.propTypes =  false ? {
	  weekday: _propTypes2.default.number,
	  className: _propTypes2.default.string,
	  locale: _propTypes2.default.string,
	  localeUtils: _propTypes2.default.object,
	
	  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string)
	} : {};
	//# sourceMappingURL=Weekday.js.map

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatDay = formatDay;
	exports.formatMonthTitle = formatMonthTitle;
	exports.formatWeekdayShort = formatWeekdayShort;
	exports.formatWeekdayLong = formatWeekdayLong;
	exports.getFirstDayOfWeek = getFirstDayOfWeek;
	exports.getMonths = getMonths;
	exports.formatDate = formatDate;
	exports.parseDate = parseDate;
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formatDay(day) {
	  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
	
	  return (0, _moment2.default)(day).locale(locale).format('ddd ll');
	} /* eslint-disable import/no-extraneous-dependencies, no-underscore-dangle */
	
	function formatMonthTitle(date) {
	  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
	
	  return (0, _moment2.default)(date).locale(locale).format('MMMM YYYY');
	}
	
	function formatWeekdayShort(day) {
	  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
	
	  return (0, _moment2.default)().locale(locale)._locale.weekdaysMin()[day];
	}
	
	function formatWeekdayLong(day) {
	  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
	
	  return (0, _moment2.default)().locale(locale)._locale.weekdays()[day];
	}
	
	function getFirstDayOfWeek() {
	  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';
	
	  var localeData = _moment2.default.localeData(locale);
	  return localeData.firstDayOfWeek();
	}
	
	function getMonths() {
	  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';
	
	  var months = [];
	  var i = 0;
	  while (i < 12) {
	    months.push((0, _moment2.default)().locale(locale).month(i).format('MMMM'));
	    i += 1;
	  }
	  return months;
	}
	
	function formatDate(date) {
	  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'L';
	  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en';
	
	  return (0, _moment2.default)(date).locale(locale).format(Array.isArray(format) ? format[0] : format);
	}
	
	function parseDate(str) {
	  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'L';
	  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en';
	
	  var m = (0, _moment2.default)(str, format, locale, true);
	  if (m.isValid()) {
	    return m.toDate();
	  }
	  return undefined;
	}
	
	exports.default = {
	  formatDay: formatDay,
	  formatMonthTitle: formatMonthTitle,
	  formatWeekdayShort: formatWeekdayShort,
	  formatWeekdayLong: formatWeekdayLong,
	  getFirstDayOfWeek: getFirstDayOfWeek,
	  getMonths: getMonths,
	  formatDate: formatDate,
	  parseDate: parseDate
	};
	//# sourceMappingURL=MomentLocaleUtils.js.map

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	(function(f) {
	  if (true) {
	    module.exports = f(__webpack_require__(1));
	    /* global define */
	  } else if (typeof define === 'function' && define.amd) {
	    define(['react'], f);
	  } else {
	    var g;
	    if (typeof window !== 'undefined') {
	      g = window;
	    } else if (typeof global !== 'undefined') {
	      g = global;
	    } else if (typeof self !== 'undefined') {
	      g = self;
	    } else {
	      g = this;
	    }
	
	    if (typeof g.React === 'undefined') {
	      throw Error('React module should be required before ReactDOMFactories');
	    }
	
	    g.ReactDOMFactories = f(g.React);
	  }
	})(function(React) {
	  /**
	   * Create a factory that creates HTML tag elements.
	   */
	  function createDOMFactory(type) {
	    var factory = React.createElement.bind(null, type);
	    // Expose the type on the factory and the prototype so that it can be
	    // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	    // This should not be named `constructor` since this may not be the function
	    // that created the element, and it may not even be a constructor.
	    factory.type = type;
	    return factory;
	  };
	
	  /**
	   * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	   */
	  var ReactDOMFactories = {
	    a: createDOMFactory('a'),
	    abbr: createDOMFactory('abbr'),
	    address: createDOMFactory('address'),
	    area: createDOMFactory('area'),
	    article: createDOMFactory('article'),
	    aside: createDOMFactory('aside'),
	    audio: createDOMFactory('audio'),
	    b: createDOMFactory('b'),
	    base: createDOMFactory('base'),
	    bdi: createDOMFactory('bdi'),
	    bdo: createDOMFactory('bdo'),
	    big: createDOMFactory('big'),
	    blockquote: createDOMFactory('blockquote'),
	    body: createDOMFactory('body'),
	    br: createDOMFactory('br'),
	    button: createDOMFactory('button'),
	    canvas: createDOMFactory('canvas'),
	    caption: createDOMFactory('caption'),
	    cite: createDOMFactory('cite'),
	    code: createDOMFactory('code'),
	    col: createDOMFactory('col'),
	    colgroup: createDOMFactory('colgroup'),
	    data: createDOMFactory('data'),
	    datalist: createDOMFactory('datalist'),
	    dd: createDOMFactory('dd'),
	    del: createDOMFactory('del'),
	    details: createDOMFactory('details'),
	    dfn: createDOMFactory('dfn'),
	    dialog: createDOMFactory('dialog'),
	    div: createDOMFactory('div'),
	    dl: createDOMFactory('dl'),
	    dt: createDOMFactory('dt'),
	    em: createDOMFactory('em'),
	    embed: createDOMFactory('embed'),
	    fieldset: createDOMFactory('fieldset'),
	    figcaption: createDOMFactory('figcaption'),
	    figure: createDOMFactory('figure'),
	    footer: createDOMFactory('footer'),
	    form: createDOMFactory('form'),
	    h1: createDOMFactory('h1'),
	    h2: createDOMFactory('h2'),
	    h3: createDOMFactory('h3'),
	    h4: createDOMFactory('h4'),
	    h5: createDOMFactory('h5'),
	    h6: createDOMFactory('h6'),
	    head: createDOMFactory('head'),
	    header: createDOMFactory('header'),
	    hgroup: createDOMFactory('hgroup'),
	    hr: createDOMFactory('hr'),
	    html: createDOMFactory('html'),
	    i: createDOMFactory('i'),
	    iframe: createDOMFactory('iframe'),
	    img: createDOMFactory('img'),
	    input: createDOMFactory('input'),
	    ins: createDOMFactory('ins'),
	    kbd: createDOMFactory('kbd'),
	    keygen: createDOMFactory('keygen'),
	    label: createDOMFactory('label'),
	    legend: createDOMFactory('legend'),
	    li: createDOMFactory('li'),
	    link: createDOMFactory('link'),
	    main: createDOMFactory('main'),
	    map: createDOMFactory('map'),
	    mark: createDOMFactory('mark'),
	    menu: createDOMFactory('menu'),
	    menuitem: createDOMFactory('menuitem'),
	    meta: createDOMFactory('meta'),
	    meter: createDOMFactory('meter'),
	    nav: createDOMFactory('nav'),
	    noscript: createDOMFactory('noscript'),
	    object: createDOMFactory('object'),
	    ol: createDOMFactory('ol'),
	    optgroup: createDOMFactory('optgroup'),
	    option: createDOMFactory('option'),
	    output: createDOMFactory('output'),
	    p: createDOMFactory('p'),
	    param: createDOMFactory('param'),
	    picture: createDOMFactory('picture'),
	    pre: createDOMFactory('pre'),
	    progress: createDOMFactory('progress'),
	    q: createDOMFactory('q'),
	    rp: createDOMFactory('rp'),
	    rt: createDOMFactory('rt'),
	    ruby: createDOMFactory('ruby'),
	    s: createDOMFactory('s'),
	    samp: createDOMFactory('samp'),
	    script: createDOMFactory('script'),
	    section: createDOMFactory('section'),
	    select: createDOMFactory('select'),
	    small: createDOMFactory('small'),
	    source: createDOMFactory('source'),
	    span: createDOMFactory('span'),
	    strong: createDOMFactory('strong'),
	    style: createDOMFactory('style'),
	    sub: createDOMFactory('sub'),
	    summary: createDOMFactory('summary'),
	    sup: createDOMFactory('sup'),
	    table: createDOMFactory('table'),
	    tbody: createDOMFactory('tbody'),
	    td: createDOMFactory('td'),
	    textarea: createDOMFactory('textarea'),
	    tfoot: createDOMFactory('tfoot'),
	    th: createDOMFactory('th'),
	    thead: createDOMFactory('thead'),
	    time: createDOMFactory('time'),
	    title: createDOMFactory('title'),
	    tr: createDOMFactory('tr'),
	    track: createDOMFactory('track'),
	    u: createDOMFactory('u'),
	    ul: createDOMFactory('ul'),
	    var: createDOMFactory('var'),
	    video: createDOMFactory('video'),
	    wbr: createDOMFactory('wbr'),
	
	    // SVG
	    circle: createDOMFactory('circle'),
	    clipPath: createDOMFactory('clipPath'),
	    defs: createDOMFactory('defs'),
	    ellipse: createDOMFactory('ellipse'),
	    g: createDOMFactory('g'),
	    image: createDOMFactory('image'),
	    line: createDOMFactory('line'),
	    linearGradient: createDOMFactory('linearGradient'),
	    mask: createDOMFactory('mask'),
	    path: createDOMFactory('path'),
	    pattern: createDOMFactory('pattern'),
	    polygon: createDOMFactory('polygon'),
	    polyline: createDOMFactory('polyline'),
	    radialGradient: createDOMFactory('radialGradient'),
	    rect: createDOMFactory('rect'),
	    stop: createDOMFactory('stop'),
	    svg: createDOMFactory('svg'),
	    text: createDOMFactory('text'),
	    tspan: createDOMFactory('tspan'),
	  };
	
	  // due to wrapper and conditionals at the top, this will either become
	  // `module.exports ReactDOMFactories` if that is available,
	  // otherwise it will be defined via `define(['react'], ReactDOMFactories)`
	  // if that is available,
	  // otherwise it will be defined as global variable.
	  return ReactDOMFactories;
	});
	


/***/ },
/* 599 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(115);
	
	var invariant = __webpack_require__(15);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(135);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactInstrumentation = __webpack_require__(70);
	
	var quoteAttributeValueForBrowser = __webpack_require__(1460);
	var warning = __webpack_require__(21);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 602 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(26);
	
	var LinkedValueUtils = __webpack_require__(297);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactUpdates = __webpack_require__(82);
	
	var warning = __webpack_require__(21);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 604 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 605 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var invariant = __webpack_require__(15);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(1419);
	
	var containsNode = __webpack_require__(1312);
	var focusNode = __webpack_require__(450);
	var getActiveElement = __webpack_require__(451);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var DOMLazyTree = __webpack_require__(134);
	var DOMProperty = __webpack_require__(135);
	var React = __webpack_require__(139);
	var ReactBrowserEventEmitter = __webpack_require__(197);
	var ReactCurrentOwner = __webpack_require__(88);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactDOMContainerInfo = __webpack_require__(1413);
	var ReactDOMFeatureFlags = __webpack_require__(1415);
	var ReactFeatureFlags = __webpack_require__(605);
	var ReactInstanceMap = __webpack_require__(157);
	var ReactInstrumentation = __webpack_require__(70);
	var ReactMarkupChecksum = __webpack_require__(1429);
	var ReactReconciler = __webpack_require__(136);
	var ReactUpdateQueue = __webpack_require__(300);
	var ReactUpdates = __webpack_require__(82);
	
	var emptyObject = __webpack_require__(130);
	var instantiateReactComponent = __webpack_require__(615);
	var invariant = __webpack_require__(15);
	var setInnerHTML = __webpack_require__(201);
	var shouldUpdateReactComponent = __webpack_require__(306);
	var warning = __webpack_require__(21);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, { child: nextElement });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var React = __webpack_require__(139);
	
	var invariant = __webpack_require__(15);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 610 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var invariant = __webpack_require__(15);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 612 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(609);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(49);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25),
	    _assign = __webpack_require__(26);
	
	var ReactCompositeComponent = __webpack_require__(1410);
	var ReactEmptyComponent = __webpack_require__(604);
	var ReactHostComponent = __webpack_require__(606);
	
	var getNextDebugID = __webpack_require__(1457);
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(21);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + 'it\'s defined in.';
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ },
/* 616 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(49);
	var escapeTextContentForBrowser = __webpack_require__(200);
	var setInnerHTML = __webpack_require__(201);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var ReactCurrentOwner = __webpack_require__(88);
	var REACT_ELEMENT_TYPE = __webpack_require__(1425);
	
	var getIteratorFn = __webpack_require__(1456);
	var invariant = __webpack_require__(15);
	var KeyEscapeUtils = __webpack_require__(296);
	var warning = __webpack_require__(21);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1), __webpack_require__(14));
		else if(typeof define === 'function' && define.amd)
			define(["react", "prop-types"], factory);
		else if(typeof exports === 'object')
			exports["Dropzone"] = factory(require("react"), require("prop-types"));
		else
			root["Dropzone"] = factory(root["react"], root["prop-types"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
		
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
		
		var _react = __webpack_require__(2);
		
		var _react2 = _interopRequireDefault(_react);
		
		var _propTypes = __webpack_require__(3);
		
		var _propTypes2 = _interopRequireDefault(_propTypes);
		
		var _attrAccept = __webpack_require__(4);
		
		var _attrAccept2 = _interopRequireDefault(_attrAccept);
		
		var _getDataTransferItems = __webpack_require__(5);
		
		var _getDataTransferItems2 = _interopRequireDefault(_getDataTransferItems);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
		
		function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
		
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint prefer-template: 0 */
		
		var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;
		
		function fileAccepted(file, accept) {
		  // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
		  // that MIME type will always be accepted
		  return file.type === 'application/x-moz-file' || (0, _attrAccept2.default)(file, accept);
		}
		
		var Dropzone = function (_React$Component) {
		  _inherits(Dropzone, _React$Component);
		
		  _createClass(Dropzone, null, [{
		    key: 'onDocumentDragOver',
		    value: function onDocumentDragOver(evt) {
		      // allow the entire document to be a drag target
		      evt.preventDefault();
		    }
		  }]);
		
		  function Dropzone(props, context) {
		    _classCallCheck(this, Dropzone);
		
		    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this, props, context));
		
		    _this.renderChildren = function (children, isDragActive, isDragReject) {
		      if (typeof children === 'function') {
		        return children(_extends({}, _this.state, { isDragActive: isDragActive, isDragReject: isDragReject }));
		      }
		      return children;
		    };
		
		    _this.onClick = _this.onClick.bind(_this);
		    _this.onDocumentDrop = _this.onDocumentDrop.bind(_this);
		    _this.onDragStart = _this.onDragStart.bind(_this);
		    _this.onDragEnter = _this.onDragEnter.bind(_this);
		    _this.onDragLeave = _this.onDragLeave.bind(_this);
		    _this.onDragOver = _this.onDragOver.bind(_this);
		    _this.onDrop = _this.onDrop.bind(_this);
		    _this.onFileDialogCancel = _this.onFileDialogCancel.bind(_this);
		    _this.setRef = _this.setRef.bind(_this);
		    _this.setRefs = _this.setRefs.bind(_this);
		    _this.onInputElementClick = _this.onInputElementClick.bind(_this);
		    _this.isFileDialogActive = false;
		    _this.state = {
		      draggedFiles: [],
		      acceptedFiles: [],
		      rejectedFiles: []
		    };
		    return _this;
		  }
		
		  _createClass(Dropzone, [{
		    key: 'componentDidMount',
		    value: function componentDidMount() {
		      var preventDropOnDocument = this.props.preventDropOnDocument;
		
		      this.dragTargets = [];
		
		      if (preventDropOnDocument) {
		        document.addEventListener('dragover', Dropzone.onDocumentDragOver, false);
		        document.addEventListener('drop', this.onDocumentDrop, false);
		      }
		      this.fileInputEl.addEventListener('click', this.onInputElementClick, false);
		      // Tried implementing addEventListener, but didn't work out
		      document.body.onfocus = this.onFileDialogCancel;
		    }
		  }, {
		    key: 'componentWillUnmount',
		    value: function componentWillUnmount() {
		      var preventDropOnDocument = this.props.preventDropOnDocument;
		
		      if (preventDropOnDocument) {
		        document.removeEventListener('dragover', Dropzone.onDocumentDragOver);
		        document.removeEventListener('drop', this.onDocumentDrop);
		      }
		      this.fileInputEl.removeEventListener('click', this.onInputElementClick, false);
		      // Can be replaced with removeEventListener, if addEventListener works
		      document.body.onfocus = null;
		    }
		  }, {
		    key: 'onDocumentDrop',
		    value: function onDocumentDrop(evt) {
		      if (this.node.contains(evt.target)) {
		        // if we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
		        return;
		      }
		      evt.preventDefault();
		      this.dragTargets = [];
		    }
		  }, {
		    key: 'onDragStart',
		    value: function onDragStart(evt) {
		      if (this.props.onDragStart) {
		        this.props.onDragStart.call(this, evt);
		      }
		    }
		  }, {
		    key: 'onDragEnter',
		    value: function onDragEnter(evt) {
		      evt.preventDefault();
		
		      // Count the dropzone and any children that are entered.
		      if (this.dragTargets.indexOf(evt.target) === -1) {
		        this.dragTargets.push(evt.target);
		      }
		
		      this.setState({ draggedFiles: (0, _getDataTransferItems2.default)(evt) });
		
		      if (this.props.onDragEnter) {
		        this.props.onDragEnter.call(this, evt);
		      }
		    }
		  }, {
		    key: 'onDragOver',
		    value: function onDragOver(evt) {
		      // eslint-disable-line class-methods-use-this
		      evt.preventDefault();
		      evt.stopPropagation();
		      try {
		        evt.dataTransfer.dropEffect = 'copy'; // eslint-disable-line no-param-reassign
		      } catch (err) {
		        // continue regardless of error
		      }
		
		      if (this.props.onDragOver) {
		        this.props.onDragOver.call(this, evt);
		      }
		      return false;
		    }
		  }, {
		    key: 'onDragLeave',
		    value: function onDragLeave(evt) {
		      var _this2 = this;
		
		      evt.preventDefault();
		
		      // Only deactivate once the dropzone and all children have been left.
		      this.dragTargets = this.dragTargets.filter(function (el) {
		        return el !== evt.target && _this2.node.contains(el);
		      });
		      if (this.dragTargets.length > 0) {
		        return;
		      }
		
		      // Clear dragging files state
		      this.setState({ draggedFiles: [] });
		
		      if (this.props.onDragLeave) {
		        this.props.onDragLeave.call(this, evt);
		      }
		    }
		  }, {
		    key: 'onDrop',
		    value: function onDrop(evt) {
		      var _this3 = this;
		
		      var _props = this.props,
		          onDrop = _props.onDrop,
		          onDropAccepted = _props.onDropAccepted,
		          onDropRejected = _props.onDropRejected,
		          multiple = _props.multiple,
		          disablePreview = _props.disablePreview,
		          accept = _props.accept;
		
		      var fileList = (0, _getDataTransferItems2.default)(evt);
		      var acceptedFiles = [];
		      var rejectedFiles = [];
		
		      // Stop default browser behavior
		      evt.preventDefault();
		
		      // Reset the counter along with the drag on a drop.
		      this.dragTargets = [];
		      this.isFileDialogActive = false;
		
		      fileList.forEach(function (file) {
		        if (!disablePreview) {
		          try {
		            file.preview = window.URL.createObjectURL(file); // eslint-disable-line no-param-reassign
		          } catch (err) {
		            if (process.env.NODE_ENV !== 'production') {
		              console.error('Failed to generate preview for file', file, err); // eslint-disable-line no-console
		            }
		          }
		        }
		
		        if (fileAccepted(file, accept) && _this3.fileMatchSize(file)) {
		          acceptedFiles.push(file);
		        } else {
		          rejectedFiles.push(file);
		        }
		      });
		
		      if (!multiple) {
		        // if not in multi mode add any extra accepted files to rejected.
		        // This will allow end users to easily ignore a multi file drop in "single" mode.
		        rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(1)));
		      }
		
		      if (onDrop) {
		        onDrop.call(this, acceptedFiles, rejectedFiles, evt);
		      }
		
		      if (rejectedFiles.length > 0 && onDropRejected) {
		        onDropRejected.call(this, rejectedFiles, evt);
		      }
		
		      if (acceptedFiles.length > 0 && onDropAccepted) {
		        onDropAccepted.call(this, acceptedFiles, evt);
		      }
		
		      // Clear files value
		      this.draggedFiles = null;
		
		      // Reset drag state
		      this.setState({
		        draggedFiles: [],
		        acceptedFiles: acceptedFiles,
		        rejectedFiles: rejectedFiles
		      });
		    }
		  }, {
		    key: 'onClick',
		    value: function onClick(evt) {
		      var _props2 = this.props,
		          onClick = _props2.onClick,
		          disableClick = _props2.disableClick;
		
		      if (!disableClick) {
		        evt.stopPropagation();
		
		        if (onClick) {
		          onClick.call(this, evt);
		        }
		
		        // in IE11/Edge the file-browser dialog is blocking, ensure this is behind setTimeout
		        // this is so react can handle state changes in the onClick prop above above
		        // see: https://github.com/okonet/react-dropzone/issues/450
		        setTimeout(this.open.bind(this), 0);
		      }
		    }
		  }, {
		    key: 'onInputElementClick',
		    value: function onInputElementClick(evt) {
		      evt.stopPropagation();
		      if (this.props.inputProps && this.props.inputProps.onClick) {
		        this.props.inputProps.onClick();
		      }
		    }
		  }, {
		    key: 'onFileDialogCancel',
		    value: function onFileDialogCancel() {
		      // timeout will not recognize context of this method
		      var onFileDialogCancel = this.props.onFileDialogCancel;
		      var fileInputEl = this.fileInputEl;
		      var isFileDialogActive = this.isFileDialogActive;
		      // execute the timeout only if the onFileDialogCancel is defined and FileDialog
		      // is opened in the browser
		
		      if (onFileDialogCancel && isFileDialogActive) {
		        setTimeout(function () {
		          // Returns an object as FileList
		          var FileList = fileInputEl.files;
		          if (!FileList.length) {
		            isFileDialogActive = false;
		            onFileDialogCancel();
		          }
		        }, 300);
		      }
		    }
		  }, {
		    key: 'setRef',
		    value: function setRef(ref) {
		      this.node = ref;
		    }
		  }, {
		    key: 'setRefs',
		    value: function setRefs(ref) {
		      this.fileInputEl = ref;
		    }
		  }, {
		    key: 'fileMatchSize',
		    value: function fileMatchSize(file) {
		      return file.size <= this.props.maxSize && file.size >= this.props.minSize;
		    }
		  }, {
		    key: 'allFilesAccepted',
		    value: function allFilesAccepted(files) {
		      var _this4 = this;
		
		      return files.every(function (file) {
		        return fileAccepted(file, _this4.props.accept);
		      });
		    }
		
		    /**
		     * Open system file upload dialog.
		     *
		     * @public
		     */
		
		  }, {
		    key: 'open',
		    value: function open() {
		      this.isFileDialogActive = true;
		      this.fileInputEl.value = null;
		      this.fileInputEl.click();
		    }
		  }, {
		    key: 'render',
		    value: function render() {
		      var _props3 = this.props,
		          accept = _props3.accept,
		          activeClassName = _props3.activeClassName,
		          inputProps = _props3.inputProps,
		          multiple = _props3.multiple,
		          name = _props3.name,
		          rejectClassName = _props3.rejectClassName,
		          children = _props3.children,
		          rest = _objectWithoutProperties(_props3, ['accept', 'activeClassName', 'inputProps', 'multiple', 'name', 'rejectClassName', 'children']);
		
		      var activeStyle = rest.activeStyle,
		          className = rest.className,
		          rejectStyle = rest.rejectStyle,
		          style = rest.style,
		          props = _objectWithoutProperties(rest, ['activeStyle', 'className', 'rejectStyle', 'style']);
		
		      var draggedFiles = this.state.draggedFiles;
		
		      var filesCount = draggedFiles.length;
		      var isMultipleAllowed = multiple || filesCount <= 1;
		      var isDragActive = filesCount > 0 && this.allFilesAccepted(draggedFiles);
		      var isDragReject = filesCount > 0 && (!isDragActive || !isMultipleAllowed);
		
		      className = className || '';
		
		      if (isDragActive && activeClassName) {
		        className += ' ' + activeClassName;
		      }
		      if (isDragReject && rejectClassName) {
		        className += ' ' + rejectClassName;
		      }
		
		      if (!className && !style && !activeStyle && !rejectStyle) {
		        style = {
		          width: 200,
		          height: 200,
		          borderWidth: 2,
		          borderColor: '#666',
		          borderStyle: 'dashed',
		          borderRadius: 5
		        };
		        activeStyle = {
		          borderStyle: 'solid',
		          borderColor: '#6c6',
		          backgroundColor: '#eee'
		        };
		        rejectStyle = {
		          borderStyle: 'solid',
		          borderColor: '#c66',
		          backgroundColor: '#eee'
		        };
		      }
		
		      var appliedStyle = void 0;
		      if (activeStyle && isDragActive) {
		        appliedStyle = _extends({}, style, activeStyle);
		      } else if (rejectStyle && isDragReject) {
		        appliedStyle = _extends({}, style, rejectStyle);
		      } else {
		        appliedStyle = _extends({}, style);
		      }
		
		      var inputAttributes = {
		        accept: accept,
		        type: 'file',
		        style: { display: 'none' },
		        multiple: supportMultiple && multiple,
		        ref: this.setRefs,
		        onChange: this.onDrop
		      };
		
		      if (name && name.length) {
		        inputAttributes.name = name;
		      }
		
		      // Remove custom properties before passing them to the wrapper div element
		      var customProps = ['acceptedFiles', 'preventDropOnDocument', 'disablePreview', 'disableClick', 'onDropAccepted', 'onDropRejected', 'onFileDialogCancel', 'maxSize', 'minSize'];
		      var divProps = _extends({}, props);
		      customProps.forEach(function (prop) {
		        return delete divProps[prop];
		      });
		
		      return _react2.default.createElement(
		        'div',
		        _extends({
		          className: className,
		          style: appliedStyle
		        }, divProps /* expand user provided props first so event handlers are never overridden */, {
		          onClick: this.onClick,
		          onDragStart: this.onDragStart,
		          onDragEnter: this.onDragEnter,
		          onDragOver: this.onDragOver,
		          onDragLeave: this.onDragLeave,
		          onDrop: this.onDrop,
		          ref: this.setRef
		        }),
		        this.renderChildren(children, isDragActive, isDragReject),
		        _react2.default.createElement('input', _extends({}, inputProps /* expand user provided inputProps first so inputAttributes override them */, inputAttributes))
		      );
		    }
		  }]);
		
		  return Dropzone;
		}(_react2.default.Component);
		
		Dropzone.propTypes = {
		  /**
		   * Allow specific types of files. See https://github.com/okonet/attr-accept for more information.
		   * Keep in mind that mime type determination is not reliable accross platforms. CSV files,
		   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
		   * Windows. In some cases there might not be a mime type set at all.
		   * See: https://github.com/okonet/react-dropzone/issues/276
		   */
		  accept: _propTypes2.default.string,
		
		  /**
		   * Contents of the dropzone
		   */
		  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
		
		  /**
		   * Disallow clicking on the dropzone container to open file dialog
		   */
		  disableClick: _propTypes2.default.bool,
		
		  /**
		   * Enable/disable preview generation
		   */
		  disablePreview: _propTypes2.default.bool,
		
		  /**
		   * If false, allow dropped items to take over the current browser window
		   */
		  preventDropOnDocument: _propTypes2.default.bool,
		
		  /**
		   * Pass additional attributes to the `<input type="file"/>` tag
		   */
		  inputProps: _propTypes2.default.object,
		
		  /**
		   * Allow dropping multiple files
		   */
		  multiple: _propTypes2.default.bool,
		
		  /**
		   * `name` attribute for the input tag
		   */
		  name: _propTypes2.default.string,
		
		  /**
		   * Maximum file size
		   */
		  maxSize: _propTypes2.default.number,
		
		  /**
		   * Minimum file size
		   */
		  minSize: _propTypes2.default.number,
		
		  /**
		   * className
		   */
		  className: _propTypes2.default.string,
		
		  /**
		   * className for accepted state
		   */
		  activeClassName: _propTypes2.default.string,
		
		  /**
		   * className for rejected state
		   */
		  rejectClassName: _propTypes2.default.string,
		
		  /**
		   * CSS styles to apply
		   */
		  style: _propTypes2.default.object,
		
		  /**
		   * CSS styles to apply when drop will be accepted
		   */
		  activeStyle: _propTypes2.default.object,
		
		  /**
		   * CSS styles to apply when drop will be rejected
		   */
		  rejectStyle: _propTypes2.default.object,
		
		  /**
		   * onClick callback
		   * @param {Event} event
		   */
		  onClick: _propTypes2.default.func,
		
		  /**
		   * onDrop callback
		   */
		  onDrop: _propTypes2.default.func,
		
		  /**
		   * onDropAccepted callback
		   */
		  onDropAccepted: _propTypes2.default.func,
		
		  /**
		   * onDropRejected callback
		   */
		  onDropRejected: _propTypes2.default.func,
		
		  /**
		   * onDragStart callback
		   */
		  onDragStart: _propTypes2.default.func,
		
		  /**
		   * onDragEnter callback
		   */
		  onDragEnter: _propTypes2.default.func,
		
		  /**
		   * onDragOver callback
		   */
		  onDragOver: _propTypes2.default.func,
		
		  /**
		   * onDragLeave callback
		   */
		  onDragLeave: _propTypes2.default.func,
		
		  /**
		   * Provide a callback on clicking the cancel button of the file dialog
		   */
		  onFileDialogCancel: _propTypes2.default.func
		};
		
		Dropzone.defaultProps = {
		  preventDropOnDocument: true,
		  disablePreview: false,
		  disableClick: false,
		  multiple: true,
		  maxSize: Infinity,
		  minSize: 0
		};
		
		exports.default = Dropzone;
		module.exports = exports['default'];
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
		// shim for using process in browser
		var process = module.exports = {};
		
		// cached from whatever global is present so that test runners that stub it
		// don't break things.  But we need to wrap it in a try catch in case it is
		// wrapped in strict mode code which doesn't define any globals.  It's inside a
		// function because try/catches deoptimize in certain engines.
		
		var cachedSetTimeout;
		var cachedClearTimeout;
		
		function defaultSetTimout() {
		    throw new Error('setTimeout has not been defined');
		}
		function defaultClearTimeout () {
		    throw new Error('clearTimeout has not been defined');
		}
		(function () {
		    try {
		        if (typeof setTimeout === 'function') {
		            cachedSetTimeout = setTimeout;
		        } else {
		            cachedSetTimeout = defaultSetTimout;
		        }
		    } catch (e) {
		        cachedSetTimeout = defaultSetTimout;
		    }
		    try {
		        if (typeof clearTimeout === 'function') {
		            cachedClearTimeout = clearTimeout;
		        } else {
		            cachedClearTimeout = defaultClearTimeout;
		        }
		    } catch (e) {
		        cachedClearTimeout = defaultClearTimeout;
		    }
		} ())
		function runTimeout(fun) {
		    if (cachedSetTimeout === setTimeout) {
		        //normal enviroments in sane situations
		        return setTimeout(fun, 0);
		    }
		    // if setTimeout wasn't available but was latter defined
		    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
		        cachedSetTimeout = setTimeout;
		        return setTimeout(fun, 0);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedSetTimeout(fun, 0);
		    } catch(e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
		            return cachedSetTimeout.call(null, fun, 0);
		        } catch(e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
		            return cachedSetTimeout.call(this, fun, 0);
		        }
		    }
		
		
		}
		function runClearTimeout(marker) {
		    if (cachedClearTimeout === clearTimeout) {
		        //normal enviroments in sane situations
		        return clearTimeout(marker);
		    }
		    // if clearTimeout wasn't available but was latter defined
		    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
		        cachedClearTimeout = clearTimeout;
		        return clearTimeout(marker);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedClearTimeout(marker);
		    } catch (e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
		            return cachedClearTimeout.call(null, marker);
		        } catch (e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
		            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
		            return cachedClearTimeout.call(this, marker);
		        }
		    }
		
		
		
		}
		var queue = [];
		var draining = false;
		var currentQueue;
		var queueIndex = -1;
		
		function cleanUpNextTick() {
		    if (!draining || !currentQueue) {
		        return;
		    }
		    draining = false;
		    if (currentQueue.length) {
		        queue = currentQueue.concat(queue);
		    } else {
		        queueIndex = -1;
		    }
		    if (queue.length) {
		        drainQueue();
		    }
		}
		
		function drainQueue() {
		    if (draining) {
		        return;
		    }
		    var timeout = runTimeout(cleanUpNextTick);
		    draining = true;
		
		    var len = queue.length;
		    while(len) {
		        currentQueue = queue;
		        queue = [];
		        while (++queueIndex < len) {
		            if (currentQueue) {
		                currentQueue[queueIndex].run();
		            }
		        }
		        queueIndex = -1;
		        len = queue.length;
		    }
		    currentQueue = null;
		    draining = false;
		    runClearTimeout(timeout);
		}
		
		process.nextTick = function (fun) {
		    var args = new Array(arguments.length - 1);
		    if (arguments.length > 1) {
		        for (var i = 1; i < arguments.length; i++) {
		            args[i - 1] = arguments[i];
		        }
		    }
		    queue.push(new Item(fun, args));
		    if (queue.length === 1 && !draining) {
		        runTimeout(drainQueue);
		    }
		};
		
		// v8 likes predictible objects
		function Item(fun, array) {
		    this.fun = fun;
		    this.array = array;
		}
		Item.prototype.run = function () {
		    this.fun.apply(null, this.array);
		};
		process.title = 'browser';
		process.browser = true;
		process.env = {};
		process.argv = [];
		process.version = ''; // empty string to avoid regexp issues
		process.versions = {};
		
		function noop() {}
		
		process.on = noop;
		process.addListener = noop;
		process.once = noop;
		process.off = noop;
		process.removeListener = noop;
		process.removeAllListeners = noop;
		process.emit = noop;
		process.prependListener = noop;
		process.prependOnceListener = noop;
		
		process.listeners = function (name) { return [] }
		
		process.binding = function (name) {
		    throw new Error('process.binding is not supported');
		};
		
		process.cwd = function () { return '/' };
		process.chdir = function (dir) {
		    throw new Error('process.chdir is not supported');
		};
		process.umask = function() { return 0; };
	
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_3__;
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports) {
	
		module.exports=function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={exports:{},id:e,loaded:!1};return t[e].call(o.exports,o,o.exports,n),o.loaded=!0,o.exports}var r={};return n.m=t,n.c=r,n.p="",n(0)}([function(t,n,r){"use strict";n.__esModule=!0,r(8),r(9),n["default"]=function(t,n){if(t&&n){var r=function(){var r=Array.isArray(n)?n:n.split(","),e=t.name||"",o=t.type||"",i=o.replace(/\/.*$/,"");return{v:r.some(function(t){var n=t.trim();return"."===n.charAt(0)?e.toLowerCase().endsWith(n.toLowerCase()):/\/\*$/.test(n)?i===n.replace(/\/.*$/,""):o===n})}}();if("object"==typeof r)return r.v}return!0},t.exports=n["default"]},function(t,n){var r=t.exports={version:"1.2.2"};"number"==typeof __e&&(__e=r)},function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r)},function(t,n,r){var e=r(2),o=r(1),i=r(4),u=r(19),c="prototype",f=function(t,n){return function(){return t.apply(n,arguments)}},s=function(t,n,r){var a,p,l,y,d=t&s.G,h=t&s.P,v=d?e:t&s.S?e[n]||(e[n]={}):(e[n]||{})[c],x=d?o:o[n]||(o[n]={});d&&(r=n);for(a in r)p=!(t&s.F)&&v&&a in v,l=(p?v:r)[a],y=t&s.B&&p?f(l,e):h&&"function"==typeof l?f(Function.call,l):l,v&&!p&&u(v,a,l),x[a]!=l&&i(x,a,y),h&&((x[c]||(x[c]={}))[a]=l)};e.core=o,s.F=1,s.G=2,s.S=4,s.P=8,s.B=16,s.W=32,t.exports=s},function(t,n,r){var e=r(5),o=r(18);t.exports=r(22)?function(t,n,r){return e.setDesc(t,n,o(1,r))}:function(t,n,r){return t[n]=r,t}},function(t,n){var r=Object;t.exports={create:r.create,getProto:r.getPrototypeOf,isEnum:{}.propertyIsEnumerable,getDesc:r.getOwnPropertyDescriptor,setDesc:r.defineProperty,setDescs:r.defineProperties,getKeys:r.keys,getNames:r.getOwnPropertyNames,getSymbols:r.getOwnPropertySymbols,each:[].forEach}},function(t,n){var r=0,e=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36))}},function(t,n,r){var e=r(20)("wks"),o=r(2).Symbol;t.exports=function(t){return e[t]||(e[t]=o&&o[t]||(o||r(6))("Symbol."+t))}},function(t,n,r){r(26),t.exports=r(1).Array.some},function(t,n,r){r(25),t.exports=r(1).String.endsWith},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,n,r){var e=r(10);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,o){return t.call(n,r,e,o)}}return function(){return t.apply(n,arguments)}}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n,r){t.exports=function(t){var n=/./;try{"/./"[t](n)}catch(e){try{return n[r(7)("match")]=!1,!"/./"[t](n)}catch(o){}}return!0}},function(t,n){t.exports=function(t){try{return!!t()}catch(n){return!0}}},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n,r){var e=r(16),o=r(11),i=r(7)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,r){var e=r(2),o=r(4),i=r(6)("src"),u="toString",c=Function[u],f=(""+c).split(u);r(1).inspectSource=function(t){return c.call(t)},(t.exports=function(t,n,r,u){"function"==typeof r&&(o(r,i,t[n]?""+t[n]:f.join(String(n))),"name"in r||(r.name=n)),t===e?t[n]=r:(u||delete t[n],o(t,n,r))})(Function.prototype,u,function(){return"function"==typeof this&&this[i]||c.call(this)})},function(t,n,r){var e=r(2),o="__core-js_shared__",i=e[o]||(e[o]={});t.exports=function(t){return i[t]||(i[t]={})}},function(t,n,r){var e=r(17),o=r(13);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(o(t))}},function(t,n,r){t.exports=!r(15)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t)}},function(t,n,r){var e=r(23),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0}},function(t,n,r){"use strict";var e=r(3),o=r(24),i=r(21),u="endsWith",c=""[u];e(e.P+e.F*r(14)(u),"String",{endsWith:function(t){var n=i(this,t,u),r=arguments,e=r.length>1?r[1]:void 0,f=o(n.length),s=void 0===e?f:Math.min(o(e),f),a=String(t);return c?c.call(n,a,s):n.slice(s-a.length,s)===a}})},function(t,n,r){var e=r(5),o=r(3),i=r(1).Array||Array,u={},c=function(t,n){e.each.call(t.split(","),function(t){void 0==n&&t in i?u[t]=i[t]:t in[]&&(u[t]=r(12)(Function.call,[][t],n))})};c("pop,reverse,shift,keys,values,entries",1),c("indexOf,every,some,forEach,map,filter,find,findIndex,includes",3),c("join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill"),o(o.S,"Array",u)}]);
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports) {
	
		"use strict";
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = getDataTransferFiles;
		function getDataTransferFiles(event) {
		  var dataTransferItemsList = [];
		  if (event.dataTransfer) {
		    var dt = event.dataTransfer;
		    if (dt.files && dt.files.length) {
		      dataTransferItemsList = dt.files;
		    } else if (dt.items && dt.items.length) {
		      // During the drag even the dataTransfer.files is null
		      // but Chrome implements some drag store, which is accesible via dataTransfer.items
		      dataTransferItemsList = dt.items;
		    }
		  } else if (event.target && event.target.files) {
		    dataTransferItemsList = event.target.files;
		  }
		  // Convert from DataTransferItemsList to the native Array
		  return Array.prototype.slice.call(dataTransferItemsList);
		}
		module.exports = exports["default"];
	
	/***/ })
	/******/ ])
	});
	;
	//# sourceMappingURL=index.js.map

/***/ },
/* 620 */
/***/ function(module, exports) {

	/*!
	 * Adapted from jQuery UI core
	 *
	 * http://jqueryui.com
	 *
	 * Copyright 2014 jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/category/ui-core/
	 */
	
	function focusable(element, isTabIndexNotNaN) {
	  var nodeName = element.nodeName.toLowerCase();
	  return (/input|select|textarea|button|object/.test(nodeName) ?
	    !element.disabled :
	    "a" === nodeName ?
	      element.href || isTabIndexNotNaN :
	      isTabIndexNotNaN) && visible(element);
	}
	
	function hidden(el) {
	  return (el.offsetWidth <= 0 && el.offsetHeight <= 0) ||
	    el.style.display === 'none';
	}
	
	function visible(element) {
	  while (element) {
	    if (element === document.body) break;
	    if (hidden(element)) return false;
	    element = element.parentNode;
	  }
	  return true;
	}
	
	function tabbable(element) {
	  var tabIndex = element.getAttribute('tabindex');
	  if (tabIndex === null) tabIndex = undefined;
	  var isTabIndexNaN = isNaN(tabIndex);
	  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
	}
	
	function findTabbableDescendants(element) {
	  return [].slice.call(element.querySelectorAll('*'), 0).filter(function(el) {
	    return tabbable(el);
	  });
	}
	
	module.exports = findTabbableDescendants;
	


/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _propTypes = __webpack_require__(2);
	
		var _propTypes2 = _interopRequireDefault(_propTypes);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var KEYCODE_UP = 38;
		var KEYCODE_DOWN = 40;
		var IS_BROWSER = typeof document != 'undefined';
		var RE_NUMBER = /^[+-]?((\.\d+)|(\d+(\.\d+)?))$/;
		var RE_INCOMPLETE_NUMBER = /^([+-]|\.0*|[+-]\.0*|[+-]?\d+\.)?$/;
	
		function addClass(element, className) {
		    if (element.classList) {
		        return element.classList.add(className);
		    }
		    if (!element.className.search(new RegExp("\\b" + className + "\\b"))) {
		        element.className = " " + className;
		    }
		}
	
		function removeClass(element, className) {
		    if (element.className) {
		        if (element.classList) {
		            return element.classList.remove(className);
		        }
	
		        element.className = element.className.replace(new RegExp("\\b" + className + "\\b", "g"), "");
		    }
		}
	
		function access(object, prop, defaultValue) {
		    var result = object[prop];
		    if (typeof result == "function") {
		        for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
		            args[_key - 3] = arguments[_key];
		        }
	
		        result = result.apply(undefined, args);
		    }
		    return result === undefined ? defaultValue : result;
		}
	
		var NumericInput = function (_Component) {
		    _inherits(NumericInput, _Component);
	
		    function NumericInput() {
		        var _ref;
	
		        _classCallCheck(this, NumericInput);
	
		        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
		            args[_key2] = arguments[_key2];
		        }
	
		        var _this = _possibleConstructorReturn(this, (_ref = NumericInput.__proto__ || Object.getPrototypeOf(NumericInput)).call.apply(_ref, [this].concat(args)));
	
		        _this._isStrict = !!_this.props.strict;
	
		        _this.state = _extends({
		            btnDownHover: false,
		            btnDownActive: false,
		            btnUpHover: false,
		            btnUpActive: false,
		            stringValue: ""
		        }, _this._propsToState(_this.props));
		        _this.stop = _this.stop.bind(_this);
		        _this.onTouchEnd = _this.onTouchEnd.bind(_this);
		        _this.refsInput = {};
		        _this.refsWrapper = {};
		        return _this;
		    }
	
		    _createClass(NumericInput, [{
		        key: '_propsToState',
		        value: function _propsToState(props) {
		            var out = {};
	
		            if (props.hasOwnProperty("value")) {
		                out.stringValue = String(props.value || props.value === 0 ? props.value : '').trim();
	
		                out.value = out.stringValue !== '' ? this._parse(props.value) : null;
		            } else if (!this._isMounted && props.hasOwnProperty("defaultValue")) {
		                out.stringValue = String(props.defaultValue || props.defaultValue === 0 ? props.defaultValue : '').trim();
	
		                out.value = props.defaultValue !== '' ? this._parse(props.defaultValue) : null;
		            }
	
		            return out;
		        }
		    }, {
		        key: 'componentWillReceiveProps',
		        value: function componentWillReceiveProps(props) {
		            var _this2 = this;
	
		            this._isStrict = !!props.strict;
		            var nextState = this._propsToState(props);
		            if (Object.keys(nextState).length) {
		                this._ignoreValueChange = true;
		                this.setState(nextState, function () {
		                    _this2._ignoreValueChange = false;
		                });
		            }
		        }
		    }, {
		        key: 'componentWillUpdate',
		        value: function componentWillUpdate() {
		            this.saveSelection();
		        }
		    }, {
		        key: 'componentDidUpdate',
		        value: function componentDidUpdate(prevProps, prevState) {
		            if (!this._ignoreValueChange && prevState.value !== this.state.value && (!isNaN(this.state.value) || this.state.value === null)) {
		                    this._invokeEventCallback("onChange", this.state.value, this.refsInput.value, this.refsInput);
		                }
	
		            if (this._inputFocus) {
		                this.refsInput.focus();
	
		                if (this.state.selectionStart || this.state.selectionStart === 0) {
		                    this.refsInput.selectionStart = this.state.selectionStart;
		                }
	
		                if (this.state.selectionEnd || this.state.selectionEnd === 0) {
		                    this.refsInput.selectionEnd = this.state.selectionEnd;
		                }
		            }
	
		            this.checkValidity();
		        }
		    }, {
		        key: 'componentWillUnmount',
		        value: function componentWillUnmount() {
		            this._isMounted = false;
		            this.stop();
		        }
		    }, {
		        key: 'componentDidMount',
		        value: function componentDidMount() {
		            var _this3 = this;
	
		            this._isMounted = true;
		            this.refsInput.getValueAsNumber = function () {
		                return _this3.state.value || 0;
		            };
	
		            this.refsInput.setValue = function (value) {
		                _this3.setState({
		                    value: _this3._parse(value),
		                    stringValue: value
		                });
		            };
	
		            if (!this._inputFocus && IS_BROWSER && document.activeElement === this.refsInput) {
		                this._inputFocus = true;
		                this.refsInput.focus();
		                this._invokeEventCallback("onFocus", {
		                    target: this.refsInput,
		                    type: "focus"
		                });
		            }
	
		            this.checkValidity();
		        }
		    }, {
		        key: 'saveSelection',
		        value: function saveSelection() {
		            this.state.selectionStart = this.refsInput.selectionStart;
		            this.state.selectionEnd = this.refsInput.selectionEnd;
		        }
		    }, {
		        key: 'checkValidity',
		        value: function checkValidity() {
		            var valid = void 0,
		                validationError = "";
	
		            var supportsValidation = !!this.refsInput.checkValidity;
	
		            var noValidate = !!(this.props.noValidate && this.props.noValidate != "false");
	
		            this.refsInput.noValidate = noValidate;
	
		            valid = noValidate || !supportsValidation;
	
		            if (valid) {
		                validationError = "";
		            } else {
		                if (this.refsInput.pattern === "") {
		                    this.refsInput.pattern = this.props.required ? ".+" : ".*";
		                }
	
		                if (supportsValidation) {
		                    this.refsInput.checkValidity();
		                    valid = this.refsInput.validity.valid;
	
		                    if (!valid) {
		                        validationError = this.refsInput.validationMessage;
		                    }
		                }
	
		                if (valid && supportsValidation && this.props.maxLength) {
		                    if (this.refsInput.value.length > this.props.maxLength) {
		                        validationError = "This value is too long";
		                    }
		                }
		            }
	
		            validationError = validationError || (valid ? "" : this.refsInput.validationMessage || "Unknown Error");
	
		            var validStateChanged = this._valid !== validationError;
		            this._valid = validationError;
		            if (validationError) {
		                addClass(this.refsWrapper, "has-error");
		                if (validStateChanged) {
		                    this._invokeEventCallback("onInvalid", validationError, this.state.value, this.refsInput.value);
		                }
		            } else {
		                removeClass(this.refsWrapper, "has-error");
		                if (validStateChanged) {
		                    this._invokeEventCallback("onValid", this.state.value, this.refsInput.value);
		                }
		            }
		        }
		    }, {
		        key: '_toNumber',
		        value: function _toNumber(x) {
		            var n = parseFloat(x);
		            if (isNaN(n) || !isFinite(n)) {
		                n = 0;
		            }
	
		            if (this._isStrict) {
		                var precision = access(this.props, "precision", null, this);
		                var q = Math.pow(10, precision === null ? 10 : precision);
		                var _min = +access(this.props, "min", NumericInput.defaultProps.min, this);
		                var _max = +access(this.props, "max", NumericInput.defaultProps.max, this);
		                n = Math.min(Math.max(n, _min), _max);
		                n = Math.round(n * q) / q;
		            }
	
		            return n;
		        }
		    }, {
		        key: '_parse',
		        value: function _parse(x) {
		            x = String(x);
		            if (typeof this.props.parse == 'function') {
		                return parseFloat(this.props.parse(x));
		            }
		            return parseFloat(x);
		        }
		    }, {
		        key: '_format',
		        value: function _format(n) {
		            var _n = this._toNumber(n);
		            var precision = access(this.props, "precision", null, this);
		            if (precision !== null) {
		                _n = n.toFixed(precision);
		            }
	
		            _n += "";
	
		            if (this.props.format) {
		                return this.props.format(_n);
		            }
	
		            return _n;
		        }
		    }, {
		        key: '_step',
		        value: function _step(n, callback) {
		            var _isStrict = this._isStrict;
		            this._isStrict = true;
	
		            var _step = +access(this.props, "step", NumericInput.defaultProps.step, this, n > 0 ? NumericInput.DIRECTION_UP : NumericInput.DIRECTION_DOWN);
	
		            var _n = this._toNumber((this.state.value || 0) + _step * n);
	
		            if (this.props.snap) {
		                _n = Math.round(_n / _step) * _step;
		            }
	
		            this._isStrict = _isStrict;
	
		            if (_n !== this.state.value) {
		                this.setState({ value: _n, stringValue: _n + "" }, callback);
		                return true;
		            }
	
		            return false;
		        }
		    }, {
		        key: '_onKeyDown',
		        value: function _onKeyDown() {
		            for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
		                args[_key3] = arguments[_key3];
		            }
	
		            args[0].persist();
		            this._invokeEventCallback.apply(this, ["onKeyDown"].concat(args));
		            var e = args[0];
		            if (!e.isDefaultPrevented()) {
		                if (e.keyCode === KEYCODE_UP) {
		                    e.preventDefault();
		                    this._step(e.ctrlKey || e.metaKey ? 0.1 : e.shiftKey ? 10 : 1);
		                } else if (e.keyCode === KEYCODE_DOWN) {
		                    e.preventDefault();
		                    this._step(e.ctrlKey || e.metaKey ? -0.1 : e.shiftKey ? -10 : -1);
		                } else {
		                    var _value = this.refsInput.value,
		                        length = _value.length;
		                    if (e.keyCode === 8) {
		                        if (this.refsInput.selectionStart == this.refsInput.selectionEnd && this.refsInput.selectionEnd > 0 && _value.length && _value.charAt(this.refsInput.selectionEnd - 1) === ".") {
		                            e.preventDefault();
		                            this.refsInput.selectionStart = this.refsInput.selectionEnd = this.refsInput.selectionEnd - 1;
		                        }
		                    } else if (e.keyCode === 46) {
		                        if (this.refsInput.selectionStart == this.refsInput.selectionEnd && this.refsInput.selectionEnd < length + 1 && _value.length && _value.charAt(this.refsInput.selectionEnd) === ".") {
		                            e.preventDefault();
		                            this.refsInput.selectionStart = this.refsInput.selectionEnd = this.refsInput.selectionEnd + 1;
		                        }
		                    }
		                }
		            }
		        }
		    }, {
		        key: 'stop',
		        value: function stop() {
		            if (this._timer) {
		                clearTimeout(this._timer);
		            }
		        }
		    }, {
		        key: 'increase',
		        value: function increase() {
		            var _this4 = this;
	
		            var _recursive = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
		            var callback = arguments[1];
	
		            this.stop();
		            this._step(1, callback);
		            var _max = +access(this.props, "max", NumericInput.defaultProps.max, this);
		            if (isNaN(this.state.value) || +this.state.value < _max) {
		                this._timer = setTimeout(function () {
		                    _this4.increase(true);
		                }, _recursive ? NumericInput.SPEED : NumericInput.DELAY);
		            }
		        }
		    }, {
		        key: 'decrease',
		        value: function decrease() {
		            var _this5 = this;
	
		            var _recursive = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
		            var callback = arguments[1];
	
		            this.stop();
		            this._step(-1, callback);
		            var _min = +access(this.props, "min", NumericInput.defaultProps.min, this);
		            if (isNaN(this.state.value) || +this.state.value > _min) {
		                this._timer = setTimeout(function () {
		                    _this5.decrease(true);
		                }, _recursive ? NumericInput.SPEED : NumericInput.DELAY);
		            }
		        }
		    }, {
		        key: 'onMouseDown',
		        value: function onMouseDown(dir, callback) {
		            if (dir == 'down') {
		                this.decrease(false, callback);
		            } else if (dir == 'up') {
		                this.increase(false, callback);
		            }
		        }
		    }, {
		        key: 'onTouchStart',
		        value: function onTouchStart(dir, e) {
		            e.preventDefault();
		            if (dir == 'down') {
		                this.decrease();
		            } else if (dir == 'up') {
		                this.increase();
		            }
		        }
		    }, {
		        key: 'onTouchEnd',
		        value: function onTouchEnd(e) {
		            e.preventDefault();
		            this.stop();
		        }
		    }, {
		        key: '_invokeEventCallback',
		        value: function _invokeEventCallback(callbackName) {
		            if (typeof this.props[callbackName] == "function") {
		                var _props$callbackName;
	
		                for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
		                    args[_key4 - 1] = arguments[_key4];
		                }
	
		                (_props$callbackName = this.props[callbackName]).call.apply(_props$callbackName, [null].concat(args));
		            }
		        }
		    }, {
		        key: 'render',
		        value: function render() {
		            var _this6 = this;
	
		            var props = this.props;
		            var state = this.state;
		            var css = {};
	
		            var _props = this.props,
		                step = _props.step,
		                min = _props.min,
		                max = _props.max,
		                precision = _props.precision,
		                parse = _props.parse,
		                format = _props.format,
		                mobile = _props.mobile,
		                snap = _props.snap,
		                componentClass = _props.componentClass,
		                value = _props.value,
		                type = _props.type,
		                style = _props.style,
		                defaultValue = _props.defaultValue,
		                onInvalid = _props.onInvalid,
		                onValid = _props.onValid,
		                strict = _props.strict,
		                noStyle = _props.noStyle,
		                rest = _objectWithoutProperties(_props, ['step', 'min', 'max', 'precision', 'parse', 'format', 'mobile', 'snap', 'componentClass', 'value', 'type', 'style', 'defaultValue', 'onInvalid', 'onValid', 'strict', 'noStyle']);
	
		            noStyle = noStyle || style === false;
	
		            for (var x in NumericInput.style) {
		                css[x] = _extends({}, NumericInput.style[x], style ? style[x] || {} : {});
		            }
	
		            var hasFormControl = props.className && /\bform-control\b/.test(props.className);
	
		            if (mobile == 'auto') {
		                mobile = IS_BROWSER && 'ontouchstart' in document;
		            }
	
		            if (typeof mobile == "function") {
		                mobile = mobile.call(this);
		            }
		            mobile = !!mobile;
	
		            var attrs = {
		                wrap: {
		                    style: noStyle ? null : css.wrap,
		                    className: 'react-numeric-input',
		                    ref: function ref(e) {
		                        if (e != null && e != undefined) {
		                            _this6.refsWrapper = e;
		                        }
		                    },
		                    onMouseUp: undefined,
		                    onMouseLeave: undefined
		                },
		                input: _extends({
		                    ref: function ref(e) {
		                        if (e != null && e != undefined) {
		                            _this6.refsInput = e;
		                        }
		                    },
		                    type: 'text',
		                    style: noStyle ? null : _extends({}, css.input, !hasFormControl ? css['input:not(.form-control)'] : {}, this._inputFocus ? css['input:focus'] : {})
		                }, rest),
		                btnUp: {
		                    onMouseEnter: undefined,
		                    onMouseDown: undefined,
		                    onMouseUp: undefined,
		                    onMouseLeave: undefined,
		                    onTouchStart: undefined,
		                    onTouchEnd: undefined,
		                    style: noStyle ? null : _extends({}, css.btn, css.btnUp, props.disabled || props.readOnly ? css['btn:disabled'] : state.btnUpActive ? css['btn:active'] : state.btnUpHover ? css['btn:hover'] : {})
		                },
		                btnDown: {
		                    onMouseEnter: undefined,
		                    onMouseDown: undefined,
		                    onMouseUp: undefined,
		                    onMouseLeave: undefined,
		                    onTouchStart: undefined,
		                    onTouchEnd: undefined,
		                    style: noStyle ? null : _extends({}, css.btn, css.btnDown, props.disabled || props.readOnly ? css['btn:disabled'] : state.btnDownActive ? css['btn:active'] : state.btnDownHover ? css['btn:hover'] : {})
		                }
		            };
	
		            var stringValue = String(state.stringValue || (state.value || state.value === 0 ? state.value : "") || "");
	
		            var loose = !this._isStrict && (this._inputFocus || !this._isMounted);
	
		            if (loose && RE_INCOMPLETE_NUMBER.test(stringValue)) {
		                attrs.input.value = stringValue;
		            } else if (loose && stringValue && !RE_NUMBER.test(stringValue)) {
		                    attrs.input.value = stringValue;
		                } else if (state.value || state.value === 0) {
		                        attrs.input.value = this._format(state.value);
		                    } else {
		                            attrs.input.value = "";
		                        }
	
		            if (hasFormControl && !noStyle) {
		                _extends(attrs.wrap.style, css['wrap.hasFormControl']);
		            }
	
		            if (mobile && !noStyle) {
		                _extends(attrs.input.style, css['input.mobile']);
		                _extends(attrs.btnUp.style, css['btnUp.mobile']);
		                _extends(attrs.btnDown.style, css['btnDown.mobile']);
		            }
	
		            if (!props.disabled && !props.readOnly) {
		                _extends(attrs.wrap, {
		                    onMouseUp: this.stop,
		                    onMouseLeave: this.stop
		                });
	
		                _extends(attrs.btnUp, {
		                    onTouchStart: this.onTouchStart.bind(this, 'up'),
		                    onTouchEnd: this.onTouchEnd,
		                    onMouseEnter: function onMouseEnter() {
		                        _this6.setState({
		                            btnUpHover: true
		                        });
		                    },
		                    onMouseLeave: function onMouseLeave() {
		                        _this6.stop();
		                        _this6.setState({
		                            btnUpHover: false,
		                            btnUpActive: false
		                        });
		                    },
		                    onMouseUp: function onMouseUp() {
		                        _this6.setState({
		                            btnUpHover: true,
		                            btnUpActive: false
		                        });
		                    },
		                    onMouseDown: function onMouseDown() {
		                        for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
		                            args[_key5] = arguments[_key5];
		                        }
	
		                        args[0].preventDefault();
		                        args[0].persist();
		                        _this6._inputFocus = true;
		                        _this6.setState({
		                            btnUpHover: true,
		                            btnUpActive: true
		                        }, function () {
		                            _this6._invokeEventCallback.apply(_this6, ["onFocus"].concat(args));
		                            _this6.onMouseDown('up');
		                        });
		                    }
		                });
	
		                _extends(attrs.btnDown, {
		                    onTouchStart: this.onTouchStart.bind(this, 'down'),
		                    onTouchEnd: this.onTouchEnd,
		                    onMouseEnter: function onMouseEnter() {
		                        _this6.setState({
		                            btnDownHover: true
		                        });
		                    },
		                    onMouseLeave: function onMouseLeave() {
		                        _this6.stop();
		                        _this6.setState({
		                            btnDownHover: false,
		                            btnDownActive: false
		                        });
		                    },
		                    onMouseUp: function onMouseUp() {
		                        _this6.setState({
		                            btnDownHover: true,
		                            btnDownActive: false
		                        });
		                    },
		                    onMouseDown: function onMouseDown() {
		                        for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
		                            args[_key6] = arguments[_key6];
		                        }
	
		                        args[0].preventDefault();
		                        args[0].persist();
		                        _this6._inputFocus = true;
		                        _this6.setState({
		                            btnDownHover: true,
		                            btnDownActive: true
		                        }, function () {
		                            _this6._invokeEventCallback.apply(_this6, ["onFocus"].concat(args));
		                            _this6.onMouseDown('down');
		                        });
		                    }
		                });
	
		                _extends(attrs.input, {
		                    onChange: function onChange(e) {
		                        var original = e.target.value;
		                        var val = _this6._parse(original);
		                        if (isNaN(val)) {
		                            val = null;
		                        }
		                        _this6.setState({
		                            value: _this6._isStrict ? _this6._toNumber(val) : val,
		                            stringValue: original
		                        });
		                    },
		                    onKeyDown: this._onKeyDown.bind(this),
		                    onInput: function onInput() {
		                        for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
		                            args[_key7] = arguments[_key7];
		                        }
	
		                        _this6.saveSelection();
		                        _this6._invokeEventCallback.apply(_this6, ["onInput"].concat(args));
		                    },
		                    onSelect: function onSelect() {
		                        for (var _len8 = arguments.length, args = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
		                            args[_key8] = arguments[_key8];
		                        }
	
		                        _this6.saveSelection();
		                        _this6._invokeEventCallback.apply(_this6, ["onSelect"].concat(args));
		                    },
		                    onFocus: function onFocus() {
		                        for (var _len9 = arguments.length, args = Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
		                            args[_key9] = arguments[_key9];
		                        }
	
		                        args[0].persist();
		                        _this6._inputFocus = true;
		                        var val = _this6._parse(args[0].target.value);
		                        _this6.setState({
		                            value: val,
		                            stringValue: val || val === 0 ? val + "" : ""
		                        }, function () {
		                            _this6._invokeEventCallback.apply(_this6, ["onFocus"].concat(args));
		                        });
		                    },
		                    onBlur: function onBlur() {
		                        for (var _len10 = arguments.length, args = Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
		                            args[_key10] = arguments[_key10];
		                        }
	
		                        var _isStrict = _this6._isStrict;
		                        _this6._isStrict = true;
		                        args[0].persist();
		                        _this6._inputFocus = false;
		                        var val = _this6._parse(args[0].target.value);
		                        _this6.setState({
		                            value: val
		                        }, function () {
		                            _this6._invokeEventCallback.apply(_this6, ["onBlur"].concat(args));
		                            _this6._isStrict = _isStrict;
		                        });
		                    }
		                });
		            } else {
		                if (!noStyle && props.disabled) {
		                    _extends(attrs.input.style, css['input:disabled']);
		                }
		            }
	
		            var InputTag = componentClass || 'input';
	
		            if (mobile) {
		                return _react2.default.createElement(
		                    'span',
		                    attrs.wrap,
		                    _react2.default.createElement(InputTag, attrs.input),
		                    _react2.default.createElement(
		                        'b',
		                        attrs.btnUp,
		                        _react2.default.createElement('i', { style: noStyle ? null : css.minus }),
		                        _react2.default.createElement('i', { style: noStyle ? null : css.plus })
		                    ),
		                    _react2.default.createElement(
		                        'b',
		                        attrs.btnDown,
		                        _react2.default.createElement('i', { style: noStyle ? null : css.minus })
		                    )
		                );
		            }
	
		            return _react2.default.createElement(
		                'span',
		                attrs.wrap,
		                _react2.default.createElement(InputTag, attrs.input),
		                _react2.default.createElement(
		                    'b',
		                    attrs.btnUp,
		                    _react2.default.createElement('i', { style: noStyle ? null : css.arrowUp })
		                ),
		                _react2.default.createElement(
		                    'b',
		                    attrs.btnDown,
		                    _react2.default.createElement('i', { style: noStyle ? null : css.arrowDown })
		                )
		            );
		        }
		    }]);
	
		    return NumericInput;
		}(_react.Component);
	
		NumericInput.propTypes = {
		    step: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
		    min: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
		    max: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
		    precision: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
		    maxLength: _propTypes2.default.number,
		    parse: _propTypes2.default.func,
		    format: _propTypes2.default.func,
		    className: _propTypes2.default.string,
		    disabled: _propTypes2.default.bool,
		    readOnly: _propTypes2.default.bool,
		    required: _propTypes2.default.bool,
		    snap: _propTypes2.default.bool,
		    noValidate: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
		    style: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.bool]),
		    noStyle: _propTypes2.default.bool,
		    type: _propTypes2.default.string,
		    pattern: _propTypes2.default.string,
		    onFocus: _propTypes2.default.func,
		    onBlur: _propTypes2.default.func,
		    onKeyDown: _propTypes2.default.func,
		    onChange: _propTypes2.default.func,
		    onInvalid: _propTypes2.default.func,
		    onValid: _propTypes2.default.func,
		    onInput: _propTypes2.default.func,
		    onSelect: _propTypes2.default.func,
		    size: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
		    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
		    defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
		    strict: _propTypes2.default.bool,
		    componentClass: _propTypes2.default.string,
		    mobile: function mobile(props, propName) {
		        var prop = props[propName];
		        if (prop !== true && prop !== false && prop !== 'auto' && typeof prop != 'function') {
		            return new Error('The "mobile" prop must be true, false, "auto" or a function');
		        }
		    }
		};
		NumericInput.defaultProps = {
		    step: 1,
		    min: Number.MIN_SAFE_INTEGER || -9007199254740991,
		    max: Number.MAX_SAFE_INTEGER || 9007199254740991,
		    precision: null,
		    parse: null,
		    format: null,
		    mobile: 'auto',
		    strict: false,
		    componentClass: "input",
		    style: {}
		};
		NumericInput.style = {
		    wrap: {
		        position: 'relative',
		        display: 'inline-block'
		    },
	
		    'wrap.hasFormControl': {
		        display: 'block'
		    },
	
		    arrowUp: {
		        position: 'absolute',
		        top: '50%',
		        left: '50%',
		        width: 0,
		        height: 0,
		        borderWidth: '0 0.6ex 0.6ex 0.6ex',
		        borderColor: 'transparent transparent rgba(0, 0, 0, 0.7)',
		        borderStyle: 'solid',
		        margin: '-0.3ex 0 0 -0.56ex'
		    },
	
		    arrowDown: {
		        position: 'absolute',
		        top: '50%',
		        left: '50%',
		        width: 0,
		        height: 0,
		        borderWidth: '0.6ex 0.6ex 0 0.6ex',
		        borderColor: 'rgba(0, 0, 0, 0.7) transparent transparent',
		        borderStyle: 'solid',
		        margin: '-0.3ex 0 0 -0.56ex'
		    },
	
		    plus: {
		        position: 'absolute',
		        top: '50%',
		        left: '50%',
		        width: 2,
		        height: 10,
		        background: 'rgba(0,0,0,.7)',
		        margin: '-5px 0 0 -1px'
		    },
	
		    minus: {
		        position: 'absolute',
		        top: '50%',
		        left: '50%',
		        width: 10,
		        height: 2,
		        background: 'rgba(0,0,0,.7)',
		        margin: '-1px 0 0 -5px'
		    },
	
		    btn: {
		        position: 'absolute',
		        right: 2,
		        width: '2.26ex',
		        borderColor: 'rgba(0,0,0,.1)',
		        borderStyle: 'solid',
		        textAlign: 'center',
		        cursor: 'default',
		        transition: 'all 0.1s',
		        background: 'rgba(0,0,0,.1)',
		        boxShadow: '-1px -1px 3px rgba(0,0,0,.1) inset,' + '1px 1px 3px rgba(255,255,255,.7) inset'
		    },
	
		    btnUp: {
		        top: 2,
		        bottom: '50%',
		        borderRadius: '2px 2px 0 0',
		        borderWidth: '1px 1px 0 1px'
		    },
	
		    'btnUp.mobile': {
		        width: '3.3ex',
		        bottom: 2,
		        boxShadow: 'none',
		        borderRadius: 2,
		        borderWidth: 1
		    },
	
		    btnDown: {
		        top: '50%',
		        bottom: 2,
		        borderRadius: '0 0 2px 2px',
		        borderWidth: '0 1px 1px 1px'
		    },
	
		    'btnDown.mobile': {
		        width: '3.3ex',
		        bottom: 2,
		        left: 2,
		        top: 2,
		        right: 'auto',
		        boxShadow: 'none',
		        borderRadius: 2,
		        borderWidth: 1
		    },
	
		    'btn:hover': {
		        background: 'rgba(0,0,0,.2)'
		    },
	
		    'btn:active': {
		        background: 'rgba(0,0,0,.3)',
		        boxShadow: '0 1px 3px rgba(0,0,0,.2) inset,' + '-1px -1px 4px rgba(255,255,255,.5) inset'
		    },
	
		    'btn:disabled': {
		        opacity: 0.5,
		        boxShadow: 'none',
		        cursor: 'not-allowed'
		    },
	
		    input: {
		        paddingRight: '3ex',
		        boxSizing: 'border-box',
		        fontSize: 'inherit'
		    },
	
		    'input:not(.form-control)': {
		        border: '1px solid #ccc',
		        borderRadius: 2,
		        paddingLeft: 4,
		        display: 'block',
		        WebkitAppearance: 'none',
		        lineHeight: 'normal'
		    },
	
		    'input.mobile': {
		        paddingLeft: ' 3.4ex',
		        paddingRight: '3.4ex',
		        textAlign: 'center'
		    },
	
		    'input:focus': {},
	
		    'input:disabled': {
		        color: 'rgba(0, 0, 0, 0.3)',
		        textShadow: '0 1px 0 rgba(255, 255, 255, 0.8)'
		    }
		};
		NumericInput.SPEED = 50;
		NumericInput.DELAY = 500;
		NumericInput.DIRECTION_UP = "up";
		NumericInput.DIRECTION_DOWN = "down";
	
	
		module.exports = NumericInput;
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(1);
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(14);
	
	/***/ })
	/******/ ]);

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getContainer;
	
	var _reactDom = __webpack_require__(46);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainer(container, defaultContainer) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom2.default.findDOMNode(container) || defaultContainer;
	}
	module.exports = exports['default'];

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _PaginationBoxView = __webpack_require__(1481);
	
	var _PaginationBoxView2 = _interopRequireDefault(_PaginationBoxView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _PaginationBoxView2.default;
	//# sourceMappingURL=index.js.map

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(308);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validate(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
	  }
	
	  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(validate);

/***/ },
/* 625 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isRequiredForA11y;
	function isRequiredForA11y(validator) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}

/***/ },
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(205);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _stripDiacritics = __webpack_require__(643);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
		autoload: _propTypes2.default.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
		cache: _propTypes2.default.any, // object to use to cache results; set to null/false to disable caching
		children: _propTypes2.default.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
		ignoreAccents: _propTypes2.default.bool, // strip diacritics when filtering; defaults to true
		ignoreCase: _propTypes2.default.bool, // perform case-insensitive filtering; defaults to true
		loadOptions: _propTypes2.default.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
		loadingPlaceholder: _propTypes2.default.oneOfType([// replaces the placeholder while options are loading
		_propTypes2.default.string, _propTypes2.default.node]),
		multi: _propTypes2.default.bool, // multi-value input
		noResultsText: _propTypes2.default.oneOfType([// field noResultsText, displayed when no options come back from the server
		_propTypes2.default.string, _propTypes2.default.node]),
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onInputChange: _propTypes2.default.func, // optional for keeping track of what is being typed
		options: _propTypes2.default.array.isRequired, // array of options
		placeholder: _propTypes2.default.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
		_propTypes2.default.string, _propTypes2.default.node]),
		searchPromptText: _propTypes2.default.oneOfType([// label to prompt for search input
		_propTypes2.default.string, _propTypes2.default.node]),
		value: _propTypes2.default.any // initial field value
	};
	
	var defaultCache = {};
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	var defaultProps = {
		autoload: true,
		cache: defaultCache,
		children: defaultChildren,
		ignoreAccents: true,
		ignoreCase: true,
		loadingPlaceholder: 'Loading...',
		options: [],
		searchPromptText: 'Type to search'
	};
	
	var Async = function (_Component) {
		_inherits(Async, _Component);
	
		function Async(props, context) {
			_classCallCheck(this, Async);
	
			var _this = _possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));
	
			_this._cache = props.cache === defaultCache ? {} : props.cache;
	
			_this.state = {
				inputValue: '',
				isLoading: false,
				options: props.options
			};
	
			_this.onInputChange = _this.onInputChange.bind(_this);
			return _this;
		}
	
		_createClass(Async, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var autoload = this.props.autoload;
	
	
				if (autoload) {
					this.loadOptions('');
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.options !== this.props.options) {
					this.setState({
						options: nextProps.options
					});
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this._callback = null;
			}
		}, {
			key: 'loadOptions',
			value: function loadOptions(inputValue) {
				var _this2 = this;
	
				var loadOptions = this.props.loadOptions;
	
				var cache = this._cache;
	
				if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
					this._callback = null;
	
					this.setState({
						isLoading: false,
						options: cache[inputValue]
					});
	
					return;
				}
	
				var callback = function callback(error, data) {
					var options = data && data.options || [];
	
					if (cache) {
						cache[inputValue] = options;
					}
	
					if (callback === _this2._callback) {
						_this2._callback = null;
	
						_this2.setState({
							isLoading: false,
							options: options
						});
					}
				};
	
				// Ignore all but the most recent request
				this._callback = callback;
	
				var promise = loadOptions(inputValue, callback);
				if (promise) {
					promise.then(function (data) {
						return callback(null, data);
					}, function (error) {
						return callback(error);
					});
				}
	
				if (this._callback && !this.state.isLoading) {
					this.setState({
						isLoading: true
					});
				}
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(inputValue) {
				var _props = this.props,
				    ignoreAccents = _props.ignoreAccents,
				    ignoreCase = _props.ignoreCase,
				    onInputChange = _props.onInputChange;
	
				var newInputValue = inputValue;
	
				if (onInputChange) {
					var value = onInputChange(newInputValue);
					// Note: != used deliberately here to catch undefined and null
					if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
						newInputValue = '' + value;
					}
				}
	
				var transformedInputValue = newInputValue;
	
				if (ignoreAccents) {
					transformedInputValue = (0, _stripDiacritics2.default)(transformedInputValue);
				}
	
				if (ignoreCase) {
					transformedInputValue = transformedInputValue.toLowerCase();
				}
	
				this.setState({ inputValue: newInputValue });
				this.loadOptions(transformedInputValue);
	
				// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
				return newInputValue;
			}
		}, {
			key: 'noResultsText',
			value: function noResultsText() {
				var _props2 = this.props,
				    loadingPlaceholder = _props2.loadingPlaceholder,
				    noResultsText = _props2.noResultsText,
				    searchPromptText = _props2.searchPromptText;
				var _state = this.state,
				    inputValue = _state.inputValue,
				    isLoading = _state.isLoading;
	
	
				if (isLoading) {
					return loadingPlaceholder;
				}
				if (inputValue && noResultsText) {
					return noResultsText;
				}
				return searchPromptText;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var _props3 = this.props,
				    children = _props3.children,
				    loadingPlaceholder = _props3.loadingPlaceholder,
				    placeholder = _props3.placeholder;
				var _state2 = this.state,
				    isLoading = _state2.isLoading,
				    options = _state2.options;
	
	
				var props = {
					noResultsText: this.noResultsText(),
					placeholder: isLoading ? loadingPlaceholder : placeholder,
					options: isLoading && loadingPlaceholder ? [] : options,
					ref: function ref(_ref) {
						return _this3.select = _ref;
					}
				};
	
				return children(_extends({}, this.props, props, {
					isLoading: isLoading,
					onInputChange: this.onInputChange
				}));
			}
		}]);
	
		return Async;
	}(_react.Component);
	
	exports.default = Async;
	
	
	Async.propTypes = propTypes;
	Async.defaultProps = defaultProps;

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _defaultFilterOptions = __webpack_require__(312);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(313);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Select = __webpack_require__(205);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreatableSelect = function (_React$Component) {
		_inherits(CreatableSelect, _React$Component);
	
		function CreatableSelect(props, context) {
			_classCallCheck(this, CreatableSelect);
	
			var _this = _possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));
	
			_this.filterOptions = _this.filterOptions.bind(_this);
			_this.menuRenderer = _this.menuRenderer.bind(_this);
			_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
			_this.onInputChange = _this.onInputChange.bind(_this);
			_this.onOptionSelect = _this.onOptionSelect.bind(_this);
			return _this;
		}
	
		_createClass(CreatableSelect, [{
			key: 'createNewOption',
			value: function createNewOption() {
				var _props = this.props,
				    isValidNewOption = _props.isValidNewOption,
				    newOptionCreator = _props.newOptionCreator,
				    onNewOptionClick = _props.onNewOptionClick,
				    _props$options = _props.options,
				    options = _props$options === undefined ? [] : _props$options;
	
	
				if (isValidNewOption({ label: this.inputValue })) {
					var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
					var _isOptionUnique = this.isOptionUnique({ option: option, options: options });
	
					// Don't add the same option twice.
					if (_isOptionUnique) {
						if (onNewOptionClick) {
							onNewOptionClick(option);
						} else {
							options.unshift(option);
	
							this.select.selectValue(option);
						}
					}
				}
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions() {
				var _props2 = this.props,
				    filterOptions = _props2.filterOptions,
				    isValidNewOption = _props2.isValidNewOption,
				    promptTextCreator = _props2.promptTextCreator;
	
				// TRICKY Check currently selected options as well.
				// Don't display a create-prompt for a value that's selected.
				// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
	
				var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];
	
				var filteredOptions = filterOptions.apply(undefined, arguments) || [];
	
				if (isValidNewOption({ label: this.inputValue })) {
					var _newOptionCreator = this.props.newOptionCreator;
	
	
					var option = _newOptionCreator({
						label: this.inputValue,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});
	
					// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
					// For multi-selects, this would remove it from the filtered list.
					var _isOptionUnique2 = this.isOptionUnique({
						option: option,
						options: excludeOptions.concat(filteredOptions)
					});
	
					if (_isOptionUnique2) {
						var prompt = promptTextCreator(this.inputValue);
	
						this._createPlaceholderOption = _newOptionCreator({
							label: prompt,
							labelKey: this.labelKey,
							valueKey: this.valueKey
						});
	
						filteredOptions.unshift(this._createPlaceholderOption);
					}
				}
	
				return filteredOptions;
			}
		}, {
			key: 'isOptionUnique',
			value: function isOptionUnique(_ref) {
				var option = _ref.option,
				    options = _ref.options;
				var isOptionUnique = this.props.isOptionUnique;
	
	
				options = options || this.props.options;
	
				return isOptionUnique({
					labelKey: this.labelKey,
					option: option,
					options: options,
					valueKey: this.valueKey
				});
			}
		}, {
			key: 'menuRenderer',
			value: function menuRenderer(params) {
				var menuRenderer = this.props.menuRenderer;
	
	
				return menuRenderer(_extends({}, params, {
					onSelect: this.onOptionSelect,
					selectValue: this.onOptionSelect
				}));
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(input) {
				var onInputChange = this.props.onInputChange;
	
				// This value may be needed in between Select mounts (when this.select is null)
	
				this.inputValue = input;
	
				if (onInputChange) {
					this.inputValue = onInputChange(input);
				}
	
				return this.inputValue;
			}
		}, {
			key: 'onInputKeyDown',
			value: function onInputKeyDown(event) {
				var _props3 = this.props,
				    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
				    onInputKeyDown = _props3.onInputKeyDown;
	
				var focusedOption = this.select.getFocusedOption();
	
				if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption({ keyCode: event.keyCode })) {
					this.createNewOption();
	
					// Prevent decorated Select from doing anything additional with this keyDown event
					event.preventDefault();
				} else if (onInputKeyDown) {
					onInputKeyDown(event);
				}
			}
		}, {
			key: 'onOptionSelect',
			value: function onOptionSelect(option) {
				if (option === this._createPlaceholderOption) {
					this.createNewOption();
				} else {
					this.select.selectValue(option);
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props4 = this.props,
				    refProp = _props4.ref,
				    restProps = _objectWithoutProperties(_props4, ['ref']);
	
				var children = this.props.children;
	
				// We can't use destructuring default values to set the children,
				// because it won't apply work if `children` is null. A falsy check is
				// more reliable in real world use-cases.
	
				if (!children) {
					children = defaultChildren;
				}
	
				var props = _extends({}, restProps, {
					allowCreate: true,
					filterOptions: this.filterOptions,
					menuRenderer: this.menuRenderer,
					onInputChange: this.onInputChange,
					onInputKeyDown: this.onInputKeyDown,
					ref: function ref(_ref2) {
						_this2.select = _ref2;
	
						// These values may be needed in between Select mounts (when this.select is null)
						if (_ref2) {
							_this2.labelKey = _ref2.props.labelKey;
							_this2.valueKey = _ref2.props.valueKey;
						}
						if (refProp) {
							refProp(_ref2);
						}
					}
				});
	
				return children(props);
			}
		}]);
	
		return CreatableSelect;
	}(_react2.default.Component);
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	var isOptionUnique = function isOptionUnique(_ref3) {
		var option = _ref3.option,
		    options = _ref3.options,
		    labelKey = _ref3.labelKey,
		    valueKey = _ref3.valueKey;
	
		if (!options || !options.length) {
			return true;
		}
	
		return options.filter(function (existingOption) {
			return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
		}).length === 0;
	};
	
	var isValidNewOption = function isValidNewOption(_ref4) {
		var label = _ref4.label;
		return !!label;
	};
	
	var newOptionCreator = function newOptionCreator(_ref5) {
		var label = _ref5.label,
		    labelKey = _ref5.labelKey,
		    valueKey = _ref5.valueKey;
	
		var option = {};
		option[valueKey] = label;
		option[labelKey] = label;
		option.className = 'Select-create-option-placeholder';
	
		return option;
	};
	
	var promptTextCreator = function promptTextCreator(label) {
		return 'Create option "' + label + '"';
	};
	
	var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
		var keyCode = _ref6.keyCode;
	
		switch (keyCode) {
			case 9: // TAB
			case 13: // ENTER
			case 188:
				// COMMA
				return true;
			default:
				return false;
		}
	};
	
	// Default prop methods
	CreatableSelect.isOptionUnique = isOptionUnique;
	CreatableSelect.isValidNewOption = isValidNewOption;
	CreatableSelect.newOptionCreator = newOptionCreator;
	CreatableSelect.promptTextCreator = promptTextCreator;
	CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;
	
	CreatableSelect.defaultProps = {
		filterOptions: _defaultFilterOptions2.default,
		isOptionUnique: isOptionUnique,
		isValidNewOption: isValidNewOption,
		menuRenderer: _defaultMenuRenderer2.default,
		newOptionCreator: newOptionCreator,
		promptTextCreator: promptTextCreator,
		shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
	};
	
	CreatableSelect.propTypes = {
		// Child function responsible for creating the inner Select component
		// This component can be used to compose HOCs (eg Creatable and Async)
		// (props: Object): PropTypes.element
		children: _propTypes2.default.func,
	
		// See Select.propTypes.filterOptions
		filterOptions: _propTypes2.default.any,
	
		// Searches for any matching option within the set of options.
		// This function prevents duplicate options from being created.
		// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
		isOptionUnique: _propTypes2.default.func,
	
		// Determines if the current input text represents a valid option.
		// ({ label: string }): boolean
		isValidNewOption: _propTypes2.default.func,
	
		// See Select.propTypes.menuRenderer
		menuRenderer: _propTypes2.default.any,
	
		// Factory to create new option.
		// ({ label: string, labelKey: string, valueKey: string }): Object
		newOptionCreator: _propTypes2.default.func,
	
		// input change handler: function (inputValue) {}
		onInputChange: _propTypes2.default.func,
	
		// input keyDown handler: function (event) {}
		onInputKeyDown: _propTypes2.default.func,
	
		// new option click handler: function (option) {}
		onNewOptionClick: _propTypes2.default.func,
	
		// See Select.propTypes.options
		options: _propTypes2.default.array,
	
		// Creates prompt/placeholder option text.
		// (filterText: string): string
		promptTextCreator: _propTypes2.default.func,
	
		ref: _propTypes2.default.func,
	
		// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
		shouldKeyDownEventCreateNewOption: _propTypes2.default.func
	};
	
	exports.default = CreatableSelect;

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(37);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _blockEvent = __webpack_require__(1513);
	
	var _blockEvent2 = _interopRequireDefault(_blockEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = function (_React$Component) {
		_inherits(Option, _React$Component);
	
		function Option(props) {
			_classCallCheck(this, Option);
	
			var _this = _possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
			_this.handleMouseMove = _this.handleMouseMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.onFocus = _this.onFocus.bind(_this);
			return _this;
		}
	
		_createClass(Option, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onSelect(this.props.option, event);
			}
		}, {
			key: 'handleMouseEnter',
			value: function handleMouseEnter(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleMouseMove',
			value: function handleMouseMove(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'onFocus',
			value: function onFocus(event) {
				if (!this.props.isFocused) {
					this.props.onFocus(this.props.option, event);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    option = _props.option,
				    instancePrefix = _props.instancePrefix,
				    optionIndex = _props.optionIndex;
	
				var className = (0, _classnames2.default)(this.props.className, option.className);
	
				return option.disabled ? _react2.default.createElement(
					'div',
					{ className: className,
						onMouseDown: _blockEvent2.default,
						onClick: _blockEvent2.default },
					this.props.children
				) : _react2.default.createElement(
					'div',
					{ className: className,
						style: option.style,
						role: 'option',
						'aria-label': option.label,
						onMouseDown: this.handleMouseDown,
						onMouseEnter: this.handleMouseEnter,
						onMouseMove: this.handleMouseMove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove,
						onTouchEnd: this.handleTouchEnd,
						id: instancePrefix + '-option-' + optionIndex,
						title: option.title },
					this.props.children
				);
			}
		}]);
	
		return Option;
	}(_react2.default.Component);
	
	Option.propTypes = {
		children: _propTypes2.default.node,
		className: _propTypes2.default.string, // className (based on mouse position)
		instancePrefix: _propTypes2.default.string.isRequired, // unique prefix for the ids (used for aria)
		isDisabled: _propTypes2.default.bool, // the option is disabled
		isFocused: _propTypes2.default.bool, // the option is focused
		isSelected: _propTypes2.default.bool, // the option is selected
		onFocus: _propTypes2.default.func, // method to handle mouseEnter on option element
		onSelect: _propTypes2.default.func, // method to handle click on option element
		onUnfocus: _propTypes2.default.func, // method to handle mouseLeave on option element
		option: _propTypes2.default.object.isRequired, // object that is base for that option
		optionIndex: _propTypes2.default.number // index of the option, used to generate unique ids for aria
	};
	
	exports.default = Option;

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(37);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Value = function (_React$Component) {
		_inherits(Value, _React$Component);
	
		function Value(props) {
			_classCallCheck(this, Value);
	
			var _this = _possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.onRemove = _this.onRemove.bind(_this);
			_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			return _this;
		}
	
		_createClass(Value, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				if (event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				if (this.props.onClick) {
					event.stopPropagation();
					this.props.onClick(this.props.value, event);
					return;
				}
				if (this.props.value.href) {
					event.stopPropagation();
				}
			}
		}, {
			key: 'onRemove',
			value: function onRemove(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onRemove(this.props.value);
			}
		}, {
			key: 'handleTouchEndRemove',
			value: function handleTouchEndRemove(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.onRemove(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'renderRemoveIcon',
			value: function renderRemoveIcon() {
				if (this.props.disabled || !this.props.onRemove) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-value-icon',
						'aria-hidden': 'true',
						onMouseDown: this.onRemove,
						onTouchEnd: this.handleTouchEndRemove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove },
					'\xD7'
				);
			}
		}, {
			key: 'renderLabel',
			value: function renderLabel() {
				var className = 'Select-value-label';
				return this.props.onClick || this.props.value.href ? _react2.default.createElement(
					'a',
					{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
					this.props.children
				) : _react2.default.createElement(
					'span',
					{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
					this.props.children
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)('Select-value', this.props.value.className),
						style: this.props.value.style,
						title: this.props.value.title
					},
					this.renderRemoveIcon(),
					this.renderLabel()
				);
			}
		}]);
	
		return Value;
	}(_react2.default.Component);
	
	Value.propTypes = {
		children: _propTypes2.default.node,
		disabled: _propTypes2.default.bool, // disabled prop passed to ReactSelect
		id: _propTypes2.default.string, // Unique id for the value - used for aria
		onClick: _propTypes2.default.func, // method to handle click on value label
		onRemove: _propTypes2.default.func, // method to handle removal of the value
		value: _propTypes2.default.object.isRequired // the option object for this value
	};
	
	exports.default = Value;

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var arrowRenderer = function arrowRenderer(_ref) {
		var onMouseDown = _ref.onMouseDown;
	
		return _react2.default.createElement('span', {
			className: 'Select-arrow',
			onMouseDown: onMouseDown
		});
	};
	
	arrowRenderer.propTypes = {
		onMouseDown: _propTypes2.default.func
	};
	
	exports.default = arrowRenderer;

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clearRenderer = function clearRenderer() {
		return _react2.default.createElement('span', {
			className: 'Select-clear',
			dangerouslySetInnerHTML: { __html: '&times;' }
		});
	};
	
	exports.default = clearRenderer;

/***/ },
/* 643 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];
	
	var stripDiacritics = function stripDiacritics(str) {
		for (var i = 0; i < map.length; i++) {
			str = str.replace(map[i].letters, map[i].base);
		}
		return str;
	};
	
	exports.default = stripDiacritics;

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(129);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _classnames = __webpack_require__(37);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Tab = __webpack_require__(206);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function renderChildren(props) {
	  return _react2.default.Children.map(props.children, function (child) {
	    // if child is not a tab we don't need to clone it
	    // since we don't need to add custom props
	
	    if (child.type !== _Tab2.default) {
	      return child;
	    }
	
	    var clonedProps = {
	      activeTabClassName: props.activeTabClassName,
	      disabledTabClassName: props.disabledTabClassName
	    };
	
	    return _react2.default.cloneElement(child, clonedProps);
	  });
	}
	
	module.exports = (0, _createReactClass2.default)({
	  displayName: 'TabList',
	
	  propTypes: {
	    className: _propTypes2.default.string,
	    activeTabClassName: _propTypes2.default.string,
	    disabledTabClassName: _propTypes2.default.string,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array])
	  },
	
	  render: function render() {
	    var _props = this.props,
	        className = _props.className,
	        activeTabClassName = _props.activeTabClassName,
	        disabledTabClassName = _props.disabledTabClassName,
	        children = _props.children,
	        attributes = _objectWithoutProperties(_props, ['className', 'activeTabClassName', 'disabledTabClassName', 'children']);
	
	    return _react2.default.createElement(
	      'ul',
	      _extends({}, attributes, {
	        className: (0, _classnames2.default)('ReactTabs__TabList', className),
	        role: 'tablist'
	      }),
	      renderChildren({ activeTabClassName: activeTabClassName, disabledTabClassName: disabledTabClassName, children: children })
	    );
	  }
	});

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TabPanel = exports.Tab = exports.TabList = exports.Tabs = undefined;
	
	var _Tabs = __webpack_require__(1516);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _TabList = __webpack_require__(644);
	
	var _TabList2 = _interopRequireDefault(_TabList);
	
	var _Tab = __webpack_require__(206);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _TabPanel = __webpack_require__(1515);
	
	var _TabPanel2 = _interopRequireDefault(_TabPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Tabs = _Tabs2.default;
	exports.TabList = _TabList2.default;
	exports.Tab = _Tab2.default;
	exports.TabPanel = _TabPanel2.default;
	
	// For bc we also export a default object, remove in 1.0
	
	exports.default = {
	  Tabs: _Tabs2.default,
	  TabList: _TabList2.default,
	  Tab: _Tab2.default,
	  TabPanel: _TabPanel2.default
	};

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(141);
	
	var ReactCurrentOwner = __webpack_require__(88);
	
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(21);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty)
	  // Strip regex characters so we can use it for regex
	  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  // Remove hasOwnProperty from the template to make it generic
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createUncontrollable = __webpack_require__(1547);
	
	var _createUncontrollable2 = _interopRequireDefault(_createUncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mixin = {
	  shouldComponentUpdate: function shouldComponentUpdate() {
	    //let the forceUpdate trigger the update
	    return !this._notifying;
	  }
	};
	
	function set(component, propName, handler, value, args) {
	  if (handler) {
	    component._notifying = true;
	    handler.call.apply(handler, [component, value].concat(args));
	    component._notifying = false;
	  }
	
	  component._values[propName] = value;
	
	  if (!component.unmounted) component.forceUpdate();
	}
	
	exports.default = (0, _createUncontrollable2.default)(mixin, set);
	module.exports = exports['default'];

/***/ },
/* 655 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 656 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI4LjUgNjBDMjAuODg2IDYwIDEzLjczMSA1Ny4wMzYgOC4zNDYgNTEuNjU0QzIuOTYxIDQ2LjI3MiAwIDM5LjExNCAwIDMxLjUwM0MwIDIzLjg4OSAyLjk2NCAxNi43MzQgOC4zNDYgMTEuMzQ5QzEzLjcyOCA1Ljk2NCAyMC44ODYgMyAyOC41IDNDMzYuMTE0IDMgNDMuMjY5IDUuOTY0IDQ4LjY1NCAxMS4zNDlDNTQuMDM5IDE2LjczNCA1NyAyMy44ODkgNTcgMzEuNTAzQzU3IDM5LjExNyA1NC4wMzYgNDYuMjcyIDQ4LjY1NCA1MS42NTRDNDMuMjcyIDU3LjAzNiAzNi4xMTQgNjAgMjguNSA2MFpNMjguNSA2QzE0LjQzOSA2IDMgMTcuNDM5IDMgMzEuNUMzIDQ1LjU2MSAxNC40MzkgNTcgMjguNSA1N0M0Mi41NjEgNTcgNTQgNDUuNTYxIDU0IDMxLjVDNTQgMTcuNDM5IDQyLjU2MSA2IDI4LjUgNloiIGZpbGw9IiMwNDU2N0QiLz4KPGxpbmUgeDE9IjI4LjUiIHkxPSIxNS41IiB4Mj0iMjguNSIgeTI9IjM1LjUiIHN0cm9rZT0iIzA0NTY3RCIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPGxpbmUgeDE9IjI4LjUiIHkxPSI0My41IiB4Mj0iMjguNSIgeTI9IjQ2LjUiIHN0cm9rZT0iIzA0NTY3RCIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg=="

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "src/images/logos/logo-blue.svg";

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "src/images/logos/logo-white.svg";

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "src/images/logos/swish_horizontal.svg";

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"NODE_ENV":"production","DEV_LOGIN_EMAIL":"","DEV_LOGIN_PASSWORD":""}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(1577);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(1576);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(132)))

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(56);
	var bind = __webpack_require__(323);
	var Axios = __webpack_require__(663);
	var defaults = __webpack_require__(209);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(320);
	axios.CancelToken = __webpack_require__(662);
	axios.isCancel = __webpack_require__(321);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(677);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(320);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(209);
	var utils = __webpack_require__(56);
	var InterceptorManager = __webpack_require__(664);
	var dispatchRequest = __webpack_require__(665);
	var isAbsoluteURL = __webpack_require__(673);
	var combineURLs = __webpack_require__(671);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(56);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(56);
	var transformData = __webpack_require__(668);
	var isCancel = __webpack_require__(321);
	var defaults = __webpack_require__(209);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ },
/* 666 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.response = response;
	  return error;
	};


/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(322);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response
	    ));
	  }
	};


/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(56);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ },
/* 669 */
/***/ function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(56);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ },
/* 671 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
	};


/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(56);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ },
/* 673 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(56);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(56);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(56);
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  });
	
	  return parsed;
	};


/***/ },
/* 677 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _reactModal = __webpack_require__(30);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _reactRedux = __webpack_require__(12);
	
	var _components = __webpack_require__(13);
	
	var _index = __webpack_require__(355);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'OPEN_BANK_ID_COMPUTER_APP' });
	
	var _ref2 = _react2.default.createElement(
	  'p',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'OPEN_BANK_ID_APP' })
	);
	
	var _ref3 = _react2.default.createElement(_components.Spinner, null);
	
	var _ref4 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CANCEL' });
	
	var BankId = function (_React$Component) {
	  (0, _inherits3.default)(BankId, _React$Component);
	
	  function BankId() {
	    (0, _classCallCheck3.default)(this, BankId);
	    return (0, _possibleConstructorReturn3.default)(this, (BankId.__proto__ || (0, _getPrototypeOf2.default)(BankId)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(BankId, [{
	    key: 'renderOpenComputerAppButton',
	    value: function renderOpenComputerAppButton() {
	      if (this.props.entity && this.props.entity.autostart !== null) {
	        return _react2.default.createElement(
	          'a',
	          { className: 'btn', href: this.props.entity.autostart },
	          _ref
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactModal2.default,
	        {
	          className: 'modal',
	          contentLabel: '',
	          isOpen: this.props.inProgress,
	          onRequestClose: this.props.cancel },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-content bank-id-modal' },
	          _react2.default.createElement('button', { className: 'close', onClick: this.props.cancel }),
	          _ref2,
	          _ref3,
	          _react2.default.createElement(
	            'div',
	            { className: 'btn-wrapper' },
	            _react2.default.createElement(
	              'button',
	              { className: 'btn outlined white', onClick: this.props.cancel },
	              _ref4
	            ),
	            '\xA0',
	            this.renderOpenComputerAppButton()
	          )
	        )
	      );
	    }
	  }]);
	  return BankId;
	}(_react2.default.Component);
	
	function mapStateToProps(state) {
	  return {
	    socialSecurityNr: state.bankId.socialSecurityNr,
	    inProgress: state.bankId.inProgress,
	    entity: state.bankId.entity
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    cancel: function cancel() {
	      return dispatch((0, _index.cancel)());
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BankId);

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Error = undefined;
	
	var _getIterator2 = __webpack_require__(18);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _reactRedux = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Error = exports.Error = function (_Component) {
	  (0, _inherits3.default)(Error, _Component);
	
	  function Error() {
	    (0, _classCallCheck3.default)(this, Error);
	    return (0, _possibleConstructorReturn3.default)(this, (Error.__proto__ || (0, _getPrototypeOf2.default)(Error)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Error, [{
	    key: 'render',
	    value: function render() {
	      if (this.props.error !== null) {
	        var keyError = null;
	
	        if (this.props.error.key) {
	          keyError = _react2.default.createElement(
	            'p',
	            { className: 'error' },
	            _react2.default.createElement(_reactTranslateComponent2.default, { content: this.props.error.key })
	          );
	        }
	
	        var errorMessages = [];
	
	        if (this.props.error.messages) {
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = (0, _getIterator3.default)(this.props.error.messages), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var msg = _step.value;
	
	              errorMessages.push(_react2.default.createElement(
	                'p',
	                { className: 'error' },
	                msg
	              ));
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	        }
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          keyError,
	          errorMessages
	        );
	      }
	
	      return null;
	    }
	  }]);
	  return Error;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    error: state.bankId.error
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Error);

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GetBankId = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'a',
	  { href: 'http://support.bankid.com/mobil', className: 'get-bank-id', target: '_blank' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'GET_BANKKID' })
	);
	
	var GetBankId = exports.GetBankId = function (_React$Component) {
	  (0, _inherits3.default)(GetBankId, _React$Component);
	
	  function GetBankId() {
	    (0, _classCallCheck3.default)(this, GetBankId);
	    return (0, _possibleConstructorReturn3.default)(this, (GetBankId.__proto__ || (0, _getPrototypeOf2.default)(GetBankId)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(GetBankId, [{
	    key: 'render',
	    value: function render() {
	      return _ref;
	    }
	  }]);
	  return GetBankId;
	}(_react2.default.Component);
	
	exports.default = GetBankId;

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GetBankId = exports.BankIdError = exports.EmailCapture = exports.BankId = undefined;
	
	var _bankId = __webpack_require__(678);
	
	var _bankId2 = _interopRequireDefault(_bankId);
	
	var _emailCapture = __webpack_require__(324);
	
	var _emailCapture2 = _interopRequireDefault(_emailCapture);
	
	var _error = __webpack_require__(679);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _getBankId = __webpack_require__(680);
	
	var _getBankId2 = _interopRequireDefault(_getBankId);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BankId = _bankId2.default;
	exports.EmailCapture = _emailCapture2.default;
	exports.BankIdError = _error2.default;
	exports.GetBankId = _getBankId2.default;

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BetaBanner = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _bullhorn = __webpack_require__(728);
	
	var _bullhorn2 = _interopRequireDefault(_bullhorn);
	
	var _featureFlagsService = __webpack_require__(768);
	
	var _featureFlagsService2 = _interopRequireDefault(_featureFlagsService);
	
	var _authentication = __webpack_require__(64);
	
	var _variables = __webpack_require__(47);
	
	var variables = _interopRequireWildcard(_variables);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'beta-banner-icon-container' },
	  _react2.default.createElement(
	    'div',
	    { className: 'beta-banner-icon' },
	    _react2.default.createElement(_bullhorn2.default, {
	      width: '20',
	      height: '20'
	    })
	  )
	);
	
	var _ref2 = _react2.default.createElement(
	  'div',
	  { className: 'beta-banner-text' },
	  _react2.default.createElement(
	    'div',
	    { className: 'beta-banner-inner-text' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { className: 'beta-banner-text-title', content: 'BETA_BANNER_TEXT_TITLE' }),
	    _react2.default.createElement(_reactTranslateComponent2.default, { className: 'beta-banner-text-subtitle', content: 'BETA_BANNER_TEXT_SUBTITLE' })
	  )
	);
	
	var _ref3 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'BETA_BANNER_BUTTON' });
	
	var BetaBanner = exports.BetaBanner = function (_React$Component) {
	  (0, _inherits3.default)(BetaBanner, _React$Component);
	
	  function BetaBanner() {
	    (0, _classCallCheck3.default)(this, BetaBanner);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (BetaBanner.__proto__ || (0, _getPrototypeOf2.default)(BetaBanner)).call(this));
	
	    _this.state = {
	      showBetaBanner: false
	    };
	
	    _this.openBeta = _this.openBeta.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(BetaBanner, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      try {
	        // check if active
	        _featureFlagsService2.default.getStoryblokFeatureFlags().then(function (features) {
	          var betaBannerFeature = features.find(function (feature) {
	            return feature.name === 'account-web-try-beta-banner';
	          });
	
	          if (betaBannerFeature && +betaBannerFeature.value === 1) {
	            _this2.setState({
	              showBetaBanner: true
	            });
	          }
	        });
	      } catch (_) {}
	    }
	  }, {
	    key: 'getBetaUrl',
	    value: function getBetaUrl() {
	      if (variables.appEnv === 'staging') {
	        return 'https://flutter-web.staging.ffdev.se';
	      }
	      if (variables.appEnv === 'demo' || variables.appEnv === 'testdrive') {
	        return 'https://flutter-web.sandbox.ffdev.se';
	      }
	
	      return 'https://konto-beta.frilansfinans.se';
	    }
	  }, {
	    key: 'openBeta',
	    value: function openBeta() {
	      var token = _authentication.authenticationService.oauthToken.accessToken ? _authentication.authenticationService.oauthToken.accessToken : '';
	      var betaDomain = this.getBetaUrl();
	      window.open(betaDomain + '/token-login?access_token=' + token, '_ff_beta');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return !this.state.showBetaBanner ? null : _react2.default.createElement(
	        'div',
	        { className: 'beta-banner-wrapper' },
	        _ref,
	        _ref2,
	        _react2.default.createElement(
	          'div',
	          { className: 'beta-banner-button' },
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'btn',
	              onClick: this.openBeta,
	              id: 'button-open-beta'
	            },
	            _ref3
	          )
	        )
	      );
	    }
	  }]);
	  return BetaBanner;
	}(_react2.default.Component);
	
	exports.default = BetaBanner;

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(27);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(30);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfirmModal = function (_React$Component) {
	  (0, _inherits3.default)(ConfirmModal, _React$Component);
	
	  function ConfirmModal(props) {
	    (0, _classCallCheck3.default)(this, ConfirmModal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ConfirmModal.__proto__ || (0, _getPrototypeOf2.default)(ConfirmModal)).call(this, props));
	
	    _this.componentWillMount = function () {
	      _this.disableScroll();
	    };
	
	    _this.componentWillUnmount = function () {
	      _this.enableScroll();
	    };
	
	    _this.preventDefault = function (e) {
	      e = e || window.event;
	      if (e.preventDefault) {
	        e.preventDefault();
	      }
	      e.returnValue = false;
	    };
	
	    _this.disableScroll = function () {
	      window.onwheel = _this.preventDefault; // modern standard
	      window.onmousewheel = document.onmousewheel = _this.preventDefault; // older browsers, IE
	      window.ontouchmove = _this.preventDefault; // mobile
	    };
	
	    _this.enableScroll = function () {
	      window.onmousewheel = document.onmousewheel = null;
	      window.onwheel = null;
	      window.ontouchmove = null;
	      document.onkeydown = null;
	    };
	
	    _this.confirm = function () {
	      _this.props.callback(true);
	    };
	
	    _this.reject = function () {
	      _this.props.callback(false);
	    };
	
	    _this.renderButtons = function () {
	      var buttons = [_react2.default.createElement(
	        'button',
	        (0, _extends3.default)({ key: 'reject', onClick: _this.reject }, _this.state.rejectButtonProps),
	        _this.state.rejectButtonText
	      ), _react2.default.createElement(
	        'button',
	        (0, _extends3.default)({ key: 'confirm', onClick: _this.confirm }, _this.state.confirmButtonProps),
	        _this.state.confirmButtonText
	      )];
	
	      if (_this.state.reversedButtonOrder) {
	        buttons.reverse();
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'btn-wrapper' },
	        buttons
	      );
	    };
	
	    _this.render = function () {
	      return _react2.default.createElement(
	        _reactModal2.default,
	        {
	          className: 'modal',
	          contentLabel: '',
	          isOpen: _this.state.open,
	          onRequestClose: _this.reject },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-content confirm-modal' },
	          _react2.default.createElement('button', { className: 'close', onClick: _this.reject }),
	          _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: _this.props.message } }),
	          _this.renderButtons()
	        )
	      );
	    };
	
	    _this.state = {
	      open: true,
	      confirmButtonProps: props.confirmButtonProps || { className: 'btn px-30' },
	      rejectButtonProps: props.rejectButtonProps || { className: 'btn px-30 outlined blue' },
	      confirmButtonText: props.confirmButtonText || (0, _proxyCounterpart.proxyCounterpart)('YES'),
	      rejectButtonText: props.rejectButtonText || (0, _proxyCounterpart.proxyCounterpart)('NO'),
	      reversedButtonOrder: props.reversedButtonOrder || false
	    };
	    return _this;
	  }
	
	  return ConfirmModal;
	}(_react2.default.Component);
	
	exports.default = ConfirmModal;

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CountryPicker = undefined;
	
	var _getIterator2 = __webpack_require__(18);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _generalError = __webpack_require__(63);
	
	var _generalError2 = _interopRequireDefault(_generalError);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_generalError2.default, null); /**
	                                                                         * Created by staffanrantzow on 12/10/16.
	                                                                         */
	
	var _ref2 = _react2.default.createElement(
	  'label',
	  { htmlFor: 'country-picker' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'COUNTRY' })
	);
	
	var CountryPicker = exports.CountryPicker = function (_React$Component) {
	  (0, _inherits3.default)(CountryPicker, _React$Component);
	
	  function CountryPicker(props) {
	    (0, _classCallCheck3.default)(this, CountryPicker);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (CountryPicker.__proto__ || (0, _getPrototypeOf2.default)(CountryPicker)).call(this, props));
	
	    _this.state = {
	      countries: _this.getInitialOptions(props.countryName),
	      selectValue: _this.props.countryName || _this.props.defaultValue,
	      fetchError: false,
	      pendingRequest: null
	    };
	
	    _this.setCountry = _this.setCountry.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(CountryPicker, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.fetchCountries();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.setCountry(this.state.selectValue);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.pendingRequest && this.state.pendingRequest.cancel) {
	        this.state.pendingRequest.cancel();
	      }
	    }
	  }, {
	    key: 'getInitialOptions',
	    value: function getInitialOptions(countryName) {
	      var c = [{
	        name: (0, _proxyCounterpart.proxyCounterpart)('PICK_COUNTRY'),
	        value: 'default',
	        disabled: true
	      }];
	
	      if (countryName) {
	        c.push({
	          disabled: false,
	          name: countryName,
	          value: countryName
	        });
	      }
	
	      return c;
	    }
	  }, {
	    key: 'fetchCountries',
	    value: function fetchCountries() {
	      var _this2 = this;
	
	      var pendingRequest = _frilansFinans.CountryService.get();
	      pendingRequest.promise.then(function (countries) {
	        var c = [{
	          name: (0, _proxyCounterpart.proxyCounterpart)('PICK_COUNTRY'),
	          value: 'default',
	          disabled: true
	        }];
	
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(countries), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var country = _step.value;
	
	            c.push({
	              disabled: false,
	              name: country.name,
	              value: _this2.props.useIdAsValue ? country.id : country.name
	            });
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        _this2.setState({
	          countries: c,
	          fetchError: false
	        });
	      }).catch(function (error) {
	        if (error.response !== undefined) {
	          _this2.setState({
	            fetchError: true
	          });
	        }
	      });
	
	      this.setState({
	        pendingRequest: pendingRequest
	      });
	    }
	  }, {
	    key: 'setCountry',
	    value: function setCountry(e) {
	      this.setState({
	        selectValue: e.target.value
	      });
	
	      this.props.setCountry(e.target.value);
	    }
	  }, {
	    key: 'renderOption',
	    value: function renderOption(country, i) {
	      return _react2.default.createElement(
	        'option',
	        {
	          disabled: country.disabled,
	          value: country.value,
	          key: i },
	        country.name
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.fetchError) {
	        return _ref;
	      }
	      if (this.state.countries.length > 0) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'input-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: '' },
	            _react2.default.createElement(
	              'div',
	              { className: 'styled-select' },
	              _react2.default.createElement(
	                'select',
	                {
	                  name: 'country-picker',
	                  value: this.state.selectValue ? this.state.selectValue : 'default',
	                  onChange: this.setCountry },
	                this.state.countries.map(this.renderOption)
	              ),
	              _ref2
	            )
	          )
	        );
	      }
	
	      return false;
	    }
	  }]);
	  return CountryPicker;
	}(_react2.default.Component);
	
	exports.default = CountryPicker;

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dashboardButton = __webpack_require__(326);
	
	var _dashboardButton2 = _interopRequireDefault(_dashboardButton);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActicityDashboardButtonContainer = function (_React$Component) {
	  (0, _inherits3.default)(ActicityDashboardButtonContainer, _React$Component);
	
	  function ActicityDashboardButtonContainer() {
	    (0, _classCallCheck3.default)(this, ActicityDashboardButtonContainer);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ActicityDashboardButtonContainer.__proto__ || (0, _getPrototypeOf2.default)(ActicityDashboardButtonContainer)).call(this));
	
	    _this.state = {
	      scrollPosition: 0
	    };
	
	    _this.scrollLeft = _this.scrollLeft.bind(_this);
	    _this.scrollRight = _this.scrollRight.bind(_this);
	    _this.handleDrag = _this.handleDrag.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(ActicityDashboardButtonContainer, [{
	    key: 'scrollLeft',
	    value: function scrollLeft() {
	      var scrollContainer = document.getElementById('dashboard-button-scroll-container');
	      if (scrollContainer) {
	        scrollContainer.scrollTo({
	          top: 0,
	          left: 0,
	          behavior: 'smooth'
	        });
	        this.setState({
	          scrollPosition: 0
	        });
	      }
	    }
	  }, {
	    key: 'scrollRight',
	    value: function scrollRight() {
	      var scrollContainer = document.getElementById('dashboard-button-scroll-container');
	      if (scrollContainer) {
	        var scrollLeft = scrollContainer.scrollWidth - scrollContainer.offsetWidth;
	        scrollContainer.scrollTo({
	          top: 0,
	          left: scrollLeft,
	          behavior: 'smooth'
	        });
	        this.setState({
	          scrollPosition: scrollLeft
	        });
	      }
	    }
	  }, {
	    key: 'handleDrag',
	    value: function handleDrag() {
	      var scrollContainer = document.getElementById('dashboard-button-scroll-container');
	      if (scrollContainer) {
	        this.setState({
	          scrollPosition: scrollContainer.scrollLeft
	        });
	      }
	    }
	  }, {
	    key: 'renderLeftScrollButton',
	    value: function renderLeftScrollButton() {
	      var scrollContainer = document.getElementById('dashboard-button-scroll-container');
	      var isMinScrollLeft = true;
	      if (scrollContainer) {
	        isMinScrollLeft = scrollContainer.scrollLeft === 0;
	      }
	      if (!isMinScrollLeft) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'left-scroll-chevron' },
	          _react2.default.createElement('img', {
	            onClick: this.scrollLeft,
	            src: __webpack_require__(1556)
	          })
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'renderRightScrollButton',
	    value: function renderRightScrollButton() {
	      var scrollContainer = document.getElementById('dashboard-button-scroll-container');
	      var isMaxScrollLeft = false;
	      if (scrollContainer) {
	        var maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.offsetWidth;
	        isMaxScrollLeft = scrollContainer.scrollLeft === maxScrollLeft;
	      }
	      if (!isMaxScrollLeft) {
	        return _react2.default.createElement(
	          'div',
	          {
	            onClick: this.scrollRight,
	            className: 'right-scroll-chevron'
	          },
	          _react2.default.createElement('img', { src: __webpack_require__(1557) })
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dashboardButtons = [];
	      var buttons = [{
	        icon: __webpack_require__(655),
	        title: 'BUTTON_REGISTER_ASSIGNMENT',
	        buttonStyle: 'secondary',
	        link: '/register-assignment',
	        openTab: false
	      }, {
	        icon: __webpack_require__(1563),
	        title: 'BUTTON_CREATE_INVOICE',
	        buttonStyle: 'primary',
	        link: '/invoice-tool',
	        openTab: false
	      }, {
	        icon: __webpack_require__(1564),
	        title: 'BUTTON_CREATE_TENDER',
	        buttonStyle: 'regular',
	        link: (0, _proxyCounterpart.proxyCounterpart)('CREATE_TENDER_LINK'),
	        openTab: true
	      }, {
	        icon: __webpack_require__(1562),
	        title: 'BUTTON_WRITE_CONTRACT',
	        buttonStyle: 'regular',
	        link: (0, _proxyCounterpart.proxyCounterpart)('CREATE_CONTRACT_LINK'),
	        openTab: true
	      }];
	
	      for (var index = 0; index < buttons.length; index++) {
	        dashboardButtons.push(_react2.default.createElement(_dashboardButton2.default, {
	          key: index,
	          icon: buttons[index].icon,
	          title: buttons[index].title,
	          buttonStyle: buttons[index].buttonStyle,
	          link: buttons[index].link,
	          openTab: buttons[index].openTab
	        }));
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'dashboard-button-container' },
	        this.renderLeftScrollButton(),
	        _react2.default.createElement(
	          'div',
	          {
	            onScroll: this.handleDrag,
	            id: 'dashboard-button-scroll-container',
	            className: 'dashboard-button-scroll-container'
	          },
	          dashboardButtons
	        ),
	        this.renderRightScrollButton()
	      );
	    }
	  }]);
	  return ActicityDashboardButtonContainer;
	}(_react2.default.Component);
	
	exports.default = ActicityDashboardButtonContainer;

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(27);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(30);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'h2',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'EXCEEDING_WORKING_HOURS_TITLE' })
	);
	
	var _ref2 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'EXCEEDING_WORKING_HOURS_BODY', className: 'pre-wrap' });
	
	var _ref3 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CLOSE' });
	
	var ExceededWorkingHoursModal = function (_React$Component) {
	  (0, _inherits3.default)(ExceededWorkingHoursModal, _React$Component);
	
	  function ExceededWorkingHoursModal(props) {
	    (0, _classCallCheck3.default)(this, ExceededWorkingHoursModal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ExceededWorkingHoursModal.__proto__ || (0, _getPrototypeOf2.default)(ExceededWorkingHoursModal)).call(this, props));
	
	    _this.componentWillMount = function () {
	      _this.disableScroll();
	    };
	
	    _this.componentWillUnmount = function () {
	      _this.enableScroll();
	    };
	
	    _this.preventDefault = function (e) {
	      e = e || window.event;
	      if (e.preventDefault) {
	        e.preventDefault();
	      }
	      e.returnValue = false;
	    };
	
	    _this.disableScroll = function () {
	      window.onwheel = _this.preventDefault; // modern standard
	      window.onmousewheel = document.onmousewheel = _this.preventDefault; // older browsers, IE
	      window.ontouchmove = _this.preventDefault; // mobile
	    };
	
	    _this.enableScroll = function () {
	      window.onmousewheel = document.onmousewheel = null;
	      window.onwheel = null;
	      window.ontouchmove = null;
	      document.onkeydown = null;
	    };
	
	    _this.reject = function () {
	      _this.props.callback(false);
	    };
	
	    _this.render = function () {
	      return _react2.default.createElement(
	        _reactModal2.default,
	        {
	          className: 'modal',
	          contentLabel: '',
	          isOpen: _this.state.open,
	          onRequestClose: _this.reject },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-content confirm-modal' },
	          _react2.default.createElement('button', { className: 'close', onClick: _this.reject }),
	          _ref,
	          _ref2,
	          _react2.default.createElement(
	            'div',
	            { className: 'btn-wrapper' },
	            _react2.default.createElement(
	              'button',
	              (0, _extends3.default)({
	                key: 'reject',
	                className: 'btn',
	                onClick: _this.reject }, _this.state.rejectButtonProps),
	              _ref3
	            )
	          )
	        )
	      );
	    };
	
	    _this.state = {
	      open: true
	    };
	    return _this;
	  }
	
	  return ExceededWorkingHoursModal;
	}(_react2.default.Component);
	
	exports.default = ExceededWorkingHoursModal;

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(30);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _surveyBody = __webpack_require__(688);
	
	var _surveyBody2 = _interopRequireDefault(_surveyBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExceededWorkingHoursSurveyModal = function (_React$Component) {
	  (0, _inherits3.default)(ExceededWorkingHoursSurveyModal, _React$Component);
	
	  function ExceededWorkingHoursSurveyModal(props) {
	    (0, _classCallCheck3.default)(this, ExceededWorkingHoursSurveyModal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ExceededWorkingHoursSurveyModal.__proto__ || (0, _getPrototypeOf2.default)(ExceededWorkingHoursSurveyModal)).call(this, props));
	
	    _this.reject = function () {
	      _this.props.callback(false);
	    };
	
	    _this.render = function () {
	      return _react2.default.createElement(
	        _reactModal2.default,
	        {
	          className: 'modal',
	          contentLabel: '',
	          isOpen: _this.state.open },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-content' },
	          _react2.default.createElement('button', { className: 'close', onClick: _this.reject }),
	          _react2.default.createElement(_surveyBody2.default, {
	            callback: _this.props.callback,
	            scrollCalendar: _this.props.scrollCalendar
	          })
	        )
	      );
	    };
	
	    _this.state = {
	      open: true
	    };
	    return _this;
	  }
	
	  return ExceededWorkingHoursSurveyModal;
	}(_react2.default.Component);
	
	exports.default = ExceededWorkingHoursSurveyModal;

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(166);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _arrowDown = __webpack_require__(211);
	
	var _arrowDown2 = _interopRequireDefault(_arrowDown);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement('span', { className: 'no-margin' });
	
	var _ref2 = _react2.default.createElement(_reactTranslateComponent2.default, { className: 'surveyAnswerText', content: 'YES' });
	
	var _ref3 = _react2.default.createElement('span', { className: 'no-margin' });
	
	var _ref4 = _react2.default.createElement(_reactTranslateComponent2.default, { className: 'surveyAnswerText', content: 'NO' });
	
	var _ref5 = _react2.default.createElement(_reactTranslateComponent2.default, { className: 'surveySubtitle', content: 'OPTIONAL_COMMENT' });
	
	var _ref6 = _react2.default.createElement(_reactTranslateComponent2.default, { className: 'surveyTitle', content: 'EXCEEDING_WORKING_HOURS_TITLE' });
	
	var _ref7 = _react2.default.createElement(_reactTranslateComponent2.default, { className: 'surveyText', content: 'SURVEY_INFORMATION_TEXT' });
	
	var _ref8 = _react2.default.createElement(
	  'div',
	  { className: 'surveyContainerWrapperRow' },
	  _react2.default.createElement(
	    'div',
	    { className: 'surveyContainer large flex-row center' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { className: 'surveySubtitle', content: 'MORE_INFORMATION' })
	  ),
	  _react2.default.createElement(
	    'div',
	    { className: 'surveyContainer small center flex-row justify-end' },
	    _react2.default.createElement(_arrowDown2.default, null)
	  )
	);
	
	var _ref9 = _react2.default.createElement(
	  'div',
	  { className: 'surveyContainer small flex-row center' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { className: 'surveySubtitle', content: 'ENTERED_WRONG_HOURS' })
	);
	
	var _ref10 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CHANGE_WORKING_HOURS' });
	
	var _ref11 = _react2.default.createElement(_reactTranslateComponent2.default, { className: 'surveySubtitle', content: 'QUESTIONS_WORKING_CONDITIONS' });
	
	var _ref12 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SEND_SURVEY_RESPONSE' });
	
	var SurveyBody = function (_React$Component) {
	  (0, _inherits3.default)(SurveyBody, _React$Component);
	
	  function SurveyBody(props) {
	    (0, _classCallCheck3.default)(this, SurveyBody);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SurveyBody.__proto__ || (0, _getPrototypeOf2.default)(SurveyBody)).call(this, props));
	
	    _this.onChangeQuestionAnswer = function (index, answer) {
	      var newQuestions = _this.state.questions;
	
	      newQuestions[index].answer = answer;
	
	      _this.setState({
	        questions: newQuestions
	      });
	    };
	
	    _this.callbackSurveyAnswers = function () {
	      var answers = [];
	      var status = true;
	
	      _this.state.questions.forEach(function (question) {
	        if (question.name !== 'question_3.comment') {
	          var answer = question.answer ? 'Ja' : 'Nej';
	          answers.push((0, _stringify2.default)({ answer: answer, question: question.question }));
	          if (question.answer === true) {
	            status = false;
	          }
	        }
	      });
	
	      answers.push((0, _stringify2.default)({ risk_information_comment: _this.state.questionComment }));
	      answers.push((0, _stringify2.default)({ optional_comment: _this.state.comment }));
	
	      _this.props.callback(answers.toString(), status);
	    };
	
	    _this.renderQuestionRow = function (question, index, isSubQuestion) {
	      var setTrue = function setTrue() {
	        return _this.onChangeQuestionAnswer(index, true);
	      };
	      var setFalse = function setFalse() {
	        return _this.onChangeQuestionAnswer(index, false);
	      };
	
	      var containerWrapperClass = 'surveyContainerWrapper gray fixed-height flex-row';
	
	      return _react2.default.createElement(
	        'div',
	        {
	          key: question.name,
	          className: isSubQuestion ? containerWrapperClass + ' margin-left-20' : containerWrapperClass
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'surveyContainer large' },
	          _react2.default.createElement(
	            'div',
	            { className: 'surveySubtitle' },
	            question.title
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'surveyBodyText' },
	            question.question
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'surveyContainer small flex-row justify-end' },
	          _react2.default.createElement('input', { id: question.name + '-alt-1',
	            type: 'radio',
	            name: question.name,
	            value: true,
	            checked: question.answer,
	            onChange: setTrue }),
	          _react2.default.createElement(
	            'label',
	            { className: 'surveyAnswer', htmlFor: question.name + '-alt-1' },
	            _ref,
	            _ref2
	          ),
	          _react2.default.createElement('input', { id: question.name + '-alt-2', type: 'radio', name: question.name, value: false,
	            checked: !question.answer,
	            onChange: setFalse }),
	          _react2.default.createElement(
	            'label',
	            { className: 'surveyAnswer', htmlFor: question.name + '-alt-2' },
	            _ref3,
	            _ref4
	          )
	        )
	      );
	    };
	
	    _this.renderQuestionComment = function (question) {
	      return _react2.default.createElement(
	        'div',
	        {
	          key: question.name,
	          className: 'surveyContainerWrapper gray flex-column margin-left-20'
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'surveySubtitle' },
	          question.title
	        ),
	        _react2.default.createElement('textarea', { className: 'no-margin',
	          name: 'survey-question-comment',
	          value: _this.state.questionComment,
	          onChange: _this.setQuestionComment
	        })
	      );
	    };
	
	    _this.renderQuestions = function () {
	      var questions = [];
	
	      _this.state.questions.forEach(function (question, index) {
	        var question3 = _this.state.questions[2];
	        var isSubQuestion = question.name.includes('.');
	
	        if (!isSubQuestion || question3.answer) {
	          var surveyQuestion = _this.renderQuestionRow(question, index, isSubQuestion);
	          if (question.name === 'question_3.comment') {
	            surveyQuestion = _this.renderQuestionComment(question);
	          }
	
	          questions.push(surveyQuestion);
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'surveyColumnContainer' },
	        questions,
	        _react2.default.createElement(
	          'div',
	          { className: 'surveyContainerWrapper gray flex-column' },
	          _ref5,
	          _react2.default.createElement('textarea', { className: 'no-margin',
	            name: 'survey-comment',
	            value: _this.state.comment,
	            onChange: _this.setComment
	          })
	        )
	      );
	    };
	
	    _this.setComment = function (event) {
	      _this.setState({
	        comment: event.target.value
	      });
	    };
	
	    _this.setQuestionComment = function (event) {
	      _this.setState({
	        questionComment: event.target.value
	      });
	    };
	
	    _this.showMoreText = function () {
	      _this.setState({
	        showMoreText: !_this.state.showMoreText
	      });
	    };
	
	    _this.renderShowMoreText = function () {
	      if (_this.state.showMoreText) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'surveyBodyText pre-wrap' },
	          (0, _proxyCounterpart.proxyCounterpart)('MORE_INFORMATION_TEXT')
	        );
	      }
	    };
	
	    _this.render = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'surveyColumnContainer' },
	        _ref6,
	        _ref7,
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'surveyContainerWrapper blue flex-column',
	            onClick: _this.showMoreText
	          },
	          _ref8,
	          _this.renderShowMoreText()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'surveyContainerWrapper blue flex-row' },
	          _ref9,
	          _react2.default.createElement(
	            'div',
	            { className: 'surveyContainer small flex-row center justify-end' },
	            _react2.default.createElement(
	              'button',
	              {
	                key: 'changeHours',
	                className: 'btn px-30 outlined blue',
	                onClick: _this.props.scrollCalendar
	              },
	              _ref10
	            )
	          )
	        ),
	        _ref11,
	        _this.renderQuestions(),
	        _react2.default.createElement(
	          'div',
	          { className: 'btn-wrapper' },
	          _react2.default.createElement(
	            'button',
	            {
	              key: 'send',
	              className: 'btn',
	              onClick: _this.callbackSurveyAnswers
	            },
	            _ref12
	          )
	        )
	      );
	    };
	
	    _this.state = {
	      showMoreText: false,
	      questions: [{
	        title: (0, _proxyCounterpart.proxyCounterpart)('QUESTION_1_TITLE'),
	        question: (0, _proxyCounterpart.proxyCounterpart)('QUESTION_1_QUESTION'),
	        answer: false,
	        name: 'question_1'
	      }, {
	        title: (0, _proxyCounterpart.proxyCounterpart)('QUESTION_2_TITLE'),
	        question: (0, _proxyCounterpart.proxyCounterpart)('QUESTION_2_QUESTION'),
	        answer: false,
	        name: 'question_2'
	      }, {
	        title: (0, _proxyCounterpart.proxyCounterpart)('QUESTION_3_TITLE'),
	        question: (0, _proxyCounterpart.proxyCounterpart)('QUESTION_3_QUESTION'),
	        answer: false,
	        name: 'question_3'
	      }, {
	        title: (0, _proxyCounterpart.proxyCounterpart)('QUESTION_3-1_TITLE'),
	        question: (0, _proxyCounterpart.proxyCounterpart)('QUESTION_3-1_QUESTION'),
	        answer: false,
	        name: 'question_3.1'
	      }, {
	        title: (0, _proxyCounterpart.proxyCounterpart)('QUESTION_3-2_TITLE'),
	        question: (0, _proxyCounterpart.proxyCounterpart)('QUESTION_3-2_QUESTION'),
	        answer: false,
	        name: 'question_3.2'
	      }, {
	        title: (0, _proxyCounterpart.proxyCounterpart)('QUESTION_3-3_TITLE'),
	        question: (0, _proxyCounterpart.proxyCounterpart)('QUESTION_3-3_QUESTION'),
	        answer: false,
	        name: 'question_3.3'
	      }, {
	        title: (0, _proxyCounterpart.proxyCounterpart)('QUESTION_3-4_TITLE'),
	        question: (0, _proxyCounterpart.proxyCounterpart)('QUESTION_3-4_QUESTION'),
	        answer: false,
	        name: 'question_3.4'
	      }, {
	        title: (0, _proxyCounterpart.proxyCounterpart)('OTHER_RISK_COMMENT'),
	        name: 'question_3.comment'
	      }, {
	        title: (0, _proxyCounterpart.proxyCounterpart)('QUESTION_4_TITLE'),
	        question: (0, _proxyCounterpart.proxyCounterpart)('QUESTION_4_QUESTION'),
	        answer: false,
	        name: 'question_4'
	      }],
	      comment: '',
	      questionComment: ''
	    };
	    return _this;
	  }
	
	  return SurveyBody;
	}(_react2.default.Component);
	
	exports.default = SurveyBody;

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Footer = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'h3',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INFORMATION' })
	); /**
	    * Created by staffanrantzow on 16/03/16.
	    */
	
	var _ref2 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'FAQ' });
	
	var _ref3 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SUPPORT' });
	
	var _ref4 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CONTACT' });
	
	var _ref5 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PRIVACY_POLICY' });
	
	var _ref6 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INSURANCES' });
	
	var _ref7 = _react2.default.createElement(
	  'h3',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SOCIAL_MEDIAS' })
	);
	
	var _ref8 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'FACEBOOK' });
	
	var _ref9 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'LINKEDIN' });
	
	var _ref10 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'TWITTER' });
	
	var _ref11 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INSTAGRAM' });
	
	var _ref12 = _react2.default.createElement(
	  'div',
	  { className: 'col-sm-4 hide-tablet' },
	  _react2.default.createElement(
	    'h3',
	    null,
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CONTACT' })
	  ),
	  _react2.default.createElement(
	    'ul',
	    { className: 'footer-list' },
	    _react2.default.createElement(
	      'li',
	      { className: 'contact-text' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'FOOTER_CONTACT_EMAIL' })
	    ),
	    _react2.default.createElement(
	      'li',
	      { className: 'contact-text' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'FOOTER_CONTACT_PHONE' })
	    ),
	    _react2.default.createElement(
	      'li',
	      { className: 'contact-text' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'FOOTER_CONTACT_OPEN' })
	    )
	  )
	);
	
	var _ref13 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'COOKIE_INFO' });
	
	var Footer = exports.Footer = function (_React$Component) {
	  (0, _inherits3.default)(Footer, _React$Component);
	
	  function Footer() {
	    (0, _classCallCheck3.default)(this, Footer);
	    return (0, _possibleConstructorReturn3.default)(this, (Footer.__proto__ || (0, _getPrototypeOf2.default)(Footer)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Footer, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'footer',
	        { className: 'site-footer' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-4' },
	              _ref,
	              _react2.default.createElement(
	                'ul',
	                { className: 'footer-list' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: (0, _proxyCounterpart.proxyCounterpart)('FOOTER_LINK_FAQ'), target: '_blank' },
	                    _ref2
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: (0, _proxyCounterpart.proxyCounterpart)('FOOTER_LINK_SUPPORT'), target: '_blank' },
	                    _ref3
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: (0, _proxyCounterpart.proxyCounterpart)('FOOTER_LINK_CONTACT'), target: '_blank' },
	                    _ref4
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    {
	                      href: (0, _proxyCounterpart.proxyCounterpart)('FOOTER_LINK_PRIVACY_POLICY'),
	                      target: '_blank' },
	                    _ref5
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: (0, _proxyCounterpart.proxyCounterpart)('FOOTER_LINK_INS'), target: '_blank' },
	                    _ref6
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-4 hide-tablet' },
	              _ref7,
	              _react2.default.createElement(
	                'ul',
	                { className: 'footer-list social-media-list' },
	                _react2.default.createElement(
	                  'li',
	                  { className: 'facebook' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: (0, _proxyCounterpart.proxyCounterpart)('FOOTER_LINK_FACEBOOK'), target: '_blank' },
	                    _ref8
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { className: 'linkedin' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: (0, _proxyCounterpart.proxyCounterpart)('FOOTER_LINK_LINKEDIN'), target: '_blank' },
	                    _ref9
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { className: 'twitter' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: (0, _proxyCounterpart.proxyCounterpart)('FOOTER_LINK_TWITTER'), target: '_blank' },
	                    _ref10
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { className: 'instagram' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: (0, _proxyCounterpart.proxyCounterpart)('FOOTER_LINK_INSTAGRAM'), target: '_blank' },
	                    _ref11
	                  )
	                )
	              )
	            ),
	            _ref12
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'footer-bottom' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	              'p',
	              { className: 'copywright' },
	              '\xA9',
	              new Date().getFullYear(),
	              ' - Frilans Finans AB'
	            ),
	            _react2.default.createElement(
	              'a',
	              { href: (0, _proxyCounterpart.proxyCounterpart)('FOOTER_LINK_COOKIE'), target: '_blank' },
	              _ref13
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footer-logo  hide-tablet' },
	              _react2.default.createElement('img', { src: __webpack_require__(1549),
	                alt: 'Egenanst\xE4llningsf\xF6retagens Branschorganisation' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return Footer;
	}(_react2.default.Component);
	
	exports.default = Footer;

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GeneralTermsContainer = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _lodash = __webpack_require__(40);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _generalTerms = __webpack_require__(691);
	
	var _generalTerms2 = _interopRequireDefault(_generalTerms);
	
	var _generalTerms3 = __webpack_require__(830);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GeneralTermsContainer = exports.GeneralTermsContainer = function (_React$Component) {
	  (0, _inherits3.default)(GeneralTermsContainer, _React$Component);
	
	  function GeneralTermsContainer() {
	    (0, _classCallCheck3.default)(this, GeneralTermsContainer);
	    return (0, _possibleConstructorReturn3.default)(this, (GeneralTermsContainer.__proto__ || (0, _getPrototypeOf2.default)(GeneralTermsContainer)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(GeneralTermsContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (_lodash2.default.isEmpty(this.props.generalTerms.headline)) {
	        this.fetchGeneralTerms();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!_lodash2.default.isEqual(nextProps.i18n, this.props.i18n)) {
	        this.fetchGeneralTerms();
	      }
	    }
	  }, {
	    key: 'fetchGeneralTerms',
	    value: function fetchGeneralTerms() {
	      var languageId = this.props.i18n.locale === 'se' ? 1 : 3;
	      this.props.fetch(languageId);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_generalTerms2.default, { generalTerms: this.props.generalTerms });
	    }
	  }]);
	  return GeneralTermsContainer;
	}(_react2.default.Component);
	
	function mapStateToProps(state) {
	  return {
	    i18n: state.i18n,
	    generalTerms: state.generalTerms.entity
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    fetch: function fetch(language) {
	      return dispatch((0, _generalTerms3.fetch)(language));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GeneralTermsContainer);

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GeneralTerms = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _closeModal = __webpack_require__(325);
	
	var _closeModal2 = _interopRequireDefault(_closeModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'APPROVE_TERMS' });
	
	var _ref2 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'GENERAL_TERMS' });
	
	var GeneralTerms = exports.GeneralTerms = function (_React$Component) {
	  (0, _inherits3.default)(GeneralTerms, _React$Component);
	
	  function GeneralTerms(props) {
	    (0, _classCallCheck3.default)(this, GeneralTerms);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (GeneralTerms.__proto__ || (0, _getPrototypeOf2.default)(GeneralTerms)).call(this, props));
	
	    _this.state = {
	      showModal: false
	    };
	
	    _this.toggleModal = _this.toggleModal.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(GeneralTerms, [{
	    key: 'toggleModal',
	    value: function toggleModal(e) {
	      this.setState({
	        showModal: !this.state.showModal
	      });
	    }
	  }, {
	    key: 'renderModal',
	    value: function renderModal() {
	      if (this.state.showModal) {
	        return _react2.default.createElement(_closeModal2.default, {
	          headline: this.props.generalTerms.headline,
	          body: this.props.generalTerms.text,
	          close: this.toggleModal });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'general-terms' },
	        _ref,
	        ' Frilans\xA0Finans\xA0',
	        _react2.default.createElement(
	          'a',
	          { href: '#', onClick: this.toggleModal },
	          _ref2
	        ),
	        this.renderModal()
	      );
	    }
	  }]);
	  return GeneralTerms;
	}(_react2.default.Component);
	
	exports.default = GeneralTerms;

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Header = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _localePicker = __webpack_require__(328);
	
	var _localePicker2 = _interopRequireDefault(_localePicker);
	
	var _countryPicker = __webpack_require__(327);
	
	var _countryPicker2 = _interopRequireDefault(_countryPicker);
	
	var _rightSection = __webpack_require__(695);
	
	var _rightSection2 = _interopRequireDefault(_rightSection);
	
	var _authentication = __webpack_require__(64);
	
	var _reactRouter = __webpack_require__(20);
	
	var _variables = __webpack_require__(47);
	
	var variables = _interopRequireWildcard(_variables);
	
	var _utils = __webpack_require__(29);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = exports.Header = function (_React$Component) {
	  (0, _inherits3.default)(Header, _React$Component);
	
	  function Header() {
	    (0, _classCallCheck3.default)(this, Header);
	    return (0, _possibleConstructorReturn3.default)(this, (Header.__proto__ || (0, _getPrototypeOf2.default)(Header)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Header, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'header',
	        { className: 'page-header sticky' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'a',
	            { href: variables.frontUrl, className: 'logo' },
	            _react2.default.createElement(
	              'object',
	              { type: 'image/svg+xml',
	                data: __webpack_require__(658),
	                alt: 'Frilans Finans-logotyp' },
	              _react2.default.createElement('img', { src: __webpack_require__(207), alt: 'Frilans Finans-logotyp' })
	            )
	          ),
	          _react2.default.createElement(_rightSection2.default, { user: this.props.user }),
	          _react2.default.createElement(
	            'div',
	            { className: 'left-section hide-large-tablet' },
	            _react2.default.createElement(
	              'div',
	              { className: 'left-menus' },
	              _react2.default.createElement(_countryPicker2.default, { countries: this.props.availableCountries, selectedCountry: this.props.selectedCountry }),
	              _react2.default.createElement(_localePicker2.default, { locales: this.props.availableLocales, selectedLocale: this.props.selectedLocale })
	            ),
	            _react2.default.createElement(
	              _authentication.Authenticated,
	              null,
	              _react2.default.createElement(
	                'p',
	                { className: 'username hide-large-tablet' },
	                this.props.user.firstName,
	                ' ',
	                this.props.user.lastName
	              ),
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: 'economy/loyalty-program/points', className: 'loyalty-points' },
	                _utils2.default.numberWithSpaces(_utils2.default.floor(this.props.user.loyaltyPoints)),
	                ' p'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return Header;
	}(_react2.default.Component);
	
	Header.contextTypes = {
	  user: _react2.default.PropTypes.object
	};
	
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    user: state.user,
	
	    selectedLocale: state.i18n.locale,
	    selectedCountry: state.i18n.country,
	    availableLocales: state.i18n.availableLocales,
	    availableCountries: state.i18n.availableCountries
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Header);

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LocaleListItem = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _i18n = __webpack_require__(361);
	
	var _reactRedux = __webpack_require__(12);
	
	var _cookieUtils = __webpack_require__(89);
	
	var _cookieUtils2 = _interopRequireDefault(_cookieUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 15/03/16.
	 */
	
	var LocaleListItem = exports.LocaleListItem = function (_React$Component) {
	  (0, _inherits3.default)(LocaleListItem, _React$Component);
	
	  function LocaleListItem(props) {
	    (0, _classCallCheck3.default)(this, LocaleListItem);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (LocaleListItem.__proto__ || (0, _getPrototypeOf2.default)(LocaleListItem)).call(this, props));
	
	    _this.boundOnChangeLanguage = _this.onChangeLanguage.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(LocaleListItem, [{
	    key: 'onChangeLanguage',
	    value: function onChangeLanguage() {
	      this.props.dispatch((0, _i18n.changeLanguage)(this.props.lang));
	      _cookieUtils2.default.setLanguageCookie(this.props.lang);
	      location.reload();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var classNames = 'sprite-image flag-' + this.props.lang;
	
	      return _react2.default.createElement(
	        'li',
	        { onClick: this.boundOnChangeLanguage },
	        _react2.default.createElement('span', { className: classNames })
	      );
	    }
	  }]);
	  return LocaleListItem;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)()(LocaleListItem);

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MainMenu = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(20);
	
	var _reactRedux = __webpack_require__(12);
	
	var _index = __webpack_require__(364);
	
	var _authentication = __webpack_require__(64);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _localePicker = __webpack_require__(328);
	
	var _localePicker2 = _interopRequireDefault(_localePicker);
	
	var _countryPicker = __webpack_require__(327);
	
	var _countryPicker2 = _interopRequireDefault(_countryPicker);
	
	var _variables = __webpack_require__(47);
	
	var variables = _interopRequireWildcard(_variables);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'p',
	  { className: 'menu-name' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'HEADER_MENU_SERVICES' })
	);
	
	var _ref2 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_TOOL_LINK_TEXT' });
	
	var _ref3 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'EVENTS_AND_INSPIRATION_LINK_TEXT' });
	
	var _ref4 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'NETWORK_LINK_TEXT' });
	
	var _ref5 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INSURANCES' });
	
	var _ref6 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'WORK_INTERNATIONALLY_LINK_TEXT' });
	
	var _ref7 = _react2.default.createElement(
	  'p',
	  { className: 'menu-name' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'HEADER_MENU_HELP' })
	);
	
	var _ref8 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'HOW_IT_WORKS' });
	
	var _ref9 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'QUESTIONS_AND_ANSWERS' });
	
	var _ref10 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'MEET_OUR_UMBRELLA_CONTRACTORS' });
	
	var _ref11 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'THIS_IS_SELF_EMPLOYMENT' });
	
	var _ref12 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'GOOD_WORKING_CONDITIONS' });
	
	var _ref13 = _react2.default.createElement(
	  'p',
	  { className: 'menu-name' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'HEADER_MENU_ABOUT' })
	);
	
	var _ref14 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ABOUT_FRILANS_FINANS' });
	
	var _ref15 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CONTACT_US' });
	
	var _ref16 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'NEWS_AND_PRESS' });
	
	var _ref17 = _react2.default.createElement(
	  'p',
	  { className: 'menu-name' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SOCIAL_MEDIA' })
	);
	
	var _ref18 = _react2.default.createElement(
	  'ul',
	  { className: 'menu-list' },
	  _react2.default.createElement(
	    'li',
	    null,
	    _react2.default.createElement(
	      'a',
	      { href: 'https://www.facebook.com/FrilansFinans/', target: '_blank' },
	      'Facebook'
	    )
	  ),
	  _react2.default.createElement(
	    'li',
	    null,
	    _react2.default.createElement(
	      'a',
	      { href: 'https://twitter.com/frilansfinans', target: '_blank' },
	      'Twitter'
	    )
	  ),
	  _react2.default.createElement(
	    'li',
	    null,
	    _react2.default.createElement(
	      'a',
	      { href: 'https://www.linkedin.com/company/frilans-finans-sverige-ab', target: '_blank' },
	      'LinkedIn'
	    )
	  ),
	  _react2.default.createElement(
	    'li',
	    null,
	    _react2.default.createElement(
	      'a',
	      { href: 'https://www.instagram.com/frilansfinans/', target: '_blank' },
	      'Instagram'
	    )
	  )
	);
	
	var _ref19 = _react2.default.createElement(
	  'p',
	  { className: 'menu-name' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'HEADER_MENU_SERVICES' })
	);
	
	var _ref20 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_TOOL' });
	
	var _ref21 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'NETWORK' });
	
	var _ref22 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INSURANCES' });
	
	var _ref23 = _react2.default.createElement(
	  'p',
	  { className: 'menu-name' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'HEADER_MENU_HELP' })
	);
	
	var _ref24 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'HOW_IT_WORKS' });
	
	var _ref25 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'QUESTIONS_AND_ANSWERS' });
	
	var _ref26 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'MEET_OUR_UMBRELLA_CONTRACTORS' });
	
	var _ref27 = _react2.default.createElement(
	  'p',
	  { className: 'menu-name' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'HEADER_MENU_ABOUT' })
	);
	
	var _ref28 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ABOUT_FRILANS_FINANS' });
	
	var _ref29 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CONTACT_US' });
	
	var _ref30 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'NEWS_AND_PRESS' });
	
	var _ref31 = _react2.default.createElement(
	  'p',
	  { className: 'menu-name' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SOCIAL_MEDIA' })
	);
	
	var _ref32 = _react2.default.createElement(
	  'ul',
	  { className: 'menu-list' },
	  _react2.default.createElement(
	    'li',
	    null,
	    _react2.default.createElement(
	      'a',
	      { href: 'https://www.facebook.com/FrilansFinans/', target: '_blank' },
	      'Facebook'
	    )
	  ),
	  _react2.default.createElement(
	    'li',
	    null,
	    _react2.default.createElement(
	      'a',
	      { href: 'https://twitter.com/frilansfinans', target: '_blank' },
	      'Twitter'
	    )
	  ),
	  _react2.default.createElement(
	    'li',
	    null,
	    _react2.default.createElement(
	      'a',
	      { href: 'https://www.linkedin.com/company/frilans-finans-sverige-ab', target: '_blank' },
	      'LinkedIn'
	    )
	  ),
	  _react2.default.createElement(
	    'li',
	    null,
	    _react2.default.createElement(
	      'a',
	      { href: 'https://www.instagram.com/frilansfinans/', target: '_blank' },
	      'Instagram'
	    )
	  )
	);
	
	var _ref33 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'LOGIN' });
	
	var _ref34 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CREATE_ACCOUNT' });
	
	var _ref35 = _react2.default.createElement(
	  _reactRouter.Link,
	  { to: '/invoice-tool', className: 'btn white' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CREATE_INVOICE' })
	);
	
	var _ref36 = _react2.default.createElement(
	  _authentication.LogoutLink,
	  { classes: 'btn outlined' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'LOGOUT' })
	);
	
	var _ref37 = _react2.default.createElement(
	  'p',
	  { className: 'menu-name' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'MY_PAGES' })
	);
	
	var _ref38 = _react2.default.createElement(
	  'li',
	  null,
	  _react2.default.createElement(
	    _reactRouter.Link,
	    { to: '/activities' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ACTIVITIES' })
	  )
	);
	
	var _ref39 = _react2.default.createElement(
	  'li',
	  null,
	  _react2.default.createElement(
	    _reactRouter.Link,
	    { to: '/economy' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'MENU_MY_INVOICING' })
	  )
	);
	
	var _ref40 = _react2.default.createElement(
	  'li',
	  null,
	  _react2.default.createElement(
	    _reactRouter.Link,
	    { to: '/insurances' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INSURANCES' })
	  )
	);
	
	var _ref41 = _react2.default.createElement(
	  'li',
	  null,
	  _react2.default.createElement(
	    _reactRouter.Link,
	    { to: '/customers' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'MY_CUSTOMERS' })
	  )
	);
	
	var _ref42 = _react2.default.createElement(
	  'li',
	  null,
	  _react2.default.createElement(
	    _reactRouter.Link,
	    { to: '/settings' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SETTINGS' })
	  )
	);
	
	var _ref43 = _react2.default.createElement(
	  'li',
	  null,
	  _react2.default.createElement(
	    _reactRouter.Link,
	    { to: '/faq' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'FAQ' })
	  )
	);
	
	var _ref44 = _react2.default.createElement(
	  'li',
	  null,
	  _react2.default.createElement(
	    _authentication.LogoutLink,
	    null,
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'LOGOUT' })
	  )
	);
	
	var MainMenu = exports.MainMenu = function (_React$Component) {
	  (0, _inherits3.default)(MainMenu, _React$Component);
	
	  function MainMenu() {
	    (0, _classCallCheck3.default)(this, MainMenu);
	    return (0, _possibleConstructorReturn3.default)(this, (MainMenu.__proto__ || (0, _getPrototypeOf2.default)(MainMenu)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MainMenu, [{
	    key: 'renderSwedishMenu',
	    value: function renderSwedishMenu() {
	      if (this.props.selectedLocale === 'se') {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _ref,
	          _react2.default.createElement(
	            'ul',
	            { className: 'menu-list' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: variables.frontUrl + '/fakturaverktyg/' },
	                _ref2
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: variables.frontUrl + '/evenemang-och-inspiration/' },
	                _ref3
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: variables.frontUrl + '/network/' },
	                _ref4
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: variables.frontUrl + '/vara-forsakringar/' },
	                _ref5
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: variables.frontUrl + '/jobba-internationellt/' },
	                _ref6
	              )
	            )
	          ),
	          _ref7,
	          _react2.default.createElement(
	            'ul',
	            { className: 'menu-list' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: variables.frontUrl + '/sa-har-fungerar-det/' },
	                _ref8
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: variables.frontUrl + '/fragor-och-svar/' },
	                _ref9
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: variables.frontUrl + '/traffa-vara-egenanstallda/' },
	                _ref10
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: variables.frontUrl + '/egenanstallning/' },
	                _ref11
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: variables.frontUrl + '/arbetsmiljo/' },
	                _ref12
	              )
	            )
	          ),
	          _ref13,
	          _react2.default.createElement(
	            'ul',
	            { className: 'menu-list' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: variables.frontUrl + '/om-frilans-finans/' },
	                _ref14
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: variables.frontUrl + '/kontakta-oss/' },
	                _ref15
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: variables.frontUrl + '/nyheter-och-press/' },
	                _ref16
	              )
	            )
	          ),
	          _ref17,
	          _ref18
	        );
	      }
	    }
	  }, {
	    key: 'renderEnglishMenu',
	    value: function renderEnglishMenu() {
	      if (this.props.selectedLocale === 'en') {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _ref19,
	          _react2.default.createElement(
	            'ul',
	            { className: 'menu-list' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: variables.frontUrl + '/testaattskickafaktura/' },
	                _ref20
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: variables.frontUrl + '/en/network/' },
	                _ref21
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: variables.frontUrl + '/en/vara-forsakringar/' },
	                _ref22
	              )
	            )
	          ),
	          _ref23,
	          _react2.default.createElement(
	            'ul',
	            { className: 'menu-list' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: variables.frontUrl + '/en/sa-har-fungerar-det/' },
	                _ref24
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: variables.frontUrl + '/en/questions-and-answers/' },
	                _ref25
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: variables.frontUrl + '/en/meet-our-umbrella-contractors/' },
	                _ref26
	              )
	            )
	          ),
	          _ref27,
	          _react2.default.createElement(
	            'ul',
	            { className: 'menu-list' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: variables.frontUrl + '/en/om-frilans-finans/' },
	                _ref28
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: variables.frontUrl + '/en/contact-us/' },
	                _ref29
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: variables.frontUrl + '/en/nyheter-och-press/' },
	                _ref30
	              )
	            )
	          ),
	          _ref31,
	          _ref32
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'top-menu-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'hide-until-tablet mobile-top-menu' },
	          _react2.default.createElement(
	            _authentication.NotAuthenticated,
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/login', onClick: this.props.closeMenu, className: 'btn white' },
	              _ref33
	            ),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/register', onClick: this.props.closeMenu, className: 'btn outlined' },
	              _ref34
	            )
	          ),
	          _react2.default.createElement(
	            _authentication.Authenticated,
	            null,
	            _react2.default.createElement(
	              'div',
	              { onClick: this.props.closeMenu },
	              _ref35,
	              _ref36
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _authentication.NotAuthenticated,
	          null,
	          this.renderEnglishMenu(),
	          this.renderSwedishMenu()
	        ),
	        _react2.default.createElement(
	          _authentication.Authenticated,
	          null,
	          _ref37,
	          _react2.default.createElement(
	            'ul',
	            { className: 'menu-list', onClick: this.props.closeMenu },
	            _ref38,
	            _ref39,
	            _ref40,
	            _ref41,
	            _ref42,
	            _ref43,
	            _ref44
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'hide-until-tablet mobile-bottom-menus' },
	          _react2.default.createElement(_countryPicker2.default, { countries: this.props.availableCountries, selectedCountry: this.props.selectedCountry }),
	          _react2.default.createElement(_localePicker2.default, { locales: this.props.availableLocales, selectedLocale: this.props.selectedLocale })
	        )
	      );
	    }
	  }]);
	  return MainMenu;
	}(_react2.default.Component);
	
	function mapStateToProps(state) {
	  return {
	    user: state.user,
	    selectedLocale: state.i18n.locale,
	    selectedCountry: state.i18n.country,
	    availableLocales: state.i18n.availableLocales,
	    availableCountries: state.i18n.availableCountries
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    closeMenu: function closeMenu() {
	      return dispatch((0, _index.closeMenu)());
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MainMenu);

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RightSection = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(20);
	
	var _reactRedux = __webpack_require__(12);
	
	var _actionTypes = __webpack_require__(224);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _index = __webpack_require__(364);
	
	var _authentication = __webpack_require__(64);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _close = __webpack_require__(213);
	
	var _close2 = _interopRequireDefault(_close);
	
	var _menu = __webpack_require__(739);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  _authentication.NotAuthenticated,
	  null,
	  _react2.default.createElement(
	    _reactRouter.Link,
	    { to: '/login', className: 'login hide-tablet' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'LOGIN' })
	  ),
	  _react2.default.createElement(
	    _reactRouter.Link,
	    { to: '/register', className: 'btn outlined create-account hide-tablet' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CREATE_ACCOUNT' })
	  )
	);
	
	var _ref2 = _react2.default.createElement(
	  _authentication.Authenticated,
	  null,
	  _react2.default.createElement(
	    _authentication.LogoutLink,
	    { classes: 'logout hide-tablet' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'LOGOUT' })
	  ),
	  _react2.default.createElement(
	    _reactRouter.Link,
	    { to: '/invoice-tool', className: 'btn outlined create-invoice hide-tablet' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CREATE_INVOICE' })
	  )
	);
	
	var _ref3 = _react2.default.createElement(
	  'span',
	  { className: 'menu-btn-svg' },
	  _react2.default.createElement(_menu2.default, { color: '#FFFFFF' })
	);
	
	var _ref4 = _react2.default.createElement(
	  'span',
	  { className: 'menu-btn-text hide-tablet' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'MENU' })
	);
	
	var _ref5 = _react2.default.createElement(
	  'span',
	  { className: 'menu-btn-svg' },
	  _react2.default.createElement(_close2.default, { color: '#FFFFFF' })
	);
	
	var _ref6 = _react2.default.createElement(
	  'span',
	  { className: 'menu-btn-text hide-tablet' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CLOSE' })
	);
	
	var RightSection = exports.RightSection = function (_React$Component) {
	  (0, _inherits3.default)(RightSection, _React$Component);
	
	  function RightSection() {
	    (0, _classCallCheck3.default)(this, RightSection);
	    return (0, _possibleConstructorReturn3.default)(this, (RightSection.__proto__ || (0, _getPrototypeOf2.default)(RightSection)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(RightSection, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'right-section' },
	        _ref,
	        _ref2,
	        _react2.default.createElement(
	          'button',
	          { className: 'menu-btn open-menu', onClick: this.props.openMenu },
	          _ref3,
	          _ref4
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'menu-btn close-menu', onClick: this.props.closeMenu },
	          _ref5,
	          _ref6
	        )
	      );
	    }
	  }]);
	  return RightSection;
	}(_react2.default.Component);
	
	function mapStateToProps(state) {
	  return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    openMenu: function openMenu() {
	      dispatch((0, _index.openMenu)({
	        action: {
	          type: types.OPEN_MAIN_MENU
	        }
	      }));
	    },
	    closeMenu: function closeMenu() {
	      dispatch((0, _index.closeMenu)({
	        action: {
	          type: types.CLOSE_MAIN_MENU
	        }
	      }));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(RightSection);

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InfoBanner = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(20);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _cross = __webpack_require__(733);
	
	var _cross2 = _interopRequireDefault(_cross);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _cookieUtils = __webpack_require__(89);
	
	var _cookieUtils2 = _interopRequireDefault(_cookieUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_reactTranslateComponent2.default, { className: 'info-banner-text', content: 'INFO_BANNER_TEXT' });
	
	var _ref2 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INFO_BANNER_READ_MORE_BUTTON' });
	
	var _ref3 = _react2.default.createElement(_cross2.default, { colorSchema: 'primary' });
	
	var InfoBanner = exports.InfoBanner = function (_React$Component) {
	  (0, _inherits3.default)(InfoBanner, _React$Component);
	
	  function InfoBanner() {
	    (0, _classCallCheck3.default)(this, InfoBanner);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (InfoBanner.__proto__ || (0, _getPrototypeOf2.default)(InfoBanner)).call(this));
	
	    _this.state = {
	      showInfoBanner: false
	    };
	
	    _this.closeInfoBanner = _this.closeInfoBanner.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(InfoBanner, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var text = (0, _proxyCounterpart.proxyCounterpart)('INFO_BANNER_TEXT', { fallback: 'notransfound' });
	
	      if (text !== 'notransfound' && !_cookieUtils2.default.getInfoBannerClosed(text)) {
	        this.setState({
	          showInfoBanner: true
	        });
	      }
	    }
	  }, {
	    key: 'closeInfoBanner',
	    value: function closeInfoBanner() {
	      var text = (0, _proxyCounterpart.proxyCounterpart)('INFO_BANNER_TEXT');
	      _cookieUtils2.default.setInfoBannerClosed(text);
	      this.setState({
	        showInfoBanner: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'info-banner-wrapper' + (this.state.showInfoBanner ? '' : ' hidden') },
	        _react2.default.createElement('img', { className: 'info-banner-image', src: (0, _proxyCounterpart.proxyCounterpart)('INFO_BANNER_IMAGE') }),
	        _ref,
	        _react2.default.createElement(
	          'div',
	          { className: 'info-banner-action-container' },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              to: (0, _proxyCounterpart.proxyCounterpart)('INFO_BANNER_READ_MORE_LINK'),
	              target: '_blank',
	              className: 'info-banner-link'
	            },
	            _ref2
	          ),
	          _react2.default.createElement(
	            'div',
	            { onClick: this.closeInfoBanner, className: 'info-banner-close' },
	            _ref3
	          )
	        )
	      );
	    }
	  }]);
	  return InfoBanner;
	}(_react2.default.Component);
	
	exports.default = InfoBanner;

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(29);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _ssnvalidator = __webpack_require__(377);
	
	var _ssnvalidator2 = _interopRequireDefault(_ssnvalidator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 30/03/16.
	 */
	
	var FieldValidator = {
	  validate: function validate(props) {
	    var type = props.validationType ? props.validationType : props.type;
	    switch (type) {
	      case 'text':
	        return this.validateText(props);
	      case 'email':
	        return this.validateEmail(props);
	      case 'number':
	        return this.validateNumber(props);
	      case 'decimal':
	        return this.validateDecimal(props);
	      case 'tel':
	        return this.validateText(props);
	      case 'personalNumber':
	        return this.validatePersonalNumber(props);
	      case 'clearingNumber':
	        return this.validateClearingNumber(props);
	      case 'accountNumber':
	        return this.validateAccountNumber(props);
	      case 'passwordRegistration':
	        return this.validatePassword(props);
	      case 'phoneNumberSwedish':
	        return this.validatePhoneNumberSwedish(props);
	      case 'einvoice':
	        return this.validateEinvoiceAddress(props);
	      default:
	        return this.validateText(props);
	    }
	  },
	  validatePhoneNumberSwedish: function validatePhoneNumberSwedish(props) {
	    var normalized = props.value.toString().replace('(0)', '').replace(/\D+/gi, '');
	    var re = /^(07|467|\+467)(0|2|3|6|9)\d{7}$/;
	    return re.test(normalized);
	  },
	  validatePassword: function validatePassword(props) {
	    var re = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^a-zA-Z0-9])[\S ]{12,}$/;
	    return re.test(props.value);
	  },
	  validateText: function validateText(props) {
	    if (props.required && props.minLength > props.value.length || props.maxLength !== 0 && props.maxLength < props.value.length) {
	      return false;
	    } else {
	      return true;
	    }
	  },
	  validateEmail: function validateEmail(props) {
	    if (props.minLength === 0 && props.value.length === 0) {
	      return true;
	    }
	    /*eslint-disable */
	    var re = /^(([^<>()\[\]\\.,;:\s@"äöå]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([åäöa-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	    /*eslint-enable */
	    return re.test(props.value.trim());
	  },
	
	
	  /**
	   * Validate phone number that must have 10 characters and can have
	   * a hyphen after the third.
	   */
	  validateTel: function validateTel(props) {
	    /*eslint-disable */
	    var re = /^\d{3}-?\d{7}$/;
	    /*eslint-enable */
	
	    return re.test(props.value);
	  },
	  validatePersonalNumber: function validatePersonalNumber(props) {
	    return props.value.replace(/\D+/g, '').length === 12 && _ssnvalidator2.default.validateSSN(props.value);
	  },
	  validateNumber: function validateNumber(props) {
	    if ((props.value !== '' || props.required) && _utils2.default.isInt(props.value) && props.minLength <= props.value.length) {
	      return true;
	    } else {
	      return false;
	    }
	  },
	  validateDecimal: function validateDecimal(props) {
	    var re = /^\d+(?:\.\d{1,2})?$/;
	    if ((props.value !== '' || props.required) && re.test(props.value) && props.minLength <= props.value.length) {
	      return true;
	    } else {
	      return false;
	    }
	  },
	  validateClearingNumber: function validateClearingNumber(props) {
	    var re = /^[\d]{4}$/;
	    return re.test(props.value);
	  },
	  validateAccountNumber: function validateAccountNumber(props) {
	    var re = /\d/;
	    return re.test(props.value);
	  },
	  validateEinvoiceAddress: function validateEinvoiceAddress(props) {
	    return _utils2.default.isValidEinvoiceAddress(props.value);
	  }
	};
	
	exports.default = FieldValidator;

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InvoiceCalculator = undefined;
	
	var _getIterator2 = __webpack_require__(18);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _toConsumableArray2 = __webpack_require__(120);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _assign = __webpack_require__(22);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(233);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _calculatorPostEntity = __webpack_require__(344);
	
	var _calculatorPostEntity2 = _interopRequireDefault(_calculatorPostEntity);
	
	var _calculatorWorkerEntity = __webpack_require__(345);
	
	var _calculatorWorkerEntity2 = _interopRequireDefault(_calculatorWorkerEntity);
	
	var _invoiceToolHelper = __webpack_require__(50);
	
	var _amountHelper = __webpack_require__(58);
	
	var _index = __webpack_require__(43);
	
	var _entities = __webpack_require__(376);
	
	var entities = _interopRequireWildcard(_entities);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ = __webpack_require__(40); /**
	                            * Created by eriksundqvist on 15/11/16.
	                            */
	
	
	var CALCULATE_AMOUNT = 'calculate-amount';
	var CALCULATE_AMOUNT_WITH_LOCKED_USERS = 'calculate-amount-with-locked-users';
	var CALCULATE_SUPPLIER_LEDGE = 'calculate-supplier-ledge';
	var CALCULATE_SUPPLIER_LEDGE_WITH_LOCKED_USERS = 'calculate-supplier-ledge-with-locked-users';
	var CALCULATE_INVOICE_USER_LOCKED_AMOUNT = 'calculate-invoice-user-locked-amount';
	var CALCULATE_INVOICE_USER_AMOUNT = 'calculate-invoice-user-amount';
	var CALCULATE_INVOICE_USER_GROSS_SALARY = 'calculate-invoice-user-gross-salary';
	var CALCULATE_INVOICE_USER_NET_SALARY = 'calculate-invoice-user-net-salary';
	var CALCULATE_INVOICE_USER_ALLOWANCE = 'calculate-invoice-user-allowance';
	var CALCULATE_INVOICE_USER_TRAVEL = 'calculate-invoice-user-travel';
	var CALCULATE_INVOICE_USER_TAX = 'calculate-invoice-user-tax';
	var CALCULATE_INVOICE_USER_ADD_REMOVE = 'calculate-invoice-user-add-remove';
	var CALCULATE_INVOICE_EXPRESS_PAYMENT = 'calculate-invoice-express-payment';
	var CALCULATE_INVOICE_HSD = 'calculate-invoice-hsd';
	var CALCULATE_INVOICE_ITP_VACATION_CHANGE = 'calculate_invoice_itp_vacation_change';
	var CALCULATE_INVOICE_COUPON = 'calculate-invoice-coupon';
	var CALCULATE_INVOICE_INITIALIZING = 'calculate-invoice-initializing';
	
	var EXPRESS_PAYMENT_PERCENT = 1.5;
	
	var _ref3 = _react2.default.createElement('div', null);
	
	var InvoiceCalculator = exports.InvoiceCalculator = function (_React$Component) {
	  (0, _inherits3.default)(InvoiceCalculator, _React$Component);
	
	  function InvoiceCalculator(props) {
	    (0, _classCallCheck3.default)(this, InvoiceCalculator);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (InvoiceCalculator.__proto__ || (0, _getPrototypeOf2.default)(InvoiceCalculator)).call(this, props));
	
	    _this.state = {
	      justUpdated: null,
	      disableCalculation: false
	    };
	
	    _this.calculate = _this.calculate.bind(_this);
	    _this.parseCalculationResponse = _this.parseCalculationResponse.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(InvoiceCalculator, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!_.isEqual(nextProps, this.props) && !nextProps.invoice.initializing && !this.state.disableCalculation) {
	        var updated = void 0;
	        var value = void 0;
	
	        this.updatedWorker = null;
	
	        if (nextProps.invoice.invoiceUser.length !== this.props.invoice.invoiceUser.length && nextProps.invoice.amount !== 0) {
	          updated = CALCULATE_INVOICE_USER_ADD_REMOVE;
	          value = nextProps.invoice.invoiceUser;
	        }
	
	        var lockAmountDistribution = nextProps.invoice.lockAmountDistribution;
	        var lockAmountLength = (0, _keys2.default)(lockAmountDistribution).length;
	
	        if (!_.isEqual(nextProps.invoice.supplierLedger, this.props.invoice.supplierLedger)) {
	          if (lockAmountLength === 0) {
	            updated = CALCULATE_SUPPLIER_LEDGE;
	          } else {
	            updated = CALCULATE_SUPPLIER_LEDGE_WITH_LOCKED_USERS;
	          }
	          value = nextProps.invoice.amount;
	        }
	
	        if (nextProps.invoice.expressPayment !== this.props.invoice.expressPayment) {
	          updated = CALCULATE_INVOICE_EXPRESS_PAYMENT;
	          value = nextProps.invoice.amount;
	        }
	
	        if (nextProps.invoice.hsd.rot !== this.props.invoice.hsd.rot || nextProps.invoice.hsd.rut !== this.props.invoice.hsd.rut) {
	          updated = CALCULATE_INVOICE_HSD;
	          value = nextProps.invoice.amount;
	        }
	
	        if (!_.isEqual(nextProps.invoice.coupon, this.props.invoice.coupon)) {
	          updated = CALCULATE_INVOICE_COUPON;
	          value = nextProps.invoice.coupon;
	        }
	
	        if (nextProps.user.saveITP !== this.props.user.saveITP || nextProps.user.saveVacationPay !== this.props.user.saveVacationPay) {
	          updated = CALCULATE_INVOICE_ITP_VACATION_CHANGE;
	          value = nextProps.user;
	        }
	
	        if (!updated) {
	          if (nextProps.invoice.amount !== this.props.invoice.amount && lockAmountLength === 0 || nextProps.invoice.taxId !== this.props.invoice.taxId) {
	            updated = CALCULATE_AMOUNT;
	            value = nextProps.invoice.amount;
	          } else if (nextProps.invoice.amount !== this.props.invoice.amount) {
	            updated = CALCULATE_AMOUNT_WITH_LOCKED_USERS;
	            value = nextProps.invoice.amount;
	          }
	        }
	
	        if (!updated) {
	          var user = void 0;
	
	          for (var i = 0; i < nextProps.invoice.invoiceUser.length; i++) {
	            user = nextProps.invoice.invoiceUser[i];
	            var prevUser = void 0;
	            for (var _i = 0; _i < this.props.invoice.invoiceUser.length; _i++) {
	              if (parseInt(user.userId) === parseInt(this.props.invoice.invoiceUser[_i].userId)) {
	                prevUser = this.props.invoice.invoiceUser[_i];
	                break;
	              }
	            }
	
	            if (user && prevUser) {
	              if ((0, _amountHelper.toMoney)(user.gross) !== (0, _amountHelper.toMoney)(prevUser.gross)) {
	                updated = CALCULATE_INVOICE_USER_GROSS_SALARY;
	              } else if ((0, _amountHelper.toMoney)(user.net) !== (0, _amountHelper.toMoney)(prevUser.net)) {
	                updated = CALCULATE_INVOICE_USER_NET_SALARY;
	              } else if ((0, _amountHelper.toMoney)(user.allowance) !== (0, _amountHelper.toMoney)(prevUser.allowance)) {
	                updated = CALCULATE_INVOICE_USER_ALLOWANCE;
	              } else if ((0, _amountHelper.toMoney)(user.travel) !== (0, _amountHelper.toMoney)(prevUser.travel)) {
	                updated = CALCULATE_INVOICE_USER_TRAVEL;
	              } else if (user.taxkeyId !== prevUser.taxkeyId) {
	                updated = CALCULATE_INVOICE_USER_TAX;
	              } else if ((0, _amountHelper.toMoney)(user.total) !== (0, _amountHelper.toMoney)(prevUser.total) && lockAmountLength === 0) {
	                updated = CALCULATE_INVOICE_USER_AMOUNT;
	              } else if ((0, _amountHelper.toMoney)(user.total) !== (0, _amountHelper.toMoney)(prevUser.total) && lockAmountLength > 0) {
	                updated = CALCULATE_INVOICE_USER_LOCKED_AMOUNT;
	              }
	
	              if (updated) {
	                this.updatedWorker = user.userId;
	                break;
	              } else {
	                this.updatedWorker = null;
	              }
	            }
	          }
	
	          value = user;
	        }
	
	        if (!updated) {
	          if (this.props.invoice.initializing) {
	            updated = CALCULATE_INVOICE_INITIALIZING;
	          }
	        }
	
	        if (updated) {
	          this.calculate(updated, value, nextProps);
	        }
	      }
	    }
	  }, {
	    key: 'populateCalculatorWorkerEntity',
	    value: function populateCalculatorWorkerEntity(invoiceUser, updated, value, nextProps) {
	      var userData = invoiceUser;
	      if (value && value.userId && invoiceUser.userId === value.userId) {
	        userData = value;
	      }
	
	      var calculatorWorkerEntity = new _calculatorWorkerEntity2.default();
	      calculatorWorkerEntity.gross = null;
	      calculatorWorkerEntity.net = null;
	      calculatorWorkerEntity.amount = null;
	
	      var userId = this.updatedWorker;
	
	      if (userId === invoiceUser.userId) {
	        switch (updated) {
	          case CALCULATE_INVOICE_USER_GROSS_SALARY:
	            calculatorWorkerEntity.gross = +userData.gross;
	            break;
	          case CALCULATE_INVOICE_USER_NET_SALARY:
	            calculatorWorkerEntity.net = +userData.net;
	            break;
	          case CALCULATE_INVOICE_USER_LOCKED_AMOUNT:
	          case CALCULATE_INVOICE_USER_AMOUNT:
	          case CALCULATE_INVOICE_USER_ALLOWANCE:
	          case CALCULATE_INVOICE_USER_TRAVEL:
	          case CALCULATE_INVOICE_USER_TAX:
	            calculatorWorkerEntity.amount = +userData.total;
	            break;
	        }
	      } else if (nextProps.invoice.lockAmountDistribution[parseInt(invoiceUser.userId)]) {
	        calculatorWorkerEntity.amount = +userData.total;
	      } else if (_.includes([CALCULATE_INVOICE_INITIALIZING, CALCULATE_INVOICE_COUPON, CALCULATE_INVOICE_EXPRESS_PAYMENT, CALCULATE_INVOICE_ITP_VACATION_CHANGE, CALCULATE_INVOICE_HSD, CALCULATE_SUPPLIER_LEDGE, CALCULATE_SUPPLIER_LEDGE_WITH_LOCKED_USERS, CALCULATE_INVOICE_USER_ALLOWANCE, CALCULATE_INVOICE_USER_TRAVEL, CALCULATE_INVOICE_USER_TAX], updated)) {
	        calculatorWorkerEntity.amount = userData.total;
	      }
	      var itp = !!userData.saveItp;
	      var itpRate = userData.itpRate === undefined ? _frilansFinans.UserSettingsConstants.itpRateDefault : userData.itpRate;
	
	      var vacation = !!userData.saveVacationPay;
	
	      if (parseInt(userData.userId) === parseInt(this.props.user.id)) {
	        if (updated === CALCULATE_INVOICE_ITP_VACATION_CHANGE) {
	          itp = value.saveITP;
	          itpRate = value.itpRate;
	          vacation = value.saveVacationPay || false;
	        } else {
	          itp = this.props.user.saveITP;
	          itpRate = this.props.user.itpRate;
	          vacation = this.props.user.saveVacationPay || false;
	        }
	      }
	
	      var taxKey = void 0;
	      taxKey = userData.taxkeys.find(function (taxkey) {
	        return +taxkey.id === +userData.taxkeyId;
	      });
	
	      if (!taxKey) {
	        // Set to default taxkey if the taxkey wasn't found
	        taxKey = userData.taxkeys.find(function (taxkey) {
	          return +taxkey.id === +nextProps.user.defaultTaxkeyId;
	        });
	      }
	
	      calculatorWorkerEntity.id = userData.userId;
	      calculatorWorkerEntity.itp = itp;
	      calculatorWorkerEntity.itp_rate = itpRate;
	      calculatorWorkerEntity.vacation = vacation;
	      calculatorWorkerEntity.allowance = userData.allowance;
	      calculatorWorkerEntity.travel = userData.travel;
	      calculatorWorkerEntity.payroll_tax = taxKey ? taxKey.payrollTax : null;
	
	      if (nextProps.invoice.expressPayment) {
	        calculatorWorkerEntity.fee = taxKey ? taxKey.feeExpress : null;
	      } else {
	        calculatorWorkerEntity.fee = taxKey ? taxKey.fee : null;
	      }
	
	      var extraFee = nextProps.invoice.expressPayment ? EXPRESS_PAYMENT_PERCENT : 0;
	      if (updated === CALCULATE_INVOICE_COUPON && value) {
	        calculatorWorkerEntity.fee = value.discountValue + extraFee;
	      } else if (nextProps.invoice.coupon) {
	        calculatorWorkerEntity.fee = nextProps.invoice.coupon.discountValue + extraFee;
	      }
	
	      calculatorWorkerEntity.tax = taxKey ? taxKey.taxAmount : null;
	
	      return calculatorWorkerEntity;
	    }
	  }, {
	    key: 'calculate',
	    value: function calculate(updated, value, nextProps) {
	      var _this2 = this;
	
	      var calculatorPostEntity = new _calculatorPostEntity2.default();
	      if (!nextProps.invoice.taxId) {
	        return;
	      }
	
	      calculatorPostEntity.vat = (0, _invoiceToolHelper.getVatById)(nextProps.invoice.taxId);
	
	      var allInvoiceUser = nextProps.invoice.invoiceUser;
	      if (updated === CALCULATE_INVOICE_USER_ADD_REMOVE) {
	        allInvoiceUser = _.map(value, function (user) {
	          return (0, _assign2.default)({}, user);
	        });
	      }
	
	      var workers = [];
	
	      var sortedInvoiceUsers = [].concat((0, _toConsumableArray3.default)(allInvoiceUser.filter(function (_ref) {
	        var userId = _ref.userId;
	        return +userId === +nextProps.invoice.userId;
	      })), (0, _toConsumableArray3.default)(allInvoiceUser.filter(function (_ref2) {
	        var userId = _ref2.userId;
	        return +userId !== +nextProps.invoice.userId;
	      })));
	
	      for (var i = 0; i < sortedInvoiceUsers.length; i++) {
	        workers.push(this.populateCalculatorWorkerEntity(sortedInvoiceUsers[i], updated, value, nextProps));
	      }
	
	      calculatorPostEntity.workers = workers;
	
	      if (this.allWorkerAmountsSet(calculatorPostEntity)) {
	        calculatorPostEntity.amount = null;
	      } else {
	        calculatorPostEntity.amount = nextProps.invoice.amount;
	      }
	
	      calculatorPostEntity.rot = nextProps.invoice.hsd.rot;
	      calculatorPostEntity.rut = nextProps.invoice.hsd.rut;
	
	      this.setState({
	        justUpdated: updated
	      });
	
	      if (this.workerAmountOrInvoiceAmountSet(calculatorPostEntity)) {
	        // We need the taxes to get the correct VAT for each expense
	        if (nextProps.invoice.supplierLedger.length > 0) {
	          _frilansFinans.TaxService.get().then(function (taxes) {
	            calculatorPostEntity.expenses = _this2.getExpenses(nextProps.invoice.supplierLedger, taxes);
	            _frilansFinans.InvoiceService.getInvoiceCalculation(calculatorPostEntity).then(_this2.parseCalculationResponse);
	          });
	        } else {
	          _frilansFinans.InvoiceService.getInvoiceCalculation(calculatorPostEntity).then(this.parseCalculationResponse);
	        }
	      } else {
	        console.log('Ignored calculate request');
	      }
	    }
	  }, {
	    key: 'countWorkersSet',
	    value: function countWorkersSet(workers) {
	      var _this3 = this;
	
	      var notNullOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var workerAmountsSet = 0;
	
	      workers.forEach(function (worker) {
	        if (_this3.checkValueOrNotNull(worker.amount, notNullOnly) || _this3.checkValueOrNotNull(worker.net, notNullOnly) || _this3.checkValueOrNotNull(worker.gross, notNullOnly)) {
	          workerAmountsSet++;
	        }
	      });
	
	      return workerAmountsSet;
	    }
	  }, {
	    key: 'checkValueOrNotNull',
	    value: function checkValueOrNotNull(value) {
	      var notNullOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (notNullOnly) {
	        return value !== null;
	      }
	
	      return value && value !== null;
	    }
	  }, {
	    key: 'allWorkerAmountsSet',
	    value: function allWorkerAmountsSet(calculatorPostEntity) {
	      return calculatorPostEntity.workers.length === this.countWorkersSet(calculatorPostEntity.workers, true);
	    }
	  }, {
	    key: 'workerAmountOrInvoiceAmountSet',
	    value: function workerAmountOrInvoiceAmountSet(calculatorPostEntity) {
	      var invoiceAmountIsSet = typeof calculatorPostEntity.amount !== 'undefined' && calculatorPostEntity.amount !== null;
	      return invoiceAmountIsSet || this.countWorkersSet(calculatorPostEntity.workers) > 0;
	    }
	  }, {
	    key: 'getExpenses',
	    value: function getExpenses(supplierLedgers, taxes) {
	      var _this4 = this;
	
	      var expenses = [];
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        var _loop = function _loop() {
	          var s = _step.value;
	
	          var vat = 0;
	          var amount = s.amount;
	
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = (0, _getIterator3.default)(taxes), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var t = _step2.value;
	
	              if (parseInt(t.id) === parseInt(s.taxId)) {
	                vat = t.percent;
	              }
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	
	          var supplierLedgerType = _this4.props.supplierLedgerTypes.find(function (type) {
	            return parseInt(type.id) === parseInt(s.supplierLedgerTypeId);
	          });
	
	          expenses.push({
	            amount: amount,
	            vat: vat,
	            rot: supplierLedgerType.isRotRut,
	            rut: supplierLedgerType.isRotRut
	          });
	        };
	
	        for (var _iterator = (0, _getIterator3.default)(supplierLedgers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          _loop();
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return expenses;
	    }
	  }, {
	    key: 'parseCalculationResponse',
	    value: function parseCalculationResponse(response) {
	      if (!response) {
	        return;
	      }
	
	      this.setState({
	        disableCalculation: true
	      });
	
	      var invoiceUser = _.map(this.props.invoice.invoiceUser, function (user) {
	        return (0, _assign2.default)({}, user);
	      });
	
	      var totalInvoiceAmount = 0;
	      for (var i = 0; i < invoiceUser.length; i++) {
	        var userId = parseInt(invoiceUser[i].userId);
	        var calculation = void 0;
	        for (var j = 0; j < response.invoiceCalculations.length; j++) {
	          if (userId === parseInt(response.invoiceCalculations[j].userId)) {
	            calculation = response.invoiceCalculations[i];
	            break;
	          }
	        }
	
	        if (!calculation) {
	          calculation = {};
	          calculation.amount = 0;
	          calculation.gross = 0;
	          calculation.net = 0;
	          calculation.allowance = 0;
	          calculation.tax = 0;
	          calculation.travel = 0;
	          calculation.toPay = 0;
	        }
	
	        invoiceUser[i].calculation = calculation;
	        invoiceUser[i].total = calculation.amount;
	
	        invoiceUser[i].net = calculation.net;
	        invoiceUser[i].gross = calculation.gross;
	        invoiceUser[i].allowance = calculation.allowance;
	        invoiceUser[i].travel = calculation.travel;
	
	        var _iteratorNormalCompletion3 = true;
	        var _didIteratorError3 = false;
	        var _iteratorError3 = undefined;
	
	        try {
	          for (var _iterator3 = (0, _getIterator3.default)(invoiceUser[i].taxkeys), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	            var taxkey = _step3.value;
	
	            if (parseInt(taxkey.id) === parseInt(invoiceUser[i].taxkeyId)) {
	              invoiceUser[i].taxkeyName = taxkey.taxkeyName;
	            }
	          }
	        } catch (err) {
	          _didIteratorError3 = true;
	          _iteratorError3 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	              _iterator3.return();
	            }
	          } finally {
	            if (_didIteratorError3) {
	              throw _iteratorError3;
	            }
	          }
	        }
	      }
	
	      totalInvoiceAmount = Number(+response.amount);
	
	      this.props.setInvoiceUser(invoiceUser);
	      this.props.setAmount(totalInvoiceAmount);
	
	      var currentExchangeRate = entities.selectById(this.props.currencies.list, this.props.invoice.currencyId).exchangeRate;
	      var currencyAmount = totalInvoiceAmount / (currentExchangeRate || 1);
	      this.props.setCurrencyAmount(currencyAmount);
	
	      this.props.setAmountIncVat(response.amountIncludingVat);
	      this.props.setAmountAfterHsd(response.amountAfterHsd);
	
	      this.setState({
	        disableCalculation: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _ref3;
	    }
	  }]);
	  return InvoiceCalculator;
	}(_react2.default.Component);
	
	function mapStateToProps(state) {
	  return {
	    user: state.user,
	    invoice: state.invoice,
	    currencies: state.currencies,
	    supplierLedgerTypes: state.supplierLedgerTypes
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    setLockAmountDistribution: function setLockAmountDistribution(lockAmountDistribution) {
	      return dispatch((0, _index.setLockAmountDistribution)(lockAmountDistribution));
	    },
	    setCurrencyAmount: function setCurrencyAmount(currencyAmount) {
	      return dispatch((0, _index.setCurrencyAmount)(currencyAmount));
	    },
	    setAmount: function setAmount(amount) {
	      return dispatch((0, _index.setAmount)(amount));
	    },
	    setAmountIncVat: function setAmountIncVat(amountIncVat) {
	      return dispatch((0, _index.setAmountIncVat)(amountIncVat));
	    },
	    setInvoiceUser: function setInvoiceUser(invoiceUser) {
	      return dispatch((0, _index.setInvoiceUser)(invoiceUser));
	    },
	    setAmountAfterHsd: function setAmountAfterHsd(amountAfterHsd) {
	      return dispatch((0, _index.setAmountAfterHsd)(amountAfterHsd));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(InvoiceCalculator);

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InvoiceDetailsCustomerColumn = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'b',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_DETAILS_INVOICING_REFERENCE' }),
	  ':'
	);
	
	var _ref2 = _react2.default.createElement(
	  'b',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'EMAIL' }),
	  ' :'
	);
	
	var _ref3 = _react2.default.createElement(
	  'div',
	  { className: 'invoice-details-title' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_DETAILS_INVOICING_RECIPIENT' })
	);
	
	var _ref4 = _react2.default.createElement('div', { className: 'invoice-details-row-divider' });
	
	var InvoiceDetailsCustomerColumn = exports.InvoiceDetailsCustomerColumn = function (_React$Component) {
	  (0, _inherits3.default)(InvoiceDetailsCustomerColumn, _React$Component);
	
	  function InvoiceDetailsCustomerColumn() {
	    (0, _classCallCheck3.default)(this, InvoiceDetailsCustomerColumn);
	    return (0, _possibleConstructorReturn3.default)(this, (InvoiceDetailsCustomerColumn.__proto__ || (0, _getPrototypeOf2.default)(InvoiceDetailsCustomerColumn)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(InvoiceDetailsCustomerColumn, [{
	    key: 'render',
	    value: function render() {
	      var invoice = this.props.invoice;
	      if (invoice && invoice.customer) {
	        var reference = _react2.default.createElement(
	          'div',
	          { className: 'invoice-details-row' },
	          _ref,
	          ' ',
	          invoice.customer.contact
	        );
	
	        var email = invoice.customer.sendToEmail ? _react2.default.createElement(
	          'div',
	          { className: 'invoice-details-row' },
	          _ref2,
	          ' ',
	          invoice.customer.sendToEmail
	        ) : null;
	
	        return _react2.default.createElement(
	          'div',
	          {
	            className: 'invoice-details-row-column' + (this.props.showMoreIsVisible ? ' padding-no-top' : ' padding')
	          },
	          _ref3,
	          _react2.default.createElement(
	            'div',
	            { className: 'invoice-details-row' },
	            invoice.customer.name,
	            ', ',
	            invoice.customer.vatNr
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'invoice-details-row' },
	            invoice.customer.address.street
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'invoice-details-row' },
	            invoice.customer.address.zip,
	            ', ',
	            invoice.customer.address.city
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'invoice-details-row' },
	            invoice.customer.address.country
	          ),
	          _ref4,
	          reference,
	          email
	        );
	      }
	      return null;
	    }
	  }]);
	  return InvoiceDetailsCustomerColumn;
	}(_react2.default.Component);
	
	exports.default = InvoiceDetailsCustomerColumn;

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InvoiceDetailsInvoicingColumn = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _helper = __webpack_require__(363);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_reactTranslateComponent2.default, { className: 'invoice-details-title', content: 'INVOICE_DETAILS_INVOICING_DETAILS' });
	
	var _ref2 = _react2.default.createElement(
	  'b',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_DETAILS_INVOICING_ORDER_NUMBER' }),
	  ': '
	);
	
	var _ref3 = _react2.default.createElement(
	  'b',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_DETAILS_INVOICING_ORDER_SENT_AS' }),
	  ': '
	);
	
	var _ref4 = _react2.default.createElement('div', { className: 'invoice-details-row-divider' });
	
	var _ref5 = _react2.default.createElement(
	  'b',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_DETAILS_INVOICING_VIEW_HOURS' }),
	  ': '
	);
	
	var _ref6 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'YES' });
	
	var _ref7 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'NO' });
	
	var _ref8 = _react2.default.createElement(
	  'b',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_DETAILS_INVOICING_REGISTERED_ASSIGNMENT' }),
	  ': '
	);
	
	var _ref9 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'YES' });
	
	var _ref10 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'NO' });
	
	var InvoiceDetailsInvoicingColumn = exports.InvoiceDetailsInvoicingColumn = function (_React$Component) {
	  (0, _inherits3.default)(InvoiceDetailsInvoicingColumn, _React$Component);
	
	  function InvoiceDetailsInvoicingColumn() {
	    (0, _classCallCheck3.default)(this, InvoiceDetailsInvoicingColumn);
	    return (0, _possibleConstructorReturn3.default)(this, (InvoiceDetailsInvoicingColumn.__proto__ || (0, _getPrototypeOf2.default)(InvoiceDetailsInvoicingColumn)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(InvoiceDetailsInvoicingColumn, [{
	    key: 'isPreReported',
	    value: function isPreReported(invoice) {
	      return invoice.preReport || invoice.preReportedAt && !!Date.parse(invoice.preReportedAt);
	    }
	  }, {
	    key: 'messageTypeTranslated',
	    value: function messageTypeTranslated(messageType) {
	      switch (messageType) {
	        case 'email':
	          return (0, _proxyCounterpart.proxyCounterpart)('INVOICING_OPTION_EMAIL');
	        case 'mail':
	          return (0, _proxyCounterpart.proxyCounterpart)('INVOICING_OPTION_MAIL');
	        case 'sms':
	          return (0, _proxyCounterpart.proxyCounterpart)('INVOICING_OPTION_SMS');
	        case 'e-invoice':
	          return (0, _proxyCounterpart.proxyCounterpart)('INVOICING_OPTION_EINVOICE');
	        default:
	          return messageType;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var invoice = this.props.invoice;
	      if (invoice) {
	        return _react2.default.createElement(
	          'div',
	          {
	            className: 'invoice-details-row-column' + (this.props.showMoreIsVisible ? ' padding-no-top' : ' padding')
	          },
	          _ref,
	          _react2.default.createElement(
	            'div',
	            { className: 'invoice-details-row' },
	            _ref2,
	            invoice.id
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'invoice-details-row' },
	            _ref3,
	            this.messageTypeTranslated(invoice.messageType)
	          ),
	          (0, _helper.renderExtraInvoicingRows)(invoice),
	          _ref4,
	          _react2.default.createElement(
	            'div',
	            { className: 'invoice-details-row' },
	            _ref5,
	            invoice.displayHours ? _ref6 : _ref7
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'invoice-details-row' },
	            _ref8,
	            this.isPreReported(invoice) ? _ref9 : _ref10
	          )
	        );
	      }
	      return null;
	    }
	  }]);
	  return InvoiceDetailsInvoicingColumn;
	}(_react2.default.Component);
	
	exports.default = InvoiceDetailsInvoicingColumn;

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InvoiceDetailsRewards = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _utils = __webpack_require__(29);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_REWARDS_REGISTERED' });
	
	var _ref2 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_REWARDS_WAITING_ON_PAYMENT' });
	
	var _ref3 = _react2.default.createElement(_reactTranslateComponent2.default, { className: 'invoice-details-title', content: 'INVOICE_DETAILS_TOGETHER_REWARDS' });
	
	var _ref4 = _react2.default.createElement('div', { className: 'invoice-details-title hide-until-mobile' });
	
	var _ref5 = _react2.default.createElement(
	  'b',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_DETAILS_REWARDS_ORDER_NUMBER' }),
	  ': '
	);
	
	var _ref6 = _react2.default.createElement(
	  'b',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_DETAILS_REWARDS_POINTS' }),
	  ': '
	);
	
	var _ref7 = _react2.default.createElement('div', { className: 'invoice-details-column-divider small' });
	
	var _ref8 = _react2.default.createElement(
	  'b',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_DETAILS_REWARDS_REGISTERED_ASSIGNMENT' }),
	  ': '
	);
	
	var _ref9 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'YES' });
	
	var _ref10 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'NO' });
	
	var _ref11 = _react2.default.createElement(
	  'b',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_DETAILS_REWARDS_STATUS' }),
	  ': '
	);
	
	var InvoiceDetailsRewards = exports.InvoiceDetailsRewards = function (_React$Component) {
	  (0, _inherits3.default)(InvoiceDetailsRewards, _React$Component);
	
	  function InvoiceDetailsRewards() {
	    (0, _classCallCheck3.default)(this, InvoiceDetailsRewards);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (InvoiceDetailsRewards.__proto__ || (0, _getPrototypeOf2.default)(InvoiceDetailsRewards)).call(this));
	
	    _this.pointsStatus = _this.pointsStatus.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(InvoiceDetailsRewards, [{
	    key: 'pointsStatus',
	    value: function pointsStatus() {
	      if (this.props.invoice.paymentStatus === 2) {
	        return _ref;
	      }
	      return _ref2;
	    }
	  }, {
	    key: 'isPreReported',
	    value: function isPreReported(invoice) {
	      return invoice.preReport || invoice.preReportedAt && !!Date.parse(invoice.preReportedAt);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var invoice = this.props.invoice;
	      if (invoice) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'invoice-details-part-container' },
	          _ref3,
	          _react2.default.createElement(
	            'div',
	            { className: 'invoice-details-row-container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'invoice-details-row-column padding' },
	              _ref4,
	              _react2.default.createElement(
	                'div',
	                { className: 'invoice-details-row' },
	                _ref5,
	                invoice.id
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'invoice-details-row' },
	                _ref6,
	                _utils2.default.numberWithSpaces(_utils2.default.floor(invoice.loyaltyPoints))
	              )
	            ),
	            _ref7,
	            _react2.default.createElement(
	              'div',
	              { className: 'invoice-details-row-column padding' },
	              _react2.default.createElement(
	                'div',
	                { className: 'invoice-details-row' },
	                _ref8,
	                this.isPreReported(invoice) ? _ref9 : _ref10
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'invoice-details-row' },
	                _ref11,
	                ' ',
	                this.pointsStatus()
	              )
	            )
	          )
	        );
	      }
	      return null;
	    }
	  }]);
	  return InvoiceDetailsRewards;
	}(_react2.default.Component);
	
	exports.default = InvoiceDetailsRewards;

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InvoiceDetailsWorkerAmount = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _amountHelper = __webpack_require__(58);
	
	var _utils = __webpack_require__(29);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_reactTranslateComponent2.default, { className: 'invoice-details-amount-title', content: 'ALLOWANCE' });
	
	var _ref2 = _react2.default.createElement(_reactTranslateComponent2.default, { className: 'invoice-details-amount-title', content: 'TRAVEL_ALLOWANCE' });
	
	var _ref3 = _react2.default.createElement(_reactTranslateComponent2.default, { className: 'invoice-details-amount-title', content: 'REVIEW_AND_CREATE_INVOICE_TO_PAY' });
	
	var _ref4 = _react2.default.createElement(_reactTranslateComponent2.default, { className: 'invoice-details-amount-title', content: 'REVIEW_AND_CREATE_INVOICE_TO_PAY_ITP' });
	
	var _ref5 = _react2.default.createElement(_reactTranslateComponent2.default, { className: 'invoice-details-amount-title', content: 'REVIEW_AND_CREATE_INVOICE_TO_PAY_VACATION' });
	
	var _ref6 = _react2.default.createElement(_reactTranslateComponent2.default, { className: 'invoice-details-amount-title', content: 'REVIEW_AND_CREATE_INVOICE_TO_BE_PAID_TOTAL' });
	
	var InvoiceDetailsWorkerAmount = exports.InvoiceDetailsWorkerAmount = function (_React$Component) {
	  (0, _inherits3.default)(InvoiceDetailsWorkerAmount, _React$Component);
	
	  function InvoiceDetailsWorkerAmount(props) {
	    (0, _classCallCheck3.default)(this, InvoiceDetailsWorkerAmount);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (InvoiceDetailsWorkerAmount.__proto__ || (0, _getPrototypeOf2.default)(InvoiceDetailsWorkerAmount)).call(this, props));
	
	    _this.state = {
	      showWorkers: false
	    };
	
	    _this.showWorkers = _this.showWorkers.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(InvoiceDetailsWorkerAmount, [{
	    key: 'isOwner',
	    value: function isOwner(worker) {
	      return worker.userId === this.props.user.userId;
	    }
	  }, {
	    key: 'toPayAmount',
	    value: function toPayAmount(worker) {
	      var toPay = worker.net + worker.allowance + worker.travel;
	      if (this.isOwner(worker)) {
	        toPay += this.props.outlaysAmount;
	      }
	      return toPay;
	    }
	  }, {
	    key: 'pensionAmount',
	    value: function pensionAmount(worker) {
	      var vacationRate = worker.saveVacationPay ? 1.12 : 1;
	      var gross = worker.gross * vacationRate;
	      return gross * worker.itpRate;
	    }
	  }, {
	    key: 'vacationAmount',
	    value: function vacationAmount(worker) {
	      return worker.saveVacationPay ? worker.gross * 0.12 : 0;
	    }
	  }, {
	    key: 'getAmountWithCurrency',
	    value: function getAmountWithCurrency(amount) {
	      return _utils2.default.amountWithCurrency((0, _amountHelper.toMoney)(amount), this.props.currencyId);
	    }
	  }, {
	    key: 'workerAllowance',
	    value: function workerAllowance(worker) {
	      if (worker.allowance) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'invoice-details-allowance-details' },
	          _ref,
	          _react2.default.createElement(
	            'div',
	            { className: 'invoice-details-amount-title' },
	            this.getAmountWithCurrency(worker.allowance)
	          )
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'workerTravel',
	    value: function workerTravel(worker) {
	      if (worker.travel) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'invoice-details-allowance-details' },
	          _ref2,
	          _react2.default.createElement(
	            'div',
	            { className: 'invoice-details-amount-title' },
	            this.getAmountWithCurrency(worker.travel)
	          )
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'workerToPay',
	    value: function workerToPay(worker) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'invoice-details-amount-details green' },
	        _ref3,
	        _react2.default.createElement(
	          'div',
	          { className: 'invoice-details-amount-title' },
	          this.getAmountWithCurrency(this.toPayAmount(worker))
	        )
	      );
	    }
	  }, {
	    key: 'workerPension',
	    value: function workerPension(worker) {
	      if (worker.saveItp) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'invoice-details-amount-details light-green' },
	          _ref4,
	          _react2.default.createElement(
	            'div',
	            { className: 'invoice-details-amount-title' },
	            this.getAmountWithCurrency(this.pensionAmount(worker))
	          )
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'workerVacation',
	    value: function workerVacation(worker) {
	      if (worker.saveVacationPay) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'invoice-details-amount-details light-green' },
	          _ref5,
	          _react2.default.createElement(
	            'div',
	            { className: 'invoice-details-amount-title' },
	            this.getAmountWithCurrency(this.vacationAmount(worker))
	          )
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'totalNet',
	    value: function totalNet(worker) {
	      var amount = this.toPayAmount(worker) + this.pensionAmount(worker) + this.vacationAmount(worker);
	      return _react2.default.createElement(
	        'div',
	        { className: 'invoice-details-amount-details white' },
	        _ref6,
	        _react2.default.createElement(
	          'div',
	          { className: 'invoice-details-amount-title' },
	          this.getAmountWithCurrency(amount)
	        )
	      );
	    }
	  }, {
	    key: 'renderAllowanceContainer',
	    value: function renderAllowanceContainer(worker) {
	      if (this.props.user.allowance || this.props.user.travel) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'invoice-details-allowance-container' },
	          this.workerAllowance(worker),
	          this.workerTravel(worker)
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderWorkerAmounts',
	    value: function renderWorkerAmounts() {
	      var _this2 = this;
	
	      var workers = [];
	      var owner = void 0;
	
	      this.props.invoice.invoiceUsers.forEach(function (worker) {
	        var workerTitle = _this2.isOwner(worker) ? _react2.default.createElement(
	          'div',
	          { className: 'invoice-details-title' },
	          (0, _proxyCounterpart.proxyCounterpart)('INVOICE_DETAILS_YOUR_COMPENSATION')
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'invoice-details-title text-transform-none' },
	          worker.firstName,
	          ' ',
	          worker.lastName
	        );
	        var workerAmounts = _react2.default.createElement(
	          'div',
	          { key: worker.userId },
	          workerTitle,
	          _this2.renderAllowanceContainer(worker),
	          _react2.default.createElement(
	            'div',
	            { className: 'invoice-details-amount-container margin-bottom' },
	            _this2.workerToPay(worker),
	            _this2.workerPension(worker),
	            _this2.workerVacation(worker),
	            _this2.totalNet(worker)
	          )
	        );
	
	        if (_this2.isOwner(worker)) {
	          owner = workerAmounts;
	        } else {
	          workers.push(workerAmounts);
	        }
	      });
	      var coworkersTitle = this.props.invoice.invoiceUsers.length > 1 ? _react2.default.createElement(
	        'div',
	        {
	          className: 'invoice-details-title clickable',
	          onClick: this.showWorkers
	        },
	        this.state.showWorkers ? '- ' : '+ ',
	        (0, _proxyCounterpart.proxyCounterpart)('COWORKERS')
	      ) : null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'invoice-details-part-container' },
	        owner,
	        coworkersTitle,
	        this.state.showWorkers ? workers : null
	      );
	    }
	  }, {
	    key: 'showWorkers',
	    value: function showWorkers() {
	      this.setState({
	        showWorkers: !this.state.showWorkers
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.renderWorkerAmounts();
	    }
	  }]);
	  return InvoiceDetailsWorkerAmount;
	}(_react2.default.Component);
	
	exports.default = InvoiceDetailsWorkerAmount;

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InvoiceDetailsWorkers = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _amountHelper = __webpack_require__(58);
	
	var _utils = __webpack_require__(29);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _frilansFinans = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'b',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'EMAIL' }),
	  ': '
	);
	
	var _ref2 = _react2.default.createElement(
	  'b',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'TELEPHONE_NR' }),
	  ': '
	);
	
	var _ref3 = _react2.default.createElement('div', { className: 'invoice-details-row-divider' });
	
	var _ref4 = _react2.default.createElement(
	  'div',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'TO_ACCOUNT' })
	);
	
	var _ref5 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SALARY_GROSS' });
	
	var _ref6 = _react2.default.createElement(
	  'div',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'OMR_KEY' })
	);
	
	var _ref7 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SALARY_NET' });
	
	var _ref8 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ALLOWANCE' });
	
	var _ref9 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'TRAVEL_ALLOWANCE' });
	
	var _ref10 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_DETAILS_REWARDS_TO_PAY' });
	
	var _ref11 = _react2.default.createElement(_reactTranslateComponent2.default, { className: 'invoice-details-title', content: 'INVOICE_DETAILS_COMPENSATION' });
	
	var InvoiceDetailsWorkers = exports.InvoiceDetailsWorkers = function (_React$Component) {
	  (0, _inherits3.default)(InvoiceDetailsWorkers, _React$Component);
	
	  function InvoiceDetailsWorkers() {
	    (0, _classCallCheck3.default)(this, InvoiceDetailsWorkers);
	    return (0, _possibleConstructorReturn3.default)(this, (InvoiceDetailsWorkers.__proto__ || (0, _getPrototypeOf2.default)(InvoiceDetailsWorkers)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(InvoiceDetailsWorkers, [{
	    key: 'outlaysSum',
	    value: function outlaysSum() {
	      return this.props.outlays.reduce(function (a, b) {
	        return a + b.amountIncVat;
	      }, 0);
	    }
	  }, {
	    key: 'workers',
	    value: function workers() {
	      var _this2 = this;
	
	      var workers = [];
	
	      this.props.invoice.invoiceUsers.forEach(function (worker) {
	        var isInvoiceCreator = parseInt(worker.userId) === parseInt(_this2.props.invoice.userId);
	
	        var gross = null;
	        var net = null;
	        var allowance = null;
	        var travel = null;
	        var toPay = null;
	        if (_this2.props.invoice.salaries) {
	          var salary = _this2.props.invoice.salaries.find(function (salary) {
	            return salary.userId === worker.userId && [1, 2, 4].includes(salary.categoryId) && salary.typeId === _frilansFinans.SalaryTypeConstants.REGULAR_TYPE;
	          });
	          if (salary) {
	            gross = salary.grossIncTaxAgencyPart();
	            net = salary.netIncTaxAgencyPart();
	            allowance = salary.allowance;
	            travel = salary.travel;
	            toPay = salary.toPayIncTaxAgencyPart();
	          }
	        }
	
	        if (toPay === null) {
	          gross = worker.gross ? worker.gross : 0;
	          net = worker.net;
	          allowance = worker.allowance;
	          travel = worker.travel;
	          toPay = worker.net + worker.allowance + worker.travel;
	        }
	
	        if (isInvoiceCreator) {
	          toPay = toPay + _this2.outlaysSum();
	        }
	
	        var email = null;
	        var telephone = null;
	        if (+_this2.props.user.id === worker.userId) {
	          if (_this2.props.user.email) {
	            email = _react2.default.createElement(
	              'div',
	              { className: 'invoice-details-row' },
	              _ref,
	              _this2.props.user.email
	            );
	          }
	
	          if (_this2.props.user.cellphone) {
	            telephone = _react2.default.createElement(
	              'div',
	              { className: 'invoice-details-row' },
	              _ref2,
	              _this2.props.user.cellphone
	            );
	          }
	        }
	
	        workers.push(_react2.default.createElement(
	          'div',
	          { key: worker.id + worker.firstName },
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'invoice-details-row-container'
	            },
	            _react2.default.createElement(
	              'div',
	              { className: 'invoice-details-row-column justify-center padding-left' },
	              _react2.default.createElement(
	                'div',
	                { className: 'invoice-details-title' },
	                worker.firstName,
	                ' ',
	                worker.lastName
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'invoice-details-row' },
	                worker.street
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'invoice-details-row' },
	                worker.zip,
	                ', ',
	                worker.city
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'invoice-details-row' },
	                worker.country
	              ),
	              _ref3,
	              email,
	              telephone
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'invoice-details-row-column' },
	              _react2.default.createElement(
	                'div',
	                { className: 'invoice-details-row light flex' },
	                _ref4,
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  worker.accountClearingNumber,
	                  ' ',
	                  worker.accountNumber
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'invoice-details-row white flex' },
	                _ref5,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'uppercase' },
	                  _utils2.default.amountWithCurrency((0, _amountHelper.toMoney)(gross), 1)
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'invoice-details-row light flex' },
	                _ref6,
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  (0, _amountHelper.toMoney)((1 - worker.net / worker.gross) * 100),
	                  ' %'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'invoice-details-row white flex' },
	                _ref7,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'uppercase' },
	                  _utils2.default.amountWithCurrency((0, _amountHelper.toMoney)(net), 1)
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'invoice-details-row light flex' },
	                _ref8,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'uppercase' },
	                  _utils2.default.amountWithCurrency((0, _amountHelper.toMoney)(allowance), 1)
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'invoice-details-row white flex' },
	                _ref9,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'uppercase' },
	                  _utils2.default.amountWithCurrency((0, _amountHelper.toMoney)(travel), 1)
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'invoice-details-row light flex bold' },
	                _ref10,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'uppercase' },
	                  _utils2.default.amountWithCurrency((0, _amountHelper.toMoney)(toPay), 1)
	                )
	              )
	            )
	          )
	        ));
	      });
	      return workers;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var invoice = this.props.invoice;
	      if (invoice) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'invoice-details-part-container' },
	          _ref11,
	          _react2.default.createElement(
	            'div',
	            { className: 'invoice-details-workers-container' },
	            this.workers()
	          )
	        );
	      }
	      return null;
	    }
	  }]);
	  return InvoiceDetailsWorkers;
	}(_react2.default.Component);
	
	exports.default = InvoiceDetailsWorkers;

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Ambassador = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NO_TRANSLATION = ' ';
	
	var _ref = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'BECOME_CLIENT_ENTER_CONTEST' });
	
	var _ref2 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'BECOME_CLIENT_ENTER_CONTEST' });
	
	var _ref3 = _react2.default.createElement(
	  'a',
	  { className: 'btn primary', to: '', onClick: '' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'DASHBOARD_CTA_POST_BUTTON_TEXT' })
	);
	
	var _ref4 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'DASHBOARD_CTA_POST_BUTTON_TEXT' });
	
	var _ref5 = _react2.default.createElement(
	  'h2',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'DASHBOARD_CTA_POST_TITLE' })
	);
	
	var _ref6 = _react2.default.createElement(
	  'h3',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'DASHBOARD_CTA_POST_SUBTITLE' })
	);
	
	var _ref7 = _react2.default.createElement(
	  'p',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'DASHBOARD_CTA_POST_CONTENT' })
	);
	
	var Ambassador = exports.Ambassador = function (_React$Component) {
	  (0, _inherits3.default)(Ambassador, _React$Component);
	
	  function Ambassador(props) {
	    (0, _classCallCheck3.default)(this, Ambassador);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Ambassador.__proto__ || (0, _getPrototypeOf2.default)(Ambassador)).call(this, props));
	
	    _this.renderButton = function () {
	      var buttonUrl = (0, _proxyCounterpart.proxyCounterpart)('BECOME_CLIENT_BUTTON_URL', { fallback: NO_TRANSLATION });
	
	      if (buttonUrl === NO_TRANSLATION) {
	        return _react2.default.createElement(
	          'a',
	          { className: 'btn primary', to: '', onClick: _this.openModal },
	          _ref
	        );
	      }
	
	      return _react2.default.createElement(
	        'a',
	        { className: 'btn primary', href: buttonUrl, target: '_blank' },
	        _ref2
	      );
	    };
	
	    _this.imageUrlFromTranslations = function () {
	      var imageUrl = (0, _proxyCounterpart.proxyCounterpart)('BECOME_CLIENT_IMAGE_URL', { fallback: NO_TRANSLATION });
	      return imageUrl === NO_TRANSLATION ? null : imageUrl;
	    };
	
	    _this.renderCtaButton = function () {
	      var buttonUrl = (0, _proxyCounterpart.proxyCounterpart)('DASHBOARD_CTA_POST_BUTTON_URL', { fallback: NO_TRANSLATION });
	
	      if (buttonUrl === NO_TRANSLATION) {
	        return _ref3;
	      }
	
	      return _react2.default.createElement(
	        'a',
	        { className: 'btn primary', href: buttonUrl, target: '_blank' },
	        _ref4
	      );
	    };
	
	    _this.ctaPostimageUrlFromTranslations = function () {
	      var imageUrl = (0, _proxyCounterpart.proxyCounterpart)('DASHBOARD_CTA_POST_IMAGE_URL', { fallback: NO_TRANSLATION });
	      return imageUrl === NO_TRANSLATION ? null : imageUrl;
	    };
	
	    _this.renderCtaPost = function () {
	      var imageUrl = _this.ctaPostimageUrlFromTranslations();
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _ref5,
	        _react2.default.createElement('div', { className: 'client-image', style: { backgroundImage: 'url(' + imageUrl + ')' } }),
	        _react2.default.createElement(
	          'div',
	          null,
	          _ref6,
	          _ref7,
	          _this.renderCtaButton()
	        )
	      );
	    };
	
	    _this.render = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'col-md-6 col-md-offset-1 ambassador' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _this.renderCtaPost()
	        )
	      );
	    };
	
	    _this.state = {
	      modalIsOpen: false
	    };
	    return _this;
	  }
	
	  return Ambassador;
	}(_react2.default.Component);
	
	exports.default = Ambassador;

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LeftSection = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sideMenuContainer = __webpack_require__(707);
	
	var _sideMenuContainer2 = _interopRequireDefault(_sideMenuContainer);
	
	var _infoBoxList = __webpack_require__(337);
	
	var _infoBoxList2 = _interopRequireDefault(_infoBoxList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_infoBoxList2.default, null); /**
	                                                                        * Created by staffanrantzow on 15/03/16.
	                                                                        */
	
	var LeftSection = exports.LeftSection = function (_React$Component) {
	  (0, _inherits3.default)(LeftSection, _React$Component);
	
	  function LeftSection() {
	    (0, _classCallCheck3.default)(this, LeftSection);
	    return (0, _possibleConstructorReturn3.default)(this, (LeftSection.__proto__ || (0, _getPrototypeOf2.default)(LeftSection)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LeftSection, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'left-section' },
	        _react2.default.createElement(_sideMenuContainer2.default, { currentPath: this.props.currentPath }),
	        _ref
	      );
	    }
	  }]);
	  return LeftSection;
	}(_react2.default.Component);
	
	exports.default = LeftSection;

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PageTitle = undefined;
	
	var _getIterator2 = __webpack_require__(18);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageTitle = exports.PageTitle = function (_React$Component) {
	  (0, _inherits3.default)(PageTitle, _React$Component);
	
	  function PageTitle(props) {
	    (0, _classCallCheck3.default)(this, PageTitle);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PageTitle.__proto__ || (0, _getPrototypeOf2.default)(PageTitle)).call(this, props));
	
	    _this.state = {
	      title: ''
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(PageTitle, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      setTimeout(this.updatePageTitle.bind(this), 1);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      setTimeout(this.updatePageTitle.bind(this), 1);
	    }
	  }, {
	    key: 'updatePageTitle',
	    value: function updatePageTitle() {
	      var selected = document.querySelectorAll('.side-menu .selected span');
	      var pageTitle = '';
	      var titles = [];
	
	      if (window.innerWidth > 400) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(selected), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var s = _step.value;
	
	            titles.push(s.textContent);
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        pageTitle = titles.join(' - ');
	      } else {
	        if (selected.length > 0) {
	          pageTitle = selected[selected.length - 1].textContent;
	        }
	      }
	
	      if (this.state.title !== pageTitle) {
	        this.setState({
	          title: pageTitle
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        this.state.title
	      );
	    }
	  }]);
	  return PageTitle;
	}(_react2.default.Component); /**
	                               * Created by staffanrantzow on 22/04/16.
	                               */
	
	exports.default = PageTitle;

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(12);
	
	var _index = __webpack_require__(368);
	
	var _sideMenu = __webpack_require__(708);
	
	var _sideMenu2 = _interopRequireDefault(_sideMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    clear: function clear() {
	      return dispatch((0, _index.clear)());
	    }
	  };
	}; /**
	    * Created by eriksundqvist on 25/05/16.
	    */
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(_sideMenu2.default);

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SideMenu = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(20);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _pageTitle = __webpack_require__(706);
	
	var _pageTitle2 = _interopRequireDefault(_pageTitle);
	
	var _velocityAnimate = __webpack_require__(317);
	
	var _velocityAnimate2 = _interopRequireDefault(_velocityAnimate);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _variables = __webpack_require__(47);
	
	var variables = _interopRequireWildcard(_variables);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var previousWidth = window.innerWidth; /**
	                                        * Created by staffanrantzow on 15/03/16.
	                                        */
	
	var NO_TRANSLATION = ' ';
	
	var _ref = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'BECOME_AMBASSADOR' });
	
	var _ref2 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'FIND_ASSIGNMENTS' });
	
	var _ref3 = _react2.default.createElement(_pageTitle2.default, null);
	
	var _ref4 = _react2.default.createElement(
	  'h2',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'MY_PAGES' })
	);
	
	var _ref5 = _react2.default.createElement(
	  'li',
	  null,
	  _react2.default.createElement(
	    _reactRouter.Link,
	    { to: '/activities', activeClassName: 'selected' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ACTIVITIES' })
	  )
	);
	
	var _ref6 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'MENU_MY_INVOICING' });
	
	var _ref7 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICES' });
	
	var _ref8 = _react2.default.createElement(
	  'li',
	  null,
	  _react2.default.createElement(
	    _reactRouter.Link,
	    { to: '/economy/register-assignment', activeClassName: 'selected' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'MENU_PREREGISTERED_INVOICES' })
	  )
	);
	
	var _ref9 = _react2.default.createElement(
	  'li',
	  null,
	  _react2.default.createElement(
	    _reactRouter.Link,
	    { to: '/economy/salaries', activeClassName: 'selected' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SALARIES' })
	  )
	);
	
	var _ref10 = _react2.default.createElement(
	  'li',
	  null,
	  _react2.default.createElement(
	    _reactRouter.Link,
	    { to: '/economy/supplier-ledgers', activeClassName: 'selected' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'DEDUCTIONS' })
	  )
	);
	
	var _ref11 = _react2.default.createElement(
	  'li',
	  null,
	  _react2.default.createElement(
	    _reactRouter.Link,
	    { to: '/economy/employercertificates', activeClassName: 'selected' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'EMPLOYER_CERTIFICATE' })
	  )
	);
	
	var _ref12 = _react2.default.createElement(
	  'li',
	  null,
	  _react2.default.createElement(
	    _reactRouter.Link,
	    { to: '/economy/agreements', activeClassName: 'selected' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CONTRACTS' })
	  )
	);
	
	var _ref13 = _react2.default.createElement(
	  'li',
	  null,
	  _react2.default.createElement(
	    _reactRouter.Link,
	    { to: '/economy/loyalty-program/points', activeClassName: 'selected' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'MENU_LOYALTY_PAGE' })
	  )
	);
	
	var _ref14 = _react2.default.createElement(
	  'li',
	  null,
	  _react2.default.createElement(
	    _reactRouter.Link,
	    { to: '/economy/incomestatements', activeClassName: 'selected' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CONTROL_STATEMENT' })
	  )
	);
	
	var _ref15 = _react2.default.createElement(
	  'li',
	  null,
	  _react2.default.createElement(
	    _reactRouter.Link,
	    { to: '/customers', activeClassName: 'selected' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'MY_CUSTOMERS' })
	  )
	);
	
	var _ref16 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SETTINGS' });
	
	var _ref17 = _react2.default.createElement(
	  'ul',
	  { className: 'side-sub-menu' },
	  _react2.default.createElement(
	    'li',
	    null,
	    _react2.default.createElement(
	      _reactRouter.Link,
	      { to: '/settings/personal-information', activeClassName: 'selected' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PERSONAL_INFO' })
	    )
	  ),
	  _react2.default.createElement(
	    'li',
	    null,
	    _react2.default.createElement(
	      _reactRouter.Link,
	      { to: '/settings/salary-information', activeClassName: 'selected' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SALARY_INFO' })
	    )
	  ),
	  _react2.default.createElement(
	    'li',
	    null,
	    _react2.default.createElement(
	      _reactRouter.Link,
	      { to: '/settings/own-employment', activeClassName: 'selected' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'OWN_EMPLOYMENT' })
	    )
	  ),
	  _react2.default.createElement(
	    'li',
	    null,
	    _react2.default.createElement(
	      _reactRouter.Link,
	      { to: '/settings/change-password', activeClassName: 'selected' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CHANGE_PASSWORD' })
	    )
	  )
	);
	
	var _ref18 = _react2.default.createElement(
	  'li',
	  null,
	  _react2.default.createElement('div', { className: 'menu-divider' })
	);
	
	var _ref19 = _react2.default.createElement(
	  'li',
	  null,
	  _react2.default.createElement(
	    _reactRouter.Link,
	    { to: '/faq', activeClassName: 'selected' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'FAQ' })
	  )
	);
	
	var _ref20 = _react2.default.createElement(
	  'li',
	  null,
	  _react2.default.createElement(
	    _reactRouter.Link,
	    { to: '/insurances', activeClassName: 'selected' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INSURANCES' })
	  )
	);
	
	var _ref21 = _react2.default.createElement(
	  'li',
	  null,
	  _react2.default.createElement(
	    _reactRouter.Link,
	    { to: '/working-environment', activeClassName: 'selected' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'WORKING_ENVIRONMENT' })
	  )
	);
	
	var _ref22 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CHECK_YOUR_WORK_ENVIRONMENT' });
	
	var _ref23 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'REPORT_ACCIDENT' });
	
	var _ref24 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CALCULATOR' });
	
	var _ref25 = _react2.default.createElement(
	  'li',
	  null,
	  _react2.default.createElement(
	    _reactRouter.Link,
	    { to: '/news', activeClassName: 'selected' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'NEWS' })
	  )
	);
	
	var SideMenu = exports.SideMenu = function (_React$Component) {
	  (0, _inherits3.default)(SideMenu, _React$Component);
	
	  function SideMenu(props) {
	    (0, _classCallCheck3.default)(this, SideMenu);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SideMenu.__proto__ || (0, _getPrototypeOf2.default)(SideMenu)).call(this, props));
	
	    _this.state = {
	      browserWidth: 0,
	      mobileBreakPoint: 960,
	      mobileMenuOpen: false,
	      mobileStyles: {},
	      pageTitle: '',
	      modalIsOpen: false
	    };
	
	    _this.onMenuClick = _this.onMenuClick.bind(_this);
	    _this.toggleMenu = _this.toggleMenu.bind(_this);
	    _this.scrollListener = _this.scrollListener.bind(_this);
	    _this.toggleSubMenu = _this.toggleSubMenu.bind(_this);
	    _this.openModal = _this.openModal.bind(_this);
	    _this.onCloseModal = _this.onCloseModal.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(SideMenu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({
	        browserWidth: window.innerWidth
	      }, function () {
	        if (window.innerWidth < this.state.mobileBreakPoint) {
	          this.addListeners();
	        }
	        window.onresize = this.setMobileListeners.bind(this);
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.onresize = null;
	      this.removeListeners();
	    }
	  }, {
	    key: 'setMobileListeners',
	    value: function setMobileListeners() {
	      if (previousWidth !== window.innerWidth) {
	        if (window.innerWidth <= this.state.mobileBreakPoint && previousWidth > this.state.mobileBreakPoint) {
	          this.addListeners();
	        } else if (window.innerWidth >= this.state.mobileBreakPoint && previousWidth < this.state.mobileBreakPoint) {
	          this.removeListeners();
	        }
	      }
	
	      previousWidth = window.innerWidth;
	    }
	  }, {
	    key: 'addListeners',
	    value: function addListeners() {
	      window.addEventListener('scroll', this.scrollListener, false);
	      this.setMaxHeight();
	      this.refs.menu.style.display = 'none';
	      document.querySelector('body').classList.remove('side-menu-open');
	      this.setState({
	        mobileMenuOpen: false
	      });
	    }
	  }, {
	    key: 'removeListeners',
	    value: function removeListeners() {
	      window.removeEventListener('scroll', this.scrollListener, false);
	      this.refs.menu.style.maxHeight = 'auto';
	      this.refs.menu.style.display = 'block';
	    }
	
	    /**
	     * On some pages the menu can be higher than the page it self
	     * We need to calculate a max height in that case
	     */
	
	  }, {
	    key: 'setMaxHeight',
	    value: function setMaxHeight() {
	      var headerHeight = document.querySelector('.mobile-header').clientHeight;
	
	      this.setState({
	        mobileStyles: {
	          maxHeight: window.innerHeight - headerHeight
	        }
	      });
	    }
	  }, {
	    key: 'scrollListener',
	    value: function scrollListener() {
	      var scrollTop = window.scrollY ? window.scrollY : window.pageYOffset;
	
	      if (scrollTop > 100) {
	        this.refs.wrapper.classList.add('sticky');
	      } else {
	        this.refs.wrapper.classList.remove('sticky');
	      }
	    }
	  }, {
	    key: 'toggleMenu',
	    value: function toggleMenu() {
	      var _this2 = this;
	
	      this.setState({
	        mobileMenuOpen: !this.state.mobileMenuOpen
	      }, function () {
	        if (_this2.state.mobileMenuOpen) {
	          document.querySelector('body').classList.add('side-menu-open');
	          (0, _velocityAnimate2.default)(_this2.refs.menu, 'slideDown', { duration: 300 });
	        } else {
	          document.querySelector('body').classList.remove('side-menu-open');
	          (0, _velocityAnimate2.default)(_this2.refs.menu, 'slideUp', { duration: 300 });
	        }
	      });
	    }
	
	    /**
	     * On click for sub menu header (economy and settings)
	     * Don't toggle the menu when you click on them b
	     * stopping propagation to toggleMenu()
	     */
	
	  }, {
	    key: 'toggleSubMenu',
	    value: function toggleSubMenu(e) {
	      e.stopPropagation();
	    }
	  }, {
	    key: 'onMenuClick',
	    value: function onMenuClick() {
	      if (window.innerWidth <= this.state.mobileBreakPoint) {
	        this.toggleMenu();
	      }
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      window.removeEventListener('scroll', this.scrollListener, false);
	      window.onresize = null;
	    }
	  }, {
	    key: 'onCloseModal',
	    value: function onCloseModal() {
	      this.setState({
	        modalIsOpen: false
	      });
	    }
	  }, {
	    key: 'openModal',
	    value: function openModal(e) {
	      e.preventDefault();
	
	      this.setState({
	        modalIsOpen: true
	      });
	    }
	  }, {
	    key: 'renderBecomeAmbassadorListItem',
	    value: function renderBecomeAmbassadorListItem() {
	      return _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: variables.frontUrl + '/ambassador', target: '_blank' },
	          _ref
	        )
	      );
	    }
	  }, {
	    key: 'renderFindAssignmentListItem',
	    value: function renderFindAssignmentListItem() {
	      var findAssignmentLink = (0, _proxyCounterpart.proxyCounterpart)('FIND_ASSIGNMENTS_LINK', { fallback: NO_TRANSLATION });
	
	      if (findAssignmentLink === NO_TRANSLATION) {
	        return '';
	      }
	
	      return _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: (0, _proxyCounterpart.proxyCounterpart)('FIND_ASSIGNMENTS_LINK'),
	            target: '_blank'
	          },
	          _ref2
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'side-menu-wrapper menu-open', ref: 'wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'mobile-header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'side-menu-title', onClick: this.toggleMenu },
	            _ref3,
	            _react2.default.createElement('img', { src: __webpack_require__(1553) })
	          )
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'side-menu', ref: 'menu', onClick: this.onMenuClick, style: this.state.mobileStyles },
	          _react2.default.createElement(
	            'div',
	            { className: 'sidebar_container' },
	            _ref4,
	            _ref5,
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/economy', activeClassName: 'selected', onClick: this.toggleSubMenu },
	                _ref6
	              ),
	              _react2.default.createElement(
	                'ul',
	                { className: 'side-sub-menu' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: '/economy/invoices', activeClassName: 'selected', onClick: this.props.clear },
	                    _ref7
	                  )
	                ),
	                _ref8,
	                _ref9,
	                _ref10,
	                _ref11,
	                _ref12,
	                _ref13,
	                _ref14
	              )
	            ),
	            _ref15,
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/settings', activeClassName: 'selected', onClick: this.toggleSubMenu },
	                _ref16
	              ),
	              _ref17
	            ),
	            _ref18,
	            _ref19,
	            _ref20,
	            _ref21,
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: (0, _proxyCounterpart.proxyCounterpart)('CHECK_YOUR_WORK_ENVIRONMENT_URL'),
	                  target: '_blank'
	                },
	                _ref22
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: (0, _proxyCounterpart.proxyCounterpart)('REPORT_ACCIDENT_LINK'),
	                  target: '_blank'
	                },
	                _ref23
	              )
	            ),
	            this.renderBecomeAmbassadorListItem(),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: { pathname: '/activities', hash: '#calculator-anchor' } },
	                _ref24
	              )
	            ),
	            _ref25,
	            this.renderFindAssignmentListItem()
	          )
	        )
	      );
	    }
	  }]);
	  return SideMenu;
	}(_react2.default.Component);
	
	exports.default = SideMenu;

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cookieItpUtils = __webpack_require__(351);
	
	var _cookieItpUtils2 = _interopRequireDefault(_cookieItpUtils);
	
	var _reactModal = __webpack_require__(30);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO remove this file after 2022-04-08
	var _ref = _react2.default.createElement(
	  'h2',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'AFFECTED_ITP_MODAL_ONE_TITLE' })
	);
	
	var _ref2 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'AFFECTED_ITP_MODAL_ONE_BODY', className: 'pre-wrap' });
	
	var _ref3 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CLOSE' });
	
	var AffectedItpOneModal = function (_React$Component) {
	  (0, _inherits3.default)(AffectedItpOneModal, _React$Component);
	
	  function AffectedItpOneModal(props) {
	    (0, _classCallCheck3.default)(this, AffectedItpOneModal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (AffectedItpOneModal.__proto__ || (0, _getPrototypeOf2.default)(AffectedItpOneModal)).call(this, props));
	
	    _this.state = {
	      open: true
	    };
	
	    _this.affectedByITP = _this.affectedByITP.bind(_this);
	    _this.onCloseModal = _this.onCloseModal.bind(_this);
	    _this.shouldRender = _this.shouldRender.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(AffectedItpOneModal, [{
	    key: 'shouldRender',
	    value: function shouldRender() {
	      var startDate = (0, _moment2.default)('2022-04-01');
	      var endDate = (0, _moment2.default)('2022-04-07');
	      var nowDate = (0, _moment2.default)();
	
	      var openModal = false;
	      if (nowDate.isBetween(startDate, endDate) && !_cookieItpUtils2.default.getItpCookie('ff_affected_itp_one') && this.affectedByITP()) {
	        openModal = true;
	      }
	
	      return openModal;
	    }
	  }, {
	    key: 'affectedByITP',
	    value: function affectedByITP() {
	      var ssnr = this.props.user.socialSecurityNr;
	      if (ssnr === undefined || ssnr === null) {
	        return false;
	      }
	
	      if (this.props.user.saveITP) {
	        return false;
	      }
	
	      var thisYear = new Date().getFullYear();
	      var age = thisYear - ssnr.substring(0, 4);
	
	      return age >= _frilansFinans.UserSettingsConstants.itpAgeThresholdLower && age < _frilansFinans.UserSettingsConstants.itpAgeThresholdUpper;
	    }
	  }, {
	    key: 'onCloseModal',
	    value: function onCloseModal() {
	      this.setState({
	        open: false
	      });
	      _cookieItpUtils2.default.setItpCookie('ff_affected_itp_one');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.shouldRender() && this.state.open ? _react2.default.createElement(
	        _reactModal2.default,
	        {
	          className: 'modal modal-extra-wide',
	          contentLabel: '',
	          isOpen: this.state.open,
	          onRequestClose: this.onCloseModal },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-content' },
	          _react2.default.createElement('button', { className: 'close', onClick: this.onCloseModal }),
	          _ref,
	          _ref2,
	          _react2.default.createElement(
	            'div',
	            { className: 'center' },
	            _react2.default.createElement(
	              'button',
	              { className: 'btn mt35', onClick: this.onCloseModal },
	              _ref3
	            )
	          )
	        )
	      ) : null;
	    }
	  }]);
	  return AffectedItpOneModal;
	}(_react2.default.Component);
	
	exports.default = AffectedItpOneModal;

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cookieItpUtils = __webpack_require__(351);
	
	var _cookieItpUtils2 = _interopRequireDefault(_cookieItpUtils);
	
	var _reactModal = __webpack_require__(30);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'h2',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'AFFECTED_ITP_MODAL_TWO_TITLE' })
	);
	
	var _ref2 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'AFFECTED_ITP_MODAL_TWO_BODY', className: 'pre-wrap' });
	
	var _ref3 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CLOSE' });
	
	var AffectedItpOneModal = function (_React$Component) {
	  (0, _inherits3.default)(AffectedItpOneModal, _React$Component);
	
	  function AffectedItpOneModal(props) {
	    (0, _classCallCheck3.default)(this, AffectedItpOneModal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (AffectedItpOneModal.__proto__ || (0, _getPrototypeOf2.default)(AffectedItpOneModal)).call(this, props));
	
	    _this.state = {
	      open: true
	    };
	
	    _this.affectedByITP = _this.affectedByITP.bind(_this);
	    _this.shouldRender = _this.shouldRender.bind(_this);
	    _this.onCloseModal = _this.onCloseModal.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(AffectedItpOneModal, [{
	    key: 'shouldRender',
	    value: function shouldRender() {
	      // TODO remove when not needed anymore
	      // also remove cookie-itp-utils.js
	
	      var startDate = (0, _moment2.default)('2022-04-07');
	      var endDate = (0, _moment2.default)('2023-01-01');
	      var nowDate = (0, _moment2.default)();
	
	      var openModal = false;
	      if (nowDate.isBetween(startDate, endDate) && !_cookieItpUtils2.default.getItpCookie('ff_affected_itp_two') && this.affectedByITP()) {
	        openModal = true;
	      }
	
	      return openModal;
	    }
	  }, {
	    key: 'affectedByITP',
	    value: function affectedByITP() {
	      var ssnr = this.props.user.socialSecurityNr;
	      if (ssnr === undefined || ssnr === null) {
	        return false;
	      }
	
	      if (this.props.user.saveITP) {
	        return false;
	      }
	
	      var thisYear = new Date().getFullYear();
	      var age = thisYear - ssnr.substring(0, 4);
	
	      return age >= _frilansFinans.UserSettingsConstants.itpAgeThresholdLower && age < _frilansFinans.UserSettingsConstants.itpAgeThresholdUpper;
	    }
	  }, {
	    key: 'onCloseModal',
	    value: function onCloseModal() {
	      this.setState({
	        open: false
	      });
	      _cookieItpUtils2.default.setItpCookie('ff_affected_itp_two');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.shouldRender() && this.state.open ? _react2.default.createElement(
	        _reactModal2.default,
	        {
	          className: 'modal modal-extra-wide',
	          contentLabel: '',
	          isOpen: this.state.open,
	          onRequestClose: this.onCloseModal },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-content' },
	          _react2.default.createElement('button', { className: 'close', onClick: this.onCloseModal }),
	          _ref,
	          _ref2,
	          _react2.default.createElement(
	            'div',
	            { className: 'center' },
	            _react2.default.createElement(
	              'button',
	              { className: 'btn mt35', onClick: this.onCloseModal },
	              _ref3
	            )
	          )
	        )
	      ) : null;
	    }
	  }]);
	  return AffectedItpOneModal;
	}(_react2.default.Component);
	
	exports.default = AffectedItpOneModal;

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(30);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _mailboxFull = __webpack_require__(738);
	
	var _mailboxFull2 = _interopRequireDefault(_mailboxFull);
	
	var _cashBlank = __webpack_require__(730);
	
	var _cashBlank2 = _interopRequireDefault(_cashBlank);
	
	var _user = __webpack_require__(342);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'h2',
	  { className: 'confirm-preregister-modal-title' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CONFIRM_INVOICE_MODAL_TITLE' })
	);
	
	var _ref2 = _react2.default.createElement(
	  'p',
	  { className: 'confirm-preregister-modal-text' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CONFIRM_INVOICE_MODAL_TEXT' })
	);
	
	var _ref3 = _react2.default.createElement(
	  'div',
	  { className: 'infolist-icon' },
	  _react2.default.createElement(_user2.default, {
	    width: '30',
	    height: '30',
	    colorSchema: 'primary'
	  })
	);
	
	var _ref4 = _react2.default.createElement(_cashBlank2.default, {
	  width: '30',
	  height: '30',
	  colorSchema: 'primary'
	});
	
	var _ref5 = _react2.default.createElement(
	  'span',
	  { className: 'infolist-lowercase' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'EXCL_VAT' })
	);
	
	var _ref6 = _react2.default.createElement(
	  'div',
	  { className: 'infolist-icon' },
	  _react2.default.createElement(_mailboxFull2.default, {
	    width: '30',
	    height: '30',
	    colorSchema: 'primary'
	  })
	);
	
	var _ref7 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CONFIRM_INVOICE_MODAL_SUBMIT' });
	
	var ConfirmInvoiceModal = function (_React$Component) {
	  (0, _inherits3.default)(ConfirmInvoiceModal, _React$Component);
	
	  function ConfirmInvoiceModal(props) {
	    (0, _classCallCheck3.default)(this, ConfirmInvoiceModal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ConfirmInvoiceModal.__proto__ || (0, _getPrototypeOf2.default)(ConfirmInvoiceModal)).call(this, props));
	
	    _this.confirm = function () {
	      _this.props.callback(true);
	    };
	
	    _this.reject = function () {
	      _this.props.callback(false);
	    };
	
	    _this.render = function () {
	      return _react2.default.createElement(
	        _reactModal2.default,
	        {
	          className: 'modal',
	          contentLabel: '',
	          isOpen: _this.state.open,
	          onRequestClose: _this.reject },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-content confirm-preregister-modal' },
	          _react2.default.createElement('button', { className: 'close', onClick: _this.reject }),
	          _react2.default.createElement(
	            'div',
	            null,
	            _ref,
	            _ref2,
	            _react2.default.createElement(
	              'ul',
	              { className: 'confirm-preregister-modal-infolist' },
	              _react2.default.createElement(
	                'li',
	                null,
	                _ref3,
	                _this.props.customer.name
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'infolist-icon' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'cash-blank-text' },
	                    _this.props.invoice.currencyName
	                  ),
	                  _ref4
	                ),
	                _this.props.amount,
	                ' ',
	                _ref5
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _ref6,
	                _this.messageSendInfo()
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'confirm-preregister-modal-btn-wrapper' },
	            _react2.default.createElement(
	              'button',
	              { className: 'btn', onClick: _this.confirm },
	              _ref7
	            )
	          )
	        )
	      );
	    };
	
	    _this.state = {
	      open: true
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(ConfirmInvoiceModal, [{
	    key: 'messageMailInfo',
	    value: function messageMailInfo(invoice) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'confirm-preregister-modal-block' },
	          _react2.default.createElement(
	            'strong',
	            null,
	            (0, _proxyCounterpart.proxyCounterpart)('CONFIRM_INVOICE_MODAL_MAIL_TO')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'confirm-preregister-modal-block' },
	          invoice.customerEntity.name
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'confirm-preregister-modal-block' },
	          invoice.customerEntity.address.co
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'confirm-preregister-modal-block' },
	          invoice.customerEntity.address.street
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'confirm-preregister-modal-block' },
	          invoice.customerEntity.address.zip,
	          '\xA0',
	          invoice.customerEntity.address.city,
	          '\xA0',
	          invoice.customerEntity.address.country
	        )
	      );
	    }
	  }, {
	    key: 'messageSendInfo',
	    value: function messageSendInfo() {
	      var invoice = this.props.invoice;
	      if (invoice) {
	        // Billing emailinvoiceMessageType
	        if (invoice.messageType === 'email' && invoice.sendToEmail) {
	          return (0, _proxyCounterpart.proxyCounterpart)('CONFIRM_INVOICE_MODAL_EMAIL_TO') + '\n          ' + invoice.sendToEmail;
	        }
	
	        // // Secondary billing email
	        if (invoice.messageType === 'email' && invoice.sendToEmailSecondary) {
	          return (0, _proxyCounterpart.proxyCounterpart)('CONFIRM_INVOICE_MODAL_EMAIL_TO') + '\n          ' + invoice.sendToEmailSecondary;
	        }
	
	        // Send To SMS
	        if (invoice.messageType === 'sms' && invoice.companyPhone) {
	          return (0, _proxyCounterpart.proxyCounterpart)('CONFIRM_INVOICE_MODAL_SMS_TO') + '\n          ' + invoice.companyPhone;
	        }
	
	        // Send To E-invoice
	        if (invoice.messageType === 'e-invoice' && invoice.einvoiceAddress) {
	          return (0, _proxyCounterpart.proxyCounterpart)('CONFIRM_INVOICE_MODAL_E_INVOICE_TO') + '\n          ' + invoice.einvoiceAddress;
	        }
	
	        // Send By Mail
	        if (invoice.messageType === 'mail') {
	          return this.messageMailInfo(invoice);
	        }
	      }
	    }
	  }]);
	  return ConfirmInvoiceModal;
	}(_react2.default.Component);
	
	exports.default = ConfirmInvoiceModal;

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(30);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _calendar = __webpack_require__(729);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _cashSek = __webpack_require__(731);
	
	var _cashSek2 = _interopRequireDefault(_cashSek);
	
	var _user = __webpack_require__(342);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'h2',
	  { className: 'confirm-preregister-modal-title' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CONFIRM_PREREGISTER_MODAL_TITLE' })
	);
	
	var _ref2 = _react2.default.createElement(
	  'p',
	  { className: 'confirm-preregister-modal-text' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CONFIRM_PREREGISTER_MODAL_TEXT' })
	);
	
	var _ref3 = _react2.default.createElement(
	  'div',
	  { className: 'infolist-icon' },
	  _react2.default.createElement(_user2.default, {
	    width: '30',
	    height: '30',
	    colorSchema: 'primary'
	  })
	);
	
	var _ref4 = _react2.default.createElement(
	  'div',
	  { className: 'infolist-icon' },
	  _react2.default.createElement(_cashSek2.default, {
	    width: '30',
	    height: '30',
	    colorSchema: 'primary'
	  })
	);
	
	var _ref5 = _react2.default.createElement(
	  'span',
	  { className: 'infolist-lowercase' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'EXCL_VAT' })
	);
	
	var _ref6 = _react2.default.createElement(
	  'div',
	  { className: 'infolist-icon' },
	  _react2.default.createElement(_calendar2.default, {
	    width: '30',
	    height: '30',
	    colorSchema: 'primary'
	  })
	);
	
	var _ref7 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CONFIRM_PREREGISTER_MODAL_PERIOD_TO' });
	
	var _ref8 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CONFIRM_PREREGISTER_MODAL_SUBMIT' });
	
	var ConfirmModal = function (_React$Component) {
	  (0, _inherits3.default)(ConfirmModal, _React$Component);
	
	  function ConfirmModal(props) {
	    (0, _classCallCheck3.default)(this, ConfirmModal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ConfirmModal.__proto__ || (0, _getPrototypeOf2.default)(ConfirmModal)).call(this, props));
	
	    _this.confirm = function () {
	      _this.props.callback(true);
	    };
	
	    _this.reject = function () {
	      _this.props.callback(false);
	    };
	
	    _this.render = function () {
	      return _react2.default.createElement(
	        _reactModal2.default,
	        {
	          className: 'modal',
	          contentLabel: '',
	          isOpen: _this.state.open,
	          onRequestClose: _this.reject },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-content confirm-preregister-modal' },
	          _react2.default.createElement('button', { className: 'close', onClick: _this.reject }),
	          _react2.default.createElement(
	            'div',
	            null,
	            _ref,
	            _ref2,
	            _react2.default.createElement(
	              'ul',
	              { className: 'confirm-preregister-modal-infolist' },
	              _react2.default.createElement(
	                'li',
	                null,
	                _ref3,
	                _this.props.customer.name
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _ref4,
	                _this.props.amount,
	                ' ',
	                _ref5
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _ref6,
	                _this.props.firstWorkDate,
	                '\xA0',
	                _ref7,
	                '\xA0',
	                _this.props.lastWorkDate
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'confirm-preregister-modal-btn-wrapper' },
	            _react2.default.createElement(
	              'button',
	              { className: 'btn', onClick: _this.confirm },
	              _ref8
	            )
	          )
	        )
	      );
	    };
	
	    _this.state = {
	      open: true
	    };
	    return _this;
	  }
	
	  return ConfirmModal;
	}(_react2.default.Component);
	
	exports.default = ConfirmModal;

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(30);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _envelope = __webpack_require__(735);
	
	var _envelope2 = _interopRequireDefault(_envelope);
	
	var _envelopeOpen = __webpack_require__(339);
	
	var _envelopeOpen2 = _interopRequireDefault(_envelopeOpen);
	
	var _shieldCheck = __webpack_require__(340);
	
	var _shieldCheck2 = _interopRequireDefault(_shieldCheck);
	
	var _umbrella = __webpack_require__(341);
	
	var _umbrella2 = _interopRequireDefault(_umbrella);
	
	var _heart = __webpack_require__(215);
	
	var _heart2 = _interopRequireDefault(_heart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  null,
	  _react2.default.createElement(
	    'h2',
	    null,
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'LOYALTY_INFO_MODAL_TITLE' })
	  ),
	  _react2.default.createElement(
	    'div',
	    { className: 'difference-wrapper' },
	    _react2.default.createElement(
	      'div',
	      { className: 'difference-col' },
	      _react2.default.createElement(
	        'h3',
	        { className: 'difference-title' },
	        _react2.default.createElement(_reactTranslateComponent2.default, { content: 'LOYALTY_INFO_MODAL_PREREGISTER_TITLE' })
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'layalty-info-modal-icon' },
	            _react2.default.createElement(_envelopeOpen2.default, {
	              width: '30',
	              height: '30',
	              colorSchema: 'primary'
	            })
	          ),
	          _react2.default.createElement(_reactTranslateComponent2.default, { content: 'LOYALTY_INFO_MODAL_PREREGISTER_MAIL_TEXT' })
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'layalty-info-modal-icon' },
	            _react2.default.createElement(_heart2.default, {
	              width: '30',
	              height: '30',
	              colorSchema: 'primary'
	            })
	          ),
	          _react2.default.createElement(_reactTranslateComponent2.default, { content: 'LOYALTY_INFO_MODAL_PREREGISTER_HEART_TEXT' })
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'layalty-info-modal-icon' },
	            _react2.default.createElement(_umbrella2.default, {
	              width: '30',
	              height: '30',
	              colorSchema: 'primary'
	            })
	          ),
	          _react2.default.createElement(_reactTranslateComponent2.default, { content: 'LOYALTY_INFO_MODAL_PREREGISTER_UMBRELLA_TEXT' })
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'layalty-info-modal-icon' },
	            _react2.default.createElement(_shieldCheck2.default, {
	              width: '30',
	              height: '30',
	              colorSchema: 'primary'
	            })
	          ),
	          _react2.default.createElement(_reactTranslateComponent2.default, { content: 'LOYALTY_INFO_MODAL_PREREGISTER_SHIELD_TEXT' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'difference-col' },
	      _react2.default.createElement(
	        'h3',
	        { className: 'difference-title' },
	        _react2.default.createElement(_reactTranslateComponent2.default, { content: 'LOYALTY_INFO_MODAL_INVOICE_TITLE' })
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'layalty-info-modal-icon' },
	            _react2.default.createElement(_envelope2.default, {
	              width: '30',
	              height: '30',
	              colorSchema: 'primary'
	            })
	          ),
	          _react2.default.createElement(_reactTranslateComponent2.default, { content: 'LOYALTY_INFO_MODAL_INVOICE_MAIL_TEXT' })
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'layalty-info-modal-icon' },
	            _react2.default.createElement(_heart2.default, {
	              width: '30',
	              height: '30',
	              colorSchema: 'primary'
	            })
	          ),
	          _react2.default.createElement(_reactTranslateComponent2.default, { content: 'LOYALTY_INFO_MODAL_INVOICE_HEART_TEXT' })
	        )
	      )
	    )
	  )
	);
	
	var LojaltyInfoModal = function (_React$Component) {
	  (0, _inherits3.default)(LojaltyInfoModal, _React$Component);
	
	  function LojaltyInfoModal() {
	    (0, _classCallCheck3.default)(this, LojaltyInfoModal);
	    return (0, _possibleConstructorReturn3.default)(this, (LojaltyInfoModal.__proto__ || (0, _getPrototypeOf2.default)(LojaltyInfoModal)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LojaltyInfoModal, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactModal2.default,
	        {
	          className: 'modal',
	          contentLabel: '',
	          isOpen: true,
	          onRequestClose: this.props.close },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-content loyalty-info-modal' },
	          _react2.default.createElement('button', { className: 'close', onClick: this.props.close }),
	          _ref
	        )
	      );
	    }
	  }]);
	  return LojaltyInfoModal;
	}(_react2.default.Component);
	
	exports.default = LojaltyInfoModal;

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(30);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _envelopeOpen = __webpack_require__(339);
	
	var _envelopeOpen2 = _interopRequireDefault(_envelopeOpen);
	
	var _shieldCheck = __webpack_require__(340);
	
	var _shieldCheck2 = _interopRequireDefault(_shieldCheck);
	
	var _umbrella = __webpack_require__(341);
	
	var _umbrella2 = _interopRequireDefault(_umbrella);
	
	var _heart = __webpack_require__(215);
	
	var _heart2 = _interopRequireDefault(_heart);
	
	var _pencil = __webpack_require__(216);
	
	var _pencil2 = _interopRequireDefault(_pencil);
	
	var _fileAdd = __webpack_require__(736);
	
	var _fileAdd2 = _interopRequireDefault(_fileAdd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'info-modal-container' },
	  _react2.default.createElement(_reactTranslateComponent2.default, {
	    className: 'info-modal-title',
	    content: 'REGISTER_ASSIGNMENT_INFO_MODAL_TITLE'
	  }),
	  _react2.default.createElement(
	    'div',
	    { className: 'info-modal-column-container' },
	    _react2.default.createElement(
	      'div',
	      { className: 'info-modal-column' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { className: 'info-modal-column-title', content: 'REGISTER_ASSIGNMENT_INFO_MODAL_HOW_TITLE' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'info-modal-row' },
	        _react2.default.createElement(
	          'span',
	          { className: 'info-modal-icon' },
	          _react2.default.createElement(_envelopeOpen2.default, {
	            width: '20',
	            height: '20',
	            colorSchema: 'primary'
	          })
	        ),
	        _react2.default.createElement(_reactTranslateComponent2.default, { content: 'REGISTER_ASSIGNMENT_INFO_MODAL_ENVELOPE_OPEN' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'info-modal-row' },
	        _react2.default.createElement(
	          'span',
	          { className: 'info-modal-icon' },
	          _react2.default.createElement(_pencil2.default, {
	            width: '20',
	            height: '20',
	            colorSchema: 'primary'
	          })
	        ),
	        _react2.default.createElement(_reactTranslateComponent2.default, { content: 'REGISTER_ASSIGNMENT_INFO_MODAL_PENCIL' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'info-modal-row' },
	        _react2.default.createElement(
	          'span',
	          { className: 'info-modal-icon' },
	          _react2.default.createElement(_fileAdd2.default, {
	            width: '20',
	            height: '20',
	            colorSchema: 'primary'
	          })
	        ),
	        _react2.default.createElement(_reactTranslateComponent2.default, { content: 'REGISTER_ASSIGNMENT_INFO_MODAL_FILE_ADD' })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'info-modal-column' },
	      _react2.default.createElement(_reactTranslateComponent2.default, {
	        className: 'info-modal-column-title',
	        content: 'REGISTER_ASSIGNMENT_INFO_MODAL_BENEFITS_TITLE' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'info-modal-row' },
	        _react2.default.createElement(
	          'span',
	          { className: 'info-modal-icon' },
	          _react2.default.createElement(_umbrella2.default, {
	            width: '20',
	            height: '20',
	            colorSchema: 'primary'
	          })
	        ),
	        _react2.default.createElement(_reactTranslateComponent2.default, { content: 'REGISTER_ASSIGNMENT_INFO_MODAL_UMBRELLA' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'info-modal-row' },
	        _react2.default.createElement(
	          'span',
	          { className: 'info-modal-icon' },
	          _react2.default.createElement(_shieldCheck2.default, {
	            width: '20',
	            height: '20',
	            colorSchema: 'primary'
	          })
	        ),
	        _react2.default.createElement(_reactTranslateComponent2.default, { content: 'REGISTER_ASSIGNMENT_INFO_MODAL_SHIELD_CHECK' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'info-modal-row' },
	        _react2.default.createElement(
	          'span',
	          { className: 'info-modal-icon' },
	          _react2.default.createElement(_heart2.default, {
	            width: '20',
	            height: '20',
	            colorSchema: 'primary'
	          })
	        ),
	        _react2.default.createElement(_reactTranslateComponent2.default, { content: 'REGISTER_ASSIGNMENT_INFO_MODAL_HEART' })
	      )
	    )
	  )
	);
	
	var RegisterAssignmentInfoModal = function (_React$Component) {
	  (0, _inherits3.default)(RegisterAssignmentInfoModal, _React$Component);
	
	  function RegisterAssignmentInfoModal() {
	    (0, _classCallCheck3.default)(this, RegisterAssignmentInfoModal);
	    return (0, _possibleConstructorReturn3.default)(this, (RegisterAssignmentInfoModal.__proto__ || (0, _getPrototypeOf2.default)(RegisterAssignmentInfoModal)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(RegisterAssignmentInfoModal, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactModal2.default,
	        {
	          className: 'modal',
	          contentLabel: '',
	          isOpen: true,
	          onRequestClose: this.props.close },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-content' },
	          _react2.default.createElement('button', { className: 'close', onClick: this.props.close }),
	          _ref
	        )
	      );
	    }
	  }]);
	  return RegisterAssignmentInfoModal;
	}(_react2.default.Component);
	
	exports.default = RegisterAssignmentInfoModal;

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(30);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _axios = __webpack_require__(17);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _amountHelper = __webpack_require__(58);
	
	var _invoiceToolHelper = __webpack_require__(50);
	
	var _reactRouter = __webpack_require__(20);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _invoicing = __webpack_require__(334);
	
	var _invoicing2 = _interopRequireDefault(_invoicing);
	
	var _specification = __webpack_require__(336);
	
	var _specification2 = _interopRequireDefault(_specification);
	
	var _dates = __webpack_require__(333);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _amount = __webpack_require__(332);
	
	var _amount2 = _interopRequireDefault(_amount);
	
	var _workerAmount = __webpack_require__(702);
	
	var _workerAmount2 = _interopRequireDefault(_workerAmount);
	
	var _outlays = __webpack_require__(335);
	
	var _outlays2 = _interopRequireDefault(_outlays);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_CURRENCY_ID = 1;
	
	var _ref = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'REVIEW_AND_CREATE_INVOICE_EDIT_ASSIGNMENT_BUTTON' });
	
	var ReviewOrderModal = function (_React$Component) {
	  (0, _inherits3.default)(ReviewOrderModal, _React$Component);
	
	  function ReviewOrderModal(props) {
	    (0, _classCallCheck3.default)(this, ReviewOrderModal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ReviewOrderModal.__proto__ || (0, _getPrototypeOf2.default)(ReviewOrderModal)).call(this, props));
	
	    _this.state = {
	      invoice: null,
	      invoiceUser: null,
	      outlays: [],
	      fetching: true,
	      fetchError: false
	    };
	
	    _this.fetchData = _this.fetchData.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(ReviewOrderModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: 'fetchData',
	    value: function fetchData() {
	      var _this2 = this;
	
	      _axios2.default.all([_frilansFinans.InvoiceService.getById(this.props.invoiceId), _frilansFinans.InvoiceService.getSupplierLedgersForInvoice(this.props.invoiceId)]).then(_axios2.default.spread(this.handleAPIResponse.bind(this))).catch(function () {
	        _this2.setState({
	          fetching: false,
	          fetchError: true
	        });
	      });
	    }
	  }, {
	    key: 'handleAPIResponse',
	    value: function handleAPIResponse(invoice, outlays) {
	      var _this3 = this;
	
	      var invoiceUser = invoice.invoiceUsers.find(function (invoiceUser) {
	        return invoiceUser.userId === +_this3.props.user.id;
	      });
	      this.setState({
	        invoice: invoice,
	        outlays: outlays,
	        invoiceUser: invoiceUser,
	        fetching: false,
	        fetchError: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.invoice && this.state.invoiceUser) {
	        var outlaysAmount = this.state.outlays.reduce(function (previous, current) {
	          return previous + (0, _amountHelper.toMoney)(current.amount * (1 + (0, _invoiceToolHelper.getVatById)(current.taxId) / 100));
	        }, 0);
	
	        return _react2.default.createElement(
	          _reactModal2.default,
	          {
	            className: 'modal',
	            contentLabel: '',
	            isOpen: true,
	            onRequestClose: this.props.close
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-content' },
	            _react2.default.createElement('button', { className: 'close', onClick: this.props.close }),
	            _react2.default.createElement(
	              'div',
	              { className: 'invoice-details-container' },
	              _react2.default.createElement(_invoicing2.default, {
	                isReviewModal: true,
	                description: 'REVIEW_AND_CREATE_INVOICE_DESCRIPTION',
	                title: 'INVOICE_DETAILS_REVIEW_AND_CREATE_INVOICE',
	                invoice: this.state.invoice,
	                user: this.props.user
	              }),
	              _react2.default.createElement(_specification2.default, { invoice: this.state.invoice }),
	              _react2.default.createElement(_dates2.default, { invoice: this.state.invoice }),
	              _react2.default.createElement(_amount2.default, { invoice: this.state.invoice }),
	              _react2.default.createElement(_outlays2.default, {
	                outlays: this.state.outlays,
	                showDetailColumns: false
	              }),
	              _react2.default.createElement(_workerAmount2.default, {
	                currencyId: DEFAULT_CURRENCY_ID,
	                invoice: this.state.invoice,
	                user: this.state.invoiceUser,
	                outlaysAmount: outlaysAmount
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: 'modal-button-container' },
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: '/invoice-tool/' + this.props.invoiceId, className: 'btn blue' },
	                  _ref
	                )
	              )
	            )
	          )
	        );
	      }
	      return null;
	    }
	  }]);
	  return ReviewOrderModal;
	}(_react2.default.Component);
	
	exports.default = ReviewOrderModal;

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(30);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _check = __webpack_require__(212);
	
	var _check2 = _interopRequireDefault(_check);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'checkbox-step checked first' },
	  _react2.default.createElement(_check2.default, {
	    width: '15',
	    height: '15',
	    colorSchema: 'white',
	    classes: 'sent-modal-checkicon'
	  })
	);
	
	var _ref2 = _react2.default.createElement('div', { className: 'step-line' });
	
	var _ref3 = _react2.default.createElement('div', { className: 'checkbox-step' });
	
	var _ref4 = _react2.default.createElement('div', { className: 'step-line' });
	
	var _ref5 = _react2.default.createElement('div', { className: 'checkbox-step last' });
	
	var SentOrderModal = function (_React$Component) {
	  (0, _inherits3.default)(SentOrderModal, _React$Component);
	
	  function SentOrderModal() {
	    (0, _classCallCheck3.default)(this, SentOrderModal);
	    return (0, _possibleConstructorReturn3.default)(this, (SentOrderModal.__proto__ || (0, _getPrototypeOf2.default)(SentOrderModal)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SentOrderModal, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactModal2.default,
	        {
	          className: 'modal',
	          contentLabel: '',
	          isOpen: true,
	          onRequestClose: this.props.close },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-content' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h2',
	              null,
	              _react2.default.createElement(_reactTranslateComponent2.default, { content: this.props.title })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'steps-wrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'steps' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'step checked' },
	                  _ref,
	                  _react2.default.createElement(_reactTranslateComponent2.default, { content: this.props.translations[0] })
	                ),
	                _ref2,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'step' },
	                  _ref3,
	                  _react2.default.createElement(_reactTranslateComponent2.default, { content: this.props.translations[1] })
	                ),
	                _ref4,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'step' },
	                  _ref5,
	                  _react2.default.createElement(_reactTranslateComponent2.default, { content: this.props.translations[2] })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'sent-modal-btn-wrapper' },
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-outline-primary', onClick: this.props.registerNew },
	              _react2.default.createElement(_reactTranslateComponent2.default, { content: this.props.registerButtonText })
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: 'btn px-30', onClick: this.props.close },
	              _react2.default.createElement(_reactTranslateComponent2.default, { content: this.props.doneButtonText })
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return SentOrderModal;
	}(_react2.default.Component);
	
	exports.default = SentOrderModal;

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PayTermsPicker = undefined;
	
	var _set = __webpack_require__(1007);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _toConsumableArray2 = __webpack_require__(120);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'p',
	  { className: 'info' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PAYTERMS_LOW_WARNING' })
	); /**
	    * Created by staffanrantzow on 12/10/16.
	    */
	
	var _ref2 = _react2.default.createElement(
	  'p',
	  { className: 'info' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PAYTERMS_HIGH_WARNING' })
	);
	
	var _ref3 = _react2.default.createElement(
	  'label',
	  { htmlFor: 'pay-terms-picker' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PAYTERMS' })
	);
	
	var PayTermsPicker = exports.PayTermsPicker = function (_React$Component) {
	  (0, _inherits3.default)(PayTermsPicker, _React$Component);
	
	  function PayTermsPicker(props) {
	    (0, _classCallCheck3.default)(this, PayTermsPicker);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PayTermsPicker.__proto__ || (0, _getPrototypeOf2.default)(PayTermsPicker)).call(this, props));
	
	    var payTermsDays = [7, 10, 14, 20, 30, 45, 60, parseInt(props.payTerms)].sort(function (a, b) {
	      return a - b;
	    });
	    var uniquePayTermDays = [].concat((0, _toConsumableArray3.default)(new _set2.default(payTermsDays)));
	    var payTermsOptions = uniquePayTermDays.map(function (days) {
	      return { value: days + ' ' + (0, _proxyCounterpart.proxyCounterpart)('DAYS'), key: days };
	    });
	
	    _this.state = {
	      options: payTermsOptions,
	      selectValue: _this.props.payTerms
	    };
	
	    _this.setPayTerms = _this.setPayTerms.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(PayTermsPicker, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.setPayTerms(this.state.selectValue);
	    }
	  }, {
	    key: 'setPayTerms',
	    value: function setPayTerms(e) {
	      this.setState({
	        selectValue: e.target.value
	      });
	
	      this.props.setPayTerms(e.target.value);
	    }
	  }, {
	    key: 'renderOption',
	    value: function renderOption(payTerm, i) {
	      return _react2.default.createElement(
	        'option',
	        {
	          value: payTerm.key,
	          key: i },
	        payTerm.value
	      );
	    }
	  }, {
	    key: 'renderPaytermsMessages',
	    value: function renderPaytermsMessages() {
	      if (parseInt(this.props.payTerms) < 30 && this.props.renderErrorMessages) {
	        return _ref;
	      }
	      if (parseInt(this.props.payTerms) > 30 && this.props.renderErrorMessages) {
	        return _ref2;
	      }
	      return;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        { className: 'input-wrapper' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: '' },
	            _react2.default.createElement(
	              'div',
	              { className: 'styled-select' },
	              _react2.default.createElement(
	                'select',
	                {
	                  name: 'pay-terms-picker',
	                  value: this.state.selectValue,
	                  onChange: this.setPayTerms },
	                this.state.options.map(this.renderOption)
	              ),
	              _ref3
	            )
	          )
	        ),
	        this.renderPaytermsMessages()
	      );
	    }
	  }]);
	  return PayTermsPicker;
	}(_react2.default.Component);
	
	PayTermsPicker.defaultProps = {
	  renderErrorMessages: true
	};
	exports.default = PayTermsPicker;

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _components = __webpack_require__(13);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _modalContainer = __webpack_require__(162);
	
	var _modalContainer2 = _interopRequireDefault(_modalContainer);
	
	var _cookieUtils = __webpack_require__(89);
	
	var _cookieUtils2 = _interopRequireDefault(_cookieUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CLOSE' });
	
	var PhoneNumberModal = function (_React$Component) {
	  (0, _inherits3.default)(PhoneNumberModal, _React$Component);
	
	  function PhoneNumberModal(props) {
	    (0, _classCallCheck3.default)(this, PhoneNumberModal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PhoneNumberModal.__proto__ || (0, _getPrototypeOf2.default)(PhoneNumberModal)).call(this, props));
	
	    _this.render = function () {
	      return _react2.default.createElement(
	        _modalContainer2.default,
	        {
	          isOpen: _this.state.open,
	          callback: _this.setModalOpen,
	          title: 'MODAL_COMPLETE_INFORMATION',
	          classes: 'complete-information-modal',
	          shrink: true
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-row' },
	          _react2.default.createElement(_components.InputField, {
	            type: 'tel',
	            name: 'cellphone',
	            classes: 'wide',
	            value: _this.state.user.cellphone.value,
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('TELEPHONE_NR'),
	            callback: _this.setPhoneNumber,
	            required: 'true',
	            minLength: '8',
	            errorMessage: (0, _proxyCounterpart.proxyCounterpart)('TELEPHONE_ERROR'),
	            showErrorWithoutBlur: _this.state.showErrorWithoutBlur
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'new-modal-button-container' },
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'btn white no-border',
	              onClick: _this.closeModal },
	            _ref
	          ),
	          _react2.default.createElement(_components.SpinnerButton, {
	            text: (0, _proxyCounterpart.proxyCounterpart)('SAVE'),
	            loading: _this.state.posting,
	            classes: 'btn',
	            callback: _this.submitForm,
	            disabled: !_this.state.user.cellphone.valid
	          })
	        )
	      );
	    };
	
	    _this.state = {
	      open: props.modalIsOpen,
	      user: {
	        cellphone: ''
	      },
	      showErrorWithoutBlur: false,
	      posting: false
	    };
	
	    _this.setPhoneNumber = _this.setPhoneNumber.bind(_this);
	    _this.closeModal = _this.closeModal.bind(_this);
	    _this.setModalOpen = _this.setModalOpen.bind(_this);
	    _this.submitForm = _this.submitForm.bind(_this);
	    _this.clickSubmit = _this.clickSubmit.bind(_this);
	    _this.handleSuccess = _this.handleSuccess.bind(_this);
	    _this.handleError = _this.handleError.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(PhoneNumberModal, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        open: nextProps.modalIsOpen
	      });
	    }
	  }, {
	    key: 'setPhoneNumber',
	    value: function setPhoneNumber(_, values) {
	      this.setState({ user: { cellphone: values } });
	    }
	  }, {
	    key: 'clickSubmit',
	    value: function clickSubmit(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	
	      this.setState({ showErrorWithoutBlur: true }, function () {
	        if (_frilansFinans.Utils.validateInputValues(_this2.state.user)) {
	          _this2.submitForm();
	        }
	      });
	    }
	  }, {
	    key: 'submitForm',
	    value: function submitForm() {
	      var params = _frilansFinans.Utils.getPostParams(this.state.user);
	      _frilansFinans.UserService.update(params).then(this.handleSuccess).catch(this.handleError);
	
	      this.setState({
	        posting: true,
	        userUpdated: false,
	        postError: false
	      });
	    }
	  }, {
	    key: 'handleSuccess',
	    value: function handleSuccess() {
	      this.setState({
	        posting: false,
	        open: false
	      });
	    }
	  }, {
	    key: 'handleError',
	    value: function handleError() {
	      this.setState({
	        posting: false
	      });
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      this.setModalOpen(false);
	    }
	  }, {
	    key: 'setModalOpen',
	    value: function setModalOpen(value) {
	      this.setState({
	        open: value
	      });
	
	      if (!value) {
	        _cookieUtils2.default.setHidePhoneNumberModalCookie();
	      }
	    }
	  }]);
	  return PhoneNumberModal;
	}(_react2.default.Component);
	
	exports.default = PhoneNumberModal;

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PrivacyPolicy = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'FF_TERMS_AND_PERSONAL_INFORMATION_BEING_TREATED' });
	
	var _ref2 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PRIVACY_POLICY' });
	
	var PrivacyPolicy = exports.PrivacyPolicy = function (_React$Component) {
	  (0, _inherits3.default)(PrivacyPolicy, _React$Component);
	
	  function PrivacyPolicy() {
	    (0, _classCallCheck3.default)(this, PrivacyPolicy);
	    return (0, _possibleConstructorReturn3.default)(this, (PrivacyPolicy.__proto__ || (0, _getPrototypeOf2.default)(PrivacyPolicy)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PrivacyPolicy, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'privacy-policy' },
	        _ref,
	        '\xA0 Frilans Finans ',
	        _react2.default.createElement(
	          'a',
	          { href: (0, _proxyCounterpart.proxyCounterpart)('FOOTER_LINK_PRIVACY_POLICY'), target: '_blank' },
	          _ref2
	        )
	      );
	    }
	  }]);
	  return PrivacyPolicy;
	}(_react2.default.Component);
	
	exports.default = PrivacyPolicy;

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Profession = undefined;
	
	var _extends2 = __webpack_require__(27);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAutosuggest = __webpack_require__(584);
	
	var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);
	
	var _professionsService = __webpack_require__(787);
	
	var _professionsService2 = _interopRequireDefault(_professionsService);
	
	var _profession = __webpack_require__(1304);
	
	var _profession2 = _interopRequireDefault(_profession);
	
	var _professionLoading = __webpack_require__(1303);
	
	var _professionLoading2 = _interopRequireDefault(_professionLoading);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _errorMessage = __webpack_require__(160);
	
	var _errorMessage2 = _interopRequireDefault(_errorMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Timeout variables doesn't play well with state
	var requestValue = '';
	
	// TO DO : IF SUGGESTIONSDROPDOWN STATE IS TRUE, E.preventDEFAULT FOR ENTERCLICKS
	
	var Profession = exports.Profession = function (_React$Component) {
	  (0, _inherits3.default)(Profession, _React$Component);
	
	  function Profession(props) {
	    (0, _classCallCheck3.default)(this, Profession);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Profession.__proto__ || (0, _getPrototypeOf2.default)(Profession)).call(this, props));
	
	    _this.state = {
	      inputValue: _this.props.value,
	      value: {
	        name: _this.props.value
	      },
	      suggestions: [],
	      loading: false,
	      fetchError: false,
	      showSelectError: false,
	      showErrorWithoutBlur: _this.props.showErrorWithoutBlur,
	      noResults: false
	    };
	
	    _this.renderInputComponent = _this.renderInputComponent.bind(_this);
	    _this.onSuggestionsClearRequested = _this.onSuggestionsClearRequested.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onSuggestionSelected = _this.onSuggestionSelected.bind(_this);
	    _this.getSuggestions = _this.getSuggestions.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(Profession, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.state.inputValue && this.state.inputValue !== '') {
	        this.getSuggestions({ value: this.state.inputValue });
	      }
	    }
	
	    /**
	     * Called when user clicks the submit button
	     * @param nextProps
	     */
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var showError = nextProps.showErrorWithoutBlur && !this.state.value.ssyk;
	      this.setState({ showErrorWithoutBlur: showError });
	    }
	  }, {
	    key: 'startRequestTimeout',
	    value: function startRequestTimeout() {
	      if (this.requestTimeout) {
	        window.clearTimeout(this.requestTimeout);
	      }
	
	      this.requestTimeout = setTimeout(this.makeRequest.bind(this), 300);
	    }
	  }, {
	    key: 'makeRequest',
	    value: function makeRequest() {
	      this.setState({ loading: true }, function () {
	        var _this2 = this;
	
	        _professionsService2.default.getByTitle(requestValue).then(function (response) {
	          return _this2.onAPIResponse(response);
	        });
	      });
	    }
	  }, {
	    key: 'onAPIResponse',
	    value: function onAPIResponse(response) {
	      var professions;
	
	      professions = response.collection;
	
	      this.setState({
	        loading: false,
	        noResults: !(Boolean(professions.length) || false),
	        suggestions: professions
	      });
	    }
	
	    /**
	     * When user selects an option
	     */
	
	  }, {
	    key: 'onSuggestionSelected',
	    value: function onSuggestionSelected(event, _ref) {
	      var suggestion = _ref.suggestion,
	          suggestionValue = _ref.suggestionValue,
	          sectionIndex = _ref.sectionIndex,
	          method = _ref.method;
	
	      this.setState({
	        value: suggestion
	      });
	
	      this.sendValueToParent(suggestion, true);
	
	      event.preventDefault();
	    }
	  }, {
	    key: 'sendValueToParent',
	    value: function sendValueToParent(suggestion, valid) {
	      this.props.callback(this.props.name, {
	        value: suggestion.title,
	        valid: valid,
	        id: suggestion.id
	      });
	    }
	
	    // Prevent reload after selection
	
	  }, {
	    key: 'onKeyDown',
	    value: function onKeyDown(event) {
	      if (event.key === 'Enter') {
	        event.preventDefault();
	        event.target.blur();
	      }
	    }
	    /**
	     * onChange from input
	     */
	
	  }, {
	    key: 'onChange',
	    value: function onChange(event, _ref2) {
	      var _this3 = this;
	
	      var newValue = _ref2.newValue;
	
	      var noResultsString = (0, _proxyCounterpart.proxyCounterpart)('NO_RESULTS_FOUND');
	
	      var suggestion = { title: newValue };
	
	      this.setState({
	        value: suggestion
	      });
	
	      this.sendValueToParent(suggestion, !!suggestion.id);
	
	      if (newValue !== noResultsString) {
	        this.setState({
	          inputValue: newValue
	        }, function () {
	          if (_this3.state.inputValue === '') {
	            _this3.setState({
	              value: {
	                name: '',
	                valid: false
	              }
	            });
	
	            _this3.props.callback(_this3.props.name, {
	              value: '',
	              valid: false
	            });
	          }
	        });
	      }
	    }
	  }, {
	    key: 'renderInputComponent',
	    value: function renderInputComponent(inputProps) {
	      var placeholder = (0, _proxyCounterpart.proxyCounterpart)('PROFESSION');
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('input', (0, _extends3.default)({ id: this.props.name }, inputProps, { required: true })),
	        _react2.default.createElement('label', { htmlFor: this.props.name, placeholder: placeholder, alt: placeholder })
	      );
	    }
	
	    /**
	     * AutoSuggest wants new suggestions based on input
	     */
	
	  }, {
	    key: 'onSuggestionsUpdateRequested',
	    value: function onSuggestionsUpdateRequested(_ref3) {
	      var value = _ref3.value;
	
	      this.setState({
	        suggestions: this.getSuggestions(value)
	      });
	    }
	
	    /**
	     * Get professions from API
	     */
	
	  }, {
	    key: 'getSuggestions',
	    value: function getSuggestions(_ref4) {
	      var value = _ref4.value;
	
	      var inputValue;
	
	      inputValue = value.trim().toLowerCase();
	
	      if (!inputValue) {
	        this.setState({
	          loading: false,
	          professions: []
	        });
	
	        return;
	      }
	
	      requestValue = value;
	      this.startRequestTimeout();
	    }
	  }, {
	    key: 'onSuggestionsClearRequested',
	    value: function onSuggestionsClearRequested() {
	      this.setState({
	        suggestions: []
	      });
	    }
	  }, {
	    key: 'getSuggestionValue',
	    value: function getSuggestionValue(suggestion) {
	      return suggestion.title;
	    }
	  }, {
	    key: 'renderSuggestion',
	    value: function renderSuggestion(suggestion) {
	      return _react2.default.createElement(
	        'span',
	        null,
	        suggestion.title
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var inputProps, theme;
	
	      inputProps = {
	        value: this.state.inputValue,
	        onChange: this.onChange,
	        name: this.props.name,
	        onKeyDown: this.onKeyDown
	      };
	
	      theme = this.state.loading ? (0, _extends3.default)({}, _professionLoading2.default, { styles: _profession2.default }) : (0, _extends3.default)({}, _profession2.default);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'input-wrapper profession' },
	        _react2.default.createElement(_reactAutosuggest2.default, {
	          suggestions: this.state.suggestions,
	          theme: theme,
	          onSuggestionsFetchRequested: this.getSuggestions,
	          onSuggestionSelected: this.onSuggestionSelected,
	          onSuggestionsClearRequested: this.onSuggestionsClearRequested,
	          getSuggestionValue: this.getSuggestionValue,
	          renderSuggestion: this.renderSuggestion,
	          inputProps: inputProps,
	          renderInputComponent: this.renderInputComponent,
	          focusFirstSuggestion: true }),
	        _react2.default.createElement(_errorMessage2.default, { show: this.state.fetchError, errorMessage: (0, _proxyCounterpart.proxyCounterpart)('GENERAL_ERROR') }),
	        _react2.default.createElement(_errorMessage2.default, { show: this.state.showErrorWithoutBlur, errorMessage: (0, _proxyCounterpart.proxyCounterpart)('PROFESSION_ERROR') })
	      );
	    }
	  }]);
	  return Profession;
	}(_react2.default.Component);
	
	exports.default = Profession;

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RegisteredOrdersOrderRow = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _components = __webpack_require__(13);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _utils = __webpack_require__(29);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _ellipsis = __webpack_require__(161);
	
	var _ellipsis2 = _interopRequireDefault(_ellipsis);
	
	var _showMore = __webpack_require__(725);
	
	var _showMore2 = _interopRequireDefault(_showMore);
	
	var _reviewOrderButton = __webpack_require__(724);
	
	var _reviewOrderButton2 = _interopRequireDefault(_reviewOrderButton);
	
	var _reviewOrderModal = __webpack_require__(715);
	
	var _reviewOrderModal2 = _interopRequireDefault(_reviewOrderModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RegisteredOrdersOrderRow = exports.RegisteredOrdersOrderRow = function (_React$Component) {
	  (0, _inherits3.default)(RegisteredOrdersOrderRow, _React$Component);
	
	  function RegisteredOrdersOrderRow(props) {
	    (0, _classCallCheck3.default)(this, RegisteredOrdersOrderRow);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (RegisteredOrdersOrderRow.__proto__ || (0, _getPrototypeOf2.default)(RegisteredOrdersOrderRow)).call(this, props));
	
	    _this.state = {
	      renderConfirmModal: false,
	      showModal: false
	    };
	
	    _this.showMoreList = _this.showMoreList.bind(_this);
	    _this.deleteInvoice = _this.deleteInvoice.bind(_this);
	    _this.closeModal = _this.closeModal.bind(_this);
	    _this.renderDeleteAssignmentModal = _this.renderDeleteAssignmentModal.bind(_this);
	    _this.setWrapperRef = _this.setWrapperRef.bind(_this);
	    _this.handleClickOutside = _this.handleClickOutside.bind(_this);
	    _this.renderLojaltyInfoModal = _this.renderLojaltyInfoModal.bind(_this);
	    _this.toggleInfoModal = _this.toggleInfoModal.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(RegisteredOrdersOrderRow, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('mousedown', this.handleClickOutside);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('mousedown', this.handleClickOutside);
	    }
	  }, {
	    key: 'setWrapperRef',
	    value: function setWrapperRef(node) {
	      this.wrapperRef = node;
	    }
	  }, {
	    key: 'handleClickOutside',
	    value: function handleClickOutside(event) {
	      if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
	        if (this.props.showMoreList.invoiceId === this.props.invoice.id) {
	          this.props.resetShowMoreList();
	        }
	      }
	    }
	  }, {
	    key: 'getActivityText',
	    value: function getActivityText(invoiceDates) {
	      var hasLaterDates = false;
	      var hasPreviousDates = false;
	
	      invoiceDates.forEach(function (invoiceDate) {
	        if (invoiceDate.date >= (0, _moment2.default)(_moment2.default.now()).format('YYYY-MM-DD')) {
	          hasLaterDates = true;
	        }
	        if (invoiceDate.date < (0, _moment2.default)(_moment2.default.now()).format('YYYY-MM-DD')) {
	          hasPreviousDates = true;
	        }
	      });
	
	      if (hasLaterDates) {
	        if (hasPreviousDates || invoiceDates.length === 1) {
	          return 'ACTIVE_ASSIGNMENT';
	        }
	        return 'UPCOMNIG_ASSIGNMENT';
	      }
	      return 'PAST_ASSIGNMENT';
	    }
	  }, {
	    key: 'showMoreList',
	    value: function showMoreList() {
	      this.props.toggleShowMoreList(this.props.invoice.id);
	    }
	  }, {
	    key: 'deleteInvoice',
	    value: function deleteInvoice() {
	      this.props.resetShowMoreList();
	      this.setState({
	        renderDeleteAssignmentModal: true
	      });
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal(confirm) {
	      var _this2 = this;
	
	      if (confirm) {
	        _frilansFinans.InvoiceService.delete(+this.props.invoice.id).then(this.props.removeInvoiceFromState(+this.props.invoice.id)).catch(function () {
	          _this2.setState({
	            fetchError: true
	          });
	        });
	
	        this.setState({
	          renderDeleteAssignmentModal: false
	        });
	      } else {
	        this.setState({
	          renderDeleteAssignmentModal: false
	        });
	      }
	    }
	  }, {
	    key: 'renderDeleteAssignmentModal',
	    value: function renderDeleteAssignmentModal() {
	      if (this.state.renderDeleteAssignmentModal) {
	        return _react2.default.createElement(_components.ConfirmModal, {
	          callback: this.closeModal,
	          message: (0, _proxyCounterpart.proxyCounterpart)('DELETE_INVOICE')
	        });
	      }
	    }
	  }, {
	    key: 'renderShowMoreList',
	    value: function renderShowMoreList(showMoreList) {
	      if (showMoreList) {
	        return _react2.default.createElement(_showMore2.default, {
	          deleteInvoice: this.deleteInvoice,
	          invoiceId: +this.props.invoice.id,
	          user: this.props.user,
	          showModal: this.toggleInfoModal
	        });
	      }
	    }
	  }, {
	    key: 'renderLojaltyInfoModal',
	    value: function renderLojaltyInfoModal() {
	      if (this.state.showModal) {
	        return _react2.default.createElement(_reviewOrderModal2.default, {
	          close: this.toggleInfoModal,
	          invoiceId: +this.props.invoice.id,
	          user: this.props.user
	        });
	      }
	    }
	  }, {
	    key: 'toggleInfoModal',
	    value: function toggleInfoModal() {
	      this.setState({
	        showModal: !this.state.showModal
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var showMoreList = this.props.showMoreList.invoiceId === this.props.invoice.id ? this.props.showMoreList.show : false;
	
	      return _react2.default.createElement(
	        'div',
	        { key: this.props.invoice.id, className: 'registered-orders-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'registered-orders-customer' },
	          _react2.default.createElement(
	            'div',
	            { className: 'registered-orders-curtomer-title' },
	            this.props.invoice.customer.name
	          ),
	          _react2.default.createElement(_reactTranslateComponent2.default, {
	            className: 'registered-orders-created-at',
	            content: 'CREATED_DATE',
	            date: _utils2.default.formatDate(this.props.invoice.createdAt)
	          })
	        ),
	        _react2.default.createElement(_reactTranslateComponent2.default, {
	          className: 'registered-orders-activity hide-extremely-tiny-screen',
	          content: this.getActivityText(this.props.invoice.invoiceDates)
	        }),
	        _react2.default.createElement(_reviewOrderButton2.default, {
	          invoice: this.props.invoice,
	          user: this.props.user,
	          showModal: this.toggleInfoModal
	        }),
	        _react2.default.createElement(
	          'div',
	          {
	            ref: this.setWrapperRef,
	            className: 'registered-orders-more'
	          },
	          this.renderShowMoreList(showMoreList),
	          _react2.default.createElement(
	            'div',
	            { onClick: this.showMoreList },
	            _react2.default.createElement(_ellipsis2.default, {
	              colorSchema: 'primary',
	              fill: showMoreList
	            })
	          )
	        ),
	        this.renderLojaltyInfoModal(),
	        this.renderDeleteAssignmentModal()
	      );
	    }
	  }]);
	  return RegisteredOrdersOrderRow;
	}(_react2.default.Component);
	
	exports.default = RegisteredOrdersOrderRow;

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RegisteredOrdersTitle = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _reactRouter = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'registered-orders-title-wrapper' },
	  _react2.default.createElement(
	    'div',
	    { className: 'registered-orders-title' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'REGISTERED_ASSIGNMENTS_TITLE' }),
	    _react2.default.createElement(
	      _reactRouter.Link,
	      { to: 'economy/register-assignment' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'REGISTERED_ASSIGNMENTS_TITLE_SHOW_ALL' })
	    )
	  ),
	  _react2.default.createElement(
	    'p',
	    { className: 'registered-orders-description' },
	    _react2.default.createElement(_reactTranslateComponent2.default, {
	      content: 'REGISTERED_ASSIGNMENTS_DESCRIPTION',
	      insurancesLink: _react2.default.createElement(
	        'b',
	        null,
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/insurances' },
	          _react2.default.createElement(_reactTranslateComponent2.default, { content: 'REGISTERED_ASSIGNMENTS_DESCRIPTION_INSURANCES_LINK' })
	        )
	      ),
	      workingConditionsLink: _react2.default.createElement(
	        'b',
	        null,
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: 'working-environment' },
	          _react2.default.createElement(_reactTranslateComponent2.default, { content: 'REGISTERED_ASSIGNMENTS_DESCRIPTION_WORKING_CONDITIONS_LINK' })
	        )
	      )
	    })
	  )
	);
	
	var RegisteredOrdersTitle = exports.RegisteredOrdersTitle = function (_React$Component) {
	  (0, _inherits3.default)(RegisteredOrdersTitle, _React$Component);
	
	  function RegisteredOrdersTitle() {
	    (0, _classCallCheck3.default)(this, RegisteredOrdersTitle);
	    return (0, _possibleConstructorReturn3.default)(this, (RegisteredOrdersTitle.__proto__ || (0, _getPrototypeOf2.default)(RegisteredOrdersTitle)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(RegisteredOrdersTitle, [{
	    key: 'render',
	    value: function render() {
	      return _ref;
	    }
	  }]);
	  return RegisteredOrdersTitle;
	}(_react2.default.Component);
	
	exports.default = RegisteredOrdersTitle;

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RegisteredOrders = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _registeredOrdersTitle = __webpack_require__(722);
	
	var _registeredOrdersTitle2 = _interopRequireDefault(_registeredOrdersTitle);
	
	var _registeredOrdersTable = __webpack_require__(338);
	
	var _registeredOrdersTable2 = _interopRequireDefault(_registeredOrdersTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RegisteredOrders = exports.RegisteredOrders = function (_React$Component) {
	  (0, _inherits3.default)(RegisteredOrders, _React$Component);
	
	  function RegisteredOrders() {
	    (0, _classCallCheck3.default)(this, RegisteredOrders);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (RegisteredOrders.__proto__ || (0, _getPrototypeOf2.default)(RegisteredOrders)).call(this));
	
	    _this.state = {
	      fetching: true,
	      fetchError: false,
	      invoices: [],
	      pendingRequest: null,
	      meta: {
	        total: 0
	      }
	    };
	
	    _this.fetchInvoices = _this.fetchInvoices.bind(_this);
	    _this.removeInvoiceFromState = _this.removeInvoiceFromState.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(RegisteredOrders, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchInvoices();
	    }
	  }, {
	    key: 'fetchInvoices',
	    value: function fetchInvoices() {
	      var _this2 = this;
	
	      this.setState({
	        fetching: true
	      });
	
	      var userId = +this.props.user.id;
	
	      var pendingRequest = _frilansFinans.InvoiceService.get(userId, null, 1, 1, null, 2);
	
	      pendingRequest.promise.then(this.handleResponse.bind(this)).catch(function (error) {
	        if (error.response !== undefined) {
	          _this2.setState({
	            fetchError: true
	          });
	        }
	      });
	
	      this.setState({
	        pendingRequest: pendingRequest
	      });
	    }
	  }, {
	    key: 'handleResponse',
	    value: function handleResponse(response) {
	      this.setState({
	        fetching: false,
	        fetchError: false,
	        invoices: response.collection,
	        meta: response.meta
	      });
	    }
	  }, {
	    key: 'removeInvoiceFromState',
	    value: function removeInvoiceFromState(invoiceId) {
	      this.setState({
	        invoices: this.state.invoices.filter(function (invoice) {
	          return +invoice.id !== invoiceId;
	        })
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.state.invoices.length ? _react2.default.createElement(
	        'div',
	        { className: 'registered-orders-wrapper' },
	        _react2.default.createElement(_registeredOrdersTitle2.default, { total: this.state.meta.total }),
	        _react2.default.createElement(_registeredOrdersTable2.default, {
	          invoices: this.state.invoices,
	          removeInvoiceFromState: this.removeInvoiceFromState,
	          user: this.props.user
	        })
	      ) : null;
	    }
	  }]);
	  return RegisteredOrders;
	}(_react2.default.Component);
	
	exports.default = RegisteredOrders;

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReviewOrderButton = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReviewOrderButton = exports.ReviewOrderButton = function (_React$Component) {
	  (0, _inherits3.default)(ReviewOrderButton, _React$Component);
	
	  function ReviewOrderButton() {
	    (0, _classCallCheck3.default)(this, ReviewOrderButton);
	    return (0, _possibleConstructorReturn3.default)(this, (ReviewOrderButton.__proto__ || (0, _getPrototypeOf2.default)(ReviewOrderButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ReviewOrderButton, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_reactTranslateComponent2.default, {
	        className: 'registered-orders-edit hide-mobile',
	        onClick: this.props.showModal,
	        content: 'BUTTON_REVIEW_AND_CREATE_INVOICE'
	      });
	    }
	  }]);
	  return ReviewOrderButton;
	}(_react2.default.Component);
	
	exports.default = ReviewOrderButton;

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RegisteredOrdersShowMore = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _reactRouter = __webpack_require__(20);
	
	var _pencil = __webpack_require__(216);
	
	var _pencil2 = _interopRequireDefault(_pencil);
	
	var _eye = __webpack_require__(214);
	
	var _eye2 = _interopRequireDefault(_eye);
	
	var _trash = __webpack_require__(743);
	
	var _trash2 = _interopRequireDefault(_trash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_eye2.default, { colorSchema: 'primary' });
	
	var _ref2 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'REVIEW_INVOICE' });
	
	var _ref3 = _react2.default.createElement(_pencil2.default, { colorSchema: 'primary' });
	
	var _ref4 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'EDIT_INVOICE' });
	
	var _ref5 = _react2.default.createElement(_trash2.default, { colorSchema: 'primary' });
	
	var _ref6 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'DELETE' });
	
	var RegisteredOrdersShowMore = exports.RegisteredOrdersShowMore = function (_React$Component) {
	  (0, _inherits3.default)(RegisteredOrdersShowMore, _React$Component);
	
	  function RegisteredOrdersShowMore() {
	    (0, _classCallCheck3.default)(this, RegisteredOrdersShowMore);
	    return (0, _possibleConstructorReturn3.default)(this, (RegisteredOrdersShowMore.__proto__ || (0, _getPrototypeOf2.default)(RegisteredOrdersShowMore)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(RegisteredOrdersShowMore, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'table-show-more-list' },
	        _react2.default.createElement(
	          'div',
	          {
	            onClick: this.props.showModal,
	            className: 'table-show-more-list-item hide-desktop'
	          },
	          _ref,
	          _ref2
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'table-show-more-list-item'
	          },
	          _ref3,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/register-assignment/' + this.props.invoiceId },
	            _ref4
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'table-show-more-list-item',
	            onClick: this.props.deleteInvoice
	          },
	          _ref5,
	          _ref6
	        )
	      );
	    }
	  }]);
	  return RegisteredOrdersShowMore;
	}(_react2.default.Component);
	
	exports.default = RegisteredOrdersShowMore;

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SelectBox = undefined;
	
	var _extends2 = __webpack_require__(27);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SelectBox = exports.SelectBox = function (_React$Component) {
	  (0, _inherits3.default)(SelectBox, _React$Component);
	
	  function SelectBox(props) {
	    (0, _classCallCheck3.default)(this, SelectBox);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SelectBox.__proto__ || (0, _getPrototypeOf2.default)(SelectBox)).call(this, props));
	
	    _this.state = {
	      value: _this.props.value ? _this.props.value : '',
	      valid: false,
	      required: _this.props.required === 'true',
	      isBlurred: false,
	      disabled: _this.props.disabled === 'true',
	      showErrorWithoutBlur: _this.props.showErrorWithoutBlur
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(SelectBox, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.validate();
	    }
	
	    /**
	     * Called when user clicks the submit button
	     * @param nextProps
	     */
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({ showErrorWithoutBlur: nextProps.showErrorWithoutBlur });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      this.setState({
	        value: e.target.value
	      }, function () {
	        this.validate();
	      });
	    }
	  }, {
	    key: 'validate',
	    value: function validate() {
	      var valid = true;
	
	      for (var i = 0; i < this.props.options.length; i++) {
	        if (this.props.options[i].value === this.state.value && this.props.options[i].disabled) {
	          valid = false;
	          break;
	        }
	      }
	
	      this.setState({ valid: valid }, function () {
	        this.sendValueToParent();
	      });
	    }
	  }, {
	    key: 'sendValueToParent',
	    value: function sendValueToParent() {
	      this.props.callback(this.props.name, {
	        value: this.state.value,
	        valid: this.state.valid
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var classes, errorClasses, disabled, options;
	
	      classes = this.props.classes ? 'input-wrapper ' + this.props.classes : 'input-wrapper';
	      /* Only show the error if the user has blurred the field or the parent
	      forces the error to show (which happens when user clicks submit) */
	      errorClasses = !this.state.valid && (this.state.isBlurred || this.state.showErrorWithoutBlur) ? 'error show' : 'error';
	      options = [];
	
	      // Create the options
	      for (var i = 0; i < this.props.options.length; i++) {
	        disabled = {};
	        if (this.props.options[i].disabled) {
	          disabled['disabled'] = 'disabled';
	        }
	        options.push(_react2.default.createElement(
	          'option',
	          (0, _extends3.default)({ value: this.props.options[i].value, key: i
	          }, disabled),
	          this.props.options[i].key
	        ));
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: classes },
	        _react2.default.createElement(
	          'div',
	          { className: 'styled-select' },
	          _react2.default.createElement(
	            'select',
	            { value: this.state.value, name: this.props.name, onChange: this.onChange },
	            options
	          ),
	          this.renderLabel()
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: errorClasses },
	          this.props.errorMessage
	        )
	      );
	    }
	  }, {
	    key: 'renderLabel',
	    value: function renderLabel() {
	      if (this.props.label) {
	        return _react2.default.createElement(
	          'label',
	          { htmlFor: this.props.name },
	          this.props.label
	        );
	      }
	    }
	  }]);
	  return SelectBox;
	}(_react2.default.Component); /**
	                               * Created by staffanrantzow on 30/03/16.
	                               */
	
	exports.default = SelectBox;

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Briefcase = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Briefcase = exports.Briefcase = function (_React$Component) {
	  (0, _inherits3.default)(Briefcase, _React$Component);
	
	  function Briefcase() {
	    (0, _classCallCheck3.default)(this, Briefcase);
	    return (0, _possibleConstructorReturn3.default)(this, (Briefcase.__proto__ || (0, _getPrototypeOf2.default)(Briefcase)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Briefcase, [{
	    key: 'render',
	    value: function render() {
	      var fill = this.props.colorSchema === 'primary' ? '#00587c' : '#000000';
	
	      return _react2.default.createElement(
	        'svg',
	        {
	          version: '1.1',
	          xmlns: 'http://www.w3.org/2000/svg',
	          width: this.props.width || '20',
	          height: this.props.height || '20',
	          viewBox: '0 0 20 20'
	        },
	        _react2.default.createElement('path', {
	          d: 'M18.5 5h-4.5v-1.5c0-0.827-0.673-1.5-1.5-1.5h-5c-0.827 0-1.5 0.673-1.5' + ' 1.5v1.5h-4.5c-0.827 0-1.5 0.673-1.5 1.5v11c0 0.827 0.673 1.5 1.5 1.5h17c0.827' + ' 0 1.5-0.673 1.5-1.5v-11c0-0.827-0.673-1.5-1.5-1.5zM7 3.5c0-0.276 0.224-0.5' + ' 0.5-0.5h5c0.276 0 0.5 0.224 0.5 0.5v1.5h-6v-1.5zM1.5 6h17c0.276 0 0.5 0.224' + ' 0.5 0.5v7.5h-2v-0.5c0-0.276-0.224-0.5-0.5-0.5h-2c-0.276 0-0.5 0.224-0.5' + ' 0.5v0.5h-8v-0.5c0-0.276-0.224-0.5-0.5-0.5h-2c-0.276 0-0.5 0.224-0.5' + ' 0.5v0.5h-2v-7.5c0-0.276 0.224-0.5 0.5-0.5zM16 14v1h-1v-1h1zM5 14v1h-1v-1h1zM18.5' + ' 18h-17c-0.276 0-0.5-0.224-0.5-0.5v-2.5h2v0.5c0 0.276 0.224 0.5 0.5 0.5h2c0.276 0' + ' 0.5-0.224 0.5-0.5v-0.5h8v0.5c0 0.276 0.224 0.5 0.5 0.5h2c0.276 0 0.5-0.224' + ' 0.5-0.5v-0.5h2v2.5c0 0.276-0.224 0.5-0.5 0.5z',
	          fill: fill })
	      );
	    }
	  }]);
	  return Briefcase;
	}(_react2.default.Component);
	
	exports.default = Briefcase;

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Bullhorn = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Bullhorn = exports.Bullhorn = function (_React$Component) {
	  (0, _inherits3.default)(Bullhorn, _React$Component);
	
	  function Bullhorn() {
	    (0, _classCallCheck3.default)(this, Bullhorn);
	    return (0, _possibleConstructorReturn3.default)(this, (Bullhorn.__proto__ || (0, _getPrototypeOf2.default)(Bullhorn)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Bullhorn, [{
	    key: 'getFillColor',
	    value: function getFillColor() {
	      switch (this.props.colorSchema) {
	        case 'primary':
	          return '#00587c';
	        case 'green-profile':
	          return '#53AD99';
	        case 'white':
	          return '#ffffff';
	        default:
	          return '#34A8C5';
	      }
	    }
	  }, {
	    key: 'getSecondaryFillColor',
	    value: function getSecondaryFillColor() {
	      switch (this.props.colorSchema) {
	        case 'primary':
	          return '#eff8fa';
	        case 'green-profile':
	          return '#beded6';
	        case 'white':
	          return '#d6d6d6';
	        default:
	          return '#b4dce7';
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var fill = this.getFillColor();
	      var secondaryFill = this.getSecondaryFillColor();
	
	      return _react2.default.createElement(
	        'svg',
	        {
	          version: '1.1',
	          xmlns: 'http://www.w3.org/2000/svg',
	          width: this.props.width || '20',
	          height: this.props.height || '20',
	          viewBox: '0 0 20 20',
	          className: this.props.classes
	        },
	        _react2.default.createElement('path', {
	          d: 'M0 7.5C0 6.12109 1.12109 5 2.5 5H7.5V12.5V13.75V18.75C7.5 19.4414 6.94141 20 6.25 20H3.75C3.05859 20 2.5 19.4414 2.5 18.75V13.75C1.12109 13.75 0 12.6289 0 11.25V7.5ZM20 9.375C20 10.4648 19.4766 11.3906 18.75 11.7344V7.01563C19.4766 7.35938 20 8.28516 20 9.375Z',
	          fill: fill
	        }),
	        _react2.default.createElement('path', {
	          d: 'M18.75 1.24998C18.75 0.746071 18.4453 0.28904 17.9766 0.0937273C17.5078 -0.101585 16.9727 0.00778983 16.6133 0.363259L14.9102 2.07029C13.0352 3.94529 10.4922 4.99998 7.83984 4.99998H7.5V6.24998V7.49998V11.25V12.5V13.75H7.83984C10.4922 13.75 13.0352 14.8047 14.9102 16.6797L16.6133 18.3828C16.9727 18.7422 17.5078 18.8476 17.9766 18.6523C18.4453 18.457 18.75 18.0039 18.75 17.4961V1.24998Z',
	          fill: secondaryFill
	        })
	      );
	    }
	  }]);
	  return Bullhorn;
	}(_react2.default.Component);
	
	exports.default = Bullhorn;

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Calendar = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Calendar = exports.Calendar = function (_React$Component) {
	  (0, _inherits3.default)(Calendar, _React$Component);
	
	  function Calendar() {
	    (0, _classCallCheck3.default)(this, Calendar);
	    return (0, _possibleConstructorReturn3.default)(this, (Calendar.__proto__ || (0, _getPrototypeOf2.default)(Calendar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Calendar, [{
	    key: 'render',
	    value: function render() {
	      var fill = this.props.colorSchema === 'primary' ? '#00587c' : '#000000';
	
	      return _react2.default.createElement(
	        'svg',
	        {
	          version: '1.1',
	          xmlns: 'http://www.w3.org/2000/svg',
	          width: this.props.width || '20',
	          height: this.props.height || '20',
	          viewBox: '0 0 20 20'
	        },
	        _react2.default.createElement('path', {
	          d: 'M18.5 2h-2.5v-0.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v0.5h-10v-0.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v0.5h-2.5c-0.827 0-1.5 0.673-1.5 1.5v14c0 0.827 0.673 1.5 1.5 1.5h17c0.827 0 1.5-0.673 1.5-1.5v-14c0-0.827-0.673-1.5-1.5-1.5zM1.5 3h2.5v1.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-1.5h10v1.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-1.5h2.5c0.276 0 0.5 0.224 0.5 0.5v2.5h-18v-2.5c0-0.276 0.224-0.5 0.5-0.5zM18.5 18h-17c-0.276 0-0.5-0.224-0.5-0.5v-10.5h18v10.5c0 0.276-0.224 0.5-0.5 0.5z',
	          fill: fill
	        }),
	        _react2.default.createElement('path', {
	          d: 'M7.5 10h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z',
	          fill: fill
	        }),
	        _react2.default.createElement('path', {
	          d: 'M10.5 10h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z',
	          fill: fill
	        }),
	        _react2.default.createElement('path', {
	          d: 'M13.5 10h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z',
	          fill: fill
	        }),
	        _react2.default.createElement('path', {
	          d: 'M16.5 10h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z',
	          fill: fill
	        }),
	        _react2.default.createElement('path', {
	          d: 'M4.5 12h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z',
	          fill: fill
	        }),
	        _react2.default.createElement('path', {
	          d: 'M7.5 12h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z',
	          fill: fill
	        }),
	        _react2.default.createElement('path', {
	          d: 'M10.5 12h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z',
	          fill: fill
	        }),
	        _react2.default.createElement('path', {
	          d: 'M13.5 12h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z',
	          fill: fill
	        }),
	        _react2.default.createElement('path', {
	          d: 'M16.5 12h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z',
	          fill: fill
	        }),
	        _react2.default.createElement('path', {
	          d: 'M4.5 14h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z',
	          fill: fill
	        }),
	        _react2.default.createElement('path', {
	          d: 'M7.5 14h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z',
	          fill: fill
	        }),
	        _react2.default.createElement('path', {
	          d: 'M10.5 14h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z',
	          fill: fill
	        }),
	        _react2.default.createElement('path', {
	          d: 'M13.5 14h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z',
	          fill: fill
	        }),
	        _react2.default.createElement('path', {
	          d: 'M16.5 14h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z',
	          fill: fill
	        }),
	        _react2.default.createElement('path', {
	          d: 'M4.5 16h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z',
	          fill: fill
	        }),
	        _react2.default.createElement('path', {
	          d: 'M7.5 16h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z',
	          fill: fill
	        }),
	        _react2.default.createElement('path', {
	          d: 'M10.5 16h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z',
	          fill: fill
	        }),
	        _react2.default.createElement('path', {
	          d: 'M13.5 16h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z',
	          fill: fill
	        }),
	        _react2.default.createElement('path', {
	          d: 'M16.5 16h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z',
	          fill: fill
	        })
	      );
	    }
	  }]);
	  return Calendar;
	}(_react2.default.Component);
	
	exports.default = Calendar;

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CashBlank = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CashBlank = exports.CashBlank = function (_React$Component) {
	  (0, _inherits3.default)(CashBlank, _React$Component);
	
	  function CashBlank() {
	    (0, _classCallCheck3.default)(this, CashBlank);
	    return (0, _possibleConstructorReturn3.default)(this, (CashBlank.__proto__ || (0, _getPrototypeOf2.default)(CashBlank)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CashBlank, [{
	    key: 'render',
	    value: function render() {
	      var fill = this.props.colorSchema === 'primary' ? '#00587c' : '#000000';
	
	      return _react2.default.createElement(
	        'svg',
	        {
	          version: '1.1',
	          xmlns: 'http://www.w3.org/2000/svg',
	          width: this.props.width || '20',
	          height: this.props.height || '20',
	          viewBox: '0 0 20 20'
	        },
	        _react2.default.createElement('path', {
	          d: 'M19,17.55H1c-0.276,0-0.5-0.225-0.5-0.5v-10c0-0.276,0.224-0.5,0.5-0.5h18c0.275,0,0.5,0.224,0.5,0.5v10 C19.5,17.325,19.275,17.55,19,17.55z M1.5,16.55h17v-9h-17V16.55z',
	          fill: fill
	        }),
	        _react2.default.createElement('path', {
	          d: 'M18,5.55H2c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h16c0.275,0,0.5,0.224,0.5,0.5S18.275,5.55,18,5.55z',
	          fill: fill
	        }),
	        _react2.default.createElement('path', {
	          d: 'M17,3.55H3c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h14c0.275,0,0.5,0.224,0.5,0.5S17.275,3.55,17,3.55z',
	          fill: fill
	        })
	      );
	    }
	  }]);
	  return CashBlank;
	}(_react2.default.Component);
	
	exports.default = CashBlank;

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CashSek = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CashSek = exports.CashSek = function (_React$Component) {
	  (0, _inherits3.default)(CashSek, _React$Component);
	
	  function CashSek() {
	    (0, _classCallCheck3.default)(this, CashSek);
	    return (0, _possibleConstructorReturn3.default)(this, (CashSek.__proto__ || (0, _getPrototypeOf2.default)(CashSek)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CashSek, [{
	    key: 'render',
	    value: function render() {
	      var fill = this.props.colorSchema === 'primary' ? '#00587c' : '#000000';
	
	      return _react2.default.createElement(
	        'svg',
	        {
	          version: '1.1',
	          xmlns: 'http://www.w3.org/2000/svg',
	          width: this.props.width || '20',
	          height: this.props.height || '20',
	          viewBox: '0 0 20 20'
	        },
	        _react2.default.createElement('path', {
	          d: 'M19,17.55H1c-0.276,0-0.5-0.225-0.5-0.5v-10c0-0.276,0.224-0.5,0.5-0.5h18c0.275,0,0.5,0.224,0.5,0.5v10 C19.5,17.325,19.275,17.55,19,17.55z M1.5,16.55h17v-9h-17V16.55z',
	          fill: fill
	        }),
	        _react2.default.createElement('path', {
	          d: 'M18,5.55H2c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h16c0.275,0,0.5,0.224,0.5,0.5S18.275,5.55,18,5.55z',
	          fill: fill
	        }),
	        _react2.default.createElement('path', {
	          d: 'M17,3.55H3c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h14c0.275,0,0.5,0.224,0.5,0.5S17.275,3.55,17,3.55z',
	          fill: fill
	        }),
	        _react2.default.createElement(
	          'g',
	          null,
	          _react2.default.createElement('path', {
	            d: 'M5.125,14.458c-0.248-0.065-0.441-0.149-0.581-0.252c-0.131-0.089-0.196-0.177-0.196-0.266c0-0.07,' + '0.026-0.154,0.077-0.252' + ' c0.051-0.099,0.112-0.185,0.182-0.259c0.07-0.075,0.128-0.112,0.175-0.112c0.028,0,0.093,0.028,0.196,0.084' + ' c0.149,0.074,0.284,0.133,0.406,0.175s0.264,0.063,0.427,0.063c0.182,0,0.337-0.036,0.465-0.109' + ' c0.128-0.072,0.192-0.199,0.192-0.381c0-0.149-0.06-0.268-0.178-0.354c-0.119-0.087-0.312-0.184-0.578-' + '0.291l-0.322-0.14' + ' c-0.294-0.14-0.525-0.313-0.693-0.521s-0.252-0.503-0.252-0.886c0-0.317,0.078-0.582,0.234-0.794' + ' c0.156-0.212,0.361-0.369,0.613-0.469c0.252-0.1,0.522-0.15,0.812-0.15c0.238,0,0.454,0.024,0.647,0.074' + ' C6.946,9.667,7.098,9.73,7.211,9.81c0.103,0.075,0.154,0.149,0.154,0.224c0,0.065-0.021,0.147-0.063,0.245' + ' s-0.093,0.184-0.154,0.256c-0.061,0.072-0.117,0.108-0.168,0.108c-0.023,0-0.062-0.012-0.116-0.035s-0.099-' + '0.042-0.136-0.057' + ' c-0.168-0.056-0.343-0.084-0.525-0.084c-0.243,0-0.412,0.04-0.507,0.119c-0.096,0.08-0.144,0.171-0.144,' + '0.273' + ' c0,0.121,0.033,0.222,0.098,0.301s0.145,0.144,0.238,0.192s0.231,0.113,0.413,0.192c0.266,0.112,0.483,0.219' + ',0.651,0.318' + ' c0.168,0.101,0.314,0.245,0.438,0.435c0.124,0.188,0.186,0.431,0.186,0.725c0,0.359-0.076,0.653-0.228,0.882' + ' c-0.151,0.229-0.346,0.395-0.584,0.497c-0.238,0.103-0.495,0.154-0.77,0.154C5.661,14.556,5.372,14.523,' + '5.125,14.458z',
	            fill: fill
	          }),
	          _react2.default.createElement('path', {
	            d: 'M8.292,14.433c-0.044-0.044-0.066-0.115-0.066-0.213V9.88c0-0.098,0.022-0.169,0.066-0.213' + ' C8.336,9.622,8.407,9.6,8.506,9.6h2.458c0.074,0,0.128,0.028,0.161,0.084c0.032,0.056,0.049,0.145,0.049,' + '0.266v0.217' + ' c0,0.122-0.017,0.209-0.049,0.266c-0.033,0.056-0.087,0.084-0.161,0.084h-1.66v1.015h1.47c0.075,0,0.129,' + '0.028,0.161,0.084' + ' s0.049,0.145,0.049,0.266v0.218c0,0.121-0.017,0.21-0.049,0.266s-0.086,0.084-0.161,0.084h-1.47v1.134h1.667' + ' c0.074,0,0.128,0.028,0.161,0.084c0.032,0.057,0.049,0.145,0.049,0.267v0.217c0,0.121-0.017,0.21-0.049,' + '0.266' + ' c-0.033,0.057-0.087,0.084-0.161,0.084H8.506C8.407,14.5,8.336,14.478,8.292,14.433z',
	            fill: fill
	          }),
	          _react2.default.createElement('path', {
	            d: 'M11.998,14.29V9.81c0-0.149,0.141-0.224,0.42-0.224h0.245c0.28,0,0.42,0.075,0.42,0.224v1.876l0.028,' + '0.007l1.218-1.974' + ' c0.052-0.089,0.191-0.133,0.42-0.133h0.329c0.262,0,0.393,0.035,0.393,0.105c0,0.042-0.019,0.091-0.057,' + '0.147l-1.351,2.072' + ' l1.533,2.353c0.037,0.056,0.056,0.104,0.056,0.146c0,0.07-0.131,0.105-0.392,0.105h-0.406c-0.233,' + '0-0.376-0.045-0.427-0.134' + ' l-1.316-2.128l-0.028,0.007v2.03c0,0.149-0.14,0.225-0.42,0.225h-0.245C12.139,14.514,11.998,14.439,11.998,' + '14.29z',
	            fill: fill
	          })
	        )
	      );
	    }
	  }]);
	  return CashSek;
	}(_react2.default.Component);
	
	exports.default = CashSek;

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Cog = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Cog = exports.Cog = function (_React$Component) {
	  (0, _inherits3.default)(Cog, _React$Component);
	
	  function Cog() {
	    (0, _classCallCheck3.default)(this, Cog);
	    return (0, _possibleConstructorReturn3.default)(this, (Cog.__proto__ || (0, _getPrototypeOf2.default)(Cog)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Cog, [{
	    key: 'render',
	    value: function render() {
	      var fill = this.props.colorSchema === 'primary' ? '#00587c' : '#FFFFFF';
	
	      return _react2.default.createElement(
	        'svg',
	        {
	          version: '1.1',
	          xmlns: 'http://www.w3.org/2000/svg',
	          width: this.props.width || '20',
	          height: this.props.height || '20',
	          viewBox: '0 0 20 20'
	        },
	        _react2.default.createElement('path', { d: 'M7.631 19.702c-0.041' + ' 0-0.083-0.005-0.125-0.016-0.898-0.231-1.761-0.587-2.564-1.059-0.233-0.137-0.315-0.434-0.186-0.671' + ' 0.159-0.292 0.243-0.622 0.243-0.957 0-1.103-0.897-2-2-2-0.334 0-0.665 0.084-0.957 0.243-0.237' + ' 0.129-0.534 0.047-0.671-0.186-0.472-0.804-0.828-1.666-1.059-2.564-0.065-0.254 0.077-0.515 0.325-0.598' + ' 0.814-0.274 1.362-1.036 1.362-1.895s-0.547-1.621-1.362-1.895c-0.248-0.084-0.39-0.344-0.325-0.598' + ' 0.231-0.898 0.587-1.761 1.059-2.564 0.137-0.233 0.434-0.315 0.671-0.186 0.291 0.159 0.622 0.243 0.957' + ' 0.243 1.103 0 2-0.897 2-2 0-0.334-0.084-0.665-0.243-0.957-0.129-0.237-0.047-0.534 0.186-0.671' + ' 0.804-0.472 1.666-0.828 2.564-1.059 0.254-0.065 0.515 0.077 0.598 0.325 0.274 0.814 1.036 1.362 1.895' + ' 1.362s1.621-0.547 1.895-1.362c0.084-0.248 0.345-0.39 0.598-0.325 0.898 0.231 1.761 0.587 2.564 1.059' + ' 0.233 0.137 0.315 0.434 0.186 0.671-0.159 0.292-0.243 0.622-0.243 0.957 0 1.103 0.897 2 2 2 0.334 0' + ' 0.665-0.084 0.957-0.243 0.237-0.129 0.534-0.047 0.671 0.186 0.472 0.804 0.828 1.666 1.059 2.564 0.065' + ' 0.254-0.077 0.515-0.325 0.598-0.814 0.274-1.362 1.036-1.362 1.895s0.547 1.621 1.362 1.895c0.248 0.084' + ' 0.39 0.344 0.325 0.598-0.231 0.898-0.587 1.761-1.059 2.564-0.137' + ' 0.233-0.434 0.315-0.671 0.186-0.292-0.159-0.622-0.243-0.957-0.243-1.103 0-2 0.897-2 2 0 0.334 0.084' + ' 0.665 0.243 0.957 0.129 0.237 0.047 0.534-0.186 0.671-0.804 0.472-1.666 0.828-2.564 1.059-0.254' + ' 0.065-0.515-0.077-0.598-0.325-0.274-0.814-1.036-1.362-1.895-1.362s-1.621 0.547-1.895 1.362c-0.070' + ' 0.207-0.264 0.341-0.474 0.341zM10 17c1.127 0 2.142 0.628 2.655 1.602 0.52-0.161 1.026-0.369' + ' 1.51-0.622-0.108-0.314-0.164-0.646-0.164-0.98 0-1.654 1.346-3 3-3 0.334 0 0.666 0.056 0.98 0.164' + ' 0.253-0.484 0.462-0.989 0.622-1.51-0.974-0.512-1.602-1.527-1.602-2.655s0.628-2.142' + ' 1.602-2.655c-0.161-0.52-0.369-1.026-0.622-1.51-0.314 0.108-0.646 0.164-0.98 0.164-1.654 0-3-1.346-3-3' + ' 0-0.334 0.056-0.666 0.164-0.98-0.484-0.253-0.989-0.462-1.51-0.622-0.512 0.974-1.527 1.602-2.655' + ' 1.602s-2.142-0.628-2.655-1.602c-0.52 0.16-1.026 0.369-1.51 0.622 0.108 0.314 0.164 0.646 0.164 0.98 0' + ' 1.654-1.346 3-3 3-0.334 0-0.666-0.056-0.98-0.164-0.253 0.484-0.462 0.989-0.622 1.51 0.974 0.512 1.602' + ' 1.527 1.602 2.655s-0.628 2.142-1.602 2.655c0.16 0.52 0.369 1.026 0.622 1.51 0.314-0.108 0.646-0.164' + ' 0.98-0.164 1.654 0 3 1.346 3 3 0 0.334-0.056 0.666-0.164 0.98 0.484 0.253 0.989 0.462 1.51 0.622' + ' 0.512-0.974 1.527-1.602 2.655-1.602z',
	          fill: fill }),
	        _react2.default.createElement('path', { d: 'M10 13c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zM10 8c-1.103 0-2 0.897-2' + ' 2s0.897 2 2 2c1.103 0 2-0.897 2-2s-0.897-2-2-2z',
	          fill: fill })
	      );
	    }
	  }]);
	  return Cog;
	}(_react2.default.Component);
	
	exports.default = Cog;

/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Cross = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Cross = exports.Cross = function (_React$Component) {
	  (0, _inherits3.default)(Cross, _React$Component);
	
	  function Cross() {
	    (0, _classCallCheck3.default)(this, Cross);
	    return (0, _possibleConstructorReturn3.default)(this, (Cross.__proto__ || (0, _getPrototypeOf2.default)(Cross)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Cross, [{
	    key: 'setFillColor',
	    value: function setFillColor() {
	      switch (this.props.colorSchema) {
	        case 'primary':
	          return '#00587c';
	        case 'white':
	          return '#FFFFFF';
	        default:
	          return '#000000';
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var fill = this.setFillColor();
	
	      return _react2.default.createElement(
	        'svg',
	        {
	          version: '1.1',
	          xmlns: 'http://www.w3.org/2000/svg',
	          width: this.props.width || '20',
	          height: this.props.height || '20',
	          viewBox: '0 0 20 20'
	        },
	        _react2.default.createElement('path', {
	          d: 'M10.707 10.5l5.646-5.646c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.646 5.646-5.646-5.646c-0.195-0.195-0.512-0.195-0.707 0s-0.195 0.512 0 0.707l5.646 5.646-5.646 5.646c-0.195 0.195-0.195 0.512 0 0.707 0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l5.646-5.646 5.646 5.646c0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146c0.195-0.195 0.195-0.512 0-0.707l-5.646-5.646z',
	          fill: fill
	        })
	      );
	    }
	  }]);
	  return Cross;
	}(_react2.default.Component);
	
	exports.default = Cross;

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Document = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Document = exports.Document = function (_React$Component) {
	  (0, _inherits3.default)(Document, _React$Component);
	
	  function Document() {
	    (0, _classCallCheck3.default)(this, Document);
	    return (0, _possibleConstructorReturn3.default)(this, (Document.__proto__ || (0, _getPrototypeOf2.default)(Document)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Document, [{
	    key: 'render',
	    value: function render() {
	      var fill = this.props.colorSchema === 'primary' ? '#00587c' : '#000000';
	
	      return _react2.default.createElement(
	        'svg',
	        {
	          version: '1.1',
	          xmlns: 'http://www.w3.org/2000/svg',
	          width: this.props.width || '20',
	          height: this.props.height || '20',
	          viewBox: '0 0 20 20'
	        },
	        _react2.default.createElement('path', { d: 'M16.5 20h-13c-0.827 0-1.5-0.673-1.5-1.5v-16c0-0.827 0.673-1.5 1.5-1.5h13c0.827' + ' 0 1.5 0.673 1.5 1.5v16c0 0.827-0.673 1.5-1.5 1.5zM3.5 2c-0.276 0-0.5 0.224-0.5' + ' 0.5v16c0 0.276 0.224 0.5 0.5 0.5h13c0.276 0 0.5-0.224' + ' 0.5-0.5v-16c0-0.276-0.224-0.5-0.5-0.5h-13z',
	          fill: fill }),
	        _react2.default.createElement('path', {
	          d: 'M12.5 5h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224' + ' 0.5 0.5s-0.224 0.5-0.5 0.5z',
	          fill: fill }),
	        _react2.default.createElement('path', {
	          d: 'M14.5 7h-9c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h9c0.276 0 0.5 0.224 0.5' + ' 0.5s-0.224 0.5-0.5 0.5z',
	          fill: fill }),
	        _react2.default.createElement('path', {
	          d: 'M14.5 9h-9c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h9c0.276 0 0.5 0.224' + ' 0.5 0.5s-0.224 0.5-0.5 0.5z',
	          fill: fill }),
	        _react2.default.createElement('path', {
	          d: 'M10.5 11h-5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h5c0.276 0 0.5 0.224 0.5' + ' 0.5s-0.224 0.5-0.5 0.5z',
	          fill: fill }),
	        _react2.default.createElement('path', {
	          d: 'M14.5 15h-9c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h9c0.276 0 0.5 0.224 0.5' + ' 0.5s-0.224 0.5-0.5 0.5z',
	          fill: fill }),
	        _react2.default.createElement('path', {
	          d: 'M12.5 17h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5' + ' 0.5s-0.224 0.5-0.5 0.5z',
	          fill: fill })
	      );
	    }
	  }]);
	  return Document;
	}(_react2.default.Component);
	
	exports.default = Document;

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Envelope = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Envelope = exports.Envelope = function (_React$Component) {
	  (0, _inherits3.default)(Envelope, _React$Component);
	
	  function Envelope() {
	    (0, _classCallCheck3.default)(this, Envelope);
	    return (0, _possibleConstructorReturn3.default)(this, (Envelope.__proto__ || (0, _getPrototypeOf2.default)(Envelope)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Envelope, [{
	    key: 'render',
	    value: function render() {
	      var fill = this.props.colorSchema === 'primary' ? '#00587c' : '#000000';
	
	      return _react2.default.createElement(
	        'svg',
	        {
	          version: '1.1',
	          xmlns: 'http://www.w3.org/2000/svg',
	          width: this.props.width || '20',
	          height: this.props.height || '20',
	          viewBox: '0 0 20 20'
	        },
	        _react2.default.createElement('path', {
	          d: 'M17.5 6h-16c-0.827 0-1.5 0.673-1.5 1.5v9c0 0.827 0.673 1.5 1.5 1.5h16c0.827 0 1.5-0.673 1.5-1.5v-9c0-0.827-0.673-1.5-1.5-1.5zM17.5 7c0.030 0 0.058 0.003 0.087 0.008l-7.532 5.021c-0.29 0.193-0.819 0.193-1.109 0l-7.532-5.021c0.028-0.005 0.057-0.008 0.087-0.008h16zM17.5 17h-16c-0.276 0-0.5-0.224-0.5-0.5v-8.566l7.391 4.927c0.311 0.207 0.71 0.311 1.109 0.311s0.798-0.104 1.109-0.311l7.391-4.927v8.566c0 0.276-0.224 0.5-0.5 0.5z',
	          fill: fill
	        })
	      );
	    }
	  }]);
	  return Envelope;
	}(_react2.default.Component);
	
	exports.default = Envelope;

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FileAdd = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileAdd = exports.FileAdd = function (_React$Component) {
	  (0, _inherits3.default)(FileAdd, _React$Component);
	
	  function FileAdd() {
	    (0, _classCallCheck3.default)(this, FileAdd);
	    return (0, _possibleConstructorReturn3.default)(this, (FileAdd.__proto__ || (0, _getPrototypeOf2.default)(FileAdd)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(FileAdd, [{
	    key: 'render',
	    value: function render() {
	      var fill = this.props.colorSchema === 'primary' ? '#00587c' : '#000000';
	
	      return _react2.default.createElement(
	        'svg',
	        {
	          version: '1.1',
	          xmlns: 'http://www.w3.org/2000/svg',
	          width: this.props.width || '20',
	          height: this.props.height || '20',
	          viewBox: '0 0 20 20'
	        },
	        _react2.default.createElement('path', {
	          d: 'M17.854 5.646l-4.5-4.5c-0.094-0.094-0.221-0.146-0.354-0.146h-9.5c-0.827' + ' 0-1.5 0.673-1.5 1.5v16c0 0.827 0.673 1.5 1.5 1.5h13c0.827 0 1.5-0.673' + ' 1.5-1.5v-12.5c0-0.133-0.053-0.26-0.146-0.354zM16.793 6h-3.293c-0.276' + ' 0-0.5-0.224-0.5-0.5v-3.293l3.793 3.793zM16.5 19h-13c-0.276' + ' 0-0.5-0.224-0.5-0.5v-16c0-0.276 0.224-0.5 0.5-0.5h8.5v3.5c0 0.827 0.673 1.5 1.5' + ' 1.5h3.5v11.5c0 0.276-0.224 0.5-0.5 0.5z',
	          fill: fill }),
	        _react2.default.createElement('path', {
	          d: 'M11.5 13h-2.5v-2.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5' + ' 0.5v2.5h-2.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h2.5v2.5c0 0.276 0.224 0.5' + ' 0.5 0.5s0.5-0.224 0.5-0.5v-2.5h2.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5z',
	          fill: fill })
	      );
	    }
	  }]);
	  return FileAdd;
	}(_react2.default.Component);
	
	exports.default = FileAdd;

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LogoInvoiceWithoutCompany = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LogoInvoiceWithoutCompany = exports.LogoInvoiceWithoutCompany = function (_React$Component) {
	  (0, _inherits3.default)(LogoInvoiceWithoutCompany, _React$Component);
	
	  function LogoInvoiceWithoutCompany() {
	    (0, _classCallCheck3.default)(this, LogoInvoiceWithoutCompany);
	    return (0, _possibleConstructorReturn3.default)(this, (LogoInvoiceWithoutCompany.__proto__ || (0, _getPrototypeOf2.default)(LogoInvoiceWithoutCompany)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LogoInvoiceWithoutCompany, [{
	    key: 'getFillColor',
	    value: function getFillColor() {
	      switch (this.props.colorSchema) {
	        case 'primary':
	          return '#00587c';
	        case 'green-profile':
	          return '#53AD99';
	        case 'white':
	          return '#ffffff';
	        default:
	          return '#000000';
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var fillColor = this.getFillColor();
	
	      return _react2.default.createElement(
	        'svg',
	        {
	          version: '1.1',
	          id: 'Layer_1',
	          xmlns: 'http://www.w3.org/2000/svg',
	          x: '0px',
	          y: '0px',
	          viewBox: '0 0 432.3 109.7'
	        },
	        _react2.default.createElement('path', { d: 'M0.1,101.4V78.1c0-0.3,0.1-0.6,0.3-0.8C0.6,77.1,0.9,77,1.1,77h11.3c0.2,0,0.4,0.1,' + '0.6,0.3c0.1,0.3,0.2,0.5,0.2,0.8v0.6c0,0.3,0,0.6-0.2,0.8c-0.1,0.2-0.3,0.3-0.6,0.3H3.2V88' + 'h8.5c0.2,0,0.4,0.1,0.6,0.3c0.1,0.3,0.2,0.5,0.2,0.8v0.6c0,0.3,0,0.6-0.2,0.8c-0.1,0.2-0.3' + ',0.3-0.6,0.3H3.2v10.7c0,0.5-0.5,0.8-1.4,0.8H1.5C0.6,102.2,0.1,101.9,0.1,101.4z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M18,100.9c-1.2-1-1.8-2.5-1.7-4c-0.1-1.6,0.5-3.2,1.7-4.2s2.6-1.6,4.2-1.8c2-0.3,4-0.4,' + '6-0.4v-1.7c0-0.8-0.3-1.6-0.9-2.2c-0.9-0.6-1.9-0.9-3-0.8c-0.9,0-1.9,0.1-2.8,0.4c-0.7,' + '0.2-1.3,0.5-2,0.8c-0.3,0.1-0.6,0.3-0.9,0.4c-0.2,0-0.5-0.2-0.8-0.7c-0.2-0.3-0.4-0.7-0.4-1' + '.1c0-0.3,0.3-0.6,0.9-1c0.8-0.4,1.6-0.7,2.5-0.9c1.1-0.3,2.2-0.4,3.3-0.4c1.8-0.1,3.7,0.4,5' + '.2,1.5c1.2,1,1.9,2.5,1.9,4.1v8c0,1.1,0,2.3,0.2,3.4c0.1,0.7,0.2,1.1,0.2,1.1c0,0.3-0.2,0.5' + '-0.7,0.6c-0.4,0.1-0.8,0.2-1.3,0.2c-0.3,0-0.6-0.2-0.7-0.6c-0.2-0.4-0.3-0.8-0.4-1.2c-0.1-0' + '.4-0.1-0.7-0.2-0.8c-1.5,1.7-3.7,2.7-6,2.7C20.9,102.4,19.3,101.9,18,100.9z M25.6,99c0.9-' + '0.5,1.8-1.1,2.6-1.8V93c-1.8,0-3.2,0.1-4.4,0.2c-1.1,0.1-2.1,0.4-3,1c-0.9,0.5-1.4,1.5-1.3,' + '2.5c-0.1,0.8,0.2,1.6,0.8,2.2c0.6,0.5,1.4,0.8,2.3,0.8C23.6,99.7,24.7,99.5,25.6,99z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M51.4,101.7c0,0.2-0.1,0.3-0.4,0.4c-0.4,0.1-0.8,0.1-1.2,0.1h-0.1c-0.4,0-0.8,0-1.2-' + '0.1c-0.3,0-0.5-0.2-0.7-0.4l-7.2-8.5h-0.1v8.2c0,0.5-0.5,0.8-1.4,0.8H39c-1,0-1.4-0.3-1.4-' + '0.8V76c0-0.5,0.5-0.8,1.4-0.8l0,0c1,0,1.4,0.3,1.4,0.8v16h0.1l6.8-8.2c0.3-0.3,0.9-0.5,1.9-' + '0.5h0.1c0.3,0,0.6,0,0.9,0.1c0.2,0.1,0.3,0.2,0.3,0.3c0,0.3-0.2,0.5-0.4,0.7l-6.7,7.9l7.4,' + '8.7C51.2,101.2,51.4,101.4,51.4,101.7z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M58,101.2c-0.9-0.7-1.4-2-1.4-3.8V85.9h-1.8c-0.2,' + '0-0.4-0.1-0.5-0.3c-0.1-0.3-0.2-0.5-0.2-0.8v-0.4c0-0.3,' + '0-0.6,0.2-0.8c0.1-0.2,0.3-0.3,0.5-0.3h1.8l0.4-3.8c0.1-0.5,' + '0.5-0.8,1.1-0.8h0.4c0.7,0,1.1,0.3,1.1,0.8v3.8h3c0.2,0,0.4,0.1,' + '0.6,0.3c0.1,0.3,0.2,0.5,0.2,0.8v0.4c0,0.3,0,0.6-0.2,0.8c-0.1,0.2-0.3,' + '0.3-0.6,0.3h-3V97c-0.1,0.7,0.1,1.5,0.5,2.1c0.4,0.4,0.9,0.6,1.4,0.6c0.3,' + '0,0.7,0,1-0.1c0.2-0.1,0.3-0.1,0.5-0.1s0.4,0.2,0.5,0.7c0.1,0.3,0.2,0.7,' + '0.2,1c0,0.7-0.9,1.1-2.6,1.1C60,102.3,58.9,101.9,58,101.2z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M69.2,100.8c-1.1-1.1-1.6-2.7-1.6-4.3V84.1c0-0.5,0.5-0.8,1.4-0.8h0.1c1,0,1.4,0.3,1.4,' + '0.8v12.1c-0.1,0.9,0.3,1.9,0.9,2.6c0.7,0.6,1.7,1,2.7,0.9c0.9,0,1.7-0.2,2.4-0.7c0.8-0.5,1.5-1.1,' + '2.1-1.8V84.1c0-0.5,0.5-0.8,1.4-0.8h0.1c1,0,1.4,0.3,1.4,0.8v12.7c0,1.1,0,2.3,0.2,3.4c0.1,0.7,0.2,' + '1.1,0.2,1.1c0,0.3-0.2,0.5-0.7,0.6c-0.4,0.1-0.8,0.2-1.3,0.2c-0.3,0-0.6-0.2-0.7-0.6c-0.2-0.4-0.3-' + '0.8-0.4-1.2c-0.1-0.4-0.1-0.7-0.2-0.8c-0.7,0.8-1.6,1.5-2.6,2c-0.9,0.5-1.9,0.7-3,0.7C71.9,102.4,70.3,' + '101.8,69.2,100.8z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M88.1,101.4V88.8c0-1.1,0-2.3-0.2-3.4c-0.1-0.7-0.2-1.1-0.2-1.1c0-0.3,0.2-0.5,' + '0.7-0.6c0.4-0.1, 0.8-0.2,1.3-0.2c0.3,0,0.6,0.2,0.7,0.5c0.2,0.4,0.3,0.7,0.4,1.1s0.1,' + '0.6,0.2,0.8c1.3-1.8,2.6-2.7,4.1-2.7c0.5,0,1.1,0.1,1.5,0.4c0.3,0.2,0.5,0.6,0.5,1s-0' + '.1,0.9-0.2,1.3s-0.3,0.7-0.5,0.7s-0.5-0.1-0.7-0.2c-0.4-0.1-0.8-0.2-1.3-0.2c-0.6,0-1.' + '1,0.2-1.6,0.5s-0.9,0.6-1.2,1.1c-0.2,0.2-0.4,0.4-0.5,0.6v13.1c0,0.5-0.5, 0.8-1.4,0.8' + 'h-0.1C88.6,102.2,88.1,101.9,88.1,101.4z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M102.1,100c-1.4-1.5-2.1-3.9-2.1-7.1s0.7-5.6,2.1-7.2c1.6-1.7,3.9-2.6,6.2-2.5' + 'c2.1-0.1,4.2,0.7,5.5 ,2.4c1.2,1.6,1.9,3.9,1.9,7c-0.1,0.3-0.2,0.6-0.4,0.9c-0.3,0.' + '4-0.5,0.6-0.8,0.6h-11.3c0,1.6,0.5,3.1,1.5,4.4c1.1,1,2.5,1.5,4,1.4c0.9,0,1.8-0.1,2.' + '6-0.4c0.6-0.2,1.2-0.5,1.8-0.8c0.3-0.2,0.5-0.3,0.8-0.4c0.2,0,0.5,0.2 ,0.8,0.7c0.2,0.' + '3,0.4,0.7,0.4,1.1c0,0.3-0.3,0.6-0.9,1c-0.7,0.4-1.5,0.7-2.4,0.9c-1,0.3-2.1,0.4-3.2,0.4' + 'C105.7,102.3,103.5,101.5,102.1,100z M112.4,91.4c0-3.8-1.4-5.7-4.3-5.7c-3.1,0-4.7,1.9-' + '5,5.7H112.4z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M120.5,101.4V88.8c0-1.1,0-2.3-0.2-3.4c-0.1-0.7-0.2-1.1-0.2-1.1c0-0.3,0.2-0.5,0.7-0.' + '6c0.4-0.1, 0.8-0.2,1.3-0.2c0.3,0,0.6,0.2,0.7,0.5c0.2,0.4,0.3,0.7,0.4,1.1s0.1,0.6,0.2,0.8c1' + '.3-1.8,2.6-2.7,4.1-2.7c0.5,0,1.1,0.1,1.5,0.4c0.3,0.2,0.5,0.6,0.5,1s-0.1,0.9-0.2,1.3c-0.1' + ',0.4-0.3,0.7-0.5,0.7s-0.5-0.1-0.7-0.2c-0.4-0.1-0.8-0.2-1.3-0.2c-0.6,0-1.1,0.2-1.6,0.5s-0.9,0' + '.6-1.2,1.1c-0.2,0.2-0.4,0.4-0.5,0.6v13.1c0,0.5 -0.5,0.8-1.4,0.8H122C120.9,102.2,120.5,' + '101.9,120.5,101.4z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M133.8,100.9c-1.2-1-1.8-2.5-1.7-4c-0.1-1.6,0.5-3.2,' + '1.7-4.2s2.6-1.6,4.2-1.8c2-0.3,4-0.4,' + '6-0.4v-1.7c0-0.8-0.3-1.6-0.9-2.2c-0.9-0.6-1.9-0.9-3-0.8c-0.9,' + '0-1.9,0.1-2.8,0.4c-0.7,' + '0.2-1.3,0.5-2,0.8c-0.3,0.1-0.6,0.3-0.9,' + '0.4c-0.2,0-0.5-0.2-0.8-0.7c-0.2-0.3-0.4-0.7-0.4-1.1c0-0.3,' + '0.3-0.6,0.9-1c0.8-0.4,1.6-0.7,2.5-0.9c1.1-0.3,2.2-0.4,3.3-0.4c1.8-0.1,3.7,0.4,' + '5.2,1.5c1.2,1,1.9,2.5,1.9,4.1v8c0,1.1,0,2.3,0.2,3.4c0.1,0.7,0.2,1.1,0.2,1.1c0,0.3-0.2,0.5-0.7,' + '0.6c-0.4,0.1-0.8,0.2-1.3,0.2c-0.3,' + '0-0.6-0.2-0.7-0.6c-0.2-0.4-0.3-0.8-0.4-1.2c-0.1-0.4-0.1-0.7-0.2-0.8c-1.5,' + '1.7-3.7,2.7-6,2.7C136.6,102.4,135,101.9,133.8,100.9z M141.4,99c0.9-0.5,' + '1.8-1.1,2.6-1.8V93c-1.8,0-3.2 ,0.1-4.4,0.2c-1.1,' + '0.1-2.1,0.4-3,1c-0.9,0.5-1.4,1.5-1.3,' + '2.5c-0.1,0.8,0.2,1.6,0.8,2.2c0.6,0.5,1.4,0.8,2.3,0.8C139.4,' + '99.7,140.4,99.5,141.4,99L141.4,99z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M162.6,100.8c-1.1-1.1-1.6-2.7-1.6-4.3V84.1c0-0.5,0.5-0.8,1.4-0.8h0.1c1,0,1.4,0.3,1.' + '4,0.8v12.1c-0.1,0.9,0.3, 1.9,0.9,2.6c0.7,0.6,1.7,1,2.7,0.9c0.9,0,1.7-0.2,2.4-0.7c0.8-0.5,1' + '.5-1.1,2.1-1.8V84.1c0-0.5,0.5-0.8,1.4-0.8h0.1c1,0 ,1.4,0.3,1.4,0.8v12.7c0,1.1,0,2.3,0.2,3.4c0.1,0.7,0' + '.2,1.1,0.2,1.1c0,0.3-0.2,0.5-0.7,0.6c-0.4,0.1-0.8,0.2-1.3,0.2c-0.3,0-0.6-0.2-0.7-0.6c-0.2-0.' + '4-0.3-0.8-0.4-1.2c-0.1-0.4-0.1-0.7-0.2-0.8c-0.7,0.8-1.6,1.5-2.6,2c-0.9,0.5-1.9,0.7-3, 0.7C165.3,102' + '.4,163.8,101.8,162.6,100.8z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M183.6,101.2c-0.9-0.7-1.4-2-1.4-3.8V85.9h-1.8c-0.2,' + '0-0.4-0.1-0.5-0.3c-0.1-0.3-0.2-0.5-0.2-0.8v-0.4c0-0.3,0-0.6,' + '0.2-0.8c0.1-0.2,0.3-0.3,0.5-0.3h1.8l0.4-3.8c0.1-0.5,0.5-0.8,' + '1.1-0.8h0.4c0.7,0,1.1,0.3,1.1,0.8v3.8h3c0.2,0,0.4,0.1,0.6,' + '0.3c0.1,0.3,0.2,0.5,0.2,0.8v0.4c0,0.3,0,0.6-0.2,0.8c-0.1,' + '0.2-0.3,0.3-0.6,0.3h-3V97c-0.1,0.7,0.1,1.5,0.5,2.1c0.4,0.4,' + '0.9,0.6,1.4,0.6c0.3,0,0.7,0,1-0.1c0.2,0,0.3-0.1,0.5-0.1s0.4,' + '0.2,0.5,0.7c0.1,0.3,0.2,0.7,0.2,1c0,0.7-0.9,1.1-2.6,1.1C185.6,' + '102.3,184.5,101.9,183.6,101.2z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M194,100.9c-1.2-1-1.8-2.5-1.7-4c-0.1-1.6,0.5-3.2,1.7-4.2s2.6-1.6,' + '4.2-1.8c2-0.3,4-0.4,6-0.4v-1.7c0-0.8-0.3-1.6-0.9-2.2c-0.9-0.6-1.' + '9-0.9-3-0.8c-0.9,0-1.9,0.1-2.8,0.4c-0.7,0.2-1.3,0.5-2,0.8c-0.3,' + '0.1-0.6,0.3-0.9,0.4c-0.2,0-0.5-0.2-0.8-0.7c-0.2-0.3-0.4-0.7-0.4-1.' + '1c0-0.3,0.3-0.6,0.9-1c0.8-0.4,1.6-0.7,2.5-0.9c1.1-0.3,2.2-0.4,' + '3.3-0.4c1.8-0.1,3.7,0.4,5.2,1.5c1.2,1,1.9,2.5,1.9,4.1v8c0,' + '1.1,0,2.3,0.2,3.4c0.1,0.7,0.2,1.1,0.2,1.1c0,0.3-0.2,0.5-0.7,' + '0.6c-0.4,0.1-0.8,0.2-1.3,0.2c-0.3,0-0.6-0.2-0.7-0.6c-0.2-0.4-' + '0.3-0.8-0.4-1.2c-0.1-0.4-0.1-0.7-0.2-0.8c-1.5,1.7-3.7,2.7-6,' + '2.7C196.8,102.4,195.3,101.9,194,100.9z M201.6,99c0.9-0.5,' + '1.8-1.1,2.6-1.8V93c-1.8,0-3.2,0.1-4.4,0.2c-1.1,0.1-2.1,' + '0.4-3,1c-0.9,0.5-1.4,1.5-1.3,2.5c-0.1,0.8,0.2,1.6,0.8,' + '2.2c0.6,0.5,1.4,0.8,2.3,0.8C199.6,99.7,200.6,99.5,201.6,' + '99L201.6,99z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M213.1,101.4V88.8c0-1.1,0-2.3-0.2-3.4c-0.1-0.7-0.2-1.1-0.2-1.1c0-0.3,0.2-0.5,0.7-0.' + '6c0.4-0.1,0.8-0.2,1.3-0.2c0.3, 0,0.6,0.2,0.7,0.5c0.2,0.4,0.3,0.7,0.4,1.1c0.1,0.4,0.1,0.6' + ',0.2,0.8c0.7-0.8,1.6-1.5,2.6-2c0.9-0.5,1.9-0.7,3-0.7c1.6-0.1,3.1,0.5,4.3,1.5c1.1,1.1,1.6,2' + '.7,1.6,4.3v12.4c0,0.5-0.5,0.8-1.4,0.8H226c-1,0-1.4-0.3-1.4-0.8V89.2c0.1-0.9-0.3-1.9-0.9-2.6c-' + '0.7-0.6-1.7-1-2.7-0.9c-0.9,0-1.7,0.2-2.4,0.7c-0.8,0.5-1.5,1.1-2.1,1.8v13.1c0,0.5-0.5,0.8-1.' + '4,0.8H215C213.6,102.2,213.1, 101.9,213.1,101.4z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M242.7,100c-1.4-1.5-2.1-3.9-2.1-7.1s0.7-5.6,2.1-7.2c1.6-1.7,3.9-2.6,6.2-2.5c2.1-0.1' + ',4.2,0.7,5.5,2.4c1.2,1.6,1.9, 3.9,1.9,7c-0.1,0.3-0.2,0.6-0.4,0.9c-0.3,0.4-0.5,0.6-0.8' + ',0.6h-11.3c0,1.6,0.5,3.1,1.5,4.4c1.1,1,2.5,1.5,4,1.4c0.9,0,1.8-0.1,2.6-0.4c0.6-0.2,1.2-0.5,1.8' + '-0.8c0.3-0.2,0.5-0.3,0.8-0.4c0.2,0,0.5,0.2,0.8,0.7c0.2,0.3,0.4,0.7,0.4,1.1c0,0.3-0.3,0.6-0.9' + ',1c-0.7,0.4-1.5,0.7-2.4,0.9c-1,0.3-2.1,0.4-3.2,0.4C246.3,102.3,244.1,101.5,242.7,100z M253,91.4c' + '0-3.8-1.4-5.7-4.3-5.7c -3.1,0-4.7,1.9-5,5.7H253z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M261.5,108.6c-1.3-0.6-2.1-1.9-2-3.4c0-1,0.3-1.9,0.9-2.7c0.6-0.8,1.4-1.4,2.4-1.8v-0.' + '1c-0.9-0.7-1.5-1.8-1.4-2.9c0-1.5,0.7-2.9,2-3.7c-0.9-0.5-1.7-1.2-2.3-2.1c-0.5-0.9-0.8-1' + '.9-0.8-3c0-1.6,0.6-3.1,1.9-4.2c1.5-1.2,3.3-1.8 ,5.2-1.6c0.7,0,1.4,0.1,2.1,0.2h6.5c0.2,0,0.4,0.1' + ',0.6,0.3c0.1,0.3,0.2,0.5,0.2,0.8v0.4c0,0.3,0,0.6-0.2,0.8c-0.1,0.2-0.3,0.3-0.6,0.3c-0.8,0-1.7' + ',0-2.5-0.1v0.1c0.6,0.9,1,2,0.9,3.1c0,1.6-0.6,3.2-1.8,4.2c-1.5,1.2-3.3,1.8-5.2,1.6c-0.9-0.1-1.8,0.1-' + '2.5,0.6c-0.6,0.4-0.9,1.1-0.9,1.9c0,0.5,0.2,1.1,0.6,1.4s0.9,0.6,1.5,0.7c0.8,0.2,1.7,0.3,2.5,0.4 c0.5' + ',0,0.9,0.1,1.2,0.1c1.4,0.1,2.8,0.5,4,1.2c1,0.7,1.5,1.9,1.4,3.1c0.1,1.6-0.7,3.1-2.1,4c-1.8,1-4,' + '1.5-6.1,1.4C265,109.8,263.1,109.4,261.5,108.6z M271,106.6c0.8-0.4,1.2-1.2,1.2-2s-0.4-1.5-1.2-' + '1.7c-1.2-0.4-2.3-0.6-3.5-0.7c-1-0.1-2-0.2-2.9-0.5c-1.6,0.7-2.4,1.6-2.4,2.9c0,1.7,1.7,2.6,5.1,' + '2.6C268.5,107.3,269.8,107.1,271,106.6z M270.4,91.7c0.8-0.6,1.3-1.6,1.2-2.6c0-2.3-1.4-3.5-4.3-3.' + '5c-2.8,0-4.3,1.2-4.3,3.5s1.4,3.4,4.3,3.4C268.4,92.5,269.5,92.2,270.4,91.7L270.4,91.7z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M281.5,100c-1.4-1.5-2.1-3.9-2.1-7.1s0.7-5.6,2.1-7.2c1.6-1.7,3.9-2.6,6.2-2.5c2.1-0.1' + ',4.2,0.7,5.5,2.4 c1.2,1.6,1.9,3.9,1.9,7c-0.1,0.3-0.2,0.6-0.4,0.9c-0.3,0.4-0.5,0.6-0.8' + ',0.6h-11.3c0,1.6,0.5,3.1,1.5,4.4c1.1,1,2.5,1.5,4,1.4 c0.9,0,1.8-0.1,2.6-0.4c0.6-0.2,1.2-0.5' + ',1.8-0.8c0.3-0.2,0.5-0.3,0.8-0.4c0.2,0,0.5,0.2,0.8,0.7c0.2,0.3,0.4,0.7,0.4,1.1 c0,0.3-0.3,0.' + '6-0.9,1c-0.7,0.4-1.5,0.7-2.4,0.9c-1,0.3-2.1,0.4-3.2,0.4C285.1,102.3,282.9,101.5,281.5,100z' + 'M291.8,91.4 c0-3.8-1.4-5.7-4.3-5.7c-3.1,0-4.7,1.9-5,5.7H291.8z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M301.9,101.2c-0.9-0.7-1.4-2-1.4-3.8V85.9h-1.8c-0.2,0-0.4-0.1-0.5-0.3c-0.1-0.3-0.2-0' + '.5-0.2-0.8v-0.4 c0-0.3, 0-0.6,0.2-0.8c0.1-0.2,0.3-0.3,0.5-0.3h1.8l0.4-3.8c0.1-0.5,0.5-0.8,1' + '.1-0.8h0.4c0.7,0,1.1,0.3,1.1,0.8v3.8h3 c0.2,0, 0.4,0.1,0.6,0.3c0.1,0.3,0.2,0.5,0.2,0.8v0.4c0,0.3,0' + ',0.6-0.2,0.8c-0.1,0.2-0.3,0.3-0.6,0.3h-3V97c-0.1,0.7,0.1,1.5, 0.5,2.1 c0.4,0.4,0.9,0.6,1.4,0.' + '6c0.3,0,0.7,0,1-0.1c0.2,0,0.3-0.1,0.5-0.1s0.4,0.2,0.5,0.7c0.1,0.3,0.2,0.7,0.2,1c0,' + '0.7-0.9,1.1-2.6,1.1 C303.9,102.3,302.8,101.9,301.9,101.2z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M321.3,101.4V85.9h-1.4c-0.2,0-0.4-0.1-0.5-0.3c-0.1-0.3-0.2-0.5-0.2-0.8v' + '-0.4c0-0.3,0-0.6,0.2-0.8 c0.1-0.2,0.3-0.3,0.5-0.3h1.4V80c0-1.9,0.5-3.2,1.4-3.9c0' + '.9-0.7,2.1-1.1,3.2-1.1c1.7,0,2.6,0.4,2.6,1.1c0,0.3-0.1,0.7-0.2,1 c-0.1,0.4-0.3,0' + '.7-0.5,0.7s-0.4,0-0.5-0.1c-0.3-0.1-0.7-0.1-1-0.1c-0.5,0-1,0.2-1.4,0.5c-0.4,0.6-0' + '.6,1.4-0.5,2.1v3.1h3.1 c0.2,0,0.4,0.1,0.6,0.3c0.1,0.3,0.2,0.5,0.2,0.8v0.4c0,0.3,' + '0,0.6-0.2,0.8c-0.1,0.2-0.3,0.3-0.6,0.3h-3.1v15.4c0,0.5-0.5,0.8-1.4,0.8 h-0.1C321' + '.8,102.2,321.3,101.9,321.3,101.4z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M333.2,99.9c-1.4-1.6-2.1-4-2.1-7c0-3.1,0.7-5.5,2.1-7.2c1.6-1.7,3.8-2.6,' + '6.2-2.5c2.3-0.1,4.5,0.8,6,2.5 c1.4,1.7,2.1,4,2.1,7.2c0,3.1-0.7,5.5-2.1,7.1c-1.5,' + '1.7-3.8,2.6-6.1,2.4C337,102.4,334.7,101.6,333.2,99.9z M343.1,98 c1-1.6,1.4-3.4,1' + '.3-5.3c0.1-1.9-0.3-3.7-1.3-5.3c-0.9-1.2-2.4-1.8-3.9-1.7c-1.5-0.1-2.9,0.5-3.8,1.7' + 'c-0.9,1.6-1.4,3.5-1.2,5.3 c-0.1,1.8,0.3,3.7,1.2,5.3c0.9,1.2,2.3,1.8,3.8,1.7C340.' + '7,99.8,342.2,99.2,343.1,98z M335.2,79.6v-1.8c0-0.5,0.5-0.8,1.6-0.8 c1,0,1.4,0.3,' + '1.4,0.8v1.8c0,0.5-0.5,0.8-1.6,0.8C335.7,80.4,335.2,80.1,335.2,79.6zM340.3,79.6v' + '-1.8c0-0.5,0.5-0.8,1.6-0.8 c1,0,1.4,0.3,1.4,0.8v1.8c0,0.5-0.5,0.8-1.6,0.8C340.8,' + '80.4,340.3,80.1,340.3,79.6L340.3,79.6z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M352.6,101.4V88.8c0-1.1,0-2.3-0.2-3.4c-0.1-0.7-0.2-1.1-0.2-1.1c0-0.3,0.' + '2-0.5,0.7-0.6 c0.4-0.1,0.8-0.2,1.3-0.2c0.3,0,0.6,0.2,0.7,0.5c0.2,0.4,0.3,0.7,0.4' + ',1.1s0.1,0.6,0.2,0.8c1.3-1.8,2.6-2.7,4.1-2.7 c0.5,0,1.1,0.1,1.5,0.4c0.3,0.2,0.5,' + '0.6,0.5,1s-0.1,0.9-0.2,1.3s-0.3,0.7-0.5,0.7s-0.5-0.1-0.7-0.2c-0.4-0.1-0.8-0.2-1.' + '3-0.2 c-0.6,0-1.1,0.2-1.6,0.5s-0.9,0.6-1.2,1.1c-0.2,0.2-0.4,0.4-0.5,0.6v13.1c0,0' + '.5-0.5,0.8-1.4,0.8h-0.1 C353.1,102.2,352.6,101.9,352.6,101.4z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M366.6,100c-1.4-1.5-2.1-3.9-2.1-7.1s0.7-5.6,2.1-7.2c1.6-1.7,3.9-2.6,6.2' + '-2.5c2.1-0.1,4.2,0.7,5.5,2.4 c1.2,1.6,1.9,3.9,1.9,7c-0.1,0.3-0.2,0.6-0.4,0.9c-0.' + '3,0.4-0.5,0.6-0.8,0.6h-11.3c0,1.6,0.5,3.1,1.5,4.4c1.1,1,2.5,1.5,4,1.4 c0.9,0,1.8' + '-0.1,2.6-0.4c0.6-0.2,1.2-0.5,1.8-0.8c0.3-0.2,0.5-0.3,0.8-0.4c0.2,0,0.5,0.2,0.8,0' + '.7c0.2,0.3,0.4,0.7,0.4,1.1 c0,0.3-0.3,0.6-0.9,1c-0.7,0.4-1.5,0.7-2.4,0.9c-1,0.3-' + '2.1,0.4-3.2,0.4C370.3,102.3,368,101.5,366.6,100z M377,91.4 c0-3.8-1.4-5.7-4.3-5.' + '7c-3.1,0-4.7,1.9-5,5.7H377z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M387,101.2c-0.9-0.7-1.4-2-1.4-3.8V85.9h-1.8c-0.2,' + '0-0.4-0.1-0.5-0.3c-0.1-0.3-0.2-0.5-0.2-0.8v-0.4c0-0.3,0-0.6,' + '0.2-0.8c0.1-0.2,0.3-0.3,0.5-0.3h1.8l0.4-3.8c0.1-0.5,0.5-0.8,' + '1.1-0.8h0.4c0.7,0,1.1,0.3,1.1,0.8v3.8h3c0.2,0,0.4,0.1,0.6,0.3c0.1,' + '0.3,0.2,0.5,0.2,0.8v0.4c0,0.3,0,0.6-0.2,0.8c-0.1,0.2-0.3,0.3-0.6,' + '0.3h-3V97c-0.1,0.7,0.1,1.5,0.5,2.1c0.4,0.4,0.9,0.6,1.4,0.6c0.3,0,0.7,' + '0,1-0.1c0.2,0,0.3-0.1,0.5-0.1s0.4,0.2,0.5,0.7c0.1,0.3,0.2,0.7,0.2,1c0,' + '0.7-0.9,1.1-2.6,1.1C389.1,102.3,387.9,101.9,387,101.2z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M397.4,100.9c-1.2-1-1.8-2.5-1.7-4c-0.1-1.6,0.5-3.2,1.7-4.2s2.6-1.6,4.2-' + '1.8c2-0.3,4-0.4,6-0.4v-1.7c0-0.8-0.3-1.6-0.9-2.2c-0.9-0.6-1.9-0.9-3-0.8c-0.9,0-' + '1.9,0.1-2.8,0.4c-0.7,0.2-1.3,0.5-2,0.8c-0.3,0.1-0.6,0.3-0.9,0.4 c-0.2,0-0.5-0.2-' + '0.8-0.7c-0.2-0.3-0.4-0.7-0.4-1.1c0-0.3,0.3-0.6,0.9-1c0.8-0.4,1.6-0.7,2.5-0.9c1.1' + '-0.3,2.2-0.4,3.3-0.4 c1.8-0.1,3.7,0.4,5.2,1.5c1.2,1,1.9,2.5,1.9,4.1v8c0,1.1,0,2.' + '3,0.2,3.4c0.1,0.7,0.2,1.1,0.2,1.1c0,0.3-0.2,0.5-0.7,0.6 c-0.4,0.1-0.8,0.2-1.3,0.' + '2c-0.3,0-0.6-0.2-0.7-0.6c-0.2-0.4-0.3-0.8-0.4-1.2c-0.1-0.4-0.1-0.7-0.2-0.8c-1.5,' + '1.7-3.7,2.7-6,2.7 C400.3,102.4,398.7,101.9,397.4,100.9z M405,99c0.9-0.5,1.8-1.1,' + '2.6-1.8V93c-1.8,0-3.2,0.1-4.4,0.2c-1.1,0.1-2.1,0.4-3,1c-0.9,0.5-1.4,1.5-1.3,2.5' + 'c-0.1,0.8,0.2,1.6,0.8,2.2c0.6,0.5,1.4,0.8,2.3,0.8C403.1,99.7,404.1,99.5,405,99L4' + '05,99z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M417.1,108.6c-1.3-0.6-2.1-1.9-2-3.4c0-1,0.3-1.9,0.9-2.7c0.6-0.8,1.4-1.4' + ',2.4-1.8v-0.1 c-0.9-0.7-1.5-1.8-1.4-2.9c0-1.5,0.7-2.9,2-3.7c-0.9-0.5-1.7-1.2-2.3' + '-2.1c-0.5-0.9-0.8-1.9-0.8-3c0-1.6,0.6-3.1,1.9-4.2 c1.5-1.2,3.3-1.8,5.2-1.6c0.7,0' + ',1.4,0.1,2.1,0.2h6.5c0.2,0,0.4,0.1,0.6,0.3c0.1,0.3,0.2,0.5,0.2,0.8v0.4c0,0.3,0,0' + '.6-0.2,0.8 c-0.1,0.2-0.3,0.3-0.6,0.3c-0.8,0-1.7,0-2.5-0.1v0.1c0.6,0.9,1,2,0.9,3.' + '1c0,1.6-0.6,3.2-1.8,4.2c-1.5,1.2-3.3,1.8-5.2,1.6 c-0.9-0.1-1.8,0.1-2.5,0.6c-0.6,' + '0.4-0.9,1.1-0.9,1.9c0,0.5,0.2,1.1,0.6,1.4s0.9,0.6,1.5,0.7c0.8,0.2,1.7,0.3,2.5,0.' + '4 c0.5,0,0.9,0.1,1.2,0.1c1.4,0.1,2.8,0.5,4,1.2c1,0.7,1.5,1.9,1.4,3.1c0.1,1.6-0.7' + ',3.1-2.1,4c-1.8,1-4,1.5-6.1,1.4 C420.7,109.8,418.8,109.4,417.1,108.6z M426.6,106' + '.6c0.8-0.4,1.2-1.2,1.2-2s-0.4-1.5-1.2-1.7c-1.2-0.4-2.3-0.6-3.5-0.7 c-1-0.1-2-0.2' + '-2.9-0.5c-1.6,0.7-2.4,1.6-2.4,2.9c0,1.7,1.7,2.6,5.1,2.6C424.2,107.3,425.5,107.1,' + '426.6,106.6z M426.1,91.7 c0.8-0.6,1.3-1.6,1.2-2.6c0-2.3-1.4-3.5-4.3-3.5c-2.8,0-4' + '.3,1.2-4.3,3.5s1.4,3.4,4.3,3.4C424,92.5,425.1,92.2,426.1,91.7L426.1,91.7z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M70.5,57.8V25.4h19.8v5.3H76.7v8.1h10.7V44H76.7v13.8H70.5z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M112.5,44.8l8.3,12.9h-7.6l-6.8-11.2c-1.4,0.2-2.9,0.2-4.3,0v11.1h-6.2V25' + '.7c15.3-2.6,22.4,2.1,22.4,10 C118.2,39.6,115.9,43.1,112.5,44.8z M102.1,41.3c6.8,' + '0.7,9.7-1.8,9.7-5.6c0-3.5-3.1-5.8-9.7-4.8V41.3z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M125.7,25.4h6.2v32.4h-6.2V25.4z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M159,57.8h-19.5V25.4h6.2v27.1H159V57.8z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M162.1,57.8l15-32.7h2.2l14.9,32.7h-6.9l-2.4-5.3h-13.4l-2.4,5.3H162.1z' + 'M173.7,47.3h8.9l-4.4-10.4L173.7,47.3z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M225.2,25.4v32.4l-1.4,0.4l-19.5-19.7v19.2h-6.1V25.4l1.4-0.4L219,44.6V25.4H225.2z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M250,32.6c-2.2-1.3-4.7-2-7.3-2.2c-3.1,0-5.3,1.4-5.3,3.5c0,2.3,2.6,3.6,6' + '.2,4.9c7.5,2.9,9.7,6.4,9.5,10.4 c-0.1,5.8-5.3,9.2-11.7,9.1c-3.9-0.1-7.7-1.3-10.8' + '-3.7l2.3-4.8c2.3,1.8,5.1,2.8,8.1,2.9c2.9,0,5.9-1.1,5.9-3.5 c0-2.7-3.7-3.9-7.6-5.' + '6c-5-2.3-8.2-5.1-8.2-9.9c0-4.6,3.9-9.2,11.1-9.2c3.4,0.2,6.8,1.1,9.8,2.6L250,32.6z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M270.6,57.8V25.4h19.8v5.3h-13.6v8.1h10.7V44h-10.7v13.8H270.6z',
	          fill: fillColor }),
	        _react2.default.createElement('path', { d: 'M296.4,25.4h6.2v32.4h-6.2V25.4z',
	          fill: fillColor }),
	        _react2.default.createElement('path', { d: 'M337.5,25.4v32.4l-1.4,0.4l-19.5-19.7v19.2h-6.1V25.4l1.4-0.4l19.5,19.7V25.4H337.5z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M340.6,57.8l15-32.7h2.2l14.9,32.7h-6.9l-2.4-5.3H350l-2.4,5.3H340.6z M352.2,47.3h8.' + '9l-4.4-10.4L352.2,47.3z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M403.8,25.4v32.4l-1.4,0.4l-19.5-19.7v19.2h-6.1V25.4l1.4-0.4l19.5,19.7V25.4H403.8z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M429.2,32.6c-2.2-1.3-4.7-2-7.3-2.2c-3.1,0-5.3,1.4-5.3,3.5c0,2.3,2.6,3.6' + ',6.2,4.9c7.5,2.9,9.7,6.4,9.5,10.4 c-0.1,5.8-5.3,9.2-11.7,9.1c-3.9-0.1-7.7-1.3-10' + '.8-3.7l2.3-4.8c2.3,1.8,5.1,2.8,8.1,2.9c2.9,0,5.9-1.1,5.9-3.5 c0-2.7-3.7-3.9-7.6-' + '5.6c-5-2.3-8.2-5.1-8.2-9.9c0-4.6,3.9-9.2,11.1-9.2c3.4,0.2,6.8,1.1,9.8,2.6L429.2,32.6z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M26.2,58h-25C0,58,0,58,0,56.8c0-0.1,0-0.3,0-0.4c0-0.4,0.1-0.5,0.5-0.6c1' + '.5-0.1,4.1-0.7,5.2-1.6 c2.2-2.1,5.7-2.1,7.9,0c2.4,2.1,6,2.2,8.5,0.1c2.8-2.3,5.5-' + '2.3,8.3,0c2.4,2,6,2,8.4,0c2.7-2.3,5.4-2.3,8.1,0 c1.1,0.9,3.7,1.5,5.2,1.5c0.4,0,0' + '.5,0.2,0.5,0.5c0,1.7-1.4,1.7-3.1,1.7H26.2z',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M52.6,53.3c0,0.6-0.2,0.8-0.7,0.6c-0.1,0-1.7-0.1-1.8-0.1c-1.5-0.3-1.6-0.' + '4-1.6-1.8c0-14.1,0-6,0-20.1 c0.1-1.9-1.1-3.7-2.9-4.2c-2.2-0.8-' + '4.6,0.3-5.4,2.5c-0.1,0.4-0.2,0.8-0.3,1.2c0,13.8,0,5.5,0,19.3c0,0.5-0.2,1-0.7,1.3' + 'c-1.1,1-2.4,1.7-3.8,2c-1.6,0.2-3.1-0.2-4.3-1.2c-0.3-0.2-0.4-0.6-0.4-0.9c0-1.4,0' + '-2.8,0-4.2c0-13.7,0-5.3,0-19 c0.1-0.9-0.2-1.9-0.6-2.7c-1-1.5-2.8-2.3-4.6-1.9c-1.' + '7,0.3-3.1,1.7-3.4,3.5c-0.1,0.5-0.1,1-0.1,1.5c0,13.4,0,4.7,0,18.1 c0,1.5,0,3,0,4.' + '5c0,0.5-0.3,1-0.7,1.3c-2,1.3-4.6,1.3-6.5,0c-0.6-0.4-1.1-0.9-1.6-1.3c-0.2-0.1-0.3' + '-0.4-0.3-0.6 c0-0.8-0.1-1.7-0.1-2.5c0-13,0-4,0-17c0-2-1.5-3.7-3.4-4c-2.1-0.4-4.2' + ',0.8-4.9,2.8c-0.1,0.5-0.2,1-0.2,1.5c0,12.7,0,3.2,0,15.9 c0,1.6-0.1,3.2,0,4.8c0.1' + ',0.6-0.3,1.1-0.8,1.2l0,0c-0.1,0-0.2,0-0.2,0.1c-1.7,0.5-3,0.4-3-1c0-16.6,0-10.5,0' + '-27.1 c0-0.8,0.2-1.1,1-1.3c7.8-2.4,16.9-5.4,24.6-7.8c0.4-0.1,0.8-0.1,1.2,0c7.8,2' + '.4,17,5.5,24.8,7.9c0.6,0.2,0.9,0.5,0.9,1.1 C52.6,32.9,52.6,51,52.6,53.3',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M9.7,13.1c0,0.6,0,1.2,0,1.8c0,0.4,0.1,0.5,0.5,0.5c1,0,2.1,0,3.1,0c0.3,0' + ',0.6,0,0.6-0.4c0-1.3,0.1-2.5-0.1-3.8 c-0.2-1.1-1.2-1.9-2.3-1.7c0,0,0,0-0.1,0c-1.' + '1,0.1-1.8,1-1.8,2C9.7,12.1,9.7,12.6,9.7,13.1 M6.2,20.5v-4.4c0-2.8,0-5.5,0-8.3 C6' + '.2,7.2,6.4,7,7,7.1c3.2,0,6.4,0,9.6,0c0.6,0,0.8,0.1,0.8,0.7c0,2.9,0,5.8,0,8.6c0.1' + ',0.4-0.2,0.7-0.5,0.8l0,0 c-3.4,1-6.7,2.1-10.1,3.1C6.5,20.4,6.4,20.4,6.2,20.5',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M40,5.5c1.9,0,3.9,0,5.8,0c0.6,0,0.8-0.1,0.8-0.7c0-1.3,0-2.9,0-4.2c0-0.4' + '-0.1-0.4-1.5-0.4 c-1.3,0-1.4,0.1-1.4,0.6v1.7c0,0.4-0.1,0.4-1.2,0.4c-1.1,0-1.2-0.' + '1-1.2-0.4c0-0.4,0-0.9,0-1.6s0-0.7-1.4-0.7c-1.6,0-1.4,0-1.4,1.1 c0,0.4,0,1.1,0,1.' + '2c0,0.4-0.3,0.3-1.2,0.3s-1.1,0-1.1-0.3c0-0.5,0-1.3,0-1.8c0-0.4,0-0.6-1.3-0.6c-1.' + '5,0-1.5,0-1.5,0.6 c0,0.8,0,3.2,0,4c0,0.6,0.2,0.9,0.9,0.8C36.2,5.4,38.1,5.5,40,5.5',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M11.8,5.5c1.9,0,3.9,0,5.8,0c0.6,0,0.8-0.1,0.8-0.7c0-1.3,0-2.9,0-4.2c0-0' + '.4-0.1-0.4-1.5-0.4 c-1.3,0-1.4,0.1-1.4,0.6v1.7c0,0.4-0.5,0.4-1.2,0.4c-0.8,0-1.2-' + '0.1-1.2-0.4c0-0.4,0-0.9,0-1.6s0-0.7-1.4-0.7c-1.6,0-1.4,0-1.4,1.1 c0,0.4,0,1.1,0,' + '1.2c0,0.4-0.5,0.3-1.2,0.3S8,2.8,8,2.5C8,2,8,1.2,8,0.7c0-0.4,0-0.6-1.3-0.6C5.2,0,' + '5.2,0,5.2,0.6c0,0.8,0,3.2,0,4 c0,0.6,0.2,0.9,0.9,0.8C8,5.4,9.9,5.5,11.8,5.5',
	          fill: fillColor
	        }),
	        _react2.default.createElement('path', { d: 'M42,13.1c0,0.6,0,1.2,0,1.8c0,0.4-0.1,0.5-0.5,0.5c-1,0-2.1,0-3.1,0c-0.3,' + '0-0.6,0-0.6-0.4 c0-1.3-0.1-2.5,0.1-3.8c0.2-1.1,1.2-1.9,2.3-1.7c0,0,0,0,0.1,0c1,0' + '.1,1.8,1,1.8,2C42,12.1,42,12.6,42,13.1 M45.6,20.5v-4.4 c0-2.8,0-5.5,0-8.3c0-0.6-' + '0.2-0.8-0.8-0.7c-3.2,0-6.4,0-9.5,0c-0.6,0-0.8,0.1-0.8,0.7c0,2.9,0,5.8,0,8.6c-0.1' + ',0.4,0.2,0.7,0.5,0.8 l0,0c3.3,1,6.7,2.1,10,3.1C45.2,20.4,45.4,20.4,45.6,20.5',
	          fill: fillColor
	        })
	      );
	    }
	  }]);
	  return LogoInvoiceWithoutCompany;
	}(_react2.default.Component);
	
	exports.default = LogoInvoiceWithoutCompany;

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MailboxFull = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MailboxFull = exports.MailboxFull = function (_React$Component) {
	  (0, _inherits3.default)(MailboxFull, _React$Component);
	
	  function MailboxFull() {
	    (0, _classCallCheck3.default)(this, MailboxFull);
	    return (0, _possibleConstructorReturn3.default)(this, (MailboxFull.__proto__ || (0, _getPrototypeOf2.default)(MailboxFull)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MailboxFull, [{
	    key: 'render',
	    value: function render() {
	      var fill = this.props.colorSchema === 'primary' ? '#00587c' : '#000000';
	
	      return _react2.default.createElement(
	        'svg',
	        {
	          version: '1.1',
	          xmlns: 'http://www.w3.org/2000/svg',
	          width: this.props.width || '20',
	          height: this.props.height || '20',
	          viewBox: '0 0 20 20'
	        },
	        _react2.default.createElement('path', {
	          d: 'M10.5 0h-4c-0.276 0-0.5 0.224-0.5 0.5v5.586c-0.582 0.206-1 0.762-1 1.414 0 0.827 0.673 1.5 1.5 1.5s1.5-0.673 1.5-1.5c0-0.652-0.418-1.208-1-1.414v-3.086h3.5c0.276 0 0.5-0.224 0.5-0.5v-2c0-0.276-0.224-0.5-0.5-0.5zM6.5 8c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM10 2h-3v-1h3v1z',
	          fill: fill
	        }),
	        _react2.default.createElement('path', {
	          d: 'M19.088 6.945c-0.354-0.916-0.818-1.628-1.38-2.118-0.628-0.548-1.38-0.826-2.234-0.826h-6.974c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h6.974c2.79 0 3.469 4.236 3.522 8h-15.997v-8h1.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.5v-0.5c0-0.276-0.224-0.5-0.5-0.5h-2c-0.276 0-0.5 0.224-0.5 0.5v11c0 0.276 0.224 0.5 0.5 0.5h2c0.276 0 0.5-0.224 0.5-0.5v-0.5h5v5.5c0 0.276 0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5v-5.5h7.5c0.276 0 0.5-0.224 0.5-0.5 0-2.785-0.307-4.99-0.912-6.555zM2 14h-1v-10h1v10zM11 19h-2v-5h2v5z',
	          fill: fill
	        })
	      );
	    }
	  }]);
	  return MailboxFull;
	}(_react2.default.Component);
	
	exports.default = MailboxFull;

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Menu = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Menu = exports.Menu = function (_React$Component) {
	  (0, _inherits3.default)(Menu, _React$Component);
	
	  function Menu() {
	    (0, _classCallCheck3.default)(this, Menu);
	    return (0, _possibleConstructorReturn3.default)(this, (Menu.__proto__ || (0, _getPrototypeOf2.default)(Menu)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Menu, [{
	    key: 'render',
	    value: function render() {
	      var stroke = this.props.color === 'primary' ? '#00587c' : this.props.color;
	
	      return _react2.default.createElement(
	        'svg',
	        {
	          version: '1.1',
	          xmlns: 'http://www.w3.org/2000/svg',
	          width: this.props.width || '33',
	          height: this.props.height || '24',
	          viewBox: '0 0 33 24',
	          fill: 'none'
	        },
	        _react2.default.createElement('path', { d: 'M2.5 22H31M2.5 2.5H31M2.5 12H31',
	          stroke: stroke,
	          strokeWidth: '4', strokeLinecap: 'round' })
	      );
	    }
	  }]);
	  return Menu;
	}(_react2.default.Component);
	
	exports.default = Menu;

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Pointer = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Pointer = exports.Pointer = function (_React$Component) {
	  (0, _inherits3.default)(Pointer, _React$Component);
	
	  function Pointer() {
	    (0, _classCallCheck3.default)(this, Pointer);
	    return (0, _possibleConstructorReturn3.default)(this, (Pointer.__proto__ || (0, _getPrototypeOf2.default)(Pointer)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Pointer, [{
	    key: 'render',
	    value: function render() {
	      var stroke = this.props.color === 'primary' || typeof this.props.color === 'undefined' ? '#00587c' : this.props.color;
	
	      return _react2.default.createElement(
	        'svg',
	        {
	          version: '1.1',
	          xmlns: 'http://www.w3.org/2000/svg',
	          width: this.props.width || '36',
	          height: this.props.height || '36',
	          viewBox: '0 0 36 36',
	          fill: 'none'
	        },
	        _react2.default.createElement('circle', { cx: '18', cy: '18', r: '17', strokeWidth: '2', stroke: stroke }),
	        _react2.default.createElement('path', {
	          d: 'M11.8286 18H23.6572M23.6572 18L18.5143 23.1428M23.6572 18L18.5143 12.8571',
	          stroke: stroke,
	          strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round'
	        })
	      );
	    }
	  }]);
	  return Pointer;
	}(_react2.default.Component);
	
	exports.default = Pointer;

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ShutEye = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ShutEye = exports.ShutEye = function (_React$Component) {
	  (0, _inherits3.default)(ShutEye, _React$Component);
	
	  function ShutEye() {
	    (0, _classCallCheck3.default)(this, ShutEye);
	    return (0, _possibleConstructorReturn3.default)(this, (ShutEye.__proto__ || (0, _getPrototypeOf2.default)(ShutEye)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ShutEye, [{
	    key: 'render',
	    value: function render() {
	      var fill = this.props.colorSchema === 'primary' ? '#00587c' : '#000000';
	
	      return _react2.default.createElement(
	        'svg',
	        {
	          version: '1.1',
	          xmlns: 'http://www.w3.org/2000/svg',
	          width: this.props.width || '25',
	          height: this.props.height || '20',
	          viewBox: '0 0 25 20'
	        },
	        _react2.default.createElement('path', { d: 'M24.883 18.9545L0.898591 0.0677435C0.83388 0.0160266 0.751283 -0.00788105 ' + '0.668952 0.00127491C0.586622 0.0104309 0.511295 0.0519012 0.459528 ' + '0.116572L0.0689031 0.605244C0.0171423 0.669906 -0.00683069 0.752472 ' + '0.00225174 0.8348C0.0113342 0.917127 0.052729 0.992482 0.117341 ' + '1.04431L24.1017 19.931C24.1338 19.9567 24.1706 19.9758 24.21 19.9872C24.2494 ' + '19.9987 24.2907 20.0022 24.3316 19.9977C24.3724 19.9932 24.4119 19.9806 24.4479 ' + '19.9608C24.4838 19.941 24.5155 19.9143 24.5412 19.8822L24.9318 19.3935C24.9835 ' + '19.3288 25.0074 19.2462 24.9983 19.1639C24.9891 19.0816 24.9476 19.0062 24.883 ' + '18.9545ZM12.5002 3.74938C13.8258 3.75083 15.0967 4.27808 16.0341 5.21545C16.9715 ' + '6.15282 17.4987 7.42375 17.5002 8.74938C17.5002 9.59391 17.2697 10.3779 16.8986 ' + '11.0763L17.8927 11.8576C18.424 10.9404 18.7502 9.88767 18.7502 8.74938C18.7502 ' + '7.31071 18.2459 6.0029 17.4306 4.94743C19.6148 6.05007 21.3911 7.81952 22.5021 ' + '9.99938C21.8381 11.2884 20.9405 12.4429 19.8548 13.4041L20.8439 14.183C21.956 ' + '13.1564 22.9091 11.9463 23.6146 10.5693C23.704 10.3925 23.7505 10.1973 23.7505 ' + '9.99919C23.7505 9.80112 23.704 9.60583 23.6146 9.42907C21.4962 5.29587 17.3025 ' + '2.49938 12.5002 2.49938C10.7456 2.49845 9.01163 2.87731 7.41734 3.60993L9.20523 ' + '5.01618C10.0877 4.23845 11.233 3.74938 12.5002 3.74938ZM14.8775 9.48493C14.9999 ' + '9.11179 15.0315 8.71481 14.9696 8.32702C14.9076 7.93922 14.754 7.57181 14.5215 ' + '7.25534C14.289 6.93887 13.9843 6.68249 13.6327 6.50752C13.2811 6.33256 12.8928 ' + '6.24406 12.5002 6.24938C12.4611 6.24938 12.4263 6.25876 12.3888 6.26071C12.5404 ' + '6.66674 12.5371 7.11441 12.3794 7.51813L14.8775 9.48493ZM6.37672 7.56462C6.2955 ' + '7.95439 6.2531 8.35125 6.25015 8.74938C6.24614 9.79654 6.5063 10.8278 7.00657 ' + '11.7477C7.50684 12.6677 8.23105 13.4466 9.1122 14.0123C9.99335 14.5781 11.003 ' + '14.9126 12.0476 14.9846C13.0923 15.0567 14.1383 14.8642 15.0888 14.4248L13.9334 ' + '13.515C13.4763 13.6529 13.0017 13.7494 12.5005 13.7494C11.1749 13.7479 9.9039 ' + '13.2207 8.96647 12.2833C8.02904 11.346 7.5017 10.0751 7.50015 8.74938C7.50015 ' + '8.65407 7.5232 8.56501 7.52828 8.47126L6.37672 7.56462ZM12.5002 16.2494C8.3064 ' + '16.2494 4.47398 13.8545 2.50015 9.99938C3.18101 8.67126 4.10523 7.54938 5.16851 ' + '6.61188L4.15836 5.81618C3.04586 6.84274 2.09312 8.05251 1.38765 9.42946C1.29829 ' + '9.60622 1.25174 9.80152 1.25174 9.99958C1.25174 10.1976 1.29829 10.3929 1.38765 ' + '10.5697C3.50445 14.7029 7.6982 17.4994 12.5002 17.4994C14.2547 17.5003 15.9887 ' + '17.1214 17.583 16.3888L16.4404 15.4904C15.1978 15.9697 13.8732 16.2494 12.5002 ' + '16.2494Z',
	          fill: fill })
	      );
	    }
	  }]);
	  return ShutEye;
	}(_react2.default.Component);
	
	exports.default = ShutEye;

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Sun = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Sun = exports.Sun = function (_React$Component) {
	  (0, _inherits3.default)(Sun, _React$Component);
	
	  function Sun() {
	    (0, _classCallCheck3.default)(this, Sun);
	    return (0, _possibleConstructorReturn3.default)(this, (Sun.__proto__ || (0, _getPrototypeOf2.default)(Sun)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Sun, [{
	    key: 'render',
	    value: function render() {
	      var fill = this.props.colorSchema === 'primary' ? '#00587c' : '#000000';
	
	      return _react2.default.createElement(
	        'svg',
	        {
	          version: '1.1',
	          xmlns: 'http://www.w3.org/2000/svg',
	          width: this.props.width || '20',
	          height: this.props.height || '20',
	          viewBox: '0 0 20 20'
	        },
	        _react2.default.createElement('path', {
	          d: 'M9.5 5c-0.276 0-0.5-0.224-0.5-0.5v-3c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v3c0' + ' 0.276-0.224 0.5-0.5 0.5z',
	          fill: fill }),
	        _react2.default.createElement('path', {
	          d: 'M3.5 11h-3c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h3c0.276 0 0.5 0.224 0.5' + ' 0.5s-0.224 0.5-0.5 0.5z',
	          fill: fill }),
	        _react2.default.createElement('path', {
	          d: 'M18.5 11h-3c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h3c0.276 0 0.5 0.224 0.5' + ' 0.5s-0.224 0.5-0.5 0.5z',
	          fill: fill }),
	        _react2.default.createElement('path', {
	          d: 'M9.5 20c-0.276 0-0.5-0.224-0.5-0.5v-3c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5' + ' 0.5v3c0 0.276-0.224 0.5-0.5 0.5z',
	          fill: fill }),
	        _react2.default.createElement('path', {
	          d: 'M9.5 7.007c0.935 0 1.814 0.363 2.475 1.024s1.025 1.536 1.025 2.469-0.364' + ' 1.809-1.025 2.469c-0.661 0.66-1.54 1.024-2.475 1.024s-1.814-0.363-2.475-1.024c-0.661' + '-0.66-1.025-1.536-1.025-2.469s0.364-1.809 1.025-2.469c0.661-0.66 1.54-1.024 2.475-' + '1.024zM9.5 6.007c-2.485 0-4.5 2.011-4.5 4.493s2.015 4.493 4.5 4.493 4.5-2.011' + ' 4.5-4.493c0-2.481-2.015-4.493-4.5-4.493v0z',
	          fill: fill }),
	        _react2.default.createElement('path', {
	          d: 'M5.507 6.507c-0.128 0-0.256-0.049-0.354-0.146l-2.121-2.121c-0.195-0.195-0.195-0.512' + ' 0-0.707s0.512-0.195 0.707 0l2.121 2.121c0.195 0.195 0.195 0.512 0 0.707-0.098' + ' 0.098-0.226 0.146-0.354 0.146z',
	          fill: fill }),
	        _react2.default.createElement('path', {
	          d: 'M3.386 17.614c-0.128 0-0.256-0.049-0.354-0.146-0.195-0.195-0.195-0.512' + ' 0-0.707l2.121-2.121c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-2.121' + ' 2.121c-0.098 0.098-0.226 0.146-0.354 0.146z',
	          fill: fill }),
	        _react2.default.createElement('path', {
	          d: 'M13.493 6.507c-0.128 0-0.256-0.049-0.354-0.146-0.195-0.195-0.195-0.512' + ' 0-0.707l2.121-2.121c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-2.121' + ' 2.121c-0.098 0.098-0.226 0.146-0.354 0.146z',
	          fill: fill }),
	        _react2.default.createElement('path', {
	          d: 'M15.614 17.614c-0.128 0-0.256-0.049-0.354-0.146l-2.121-2.121c-0.195-0.195-0.195-' + '0.512 0-0.707s0.512-0.195 0.707 0l2.121 2.121c0.195 0.195 0.195 0.512' + ' 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146z',
	          fill: fill })
	      );
	    }
	  }]);
	  return Sun;
	}(_react2.default.Component);
	
	exports.default = Sun;

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Eye = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Eye = exports.Eye = function (_React$Component) {
	  (0, _inherits3.default)(Eye, _React$Component);
	
	  function Eye() {
	    (0, _classCallCheck3.default)(this, Eye);
	    return (0, _possibleConstructorReturn3.default)(this, (Eye.__proto__ || (0, _getPrototypeOf2.default)(Eye)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Eye, [{
	    key: 'render',
	    value: function render() {
	      var fill = this.props.colorSchema === 'primary' ? '#00587c' : '#000000';
	
	      return _react2.default.createElement(
	        'svg',
	        {
	          version: '1.1',
	          xmlns: 'http://www.w3.org/2000/svg',
	          width: this.props.width || '20',
	          height: this.props.height || '20',
	          viewBox: '0 0 20 20'
	        },
	        _react2.default.createElement('path', {
	          d: 'M18.5 2h-5.75l-1.35-1.8c-0.094-0.126-0.243-0.2-0.4-0.2h-2c-0.157 0-0.306' + ' 0.074-0.4 0.2l-1.35 1.8h-5.75c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5l17' + ' 0c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5zM9.25 1h1.5l0.75 1h-3l0.75-1z',
	          fill: fill }),
	        _react2.default.createElement('path', {
	          d: 'M17.582 4.007c-0.272-0.045-0.53 0.139-0.575 0.411l-2.336 14.014c-0.051' + ' 0.303-0.364 0.569-0.671 0.569h-8c-0.307 0-0.621-0.266-0.671-0.569l-2.336-' + '14.014c-0.045-0.272-0.303-0.456-0.575-0.411s-0.456 0.303-0.411 0.575l2.336' + ' 14.014c0.131 0.787 0.859 1.404 1.658 1.404h8c0.798 0 1.526-0.617 1.658-' + '1.404l2.336-14.014c0.045-0.272-0.139-0.53-0.411-0.575z',
	          fill: fill })
	      );
	    }
	  }]);
	  return Eye;
	}(_react2.default.Component);
	
	exports.default = Eye;

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleDisplay = function (_React$Component) {
	  (0, _inherits3.default)(ToggleDisplay, _React$Component);
	
	  function ToggleDisplay() {
	    (0, _classCallCheck3.default)(this, ToggleDisplay);
	    return (0, _possibleConstructorReturn3.default)(this, (ToggleDisplay.__proto__ || (0, _getPrototypeOf2.default)(ToggleDisplay)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ToggleDisplay, [{
	    key: 'render',
	    value: function render() {
	      return this.props.show ? this.props.children : null;
	    }
	  }]);
	  return ToggleDisplay;
	}(_react2.default.Component); /**
	                               * Created by staffanrantzow on 02/11/16.
	                               */
	
	exports.default = ToggleDisplay;

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OverlayTrigger = __webpack_require__(1378);
	
	var _OverlayTrigger2 = _interopRequireDefault(_OverlayTrigger);
	
	var _Tooltip = __webpack_require__(1383);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToolTip = function (_React$Component) {
	  (0, _inherits3.default)(ToolTip, _React$Component);
	
	  function ToolTip(props) {
	    (0, _classCallCheck3.default)(this, ToolTip);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ToolTip.__proto__ || (0, _getPrototypeOf2.default)(ToolTip)).call(this, props));
	
	    _this.getToolTip = _this.getToolTip.bind(_this);
	    _this.manualHide = _this.manualHide.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(ToolTip, [{
	    key: 'manualHide',
	    value: function manualHide(event) {
	      this.refs['overlay-trigger'].hide();
	    }
	  }, {
	    key: 'getToolTip',
	    value: function getToolTip() {
	      return _react2.default.createElement(
	        _Tooltip2.default,
	        { id: 'tt-' + this.props.id, bsClass: 'info-tooltip' },
	        _react2.default.createElement('button', { className: 'close', onClick: this.manualHide }),
	        this.props.msg
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _OverlayTrigger2.default,
	        { placement: 'bottom', ref: 'overlay-trigger', trigger: ['hover', 'focus'], overlay: this.getToolTip() },
	        _react2.default.createElement('button', { type: 'button', className: this.props.buttonClasses, tabIndex: -1 })
	      );
	    }
	  }]);
	  return ToolTip;
	}(_react2.default.Component); /**
	                               * Created by staffanrantzow on 17/10/16.
	                               */
	
	ToolTip.defaultProps = {
	  buttonClasses: 'tooltip-info-button'
	};
	exports.default = ToolTip;

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Freshchat = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Freshchat = exports.Freshchat = function (_React$Component) {
	  (0, _inherits3.default)(Freshchat, _React$Component);
	
	  function Freshchat() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Freshchat);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Freshchat.__proto__ || (0, _getPrototypeOf2.default)(Freshchat)).call.apply(_ref, [this].concat(args))), _this), _this.componentWillReceiveProps = function (nextProps) {
	      if (!window.fcWidget) {
	        return;
	      }
	
	      if (_this.userId !== nextProps.userId && nextProps.email) {
	        window.fcWidget.setExternalId('userId:' + nextProps.userId);
	        window.fcWidget.user.setFirstName(nextProps.firstName);
	        window.fcWidget.user.setEmail(nextProps.email);
	      }
	    }, _this.render = function () {
	      return false;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  return Freshchat;
	}(_react2.default.Component);
	
	function mapStateToProps(state) {
	  return {
	    userId: state.user.id,
	    firstName: state.user.firstName,
	    email: state.user.email
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Freshchat);

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ValidationError = undefined;
	
	var _slicedToArray2 = __webpack_require__(385);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _getIterator2 = __webpack_require__(18);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _typeof2 = __webpack_require__(167);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _generalError = __webpack_require__(63);
	
	var _generalError2 = _interopRequireDefault(_generalError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TRANSLATION_FALLBACK = ' ';
	
	var _ref = _react2.default.createElement(_generalError2.default, null);
	
	var ValidationError = exports.ValidationError = function (_React$Component) {
	  (0, _inherits3.default)(ValidationError, _React$Component);
	
	  function ValidationError() {
	    (0, _classCallCheck3.default)(this, ValidationError);
	    return (0, _possibleConstructorReturn3.default)(this, (ValidationError.__proto__ || (0, _getPrototypeOf2.default)(ValidationError)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ValidationError, [{
	    key: 'normalize',
	
	
	    /**
	     * Create a key to be used in the translation file
	     */
	    value: function normalize() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return 'VALIDATION_' + args.join('_').replace(/[^a-z]/gi, '_').replace(/_+/g, '_').toUpperCase();
	    }
	  }, {
	    key: 'keys',
	    value: function keys() {
	      var keys = [];
	      for (var index in this.props.errors) {
	        if ((0, _typeof3.default)(this.props.errors[index]) === 'object') {
	          for (var subIndex in this.props.errors[index]) {
	            keys.push({
	              key: this.normalize(index, subIndex, this.props.errors[index][subIndex]),
	              value: parseInt(index.match(/\d+/)[0]) + 1 || null
	            });
	          }
	        } else {
	          keys.push({
	            key: this.normalize(index, this.props.errors[index]),
	            value: null
	          });
	        }
	      }
	      // Print keys to the log for reference
	      console.log(keys);
	      return keys;
	    }
	  }, {
	    key: 'translateKey',
	    value: function translateKey(item) {
	      var translation;
	      if (item.value) {
	        translation = (0, _proxyCounterpart.proxyCounterpart)(item.key, { value: item.value, fallback: TRANSLATION_FALLBACK });
	      } else {
	        translation = (0, _proxyCounterpart.proxyCounterpart)(item.key, { fallback: TRANSLATION_FALLBACK });
	      }
	      return translation === TRANSLATION_FALLBACK ? null : translation;
	    }
	  }, {
	    key: 'list',
	    value: function list() {
	      var list = [];
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(this.keys().entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
	              index = _step$value[0],
	              item = _step$value[1];
	
	          var translation = this.translateKey(item);
	          // Only push existing translations to the list
	          if (translation) {
	            list.push(_react2.default.createElement(
	              'li',
	              { key: index },
	              translation
	            ));
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return list;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var list = this.list();
	      if (list.length) {
	        return _react2.default.createElement(
	          'ul',
	          { className: 'error' },
	          list
	        );
	      }
	      return _ref;
	    }
	  }]);
	  return ValidationError;
	}(_react2.default.Component);
	
	exports.default = ValidationError;

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactRouter = __webpack_require__(20);
	
	var _uaParserJs = __webpack_require__(1546);
	
	var _uaParserJs2 = _interopRequireDefault(_uaParserJs);
	
	var _reactModal = __webpack_require__(30);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _components = __webpack_require__(13);
	
	var _tagManager = __webpack_require__(851);
	
	var _tagManager2 = _interopRequireDefault(_tagManager);
	
	var _tagManagerRemove = __webpack_require__(852);
	
	var _tagManagerRemove2 = _interopRequireDefault(_tagManagerRemove);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_reactModal2.default.defaultStyles.overlay.backgroundColor = 'rgba(0, 0, 0, 0.4)';
	
	var _ref = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'UNSUPPORTED_BROWSER' });
	
	var _ref2 = _react2.default.createElement(_components.EmailCapture, null);
	
	var _ref3 = _react2.default.createElement(_components.Freshchat, null);
	
	var Root = function (_React$Component) {
	  (0, _inherits3.default)(Root, _React$Component);
	
	  function Root(props) {
	    (0, _classCallCheck3.default)(this, Root);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Root.__proto__ || (0, _getPrototypeOf2.default)(Root)).call(this, props));
	
	    var incompatibleBrowserModalOpen = false;
	    var ua = (0, _uaParserJs2.default)(navigator.userAgent);
	    if (ua.browser.name === 'IE' && ua.browser.major <= 10) {
	      incompatibleBrowserModalOpen = true;
	    }
	
	    _this.state = {
	      incompatibleBrowserModalOpen: incompatibleBrowserModalOpen,
	      y: 0
	    };
	
	    _this.renderModal = _this.renderModal.bind(_this);
	    _this.onCloseModal = _this.onCloseModal.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(Root, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.props.history.listen(function (location) {
	        _this2.renderTagManager(location.pathname);
	      });
	    }
	  }, {
	    key: 'onUpdate',
	    value: function onUpdate() {
	      setTimeout(function () {
	        window.scrollTo(0, 0);
	        document.querySelector('html').style.height = '100%';
	      }, 1);
	      // Set height on html to auto before scrollTo. Otherwise it doesn't work
	      // See core.scss for info on why height:100% is needed.
	      document.querySelector('html').style.height = 'auto';
	
	      var hash = window.location.hash;
	
	      if (hash !== '') {
	        // Push onto callback queue so it runs after the DOM is updated,
	        // this is required when navigating from a different page so that
	        // the element is rendered on the page before trying to getElementById.
	        setTimeout(function () {
	          var id = hash.replace('#', '');
	          var element = document.getElementById(id);
	          if (element) element.scrollIntoView();
	        }, 1000);
	      }
	    }
	  }, {
	    key: 'renderModal',
	    value: function renderModal() {
	      return _react2.default.createElement(
	        _reactModal2.default,
	        {
	          className: 'modal',
	          contentLabel: '',
	          isOpen: this.state.incompatibleBrowserModalOpen,
	          onRequestClose: this.onCloseModal },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-content' },
	          _react2.default.createElement('button', { className: 'close', onClick: this.onCloseModal }),
	          _ref
	        )
	      );
	    }
	  }, {
	    key: 'renderTagManager',
	    value: function renderTagManager(pathName) {
	      var googleTracking = 'googleTrackingActivitesManager';
	      var pageTracking = 'trackingActivitesPage';
	      if (pathName === '/activities') {
	        return (0, _tagManager2.default)(googleTracking, pageTracking);
	      } else {
	        return (0, _tagManagerRemove2.default)(googleTracking, pageTracking);
	      }
	    }
	  }, {
	    key: 'onCloseModal',
	    value: function onCloseModal() {
	      this.setState({
	        incompatibleBrowserModalOpen: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactRedux.Provider,
	        { store: this.props.store },
	        _react2.default.createElement(
	          'div',
	          { style: { height: '100%' } },
	          this.content,
	          this.devTools,
	          this.renderModal(),
	          _ref2,
	          _ref3,
	          this.renderTagManager()
	        )
	      );
	    }
	  }, {
	    key: 'content',
	    get: function get() {
	      return _react2.default.createElement(
	        _reactRouter.Router,
	        { onUpdate: this.onUpdate, history: this.props.history },
	        this.props.routes
	      );
	    }
	  }, {
	    key: 'devTools',
	    get: function get() {
	      if (false) {
	        if (__DEBUG_NEW_WINDOW__) {
	          if (!window.devToolsExtension) {
	            require('../redux/utils/createDevToolsWindow').default(this.props.store);
	          } else {
	            window.devToolsExtension.open();
	          }
	        } else if (!window.devToolsExtension) {
	          var DevTools = require('containers/DevTools').default;
	          return _react2.default.createElement(DevTools, null);
	        }
	      }
	    }
	  }]);
	  return Root;
	}(_react2.default.Component);
	
	exports.default = Root;

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 01/12/16.
	 */
	
	var AgreementDraftEntity = function AgreementDraftEntity(id, headline, languageId, text, typeId) {
	  (0, _classCallCheck3.default)(this, AgreementDraftEntity);
	
	  this.id = id;
	  this.headline = headline;
	  this.languageId = languageId;
	  this.text = text;
	  this.typeId = typeId;
	};
	
	exports.default = AgreementDraftEntity;

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(17);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _agreementDraftEntity = __webpack_require__(749);
	
	var _agreementDraftEntity2 = _interopRequireDefault(_agreementDraftEntity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AgreementDraftService = function () {
	  function AgreementDraftService() {
	    (0, _classCallCheck3.default)(this, AgreementDraftService);
	  }
	
	  (0, _createClass3.default)(AgreementDraftService, [{
	    key: 'hydrate',
	    value: function hydrate(data) {
	      if (data) {
	        return new _agreementDraftEntity2.default(data.id, data.headline, data.language_id, data.text, data.type_id);
	      }
	
	      return {};
	    }
	  }, {
	    key: 'extractParams',
	    value: function extractParams(params) {
	      return {
	        data: {
	          attributes: {
	            user_id: params.userId,
	            company_id: params.customerId,
	            specification: params.specification,
	            firstWorkDate: params.firstWorkDate,
	            lastWorkDate: params.lastWorkDate,
	            language_id: params.languageId
	          }
	        }
	      };
	    }
	  }, {
	    key: 'post',
	    value: function post(params) {
	      var _this = this;
	
	      var data = this.extractParams(params);
	
	      return _axios2.default.post('backend://agreement-drafts', data).then(function (response) {
	        var attr = response.data.data.attributes;
	        return [_this.hydrate(attr[0]), _this.hydrate(attr[1])];
	      });
	    }
	  }, {
	    key: 'generalTerms',
	    value: function generalTerms(languageId) {
	      var _this2 = this;
	
	      return _axios2.default.post('backend://general-terms', {
	        data: {
	          attributes: {
	            language_id: languageId
	          }
	        }
	      }).then(function (response) {
	        var attr = response.data.data.attributes;
	        return _this2.hydrate(attr[0]);
	      });
	    }
	  }]);
	  return AgreementDraftService;
	}();
	
	exports.default = new AgreementDraftService();

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 21/09/16.
	 */
	
	var AgreementEntity = function AgreementEntity(id, createdAt, invoiceId, text, typeId, pdfUrl) {
	  (0, _classCallCheck3.default)(this, AgreementEntity);
	
	  this.id = id;
	  this.createdAt = createdAt;
	  this.invoiceId = invoiceId;
	  this.text = text;
	  this.typeId = typeId;
	  this.pdfUrl = pdfUrl;
	};
	
	exports.default = AgreementEntity;

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 21/09/16.
	 */
	
	var AgreementWrapperEntity = function AgreementWrapperEntity(agreement, condition) {
	  (0, _classCallCheck3.default)(this, AgreementWrapperEntity);
	
	  this.agreement = agreement;
	  this.condition = condition;
	};
	
	exports.default = AgreementWrapperEntity;

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BankIdEntity = function BankIdEntity(sessionId, redirectUrl, autostart) {
	  (0, _classCallCheck3.default)(this, BankIdEntity);
	
	  this.sessionId = sessionId;
	  this.redirectUrl = redirectUrl;
	  this.autostart = autostart;
	};
	
	exports.default = BankIdEntity;

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(17);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _bankIdEntity = __webpack_require__(753);
	
	var _bankIdEntity2 = _interopRequireDefault(_bankIdEntity);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _pendingRequestEntity = __webpack_require__(42);
	
	var _pendingRequestEntity2 = _interopRequireDefault(_pendingRequestEntity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BankIdService = function () {
	  function BankIdService() {
	    (0, _classCallCheck3.default)(this, BankIdService);
	  }
	
	  (0, _createClass3.default)(BankIdService, [{
	    key: 'hydrate',
	    value: function hydrate(data) {
	      return new _bankIdEntity2.default(data.session_id, data.redirect_url, data.autostart);
	    }
	  }, {
	    key: 'requestLogin',
	    value: function requestLogin(socialSecurityNr, email) {
	      var _this = this;
	
	      var pendingRequest = new _pendingRequestEntity2.default();
	
	      pendingRequest.promise = _axios2.default.post('backend://bankid/login', {
	        data: {
	          attributes: {
	            social_security_number: socialSecurityNr,
	            email: email
	          }
	        }
	      }, {
	        cancelToken: new _axios2.default.CancelToken(function executor(c) {
	          pendingRequest.cancel = c;
	        })
	      }).then(function (response) {
	        if (response.data.data) {
	          return _this.hydrate(response.data.data.attributes);
	        }
	        return null;
	      });
	
	      return pendingRequest;
	    }
	  }, {
	    key: 'getErrors',
	    value: function getErrors(error) {
	      if (error) {
	        var errorMessages = [(0, _proxyCounterpart.proxyCounterpart)('BANKID_GENERAL_ERROR')];
	        if (errorMessages.length > 0) {
	          return { messages: errorMessages };
	        }
	      }
	      return false;
	    }
	  }]);
	  return BankIdService;
	}();
	
	exports.default = new BankIdService();

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BankEntity = function BankEntity(id, accLen, clrMax, clrMin, shortName, fullName) {
	  (0, _classCallCheck3.default)(this, BankEntity);
	
	  this.id = parseInt(id);
	  this.accLen = accLen;
	  this.clrMax = clrMax;
	  this.clrMin = clrMin;
	  this.shortName = shortName;
	  this.fullName = fullName;
	};
	
	exports.default = BankEntity;

/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(18);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(17);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _bankEntity = __webpack_require__(755);
	
	var _bankEntity2 = _interopRequireDefault(_bankEntity);
	
	var _pendingRequestEntity = __webpack_require__(42);
	
	var _pendingRequestEntity2 = _interopRequireDefault(_pendingRequestEntity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BankService = function () {
	  function BankService() {
	    (0, _classCallCheck3.default)(this, BankService);
	  }
	
	  (0, _createClass3.default)(BankService, [{
	    key: 'hydrate',
	    value: function hydrate(data) {
	      return new _bankEntity2.default(data.id, data.attributes.acc_len, data.attributes.clr_max, data.attributes.clr_min, data.attributes.short_name, data.attributes.full_name);
	    }
	  }, {
	    key: 'hydrateCollection',
	    value: function hydrateCollection(data) {
	      var col = [];
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var bank = _step.value;
	
	          col.push(this.hydrate(bank));
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return col;
	    }
	  }, {
	    key: 'get',
	    value: function get() {
	      var _this = this;
	
	      var pendingRequest = new _pendingRequestEntity2.default();
	      pendingRequest.promise = _axios2.default.get('backend://banks?page[size]=50', {
	        cancelToken: new _axios2.default.CancelToken(function executor(c) {
	          pendingRequest.cancel = c;
	        })
	      }).then(function (response) {
	        return _this.hydrateCollection(response.data.data);
	      });
	      return pendingRequest;
	    }
	  }, {
	    key: 'getByAccount',
	    value: function getByAccount(accountNr, accountClearingNr) {
	      var _this2 = this;
	
	      var pendingRequest = new _pendingRequestEntity2.default();
	      pendingRequest.promise = _axios2.default.get('backend://banks?filter[accountNumber]=' + accountClearingNr + '-' + accountNr, {
	        cancelToken: new _axios2.default.CancelToken(function executor(c) {
	          pendingRequest.cancel = c;
	        })
	      }).then(function (response) {
	        if (response.data.data[0]) {
	          return _this2.hydrate(response.data.data[0]);
	        }
	        return null;
	      });
	      return pendingRequest;
	    }
	  }]);
	  return BankService;
	}();
	
	exports.default = new BankService();

/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(17);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BouncedEmailService = function () {
	  function BouncedEmailService() {
	    (0, _classCallCheck3.default)(this, BouncedEmailService);
	  }
	
	  (0, _createClass3.default)(BouncedEmailService, [{
	    key: 'getCompanyDataFromToken',
	    value: function getCompanyDataFromToken(token) {
	      var url = 'backend://bounced-email/' + token;
	      return _axios2.default.get(url).then(function (response) {
	        return response;
	      });
	    }
	  }, {
	    key: 'updateCompanyEmail',
	    value: function updateCompanyEmail(token, email) {
	      return _axios2.default.post('backend://bounced-email-resend', {
	        'data': {
	          'attributes': {
	            'email': email,
	            'token': token
	          }
	        }
	      }).then(function (response) {
	        return response;
	      });
	    }
	  }]);
	  return BouncedEmailService;
	}();
	
	exports.default = new BouncedEmailService();

/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 12/10/16.
	 */
	
	var CountryEntity = function CountryEntity(id, name, code) {
	  (0, _classCallCheck3.default)(this, CountryEntity);
	
	  this.id = id;
	  this.name = name;
	  this.code = code;
	};
	
	exports.default = CountryEntity;

/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(72);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getIterator2 = __webpack_require__(18);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(17);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _countryEntity = __webpack_require__(758);
	
	var _countryEntity2 = _interopRequireDefault(_countryEntity);
	
	var _pendingRequestEntity = __webpack_require__(42);
	
	var _pendingRequestEntity2 = _interopRequireDefault(_pendingRequestEntity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CountryService = function () {
	  function CountryService() {
	    (0, _classCallCheck3.default)(this, CountryService);
	
	    this.countries = null;
	  }
	
	  (0, _createClass3.default)(CountryService, [{
	    key: 'hydrate',
	    value: function hydrate(country) {
	      return new _countryEntity2.default(country.id, country.attributes.country_name, country.attributes.country_code);
	    }
	  }, {
	    key: 'hydrateCollection',
	    value: function hydrateCollection(data) {
	      var countries = [];
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var country = _step.value;
	
	          countries.push(this.hydrate(country));
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return countries;
	    }
	  }, {
	    key: 'get',
	    value: function get() {
	      var _this = this;
	
	      var pendingRequest = new _pendingRequestEntity2.default();
	      if (this.countries) {
	        pendingRequest.promise = _promise2.default.resolve(this.countries);
	        return pendingRequest;
	      } else {
	        pendingRequest.promise = _axios2.default.get('backend://countries', {
	          params: {
	            'page[number]': 1,
	            'page[size]': 250,
	            'sort': 'country_name'
	          },
	          cancelToken: new _axios2.default.CancelToken(function executor(c) {
	            pendingRequest.cancel = c;
	          })
	        }).then(function (response) {
	          _this.countries = _this.hydrateCollection(response.data.data);
	          return _this.countries;
	        });
	      }
	
	      return pendingRequest;
	    }
	  }]);
	  return CountryService;
	}(); /**
	      * Created by staffanrantzow on 12/10/16.
	      */
	
	exports.default = new CountryService();

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by eriksundqvist on 12/10/16.
	 */
	var CouponEntity = function CouponEntity(discountValue) {
	  (0, _classCallCheck3.default)(this, CouponEntity);
	
	  this.discountValue = discountValue;
	};
	
	exports.default = CouponEntity;

/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(17);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _couponEntity = __webpack_require__(760);
	
	var _couponEntity2 = _interopRequireDefault(_couponEntity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 01/11/16.
	 */
	
	var CouponService = function () {
	  function CouponService() {
	    (0, _classCallCheck3.default)(this, CouponService);
	  }
	
	  (0, _createClass3.default)(CouponService, [{
	    key: 'hydrate',
	    value: function hydrate(coupon) {
	      return new _couponEntity2.default(coupon.attributes.discount_value);
	    }
	  }, {
	    key: 'getById',
	    value: function getById(id, invoiceId) {
	      var _this = this;
	
	      var url = 'backend://coupons/' + id;
	      if (invoiceId !== null) {
	        url += '/' + invoiceId;
	      }
	      return _axios2.default.get(url).then(function (response) {
	        return _this.hydrate(response.data.data);
	      });
	    }
	  }]);
	  return CouponService;
	}();
	
	exports.default = new CouponService();

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 15/04/16.
	 */
	
	var CurrencyEntity = function CurrencyEntity(id, active, code, exchangeRate, name, standard, updatedAt) {
	  (0, _classCallCheck3.default)(this, CurrencyEntity);
	
	  this.id = id;
	  this.active = active;
	  this.code = code;
	  this.exchangeRate = exchangeRate;
	  this.name = name;
	  this.standard = standard;
	  this.updatedAt = updatedAt;
	};
	
	exports.default = CurrencyEntity;

/***/ },
/* 763 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var billingEmailType = exports.billingEmailType = 2;
	var contactEmailType = exports.contactEmailType = 3;

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(17);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmploymentCertificateService = function () {
	  function EmploymentCertificateService() {
	    (0, _classCallCheck3.default)(this, EmploymentCertificateService);
	  }
	
	  (0, _createClass3.default)(EmploymentCertificateService, [{
	    key: 'createFromInvoices',
	    value: function createFromInvoices(invoiceIds, orderType) {
	      return _axios2.default.post('backend://employment-certificate', {
	        data: {
	          attributes: {
	            invoice_ids: invoiceIds,
	            order_type: orderType
	          }
	        }
	      });
	    }
	  }, {
	    key: 'createFromWorkPeriod',
	    value: function createFromWorkPeriod(startDate, endDate, orderType) {
	      return _axios2.default.post('backend://employment-certificate', {
	        data: {
	          attributes: {
	            workdate_start: startDate,
	            workdate_end: endDate,
	            order_type: orderType
	          }
	        }
	      });
	    }
	  }]);
	  return EmploymentCertificateService;
	}(); /**
	      * Created by staffanrantzow on 27/09/16.
	      */
	
	exports.default = new EmploymentCertificateService();

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaqEntity = function FaqEntity(id, title, questionGroup) {
	  (0, _classCallCheck3.default)(this, FaqEntity);
	
	  this.id = id;
	  this.title = title;
	  this.questionGroup = questionGroup;
	};
	
	exports.default = FaqEntity;

/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(17);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _faqEntity = __webpack_require__(765);
	
	var _faqEntity2 = _interopRequireDefault(_faqEntity);
	
	var _pendingRequestEntity = __webpack_require__(42);
	
	var _pendingRequestEntity2 = _interopRequireDefault(_pendingRequestEntity);
	
	var _counterpart = __webpack_require__(86);
	
	var _counterpart2 = _interopRequireDefault(_counterpart);
	
	var _variables = __webpack_require__(47);
	
	var variables = _interopRequireWildcard(_variables);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaqService = function () {
	  function FaqService() {
	    (0, _classCallCheck3.default)(this, FaqService);
	  }
	
	  (0, _createClass3.default)(FaqService, [{
	    key: 'getFaqsAsObject',
	    value: function getFaqsAsObject(faqs) {
	      var faqsById = {};
	
	      faqs.forEach(function (faq) {
	        faqsById[faq.id] = faq.acf;
	      });
	
	      return faqsById;
	    }
	  }, {
	    key: 'getGroupFaqs',
	    value: function getGroupFaqs(faqsDictonary, group) {
	      var questions = group.acf.question_group[0].question_group_q;
	      return questions.filter(function (question) {
	        return question.post_status === 'publish';
	      }).map(function (question) {
	        var faq = faqsDictonary[question.ID];
	        return {
	          id: question.ID,
	          q: faq ? faq.q_and_a_q : '',
	          a: faq ? faq.q_and_a_a : '',
	          groupId: group.id
	        };
	      });
	    }
	  }, {
	    key: 'hydrateCollection',
	    value: function hydrateCollection(groups, faqs) {
	      var _this = this;
	
	      var faqsDictonary = this.getFaqsAsObject(faqs);
	      return groups.map(function (group) {
	        return new _faqEntity2.default(group.id, group.title.rendered, _this.getGroupFaqs(faqsDictonary, group));
	      }).reverse();
	    }
	  }, {
	    key: 'request',
	    value: function request(url) {
	      var pendingRequest = new _pendingRequestEntity2.default();
	
	      pendingRequest.promise = _axios2.default.get(url, {
	        cancelToken: new _axios2.default.CancelToken(function executor(c) {
	          pendingRequest.cancel = c;
	        })
	      });
	
	      return pendingRequest.promise;
	    }
	  }, {
	    key: 'getGroups',
	    value: function getGroups() {
	      var url = _counterpart2.default.getLocale() === 'en' ? variables.frontUrl + '/en/wp-json/wp/v2/fragegrupp?per_page=100' : variables.frontUrl + '/wp-json/wp/v2/fragegrupp?per_page=100';
	
	      return this.request(url);
	    }
	  }, {
	    key: 'getFaqs',
	    value: function getFaqs() {
	      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	      var url = _counterpart2.default.getLocale() === 'en' ? variables.frontUrl + '/en/wp-json/wp/v2/fragor-och-svar/?per_page=100&page=' + page : variables.frontUrl + '/wp-json/wp/v2/fragor-och-svar/?per_page=100&page=' + page;
	
	      return this.request(url);
	    }
	  }, {
	    key: 'get',
	    value: function get() {
	      var _this2 = this;
	
	      var pendingRequest = new _pendingRequestEntity2.default();
	
	      if (_counterpart2.default.getLocale() === 'se') {
	        pendingRequest.promise = _axios2.default.all([this.getGroups(), this.getFaqs(1), this.getFaqs(2)]).then(_axios2.default.spread(function (groups, faqs1, faqs2) {
	          return _this2.hydrateCollection(groups.data, faqs1.data.concat(faqs2.data));
	        }));
	      } else {
	        pendingRequest.promise = _axios2.default.all([this.getGroups(), this.getFaqs(1)]).then(_axios2.default.spread(function (groups, faqs1) {
	          return _this2.hydrateCollection(groups.data, faqs1.data);
	        }));
	      }
	
	      return pendingRequest;
	    }
	  }]);
	  return FaqService;
	}();
	
	exports.default = new FaqService();

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FeatureFlagEntity = function FeatureFlagEntity(id, name, value) {
	  (0, _classCallCheck3.default)(this, FeatureFlagEntity);
	
	  this.id = id;
	  this.name = name;
	  this.value = value;
	};
	
	exports.default = FeatureFlagEntity;

/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(18);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(17);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _featureFlagsEntity = __webpack_require__(767);
	
	var _featureFlagsEntity2 = _interopRequireDefault(_featureFlagsEntity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FeatureFlagsService = function () {
	  function FeatureFlagsService() {
	    (0, _classCallCheck3.default)(this, FeatureFlagsService);
	  }
	
	  (0, _createClass3.default)(FeatureFlagsService, [{
	    key: 'hydrate',
	    value: function hydrate(featureFlag) {
	      return new _featureFlagsEntity2.default(featureFlag.id, featureFlag.name, featureFlag.value);
	    }
	  }, {
	    key: 'hydrateCollection',
	    value: function hydrateCollection(data) {
	      var features = [];
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var feature = _step.value;
	
	          features.push(this.hydrate(feature));
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return features;
	    }
	  }, {
	    key: 'getStoryblokFeatureFlags',
	    value: function getStoryblokFeatureFlags() {
	      var _this = this;
	
	      var cacheBuster = '&cv=' + Date.now();
	      // eslint-disable-next-line max-len
	      return _axios2.default.get('https://api.storyblok.com/v2/cdn/datasource_entries?datasource=feature-flags&token=zmSiv98DssZf7fOvJqKPdQtt' + cacheBuster).then(function (response) {
	        var features = _this.hydrateCollection(response.data.datasource_entries);
	        return features;
	      });
	    }
	  }]);
	  return FeatureFlagsService;
	}();
	
	exports.default = new FeatureFlagsService();

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(18);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(17);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _incomentStatementEntity = __webpack_require__(770);
	
	var _incomentStatementEntity2 = _interopRequireDefault(_incomentStatementEntity);
	
	var _pendingRequestEntity = __webpack_require__(42);
	
	var _pendingRequestEntity2 = _interopRequireDefault(_pendingRequestEntity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IncomeStatementService = function () {
	  function IncomeStatementService() {
	    (0, _classCallCheck3.default)(this, IncomeStatementService);
	  }
	
	  (0, _createClass3.default)(IncomeStatementService, [{
	    key: 'hydrate',
	    value: function hydrate(data) {
	      return new _incomentStatementEntity2.default(data.id, data.attributes.url, data.attributes.user_id, data.attributes.year);
	    }
	  }, {
	    key: 'hydrateCollection',
	    value: function hydrateCollection(data) {
	      var statements = [];
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var d = _step.value;
	
	          statements.push(this.hydrate(d));
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return statements;
	    }
	  }, {
	    key: 'getIncomeStatements',
	    value: function getIncomeStatements(userId) {
	      var _this = this;
	
	      var pendingRequest = new _pendingRequestEntity2.default();
	      pendingRequest.promise = _axios2.default.get('backend://users/' + userId + '/income-statements', {
	        cancelToken: new _axios2.default.CancelToken(function executor(c) {
	          pendingRequest.cancel = c;
	        })
	      }).then(function (response) {
	        return _this.hydrateCollection(response.data.data);
	      });
	
	      return pendingRequest;
	    }
	  }]);
	  return IncomeStatementService;
	}(); /**
	      * Created by staffanrantzow on 24/11/16.
	      */
	
	exports.default = new IncomeStatementService();

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 14/06/16.
	 */
	
	var IncomeStatementEntity = function IncomeStatementEntity(id, url, userId, year) {
	  (0, _classCallCheck3.default)(this, IncomeStatementEntity);
	
	  this.id = id;
	  this.url = url;
	  this.userId = userId;
	  this.year = year;
	  this.name = year; // used for select
	  this.value = id; // used for select
	};
	
	exports.default = IncomeStatementEntity;

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 14/06/16.
	 */
	
	var InfoEntity = function InfoEntity(id, date, title, text) {
	  (0, _classCallCheck3.default)(this, InfoEntity);
	
	  this.id = id;
	  this.date = date;
	  this.title = title;
	  this.text = text;
	};
	
	exports.default = InfoEntity;

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(17);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _infoEntity = __webpack_require__(771);
	
	var _infoEntity2 = _interopRequireDefault(_infoEntity);
	
	var _pendingRequestEntity = __webpack_require__(42);
	
	var _pendingRequestEntity2 = _interopRequireDefault(_pendingRequestEntity);
	
	var _variables = __webpack_require__(47);
	
	var variables = _interopRequireWildcard(_variables);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 14/10/16.
	 */
	
	var InfoService = function () {
	  function InfoService() {
	    (0, _classCallCheck3.default)(this, InfoService);
	  }
	
	  (0, _createClass3.default)(InfoService, [{
	    key: 'hydrate',
	    value: function hydrate(list) {
	      return list.map(function (data) {
	        return new _infoEntity2.default(data.id, data.date, data.title.rendered, data.content.rendered);
	      });
	    }
	  }, {
	    key: 'get',
	    value: function get() {
	      var _this = this;
	
	      var pendingRequest = new _pendingRequestEntity2.default();
	      pendingRequest.promise = _axios2.default.get(variables.frontUrl + '/wp-json/wp/v2/viktig-information?filter[order]=DESC&per_page=2', {
	        cancelToken: new _axios2.default.CancelToken(function executor(c) {
	          pendingRequest.cancel = c;
	        })
	      }).then(function (response) {
	        if (response.data && response.data.length > 0) {
	          return _this.hydrate(response.data);
	        }
	        return [];
	      });
	      return pendingRequest;
	    }
	  }]);
	  return InfoService;
	}();
	
	exports.default = new InfoService();

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InsurancesPageEntity = function InsurancesPageEntity(id, title, insurancesIngress, insurancesText, insurancesSections, insurancesImage, insurancesLetterButton, insurancesLetterBox) {
	  (0, _classCallCheck3.default)(this, InsurancesPageEntity);
	
	  this.id = id;
	  this.title = title;
	  this.insurancesIngress = insurancesIngress;
	  this.insurancesText = insurancesText;
	  this.insurancesSections = insurancesSections;
	  this.insurancesImage = insurancesImage;
	  this.insurancesLetterButton = insurancesLetterButton;
	  this.insurancesLetterBox = insurancesLetterBox;
	};
	
	exports.default = InsurancesPageEntity;

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(17);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _insurancesPageEntity = __webpack_require__(773);
	
	var _insurancesPageEntity2 = _interopRequireDefault(_insurancesPageEntity);
	
	var _pendingRequestEntity = __webpack_require__(42);
	
	var _pendingRequestEntity2 = _interopRequireDefault(_pendingRequestEntity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InsurancesPageService = function () {
	  function InsurancesPageService() {
	    (0, _classCallCheck3.default)(this, InsurancesPageService);
	  }
	
	  (0, _createClass3.default)(InsurancesPageService, [{
	    key: 'hydrate',
	    value: function hydrate(data) {
	      return new _insurancesPageEntity2.default(data.id, data.title.rendered, data.acf.insurances_ingress, data.acf.insurances_text, data.acf.insurances_sections, data.acf.insurances_image.url, data.acf.insurances_letter_button, data.acf.insurances_letter_box);
	    }
	  }, {
	    key: 'get',
	    value: function get(pageID) {
	      var _this = this;
	
	      var pendingRequest = new _pendingRequestEntity2.default();
	
	      pendingRequest.promise = _axios2.default.get('https://www.frilansfinans.se/wp-json/wp/v2/pages/' + pageID, {
	        cancelToken: new _axios2.default.CancelToken(function executor(c) {
	          pendingRequest.cancel = c;
	        })
	      }).then(function (response) {
	        return _this.hydrate(response.data);
	      });
	
	      return pendingRequest;
	    }
	  }]);
	  return InsurancesPageService;
	}();
	
	exports.default = new InsurancesPageService();

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(17);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InvoiceCopyService = function () {
	  function InvoiceCopyService() {
	    (0, _classCallCheck3.default)(this, InvoiceCopyService);
	  }
	
	  (0, _createClass3.default)(InvoiceCopyService, [{
	    key: 'get',
	    value: function get(ocr, companyId) {
	      return _axios2.default.get('backend://invoice/copy?ocr=' + ocr + '&customer_id=' + companyId).then(function (response) {
	        return response.data.data.attributes;
	      });
	    }
	  }]);
	  return InvoiceCopyService;
	}();
	
	exports.default = new InvoiceCopyService();

/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InvoiceCalculationEntity = function InvoiceCalculationEntity(allowance, amount, expense, fee, gross, invoiceValue, itp, itpTax, net, payrollTax, salaryTotal, tax, toPay, totalPayrollTax, travel, vacationGross, vacationNet, vacationPayrollTax, vat, userId) {
	  (0, _classCallCheck3.default)(this, InvoiceCalculationEntity);
	
	  this.allowance = allowance ? +allowance : allowance;
	  this.amount = amount ? +amount : amount;
	  this.expense = expense ? +expense : expense;
	  this.fee = fee ? +fee : fee;
	  this.gross = gross ? +gross : gross;
	  this.invoiceValue = invoiceValue;
	  this.itp = itp;
	  this.itpTax = itpTax;
	  this.net = net ? +net : net;
	  this.payrollTax = payrollTax ? +payrollTax : payrollTax;
	  this.salaryTotal = salaryTotal ? +salaryTotal : salaryTotal;
	  this.tax = tax ? +tax : tax;
	  this.toPay = toPay;
	  this.totalPayrollTax = totalPayrollTax;
	  this.travel = travel;
	  this.vacationGross = vacationGross;
	  this.vacationNet = vacationNet;
	  this.vacationPayrollTax = vacationPayrollTax;
	  this.vat = vat ? +vat : vat;
	  this.userId = parseInt(userId);
	};
	
	exports.default = InvoiceCalculationEntity;

/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InvoiceEntity = function () {
	  function InvoiceEntity(id, allowance, amount, approvalStatus, createdAt, currencyAmount, currencyName, currencyExchangeRate, currencyId, expense, fullPaymentDateTime, gross, hasCreditErrand, invoiceNumber, loyaltyPoints, net, paymentStatus, preReport, preReportedAt, sendToEmail, sent, specification, status, supplierLedgerDateTime, taxId, taxPercent, travel, userId, customer, currency, hours, invoiceUsers, pdfLink, hsd, displayDates, displayHours, salaries, invoiceDates, calculation, ocr, uuid, users, messageType, billingEmails, eInvoiceEmail, surveys, poNumber, companyPhone) {
	    (0, _classCallCheck3.default)(this, InvoiceEntity);
	
	    this.id = id;
	    this.allowance = allowance;
	    this.amount = amount;
	    this.approvalStatus = approvalStatus;
	    this.createdAt = createdAt;
	    this.currencyExchangeRate = currencyExchangeRate;
	    this.currencyId = currencyId;
	    this.currencyAmount = currencyAmount;
	    this.currencyName = currencyName;
	    this.expense = expense;
	    this.fullPaymentDateTime = fullPaymentDateTime;
	    this.gross = gross;
	    this.hasCreditErrand = hasCreditErrand;
	    this.invoiceNumber = invoiceNumber;
	    this.loyaltyPoints = loyaltyPoints;
	    this.net = net;
	    this.paymentStatus = paymentStatus;
	    this.preReport = preReport;
	    this.preReportedAt = preReportedAt;
	    this.sendToEmail = sendToEmail;
	    this.sent = sent;
	    this.specification = specification;
	    this.status = status;
	    this.supplierLedgerDateTime = supplierLedgerDateTime;
	    this.taxId = taxId;
	    this.taxPercent = taxPercent;
	    this.travel = travel;
	    this.userId = userId;
	    this.customer = customer;
	    this.currency = currency;
	    this.hours = hours;
	    this.invoiceUsers = invoiceUsers;
	    this.pdfLink = pdfLink;
	    this.hsd = hsd;
	    this.displayDates = displayDates;
	    this.displayHours = displayHours;
	    this.salaries = salaries;
	    this.invoiceDates = invoiceDates;
	    this.calculation = calculation;
	    this.ocr = ocr;
	    this.uuid = uuid;
	    this.users = users;
	    this.messageType = messageType;
	    this.billingEmails = billingEmails;
	    this.eInvoiceEmail = eInvoiceEmail;
	    this.surveys = surveys;
	    this.poNumber = poNumber;
	    this.companyPhone = companyPhone;
	  }
	
	  (0, _createClass3.default)(InvoiceEntity, [{
	    key: 'currencyValue',
	    get: function get() {
	      if (this.currency) {
	        return this.amount / this.currency.exchangeRate;
	      }
	
	      return 0;
	    }
	  }, {
	    key: 'statusText',
	    get: function get() {
	      switch (this.status) {
	        case 1:
	          return (0, _proxyCounterpart.proxyCounterpart)('WITH_RES');
	        case 2:
	          return (0, _proxyCounterpart.proxyCounterpart)('APPROVED');
	        case 3:
	          return (0, _proxyCounterpart.proxyCounterpart)('NOT_APPROVED');
	        case 4:
	          return (0, _proxyCounterpart.proxyCounterpart)('WAIT_JUDGEMENT');
	      }
	    }
	  }, {
	    key: 'paymentStatusText',
	    get: function get() {
	      switch (this.paymentStatus) {
	        case 1:
	          return (0, _proxyCounterpart.proxyCounterpart)('NOT_PAID');
	        case 2:
	          return (0, _proxyCounterpart.proxyCounterpart)('IS_PAID');
	        case 3:
	          return (0, _proxyCounterpart.proxyCounterpart)('PART_PAID');
	      }
	    }
	  }, {
	    key: 'approvalStatusText',
	    get: function get() {
	      switch (this.approvalStatus) {
	        case 1:
	          return (0, _proxyCounterpart.proxyCounterpart)('WAIT_JUDGEMENT');
	        case 2:
	          return (0, _proxyCounterpart.proxyCounterpart)('APPROVED');
	        case 3:
	          return (0, _proxyCounterpart.proxyCounterpart)('NOT_APPROVED');
	        case 4:
	          return (0, _proxyCounterpart.proxyCounterpart)('APPROVED_WITH_RES');
	        case 5:
	          return (0, _proxyCounterpart.proxyCounterpart)('PREREGISTERED');
	        default:
	          return '';
	      }
	    }
	  }]);
	  return InvoiceEntity;
	}(); /**
	      * Created by staffanrantzow on 14/04/16.
	      */
	
	exports.default = InvoiceEntity;

/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by eriksundqvist on 12/10/16.
	 */
	var InvoiceHsdEntity = function InvoiceHsdEntity(rot, rut, data, apartmentNumber, cooperativeApartmentRegistrationNumber, accommodationType) {
	  (0, _classCallCheck3.default)(this, InvoiceHsdEntity);
	
	  this.rot = rot;
	  this.rut = rut;
	  this.data = data;
	  this.apartmentNumber = apartmentNumber;
	  this.cooperativeApartmentRegistrationNumber = cooperativeApartmentRegistrationNumber;
	  this.accommodationType = accommodationType;
	};
	
	exports.default = InvoiceHsdEntity;

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by eriksundqvist on 12/10/16.
	 */
	
	var InvoicePostEntity = function InvoicePostEntity(specification, userId, taxId, companyId, currencyId, currencyName, amount, invoiceUsers, invoiceDates, preReport, preReportedAt, createdAt, hsd, sendToEmail, sendToEinvoiceAddress, displayDates, displayHours, couponId, currencyAmount, messageType) {
	  (0, _classCallCheck3.default)(this, InvoicePostEntity);
	
	  this.specification = specification;
	  this.userId = userId;
	  this.taxId = taxId;
	  this.companyId = companyId;
	  this.currencyId = currencyId;
	  this.currencyName = currencyName;
	  this.amount = amount;
	  this.invoiceUsers = invoiceUsers;
	  this.invoiceDates = invoiceDates;
	  this.preReport = preReport;
	  this.preReportedAt = preReportedAt;
	  this.createdAt = createdAt;
	  this.hsd = hsd;
	  this.sendToEmail = sendToEmail;
	  this.sendToEinvoiceAddress = sendToEinvoiceAddress;
	  this.displayHours = displayHours;
	  this.displayDates = displayDates;
	  this.couponId = couponId || '';
	  this.currencyAmount = currencyAmount;
	  this.messageType = messageType;
	};
	
	exports.default = InvoicePostEntity;

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(120);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _axios = __webpack_require__(17);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _service = __webpack_require__(118);
	
	var _service2 = _interopRequireDefault(_service);
	
	var _invoiceUserEntity = __webpack_require__(221);
	
	var _invoiceUserEntity2 = _interopRequireDefault(_invoiceUserEntity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InvoiceUserService = function (_Service) {
	  (0, _inherits3.default)(InvoiceUserService, _Service);
	
	  function InvoiceUserService() {
	    (0, _classCallCheck3.default)(this, InvoiceUserService);
	    return (0, _possibleConstructorReturn3.default)(this, (InvoiceUserService.__proto__ || (0, _getPrototypeOf2.default)(InvoiceUserService)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(InvoiceUserService, [{
	    key: 'hydrate',
	    value: function hydrate(invoiceUser) {
	      return new _invoiceUserEntity2.default(invoiceUser.attributes.travel, invoiceUser.attributes.co, invoiceUser.attributes.street, invoiceUser.attributes.zip, invoiceUser.attributes.city, invoiceUser.attributes.country, invoiceUser.attributes.invoice_id, invoiceUser.attributes.user_id, invoiceUser.attributes.allowance, invoiceUser.attributes.taxkey_id, invoiceUser.attributes.total, invoiceUser.attributes.first_name, invoiceUser.attributes.last_name, invoiceUser.attributes.account_clearing_number, invoiceUser.attributes.account_number, invoiceUser.attributes.salary_payed_date, invoiceUser.attributes.express_payment, invoiceUser.attributes.taxkey_name, invoiceUser.attributes.save_vacation_pay, invoiceUser.attributes.save_itp, invoiceUser.attributes.itp_rate, null, // calculation
	      invoiceUser.attributes.gross, invoiceUser.attributes.salary_net);
	    }
	  }, {
	    key: 'hydrateCollection',
	    value: function hydrateCollection(data, invoiceOwnerId) {
	      var invoiceUsers = [];
	
	      var sortedInvoiceUsersData = [].concat((0, _toConsumableArray3.default)(data.filter(function (invoiceUser) {
	        return +invoiceUser.attributes.user_id === +invoiceOwnerId;
	      })), (0, _toConsumableArray3.default)(data.filter(function (invoiceUser) {
	        return +invoiceUser.attributes.user_id !== +invoiceOwnerId;
	      })));
	
	      for (var i = 0; i < sortedInvoiceUsersData.length; i++) {
	        invoiceUsers.push(this.hydrate(sortedInvoiceUsersData[i]));
	      }
	
	      return invoiceUsers;
	    }
	  }, {
	    key: 'getById',
	    value: function getById(invoiceId) {
	      var _this2 = this;
	
	      return _axios2.default.get('backend://invoice-users/' + invoiceId).then(function (response) {
	        return _this2.hydrate(response.data.data);
	      });
	    }
	  }]);
	  return InvoiceUserService;
	}(_service2.default); /**
	                       * Created by eriksundqvist on 11/10/16.
	                       */
	
	
	exports.default = new InvoiceUserService();

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 12/04/16.
	 */
	
	var LogotypeEntity = function LogotypeEntity(id, imageSrc) {
	  (0, _classCallCheck3.default)(this, LogotypeEntity);
	
	  this.id = id;
	  this.imageSrc = imageSrc;
	};
	
	exports.default = LogotypeEntity;

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(18);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(17);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _store = __webpack_require__(92);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _index = __webpack_require__(164);
	
	var _logotypeEntity = __webpack_require__(781);
	
	var _logotypeEntity2 = _interopRequireDefault(_logotypeEntity);
	
	var _http = __webpack_require__(71);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LogotypeService = function () {
	  function LogotypeService() {
	    (0, _classCallCheck3.default)(this, LogotypeService);
	  }
	
	  (0, _createClass3.default)(LogotypeService, [{
	    key: 'hydrate',
	    value: function hydrate(logotype) {
	      return new _logotypeEntity2.default(logotype.id, logotype.attributes.image_src);
	    }
	  }, {
	    key: 'hydrateCollection',
	    value: function hydrateCollection(data) {
	      var logotypes = [];
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var logotype = _step.value;
	
	          logotypes.push(this.hydrate(logotype));
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return logotypes;
	    }
	  }, {
	    key: 'get',
	    value: function get() {
	      var _this = this;
	
	      return _axios2.default.get('backend://logotypes').then(function (response) {
	        var logotypes = _this.hydrateCollection(response.data.data);
	        return new _http.APIResult(logotypes, response.data.meta);
	      });
	    }
	  }, {
	    key: 'post',
	    value: function post(params) {
	      var _this2 = this;
	
	      var data = {
	        data: {
	          attributes: params
	        }
	      };
	      return _axios2.default.request({
	        url: 'backend://logotypes',
	        method: 'POST',
	        data: data
	      }).then(function (response) {
	        var logotype = _this2.hydrate(response.data.data);
	        _store2.default.dispatch((0, _index.setUserImageSrc)(logotype.imageSrc));
	        return logotype;
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(params) {
	      var data = {
	        data: {
	          attributes: params
	        }
	      };
	      return _axios2.default.request({
	        url: 'backend://logotypes',
	        method: 'DELETE',
	        data: data
	      }).then(function (response) {
	        _store2.default.dispatch((0, _index.setUserImageSrc)(''));
	        return response.data;
	      });
	    }
	  }]);
	  return LogotypeService;
	}();
	
	exports.default = new LogotypeService();

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(18);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _axios = __webpack_require__(17);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _loyaltyPointTypeEntity = __webpack_require__(784);
	
	var _loyaltyPointTypeEntity2 = _interopRequireDefault(_loyaltyPointTypeEntity);
	
	var _http = __webpack_require__(71);
	
	var _service = __webpack_require__(118);
	
	var _service2 = _interopRequireDefault(_service);
	
	var _pendingRequestEntity = __webpack_require__(42);
	
	var _pendingRequestEntity2 = _interopRequireDefault(_pendingRequestEntity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoyaltyPointService = function (_Service) {
	  (0, _inherits3.default)(LoyaltyPointService, _Service);
	
	  function LoyaltyPointService() {
	    (0, _classCallCheck3.default)(this, LoyaltyPointService);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (LoyaltyPointService.__proto__ || (0, _getPrototypeOf2.default)(LoyaltyPointService)).call(this));
	
	    _this.types = null;
	    return _this;
	  }
	
	  (0, _createClass3.default)(LoyaltyPointService, [{
	    key: 'hydrate',
	    value: function hydrate(point) {
	      return new _loyaltyPointTypeEntity2.default(point.id, point.amount, point.company_name, point.expires_at, point.factor, point.loyaltyable_id, point.loyaltyable_type, point.status, point.created_at, point.deleted_at, point.updated_at);
	    }
	  }, {
	    key: 'hydrateCollection',
	    value: function hydrateCollection(data) {
	      var points = [];
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var point = _step.value;
	
	          points.push(this.hydrate(point));
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return points;
	    }
	  }, {
	    key: 'mapApiResponseForApiResult',
	    value: function mapApiResponseForApiResult(meta) {
	      if (meta.pagination) {
	        return meta;
	      }
	      return {
	        pagination: {
	          page: {
	            items: +meta.total,
	            number: +meta.current_page,
	            size: +meta.per_page
	          },
	          items: +meta.to - +meta.from,
	          pages: +meta.last_page
	        }
	      };
	    }
	  }, {
	    key: 'getPending',
	    value: function getPending(page) {
	      var _this2 = this;
	
	      var pendingRequest = new _pendingRequestEntity2.default();
	
	      var params = {
	        'page': page || 1,
	        'per_page': 10
	      };
	
	      pendingRequest.promise = _axios2.default.get('backend://users/loyalty-points/pending', {
	        params: params,
	        cancelToken: new _axios2.default.CancelToken(function executor(c) {
	          pendingRequest.cancel = c;
	        })
	      }).then(function (response) {
	        var points = _this2.hydrateCollection(response.data.data);
	        var meta = _this2.mapApiResponseForApiResult(response.data.meta);
	        return new _http.APIResult(points, meta);
	      });
	
	      return pendingRequest;
	    }
	  }, {
	    key: 'getComplete',
	    value: function getComplete(page) {
	      var _this3 = this;
	
	      var pendingRequest = new _pendingRequestEntity2.default();
	
	      var params = {
	        'page': page || 1,
	        'per_page': 10
	      };
	
	      pendingRequest.promise = _axios2.default.get('backend://users/loyalty-points/complete', {
	        params: params,
	        cancelToken: new _axios2.default.CancelToken(function executor(c) {
	          pendingRequest.cancel = c;
	        })
	      }).then(function (response) {
	        var points = _this3.hydrateCollection(response.data.data, response.data.included);
	        var meta = _this3.mapApiResponseForApiResult(response.data.meta);
	        return new _http.APIResult(points, meta);
	      });
	
	      return pendingRequest;
	    }
	  }]);
	  return LoyaltyPointService;
	}(_service2.default);
	
	exports.default = new LoyaltyPointService();

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 10/11/16.
	 */
	
	var LoyaltyPointsTypeEntity = function LoyaltyPointsTypeEntity(id, amount, companyName, expiresAt, factor, loyaltyableId, loyaltyableType, status, createdAt, deletedAt, updatedAt) {
	  (0, _classCallCheck3.default)(this, LoyaltyPointsTypeEntity);
	
	  this.id = id;
	  this.amount = amount;
	  this.companyName = companyName;
	  this.expires_at = expiresAt;
	  this.factor = factor;
	  this.loyaltyableId = loyaltyableId;
	  this.loyaltyableType = loyaltyableType;
	  this.status = status;
	  this.createdAt = createdAt;
	  this.deletedAt = deletedAt;
	  this.updatedAt = updatedAt;
	};
	
	exports.default = LoyaltyPointsTypeEntity;

/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(17);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaymentRequestService = function () {
	  function PaymentRequestService() {
	    (0, _classCallCheck3.default)(this, PaymentRequestService);
	  }
	
	  (0, _createClass3.default)(PaymentRequestService, [{
	    key: 'create',
	    value: function create(uuid) {
	      return _axios2.default.post('backend://payment-request/' + uuid + '/swish').then(function (response) {
	        return response.data.data;
	      });
	    }
	  }]);
	  return PaymentRequestService;
	}();
	
	exports.default = new PaymentRequestService();

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 12/04/16.
	 */
	
	var ProfessionEntity = function ProfessionEntity(id, insuranceStatusId, languageId, ssyk, title) {
	  (0, _classCallCheck3.default)(this, ProfessionEntity);
	
	  this.id = id;
	  this.insuranceStatusId = insuranceStatusId;
	  this.languageId = languageId;
	  this.ssyk = ssyk;
	  this.title = title;
	};
	
	exports.default = ProfessionEntity;

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(18);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(17);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _professionEntity = __webpack_require__(786);
	
	var _professionEntity2 = _interopRequireDefault(_professionEntity);
	
	var _http = __webpack_require__(71);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProfessionsService = function () {
	  function ProfessionsService() {
	    (0, _classCallCheck3.default)(this, ProfessionsService);
	  }
	
	  (0, _createClass3.default)(ProfessionsService, [{
	    key: 'hydrate',
	    value: function hydrate(profession) {
	      return new _professionEntity2.default(profession.id, profession.attributes.insurance_status_id, profession.attributes.language_id, profession.attributes.ssyk, profession.attributes.title);
	    }
	  }, {
	    key: 'hydrateCollection',
	    value: function hydrateCollection(data) {
	      var professions = [];
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var profession = _step.value;
	
	          professions.push(this.hydrate(profession));
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return professions;
	    }
	  }, {
	    key: 'getByTitle',
	    value: function getByTitle(title) {
	      var _this = this;
	
	      return _axios2.default.get('backend://professions?filter[title][*]=' + title).then(function (response) {
	        var professions = _this.hydrateCollection(response.data.data);
	        return new _http.APIResult(professions, response.data.meta);
	      });
	    }
	  }, {
	    key: 'get',
	    value: function get() {
	      var _this2 = this;
	
	      return _axios2.default.get('backend://professions').then(function (response) {
	        var professions = _this2.hydrateCollection(response.data.data);
	        return new _http.APIResult(professions, response.data.meta);
	      });
	    }
	  }]);
	  return ProfessionsService;
	}(); /**
	      * Created by staffanrantzow on 05/04/16.
	      */
	
	exports.default = new ProfessionsService();

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.replaceBackendUri = replaceBackendUri;
	
	var _variables = __webpack_require__(47);
	
	var variables = _interopRequireWildcard(_variables);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * Inject the proper api base url depending on the current domain
	 *
	 * @param config
	 *
	 * @returns {*}
	 */
	
	var defaultUrl = 'http://api.staging.frilansfinans.se/';
	
	function replaceBackendUri(config) {
	  if (config.url.substring(0, 10) === 'backend://') {
	    var url = variables.apiUrl || defaultUrl;
	    config.url = url + config.url.substring(10);
	  }
	  return config;
	}

/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 14/06/16.
	 */
	
	var REGULAR_TYPE_ID = 1;
	
	var SalaryEntity = function () {
	  function SalaryEntity(id, allowance, categoryId, typeId, createdAt, grossAmount, grossOld, invoiceId, netAmount, paidAt, paymentStatus, plannedPaymentAt, resentStatus, taxAmount, taxkeyId, toPay, travel, userId, companyName, specificationPdfUrl, invoice, invoiceDates, taxAgencySalary) {
	    (0, _classCallCheck3.default)(this, SalaryEntity);
	
	    this.id = id;
	    this.allowance = allowance;
	    this.categoryId = categoryId;
	    this.typeId = parseInt(typeId);
	    this.createdAt = createdAt;
	    this.grossAmount = grossAmount;
	    this.grossOld = grossOld;
	    this.invoiceId = invoiceId;
	    this.netAmount = netAmount;
	    this.paidAt = paidAt;
	    this.paymentStatus = paymentStatus;
	    this.plannedPaymentAt = plannedPaymentAt;
	    this.resentStatus = resentStatus;
	    this.taxAmount = taxAmount;
	    this.taxkeyId = taxkeyId;
	    this.toPay = toPay;
	    this.travel = travel;
	    this.userId = userId;
	    this.companyName = companyName;
	    this.specificationPdfUrl = specificationPdfUrl;
	    this.invoice = invoice;
	    this.invoiceDates = invoiceDates;
	    this.taxAgencySalary = taxAgencySalary;
	  }
	
	  (0, _createClass3.default)(SalaryEntity, [{
	    key: 'isRegular',
	    value: function isRegular() {
	      return this.typeId === REGULAR_TYPE_ID;
	    }
	  }, {
	    key: 'taxAgencyPart',
	    value: function taxAgencyPart(attribute) {
	      if (this.taxAgencySalary) {
	        return parseFloat(this.taxAgencySalary.attributes[attribute]);
	      }
	
	      return 0;
	    }
	  }, {
	    key: 'grossIncTaxAgencyPart',
	    value: function grossIncTaxAgencyPart() {
	      return this.grossAmount + this.taxAgencyPart('gross_amount');
	    }
	  }, {
	    key: 'netIncTaxAgencyPart',
	    value: function netIncTaxAgencyPart() {
	      return this.netAmount + this.taxAgencyPart('net_amount');
	    }
	  }, {
	    key: 'toPayIncTaxAgencyPart',
	    value: function toPayIncTaxAgencyPart() {
	      return this.toPay + this.taxAgencyPart('to_pay');
	    }
	  }]);
	  return SalaryEntity;
	}();
	
	exports.default = SalaryEntity;

/***/ },
/* 790 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PAUSED_STATUS = 1;
	var PAID_STATUS = 2;
	var NOT_APPROVED_STATUS = 3;
	var PLANNED_STATUS = 4;
	var LOCKED_STATUS = 5;
	
	exports.default = {
	  PAUSED_STATUS: PAUSED_STATUS,
	  PAID_STATUS: PAID_STATUS,
	  NOT_APPROVED_STATUS: NOT_APPROVED_STATUS,
	  PLANNED_STATUS: PLANNED_STATUS,
	  LOCKED_STATUS: LOCKED_STATUS
	};

/***/ },
/* 791 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var REGULAR_TYPE = 1;
	var VACATION_TYPE = 2;
	var ITP_TYPE = 3;
	var ITP_TAX_TYPE = 4;
	var EXPENSE_TYPE = 5;
	var EXPENSE_TRAVEL_TYPE = 6;
	var SICK_PAYMENT_TYPE = 7;
	var KRONOFOGDEN_PAYMENT_TYPE = 8;
	var TRAVEL_ALLOWANCE_PAYMENT_TYPE = 9;
	
	exports.default = {
	  REGULAR_TYPE: REGULAR_TYPE,
	  VACATION_TYPE: VACATION_TYPE,
	  ITP_TYPE: ITP_TYPE,
	  ITP_TAX_TYPE: ITP_TAX_TYPE,
	  EXPENSE_TYPE: EXPENSE_TYPE,
	  EXPENSE_TRAVEL_TYPE: EXPENSE_TRAVEL_TYPE,
	  SICK_PAYMENT_TYPE: SICK_PAYMENT_TYPE,
	  KRONOFOGDEN_PAYMENT_TYPE: KRONOFOGDEN_PAYMENT_TYPE,
	  TRAVEL_ALLOWANCE_PAYMENT_TYPE: TRAVEL_ALLOWANCE_PAYMENT_TYPE
	};

/***/ },
/* 792 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SpinnerPage = exports.SpinnerPage = "<!DOCTYPE html>\n<html>\n<head>\n  <style>\n    .spinner{\n      box-sizing: border-box;\n      position: absolute;\n      left: 50%;\n      top: 50%;\n      height: 100px;\n      margin-left: -50px;\n      margin-top: -50px;\n      width: 100px;\n      -webkit-animation: rotation .7s infinite linear;\n      -moz-animation: rotation .7s infinite linear;\n      -o-animation: rotation .7s infinite linear;\n      animation: rotation .7s infinite linear;\n      border-left: 5px solid hsla(0,0%,59%,.3);\n      border-right: 5px solid hsla(0,0%,59%,.3);\n      border-bottom: 5px solid hsla(0,0%,59%,.3);\n      border-top: 5px solid hsla(0,0%,59%,.9);\n      border-radius: 100%;\n    }\n\n    @-webkit-keyframes rotation {\n   from {-webkit-transform: rotate(0deg);}\n   to {-webkit-transform: rotate(359deg);}\n  }\n\n  @-moz-keyframes rotation {\n   from {-moz-transform: rotate(0deg);}\n   to {-moz-transform: rotate(359deg);}\n  }\n\n  @-o-keyframes rotation {\n   from {-o-transform: rotate(0deg);}\n   to {-o-transform: rotate(359deg);}\n  }\n\n  @keyframes rotation {\n   from {transform: rotate(0deg);}\n   to {transform: rotate(359deg);}\n  }\n  </style>\n  <title></title>\n</head>\n<body>\n  <div class=\"spinner\"></div>\n</body>\n</html>";

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _invoiceToolHelper = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 15/04/16.
	 */
	
	var SupplierLedgerEntity = function () {
	  function SupplierLedgerEntity(id, amount, arrivedDate, createdAt, expenseId, invoiceId, invoiceItemId, payedDate, status, supplierInvoiceAccount, supplierInvoiceNr, supplierInvoiceUt, supplierLedgerTypeId, supplierName, taxId, taxPercent, typeId, userIdAuthorization, userIdCreator, file) {
	    (0, _classCallCheck3.default)(this, SupplierLedgerEntity);
	
	    this.id = id;
	    this.amount = amount;
	    this.arrivedDate = arrivedDate;
	    this.createdAt = createdAt;
	    this.expenseId = expenseId;
	    this.invoiceId = invoiceId;
	    this.invoiceItemId = invoiceItemId;
	    this.payedDate = payedDate;
	    this.status = status;
	    this.supplierInvoiceAccount = supplierInvoiceAccount;
	    this.supplierInvoiceNr = supplierInvoiceNr;
	    this.supplierInvoiceUt = supplierInvoiceUt;
	    this.supplierLedgerTypeId = supplierLedgerTypeId;
	    this.supplierName = supplierName;
	    this.taxId = taxId;
	    this.taxPercent = taxPercent;
	    this.typeId = typeId;
	    this.userIdAuthorization = userIdAuthorization;
	    this.userIdCreator = userIdCreator;
	    this.file = file;
	  }
	
	  (0, _createClass3.default)(SupplierLedgerEntity, [{
	    key: 'statusText',
	    get: function get() {
	      switch (this.status) {
	        case 1:
	          return (0, _proxyCounterpart.proxyCounterpart)('IS_PAID');
	        case 2:
	          return (0, _proxyCounterpart.proxyCounterpart)('ONGOING');
	        case 3:
	          return (0, _proxyCounterpart.proxyCounterpart)('NEW');
	        case 4:
	          return (0, _proxyCounterpart.proxyCounterpart)('WAITING');
	        case 5:
	          return (0, _proxyCounterpart.proxyCounterpart)('CREDITED');
	        case 6:
	          return (0, _proxyCounterpart.proxyCounterpart)('DISPUTE');
	        case 7:
	          return (0, _proxyCounterpart.proxyCounterpart)('INVOICE_NOT_CHECKED');
	        case 8:
	          return (0, _proxyCounterpart.proxyCounterpart)('LEVRES');
	        case 9:
	          return (0, _proxyCounterpart.proxyCounterpart)('INVOICE_NOT_CREATED');
	        case 10:
	          return (0, _proxyCounterpart.proxyCounterpart)('TO_PAYMENT');
	        case 11:
	          return (0, _proxyCounterpart.proxyCounterpart)('PAID_FILE');
	        case 12:
	          return (0, _proxyCounterpart.proxyCounterpart)('OLD_POST');
	      }
	    }
	  }, {
	    key: 'amountIncVat',
	    get: function get() {
	      return Math.round(this.amount * (1 + (0, _invoiceToolHelper.getVatById)(this.taxId) / 100) * 100) / 100;
	    }
	  }]);
	  return SupplierLedgerEntity;
	}();
	
	exports.default = SupplierLedgerEntity;

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 10/11/16.
	 */
	
	var SupplierLedgerTypeEntity = function SupplierLedgerTypeEntity(id, active, displayName, displayOrder, isRotRut, specifyDate, taxId) {
	  (0, _classCallCheck3.default)(this, SupplierLedgerTypeEntity);
	
	  this.id = id;
	  this.active = active;
	  this.displayName = displayName;
	  this.displayOrder = displayOrder;
	  this.isRotRut = isRotRut;
	  this.specifyDate = specifyDate;
	  this.taxId = taxId;
	};
	
	exports.default = SupplierLedgerTypeEntity;

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 14/06/16.
	 */
	
	var TaxEntity = function TaxEntity(id, percent, standard) {
	  (0, _classCallCheck3.default)(this, TaxEntity);
	
	  this.id = id;
	  this.percent = percent;
	  this.standard = standard;
	};
	
	exports.default = TaxEntity;

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(72);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getIterator2 = __webpack_require__(18);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _taxEntity = __webpack_require__(795);
	
	var _taxEntity2 = _interopRequireDefault(_taxEntity);
	
	var _axios = __webpack_require__(17);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 10/11/16.
	 */
	
	var TaxService = function () {
	  function TaxService() {
	    (0, _classCallCheck3.default)(this, TaxService);
	
	    this.taxes = null;
	  }
	
	  (0, _createClass3.default)(TaxService, [{
	    key: 'hydrate',
	    value: function hydrate(tax) {
	      return new _taxEntity2.default(tax.id, tax.attributes.percent, tax.attributes.standard);
	    }
	  }, {
	    key: 'hydrateCollection',
	    value: function hydrateCollection(data) {
	      var taxes = [];
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var tax = _step.value;
	
	          taxes.push(this.hydrate(tax));
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return taxes;
	    }
	  }, {
	    key: 'get',
	    value: function get() {
	      var _this = this;
	
	      if (this.taxes) {
	        return _promise2.default.resolve(this.taxes);
	      }
	
	      return _axios2.default.get('backend://taxes').then(function (response) {
	        _this.taxes = _this.hydrateCollection(response.data.data);
	        return _this.taxes;
	      });
	    }
	  }]);
	  return TaxService;
	}();
	
	exports.default = new TaxService();

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 14/06/16.
	 */
	
	var TaxkeyEntity = function TaxkeyEntity(id, active, taxkeyName, taxkeyValue, taxAmount, payrollTax, fee, feeExpress, feeDiscount) {
	  (0, _classCallCheck3.default)(this, TaxkeyEntity);
	
	  this.id = id;
	  this.active = active;
	  this.taxkeyName = taxkeyName;
	  this.taxkeyValue = taxkeyValue;
	  this.taxAmount = taxAmount;
	  this.payrollTax = payrollTax;
	  this.fee = fee;
	  this.feeExpress = feeExpress;
	  this.feeDiscount = feeDiscount;
	};
	
	exports.default = TaxkeyEntity;

/***/ },
/* 798 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var itpAgeThresholdLower = 25;
	var itpAgeThresholdUpper = 65;
	var itpRateDefault = 0.045;
	
	exports.default = {
	  itpAgeThresholdLower: itpAgeThresholdLower,
	  itpAgeThresholdUpper: itpAgeThresholdUpper,
	  itpRateDefault: itpRateDefault
	};

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 12/04/16.
	 */
	
	var UserEntity = function () {
	  function UserEntity(id, accountClearingNr, accountNr, apiConsumerId, autogen, bankgiro, cellphone, co, companyName, createdAt, defaultTaxkeyId, email, emailConfirmed, firstName, foreclosure, lastLogin, lastName, loyaltyPoints, postgiro, professionTitle, professionId, role, showRegInvoicePage, socialSecurityNr, telephone, userIdOwner, verifyPassword, addedlatest, bic, receiveEmailNotifications, iban, imageSrc, itp, lang, preferredPaymentTypeID, showNameInNetwork, displayHsd, receiveSmsNotifications, vacationPay, vacationPayGross, internationalAccount, canChangeItp, saveITP, itpRate, saveVacationPay, address, bank) {
	    (0, _classCallCheck3.default)(this, UserEntity);
	
	    this.id = id;
	
	    // Attributes
	    this.accountClearingNr = accountClearingNr;
	    this.accountNr = accountNr;
	    this.apiConsumerId = apiConsumerId;
	    this.autogen = autogen;
	    this.bankgiro = bankgiro;
	    this.cellphone = cellphone;
	    this.co = co;
	    this.companyName = companyName;
	    this.createdAt = createdAt;
	    this.defaultTaxkeyId = defaultTaxkeyId;
	    this.email = email;
	    this.emailConfirmed = emailConfirmed;
	    this.firstName = firstName;
	    this.foreclosure = foreclosure;
	    this.lastLogin = lastLogin;
	    this.lastName = lastName;
	    this.loyaltyPoints = loyaltyPoints;
	    this.postgiro = postgiro;
	    this.professionTitle = professionTitle;
	    this.professionId = professionId;
	    this.role = role;
	    this.showRegInvoicePage = showRegInvoicePage;
	    this.socialSecurityNr = socialSecurityNr;
	    this.telephone = telephone;
	    this.userIdOwner = userIdOwner;
	    this.verifyPassword = verifyPassword;
	    this.address = address;
	    this.imageSrc = imageSrc;
	
	    // Extended
	    this.addedlatest = addedlatest;
	    this.bic = bic !== null ? bic : '';
	    this.receiveEmailNotifications = receiveEmailNotifications;
	    this.iban = iban !== null ? iban : '';
	    this.itp = itp;
	    this.lang = lang;
	    this.preferredPaymentTypeID = preferredPaymentTypeID;
	    this.showNameInNetwork = showNameInNetwork;
	    this.displayHsd = displayHsd;
	    this.receiveSmsNotifications = receiveSmsNotifications;
	    this.vacationPay = vacationPay;
	    this.vacationPayGross = vacationPayGross;
	    this.internationalAccount = internationalAccount !== null ? internationalAccount : 'off';
	    this.canChangeItp = canChangeItp;
	    this.saveITP = saveITP;
	    this.itpRate = itpRate;
	    this.saveVacationPay = saveVacationPay;
	    this.bank = bank;
	
	    this.calcKey = 1; // defaultTaxkeyId but we have no option yet
	  }
	
	  (0, _createClass3.default)(UserEntity, [{
	    key: 'fullName',
	    get: function get() {
	      return this.firstName + ' ' + this.lastName;
	    }
	  }]);
	  return UserEntity;
	}();
	
	exports.default = UserEntity;

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(72);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getIterator2 = __webpack_require__(18);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(17);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _userEntity = __webpack_require__(799);
	
	var _userEntity2 = _interopRequireDefault(_userEntity);
	
	var _addressEntity = __webpack_require__(217);
	
	var _addressEntity2 = _interopRequireDefault(_addressEntity);
	
	var _store = __webpack_require__(92);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _index = __webpack_require__(164);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _localStorageStore = __webpack_require__(352);
	
	var _cookieUtils = __webpack_require__(89);
	
	var _cookieUtils2 = _interopRequireDefault(_cookieUtils);
	
	var _pendingRequestEntity = __webpack_require__(42);
	
	var _pendingRequestEntity2 = _interopRequireDefault(_pendingRequestEntity);
	
	var _ravenJs = __webpack_require__(287);
	
	var _ravenJs2 = _interopRequireDefault(_ravenJs);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _index2 = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 05/04/16.
	 */
	
	var UserService = function () {
	  function UserService() {
	    (0, _classCallCheck3.default)(this, UserService);
	
	    this.currentUser = null;
	    this.store = new _localStorageStore.LocalStorageStore();
	  }
	
	  (0, _createClass3.default)(UserService, [{
	    key: 'hydrate',
	    value: function hydrate(user) {
	      var attr = user.data.attributes;
	
	      _ravenJs2.default.setUserContext({
	        email: attr.email,
	        id: user.data.id
	      });
	
	      return new _userEntity2.default(user.data.id, attr.account_clearing_number, attr.account_number, attr.api_consumer_id, attr.autogen, attr.bankgiro, attr.cellphone, attr.co, attr.company_name, attr.created_at, attr.default_taxkey_id, attr.email, attr.email_confirmed, attr.first_name, attr.foreclosure, attr.last_login, attr.last_name, attr.loyalty_points, attr.postgiro, attr.profession_title, attr.profession_id, attr.role, attr.show_reg_invoice_page, attr.social_security_number, attr.telephone, attr.user_id_owner, attr.verify_password, attr.addedlatest, attr.bic, attr.receive_email_notifications, attr.iban, attr.image_src, attr.itp, attr.lang, attr.preferred_payment_type_id, attr.show_name_in_network, attr.display_rotrut, attr.receive_sms_notifications, attr.vacationpay, attr.vacationpay_gross, attr.international_account, attr.can_change_itp, attr.save_itp, attr.itp_rate, attr.save_vacation_pay, new _addressEntity2.default(attr.city, attr.co, attr.country, attr.street, attr.zip), attr.bank);
	    }
	  }, {
	    key: 'extractParams',
	    value: function extractParams(params) {
	      return {
	        data: {
	          attributes: {
	            first_name: params.firstName,
	            last_name: params.lastName,
	            email: params.email,
	            cellphone: params.cellphone,
	            password: params.password,
	            social_security_number: params.identityNumber
	          }
	        }
	      };
	    }
	  }, {
	    key: 'post',
	    value: function post(params) {
	      return _axios2.default.request({
	        url: 'backend://users?url=' + location.origin + '/activate-account',
	        method: 'POST',
	        data: this.extractParams(params)
	      });
	    }
	  }, {
	    key: 'getError',
	    value: function getError(error) {
	      var response = error.response;
	
	      if (response && response.status === 422) {
	        var errorMessages = [];
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(error.response.data.errors), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var _error = _step.value;
	
	            if (_error.detail.hasOwnProperty('first_name') && _error.detail.first_name === 'iso20022text') {
	              errorMessages.push((0, _proxyCounterpart.proxyCounterpart)('FIRST_NAME_ERROR_INVALID_CHARACTERS'));
	            }
	            if (_error.detail.hasOwnProperty('last_name') && _error.detail.last_name === 'iso20022text') {
	              errorMessages.push((0, _proxyCounterpart.proxyCounterpart)('LAST_NAME_ERROR_INVALID_CHARACTERS'));
	            }
	            if (_error.detail.hasOwnProperty('errors')) {
	              if (_error.detail.errors.hasOwnProperty('account_number') && _error.detail.errors.account_number === 'accountnumber:account_clearing_number') {
	                errorMessages.push((0, _proxyCounterpart.proxyCounterpart)('ACCOUNT_CLEARING_NUMBER_ERROR'));
	              }
	              if (_error.detail.errors.hasOwnProperty('iban')) {
	                errorMessages.push((0, _proxyCounterpart.proxyCounterpart)('IBAN_ERROR'));
	              }
	              if (_error.detail.errors.hasOwnProperty('bic')) {
	                errorMessages.push((0, _proxyCounterpart.proxyCounterpart)('BIC_ERROR'));
	              }
	              if (_error.detail.errors.hasOwnProperty('cellphone')) {
	                errorMessages.push((0, _proxyCounterpart.proxyCounterpart)('TELEPHONE_ERROR'));
	              }
	              if (_error.detail.errors.hasOwnProperty('email') && (_error.detail.errors.email === 'uniq:user' || _error.detail.errors.email === 'uniqperclientorapiconsumer:user')) {
	                errorMessages.push((0, _proxyCounterpart.proxyCounterpart)('EMAIL_ALREADY_REGISTERED'));
	              }
	              if (_error.detail.errors.hasOwnProperty('social_security_number') && _error.detail.errors.social_security_number === 'uniqwith:user,primary_account,1') {
	                errorMessages.push((0, _proxyCounterpart.proxyCounterpart)('SSNR_ALREADY_REGISTERED'));
	              }
	            }
	            if (_error.detail.hasOwnProperty('current_password') && _error.detail.current_password[0] === 'Wrong password') {
	              errorMessages.push((0, _proxyCounterpart.proxyCounterpart)('CURRENT_PASSWORD_ERROR'));
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        if (errorMessages.length > 0) {
	          return errorMessages;
	        }
	      }
	
	      return false;
	    }
	  }, {
	    key: 'hasErrorFor',
	    value: function hasErrorFor(attribute, error) {
	      var response = error.response;
	
	      if (response && response.status === 422) {
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = (0, _getIterator3.default)(response.data.errors), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var _error2 = _step2.value;
	
	            if (_error2.detail.hasOwnProperty('errors')) {
	              if (_error2.detail.errors.hasOwnProperty(attribute)) {
	                return true;
	              }
	            }
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	      }
	
	      return false;
	    }
	  }, {
	    key: 'getParams',
	    value: function getParams(params) {
	      var obj = {};
	
	      if (params.firstName) {
	        obj.first_name = params.firstName;
	      }
	      if (params.lastName) {
	        obj.last_name = params.lastName;
	      }
	      if (params.cellphone) {
	        obj.cellphone = params.cellphone;
	      }
	      if (params.email) {
	        obj.email = params.email;
	      }
	      if (params.street) {
	        obj.street = params.street;
	      }
	      if (params.hasOwnProperty('co')) {
	        obj.co = params.co;
	      }
	      if (params.city) {
	        obj.city = params.city;
	      }
	      if (params.zip) {
	        obj.zip = params.zip;
	      }
	      if (params.country) {
	        obj.country = params.country;
	      }
	      if (params.bank) {
	        obj.bank = params.bank;
	      }
	      if (params.bic) {
	        obj.bic = params.bic;
	      }
	      if (params.iban) {
	        obj.iban = params.iban;
	      }
	      if (params.internationalAccount) {
	        obj.international_account = params.internationalAccount;
	      }
	      if (params.accountClearingNr) {
	        obj.account_clearing_number = params.accountClearingNr;
	      }
	      if (params.socialSecurityNr) {
	        obj.social_security_number = params.socialSecurityNr;
	      }
	      if (params.accountNr) {
	        obj.account_number = params.accountNr;
	      }
	      if (params.defaultTaxkeyId) {
	        obj.default_taxkey_id = params.defaultTaxkeyId;
	      }
	      if (params.hasOwnProperty('displayHsd')) {
	        obj.display_rotrut = params.displayHsd;
	      }
	      if (params.professionId) {
	        obj.profession_id = params.professionId;
	      }
	      if (params.hasOwnProperty('saveITP')) {
	        obj.save_itp = params.saveITP;
	      }
	      if (params.hasOwnProperty('itpRate')) {
	        obj.itp_rate = parseFloat(params.itpRate);
	      }
	      if (params.hasOwnProperty('saveVacationPay')) {
	        obj.save_vacation_pay = params.saveVacationPay;
	      }
	      if (params.hasOwnProperty('loyaltyPoints')) {
	        obj.loyalty_points = params.loyaltyPoints;
	      }
	      if (params.password) {
	        obj.password = params.password;
	      }
	      if (params.currentPassword) {
	        obj.current_password = params.currentPassword;
	      }
	      if (params.hasOwnProperty('receiveSmsNotifications')) {
	        obj.receive_sms_notifications = params.receiveSmsNotifications;
	      }
	      if (params.hasOwnProperty('receiveEmailNotifications')) {
	        obj.receive_email_notifications = params.receiveEmailNotifications;
	      }
	
	      return {
	        data: {
	          attributes: obj
	        }
	      };
	    }
	  }, {
	    key: 'update',
	    value: function update(params) {
	      var _this = this;
	
	      return _axios2.default.patch('backend://me', this.getParams(params)).then(function (response) {
	        var user = _this.hydrate(response.data);
	        _store2.default.dispatch((0, _index.setUser)(user));
	        _cookieUtils2.default.setNameCookie(user.fullName);
	        return user;
	      });
	    }
	  }, {
	    key: 'updateSsnr',
	    value: function updateSsnr(params) {
	      var _this2 = this;
	
	      return _axios2.default.patch('backend://me', this.getParams(params)).then(function (response) {
	        var user = _this2.hydrate(response.data);
	        _cookieUtils2.default.setNameCookie(user.fullName);
	        return user;
	      }).then(function (user) {
	        _frilansFinans.TaxkeyService.get(user.id);
	        return user;
	      }).then(function (user) {
	        _store2.default.dispatch((0, _index2.setLoggedInInvoiceUserTaxKeyId)(user.defaultTaxkeyId));
	        _store2.default.dispatch((0, _index.setUser)(user));
	        return user;
	      });
	    }
	  }, {
	    key: 'get',
	    value: function get() {
	      if (this.currentUser) {
	        var pendingRequest = new _pendingRequestEntity2.default();
	        pendingRequest.promise = _promise2.default.resolve(this.currentUser);
	        return pendingRequest;
	      } else {
	        return this.fetchUser();
	      }
	    }
	  }, {
	    key: 'fetchUser',
	    value: function fetchUser() {
	      var _this3 = this;
	
	      var oauth = this.store.getOauth();
	
	      var pendingRequest = new _pendingRequestEntity2.default();
	
	      if (oauth) {
	        pendingRequest.promise = _axios2.default.get('backend://me', {
	          cancelToken: new _axios2.default.CancelToken(function executor(c) {
	            pendingRequest.cancel = c;
	          })
	        }).then(function (response) {
	          _this3.currentUser = _this3.hydrate(response.data);
	          _store2.default.dispatch((0, _index.setUser)(_this3.currentUser));
	          _cookieUtils2.default.setNameCookie(_this3.currentUser.fullName);
	
	          return _this3.currentUser;
	        });
	
	        return pendingRequest;
	      }
	      pendingRequest.promise = _promise2.default.reject();
	      return pendingRequest;
	    }
	  }, {
	    key: 'clearUser',
	    value: function clearUser() {
	      this.currentUser = null;
	      _ravenJs2.default.setUserContext();
	    }
	  }, {
	    key: 'resetPassword',
	    value: function resetPassword(email) {
	      return _axios2.default.post('backend://reset-password', {
	        data: {
	          attributes: {
	            email: email,
	            url: location.origin + '/set-new-password'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'changePassword',
	    value: function changePassword(id, token, password) {
	      return _axios2.default.post('backend://users/' + id + '/change-password', {
	        data: {
	          attributes: {
	            token: token,
	            password: password
	          }
	        }
	      });
	    }
	  }, {
	    key: 'activateAccount',
	    value: function activateAccount(id, token) {
	      return _axios2.default.get('backend://users/' + id + '/confirm-email/' + token, {
	        data: {
	          attributes: {
	            token: token
	          }
	        }
	      });
	    }
	  }, {
	    key: 'getHoursWorked',
	    value: function getHoursWorked(userId, from, to) {
	      return _axios2.default.get('backend://users/' + userId + '/hours-worked-sum?from_date=' + from + '&to_date=' + to);
	    }
	  }]);
	  return UserService;
	}();
	
	exports.default = new UserService();

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 16/06/16.
	 */
	
	var WorkerEntity = function WorkerEntity(id, accountClearingNumber, accountNumber, bic, cellphone, city, co, country, createdAt, defaultTaxkeyId, displayHsd, email, firstName, iban, internationalAccount, lastLogin, lastName, notificationLanguage, preferredPaymentTypeId, professionTitle, professionId, saveItp, itpRate, saveVacationPay, socialSecurityNumber, street, userIdOwner, zip) {
	  (0, _classCallCheck3.default)(this, WorkerEntity);
	
	  this.id = id;
	  this.accountClearingNumber = accountClearingNumber;
	  this.accountNumber = accountNumber;
	  this.bic = bic;
	  this.cellphone = cellphone;
	  this.city = city;
	  this.co = co;
	  this.country = country;
	  this.createdAt = createdAt;
	  this.defaultTaxkeyId = defaultTaxkeyId;
	  this.displayHsd = displayHsd;
	  this.email = email;
	  this.firstName = firstName;
	  this.fullNamePersonalCode = firstName + ' ' + lastName + ' (' + socialSecurityNumber + ')';
	  this.iban = iban;
	  this.internationalAccount = internationalAccount;
	  this.lastLogin = lastLogin;
	  this.lastName = lastName;
	  this.notificationLanguage = notificationLanguage;
	  this.preferredPaymentTypeId = preferredPaymentTypeId;
	  this.professionTitle = professionTitle;
	  this.professionId = professionId;
	  this.saveItp = saveItp;
	  this.itpRate = itpRate;
	  this.saveVacationPay = saveVacationPay;
	  this.socialSecurityNumber = socialSecurityNumber;
	  this.street = street;
	  this.userIdOwner = userIdOwner;
	  this.zip = zip;
	};
	
	exports.default = WorkerEntity;

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(18);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(17);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _workerEntity = __webpack_require__(801);
	
	var _workerEntity2 = _interopRequireDefault(_workerEntity);
	
	var _http = __webpack_require__(71);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 16/06/16.
	 */
	
	var WorkerService = function () {
	  function WorkerService() {
	    (0, _classCallCheck3.default)(this, WorkerService);
	  }
	
	  (0, _createClass3.default)(WorkerService, [{
	    key: 'hydrate',
	    value: function hydrate(worker) {
	      var attr = worker.attributes;
	
	      return new _workerEntity2.default(worker.id, attr.account_clearing_number, attr.account_number, attr.bic, attr.cellphone, attr.city, attr.co, attr.country, attr.created_at, attr.default_taxkey_id, attr.display_hsd, attr.email, attr.first_name, attr.iban, attr.international_account, attr.last_login, attr.last_name, attr.notification_language, attr.preferred_payment_type_id, attr.profession_title, attr.profession_id, attr.save_itp, attr.itp_rate, attr.save_vacation_pay, attr.social_security_number, attr.street, attr.user_id_owner, attr.zip);
	    }
	  }, {
	    key: 'hydrateCollection',
	    value: function hydrateCollection(data) {
	      var workers = [];
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var worker = _step.value;
	
	          workers.push(this.hydrate(worker));
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return workers;
	    }
	  }, {
	    key: 'getError',
	    value: function getError(error) {
	      var status = (error.response || { status: 200 }).status;
	      if (status === 422) {
	        var errorMessages = [];
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = (0, _getIterator3.default)(error.response.data.errors), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var _error = _step2.value;
	
	            if (_error.detail.hasOwnProperty('errors')) {
	              if (_error.detail.errors.hasOwnProperty('social_security_number')) {
	                errorMessages.push((0, _proxyCounterpart.proxyCounterpart)('PERSONAL_NUMBER_ERROR_BACKEND'));
	              }
	              if (_error.detail.errors.hasOwnProperty('cellphone')) {
	                errorMessages.push((0, _proxyCounterpart.proxyCounterpart)('VALIDATION_CELLPHONE_PHONENUMBER'));
	              }
	            }
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	
	        if (errorMessages.length > 0) {
	          return errorMessages;
	        }
	      }
	
	      return false;
	    }
	  }, {
	    key: 'extractParams',
	    value: function extractParams(params) {
	      return {
	        data: {
	          attributes: {
	            first_name: params.firstName,
	            last_name: params.lastName,
	            cellphone: params.cellphone,
	            street: params.street,
	            city: params.city,
	            zip: params.zip,
	            social_security_number: params.socialSecurityNumber,
	            profession_title: params.professionTitle,
	            profession_id: params.professionId,
	            account_clearing_number: params.accountClearingNumber,
	            account_number: params.accountNumber,
	            email: params.email,
	            country: params.country,
	            international_account: params.internationalAccount,
	            bic: params.bic,
	            iban: params.iban
	          }
	        }
	      };
	    }
	  }, {
	    key: 'post',
	    value: function post(params) {
	      var data = this.extractParams(params);
	
	      return _axios2.default.request({
	        url: 'backend://workers',
	        method: 'POST',
	        data: data
	      });
	    }
	  }, {
	    key: 'get',
	    value: function get() {
	      var _this = this;
	
	      return _axios2.default.get('backend://workers', { params: {
	          'page[number]': 1,
	          'page[size]': 25,
	          'sort': 'first_name'
	        } }).then(function (response) {
	        var workers = _this.hydrateCollection(response.data.data);
	        return new _http.APIResult(workers, response.data.meta);
	      });
	    }
	  }, {
	    key: 'getWorker',
	    value: function getWorker(id) {
	      var _this2 = this;
	
	      return _axios2.default.get('backend://workers/' + id).then(function (response) {
	        var worker = _this2.hydrateCollection([response.data.data]);
	        return worker;
	      });
	    }
	  }, {
	    key: 'searchByLastName',
	    value: function searchByLastName(name) {
	      var _this3 = this;
	
	      return _axios2.default.get('backend://workers', { params: {
	          'page[size]': 100,
	          'sort': 'first_name',
	          'filter[last_name][^]': name
	        } }).then(function (response) {
	        var workers = _this3.hydrateCollection(response.data.data);
	        return new _http.APIResult(workers, response.data.meta);
	      });
	    }
	  }]);
	  return WorkerService;
	}();
	
	exports.default = new WorkerService();

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WorkingEnvironmentPageEntity = function WorkingEnvironmentPageEntity(id, title, ingress, text, sections, image, letterbutton, letterbox) {
	  (0, _classCallCheck3.default)(this, WorkingEnvironmentPageEntity);
	
	  this.id = id;
	  this.title = title;
	  this.ingress = ingress;
	  this.text = text;
	  this.sections = sections;
	  this.image = image;
	  this.letterbutton = letterbutton;
	  this.letterbox = letterbox;
	};
	
	exports.default = WorkingEnvironmentPageEntity;

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(17);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _workingEnvironmentPageEntity = __webpack_require__(803);
	
	var _workingEnvironmentPageEntity2 = _interopRequireDefault(_workingEnvironmentPageEntity);
	
	var _pendingRequestEntity = __webpack_require__(42);
	
	var _pendingRequestEntity2 = _interopRequireDefault(_pendingRequestEntity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WorkingEnvironmentPageService = function () {
	  function WorkingEnvironmentPageService() {
	    (0, _classCallCheck3.default)(this, WorkingEnvironmentPageService);
	  }
	
	  (0, _createClass3.default)(WorkingEnvironmentPageService, [{
	    key: 'hydrate',
	    value: function hydrate(data) {
	      return new _workingEnvironmentPageEntity2.default(data.id, data.title.rendered, data.acf.insurances_ingress, data.acf.insurances_text, data.acf.insurances_sections, data.acf.insurances_image.url, data.acf.insurances_letter_button, data.acf.insurances_letter_box);
	    }
	  }, {
	    key: 'get',
	    value: function get(pageID) {
	      var _this = this;
	
	      var pendingRequest = new _pendingRequestEntity2.default();
	
	      pendingRequest.promise = _axios2.default.get('https://www.frilansfinans.se/wp-json/wp/v2/pages/' + pageID, {
	        cancelToken: new _axios2.default.CancelToken(function executor(c) {
	          pendingRequest.cancel = c;
	        })
	      }).then(function (response) {
	        return _this.hydrate(response.data);
	      });
	
	      return pendingRequest;
	    }
	  }]);
	  return WorkingEnvironmentPageService;
	}();
	
	exports.default = new WorkingEnvironmentPageService();

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loginFailure = loginFailure;
	exports.loginSuccess = loginSuccess;
	exports.logout = logout;
	
	var _constants = __webpack_require__(812);
	
	var types = _interopRequireWildcard(_constants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function loginFailure() {
	  return {
	    type: types.LOGIN_FAILURE,
	    isError: true
	  };
	}
	
	function loginSuccess() {
	  return {
	    type: types.LOGIN_SUCCESS
	  };
	}
	
	function logout() {
	  return {
	    type: types.LOGOUT
	  };
	}

/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _context = __webpack_require__(222);
	
	var _context2 = _interopRequireDefault(_context);
	
	var _events = __webpack_require__(447);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var App = function (_EventEmitter) {
	  (0, _inherits3.default)(App, _EventEmitter);
	
	  function App() {
	    (0, _classCallCheck3.default)(this, App);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (App.__proto__ || (0, _getPrototypeOf2.default)(App)).call(this));
	
	    _this.initialized = false;
	    return _this;
	  }
	
	  (0, _createClass3.default)(App, [{
	    key: 'isInitialized',
	    value: function isInitialized() {
	      return this.initialized;
	    }
	  }, {
	    key: 'init',
	    value: function init(options) {
	      options = options || {};
	
	      if (this.isInitialized()) {
	        throw new Error('InteractiveSolutions authentication has already been initialized');
	      }
	
	      this.initialized = true;
	
	      _context2.default.store = options.store;
	      _context2.default.endpoints = options.endpoints || {};
	
	      this.emit('ready');
	    }
	  }]);
	  return App;
	}(_events.EventEmitter);
	
	exports.default = new App();

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(12);
	
	var _authenticated = __webpack_require__(808);
	
	var _authenticated2 = _interopRequireDefault(_authenticated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    user: state.user
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(_authenticated2.default);

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _authentication = __webpack_require__(90);
	
	var _authentication2 = _interopRequireDefault(_authentication);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Authenticated = function (_Component) {
	  (0, _inherits3.default)(Authenticated, _Component);
	
	  function Authenticated() {
	    (0, _classCallCheck3.default)(this, Authenticated);
	    return (0, _possibleConstructorReturn3.default)(this, (Authenticated.__proto__ || (0, _getPrototypeOf2.default)(Authenticated)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Authenticated, [{
	    key: 'render',
	    value: function render() {
	      if (_authentication2.default.isAuthenticated) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'authenticated' },
	          this.props.children
	        );
	      }
	
	      return null;
	    }
	  }]);
	  return Authenticated;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)()(Authenticated);

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _context = __webpack_require__(222);
	
	var _context2 = _interopRequireDefault(_context);
	
	var _authentication = __webpack_require__(90);
	
	var _authentication2 = _interopRequireDefault(_authentication);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(20);
	
	var _variables = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LogoutLink = function (_Component) {
	  (0, _inherits3.default)(LogoutLink, _Component);
	
	  function LogoutLink() {
	    (0, _classCallCheck3.default)(this, LogoutLink);
	    return (0, _possibleConstructorReturn3.default)(this, (LogoutLink.__proto__ || (0, _getPrototypeOf2.default)(LogoutLink)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LogoutLink, [{
	    key: 'onClick',
	    value: function onClick() {
	      _authentication2.default.logout();
	      window.location = _variables.frontUrl;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var classes = this.props.classes;
	
	      return _react2.default.createElement(
	        _reactRouter.Link,
	        { className: classes, to: _context2.default.routes.login, onClick: this.onClick },
	        this.props.children
	      );
	    }
	  }]);
	  return LogoutLink;
	}(_react.Component);
	
	exports.default = LogoutLink;

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(12);
	
	var _notAuthenticated = __webpack_require__(811);
	
	var _notAuthenticated2 = _interopRequireDefault(_notAuthenticated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    user: state.user
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(_notAuthenticated2.default);

/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _authentication = __webpack_require__(90);
	
	var _authentication2 = _interopRequireDefault(_authentication);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotAuthenticated = function (_Component) {
	  (0, _inherits3.default)(NotAuthenticated, _Component);
	
	  function NotAuthenticated() {
	    (0, _classCallCheck3.default)(this, NotAuthenticated);
	    return (0, _possibleConstructorReturn3.default)(this, (NotAuthenticated.__proto__ || (0, _getPrototypeOf2.default)(NotAuthenticated)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(NotAuthenticated, [{
	    key: 'render',
	    value: function render() {
	      if (!_authentication2.default.isAuthenticated) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'not-authenticated' },
	          this.props.children
	        );
	      }
	
	      return null;
	    }
	  }]);
	  return NotAuthenticated;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)()(NotAuthenticated);

/***/ },
/* 812 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Created by staffanrantzow on 17/03/16.
	 */
	
	var LOGIN_FAILURE = exports.LOGIN_FAILURE = 'auth:login:failure';
	var LOGIN_SUCCESS = exports.LOGIN_SUCCESS = 'auth:login:success';
	var LOGOUT = exports.LOGOUT = 'auth:logout';

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactRouter = __webpack_require__(20);
	
	var _authentication = __webpack_require__(90);
	
	var _authentication2 = _interopRequireDefault(_authentication);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuthenticatedRoute = function (_Route) {
	  (0, _inherits3.default)(AuthenticatedRoute, _Route);
	
	  function AuthenticatedRoute() {
	    (0, _classCallCheck3.default)(this, AuthenticatedRoute);
	    return (0, _possibleConstructorReturn3.default)(this, (AuthenticatedRoute.__proto__ || (0, _getPrototypeOf2.default)(AuthenticatedRoute)).apply(this, arguments));
	  }
	
	  return AuthenticatedRoute;
	}(_reactRouter.Route);
	
	AuthenticatedRoute.defaultProps = {
	  onEnter: function onEnter(nextState, replace) {
	    if (_authentication2.default.isAuthenticated) {
	      return;
	    }
	
	    return replace('/login');
	  }
	};
	exports.default = AuthenticatedRoute;

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactRouter = __webpack_require__(20);
	
	var _authentication = __webpack_require__(90);
	
	var _authentication2 = _interopRequireDefault(_authentication);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UnauthenticatedRoute = function (_Route) {
	  (0, _inherits3.default)(UnauthenticatedRoute, _Route);
	
	  function UnauthenticatedRoute() {
	    (0, _classCallCheck3.default)(this, UnauthenticatedRoute);
	    return (0, _possibleConstructorReturn3.default)(this, (UnauthenticatedRoute.__proto__ || (0, _getPrototypeOf2.default)(UnauthenticatedRoute)).apply(this, arguments));
	  }
	
	  return UnauthenticatedRoute;
	}(_reactRouter.Route);
	
	UnauthenticatedRoute.defaultProps = {
	  onEnter: function onEnter(nextState, replace) {
	    if (!_authentication2.default.isAuthenticated) {
	      return;
	    }
	
	    return replace('/activities');
	  }
	};
	exports.default = UnauthenticatedRoute;

/***/ },
/* 815 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/* eslint-disable */exports.default = {
	    "hello": "Hello",
	    "name": "Name",
	    "invoice": "Invoice",
	    "que": "what",
	    "one": "one",
	    "LOGIN": "Login",
	    "LOGOUT": "Logout",
	    "CREATE_INVOICE": "Create invoice",
	    "MENU": "Menu",
	    "MY_PAGES": "Menu",
	    "ACTIVITIES": "Home",
	    "ECONOMY": "Economy",
	    "CREATE_NEW_INVOICE": "Create invoice",
	    "CREATE_NEW_TENDER": "Create tender",
	    "CREATE_CONTRACT": "Write a contract",
	    "CURRENT_ERRANDS": "Your current invoices",
	    "CURRENT_ERRANDS_SHOW_MORE": "Show all invoices",
	    "ERRAND_TABLE_NO_INVOICES": "No invoices to show",
	    "ERRAND_TABLE_ALL_INVOICES_ARE_LOADED": "All current invoices loaded",
	    "ERRAND_TABLE_TABLE_SHOW_MORE_INVOICES": "Show more",
	    "STATUS": "Status",
	    "IN_PROGRESS": "In progress",
	    "SALARY_PAYMENT": "Salary payment",
	    "INVOICE_PAYMENT": "Invoice payment",
	    "APPROVED": "Approved",
	    "NOT_APPROVED": "Not approved",
	    "APPROVED_WITH_RES": "Approved",
	    "CREATED_DATE": "Created %(date)s",
	    "DATE": "Date",
	    "DATE_ERROR": "You have to pick a date",
	    "EXPECTED_TO": "Expected to\n%(date)s",
	    "EXPIRES": "Expires\n%(date)s",
	    "PAID": "Paid\n%(date)s",
	    "INVOICE_PAID": "Paid\n%(date)s",
	    "ORDER_APPROVED": "Approved\n%(date)s",
	    "INOVICE_LAST_12": "Invoices the last 12 months",
	    "NO_INVOICES_LAST_12": "You have no invoices for the last 12 months",
	    "JAN": "Jan",
	    "FEB": "Feb",
	    "MAR": "Mar",
	    "APR": "Apr",
	    "MAY": "May",
	    "JUN": "Jun",
	    "JUL": "Jul",
	    "AUG": "Aug",
	    "SEP": "Sep",
	    "OCT": "Oct",
	    "NOV": "Nov",
	    "DEC": "Dec",
	    "YEARS": "years",
	    "PENSION_VACATION": "Pension and vacation",
	    "CHANGE": "Change settings",
	    "SAVED_VACATION": "Saved vacation",
	    "SAVED_PENSION": "Saved pension",
	    "NEWS": "News",
	    "INFORMATION": "Information",
	    "FAQ": "Common questions",
	    "SUPPORT": "Support",
	    "CONTACT": "Contact",
	    "INSURANCES": "Insurances",
	    "WORKING_ENVIRONMENT": "Good working conditions",
	    "CHECK_YOUR_WORK_ENVIRONMENT": "Check your work environment",
	    "CHECK_YOUR_WORK_ENVIRONMENT_URL": "https://www.frilansfinans.se/wp-content/uploads/2022/05/Frilans-Finans-Checklista-allman-2022.pdf",
	    "REPORT_ACCIDENT": "Report an accident",
	    "REPORT_ACCIDENT_LINK": "https://www.frilansfinans.se/wp-content/uploads/2022/09/N-9.1-A-Blankett-for-rapporteri-ng-av-olycka-eller-tillbud-v1.4.pdf",
	    "PRIVACY_POLICY": "Privacy Policy",
	    "SOCIAL_MEDIAS": "Social medias",
	    "FACEBOOK": "Facebook",
	    "TWITTER": "Twitter",
	    "LINKEDIN": "LinkedIn",
	    "INSTAGRAM": "Instagram",
	    "CREATE_ACCOUNT": "Create account",
	    "CREATE_ACCOUNT_SUCCESS_MSG": "Your account have been created. We have sent you an email with instructions on how to activate your account.",
	    "COOKIE_INFO": "Information about cookies",
	    "PERSONAL_ADMIN": "Your personal administrator is",
	    "SWEDEN": "Sweden",
	    "NORWAY": "Norway",
	    "DENMARK": "Denmark",
	    "YOUR_INVOICES": "Your invoices",
	    "YOUR_INVOICES_TEXT": "Here you will find all your invoices. You may view, download and print your invoices. Filter your search by chosing a period in the calendar below. Your invoice is shown within 24 hours after creation.",
	    "CUSTOMER": "Customer",
	    "CREATED": "Created",
	    "ORDER_NR": "Order nr.",
	    "SUM_EX_VAT": "Sum excl. VAT",
	    "INVOICE_STATUS": "Invoice status",
	    "INVOICE_PAY_SHORT": "Invoice Pay.",
	    "INVOICE_PAY": "Inovice payment",
	    "PRINT": "Print",
	    "PREREGISTERED_INVOICES": "Your preregistered invoices",
	    "PREREGISTERED": "Preregistered",
	    "PREREGISTERED_INVOICES_TABLE_SHOW_MORE_INVOICES": "Show more",
	    "PREREGISTERED_INVOICES_TABLE_ALL_INVOICES_ARE_LOADED": "All preregistered invoices loaded",
	    "PREREGISTERED_INVOICES_TABLE_NO_INVOICES": "No preregistered invoices",
	    "DATE_COMPARE_ERROR": "End date must be higher than start date",
	    "PAY_ID": "Pay ID",
	    "WORK_DATE": "Work date",
	    "WORK_DATE_VISIBILITY": "Show work date",
	    "WORK_DATE_SHOW_DATES": "Show date on invoice",
	    "WORK_DATE_SHOW_HOURS": "Show hours on invoice",
	    "PAY_SALARY": "Paid sum",
	    "YOUR_SALARIES": "Your salaries",
	    "YOUR_SALARIES_TEXT": "Here are all your payment slips for work carried out through Frilans Finans. Filter your search by chosing a period in the calendar.",
	    "FROM": "From",
	    "TO": "To",
	    "COPY": "Copy",
	    "INVOICES": "Invoices",
	    "SALARIES": "Salaries",
	    "EMPLOYER_CERTIFICATE": "Employer certificate",
	    "EMPLOYER_CERTIFICATE_TEXT": "Once your invoice has been approved you can order an employer certificate. An employer certificate may be needed when applying for unemployment benefits.",
	    "EMPLOYER_CERTIFICATE_CHOOSE_PERIOD": "1. Choose dates for the period",
	    "EMPLOYER_CERTIFICATE_ORDERING": "2. Delivery",
	    "EMPLOYER_CERTIFICATE_PERIOD_WORKDATES": "\nOrder an employer certificate for the selected period",
	    "EMPLOYER_CERTIFICATE_PERIOD_INVOICES": "\nOrder an employer certificate for individual invoices",
	    "EMPLOYER_CERTIFICATE_BY_AI_NU": "Send employer certificate via <a href=\"https://www.arbetsgivarintyg.nu\" target=\"_blank\">arbetsgivarintyg.nu</a> (possible if you are a member of an unemployment insurance fund)",
	    "EMPLOYER_CERTIFICATE_BY_MAIL": "Send employer certificate with mail (1-3 work days)",
	    "NO_EMPLOYER_CERTIFICATES": "You have no invoices for the specified period",
	    "EMP_CERT_SUCCESS": "Your employer certificate has been ordered! The certificate will be compiled and sent to you within a few days. If you have any questions, do not hesitate to contact Client support at info@frilansfinans.se or 0771-15 10 00.",
	    "GROSS_SALARY": "Gross salary",
	    "GROSS_SALARY_H": "Gross salary/h",
	    "ORDER_EMP_CERT": "Order employer certificate",
	    "CONTRACTS": "Contracts",
	    "YOUR_CONTRACTS": "Your contracts",
	    "CONTRACTS_YOU_CUST": "Contracts between you and the customer",
	    "YOUR_CONTRACTS_TEXT": "Here are various templates used when entering agreement with your customer.",
	    "CHOOSE_CONTRACT": "Choose contract",
	    "DOWNLOAD": "Download",
	    "CONTRACT_FF": "Contract with Frilans Finans",
	    "CONTRACT_FF_TEXT": "As self-employed, you enter a contract with Frilans Finans by approving the general terms and conditions of employment at the time of creating the invoice. Rights and obligations between you and Frilans Finans are regulated with this approval. Here is a summary of your agreements with Frilans Finans.",
	    "CONDITIONS": "Conditions",
	    "SHOW_MORE": "Show more",
	    "CONTRACT_SHORT_TERM": "Contract of short term employment",
	    "NO_CONTRACTS": "You have no agreements for the selected time period",
	    "GENERAL_TERMS": "General Terms and Conditions for Work",
	    "DEDUCTIONS": "Expenses",
	    "YOUR_DEDUCTIONS": "Your expenses",
	    "YOUR_DEDUCTIONS_TEXT": "Here are all the expenses made via invoices created through Frilans Finans.",
	    "ADD_DEDUCTION": "Add expenses",
	    "ADD_DEDUCTION_RECEIPT": "Add receipt",
	    "DEDUCTION_FILE_INFO": "Enter the costs you had in connection with your assignment. Please note that the expense amount is not automatically added to the invoice amount. Should your customer be responsible for the costs, add the receipt amount excluding VAT to the invoice amount. Enter the costs you had in connection with your assignment. Please note that the expense amount is not automatically added to the invoice amount. Should your customer be responsible for the costs, add the receipt amount excluding VAT to the invoice amount. Please attach receipts for amounts lower than 2000 SEK incl. VAT below, if you do not have the possibility to add the receipts below you can send them by email to avdrag@frilansfinans.se. Receipts over 2000 SEK incl. VAT is sent to Frilans Finans AB, Dag Hammarskjölds Väg 13, 752 37 Uppsala. Remember to save the original receipts for at least 3 years if you send us copies of the receipts. ",
	    "DEDUCTION_FILE_CONFIRMATION": "I confirm that I save physical receipts for at least 3 years",
	    "DEDUCTION_FILE_CONFIRMATION_ERROR": "To add the expense, you need to confirm saving of the receipt",
	    "EDIT_DEDUCTION": "Edit expenses",
	    "DEDUCTION_AMOUNT": "Expense amount",
	    "DEDUCTION_GUIDE": "Expense guide",
	    "DEDUCTION_GUIDE_LINK": "https://www.frilansfinans.se/wp-content/uploads/2023/07/Expense_guide_2023.pdf",
	    "PICK_DEDUCTION_CATEGORY": "Pick an expense category",
	    "DEDUCTION_CATEGORY": "Expense guide",
	    "DEDUCTION_CATEGORY_ERROR": "You have to pick an expense category",
	    "TO_DE_GUIDE": "To the expense guide",
	    "CLEAR": "Clear",
	    "CATEGORY": "Category",
	    "LEV_ID": "Lev id",
	    "SUPPLIER": "Supplier",
	    "SUPPLIER_ERROR": "You have to enter a supplier",
	    "ARRIVED": "Arrived",
	    "SUM": "Sum",
	    "PAID_DATE": "Date paid",
	    "PREREGISTER_INVOICE": "Preregister invoice",
	    "PREREGISTER_INVOICE_TEXT": "When applying for unemployment insurance funds you need to report to Frilans Finans when, where and with which customer you are to work before the work is carried out. Preregister your work by clicking 'Preregister invoice' down below and then select 'Preregister / Save Draft'",
	    "CONTROL_STATEMENT": "Income statements",
	    "YOUR_CONTROL_STATEMENT": "Your statements",
	    "YOUR_CONTROL_STATEMENT_TEXT": "Here are your income statements we have sent to the Swedish Tax Agency which are declared in your annual tax return.",
	    "NO_STATEMENTS": "You have no available income statements",
	    "CHOOSE_INCOME_YEAR": "Choose year of income",
	    "INSURANCES_HEADING": "Frilans Finans Basic Insurance is always included for free",
	    "INSURANCES_TEXT_1": "When working through Frilans Finans as self-employed you are covered by a strong insurance package consisting of accident- and life insurance (equal to union level insurance). You are also covered by a liability insurance to protect you if an accident should occur. Please see links below for further information.",
	    "GROUP_INS": "Group Insurance Plan, Occupational Injury",
	    "INS_GROUP": "Terms and Conditions, Group Insurance Plan",
	    "INS_LETTER_ACC": "Insurance policy occupational injury",
	    "INS_ENT_MON": "Insurance policy entrepreneur and construction",
	    "INS_TECH": "Insurance policy technical consultant",
	    "INS_ADV": "Insurance policy advisory-/IT consultants",
	    "INS_RESP": "Insurance policy liability insurance",
	    "INS_RESP_ENG": "Insurance policy liability insurance in english",
	    "INS_TRAVEL_LETTER": "Travel insurance policy",
	    "INS_TRAVEL_ADV": "Travel insurance tips and advice",
	    "INS_TRAVEL_COND": "Travel insurance Terms and Conditions",
	    "INS_INFO": "Life insurance information",
	    "INS_COND": "Life insurance Terms and Condtitions",
	    "ITP_COND": "Occupational pension insurance Terms and Conditions",
	    "ITP": "Occupational pension insurance",
	    "ITP_RATE": "Occupational pension insurance",
	    "ITP_FLEXIBLE": "Flexible occupational pension insurance",
	    "ITP_FLEXIBLE_FAQ": "FAQ flexible occupational pension insurance",
	    "ITP_READ_MORE": "Read more",
	    "DAMAGE_REPORT_INS": "Insurance claim,  Occupational injury insurance",
	    "REGISTER_INS": "Insurance claim, Life insurance",
	    "FORGOT_PASSWORD": "Forgot password",
	    "RESET_PASSWORD": "Reset password",
	    "RESET_PASSWORD_TEXT": "Enter your e-mail adress you provided when creating your account. A link for password reset will be sent to the specified adress.",
	    "RESET_PASSWORD_SUCCESS": "We have sent instructions on how to reset your password to your mail.",
	    "EMAIL": "E-mail",
	    "EMAIL_BILLING": "Billing e-mail",
	    "EMAIL_BILLING_SECONDARY": "Secondary billing e-mail (optional)",
	    "REPEAT_EMAIL": "Repeat e-mail",
	    "EMAIL_NOT_EQUAL": "The emails are not the same",
	    "PASSWORD": "Password",
	    "FIRST_NAME": "First name",
	    "LAST_NAME": "Last name",
	    "MOBILE_PHONE": "Mobile phone",
	    "APPROVE_TERMS": "By creating an account I approve",
	    "FF_TERMS": "Frilans Finans terms and conditions",
	    "FF_TERMS_AND_PERSONAL_INFORMATION_BEING_TREATED": "I consent to the processing of my personal data in accordance with",
	    "MY_CUSTOMERS": "My customers",
	    "MY_CUSTOMERS_TEXT": "Here is the information of all your customers you have invoiced. You can edit your customers information below",
	    "ORG_NR": "Org. nr.",
	    "REF": "Reference",
	    "REF_ERROR": "A referense can be at most 30 characters long",
	    "ADDRESS": "Address",
	    "EDIT": "Edit",
	    "SETTINGS": "Settings",
	    "SETTINGS_TEXT": "Here you can change your personal information. You will find account details under 'Salary information' in the menu to the left.",
	    "PERSONAL_INFO": "Personal information",
	    "POSTAL_CODE": "Postal code",
	    "TELEPHONE_NR": "Telephone number",
	    "BANK_INFO": "Bank information",
	    "CLEAR_NR": "Clearing number",
	    "ACCOUNT_NR": "Account number",
	    "BANK": "Bank",
	    "EMPLOYMENT_INVOICE": "Invoice settings",
	    "PROFESSION": "Profession",
	    "CALC_KEY": "Tax percentage",
	    "ROT_RUT": "Rot- and Rut tax deduction",
	    "ACTIVATE_ROT_RUT": "Activate Rot- and Rut tax deduction",
	    "READ_MORE": "Read more",
	    "SAVE_TO_PENSION": "Save <a href=\"https://www.frilansfinans.se/fragor-och-svar/tjanstepension/\" target=\"_blank\">occupational pension</a> and <a href=\"https://www.frilansfinans.se/fragor-och-svar/semesterersattning/\" target=\"_blank\">holiday pay</a>",
	    "PENSION": "Occupational pension",
	    "VACATION_MONEY": "Holiday pay",
	    "VACATION_MONEY_READ_MORE": "Read more",
	    "USE_LOGO": "Use your own logotype",
	    "USE_LOGO_TEXT": "It is possible to use your own logotype for your invoices. The cost is 225 SEK/year",
	    "UPLOAD_LOGO": "Upload logotype",
	    "LOGO_INSTRUCTIONS": "Drop your logo here or click to upload logotype",
	    "LOGO_ERROR": "You can only upload a png or jpg and it cannot be larger than 2 MB ",
	    "CURRENT_PASSWORD": "Current password",
	    "CURRENT_PASSWORD_ERROR": "The current password is not correct",
	    "CHANGE_PASSWORD": "Change password",
	    "NEW_PASSWORD": "New password",
	    "REPEAT_PASSWORD": "Repeat password",
	    "PASSWORD_NOT_EQUAL": "The passwords are not the same",
	    "SAVE_SETTINGS": "Save settings",
	    "FIRST_NAME_ERROR": "You have to enter a first name with at least 2 characters",
	    "LAST_NAME_ERROR": "You have to enter a last name with at least 2 characters",
	    "EMAIL_ERROR": "Enter an email address",
	    "CITY": "City",
	    "CITY_ERROR": "You have to enter a city with at least 2 and up to 40 characters maximum",
	    "POSTAL_CODE_ERROR": "You have to enter a postal code",
	    "TELEPHONE_ERROR": "You have to enter a swedish phone number",
	    "PERSONAL_NUMBER": "Social security number",
	    "PERSONAL_NUMBER_ERROR": "You have to enter a social security number with 12 numbers",
	    "PERSONAL_NUMBER_ERROR_BACKEND": "Invalid social security number",
	    "ADDRESS_ERROR": "You have to enter an address with at least 3 and up to 50 characters maximum",
	    "CLEAR_NR_ERROR": "You have to enter a four digit clearing number. The fifth digit in the clearing number is not necessary",
	    "ACCOUNT_NR_ERROR": "You have to enter an account number with at least 1 digit",
	    "BANK_ERROR": "You have to enter a bank",
	    "PROFESSION_ERROR": "You have to enter a profession",
	    "CALC_KEY_ERROR": "You have to select a tax key",
	    "NO_SWEDISH_ACCOUNT": "I don't have a swedish bank account",
	    "IBAN": "IBAN",
	    "BIC": "BIC",
	    "IBAN_ERROR": "That is not a correct IBAN number",
	    "BIC_ERROR": "That is not a correct BIC number",
	    "EDIT_CUSTOMER": "Edit customer",
	    "NAME_ERROR": "You have to enter a name with at least 4 and up to 50 characters maximum",
	    "ORG_NR_ERROR": "You have to enter an organization number",
	    "CONTACT_ERROR": "The contact must have at least 4 characters",
	    "CONTACT_MAX_ERROR": "The contact must not be longer than 30 characters",
	    "CO": "C/O",
	    "CO_ERROR": "C/O must have at least 4 characters",
	    "COUNTRY": "Country",
	    "COUNTRY_ERROR": "You have to enter a country",
	    "BACK": "Back",
	    "SAVE": "Save",
	    "FF_TITLE": "Frilans Finans Sverige AB",
	    "GENERAL_ERROR": "Something went wrong. Please try again later.",
	    "LOGIN_NO_EMAIL": "You have to enter an email",
	    "LOGIN_NO_PASSWORD": "You have to enter a password",
	    "LOGIN_ERROR": "Wrong kombination of password and email",
	    "LOGIN_403_ERROR": "Unfortunately, you could not log in right now, please try again in a little while. \nStill not working? Try changing your password",
	    "NO_INVOICES": "You have no invoices for the selected period",
	    "NO_PRE_INVOICES": "You have no preregistered invoices",
	    "SEK_SHORT": "Kr",
	    "EURO_SHORT": "Euro",
	    "DOLLAR_SHORT": "$",
	    "SEK": "SEK",
	    "WITH_RES": "With res.",
	    "IS_PAID": "Paid",
	    "NOT_PAID": "Not paid",
	    "PART_PAID": "Part paid",
	    "WAIT_JUDGEMENT": "Waiting for approval",
	    "WAIT_PAYMENT": "Waiting for customer payment",
	    "NO_RESULTS_FOUND": "No results found",
	    "WELCOME_TEXT": "Hello %(date)s! What do you want to do today?",
	    "NO_CUSTOMERS": "You have no customers",
	    "NAME": "Name",
	    "CUSTOMER_UPDATED": "%(name)s is now updated",
	    "PRE_REG_DATE": "Preregistered date: %(date)s",
	    "INVOICE_PRE_REG": "Invoice preregistered",
	    "YES": "Yes",
	    "NO": "No",
	    "INVOICE_SPEC": "Specification",
	    "WORKER": "Worker",
	    "WORKER_PAY": "Worker pay information",
	    "PAY_DETAILS": "Salary details",
	    "SALARY_NET": "Salary net",
	    "TO_ACCOUNT": "To account number",
	    "SALARY_GROSS": "Salary gross",
	    "ALLOWANCE": "Allowance",
	    "TRAVEL_ALLOWANCE": "Mileage allowance ",
	    "TRAVEL_ALLOWANCE_REMEMBER": "(remember to fill in and save the ",
	    "TRAVEL_ALLOWANCE_REMEMBER_LINK_TEXT": "driving record template)",
	    "TRAVEL_ALLOWANCE_REMEMBER_LINK_URL": "https://www.frilansfinans.se/wp-content/uploads/2023/04/frilansfinans-driving-record-template.pdf",
	    "PART_OF_INVOICE": "Amount to be paid",
	    "NO_DEDUCTIONS": "You have no deductions for the selected period",
	    "SUMMARY": "Summary",
	    "INVOICE_AMOUNT": "Invoice amount excl. VAT",
	    "VAT": "VAT",
	    "SUM_INC_MOMS": "Sum inc. VAT",
	    "CURRENCY": "Currency",
	    "CURRENCY_RATE": "Currency rate",
	    "CURRENCY_VAL": "Currency value",
	    "ONGOING": "On going",
	    "NEW": "New",
	    "WAITING": "Waiting",
	    "CREDITED": "Credited",
	    "DISPUTE": "Disputed",
	    "INVOICE_NOT_CHECKED": "Invoice not verified",
	    "LEVRES": "Supplier post closed",
	    "INVOICE_NOT_CREATED": "Invoice not created",
	    "TO_PAYMENT": "To payment",
	    "PAID_FILE": "Paid by file",
	    "OLD_POST": "Old post, not paid",
	    "DOWNLOAD_AS_PDF": "Download as PDF and print",
	    "CLOSE": "Close",
	    "SETTINGS_UPDATED": "Your settings are updated",
	    "OWN_EMPLOYMENT": "Invoice setting",
	    "OWN_EMPLOYMENT_READ_MORE": "Read more",
	    "PASSWORD_LENGTH_ERROR": "The password must have at least 8 characters and must include a number and capital letter",
	    "CALCULATOR": "Calculator",
	    "CALCULATOR_TEXT": "Enter invoice amount or salary",
	    "AMOUNT_INVOICE": "Amount to invoice",
	    "AMOUNT_INVOICE_PLACEHOLDER": "Invoiced amount (excl. VAT)",
	    "AFTER_TAX": "after tax",
	    "SALARY_AFTER_TAX": "Salary after tax",
	    "ADV_CALC": "Show advanced calculation",
	    "HIDE_ADV_CALC": "Hide advanced calculation",
	    "SAVE_PENSION": "Save pension 4.5 %",
	    "SAVE_VACATION": "Save holiday pay 12 %",
	    "TRAVEL_ALLOWANCE_SEK": "Expense allowance SEK",
	    "TRAVEL_FEE_SEK": "Mileage allowance SEK",
	    "HOW_CALC": "See our calculation",
	    "HIDE_HOW_CALC": "Hide our calculation",
	    "INVOICE_INC_VAT": "Invoice amount inc. VAT",
	    "FRILANS_FINANS": "Frilans Finans 6 percent fee ",
	    "SOCIAL_FEES": "Social fees",
	    "GROSS_SALARY_VACATION": "Gross salary incl. holiday pay",
	    "GROSS_EXCL_VACATION": "Gross salary excl. holiday pay",
	    "TAX": "Tax",
	    "NET_SALARY_VACATION": "Net salary incl. holiday pay",
	    "NET_EXCL_VACATION": "Net salary excl. holiday pay",
	    "CLOSE_INVOICE_TOOL": "Close invoice tool",
	    "ACCOUNT_SETTINGS": "Account settings",
	    "INVOICE_TOOL": "Invoice tool",
	    "INVOICE_PART_ONE": "Invoice part 1",
	    "INVOICE_PART_TWO": "Invoice part 2",
	    "CUSTOMER_TEXT": "Enter customer details.",
	    "CUSTOMER_CHOOSE_TEXT": "Choose a customer from the list or create a new customer.",
	    "CUSTOMER_ADD": "Add new customer",
	    "HOURS": "Hours",
	    "WORK_DATE_TEXT": "It is important that your working hours are filled in correctly if you need compensation from the social insurance office or other authorities, %(readMoreLink)s. You choose if you want to show \nthe working hours on the invoice.",
	    "WORK_DATE_TEXT_LINK": "read more about why here",
	    "ROT_RUT_TEXT": "If your invoice relates to a job that entitles your client to claim allowances for home maintenance and repairs, click below.",
	    "SHOW_DATE": "Show date on the invoice",
	    "ALT_ONE": "No",
	    "ALT_TWO": "Yes",
	    "ROT": "Rot-deduction",
	    "RUT": "Rut-deduction",
	    "BRF": "Property designation",
	    "ROT_RUT_READ_MORE": "Read more about Rot- and Rut-deduction",
	    "INVOICE_TEXT": "Enter a detailed work description. This information will appear on your invoice.",
	    "CHOOSE_CUSTOMER": "Choose a customer",
	    "EDIT_INFO": "Edit information",
	    "ADD_WORK_DATE": "Add work date",
	    "WORKED_HOURS": "Worked hours per day",
	    "CAMPAIGN_CODE_TITLE": "Do you have a promotion code?",
	    "CAMPAIGN_CODE": "Promotion code",
	    "SAME_DAY_PAYMENT": "Do you want to get paid the same day?",
	    "AMOUNT_TO_BILL_EXCL_VAT": "Invoice amount (excl. VAT)",
	    "INVOICE_DUE_DATE": "Due date",
	    "ADDED_LATER": "Added later",
	    "BANK_GIRO": "Bankgiro",
	    "VAT_READ_MORE": "Read more about VAT",
	    "AMOUNT_INCL_VAT": "Invoice amount incl. VAT",
	    "AMOUNT": "Invoice amount",
	    "INC_VAT": "Incl. vat",
	    "EXCL_VAT": "Exc. vat",
	    "VALUE_ERROR": "You have to enter a value",
	    "MONEY_DISTRIBUTION": "Allocation of money",
	    "MONEY_DISTRIBUTION_TEXT": "Here you see the expected payment to your account and how much that will be saved for your occupational pension. If you have chosen to save holiday pay, you can also see that amount. By clicking on \"Show details\", you can claim deductions, add employees and see the complete calculation. The information in this section is not shared with your client.",
	    "TO_PAY_TO_MY_ACCOUNT": "To be paid to you",
	    "INVOICING": "Invoicing",
	    "INVOICING_TEXT": "In this section you choose how the invoice will be sent to your customer.",
	    "SEND_INVOICE_AS_LETTER": "Send invoice by postal services",
	    "SEND_INVOICE_AS_EMAIL": "Send invoice by e-mail",
	    "HAVE_READ": "I have read and hereby approve the currently applicable",
	    "INVOICE_TERMS_AND_CONDITIONS": "Project Basis Employment agreement, General terms and conditions and Occupational safety and health documents.",
	    "INVOICE_TERMS_AND_CONDITIONS_1": "Agreement regarding special fixed-term employment",
	    "INVOICE_TERMS_AND_CONDITIONS_2": "General Terms and Conditions",
	    "INVOICE_TERMS_AND_CONDITIONS_2_INCL": "General Terms and Conditions for Work (incl. the right to work)",
	    "INVOICE_TERMS_AND_CONDITIONS_3": "Occupational safety and health documents",
	    "INVOICE_TERMS_AND_CONDITIONS_4": "Appendix Processing of Personal Data.",
	    "INVOICE_TERMS_AND_CONDITIONS_AND": "and the",
	    "INVOICE_TERMS_AND_CONDITIONS_EMPTY": "To see the terms and conditions you must choose a customer and complete working hours and invoice specification.",
	    "REGISTER_SAVE_DRAFT": "Pre register / Save draft",
	    "PREVIEW": "Preview",
	    "INVOICE_TOOL_GIRO": "783-6539",
	    "OMR_KEY": "Tax ",
	    "SPECIAL_PENSION_TAX": "Tax for occupational pension",
	    "NET_SALARY": "Net salary",
	    "COWORKERS": "Coworkers",
	    "ADD_COWORKER": "Add coworkers",
	    "TO_PAY": "To be paid",
	    "TO_PAY_WORKER": "To be paid to your coworker",
	    "PROFESSION_TITLE": "Profession",
	    "PERSONAL_NUMBER_FORMAT": "YYYYMMDDXXXX",
	    "STREET_ADDRESS": "Street",
	    "POSTAL_CODE_ABBR": "Zip code",
	    "NO_SALARIES": "You have no pay checks",
	    "ADD": "Add",
	    "ADD_NEW_COWORKER": "Add new coworker",
	    "ADD_SELECTED_COWORKER": "Add selected coworker",
	    "INVOICETOOL_EXPENSES": "These are expenses which are directly related to the performed assignment and are paid for by Frilans Finans (only after a receipt or invoice is provided). This can be, for example, travel by public transportation, car rental.",
	    "INVOICETOOL_TAX_KEY": "The tax key calculates the result of net pay from your total invoice amount. All fees such as Frilans Finans administrational fee, employers contributions, income tax and optionally occupational pension and holiday pay.",
	    "INVOICETOOL_VACATION_PAY": "By activating Save Holiday Pay you automatically save 12 percent of your gross salary plus employer's contributions in an account with Frilans Finans every time you create an invoice. You can see how much money you have saved on 'My pages'. \n\nYour holiday money – minus tax and employer's contributions – is paid into your account on 25 June, or on the following business day if the 25th is a holiday. You can ask for the saved holiday money that is due to you to be paid out at any time.",
	    "INVOICETOOL_ITP": "Occupational pension is the part of your pension that your employer allocates for you in addition to the general pension. Frilans Finans sets aside a basic occupational pension of 4.5 %% of your gross salary (gross salary including holiday pay) for those 25-66 years of age. \n\nIf you are between 18-24 years old, you can choose to set aside an occupational pension under “Settings” → “Salary and benefits”. If you want a higher amount to be set aside, you regulate this under account settings.",
	    "INVOICETOOL_GROSS": "Gross earnings is the total amount of your net earnings, applicable incomes taxes and vacation pay.",
	    "INVOICETOOL_TAX": "The tax key calculates the result of net pay from your total invoice amount. All fees such as Frilans Finans administrational fee, employers contributions, income tax and optionally occupational pension and holiday pay.",
	    "INVOICETOOL_NET": "The amount of the total fee that you keep, after applicable statutory taxes and social security fees are deducted.",
	    "INVOICETOOL_ALLOWANCE": "Expense allowance is a tax-free compensation. Expense allowance is designed to pay for added personal living expenses related to performing your duties as a consultant away from home. You are entitled to travel allowance if you must travel more than 50 kilometres from your home, and, if you must stay overnight away from home. As of 2020, the Swedish Tax Authority has set standard expense allowance at SEK 290 per day. Note, that the expense allowance for performing your duties in another country may differ depending on the country. Please contact us for more information and exact amounts for each country.",
	    "INVOICETOOL_TRAVEL": "Mileage allowance is a tax-free compensation in the amount of SEK 25 for every 10 kilometers you drive your own car in connection with performing your work.",
	    "INVOICETOOL_TOPAY": "This is the total amount to be paid into your account. This amount is the total of Net earnings + Mileage allowance + Expense allowance - Fees.",
	    "INVOICETOOL_PREVIEW": "Here you can see what your invoice looks like. Check that you have filled in the right end customer and invoice amount excl. VAT.",
	    "INVOICETOOL_SAVE": "Note: This function can be used if you want to create an invoice and then finalise it later. The function also lets you draw compensation from the unemployment benefit fund, where applicable, based on income from Frilans Finans. To meet the unemployment benefit fund’s requirement that you are an employee and not self-employed, you must notify Frilans Finans of when, where and what kind of work you will be carrying out before it is started. Provide this information by entering at the very least the end customer's name and work date in 'Register invoice', then select 'Save invoice'. The invoice you have begun is now saved in 'My pages' and when you want to issue a final invoice you enter the remaining details and complete invoicing. \n\nMinor differences are accepted. For example, if a work day has been postponed by a few days or if it is a different number of work days from what was originally planned. The work is still counted as notified in advance.",
	    "INVOICETOOL_VAT": "You can set a specific VAT percentage for your invoice. However, it is up to Frilans Finans to make the final decision based on applicable laws and regulations regarding the appropriate VAT percentage to use. If you are unsure as to the applicable VAT percentage you can leave this blank. Frilans Finans checks the applicable VAT percentage on all invoices. \n\nNote that VAT is not an expense since your customer can deduct VAT receivable against VAT payable with the Swedish Tax Authority, with the exception of religious congregations, private associations, and private persons. For customers belonging to these VAT exceptions, you must clearly identify your charges excluding VAT when agreeing on your fees to invoice, and that VAT (at a specified applicable rate) will be added to the charges on the invoice.",
	    "BECOME_CLIENT_OF_THE_MONTH": "Become client of the month",
	    "CLIENT_OF_THE_MONTH_MOTIVATION": "My preferred job",
	    "YOUR_PHOTO": "Photo of me",
	    "YOUR_PHOTO_WORKING": "Photo of me during work",
	    "UPLOAD": "Upload",
	    "IMAGE_SIZE_500_PX": "Picture must be atleast 500 pixels wide",
	    "ADD_COWORKERS": "Add coworkers",
	    "TEST": "Test",
	    "PASSWORD_ERROR_ORIGINAL": "The password does not meet the requirements",
	    "PASSWORD_ERROR_REPEAT": "Passwords do not match",
	    "PASSWORD_ERROR": "Enter a password with at least 12 characters. The password must contain letters (both uppercase and lowercase), numbers and symbols. For strong passwords do not include any obvious personal information or common words. Also do not enter a password that you already use on other websites. ",
	    "SEND": "Send",
	    "CANCEL": "Cancel",
	    "ACCOUNT_CLEARING_NUMBER_ERROR": "The clearing number doesn't match the account number",
	    "EMAIL_ALREADY_REGISTERED": "The email address is already registered",
	    "INVOCETOOL_SHOW_HOURS": "Show hours on invoice",
	    "CREATE_PASSWORD": "Create new password",
	    "PASSWORD_UPDATED": "Your password is now updated. Please go to the login page.",
	    "PASSWORD_UPDATED_2": "Please go to the login page.",
	    "PICK_COUNTRY": "Pick a country",
	    "CONFIRM_CLOSE_TOOL": "Are you sure you want to close the invoice tool? Any changes will be removed.",
	    "SEND_TO_EMAIL_INFO": "By checking the box and entering an e-mailaddress in the textfield above, this invoice will be sent as a PDF-file to the customer.",
	    "BIC_IBAN_INFO": "Ange BIC och IBAN om medarbetaren inte har svenskt bankkonto",
	    "TOOLTIP_ORM": "Based on income tax, social fees and Frilans Finans administrational fee of 6 %%. Tax key can differ from person to person and depends on age, profession and specified income tax.",
	    "TOOLTIP_ITP": "Occupational pension is the part of your pension that your employer allocates for you in addition to the general pension. Frilans Finans sets aside a basic occupational pension of 4.5 %% of your gross salary (gross salary including holiday pay) for those between 25-66 years of age. \n\nIf you are between 18-24 years old, you can choose to set aside an occupational pension under “Settings” → “Salary and benefits”. If you want a higher amount to be set aside, you regulate this under account settings.",
	    "TOOLTIP_VACATION": "By activating Save Holiday Pay you automatically save 12 percent of your gross salary plus employer's contributions in an account with Frilans Finans every time you create an invoice. You can see how much money you have saved on “My page”. \n\nYour holiday money – minus tax and employer's contributions – is paid into your account on 25 June, or on the following business day if the 25th is a holiday. You can ask for the saved holiday money that is due to you to be paid out at any time.",
	    "TOOLTIP_GROSS": "Gross earnings is the total amount of your net earnings, applicable incomes taxes and vacation pay.",
	    "TOOLTIP_TAX": "This is your income tax",
	    "TOOLTIP_NET": "The amount of the total fee that you keep, after applicable statutory taxes and social security fees are deducted.",
	    "TOOLTIP_TRAVEL": "Mileage allowance is a tax-free compensation in the amount of SEK 25 for every 10 kilometers you drive your own car in connection with performing your work.",
	    "TOOLTIP_DEDUCTION": "These are expenses which are directly related to the performed assignment and are paid for by Frilans Finans (only after a receipt or invoice is provided). This can be, for example, travel by public transportation, car rental, taxi (only in excess of SEK 25 per 10 kilometers).",
	    "TOOLTIP_WORKER": "Here you may add one or more coworkers and distribute the earnings amongst you",
	    "TOOLTIP_ALLOWANCE": "Allowances are to cover your private, increased living costs that arise in connection with traveling on business. To be entitled to an allowance, the Swedish Tax Agency requires that you work at least 50 kilometers from home and that overnight stays take place in a place other than your home town. The Swedish Tax Agency has set the allowance in Sweden at SEK 290 per day. The allowance varies depending on the country you work in. Please contact us at Client Support if you have any questions about allowances.",
	    "TOOLTIP_CHECKBOX": "By checking the box the workers part of the invoice amount is locked.",
	    "HIDE_DETAILS": "Hide details",
	    "SHOW_DETAILS": "Show details",
	    "VACATION_PAY": "Vacation pay",
	    "INCORRECT_LOGIN": "You have entered inccorect login details",
	    "COMPANY": "Company",
	    "PRIVATPERSON": "Individual",
	    "DELETE": "Remove",
	    "DELETE_CUSTOMER": "Are you sure you want to remove %(name)s?",
	    "FOOTER_LINK_FAQ": "https://www.frilansfinans.se/fragor-och-svar/",
	    "FOOTER_LINK_SUPPORT": "https://www.frilansfinans.se/sa-har-fungerar-det/",
	    "FOOTER_LINK_CONTACT": "https://www.frilansfinans.se/kontakta-oss/",
	    "FOOTER_LINK_INS": "https://www.frilansfinans.se/vara-forsakringar/",
	    "FOOTER_LINK_FACEBOOK": "https://www.facebook.com/FrilansFinans/",
	    "FOOTER_LINK_PRIVACY_POLICY": "https://www.frilansfinans.se/en/privacy-policy/",
	    "FOOTER_LINK_LINKEDIN": "https://www.linkedin.com/company/frilans-finans-sverige-ab",
	    "FOOTER_LINK_TWITTER": "https://twitter.com/frilansfinans/",
	    "FOOTER_LINK_INSTAGRAM": "https://www.instagram.com/frilansfinans/",
	    "FOOTER_CONTACT_TEXT": "info@frilansfinans.se\n\nPhone: 0771-15 10 00",
	    "FOOTER_OPEN_TEXT": "Open weekdays 9.00-17.00",
	    "FOOTER_LINK_COOKIE": "https://www.frilansfinans.se/information-om-cookies/",
	    "UPDATE_INVOICE": "Update invoice",
	    "ACCOUNT_ACTIVATED": "Activation successful! You may log in.",
	    "CREATE_TENDER_LINK": "https://www.frilansfinans.se/wp-content/uploads/2023/06/Offertmall-engelska-2023.docx",
	    "CREATE_CONTRACT_LINK": "https://www.frilansfinans.se/wp-content/uploads/2023/06/FrilansFinans_AssignmentAgreement-fullENG_S221020.pdf",
	    "LOCK_AMOUNT": "Lock amount",
	    "EXPRESS_PAYMENT_INFO": "Express payment means that Frilans Finans pays your salary on the same day you send the invoice (applies to invoices received on weekdays no later than 3 p.m.). Most often, the money reaches your account the next weekday, if you send in the invoice before 11 a.m. the money reaches your account already the same day.\n\nTo be able to grant express payment, the conditions for advance payment must be met. Frilans Finans also makes an overall credit assessment of the invoices, where we e.g. checks:\n\nThat the customer is creditworthy, has a good ability to pay and has no payment complaints.\nThat you have no payment notes.\nThat the customer is not yourself or another party with whom you have a significant common interest.\nThat the working day/days are not older than 30 days.\nThat due dates are not over 30 days.\nThat the customer is a registered company with the Swedish Companies Registration Office.\nThat the customer is located in Sweden.\nThat the claim regarding the work you performed is not subject to dispute.\n\nThe cost of express payment is only 1.5%% in addition to Frilans Finans' regular fee.\n\nFAQ\nWhat happens if the prepayment conditions are not met?\nFrilans Finans will then remove the cost of express from your invoice document and, if the invoice document is approved, send the invoice to the customer. Your salary will be paid after the customer has paid the invoice.",
	    "EXPRESS_PAYMENT": "Express payment",
	    "EXPRESS_PAYMENT_READ_MORE": "Terms and conditions",
	    "RUT_ROT_INFO": "What is ROT/RUT deduction?\nWhen you carry out work for a private individual who is entitled to a ROT/RUT deduction, the customer can receive a tax reduction on the cost of the work. Please note that it is only the labor cost on the invoice that is entitled to the ROT/RUT deduction. Materials and travel expenses in connection with the work do not qualify for a deduction.\n\nWork entitled to ROT, 30%%\nRefers to repairs and maintenance as well as alterations and extensions, provided that the work is carried out in or close to a dwelling owned by the person entitled to the deduction. ROT deductions cannot be made for completely new houses, nor for extensions to new dwellings (within the first five years). \n\nWork entitled to RUT, 50%%\nRefers to domestic work carried out in property in which the purchaser of the service or their parents live or stay. \n\nWhat should the invoice description contain?\n- details of the work carried out\n- breakdown of the cost of labor or materials, rental of machinery, equipment and travel.\n- the amount of the tax reduction\n- if the invoice relates only to labour costs, the specification should indicate this.\n- details of where the work was carried out.\n\nWho applies for the deduction at the Tax Agency?\nAll invoices you design as ROT or RUT via our website, Frilans Finans will seek deductions for. We will have all contact with the Swedish Tax Agency regarding this, and your salary is already paid when the customer has paid his part of the invoice. \n\nWho can use the deduction and how much can be deducted? \nA buyer who had unlimited tax liability during the tax year and turned 18 before the end of the year is entitled to receive a maximum of SEK 50,000 in ROT deductions and SEK 25,000 in RUT deductions per person and year. The scope is based on the buyer's final tax where other possible deductions are first taken into account.\n\nThe ROT/RUT deduction can only be used on the cost of the work, where 30%% deduction can be made for ROT work and 50%% deduction for RUT work. Please note that the service provider must not be related to the buyer. \n\nHow do I know that the buyer has enough ROT/RUT deductions?\nIf you are not sure that the buyer has enough room for your work, you can ask the buyer for a certificate from the tax authorities. This shows how much deduction has been used so far this year. Should it turn out that the customer does not have enough ROT/RUT deductions left, Frilans Finans will create an additional invoice for the remaining amount to the customer. Your salary will therefore not be affected.",
	    "VAT_INFO": "You can set a specific VAT percentage for your invoice. However, it is up to Frilans Finans to make the final decision based on applicable laws and regulations regarding the appropriate VAT percentage to use. If you are unsure as to the applicable VAT percentage you can leave this blank. Frilans Finanschecks the applicable VAT percentage on all invoices. \n\nNote that VAT is not an expense since your customer can deduct VAT receivable against VAT payable with the Swedish Tax Authority, with the exception of religious congregations, private associations, and private persons. For customers belonging to these VAT exceptions, you must clearly identify your charges excluding VAT when agreeing on your fees to invoice, and that VAT (at a specified applicable rate) will be added to the charges on the invoice.",
	    "ALERT": "Please note",
	    "EXPRESS_PAYMENT_NOT_ROT_RUT": "Express payment cannot be used if you selected tax relief for home maintenance or renovation work. If you select ROT or RUT express payment will be deselected.",
	    "ACCEPT_TERMS": "Accept the terms and conditions to send your invoice",
	    "INVOICE_NOT_VALID": "You need to correct some errors above",
	    "INVOICE_ERROR_SPECIFICATION": "At least 5 characters is required",
	    "INVOICE_ERROR_CUSTOMER": "Choose a customer",
	    "INVOICE_ERROR_INVOICEDATE_MAX_HOURS": "Please enter maximum 24 hours per day",
	    "INVOICE_ERROR_INVOICEDATE": "At least one date is required",
	    "INVOICE_EMAIL": "Invoice email",
	    "SALARY_INFORMATION": "Salary information",
	    "SALARY_INFORMATION_VIA_SMS": "Salary information via sms",
	    "SALARY_INFORMATION_VIA_EMAIL": "Salary information via email",
	    "LOGIN_FAILED": "The link is no longer valid, please login again.",
	    "CLIENT_OF_THE_MONTH_SUBMITTED": "Thank you for your contribution!",
	    "COTM_SPEC_EMPTY": "You have to enter a description",
	    "COTM_PORTRAIT_EMPTY": "You must choose a picture of yourself",
	    "COTM_ACTION_EMPTY": "You must choose a picture of yourself while working",
	    "NO_CUSTOMER_SELECTED": "No customer selected",
	    "AMOUNT_EXCL_VAT": "Invoice amount excl. VAT",
	    "INVOICE_ERROR_AMOUNT": "Enter invoice amount",
	    "INVOICE_ERROR_SUPPLIER_LEDGER": "Deductions cannot exceed half of invoice amount",
	    "TOTAL_NR_OF_WORKHOURS": "Total hours",
	    "INVOICE_TOOL_TRAVEL_DEDUCTION_INFO": "The sum of allowances cannot exceed 50%% of invoice amount.",
	    "ERRAND_ICON_DESCRIPTION_PEN": "Click here to make changes to your invoice",
	    "ERRAND_ICON_DESCRIPTION_MAIL": "The invoice is created and sent to the customer",
	    "ERRAND_ICON_DESCRIPTION_LOCK": "Admin is viewing this invoice",
	    "ERRAND_ICON_DESCRIPTION_EYE": "Review",
	    "ERRAND_ICON_DESCRIPTION_POINTER": "?",
	    "INVOICE_TOOL_AMOUNT_BELOW_TRAVEL_DEDUCTIONS": "Invoice amount is too low in relation to travel, allowances and expenses",
	    "MISSING_PAGE": "The page you are looking for does not exist.",
	    "CLIENT_OF_THE_MONTH_TOO_FREQUENT": "You can apply for freelancer of the month once every 14 days.",
	    "INVOICE_SENT": "The invoice has been sent",
	    "WRITE_DOWN_LEVID_ON_RECEIPT": "You will find below a summary of the allowances on the invoice.\n\nWrite the supplier’s ID on the back of the receipt relating to it before you post it to us.",
	    "CONTINUE": "Continue",
	    "AMOUNT_TO_BILL_HSD_ROT_EXCL_VAT": "Amount after deduction of allowance for home maintenance and repairs excluding VAT",
	    "AMOUNT_TO_BILL_HSD_RUT_EXCL_VAT": "Amount after RUT deduction excl. VAT",
	    "INVOICE_UPDATED": "The invoice has been updated",
	    "NO_COWORKERS_ADD_NEW_BELOW": "You have no previous coworkers.",
	    "INVOICE_HSD_ROT_DATA": "To utilise ROT deductions you must enter the land registry number of the property or the company registration number of the cooperative housing association.",
	    "SEND_INVOICE_MODAL_TITLE": "Send invoice",
	    "SEND_INVOICE_MODAL_TEXT": "You are about to send an invoice. Have you checked that your input values are correct? Your current inputs means that the invoice has a total amount of %(amount)s Ex. VAT.",
	    "INVOICE_SENT_MODAL_TITLE": "The invoice was sent",
	    "INVOICE_SENT_MODAL_TEXT": "The invoice was sent",
	    "VALIDATION_USER_PROFESSION_TITLE_FOUND_PROFESSION_TITLE": "Worker number %(value)s lacks job title",
	    "VALIDATION_USER_PROFESSION_TITLE_REQUIRED": "Job title is missing. Please go to the top of the invoice tool and click  account settings and select Invoice setting. Here you will need to enter your job title. For questions please contact support at info@frilansfinans.se or 0771 15 10 00.",
	    "VALIDATION_USER_COUNTRY_REQUIRED": "Country is missing",
	    "VALIDATION_USER_ACCOUNT_NUMBER_REQUIREDUNLESS_INTERNATIONAL_ACCOUNT_ON": "Account number is missing",
	    "VALIDATION_USER_ACCOUNT_CLEARING_NUMBER_REQUIREDUNLESS_INTERNATIONAL_ACCOUNT_ON": "Clearing number is missing",
	    "VALIDATION_USER_COUNTRY_FOUND_COUNTRY_COUNTRY_NAME": "Invalid country",
	    "INVOICE_SAVED_MODAL_TEXT": "The invoice is saved",
	    "DEFAULT_CURRENCY_NAME_SHORT": "SEK",
	    "DEFAULT_COUNTRY_FOR_NEW_CUSTOMERS": "SWEDEN",
	    "NET_SUM": "Net",
	    "GROSS_SUM": "Gross",
	    "TAX_SUM": "Tax",
	    "TRAVEL_SUM": "Mileage allowance",
	    "ALLOWANCE_SUM": "Allowance",
	    "DEFAULT_CURRENCY_NAME_SHORT_OTHER": "Kr",
	    "PART_OF_INVOICE_SUM": "Part of invoice sum",
	    "VALIDATION_EMAIL_UNIQ_USER": "The email address is already registered",
	    "TOTAL_PAID_TO_CLIENT": "Paid to my account",
	    "VALIDATION__ACCOUNT_NUMBER_REQUIREDWITHOUTALL_IBAN_BIC": "You have to enter a bank account",
	    "LOADING": "Loading",
	    "GET_SALARY_SPECIFICATION_ERROR": "The salary specification could not be found",
	    "UNSUPPORTED_BROWSER": "This version of your web browser is not supported. Please update your browser.",
	    "VALIDATION_CELLPHONE_PHONENUMBER_SE_FALSE": "You have to enter a cellphone number",
	    "OPEN_BANK_ID": "Open BankID",
	    "OPEN_BANK_ID_COMPUTER_APP": "Open BankID software",
	    "OPEN_BANK_ID_APP": "Open BankID app",
	    "BANK_ID_ANOTHER_DEVICE": "Mobile BankID on another device",
	    "EMAIL_CAPTURE_HEADER": "Set email",
	    "EMAIL_CAPTURE_TEXT": "We need your email to complete the sign up process",
	    "GET_BANKKID": "Skaffa BankID",
	    "DIVIDER_OR": "OR",
	    "LOGIN_WITH_MOBILE_BANKID": "Login with mobile BankID",
	    "LOGIN_WITH_BANKID": "Login with BankID",
	    "LOGIN_WITH_BANKID_ON_FILE": "Login with BankID on file",
	    "LOGIN_WITHOUT_BANKID": "Login with email and password",
	    "REGISTER_WITH_MOBILE_BANKID": "Create account with mobile BankID",
	    "REGISTER_WITH_BANKID_ON_FILE": "Create account with BankID on file",
	    "CREATE_ACCOUNT_WITH_BANKID": "Create account with BankID",
	    "CREATE_ACCOUNT_WITHOUT_BANKID": "Create account without BankID",
	    "REGISTER_WITHOUT_BANKID": "Create account with email and password",
	    "EMAIL_NOT_CONFIRMED": "You have to verify your email address \"%(email)s\" to be able to set a password.",
	    "SEND_VERIFICATION_MAIL": "Send verification email",
	    "VALIDATION_USER_ACCOUNT_NUMBER_REQUIRED": "Account number is missing",
	    "VALIDATION_USER_ACCOUNT_CLEARING_NUMBER_REQUIRED": "Clearing number is missing",
	    "TAB_TITLE_EMAIL": "Email and password",
	    "TAB_TITLE_BANKID_MOBILE": "Mobile BankID",
	    "TAB_TITLE_BANKID_FILE": "BankID",
	    "CANCELLED": "Cancelled",
	    "BANKID_USER_NOT_FOUND": "You tried to login with a social security number that is not yet registered. Please proceed to create an account.",
	    "ERRAND_ICON_DESCRIPTION_REMOVE": "Click here to remove your preregistered invoice",
	    "DELETE_INVOICE": "Are you sure you want to remove the preregistered invoice?",
	    "VALIDATION_COUPON_ID_COUPON": "The promotion code is invalid",
	    "VALIDATION_USER_STREET_REQUIRED": "Address is missing",
	    "VALIDATION_USER_ZIP_REQUIRED": "Postal code is missing",
	    "VALIDATION_USER_CITY_REQUIRED": "City is missing",
	    "BANKID_GENERAL_ERROR": "Something unexpected happend! Try again later or contact our support team at 0771-15 10 00.",
	    "FOOTER_CONTACT_EMAIL": "info@frilansfinans.se",
	    "FOOTER_CONTACT_PHONE": "Phone: 0771-15 10 00",
	    "FOOTER_CONTACT_OPEN": "Open weekdays 9.00-17.00",
	    "SSNR_ALREADY_REGISTERED": "Something went wrong. Please contact client support to complete the registration; tel: 0771-15 10 00 eller mail: info@frilansfinans.se.",
	    "PREREGISTER_WORK": "Preregister work",
	    "VALIDATION_COMPANY_PHONE_PHONENUMBER_SE_FALSE": "Enter a swedish cell phone number",
	    "VALIDATION_COMPANY_PHONE_REQUIREDIF_MESSAGE_TYPE_SMS": "Enter a swedish cell phone number",
	    "VALIDATION_SEND_TO_EMAIL_EMAIL": "You have to enter a valid email ",
	    "VALIDATION_SEND_TO_EMAIL_REQUIREDIF_MESSAGE_TYPE_EMAIL": "You have to enter a valid email ",
	    "EMAIL_INVALID_ERROR": "You have to enter a valid email ",
	    "CANT_DELETE_COMPANY_WITH_PREREPORT_INVOICES": "This customer belongs to at least one pre-reported invoice and can therefore not be deleted.",
	    "PAYMENT_INVOICE_DATA": "Invoice data",
	    "PAYMENT_INVOICE_ROT_OR_RUT_DEDUCTION": "HSD deduction inc. VAT",
	    "NETWORK": "Network",
	    "HOW_IT_WORKS": "This is how it works",
	    "QUESTIONS_AND_ANSWERS": "Questions and answers",
	    "MEET_OUR_UMBRELLA_CONTRACTORS": "Meet our umbrella contractors",
	    "THIS_IS_SELF_EMPLOYMENT": "This is self-employment",
	    "GOOD_WORKING_CONDITIONS": "Good working conditions",
	    "ABOUT_FRILANS_FINANS": "About Frilans Finans",
	    "CONTACT_US": "Contact us",
	    "NEWS_AND_PRESS": "News and press",
	    "SOCIAL_MEDIA": "Social Media",
	    "HEADER_MENU_SERVICES": "Services",
	    "HEADER_MENU_HELP": "Help",
	    "HEADER_MENU_ABOUT": "About Frilans Finans",
	    "PAYMENT_PAY_WITH_PLUSGIRO": "To pay with PlusGiro use the following info",
	    "PLUSGIRO_NUMBER": "858393-2",
	    "BECOME_CLIENT_NEXT_CLIENT": "Klara Wåhlberg, Model and skier",
	    "BECOME_CLIENT_ENTER_CONTEST": "Read more and register here",
	    "BECOME_CLIENT_IMAGE_URL": "https://d36fgo9tveb5fn.cloudfront.net/wp-content/uploads/2019/12/30112408/FrilansFinans_Klara_Wahlberg_ME_dec_16x9.jpg",
	    "BECOME_CLIENT_OT_THE_MONTH_AGREEMENT": "When you send us the text and photo you agree that we may alter and use the content in marketing purpose for Frilans Finans.",
	    "BECOME_CLIENT_SPECIFICATION_PLACEHOLDER": "Tell us about an exiting job you have done...",
	    "BECOME_CLIENT_TELL_US": "Tell us about an exciting job you have done for the chance to become the employee of the month. Every month 5 000 SEK is at stake!",
	    "SIDEBAR_EXTRA": "Other",
	    "UPLOAD_IMAGE": "Upload image",
	    "PAYMENT_START_FROM_NAME": "Invoice from %(name)s via Frilans Finans",
	    "PAY_WITH_SWISH": "Pay with Swish",
	    "SEE_INVOICE_SPECIFICATION": "Show invocie specification",
	    "PAY_WITH_PLUSGIRO": "Pay with Plusgiro",
	    "MINIMIZE": "Minimize",
	    "PAYMENT_PAGE_TO_PAY": "Amount to pay",
	    "PLUSGIRO": "PlusGiro",
	    "OCR": "OCR",
	    "PAYMENT_DOWNLOAD_PDF": "Download PDF",
	    "PAYMENT_PAID_THANK_YOU_FOR_PAYMENT": "Thank you for your payment",
	    "PAYMENT_PAID_PAID_AT": "Payment completed",
	    "PAYMENT_ERROR_TRY_AGAIN": "Try again",
	    "INVOICING_MESSAGE_TYPE_SMS": "<ul><li>The customer is able to pay with Swish directly to Frilans Finans.</li>\n<li>When we've approved the invoice, we send a text message to the customer with a link to the Swish payment.</li>\n<li>The salary will be paid 1 business day after the invoice has been paid.</li></ul>",
	    "INVOICING_SEND_INVOICE_BY_EMAIL": "Send invoice by e-mail",
	    "INVOICING_SEND_INVOICE_BY_MAIL": "Send invoice by mail",
	    "INVOICING_SEND_INVOICE_BY_SMS": "Send invoice by text message",
	    "INVOICING_SEND_INVOICE_BY_EMAIL_TO": "Send invoice by e-mail to",
	    "INVOICING_SEND_INVOICE_BY_EMAIL_TO_SECONDARY": "Send a copy to (optional)",
	    "INVOICING_SEND_INVOICE_BY_MAIL_TO": "Send invoice by mail to",
	    "INVOICING_SEND_INVOICE_BY_SMS_TO": "Send invoice by text message to",
	    "INVOICING_CANT_SEND_INVOICE_BY_SMS": "It's not possible to send invoices by text message to companies",
	    "PAYMENT_START_INVOICE_AMOUNT_EXCL": "Amount excl. VAT",
	    "PAYMENT_START_INVOICE_AMOUNT_INCL": "Amount incl. VAT",
	    "PLUSGIRO_RECIPIENT": "Recipient",
	    "PLUSGIRO_RECIPIENT_NAME": "Frilans Finans Sverige AB",
	    "PENSION_TOO_OLD": "You can save occupational pension until the year you reach 65",
	    "INVALID_PHONE_NUMBER": "Invalid phone number",
	    "INVALID_EMAIL": "Invalid email",
	    "VALIDATION_COMPANY_PHONE_PHONENUMBER": "Your customer has an invalid phone number",
	    "INVOICE_SPECIFICATION_ROT": "This invoice refers to ROT work and preliminary tax reduction has been made with 30 % on labor costs.",
	    "INVOICE_SPECIFICATION_RUT": "This invoice refers to RUT work and preliminary tax reduction has been made with 50 % on labor costs.",
	    "INVOICE_TOOL_BIC": "ESSESESS",
	    "INVOICE_TOOL_IBAN": "SE2250000000053681053693",
	    "INVOICE_TOOL_ACCOUNT_NUMBER": "5368 10 536 93",
	    "BANK_INFO_TITLE": "Bank information",
	    "SELECT_BANK_INITIAL": "-- Select a bank --",
	    "SELECT_BANK_HANDELSBANKEN": "Handelsbanken",
	    "SELECT_BANK_NORDEA_PERSON": "Nordea (social security number)",
	    "SELECT_BANK_NORDEA_KONTO": "Nordea (account number)",
	    "SELECT_BANK_SWEDBANK": "Swedbank",
	    "SELECT_BANK_SEB": "SEB",
	    "SELECT_BANK_IBAN": "Foreign bank (BIC/IBAN)",
	    "SELECT_BANK_OTHER": "Other banks",
	    "CLEARING_NR_LABEL_INITIAL": "Clearing number",
	    "CLEARING_NR_PLACEHOLDER_INITIAL": "4 digits",
	    "CLEARING_NR_ERROR_INITIAL": "Invalid clearing number",
	    "ACCOUNT_NR_LABEL_INITIAL": "Account number",
	    "ACCOUNT_NR_PLACEHOLDER_INITIAL": "7 digits",
	    "ACCOUNT_NR_ERROR_INITIAL": "Invalid account number",
	    "CLEARING_NR_LABEL_HANDELSBANKEN": "Clearing number",
	    "CLEARING_NR_PLACEHOLDER_HANDELSBANKEN": "4 digits",
	    "CLEARING_NR_ERROR_HANDELSBANKEN": "Invalid clearing number, allowed format for Handelsbanken: 6XXX",
	    "ACCOUNT_NR_LABEL_HANDELSBANKEN": "Account number",
	    "ACCOUNT_NR_PLACEHOLDER_HANDELSBANKEN": "9 digits",
	    "ACCOUNT_NR_ERROR_HANDELSBANKEN": "Invalid account number",
	    "CLEARING_NR_LABEL_NORDEA_PERSON": "Clearing number",
	    "CLEARING_NR_PLACEHOLDER_NORDEA_PERSON": "Always 3300",
	    "CLEARING_NR_ERROR_NORDEA_PERSON": "Invalid clearing number",
	    "ACCOUNT_NR_LABEL_NORDEA_PERSON": "Account number",
	    "ACCOUNT_NR_PLACEHOLDER_NORDEA_PERSON": "Civic number with 10 digits",
	    "ACCOUNT_NR_ERROR_NORDEA_PERSON": "Invalid account number",
	    "CLEARING_NR_LABEL_NORDEA_KONTO": "Clearing number",
	    "CLEARING_NR_PLACEHOLDER_NORDEA_KONTO": "4 digits",
	    "CLEARING_NR_ERROR_NORDEA_KONTO": "Invalid clearing number",
	    "ACCOUNT_NR_LABEL_NORDEA_KONTO": "Account number",
	    "ACCOUNT_NR_PLACEHOLDER_NORDEA_KONTO": "7 or 10 digits",
	    "ACCOUNT_NR_ERROR_NORDEA_KONTO": "Invalid account number",
	    "CLEARING_NR_LABEL_SWEDBANK": "Clearing number",
	    "CLEARING_NR_PLACEHOLDER_SWEDBANK": "4 or 5 digits",
	    "CLEARING_NR_ERROR_SWEDBANK": "Invalid clearing number, allowed formats for Swedbank: 8XXXX or 7XXX",
	    "ACCOUNT_NR_LABEL_SWEDBANK": "Account number",
	    "ACCOUNT_NR_PLACEHOLDER_SWEDBANK": "7 to 10 digits",
	    "ACCOUNT_NR_ERROR_SWEDBANK": "Invalid account number",
	    "CLEARING_NR_LABEL_SEB": "Clearing number",
	    "CLEARING_NR_PLACEHOLDER_SEB": "4 digits",
	    "CLEARING_NR_ERROR_SEB": "Invalid clearing number, allowed format for SEB: 5XXX",
	    "ACCOUNT_NR_LABEL_SEB": "Account number",
	    "ACCOUNT_NR_PLACEHOLDER_SEB": "7 digits",
	    "ACCOUNT_NR_ERROR_SEB": "Invalid account number",
	    "CLEARING_NR_LABEL_IBAN": "BIC",
	    "CLEARING_NR_PLACEHOLDER_IBAN": "8 or 11 letters and digits",
	    "CLEARING_NR_ERROR_IBAN": "Invalid BIC",
	    "ACCOUNT_NR_LABEL_IBAN": "IBAN",
	    "ACCOUNT_NR_PLACEHOLDER_IBAN": "Up to 34 letters and digits",
	    "ACCOUNT_NR_ERROR_IBAN": "Invalid IBAN",
	    "CLEARING_NR_LABEL_OTHER": "Clearing number",
	    "CLEARING_NR_PLACEHOLDER_OTHER": "4 digits",
	    "CLEARING_NR_ERROR_OTHER": "Invalid clearing number",
	    "ACCOUNT_NR_LABEL_OTHER": "Account number",
	    "ACCOUNT_NR_PLACEHOLDER_OTHER": "7 or 10 digits",
	    "ACCOUNT_NR_ERROR_OTHER": "Invalid account number",
	    "LOW_SALARY_PROCEED_ANYWAY": "You are about to send an invoice with a hourly wage lower than 70 SEK. Our mission is to make sure that you have good working conditions and a reasonable salary. Therefore, we recommend either raising the amount you will be billing or work fewer hours.<br/><br/>",
	    "SEND_INVOICE_ANYWAY": "Send the invoice anyway",
	    "NEW_CUSTOMER_INFO": "Enter registration number ( companies/organizations ) or social security number ( private persons). If the customer is a company in an EU country other than Sweden, enter VAT number.",
	    "GET_SALARY_SPECIFICATION": "Get salary specification",
	    "INVOICE_DESCRIPTION": "Description",
	    "VALIDATION_AMOUNT_ABOVEORBELOW": "Enter invoice amount",
	    "DEDUCTION_CATEGORY_1": "International receipt 0% VAT",
	    "DEDUCTION_CATEGORY_2": "Public transport in Sweden 6% VAT",
	    "DEDUCTION_CATEGORY_3": "Groceries 12% VAT",
	    "DEDUCTION_CATEGORY_4": "Consumption 12% VAT",
	    "DEDUCTION_CATEGORY_5": "Consumption 25% VAT",
	    "DEDUCTION_CATEGORY_6": "Work material forwarded to customer (RUT/ROT) 12% VAT",
	    "DEDUCTION_CATEGORY_7": "Work material forwarded to customer (RUT/ROT) 25% VAT",
	    "DEDUCTION_CATEGORY_8": "Parking 25% VAT",
	    "DEDUCTION_CATEGORY_9": "0% VAT",
	    "DEDUCTION_CATEGORY_10": "6% VAT",
	    "DEDUCTION_CATEGORY_11": "12% VAT",
	    "DEDUCTION_CATEGORY_12": "25% VAT",
	    "DEDUCTION_CATEGORY_13": "Inventories - specify on the invoice",
	    "DEDUCTION_CATEGORY_14": "Accommodation 12% VAT",
	    "DEDUCTION_CATEGORY_15": "6% VAT - does not affect customers right to RUT- and ROT-expense.",
	    "DEDUCTION_CATEGORY_16": "12% VAT - does not affect customers right to RUT- and ROT-expense.",
	    "DEDUCTION_CATEGORY_17": "25% VAT - does not affect customers right to RUT- and ROT-expense.",
	    "DEDUCTION_CATEGORY_18": "0% VAT - does not affect customers right to RUT- and ROT-expense.",
	    "CUSTOMER_SELECT_LABEL": "Search here...",
	    "CUSTOMER_SELECT_NOTFOUND": "No results found",
	    "WORKED_TIME": "Working time",
	    "TOGGLE_WEEK": "Do you have a lot of workdays? Click on the week number to mark the whole week Mon-Fri.",
	    "SEARCH_FAQ": "Search among questions and answers",
	    "ACCEPT_NEW_COWORKER": "I hereby confirm that I have received my coworkers' approval to register their personal data at Frilans Finans.",
	    "FINLAND": "Finland",
	    "FRANCE": "France",
	    "INVOICE_ERROR_NEGATIVE_SALARY": "The net salary is negative because of the deduction amount (expenses, mileage allowance and allowance). To send the invoice, you can either raise the invoice amount or reduce the deduction costs. ",
	    "SEARCH_COWORKER": "Search for existing coworkers by entering the three first characters in the surname.\n",
	    "PROFESSION_ID_TITLE": "Please choose your job title",
	    "PROFESSION_ID_INFO": "In order to work as an umbrella contractor and for you to be covered by the right insurance, it is important that you have chosen the right job title.\n\nEnter your title in the box (in swedish). If your profession is not listed (which you see when you enter at least three letters), please choose the one that best matches your assignments via Frilans Finans. ",
	    "INVOICE_TOOL_MISSING_DATA_TITLE": "We need some more information about you",
	    "INVOICE_TOOL_MISSING_DATA_INFO": "Fill in the missing information about you to send your invoice.",
	    "ZIP": "Postal code",
	    "STREET": "Street",
	    "FUTURE_WORK_DATE": "The submitted work dates have not occured. Is this correct? ",
	    "ACCEPT_FUTURE_DATES": "Continue",
	    "HSD_PROPERTY_LABEL": "Property",
	    "HSD_BRF_ORG_NUMBER": "Brf org. number",
	    "HSD_BRF_APARTMENT_NUMBER": "Apartment number",
	    "HSD_PROPERTY": "House",
	    "HSD_APARTMENT": "Apartment",
	    "HSD_CHOOSE_ACCOMMODATION": "Choose type of accommodation",
	    "STREET_ERROR": "Address is missing",
	    "ZIP_ERROR": "Postal code is missing",
	    "INVOICE_HSD_ROT_HOUSE": "Fill in the property name",
	    "INVOICE_HSD_ROT_APARTMENT": "Fill in the Brf org. number and apartment number ",
	    "BANKID_LOGIN_FAILED": "Login failed or was cancelled",
	    "UK": "United Kingdom",
	    "LOGIN_REGISTER_PERKS_TITLE": "Quick, safe and easy",
	    "LOGIN_REGISTER_PERK_FREE_ACCOUNT": "No hidden fees, it's free to create an account.",
	    "LOGIN_REGISTER_PERK_PAPERS": "We help you with all administration such as accounting and payment of taxes.",
	    "LOGIN_REGISTER_PERK_WALLET": "There are no hidden costs or monthly fees. You only pay 6% of the invoiced amount, each time you invoice a customer.",
	    "LOGIN_REGISTER_PERK_JUMPING": "You don't commit to anything by creating an account, just use Frilans Finans whenever you need.",
	    "LOGIN_REGISTER_PERK_HEADPHONE": "Support via email, phone or chat all weekdays.",
	    "LOGIN_REGISTER_PERKS_BGIMAGE_URL": "https://d36fgo9tveb5fn.cloudfront.net/wp-content/uploads/2019/08/23141524/ff_photographer_25.jpg",
	    "VALIDATION_CELLPHONE_PHONENUMBER": "You have to enter a cellphone number",
	    "INVOICE_TOOL_LINK_TEXT": "Invoice tool",
	    "FIND_ASSIGNMENTS": "Find assignments",
	    "DASHBOARD_CTA_POST_TITLE": "Join us for our upcoming event!",
	    "DASHBOARD_CTA_POST_SUBTITLE": "Afternoon lecture with OneLab",
	    "DASHBOARD_CTA_POST_CONTENT": "Welcome to a lecture on physical activity and recovery arranged by OneLab with Mira Lidell as representative. The lecture provides insights into active and passive recovery and its impact on health and well-being. The aim is to provide tools to reflect on one's own behaviors and habits to promote a healthy lifestyle. Frilans Finans staff will also attend the lecture and are happy to answer any questions about our service afterwards.\n\nTime: 13.30-14.10\n\nDate: 18 June\n\nLocation: Gamla Brogatan 13, Frilans Finans visitor office in Stockholm",
	    "DASHBOARD_CTA_POST_BUTTON_TEXT": "Read more",
	    "DASHBOARD_CTA_POST_BUTTON_URL": "https://med-hlsan-i-fokus.confetti.events/",
	    "DASHBOARD_CTA_POST_IMAGE_URL": "https://www.frilansfinans.se/wp-content/uploads/2024/06/timon-studler-BIk2ANMmNz4-unsplash-1.jpg",
	    "SETTINGS_LOGOTYPE_DELETED": "Your logo is now removed and will not appear on future invoices.",
	    "SETTINGS_CONFIRM_LOGOTYPE_DELETE": "Are you sure you want to remove your logo?",
	    "PDF": "PDF",
	    "INVOICING_SEND_INVOICE_BY_E_INVOICE": "Send invoice by e-invoice",
	    "INVOICING_SEND_INVOICE_BY_E_INVOICE_TO": "Enter GLN or PEPPOL",
	    "EINVOICE_ERROR": "GLN or PEPPOL must be between 10 and 50 characters",
	    "NO_EMAIL_ERROR": "The invoice number can not contain a @, if you want to send by e-mail choose \"Send by e-mail\".",
	    "PO_NUMBER": "Enter purchase order number",
	    "PO_NUMBER_ERROR": "A purchase order number must not contain more than 30 characters",
	    "INVOICING_MESSAGE_TYPE_EINVOICE": "<ul><li>E-invoices are sent electronically to the customer's internet bank through PEPPOL or GLN.</li>\n<li>A purchase order number (PO number) is given to you by the customer and is usually given in the form of a number of letters or numbers (optional to enter)</li></ul>",
	    "BECOME_AMBASSADOR": "Become Ambassador",
	    "PAYTERMS": "Due days",
	    "PAYTERMS_ERROR": "An error occured with the due days",
	    "DAYS": "days",
	    "PAYTERMS_LOW_WARNING": "Please note, to send an invoice with a due date of less than 30 days, you need to agree this with your customer.",
	    "PAYTERMS_HIGH_WARNING": "Please note, for invoices with a due date longer than 30 days, the salary will be paid as soon as we have received payment from the customer. ",
	    "WORK_PERIOD": "Work period",
	    "NEXT": "Next",
	    "WORKDATE_HOURS_INFO": "It is important that you enter dates and hours correctly as the information is used for income reports.",
	    "DEDUCTION_APPENDED_FILES": "Files",
	    "DEDUCTION_FILE_ERROR": "You can only upload a  png, jpeg, bmp, gif, doc or pdf and it cannot be larger than 2 MB ",
	    "DEDUCTION_INFO_BUTTON": "Information about expenses",
	    "DEDUCTION_INFO_SHORT": "Information about expenses",
	    "INVOICE_TOTAL_EXCL_VAT": "Total excl. VAT",
	    "INVOICE_YOUR_CUSTOMER_NO": "Your customer No.",
	    "INVOICE_YOUR_REFERENCE": "Your reference",
	    "INVOICE_OUR_REFERENCE": "Our reference",
	    "INVOICE_INVOICE_SERVICE": "Invoice service",
	    "INVOICE_PAYMENT_TERMS": "Payment terms",
	    "INVOICE_INTEREST_FEE": "Interest fee",
	    "INVOICE_PAYMENT_REMINDER_FEE": "Payment reminder fee 60.00 SEK.",
	    "INVOICE_VAT_RATE": "VAT rate",
	    "INVOICE_VAT": "VAT",
	    "INVOICE_ROUNDING": "Rounding",
	    "INVOICE_TOTAL_INCL_VAT": "Total incl. VAT",
	    "INVOICE_PLEASE_ALWAYS": "Please always enter OCR number when making the payment.",
	    "INVOICE_COMMENTS_MADE": "Comments made after 8 days will not be considered.",
	    "INVOICE_DAYS_NET": "net days",
	    "INVOICE_OCR_NUMBER": "OCR number",
	    "INVOICE_INVOICE_NO": "Invoice No.",
	    "INVOICE_DATE": "Invoice date",
	    "INVOICE_SWIFT_NO": "SWIFT No:",
	    "INVOICE_IBAN_NO": "IBAN No:",
	    "INVOICE_BANK_ACCOUNT_NO": "Bank account No:",
	    "INVOICE_BANKGIRO": "BankGiro:",
	    "INVOICE_IS_NOT_EU_CUSTOMER": "Export, article 15, 6th VAT-directive.",
	    "INVOICE_IS_EU_CUSTOMER": "Reverse charge, article 9.2e or 28c of 6th VAT directive.",
	    "INVOICE_INTEREST_FEE_VALUE": "24.00 %",
	    "INVOICE_COPY_DOWNLOAD": "Download invoice copy",
	    "INVOICE_COPY_ABOUT_PAGE": "Fill in the Invoice/OCR number and customer number to download a copy of the invoice.",
	    "INVOICE_COPY_ENTER_OCR_NUMBER": "Invoice/OCR number",
	    "INVOICE_COPY_ENTER_COMPANY_ID": "Customer number",
	    "INVOICE_COPY_COULD_NOT_FIND_INVOICE": "The invoice cannot be found, please check that the information is correct.",
	    "INVOICE_COPY_SUBMIT": "Download invoice copy",
	    "INVOICING_OPTION": "Invoicing by",
	    "INVOICING_OPTION_EMAIL": "Email",
	    "INVOICING_OPTION_MAIL": "Mail",
	    "INVOICING_OPTION_SMS": "SMS",
	    "INVOICING_OPTION_EINVOICE": "E-invoice",
	    "SEND_INVOICE_BY_EMAIL": "Send invoice by email",
	    "SEND_INVOICE_BY_MAIL": "Send invoice by mail",
	    "SEND_INVOICE_BY_SMS": "Send invoice by sms",
	    "SEND_INVOICE_BY_E_INVOICE": "Send invoice as e-invoice",
	    "SALARY_SETTINGS_TITLE": "Salary and allowance",
	    "SALARY_INFO": "Salary information",
	    "INCOME_TAX": "Income tax",
	    "OTHER_ALLOWANCE": "Other allowance",
	    "SAVE_PENSION_CHECKBOX": "Save pension",
	    "SAVE_VACATION_CHECKBOX": "Save holiday pay",
	    "ORDER_TOOL_TO_BE_PAID_ITP": "Occupational pension savings",
	    "TOOLTIP_ORDER_TOOL_TO_BE_PAID_ITP": "Frilans Finans automatically allocates 4.5%% of the gross salary (gross salary including holiday pay) to your occupational pension. “Saved for occupational pension” shows the amount allocated to SPP Pension & Försäkring. You can see your total savings and read more about how you can follow the value development under: Settings → Salary and benefits → “Occupational pension Read more”.",
	    "ORDER_TOOL_TO_BE_PAID_ITP_WORKER": "Your coworkers occupational pension savings",
	    "ORDER_TOOL_TO_BE_PAID_VACATION": "Holiday pay savings",
	    "TOOLTIP_ORDER_TOOL_TO_BE_PAID_VACATION": "Holiday pay is the percentage (12%%) of your gross salary that is saved for your holiday. Holiday pay is paid automatically and income tax is deducted upon payment. You can choose not to save holiday pay under: My pages → Settings → Salary and allowances. If you choose not to save the holiday pay, the same share will instead be paid with the salary.",
	    "ORDER_TOOL_TO_BE_PAID_VACATION_WORKER": "Your coworkers holiday pay saving",
	    "ORDER_TOOL_TO_BE_PAID_TOTAL": "Your total net balance",
	    "ORDER_TOOL_TO_BE_PAID_TOTAL_WORKER": "Your coworkers total net balance",
	    "TOOLTIP_TRAVEL_ALLOWANCE": "Here you can enter your tax-free mileage allowance with your own or a relative's car. You are entitled to tax-free compensation of SEK 25 SEK / 10 km. Please note that you can generally not claim car compensation for travel between home and regular place of work. Ordinary place of employment refers to the place where you perform most of your assignment, e.g. in the client's premises or office. Note that you may need to submit a driving record.",
	    "SHOW_CALCULATION": "Show calculation",
	    "HIDE_CALCULATION": "Hide calculation",
	    "CALCULATION_INVOICERY_FEE": "Frilans Finans",
	    "TOOLTIP_CALCULATION_INVOICERY_FEE": "Cost of administration and accounting.",
	    "CALCULATION_REWARDS_DISCOUNT": "Discount \"Together\"",
	    "CALCULATION_PAYROLL_TAX": "Payroll tax",
	    "TOOLTIP_CALCULTAION_PAYROLL_TAX": "Statutory fee for salary payments paid to the Swedish Tax Agency. The payroll tax finances Swedish social insurance such as the general pension.",
	    "CALCULATION_SPECIAL_PENSION_TAX": "Pension tax",
	    "TOOLTIP_CALCULATION_SPECIAL_PENSION_TAX": "Statutory tax on occupational pensions paid to the Swedish Tax Agency.",
	    "TOOLTIP_CALCULATION_GROSS_SALARY": "Gross salary is your salary that is left after Frilans Finans' administrative cost, employer contributions, occupational pension and any tax-free parts. The gross salary is presented including holiday pay and is paid at each salary payment. If you choose to save your holiday pay, it is reported separately.",
	    "CALCULATION_HOURLY_SALARY_VACATION_INCLUDED": "Hourly wage incl. holiday pay",
	    "CALCULATION_HOURLY_SALARY_VACATION_EXCLUDED": "Hourly wage excl. holiday pay",
	    "CALCULATION_INCOME_TAX": "Statutory tax",
	    "TOOLTIP_CALCULATION_INCOME_TAX": "Statutory tax on income from services paid to the Swedish Tax Agency.",
	    "TOOLTIP_CALCULATION_NET_SALARY": "Salary after taxes and fees.",
	    "MENU_PREREGISTERED_INVOICES": "Registered assignments",
	    "MENU_MY_INVOICING": "My invoicing",
	    "MENU_LOYALTY_PAGE": "Total points",
	    "POINTS_AND_SAVINGS": "Points and Savings",
	    "EARNED_REWARD_POINTS": "Your points",
	    "POINTS_AND_SAVINGS_LINK_PENSION": "Read more about occupational pension",
	    "POINTS_AND_SAVINGS_LINK_VACATION": "Change settings",
	    "POINTS_AND_SAVINGS_LINK_TOGETHER_REWARDS": "To Together Rewards",
	    "REWARD_POINTS": "Points",
	    "DASHBOARD_GREETING_1": "Hello %(name)s,",
	    "DASHBOARD_GREETING_2": "What do you want to do today?",
	    "DASHBOARD_INFO_LINK": "Read more about the difference between registering assignments and creating an invoice directly",
	    "ACTIVE_ASSIGNMENT": "Ongoing assignment",
	    "UPCOMNIG_ASSIGNMENT": "Upcoming assignment",
	    "PAST_ASSIGNMENT": "Work date has passed",
	    "REVIEW_INVOICE": "Review and create invoice",
	    "EDIT_INVOICE": "Edit",
	    "REGISTERED_ASSIGNMENTS_TITLE": "Registered assignments",
	    "REGISTERED_ASSIGNMENTS_TITLE_SHOW_ALL": "Show all assignments",
	    "REGISTERED_ASSIGNMENTS_DESCRIPTION": "As self-employed, it´s important that you feel secure in your work situation. We can more easily ensure good working conditions when you register your assignment, even if we also work with aftercare. Read more about how we work with %(insurancesLink)s and %(workingConditionsLink)s.",
	    "REGISTERED_ASSIGNMENTS_DESCRIPTION_INSURANCES_LINK": "insurances",
	    "REGISTERED_ASSIGNMENTS_DESCRIPTION_WORKING_CONDITIONS_LINK": "good working conditions",
	    "LOYALTY_POINTS_TITLE": "Collected points - Together",
	    "LOTALTY_START_LEVEL": "Start level",
	    "LOYALTY_TITLE_1": "Come",
	    "LOYALTY_TITLE_2": "Stay",
	    "LOYALTY_TITLE_3": "Share",
	    "LOYALTY_TITLE_4": "Dream",
	    "LOYALTY_TITLE_5": "Take off",
	    "LOYALTY_TITLE_6": "Fly",
	    "LOYALTY_DESCRIPTION_1": "Welcome to Together! When you use Frilans Finans, you, together with many other self-employed people, share necessary resources such as accounting economists, accountants, tax lawyers, labor law lawyers, and consulting. All self-employed workers have access to the resources of the large company but at a fraction of the actual cost. You could say that we share a company together instead of everyone having one company each. The level Come means the start of our journey together.",
	    "LOYALTY_DESCRIPTION_2": "Now you have collected over 100 000 points. Well done and thank you for being with us! Frilans Finans has always had a basic cost for administration, 6% of the invoice amount. We stick together and reduce your cost to 5.75%. The discount is deducted automatically. Enjoy!",
	    "LOYALTY_DESCRIPTION_3": "Now you have collected over 250 000 points. Good job! Frilans Finans has always had a basic cost for administration, 6% of the invoice amount. We share the trip together and reduce your cost to 5.5%. The discount is deducted automatically. Enjoy!",
	    "LOYALTY_DESCRIPTION_4": "Now you have collected over 500 000 points. Well done and thank you for the confidence to handle your invoicing! Frilans Finans has always had a basic cost for administratio, 6% of the invoice amount. We support your dream and reduce your cost to 5%. The discount is deducted automatically. Enjoy!",
	    "LOYALTY_DESCRIPTION_5": "Now you have collected over 1 000 000 points. Good job! Frilans Finans has always had a basic cost for administration, 6% of the invoice amount. We want to support you so you can lift even more and reduce your cost to 4.5%. The discount is deducted automatically. Enjoy!",
	    "LOYALTY_DESCRIPTION_6": "You have now collected over 1 500 000 points. What an impressive and inspiring work you do for both you and our entire organization! Frilans Finans has always had a basic cost for administration, 6% of the invoice amount. Now we fly together and reduce your cost to 4%. The discount is deducted automatically. Enjoy!",
	    "LOYALTY_ALWAYS_INCLUDED_TITLE": "Always included",
	    "LOYALTY_ALWAYS_INCLUDED_FAST_PAYMENT": "Fast salary payment",
	    "LOYALTY_ALWAYS_INCLUDED_ADVICE": "Advice",
	    "LOYALTY_ALWAYS_INCLUDED_HOTLINE": "The negotiation hotline",
	    "LOYALTY_ALWAYS_INCLUDED_BENEFITS": "Benefits",
	    "LOYALTY_HOW_TO_TITLE": "How to collect points",
	    "LOYALTY_HOW_TO_DESCRIPTION": "When you create an invoice for a registered assignment, you collect 1 point per invoiced krona. When you create an invoice directly, you collect 0.2 points per invoiced krona.\n\nThe points accrue to your points balance as soon as the invoice has been paid by your customer and are valid for 24 months. In the points history below, you see both your upcoming points and registered points.",
	    "LOYALTY_HOW_TO_LINK": "Click here to read more about the loyalty program",
	    "LOYALTY_POINTS_TABLE_TITLE": "Points history",
	    "LOYALTY_POINTS_TABLE_UPCOMING": "Upcoming points",
	    "LOYALTY_POINTS_TABLE_REGISTERED": "Registered points",
	    "LOYALTY_INFO_MODAL_TITLE": "What is the difference?",
	    "LOYALTY_INFO_MODAL_PREREGISTER_TITLE": "Register assignment",
	    "LOYALTY_INFO_MODAL_PREREGISTER_MAIL_TEXT": "Suitable for you if you have an upcoming assignment",
	    "LOYALTY_INFO_MODAL_PREREGISTER_HEART_TEXT": "1 point per invoiced swedish krona when you create an invoice from the assignment ",
	    "LOYALTY_INFO_MODAL_PREREGISTER_UMBRELLA_TEXT": "Guaranteed sick pay in accordance with the Sick Pay Act",
	    "LOYALTY_INFO_MODAL_PREREGISTER_SHIELD_TEXT": "We can more easily ensure that you work under good working conditions",
	    "LOYALTY_INFO_MODAL_INVOICE_TITLE": "Create invoice directly",
	    "LOYALTY_INFO_MODAL_INVOICE_MAIL_TEXT": "Suitable for you if you already have completed your assignment",
	    "LOYALTY_INFO_MODAL_INVOICE_HEART_TEXT": "0.2 points per invoiced swedish krona",
	    "REGISTERED_ASSIGNMENTS_TEXT": "Register an assignment by clicking on 'Register assignment' below. When the assignment is completed, you can create an invoice of the assignment by clicking on \"Review and leverage invoice\". You can also edit or delete assignments.",
	    "BUTTON_REGISTER_ASSIGNMENT": "Register assignment",
	    "BUTTON_CREATE_INVOICE": "Create invoice",
	    "BUTTON_CREATE_TENDER": "Create tender",
	    "BUTTON_WRITE_CONTRACT": "Write a contract",
	    "INVOICES_TABLE_TITLE_CUSTOMER": "Customer",
	    "INVOICES_TABLE_TITLE_CREATED": "Created",
	    "INVOICES_TABLE_TITLE_ORDER_NUMBER": "Order nr.",
	    "INVOICES_TABLE_TITLE_SUM_EXCL_VAT": "Sum excl. VAT",
	    "INVOICES_TABLE_TITLE_STATUS": "Status",
	    "INVOICES_TABLE_TITLE_MORE": "More",
	    "SENT_PREREPORT_MODAL_TITLE": "Your assignment is registered",
	    "SENT_PREREPORT_MODAL_REGISTERED": "Your assignment is now registered",
	    "SENT_PREREPORT_MODAL_WORK_DONE": "You perform the assignment",
	    "SENT_PREREPORT_MODAL_EASY_INVOICING": "You easily create an invoice and do not have to fill in all the information",
	    "SENT_PREREPORT_MODAL_PREREGISTER_AGAIN_BTN": "Register another assignment",
	    "SENT_PREREPORT_MODAL_DONE_BTN": "Done",
	    "INVOICE_OVERVIEW": "Invoice overview",
	    "CONFIRM_PREREGISTER_MODAL_TITLE": "Summary",
	    "CONFIRM_PREREGISTER_MODAL_TEXT": "You are about to register an assignment with following information",
	    "CONFIRM_PREREGISTER_MODAL_PERIOD": "Period:",
	    "CONFIRM_PREREGISTER_MODAL_PERIOD_TO": "to",
	    "CONFIRM_PREREGISTER_MODAL_SUBMIT": "Register assignment",
	    "CONFIRM_INVOICE_MODAL_TITLE": "Summary",
	    "CONFIRM_INVOICE_MODAL_TEXT": "You are about to create an invoice with following information",
	    "CONFIRM_INVOICE_MODAL_EMAIL_TO": "Email to ",
	    "CONFIRM_INVOICE_MODAL_MAIL_TO": "Mail to",
	    "CONFIRM_INVOICE_MODAL_E_INVOICE_TO": "E-invoice to",
	    "CONFIRM_INVOICE_MODAL_SMS_TO": "SMS to",
	    "CONFIRM_INVOICE_MODAL_SUBMIT": "Create invoice",
	    "SENT_INVOICE_MODAL_TITLE": "Your invoice has been created",
	    "SENT_INVOICE_MODAL_INVOICE_CREATED": "You have created an invoice",
	    "SENT_INVOICE_MODAL_INVOICE_REVIEWED_BY_FF": "Invoice sent for review by client support",
	    "SENT_INVOICE_MODAL_SENT_TO_COMPANY": "The invoice is sent to your customer and you receive a confirmation email",
	    "SENT_INVOICE_MODAL_INVOICE_AGAIN_BTN": "Create another invoice",
	    "SENT_INVOICE_MODAL_DONE_BTN": "Done",
	    "INVOICE_DETAILS_ORDER_NUMBER": "Order number #%(ordernumber)s",
	    "INVOICE_DETAILS_SPECIFICATION": "Specification",
	    "INVOICE_DETAILS_WORK_DATES": "Work dates",
	    "INVOICE_DETAILS_INVOICE_AMOUNT": "Invoice amount",
	    "INVOICE_DETAILS_YOUR_COMPENSATION": "Your compensation",
	    "INVOICE_DETAILS_DEDUCTION": "Deductions",
	    "INVOICE_DETAILS_NO_DEDUCTIONS": "You have no deductions",
	    "INVOICE_DETAILS_COMPENSATION": "Employee's compensation",
	    "INVOICE_DETAILS_TOGETHER_REWARDS": "Together rewards",
	    "INVOICE_DETAILS_INVOICING_RECIPIENT": "Customer information",
	    "INVOICE_DETAILS_INVOICING_REFERENCE": "Reference",
	    "INVOICE_DETAILS_INVOICING_DETAILS": "Details",
	    "INVOICE_DETAILS_INVOICING_ORDER_NUMBER": "Order nr",
	    "INVOICE_DETAILS_INVOICING_ORDER_SENT_AS": "Invoice sent as",
	    "INVOICE_DETAILS_INVOICING_VIEW_HOURS": "View hours worked",
	    "INVOICE_DETAILS_INVOICING_REGISTERED_ASSIGNMENT": "Registered assignment",
	    "INVOICE_DETAILS_REWARDS_ORDER_NUMBER": "Order nr",
	    "INVOICE_DETAILS_REWARDS_POINTS": "Total points",
	    "INVOICE_DETAILS_REWARDS_REGISTERED_ASSIGNMENT": "Registered assignment",
	    "INVOICE_DETAILS_REWARDS_STATUS": "Points status",
	    "INVOICE_DETAILS_REWARDS_TO_PAY": "Total to be paid",
	    "INVOICE_DETAILS_REVIEW_AND_CREATE_INVOICE": "Review and create invoice",
	    "BUTTON_REVIEW_AND_CREATE_INVOICE": "Review and create invoice",
	    "REVIEW_AND_CREATE_INVOICE_DESCRIPTION": "Before you create your invoice, you get the opportunity to review your entries. To edit information and create your invoice, press the \"Go to invoice tool\" button. You will find the button at the bottom.",
	    "REVIEW_AND_CREATE_INVOICE_TO_PAY": "To pay to your bank account",
	    "REVIEW_AND_CREATE_INVOICE_TO_PAY_ITP": "Saved for occupational pension",
	    "REVIEW_AND_CREATE_INVOICE_TO_PAY_VACATION": "Saved for vacation",
	    "REVIEW_AND_CREATE_INVOICE_CREATE_ASSIGNMENT_BUTTON": "Create invoice",
	    "REVIEW_AND_CREATE_INVOICE_EDIT_ASSIGNMENT_BUTTON": "Go to the invoice tool",
	    "REVIEW_AND_CREATE_INVOICE_TO_BE_PAID_TOTAL": "Total net balance",
	    "LOYALTY_POINTS_TABLE_FRILANS_FINANS": "Frilans Finans",
	    "LOYALTY_POINTS_TABLE_SHOW_MORE_POINTS": "Show more +",
	    "LOYALTY_POINTS_TABLE_ALL_POINTS_ARE_LOADED": "All points are loaded",
	    "LOYALTY_POINTS_TABLE_NO_PENDING_POINTS": "You have no pending points",
	    "LOYALTY_POINTS_TABLE_NO_COMPLETE_POINTS": "You have no registered points",
	    "REGISTER_ASSIGNMENT_CUSTOMER_TEXT": "Here you specify who you are to perform the task for.",
	    "REGISTER_ASSIGNMENT_MONEY_DISTRIBUTION_TEXT": "Here you see the expected payment to your account and how much that will be saved for your occupational pension. If you have chosen to save holiday pay, you can also see that amount. By clicking on \"Show details\", you can claim deductions, add employees and see the complete calculation. The information in this section is not shared with your client.",
	    "REGISTER_ASSIGNMENT_UPDATE_INVOICE": "Update",
	    "REGISTER_ASSIGNMENT_REGISTER_SAVE_DRAFT": "Complete registration",
	    "REGISTER_ASSIGNMENT_CANCEL_BUTTON": "Cancel",
	    "REGISTER_ASSIGNMENT_CLOSE_INVOICE_TOOL": "Close",
	    "REGISTER_ASSIGNMENT_ROT_RUT_TEXT": "Here you fill in if your assignment refers to a job that entitles your customer to root and square deductions.",
	    "REGISTER_ASSIGNMENT_INVOICING_TEXT": "Here you choose how the upcoming invoice is to be sent to your customer. By entering it now, you can send your invoice faster when the assignment is completed.",
	    "REGISTER_ASSIGNMENT_INVOICE_TEXT": "Describe your assignment in as much detail as you can. This information is the description of the assignment's upcoming invoice that is sent to your customer.",
	    "REGISTER_ASSIGNMENT_WORK_DATE_TEXT": "Here you fill in the working hours you plan for your assignment. You can also choose whether this information should be displayed on future invoices.\n\nDo you have many work dates? Click on the week number to mark the whole week Mon-Fri.",
	    "REGISTER_ASSIGNMENT_INVOICE_TOOL": "REGISTRATION OF ASSIGNMENT",
	    "REGISTER_ASSIGNMENT_INFO_MODAL_TITLE": "Welcome to registration of assignments",
	    "REGISTER_ASSIGNMENT_INFO_MODAL_HOW_TITLE": "How does it work?",
	    "REGISTER_ASSIGNMENT_INFO_MODAL_BENEFITS_TITLE": "Benefits",
	    "REGISTER_ASSIGNMENT_INFO_MODAL_ENVELOPE_OPEN": "You register your upcoming assignment in this tool",
	    "REGISTER_ASSIGNMENT_INFO_MODAL_PENCIL": "You can easily change or delete your assignment after you have registered it",
	    "REGISTER_ASSIGNMENT_INFO_MODAL_FILE_ADD": "When the assignment is completed, you create the invoice and do not have to fill in all the information",
	    "REGISTER_ASSIGNMENT_INFO_MODAL_UMBRELLA": "Guaranteed sick pay in accordance with the Sick Pay Act",
	    "REGISTER_ASSIGNMENT_INFO_MODAL_SHIELD_CHECK": "We can more easily ensure that you work under good working conditions",
	    "REGISTER_ASSIGNMENT_INFO_MODAL_HEART": "You collect more points in the loyalty program Together",
	    "LEVEL_CURRENT_LEVEL": "Your level",
	    "LEVEL_NEXT_LEVEL": "Next level",
	    "INVOICE_TOOL_PREVIEW_INVOICE_TEXTLINK": "See invoice that will be sent to customer",
	    "INVOICE_TOOL_CREATE_INVOICE_BUTTON": "Create invoice",
	    "INVOICE_TOOL_COMPLETE_BUTTON": "Complete invoice",
	    "CANCEL_BUTTON": "Cancel",
	    "INVOICE_REWARDS_WAITING_ON_PAYMENT": "Awaiting payment from customer",
	    "INVOICE_REWARDS_REGISTERED": "Points registered",
	    "INVOICE_TOOL_INVOICE_UPDATED_TITLE": "Invoice updated",
	    "INVOICE_TOOL_INVOICE_UPDATED_BODY": "Your changes have been saved",
	    "INVOICE_TOOL_ASSIGNMENT_UPDATED_TITLE": "Registered assignment updated",
	    "INVOICE_TOOL_ASSIGNMENT_UPDATED_BODY": "Your changes have been saved",
	    "TOOLTIP_CALCULATION_REWARDS_DISCOUNT": "Du har uppnått en nivå i lojalitetsprogrammet Together som ger dig rabatt på Frilans Finans administation cost (over head). Du kan se hur mycket rabatt du har genom att gå in på Min fakturering --> Samlade poäng.",
	    "LOYALTY_CHART_TITLE": "Your collected points",
	    "LOYALTY_CHART_NEXT_LEVEL": "Next level:",
	    "LOYALTY_CHART_POINTS_OF": "of",
	    "AFFECTED_ITP_MODAL_ONE_TITLE": "Now it will be even safer to be an umbrella contractor at Frilans Finans 🎉",
	    "AFFECTED_ITP_MODAL_ONE_BODY": "From April 7, 2022, we automatically activate savings for your occupational pension every time you invoice. This is so that you have a stable and sustainable economy when it's time to retire.\n\nIf you want to save occupational pension already now, you can activate it under \"Salary and compensation\" in \"Settings\".\n\nYou can always contact client support if you have any questions.",
	    "AFFECTED_ITP_MODAL_TWO_TITLE": "Now things are happening! 🎉",
	    "AFFECTED_ITP_MODAL_TWO_BODY": "We now automatically set aside savings for your occupational pension every time you create an invoice. This is so that you will have a stable and sustainable economy when it's time to retire. You see the new distribution of money in the invoicing tool.\n\nIn addition, we are launching the loyalty program Together, a way for you to collect points and at the same time receive discounts. Read more about your points under \"My invoicing\" -> \"Collected points\".",
	    "EXCEEDING_WORKING_HOURS_TITLE": "You have entered more than 48 hours in 7 days",
	    "EXCEEDING_WORKING_HOURS_BODY": "The working time you specified exceeds 48 hours in 7 days. If you can influence your working hours, we recommend more rest to reduce the risk of accidents.\n\nIf you choose to carry out the specified working hours, we will ask 4 questions about your working conditions when creating the invoice.",
	    "CHANGE_WORKING_HOURS": "Change working hours",
	    "SEND_SURVEY_RESPONSE": "Submit your response",
	    "ENTERED_WRONG_HOURS": "I entered the wrong working hours",
	    "MORE_INFORMATION": "More information",
	    "QUESTIONS_WORKING_CONDITIONS": "Questions about your working conditions:",
	    "SURVEY_INFORMATION_TEXT": "In order for us to be able to ensure that you work under good working conditions, we want you to answer a few questions or change your working time.",
	    "OPTIONAL_COMMENT": "Optional comment",
	    "QUESTION_1_TITLE": "Question 1",
	    "QUESTION_1_QUESTION": "Do you have the possibility to arrange your working hours so that they do not exceed 48 hours during a seven-day period?",
	    "QUESTION_2_TITLE": "Question 2",
	    "QUESTION_2_QUESTION": "Do you think that you have worked in that extent that you do not have time for a proper recovery between different tasks / assignments?",
	    "QUESTION_3_TITLE": "Question 3",
	    "QUESTION_3_QUESTION": "Are there risks in your work environment, e.g. work with machines or similar in the workplace?",
	    "QUESTION_3-1_TITLE": "Question 3.1",
	    "QUESTION_3-1_QUESTION": "Do you use equipment / tools / machines that may pose a risk to you?",
	    "QUESTION_3-2_TITLE": "Question 3.2",
	    "QUESTION_3-2_QUESTION": "Do you use any vehicle in the workplace? ",
	    "QUESTION_3-3_TITLE": "Question 3.3",
	    "QUESTION_3-3_QUESTION": "Do you drive a vehicle to and from work?",
	    "QUESTION_3-4_TITLE": "Question 3.4",
	    "QUESTION_3-4_QUESTION": "Do you work at a high altitude (> 2m)?",
	    "QUESTION_4_TITLE": "Question 4",
	    "QUESTION_4_QUESTION": "Do you estimate that the working hours in your future assignments will exceed 48 hours during a seven-day period?",
	    "OTHER_RISK_COMMENT": "Other risk/information",
	    "MORE_INFORMATION_TEXT": "Frilans Finans' assignment includes working to ensure that your work as a self-employed employee is part of an economically and socially sustainable working life. One of several initiatives to realize this goal is the collective agreement we have signed with the politically independent trade union Säljarnas Riksförbund, which, among other things, defines what is sustainable working hours.\n\nThe working hours you have specified exceed 48 hours during a seven-day period, which may constitute an increased risk of working environment and is therefore not compatible with the purpose of the Working Hours Act. When we are tired the risk of an accident or incident increases.\n\nThe social partners state that it is understandable that it may sometimes be necessary to work more during a temporary period, for example due to the art of work or a temporary situation that arises. By answering the questions, we can assess whether you have the opportunity for recovery.",
	    "WORKING_HOURS_INFO_MODAL_TITLE": "Why is working hours important",
	    "WORKING_HOURS_INFO_MODAL_BODY": "When you invoice through Frilans Finans, you are, in order to be able to invoice without F-tax, employed by Frilans Finans during the assignment period. The registered working hours form the basis for your employment and then also income information to, among other things, the social insurance office and employer certificate. We also want to be able to ensure that you work under good working conditions.\n\nIf you invoice several customers for the same working hours, e.g. If a PT has held a group training and invoices several group members for the same time, it is important to divide the time on all invoices. The same hour is otherwise registered several times.",
	    "LOW_HOURLY_SALARY_MODAL_TITLE": "Is your hourly wage correct?",
	    "LOW_HOURLY_SALARY_MODAL_BODY": "During your assignment, you are employed by Frilans Finans. According to our collective agreement, a reasonable hourly wage is %(minimumHourlySalary)s SEK excluding holiday pay at your age. Based on the stated invoice amount and working hours, your hourly wage is %(currentHourlySalary)s SEK excluding holiday pay.\n\nYou can still create an invoice with the current hourly wage, but we will then contact you to ensure that you work under good conditions.\n\nIf you want your hourly wage to be %(minimumHourlySalary)s SEK excluding holiday pay, you can either add %(addAmount)s SEK excluding VAT to your invoice amount or reduce your working hours by %(removeHours)s hours.\n\nYou can see your current hourly wage under step 3 “Allocation of money” -> “Show details” -> “Show calculation” in the invoicing tool.",
	    "MODAL_COMPLETE_INFORMATION": "Complete your information",
	    "LOG_IN_REMEMBER_ME": "Remember me",
	    "LOG_IN_CANCEL": "Cancel login",
	    "NO_BANK_ID": "Don't have BankID?",
	    "LOG_IN_WITH_EMAIL_LINK": "Log in with email and password",
	    "LOG_IN_WITH_BANKID_LINK": "Log in with BankID",
	    "REGISTER_HAVE_ACCOUNT": "Do you already have an account?",
	    "COMPLETE_INFORMATION_ORDER_TOOL_TITLE": "Fill in your details to create the invoice",
	    "FIRST_NAME_ERROR_INVALID_CHARACTERS": "First name contains invalid characters",
	    "LAST_NAME_ERROR_INVALID_CHARACTERS": "Last name contains invalid characters",
	    "COMPLETE_INFORMATION_ORDER_TOOL_CONTACT_INFO_TAB": "Contact information",
	    "COMPLETE_INFORMATION_ORDER_TOOL_SALARY_INFO_TAB": "Salary payment",
	    "COMPLETE_INFORMATION_ORDER_TOOL_INVOICING_INFO_TAB": "Your invoicing",
	    "COMPLETE_INFORMATION_ORDER_TOOL_CONTACT_INFO_DESCRIPTION": "We need contact information to be able to communicate about e.g. salary payment, invoice status and eventual questions.",
	    "COMPLETE_INFORMATION_ORDER_TOOL_SALARY_INFO_DESCRIPTION": "We need your account information to be able to pay your salary.",
	    "COMPLETE_INFORMATION_ORDER_TOOL_INVOICING_INFO_DESCRIPTION": "We need information about the work you will invoice for to e.g. be able to insure you and ensure that you work in a sustainable way.",
	    "COMPLETE_INFORMATION_ORDER_TOOL_INVOICING_INFO_SUB_DESCRIPTION": "Choose the profession that best matches your work tasks. If you invoice for several different types of work, you can choose the profession that corresponds to the majority of your assignments.",
	    "COMPLETE_INFORMATION_ORDER_TOOL_INVOICING_INFO_SAVE_VACATION": "Save holiday pay",
	    "COMPLETE_INFORMATION_ORDER_TOOL_INVOICING_INFO_PAY_VACATION": "Pay out together with the salary",
	    "MODAL_SAVE_VACATION_INVOICING_INFO_CONTINUE_AS_IT_IS": "Continue as it is today",
	    "COMPLETE_INFORMATION_ORDER_TOOL_INVOICING_INFO_SAVE_VACATION_INFO": "* We recommend that you save your holiday pay if you work more than 480 hours (3 months) each year.",
	    "MODAL_SAVE_VACATION_TITLE": "You have worked a lot 👏🏼",
	    "MODAL_SAVE_VACATION_BODY": "Great that you have many assignments and good job! When you work a lot, it is important to rest and enjoy the holidays. To be able to fully enjoy, it could be nice to have holiday money saved. Do you want to start saving your holiday pay? 🏖\n\nIf you choose to save the holiday pay, we will pay it out around June 19th each year (or when you request it). This will result in you getting paid less with each invoicing, but instead receive the money when it's time for holiday.",
	    "MODAL_VACATION_INFORMATION_TITLE": "Holiday day",
	    "MODAL_VACATION_INFORMATION_BODY": "As an umbrella contractor, you can choose how your holiday pay is to be handled. It´s possible to get it paid with the salary you receive for each completed assignment or save it and get it paid out around June 19th each year. You can change your settings before each invoice if you wish.\n\nFrom our collective agreement (in swedish): \nSemester § 6 \nSemester tjänas in under perioden 1 april till 31 mars varje år. För uppdrag kortare än tre månader och där den egenanställde arbetstagaren så önskar ska semesterersättning uppgående till 12 procent löpande betalas ut utöver den lön som den egenanställde arbetstagaren erhåller. Detta belopp ska särredovisas i lönespecifikationen till den anställde så att det tydligt framgår vad som utgör lön och vad som utgör semesterersättning. Den egenanställde arbetstagaren kan särskilt begära att semestersättning ska ackumuleras vid uppdrag kortare än 3 månader. Har inte annat överenskommits mellan den egenanställde arbetstagaren och arbetsgivaren ska semesterförmånerna betalas i samband med huvudsemestern. Arbetsgivaren betalar då ut de ackumulerade semesterförmånerna den 25 juni varje år. ",
	    "SENT_PREREPORT_UPDATE_MODAL_TITLE": "The assignment has been updated",
	    "UPDATE": "Update",
	    "SSNR_MODAL_HEADER": "Welcome as an umbrella contractor!",
	    "SSNR_MODAL_TEXT": "Enter your social security number. We need it to register the correct tax with the tax authority and be able to establish employers´s certificate.",
	    "SSNR_MODAL_PLACEHOLDER": "YYYYMMDD-XXXX",
	    "SSNR_MODAL_SMALL_TEXT": "Frilans Finans processes all data in accordance with the data protection regulation (GDPR) and thus confidentially.",
	    "SSNR_MODAL_IMAGE": "https://www.frilansfinans.se/wp-content/uploads/2022/10/FF_TE_210916_24-scaled.jpg",
	    "EMAIL_MODAL_TITLE": "Welcome to Frilans Finans!",
	    "EMAIL_MODAL_TEXT": "Please enter your email. We use your email to provide you with updates on your invoice and to communicate in matters relating to your assignments.",
	    "EMAIL_MODAL_IMAGE": "https://www.frilansfinans.se/wp-content/uploads/2022/10/ff_stockholm-office-corner-1-scaled.jpg",
	    "LOGIN_LINK_SENT_CHECK_YOUR_EMAIL": "A login link has been sent to your email.\n\nThis link is valid one time for 30 minutes.",
	    "INVOICE_TOOL_LOCK_INVOICE_ERROR_TITLE": "Invoice currently being reviewed",
	    "INVOICE_TOOL_LOCK_INVOICE_ERROR_MESSAGE": "You cannot edit the invoice at this time. An administrator is currently handling the invoice. If you need to change something on the invoice, please contact us.",
	    "BETA_BANNER_TEXT_TITLE": "Sneak peek! 👀",
	    "BETA_BANNER_TEXT_SUBTITLE": "New, fresh Frilans Finans awaits your review. Welcome to test the beta version.",
	    "BETA_BANNER_BUTTON": "Open Beta Version" /* eslint-enable */
	
	};

/***/ },
/* 816 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/* eslint-disable */exports.default = {
	    "hello": "Hej",
	    "name": "Namn",
	    "invoice": "Faktura",
	    "que": "vad",
	    "one": "en",
	    "LOGIN": "Logga in",
	    "LOGOUT": "Logga ut",
	    "CREATE_INVOICE": "Skapa faktura",
	    "MENU": "Meny",
	    "MY_PAGES": "Meny",
	    "ACTIVITIES": "Hem",
	    "ECONOMY": "Ekonomi",
	    "CREATE_NEW_INVOICE": "Skapa faktura",
	    "CREATE_NEW_TENDER": "Skapa offert",
	    "CREATE_CONTRACT": "Skapa uppdragsavtal",
	    "CURRENT_ERRANDS": "Dina aktuella fakturor",
	    "CURRENT_ERRANDS_SHOW_MORE": "Visa alla fakturor",
	    "ERRAND_TABLE_NO_INVOICES": "Inga fakturor att visa",
	    "ERRAND_TABLE_ALL_INVOICES_ARE_LOADED": "Alla aktuella fakturor inladdade",
	    "ERRAND_TABLE_TABLE_SHOW_MORE_INVOICES": "Visa fler",
	    "STATUS": "Status",
	    "IN_PROGRESS": "Bearbetas",
	    "SALARY_PAYMENT": "Löneutbetalning",
	    "INVOICE_PAYMENT": "Fakturabetalning",
	    "APPROVED": "Godkänd",
	    "NOT_APPROVED": "Ej godkänd",
	    "APPROVED_WITH_RES": "Godkänd",
	    "CREATED_DATE": "Skapad %(date)s",
	    "DATE": "Datum",
	    "DATE_ERROR": "Du måste välja ett datum",
	    "EXPECTED_TO": "Beräknad till \n%(date)s",
	    "EXPIRES": "Förfaller\n%(date)s",
	    "PAID": "Utbetald\n%(date)s",
	    "INVOICE_PAID": "Betald\n%(date)s",
	    "ORDER_APPROVED": "Godkänd\n%(date)s",
	    "INOVICE_LAST_12": "Fakturerat de senaste 12 månaderna",
	    "NO_INVOICES_LAST_12": "Du har inga fakturor för de senaste 12 månaderna",
	    "JAN": "jan",
	    "FEB": "feb",
	    "MAR": "mar",
	    "APR": "apr",
	    "MAY": "maj",
	    "JUN": "jun",
	    "JUL": "jul",
	    "AUG": "aug",
	    "SEP": "sep",
	    "OCT": "okt",
	    "NOV": "nov",
	    "DEC": "dec",
	    "YEARS": "år",
	    "PENSION_VACATION": "Pension och semester",
	    "CHANGE": "Ändra inställningar",
	    "SAVED_VACATION": "Sparad semesterersättning",
	    "SAVED_PENSION": "Sparad tjänstepension",
	    "NEWS": "Nyheter",
	    "INFORMATION": "Information",
	    "FAQ": "Vanliga frågor",
	    "SUPPORT": "Support",
	    "CONTACT": "Kontakt",
	    "INSURANCES": "Försäkringar",
	    "WORKING_ENVIRONMENT": "Goda arbetsvillkor",
	    "CHECK_YOUR_WORK_ENVIRONMENT": "Kontrollera din arbetsmiljö",
	    "CHECK_YOUR_WORK_ENVIRONMENT_URL": "https://www.frilansfinans.se/wp-content/uploads/2022/05/Frilans-Finans-Checklista-allman-2022.pdf",
	    "REPORT_ACCIDENT": "Rapportera tillbud eller olycka",
	    "REPORT_ACCIDENT_LINK": "https://www.frilansfinans.se/wp-content/uploads/2022/09/N-9.1-A-Blankett-for-rapporteri-ng-av-olycka-eller-tillbud-v1.4.pdf",
	    "PRIVACY_POLICY": "Integritetspolicy",
	    "SOCIAL_MEDIAS": "Sociala medier",
	    "FACEBOOK": "Facebook",
	    "TWITTER": "Twitter",
	    "LINKEDIN": "LinkedIn",
	    "INSTAGRAM": "Instagram",
	    "CREATE_ACCOUNT": "Skapa konto",
	    "CREATE_ACCOUNT_SUCCESS_MSG": "Ditt konto är nu skapat. Vi har skickat ett mail till dig med instruktioner om hur du aktiverar ditt konto.",
	    "COOKIE_INFO": "Information om cookies",
	    "PERSONAL_ADMIN": "Dina personliga adminsitratör är",
	    "SWEDEN": "Sverige",
	    "NORWAY": "Norge",
	    "DENMARK": "Danmark",
	    "YOUR_INVOICES": "Dina fakturor",
	    "YOUR_INVOICES_TEXT": "Här hittar du alla dina fakturor. Här kan du även granska, spara ner, och skriva ut dina fakturor. Filtrera din sökning genom att välja period i kalendern nedan. Din faktura blir synlig senast 24 timmar efter att fakturan skapats, alternativt nästföljande vardag. ",
	    "CUSTOMER": "Kund",
	    "CREATED": "Skapad",
	    "ORDER_NR": "Ordernr.",
	    "SUM_EX_VAT": "Belopp ex. moms",
	    "INVOICE_STATUS": "Fakturastatus",
	    "INVOICE_PAY_SHORT": "Fakturabet.",
	    "INVOICE_PAY": "Fakturabetalning",
	    "PRINT": "Granska",
	    "PREREGISTERED_INVOICES": "Dina föranmälda arbeten",
	    "PREREGISTERED": "Föranmäld",
	    "PREREGISTERED_INVOICES_TABLE_SHOW_MORE_INVOICES": "Visa fler",
	    "PREREGISTERED_INVOICES_TABLE_ALL_INVOICES_ARE_LOADED": "Alla aktuella föranmälningar inladdade",
	    "PREREGISTERED_INVOICES_TABLE_NO_INVOICES": "Inga aktuella föranmälningar",
	    "DATE_COMPARE_ERROR": "Slutdatum måste vara högre än startdatum",
	    "PAY_ID": "LöneID",
	    "WORK_DATE": "Arbetsdatum",
	    "WORK_DATE_VISIBILITY": "Visning av arbetsdatum",
	    "WORK_DATE_SHOW_DATES": "Visa datum på fakturan",
	    "WORK_DATE_SHOW_HOURS": "Visa timmar på fakturan",
	    "PAY_SALARY": "Utbetald summa",
	    "YOUR_SALARIES": "Dina lönespecifikationer",
	    "YOUR_SALARIES_TEXT": "Här finns alla dina lönespecifikationer för alla uppdrag du utfört via Frilans Finans. Filtrera din sökning genom att välja period i kalendern.",
	    "FROM": "Från",
	    "TO": "Till",
	    "COPY": "Kopia",
	    "INVOICES": "Fakturor",
	    "SALARIES": "Lönespecifikationer",
	    "EMPLOYER_CERTIFICATE": "Arbetsgivarintyg",
	    "EMPLOYER_CERTIFICATE_TEXT": "När din faktura har blivit godkänd kan du via den här sidan beställa arbetsgivarintyg. Arbetsgivarintyg kan behövas om man t.ex. ska söka ersättning hos a-kassan.",
	    "EMPLOYER_CERTIFICATE_CHOOSE_PERIOD": "1. Välj datum för perioden",
	    "EMPLOYER_CERTIFICATE_ORDERING": "2. Leveranssätt",
	    "EMPLOYER_CERTIFICATE_PERIOD_WORKDATES": "Beställ arbetsgivarintyg för vald period",
	    "EMPLOYER_CERTIFICATE_PERIOD_INVOICES": "Beställ arbetsgivarintyg för enskilda fakturor",
	    "EMPLOYER_CERTIFICATE_BY_AI_NU": "Skicka arbetsgivarintyg via <a href=\"https://www.arbetsgivarintyg.nu\" target=\"_blank\">arbetsgivarintyg.nu</a> (möjligt för dig som är medlem i någon a-kassa)",
	    "EMPLOYER_CERTIFICATE_BY_MAIL": "Skicka arbetsgivarintyg med post (1-3 arbetsdagar)",
	    "NO_EMPLOYER_CERTIFICATES": "Du har inga fakturor för den valda perioden",
	    "EMP_CERT_SUCCESS": "Ditt arbetsgivarintyg är beställt! Intyget kommer sammanställas och skickas till dig inom kort. Har du några frågor eller funderingar är du välkommen att kontakta Klientstöd på info@frilansfinans.se eller 0771-15 10 00.",
	    "GROSS_SALARY": "Bruttolön",
	    "GROSS_SALARY_H": "Bruttolön/h",
	    "ORDER_EMP_CERT": "Beställ arbetsgivarintyg",
	    "CONTRACTS": "Avtal",
	    "YOUR_CONTRACTS": "Dina avtal",
	    "CONTRACTS_YOU_CUST": "Avtal mellan dig och kund",
	    "YOUR_CONTRACTS_TEXT": "Här finns olika mallar att utgå ifrån när du behöver skriva avtal med din kund om exempelvis bildrättigheter. Obs. Detta är inte anställningsavtal, eftersom du är visstidsanställd av Frilans Finans för varje uppdrag.",
	    "CHOOSE_CONTRACT": "Välj avtal",
	    "DOWNLOAD": "Ladda ner",
	    "CONTRACT_FF": "Avtal med Frilans Finans",
	    "CONTRACT_FF_TEXT": "Du som egenanställd ingår avtal med oss på Frilans Finans genom att godkänna de allmänna villkoren och anställningsvillkoren vid fakturatillfället. Rättigheter och skyldigheter mellan dig/er och Frilans Finans regleras i och med detta godkännande. Här är en sammanställning av dina ingångna avtal med Frilans Finans. ",
	    "CONDITIONS": "Villkor",
	    "SHOW_MORE": "Visa fler",
	    "CONTRACT_SHORT_TERM": "Avtal om visstidsanställning",
	    "NO_CONTRACTS": "Du har inga avtal för den valda tidsperioden",
	    "GENERAL_TERMS": "Generella arbetsvillkor",
	    "DEDUCTIONS": "Avdrag",
	    "YOUR_DEDUCTIONS": "Dina avdrag",
	    "YOUR_DEDUCTIONS_TEXT": "Här finns alla avdrag du gjort i dina fakturor via Frilans Finans.",
	    "ADD_DEDUCTION": "Lägg till avdrag",
	    "ADD_DEDUCTION_RECEIPT": "Klicka här för att bifoga kvitto (kvittot skickas ej till kund)",
	    "DEDUCTION_FILE_INFO": "Lägg in de kostnader du haft i samband med ditt uppdrag. Observera att avdragsbeloppet inte automatiskt adderas på fakturabeloppet. Ska din kund stå för kostnaderna adderar du in kvittobeloppet exkl. moms på fakturabeloppet.\nFör att vi ska kunna behandla dina avdrag behöver du inkomma med dina kvitton. Digitala kvitton samt fysiska kvitton som ej överstiger 2000kr bifogar du direkt i fakturaverktyget. I det fall du ej har möjlighet att ladda upp kvittot i fakturaverktyget så kan du maila det till avdrag@frilansfinans.se (endast om du inte har laddat upp kvittot här). Om kvittot är i pappersformat och överstiger 2000 kr så skickas detta till vår postadress i Uppsala. Kom ihåg att skriva kvittots Levid på kvittot. Vi påminner även om att spara originalkvitton i minst 3 år i de fall du skickar in kvittokopior.",
	    "DEDUCTION_FILE_CONFIRMATION": "Jag bekräftar att jag sparar ett eventuellt fysiskt kvitto i minst 3 år",
	    "DEDUCTION_FILE_CONFIRMATION_ERROR": "För att lägga till avdraget behöver du bekräfta sparande av kvittot",
	    "EDIT_DEDUCTION": "Ändra avdrag",
	    "DEDUCTION_AMOUNT": "Summa avdrag",
	    "DEDUCTION_GUIDE": "Avdragsguide",
	    "DEDUCTION_GUIDE_LINK": "https://www.frilansfinans.se/wp-content/uploads/2023/01/Avdragsguide_2023-1.pdf",
	    "PICK_DEDUCTION_CATEGORY": "Välj en avdragskategori",
	    "DEDUCTION_CATEGORY": "Avdragsguide",
	    "DEDUCTION_CATEGORY_ERROR": "Du måste välja en avdragskategori",
	    "TO_DE_GUIDE": "Till avdragsguiden",
	    "CLEAR": "Rensa",
	    "CATEGORY": "Kategori",
	    "LEV_ID": "Levid",
	    "SUPPLIER": "Leverantör",
	    "SUPPLIER_ERROR": "Du måste ange en leverantör",
	    "ARRIVED": "Inkommet",
	    "SUM": "Summa",
	    "PAID_DATE": "Utbet. datum",
	    "PREREGISTER_INVOICE": "Föranmäl faktura",
	    "PREREGISTER_INVOICE_TEXT": "Du som ansöker om a-kassa behöver informera Frilans Finans när, var och med vem du ska arbeta innan uppdraget påbörjas. Föranmäl ett uppdrag genom att klicka på 'Föranmäl faktura' här nedan, välj sedan 'Föranmäl/spara utkast'. När uppdraget är slutfört kan du skicka din föranmälda faktura, färdigställda fakturor finner du under \"Fakturor\".",
	    "CONTROL_STATEMENT": "Kontrolluppgifter",
	    "YOUR_CONTROL_STATEMENT": "Dina kontrolluppgifter",
	    "YOUR_CONTROL_STATEMENT_TEXT": "Här finns dina kontrolluppgifter som vi har skickat till Skatteverket och som finns förtryckta i din deklaration. ",
	    "NO_STATEMENTS": "Du har inga tillgängliga kontrolluppgifter",
	    "CHOOSE_INCOME_YEAR": "Välj inkomstår",
	    "INSURANCES_HEADING": "Frilans Finans Basförsäkring ingår alltid utan kostnad",
	    "INSURANCES_TEXT_1": "När du arbetar via Frilans omfattas du av ett kraftigt försäkringsskydd bestående av en olycksfall- och livförsäkring (motsvarande kollektivavtalsenlig tjänstegrupplivförsäkring, TGL). Du omfattas även av en ansvarsförsäkring som skyddar dig om olyckan skulle vara framme. Ta del av fullständiga försäkringsvillkor via länkarna nedan. ",
	    "GROUP_INS": "GRUPPFÖRSÄKRINGSPLAN, OLYCKSFALLSFÖRSÄKRINg",
	    "INS_GROUP": "Allmänna villkor, Gruppförsäkrning",
	    "INS_LETTER_ACC": "Försäkringsbrev olycksfall",
	    "INS_ENT_MON": "Försäkringsbrev entreprenad och montage",
	    "INS_TECH": "Försäkringsbrev tekniska konsulter",
	    "INS_ADV": "Försäkringsbrev Rådgivande-/datakonsulter",
	    "INS_RESP": "Försäkringsbrev ansvarsförsäkring allmän- och produktansvar",
	    "INS_RESP_ENG": "Försäkringsbrev ansvarsförsäkring på engelska",
	    "INS_TRAVEL_LETTER": "Reseförsäkring försäkringsbrev",
	    "INS_TRAVEL_ADV": "Reseförsäkring goda råd",
	    "INS_TRAVEL_COND": "Reseförsäkring villkor",
	    "INS_INFO": "TGL Försäkringsinformation",
	    "INS_COND": "TGL Försäkringsvillkor",
	    "ITP_COND": "Tjänstepension villkor",
	    "ITP": "Tjänstepension",
	    "ITP_RATE": "Tjänstepensionsavsättning",
	    "ITP_FLEXIBLE": "Flexibel tjänstepesion",
	    "ITP_FLEXIBLE_FAQ": "FAQ flexibel tjänstepesion",
	    "ITP_READ_MORE": "Läs mer",
	    "DAMAGE_REPORT_INS": "Skadeanmälan, olycksfallsförsäkring",
	    "REGISTER_INS": "ANMÄLAN TJÄNSTEGRUPPLIVFÖRSÄKRING TGL",
	    "FORGOT_PASSWORD": "Glömt lösenord",
	    "RESET_PASSWORD": "Återställ lösenord",
	    "RESET_PASSWORD_TEXT": "Ange den e-postadress du angav när du skapade ditt konto. En länk för lösenordsåterställning skickas därefter ut till angiven e-postadress. ",
	    "RESET_PASSWORD_SUCCESS": "Vi har skickat instruktioner om återställande av ditt lösenord till din mail.",
	    "EMAIL": "E-postadress",
	    "EMAIL_BILLING": "E-postadress för faktura",
	    "EMAIL_BILLING_SECONDARY": "Sekundär e-postadress för faktura (valfritt)",
	    "REPEAT_EMAIL": "Upprepa e-postadress",
	    "EMAIL_NOT_EQUAL": "E-postadresserna är inte likadana",
	    "PASSWORD": "Lösenord",
	    "FIRST_NAME": "Förnamn",
	    "LAST_NAME": "Efternamn",
	    "MOBILE_PHONE": "Mobiltelefonnummer",
	    "APPROVE_TERMS": "Genom att skapa ett konto godkänner jag",
	    "FF_TERMS": "Frilans Finans Villkor",
	    "FF_TERMS_AND_PERSONAL_INFORMATION_BEING_TREATED": "Jag godkänner att mina personuppgifter behandlas i enlighet med",
	    "MY_CUSTOMERS": "Mina kunder",
	    "MY_CUSTOMERS_TEXT": "Här kan du ta bort eller ändra befintliga kunder. Nya kunder lägger du in i fakturaverktyget.",
	    "ORG_NR": "Orgnr",
	    "REF": "Referens",
	    "REF_ERROR": "En referens får max vara 30 tecken",
	    "ADDRESS": "Adress",
	    "EDIT": "Ändra",
	    "SETTINGS": "Inställningar",
	    "SETTINGS_TEXT": "Här fyller du i och ändrar dina personuppgifter. Du hittar dina kontouppgifter under 'Lön och ersättningar' i menyn till vänster.",
	    "PERSONAL_INFO": "Personuppgifter",
	    "POSTAL_CODE": "Postnummer",
	    "TELEPHONE_NR": "Telefonnummer",
	    "BANK_INFO": "Bankinformation",
	    "CLEAR_NR": "Clearingnummer",
	    "ACCOUNT_NR": "Kontonummer",
	    "BANK": "Bank",
	    "EMPLOYMENT_INVOICE": "Fakturainställningar",
	    "PROFESSION": "Yrke",
	    "CALC_KEY": "Skattesats",
	    "ROT_RUT": "Rot- och Rutavdrag",
	    "ACTIVATE_ROT_RUT": "Aktivera Rot- och Rutavdrag",
	    "READ_MORE": "Läs mer",
	    "SAVE_TO_PENSION": "Spara till <a href=\"https://www.frilansfinans.se/fragor-och-svar/tjanstepension/\" target=\"_blank\">tjänstepension</a> och <a href=\"https://www.frilansfinans.se/fragor-och-svar/semesterersattning/\" target=\"_blank\">semesterersättning</a>",
	    "PENSION": "Tjänstepension",
	    "VACATION_MONEY": "Semesterersättning",
	    "VACATION_MONEY_READ_MORE": "Läs mer",
	    "USE_LOGO": "Använd egen logotyp",
	    "USE_LOGO_TEXT": "Det finns möjlighet att använda din egen logotyp i dina fakturor. Kostnaden är 225 SEK/år.",
	    "UPLOAD_LOGO": "Ladda upp logotyp",
	    "LOGO_INSTRUCTIONS": "Släpp din logotyp här eller klicka för att ladda upp",
	    "LOGO_ERROR": "Du kan endast välja en bild av typen png eller jpeg och den får max vara 2MB stor",
	    "CURRENT_PASSWORD": "Nuvarande lösenord",
	    "CURRENT_PASSWORD_ERROR": "Det nuvarande lösenordet är inte korrekt",
	    "CHANGE_PASSWORD": "Ändra lösenord",
	    "NEW_PASSWORD": "Nytt lösenord",
	    "REPEAT_PASSWORD": "Upprepa nytt lösenord",
	    "PASSWORD_NOT_EQUAL": "Lösenorden är inte likadana",
	    "SAVE_SETTINGS": "Spara inställningar",
	    "FIRST_NAME_ERROR": "Du måste ange ett förnamn på minst 2 tecken",
	    "LAST_NAME_ERROR": "Du måste ange ett efternamn på minst 2 tecken",
	    "EMAIL_ERROR": "Du måste ange en e-postadress",
	    "CITY": "Ort",
	    "CITY_ERROR": "Du måste ange en ort med minst 2 och som mest 40 tecken",
	    "POSTAL_CODE_ERROR": "Du måste ange ett postnummer",
	    "TELEPHONE_ERROR": "Du måste ange ett svenskt telefonnummer",
	    "PERSONAL_NUMBER": "Personnummer",
	    "PERSONAL_NUMBER_ERROR": "Du måste ange ett personnummer med 12 siffror",
	    "PERSONAL_NUMBER_ERROR_BACKEND": "Ogiltigt personnummer",
	    "ADDRESS_ERROR": "Du måste ange en adress med minst 3 och som mest 50 tecken",
	    "CLEAR_NR_ERROR": "Du måste ange ett clearingnummer på fyra siffror. Den femte siffran i clearing ska inte anges",
	    "ACCOUNT_NR_ERROR": "Du måste ange ett kontonummer med minst 1 siffra",
	    "BANK_ERROR": "Du måste ange en bank",
	    "PROFESSION_ERROR": "Du måste ange ett yrke",
	    "CALC_KEY_ERROR": "Du måste välja en omräkningsnyckel",
	    "NO_SWEDISH_ACCOUNT": "Jag saknar ett svenskt kontonummer",
	    "IBAN": "IBAN",
	    "BIC": "BIC",
	    "IBAN_ERROR": "Det är inte ett korrekt IBAN-nummer",
	    "BIC_ERROR": "Det är inte ett korrekt BIC-nummer",
	    "EDIT_CUSTOMER": "Redigera kunduppgifter",
	    "NAME_ERROR": "Du måste ange ett namn på minst 4 och som mest 50 bokstäver",
	    "ORG_NR_ERROR": "Du måste ange ett organisationsnummer",
	    "CONTACT_ERROR": "En kontakt måste ha minst 4 bokstäver",
	    "CONTACT_MAX_ERROR": "En referens får inte vara längre än 30 tecken",
	    "CO": "C/O",
	    "CO_ERROR": "C/O måste ha minst 4 bokstäver",
	    "COUNTRY": "Land",
	    "COUNTRY_ERROR": "Du måste ange ett land",
	    "BACK": "Tillbaka",
	    "SAVE": "Spara",
	    "FF_TITLE": "Frilans Finans Sverige AB",
	    "GENERAL_ERROR": "Något gick fel. Var god försök igen senare.",
	    "LOGIN_NO_EMAIL": "Du måste ange en e-postadress",
	    "LOGIN_NO_PASSWORD": "Du måste ange ett lösenord",
	    "LOGIN_ERROR": "Fel kombination av lösenord och e-postadress",
	    "LOGIN_403_ERROR": "Du kunde tyvärr inte logga in just nu, prova igen om en liten stund. \nFungerar det fortfarande inte? Prova att byta lösenord",
	    "NO_INVOICES": "Du har inga fakturor för den valda perioden",
	    "NO_PRE_INVOICES": "Du har inga föranmälda arbeten",
	    "SEK_SHORT": "Kr",
	    "EURO_SHORT": "Euro",
	    "DOLLAR_SHORT": "$",
	    "SEK": "SEK",
	    "WITH_RES": "Med res.",
	    "IS_PAID": "Betald",
	    "NOT_PAID": "Obetald",
	    "PART_PAID": "Delbetald",
	    "WAIT_JUDGEMENT": "Väntar på bedömning",
	    "WAIT_PAYMENT": "Väntar på kundbetalning",
	    "NO_RESULTS_FOUND": "Inga resultat hittades",
	    "WELCOME_TEXT": "Hej %(date)s! Vad vill du göra idag?",
	    "NO_CUSTOMERS": "Du har inga inlagda kunder",
	    "NAME": "Namn",
	    "CUSTOMER_UPDATED": "%(name)s är nu uppdaterad",
	    "PRE_REG_DATE": "Föranmäld datum: %(date)s",
	    "INVOICE_PRE_REG": "Fakturan föranmäld",
	    "YES": "Ja",
	    "NO": "Nej",
	    "INVOICE_SPEC": "Specifikation",
	    "WORKER": "Arbetstagare",
	    "WORKER_PAY": "Arbetstagare löneuppgifter",
	    "PAY_DETAILS": "Löneuppgifter",
	    "SALARY_NET": "Lön netto",
	    "TO_ACCOUNT": "Till kontonummer",
	    "SALARY_GROSS": "Lön brutto",
	    "ALLOWANCE": "Traktamente",
	    "TRAVEL_ALLOWANCE": "Milersättning ",
	    "TRAVEL_ALLOWANCE_REMEMBER": "(kom i håg att fylla i och spara ",
	    "TRAVEL_ALLOWANCE_REMEMBER_LINK_TEXT": "körjournalsmallen)",
	    "TRAVEL_ALLOWANCE_REMEMBER_LINK_URL": "https://www.frilansfinans.se/wp-content/uploads/2023/04/frilansfinans-korjournal-mall.pdf",
	    "PART_OF_INVOICE": "Summa att utbetala ",
	    "NO_DEDUCTIONS": "Du har inga avdrag för den valda perioden",
	    "SUMMARY": "Summering",
	    "INVOICE_AMOUNT": "Fakturabelopp exkl. moms",
	    "VAT": "Moms",
	    "SUM_INC_MOMS": "Summa inkl moms",
	    "CURRENCY": "Valuta",
	    "CURRENCY_RATE": "Valutakurs",
	    "CURRENCY_VAL": "Valutavärde",
	    "ONGOING": "Pågående",
	    "NEW": "Ny",
	    "WAITING": "Väntar",
	    "CREDITED": "Krediterad",
	    "DISPUTE": "Bestridan",
	    "INVOICE_NOT_CHECKED": "Faktura inte kontrollerad",
	    "LEVRES": "Levrespost avslutad",
	    "INVOICE_NOT_CREATED": "Faktura inte skapad",
	    "TO_PAYMENT": "Till betalning",
	    "PAID_FILE": "Betald vid fil",
	    "OLD_POST": "Gammal post, ej utbetald",
	    "DOWNLOAD_AS_PDF": "Spara som PDF och skriv ut",
	    "CLOSE": "Stäng",
	    "SETTINGS_UPDATED": "Dina inställningar är uppdaterade",
	    "OWN_EMPLOYMENT": "Fakturainställningar",
	    "OWN_EMPLOYMENT_READ_MORE": "Läs mer",
	    "PASSWORD_LENGTH_ERROR": "Lösenordet måste vara minst 8 tecken varav en versal och en siffra",
	    "CALCULATOR": "Kalkylator",
	    "CALCULATOR_TEXT": "Fyll i fakturabelopp eller lön",
	    "AMOUNT_INVOICE": "Belopp att fakturera",
	    "AMOUNT_INVOICE_PLACEHOLDER": "Fakturerat belopp (ex. moms)",
	    "AFTER_TAX": "efter skatt",
	    "SALARY_AFTER_TAX": "Lön efter skatt",
	    "ADV_CALC": "Gör en mer avancerad uträkning",
	    "HIDE_ADV_CALC": "Dölj avancerade uträkningar",
	    "SAVE_PENSION": "Avsätt tjänstepension 4.5 %",
	    "SAVE_VACATION": "Semesterspara 12 %",
	    "TRAVEL_ALLOWANCE_SEK": "Traktamente SEK",
	    "TRAVEL_FEE_SEK": "Milersättning SEK",
	    "HOW_CALC": "Se hur vi räknat",
	    "HIDE_HOW_CALC": "Dölj hur vi räknat",
	    "INVOICE_INC_VAT": "Fakturabelopp inkl. moms",
	    "FRILANS_FINANS": "Frilans Finans 6 % avgift",
	    "SOCIAL_FEES": "Sociala avgifter",
	    "GROSS_SALARY_VACATION": "Bruttolön inkl. semesterersättning",
	    "GROSS_EXCL_VACATION": "Bruttolön exkl. semesterersättning",
	    "TAX": "Skatt",
	    "NET_SALARY_VACATION": "Nettolön inkl. semesterersättning",
	    "NET_EXCL_VACATION": "Nettolön exkl. semesterersättning",
	    "CLOSE_INVOICE_TOOL": "Stäng fakturaverktyget",
	    "ACCOUNT_SETTINGS": "Kontoinställningar",
	    "INVOICE_TOOL": "Fakturaverktyget",
	    "INVOICE_PART_ONE": "Fakturadel 1",
	    "INVOICE_PART_TWO": "Fakturadel 2",
	    "CUSTOMER_TEXT": "Här anger du vem fakturan ska skickas till.",
	    "CUSTOMER_CHOOSE_TEXT": "Välj en kund från listan eller skapa en ny kund.",
	    "CUSTOMER_ADD": "Lägg till ny kund",
	    "HOURS": "Timmar",
	    "WORK_DATE_TEXT": "Det är viktigt att din arbetstid är korrekt ifylld om du skulle behöva ersättning från försäkringskassan eller andra myndigheter, %(readMoreLink)s. Du väljer själv om du vill visa arbetstiden på fakturan.",
	    "WORK_DATE_TEXT_LINK": "läs mer om varför här",
	    "ROT_RUT_TEXT": "Fyll i här om din faktura avser ett arbete som berättigar din kund till rot- och rutavdrag.",
	    "SHOW_DATE": "Visa datum på fakturan",
	    "ALT_ONE": "Nej",
	    "ALT_TWO": "Ja",
	    "ROT": "Rot-avdrag",
	    "RUT": "Rut-avdrag",
	    "BRF": "Fastighetsbet./BRF Org.nr",
	    "ROT_RUT_READ_MORE": "Läs mer om Rot- och Rutavdrag",
	    "INVOICE_TEXT": "Beskriv ditt arbete så utförligt du kan. Denna information utgör beskrivningen på fakturan som skickas till din kund.  ",
	    "CHOOSE_CUSTOMER": "Välj en kund",
	    "EDIT_INFO": "Redigera information",
	    "ADD_WORK_DATE": "Lägg till arbetsdatum",
	    "WORKED_HOURS": "Arbetade timmar/dag",
	    "CAMPAIGN_CODE_TITLE": "Har du en kampanjkod?",
	    "CAMPAIGN_CODE": "Kampanjkod",
	    "SAME_DAY_PAYMENT": "Vill du ha utbetalning samma dag?",
	    "AMOUNT_TO_BILL_EXCL_VAT": "Belopp att fakturera (exkl. moms)",
	    "INVOICE_DUE_DATE": "Förfallodag",
	    "ADDED_LATER": "Sätts senare",
	    "BANK_GIRO": "Bankgiro",
	    "VAT_READ_MORE": "Läs mer om moms",
	    "AMOUNT_INCL_VAT": "Belopp inkl. moms",
	    "AMOUNT": "Belopp",
	    "INC_VAT": "Inkl. moms",
	    "EXCL_VAT": "Exkl. moms",
	    "VALUE_ERROR": "Du måste ange ett värde",
	    "MONEY_DISTRIBUTION": "Fördelning av pengar",
	    "MONEY_DISTRIBUTION_TEXT": "Här ser du hur mycket som kommer utbetalas till ditt bankkonto och hur mycket som sparas till din tjänstepension. Har du valt att spara semesterersättning kan du även se det beloppet. Genom att klicka på “Visa detaljer” kan du yrka avdrag, lägga till medarbetare samt se fullständig uträkning. Informationen i detta avsnitt delas inte med din uppdragsgivare/kund.",
	    "TO_PAY_TO_MY_ACCOUNT": "Utbetalas till dig",
	    "INVOICING": "Fakturering",
	    "INVOICING_TEXT": "Här väljer du hur fakturan ska skickas till din kund.",
	    "SEND_INVOICE_AS_LETTER": "Skicka faktura som brev",
	    "SEND_INVOICE_AS_EMAIL": "Skicka faktura som e-post",
	    "HAVE_READ": "Jag har tagit del av och godkänner härmed de per denna dag gällande",
	    "INVOICE_TERMS_AND_CONDITIONS": "Avtal om allmän visstidsanställning, allmänna villkor samt arbetsmiljödokumenten.",
	    "INVOICE_TERMS_AND_CONDITIONS_1": "avtal om särskild visstidsanställning",
	    "INVOICE_TERMS_AND_CONDITIONS_2": "generella villkoren",
	    "INVOICE_TERMS_AND_CONDITIONS_2_INCL": "generella arbetsvillkor (inkl. rätten att arbeta)",
	    "INVOICE_TERMS_AND_CONDITIONS_3": "arbetsmiljödokumenten",
	    "INVOICE_TERMS_AND_CONDITIONS_4": "bilaga behandling av personuppgifter.",
	    "INVOICE_TERMS_AND_CONDITIONS_AND": "samt",
	    "INVOICE_TERMS_AND_CONDITIONS_EMPTY": "För att se villkoren måste du välja kund, arbetsdatum och skriva en specifikation.",
	    "REGISTER_SAVE_DRAFT": "Föranmäl/Spara utkast",
	    "PREVIEW": "Förhandsgranska",
	    "INVOICE_TOOL_GIRO": "783-6539",
	    "OMR_KEY": "Skattesats",
	    "SPECIAL_PENSION_TAX": "Löneskatt tjänstepension",
	    "NET_SALARY": "Nettolön",
	    "COWORKERS": "Medarbetare",
	    "ADD_COWORKER": "Lägg till medarbetare",
	    "TO_PAY": "Att utbetala",
	    "TO_PAY_WORKER": "Att utbetala till din medarbetare",
	    "PROFESSION_TITLE": "Yrkestitel",
	    "PERSONAL_NUMBER_FORMAT": "ÅÅÅÅMMDDXXXX",
	    "STREET_ADDRESS": "Gatuadress",
	    "POSTAL_CODE_ABBR": "Postnr.",
	    "NO_SALARIES": "Du har inga lönespecifikationer",
	    "ADD": "Lägg till",
	    "ADD_NEW_COWORKER": "Lägg till ny medarbetare",
	    "ADD_SELECTED_COWORKER": "Lägg till vald medarbetare",
	    "INVOICETOOL_EXPENSES": "Här kan du göra avdrag för kostnader som direkt kan härleds till detta uppdrag. För fördjupad information se länken här till vänster Så här gör du avdrag.",
	    "INVOICETOOL_TAX_KEY": "Omräkningsnyckeln baseras på arbetsgivaravgift och Frilans Finans avgift om 6 %%. Omräkningsnyckeln kan skilja sig från person till person och är beroende av ålder, yrke och angiven skattesats.\n",
	    "INVOICETOOL_VACATION_PAY": "Den andel (12 %%) av din bruttolön som arbetsgivaren lägger undan till dig för din framtida semester. Vill du att Frilans Finans ska avsätta semesterersättning åt dig kan du reglera detta under kontoinställningar högst upp i fakturaverktyget, beloppet beräknas och betalas ut automatiskt.",
	    "INVOICETOOL_ITP": "Tjänstepension är den del av din pension som din arbetsgivare avsätter för dig utöver den allmänna pensionen. Frilans Finans avsätter en grundläggande tjänstepension om 4.5%% av din bruttolön (bruttolön inkl. semesterersättning) för dig som är 25-66 år. \n\nÄr du mellan 18-24 år kan du välja att avsätta tjänstepension under “Inställningar” → “Lön och ersättningar”. Önskar du att det avsätts högre belopp reglerar du detta under kontoinställningar.",
	    "INVOICETOOL_GROSS": "Bruttolön avser lönesumman innan skatteavdrag. \n",
	    "INVOICETOOL_TAX": "Baseras på angiven skattesats, arbetsgivaravgift och Frilans Finans avgift om 6 %%. Omräkningsnyckeln kan skilja sig från person till person och är beroende av ålder, yrke och angiven skattesats.\n",
	    "INVOICETOOL_NET": "Nettolön avser lönesumman efter skatteavdrag och sociala avgifter.\n",
	    "INVOICETOOL_ALLOWANCE": "Traktamenten är till för att täcka dina privata, förhöjda levnadskostnader som uppstår och är nödvändiga för ditt uppdrags utförande. Rätt till traktamenten har du om arbetet sker mer än 5 mil från hemorten samt att övernattning sker på annan ort än hemorten. Skatteverket har fastställt traktamentet till 290 kr per dygn. Notera att traktamenten för tjänsteförrättning i annat land skiljer, vänligen kontakta oss för information om aktuella belopp och land.\n",
	    "INVOICETOOL_TRAVEL": "Här kan du addera underlag för kostnader som uppstått vid resa i samband med tjänst. Du har rätt till skattefri ersättning om 25 sek/mil. Observera att du bara kan yrka milersättning för resor som inte gått till och från ditt ordinarie tjänsteställe. Med ordinarie tjänsteställe menas den plats där du utför merparten av ditt uppdrag, som t.ex. uppdragsgivarens eller kundens lokal, kontor eller verkstad.",
	    "INVOICETOOL_TOPAY": "Den här summan är det belopp som betalas ut till ditt konto. Det är summan av nettolön, milersättning, traktamente minus skatter och avgifter.",
	    "INVOICETOOL_PREVIEW": "Här kan du se hur din faktura ser ut. Kontrollera gärna att du fyllt i rätt kund och fakturabelopp exkl. moms.",
	    "INVOICETOOL_SAVE": "OBS! Denna funktion är till för dig som vill börja skapa en faktura och sedan färdigställa den vid annat tillfälle. Denna funktion är också till för för dig som skall uppbära eventuell ersättning från A-kassa baserat på inkomster från Frilans Finans. För att uppfylla A-Kassans krav om att du som arbetstagare skall vara osjälvständig meddelar du Frilans Finans när, var och vad för slags arbete du skall utföra innan det påbörjas. Denna information lämnar du genom att minimum mata in kund och arbetsdatum i 'Registrera faktura', välj sedan 'Spara faktura'. Den påbörjade fakturan finns nu sparad på 'Mina sidor' och när du vill slutfakturera fortsätter du att mata in resterande uppgifter och slutför faktureringen. \n\nMindre avvikelser accepteras. T ex om någon arbetsdag har förskjutits några dagar eller om det har blivit fel arbetsdagar än vad det var från början planerat. Arbetet räknas ändå som föranmält.",
	    "INVOICETOOL_VAT": "Skatteverkets huvudregel är att varor och tjänster som faktureras inom Sverige ska ha ett momspåslag på 25 %%. Det finns dock några få undantagsfall där skattesatsen kan vara 12, 6 eller 0 procent. Exempel på undantagsfall med 6 %% moms är upphovsrättsskyddat material.\nExport, arbete på internationellt vatten, CSN-berättigad utbildning samt viss typ av sjukvård är momsbefriade. Artist- och musikergager har 25 %% momspåslag, förutom när artisten eller musikern äger det fakturerande bolaget varvid gagerna är momsbefriade.\n\nFrilans Finans förbehåller sig rätten att korrigera momsen i de fall det vid granskning av fakturaunderlaget upptäcks vara fel moms angiven. Ändringen kan i vissa fall medföra att fakturabeloppet inkl. moms justeras. Om du är osäker på vilken momssats som gäller för ditt arbete, tveka inte att kontakta Frilans Finans Klientstöd på 0771-15 10 00.",
	    "BECOME_CLIENT_OF_THE_MONTH": "Bli Månadens egenanställd",
	    "CLIENT_OF_THE_MONTH_MOTIVATION": "Mitt roligaste jobb",
	    "YOUR_PHOTO": "Bild på dig själv",
	    "YOUR_PHOTO_WORKING": "Bild på dig under yrkesutövning",
	    "UPLOAD": "Ladda upp",
	    "IMAGE_SIZE_500_PX": "Bilden bör vara minst 500 pixlar bred.",
	    "ADD_COWORKERS": "Lägg till medarbetare",
	    "TEST": "Test",
	    "PASSWORD_ERROR_ORIGINAL": "Lösenordet uppfyller inte kraven",
	    "PASSWORD_ERROR_REPEAT": "Lösenord stämmer inte överens",
	    "PASSWORD_ERROR": "Ange ett lösenord med minst 12 tecken. Lösenordet måste innehålla bokstäver (både versaler och gemener), siffror och specialtecken. För att ange ett säkert lösenord, inkludera inte någon uppenbar personlig information eller vanliga ord. Ange inte heller ett lösenord som du redan använder på någon annan webbplats. ",
	    "SEND": "Skicka",
	    "CANCEL": "Avbryt",
	    "ACCOUNT_CLEARING_NUMBER_ERROR": "Clearingnumret passar inte ihop med kontonumret",
	    "EMAIL_ALREADY_REGISTERED": "E-postadressen är redan registrerad",
	    "INVOCETOOL_SHOW_HOURS": "Visa timmar på fakturan",
	    "CREATE_PASSWORD": "Skapa nytt lösenord",
	    "PASSWORD_UPDATED": "Ditt lösenord är nu uppdaterat. Du kan gå vidare till login",
	    "PASSWORD_UPDATED_2": "Du kan gå vidare till login",
	    "PICK_COUNTRY": "Välj ett land",
	    "CONFIRM_CLOSE_TOOL": "Är du säker på att du vill stänga fakturaverktyget? Eventuella förändringar kommer tas bort.",
	    "SEND_TO_EMAIL_INFO": "Genom att fylla i en e-postadress i fältet kommer fakturan att skickas som en PDF till kunden ",
	    "BIC_IBAN_INFO": "Ange BIC och IBAN om medarbetaren inte har svenskt bankkonto",
	    "TOOLTIP_ORM": "Baseras på angiven skattesats, arbetsgivaravgift och Frilans Finans avgift om 6 %%. Omräkningsnyckeln kan skilja sig från person till person och är beroende av ålder, yrke och angiven skattesats.",
	    "TOOLTIP_ITP": "Tjänstepension är den del av din pension som din arbetsgivare avsätter för dig utöver den allmänna pensionen. Frilans Finans avsätter en grundläggande tjänstepension om 4,5 %% av din bruttolön (bruttolön inkl. semesterersättning) för dig som är mellan 25-66 år. \n\nÄr du mellan 18-24 år kan du välja att avsätta tjänstepension under “Inställningar” → “Lön och ersättningar”. Önskar du att det avsätts högre belopp reglerar du detta under kontoinställningar.",
	    "TOOLTIP_VACATION": "Den andel (12 %%) av din bruttolön som arbetsgivaren lägger undan till dig för din framtida semester. Vill du att Frilans Finans ska avsätta semesterersättning åt dig kan du reglera detta under kontoinställningar högst upp i fakturaverktyget, beloppet beräknas och betalas ut automatiskt.\n",
	    "TOOLTIP_GROSS": "Bruttolön avser lönesumman innan skatteavdrag. \n",
	    "TOOLTIP_TAX": "Avser din inkomstskatt, en direkt skatt på inkomst.",
	    "TOOLTIP_NET": "Nettolön avser lönesumman efter skatteavdrag och sociala avgifter.\n",
	    "TOOLTIP_TRAVEL": "Här kan du addera underlag för kostnader som uppstått vid resa i samband med tjänst. Du har rätt till skattefri ersättning om 25 sek/mil. Observera att du bara kan yrka milersättning för resor som inte gått till och från ditt ordinarie tjänsteställe. Med ordinarie tjänsteställe menas den plats där du utför merparten av ditt uppdrag, som t.ex. uppdragsgivarens eller kundens lokal, kontor eller verkstad.",
	    "TOOLTIP_DEDUCTION": "Här kan du addera underlag för ”kostnader nödvändiga för yrkets förvärvande”, med andra ord kostnader nödvändiga för att utföra och slutföra ditt uppdrag. Kostnaden som uppstår måste förbrukas under fakturaperioden och får därmed inte ha ett bestående värde. Se Avdragsguide för mer information.",
	    "TOOLTIP_WORKER": "Här kan du lägga till en eller flera medarbetare och fördela uppdragets arvode mellan er.\n",
	    "TOOLTIP_ALLOWANCE": "Traktamente är till för att täcka dina privata, förhöjda levnadskostnader som uppstår i samband med resande i tjänst. För att ha rätt till traktamente kräver Skatteverket att du arbetar minst 50 kilometer hemifrån samt att övernattning sker på annan ort än hemorten. Skatteverket har fastställt traktamentet i Sverige till 290 kr per dygn. Traktamentet varierar beroende på land man arbetar i. Vänligen kontakta oss på Klientstöd om du har några frågor kring traktamente.",
	    "TOOLTIP_CHECKBOX": "Genom att kryssa i rutan så kommer arbetstagarens del av fakturabeloppet att låsas.",
	    "HIDE_DETAILS": "Dölj detaljer",
	    "SHOW_DETAILS": "Visa detaljer",
	    "VACATION_PAY": "Semesterersättning",
	    "INCORRECT_LOGIN": "Du har angivit felaktiga inloggningsuppgifter",
	    "COMPANY": "Företag",
	    "PRIVATPERSON": "Privatperson",
	    "DELETE": "Ta bort",
	    "DELETE_CUSTOMER": "Är du säker på att du vill ta bort %(name)s?",
	    "FOOTER_LINK_FAQ": "https://www.frilansfinans.se/fragor-och-svar/",
	    "FOOTER_LINK_SUPPORT": "https://www.frilansfinans.se/sa-har-fungerar-det/",
	    "FOOTER_LINK_CONTACT": "https://www.frilansfinans.se/kontakta-oss/",
	    "FOOTER_LINK_INS": "https://www.frilansfinans.se/vara-forsakringar/",
	    "FOOTER_LINK_FACEBOOK": "https://www.facebook.com/FrilansFinans/",
	    "FOOTER_LINK_PRIVACY_POLICY": "https://www.frilansfinans.se/integritetspolicy/",
	    "FOOTER_LINK_LINKEDIN": "https://www.linkedin.com/company/frilans-finans-sverige-ab",
	    "FOOTER_LINK_TWITTER": "https://twitter.com/frilansfinans/",
	    "FOOTER_LINK_INSTAGRAM": "https://www.instagram.com/frilansfinans/",
	    "FOOTER_CONTACT_TEXT": "info@frilansfinans.se\n\nTelefon: 0771-15 10 00",
	    "FOOTER_OPEN_TEXT": "Öppet vardagar 9.00-17.00",
	    "FOOTER_LINK_COOKIE": "https://www.frilansfinans.se/information-om-cookies/",
	    "UPDATE_INVOICE": "Uppdatera faktura",
	    "ACCOUNT_ACTIVATED": "Ditt konto är nu aktiverat. Du kan nu logga in.",
	    "CREATE_TENDER_LINK": "https://www.frilansfinans.se/wp-content/uploads/2023/06/Offertmall-svenska-2023.docx",
	    "CREATE_CONTRACT_LINK": "https://www.frilansfinans.se/wp-content/uploads/2023/06/FrilansFinans_Uppdragsavtal-fullSV_S221020.pdf",
	    "LOCK_AMOUNT": "Lås belopp",
	    "EXPRESS_PAYMENT_INFO": "Expressutbetalning innebär att Frilans Finans betalar ut din lön samma dag du skickar in fakturaunderlaget (gäller fakturor som inkommer vardagar senast kl. 15.00). Oftast når pengarna ditt konto nästkommande vardag, skickar du in fakturaunderlaget innan kl. 11.00 når pengarna ditt konto redan samma dag.\n\nFör att kunna bevilja expressutbetalning behöver villkoren för förskottsutbetalning vara uppfyllda. Frilans Finans gör även en samlad kreditbedömning av faktuarunderlaget där vi bl.a. kontrollerar:\n\nAtt kunden är kreditvärdig, har god betalningsförmåga och inte har några betalningsanmärkningar.\nAtt du inte har några betalningsanmärkningar.\nAtt kund inte utgörs av dig själv eller annan part vari du har väsentlig intressegemenskap.\nAtt arbetsdagen/arbetsdagarna inte är äldre än 30 dagar.\nAtt förfallodagar inte är över 30 dagar.\nAtt kund är ett registrerat företag hos Bolagsverket.\nAtt kund är belägen i Sverige.\nAtt fordran gällande arbetet du utfört inte är föremål för tvist.\n\nKostnaden för expressutbetalning är endast 1,5 %% utöver Frilans Finans ordinarie avgift.\n\nFAQ\nVad händer om villkoren för förskottsbetalning inte uppfylls?\nFrilans Finans kommer då ta bort kostanden för express från ditt fakturaunderlag och vid godkänt fakturaunderlag skicka fakturan till kund. Din lön kommer utbetalas efter kund betalt fakturan.\n",
	    "EXPRESS_PAYMENT": "Expressbetalning",
	    "EXPRESS_PAYMENT_READ_MORE": "Se villkor",
	    "RUT_ROT_INFO": "Vad är rot/rut-avdag?\nNär du utfört ett arbete för en privatperson som är berättigat till rot/rutavdrag kan kunden få skattereduction på arbetskostnaden. Observera att det endast är arbetskostnaden på fakturan som har rätt till rot/rut-avdrag. Material och resekostnader i samband med arbetet ger inte rätt till avdrag.\n\nRotarbeten, 30%% avdrag\nAvser reparation och underhåll samt om- och tillbyggnad, förutsatt att arbetet utförs i eller i nära anslutning till en bostad som den avdragsberättigade äger. Rotavdrag kan däremot inte göras för helt nya hus och heller inte för tillbyggnad av nya bostäder (inom de fem första åren).\n\nRutarbeten, 50%% avdrag\nAvser hushållsarbeten som utförs i fastighet som köparen av tjänsten eller dess föräldrar bor i eller vistas i.\n\nVad ska fakturabeskrivningen innehålla?\n- uppgifter om vilka arbeten som har utförts\n- fördelning av kostnaden på arbete resp. material, maskinhyra, utrustning och resor\n- skattereduktionens storlek\n- om fakturan enbart avser arbetskostnader bör det framgå i specifikationen\n- uppgifter om var arbetet har utförts.\n\nVem ansöker om avdraget hos Skatteverket?\nAlla fakturor du utformar som rot eller rut via frilans Finans kommer Frilans Finans söka avdrag för. Vi kommer ha all kontakt med Skatteverket gällande detta. Din lön betalas sedan ut då kunden betalat sin del av fakturan.\n\nVem får nyttja avdraget och hur mycket avdrag får göras?\nEn kund som varit obegränsat skatteskyldig under beskattningsåret och fyllt 18 år innan årets slut har rätt att få maximalt 50.000 kr i rot-avdrag och 25.000 i rut-avdrag per person och år. Utrymmet baseras på kundens slutliga skatt där det först tas hänsyn till andra eventuella avdrag.\n\nRot/rut-avdrag kan endast nyttjas på arbetskostnaden där 30%% avdrag får göras för rotarbeten och 50%% avdrag för rutarbeten. Observera att du som utförare av tjänsten inte får vara närstående till kunden.\n\nHur vet jag att köparen har tillräckligt med rot/rut-avdrag?\nOm du är osäker på om kunden har tillräckligt utrymme för ditt arbete kan du be kunden om ett intyg från Skatteverket. Det visar hur mycket avdrag som dittills nyttjats under innevarande år. Skulle det visa sig att kund inte har tillräckligt med rot/rut-avdrag kvar kommer Frilans Finans skapa en tilläggsfaktura på resterande belopp till kund. Din lön kommer alltså inte påverkas.",
	    "VAT_INFO": "Skatteverkets huvudregel är att varor och tjänster som faktureras inom Sverige ska ha ett momspåslag på 25 %%. Det finns dock några få undantagsfall där skattesatsen kan vara 12, 6 eller 0 procent. Exempel på undantagsfall med 6 %% moms är upphovsrättsskyddat material.\nExport, arbete på internationellt vatten, CSN-berättigad utbildning samt viss typ av sjukvård är momsbefriade. Artist- och musikergager har 25 %% momspåslag, förutom när artisten eller musikern äger det fakturerande bolaget varvid gagerna är momsbefriade.\n\nFrilans Finans förbehåller sig rätten att korrigera momsen i de fall det vid granskning av fakturaunderlaget upptäcks vara fel moms angiven. Ändringen kan i vissa fall medföra att fakturabeloppet inkl. moms justeras. Om du är osäker på vilken momssats som gäller för ditt arbete, tveka inte att kontakta Frilans Finans Klientstöd på 0771-15 10 00.",
	    "ALERT": "Vänligen observera",
	    "EXPRESS_PAYMENT_NOT_ROT_RUT": "Expressbetalning kan inte användas om du valt rot eller rut. Om du väljer rot eller rut kommer expressbetalning att väljas bort.",
	    "ACCEPT_TERMS": "Godkänn de allmänna villkoren för att skicka fakturan ",
	    "INVOICE_NOT_VALID": "Det finns fel ovan som du måste åtgärda",
	    "INVOICE_ERROR_SPECIFICATION": "Ange minst 5 tecken",
	    "INVOICE_ERROR_CUSTOMER": "Välj en kund i listan",
	    "INVOICE_ERROR_INVOICEDATE_MAX_HOURS": "Ange max 24 timmar per arbetsdatum",
	    "INVOICE_ERROR_INVOICEDATE": "Lägg till minst ett arbetsdatum",
	    "INVOICE_EMAIL": "Fakturamottagarens e-postadress",
	    "SALARY_INFORMATION": "Löneinformation",
	    "SALARY_INFORMATION_VIA_SMS": "Löneinformation via sms",
	    "SALARY_INFORMATION_VIA_EMAIL": "Löneinformation via email",
	    "LOGIN_FAILED": "Länken är inte längre giltig, vänligen logga in igen.",
	    "CLIENT_OF_THE_MONTH_SUBMITTED": "Tack för ditt bidrag!",
	    "COTM_SPEC_EMPTY": "Du måste skriva en beskrivning",
	    "COTM_PORTRAIT_EMPTY": "Du måste välja en bild på dig själv",
	    "COTM_ACTION_EMPTY": "Du måste välja en bild på dig själv under yrkesutövning",
	    "NO_CUSTOMER_SELECTED": "Ingen kund vald",
	    "AMOUNT_EXCL_VAT": "Belopp exkl. moms",
	    "INVOICE_ERROR_AMOUNT": "Ange ett fakturabelopp",
	    "INVOICE_ERROR_SUPPLIER_LEDGER": "Avdrag får inte överstiga hälften av fakturabeloppet",
	    "TOTAL_NR_OF_WORKHOURS": "Totala arbetstimmar",
	    "INVOICE_TOOL_TRAVEL_DEDUCTION_INFO": "Summan av traktamente, milersättning och avdrag kan inte överstiga 50%% av det fakturerade beloppet.",
	    "ERRAND_ICON_DESCRIPTION_PEN": "Klicka här för att göra ändringar i din faktura",
	    "ERRAND_ICON_DESCRIPTION_MAIL": "Fakturan har behandlats och skickats till kund. Inga ändringar kan längre göras i fakturan.",
	    "ERRAND_ICON_DESCRIPTION_LOCK": "Fakturan behandlas just nu av en handläggare på Administrationen och är därför inte möjlig att ändra. Vänligen kontakta Administrationen snarast om du önskar göra några ändringar.",
	    "ERRAND_ICON_DESCRIPTION_EYE": "Granska",
	    "ERRAND_ICON_DESCRIPTION_POINTER": "?",
	    "INVOICE_TOOL_AMOUNT_BELOW_TRAVEL_DEDUCTIONS": "Fakturabeloppet är för lågt i förhållande till resersättning och avdrag.",
	    "MISSING_PAGE": "Sidan du letar efter finns inte.",
	    "CLIENT_OF_THE_MONTH_TOO_FREQUENT": "Du kan skicka in ansökningar till månadens klient med fjorton dagars mellanrum.",
	    "INVOICE_SENT": "Din faktura är skapad!",
	    "WRITE_DOWN_LEVID_ON_RECEIPT": "För att vi ska kunna behandla dina avdrag behöver du inkomma med dina kvitton. Digitala kvitton ber vi dig mejla till <a href=\"mailto:avdrag@frilansfinans.se\">avdrag@frilansfinans.se</a>. Om kvittot är i pappersform och på ett belopp <i style=\"font-style: italic;\">mindre än 2000 kr</i> går det bra att mejla oss en kopia på kvittot. Övriga kvitton skickas till vår postadress i Uppsala. Kom ihåg att skriva kvittots LevId i mejlet eller på kvittot. Har du redan bifogat kvittot direkt i fakturaverktyget behöver du inte göra något mer.<br>\n<br>\nVi påminner även om att spara originalkvitton i minst 3 år i de fall du skickar in kvittokopior.",
	    "CONTINUE": "Fortsätt",
	    "AMOUNT_TO_BILL_HSD_ROT_EXCL_VAT": "Belopp efter ROT-avdrag exkl. moms",
	    "AMOUNT_TO_BILL_HSD_RUT_EXCL_VAT": "Belopp efter RUT-avdrag exkl. moms",
	    "INVOICE_UPDATED": "Fakturan har uppdaterats.",
	    "NO_COWORKERS_ADD_NEW_BELOW": "Du saknar tidigare medarbetstagare.",
	    "INVOICE_HSD_ROT_DATA": "För att nyttja ROT-avdrag så behöver fastighetsbeteckning eller bostadsrättföreningens organisationsnummer anges.",
	    "SEND_INVOICE_MODAL_TITLE": "Skapa fakturan",
	    "SEND_INVOICE_MODAL_TEXT": "Du är på väg att skicka en faktura. Har du kontrollerat att dina inmatade värden är korrekta?<br />\n<br />Dina nuvarande inmatningar innebär att fakturan har en totalsumma på %(amount)s Ex. moms",
	    "INVOICE_SENT_MODAL_TITLE": "Fakturan är skapad",
	    "INVOICE_SENT_MODAL_TEXT": "Fakturan är skapad",
	    "VALIDATION_USER_PROFESSION_TITLE_FOUND_PROFESSION_TITLE": "Arbetstagare %(value)s behöver ändra yrkestitel under fakturainställningar",
	    "VALIDATION_USER_PROFESSION_TITLE_REQUIRED": "Du har inte angivit någon arbetstitel. Vänligen klicka på kontoinställningar högst upp i fakturaverktyget. Gå sedan till fakturainställningar och ange ett yrke. Har du frågor är du välkommen att kontakta klientstöd på info@frilansfinans.se eller 0771 15 10 00.",
	    "VALIDATION_USER_COUNTRY_REQUIRED": "Du saknar angivet land. Vänligen klicka på kontoinställningar högst upp i fakturaverktyget. Gå sedan till personuppgifter och ange land.",
	    "VALIDATION_USER_ACCOUNT_NUMBER_REQUIREDUNLESS_INTERNATIONAL_ACCOUNT_ON": "Kontonummer saknas",
	    "VALIDATION_USER_ACCOUNT_CLEARING_NUMBER_REQUIREDUNLESS_INTERNATIONAL_ACCOUNT_ON": "Clearingnummer saknas",
	    "VALIDATION_USER_COUNTRY_FOUND_COUNTRY_COUNTRY_NAME": "Ogiltigt land",
	    "INVOICE_SAVED_MODAL_TEXT": "Fakturan är sparad",
	    "DEFAULT_CURRENCY_NAME_SHORT": "SEK",
	    "DEFAULT_COUNTRY_FOR_NEW_CUSTOMERS": "SWEDEN",
	    "NET_SUM": "Netto",
	    "GROSS_SUM": "Brutto",
	    "TAX_SUM": "Skatt",
	    "TRAVEL_SUM": "Milersättning",
	    "ALLOWANCE_SUM": "Traktamente",
	    "DEFAULT_CURRENCY_NAME_SHORT_OTHER": "kr",
	    "PART_OF_INVOICE_SUM": "Del av fakturabelopp",
	    "VALIDATION_EMAIL_UNIQ_USER": "E-postadressen är redan registrerad",
	    "TOTAL_PAID_TO_CLIENT": "Utbetalt till mitt konto",
	    "VALIDATION__ACCOUNT_NUMBER_REQUIREDWITHOUTALL_IBAN_BIC": "Du måste ange ett bankkonto",
	    "LOADING": "Laddar",
	    "GET_SALARY_SPECIFICATION_ERROR": "Det gick inte att hämta lönespecificationen",
	    "UNSUPPORTED_BROWSER": "Versionen av din webbläsare stöds inte. Uppdatera webbläsaren för att sidan ska fungera som avsett.",
	    "VALIDATION_CELLPHONE_PHONENUMBER_SE_FALSE": "Du måste ange ett mobiltelefonnummer",
	    "OPEN_BANK_ID": "Öppna BankID",
	    "OPEN_BANK_ID_COMPUTER_APP": "Öppna BankID-programmet",
	    "OPEN_BANK_ID_APP": "Öppna BankID-appen",
	    "BANK_ID_ANOTHER_DEVICE": "Mobilt BankID på annan enhet",
	    "EMAIL_CAPTURE_HEADER": "Ange e-postadress",
	    "EMAIL_CAPTURE_TEXT": "Vi behöver din e-postadress för att kunna slutföra registreringen",
	    "GET_BANKKID": "Skaffa BankID",
	    "DIVIDER_OR": "ELLER",
	    "LOGIN_WITH_MOBILE_BANKID": "Logga in med Mobilt BankID",
	    "LOGIN_WITH_BANKID": "Logga in med BankID",
	    "LOGIN_WITH_BANKID_ON_FILE": "Logga in med BankID på fil",
	    "LOGIN_WITHOUT_BANKID": "Logga in med e-postadress och lösenord",
	    "REGISTER_WITH_MOBILE_BANKID": "Skapa konto med Mobilt BankID",
	    "REGISTER_WITH_BANKID_ON_FILE": "Skapa konto med BankID på fil",
	    "CREATE_ACCOUNT_WITH_BANKID": "Skapa konto med BankID",
	    "CREATE_ACCOUNT_WITHOUT_BANKID": "Skapa konto utan BankID",
	    "REGISTER_WITHOUT_BANKID": "Skapa konto med e-postadress och lösenord",
	    "EMAIL_NOT_CONFIRMED": "Du behöver verifiera din e-postadress \"%(email)s\" för att kunna ange ett lösenord.",
	    "SEND_VERIFICATION_MAIL": "Skicka mejl med verifieringslänk",
	    "VALIDATION_USER_ACCOUNT_NUMBER_REQUIRED": "Kontonummer saknas",
	    "VALIDATION_USER_ACCOUNT_CLEARING_NUMBER_REQUIRED": "Clearingnummer saknas",
	    "TAB_TITLE_EMAIL": "E-post och lösenord",
	    "TAB_TITLE_BANKID_MOBILE": "Mobilt BankID",
	    "TAB_TITLE_BANKID_FILE": "BankID",
	    "CANCELLED": "Avbruten",
	    "BANKID_USER_NOT_FOUND": "Du har försökt logga in med ett personnummer som ännu inte är registrerat. Skapa ett konto för att fortsätta eller kontakta klientstöd på 0771-15 10 00 om du har frågor.",
	    "ERRAND_ICON_DESCRIPTION_REMOVE": "Klicka här för att ta bort din föranmälda faktura",
	    "DELETE_INVOICE": "Är du säker på att du vill ta bort den föranmälda fakturan?",
	    "VALIDATION_COUPON_ID_COUPON": "Kampanjkoden är ej giltig.",
	    "VALIDATION_USER_STREET_REQUIRED": "Adress saknas",
	    "VALIDATION_USER_ZIP_REQUIRED": "Postnummer saknas",
	    "VALIDATION_USER_CITY_REQUIRED": "Ort saknas",
	    "BANKID_GENERAL_ERROR": "Något oväntat inträffade! Försök igen om en liten stund eller eller kontakta Klientstöd på 0771-15 10 00.",
	    "FOOTER_CONTACT_EMAIL": "info@frilansfinans.se",
	    "FOOTER_CONTACT_PHONE": "Telefon: 0771-15 10 00",
	    "FOOTER_CONTACT_OPEN": "Öppet vardagar 9.00-17.00",
	    "SSNR_ALREADY_REGISTERED": "Något gick fel. Vänligen kontakta Klientstöd för att slutföra registreringen; tel: 0771-15 10 00 eller mail: info@frilansfinans.se.",
	    "PREREGISTER_WORK": "Föranmäl arbete",
	    "VALIDATION_COMPANY_PHONE_PHONENUMBER_SE_FALSE": "Ange ett svenskt mobiltelefonnummer",
	    "VALIDATION_COMPANY_PHONE_REQUIREDIF_MESSAGE_TYPE_SMS": "Ange ett svenskt mobiltelefonnummer",
	    "VALIDATION_SEND_TO_EMAIL_EMAIL": "Du måste ange en giltig e-postadress",
	    "VALIDATION_SEND_TO_EMAIL_REQUIREDIF_MESSAGE_TYPE_EMAIL": "Du måste ange en giltig e-postadress",
	    "EMAIL_INVALID_ERROR": "Du måste ange en giltig e-postadress",
	    "CANT_DELETE_COMPANY_WITH_PREREPORT_INVOICES": "Den angivna kunden tillhör minst en föranmäld faktura och kan därav inte tas bort.",
	    "PAYMENT_INVOICE_DATA": "Fakturaunderlag",
	    "PAYMENT_INVOICE_ROT_OR_RUT_DEDUCTION": "ROT/RUT-avdrag inkl. moms",
	    "NETWORK": "Network",
	    "HOW_IT_WORKS": "Så här fungerar det",
	    "QUESTIONS_AND_ANSWERS": "Frågor och svar",
	    "MEET_OUR_UMBRELLA_CONTRACTORS": "Träffa våra egenanställda",
	    "THIS_IS_SELF_EMPLOYMENT": "Det här är egenanställning",
	    "GOOD_WORKING_CONDITIONS": "Goda arbetsvillkor",
	    "ABOUT_FRILANS_FINANS": "Om Frilans Finans",
	    "CONTACT_US": "Kontakta oss",
	    "NEWS_AND_PRESS": "Nyheter och press",
	    "SOCIAL_MEDIA": "Sociala Media",
	    "HEADER_MENU_SERVICES": "Tjänster",
	    "HEADER_MENU_HELP": "Om egenanställning",
	    "HEADER_MENU_ABOUT": "Om Frilans Finans",
	    "PAYMENT_PAY_WITH_PLUSGIRO": "Om du inte har möjlighet att betala fakturan med Swish kan du välja att betala till Plusgiro. Kom ihåg att ange rätt OCR.",
	    "PLUSGIRO_NUMBER": "858393-2",
	    "BECOME_CLIENT_NEXT_CLIENT": "Klara Wåhlberg, Modell och skidåkare",
	    "BECOME_CLIENT_ENTER_CONTEST": "Ansök här",
	    "BECOME_CLIENT_IMAGE_URL": "https://d36fgo9tveb5fn.cloudfront.net/wp-content/uploads/2019/12/30112408/FrilansFinans_Klara_Wahlberg_ME_dec_16x9.jpg",
	    "BECOME_CLIENT_OT_THE_MONTH_AGREEMENT": "Vi förbehåller oss rätten att ändra och använda text och bild i marknadsföringen av Frilans Finans.",
	    "BECOME_CLIENT_SPECIFICATION_PLACEHOLDER": "Berätta om ett spännande eller roligt arbete du utfört...",
	    "BECOME_CLIENT_TELL_US": "Berätta om ett spännande jobb du gjort för chansen att bli månadens egenanställd. Varje månad står 5 000 kr på spel!",
	    "SIDEBAR_EXTRA": "Allmänt",
	    "UPLOAD_IMAGE": "Ladda upp bild",
	    "PAYMENT_START_FROM_NAME": "Faktura från %(name)s via Frilans Finans",
	    "PAY_WITH_SWISH": "Betala med Swish",
	    "SEE_INVOICE_SPECIFICATION": "Visa fakturadetaljer",
	    "PAY_WITH_PLUSGIRO": "Betala till Plusgiro",
	    "MINIMIZE": "Minimera",
	    "PAYMENT_PAGE_TO_PAY": "Att betala",
	    "PLUSGIRO": "Plusgiro",
	    "OCR": "OCR",
	    "PAYMENT_DOWNLOAD_PDF": "Hämta PDF",
	    "PAYMENT_PAID_TITLE": "Betalning genomförd",
	    "PAYMENT_PAID_THANK_YOU_FOR_PAYMENT": "Tack för din betalning",
	    "PAYMENT_PAID_PAID_AT": "Betalningen är genomförd",
	    "PAYMENT_PAID_EMAIL_SENT": "Fakturan är skickad",
	    "EMAIL_INVOICE_SPECIFICATION": "Maila fakturaunderlag",
	    "PAYMENT_CANCEL_TITLE": "Betalningen är avbruten",
	    "PAYMENT_CANCEL_MESSAGE": "Din betalning har inte genomförts.<br/>\n<br/>Du kan återuppta betalningsprocessen med knappen nedan eller genom länken i ditt sms.<br/><br/>\nHar du frågor, kontakta oss på info@frilansfinans.se eller 0771-15 10 00.",
	    "PAYMENT_CANCEL_TRY_AGAIN": "Återuppta",
	    "PAYMENT_INVOICE_CREDITED_AND_UNPAID_MESSAGE": "Denna faktura är borttagen och ingen betalning har genomförts. <br/>\n<br/>\nHar du frågor om fakturan, kontakta oss på info@frilansfinans.se eller 0771-15 10 00.<br/>\n<br/>\nDu kan nu stänga den här sidan.\n",
	    "PAYMENT_INVOICE_CREDITED_AND_PAID_MESSAGE": "Denna faktura har tagits bort och länken är inte längre giltig. <br>\n</br>\nHar du frågor om fakturan, kontakta oss på info@frilansfinans.se eller 0771-15 10 00.<br>\n</br>\nDu kan nu stänga den här sidan.",
	    "PAYMENT_INVOICE_CREDITED_TITLE": "Fakturan är krediterad",
	    "PAYMENT_ERROR_TITLE": "Ett tillfälligt fel har uppstått.",
	    "PAYMENT_ERROR_MESSAGE": "<strong>Din betalning har inte genomförts.</strong><br/><br/>Du kan återuppta betalningsprocessen med knappen nedan eller genom länken i ditt sms.<br/><br/>\nOm felet kvarstår, kontakta oss på info@frilansfinans.se eller 0771-15 10 00.",
	    "PAYMENT_ERROR_TRY_AGAIN": "Försök igen",
	    "INVOICING_MESSAGE_TYPE_SMS": "<ul><li>Kunden har möjlighet att betala med Swish direkt till Frilans Finans.</li>\n<li>När fakturan har godkänts av oss skickar vi ett sms till kunden med en länk till Swish-betalningen.</li>\n<li>Lönen utbetalas 1 bankdag efter det att fakturan blivit betald.</li></ul>",
	    "INVOICING_MESSAGE_TYPE_MAIL_COMPANY": "<p>Din faktura skickas per post till kundens adress. </p>\n<p>Fakturan skickas från oss samma dag som den godkänts.</p> ",
	    "INVOICING_SEND_INVOICE_BY_EMAIL": "Skicka faktura med e-post",
	    "INVOICING_SEND_INVOICE_BY_MAIL": "Skicka faktura med post",
	    "INVOICING_SEND_INVOICE_BY_SMS": "Skicka faktura som sms",
	    "INVOICING_SEND_INVOICE_BY_EMAIL_TO": "Skicka faktura med e-post till",
	    "INVOICING_SEND_INVOICE_BY_EMAIL_TO_SECONDARY": "Skicka en kopia till (valfritt)",
	    "INVOICING_SEND_INVOICE_BY_MAIL_TO": "Skicka faktura med post till",
	    "INVOICING_SEND_INVOICE_BY_SMS_TO": "Skicka faktura med sms till",
	    "INVOICING_CANT_SEND_INVOICE_BY_SMS": "Det är inte möjligt att skicka SMS-faktura till företag",
	    "PAYMENT_START_SWISH_NOT_INSTALLED": "Swishappen är inte installerad på den här enheten",
	    "PAYMENT_PAID_ENTER_EMAIL_FOR_INVOICE": "Ange din e-postadress nedan om du vill ha en kopia på fakturaunderlaget.",
	    "PAYMENT_PAID_CAN_CLOSE_PAGE": "Du kan nu stänga den här sidan.",
	    "PAYMENT_PAID_EMAIL_INVOICE_SENT": "Fakturan har nu skickats till %(email)s",
	    "PAYMENT_START_INVOICE_AMOUNT_EXCL": "Belopp exkl. moms",
	    "PAYMENT_START_INVOICE_AMOUNT_INCL": "Belopp inkl. moms",
	    "PLUSGIRO_RECIPIENT": "Mottagare",
	    "PLUSGIRO_RECIPIENT_NAME": "Frilans Finans Sverige AB",
	    "PENSION_TOO_OLD": "Du kan spara tjänstepension till det år du fyller 65",
	    "INVALID_PHONE_NUMBER": "Ogiltigt telefonnummer",
	    "INVALID_EMAIL": "Ogiltig e-postadress",
	    "VALIDATION_COMPANY_PHONE_PHONENUMBER": "Vald kund har ett ogiltigt telefonnummer",
	    "INVOICE_SPECIFICATION_ROT": "Denna faktura avser ROT-arbete och preliminär skattereduktion har gjorts med 30 % på arbetskostnaden.",
	    "INVOICE_SPECIFICATION_RUT": "Denna faktura avser RUT-arbete och preliminär skattereduktion har gjorts med 50 % på arbetskostnaden.",
	    "INVOICE_TOOL_BIC": "ESSESESS",
	    "INVOICE_TOOL_IBAN": "SE2250000000053681053693",
	    "INVOICE_TOOL_ACCOUNT_NUMBER": "5368 10 536 93",
	    "BANK_INFO_TITLE": "Bankinformation",
	    "SELECT_BANK_INITIAL": "-- Välj bank --",
	    "SELECT_BANK_HANDELSBANKEN": "Handelsbanken",
	    "SELECT_BANK_NORDEA_PERSON": "Nordea (personnummer)",
	    "SELECT_BANK_NORDEA_KONTO": "Nordea (kontonummer)",
	    "SELECT_BANK_SWEDBANK": "Swedbank",
	    "SELECT_BANK_SEB": "SEB",
	    "SELECT_BANK_IBAN": "Utländsk bank (BIC/IBAN)",
	    "SELECT_BANK_OTHER": "Övriga banker",
	    "CLEARING_NR_LABEL_INITIAL": "Clearingnummer",
	    "CLEARING_NR_PLACEHOLDER_INITIAL": "4 siffror",
	    "CLEARING_NR_ERROR_INITIAL": "Ogiltigt clearingnummer",
	    "ACCOUNT_NR_LABEL_INITIAL": "Kontonummer",
	    "ACCOUNT_NR_PLACEHOLDER_INITIAL": "7 siffror",
	    "ACCOUNT_NR_ERROR_INITIAL": "Ogiltigt kontonummer",
	    "CLEARING_NR_LABEL_HANDELSBANKEN": "Clearingnummer",
	    "CLEARING_NR_PLACEHOLDER_HANDELSBANKEN": "4 siffror",
	    "CLEARING_NR_ERROR_HANDELSBANKEN": "Felaktigt clearingnummer, tillåtet format för Handelsbanken: 6XXX",
	    "ACCOUNT_NR_LABEL_HANDELSBANKEN": "Kontonummer",
	    "ACCOUNT_NR_PLACEHOLDER_HANDELSBANKEN": "9 siffror",
	    "ACCOUNT_NR_ERROR_HANDELSBANKEN": "Ogiltigt kontonummer",
	    "CLEARING_NR_LABEL_NORDEA_PERSON": "Clearingnummer",
	    "CLEARING_NR_PLACEHOLDER_NORDEA_PERSON": "Alltid 3300",
	    "CLEARING_NR_ERROR_NORDEA_PERSON": "Felaktigt clearingnummer",
	    "ACCOUNT_NR_LABEL_NORDEA_PERSON": "Kontonummer",
	    "ACCOUNT_NR_PLACEHOLDER_NORDEA_PERSON": "Personnummer med 10 siffror ",
	    "ACCOUNT_NR_ERROR_NORDEA_PERSON": "Ogiltigt kontonummer",
	    "CLEARING_NR_LABEL_NORDEA_KONTO": "Clearingnummer",
	    "CLEARING_NR_PLACEHOLDER_NORDEA_KONTO": "4 siffror",
	    "CLEARING_NR_ERROR_NORDEA_KONTO": "Felaktigt clearingnummer",
	    "ACCOUNT_NR_LABEL_NORDEA_KONTO": "Kontonummer",
	    "ACCOUNT_NR_PLACEHOLDER_NORDEA_KONTO": "7 eller 10 siffror",
	    "ACCOUNT_NR_ERROR_NORDEA_KONTO": "Ogiltigt kontonummer",
	    "CLEARING_NR_LABEL_SWEDBANK": "Clearingnummer",
	    "CLEARING_NR_PLACEHOLDER_SWEDBANK": "4 eller 5 siffror",
	    "CLEARING_NR_ERROR_SWEDBANK": "Felaktigt clearingnummer, tillåtna format för Swedbank 8XXXX eller 7XXX",
	    "ACCOUNT_NR_LABEL_SWEDBANK": "Kontonummer",
	    "ACCOUNT_NR_PLACEHOLDER_SWEDBANK": "7 till 10 siffror",
	    "ACCOUNT_NR_ERROR_SWEDBANK": "Ogiltigt kontonummer",
	    "CLEARING_NR_LABEL_SEB": "Clearingnummer",
	    "CLEARING_NR_PLACEHOLDER_SEB": "4 siffror",
	    "CLEARING_NR_ERROR_SEB": "Felaktigt clearingnummer, tillåtet format för SEB: 5XXX",
	    "ACCOUNT_NR_LABEL_SEB": "Kontonummer",
	    "ACCOUNT_NR_PLACEHOLDER_SEB": "7 siffror",
	    "ACCOUNT_NR_ERROR_SEB": "Ogiltigt kontonummer",
	    "CLEARING_NR_LABEL_IBAN": "BIC",
	    "CLEARING_NR_PLACEHOLDER_IBAN": "8 eller 11 bokstäver och siffror",
	    "CLEARING_NR_ERROR_IBAN": "Ogiltigt BIC",
	    "ACCOUNT_NR_LABEL_IBAN": "IBAN",
	    "ACCOUNT_NR_PLACEHOLDER_IBAN": "Upp till 34 bokstäver och siffror",
	    "ACCOUNT_NR_ERROR_IBAN": "Ogiltigt IBAN",
	    "CLEARING_NR_LABEL_OTHER": "Clearingnummer",
	    "CLEARING_NR_PLACEHOLDER_OTHER": "4 siffror",
	    "CLEARING_NR_ERROR_OTHER": "Ogiltigt clearingnummer",
	    "ACCOUNT_NR_LABEL_OTHER": "Kontonummer",
	    "ACCOUNT_NR_PLACEHOLDER_OTHER": "7 eller 10 siffror",
	    "ACCOUNT_NR_ERROR_OTHER": "Ogiltigt kontonummer",
	    "LOW_SALARY_PROCEED_ANYWAY": "Du är på väg att skicka en faktura med lägre bruttolön än 70 SEK/timme. En del i vårt uppdrag är att verka för bra arbetsvillkor och en skälig lön, därför rekommenderar vi dig att antingen höja det belopp du ska fakturera eller arbeta färre timmar.<br/><br/>",
	    "SEND_INVOICE_ANYWAY": "Skicka fakturan ändå",
	    "NEW_CUSTOMER_INFO": "Ange organisationsnummer för företag/organisationer och personnummer för privatkunder. Om kunden är ett företag i annat EU-land än Sverige, ange VAT-nummer.",
	    "GET_SALARY_SPECIFICATION": "Hämta lönespecifikation",
	    "INVOICE_DESCRIPTION": "Beskrivning",
	    "VALIDATION_AMOUNT_ABOVEORBELOW": "Ange ett fakturabelopp",
	    "DEDUCTION_CATEGORY_1": "Utland 0%",
	    "DEDUCTION_CATEGORY_2": "Resor inom Sverige 6%",
	    "DEDUCTION_CATEGORY_3": "Livsmedel 12%",
	    "DEDUCTION_CATEGORY_4": "Förbrukning 12%",
	    "DEDUCTION_CATEGORY_5": "Förbrukning 25%",
	    "DEDUCTION_CATEGORY_6": "Material som tillfaller kunden (rut/rot) 12%",
	    "DEDUCTION_CATEGORY_7": "Material som tillfaller kunden (rut/rot) 25%",
	    "DEDUCTION_CATEGORY_8": "Parkering 25%",
	    "DEDUCTION_CATEGORY_9": "0% moms",
	    "DEDUCTION_CATEGORY_10": "6% moms",
	    "DEDUCTION_CATEGORY_11": "12% moms",
	    "DEDUCTION_CATEGORY_12": "25% moms",
	    "DEDUCTION_CATEGORY_13": "Inventarier - specificera på fakturan",
	    "DEDUCTION_CATEGORY_14": "Logi 12%",
	    "DEDUCTION_CATEGORY_15": "6% moms - påverkar ej kunds rätt till Rut -och Rotavdrag",
	    "DEDUCTION_CATEGORY_16": "12% moms - påverkar ej kunds rätt till Rut -och Rotavdrag",
	    "DEDUCTION_CATEGORY_17": "25% moms - påverkar ej kunds rätt till Rut -och Rotavdrag",
	    "DEDUCTION_CATEGORY_18": "0% moms - påverkar ej kunds rätt till Rut -och Rotavdrag",
	    "CUSTOMER_SELECT_LABEL": "Sök här...",
	    "CUSTOMER_SELECT_NOTFOUND": "Inga resultat hittades",
	    "WORKED_TIME": "Arbetad tid",
	    "TOGGLE_WEEK": "Har du många arbetsdatum? Klicka på veckonumret för att markera hela veckan mån-fre.",
	    "SEARCH_FAQ": "Sök bland frågor och svar",
	    "ACCEPT_NEW_COWORKER": "Jag intygar härmed att jag fått min medarbetares godkännande att registrera dennes personuppgifter hos Frilans Finans",
	    "FINLAND": "Finland",
	    "FRANCE": "Frankrike",
	    "INVOICE_ERROR_NEGATIVE_SALARY": "Den skattefria delen (avdrag, traktamente och milersättning) är för hög i förhållande till lönedelen. För att skicka din faktura kan du antingen höja fakturabeloppet eller minska den skattefria delen.",
	    "SEARCH_COWORKER": "Sök efter befintliga medarbetare genom att ange dem tre första bokstäverna i efternamnet.",
	    "PROFESSION_ID_TITLE": "Dags att välja yrke!",
	    "PROFESSION_ID_INFO": "För att kunna arbeta som egenanställd och för att du ska omfattas av rätt försäkringar är det viktigt att du har valt rätt yrkestitel.\n\nSkriv in ditt yrke i rutan. Om ditt yrke inte finns i listan (som du ser när du angett minst tre bokstäver) ber vi dig välja det som bäst matchar dina arbetsuppgifter. Fakturerar du för flera olika typer av arbeten kan du välja det yrke som motsvarar merparten av dina uppdrag. ",
	    "INVOICE_TOOL_MISSING_DATA_TITLE": "Vi saknar några uppgifter om dig",
	    "INVOICE_TOOL_MISSING_DATA_INFO": "Fyll i uppgifterna om dig som saknas för att kunna skicka din faktura.",
	    "ZIP": "Postnummer",
	    "STREET": "Gatuadress",
	    "FUTURE_WORK_DATE": "Dina angivna arbetsdatum har inte ägt rum, är detta korrekt?",
	    "ACCEPT_FUTURE_DATES": "Godkänn arbetsdatum",
	    "HSD_PROPERTY_LABEL": "Fastighetsbeteckning",
	    "HSD_BRF_ORG_NUMBER": "BRF Org. nummer",
	    "HSD_BRF_APARTMENT_NUMBER": "Lägenhetsnummer",
	    "HSD_PROPERTY": "Hus",
	    "HSD_APARTMENT": "Lägenhet",
	    "HSD_CHOOSE_ACCOMMODATION": "Välj typ av bostad",
	    "STREET_ERROR": "Adress saknas",
	    "ZIP_ERROR": "Postnummer saknas",
	    "INVOICE_HSD_ROT_HOUSE": "Fyll i fastighetsbeteckningen",
	    "INVOICE_HSD_ROT_APARTMENT": "Fyll i bostadsrättsföreningens organisationsnummer samt fyrsiffrigt lägenhetsnummer",
	    "BANKID_LOGIN_FAILED": "Inloggningen misslyckades eller avbröts",
	    "UK": "Storbritannien",
	    "LOGIN_REGISTER_PERKS_TITLE": "Snabbt, tryggt och enkelt",
	    "LOGIN_REGISTER_PERK_FREE_ACCOUNT": "Inga dolda avgifter, det är gratis att skapa konto.",
	    "LOGIN_REGISTER_PERK_PAPERS": "Vi hjälper dig med all administration som bokföring och inbetalning av skatter.",
	    "LOGIN_REGISTER_PERK_WALLET": "Ingen fast månadskostnad, du betalar endast 6% av fakturabeloppet vid varje faktureringstillfälle.",
	    "LOGIN_REGISTER_PERK_JUMPING": "Du förbinder dig inte till något utan kan använda Frilans Finans när du vill och hur mycket du vill.",
	    "LOGIN_REGISTER_PERK_HEADPHONE": "Stöd och rådgivning via mejl, telefon eller chatt alla helgfria vardagar.",
	    "LOGIN_REGISTER_PERKS_BGIMAGE_URL": "https://d36fgo9tveb5fn.cloudfront.net/wp-content/uploads/2019/08/23141524/ff_photographer_25.jpg",
	    "VALIDATION_CELLPHONE_PHONENUMBER": "Du måste ange ett mobiltelefonnummer",
	    "INVOICE_TOOL_LINK_TEXT": "Fakturera utan företag",
	    "NETWORK_LINK_TEXT": "Uppdrag och förmåner",
	    "EVENTS_AND_INSPIRATION_LINK_TEXT": "Evenemang och inspiration",
	    "WORK_INTERNATIONALLY_LINK_TEXT": "Jobba internationellt",
	    "FIND_ASSIGNMENTS": "Hitta uppdrag",
	    "FIND_ASSIGNMENTS_LINK": "https://www.frilansfinans.se/uppdrag-och-formaner-inloggad/",
	    "Rivstarta hösten den 7-11 september genom att ta del av 40 av Sveriges mest inspirerande talare. Genom ett samarbete mellan Frilans Finans och organisationen Hela Sverige Samlas kan du den 2-3 september boka ditt premiumpass helt gratis.": "Nyhet",
	    "DASHBOARD_CTA_POST_TITLE": "Ta del av vårt nästa event",
	    "DASHBOARD_CTA_POST_SUBTITLE": "Eftermiddagsföreläsning med OneLab",
	    "DASHBOARD_CTA_POST_CONTENT": "Välkomna på en föreläsning om fysisk aktivitet och återhämtning arrangerad av OneLab med Mira Lidell som representant. Föreläsningen ger insikter om aktiv och passiv återhämtning och dess påverkan på hälsa och välmående. Syftet är att ge verktyg för att reflektera över egna beteenden och vanor för att främja en hälsosam livsstil. Frilans Finans personal närvarar också på föreläsningen och svarar gärna efteråt på eventuella frågor gällande vår tjänst.\n\nTid: 13.30-14.10 \n\nDatum: 18 juni \n\nPlats: Gamla Brogatan 13, Frilans Finans besökskontor i Stockholm",
	    "DASHBOARD_CTA_POST_BUTTON_TEXT": "Läs mer",
	    "DASHBOARD_CTA_POST_BUTTON_URL": "https://med-hlsan-i-fokus.confetti.events/",
	    "DASHBOARD_CTA_POST_IMAGE_URL": "https://www.frilansfinans.se/wp-content/uploads/2024/06/timon-studler-BIk2ANMmNz4-unsplash-1.jpg",
	    "SETTINGS_LOGOTYPE_DELETED": "Din logotyp är nu borttagen och kommer inte visas på framtida fakturor.",
	    "SETTINGS_CONFIRM_LOGOTYPE_DELETE": "Är du säker på att du vill ta bort din logotyp?",
	    "PDF": "PDF",
	    "INVOICING_SEND_INVOICE_BY_E_INVOICE": "Skicka faktura som e-faktura",
	    "INVOICING_SEND_INVOICE_BY_E_INVOICE_TO": "Ange GLN eller PEPPOL",
	    "EINVOICE_ERROR": "GLN eller PEPPOL måste vara mellan 10 och 50 tecken",
	    "NO_EMAIL_ERROR": "E-fakturering får ej innehålla @, om du vill skicka som e-post vänligen välj “Skicka faktura med e-post.”",
	    "PO_NUMBER": "Ange inköpsordernummer (PO-nummer)",
	    "PO_NUMBER_ERROR": "Ett inköpsordernummer (PO-nummer) får inte innehålla mer än 30 tecken",
	    "INVOICING_MESSAGE_TYPE_EINVOICE": "<ul><li>E-fakturor skickas elektroniskt till kunds internetbank genom PEPPOL eller GLN.</li>\n<li>Ett inköpsordernummer (PO-nummer) får du av kund och anges oftast i form av ett antal bokstäver eller siffror (valfritt att ange)</li></ul>",
	    "BECOME_AMBASSADOR": "Bli Ambassadör",
	    "PAYTERMS": "Betalningsvillkor",
	    "PAYTERMS_ERROR": "Ett fel uppstod för betalningsvillkor",
	    "DAYS": "dagar",
	    "PAYTERMS_LOW_WARNING": "Vänligen observera, för att skicka en faktura med kortare betalningsvillkor än 30 dagar behöver du avtala detta med din kund.",
	    "PAYTERMS_HIGH_WARNING": "Vänligen observera, för fakturor som har längre betalningsvillkor än 30 dagar betalas lönen ut så snart vi erhållit betalning från kund.",
	    "WORK_PERIOD": "Arbetsperiod",
	    "NEXT": "Nästa",
	    "WORKDATE_HOURS_INFO": "Här rapporterar du din arbetade tid. Det är viktigt att du registrerar arbetsdatum och timmar enligt hur du faktiskt arbetar. Den registrerade arbetstiden utgör underlag för din anställning, inkomstuppgifter till bland annat Försäkringskassan och arbetsgivarintyg.  \nOm du fakturerar flera kunder för samma uppdrag, tänk då på att dela upp dina timmar mellan fakturorna så att timmarna inte registreras dubbelt.",
	    "DEDUCTION_APPENDED_FILES": "Bilagor",
	    "DEDUCTION_FILE_ERROR": "Du kan endast välja filer av typen png, jpeg, bmp, gif, doc eller pdf och den får max vara 2MB stor",
	    "DEDUCTION_INFO_BUTTON": "Information om avdrag",
	    "DEDUCTION_INFO_SHORT": "Information om avdrag",
	    "INVOICE_TOTAL_EXCL_VAT": "Totalt exkl. moms",
	    "INVOICE_YOUR_CUSTOMER_NO": "Ert kundnr.",
	    "INVOICE_YOUR_REFERENCE": "Er referens",
	    "INVOICE_OUR_REFERENCE": "Vår referens",
	    "INVOICE_INVOICE_SERVICE": "Fakturaservice",
	    "INVOICE_PAYMENT_TERMS": "Betalningsvillkor",
	    "INVOICE_INTEREST_FEE": "Dröjmålsränta",
	    "INVOICE_PAYMENT_REMINDER_FEE": "Betalningspåminnelse debiteras med 60,00 SEK.",
	    "INVOICE_VAT_RATE": "Momssats",
	    "INVOICE_VAT": "Moms",
	    "INVOICE_ROUNDING": "Öresutj.",
	    "INVOICE_TOTAL_INCL_VAT": "Totalt inkl. moms",
	    "INVOICE_PLEASE_ALWAYS": "Vänligen ange alltid OCR-nummer vid betalning.",
	    "INVOICE_COMMENTS_MADE": "Anmärkning gjorda efter 8 dagar kommer ej att beaktas.",
	    "INVOICE_DAYS_NET": "dagar netto",
	    "INVOICE_OCR_NUMBER": "OCR-nummer",
	    "INVOICE_INVOICE_NO": "Fakturanr.",
	    "INVOICE_DATE": "Fakturadatum",
	    "INVOICE_SWIFT_NO": "Swift",
	    "INVOICE_IBAN_NO": "IBAN",
	    "INVOICE_BANK_ACCOUNT_NO": "Bankkonto nr:",
	    "INVOICE_BANKGIRO": "Bankgiro:",
	    "INVOICE_IS_NOT_EU_CUSTOMER": " ",
	    "INVOICE_IS_EU_CUSTOMER": "",
	    "INVOICE_INTEREST_FEE_VALUE": "24,00 %",
	    "INVOICE_COPY_DOWNLOAD": "Ladda ner fakturakopia",
	    "INVOICE_COPY_ABOUT_PAGE": "Fyll i Faktura/OCR-nummer och kundnummer för att ladda ner en kopia av din faktura.",
	    "INVOICE_COPY_ENTER_OCR_NUMBER": "Faktura/OCR-nummer",
	    "INVOICE_COPY_ENTER_COMPANY_ID": "Kundnummer",
	    "INVOICE_COPY_COULD_NOT_FIND_INVOICE": "Fakturakopian går inte att hitta, vänligen kontrollera att uppgifterna stämmer.",
	    "INVOICE_COPY_SUBMIT": "Hämta fakturakopia",
	    "INVOICING_OPTION": "Fakturautskick via",
	    "INVOICING_OPTION_EMAIL": "E-post",
	    "INVOICING_OPTION_MAIL": "Post",
	    "INVOICING_OPTION_SMS": "SMS",
	    "INVOICING_OPTION_EINVOICE": "E-faktura",
	    "SEND_INVOICE_BY_EMAIL": "Skicka faktura via e-post",
	    "SEND_INVOICE_BY_MAIL": "Skicka faktura via post",
	    "SEND_INVOICE_BY_SMS": "Skicka faktura via sms",
	    "SEND_INVOICE_BY_E_INVOICE": "Skicka faktura som e-faktura",
	    "SALARY_SETTINGS_TITLE": "Lön och ersättningar",
	    "SALARY_INFO": "Lön och ersättningar",
	    "INCOME_TAX": "Inkomstskatt",
	    "OTHER_ALLOWANCE": "Övrig ersättning",
	    "SAVE_PENSION_CHECKBOX": "Spara tjänstepension",
	    "SAVE_VACATION_CHECKBOX": "Spara semesterersättning",
	    "ORDER_TOOL_TO_BE_PAID_ITP": "Sparas till din tjänstepension",
	    "TOOLTIP_ORDER_TOOL_TO_BE_PAID_ITP": "Frilans Finans avsätter automatiskt 4.5%% av bruttolönen (bruttolön inkl. semesterersättning) till din tjänstepension om du är 25-66 år. “Sparas till tjänstepension” visar beloppet som avsätts till SPP Pension & Försäkring. Du kan se ditt totala sparande samt läsa mer om hur du kan följa värdeutvecklingen under: Inställningar → Lön och ersättningar → “Tjänstepension Läs mer\".",
	    "ORDER_TOOL_TO_BE_PAID_ITP_WORKER": "Sparas till din medarbetares tjänstepension",
	    "ORDER_TOOL_TO_BE_PAID_VACATION": "Sparas till din semester",
	    "TOOLTIP_ORDER_TOOL_TO_BE_PAID_VACATION": "Semesterersättning är den andel (12%%) av din bruttolön som sparas till din semester. Semesterersättningen betalas ut automatiskt och inkomstskatt dras vid utbetalning. Du kan välja att inte spara semesterersättning under: Mina sidor → Inställningar → Lön och ersättningar. Väljer du att inte spara semesterersättningen kommer samma andel istället betalas ut med lönen.",
	    "ORDER_TOOL_TO_BE_PAID_VACATION_WORKER": "Sparas till din medarbetares semester",
	    "ORDER_TOOL_TO_BE_PAID_TOTAL": "Din totala nettobehållning",
	    "ORDER_TOOL_TO_BE_PAID_TOTAL_WORKER": "Din medarbetares totala nettobehållning",
	    "TOOLTIP_TRAVEL_ALLOWANCE": "Här kan du ange din skattefria milersättning med egen eller närståendes bil. Du har rätt till skattefri ersättning om 25 kr / mil. Observera att du generellt inte kan yrka milersättning för resor mellan hem och ordinare tjänsteställe. Med ordinare tjänsteställe avses den plats där du utför merparten av ditt uppdrag, t.ex. i uppdragsgivarens lokal eller kontor. När du begär skatteavdrag för bilresor i jobbet är det viktigt att du har ett underlag i form av en körjournal. Vi kan komma att begära in körjournal vid granskning av fakturaunderlaget.",
	    "SHOW_CALCULATION": "Visa uträkning",
	    "HIDE_CALCULATION": "Dölj uträkning",
	    "CALCULATION_INVOICERY_FEE": "Frilans Finans",
	    "TOOLTIP_CALCULATION_INVOICERY_FEE": "Kostnad för administration och redovisning.",
	    "CALCULATION_REWARDS_DISCOUNT": "Rabatt \"Together\"",
	    "CALCULATION_PAYROLL_TAX": "Arbetsgivaravgift",
	    "TOOLTIP_CALCULTAION_PAYROLL_TAX": "Lagstadgad avgift vid löneutbetalning som betalas till Skatteverket. Arbetsgivaravgiften finansierar svenska socialförsäkringar som t.ex. den allmänna pensionen.",
	    "CALCULATION_SPECIAL_PENSION_TAX": "Löneskatt tjänstepension",
	    "TOOLTIP_CALCULATION_SPECIAL_PENSION_TAX": "Lagstadgad skatt på tjänstepension som betalas in till Skatteverket.",
	    "TOOLTIP_CALCULATION_GROSS_SALARY": "Bruttolön är din lön som är kvar efter Frilans Finans administrativa kostnad, arbetsgivaravgifter, tjänstepension och eventuella skattefria delar. Bruttolönen presenteras inklusive semesterersättning och utbetalas vid varje löneutbetalning. Väljer du att spara din semesterersättning redovisas den separat.",
	    "CALCULATION_HOURLY_SALARY_VACATION_INCLUDED": "Timlön inkl. semesterersättning",
	    "CALCULATION_HOURLY_SALARY_VACATION_EXCLUDED": "Timlön exkl. semesterersättning",
	    "CALCULATION_INCOME_TAX": "Inkomstskatt",
	    "TOOLTIP_CALCULATION_INCOME_TAX": "Lagstadgad skatt på inkomst av tjänst som betalas in till Skatteverket.",
	    "TOOLTIP_CALCULATION_NET_SALARY": "Lön efter skatter och avgifter.",
	    "MENU_PREREGISTERED_INVOICES": "Registrerade uppdrag",
	    "MENU_MY_INVOICING": "Min fakturering",
	    "MENU_LOYALTY_PAGE": "Samlade poäng",
	    "POINTS_AND_SAVINGS": "Poäng och Sparande",
	    "EARNED_REWARD_POINTS": "Dina poäng",
	    "POINTS_AND_SAVINGS_LINK_PENSION": "Läs mer om tjänstepension",
	    "POINTS_AND_SAVINGS_LINK_VACATION": "Ändra inställningar",
	    "POINTS_AND_SAVINGS_LINK_TOGETHER_REWARDS": "Till Together Rewards",
	    "REWARD_POINTS": "Poäng",
	    "DASHBOARD_GREETING_1": "Hej %(name)s,",
	    "DASHBOARD_GREETING_2": "Vad vill du göra idag?",
	    "DASHBOARD_INFO_LINK": "Läs mer om skillnaden mellan att registrera uppdrag och skapa faktura direkt",
	    "ACTIVE_ASSIGNMENT": "Pågående uppdrag",
	    "UPCOMNIG_ASSIGNMENT": "Kommande uppdrag",
	    "PAST_ASSIGNMENT": "Arbetsdatum passerat",
	    "REVIEW_INVOICE": "Granska och skapa faktura",
	    "EDIT_INVOICE": "Redigera",
	    "REGISTERED_ASSIGNMENTS_TITLE": "Registrerade uppdrag",
	    "REGISTERED_ASSIGNMENTS_TITLE_SHOW_ALL": "Visa alla uppdrag",
	    "REGISTERED_ASSIGNMENTS_DESCRIPTION": "Som egenanställd är det viktigt att du känner trygghet i din arbetssituation. Vi kan enklare säkerställa goda arbetsvillkor när du registrerar ditt uppdrag även om vi också arbetar efterhjälpande. Läs mer om hur vi jobbar med %(insurancesLink)s och %(workingConditionsLink)s.",
	    "REGISTERED_ASSIGNMENTS_DESCRIPTION_INSURANCES_LINK": "försäkringar",
	    "REGISTERED_ASSIGNMENTS_DESCRIPTION_WORKING_CONDITIONS_LINK": "goda arbetsvillkor",
	    "LOYALTY_POINTS_TITLE": "Samlade poäng - Together",
	    "LOTALTY_START_LEVEL": "Startnivå",
	    "LOYALTY_TITLE_1": "Come",
	    "LOYALTY_TITLE_2": "Stay",
	    "LOYALTY_TITLE_3": "Share",
	    "LOYALTY_TITLE_4": "Dream",
	    "LOYALTY_TITLE_5": "Take off",
	    "LOYALTY_TITLE_6": "Fly",
	    "LOYALTY_DESCRIPTION_1": "Välkommen till lojalitetsprogrammet Together! När du använder Frilans Finans delar du, tillsammans med många andra egenanställda på nödvändiga resurser som t.ex. redovisningsekonomer, revisorer, skattejurister, arbetsrättsjurister och rådgivning. Alla egenanställda arbetstagare har tillgång till det stora företagets resurser men till en bråkdel av den faktiska kostnaden. Man kan säga att vi delar på ett företag tillsammans istället för att alla har varsitt. Nivån Come innebär starten på vår resa tillsammans.",
	    "LOYALTY_DESCRIPTION_2": "Nu har du samlat över 100 000 poäng. Väl kämpat och tack för att du är med oss! Frilans Finans har alltid haft en grundkostnad för administration på 6% av fakturabeloppet. Vi håller ihop och sänker din kostnad till 5.75%. Rabatten dras av automatiskt. Enjoy!",
	    "LOYALTY_DESCRIPTION_3": "Nu har du samlat över 250 000 poäng. Bra jobbat! Frilans Finans har alltid haft en grundkostnad för administration på 6% av fakturabeloppet. Vi delar på resan tillsammans och sänker din kostnad till 5.5%. Rabatten dras av automatiskt. Enjoy!",
	    "LOYALTY_DESCRIPTION_4": "Nu har du samlat över 500 000 poäng. Väl kämpat och tack för förtroendet att få hantera din fakturering! Frilans Finans har alltid haft en grundkostnad för administration på 6% av fakturabeloppet. Vi stödjer din dröm och sänker din kostnad till 5%. Rabatten dras av automatiskt. Enjoy!",
	    "LOYALTY_DESCRIPTION_5": "Nu har du samlat över 1 000 000 poäng. Bra jobbat! Frilans Finans har alltid haft en grundkostnad för administration på 6% av fakturabeloppet. Vi vill stötta dig så du kan lyfta ännu mer och sänker din kostnad till 4.5%. Rabatten dras av automatiskt. Enjoy!",
	    "LOYALTY_DESCRIPTION_6": "Nu har du samlat över 1 500 000 poäng. Vilket imponerande och inspirerande arbete du gör för dig och hela vår organisation! Frilans Finans har alltid haft en grundkostnad för administration på 6% av fakturabeloppet. Nu flyger vi tillsammans och sänker din kostnad till 4%. Rabatten dras av automatiskt. Enjoy!",
	    "LOYALTY_ALWAYS_INCLUDED_TITLE": "Ingår alltid",
	    "LOYALTY_ALWAYS_INCLUDED_FAST_PAYMENT": "Snabb löneutbetalning",
	    "LOYALTY_ALWAYS_INCLUDED_ADVICE": "Rådgivning",
	    "LOYALTY_ALWAYS_INCLUDED_HOTLINE": "Förhandlingsjouren",
	    "LOYALTY_ALWAYS_INCLUDED_BENEFITS": "Förmåner",
	    "LOYALTY_HOW_TO_TITLE": "Hur du samlar poäng",
	    "LOYALTY_HOW_TO_DESCRIPTION": "När du skapar en faktura av ett registrerat uppdrag samlar du 1 poäng per fakturerad krona. När du skapar en faktura direkt samlar du 0.2 poäng per fakturerad krona.\n\nPoängen tillfaller ditt poängsaldo så snart fakturan blivit betald av din kund och är giltiga i 24 månader. I poänghistoriken nedan ser du både dina kommande poäng och registrerade poäng.",
	    "LOYALTY_HOW_TO_LINK": "Klicka här för att läsa mer om lojalitetsprogrammet",
	    "LOYALTY_POINTS_TABLE_TITLE": "Poänghistorik",
	    "LOYALTY_POINTS_TABLE_UPCOMING": "Kommande poäng",
	    "LOYALTY_POINTS_TABLE_REGISTERED": "Registrerade poäng",
	    "LOYALTY_INFO_MODAL_TITLE": "Vad är skillnaden?",
	    "LOYALTY_INFO_MODAL_PREREGISTER_TITLE": "Registrera uppdrag",
	    "LOYALTY_INFO_MODAL_PREREGISTER_MAIL_TEXT": "Passar dig som har ett kommande uppdrag",
	    "LOYALTY_INFO_MODAL_PREREGISTER_HEART_TEXT": "1 poäng per fakturerad krona när du skapar en faktura av uppdraget",
	    "LOYALTY_INFO_MODAL_PREREGISTER_UMBRELLA_TEXT": "Garanterad sjuklön i enlighet med sjuklönelagen",
	    "LOYALTY_INFO_MODAL_PREREGISTER_SHIELD_TEXT": "Vi kan enklare säkerställa att du arbetar under goda arbetsvillkor",
	    "LOYALTY_INFO_MODAL_INVOICE_TITLE": "Skapa faktura direkt",
	    "LOYALTY_INFO_MODAL_INVOICE_MAIL_TEXT": "Passar dig som redan utfört ditt uppdrag",
	    "LOYALTY_INFO_MODAL_INVOICE_HEART_TEXT": "0.2 poäng per fakturerad krona",
	    "REGISTERED_ASSIGNMENTS_TEXT": "Registrera ett uppdrag genom att klicka på 'Registrera uppdrag' här nedan. När uppdraget är slutfört kan du skapa en faktura av uppdraget genom att klicka på \"Granska och skapa faktura\". Du kan även redigera eller ta bort uppdrag.",
	    "BUTTON_REGISTER_ASSIGNMENT": "Registrera uppdrag",
	    "BUTTON_CREATE_INVOICE": "Skapa faktura",
	    "BUTTON_CREATE_TENDER": "Skapa offert",
	    "BUTTON_WRITE_CONTRACT": "Skapa uppdragsavtal",
	    "INVOICES_TABLE_TITLE_CUSTOMER": "Kund",
	    "INVOICES_TABLE_TITLE_CREATED": "Skapad",
	    "INVOICES_TABLE_TITLE_ORDER_NUMBER": "Ordernr.",
	    "INVOICES_TABLE_TITLE_SUM_EXCL_VAT": "Belopp ex. moms",
	    "INVOICES_TABLE_TITLE_STATUS": "Status",
	    "INVOICES_TABLE_TITLE_MORE": "Mer",
	    "SENT_PREREPORT_MODAL_TITLE": "Ditt uppdrag är registrerat",
	    "SENT_PREREPORT_MODAL_REGISTERED": "Ditt uppdrag är nu registrerat",
	    "SENT_PREREPORT_MODAL_WORK_DONE": "Du utför uppdraget",
	    "SENT_PREREPORT_MODAL_EASY_INVOICING": "Du skapar enkelt en faktura av uppdraget och slipper fylla i alla uppgifter",
	    "SENT_PREREPORT_MODAL_PREREGISTER_AGAIN_BTN": "Registrera fler uppdrag",
	    "SENT_PREREPORT_MODAL_DONE_BTN": "Klar",
	    "INVOICE_OVERVIEW": "Fakturaöversikt",
	    "CONFIRM_PREREGISTER_MODAL_TITLE": "Sammanfattning",
	    "CONFIRM_PREREGISTER_MODAL_TEXT": "Du är påväg att registrera ett uppdrag med följande uppgifter",
	    "CONFIRM_PREREGISTER_MODAL_PERIOD": "Period:",
	    "CONFIRM_PREREGISTER_MODAL_PERIOD_TO": "till",
	    "CONFIRM_PREREGISTER_MODAL_SUBMIT": "Registrera uppdrag",
	    "CONFIRM_INVOICE_MODAL_TITLE": "Sammanfattning",
	    "CONFIRM_INVOICE_MODAL_TEXT": "Du är påväg att skapa en faktura med följande uppgifter",
	    "CONFIRM_INVOICE_MODAL_EMAIL_TO": "E-post till ",
	    "CONFIRM_INVOICE_MODAL_MAIL_TO": "Brev till",
	    "CONFIRM_INVOICE_MODAL_E_INVOICE_TO": "E-faktura till",
	    "CONFIRM_INVOICE_MODAL_SMS_TO": "SMS till",
	    "CONFIRM_INVOICE_MODAL_SUBMIT": "Skapa faktura",
	    "SENT_INVOICE_MODAL_TITLE": "Din faktura är skapad",
	    "SENT_INVOICE_MODAL_INVOICE_CREATED": "Du har skapat en faktura",
	    "SENT_INVOICE_MODAL_INVOICE_REVIEWED_BY_FF": "Faktura skickas för granskning av klientstöd",
	    "SENT_INVOICE_MODAL_SENT_TO_COMPANY": "Faktura skickas till din kund och du får ett bekräftelsemail",
	    "SENT_INVOICE_MODAL_INVOICE_AGAIN_BTN": "Skapa en till faktura",
	    "SENT_INVOICE_MODAL_DONE_BTN": "Klar",
	    "INVOICE_DETAILS_ORDER_NUMBER": "Ordernummer #%(ordernumber)s",
	    "INVOICE_DETAILS_SPECIFICATION": "Specifikation",
	    "INVOICE_DETAILS_WORK_DATES": "Arbetsdatum",
	    "INVOICE_DETAILS_INVOICE_AMOUNT": "Fakturabelopp",
	    "INVOICE_DETAILS_YOUR_COMPENSATION": "Din ersättning",
	    "INVOICE_DETAILS_DEDUCTION": "Avdrag",
	    "INVOICE_DETAILS_NO_DEDUCTIONS": "Du har inga avdrag",
	    "INVOICE_DETAILS_COMPENSATION": "Arbetstagares ersättning",
	    "INVOICE_DETAILS_TOGETHER_REWARDS": "Together rewards",
	    "INVOICE_DETAILS_INVOICING_RECIPIENT": "Kunduppgifter",
	    "INVOICE_DETAILS_INVOICING_REFERENCE": "Referens",
	    "INVOICE_DETAILS_INVOICING_DETAILS": "Detaljer",
	    "INVOICE_DETAILS_INVOICING_ORDER_NUMBER": "Ordernr",
	    "INVOICE_DETAILS_INVOICING_ORDER_SENT_AS": "Faktura skickas som",
	    "INVOICE_DETAILS_INVOICING_VIEW_HOURS": "Visa arbetade timmar",
	    "INVOICE_DETAILS_INVOICING_REGISTERED_ASSIGNMENT": "Registrerat uppdrag",
	    "INVOICE_DETAILS_REWARDS_ORDER_NUMBER": "Ordernr",
	    "INVOICE_DETAILS_REWARDS_POINTS": "Antal poäng",
	    "INVOICE_DETAILS_REWARDS_REGISTERED_ASSIGNMENT": "Registrerat uppdrag",
	    "INVOICE_DETAILS_REWARDS_STATUS": "Poängstatus",
	    "INVOICE_DETAILS_REWARDS_TO_PAY": "Summa att utbetala",
	    "INVOICE_DETAILS_REVIEW_AND_CREATE_INVOICE": "Granska och skapa faktura",
	    "BUTTON_REVIEW_AND_CREATE_INVOICE": "Granska och skapa faktura",
	    "REVIEW_AND_CREATE_INVOICE_DESCRIPTION": "Innan du skapar din faktura får du här möjlighet att granska dina inmatningar. För att redigera uppgifter och skapa din faktura tryck på knappen ”Gå till fakturaverktyget”. Du hittar knappen längst ner.",
	    "REVIEW_AND_CREATE_INVOICE_TO_PAY": "Att betala till ditt bankkonto",
	    "REVIEW_AND_CREATE_INVOICE_TO_PAY_ITP": "Sparas till tjänstepension",
	    "REVIEW_AND_CREATE_INVOICE_TO_PAY_VACATION": "Sparas till semester",
	    "REVIEW_AND_CREATE_INVOICE_CREATE_ASSIGNMENT_BUTTON": "Skapa faktura",
	    "REVIEW_AND_CREATE_INVOICE_EDIT_ASSIGNMENT_BUTTON": "Gå till fakturaverktyget",
	    "REVIEW_AND_CREATE_INVOICE_TO_BE_PAID_TOTAL": "Total nettobehållning",
	    "LOYALTY_POINTS_TABLE_FRILANS_FINANS": "Frilans Finans",
	    "LOYALTY_POINTS_TABLE_SHOW_MORE_POINTS": "Visa fler +",
	    "LOYALTY_POINTS_TABLE_ALL_POINTS_ARE_LOADED": "Alla poäng inladdade",
	    "LOYALTY_POINTS_TABLE_NO_PENDING_POINTS": "Du har inga kommande poäng",
	    "LOYALTY_POINTS_TABLE_NO_COMPLETE_POINTS": "Du har inga poäng registrerade",
	    "REGISTER_ASSIGNMENT_CUSTOMER_TEXT": "Här anger du vem du ska utföra uppdraget för.",
	    "REGISTER_ASSIGNMENT_MONEY_DISTRIBUTION_TEXT": "Här ser du hur mycket som kommer utbetalas till ditt bankkonto och hur mycket som sparas till din tjänstepension. Har du valt att spara semesterersättning kan du även se det beloppet. Genom att klicka på “Visa detaljer” kan du yrka avdrag, lägga till medarbetare samt se fullständig uträkning. Informationen i detta avsnitt delas inte med din uppdragsgivare/kund.",
	    "REGISTER_ASSIGNMENT_UPDATE_INVOICE": "Uppdatera",
	    "REGISTER_ASSIGNMENT_REGISTER_SAVE_DRAFT": "Slutför registrering",
	    "REGISTER_ASSIGNMENT_CANCEL_BUTTON": "Avbryt",
	    "REGISTER_ASSIGNMENT_CLOSE_INVOICE_TOOL": "Stäng",
	    "REGISTER_ASSIGNMENT_ROT_RUT_TEXT": "Här fyller du i om ditt uppdrag avser ett arbete som berättigar din kund till rot- och rutavdrag.",
	    "REGISTER_ASSIGNMENT_INVOICING_TEXT": "Här väljer du hur kommande faktura ska skickas till din kund. Genom att ange det nu kan du skicka din faktura snabbare när uppdraget är slutfört.",
	    "REGISTER_ASSIGNMENT_INVOICE_TEXT": "Beskriv ditt uppdrag så utförligt du kan. Denna informationen utgör beskrivningen på uppdragets kommande faktura som skickas till din kund.",
	    "REGISTER_ASSIGNMENT_WORK_DATE_TEXT": "Här fyller du i arbetstiden du planerar för ditt uppdrag. Du kan också välja om denna informationen ska visas på kommande faktura. \n\nHar du många arbetsdatum? Klicka på veckonumret för att markera hela veckan mån-fre.",
	    "REGISTER_ASSIGNMENT_INVOICE_TOOL": "REGISTRERING AV UPPDRAG",
	    "REGISTER_ASSIGNMENT_INFO_MODAL_TITLE": "Välkommen till registrering av uppdrag",
	    "REGISTER_ASSIGNMENT_INFO_MODAL_HOW_TITLE": "Hur funkar det?",
	    "REGISTER_ASSIGNMENT_INFO_MODAL_BENEFITS_TITLE": "Fördelar",
	    "REGISTER_ASSIGNMENT_INFO_MODAL_ENVELOPE_OPEN": "Du registrerar ditt kommande uppdrag i detta verktyg",
	    "REGISTER_ASSIGNMENT_INFO_MODAL_PENCIL": "Du kan enkelt ändra eller ta bort ditt uppdrag efter du registrerat det",
	    "REGISTER_ASSIGNMENT_INFO_MODAL_FILE_ADD": "När uppdraget är utfört skapar du fakturan och slipper fylla i alla uppgifter",
	    "REGISTER_ASSIGNMENT_INFO_MODAL_UMBRELLA": "Garanterad sjuklön i enlighet med sjuklönelagen",
	    "REGISTER_ASSIGNMENT_INFO_MODAL_SHIELD_CHECK": "Vi kan enklare säkerställa att du arbetar under goda arbetsvillkor",
	    "REGISTER_ASSIGNMENT_INFO_MODAL_HEART": "Du samlar fler poäng i lojalitetsprogrammet Together",
	    "LEVEL_CURRENT_LEVEL": "Din nivå",
	    "LEVEL_NEXT_LEVEL": "Nästa nivå",
	    "INVOICE_TOOL_PREVIEW_INVOICE_TEXTLINK": "Se faktura som den skickas till kund",
	    "INVOICE_TOOL_CREATE_INVOICE_BUTTON": "Skapa faktura",
	    "INVOICE_TOOL_COMPLETE_BUTTON": "Slutför fakturering",
	    "CANCEL_BUTTON": "Avbryt",
	    "INVOICE_REWARDS_WAITING_ON_PAYMENT": "Inväntar betalning från kund",
	    "INVOICE_REWARDS_REGISTERED": "Poäng registrerade",
	    "INVOICE_TOOL_INVOICE_UPDATED_TITLE": "Faktura uppdaterad",
	    "INVOICE_TOOL_INVOICE_UPDATED_BODY": "Dina ändringar har sparats",
	    "INVOICE_TOOL_ASSIGNMENT_UPDATED_TITLE": "Registrerat uppdrag uppdaterat",
	    "INVOICE_TOOL_ASSIGNMENT_UPDATED_BODY": "Dina ändringar har sparats",
	    "TOOLTIP_CALCULATION_REWARDS_DISCOUNT": "Du har uppnått en nivå i lojalitetsprogrammet Together som ger dig rabatt på Frilans Finans administrationskostnad (over head). Du kan se hur mycket rabatt du har genom att gå in på Min fakturering --> Samlade poäng.",
	    "LOYALTY_CHART_TITLE": "Dina samlade poäng",
	    "LOYALTY_CHART_NEXT_LEVEL": "Nästa nivå:",
	    "LOYALTY_CHART_POINTS_OF": "av",
	    "AFFECTED_ITP_MODAL_ONE_TITLE": "Nu blir det ännu tryggare att vara egenanställd hos Frilans Finans 🎉",
	    "AFFECTED_ITP_MODAL_ONE_BODY": "Från den 7 april 2022 aktiverar vi automatiskt sparande till din tjänstepension varje gång du fakturerar. Detta för att du ska ha en stabil och hållbar ekonomi när det väl är dags för pension.\n\nVill du spara tjänstepension redan nu kan du aktivera det under ”Lön och ersättning” i ”Inställningar”.\n\nDu kan alltid kontakta klientstöd om du har några frågor.",
	    "AFFECTED_ITP_MODAL_TWO_TITLE": "Nu händer det grejer! 🎉",
	    "AFFECTED_ITP_MODAL_TWO_BODY": "Nu sätter vi automatiskt av sparande till din tjänstepension varje gång du skapar en faktura. Detta för att du ska ha en stabil och hållbar ekonomi när det väl är dags för pension. Du ser den nya fördelningen av pengar i fakturaverktyget.\n\nDessutom lanserar vi lojalitetsprogrammet Together, ett sätt för dig att samla poäng och i takt med det erhålla rabatter. Läs mer dina poäng under ”Min fakturering” —> ”Samlade poäng”.",
	    "EXCEEDING_WORKING_HOURS_TITLE": "Du har angett mer än 48 timmar på 7 dagar",
	    "EXCEEDING_WORKING_HOURS_BODY": "Arbetstiden du angett överstiger 48 timmar på 7dagar. Kan du påverka din arbetstid rekommenderar vi mer vila för att minska risken för olyckor.\n\nVäljer du att genomföra angiven arbetstid kommer vi vid skapandet av fakturan ställa 4 frågor om dina arbetsvillkor.",
	    "CHANGE_WORKING_HOURS": "Ändra arbetstid",
	    "SEND_SURVEY_RESPONSE": "Skicka in svar",
	    "ENTERED_WRONG_HOURS": "Jag angav fel arbetstid",
	    "MORE_INFORMATION": "Mer information",
	    "QUESTIONS_WORKING_CONDITIONS": "Frågor om dina arbetsvillkor:",
	    "SURVEY_INFORMATION_TEXT": "För att vi ska kunna säkerställa att du arbetar under goda arbetsvillkor önskar vi att du svarar på några frågor alternativt ändrar din arbetstid.",
	    "OPTIONAL_COMMENT": "Frivillig kommentar",
	    "QUESTION_1_TITLE": "Fråga 1",
	    "QUESTION_1_QUESTION": "Har du möjlighet att planera att din arbetstid inte ska överstiga 48 timmar under en sjudagarsperiod?",
	    "QUESTION_2_TITLE": "Fråga 2",
	    "QUESTION_2_QUESTION": "Anser du att du arbetat så mycket att du inte hinner med ordentlig återhämtning mellan olika arbetsuppgifter/uppdrag?",
	    "QUESTION_3_TITLE": "Fråga 3",
	    "QUESTION_3_QUESTION": "Finns det risker i din arbetsmiljö, t.ex. arbete med maskiner eller dylikt, på arbetsplatsen?",
	    "QUESTION_3-1_TITLE": "Fråga 3.1",
	    "QUESTION_3-1_QUESTION": "Använder du utrustning/verktyg/maskiner som kan utgöra en risk för dig?",
	    "QUESTION_3-2_TITLE": "Fråga 3.2",
	    "QUESTION_3-2_QUESTION": "Framför du fordon på arbetsplatsen?",
	    "QUESTION_3-3_TITLE": "Fråga 3.3",
	    "QUESTION_3-3_QUESTION": "Framför du fordon till och från arbetsplatsen?",
	    "QUESTION_3-4_TITLE": "Fråga 3.4",
	    "QUESTION_3-4_QUESTION": "Arbetar du på hög höjd (>2m)? ",
	    "QUESTION_4_TITLE": "Fråga 4",
	    "QUESTION_4_QUESTION": "Bedömer du att arbetstiden i framtida uppdrag kommer överstiga 48 timmar under en sjudagarsperiod?",
	    "OTHER_RISK_COMMENT": "Övrig risk/annan information",
	    "MORE_INFORMATION_TEXT": "I Frilans Finans uppdrag ingår att verka för att ditt arbete som egenanställd arbetstagare ska utgöra en del av ett ekonomiskt och socialt hållbart arbetsliv. Ett av flera initiativ för att förverkliga detta mål, är det kollektivavtal vi tecknat med det politiskt oberoende fackförbundet Säljarnas Riksförbund som bland annat definierar vad som är hållbar arbetstid.\n\nDen arbetstid du angivit översiger 48 timmar under en sjudagarsperiod, vilket kan utgöra en förhöjd arbetsmiljörisk och därför inte är förenligt med arbetstidslagens syfte. Det är när vi är trötta som risken för olycka eller tillbud ökar. \n\nArbetsmarknadens parter konstaterar att det är förståeligt att man ibland kan man behöva arbeta mer under en tillfällig period, till exempel på grund av arbetets art eller en tillfällig situation somuppstår. Genom att svara på frågorna kan vi bedöma om du har möjlighet till återhämtning.",
	    "WORKING_HOURS_INFO_MODAL_TITLE": "Varför är arbetstid viktigt att fylla i",
	    "WORKING_HOURS_INFO_MODAL_BODY": "När du fakturerar genom Frilans Finans är du, för att kunna fakturera utan F-skatt, anställd av Frilans Finans under uppdragsperioden. Den registrerade arbetstiden utgör underlag för din anställning och då också inkomstuppgifter till bland annat försäkringskassan och arbetsgivarintyg. Vi vill dessutom kunna säkerställa att du arbetar under goda arbetsvillkor.\n\nOm du fakturerar flera kunder för samma arbetstid, t.ex. om en PT haft gruppträning och fakturerar gruppmedlemmar för samma tid, är det viktigt att dela upp tiden på alla fakturor. Samma timme registreras annars flera gånger.",
	    "LOW_HOURLY_SALARY_MODAL_TITLE": "Är din timlön korrekt?",
	    "LOW_HOURLY_SALARY_MODAL_BODY": "Under din uppdragstid är du anställd av Frilans Finans. Enligt vårt kollektivavtal är en skälig timlön %(minimumHourlySalary)s SEK exkl. semesterersättning i din ålder. Baserat på angivet fakturabelopp och arbetstid är din timlön %(currentHourlySalary)s SEK exkl. semesterersättning.\n\nDu kan fortfarande skapa ett fakturaunderlag med nuvarande timlön men vi kommer då kontakta dig för att säkerställa att du arbetar under goda arbetsvillkor.\n\nOm du vill att din timlön ska bli %(minimumHourlySalary)s SEK exkl. semesterersättning kan du antingen lägga till %(addAmount)s SEK exkl. moms på ditt fakturabelopp eller minska arbetstiden med %(removeHours)s timmar.\n\nDu kan se din aktuella timlön under steg 3 “Fördelning av pengar” -> “Visa detaljer” -> “Visa fullständig uträkning” i fakturaverktyget. ",
	    "MODAL_COMPLETE_INFORMATION": "Komplettera dina uppgifter",
	    "LOG_IN_REMEMBER_ME": "Kom ihåg mig",
	    "LOG_IN_CANCEL": "Avbryt inloggning",
	    "NO_BANK_ID": "Har du inget BankID?",
	    "LOG_IN_WITH_EMAIL_LINK": "Logga in med e-post och lösenord",
	    "LOG_IN_WITH_BANKID_LINK": "Logga in med BankID",
	    "REGISTER_HAVE_ACCOUNT": "Har du redan ett konto?",
	    "COMPLETE_INFORMATION_ORDER_TOOL_TITLE": "Fyll i dina uppgifter för att skapa fakturan",
	    "FIRST_NAME_ERROR_INVALID_CHARACTERS": "Förnamn innehåller otillåtna tecken",
	    "LAST_NAME_ERROR_INVALID_CHARACTERS": "Efternamn innehåller otillåtna tecken",
	    "COMPLETE_INFORMATION_ORDER_TOOL_CONTACT_INFO_TAB": "Kontaktuppgifter",
	    "COMPLETE_INFORMATION_ORDER_TOOL_SALARY_INFO_TAB": "Löneutbetalning",
	    "COMPLETE_INFORMATION_ORDER_TOOL_INVOICING_INFO_TAB": "Din fakturering",
	    "COMPLETE_INFORMATION_ORDER_TOOL_CONTACT_INFO_DESCRIPTION": "Vi behöver dina kontaktuppgifter för att effektivt kunna kommunicera om t.ex. löneutbetalning, fakturastatus och eventuella frågor.",
	    "COMPLETE_INFORMATION_ORDER_TOOL_SALARY_INFO_DESCRIPTION": "Vi behöver dina kontouppgifter för att kunna betala ut din lön.",
	    "COMPLETE_INFORMATION_ORDER_TOOL_INVOICING_INFO_DESCRIPTION": "Vi behöver uppgifter om det arbete du ska fakturera för så vi kan försäkra dig och ditt arbete samt säkerställa att du arbetar under skäliga och goda villkor.",
	    "COMPLETE_INFORMATION_ORDER_TOOL_INVOICING_INFO_SUB_DESCRIPTION": "Välj det yrke som bäst matchar dina arbetsuppgifter. Fakturerar du för flera olika typer av arbeten kan du välja det yrke som motsvarar merparten av dina uppdrag.",
	    "COMPLETE_INFORMATION_ORDER_TOOL_INVOICING_INFO_SAVE_VACATION": "Spara Semesterersättning",
	    "COMPLETE_INFORMATION_ORDER_TOOL_INVOICING_INFO_PAY_VACATION": "Betala ut i samband med lön",
	    "MODAL_SAVE_VACATION_INVOICING_INFO_CONTINUE_AS_IT_IS": "Fortsätt som det är idag",
	    "COMPLETE_INFORMATION_ORDER_TOOL_INVOICING_INFO_SAVE_VACATION_INFO": "* Vi rekommenderar att du sparar semesterersättningen om du arbetar över 480 timmar (3 månader) varje år.",
	    "MODAL_SAVE_VACATION_TITLE": "Du har arbetat mycket hos oss 👏🏼",
	    "MODAL_SAVE_VACATION_BODY": "Härligt att du har många uppdrag och bra jobbat! När man arbetar mycket är det viktigt att vila och njuta av semester. För att kunna njuta fullt ut kan det vara skönt att ha semesterpengar sparat. Vill du börja spara din semesterersättning? 🏖\n\nVäljer du att spara semesterersättningen kommer vi betala ut ersättningen runt 19 juni varje år (eller när du begär ut den). Det kommer resultera i att du får mindre utbetalt på ditt bankkonto vi varje fakturering men istället får pengarna när det är dags för semester.",
	    "MODAL_VACATION_INFORMATION_TITLE": "Semesterersättning",
	    "MODAL_VACATION_INFORMATION_BODY": "Som egenanställd kan du välja hur din semesterersättning ska hanteras. Det är möjligt att få den utbetald med lönen du får för varje genomfört uppdrag eller spara den och få den utbetald runt den 19 juni varje år. Du kan ändra dina inställningar inför varje faktureringstillfälle om du önskar.\n\nFrån vårt kollektivavtal: \nSemester § 6 \nSemester tjänas in under perioden 1 april till 31 mars varje år. För uppdrag kortare än tre månader och där den egenanställde arbetstagaren så önskar ska semesterersättning uppgående till 12 procent löpande betalas ut utöver den lön som den egenanställde arbetstagaren erhåller. Detta belopp ska särredovisas i lönespecifikationen till den anställde så att det tydligt framgår vad som utgör lön och vad som utgör semesterersättning. Den egenanställde arbetstagaren kan särskilt begära att semestersättning ska ackumuleras vid uppdrag kortare än 3 månader. Har inte annat överenskommits mellan den egenanställde arbetstagaren och arbetsgivaren ska semesterförmånerna betalas i samband med huvudsemestern. Arbetsgivaren betalar då ut de ackumulerade semesterförmånerna den 25 juni varje år. ",
	    "SENT_PREREPORT_UPDATE_MODAL_TITLE": "Ditt registrerade uppdrag har uppdaterats",
	    "UPDATE": "Uppdatera",
	    "SSNR_MODAL_HEADER": "Välkommen som egenanställd!",
	    "SSNR_MODAL_TEXT": "Vänligen ange ditt personnummer. Det behövs för att rätt skatt ska registreras hos skatteverket och för att vi ska kunna upprätta arbetsgivarintyg. ",
	    "SSNR_MODAL_PLACEHOLDER": "YYYYMMDD-XXXX",
	    "SSNR_MODAL_SMALL_TEXT": "Frilans Finans behandlar samtliga uppgifter i enlighet med dataskyddsförordningen (GDPR) och därmed konfidentiellt.",
	    "SSNR_MODAL_IMAGE": "https://www.frilansfinans.se/wp-content/uploads/2022/10/FF_TE_210916_24-scaled.jpg",
	    "EMAIL_MODAL_TITLE": "Välkommen till Frilans Finans!",
	    "EMAIL_MODAL_TEXT": "Vänligen ange din e-post. Vi använder din e-post för att ge dig uppdateringar kring din fakturering och för att kommunicera i frågor som rör dina uppdrag.",
	    "EMAIL_MODAL_IMAGE": "https://www.frilansfinans.se/wp-content/uploads/2022/10/ff_stockholm-office-corner-1-scaled.jpg",
	    "LOGIN_LINK_SENT_CHECK_YOUR_EMAIL": "En länk för att logga in har skickats till din e-postadress.\n\nDenna länk är giltig i 30 minuter.",
	    "BOUNCED_EMAIL_COMPANY_TOKEN_ERROR": "Hoppsan, länken verkar inte fungera. Testa öppna länken på nytt eller kontakta klientstöd på mejl info@frilansfinans.se eller telefon 0771-15 10 00.",
	    "BOUNCED_EMAIL_COMPANY_TITLE": "Uppdatera kunds mejladress",
	    "BOUNCED_EMAIL_COMPANY_BODY_PART_1": "Du har angivit mejladressen",
	    "BOUNCED_EMAIL_COMPANY_BODY_PART_2": "till kund",
	    "BOUNCED_EMAIL_COMPANY_BODY_PART_3": "Adressen verkar inte användas då mejlet med fakturan har studsat i vårt system. Uppdatera mejladressen till kund för att skicka fakturan på nytt.",
	    "BOUNCED_EMAIL_COMPANY_ALREADY_UPDATED": "Mejladressen har redan uppdaterats av dig eller klientstöd. Fakturan har skickats till den nya adressen.",
	    "BOUNCED_EMAIL_COMPANY_UPDATED": "Mejladressen är nu uppdaterad och fakturan skickas till den nya adressen.",
	    "ENTER_NEW_EMAIL": "Ange ny mejladress",
	    "INVOICE_TOOL_LOCK_INVOICE_ERROR_TITLE": "Fakturan hanteras just nu av en handläggare",
	    "INVOICE_TOOL_LOCK_INVOICE_ERROR_MESSAGE": "Du kan inte redigera fakturan för tillfället. En handläggare hanterar just nu fakturan. Behöver du ändra något på fakturan kan du istället kontakta oss.",
	    "BETA_BANNER_TEXT_TITLE": "Sneak peek! 👀",
	    "BETA_BANNER_TEXT_SUBTITLE": "Nya, fräscha Frilans Finans väntar på ditt omdöme. Välkommen att testa betaversionen.",
	    "BETA_BANNER_BUTTON": "Öppna Betaversion" /* eslint-enable */
	
	};

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CoreLayout = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1307);
	
	var _reactRedux = __webpack_require__(12);
	
	var _header = __webpack_require__(692);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(689);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _mainMenu = __webpack_require__(694);
	
	var _mainMenu2 = _interopRequireDefault(_mainMenu);
	
	var _authentication = __webpack_require__(90);
	
	var _authentication2 = _interopRequireDefault(_authentication);
	
	var _spinnerPage = __webpack_require__(379);
	
	var _spinnerPage2 = _interopRequireDefault(_spinnerPage);
	
	var _taxkeyService = __webpack_require__(119);
	
	var _taxkeyService2 = _interopRequireDefault(_taxkeyService);
	
	var _frilansFinans = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_header2.default, null);
	
	var _ref2 = _react2.default.createElement(_mainMenu2.default, null);
	
	var _ref3 = _react2.default.createElement(_footer2.default, null);
	
	var _ref4 = _react2.default.createElement(_spinnerPage2.default, null);
	
	var CoreLayout = exports.CoreLayout = function (_React$Component) {
	  (0, _inherits3.default)(CoreLayout, _React$Component);
	
	  function CoreLayout(props, context) {
	    (0, _classCallCheck3.default)(this, CoreLayout);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (CoreLayout.__proto__ || (0, _getPrototypeOf2.default)(CoreLayout)).call(this, props, context));
	
	    _this.componentWillMount = function () {
	      // Prevent main menu transition to run on page load
	      setTimeout(function () {
	        document.querySelector('body').classList.remove('preload');
	      }, 1);
	
	      _frilansFinans.UserService.get().promise.then(function (user) {
	        _taxkeyService2.default.get(user.id).done(this.loadingDone);
	      }).catch(_this.loadingDone);
	    };
	
	    _this.loadingDone = function () {
	      _this.setState({
	        loading: false
	      });
	    };
	
	    _this.componentWillReceiveProps = function (nextProps) {
	      _this.setState({
	        user: nextProps.user,
	        taxkeys: nextProps.taxkeys
	      });
	    };
	
	    _this.getChildContext = function () {
	      return {
	        user: _this.state.user,
	        taxkeys: _this.state.taxkeys
	      };
	    };
	
	    _this.renderReady = function () {
	      var classes = 'page-wrapper';
	      var showFooter = true;
	      var showHeader = true;
	
	      if (_authentication2.default.isAuthenticated) {
	        classes += ' logged-in';
	      }
	
	      if (_this.props.menuState === 'open') {
	        classes += ' menu-open';
	      }
	
	      if (!_this.props.topBottomSectionState.showFooter) {
	        showFooter = false;
	      }
	
	      if (!_this.props.topBottomSectionState.showHeader) {
	        showHeader = false;
	        classes = 'page-wrapper no-padding';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: classes },
	        showHeader ? _ref : '',
	        _ref2,
	        _react2.default.createElement(
	          'div',
	          { className: 'view-container' },
	          _this.props.children
	        ),
	        showFooter ? _ref3 : ''
	      );
	    };
	
	    _this.render = function () {
	      if (!_this.state.loading || _this.props.auth.reauthenticationStatus === 'fail') {
	        return _this.renderReady();
	      }
	
	      return _ref4;
	    };
	
	    _this.state = {
	      user: props.user,
	      taxkeys: props.taxkeys,
	      loading: true,
	      showFooter: true,
	      showHeader: true
	    };
	    return _this;
	  }
	
	  return CoreLayout;
	}(_react2.default.Component);
	
	CoreLayout.childContextTypes = {
	  user: _react2.default.PropTypes.object,
	  taxkeys: _react2.default.PropTypes.array
	};
	
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    menuState: state.menuState,
	    topBottomSectionState: state.topBottomSectionState,
	    user: state.user,
	    taxkeys: state.taxkeys
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(CoreLayout);

/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(12);
	
	var _pageWrapper = __webpack_require__(819);
	
	var _pageWrapper2 = _interopRequireDefault(_pageWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    user: state.user,
	    taxkeys: state.taxkeys
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(_pageWrapper2.default);

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PageWrapper = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _leftPageSection = __webpack_require__(705);
	
	var _leftPageSection2 = _interopRequireDefault(_leftPageSection);
	
	var _infoBoxList = __webpack_require__(337);
	
	var _infoBoxList2 = _interopRequireDefault(_infoBoxList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_infoBoxList2.default, null); /**
	                                                                        * Created by staffanrantzow on 15/03/16.
	                                                                        */
	
	var PageWrapper = exports.PageWrapper = function (_React$Component) {
	  (0, _inherits3.default)(PageWrapper, _React$Component);
	
	  function PageWrapper(props, context) {
	    (0, _classCallCheck3.default)(this, PageWrapper);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PageWrapper.__proto__ || (0, _getPrototypeOf2.default)(PageWrapper)).call(this, props, context));
	
	    _this.state = {
	      user: props.user,
	      taxkeys: props.taxkeys
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(PageWrapper, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        user: nextProps.user,
	        taxkeys: nextProps.taxkeys
	      });
	    }
	  }, {
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        user: this.state.user,
	        taxkeys: this.state.taxkeys
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'container page' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'left-column' },
	              _react2.default.createElement(_leftPageSection2.default, { currentPath: this.props.location.pathname })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'right-column page-content' },
	              this.props.children || 'Welcome to your PageWrapper',
	              _ref
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return PageWrapper;
	}(_react2.default.Component);
	
	PageWrapper.childContextTypes = {
	  user: _react2.default.PropTypes.object,
	  taxkeys: _react2.default.PropTypes.array
	};
	exports.default = PageWrapper;

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(46);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _routes = __webpack_require__(849);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _Root = __webpack_require__(748);
	
	var _Root2 = _interopRequireDefault(_Root);
	
	var _counterpart = __webpack_require__(86);
	
	var _counterpart2 = _interopRequireDefault(_counterpart);
	
	var _authentication = __webpack_require__(64);
	
	var _authentication2 = _interopRequireDefault(_authentication);
	
	var _store = __webpack_require__(92);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _langSe = __webpack_require__(816);
	
	var _langSe2 = _interopRequireDefault(_langSe);
	
	var _langEn = __webpack_require__(815);
	
	var _langEn2 = _interopRequireDefault(_langEn);
	
	var _cookieUtils = __webpack_require__(89);
	
	var _cookieUtils2 = _interopRequireDefault(_cookieUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(1295).polyfill();
	
	__webpack_require__(999);
	
	_counterpart2.default.registerTranslations('en', _langEn2.default);
	_counterpart2.default.registerTranslations('se', _langSe2.default);
	_counterpart2.default.setLocale('se');
	
	// Configure the authentication system
	_authentication2.default.init({
	  endpoints: {
	    token: 'https://ff-lumen-api-dev.herokuapp.com/auth/accesstoken'
	  },
	  store: _store2.default
	});
	
	// Now that we have the Redux store, we can create our routes. We provide
	// the store to the route definitions so that routes have access to it for
	// hooks such as `onEnter`.
	var routes = (0, _routes2.default)(_store2.default);
	
	// Now that redux and react-router have been configured, we can render the
	// React application to the DOM!
	_reactDom2.default.render(_react2.default.createElement(_Root2.default, { history: _store.history, routes: routes, store: _store2.default }), document.getElementById('root'));
	
	_cookieUtils2.default.setLanguageFromCookie(_store2.default);

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(120);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.default = configureStore;
	
	var _redux = __webpack_require__(142);
	
	var _reactRouterRedux = __webpack_require__(137);
	
	var _reduxThunk = __webpack_require__(1534);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _rootReducer = __webpack_require__(848);
	
	var _rootReducer2 = _interopRequireDefault(_rootReducer);
	
	var _variables = __webpack_require__(47);
	
	var variables = _interopRequireWildcard(_variables);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function configureStore() {
	  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var history = arguments[1];
	
	  // Compose final middleware and use devtools in debug environment
	  var middleware = [_reduxThunk2.default, (0, _reactRouterRedux.routerMiddleware)(history)];
	
	  if (true) {
	    var RavenMiddleware = __webpack_require__(1533);
	
	    var raven = RavenMiddleware(variables.sentryDsn, {
	      release: 'account-web:' + variables.version,
	      environment: variables.appEnv
	    });
	
	    middleware = [].concat((0, _toConsumableArray3.default)(middleware), [raven]);
	  }
	
	  middleware = _redux.applyMiddleware.apply(undefined, (0, _toConsumableArray3.default)(middleware));
	
	  if (false) {
	    var devTools = window.devToolsExtension ? window.devToolsExtension() : require('containers/DevTools').default.instrument();
	    middleware = (0, _redux.compose)(middleware, devTools);
	  }
	
	  // Create final store and subscribe router in debug env ie. for devtools
	  var store;
	  if (true) {
	    store = middleware(_redux.createStore)(_rootReducer2.default, initialState, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
	  } else {
	    store = middleware(_redux.createStore)(_rootReducer2.default, initialState);
	  }
	
	  if (false) {
	    module.hot.accept('./rootReducer', function () {
	      var nextRootReducer = require('./rootReducer').default;
	
	      store.replaceReducer(nextRootReducer);
	    });
	  }
	  return store;
	}

/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setReauthenticationStatus = setReauthenticationStatus;
	
	var _actionTypes = __webpack_require__(353);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function setReauthenticationStatus(status) {
	  return {
	    type: types.SET_REAUTHENTICATION_STATUS,
	    payload: status
	  };
	}

/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _assign = __webpack_require__(22);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.default = loading;
	
	var _actionTypes = __webpack_require__(353);
	
	var type = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = exports.initialState = {
	  reauthenticationStatus: null
	};
	
	function loading() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case type.SET_REAUTHENTICATION_STATUS:
	      return (0, _assign2.default)({}, state, {
	        reauthenticationStatus: action.payload
	      });
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _assign = __webpack_require__(22);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.default = bankId;
	
	var _actionTypes = __webpack_require__(354);
	
	var type = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = exports.initialState = {
	  socialSecurityNr: '',
	  email: '',
	  inProgress: false,
	  createOnAuth: false,
	  authType: 'MOBILE',
	  error: null
	};
	
	function bankId() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case type.SET_SOCIAL_SECURITY_NR:
	      return (0, _assign2.default)({}, state, {
	        socialSecurityNr: action.payload
	      });
	
	    case type.SET_EMAIL:
	      return (0, _assign2.default)({}, state, {
	        email: action.payload
	      });
	
	    case type.SET_IN_PROGRESS:
	      return (0, _assign2.default)({}, state, {
	        inProgress: action.payload
	      });
	
	    case type.SET_LOGIN_SUCCEEDED:
	      return (0, _assign2.default)({}, state, {
	        success: action.payload
	      });
	
	    case type.SET_ERROR:
	      return (0, _assign2.default)({}, state, {
	        error: action.payload
	      });
	
	    case type.SET_AUTH_TYPE:
	      return (0, _assign2.default)({}, state, {
	        authType: action.payload
	      });
	
	    case type.SET_ENTITY:
	      return (0, _assign2.default)({}, state, {
	        entity: action.payload
	      });
	
	    case type.SET_CREATE_ON_AUTH:
	      return (0, _assign2.default)({}, state, {
	        createOnAuth: action.payload
	      });
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _extends2 = __webpack_require__(27);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(22);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _actionTypes = __webpack_require__(356);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = exports.initialState = {
	  selectedBank: 'INITIAL',
	  clearingNumber: {
	    value: '',
	    isValid: false,
	    suppressError: true,
	    errorMessage: ''
	  },
	  accountNumber: {
	    value: '',
	    isValid: false,
	    suppressError: true,
	    errorMessage: ''
	  },
	
	  banks: []
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.RESET:
	      return (0, _assign2.default)({}, initialState);
	
	    case types.SET_BANKS:
	      return (0, _assign2.default)({}, state, {
	        banks: action.payload
	      });
	
	    case types.SET_SELECTED_BANK:
	      return (0, _assign2.default)({}, state, {
	        selectedBank: action.payload
	      });
	
	    case types.SET_CLEARING_NUMBER:
	      return (0, _assign2.default)({}, state, {
	        clearingNumber: (0, _extends3.default)({}, state.clearingNumber, {
	          value: action.payload
	        })
	      });
	
	    case types.SET_CLEARING_NUMBER_IS_VALID:
	      return (0, _assign2.default)({}, state, {
	        clearingNumber: (0, _extends3.default)({}, state.clearingNumber, {
	          isValid: action.payload
	        })
	      });
	
	    case types.SET_CLEARING_NUMBER_SUPPRESS_ERROR:
	      return (0, _assign2.default)({}, state, {
	        clearingNumber: (0, _extends3.default)({}, state.clearingNumber, {
	          suppressError: action.payload
	        })
	      });
	
	    case types.SET_CLEARING_NUMBER_ERROR_MESSAGE:
	      return (0, _assign2.default)({}, state, {
	        clearingNumber: (0, _extends3.default)({}, state.clearingNumber, {
	          errorMessage: action.payload
	        })
	      });
	
	    case types.SET_ACCOUNT_NUMBER:
	      return (0, _assign2.default)({}, state, {
	        accountNumber: (0, _extends3.default)({}, state.accountNumber, {
	          value: action.payload
	        })
	      });
	
	    case types.SET_ACCOUNT_NUMBER_IS_VALID:
	      return (0, _assign2.default)({}, state, {
	        accountNumber: (0, _extends3.default)({}, state.accountNumber, {
	          isValid: action.payload
	        })
	      });
	
	    case types.SET_ACCOUNT_NUMBER_SUPPRESS_ERROR:
	      return (0, _assign2.default)({}, state, {
	        accountNumber: (0, _extends3.default)({}, state.accountNumber, {
	          suppressError: action.payload
	        })
	      });
	
	    case types.SET_ACCOUNT_NUMBER_ERROR_MESSAGE:
	      return (0, _assign2.default)({}, state, {
	        accountNumber: (0, _extends3.default)({}, state.accountNumber, {
	          errorMessage: action.payload
	        })
	      });
	  }
	
	  return state;
	};

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchCurrencies = undefined;
	
	var _actionTypes = __webpack_require__(357);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _frilansFinans = __webpack_require__(11);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var setCurrencies = function setCurrencies(currencies) {
	  var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  return {
	    type: types.SET_CURRENCIES,
	    payload: currencies
	  };
	};
	
	var fetchCurrencies = exports.fetchCurrencies = function fetchCurrencies() {
	  return function (dispatch) {
	    dispatch({ type: types.FETCH_CURRENCIES });
	
	    _frilansFinans.CurrenciesService.get().then(function (currencies) {
	      dispatch({ type: types.FETCH_CURRENCIES_SUCCESS });
	      dispatch(setCurrencies(currencies.collection));
	    }).catch(function (error) {
	      dispatch({ type: types.FETCH_CURRENCIES_FAIL });
	      dispatch({ type: types.ERROR_CURRENCIES, error: error });
	    });
	  };
	};

/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _extends2 = __webpack_require__(27);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _actionTypes = __webpack_require__(357);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = exports.initialState = {
	  list: [],
	  fetchStatus: null,
	  error: null
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.SET_CURRENCIES:
	      return (0, _extends3.default)({}, state, { list: action.payload, error: null });
	    case types.FETCH_CURRENCIES:
	      return (0, _extends3.default)({}, state, { fetchStatus: 'fetching' });
	    case types.FETCH_CURRENCIES_SUCCESS:
	      return (0, _extends3.default)({}, state, { fetchStatus: 'success', error: null });
	    case types.FETCH_CURRENCIES_FAIL:
	      return (0, _extends3.default)({}, state, { fetchStatus: 'fail' });
	    case types.ERROR_CURRENCIES:
	      return (0, _extends3.default)({}, state, { error: action.payload });
	  }
	
	  return state;
	};

/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.changeStartDate = changeStartDate;
	exports.changeEndDate = changeEndDate;
	
	var _actionTypes = __webpack_require__(223);
	
	var dateTypes = _interopRequireWildcard(_actionTypes);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function changeStartDate(date) {
	  return {
	    type: dateTypes.CHANGE_START_DATE,
	    payload: (0, _moment2.default)(date).format('YYYY-MM-DD')
	  };
	}
	
	function changeEndDate(date) {
	  return {
	    type: dateTypes.CHANGE_END_DATE,
	    payload: (0, _moment2.default)(date).format('YYYY-MM-DD')
	  };
	}

/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(22);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _actionTypes = __webpack_require__(223);
	
	var dateType = _interopRequireWildcard(_actionTypes);
	
	var _reducer = __webpack_require__(358);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = _reducer.initialState;
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case dateType.CHANGE_START_DATE:
	      return (0, _assign2.default)({}, state, {
	        dateFilter: (0, _reducer.changeDate)(state, action)
	      });
	
	    case dateType.CHANGE_END_DATE:
	      return (0, _assign2.default)({}, state, {
	        dateFilter: (0, _reducer.changeDate)(state, action)
	      });
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setEntity = setEntity;
	exports.fetch = fetch;
	
	var _actionTypes = __webpack_require__(359);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _frilansFinans = __webpack_require__(11);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function setEntity(terms) {
	  return {
	    type: types.SET_ENTITY,
	    payload: terms
	  };
	}
	
	// Thunks
	
	function fetch(language) {
	  return function (dispatch) {
	    _frilansFinans.AgreementDraftService.generalTerms(language).then(function (entity) {
	      dispatch(setEntity(entity));
	    });
	  };
	}

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _assign = __webpack_require__(22);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.default = generalTerms;
	
	var _actionTypes = __webpack_require__(359);
	
	var type = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = exports.initialState = {
	  entity: {
	    headline: '',
	    text: ''
	  }
	};
	
	function generalTerms() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case type.SET_ENTITY:
	      return (0, _assign2.default)({}, state, {
	        entity: action.payload
	      });
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(22);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _actionTypes = __webpack_require__(360);
	
	var type = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	  locale: 'se',
	  country: 'se',
	
	  availableLocales: ['se', 'en'],
	  availableCountries: ['sweden', 'england']
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case type.CHANGE_LOCALE:
	      return (0, _assign2.default)({}, state, {
	        locale: action.payload
	      });
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(27);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(22);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _actionTypes = __webpack_require__(362);
	
	var type = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	  userId: null,
	  taxId: 1,
	  customerEntity: null,
	  customerId: 0,
	  couponId: '',
	  coupon: null,
	  currencyId: 0,
	  currencyName: '',
	  currencyAmount: 0,
	  displayDates: 0,
	  displayHours: 0,
	  preReport: false,
	  preReportedAt: null,
	  amount: 0,
	  specification: '',
	  saveVacationPay: null,
	  invoiceUser: [],
	  invoiceDate: [],
	  sendToEmailBool: true, // Send letter or email
	  sendToEmail: '', // The email address
	  sendToEmailSecondary: '',
	  companyPhone: '',
	  supplierLedger: [],
	  taxkeyId: null,
	  expressPayment: false,
	  invoiceId: null,
	  amountIncVat: 0,
	  lockAmountDistribution: {},
	  hsd: {
	    rot: false,
	    rut: false,
	    data: '',
	    apartmentNumber: '',
	    cooperativeApartmentRegistrationNumber: '',
	    accommodationType: ''
	  },
	  supplierLedgers: {
	    supplierName: null,
	    invoiceId: null,
	    userIdCreator: null,
	    taxId: null,
	    type: null
	  },
	  submitted: false,
	  termsAccepted: false,
	  valid: false,
	  posting: false,
	  postError: false,
	  initializing: false,
	  manualInvoiceCalc: false,
	  showDateOnInvoice: false,
	  showHoursOnInvoice: false,
	  messageType: 'email',
	  surveys: {
	    questions_and_answers: '',
	    status: ''
	  }
	}; /**
	    * Created by eriksundqvist on 24/05/16.
	    */
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case type.SET_AMOUNT:
	      return (0, _assign2.default)({}, state, {
	        amount: action.payload ? +action.payload : 0
	      });
	
	    case type.SET_CUSTOMER_ENTITY:
	      return (0, _assign2.default)({}, state, {
	        customerEntity: action.payload
	      });
	
	    case type.SET_COUPON_ID:
	      return (0, _assign2.default)({}, state, {
	        couponId: action.payload
	      });
	
	    case type.SET_COUPON:
	      return (0, _assign2.default)({}, state, {
	        coupon: action.payload
	      });
	
	    case type.CLEAR_COUPON:
	      return (0, _assign2.default)({}, state, {
	        coupon: null
	      });
	
	    case type.SET_CURRENCY_ID:
	      return (0, _assign2.default)({}, state, {
	        currencyId: action.payload
	      });
	
	    case type.SET_CURRENCY_NAME:
	      return (0, _assign2.default)({}, state, {
	        currencyName: action.payload
	      });
	
	    case type.SET_CURRENCY_AMOUNT:
	      return (0, _assign2.default)({}, state, {
	        currencyAmount: action.payload ? +action.payload : 0
	      });
	
	    case type.SET_SPECIFICATION:
	      return (0, _assign2.default)({}, state, {
	        specification: action.payload
	      });
	
	    case type.SET_INVOICEDATE:
	      return (0, _assign2.default)({}, state, {
	        invoiceDate: action.payload
	      });
	
	    case type.SET_USER_ID:
	      return (0, _assign2.default)({}, state, {
	        userId: action.payload
	      });
	
	    case type.SET_TAX_ID:
	      return (0, _assign2.default)({}, state, {
	        taxId: action.payload
	      });
	
	    case type.SET_SAVE_VACATION_PAY:
	      return (0, _assign2.default)({}, state, {
	        saveVacationPay: action.payload
	      });
	
	    case type.SET_INVOICEUSER:
	      return (0, _assign2.default)({}, state, {
	        invoiceUser: action.payload
	      });
	
	    case type.SET_SEND_TO_EMAIL:
	      return (0, _assign2.default)({}, state, {
	        sendToEmail: action.payload
	      });
	
	    case type.SET_SEND_TO_EMAIL_SECONDARY:
	      return (0, _assign2.default)({}, state, {
	        sendToEmailSecondary: action.payload
	      });
	
	    case type.SET_SEND_TO_EMAIL_BOOL:
	      return (0, _assign2.default)({}, state, {
	        sendToEmailBool: action.payload
	      });
	
	    case type.SET_COMPANY_PHONE:
	      return (0, _assign2.default)({}, state, {
	        companyPhone: action.payload
	      });
	
	    case type.SET_EINVOICE_ADDRESS:
	      return (0, _assign2.default)({}, state, {
	        einvoiceAddress: action.payload
	      });
	
	    case type.SET_PO_NUMBER:
	      return (0, _assign2.default)({}, state, {
	        poNumber: action.payload
	      });
	
	    case type.SET_TAX_KEY_ID:
	      return (0, _assign2.default)({}, state, {
	        taxkeyId: action.payload
	      });
	
	    case type.SET_EXPRESS_PAYMENT:
	      return (0, _assign2.default)({}, state, {
	        expressPayment: action.payload
	      });
	
	    case type.SET_INVOICE_ID:
	      return (0, _assign2.default)({}, state, {
	        invoiceId: action.payload
	      });
	
	    case type.SET_CUSTOMER_ID:
	      return (0, _assign2.default)({}, state, {
	        customerId: action.payload
	      });
	
	    case type.SET_SUPPLIER_LEDGER:
	      return (0, _assign2.default)({}, state, {
	        supplierLedger: action.payload
	      });
	
	    case type.SET_SUBMITTED:
	      return (0, _assign2.default)({}, state, {
	        submitted: action.payload
	      });
	
	    case type.SET_VALID:
	      return (0, _assign2.default)({}, state, {
	        valid: action.payload
	      });
	
	    case type.SET_POSTING:
	      return (0, _assign2.default)({}, state, {
	        posting: action.payload
	      });
	
	    case type.SET_POST_ERROR:
	      return (0, _assign2.default)({}, state, {
	        postError: action.payload
	      });
	
	    case type.SET_AMOUNT_INC_VAT:
	      return (0, _assign2.default)({}, state, {
	        amountIncVat: action.payload
	      });
	
	    case type.SET_LOCK_AMOUNT_DISTRIBUTION:
	      return (0, _assign2.default)({}, state, {
	        lockAmountDistribution: action.payload
	      });
	
	    case type.SET_INITIALIZING:
	      return (0, _assign2.default)({}, state, {
	        initializing: action.payload
	      });
	
	    case type.SET_AMOUNT_AFTER_HSD:
	      return (0, _assign2.default)({}, state, {
	        amountAfterHsd: action.payload
	      });
	
	    case type.CLEAR:
	      return (0, _assign2.default)({}, initialState);
	
	    case type.SET_ROT:
	      return (0, _assign2.default)({}, state, {
	        hsd: (0, _extends3.default)({
	          rut: false
	        }, action.payload)
	      });
	
	    case type.SET_RUT:
	      return (0, _assign2.default)({}, state, {
	        hsd: {
	          rot: false,
	          data: '',
	          rut: action.payload
	        }
	      });
	
	    case type.SET_MANUAL_INVOICE_CALC:
	      return (0, _assign2.default)({}, state, {
	        manualInvoiceCalc: action.payload
	      });
	
	    case type.SET_DISPLAY_DATES:
	      return (0, _assign2.default)({}, state, {
	        displayDates: action.payload
	      });
	
	    case type.SET_DISPLAY_HOURS:
	      return (0, _assign2.default)({}, state, {
	        displayHours: action.payload
	      });
	
	    case type.SET_PREREPORT:
	      return (0, _assign2.default)({}, state, {
	        preReport: action.payload
	      });
	
	    case type.SET_PREREPORTED_AT:
	      return (0, _assign2.default)({}, state, {
	        preReportedAt: action.payload
	      });
	
	    case type.SET_TERMSACCEPTED:
	      return (0, _assign2.default)({}, state, {
	        termsAccepted: action.payload
	      });
	
	    case type.SET_LOGGED_IN_INVOICE_USER_TAXKEYS:
	      return (0, _assign2.default)({}, state, {
	        invoiceUser: state.invoiceUser.map(function (invoiceUser, index) {
	          if (index === 0) {
	            return (0, _assign2.default)({}, invoiceUser, { taxkeys: action.payload });
	          } else {
	            return invoiceUser;
	          }
	        })
	      });
	
	    case type.SET_LOGGED_IN_INVOICE_USER_TAXKEY_ID:
	      return (0, _assign2.default)({}, state, {
	        invoiceUser: state.invoiceUser.map(function (invoiceUser, index) {
	          if (index === 0) {
	            return (0, _assign2.default)({}, invoiceUser, { taxkeyId: action.payload });
	          } else {
	            return invoiceUser;
	          }
	        })
	      });
	
	    case type.SET_MESSAGE_TYPE:
	      return (0, _extends3.default)({}, state, {
	        messageType: action.payload
	      });
	
	    case type.SET_SURVEY_ANSWERS:
	      return (0, _extends3.default)({}, state, {
	        surveys: action.payload
	      });
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actionTypes = __webpack_require__(224);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var menuState = function menuState() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'closed';
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.OPEN_MAIN_MENU:
	      return 'open';
	    case types.CLOSE_MAIN_MENU:
	      return 'closed';
	    default:
	      return state;
	  }
	}; /**
	    * Created by staffanrantzow on 17/03/16.
	    */
	
	exports.default = menuState;

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _extends2 = __webpack_require__(27);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _actionTypes = __webpack_require__(365);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = exports.initialState = {
	  status: 'initial',
	  invoice: {
	    status: 'initial',
	    data: {},
	    error: {}
	  },
	  paymentRequest: {
	    status: null,
	    data: {
	      status: null
	    },
	    error: {}
	  }
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.SET_INVOICE:
	      return (0, _extends3.default)({}, state, {
	        invoice: (0, _extends3.default)({}, state.invoice, {
	          status: 'success',
	          data: action.payload
	        })
	      });
	    case types.FETCH_INVOICE:
	      return (0, _extends3.default)({}, state, {
	        invoice: (0, _extends3.default)({}, state.invoice, {
	          status: 'fetching'
	        })
	      });
	    case types.ERROR_INVOICE:
	      return (0, _extends3.default)({}, state, {
	        invoice: (0, _extends3.default)({}, state.invoice, {
	          status: 'error',
	          error: action.payload
	        })
	      });
	    case types.CREATE_PAYMENT_REQUEST:
	      return (0, _extends3.default)({}, state, {
	        paymentRequest: (0, _extends3.default)({}, state.paymentRequest, {
	          status: 'creating'
	        })
	      });
	    case types.SET_PAYMENT_REQUEST:
	      return (0, _extends3.default)({}, state, {
	        paymentRequest: (0, _extends3.default)({}, state.paymentRequest, {
	          status: 'success',
	          data: action.payload
	        })
	      });
	    case types.ERROR_PAYMENT_REQUEST:
	      return (0, _extends3.default)({}, state, {
	        paymentRequest: (0, _extends3.default)({}, state.paymentRequest, {
	          status: 'error',
	          error: action.payload
	        })
	      });
	    case types.CREATING_INVOICE_EMAIL:
	      return (0, _extends3.default)({}, state, {
	        invoiceEmail: {
	          status: 'creating'
	        }
	      });
	    case types.SUCCESS_INVOICE_EMAIL:
	      return (0, _extends3.default)({}, state, {
	        invoiceEmail: {
	          status: 'success'
	        }
	      });
	    case types.ERROR_INVOICE_EMAIL:
	      return (0, _extends3.default)({}, state, {
	        invoiceEmail: {
	          status: 'error',
	          error: action.payload
	        }
	      });
	    case types.SET_STATUS:
	      return (0, _extends3.default)({}, state, {
	        status: action.payload
	      });
	  }
	
	  return state;
	};

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(22);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _actionTypes = __webpack_require__(367);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Keeps track of scroll position and currently fetched page on invoices.
	  * So if user clicks back on an invoice they should be returned
	  * to the previously set scroll position.
	 */
	var initialState = {
	  scrollPosition: 0,
	  invoice: {
	    page: 1
	  },
	  preregisteredInvoice: {
	    page: 1
	  }
	}; /**
	    * Created by staffanrantzow on 07/10/16.
	    */
	
	var filter = function filter() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.SET_INVOICE_PAGE:
	      return (0, _assign2.default)({}, state, {
	        invoice: action.payload
	      });
	    case types.SET_PREREGISTERED_INVOICE_PAGE:
	      return (0, _assign2.default)({}, state, {
	        preregisteredInvoice: action.payload
	      });
	    case types.SET_SCROLL_POSITION:
	      return (0, _assign2.default)({}, state, {
	        scrollPosition: action.payload
	      });
	    case types.CLEAR_SCROLL_POSITION:
	      return (0, _assign2.default)({}, initialState);
	    default:
	      return state;
	  }
	};
	
	exports.default = filter;

/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setSupplierLedgerTypes = setSupplierLedgerTypes;
	
	var _actionTypes = __webpack_require__(369);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function setSupplierLedgerTypes(supplierLedgerTypes) {
	  return {
	    type: types.SET_SUPPLIER_LEDGER_TYPES,
	    payload: supplierLedgerTypes
	  };
	}

/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _actionTypes = __webpack_require__(369);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = exports.initialState = [];
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.SET_SUPPLIER_LEDGER_TYPES:
	      return action.payload.slice(0);
	    default:
	      return state;
	  }
	};

/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setTaxkeys = setTaxkeys;
	
	var _actionTypes = __webpack_require__(370);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function setTaxkeys(taxkeys) {
	  return {
	    type: types.SET_TAXKEYS,
	    payload: taxkeys
	  };
	}

/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _actionTypes = __webpack_require__(370);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = exports.initialState = [];
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.SET_TAXKEYS:
	      return action.payload;
	    default:
	      return state;
	  }
	};

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(386);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(384);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	exports.setStatus = setStatus;
	exports.startTimer = startTimer;
	exports.checkTimeout = checkTimeout;
	exports.stopTimer = stopTimer;
	
	var _lodash = __webpack_require__(40);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _actionTypes = __webpack_require__(371);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var interval = void 0,
	    startedAt = void 0;
	
	function setStatus(string) {
	  return {
	    type: types.SET_STATUS,
	    payload: string
	  };
	}
	
	function startTimer(callback) {
	  var _this = this;
	
	  return function () {
	    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
	      var runCallback;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              dispatch(setStatus('started'));
	              startedAt = new Date();
	
	              runCallback = function () {
	                var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(callback) {
	                  var _getState, timer;
	
	                  return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                      switch (_context.prev = _context.next) {
	                        case 0:
	                          _context.next = 2;
	                          return callback(dispatch, getState);
	
	                        case 2:
	
	                          dispatch(checkTimeout());
	
	                          _getState = getState(), timer = _getState.timer;
	
	                          if (timer.status === 'started') {
	                            _lodash2.default.delay(function () {
	                              runCallback(callback);
	                            }, timer.delay * 1000);
	                          }
	
	                        case 5:
	                        case 'end':
	                          return _context.stop();
	                      }
	                    }
	                  }, _callee, _this);
	                }));
	
	                return function runCallback(_x3) {
	                  return _ref2.apply(this, arguments);
	                };
	              }();
	
	              runCallback(callback);
	
	            case 4:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this);
	    }));
	
	    return function (_x, _x2) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	}
	
	function checkTimeout() {
	  return function (dispatch, getState) {
	    var _getState2 = getState(),
	        timer = _getState2.timer;
	
	    var done = (new Date() - startedAt) / 1000 > timer.timeout;
	
	    if (done) {
	      dispatch(stopTimer('timeout'));
	    }
	  };
	}
	
	function stopTimer() {
	  var nextStatus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'stopped';
	
	  return function (dispatch) {
	    clearTimeout(interval);
	    dispatch(setStatus(nextStatus));
	  };
	}

/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _assign = __webpack_require__(22);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.default = timer;
	
	var _actionTypes = __webpack_require__(371);
	
	var type = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = exports.initialState = {
	  status: 'initial',
	  delay: 1,
	  timeout: 60
	};
	
	function timer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	
	    case type.SET_STATUS:
	      return (0, _assign2.default)({}, state, {
	        status: action.payload
	      });
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _assign = __webpack_require__(22);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _actionTypes = __webpack_require__(372);
	
	var type = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = exports.initialState = {
	  showFooter: true,
	  showHeader: true
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case type.SET_SHOW_FOOTER:
	      return (0, _assign2.default)({}, state, {
	        showFooter: true
	      });
	
	    case type.SET_HIDE_FOOTER:
	      return (0, _assign2.default)({}, state, {
	        showFooter: false
	      });
	
	    case type.SET_SHOW_HEADER:
	      return (0, _assign2.default)({}, state, {
	        showHeader: true
	      });
	
	    case type.SET_HIDE_HEADER:
	      return (0, _assign2.default)({}, state, {
	        showHeader: false
	      });
	    default:
	      return state;
	  }
	};

/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _assign = __webpack_require__(22);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _actionTypes = __webpack_require__(373);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = exports.initialState = {};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.SET_USER:
	      return action.payload;
	    case types.SET_IMAGE_SRC:
	      return (0, _assign2.default)({}, state, {
	        imageSrc: action.payload
	      });
	    case types.CLEAR_USER:
	      return initialState;
	    case types.SET_SOCIAL_SECURITY_NUMBER:
	      return (0, _assign2.default)({}, state, {
	        socialSecurityNr: action.payload
	      });
	    default:
	      return state;
	  }
	};

/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _assign = __webpack_require__(22);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _actionTypes = __webpack_require__(374);
	
	var type = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = exports.initialState = {};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case type.SET_VALIDATION_ERRORS:
	      var errors = typeof action.payload.errors[0].detail.errors !== 'undefined' ? action.payload.errors[0].detail.errors : {};
	      return (0, _assign2.default)({}, errors);
	
	    case type.CLEAR_VALIDATION_ERRORS:
	      return (0, _assign2.default)({}, initialState);
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 846 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_FIRST_NAME = exports.SET_FIRST_NAME = 'workers:set-first-name';
	var SET_LAST_NAME = exports.SET_LAST_NAME = 'workers:set-last-name';
	var SET_EMAIL = exports.SET_EMAIL = 'workers:set-email';
	var SET_CELLPHONE = exports.SET_CELLPHONE = 'workers:set-cellphone';
	var SET_CO = exports.SET_CO = 'workers:set-co';
	var SET_STREET = exports.SET_STREET = 'workers:set-street';
	var SET_ZIP = exports.SET_ZIP = 'workers:set-zip';
	var SET_CITY = exports.SET_CITY = 'workers:set-city';
	var SET_COUNTRY = exports.SET_COUNTRY = 'workers:set-country';
	var SET_PROFESSION_TITLE = exports.SET_PROFESSION_TITLE = 'workers:set-profession-title';
	var SET_SOCIAL_SECUTIRY_NUMBER = exports.SET_SOCIAL_SECUTIRY_NUMBER = 'workers:set-social-security-number';
	var SET_ACCOUNT_CLEARING_NUMBER = exports.SET_ACCOUNT_CLEARING_NUMBER = 'workers:set-account-clearing-number';
	var SET_ACCOUNT_NUMBER = exports.SET_ACCOUNT_NUMBER = 'workers:set-account-number';
	var SET_BANKGIRO = exports.SET_BANKGIRO = 'workers:set-bankgiro';
	var SET_POSTGIRO = exports.SET_POSTGIRO = 'workers:set-postgiro';
	var SET_BIC = exports.SET_BIC = 'workers:set-bic';
	var SET_IBAN = exports.SET_IBAN = 'workers:set-iban';
	var SET_INTERNATIONAL_ACCOUNT = exports.SET_INTERNATIONAL_ACCOUNT = 'workers:set-international-account';
	var SET_SHOW_NAME_IN_NETWORK = exports.SET_SHOW_NAME_IN_NETWORK = 'workers:set-show-name-in-network';
	var SET_SAVE_VACATION_PAY = exports.SET_SAVE_VACATION_PAY = 'workers:set-save-vacation-pay';
	var SET_SAVE_ITP = exports.SET_SAVE_ITP = 'workers:set-save-itp';
	var SET_ITP_RATE = exports.SET_ITP_RATE = 'workers:set-itp-rate';
	var SET_DISPLAY_HSD = exports.SET_DISPLAY_HSD = 'workers:set-display-hsd';
	var SET_PREFFERED_PAYMENT_TYPE_ID = exports.SET_PREFFERED_PAYMENT_TYPE_ID = 'workers:set-preffered-payment-type-id';
	var SET_RECEIVE_SMS_NOTIFICATIONS = exports.SET_RECEIVE_SMS_NOTIFICATIONS = 'workers:set-receive-sms-notifications';
	var SET_RECEIVE_EMAIL_NOTICATIONS = exports.SET_RECEIVE_EMAIL_NOTICATIONS = 'workers:set-receive-email-notifications';
	var SET_NOTIFICATION_LANGUAGE = exports.SET_NOTIFICATION_LANGUAGE = 'workers:set-notification-language';
	var SET_REMOTE_ID = exports.SET_REMOTE_ID = 'workers:set-remote-id';

/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(22);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _actionTypes = __webpack_require__(846);
	
	var type = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	  firstName: null,
	  lastName: null,
	  email: null,
	  cellphone: null,
	  co: null,
	  street: null,
	  zip: null,
	  city: null,
	  country: null,
	  professionTitle: null,
	  socialSecurityNumber: null,
	  accountClearingNumber: null,
	  accountNumber: null,
	  bankgiro: null,
	  postgiro: null,
	  bic: null,
	  iban: null,
	  internationalAccount: null,
	  showNameInNetwork: null,
	  saveVacationPay: null,
	  saveItp: null,
	  displayHsd: null,
	  prefferedPaymentTypeId: null,
	  receiveSmsNotifications: null,
	  receiveEmailNotifications: null,
	  notificationLanguage: null,
	  remoteId: null
	}; /**
	    * Created by eriksundqvist on 12/10/16.
	    */
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case type.SET_FIRST_NAME:
	      return (0, _assign2.default)({}, state, {
	        firstName: action.payload
	      });
	
	    case type.SET_LAST_NAME:
	      return (0, _assign2.default)({}, state, {
	        lastName: action.payload
	      });
	
	    case type.SET_EMAIL:
	      return (0, _assign2.default)({}, state, {
	        email: action.payload
	      });
	
	    case type.SET_CELLPHONE:
	      return (0, _assign2.default)({}, state, {
	        cellphone: action.payload
	      });
	
	    case type.SET_CO:
	      return (0, _assign2.default)({}, state, {
	        co: action.payload
	      });
	
	    case type.SET_ZIP:
	      return (0, _assign2.default)({}, state, {
	        zip: action.payload
	      });
	
	    case type.SET_STREET:
	      return (0, _assign2.default)({}, state, {
	        street: action.payload
	      });
	
	    case type.SET_CITY:
	      return (0, _assign2.default)({}, state, {
	        city: action.payload
	      });
	
	    case type.SET_COUNTRY:
	      return (0, _assign2.default)({}, state, {
	        country: action.payload
	      });
	
	    case type.SET_PROFESSION_TITLE:
	      return (0, _assign2.default)({}, state, {
	        professionTitle: action.payload
	      });
	
	    case type.SET_SOCIAL_SECUTIRY_NUMBER:
	      return (0, _assign2.default)({}, state, {
	        socialSecurityNumber: action.payload
	      });
	
	    case type.SET_ACCOUNT_CLEARING_NUMBER:
	      return (0, _assign2.default)({}, state, {
	        accountClearingNumber: action.payload
	      });
	
	    case type.SET_ACCOUNT_NUMBER:
	      return (0, _assign2.default)({}, state, {
	        accountNumber: action.payload
	      });
	
	    case type.SET_BANKGIRO:
	      return (0, _assign2.default)({}, state, {
	        bankgiro: action.payload
	      });
	
	    case type.SET_POSTGIRO:
	      return (0, _assign2.default)({}, state, {
	        postgiro: action.payload
	      });
	
	    case type.SET_BIC:
	      return (0, _assign2.default)({}, state, {
	        bic: action.payload
	      });
	
	    case type.SET_IBAN:
	      return (0, _assign2.default)({}, state, {
	        iban: action.payload
	      });
	
	    case type.SET_INTERNATIONAL_ACCOUNT:
	      return (0, _assign2.default)({}, state, {
	        internationalAccount: action.payload
	      });
	
	    case type.SET_SHOW_NAME_IN_NETWORK:
	      return (0, _assign2.default)({}, state, {
	        showNameInNetwork: action.payload
	      });
	
	    case type.SET_SAVE_VACATION_PAY:
	      return (0, _assign2.default)({}, state, {
	        saveVacationPay: action.payload
	      });
	
	    case type.SET_SAVE_ITP:
	      return (0, _assign2.default)({}, state, {
	        saveItp: action.payload
	      });
	
	    case type.SET_ITP_RATE:
	      return (0, _assign2.default)({}, state, {
	        itpRate: action.payload
	      });
	
	    case type.SET_DISPLAY_HSD:
	      return (0, _assign2.default)({}, state, {
	        displayHsd: action.payload
	      });
	
	    case type.SET_PREFFERED_PAYMENT_TYPE_ID:
	      return (0, _assign2.default)({}, state, {
	        prefferedPaymentTypeId: action.payload
	      });
	
	    case type.SET_RECEIVE_SMS_NOTIFICATIONS:
	      return (0, _assign2.default)({}, state, {
	        receiveSmsNotifications: action.payload
	      });
	
	    case type.SET_RECEIVE_EMAIL_NOTICATIONS:
	      return (0, _assign2.default)({}, state, {
	        receiveEmailNotifications: action.payload
	      });
	
	    case type.SET_NOTIFICATION_LANGUAGE:
	      return (0, _assign2.default)({}, state, {
	        notificationLanguage: action.payload
	      });
	
	    case type.SET_REMOTE_ID:
	      return (0, _assign2.default)({}, state, {
	        remoteId: action.payload
	      });
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(142);
	
	var _reactRouterRedux = __webpack_require__(137);
	
	var _reducer = __webpack_require__(834);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reducer3 = __webpack_require__(843);
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	var _reducer5 = __webpack_require__(832);
	
	var _reducer6 = _interopRequireDefault(_reducer5);
	
	var _reducer7 = __webpack_require__(829);
	
	var _reducer8 = _interopRequireDefault(_reducer7);
	
	var _reducer9 = __webpack_require__(840);
	
	var _reducer10 = _interopRequireDefault(_reducer9);
	
	var _reducer11 = __webpack_require__(833);
	
	var _reducer12 = _interopRequireDefault(_reducer11);
	
	var _reducer13 = __webpack_require__(844);
	
	var _reducer14 = _interopRequireDefault(_reducer13);
	
	var _reducer15 = __webpack_require__(847);
	
	var _reducer16 = _interopRequireDefault(_reducer15);
	
	var _reducer17 = __webpack_require__(836);
	
	var _reducer18 = _interopRequireDefault(_reducer17);
	
	var _reducer19 = __webpack_require__(845);
	
	var _reducer20 = _interopRequireDefault(_reducer19);
	
	var _reducer21 = __webpack_require__(838);
	
	var _reducer22 = _interopRequireDefault(_reducer21);
	
	var _reducer23 = __webpack_require__(824);
	
	var _reducer24 = _interopRequireDefault(_reducer23);
	
	var _reducer25 = __webpack_require__(835);
	
	var _reducer26 = _interopRequireDefault(_reducer25);
	
	var _reducer27 = __webpack_require__(831);
	
	var _reducer28 = _interopRequireDefault(_reducer27);
	
	var _reducer29 = __webpack_require__(827);
	
	var _reducer30 = _interopRequireDefault(_reducer29);
	
	var _reducer31 = __webpack_require__(842);
	
	var _reducer32 = _interopRequireDefault(_reducer31);
	
	var _reducer33 = __webpack_require__(825);
	
	var _reducer34 = _interopRequireDefault(_reducer33);
	
	var _reducer35 = __webpack_require__(823);
	
	var _reducer36 = _interopRequireDefault(_reducer35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  router: _reactRouterRedux.routerReducer,
	  i18n: _reducer6.default,
	  menuState: _reducer2.default,
	  topBottomSectionState: _reducer4.default,
	  filters: _reducer8.default,
	  taxkeys: _reducer10.default,
	  invoice: _reducer12.default,
	  user: _reducer14.default,
	  workers: _reducer16.default,
	  scrollPosition: _reducer18.default,
	  validationError: _reducer20.default,
	  supplierLedgerTypes: _reducer22.default,
	  bankId: _reducer24.default,
	  payment: _reducer26.default,
	  generalTerms: _reducer28.default,
	  currencies: _reducer30.default,
	  timer: _reducer32.default,
	  bankInfo: _reducer34.default,
	  auth: _reducer36.default
	});

/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(20);
	
	var _authenticated = __webpack_require__(813);
	
	var _authenticated2 = _interopRequireDefault(_authenticated);
	
	var _unauthenticated = __webpack_require__(814);
	
	var _unauthenticated2 = _interopRequireDefault(_unauthenticated);
	
	var _CoreLayout = __webpack_require__(817);
	
	var _CoreLayout2 = _interopRequireDefault(_CoreLayout);
	
	var _loginTabs = __webpack_require__(959);
	
	var _loginTabs2 = _interopRequireDefault(_loginTabs);
	
	var _registerTabs = __webpack_require__(987);
	
	var _registerTabs2 = _interopRequireDefault(_registerTabs);
	
	var _forgotPasswordView = __webpack_require__(893);
	
	var _forgotPasswordView2 = _interopRequireDefault(_forgotPasswordView);
	
	var _setNewPassword = __webpack_require__(894);
	
	var _setNewPassword2 = _interopRequireDefault(_setNewPassword);
	
	var _registerSettings = __webpack_require__(982);
	
	var _registerSettings2 = _interopRequireDefault(_registerSettings);
	
	var _activateAccount = __webpack_require__(853);
	
	var _activateAccount2 = _interopRequireDefault(_activateAccount);
	
	var _activitiesView = __webpack_require__(854);
	
	var _activitiesView2 = _interopRequireDefault(_activitiesView);
	
	var _invoiceWrapper = __webpack_require__(873);
	
	var _invoiceWrapper2 = _interopRequireDefault(_invoiceWrapper);
	
	var _invoice = __webpack_require__(874);
	
	var _invoice2 = _interopRequireDefault(_invoice);
	
	var _pageWrapperContainer = __webpack_require__(818);
	
	var _pageWrapperContainer2 = _interopRequireDefault(_pageWrapperContainer);
	
	var _salaries = __webpack_require__(880);
	
	var _salaries2 = _interopRequireDefault(_salaries);
	
	var _employerCertificates = __webpack_require__(871);
	
	var _employerCertificates2 = _interopRequireDefault(_employerCertificates);
	
	var _employerCertificate = __webpack_require__(870);
	
	var _employerCertificate2 = _interopRequireDefault(_employerCertificate);
	
	var _agreementsWrapper = __webpack_require__(869);
	
	var _agreementsWrapper2 = _interopRequireDefault(_agreementsWrapper);
	
	var _agreementHtml = __webpack_require__(866);
	
	var _agreementHtml2 = _interopRequireDefault(_agreementHtml);
	
	var _supplierLedgers = __webpack_require__(885);
	
	var _supplierLedgers2 = _interopRequireDefault(_supplierLedgers);
	
	var _supplierLedger = __webpack_require__(884);
	
	var _supplierLedger2 = _interopRequireDefault(_supplierLedger);
	
	var _registerAssignment = __webpack_require__(878);
	
	var _registerAssignment2 = _interopRequireDefault(_registerAssignment);
	
	var _incomeStatements = __webpack_require__(872);
	
	var _incomeStatements2 = _interopRequireDefault(_incomeStatements);
	
	var _insurances = __webpack_require__(896);
	
	var _insurances2 = _interopRequireDefault(_insurances);
	
	var _workingEnvironment = __webpack_require__(998);
	
	var _workingEnvironment2 = _interopRequireDefault(_workingEnvironment);
	
	var _customers = __webpack_require__(865);
	
	var _customers2 = _interopRequireDefault(_customers);
	
	var _customer = __webpack_require__(864);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _paymentPage = __webpack_require__(978);
	
	var _paymentPage2 = _interopRequireDefault(_paymentPage);
	
	var _paymentStatusPage = __webpack_require__(981);
	
	var _paymentStatusPage2 = _interopRequireDefault(_paymentStatusPage);
	
	var _paymentCancel = __webpack_require__(383);
	
	var _paymentCancel2 = _interopRequireDefault(_paymentCancel);
	
	var _settingsWrapper = __webpack_require__(995);
	
	var _settingsWrapper2 = _interopRequireDefault(_settingsWrapper);
	
	var _personalInfo = __webpack_require__(230);
	
	var _personalInfo2 = _interopRequireDefault(_personalInfo);
	
	var _salaryInfo = __webpack_require__(232);
	
	var _salaryInfo2 = _interopRequireDefault(_salaryInfo);
	
	var _ownEmployment = __webpack_require__(229);
	
	var _ownEmployment2 = _interopRequireDefault(_ownEmployment);
	
	var _faq = __webpack_require__(892);
	
	var _faq2 = _interopRequireDefault(_faq);
	
	var _loyaltyPointsContainer = __webpack_require__(961);
	
	var _loyaltyPointsContainer2 = _interopRequireDefault(_loyaltyPointsContainer);
	
	var _changePassword = __webpack_require__(228);
	
	var _changePassword2 = _interopRequireDefault(_changePassword);
	
	var _invoiceToolContainer = __webpack_require__(935);
	
	var _invoiceToolContainer2 = _interopRequireDefault(_invoiceToolContainer);
	
	var _tokenLogin = __webpack_require__(996);
	
	var _tokenLogin2 = _interopRequireDefault(_tokenLogin);
	
	var _linkLogin = __webpack_require__(954);
	
	var _linkLogin2 = _interopRequireDefault(_linkLogin);
	
	var _eidLinkLogin = __webpack_require__(886);
	
	var _eidLinkLogin2 = _interopRequireDefault(_eidLinkLogin);
	
	var _eidLinkRegister = __webpack_require__(887);
	
	var _eidLinkRegister2 = _interopRequireDefault(_eidLinkRegister);
	
	var _missingView = __webpack_require__(974);
	
	var _missingView2 = _interopRequireDefault(_missingView);
	
	var _newsList = __webpack_require__(975);
	
	var _newsList2 = _interopRequireDefault(_newsList);
	
	var _invoiceCopy = __webpack_require__(897);
	
	var _invoiceCopy2 = _interopRequireDefault(_invoiceCopy);
	
	var _authentication = __webpack_require__(90);
	
	var _authentication2 = _interopRequireDefault(_authentication);
	
	var _currencies = __webpack_require__(826);
	
	var _store = __webpack_require__(92);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _axios = __webpack_require__(17);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _taxkeyService = __webpack_require__(119);
	
	var _taxkeyService2 = _interopRequireDefault(_taxkeyService);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _updateCustomerEmail = __webpack_require__(862);
	
	var _updateCustomerEmail2 = _interopRequireDefault(_updateCustomerEmail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onLogout = function onLogout() {
	  _authentication2.default.logout();
	};
	
	var onEnterInvoiceTool = function onEnterInvoiceTool() {
	  _store2.default.dispatch((0, _currencies.fetchCurrencies)());
	};
	
	var onEnterPotentiallyAuthenticatedRoutes = function onEnterPotentiallyAuthenticatedRoutes() {
	  _axios2.default.interceptors.request.use(_authentication2.default._requestInterceptor);
	  _axios2.default.interceptors.response.use(function (response) {
	    return response;
	  }, _authentication2.default._responseInterceptor);
	};
	
	var fetchUserAndTaxkeys = function fetchUserAndTaxkeys(nextState, replace, callback) {
	  _frilansFinans.UserService.get().promise.then(function (user) {
	    _taxkeyService2.default.get(user.id).then(callback).catch(callback);
	  }).then(callback).catch(callback);
	};
	
	var _ref = _react2.default.createElement(
	  _reactRouter.Route,
	  null,
	  _react2.default.createElement(_reactRouter.Route, { path: 'payment/cancel', component: _paymentCancel2.default }),
	  _react2.default.createElement(_reactRouter.Route, { path: 'payment/:uuid/status', component: _paymentStatusPage2.default }),
	  _react2.default.createElement(_reactRouter.Route, { path: 'payment/:uuid', component: _paymentPage2.default }),
	  _react2.default.createElement(_reactRouter.Route, { path: 'invoice-copy', component: _invoiceCopy2.default }),
	  _react2.default.createElement(_reactRouter.Route, { path: 'bounced-email/update-customer/:token', component: _updateCustomerEmail2.default }),
	  _react2.default.createElement(
	    _reactRouter.Route,
	    { onEnter: onEnterPotentiallyAuthenticatedRoutes },
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: '/', component: _CoreLayout2.default },
	      _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'activities' }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'set-new-password', component: _setNewPassword2.default }),
	      _react2.default.createElement(
	        _unauthenticated2.default,
	        null,
	        _react2.default.createElement(_reactRouter.Route, { path: 'login', component: _loginTabs2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'register', component: _registerTabs2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'forgot-password', component: _forgotPasswordView2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'activate-account', component: _activateAccount2.default })
	      ),
	      _react2.default.createElement(
	        _authenticated2.default,
	        null,
	        _react2.default.createElement(_reactRouter.Route, { path: 'logout', component: _loginTabs2.default, onEnter: onLogout })
	      ),
	      _react2.default.createElement(_reactRouter.Route, { path: 'token-login', component: _tokenLogin2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'link-login/:token', component: _linkLogin2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'eid-link-login', component: _eidLinkLogin2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'eid-link-register', component: _eidLinkRegister2.default }),
	      _react2.default.createElement(
	        _authenticated2.default,
	        { component: _pageWrapperContainer2.default },
	        _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'activities' }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'activities', component: _activitiesView2.default }),
	        _react2.default.createElement(
	          _reactRouter.Route,
	          { path: 'economy' },
	          _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'invoices', component: _invoiceWrapper2.default }),
	          _react2.default.createElement(
	            _reactRouter.Route,
	            { path: 'invoices' },
	            _react2.default.createElement(_reactRouter.IndexRoute, { component: _invoiceWrapper2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: ':id', component: _invoice2.default })
	          ),
	          _react2.default.createElement(_reactRouter.Route, { path: 'salaries', component: _salaries2.default }),
	          _react2.default.createElement(
	            _reactRouter.Route,
	            { path: 'employercertificates' },
	            _react2.default.createElement(_reactRouter.IndexRoute, { component: _employerCertificates2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: ':id', component: _employerCertificate2.default })
	          ),
	          _react2.default.createElement(_reactRouter.Route, { path: 'agreements', component: _agreementsWrapper2.default }),
	          _react2.default.createElement(
	            _reactRouter.Route,
	            { path: 'supplier-ledgers' },
	            _react2.default.createElement(_reactRouter.IndexRoute, { component: _supplierLedgers2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: ':id', component: _supplierLedger2.default })
	          ),
	          _react2.default.createElement(_reactRouter.Route, { path: 'register-assignment', component: _registerAssignment2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'incomestatements', component: _incomeStatements2.default }),
	          _react2.default.createElement(
	            _reactRouter.Route,
	            { path: 'loyalty-program' },
	            _react2.default.createElement(_reactRouter.Route, { path: 'points', component: _loyaltyPointsContainer2.default })
	          )
	        ),
	        _react2.default.createElement(_reactRouter.Route, { path: 'insurances', component: _insurances2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'working-environment', component: _workingEnvironment2.default }),
	        _react2.default.createElement(
	          _reactRouter.Route,
	          { path: 'customers' },
	          _react2.default.createElement(_reactRouter.IndexRoute, { component: _customers2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: ':id', component: _customer2.default })
	        ),
	        _react2.default.createElement(
	          _reactRouter.Route,
	          { path: 'settings', component: _settingsWrapper2.default },
	          _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'personal-information' }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'personal-information', component: _personalInfo2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'salary-information', component: _salaryInfo2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'own-employment', component: _ownEmployment2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'change-password', component: _changePassword2.default })
	        ),
	        _react2.default.createElement(_reactRouter.Route, { path: 'faq', component: _faq2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'news', component: _newsList2.default })
	      )
	    ),
	    _react2.default.createElement(
	      _authenticated2.default,
	      { onEnter: fetchUserAndTaxkeys },
	      _react2.default.createElement(_reactRouter.Route, { path: 'invoice-tool', component: _invoiceToolContainer2.default, onEnter: onEnterInvoiceTool }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'invoicetool', component: _invoiceToolContainer2.default, onEnter: onEnterInvoiceTool }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'invoice-tool(/:id)', component: _invoiceToolContainer2.default, onEnter: onEnterInvoiceTool }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'register-assignment', component: _invoiceToolContainer2.default, onEnter: onEnterInvoiceTool }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'register-assignment(/:id)', component: _invoiceToolContainer2.default, onEnter: onEnterInvoiceTool }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'registersettings', component: _registerSettings2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'economy/agreements/:id', component: _agreementHtml2.default })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: '/', component: _CoreLayout2.default },
	      _react2.default.createElement(_reactRouter.Route, { path: '*', component: _missingView2.default })
	    )
	  )
	);
	
	exports.default = function (store) {
	  return _ref;
	};

/***/ },
/* 850 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var tracking = "\n  window.dataLayer = window.dataLayer || [];\n  function gtag () {\n    window.dataLayer.push(arguments);\n  }\n  gtag('js', new Date());\n  gtag('config', 'DC-9858150');\n\n  gtag('event', 'conversion', {\n    'allow_custom_scripts': true,\n    'send_to': 'DC-9858150/invmedia/medle0+unique'\n  });\n";
	exports.default = tracking;

/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var importScript = function importScript(googleTracking, pageTracking) {
	  var script = document.createElement('script');
	  script.async = true;
	  script.id = googleTracking;
	  script.src = 'https://www.googletagmanager.com/gtag/js?id=DC-9858150';
	  document.body.appendChild(script);
	
	  var activitesPage = __webpack_require__(850);
	
	  var script2 = document.createElement('script');
	  script2.id = pageTracking;
	  script2.text = activitesPage.default;
	  document.body.appendChild(script2);
	};
	exports.default = importScript;

/***/ },
/* 852 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var removeScript = function removeScript(googleTracking, pageTracking) {
	  var google = document.getElementById(googleTracking);
	  var page = document.getElementById(pageTracking);
	
	  if (google) google.remove();
	  if (page) page.remove();
	};
	exports.default = removeScript;

/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(13);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _reactRouter = __webpack_require__(20);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_components.Spinner, null); /**
	                                                                      * Created by staffanrantzow on 01/11/16.
	                                                                      */
	
	var _ref2 = _react2.default.createElement(_components.GeneralError, null);
	
	var _ref3 = _react2.default.createElement(
	  'div',
	  null,
	  _react2.default.createElement(
	    'p',
	    { className: 'info' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ACCOUNT_ACTIVATED' })
	  ),
	  _react2.default.createElement(
	    _reactRouter.Link,
	    { to: '/login?tab=EMAIL', className: 'btn' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'LOGIN' })
	  )
	);
	
	var ActivateAccount = function (_React$Component) {
	  (0, _inherits3.default)(ActivateAccount, _React$Component);
	
	  function ActivateAccount(props) {
	    (0, _classCallCheck3.default)(this, ActivateAccount);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ActivateAccount.__proto__ || (0, _getPrototypeOf2.default)(ActivateAccount)).call(this, props));
	
	    _this.state = {
	      fetching: true,
	      error: false
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(ActivateAccount, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _frilansFinans.UserService.activateAccount(this.props.location.query.id, this.props.location.query.token).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
	    }
	  }, {
	    key: 'handleResponse',
	    value: function handleResponse() {
	      this.setState({
	        fetching: false,
	        error: false
	      });
	    }
	  }, {
	    key: 'handleError',
	    value: function handleError() {
	      this.setState({
	        fetching: false,
	        error: true
	      });
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      if (this.state.fetching) {
	        return _ref;
	      }
	      if (this.state.error) {
	        return _ref2;
	      }
	
	      return _ref3;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'container page mt35 mb70' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12' },
	            this.renderContent()
	          )
	        )
	      );
	    }
	  }]);
	  return ActivateAccount;
	}(_react2.default.Component);
	
	exports.default = ActivateAccount;

/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _errandTable = __webpack_require__(859);
	
	var _errandTable2 = _interopRequireDefault(_errandTable);
	
	var _registeredOrders = __webpack_require__(723);
	
	var _registeredOrders2 = _interopRequireDefault(_registeredOrders);
	
	var _benefit = __webpack_require__(855);
	
	var _benefit2 = _interopRequireDefault(_benefit);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _calculatorContainer = __webpack_require__(856);
	
	var _calculatorContainer2 = _interopRequireDefault(_calculatorContainer);
	
	var _phoneNumberModal = __webpack_require__(718);
	
	var _phoneNumberModal2 = _interopRequireDefault(_phoneNumberModal);
	
	var _ambassador = __webpack_require__(704);
	
	var _ambassador2 = _interopRequireDefault(_ambassador);
	
	var _betaBanner = __webpack_require__(682);
	
	var _betaBanner2 = _interopRequireDefault(_betaBanner);
	
	var _infoBanner = __webpack_require__(696);
	
	var _infoBanner2 = _interopRequireDefault(_infoBanner);
	
	var _dashboardButtonContainer = __webpack_require__(685);
	
	var _dashboardButtonContainer2 = _interopRequireDefault(_dashboardButtonContainer);
	
	var _activityDashboardWelcomeMessage = __webpack_require__(861);
	
	var _activityDashboardWelcomeMessage2 = _interopRequireDefault(_activityDashboardWelcomeMessage);
	
	var _index = __webpack_require__(225);
	
	var _affectedItpOneModal = __webpack_require__(709);
	
	var _affectedItpOneModal2 = _interopRequireDefault(_affectedItpOneModal);
	
	var _affectedItpTwoModal = __webpack_require__(710);
	
	var _affectedItpTwoModal2 = _interopRequireDefault(_affectedItpTwoModal);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _cookieUtils = __webpack_require__(89);
	
	var _cookieUtils2 = _interopRequireDefault(_cookieUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 15/03/16.
	 */
	
	var _ref = _react2.default.createElement(_errandTable2.default, null);
	
	var _ref2 = _react2.default.createElement(_betaBanner2.default, null);
	
	var _ref3 = _react2.default.createElement(_infoBanner2.default, null);
	
	var _ref4 = _react2.default.createElement(_dashboardButtonContainer2.default, null);
	
	var _ref5 = _react2.default.createElement(
	  'h2',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'POINTS_AND_SAVINGS' })
	);
	
	var _ref6 = _react2.default.createElement(_calculatorContainer2.default, null);
	
	var _ref7 = _react2.default.createElement(_ambassador2.default, null);
	
	var ActivitiesView = function (_React$Component) {
	  (0, _inherits3.default)(ActivitiesView, _React$Component);
	
	  function ActivitiesView() {
	    (0, _classCallCheck3.default)(this, ActivitiesView);
	    return (0, _possibleConstructorReturn3.default)(this, (ActivitiesView.__proto__ || (0, _getPrototypeOf2.default)(ActivitiesView)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ActivitiesView, [{
	    key: 'missingPhoneNumber',
	    value: function missingPhoneNumber() {
	      var user = this.props.user;
	
	
	      return !_cookieUtils2.default.getHidePhoneNumberModalCookie() && user.hasOwnProperty('cellphone') && !user.cellphone && user.createdAt < (0, _moment2.default)('20221014').format();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.setShowFooter();
	      this.props.setShowHeader();
	    }
	  }, {
	    key: 'renderRegisteredOrders',
	    value: function renderRegisteredOrders() {
	      return this.props.user && this.props.user.id ? _react2.default.createElement(_registeredOrders2.default, {
	        user: this.props.user
	      }) : null;
	    }
	  }, {
	    key: 'renderErrandTable',
	    value: function renderErrandTable() {
	      return this.props.user && this.props.user.id ? _ref : null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'activities' },
	        _ref2,
	        _ref3,
	        _react2.default.createElement(
	          'div',
	          { className: 'dashboard-welcome-container' },
	          _react2.default.createElement(_activityDashboardWelcomeMessage2.default, {
	            username: this.props.user.firstName
	          }),
	          _ref4
	        ),
	        this.renderRegisteredOrders(),
	        this.renderErrandTable(),
	        _react2.default.createElement(
	          'div',
	          { className: 'invoice-chart-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row mb35' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-5 mb35' },
	              _ref5,
	              _react2.default.createElement(_benefit2.default, { type: 'bonus', user: this.props.user }),
	              _react2.default.createElement(_benefit2.default, { type: 'vacation', user: this.props.user }),
	              _react2.default.createElement(_benefit2.default, { type: 'pension', user: this.props.user }),
	              _ref6
	            ),
	            _ref7
	          )
	        ),
	        _react2.default.createElement(_phoneNumberModal2.default, {
	          modalIsOpen: this.missingPhoneNumber()
	        }),
	        _react2.default.createElement(_affectedItpOneModal2.default, { user: this.props.user }),
	        _react2.default.createElement(_affectedItpTwoModal2.default, { user: this.props.user })
	      );
	    }
	  }]);
	  return ActivitiesView;
	}(_react2.default.Component);
	
	function mapStateToProps(state) {
	  return {
	    footerState: state.topBottomSectionState.showFooter,
	    headerState: state.topBottomSectionState.showHeader,
	    user: state.user
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    setShowFooter: function setShowFooter() {
	      return dispatch((0, _index.setShowFooter)());
	    },
	    setShowHeader: function setShowHeader() {
	      return dispatch((0, _index.setShowHeader)());
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ActivitiesView);

/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Benefit = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(20);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _briefcase = __webpack_require__(727);
	
	var _briefcase2 = _interopRequireDefault(_briefcase);
	
	var _heart = __webpack_require__(215);
	
	var _heart2 = _interopRequireDefault(_heart);
	
	var _sun = __webpack_require__(742);
	
	var _sun2 = _interopRequireDefault(_sun);
	
	var _utils = __webpack_require__(29);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SAVED_VACATION' });
	
	var _ref2 = _react2.default.createElement(_sun2.default, { width: '42', height: '42', colorSchema: 'primary' });
	
	var _ref3 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'EARNED_REWARD_POINTS' });
	
	var _ref4 = _react2.default.createElement(_heart2.default, { width: '42', height: '42', colorSchema: 'primary' });
	
	var _ref5 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'REWARD_POINTS' });
	
	var _ref6 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SAVED_PENSION' });
	
	var _ref7 = _react2.default.createElement(_briefcase2.default, { width: '42', height: '42', colorSchema: 'primary' });
	
	var _ref8 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'AFTER_TAX', className: 'lower-case' });
	
	var Benefit = exports.Benefit = function (_React$Component) {
	  (0, _inherits3.default)(Benefit, _React$Component);
	
	  function Benefit() {
	    (0, _classCallCheck3.default)(this, Benefit);
	    return (0, _possibleConstructorReturn3.default)(this, (Benefit.__proto__ || (0, _getPrototypeOf2.default)(Benefit)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Benefit, [{
	    key: 'render',
	    value: function render() {
	      var text = void 0;
	      var link = '/settings/salary-information';
	      var linkText = '';
	      var icon = null;
	      var target = '_self';
	      var primaryValue = 0;
	      var secondaryValue = 0;
	      var amountTrailing = 'SEK';
	
	      if (this.props.type === 'vacation') {
	        text = _ref;
	        icon = _ref2;
	        primaryValue = this.props.user.vacationPayGross;
	        secondaryValue = this.props.user.vacationPay;
	        link = 'settings/salary-information';
	        linkText = 'POINTS_AND_SAVINGS_LINK_VACATION';
	      } else if (this.props.type === 'bonus') {
	        text = _ref3;
	        icon = _ref4;
	        primaryValue = this.props.user.loyaltyPoints;
	        link = 'economy/loyalty-program/points';
	        linkText = 'POINTS_AND_SAVINGS_LINK_TOGETHER_REWARDS';
	        amountTrailing = _ref5;
	      } else {
	        text = _ref6;
	        icon = _ref7;
	        primaryValue = this.props.user.itp;
	        link = 'https://www.frilansfinans.se/fragor-och-svar/tjanstepension/';
	        linkText = 'POINTS_AND_SAVINGS_LINK_PENSION';
	        target = '_blank';
	      }
	
	      var renderSecondaryValue = function renderSecondaryValue() {
	        return secondaryValue ? _react2.default.createElement(
	          'p',
	          { className: 'benefit-sum secondary' },
	          _utils2.default.numberWithSpaces(_utils2.default.floor(secondaryValue)),
	          ' ',
	          amountTrailing,
	          '\xA0',
	          _ref8
	        ) : null;
	      };
	
	      return _react2.default.createElement(
	        _reactRouter.Link,
	        {
	          className: 'benefit-icon',
	          to: link,
	          target: target
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'benefit' },
	          icon,
	          _react2.default.createElement(
	            'div',
	            { className: 'benefit-text' },
	            _react2.default.createElement(
	              'p',
	              { className: 'benefit-sum' },
	              _utils2.default.numberWithSpaces(_utils2.default.floor(primaryValue)),
	              ' ',
	              amountTrailing
	            ),
	            renderSecondaryValue(),
	            _react2.default.createElement(
	              'p',
	              { className: 'benefit-description' },
	              text
	            ),
	            _react2.default.createElement(_reactTranslateComponent2.default, { content: linkText })
	          )
	        )
	      );
	    }
	  }]);
	  return Benefit;
	}(_react2.default.Component);
	
	exports.default = Benefit;

/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(12);
	
	var _calculator = __webpack_require__(857);
	
	var _calculator2 = _interopRequireDefault(_calculator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    user: state.user,
	    taxkeys: state.taxkeys
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(_calculator2.default);

/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Calculator = undefined;
	
	var _assign = __webpack_require__(22);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _components = __webpack_require__(13);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _calculatorPostEntity = __webpack_require__(344);
	
	var _calculatorPostEntity2 = _interopRequireDefault(_calculatorPostEntity);
	
	var _calculatorWorkerEntity = __webpack_require__(345);
	
	var _calculatorWorkerEntity2 = _interopRequireDefault(_calculatorWorkerEntity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_components.GeneralError, null);
	
	var _ref2 = _react2.default.createElement(
	  'td',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'VACATION_PAY' })
	);
	
	var _ref3 = _react2.default.createElement(
	  'td',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ITP' })
	);
	
	var _ref4 = _react2.default.createElement(
	  'label',
	  { htmlFor: 'itp', className: 'small-label' },
	  _react2.default.createElement('span', null),
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SAVE_PENSION' })
	);
	
	var _ref5 = _react2.default.createElement(
	  'label',
	  { htmlFor: 'vacation', className: 'small-label' },
	  _react2.default.createElement('span', null),
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SAVE_VACATION' })
	);
	
	var _ref6 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'HIDE_ADV_CALC' });
	
	var _ref7 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ADV_CALC' });
	
	var _ref8 = _react2.default.createElement(
	  'td',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_INC_VAT' })
	);
	
	var _ref9 = _react2.default.createElement(
	  'td',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'VAT' })
	);
	
	var _ref10 = _react2.default.createElement(
	  'td',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_AMOUNT' })
	);
	
	var _ref11 = _react2.default.createElement(
	  'td',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'FRILANS_FINANS' })
	);
	
	var _ref12 = _react2.default.createElement(
	  'td',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SOCIAL_FEES' })
	);
	
	var _ref13 = _react2.default.createElement(
	  'td',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'TAX' })
	);
	
	var _ref14 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'HIDE_HOW_CALC' });
	
	var _ref15 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'HOW_CALC' });
	
	var _ref16 = _react2.default.createElement(
	  'td',
	  { className: 'blue-fat' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'TOTAL_PAID_TO_CLIENT' })
	);
	
	var _ref17 = _react2.default.createElement(_components.Spinner, { size: 25 });
	
	var _ref18 = _react2.default.createElement(
	  'label',
	  { htmlFor: 'amount', className: 'blue-label' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'AMOUNT_INVOICE' })
	);
	
	var _ref19 = _react2.default.createElement(
	  'label',
	  { htmlFor: 'salary', className: 'blue-label' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SALARY_AFTER_TAX' })
	);
	
	var _ref20 = _react2.default.createElement('div', { id: 'calculator-anchor' });
	
	var _ref21 = _react2.default.createElement(
	  'div',
	  { className: 'calculator-header' },
	  _react2.default.createElement(
	    'div',
	    { className: 'icon-heading' },
	    _react2.default.createElement(
	      'h2',
	      null,
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CALCULATOR' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CALCULATOR_TEXT' })
	    )
	  )
	);
	
	var Calculator = exports.Calculator = function (_React$Component) {
	  (0, _inherits3.default)(Calculator, _React$Component);
	
	  function Calculator(props, context) {
	    (0, _classCallCheck3.default)(this, Calculator);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Calculator.__proto__ || (0, _getPrototypeOf2.default)(Calculator)).call(this, props, context));
	
	    _this.state = {
	      showAdvanced: false,
	      showTables: false,
	      valuesSet: false,
	      posting: false,
	      postError: false,
	      calculation: null,
	      input: {
	        type: 'amount',
	        value: '0'
	      },
	      worker: _this.createCalculatorCoworkerEntity(props)
	    };
	
	    _this.toggleAdvanced = _this.toggleAdvanced.bind(_this);
	    _this.toggleTables = _this.toggleTables.bind(_this);
	    _this.updateTravelOrAllowance = _this.updateTravelOrAllowance.bind(_this);
	    _this.updateMainValues = _this.updateMainValues.bind(_this);
	    _this.checkboxClick = _this.checkboxClick.bind(_this);
	    _this.switchValues = _this.switchValues.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(Calculator, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState((0, _assign2.default)(this.state, {
	        worker: this.createCalculatorCoworkerEntity(nextProps)
	      }));
	    }
	  }, {
	    key: 'createCalculatorCoworkerEntity',
	    value: function createCalculatorCoworkerEntity(props) {
	      var taxKey = this.getTaxKey(props.user.defaultTaxkeyId, props.taxkeys);
	
	      var calculatorCoworkerEntity = new _calculatorWorkerEntity2.default();
	      calculatorCoworkerEntity.fee = 6;
	      calculatorCoworkerEntity.tax = taxKey.taxAmount || 0;
	      calculatorCoworkerEntity.vat = 25;
	      calculatorCoworkerEntity.payroll_tax = taxKey.payrollTax || 0;
	      calculatorCoworkerEntity.vacation = props.user.saveVacationPay || false;
	      calculatorCoworkerEntity.itp = props.user.socialSecurityNr != null ? props.user.saveITP : true;
	      calculatorCoworkerEntity.travel = 0;
	      calculatorCoworkerEntity.allowance = 0;
	      calculatorCoworkerEntity.id = props.user.id;
	
	      return calculatorCoworkerEntity;
	    }
	  }, {
	    key: 'getTaxKey',
	    value: function getTaxKey(taxkeyId, taxkeys) {
	      for (var i = 0; i < taxkeys.length; i++) {
	        if (parseInt(taxkeyId) === parseInt(taxkeys[i].id)) {
	          return taxkeys[i];
	        }
	      }
	
	      return {};
	    }
	  }, {
	    key: 'toggleAdvanced',
	    value: function toggleAdvanced() {
	      this.setState({
	        showAdvanced: !this.state.showAdvanced
	      });
	    }
	  }, {
	    key: 'toggleTables',
	    value: function toggleTables() {
	      this.setState({
	        showTables: !this.state.showTables
	      });
	    }
	
	    /**
	     * Switch the values between Invoice and Salary
	     *
	     * Currently unused
	     */
	
	  }, {
	    key: 'switchValues',
	    value: function switchValues() {
	      var type = void 0;
	
	      if (this.state.input.type === 'amount') {
	        type = 'salary';
	        this.refs.salary.value = this.refs.amount.value;
	        this.refs.amount.value = '';
	      } else {
	        type = 'amount';
	        this.refs.amount.value = this.refs.salary.value;
	        this.refs.salary.value = '';
	      }
	
	      this.setState({
	        input: {
	          type: type,
	          value: this.state.input.value
	        }
	      }, this.startRequestTimeout);
	    }
	
	    /**
	     * Required function when you have the checked attribute on a checkbox
	     */
	
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {}
	
	    /**
	     * Handle Vacation and Allowance fields
	     */
	
	  }, {
	    key: 'updateTravelOrAllowance',
	    value: function updateTravelOrAllowance(e) {
	      // Force a positive value
	      if (e.target.value) {
	        e.target.value = Math.abs(e.target.value);
	      }
	      var worker = this.state.worker;
	      worker[e.target.name] = e.target.value ? parseInt(e.target.value) : 0;
	
	      this.setState({ worker: worker }, this.startRequestTimeout);
	    }
	
	    /**
	     * Handle ITP and Vacation booleans
	     */
	
	  }, {
	    key: 'checkboxClick',
	    value: function checkboxClick(e) {
	      var worker = this.state.worker;
	      worker[e.target.name] = e.target.checked;
	
	      this.setState({ worker: worker }, this.startRequestTimeout);
	    }
	
	    /**
	     * Handle values from Invoice and Salary fields
	     */
	
	  }, {
	    key: 'updateMainValues',
	    value: function updateMainValues(e) {
	      this.setState({
	        input: {
	          value: e.target.value ? parseInt(e.target.value) : 0,
	          type: e.target.name
	        }
	      }, this.startRequestTimeout);
	    }
	
	    /**
	     * Wait 300 ms since last input before making the request to
	     * the backend.
	     */
	
	  }, {
	    key: 'startRequestTimeout',
	    value: function startRequestTimeout() {
	      if (this.requestTimeout) {
	        window.clearTimeout(this.requestTimeout);
	      }
	
	      this.requestTimeout = setTimeout(this.makeRequest.bind(this), 300);
	    }
	  }, {
	    key: 'makeRequest',
	    value: function makeRequest() {
	      var _this2 = this;
	
	      if (this.state.input.value && this.state.input.value > 0) {
	        var worker = (0, _assign2.default)({}, this.state.worker);
	
	        var calculatorPostEntity = new _calculatorPostEntity2.default();
	        calculatorPostEntity.vat = 25;
	
	        if (this.state.input.type === 'amount') {
	          calculatorPostEntity.amount = this.state.input.value;
	        } else {
	          worker.net = this.state.input.value;
	        }
	
	        calculatorPostEntity.workers = [worker];
	
	        this.setState({
	          posting: true,
	          postError: false
	        }, function () {
	          _frilansFinans.InvoiceService.getInvoiceCalculation(calculatorPostEntity).then(_this2.handleResponse.bind(_this2)).catch(_this2.handleError.bind(_this2));
	        });
	      }
	    }
	  }, {
	    key: 'handleResponse',
	    value: function handleResponse(response) {
	      var _this3 = this;
	
	      response = response.invoiceCalculations[0];
	      this.setState({
	        posting: false,
	        postError: false,
	        calculation: response
	      }, function () {
	        if (_this3.state.input.type === 'amount') {
	          _this3.refs.salary.value = Math.round(response.net);
	        } else {
	          _this3.refs.amount.value = Math.round(response.amount);
	        }
	      });
	    }
	  }, {
	    key: 'handleError',
	    value: function handleError() {
	      this.setState({
	        posting: false,
	        postError: true
	      });
	    }
	  }, {
	    key: 'renderError',
	    value: function renderError() {
	      if (this.state.postError) {
	        return _ref;
	      }
	    }
	  }, {
	    key: 'renderVacationPay',
	    value: function renderVacationPay() {
	      if (this.state.worker.vacation) {
	        return _react2.default.createElement(
	          'tr',
	          null,
	          _ref2,
	          _react2.default.createElement(
	            'td',
	            null,
	            Math.round(this.state.calculation.vacationGross),
	            ' kr'
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderITP',
	    value: function renderITP() {
	      if (this.state.worker.itp) {
	        return _react2.default.createElement(
	          'tr',
	          null,
	          _ref3,
	          _react2.default.createElement(
	            'td',
	            null,
	            Math.round(this.state.calculation.itp),
	            ' kr'
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderITPCheckbox',
	    value: function renderITPCheckbox() {
	      if (this.props.user.canChangeItp && this.props.user.socialSecurityNr != null) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'first-col' },
	          _react2.default.createElement('input', { id: 'itp', type: 'checkbox', name: 'itp', onChange: this.onChange,
	            checked: this.state.worker.itp, onClick: this.checkboxClick }),
	          _ref4
	        );
	      }
	    }
	  }, {
	    key: 'renderAdvancedCalculations',
	    value: function renderAdvancedCalculations() {
	      if (this.state.showAdvanced) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-form' },
	            _react2.default.createElement(
	              'div',
	              { className: 'first-col' },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-form check-boxes break-1200' },
	                this.renderITPCheckbox(),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'last-col' },
	                  _react2.default.createElement('input', { id: 'vacation', type: 'checkbox', name: 'vacation', onChange: this.onChange,
	                    checked: this.state.worker.vacation, onClick: this.checkboxClick }),
	                  _ref5
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'last-col' },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-form break-1200' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'first-col' },
	                  _react2.default.createElement('input', { type: 'number', name: 'travel',
	                    placeholder: (0, _proxyCounterpart.proxyCounterpart)('TRAVEL_FEE_SEK'), onChange: this.updateTravelOrAllowance })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'last-col' },
	                  _react2.default.createElement('input', { type: 'number', name: 'allowance',
	                    placeholder: (0, _proxyCounterpart.proxyCounterpart)('TRAVEL_ALLOWANCE_SEK'),
	                    onChange: this.updateTravelOrAllowance })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn-minus', onClick: this.toggleAdvanced },
	            _ref6
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'button',
	        { className: 'btn-plus', onClick: this.toggleAdvanced },
	        _ref7
	      );
	    }
	  }, {
	    key: 'renderTables',
	    value: function renderTables() {
	      if (this.state.calculation) {
	        if (this.state.showTables) {
	          var c = this.state.calculation;
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'flex-form tables-wrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'first-col' },
	                _react2.default.createElement(
	                  'table',
	                  { className: 'clean-table' },
	                  _react2.default.createElement(
	                    'tbody',
	                    null,
	                    _react2.default.createElement(
	                      'tr',
	                      null,
	                      _ref8,
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        Math.round(c.amount + c.vat),
	                        ' kr'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tr',
	                      null,
	                      _ref9,
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        Math.round(c.vat),
	                        ' kr'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tr',
	                      null,
	                      _ref10,
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        Math.round(c.amount),
	                        ' kr'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tr',
	                      null,
	                      _ref11,
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        Math.round(c.fee),
	                        ' kr'
	                      )
	                    ),
	                    this.renderITP()
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'last-col' },
	                _react2.default.createElement(
	                  'table',
	                  { className: 'clean-table' },
	                  _react2.default.createElement(
	                    'tbody',
	                    null,
	                    _react2.default.createElement(
	                      'tr',
	                      null,
	                      _ref12,
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        Math.round(c.totalPayrollTax),
	                        ' kr'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tr',
	                      null,
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement(_reactTranslateComponent2.default, {
	                          content: this.state.worker.vacation ? 'GROSS_EXCL_VACATION' : 'GROSS_SALARY_VACATION'
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        Math.round(c.gross),
	                        ' kr'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tr',
	                      null,
	                      _ref13,
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        Math.round(c.tax),
	                        ' kr'
	                      )
	                    ),
	                    this.renderVacationPay(),
	                    this.renderNet(),
	                    this.renderPaidToClient()
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: 'btn-minus', onClick: this.toggleTables },
	              _ref14
	            )
	          );
	        }
	
	        return _react2.default.createElement(
	          'button',
	          { className: 'btn-plus', onClick: this.toggleTables },
	          _ref15
	        );
	      }
	    }
	  }, {
	    key: 'renderNet',
	    value: function renderNet() {
	      var c = this.state.calculation;
	
	      var hasExpense = c.travel > 0 || c.allowance > 0;
	      var netTextClass = !hasExpense ? 'blue-fat' : '';
	
	      return _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          { className: netTextClass },
	          _react2.default.createElement(_reactTranslateComponent2.default, { content: this.state.worker.vacation ? 'NET_EXCL_VACATION' : 'NET_SALARY_VACATION' })
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: netTextClass },
	          Math.round(c.net),
	          ' kr'
	        )
	      );
	    }
	  }, {
	    key: 'renderPaidToClient',
	    value: function renderPaidToClient() {
	      var c = this.state.calculation;
	
	      var hasExpense = c.travel > 0 || c.allowance > 0;
	
	      if (hasExpense) {
	        return _react2.default.createElement(
	          'tr',
	          null,
	          _ref16,
	          _react2.default.createElement(
	            'td',
	            { className: 'blue-fat' },
	            Math.round(c.toPay),
	            ' kr'
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderSpinner',
	    value: function renderSpinner() {
	      if (this.state.posting) {
	        return _ref17;
	      }
	
	      // Render switch button if we want to add it again
	      // return (<button className='switch-btn' onClick={this.switchValues}></button>);
	    }
	  }, {
	    key: 'renderForm',
	    value: function renderForm() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'calc-form' },
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-form' },
	          _react2.default.createElement(
	            'div',
	            { className: 'invoice-amount first-col' },
	            _ref18,
	            _react2.default.createElement('input', {
	              ref: 'amount',
	              type: 'number',
	              name: 'amount',
	              placeholder: (0, _proxyCounterpart.proxyCounterpart)('AMOUNT_INVOICE_PLACEHOLDER'),
	              onChange: this.updateMainValues
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'spinner-wrapper' },
	            this.renderSpinner()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'salary-amount last-col' },
	            _ref19,
	            _react2.default.createElement('input', {
	              ref: 'salary',
	              type: 'number',
	              name: 'salary',
	              placeholder: (0, _proxyCounterpart.proxyCounterpart)('SALARY_AFTER_TAX'),
	              onChange: this.updateMainValues
	            })
	          )
	        ),
	        this.renderAdvancedCalculations(),
	        this.renderTables(),
	        this.renderError()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { id: 'calculator', className: 'calculator' },
	        _ref20,
	        _ref21,
	        this.renderForm()
	      );
	    }
	  }]);
	  return Calculator;
	}(_react2.default.Component);
	
	Calculator.contextTypes = {
	  user: _react.PropTypes.object.isRequired,
	  taxkeys: _react.PropTypes.array.isRequired
	};
	exports.default = Calculator;

/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ErrandRow = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _utils = __webpack_require__(29);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _invoiceActivityStatus = __webpack_require__(331);
	
	var _invoiceActivityStatus2 = _interopRequireDefault(_invoiceActivityStatus);
	
	var _ellipsis = __webpack_require__(161);
	
	var _ellipsis2 = _interopRequireDefault(_ellipsis);
	
	var _showMoreInvoice = __webpack_require__(210);
	
	var _showMoreInvoice2 = _interopRequireDefault(_showMoreInvoice);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ErrandRow = exports.ErrandRow = function (_React$Component) {
	  (0, _inherits3.default)(ErrandRow, _React$Component);
	
	  function ErrandRow(props, context) {
	    (0, _classCallCheck3.default)(this, ErrandRow);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ErrandRow.__proto__ || (0, _getPrototypeOf2.default)(ErrandRow)).call(this, props, context));
	
	    _this.isAwaitingApproval = _this.isAwaitingApproval.bind(_this);
	    _this.showMoreList = _this.showMoreList.bind(_this);
	    _this.setWrapperRef = _this.setWrapperRef.bind(_this);
	    _this.setWrapperRefMobile = _this.setWrapperRefMobile.bind(_this);
	    _this.handleClickOutside = _this.handleClickOutside.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(ErrandRow, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('mousedown', this.handleClickOutside);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('mousedown', this.handleClickOutside);
	    }
	  }, {
	    key: 'setWrapperRef',
	    value: function setWrapperRef(node) {
	      this.wrapperRef = node;
	    }
	  }, {
	    key: 'setWrapperRefMobile',
	    value: function setWrapperRefMobile(node) {
	      this.wrapperRefMobile = node;
	    }
	  }, {
	    key: 'handleClickOutside',
	    value: function handleClickOutside(event) {
	      if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.wrapperRefMobile && !this.wrapperRefMobile.contains(event.target)) {
	        if (this.props.showMoreList.invoiceId === this.props.invoice.id) {
	          this.props.resetShowMoreList();
	        }
	      }
	    }
	  }, {
	    key: 'showMoreList',
	    value: function showMoreList() {
	      this.props.toggleShowMoreList(this.props.invoice.id);
	    }
	  }, {
	    key: 'renderShowMore',
	    value: function renderShowMore(showMoreList, route) {
	      if (showMoreList) {
	        return _react2.default.createElement(_showMoreInvoice2.default, {
	          invoice: this.props.invoice,
	          invoiceRoute: route,
	          user: this.context.user
	        });
	      }
	    }
	  }, {
	    key: 'isAwaitingApproval',
	    value: function isAwaitingApproval() {
	      return this.props.invoice.status === 1;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var route = '/economy/invoices/' + this.props.invoice.id;
	      var showMoreList = +this.props.showMoreList.invoiceId === +this.props.invoice.id ? this.props.showMoreList.show : false;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'errand-flex-row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'errand-flex-row-content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'errand-flex-title-container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'errand-flex-title' },
	              _react2.default.createElement(
	                'p',
	                { className: 'errand-title' },
	                this.props.invoice.customer.name
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'errand-subtitle' },
	                this.props.invoice.amount,
	                ' ',
	                (0, _proxyCounterpart.proxyCounterpart)('SEK'),
	                ' ',
	                (0, _proxyCounterpart.proxyCounterpart)('EXCL_VAT')
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'errand-subtitle' },
	                _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CREATED_DATE',
	                  date: _utils2.default.formatDate(this.props.invoice.createdAt) })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                ref: this.setWrapperRefMobile,
	                className: 'errand-flex-trailing hide-until-mobile'
	              },
	              this.renderShowMore(showMoreList, route),
	              _react2.default.createElement(
	                'div',
	                { onClick: this.showMoreList },
	                _react2.default.createElement(_ellipsis2.default, {
	                  colorSchema: 'primary',
	                  fill: showMoreList
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'errand-activity-status' },
	            _react2.default.createElement(_invoiceActivityStatus2.default, {
	              invoice: this.props.invoice,
	              user: this.context.user,
	              containerStyle: ' dashboard'
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              ref: this.setWrapperRef,
	              className: 'errand-flex-trailing hide-mobile'
	            },
	            this.renderShowMore(showMoreList, route),
	            _react2.default.createElement(
	              'div',
	              { onClick: this.showMoreList },
	              _react2.default.createElement(_ellipsis2.default, {
	                colorSchema: 'primary',
	                fill: showMoreList
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return ErrandRow;
	}(_react2.default.Component);
	
	ErrandRow.contextTypes = {
	  user: _react.PropTypes.object.isRequired
	};
	exports.default = ErrandRow;

/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ErrandTable = undefined;
	
	var _toConsumableArray2 = __webpack_require__(120);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _errandRow = __webpack_require__(858);
	
	var _errandRow2 = _interopRequireDefault(_errandRow);
	
	var _spinner = __webpack_require__(57);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _generalError = __webpack_require__(63);
	
	var _generalError2 = _interopRequireDefault(_generalError);
	
	var _invoiceService = __webpack_require__(220);
	
	var _invoiceService2 = _interopRequireDefault(_invoiceService);
	
	var _showMoreButton = __webpack_require__(860);
	
	var _showMoreButton2 = _interopRequireDefault(_showMoreButton);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_generalError2.default, null); /**
	                                                                         * Created by staffanrantzow on 17/03/16.
	                                                                         */
	
	var _ref2 = _react2.default.createElement(
	  'div',
	  { className: 'loader-wrapper' },
	  _react2.default.createElement(_spinner2.default, null)
	);
	
	var _ref3 = _react2.default.createElement(
	  'p',
	  { className: 'info' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'NO_INVOICES' })
	);
	
	var _ref4 = _react2.default.createElement(
	  'div',
	  { className: 'current-invoices-title' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CURRENT_ERRANDS' })
	);
	
	var ErrandTable = exports.ErrandTable = function (_React$Component) {
	  (0, _inherits3.default)(ErrandTable, _React$Component);
	
	  function ErrandTable(props) {
	    (0, _classCallCheck3.default)(this, ErrandTable);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ErrandTable.__proto__ || (0, _getPrototypeOf2.default)(ErrandTable)).call(this, props));
	
	    _this.state = {
	      fetchingInitial: true,
	      fetchError: false,
	      invoices: [],
	      pendingRequest: null,
	      showMoreList: {
	        invoiceId: null,
	        show: false
	      },
	      meta: {
	        count: 0,
	        currentPage: 0,
	        perPage: 0,
	        total: 0,
	        totalPages: 0
	      }
	    };
	
	    _this.getInvoices = _this.getInvoices.bind(_this);
	    _this.handleError = _this.handleError.bind(_this);
	    _this.setShowMoreList = _this.setShowMoreList.bind(_this);
	    _this.resetShowMoreList = _this.resetShowMoreList.bind(_this);
	    _this.renderTable = _this.renderTable.bind(_this);
	    _this.renderTableRow = _this.renderTableRow.bind(_this);
	    _this.renderShowMoreBtn = _this.renderShowMoreBtn.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(ErrandTable, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getInvoices();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.pendingRequest && this.state.pendingRequest.cancel) {
	        this.state.pendingRequest.cancel();
	      }
	    }
	  }, {
	    key: 'getInvoices',
	    value: function getInvoices() {
	      var page = +this.state.meta.currentPage + 1;
	      var userId = +this.props.user.id;
	
	      var pendingRequest = _invoiceService2.default.get(userId, null, page, 0, 1, 2, null, true);
	
	      pendingRequest.promise.then(this.handleResponse.bind(this)).catch(this.handleError);
	
	      this.setState({
	        pendingRequest: pendingRequest
	      });
	    }
	  }, {
	    key: 'handleResponse',
	    value: function handleResponse(response) {
	      var invoicesMerged = [].concat((0, _toConsumableArray3.default)(this.state.invoices), (0, _toConsumableArray3.default)(response.collection));
	      this.setState({
	        fetchingInitial: false,
	        fetchError: false,
	        invoices: invoicesMerged,
	        meta: response.meta
	      });
	    }
	  }, {
	    key: 'handleError',
	    value: function handleError(error) {
	      if (error.response !== undefined) {
	        this.setState({
	          fetchError: true
	        });
	      }
	    }
	  }, {
	    key: 'noInvoicesRow',
	    value: function noInvoicesRow() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'errand-table-no-more-info' },
	        (0, _proxyCounterpart.proxyCounterpart)('ERRAND_TABLE_NO_INVOICES')
	      );
	    }
	  }, {
	    key: 'noMoreInfoRow',
	    value: function noMoreInfoRow() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'errand-table-no-more-info' },
	        (0, _proxyCounterpart.proxyCounterpart)('ERRAND_TABLE_ALL_INVOICES_ARE_LOADED')
	      );
	    }
	  }, {
	    key: 'renderShowMoreBtn',
	    value: function renderShowMoreBtn() {
	      if (this.state.meta.currentPage === this.state.meta.totalPages) {
	        return this.noMoreInfoRow();
	      }
	
	      if (!this.state.meta || this.state.invoices.length <= 0) {
	        return this.noInvoicesRow();
	      }
	
	      if (this.state.fetchingInitial || !this.state.meta.currentPage || this.state.meta.currentPage >= this.state.meta.totalPages) {
	        return null;
	      }
	
	      return _react2.default.createElement(_showMoreButton2.default, {
	        text: (0, _proxyCounterpart.proxyCounterpart)('ERRAND_TABLE_TABLE_SHOW_MORE_INVOICES'),
	        loading: this.state.fetchingInitial || false,
	        callback: this.getInvoices
	      });
	    }
	  }, {
	    key: 'setShowMoreList',
	    value: function setShowMoreList(invoiceId) {
	      var invoiceIdSet = this.state.showMoreList.invoiceId === invoiceId;
	      this.setState({
	        showMoreList: {
	          invoiceId: invoiceIdSet ? null : invoiceId,
	          show: !invoiceIdSet
	        }
	      });
	    }
	  }, {
	    key: 'resetShowMoreList',
	    value: function resetShowMoreList() {
	      this.setState({
	        showMoreList: {
	          invoiceId: null,
	          show: false
	        }
	      });
	    }
	  }, {
	    key: 'getContent',
	    value: function getContent() {
	      if (this.state.fetchError) {
	        return _ref;
	      }
	      if (this.state.fetchingInitial) {
	        return this.renderLoader();
	      }
	      if (this.state.invoices.length === 0) {
	        return this.renderNoResult();
	      }
	      return this.renderTable();
	    }
	  }, {
	    key: 'renderLoader',
	    value: function renderLoader() {
	      return _ref2;
	    }
	  }, {
	    key: 'renderNoResult',
	    value: function renderNoResult() {
	      return _ref3;
	    }
	  }, {
	    key: 'renderTableRow',
	    value: function renderTableRow(invoice, i) {
	      return _react2.default.createElement(_errandRow2.default, {
	        key: i,
	        invoice: invoice,
	        toggleShowMoreList: this.setShowMoreList,
	        resetShowMoreList: this.resetShowMoreList,
	        showMoreList: this.state.showMoreList
	      });
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'errand-table-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'errand-flex-table' },
	          this.state.invoices.map(function (invoice, i) {
	            return _this2.renderTableRow(invoice, i);
	          })
	        ),
	        this.renderShowMoreBtn()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var content = this.getContent();
	      return this.state.invoices.length ? _react2.default.createElement(
	        'div',
	        { className: 'current-invoices' },
	        _ref4,
	        content
	      ) : null;
	    }
	  }]);
	  return ErrandTable;
	}(_react2.default.Component);
	
	function mapStateToProps(state) {
	  return {
	    user: state.user
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ErrandTable);

/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ShowMoreButton = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ShowMoreButton = exports.ShowMoreButton = function (_React$Component) {
	  (0, _inherits3.default)(ShowMoreButton, _React$Component);
	
	  function ShowMoreButton(props) {
	    (0, _classCallCheck3.default)(this, ShowMoreButton);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ShowMoreButton.__proto__ || (0, _getPrototypeOf2.default)(ShowMoreButton)).call(this, props));
	
	    _this.callCallback = _this.callCallback.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(ShowMoreButton, [{
	    key: 'callCallback',
	    value: function callCallback(e) {
	      if (!this.props.loading && typeof this.props.callback === 'function') {
	        this.props.callback(e);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'button',
	        {
	          id: this.props.id,
	          className: 'errand-table-show-more-button',
	          onClick: this.callCallback
	        },
	        this.props.text
	      );
	    }
	  }]);
	  return ShowMoreButton;
	}(_react2.default.Component);
	
	exports.default = ShowMoreButton;

/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _loyaltyInfoModal = __webpack_require__(713);
	
	var _loyaltyInfoModal2 = _interopRequireDefault(_loyaltyInfoModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'span',
	  { className: 'dashboard-welcome-text' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'DASHBOARD_GREETING_2' })
	);
	
	var _ref2 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'DASHBOARD_INFO_LINK' });
	
	var ActivityDashboardWelcomeMessage = function (_React$Component) {
	  (0, _inherits3.default)(ActivityDashboardWelcomeMessage, _React$Component);
	
	  function ActivityDashboardWelcomeMessage(props) {
	    (0, _classCallCheck3.default)(this, ActivityDashboardWelcomeMessage);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ActivityDashboardWelcomeMessage.__proto__ || (0, _getPrototypeOf2.default)(ActivityDashboardWelcomeMessage)).call(this, props));
	
	    _this.state = {
	      showModal: false
	    };
	
	    _this.toggleModal = _this.toggleModal.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(ActivityDashboardWelcomeMessage, [{
	    key: 'toggleModal',
	    value: function toggleModal(e) {
	      this.setState({
	        showModal: !this.state.showModal
	      });
	    }
	  }, {
	    key: 'renderLojaltyInfoModal',
	    value: function renderLojaltyInfoModal() {
	      if (this.state.showModal) {
	        return _react2.default.createElement(_loyaltyInfoModal2.default, { close: this.toggleModal });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'dashboard-welcome-message-container' },
	        _react2.default.createElement(
	          'span',
	          { className: 'dashboard-welcome-text' },
	          _react2.default.createElement(_reactTranslateComponent2.default, { content: 'DASHBOARD_GREETING_1', name: this.props.username })
	        ),
	        _ref,
	        _react2.default.createElement(
	          'span',
	          { className: 'dashboard-info-text' },
	          _react2.default.createElement(
	            'a',
	            { href: '#', onClick: this.toggleModal },
	            _ref2
	          )
	        ),
	        this.renderLojaltyInfoModal()
	      );
	    }
	  }]);
	  return ActivityDashboardWelcomeMessage;
	}(_react2.default.Component);
	
	exports.default = ActivityDashboardWelcomeMessage;

/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UpdateCustomerEmail = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(13);
	
	var _bouncedEmailService = __webpack_require__(757);
	
	var _bouncedEmailService2 = _interopRequireDefault(_bouncedEmailService);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'update-email-header' },
	  _react2.default.createElement(
	    'h3',
	    null,
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'BOUNCED_EMAIL_COMPANY_TITLE' })
	  )
	);
	
	var _ref2 = _react2.default.createElement(
	  'span',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'BOUNCED_EMAIL_COMPANY_BODY_PART_2' })
	);
	
	var _ref3 = _react2.default.createElement(
	  'p',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'BOUNCED_EMAIL_COMPANY_BODY_PART_3' })
	);
	
	var _ref4 = _react2.default.createElement(_components.Spinner, null);
	
	var _ref5 = _react2.default.createElement(
	  'p',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'EMAIL_INVALID_ERROR', className: 'error' })
	);
	
	var UpdateCustomerEmail = exports.UpdateCustomerEmail = function (_Component) {
	  (0, _inherits3.default)(UpdateCustomerEmail, _Component);
	
	  function UpdateCustomerEmail(props) {
	    (0, _classCallCheck3.default)(this, UpdateCustomerEmail);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (UpdateCustomerEmail.__proto__ || (0, _getPrototypeOf2.default)(UpdateCustomerEmail)).call(this, props));
	
	    _this.state = {
	      email: '',
	      companyEmail: '',
	      companyName: '',
	
	      errorMessage: false,
	      loadingCompanyData: true,
	      loading: false,
	      successMessage: false,
	      validEmail: true
	    };
	
	    _this.handleChangeEmail = _this.handleChangeEmail.bind(_this);
	    _this.handleGeneralError = _this.handleGeneralError.bind(_this);
	    _this.handleGetCompanySuccess = _this.handleGetCompanySuccess.bind(_this);
	    _this.handleGetCompanyReject = _this.handleGetCompanyReject.bind(_this);
	    _this.submitForm = _this.submitForm.bind(_this);
	    _this.validateEmail = _this.validateEmail.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(UpdateCustomerEmail, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var linkToken = this.props.params.token;
	
	      if (linkToken) {
	        _bouncedEmailService2.default.getCompanyDataFromToken(linkToken).then(function (response) {
	          if (response.status === 200) {
	            _this2.handleGetCompanySuccess(response);
	          } else {
	            _this2.handleGetCompanyReject();
	          }
	        }).catch(function () {
	          return _this2.handleGetCompanyReject();
	        });
	      } else {
	        this.handleGeneralError();
	      }
	    }
	  }, {
	    key: 'handleChangeEmail',
	    value: function handleChangeEmail(event) {
	      this.setState({ email: event.target.value });
	    }
	  }, {
	    key: 'handleGetCompanySuccess',
	    value: function handleGetCompanySuccess(response) {
	      this.setState({
	        loadingCompanyData: false,
	        companyEmail: response.data.data.email,
	        companyName: response.data.data.company_name
	      });
	    }
	  }, {
	    key: 'handleGetCompanyReject',
	    value: function handleGetCompanyReject() {
	      this.setState({
	        loadingCompanyData: false,
	        errorMessage: (0, _proxyCounterpart.proxyCounterpart)('BOUNCED_EMAIL_COMPANY_ALREADY_UPDATED')
	      });
	    }
	  }, {
	    key: 'handleGeneralError',
	    value: function handleGeneralError() {
	      this.setState({
	        loading: false,
	        loadingCompanyData: false,
	        errorMessage: (0, _proxyCounterpart.proxyCounterpart)('GENERAL_ERROR')
	      });
	    }
	  }, {
	    key: 'validateEmail',
	    value: function validateEmail(email) {
	      /*eslint-disable */
	      var re = /^(([^<>()\[\]\\.,;:\s@"äöå]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([åäöa-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	      /*eslint-enable */
	
	      return re.test(email);
	    }
	  }, {
	    key: 'submitForm',
	    value: function submitForm(e) {
	      var _this3 = this;
	
	      e.preventDefault();
	
	      if (!this.validateEmail(this.state.email)) {
	        this.setState({
	          loading: false,
	          validEmail: false
	        });
	        return;
	      }
	
	      this.setState({
	        loading: true,
	        errorMessage: false,
	        successMessage: false,
	        validEmail: true
	      });
	
	      var linkToken = this.props.params.token;
	
	      _bouncedEmailService2.default.updateCompanyEmail(linkToken, this.state.email).then(function (response) {
	        if (response.status === 200) {
	          _this3.setState({
	            loading: false,
	            errorMessage: false,
	            successMessage: (0, _proxyCounterpart.proxyCounterpart)('BOUNCED_EMAIL_COMPANY_UPDATED')
	          });
	        } else {
	          _this3.handleGeneralError();
	        }
	      }).catch(function () {
	        _this3.handleGeneralError();
	      });
	    }
	  }, {
	    key: 'renderForm',
	    value: function renderForm() {
	      if (!this.state.errorMessage && !this.state.successMessage && !this.state.loadingCompanyData) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'update-email-container' },
	          _ref,
	          _react2.default.createElement(
	            'div',
	            { className: 'update-email-body' },
	            _react2.default.createElement(
	              'div',
	              { className: 'mb-30' },
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  (0, _proxyCounterpart.proxyCounterpart)('BOUNCED_EMAIL_COMPANY_BODY_PART_1')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'bold' },
	                  ' ',
	                  this.state.companyEmail,
	                  ' '
	                ),
	                _ref2,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'bold' },
	                  ' ',
	                  this.state.companyName,
	                  '.'
	                )
	              ),
	              _ref3
	            ),
	            _react2.default.createElement(
	              'form',
	              { action: '', method: 'POST' },
	              _react2.default.createElement(
	                'div',
	                { className: 'mb-15' },
	                _react2.default.createElement('input', {
	                  type: 'text',
	                  name: 'email',
	                  className: 'no-margin',
	                  placeholder: (0, _proxyCounterpart.proxyCounterpart)('ENTER_NEW_EMAIL'),
	                  value: this.state.email,
	                  onChange: this.handleChangeEmail,
	                  autoCorrect: 'off',
	                  autoComplete: 'off'
	                })
	              ),
	              this.renderValidEmailError(),
	              _react2.default.createElement(
	                'div',
	                { className: 'update-email-button-wrapper' },
	                _react2.default.createElement(_components.SpinnerButton, {
	                  text: (0, _proxyCounterpart.proxyCounterpart)('SAVE'),
	                  loading: this.state.loading,
	                  classes: 'btn',
	                  callback: this.submitForm
	                })
	              )
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderLoading',
	    value: function renderLoading() {
	      if (this.state.loadingCompanyData) {
	        return _ref4;
	      }
	    }
	  }, {
	    key: 'renderErrorMessage',
	    value: function renderErrorMessage() {
	      if (this.state.errorMessage) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'update-email-message-container update-email-error' },
	          _react2.default.createElement('img', { src: __webpack_require__(656) }),
	          this.state.errorMessage
	        );
	      }
	    }
	  }, {
	    key: 'renderSuccessMessage',
	    value: function renderSuccessMessage() {
	      if (this.state.successMessage) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'update-email-message-container' },
	          _react2.default.createElement('img', { src: __webpack_require__(1552) }),
	          this.state.successMessage
	        );
	      }
	    }
	  }, {
	    key: 'renderValidEmailError',
	    value: function renderValidEmailError() {
	      if (!this.state.validEmail) {
	        return _ref5;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'bounced-email-page-container' },
	        this.renderLoading(),
	        this.renderForm(),
	        this.renderErrorMessage(),
	        this.renderSuccessMessage()
	      );
	    }
	  }]);
	  return UpdateCustomerEmail;
	}(_react.Component);
	
	exports.default = UpdateCustomerEmail;

/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CustomerRow = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 15/03/16.
	 */
	
	var CustomerRow = exports.CustomerRow = function (_React$Component) {
	  (0, _inherits3.default)(CustomerRow, _React$Component);
	
	  function CustomerRow(props) {
	    (0, _classCallCheck3.default)(this, CustomerRow);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (CustomerRow.__proto__ || (0, _getPrototypeOf2.default)(CustomerRow)).call(this, props));
	
	    _this.onDeleteClick = _this.onDeleteClick.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(CustomerRow, [{
	    key: 'onDeleteClick',
	    value: function onDeleteClick(e) {
	      e.preventDefault();
	      this.props.remove(this.props.customer);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var route = 'customers/' + this.props.customer.id;
	
	      return _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          { className: 'col-customer' },
	          this.props.customer.name
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'col-orgnr' },
	          this.props.customer.vatNr
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'col-ref' },
	          this.props.customer.contact
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'col-address' },
	          _react2.default.createElement(
	            'span',
	            null,
	            this.props.customer.address.street
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            this.props.customer.address.zip,
	            ' ',
	            this.props.customer.address.city
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'col-edit' },
	          _react2.default.createElement(_reactRouter.Link, { to: route, className: 'pen-link' })
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'col-remove' },
	          _react2.default.createElement(_reactRouter.Link, { to: '/', className: 'remove-link', onClick: this.onDeleteClick })
	        )
	      );
	    }
	  }]);
	  return CustomerRow;
	}(_react2.default.Component);
	
	exports.default = CustomerRow;

/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Customer = undefined;
	
	var _assign = __webpack_require__(22);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _reactRouter = __webpack_require__(20);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _utils = __webpack_require__(29);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _components = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_components.GeneralError, null); /**
	                                                                           * Created by staffanrantzow on 16/03/16.
	                                                                           */
	
	var _ref2 = _react2.default.createElement(
	  'div',
	  { className: 'loader-wrapper' },
	  _react2.default.createElement(_components.Spinner, null)
	);
	
	var _ref3 = _react2.default.createElement(
	  'p',
	  { className: 'error' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ORG_NR_ERROR' })
	);
	
	var _ref4 = _react2.default.createElement(
	  'p',
	  { className: 'info' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PAYTERMS_LOW_WARNING' })
	);
	
	var _ref5 = _react2.default.createElement(
	  'p',
	  { className: 'info' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PAYTERMS_HIGH_WARNING' })
	);
	
	var _ref6 = _react2.default.createElement(_components.GeneralError, null);
	
	var _ref7 = _react2.default.createElement(
	  _reactRouter.Link,
	  { className: 'btn blue outlined', to: '/customers' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'BACK' })
	);
	
	var _ref8 = _react2.default.createElement(
	  'h2',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'EDIT_CUSTOMER' })
	);
	
	var Customer = exports.Customer = function (_React$Component) {
	  (0, _inherits3.default)(Customer, _React$Component);
	
	  function Customer(props) {
	    (0, _classCallCheck3.default)(this, Customer);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Customer.__proto__ || (0, _getPrototypeOf2.default)(Customer)).call(this, props));
	
	    _this.state = {
	      name: '',
	      showErrorWithoutBlur: false,
	      posting: false,
	      fetching: true,
	      fetchError: false,
	      postError: false,
	      customer: null,
	      customerUpdated: false,
	      countryOrgNumError: false,
	      pendingRequestGetById: null
	    };
	
	    _this.newValueFromChild = _this.newValueFromChild.bind(_this);
	    _this.clickSubmit = _this.clickSubmit.bind(_this);
	    _this.setCountry = _this.setCountry.bind(_this);
	    _this.setPayTerms = _this.setPayTerms.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(Customer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchCustomer();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.pendingRequestGetById) {
	        this.state.pendingRequestGetById.cancel();
	      }
	    }
	  }, {
	    key: 'fetchCustomer',
	    value: function fetchCustomer() {
	      var _this2 = this;
	
	      this.setState({
	        fetching: true
	      });
	      var pendingRequest = _frilansFinans.CustomerService.getById(this.props.params.id);
	      pendingRequest.promise.then(function (response) {
	        return _this2.handleResponse(response);
	      }).catch(function () {
	        return _this2.handleError();
	      });
	
	      this.setState({
	        pendingRequestGetById: pendingRequest
	      });
	    }
	  }, {
	    key: 'handleError',
	    value: function handleError(error) {
	      if (error.response !== undefined) {
	        this.setState({
	          fetchError: true
	        });
	      }
	    }
	  }, {
	    key: 'handleResponse',
	    value: function handleResponse(data) {
	      this.setState({
	        customer: _utils2.default.getInputValueObjects(data),
	        name: data.name,
	        fetching: false
	      });
	    }
	  }, {
	    key: 'setCountry',
	    value: function setCountry(country) {
	      this.newValueFromChild('country', { value: country, valid: true });
	      this.validateCountryOrgnr();
	    }
	  }, {
	    key: 'setPayTerms',
	    value: function setPayTerms(payTerms) {
	      this.newValueFromChild('payTerms', { value: payTerms, valid: true });
	    }
	  }, {
	    key: 'newValueFromChild',
	    value: function newValueFromChild(name, values) {
	      var tempFormValues = this.state.customer;
	
	      (0, _assign2.default)(tempFormValues[name], values);
	      this.setState({ customer: tempFormValues });
	    }
	  }, {
	    key: 'submitForm',
	    value: function submitForm() {
	      var _this3 = this;
	
	      var params = _utils2.default.getPostParams(this.state.customer);
	
	      this.setState({
	        posting: true,
	        customerUpdated: false,
	        postError: false
	      });
	
	      _frilansFinans.CustomerService.updateBillingEmails(params.id, params).then(function () {
	        _frilansFinans.CustomerService.update(params.id, params).then(function (customer) {
	          _this3.handleResponse(customer);
	
	          _this3.setState({
	            posting: false,
	            name: customer.name,
	            customerUpdated: true,
	            postError: false
	          });
	        }, function () {
	          _this3.setState({
	            posting: false,
	            customerUpdated: false,
	            postError: true
	          });
	        });
	      });
	    }
	
	    /**
	     * If country isn't Sweden a Org number is required
	     * @returns {boolean}
	     */
	
	  }, {
	    key: 'validateCountryOrgnr',
	    value: function validateCountryOrgnr() {
	      var countryOrgNumInvalid = this.state.customer.country.value !== 'SWEDEN' && this.state.customer.vatNr.value === '';
	
	      this.setState({
	        countryOrgNumError: countryOrgNumInvalid
	      });
	
	      return !countryOrgNumInvalid;
	    }
	  }, {
	    key: 'clickSubmit',
	    value: function clickSubmit(e) {
	      var _this4 = this;
	
	      e.preventDefault();
	
	      this.setState({ showErrorWithoutBlur: true }, function () {
	        if (_utils2.default.validateInputValues(_this4.state.customer) && _this4.validateCountryOrgnr()) {
	          _this4.submitForm();
	        }
	      });
	    }
	  }, {
	    key: 'getContent',
	    value: function getContent() {
	      if (this.state.fetchError) {
	        return _ref;
	      } else if (this.state.fetching) {
	        return this.renderLoader();
	      }
	
	      return this.renderForm();
	    }
	  }, {
	    key: 'renderLoader',
	    value: function renderLoader() {
	      return _ref2;
	    }
	  }, {
	    key: 'renderPostSuccess',
	    value: function renderPostSuccess() {
	      return _react2.default.createElement(
	        'p',
	        { className: 'info' },
	        _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CUSTOMER_UPDATED', name: this.state.name })
	      );
	    }
	  }, {
	    key: 'renderCountryOrgNumberError',
	    value: function renderCountryOrgNumberError() {
	      if (this.state.countryOrgNumError) {
	        return _ref3;
	      }
	    }
	  }, {
	    key: 'renderPayTermsMessage',
	    value: function renderPayTermsMessage() {
	      if (parseInt(this.state.customer.payTerms.value) < 30) {
	        return _ref4;
	      }
	      if (parseInt(this.state.customer.payTerms.value) > 30) {
	        return _ref5;
	      }
	    }
	  }, {
	    key: 'renderForm',
	    value: function renderForm() {
	      var postError, customerUpdated, disableVatInput;
	
	      postError = this.state.postError ? _ref6 : false;
	      customerUpdated = this.state.customerUpdated ? this.renderPostSuccess() : false;
	      disableVatInput = this.state.customer.vatNr.value.length > 0 ? 'true' : 'false';
	
	      return _react2.default.createElement(
	        'form',
	        { action: '' },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-row' },
	          _react2.default.createElement(_components.InputField, { type: 'text', name: 'name', value: this.state.customer.name.value,
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('NAME'), callback: this.newValueFromChild,
	            required: 'true', minLength: '3', errorMessage: (0, _proxyCounterpart.proxyCounterpart)('NAME_ERROR'),
	            showErrorWithoutBlur: this.state.showErrorWithoutBlur }),
	          _react2.default.createElement(_components.InputField, { type: 'text', name: 'contact', value: this.state.customer.contact.value,
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('REF'), callback: this.newValueFromChild,
	            required: 'true', minLength: '0', maxLength: '30', errorMessage: (0, _proxyCounterpart.proxyCounterpart)('REF_ERROR'),
	            showErrorWithoutBlur: this.state.showErrorWithoutBlur })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-row' },
	          _react2.default.createElement(_components.InputField, { type: 'tel', name: 'vatNr', value: this.state.customer.vatNr.value,
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('ORG_NR'), callback: this.newValueFromChild,
	            required: 'true', minLength: '0', errorMessage: (0, _proxyCounterpart.proxyCounterpart)('ORG_NR_ERROR'),
	            showErrorWithoutBlur: this.state.showErrorWithoutBlur, disabled: disableVatInput }),
	          _react2.default.createElement(_components.InputField, { type: 'text', name: 'co', value: this.state.customer.co.value,
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('CO'), callback: this.newValueFromChild,
	            required: 'true', minLength: '0', errorMessage: (0, _proxyCounterpart.proxyCounterpart)('CO_ERROR'),
	            showErrorWithoutBlur: this.state.showErrorWithoutBlur })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-row' },
	          _react2.default.createElement(_components.InputField, { type: 'text', name: 'street', value: this.state.customer.street.value,
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('ADDRESS'), callback: this.newValueFromChild,
	            required: 'true', minLength: '3', errorMessage: (0, _proxyCounterpart.proxyCounterpart)('ADDRESS_ERROR'),
	            showErrorWithoutBlur: this.state.showErrorWithoutBlur }),
	          _react2.default.createElement(_components.InputField, { type: 'text', name: 'zip', value: this.state.customer.zip.value,
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('POSTAL_CODE'), callback: this.newValueFromChild,
	            required: 'true', minLength: '3', errorMessage: (0, _proxyCounterpart.proxyCounterpart)('POSTAL_CODE_ERROR'),
	            showErrorWithoutBlur: this.state.showErrorWithoutBlur })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-row' },
	          _react2.default.createElement(_components.InputField, { type: 'text', name: 'city', value: this.state.customer.city.value,
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('CITY'), callback: this.newValueFromChild,
	            required: 'true', minLength: '2', maxLength: '40', errorMessage: (0, _proxyCounterpart.proxyCounterpart)('CITY_ERROR'),
	            showErrorWithoutBlur: this.state.showErrorWithoutBlur }),
	          _react2.default.createElement(_components.CountryPicker, {
	            setCountry: this.setCountry,
	            countryName: this.state.customer.country.value,
	            showErrorWithoutBlur: this.state.showErrorWithoutBlur
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-row' },
	          _react2.default.createElement(_components.InputField, { type: 'email', name: 'sendToEmail', value: this.state.customer.sendToEmail.value,
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('EMAIL_BILLING'), callback: this.newValueFromChild,
	            required: 'true', minLength: '0', errorMessage: (0, _proxyCounterpart.proxyCounterpart)('EMAIL_ERROR'),
	            showErrorWithoutBlur: this.state.showErrorWithoutBlur }),
	          _react2.default.createElement(_components.InputField, { type: 'email', name: 'sendToEmailSecondary', value: this.state.customer.sendToEmailSecondary.value,
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('EMAIL_BILLING_SECONDARY'), callback: this.newValueFromChild,
	            required: 'true', minLength: '0', errorMessage: (0, _proxyCounterpart.proxyCounterpart)('EMAIL_ERROR'),
	            showErrorWithoutBlur: this.state.showErrorWithoutBlur })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-row' },
	          _react2.default.createElement(_components.InputField, { type: 'text', name: 'phone', value: this.state.customer.phone.value,
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('TELEPHONE_NR'), callback: this.newValueFromChild,
	            required: 'true', minLength: '0', errorMessage: (0, _proxyCounterpart.proxyCounterpart)('TELEPHONE_ERROR'),
	            showErrorWithoutBlur: this.state.showErrorWithoutBlur }),
	          _react2.default.createElement(_components.PayTermsPicker, {
	            setPayTerms: this.setPayTerms,
	            payTerms: this.state.customer.payTerms.value,
	            renderErrorMessages: false
	          })
	        ),
	        this.renderPayTermsMessage(),
	        customerUpdated,
	        postError,
	        this.renderCountryOrgNumberError(),
	        _react2.default.createElement(
	          'div',
	          { className: 'btn-wrapper' },
	          _ref7,
	          _react2.default.createElement(_components.SpinnerButton, { text: (0, _proxyCounterpart.proxyCounterpart)('SAVE'),
	            loading: this.state.posting, classes: 'btn', callback: this.clickSubmit })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var content = this.getContent();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'customer' },
	        _ref8,
	        content
	      );
	    }
	  }]);
	  return Customer;
	}(_react2.default.Component);
	
	exports.default = Customer;

/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Customers = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _reactRedux = __webpack_require__(12);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _customerRow = __webpack_require__(863);
	
	var _customerRow2 = _interopRequireDefault(_customerRow);
	
	var _reactPaginate = __webpack_require__(623);
	
	var _reactPaginate2 = _interopRequireDefault(_reactPaginate);
	
	var _spinner = __webpack_require__(57);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _components = __webpack_require__(13);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _generalError = __webpack_require__(63);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 24/03/16.
	 */
	
	var _ref = _react2.default.createElement(_generalError.GeneralError, null);
	
	var _ref2 = _react2.default.createElement(_spinner2.default, null);
	
	var _ref3 = _react2.default.createElement('div', { className: 'overlay' });
	
	var _ref4 = _react2.default.createElement(
	  'thead',
	  null,
	  _react2.default.createElement(
	    'tr',
	    null,
	    _react2.default.createElement(
	      'th',
	      { className: 'col-customer' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CUSTOMER' })
	    ),
	    _react2.default.createElement(
	      'th',
	      { className: 'col-orgnr' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ORG_NR' })
	    ),
	    _react2.default.createElement(
	      'th',
	      { className: 'col-ref' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'REF' })
	    ),
	    _react2.default.createElement(
	      'th',
	      { className: 'col-address' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ADDRESS' })
	    ),
	    _react2.default.createElement(
	      'th',
	      { className: 'col-edit' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'EDIT' })
	    ),
	    _react2.default.createElement(
	      'th',
	      { className: 'col-edit' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'DELETE' })
	    )
	  )
	);
	
	var _ref5 = _react2.default.createElement(
	  'p',
	  { className: 'error' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'GENERAL_ERROR' })
	);
	
	var _ref6 = _react2.default.createElement(
	  'p',
	  { className: 'info' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'NO_CUSTOMERS' })
	);
	
	var _ref7 = _react2.default.createElement(
	  'a',
	  { href: '' },
	  '...'
	);
	
	var _ref8 = _react2.default.createElement(
	  'h2',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'MY_CUSTOMERS' })
	);
	
	var _ref9 = _react2.default.createElement(
	  'p',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'MY_CUSTOMERS_TEXT' })
	);
	
	var Customers = exports.Customers = function (_React$Component) {
	  (0, _inherits3.default)(Customers, _React$Component);
	
	  function Customers(props) {
	    (0, _classCallCheck3.default)(this, Customers);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Customers.__proto__ || (0, _getPrototypeOf2.default)(Customers)).call(this, props));
	
	    _this.state = {
	      customers: [],
	      fetching: true,
	      fetchError: false,
	      deleteError: false,
	      errorMessage: false,
	      contentFetched: false,
	      page: 1,
	      pageRange: 5,
	      totalPages: 1,
	      meta: {
	        totalPages: 1
	      },
	      renderConfirmModal: false,
	      customerToDelete: null,
	      pendingRequest: null
	    };
	
	    _this.handlePaginationClick = _this.handlePaginationClick.bind(_this);
	    _this.handleError = _this.handleError.bind(_this);
	    _this.onRemoveClick = _this.onRemoveClick.bind(_this);
	    _this.closeModal = _this.closeModal.bind(_this);
	    _this.fetchCustomers = _this.fetchCustomers.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(Customers, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchCustomers();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.pendingRequest) {
	        this.state.pendingRequest.cancel();
	      }
	    }
	  }, {
	    key: 'fetchCustomers',
	    value: function fetchCustomers() {
	      var _this2 = this;
	
	      var userId = +this.props.user.id;
	
	      var pendingRequest = _frilansFinans.CustomerService.get(userId, this.state.page);
	      pendingRequest.promise.then(function (response) {
	        return _this2.handleResponse(response);
	      }).catch(function (error) {
	        if (error.response !== undefined) {
	          _this2.setState({
	            fetchError: true
	          });
	        }
	      });
	
	      this.setState({
	        pendingRequest: pendingRequest
	      });
	    }
	  }, {
	    key: 'handleResponse',
	    value: function handleResponse(apiResult) {
	      this.setState({
	        fetching: false,
	        customers: apiResult.collection,
	        contentFetched: true,
	        total: apiResult.meta.total,
	        totalPages: Math.ceil(apiResult.meta.total / apiResult.meta.currentPage),
	        meta: apiResult.meta
	      });
	    }
	  }, {
	    key: 'handleError',
	    value: function handleError(error) {
	      var errors = _frilansFinans.CustomerService.getError(error);
	
	      this.setState({
	        fetching: false,
	        deleteError: true,
	        errorMessage: errors
	      });
	    }
	  }, {
	    key: 'handlePaginationClick',
	    value: function handlePaginationClick(data) {
	      this.setState({
	        page: data.selected + 1,
	        fetching: true
	      }, this.fetchCustomers.bind(this));
	    }
	  }, {
	    key: 'onRemoveClick',
	    value: function onRemoveClick(customer) {
	      this.setState({
	        renderConfirmModal: true,
	        customerToDelete: customer
	      });
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal(confirm) {
	      if (confirm) {
	        _frilansFinans.CustomerService.delete(this.state.customerToDelete.id).then(this.fetchCustomers).catch(this.handleError);
	
	        this.setState({
	          fetching: true,
	          renderConfirmModal: false,
	          customerToDelete: null
	        });
	      } else {
	        this.setState({
	          renderConfirmModal: false,
	          customerToDelete: null
	        });
	      }
	    }
	  }, {
	    key: 'renderError',
	    value: function renderError() {
	      if (this.state.deleteError) {
	        if (!this.state.errorMessage) {
	          return _ref;
	        } else {
	          return _react2.default.createElement(
	            'div',
	            null,
	            this.state.errorMessage.map(function (error, i) {
	              return _react2.default.createElement(
	                'p',
	                { className: 'error', key: i },
	                error
	              );
	            })
	          );
	        }
	      }
	    }
	  }, {
	    key: 'renderConfirmModal',
	    value: function renderConfirmModal() {
	      if (this.state.renderConfirmModal) {
	        return _react2.default.createElement(_components.ConfirmModal, {
	          callback: this.closeModal,
	          message: (0, _proxyCounterpart.proxyCounterpart)('DELETE_CUSTOMER', { name: this.state.customerToDelete.name })
	        });
	      }
	    }
	  }, {
	    key: 'renderLoader',
	    value: function renderLoader() {
	      var tableContent, classes;
	
	      tableContent = this.state.contentFetched ? this.renderTable() : false;
	      classes = this.state.contentFetched ? 'loader-wrapper absolute' : 'loader-wrapper';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'table-loading' },
	        _react2.default.createElement(
	          'div',
	          { className: classes },
	          _ref2
	        ),
	        tableContent,
	        _ref3
	      );
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var onRemoveClick = this.onRemoveClick;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'table-wrapper mobile-full-width-table' },
	        _react2.default.createElement(
	          'table',
	          { className: 'standard-table' },
	          _ref4,
	          _react2.default.createElement(
	            'tbody',
	            null,
	            this.state.customers.map(function (customer, i) {
	              return _react2.default.createElement(_customerRow2.default, { customer: customer, remove: onRemoveClick, key: i });
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderFetchError',
	    value: function renderFetchError() {
	      return _ref5;
	    }
	  }, {
	    key: 'renderNoResult',
	    value: function renderNoResult() {
	      return _ref6;
	    }
	  }, {
	    key: 'renderPagination',
	    value: function renderPagination() {
	      if (this.state.contentFetched && this.state.meta.totalPages > 1) {
	        return _react2.default.createElement(_reactPaginate2.default, {
	          breakLabel: _ref7,
	          pageNum: this.state.meta.totalPages,
	          marginPagesDisplayed: 3,
	          pageRangeDisplayed: this.state.pageRange,
	          clickCallback: this.handlePaginationClick,
	          subContainerClassName: 'pages pagination',
	          activeClassName: 'active',
	          previousLabel: '',
	          nextLabel: '',
	          containerClassName: 'pagination' });
	      }
	
	      return false;
	    }
	  }, {
	    key: 'getContent',
	    value: function getContent() {
	      if (this.state.fetchError) {
	        return this.renderFetchError();
	      }
	      if (this.state.fetching) {
	        return this.renderLoader();
	      }
	      if (this.state.customers.length === 0 && this.state.contentFetched) {
	        return this.renderNoResult();
	      } else {
	        return this.renderTable();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var content = this.getContent();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'customers' },
	        _ref8,
	        _ref9,
	        content,
	        this.renderError(),
	        this.renderPagination(),
	        this.renderConfirmModal()
	      );
	    }
	  }]);
	  return Customers;
	}(_react2.default.Component);
	
	function mapStateToProps(state) {
	  return {
	    user: state.user
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Customers);

/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AgreementHtml = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(13);
	
	var _agreementService = __webpack_require__(343);
	
	var _agreementService2 = _interopRequireDefault(_agreementService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 22/09/16.
	 */
	
	var _ref = _react2.default.createElement(_components.GeneralError, null);
	
	var _ref2 = _react2.default.createElement(_components.Spinner, null);
	
	var _ref3 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'DOWNLOAD_AS_PDF' });
	
	var AgreementHtml = exports.AgreementHtml = function (_React$Component) {
	  (0, _inherits3.default)(AgreementHtml, _React$Component);
	
	  function AgreementHtml(props) {
	    (0, _classCallCheck3.default)(this, AgreementHtml);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (AgreementHtml.__proto__ || (0, _getPrototypeOf2.default)(AgreementHtml)).call(this, props));
	
	    _this.state = {
	      fetching: true,
	      fetchError: false,
	      agreement: null
	    };
	
	    _this.fetchAgreement();
	    return _this;
	  }
	
	  (0, _createClass3.default)(AgreementHtml, [{
	    key: 'fetchAgreement',
	    value: function fetchAgreement() {
	      if (this.props.params.id) {
	        _agreementService2.default.getById(this.props.params.id).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
	      }
	    }
	  }, {
	    key: 'handleResponse',
	    value: function handleResponse(agreement) {
	      this.setState({
	        fetching: false,
	        agreement: agreement,
	        fetchError: false
	      });
	    }
	  }, {
	    key: 'handleError',
	    value: function handleError() {
	      this.setState({
	        fetching: false,
	        fetchError: true
	      });
	    }
	  }, {
	    key: 'createMarkup',
	    value: function createMarkup(html) {
	      return { __html: html };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var button = void 0;
	
	      if (this.state.fetchError) {
	        return _ref;
	      }
	
	      if (this.state.fetching) {
	        return _ref2;
	      }
	
	      if (this.state.agreement.pdfUrl) {
	        button = _react2.default.createElement(
	          'a',
	          { href: this.state.agreement.pdfUrl, target: '_blank', className: 'btn dl-btn' },
	          _ref3
	        );
	      } else {
	        button = '';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'container agreement' },
	        button,
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-6 col-lg-push-3 col-sm-8 col-sm-push-2' },
	            _react2.default.createElement('p', { dangerouslySetInnerHTML: this.createMarkup(this.state.agreement.text) })
	          )
	        )
	      );
	    }
	  }]);
	  return AgreementHtml;
	}(_react2.default.Component);
	
	exports.default = AgreementHtml;

/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(12);
	
	var _agreementsList = __webpack_require__(868);
	
	var _agreementsList2 = _interopRequireDefault(_agreementsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    dateFilter: state.filters.dateFilter,
	    user: state.user
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(_agreementsList2.default);

/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AgreementsList = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(20);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _datepickerRange = __webpack_require__(117);
	
	var _datepickerRange2 = _interopRequireDefault(_datepickerRange);
	
	var _agreementService = __webpack_require__(343);
	
	var _agreementService2 = _interopRequireDefault(_agreementService);
	
	var _spinnerButton = __webpack_require__(97);
	
	var _spinnerButton2 = _interopRequireDefault(_spinnerButton);
	
	var _spinner = __webpack_require__(57);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _utils = __webpack_require__(29);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'p',
	  { className: 'error' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'GENERAL_ERROR' })
	); /**
	    * Created by staffanrantzow on 15/03/16.
	    */
	
	var _ref2 = _react2.default.createElement(
	  'p',
	  { className: 'info' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'NO_CONTRACTS' })
	);
	
	var _ref3 = _react2.default.createElement(
	  'div',
	  { className: 'loader-wrapper' },
	  _react2.default.createElement(_spinner2.default, null)
	);
	
	var _ref4 = _react2.default.createElement(
	  'thead',
	  null,
	  _react2.default.createElement(
	    'tr',
	    null,
	    _react2.default.createElement(
	      'th',
	      { className: 'col-contract' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CONTRACTS' })
	    ),
	    _react2.default.createElement(
	      'th',
	      { className: 'col-ordernr' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ORDER_NR' })
	    ),
	    _react2.default.createElement(
	      'th',
	      { className: 'col-created' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CREATED' })
	    ),
	    _react2.default.createElement(
	      'th',
	      { className: 'col-cond' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CONDITIONS' })
	    )
	  )
	);
	
	var _ref5 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CONTRACT_SHORT_TERM' });
	
	var _ref6 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'GENERAL_TERMS' });
	
	var _ref7 = _react2.default.createElement(
	  'h2',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CONTRACT_FF' })
	);
	
	var _ref8 = _react2.default.createElement(
	  'p',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CONTRACT_FF_TEXT' })
	);
	
	var _ref9 = _react2.default.createElement(_datepickerRange2.default, null);
	
	var AgreementsList = exports.AgreementsList = function (_React$Component) {
	  (0, _inherits3.default)(AgreementsList, _React$Component);
	
	  function AgreementsList(props) {
	    (0, _classCallCheck3.default)(this, AgreementsList);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (AgreementsList.__proto__ || (0, _getPrototypeOf2.default)(AgreementsList)).call(this, props));
	
	    _this.state = {
	      fetchingMore: false,
	      fetchingInitial: true,
	      contentFetched: false,
	      fetchError: false,
	      agreements: [],
	      meta: {
	        currentPage: 0
	      },
	      pendingRequest: null
	    };
	
	    _this.handleSuccess = _this.handleSuccess.bind(_this);
	    _this.handleError = _this.handleError.bind(_this);
	    _this.fetchAgreements = _this.fetchAgreements.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(AgreementsList, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.pendingRequest && this.state.pendingRequest.cancel) {
	        this.state.pendingRequest.cancel();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.dateFilter.startDate !== this.props.dateFilter.startDate || nextProps.dateFilter.endDate !== this.props.dateFilter.endDate) {
	        this.props = nextProps;
	
	        this.setState({
	          fetchingMore: true,
	          agreements: [],
	          fetchingInitial: true,
	          meta: {
	            currentPage: 0
	          }
	        }, this.fetchAgreements);
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchAgreements();
	    }
	  }, {
	    key: 'fetchAgreements',
	    value: function fetchAgreements() {
	      var _this2 = this;
	
	      var filter = this.props.dateFilter;
	      var page = this.state.meta.currentPage + 1;
	      var userId = this.props.user.id;
	
	      this.setState({
	        fetchingMore: true
	      }, function () {
	        var pendingRequest = _agreementService2.default.get(filter, page, userId);
	        pendingRequest.promise.then(_this2.handleSuccess).catch(_this2.handleError);
	
	        _this2.setState({
	          pendingRequest: pendingRequest
	        });
	      });
	    }
	  }, {
	    key: 'handleSuccess',
	    value: function handleSuccess(response) {
	      this.setState({
	        agreements: this.state.agreements.concat(response.collection),
	        fetchingInitial: false,
	        fetchingMore: false,
	        contentFetched: true,
	        fetchError: false,
	        meta: response.meta
	      });
	    }
	  }, {
	    key: 'handleError',
	    value: function handleError(error) {
	      if (error.response !== undefined) {
	        this.setState({
	          fetchingInitial: false,
	          contentFetched: true,
	          fetchError: true
	        });
	      }
	    }
	  }, {
	    key: 'renderError',
	    value: function renderError() {
	      return _ref;
	    }
	  }, {
	    key: 'renderNoResult',
	    value: function renderNoResult() {
	      return _ref2;
	    }
	  }, {
	    key: 'renderLoader',
	    value: function renderLoader() {
	      return _ref3;
	    }
	  }, {
	    key: 'renderTableWrapper',
	    value: function renderTableWrapper() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.renderTable(),
	        this.renderShowMoreBtn()
	      );
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      return _react2.default.createElement(
	        'table',
	        { className: 'standard-table' },
	        _ref4,
	        _react2.default.createElement(
	          'tbody',
	          null,
	          this.state.agreements.map(this.renderTableRow)
	        )
	      );
	    }
	  }, {
	    key: 'renderTableRow',
	    value: function renderTableRow(row, i) {
	      return _react2.default.createElement(
	        'tr',
	        { key: i },
	        _react2.default.createElement(
	          'td',
	          { className: 'col-contract' },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/economy/agreements/' + row.agreement.id, className: 'pointer-link desktop' },
	            _ref5
	          ),
	          _react2.default.createElement(_reactRouter.Link, { to: '/economy/agreements/' + row.agreement.id, className: 'pointer-link mobile' })
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'col-ordernr' },
	          row.agreement.invoiceId
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'col-created' },
	          _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CREATED_DATE', date: _utils2.default.formatDate(row.agreement.createdAt) })
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'col-cond' },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/economy/agreements/' + row.condition.id, className: 'pointer-link desktop' },
	            _ref6
	          ),
	          _react2.default.createElement(_reactRouter.Link, { to: '/economy/agreements/' + row.condition.id, className: 'pointer-link mobile' })
	        )
	      );
	    }
	  }, {
	    key: 'renderShowMoreBtn',
	    value: function renderShowMoreBtn() {
	      if (this.state.meta.currentPage < this.state.meta.totalPages && !this.state.fetchingInitial) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'show-more-btn-wrapper' },
	          _react2.default.createElement(_spinnerButton2.default, { text: (0, _proxyCounterpart.proxyCounterpart)('SHOW_MORE'), graySpinner: 'true',
	            loading: this.state.fetchingMore, classes: 'btn white show-more', callback: this.fetchAgreements })
	        );
	      }
	
	      return false;
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      if (this.state.fetchError) {
	        return this.renderError();
	      }
	      if (this.state.fetchingInitial) {
	        return this.renderLoader();
	      }
	      if (this.state.agreements.length === 0 && this.state.contentFetched) {
	        return this.renderNoResult();
	      } else {
	        return this.renderTableWrapper();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'agreements-list' },
	        _ref7,
	        _ref8,
	        _ref9,
	        _react2.default.createElement(
	          'div',
	          { className: 'table-wrapper mobile-full-width-table' },
	          this.renderContent()
	        )
	      );
	    }
	  }]);
	  return AgreementsList;
	}(_react2.default.Component);
	
	exports.default = AgreementsList;

/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AgreementsWrapper = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _agreementsListContainer = __webpack_require__(867);
	
	var _agreementsListContainer2 = _interopRequireDefault(_agreementsListContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 15/03/16.
	 */
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'agreements' },
	  _react2.default.createElement(_agreementsListContainer2.default, null)
	);
	
	var AgreementsWrapper = exports.AgreementsWrapper = function (_React$Component) {
	  (0, _inherits3.default)(AgreementsWrapper, _React$Component);
	
	  function AgreementsWrapper() {
	    (0, _classCallCheck3.default)(this, AgreementsWrapper);
	    return (0, _possibleConstructorReturn3.default)(this, (AgreementsWrapper.__proto__ || (0, _getPrototypeOf2.default)(AgreementsWrapper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AgreementsWrapper, [{
	    key: 'render',
	    value: function render() {
	      return _ref;
	    }
	  }]);
	  return AgreementsWrapper;
	}(_react2.default.Component);
	
	exports.default = AgreementsWrapper;

/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EmployerCertificate = undefined;
	
	var _getIterator2 = __webpack_require__(18);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _components = __webpack_require__(13);
	
	var _store = __webpack_require__(92);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _reactRedux = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'loader-wrapper' },
	  _react2.default.createElement(_components.Spinner, null)
	); /**
	    * Created by staffanrantzow on 12/10/16.
	    */
	
	var _ref2 = _react2.default.createElement(_components.GeneralError, null);
	
	var _ref3 = _react2.default.createElement(
	  'td',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CUSTOMER' })
	);
	
	var _ref4 = _react2.default.createElement(
	  'td',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ORDER_NR' })
	);
	
	var _ref5 = _react2.default.createElement(
	  'td',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CREATED' })
	);
	
	var _ref6 = _react2.default.createElement(
	  'td',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'GROSS_SALARY' })
	);
	
	var _ref7 = _react2.default.createElement(
	  'td',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'GROSS_SALARY_H' })
	);
	
	var _ref8 = _react2.default.createElement(
	  'td',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_PAY' })
	);
	
	var _ref9 = _react2.default.createElement(_components.GeneralError, null);
	
	var _ref10 = _react2.default.createElement(
	  'p',
	  { className: 'info' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'EMP_CERT_SUCCESS' })
	);
	
	var _ref11 = _react2.default.createElement(
	  'h2',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'EMPLOYER_CERTIFICATE' })
	);
	
	var EmployerCertificate = exports.EmployerCertificate = function (_React$Component) {
	  (0, _inherits3.default)(EmployerCertificate, _React$Component);
	
	  function EmployerCertificate(props) {
	    (0, _classCallCheck3.default)(this, EmployerCertificate);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (EmployerCertificate.__proto__ || (0, _getPrototypeOf2.default)(EmployerCertificate)).call(this, props));
	
	    _this.state = {
	      invoice: null,
	      user: null,
	      fetching: true,
	      fetchError: false,
	      posting: false,
	      postError: false,
	      postSuccess: false
	    };
	
	    _this.fetchInvoice();
	
	    _this.orderEmployerCerts = _this.orderEmployerCerts.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(EmployerCertificate, [{
	    key: 'fetchInvoice',
	    value: function fetchInvoice() {
	      var _this2 = this;
	
	      _frilansFinans.InvoiceService.getById(this.props.params.id).then(function (response) {
	        _this2.setState({
	          fetchError: false,
	          fetching: false,
	          invoice: response
	        });
	      }).catch(function () {
	        _this2.setState({
	          fetchError: true,
	          fetching: false
	        });
	      });
	    }
	  }, {
	    key: 'orderEmployerCerts',
	    value: function orderEmployerCerts() {
	      _frilansFinans.EmploymentCertificateService.post([parseInt(this.state.invoice.id)]).then(this.handleSuccess.bind(this)).catch(this.handleError.bind(this));
	
	      this.setState({
	        posting: true,
	        postError: false,
	        postSuccess: false
	      });
	    }
	  }, {
	    key: 'handleSuccess',
	    value: function handleSuccess() {
	      this.setState({
	        posting: false,
	        postSuccess: true,
	        postError: false
	      });
	    }
	  }, {
	    key: 'handleError',
	    value: function handleError() {
	      this.setState({
	        posting: false,
	        postError: true,
	        postSuccess: false
	      });
	    }
	  }, {
	    key: 'renderLoader',
	    value: function renderLoader() {
	      return _ref;
	    }
	  }, {
	    key: 'renderPostError',
	    value: function renderPostError() {
	      if (this.state.postError) {
	        return _ref2;
	      }
	    }
	  }, {
	    key: 'renderCertificate',
	    value: function renderCertificate() {
	      var i = this.state.invoice;
	      var salaryGross = 0;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(i.salaries), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var userSalary = _step.value;
	
	          // TODO: FIND REASON WHY REGULAR INVOICES GET CREDITED
	          if (userSalary.userId === parseInt(this.props.user.id) && userSalary.typeId === 1 && [1, 2, 3, 4].includes(userSalary.categoryId)) {
	            salaryGross += userSalary.grossAmount;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'table',
	          { className: 'slim-table' },
	          _react2.default.createElement(
	            'tbody',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _ref3,
	              _react2.default.createElement(
	                'td',
	                null,
	                i.customer.name
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _ref4,
	              _react2.default.createElement(
	                'td',
	                null,
	                i.id
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _ref5,
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CREATED_DATE',
	                  date: _frilansFinans.Utils.formatDate(i.createdAt) })
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _ref6,
	              _react2.default.createElement(
	                'td',
	                null,
	                Math.round(salaryGross),
	                ' KR'
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _ref7,
	              _react2.default.createElement(
	                'td',
	                null,
	                Math.round(salaryGross / i.hours),
	                ' KR'
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _ref8,
	              _react2.default.createElement(
	                'td',
	                null,
	                _frilansFinans.Utils.formatDate(i.fullPaymentDateTime)
	              )
	            )
	          )
	        ),
	        this.renderPostError(),
	        _react2.default.createElement(_components.SpinnerButton, { text: (0, _proxyCounterpart.proxyCounterpart)('BACK'),
	          loading: false, classes: 'btn outlined blue back-btn', callback: _store.history.goBack }),
	        _react2.default.createElement(_components.SpinnerButton, { text: (0, _proxyCounterpart.proxyCounterpart)('ORDER_EMP_CERT'),
	          loading: this.state.posting, classes: 'btn submit-btn', callback: this.orderEmployerCerts })
	      );
	    }
	  }, {
	    key: 'getContent',
	    value: function getContent() {
	      if (this.state.fetching) {
	        return this.renderLoader();
	      }
	      if (this.state.fetchError) {
	        return _ref9;
	      }
	      if (this.state.postSuccess && !this.state.posting) {
	        return _ref10;
	      }
	
	      return this.renderCertificate();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var content = this.getContent();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'employer-certificate' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-8' },
	              _ref11,
	              content
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return EmployerCertificate;
	}(_react2.default.Component);
	
	function mapStateToProps(state) {
	  return {
	    user: state.user
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(EmployerCertificate);

/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EmployerCertificates = undefined;
	
	var _getIterator2 = __webpack_require__(18);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _stringify = __webpack_require__(166);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _reactRedux = __webpack_require__(12);
	
	var _store = __webpack_require__(92);
	
	var _spinner = __webpack_require__(57);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _spinnerButton = __webpack_require__(97);
	
	var _spinnerButton2 = _interopRequireDefault(_spinnerButton);
	
	var _generalError = __webpack_require__(63);
	
	var _generalError2 = _interopRequireDefault(_generalError);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _datepickerRange = __webpack_require__(117);
	
	var _datepickerRange2 = _interopRequireDefault(_datepickerRange);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/jsx-no-bind */
	/**
	 * Created by staffanrantzow on 15/03/16.
	 */
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'loader-wrapper' },
	  _react2.default.createElement(_spinner2.default, null)
	);
	
	var _ref2 = _react2.default.createElement(
	  'p',
	  { className: 'info' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'NO_EMPLOYER_CERTIFICATES' })
	);
	
	var _ref3 = _react2.default.createElement(_generalError2.default, null);
	
	var _ref4 = _react2.default.createElement(
	  'p',
	  { className: 'info' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'EMP_CERT_SUCCESS' })
	);
	
	var _ref5 = _react2.default.createElement('span', null);
	
	var _ref6 = _react2.default.createElement(
	  'label',
	  { htmlFor: 'check-all' },
	  _react2.default.createElement('span', null)
	);
	
	var _ref7 = _react2.default.createElement(
	  'th',
	  { className: 'col-ordernr' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ORDER_NR' })
	);
	
	var _ref8 = _react2.default.createElement(
	  'th',
	  { className: 'col-customer' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CUSTOMER' })
	);
	
	var _ref9 = _react2.default.createElement(
	  'th',
	  { className: 'col-created' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'WORK_PERIOD' })
	);
	
	var _ref10 = _react2.default.createElement(
	  'th',
	  { className: 'col-gross-h' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'GROSS_SALARY_H' })
	);
	
	var _ref11 = _react2.default.createElement(_generalError2.default, null);
	
	var _ref12 = _react2.default.createElement(
	  'label',
	  { htmlFor: 'date-period-type-workdates' },
	  _react2.default.createElement('span', null),
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'EMPLOYER_CERTIFICATE_PERIOD_WORKDATES' })
	);
	
	var _ref13 = _react2.default.createElement('br', null);
	
	var _ref14 = _react2.default.createElement('br', null);
	
	var _ref15 = _react2.default.createElement(
	  'label',
	  { htmlFor: 'date-period-type-invoices' },
	  _react2.default.createElement('span', null),
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'EMPLOYER_CERTIFICATE_PERIOD_INVOICES' })
	);
	
	var _ref16 = _react2.default.createElement('span', null);
	
	var _ref17 = _react2.default.createElement('br', null);
	
	var _ref18 = _react2.default.createElement('br', null);
	
	var _ref19 = _react2.default.createElement(
	  'label',
	  { htmlFor: 'order-type-mail' },
	  _react2.default.createElement('span', null),
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'EMPLOYER_CERTIFICATE_BY_MAIL' })
	);
	
	var _ref20 = _react2.default.createElement(
	  'h2',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'EMPLOYER_CERTIFICATE_CHOOSE_PERIOD' })
	);
	
	var _ref21 = _react2.default.createElement(_datepickerRange2.default, null);
	
	var _ref22 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'EMPLOYER_CERTIFICATE_CHOOSE_PERIOD' });
	
	var _ref23 = _react2.default.createElement(
	  'h2',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'EMPLOYER_CERTIFICATE_ORDERING' })
	);
	
	var _ref24 = _react2.default.createElement(
	  'p',
	  { className: 'info' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'EMPLOYER_CERTIFICATE_ORDERING' })
	);
	
	var _ref25 = _react2.default.createElement(
	  'h2',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'EMPLOYER_CERTIFICATE' })
	);
	
	var _ref26 = _react2.default.createElement(
	  'p',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'EMPLOYER_CERTIFICATE_TEXT' })
	);
	
	var _ref27 = _react2.default.createElement('br', null);
	
	var EmployerCertificates = exports.EmployerCertificates = function (_React$Component) {
	  (0, _inherits3.default)(EmployerCertificates, _React$Component);
	
	  function EmployerCertificates(props) {
	    (0, _classCallCheck3.default)(this, EmployerCertificates);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (EmployerCertificates.__proto__ || (0, _getPrototypeOf2.default)(EmployerCertificates)).call(this, props));
	
	    _this.state = {
	      fetchingInvoices: false,
	      fetchingMore: false,
	      fetchError: false,
	      posting: false,
	      postError: false,
	      postSuccess: false,
	      invoices: [],
	      selectedInvoices: [],
	      showPreview: false,
	      previewInvoice: null,
	      checkAll: false,
	      size: 25,
	      meta: {
	        currentPage: 0
	      },
	      pendingRequest: null,
	      orderType: 'web',
	      datePeriodType: 'workdates',
	      showOrderTypeSection: false
	    };
	
	    _this.fetchInvoices = _this.fetchInvoices.bind(_this);
	    _this.orderEmployerCerts = _this.orderEmployerCerts.bind(_this);
	    _this.onClick = _this.onClick.bind(_this);
	    _this.checkAll = _this.checkAll.bind(_this);
	    _this.handleSuccess = _this.handleSuccess.bind(_this);
	    _this.handleError = _this.handleError.bind(_this);
	    _this.onChangeOrderType = _this.onChangeOrderType.bind(_this);
	    _this.onChangeDatePeriodType = _this.onChangeDatePeriodType.bind(_this);
	    _this.setShowOrderTypeSection = _this.setShowOrderTypeSection.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(EmployerCertificates, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.pendingRequest && this.state.pendingRequest.cancel) {
	        this.state.pendingRequest.cancel();
	      }
	    }
	  }, {
	    key: 'rememberState',
	    value: function rememberState() {
	      this.setState({
	        posting: false,
	        postError: false,
	        postSuccess: false
	      });
	
	      localStorage.setItem('employmentCertificateSavedState', (0, _stringify2.default)(this.state));
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var rehydrate = JSON.parse(localStorage.getItem('employmentCertificateSavedState'));
	      this.setState(rehydrate);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var newStartDate = nextProps.dateFilter.startDate !== this.props.dateFilter.startDate;
	      var newEndDate = nextProps.dateFilter.endDate !== this.props.dateFilter.endDate;
	
	      if ((newStartDate || newEndDate) && this.state.datePeriodType === 'invoices') {
	        this.props = nextProps;
	
	        this.setState({
	          fetchingMore: true,
	          invoices: [],
	          selectedInvoices: [],
	          fetchingInvoices: true,
	          meta: {
	            currentPage: 0
	          }
	        }, this.fetchInvoices);
	      }
	    }
	  }, {
	    key: 'onChangeDatePeriodType',
	    value: function onChangeDatePeriodType(event) {
	      if (event.currentTarget.value === 'invoices') {
	        this.fetchInvoices();
	      }
	
	      this.setState({
	        datePeriodType: event.currentTarget.value
	      });
	    }
	  }, {
	    key: 'onChangeOrderType',
	    value: function onChangeOrderType(event) {
	      this.setState({
	        orderType: event.currentTarget.value
	      });
	    }
	  }, {
	    key: 'setShowOrderTypeSection',
	    value: function setShowOrderTypeSection(shouldShow) {
	      this.setState({
	        showOrderTypeSection: shouldShow,
	        postSuccess: false
	      });
	    }
	  }, {
	    key: 'goToSingleEmploymentCertificate',
	    value: function goToSingleEmploymentCertificate(invoiceId) {
	      this.rememberState();
	      _store.history.push('/economy/employercertificates/' + invoiceId);
	    }
	  }, {
	    key: 'fetchInvoices',
	    value: function fetchInvoices() {
	      var _this2 = this;
	
	      this.setState({
	        fetchingMore: true
	      });
	
	      var pendingRequest = _frilansFinans.InvoiceService.getForEmployerCertificates(this.props.dateFilter, this.state.meta.currentPage + 1, this.state.size);
	      pendingRequest.promise.then(this.handleResponse.bind(this)).catch(function (error) {
	        if (error.response !== undefined) {
	          _this2.setState({
	            fetchError: true
	          });
	        }
	      });
	
	      this.setState({
	        pendingRequest: pendingRequest
	      });
	    }
	  }, {
	    key: 'handleResponse',
	    value: function handleResponse(response) {
	      var selected = [];
	
	      // Store all indexes with true/false for checked
	      for (var i = 0; i < response.collection.length; i++) {
	        selected[i] = false;
	      }
	
	      this.setState({
	        fetchingMore: false,
	        fetchingInvoices: false,
	        fetchError: false,
	        invoices: this.state.invoices.concat(response.collection),
	        selectedInvoices: this.state.selectedInvoices.concat(selected),
	        meta: response.meta
	      });
	    }
	  }, {
	    key: 'checkAll',
	    value: function checkAll(e) {
	      var _this3 = this;
	
	      this.setState({
	        checkAll: !this.state.checkAll
	      }, function () {
	        var selected = _this3.state.selectedInvoices;
	        var value = _this3.state.checkAll;
	
	        // Set all checkboxes to true or false
	        for (var i = 0; i < selected.length; i++) {
	          selected[i] = value;
	        }
	
	        _this3.setState({
	          selectedInvoices: selected
	        });
	      });
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick(e) {
	      var index = e.target.value;
	      var selected = this.state.selectedInvoices;
	
	      selected[index] = !this.state.selectedInvoices[index];
	
	      this.setState({
	        selectedInvoices: selected
	      });
	    }
	  }, {
	    key: 'orderEmployerCerts',
	    value: function orderEmployerCerts() {
	      var invoices = [];
	      var request = null;
	      var _state = this.state,
	          datePeriodType = _state.datePeriodType,
	          orderType = _state.orderType,
	          posting = _state.posting;
	
	
	      if (!posting) {
	        for (var i = 0; i < this.state.selectedInvoices.length; i++) {
	          if (this.state.selectedInvoices[i]) {
	            invoices.push(parseInt(this.state.invoices[i].id));
	          }
	        }
	
	        if (datePeriodType === 'invoices' && invoices.length > 0) {
	          request = _frilansFinans.EmploymentCertificateService.createFromInvoices(invoices, orderType);
	        } else if (datePeriodType === 'workdates') {
	          var _props$dateFilter = this.props.dateFilter,
	              startDate = _props$dateFilter.startDate,
	              endDate = _props$dateFilter.endDate;
	
	
	          request = _frilansFinans.EmploymentCertificateService.createFromWorkPeriod(startDate, endDate, orderType);
	        } else {
	          return;
	        }
	
	        this.setState({
	          posting: true,
	          postError: false,
	          postSuccess: false
	        });
	
	        request.then(this.handleSuccess.bind(this)).catch(this.handleError.bind(this));
	      }
	    }
	  }, {
	    key: 'handleSuccess',
	    value: function handleSuccess() {
	      this.setState({
	        posting: false,
	        postSuccess: true,
	        postError: false
	      });
	    }
	  }, {
	    key: 'handleError',
	    value: function handleError() {
	      this.setState({
	        posting: false,
	        postError: true,
	        postSuccess: false
	      });
	    }
	  }, {
	    key: 'renderLoader',
	    value: function renderLoader() {
	      return _ref;
	    }
	  }, {
	    key: 'renderNoResult',
	    value: function renderNoResult() {
	      return _ref2;
	    }
	  }, {
	    key: 'renderPostError',
	    value: function renderPostError() {
	      if (this.state.postError) {
	        return _ref3;
	      }
	    }
	  }, {
	    key: 'renderPostSuccess',
	    value: function renderPostSuccess() {
	      if (this.state.postSuccess || this.state.posting) {
	        return _ref4;
	      }
	    }
	  }, {
	    key: 'renderRow',
	    value: function renderRow(invoice, i) {
	      var _this4 = this;
	
	      var gross = 0;
	      var payPerHour = 0;
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(invoice.salaries), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var salary = _step.value;
	
	          if (parseInt(salary.userId) === parseInt(this.props.user.id) && salary.typeId === 1 && [1, 2, 3, 4].includes(salary.categoryId)) {
	            gross += salary.grossAmount;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      if (_frilansFinans.Utils.isNumeric(invoice.hours)) {
	        payPerHour = Math.round(gross / invoice.hours);
	      }
	
	      var sortedWorkDates = invoice.invoiceDates.sort(function (date1, date2) {
	        return date1.date - date2.date;
	      });
	
	      var firstWorkDate = sortedWorkDates[0].date;
	      var lastWorkDate = sortedWorkDates[sortedWorkDates.length - 1].date;
	
	      return _react2.default.createElement(
	        'tr',
	        { className: 'employment-certificate-row', key: i },
	        _react2.default.createElement(
	          'td',
	          { className: 'col-check employment-certificate-row-checkbox' },
	          _react2.default.createElement('input', { id: 'invoice-' + invoice.id, type: 'checkbox',
	            value: i, checked: this.state.selectedInvoices[i], onClick: this.onClick,
	            onChange: function onChange(e) {},
	            name: 'invoice-' + invoice.id }),
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'invoice-' + invoice.id },
	            _ref5
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          {
	            onClick: function onClick() {
	              return _this4.goToSingleEmploymentCertificate(invoice.id);
	            },
	            className: 'col-ordernr' },
	          invoice.id
	        ),
	        _react2.default.createElement(
	          'td',
	          {
	            onClick: function onClick() {
	              return _this4.goToSingleEmploymentCertificate(invoice.id);
	            },
	            className: 'col-customer' },
	          invoice.customer.name
	        ),
	        _react2.default.createElement(
	          'td',
	          {
	            onClick: function onClick() {
	              return _this4.goToSingleEmploymentCertificate(invoice.id);
	            },
	            className: 'col-created' },
	          _frilansFinans.Utils.formatDate(firstWorkDate) + ' - ' + _frilansFinans.Utils.formatDate(lastWorkDate)
	        ),
	        _react2.default.createElement(
	          'td',
	          {
	            onClick: function onClick() {
	              return _this4.goToSingleEmploymentCertificate(invoice.id);
	            },
	            className: 'col-gross-h' },
	          payPerHour + ' ' + (0, _proxyCounterpart.proxyCounterpart)('DEFAULT_CURRENCY_NAME_SHORT_OTHER')
	        )
	      );
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'table-wrapper' },
	          _react2.default.createElement(
	            'table',
	            { className: 'standard-table' },
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  { className: 'col-check employment-certificate-row-checkbox' },
	                  _react2.default.createElement('input', { id: 'check-all', type: 'checkbox', name: 'check-all',
	                    checked: this.state.checkAll, onClick: this.checkAll }),
	                  _ref6
	                ),
	                _ref7,
	                _ref8,
	                _ref9,
	                _ref10
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              this.state.invoices.map(this.renderRow.bind(this))
	            )
	          ),
	          this.renderShowMoreBtn()
	        )
	      );
	    }
	  }, {
	    key: 'renderTableWrapper',
	    value: function renderTableWrapper() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.renderTable()
	      );
	    }
	  }, {
	    key: 'renderNextButton',
	    value: function renderNextButton() {
	      var _this5 = this;
	
	      var noSelectedInvoices = this.state.datePeriodType === 'invoices' && !this.state.selectedInvoices.some(function (inv) {
	        return !!inv;
	      });
	
	      return _react2.default.createElement(_spinnerButton2.default, { text: (0, _proxyCounterpart.proxyCounterpart)('NEXT'),
	        disabled: noSelectedInvoices && !this.state.fetchingMore,
	        loading: this.state.fetchingMore, classes: 'btn submit-btn',
	        callback: function callback() {
	          return _this5.setShowOrderTypeSection(true);
	        } });
	    }
	  }, {
	    key: 'renderOrderButton',
	    value: function renderOrderButton() {
	      return _react2.default.createElement(_spinnerButton2.default, { text: (0, _proxyCounterpart.proxyCounterpart)('ORDER_EMP_CERT'),
	        loading: this.state.posting, classes: 'btn submit-btn', callback: this.orderEmployerCerts });
	    }
	  }, {
	    key: 'renderShowMoreBtn',
	    value: function renderShowMoreBtn() {
	      if (this.state.meta.currentPage < this.state.meta.totalPages && !this.state.fetchingInvoices) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'show-more-btn-wrapper' },
	          _react2.default.createElement(_spinnerButton2.default, { text: (0, _proxyCounterpart.proxyCounterpart)('SHOW_MORE'), graySpinner: 'true',
	            loading: this.state.fetchingMore, classes: 'btn white show-more', callback: this.fetchInvoices })
	        );
	      }
	
	      return false;
	    }
	  }, {
	    key: 'getContentForInvoices',
	    value: function getContentForInvoices() {
	      if (this.state.datePeriodType === 'invoices') {
	        if (this.state.fetchError) {
	          return _ref11;
	        }
	        if (this.state.fetchingInvoices) {
	          return this.renderLoader();
	        }
	        if (this.state.invoices.length === 0) {
	          return this.renderNoResult();
	        }
	
	        return this.renderTableWrapper();
	      }
	    }
	  }, {
	    key: 'renderDatePeriodCheckboxes',
	    value: function renderDatePeriodCheckboxes() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'date-period-type-input' },
	        _react2.default.createElement('input', { id: 'date-period-type-workdates', name: 'date-period-type', type: 'radio', value: 'workdates',
	          checked: this.state.datePeriodType === 'workdates',
	          onChange: this.onChangeDatePeriodType }),
	        _ref12,
	        _ref13,
	        _ref14,
	        _react2.default.createElement('input', { id: 'date-period-type-invoices', name: 'date-period-type', type: 'radio', value: 'invoices',
	          checked: this.state.datePeriodType === 'invoices',
	          onChange: this.onChangeDatePeriodType }),
	        _ref15
	      );
	    }
	  }, {
	    key: 'renderOrderCheckboxes',
	    value: function renderOrderCheckboxes() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'order-type-input' },
	        _react2.default.createElement('input', { id: 'order-type-web', name: 'order-type-web', type: 'radio', value: 'web',
	          checked: this.state.orderType === 'web',
	          onChange: this.onChangeOrderType }),
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'order-type-web' },
	          _ref16,
	          _react2.default.createElement('span', {
	            dangerouslySetInnerHTML: { __html: (0, _proxyCounterpart.proxyCounterpart)('EMPLOYER_CERTIFICATE_BY_AI_NU') } })
	        ),
	        _ref17,
	        _ref18,
	        _react2.default.createElement('input', { id: 'order-type-mail', name: 'order-type-mail', type: 'radio', value: 'mail',
	          checked: this.state.orderType === 'mail',
	          onChange: this.onChangeOrderType }),
	        _ref19
	      );
	    }
	  }, {
	    key: 'renderDatePeriodSection',
	    value: function renderDatePeriodSection() {
	      var _this6 = this;
	
	      if (!this.state.postSuccess && !this.state.posting) {
	        if (!this.state.showOrderTypeSection) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _ref20,
	            _ref21,
	            this.renderDatePeriodCheckboxes(),
	            this.getContentForInvoices(),
	            this.renderNextButton()
	          );
	        } else {
	          return _react2.default.createElement(
	            'h2',
	            { className: 'clickable-header', onClick: function onClick() {
	                return _this6.setShowOrderTypeSection(false);
	              } },
	            _ref22,
	            ' - \u2713'
	          );
	        }
	      }
	    }
	  }, {
	    key: 'renderOrderSection',
	    value: function renderOrderSection() {
	      if (!this.state.postSuccess && !this.state.posting) {
	        if (this.state.showOrderTypeSection) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _ref23,
	            this.renderOrderCheckboxes(),
	            this.renderOrderButton()
	          );
	        } else {
	          return _ref24;
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'employer-certificate' },
	        _ref25,
	        _ref26,
	        _ref27,
	        this.renderDatePeriodSection(),
	        this.renderOrderSection(),
	        this.renderPostError(),
	        this.renderPostSuccess()
	      );
	    }
	  }]);
	  return EmployerCertificates;
	}(_react2.default.Component);
	
	function mapStateToProps(state) {
	  return {
	    dateFilter: state.filters.dateFilter,
	    user: state.user
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(EmployerCertificates);

/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IncomeStatements = undefined;
	
	var _extends2 = __webpack_require__(27);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getIterator2 = __webpack_require__(18);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _spinner = __webpack_require__(57);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _generalError = __webpack_require__(63);
	
	var _generalError2 = _interopRequireDefault(_generalError);
	
	var _frilansFinans = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 15/03/16.
	 */
	
	var _ref = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'DOWNLOAD' });
	
	var _ref2 = _react2.default.createElement(_generalError2.default, null);
	
	var _ref3 = _react2.default.createElement(
	  'div',
	  { className: 'loader-wrapper' },
	  _react2.default.createElement(_spinner2.default, null)
	);
	
	var _ref4 = _react2.default.createElement(
	  'h2',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'YOUR_CONTROL_STATEMENT' })
	);
	
	var _ref5 = _react2.default.createElement(
	  'p',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'YOUR_CONTROL_STATEMENT_TEXT' })
	);
	
	var IncomeStatements = exports.IncomeStatements = function (_React$Component) {
	  (0, _inherits3.default)(IncomeStatements, _React$Component);
	
	  function IncomeStatements(props, context) {
	    (0, _classCallCheck3.default)(this, IncomeStatements);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (IncomeStatements.__proto__ || (0, _getPrototypeOf2.default)(IncomeStatements)).call(this, props, context));
	
	    _this.state = {
	      selectValue: '0',
	      fetching: true,
	      fetched: false,
	      fetchError: false,
	      statements: [],
	      pendingRequest: null
	    };
	
	    _this.setYear = _this.setYear.bind(_this);
	    _this.downloadYear = _this.downloadYear.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(IncomeStatements, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchStatements();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.pendingRequest && this.state.pendingRequest.cancel) {
	        this.state.pendingRequest.cancel();
	      }
	    }
	  }, {
	    key: 'fetchStatements',
	    value: function fetchStatements() {
	      var _this2 = this;
	
	      this.setState({
	        fetching: true
	      }, function () {
	        var pendingRequest = _frilansFinans.IncomeStatementService.getIncomeStatements(_this2.context.user.id);
	        pendingRequest.promise.then(_this2.handleResponse.bind(_this2)).catch(_this2.handleError.bind(_this2));
	
	        _this2.setState({
	          pendingRequest: pendingRequest
	        });
	      });
	    }
	  }, {
	    key: 'handleResponse',
	    value: function handleResponse(response) {
	      var statements = response;
	
	      if (statements.length === 0) {
	        statements.push({
	          disabled: true,
	          name: (0, _proxyCounterpart.proxyCounterpart)('NO_STATEMENTS'),
	          value: '0'
	        });
	      } else {
	        statements.unshift({
	          disabled: true,
	          name: (0, _proxyCounterpart.proxyCounterpart)('CHOOSE_INCOME_YEAR'),
	          value: '0'
	        });
	      }
	
	      this.setState({
	        fetching: false,
	        fetched: true,
	        fetchError: false,
	        statements: statements
	      });
	    }
	  }, {
	    key: 'handleError',
	    value: function handleError(error) {
	      if (error.response !== undefined) {
	        this.setState({
	          fetching: false,
	          fetched: true,
	          fetchError: true
	        });
	      }
	    }
	  }, {
	    key: 'setYear',
	    value: function setYear(e) {
	      this.setState({
	        selectValue: e.target.value
	      });
	    }
	  }, {
	    key: 'downloadYear',
	    value: function downloadYear() {
	      if (this.state.selectValue !== '0') {
	        var statement = null;
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(this.state.statements), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var s = _step.value;
	
	            if (s.id === this.state.selectValue) {
	              statement = s;
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        if (statement) {
	          window.open(statement.url);
	        }
	      }
	    }
	  }, {
	    key: 'renderOption',
	    value: function renderOption(statement, i) {
	      return _react2.default.createElement(
	        'option',
	        { disabled: statement.disabled, value: statement.value, key: i },
	        statement.name
	      );
	    }
	  }, {
	    key: 'renderDropDown',
	    value: function renderDropDown() {
	      var options = {};
	
	      if (this.state.statements.length <= 1) {
	        options['disabled'] = 'disabled';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'select-btn-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'styled-select' },
	          _react2.default.createElement(
	            'select',
	            (0, _extends3.default)({ value: this.state.selectValue, onChange: this.setYear }, options),
	            this.state.statements.map(this.renderOption)
	          )
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'btn download-btn', onClick: this.downloadYear },
	          _ref
	        )
	      );
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      if (this.state.fetchError) {
	        return _ref2;
	      }
	      if (this.state.fetching) {
	        return _ref3;
	      }
	
	      if (this.state.fetched) {
	        return this.renderDropDown();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'contract-picker' },
	        _ref4,
	        _ref5,
	        this.renderContent()
	      );
	    }
	  }]);
	  return IncomeStatements;
	}(_react2.default.Component);
	
	IncomeStatements.contextTypes = {
	  user: _react.PropTypes.object.isRequired
	};
	exports.default = IncomeStatements;

/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InvoiceWrapper = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _datepickerRange = __webpack_require__(117);
	
	var _datepickerRange2 = _interopRequireDefault(_datepickerRange);
	
	var _invoices = __webpack_require__(875);
	
	var _invoices2 = _interopRequireDefault(_invoices);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 15/03/16.
	 */
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'invoices-wrapper' },
	  _react2.default.createElement(
	    'h2',
	    null,
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'YOUR_INVOICES' })
	  ),
	  _react2.default.createElement(
	    'p',
	    null,
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'YOUR_INVOICES_TEXT' })
	  ),
	  _react2.default.createElement(_datepickerRange2.default, null),
	  _react2.default.createElement(_invoices2.default, null)
	);
	
	var InvoiceWrapper = exports.InvoiceWrapper = function (_React$Component) {
	  (0, _inherits3.default)(InvoiceWrapper, _React$Component);
	
	  function InvoiceWrapper() {
	    (0, _classCallCheck3.default)(this, InvoiceWrapper);
	    return (0, _possibleConstructorReturn3.default)(this, (InvoiceWrapper.__proto__ || (0, _getPrototypeOf2.default)(InvoiceWrapper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(InvoiceWrapper, [{
	    key: 'render',
	    value: function render() {
	      return _ref;
	    }
	  }]);
	  return InvoiceWrapper;
	}(_react2.default.Component);
	
	exports.default = InvoiceWrapper;

/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Invoice = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _axios = __webpack_require__(17);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _invoicing = __webpack_require__(334);
	
	var _invoicing2 = _interopRequireDefault(_invoicing);
	
	var _specification = __webpack_require__(336);
	
	var _specification2 = _interopRequireDefault(_specification);
	
	var _dates = __webpack_require__(333);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _amount = __webpack_require__(332);
	
	var _amount2 = _interopRequireDefault(_amount);
	
	var _outlays = __webpack_require__(335);
	
	var _outlays2 = _interopRequireDefault(_outlays);
	
	var _workers = __webpack_require__(703);
	
	var _workers2 = _interopRequireDefault(_workers);
	
	var _rewards = __webpack_require__(701);
	
	var _rewards2 = _interopRequireDefault(_rewards);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'DOWNLOAD_AS_PDF' });
	
	var _ref2 = _react2.default.createElement('div', null);
	
	var Invoice = exports.Invoice = function (_React$Component) {
	  (0, _inherits3.default)(Invoice, _React$Component);
	
	  function Invoice(props, context) {
	    (0, _classCallCheck3.default)(this, Invoice);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Invoice.__proto__ || (0, _getPrototypeOf2.default)(Invoice)).call(this, props, context));
	
	    _this.state = {
	      invoice: null,
	      outlays: [],
	      user: context.user,
	      fetching: true,
	      fetchError: false
	    };
	
	    _this.fetchData = _this.fetchData.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(Invoice, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: 'fetchData',
	    value: function fetchData() {
	      var _this2 = this;
	
	      _axios2.default.all([_frilansFinans.InvoiceService.getById(this.props.params.id), _frilansFinans.InvoiceService.getSupplierLedgersForInvoice(this.props.params.id)]).then(_axios2.default.spread(this.handleAPIResponse.bind(this))).catch(function () {
	        _this2.setState({
	          fetching: false,
	          fetchError: true
	        });
	      });
	    }
	  }, {
	    key: 'handleAPIResponse',
	    value: function handleAPIResponse(invoice, outlays) {
	      this.setState({
	        invoice: invoice,
	        outlays: outlays,
	        fetching: false,
	        fetchError: false
	      });
	    }
	  }, {
	    key: 'renderPDFButton',
	    value: function renderPDFButton() {
	      if (this.state.invoice && this.state.invoice.pdfLink) {
	        return _react2.default.createElement(
	          'a',
	          { href: this.state.invoice.pdfLink, target: '_blank', className: 'btn' },
	          _ref
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.state.fetching && this.state.invoice) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'invoice-details-container' },
	          _react2.default.createElement(_invoicing2.default, {
	            invoice: this.state.invoice,
	            user: this.context.user
	          }),
	          _react2.default.createElement(_specification2.default, { invoice: this.state.invoice }),
	          _react2.default.createElement(_dates2.default, { invoice: this.state.invoice }),
	          _react2.default.createElement(_amount2.default, { invoice: this.state.invoice }),
	          _react2.default.createElement(_outlays2.default, {
	            outlays: this.state.outlays,
	            showDetailColumns: true
	          }),
	          _react2.default.createElement(_workers2.default, {
	            invoice: this.state.invoice,
	            outlays: this.state.outlays,
	            user: this.state.user
	          }),
	          _react2.default.createElement(_rewards2.default, { invoice: this.state.invoice }),
	          this.renderPDFButton()
	        );
	      }
	      return _ref2;
	    }
	  }]);
	  return Invoice;
	}(_react2.default.Component);
	
	Invoice.contextTypes = {
	  user: _react.PropTypes.object.isRequired,
	  router: _react.PropTypes.object.isRequired
	};
	exports.default = Invoice;

/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Invoices = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _reactRedux = __webpack_require__(12);
	
	var _index = __webpack_require__(368);
	
	var _spinner = __webpack_require__(57);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _spinnerButton = __webpack_require__(97);
	
	var _spinnerButton2 = _interopRequireDefault(_spinnerButton);
	
	var _generalError = __webpack_require__(63);
	
	var _generalError2 = _interopRequireDefault(_generalError);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _invoicesTable = __webpack_require__(877);
	
	var _invoicesTable2 = _interopRequireDefault(_invoicesTable);
	
	var _components = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'loader-wrapper' },
	  _react2.default.createElement(_spinner2.default, null)
	); /**
	    * Created by staffanrantzow on 15/03/16.
	    */
	
	var _ref2 = _react2.default.createElement(
	  'p',
	  { className: 'info' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'NO_INVOICES' })
	);
	
	var _ref3 = _react2.default.createElement(_generalError2.default, null);
	
	var Invoices = exports.Invoices = function (_React$Component) {
	  (0, _inherits3.default)(Invoices, _React$Component);
	
	  function Invoices(props) {
	    (0, _classCallCheck3.default)(this, Invoices);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Invoices.__proto__ || (0, _getPrototypeOf2.default)(Invoices)).call(this, props));
	
	    _this.state = {
	      fetchingInitial: true,
	      fetchingMore: false,
	      fetchError: false,
	      invoices: [],
	      showPreview: false,
	      previewInvoice: null,
	      defaultSize: 10,
	      size: 10,
	      meta: {
	        currentPage: 0
	      },
	      pendingRequest: null,
	      renderConfirmModal: false,
	      invoiceToDelete: null
	    };
	
	    _this.fetchInvoices = _this.fetchInvoices.bind(_this);
	    _this.deleteInvoice = _this.deleteInvoice.bind(_this);
	    _this.closeModal = _this.closeModal.bind(_this);
	    _this.fetchInvoicesAgain = _this.fetchInvoicesAgain.bind(_this);
	    _this.removeInvoiceFromState = _this.removeInvoiceFromState.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(Invoices, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.pendingRequest && this.state.pendingRequest.cancel) {
	        this.state.pendingRequest.cancel();
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchInvoices();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.dateFilter.startDate !== this.props.dateFilter.startDate || nextProps.dateFilter.endDate !== this.props.dateFilter.endDate) {
	        this.props = nextProps;
	
	        this.fetchInvoicesAgain();
	      }
	    }
	  }, {
	    key: 'fetchInvoices',
	    value: function fetchInvoices() {
	      var _this2 = this;
	
	      this.setState({
	        fetchingMore: true
	      });
	
	      var userId = +this.props.user.id;
	
	      var pendingRequest = _frilansFinans.InvoiceService.get(userId, this.props.dateFilter, this.state.meta.currentPage + 1, 0, null, this.state.size);
	
	      pendingRequest.promise.then(this.handleResponse.bind(this)).catch(function (error) {
	        if (error.response !== undefined) {
	          _this2.setState({
	            fetchError: true
	          });
	        }
	      });
	
	      this.setState({
	        pendingRequest: pendingRequest
	      });
	    }
	  }, {
	    key: 'fetchInvoicesAgain',
	    value: function fetchInvoicesAgain() {
	      this.setState({
	        fetchingMore: true,
	        invoices: [],
	        fetchingInitial: true,
	        meta: {
	          currentPage: 0
	        }
	      }, this.fetchInvoices);
	    }
	  }, {
	    key: 'handleResponse',
	    value: function handleResponse(response) {
	      this.setState({
	        fetchingMore: false,
	        fetchingInitial: false,
	        fetchError: false,
	        invoiceServiceGet: null,
	        size: this.state.defaultSize,
	        invoices: this.state.invoices.concat(response.collection),
	        meta: response.meta
	      }, this.scrollDown);
	    }
	  }, {
	    key: 'removeInvoiceFromState',
	    value: function removeInvoiceFromState(id) {
	      this.setState({
	        invoices: this.state.invoices.filter(function (invoice) {
	          return invoice.id !== id;
	        })
	      });
	    }
	  }, {
	    key: 'deleteInvoice',
	    value: function deleteInvoice(invoice) {
	      this.setState({
	        renderConfirmModal: true,
	        invoiceToDelete: invoice
	      });
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal(confirm) {
	      var _this3 = this;
	
	      if (confirm) {
	        _frilansFinans.InvoiceService.delete(this.state.invoiceToDelete.id).then(this.removeInvoiceFromState(this.state.invoiceToDelete.id)).catch(function () {
	          _this3.setState({
	            fetchError: true
	          });
	        });
	
	        this.setState({
	          renderConfirmModal: false,
	          invoiceToDelete: null
	        });
	      } else {
	        this.setState({
	          renderConfirmModal: false,
	          invoiceToDelete: null
	        });
	      }
	    }
	  }, {
	    key: 'renderConfirmModal',
	    value: function renderConfirmModal() {
	      if (this.state.renderConfirmModal) {
	        return _react2.default.createElement(_components.ConfirmModal, {
	          callback: this.closeModal,
	          message: (0, _proxyCounterpart.proxyCounterpart)('DELETE_INVOICE')
	        });
	      }
	    }
	  }, {
	    key: 'renderLoader',
	    value: function renderLoader() {
	      return _ref;
	    }
	  }, {
	    key: 'renderNoResult',
	    value: function renderNoResult() {
	      return _ref2;
	    }
	  }, {
	    key: 'renderTableWrapper',
	    value: function renderTableWrapper() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_invoicesTable2.default, { invoices: this.state.invoices }),
	        this.renderShowMoreBtn()
	      );
	    }
	  }, {
	    key: 'renderShowMoreBtn',
	    value: function renderShowMoreBtn() {
	      if (this.state.meta.currentPage < this.state.meta.totalPages && !this.state.fetchingInitial) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'show-more-btn-wrapper' },
	          _react2.default.createElement(_spinnerButton2.default, { text: (0, _proxyCounterpart.proxyCounterpart)('SHOW_MORE'), graySpinner: 'true',
	            loading: this.state.fetchingMore, classes: 'btn white show-more', callback: this.fetchInvoices })
	        );
	      }
	
	      return false;
	    }
	  }, {
	    key: 'getContent',
	    value: function getContent() {
	      if (this.state.fetchError) {
	        return _ref3;
	      }
	      if (this.state.fetchingInitial) {
	        return this.renderLoader();
	      }
	      if (this.state.invoices.length === 0) {
	        return this.renderNoResult();
	      }
	
	      return this.renderTableWrapper();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var content = this.getContent();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'invoices' },
	        content,
	        this.renderConfirmModal()
	      );
	    }
	  }]);
	  return Invoices;
	}(_react2.default.Component);
	
	function mapStateToProps(state) {
	  return {
	    dateFilter: state.filters.dateFilter,
	    user: state.user
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    setInvoicePage: function setInvoicePage(invoice) {
	      return dispatch((0, _index.setInvoicePage)(invoice));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Invoices);

/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InvoiceRow = exports.systemCurrencyId = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(20);
	
	var _utils = __webpack_require__(29);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _ellipsis = __webpack_require__(161);
	
	var _ellipsis2 = _interopRequireDefault(_ellipsis);
	
	var _showMoreInvoice = __webpack_require__(210);
	
	var _showMoreInvoice2 = _interopRequireDefault(_showMoreInvoice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var systemCurrencyId = exports.systemCurrencyId = 1; /**
	                                                      * Created by staffanrantzow on 15/03/16.
	                                                      */
	
	var InvoiceRow = exports.InvoiceRow = function (_React$Component) {
	  (0, _inherits3.default)(InvoiceRow, _React$Component);
	
	  function InvoiceRow(props) {
	    (0, _classCallCheck3.default)(this, InvoiceRow);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (InvoiceRow.__proto__ || (0, _getPrototypeOf2.default)(InvoiceRow)).call(this, props));
	
	    _this.showMoreList = _this.showMoreList.bind(_this);
	    _this.setWrapperRef = _this.setWrapperRef.bind(_this);
	    _this.handleClickOutside = _this.handleClickOutside.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(InvoiceRow, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('mousedown', this.handleClickOutside);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('mousedown', this.handleClickOutside);
	    }
	  }, {
	    key: 'setWrapperRef',
	    value: function setWrapperRef(node) {
	      this.wrapperRef = node;
	    }
	  }, {
	    key: 'handleClickOutside',
	    value: function handleClickOutside(event) {
	      if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
	        if (this.props.showMoreList.invoiceId === this.props.invoice.id) {
	          this.props.resetShowMoreList();
	        }
	      }
	    }
	  }, {
	    key: 'showMoreList',
	    value: function showMoreList() {
	      this.props.toggleShowMoreList(this.props.invoice.id);
	    }
	  }, {
	    key: 'renderShowMore',
	    value: function renderShowMore(showMoreList, route) {
	      if (showMoreList) {
	        return _react2.default.createElement(_showMoreInvoice2.default, {
	          invoice: this.props.invoice,
	          invoiceRoute: route,
	          user: this.context.user
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var route = '/economy/invoices/' + this.props.invoice.id;
	      var showMoreList = +this.props.showMoreList.invoiceId === +this.props.invoice.id ? this.props.showMoreList.show : false;
	
	      return _react2.default.createElement(
	        'tr',
	        { className: 'invoices-table-body' },
	        _react2.default.createElement(
	          'td',
	          { className: 'invoice-table-body-column' },
	          _utils2.default.formatDate(this.props.invoice.createdAt)
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'invoice-table-body-column' },
	          _react2.default.createElement(
	            'span',
	            null,
	            this.props.invoice.customer.name
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'invoice-table-body-column hide-mobile' },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: route },
	            this.props.invoice.id
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'invoice-table-body-column' },
	          _utils2.default.amountWithCurrency(Math.round(this.props.invoice.amount), systemCurrencyId)
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'invoice-table-body-column hide-mobile' },
	          this.props.invoice.approvalStatusText
	        ),
	        _react2.default.createElement(
	          'td',
	          {
	            ref: this.setWrapperRef,
	            className: 'invoice-table-body-column more',
	            onClick: this.showMoreList
	          },
	          this.renderShowMore(showMoreList, route),
	          _react2.default.createElement(_ellipsis2.default, {
	            colorSchema: 'primary',
	            fill: showMoreList
	          })
	        )
	      );
	    }
	  }]);
	  return InvoiceRow;
	}(_react2.default.Component);
	
	InvoiceRow.contextTypes = {
	  user: _react.PropTypes.object.isRequired
	};
	exports.default = InvoiceRow;

/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InvoicesTable = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invoiceRow = __webpack_require__(876);
	
	var _invoiceRow2 = _interopRequireDefault(_invoiceRow);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'thead',
	  null,
	  _react2.default.createElement(
	    'tr',
	    { className: 'invoices-table-header' },
	    _react2.default.createElement(
	      'th',
	      { className: 'invoice-table-header-column' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICES_TABLE_TITLE_CREATED' })
	    ),
	    _react2.default.createElement(
	      'th',
	      { className: 'invoice-table-header-column' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICES_TABLE_TITLE_CUSTOMER' })
	    ),
	    _react2.default.createElement(
	      'th',
	      { className: 'invoice-table-header-column hide-mobile' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICES_TABLE_TITLE_ORDER_NUMBER' })
	    ),
	    _react2.default.createElement(
	      'th',
	      { className: 'invoice-table-header-column' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICES_TABLE_TITLE_SUM_EXCL_VAT' })
	    ),
	    _react2.default.createElement(
	      'th',
	      { className: 'invoice-table-header-column hide-mobile' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICES_TABLE_TITLE_STATUS' })
	    ),
	    _react2.default.createElement(
	      'th',
	      { className: 'invoice-table-header-column' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICES_TABLE_TITLE_MORE' })
	    )
	  )
	); /**
	    * Created by staffanrantzow on 19/04/16.
	    */
	
	var InvoicesTable = exports.InvoicesTable = function (_React$Component) {
	  (0, _inherits3.default)(InvoicesTable, _React$Component);
	
	  function InvoicesTable(props) {
	    (0, _classCallCheck3.default)(this, InvoicesTable);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (InvoicesTable.__proto__ || (0, _getPrototypeOf2.default)(InvoicesTable)).call(this, props));
	
	    _this.state = {
	      showMoreList: {
	        invoiceId: null,
	        show: false
	      }
	    };
	
	    _this.setShowMoreList = _this.setShowMoreList.bind(_this);
	    _this.resetShowMoreList = _this.resetShowMoreList.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(InvoicesTable, [{
	    key: 'setShowMoreList',
	    value: function setShowMoreList(invoiceId) {
	      var invoiceIdSet = this.state.showMoreList.invoiceId === invoiceId;
	      this.setState({
	        showMoreList: {
	          invoiceId: invoiceIdSet ? null : invoiceId,
	          show: !invoiceIdSet
	        }
	      });
	    }
	  }, {
	    key: 'resetShowMoreList',
	    value: function resetShowMoreList() {
	      this.setState({
	        showMoreList: {
	          invoiceId: null,
	          show: false
	        }
	      });
	    }
	  }, {
	    key: 'renderRow',
	    value: function renderRow(invoice, i) {
	      return _react2.default.createElement(_invoiceRow2.default, {
	        key: i,
	        invoice: invoice,
	        toggleShowMoreList: this.setShowMoreList,
	        resetShowMoreList: this.resetShowMoreList,
	        showMoreList: this.state.showMoreList
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'table',
	        { className: 'invoices-table' },
	        _ref,
	        _react2.default.createElement(
	          'tbody',
	          null,
	          this.props.invoices.map(this.renderRow.bind(this))
	        )
	      );
	    }
	  }]);
	  return InvoicesTable;
	}(_react2.default.Component);
	
	exports.default = InvoicesTable;

/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RegisterAssignment = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _registeredOrdersTable = __webpack_require__(338);
	
	var _registeredOrdersTable2 = _interopRequireDefault(_registeredOrdersTable);
	
	var _dashboardButton = __webpack_require__(326);
	
	var _dashboardButton2 = _interopRequireDefault(_dashboardButton);
	
	var _showMoreButton = __webpack_require__(879);
	
	var _showMoreButton2 = _interopRequireDefault(_showMoreButton);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'register-assignment-text-container' },
	  _react2.default.createElement(
	    'h2',
	    null,
	    _react2.default.createElement(_reactTranslateComponent2.default, { className: 'register-assignment-title', content: 'REGISTERED_ASSIGNMENTS_TITLE' })
	  ),
	  _react2.default.createElement(
	    'p',
	    null,
	    _react2.default.createElement(_reactTranslateComponent2.default, { className: 'register-assignment-text', content: 'REGISTERED_ASSIGNMENTS_TEXT' })
	  )
	);
	
	var RegisterAssignment = exports.RegisterAssignment = function (_React$Component) {
	  (0, _inherits3.default)(RegisterAssignment, _React$Component);
	
	  function RegisterAssignment() {
	    (0, _classCallCheck3.default)(this, RegisterAssignment);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (RegisterAssignment.__proto__ || (0, _getPrototypeOf2.default)(RegisterAssignment)).call(this));
	
	    _this.state = {
	      fetching: true,
	      fetchError: false,
	      invoices: [],
	      pendingRequest: null,
	      meta: {
	        count: 0,
	        currentPage: 0,
	        perPage: 0,
	        total: 0,
	        totalPages: 0
	      }
	    };
	
	    _this.fetchInvoices = _this.fetchInvoices.bind(_this);
	    _this.renderShowMoreBtn = _this.renderShowMoreBtn.bind(_this);
	    _this.removeInvoiceFromState = _this.removeInvoiceFromState.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(RegisterAssignment, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchInvoices();
	    }
	  }, {
	    key: 'fetchInvoices',
	    value: function fetchInvoices() {
	      var _this2 = this;
	
	      this.setState({
	        fetching: true
	      });
	
	      var page = +this.state.meta.currentPage + 1;
	      var userId = +this.context.user.id;
	      var pendingRequest = _frilansFinans.InvoiceService.get(userId, null, page, 1, null, 25);
	
	      pendingRequest.promise.then(this.handleResponse.bind(this)).catch(function (error) {
	        if (error.response !== undefined) {
	          _this2.setState({
	            fetchError: true
	          });
	        }
	      });
	
	      this.setState({
	        pendingRequest: pendingRequest
	      });
	    }
	  }, {
	    key: 'handleResponse',
	    value: function handleResponse(response) {
	      this.setState({
	        fetching: false,
	        fetchError: false,
	        invoices: this.state.invoices.concat(response.collection),
	        meta: response.meta
	      });
	    }
	  }, {
	    key: 'noInvoicesRow',
	    value: function noInvoicesRow() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'assignments-table-no-more-info' },
	        (0, _proxyCounterpart.proxyCounterpart)('PREREGISTERED_INVOICES_TABLE_NO_INVOICES')
	      );
	    }
	  }, {
	    key: 'noMoreInfoRow',
	    value: function noMoreInfoRow() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'assignments-table-no-more-info' },
	        (0, _proxyCounterpart.proxyCounterpart)('PREREGISTERED_INVOICES_TABLE_ALL_INVOICES_ARE_LOADED')
	      );
	    }
	  }, {
	    key: 'renderShowMoreBtn',
	    value: function renderShowMoreBtn() {
	      if (this.state.meta.currentPage === this.state.meta.totalPages) {
	        return this.noMoreInfoRow();
	      }
	
	      if (!this.state.meta || this.state.invoices.length <= 0) {
	        return this.noInvoicesRow();
	      }
	
	      if (this.state.fetching || !this.state.meta.currentPage || this.state.meta.currentPage >= this.state.meta.totalPages) {
	        return null;
	      }
	
	      return _react2.default.createElement(_showMoreButton2.default, {
	        text: (0, _proxyCounterpart.proxyCounterpart)('PREREGISTERED_INVOICES_TABLE_SHOW_MORE_INVOICES'),
	        loading: this.state.fetching || false,
	        callback: this.fetchInvoices
	      });
	    }
	  }, {
	    key: 'removeInvoiceFromState',
	    value: function removeInvoiceFromState(invoiceId) {
	      this.setState({
	        invoices: this.state.invoices.filter(function (invoice) {
	          return +invoice.id !== invoiceId;
	        })
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'register-assignment-container' },
	        _ref,
	        _react2.default.createElement(_dashboardButton2.default, {
	          icon: __webpack_require__(655),
	          title: 'BUTTON_REGISTER_ASSIGNMENT',
	          buttonStyle: 'secondary',
	          link: '/register-assignment'
	        }),
	        _react2.default.createElement(_registeredOrdersTable2.default, {
	          invoices: this.state.invoices,
	          removeInvoiceFromState: this.removeInvoiceFromState,
	          user: this.context.user
	        }),
	        this.renderShowMoreBtn()
	      );
	    }
	  }]);
	  return RegisterAssignment;
	}(_react2.default.Component);
	
	RegisterAssignment.contextTypes = {
	  user: _react2.default.PropTypes.object
	};
	exports.default = RegisterAssignment;

/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ShowMoreButton = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ShowMoreButton = exports.ShowMoreButton = function (_React$Component) {
	  (0, _inherits3.default)(ShowMoreButton, _React$Component);
	
	  function ShowMoreButton(props) {
	    (0, _classCallCheck3.default)(this, ShowMoreButton);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ShowMoreButton.__proto__ || (0, _getPrototypeOf2.default)(ShowMoreButton)).call(this, props));
	
	    _this.callCallback = _this.callCallback.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(ShowMoreButton, [{
	    key: 'callCallback',
	    value: function callCallback(e) {
	      if (!this.props.loading && typeof this.props.callback === 'function') {
	        this.props.callback(e);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'button',
	        {
	          id: this.props.id,
	          className: 'assignments-table-show-more-button',
	          onClick: this.callCallback
	        },
	        this.props.text
	      );
	    }
	  }]);
	  return ShowMoreButton;
	}(_react2.default.Component);
	
	exports.default = ShowMoreButton;

/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Salaries = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _datepickerRange = __webpack_require__(117);
	
	var _datepickerRange2 = _interopRequireDefault(_datepickerRange);
	
	var _reactRedux = __webpack_require__(12);
	
	var _salaryService = __webpack_require__(349);
	
	var _salaryService2 = _interopRequireDefault(_salaryService);
	
	var _salaryRow = __webpack_require__(881);
	
	var _salaryRow2 = _interopRequireDefault(_salaryRow);
	
	var _salarySums = __webpack_require__(882);
	
	var _salarySums2 = _interopRequireDefault(_salarySums);
	
	var _reactPaginate = __webpack_require__(623);
	
	var _reactPaginate2 = _interopRequireDefault(_reactPaginate);
	
	var _spinner = __webpack_require__(57);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _spinnerPage = __webpack_require__(792);
	
	var _invoiceConstants = __webpack_require__(219);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 15/03/16.
	 */
	
	var Salaries = exports.Salaries = function (_React$Component) {
	  (0, _inherits3.default)(Salaries, _React$Component);
	
	  function Salaries(props) {
	    (0, _classCallCheck3.default)(this, Salaries);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Salaries.__proto__ || (0, _getPrototypeOf2.default)(Salaries)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      salaries: [],
	      selectAllSalaries: false,
	      fetchingMore: false,
	      fetchingInitial: true,
	      fetchError: false,
	      contentFetched: false,
	      page: 1,
	      size: 25,
	      pageRange: 5,
	      meta: {
	        totalPages: 1
	      },
	      salarySums: {
	        net: 0,
	        gross: 0,
	        tax: 0,
	        travel: 0,
	        allowance: 0
	      },
	      pendingRequest: null,
	      salarySpecification: null,
	      openSalarySpecification: false,
	      salarySpecificationWindow: null
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Salaries, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.fetchSalariesAndSalarySums(this.props);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.pendingRequest && this.state.pendingRequest.cancel) {
	        this.state.pendingRequest.cancel();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.fetchSalariesAndSalarySums(nextProps);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      this.openSalarySpecification();
	    }
	  }]);
	  return Salaries;
	}(_react2.default.Component);
	
	var _ref = _react2.default.createElement(_spinner2.default, null);
	
	var _ref2 = _react2.default.createElement('div', { className: 'overlay' });
	
	var _ref3 = _react2.default.createElement(
	  'thead',
	  null,
	  _react2.default.createElement(
	    'tr',
	    null,
	    _react2.default.createElement(
	      'th',
	      { className: 'col-gross-sum' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'GROSS_SUM' })
	    ),
	    _react2.default.createElement(
	      'th',
	      { className: 'col-tax-sum' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'TAX_SUM' })
	    ),
	    _react2.default.createElement(
	      'th',
	      { className: 'col-allowance-sum' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ALLOWANCE_SUM' })
	    ),
	    _react2.default.createElement(
	      'th',
	      { className: 'col-travel-sum' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'TRAVEL_SUM' })
	    ),
	    _react2.default.createElement(
	      'th',
	      { className: 'col-net-sum' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'NET_SUM' })
	    )
	  )
	);
	
	var _ref4 = _react2.default.createElement(
	  'label',
	  { htmlFor: 'check-all' },
	  _react2.default.createElement('span', null)
	);
	
	var _ref5 = _react2.default.createElement(
	  'th',
	  { className: 'col-customer' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CUSTOMER' })
	);
	
	var _ref6 = _react2.default.createElement(
	  'th',
	  { className: 'col-ordernr' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ORDER_NR' })
	);
	
	var _ref7 = _react2.default.createElement(
	  'th',
	  { className: 'col-pay-id' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PAY_ID' })
	);
	
	var _ref8 = _react2.default.createElement(
	  'th',
	  { className: 'col-date' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'WORK_DATE' })
	);
	
	var _ref9 = _react2.default.createElement(
	  'th',
	  { className: 'col-pay-sum' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PAY_SALARY' })
	);
	
	var _ref10 = _react2.default.createElement(
	  'th',
	  { className: 'col-pay-date' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SALARY_PAYMENT' })
	);
	
	var _ref11 = _react2.default.createElement(
	  'th',
	  { className: 'col-in-links' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PRINT' })
	);
	
	var _ref12 = _react2.default.createElement(
	  'span',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'GET_SALARY_SPECIFICATION' })
	);
	
	var _ref13 = _react2.default.createElement(
	  'p',
	  { className: 'error' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'GENERAL_ERROR' })
	);
	
	var _ref14 = _react2.default.createElement(
	  'p',
	  { className: 'info' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'NO_SALARIES' })
	);
	
	var _ref15 = _react2.default.createElement(
	  'a',
	  { href: '' },
	  '...'
	);
	
	var _ref16 = _react2.default.createElement(_spinner2.default, null);
	
	var _ref17 = _react2.default.createElement(
	  'h2',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'YOUR_SALARIES' })
	);
	
	var _ref18 = _react2.default.createElement(
	  'p',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'YOUR_SALARIES_TEXT' })
	);
	
	var _ref19 = _react2.default.createElement(_datepickerRange2.default, null);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.openSalarySpecification = function () {
	    if (_this2.state.salarySpecification && _this2.state.openSalarySpecification && _this2.state.salarySpecificationWindow) {
	      _this2.state.salarySpecificationWindow.location = _this2.state.salarySpecification.specification_pdf_url;
	
	      _this2.setState({
	        openSalarySpecification: false,
	        salarySpecificationWindow: null
	      });
	    }
	  };
	
	  this.selectAllSalaries = function () {
	    var salaries = _this2.state.salaries;
	
	    _this2.setState({
	      selectAllSalaries: !_this2.state.selectAllSalaries
	    }, function () {
	      salaries.forEach(function (salary) {
	        salary.selected = _this2.state.selectAllSalaries;
	      });
	
	      _this2.setState({
	        salaries: salaries
	      });
	    });
	  };
	
	  this.toggleSalary = function (salaryId) {
	    var salaries = _this2.state.salaries;
	    var selectAllSalaries = _this2.state.selectAllSalaries;
	
	    salaries.forEach(function (salary) {
	      if (salary.id === salaryId) {
	        salary.selected = !salary.selected;
	
	        if (!salary.selected) {
	          selectAllSalaries = false;
	        }
	      }
	    });
	
	    _this2.setState({
	      salaries: salaries,
	      selectAllSalaries: selectAllSalaries
	    });
	  };
	
	  this.handleSalarySpecificationResponse = function (apiResult) {
	    _this2.setState({
	      salarySpecification: apiResult,
	      openSalarySpecification: true
	    });
	  };
	
	  this.createSalarySpecification = function (salaryIds) {
	    var pendingRequest = _salaryService2.default.createSalarySpecification(salaryIds);
	    pendingRequest.promise.then(function (response) {
	      return _this2.handleSalarySpecificationResponse(response);
	    }).catch(function (error) {
	      if (error.response !== undefined) {
	        _this2.state.salarySpecificationWindow.close();
	
	        _this2.setState({
	          openSalarySpecification: false,
	          salarySpecificationWindow: null
	        });
	
	        alert((0, _proxyCounterpart.proxyCounterpart)('GET_SALARY_SPECIFICATION_ERROR'));
	      }
	    });
	
	    return pendingRequest;
	  };
	
	  this.fetchSalariesAndSalarySums = function (props) {
	    if (typeof props.user.id !== 'undefined') {
	      _this2.setState({
	        fetchingMore: true,
	        invoices: [],
	        fetchingInitial: true,
	        meta: {
	          currentPage: 0
	        }
	      }, function () {
	        return _this2.fetchSalaries(props.user.id, props.dateFilter);
	      });
	
	      _this2.fetchSalarySums(props.user.id, props.dateFilter);
	    }
	  };
	
	  this.fetchSalaries = function (userId, dateFilter) {
	    var pendingRequest = _salaryService2.default.get(userId, _this2.state.page, _this2.state.size, dateFilter, '-paid_at');
	    pendingRequest.promise.then(function (response) {
	      return _this2.handleResponse(response);
	    }).catch(function (error) {
	      if (error.response !== undefined) {
	        _this2.setState({
	          fetchError: true,
	          fetchingMore: false,
	          fetchingInitial: false
	        });
	      }
	    });
	
	    _this2.setState({
	      pendingRequest: pendingRequest
	    });
	  };
	
	  this.fetchSalarySums = function (userId, dateFilter) {
	    var pendingRequest = _salaryService2.default.getSums(userId, dateFilter);
	    pendingRequest.promise.then(function (response) {
	      return _this2.handleSumResponse(response);
	    }).catch(function (error) {
	      if (error.response !== undefined) {
	        _this2.setState({
	          fetchError: true
	        });
	      }
	    });
	
	    _this2.setState({
	      pendingRequest: pendingRequest
	    });
	  };
	
	  this.handleResponse = function (apiResult) {
	    _this2.setState({
	      fetchingMore: false,
	      fetchingInitial: false,
	      salaries: apiResult.collection,
	      contentFetched: true,
	      total: apiResult.meta.total,
	      totalPages: Math.ceil(apiResult.meta.total / apiResult.meta.currentPage),
	      meta: apiResult.meta
	    });
	  };
	
	  this.handleSumResponse = function (apiResult) {
	    _this2.setState({
	      salarySums: apiResult
	    });
	  };
	
	  this.handlePaginationClick = function (data) {
	    _this2.setState({
	      page: data.selected + 1,
	      fetchingMore: true
	    }, function () {
	      return _this2.fetchSalaries(_this2.props.user.id, _this2.props.dateFilter);
	    });
	  };
	
	  this.renderLoader = function () {
	    var tableContent, classes;
	
	    tableContent = _this2.state.contentFetched ? _this2.renderTable() : false;
	    classes = _this2.state.contentFetched ? 'loader-wrapper absolute' : 'loader-wrapper';
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'table-loading' },
	      _react2.default.createElement(
	        'div',
	        { className: classes },
	        _ref
	      ),
	      tableContent,
	      _ref2
	    );
	  };
	
	  this.renderTable = function () {
	    var canGenerateSalarySpecification = _this2.canGenerateSalarySpecification;
	    var selectAllSalaries = _this2.selectAllSalaries;
	    var toggleSalary = _this2.toggleSalary;
	    var showSalarySpecification = _this2.showSalarySpecification;
	    var showSalarySpecificationForSelected = _this2.showSalarySpecificationForSelected;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'table-wrapper mobile-full-width-table' },
	        _react2.default.createElement(
	          'table',
	          { className: 'standard-table' },
	          _ref3,
	          _react2.default.createElement(
	            'tbody',
	            null,
	            _react2.default.createElement(_salarySums2.default, { sums: _this2.state.salarySums })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'table-wrapper mobile-full-width-table' },
	        _react2.default.createElement(
	          'table',
	          { className: 'standard-table' },
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                { className: 'col-check' },
	                _react2.default.createElement('input', { id: 'check-all', type: 'checkbox', name: 'check-all',
	                  checked: _this2.state.selectAllSalaries, onClick: selectAllSalaries }),
	                _ref4
	              ),
	              _ref5,
	              _ref6,
	              _ref7,
	              _ref8,
	              _ref9,
	              _ref10,
	              _ref11
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            _this2.state.salaries.map(function (salary, i) {
	              return _react2.default.createElement(_salaryRow2.default, {
	                salary: salary,
	                toggleSalary: toggleSalary,
	                showSalarySpecification: showSalarySpecification,
	                canGenerateSalarySpecification: canGenerateSalarySpecification,
	                key: i
	              });
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { className: 'btn submit-btn mb35', onClick: showSalarySpecificationForSelected },
	        _ref12
	      )
	    );
	  };
	
	  this.canGenerateSalarySpecification = function (salary) {
	    return salary.selected && salary.paymentStatus === _invoiceConstants.paidPaymentStatus && [_invoiceConstants.paidByFileCategory, _invoiceConstants.paidManuallyCategory, _invoiceConstants.paidInCashCategory, _invoiceConstants.creditCategory].includes(salary.categoryId);
	  };
	
	  this.showSalarySpecificationForSelected = function () {
	    var salaryIds = [];
	    _this2.state.salaries.forEach(function (salary) {
	      if (_this2.canGenerateSalarySpecification(salary)) {
	        salaryIds.push(salary.id);
	      }
	    });
	
	    if (salaryIds.length > 0) {
	      _this2.showSalarySpecification(salaryIds);
	    }
	  };
	
	  this.showSalarySpecification = function (salaryIds) {
	    _this2.createSalarySpecification(salaryIds);
	
	    var win = window.open('', '_blank');
	    win.document.title = (0, _proxyCounterpart.proxyCounterpart)('LOADING');
	    win.document.body.innerHTML = _spinnerPage.SpinnerPage;
	
	    _this2.setState({
	      salarySpecificationWindow: win
	    });
	  };
	
	  this.renderFetchError = function () {
	    return _ref13;
	  };
	
	  this.renderNoResult = function () {
	    return _ref14;
	  };
	
	  this.renderPagination = function () {
	    if (_this2.state.contentFetched && _this2.state.meta.totalPages > 1) {
	      return _react2.default.createElement(_reactPaginate2.default, {
	        breakLabel: _ref15,
	        pageNum: _this2.state.meta.totalPages,
	        marginPagesDisplayed: 3,
	        pageRangeDisplayed: _this2.state.pageRange,
	        clickCallback: _this2.handlePaginationClick,
	        subContainerClassName: 'pages pagination',
	        activeClassName: 'active',
	        previousLabel: '',
	        nextLabel: '',
	        containerClassName: 'pagination' });
	    }
	
	    return false;
	  };
	
	  this.getContent = function () {
	    if (_this2.state.fetchError) {
	      return _this2.renderFetchError();
	    }
	    if (_this2.state.fetchingInitial) {
	      return _ref16;
	    }
	    if (_this2.state.fetchingMore) {
	      return _this2.renderLoader();
	    }
	    if (_this2.state.salaries.length === 0 && _this2.state.contentFetched) {
	      return _this2.renderNoResult();
	    } else {
	      return _this2.renderTable();
	    }
	  };
	
	  this.render = function () {
	    var content = _this2.getContent();
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'pay-checks' },
	      _ref17,
	      _ref18,
	      _ref19,
	      content,
	      _this2.renderPagination()
	    );
	  };
	};
	
	function mapStateToProps(state) {
	  return {
	    dateFilter: state.filters.dateFilter,
	    user: state.user
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Salaries);

/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(29);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _reactRouter = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 14/06/16.
	 */
	
	var _ref2 = _react2.default.createElement('div', null);
	
	var _ref3 = _react2.default.createElement('span', null);
	
	var SalaryRow = function (_React$Component) {
	  (0, _inherits3.default)(SalaryRow, _React$Component);
	
	  function SalaryRow() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SalaryRow);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SalaryRow.__proto__ || (0, _getPrototypeOf2.default)(SalaryRow)).call.apply(_ref, [this].concat(args))), _this), _this.toggleSalary = function () {
	      _this.props.toggleSalary(_this.props.salary.id);
	    }, _this.showSalarySpecification = function () {
	      _this.props.showSalarySpecification([_this.props.salary.id]);
	    }, _this.canGenerateSalarySpecification = function (salary) {
	      _this.props.canGenerateSalarySpecification(salary);
	    }, _this.renderOrderNumber = function (salary) {
	      return _react2.default.createElement(
	        'td',
	        { className: 'col-ordernr' },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          {
	            to: '/economy/invoices/' + salary.invoiceId },
	          salary.invoiceId
	        )
	      );
	    }, _this.renderDownloadSalarySpecification = function (salary) {
	      if (_this.canGenerateSalarySpecification(salary)) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            Math.round(salary.toPayIncTaxAgencyPart()),
	            ' ',
	            (0, _proxyCounterpart.proxyCounterpart)('DEFAULT_CURRENCY_NAME_SHORT_OTHER')
	          ),
	          _react2.default.createElement('a', { className: 'printer-link', onClick: _this.showSalarySpecification, target: '_blank' })
	        );
	      }
	      return _ref2;
	    }, _this.render = function () {
	      var s = _this.props.salary;
	      var firstWorkDate = s.invoiceDates[0] ? _utils2.default.formatDate(s.invoiceDates[0].date) : '';
	
	      return _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          { className: 'col-check' },
	          _react2.default.createElement('input', { id: 'salary-' + s.id, type: 'checkbox',
	            checked: s.selected, onClick: _this.toggleSalary,
	            name: 'salary-' + s.id }),
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'salary-' + s.id },
	            _ref3
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'col-customer' },
	          _react2.default.createElement(
	            'span',
	            { className: 'customer-name' },
	            s.typeId === 2 ? s.companyName + ' (' + (0, _proxyCounterpart.proxyCounterpart)('VACATION_MONEY') + ')' : s.companyName
	          )
	        ),
	        _this.renderOrderNumber(s),
	        _react2.default.createElement(
	          'td',
	          { className: 'col-pay-id' },
	          s.id
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'col-date' },
	          firstWorkDate
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'col-pay-sum' },
	          _this.renderDownloadSalarySpecification(s)
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'col-pay-date' },
	          _utils2.default.formatDate(s.paidAt)
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'col-in-links' },
	          _react2.default.createElement('a', { className: 'printer-link', onClick: _this.showSalarySpecification, target: '_blank' })
	        )
	      );
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  return SalaryRow;
	}(_react2.default.Component);
	
	exports.default = SalaryRow;

/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SalarySums = function (_React$Component) {
	  (0, _inherits3.default)(SalarySums, _React$Component);
	
	  function SalarySums() {
	    (0, _classCallCheck3.default)(this, SalarySums);
	    return (0, _possibleConstructorReturn3.default)(this, (SalarySums.__proto__ || (0, _getPrototypeOf2.default)(SalarySums)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SalarySums, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          { className: 'col-gross-sum' },
	          _react2.default.createElement(
	            'span',
	            null,
	            Math.round(this.props.sums.gross),
	            ' ',
	            (0, _proxyCounterpart.proxyCounterpart)('DEFAULT_CURRENCY_NAME_SHORT_OTHER')
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'col-tax-sum' },
	          _react2.default.createElement(
	            'span',
	            null,
	            Math.round(this.props.sums.tax),
	            ' ',
	            (0, _proxyCounterpart.proxyCounterpart)('DEFAULT_CURRENCY_NAME_SHORT_OTHER')
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'col-allowance-sum' },
	          _react2.default.createElement(
	            'span',
	            null,
	            Math.round(this.props.sums.allowance),
	            ' ',
	            (0, _proxyCounterpart.proxyCounterpart)('DEFAULT_CURRENCY_NAME_SHORT_OTHER')
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'col-travel-sum' },
	          _react2.default.createElement(
	            'span',
	            null,
	            Math.round(this.props.sums.travel),
	            ' ',
	            (0, _proxyCounterpart.proxyCounterpart)('DEFAULT_CURRENCY_NAME_SHORT_OTHER')
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'col-net-sum' },
	          _react2.default.createElement(
	            'span',
	            null,
	            Math.round(this.props.sums.net),
	            ' ',
	            (0, _proxyCounterpart.proxyCounterpart)('DEFAULT_CURRENCY_NAME_SHORT_OTHER')
	          )
	        )
	      );
	    }
	  }]);
	  return SalarySums;
	}(_react2.default.Component);
	
	exports.default = SalarySums;

/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SupplierLedgerRow = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(20);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _utils = __webpack_require__(29);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _invoiceToolHelper = __webpack_require__(50);
	
	var _amountHelper = __webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 15/04/16.
	 */
	
	var _ref = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SEK_SHORT' });
	
	var SupplierLedgerRow = exports.SupplierLedgerRow = function (_React$Component) {
	  (0, _inherits3.default)(SupplierLedgerRow, _React$Component);
	
	  function SupplierLedgerRow() {
	    (0, _classCallCheck3.default)(this, SupplierLedgerRow);
	    return (0, _possibleConstructorReturn3.default)(this, (SupplierLedgerRow.__proto__ || (0, _getPrototypeOf2.default)(SupplierLedgerRow)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SupplierLedgerRow, [{
	    key: 'renderOrderNumber',
	    value: function renderOrderNumber() {
	      if (!this.props.hideOrderNumber) {
	        return _react2.default.createElement(
	          'td',
	          { className: 'col-ordernr' },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              to: '/economy/invoices/' + this.props.supplierLedger.invoiceId },
	            this.props.supplierLedger.invoiceId
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderDetailArrived',
	    value: function renderDetailArrived() {
	      if (this.props.showDetailColumns) {
	        return _react2.default.createElement(
	          'td',
	          { className: 'col-arrived' },
	          _utils2.default.formatDate(this.props.supplierLedger.arrivedDate)
	        );
	      }
	    }
	  }, {
	    key: 'renderDetailStatus',
	    value: function renderDetailStatus() {
	      if (this.props.showDetailColumns) {
	        return _react2.default.createElement(
	          'td',
	          { className: 'col-status' },
	          this.props.supplierLedger.statusText
	        );
	      }
	    }
	  }, {
	    key: 'renderDetailPayed',
	    value: function renderDetailPayed() {
	      if (this.props.showDetailColumns) {
	        return _react2.default.createElement(
	          'td',
	          { className: 'col-paid' },
	          _utils2.default.formatDate(this.props.supplierLedger.payedDate)
	        );
	      }
	    }
	  }, {
	    key: 'renderLink',
	    value: function renderLink() {
	      var route = '/economy/supplier-ledgers/' + this.props.supplierLedger.id;
	      if (this.props.showDetailColumns) {
	        return _react2.default.createElement(_reactRouter.Link, { to: route, className: 'pointer-link' });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          { className: 'col-levid' },
	          this.props.supplierLedger.id
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'col-supplier' },
	          this.props.supplierLedger.supplierName
	        ),
	        this.renderOrderNumber(),
	        this.renderDetailArrived(),
	        this.renderDetailStatus(),
	        this.renderDetailPayed(),
	        _react2.default.createElement(
	          'td',
	          { className: 'col-sum' },
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _amountHelper.toMoney)(this.props.supplierLedger.amount * (1 + (0, _invoiceToolHelper.getVatById)(this.props.supplierLedger.taxId) / 100))
	          ),
	          ' ',
	          _ref,
	          this.renderLink()
	        )
	      );
	    }
	  }]);
	  return SupplierLedgerRow;
	}(_react2.default.Component);
	
	exports.default = SupplierLedgerRow;

/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SupplierLedger = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _generalError = __webpack_require__(63);
	
	var _generalError2 = _interopRequireDefault(_generalError);
	
	var _spinner = __webpack_require__(57);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _utils = __webpack_require__(29);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _reactRouter = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_generalError2.default, null); /**
	                                                                         * Created by staffanrantzow on 15/03/16.
	                                                                         */
	
	var _ref2 = _react2.default.createElement(
	  'div',
	  { className: 'loader-wrapper' },
	  _react2.default.createElement(_spinner2.default, null)
	);
	
	var _ref3 = _react2.default.createElement(
	  'td',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'LEV_ID' })
	);
	
	var _ref4 = _react2.default.createElement(
	  'td',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ORDER_NR' })
	);
	
	var _ref5 = _react2.default.createElement(
	  'td',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ARRIVED' })
	);
	
	var _ref6 = _react2.default.createElement(
	  'td',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'STATUS' })
	);
	
	var _ref7 = _react2.default.createElement(
	  'td',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PAID_DATE' })
	);
	
	var _ref8 = _react2.default.createElement(
	  'td',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SUM' })
	);
	
	var _ref9 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SEK_SHORT' });
	
	var _ref10 = _react2.default.createElement(
	  _reactRouter.Link,
	  { className: 'btn blue outlined', to: '/economy/supplier-ledgers' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'BACK' })
	);
	
	var SupplierLedger = exports.SupplierLedger = function (_React$Component) {
	  (0, _inherits3.default)(SupplierLedger, _React$Component);
	
	  function SupplierLedger(props) {
	    (0, _classCallCheck3.default)(this, SupplierLedger);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SupplierLedger.__proto__ || (0, _getPrototypeOf2.default)(SupplierLedger)).call(this, props));
	
	    _this.state = {
	      fetching: true,
	      fetchError: false
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(SupplierLedger, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchDeduction();
	    }
	  }, {
	    key: 'fetchDeduction',
	    value: function fetchDeduction() {
	      this.setState({
	        fetching: true
	      });
	      _frilansFinans.SupplierLedgerService.getById(this.props.params.id).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
	    }
	  }, {
	    key: 'handleResponse',
	    value: function handleResponse(response) {
	      this.setState({
	        fetching: false,
	        fetchError: false,
	        deduction: response
	      });
	    }
	  }, {
	    key: 'handleError',
	    value: function handleError() {
	      this.setState({
	        fetchError: true
	      });
	    }
	  }, {
	    key: 'getContent',
	    value: function getContent() {
	      if (this.state.fetchError) {
	        return _ref;
	      }
	      if (this.state.fetching) {
	        return this.renderLoader();
	      }
	
	      return this.renderTable();
	    }
	  }, {
	    key: 'renderLoader',
	    value: function renderLoader() {
	      return _ref2;
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          this.state.deduction.supplierName
	        ),
	        _react2.default.createElement(
	          'table',
	          { className: 'slim-table' },
	          _react2.default.createElement(
	            'tbody',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _ref3,
	              _react2.default.createElement(
	                'td',
	                null,
	                this.state.deduction.id
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _ref4,
	              _react2.default.createElement(
	                'td',
	                null,
	                this.state.deduction.invoiceId
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _ref5,
	              _react2.default.createElement(
	                'td',
	                null,
	                _utils2.default.formatDate(this.state.deduction.arrivedDate)
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _ref6,
	              _react2.default.createElement(
	                'td',
	                null,
	                this.state.deduction.statusText
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _ref7,
	              _react2.default.createElement(
	                'td',
	                null,
	                _utils2.default.formatDate(this.state.deduction.payedDate)
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _ref8,
	              _react2.default.createElement(
	                'td',
	                null,
	                this.state.deduction.amount,
	                ' ',
	                _ref9
	              )
	            )
	          )
	        ),
	        _react2.default.createElement('img', { src: this.state.deduction.file ? this.state.deduction.file.attributes.file_src : '', alt: '' }),
	        _ref10
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var content = this.getContent();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'deduction' },
	        content
	      );
	    }
	  }]);
	  return SupplierLedger;
	}(_react2.default.Component);
	
	exports.default = SupplierLedger;

/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SupplierLedgers = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _datepickerRange = __webpack_require__(117);
	
	var _datepickerRange2 = _interopRequireDefault(_datepickerRange);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _supplierLedgersTable = __webpack_require__(378);
	
	var _supplierLedgersTable2 = _interopRequireDefault(_supplierLedgersTable);
	
	var _generalError = __webpack_require__(63);
	
	var _generalError2 = _interopRequireDefault(_generalError);
	
	var _spinner = __webpack_require__(57);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _spinnerButton = __webpack_require__(97);
	
	var _spinnerButton2 = _interopRequireDefault(_spinnerButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 15/03/16.
	 */
	
	var _ref = _react2.default.createElement(_generalError2.default, null);
	
	var _ref2 = _react2.default.createElement(
	  'p',
	  { className: 'info' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'NO_DEDUCTIONS' })
	);
	
	var _ref3 = _react2.default.createElement(
	  'div',
	  { className: 'loader-wrapper' },
	  _react2.default.createElement(_spinner2.default, null)
	);
	
	var _ref4 = _react2.default.createElement(
	  'h2',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'YOUR_DEDUCTIONS' })
	);
	
	var _ref5 = _react2.default.createElement(
	  'p',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'YOUR_DEDUCTIONS_TEXT' })
	);
	
	var _ref6 = _react2.default.createElement(_datepickerRange2.default, null);
	
	var SupplierLedgers = exports.SupplierLedgers = function (_React$Component) {
	  (0, _inherits3.default)(SupplierLedgers, _React$Component);
	
	  function SupplierLedgers(props) {
	    (0, _classCallCheck3.default)(this, SupplierLedgers);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SupplierLedgers.__proto__ || (0, _getPrototypeOf2.default)(SupplierLedgers)).call(this, props));
	
	    _this.state = {
	      fetchingInitial: true,
	      fetchingMore: false,
	      fetchError: false,
	      supplierLedgers: [],
	      meta: {
	        currentPage: 0
	      },
	      pendingRequest: null
	    };
	
	    _this.fetchDeductions = _this.fetchDeductions.bind(_this);
	    _this.getNextPage = _this.getNextPage.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(SupplierLedgers, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchDeductions();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.pendingRequest && this.state.pendingRequest.cancel) {
	        this.state.pendingRequest.cancel();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.dateFilter.startDate !== this.props.dateFilter.startDate || nextProps.dateFilter.endDate !== this.props.dateFilter.endDate) {
	        this.props = nextProps;
	
	        this.setState({
	          fetchingMore: true,
	          supplierLedgers: [],
	          fetchingInitial: true,
	          meta: {
	            currentPage: 0
	          }
	        }, this.fetchDeductions.bind(this));
	      }
	    }
	  }, {
	    key: 'fetchDeductions',
	    value: function fetchDeductions() {
	      this.setState({
	        fetchingMore: true
	      });
	
	      var getOnlySupplierLedgersWithInvoices = 1;
	
	      var pendingRequest = _frilansFinans.SupplierLedgerService.get(this.props.user.id, this.state.meta.currentPage + 1, this.props.dateFilter, 1, getOnlySupplierLedgersWithInvoices);
	      pendingRequest.promise.then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
	
	      this.setState({
	        pendingRequest: pendingRequest
	      });
	    }
	  }, {
	    key: 'handleResponse',
	    value: function handleResponse(response) {
	      this.setState({
	        fetchingMore: false,
	        fetchingInitial: false,
	        fetchError: false,
	        supplierLedgers: this.state.supplierLedgers.concat(response.collection),
	        meta: response.meta
	      });
	    }
	  }, {
	    key: 'handleError',
	    value: function handleError(error) {
	      if (error.response !== undefined) {
	        this.setState({
	          fetchError: true
	        });
	      }
	    }
	  }, {
	    key: 'getNextPage',
	    value: function getNextPage() {
	      this.fetchDeductions();
	    }
	  }, {
	    key: 'getContent',
	    value: function getContent() {
	      if (this.state.fetchError) {
	        return _ref;
	      }
	      if (this.state.fetchingInitial) {
	        return this.renderLoader();
	      }
	      if (this.state.supplierLedgers.length === 0) {
	        return _ref2;
	      }
	
	      return this.renderTable();
	    }
	  }, {
	    key: 'renderLoader',
	    value: function renderLoader() {
	      return _ref3;
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_supplierLedgersTable2.default, {
	          supplierLedgers: this.state.supplierLedgers,
	          showDetailColumns: true
	        }),
	        this.renderShowMoreBtn()
	      );
	    }
	  }, {
	    key: 'renderShowMoreBtn',
	    value: function renderShowMoreBtn() {
	      if (this.state.meta.currentPage < this.state.meta.totalPages && !this.state.fetchingInitial) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'show-more-btn-wrapper' },
	          _react2.default.createElement(_spinnerButton2.default, { text: (0, _proxyCounterpart.proxyCounterpart)('SHOW_MORE'), graySpinner: 'true',
	            loading: this.state.fetchingMore, classes: 'btn white show-more', callback: this.getNextPage })
	        );
	      }
	
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var content = this.getContent();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'deductions' },
	        _ref4,
	        _ref5,
	        _ref6,
	        content
	      );
	    }
	  }]);
	  return SupplierLedgers;
	}(_react2.default.Component);
	
	function mapStateToProps(state) {
	  return {
	    dateFilter: state.filters.dateFilter,
	    user: state.user
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(SupplierLedgers);

/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _components = __webpack_require__(13);
	
	var _authentication = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'p',
	  { className: 'error' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'BANKID_LOGIN_FAILED' })
	);
	
	var _ref2 = _react2.default.createElement(_components.Spinner, null);
	
	var EIDLinkLogin = function (_React$Component) {
	  (0, _inherits3.default)(EIDLinkLogin, _React$Component);
	
	  function EIDLinkLogin(props) {
	    (0, _classCallCheck3.default)(this, EIDLinkLogin);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (EIDLinkLogin.__proto__ || (0, _getPrototypeOf2.default)(EIDLinkLogin)).call(this, props));
	
	    _this.state = {
	      loggingIn: true,
	      loginFailed: false
	    };
	
	    _this.handleSuccess = _this.handleSuccess.bind(_this);
	    _this.handleReject = _this.handleReject.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(EIDLinkLogin, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // eslint-disable-next-line react/prop-types
	      var eidAuthCode = this.props.location.query.code;
	
	      if (eidAuthCode) {
	        _authentication.authenticationService.logoutWithoutRedirect();
	        this.login(eidAuthCode);
	      } else {
	        this.context.router.push('login');
	      }
	    }
	  }, {
	    key: 'login',
	    value: function login(eidAuthCode) {
	      var _this2 = this;
	
	      _authentication.authenticationService.eidLinkLogin(eidAuthCode).then(function (response) {
	        return _this2.handleSuccess(response);
	      }).catch(function () {
	        return _this2.handleReject();
	      });
	    }
	  }, {
	    key: 'handleSuccess',
	    value: function handleSuccess(response) {
	      // Only available on error
	      if (response.status && response.status !== 200) {
	        this.handleReject();
	        return false;
	      }
	      this.context.router.push('login');
	    }
	  }, {
	    key: 'handleReject',
	    value: function handleReject() {
	      _authentication.authenticationService.logoutWithoutRedirect();
	
	      this.setState({
	        loggingIn: false,
	        loginFailed: true
	      });
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      if (this.state.loginFailed) {
	        return _ref;
	      }
	      if (this.state.loggingIn) {
	        return _ref2;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'link-login' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container link-login-container' },
	          this.renderContent()
	        )
	      );
	    }
	  }]);
	  return EIDLinkLogin;
	}(_react2.default.Component);
	
	EIDLinkLogin.contextTypes = {
	  router: _react.PropTypes.object.isRequired
	};
	exports.default = EIDLinkLogin;

/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _components = __webpack_require__(13);
	
	var _authentication = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'p',
	  { className: 'error' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'BANKID_LOGIN_FAILED' })
	);
	
	var _ref2 = _react2.default.createElement(_components.Spinner, null);
	
	var EIDLinkRegister = function (_React$Component) {
	  (0, _inherits3.default)(EIDLinkRegister, _React$Component);
	
	  function EIDLinkRegister(props) {
	    (0, _classCallCheck3.default)(this, EIDLinkRegister);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (EIDLinkRegister.__proto__ || (0, _getPrototypeOf2.default)(EIDLinkRegister)).call(this, props));
	
	    _this.state = {
	      loggingIn: true,
	      loginFailed: false
	    };
	
	    _this.handleSuccess = _this.handleSuccess.bind(_this);
	    _this.handleReject = _this.handleReject.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(EIDLinkRegister, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // eslint-disable-next-line react/prop-types
	      var eidAuthCode = this.props.location.query.code;
	
	      if (eidAuthCode) {
	        _authentication.authenticationService.logoutWithoutRedirect();
	        this.createAccount(eidAuthCode);
	      } else {
	        this.context.router.push('login');
	      }
	    }
	  }, {
	    key: 'createAccount',
	    value: function createAccount(eidAuthCode) {
	      var _this2 = this;
	
	      _authentication.authenticationService.eidLinkRegister(eidAuthCode).then(function (response) {
	        return _this2.handleSuccess(response);
	      }).catch(function () {
	        return _this2.handleReject();
	      });
	    }
	  }, {
	    key: 'handleSuccess',
	    value: function handleSuccess(response) {
	      // Only available on error
	      if (response.status && response.status !== 200) {
	        this.handleReject();
	        return false;
	      }
	      this.context.router.push('login');
	    }
	  }, {
	    key: 'handleReject',
	    value: function handleReject() {
	      _authentication.authenticationService.logoutWithoutRedirect();
	
	      this.setState({
	        loggingIn: false,
	        loginFailed: true
	      });
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      if (this.state.loginFailed) {
	        return _ref;
	      }
	      if (this.state.loggingIn) {
	        return _ref2;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'link-login' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container link-login-container' },
	          this.renderContent()
	        )
	      );
	    }
	  }]);
	  return EIDLinkRegister;
	}(_react2.default.Component);
	
	EIDLinkRegister.contextTypes = {
	  router: _react.PropTypes.object.isRequired
	};
	exports.default = EIDLinkRegister;

/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _reactAutosuggest = __webpack_require__(584);
	
	var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref4 = _react2.default.createElement(
	  'button',
	  { className: 'search', type: 'submit' },
	  _react2.default.createElement('div', null)
	);
	
	var FaqAutosuggest = function (_React$Component) {
	  (0, _inherits3.default)(FaqAutosuggest, _React$Component);
	
	  function FaqAutosuggest(props) {
	    (0, _classCallCheck3.default)(this, FaqAutosuggest);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (FaqAutosuggest.__proto__ || (0, _getPrototypeOf2.default)(FaqAutosuggest)).call(this, props));
	
	    _this.state = {
	      value: '',
	      suggestions: []
	    };
	
	    _this.getSuggestions = _this.getSuggestions.bind(_this);
	    _this.handleSuggestionsFetchRequested = _this.handleSuggestionsFetchRequested.bind(_this);
	    _this.handleSuggestionsClearRequested = _this.handleSuggestionsClearRequested.bind(_this);
	    _this.handleSuggestionSelected = _this.handleSuggestionSelected.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(FaqAutosuggest, [{
	    key: 'getSuggestions',
	    value: function getSuggestions(value) {
	      var query = value.trim();
	
	      if (!query.length) {
	        return [];
	      }
	
	      var suggestions = [];
	
	      this.props.faqs.forEach(function (faq) {
	        var matches = faq.questionGroup.filter(function (group) {
	          var question = group.q.toLowerCase();
	          var answer = group.a.toLowerCase();
	          var qa = question + ' ' + answer;
	          return qa.indexOf(query.toLowerCase()) > -1;
	        });
	        suggestions = suggestions.concat(matches);
	      });
	
	      return suggestions.length ? suggestions : [{ q: (0, _proxyCounterpart.proxyCounterpart)('NO_RESULTS_FOUND') }];
	    }
	  }, {
	    key: 'renderSuggestion',
	    value: function renderSuggestion(suggestion) {
	      var answer = suggestion.a ? suggestion.a.replace(/(<([^>]+)>)/ig, '') // Replace html
	      .replace(/&#8211;/g, '') // Replace all - characters
	      : '';
	      var qa = suggestion.q + ' - ' + answer;
	      return qa.substring(0, 80) + '...';
	    }
	  }, {
	    key: 'shouldRenderSuggestions',
	    value: function shouldRenderSuggestions(value) {
	      return value.trim().length > 1;
	    }
	  }, {
	    key: 'getSuggestionValue',
	    value: function getSuggestionValue(suggestion) {
	      return suggestion.q;
	    }
	  }, {
	    key: 'handleSuggestionsFetchRequested',
	    value: function handleSuggestionsFetchRequested(_ref) {
	      var value = _ref.value;
	
	      this.setState({
	        suggestions: this.getSuggestions(value)
	      });
	    }
	  }, {
	    key: 'handleSuggestionsClearRequested',
	    value: function handleSuggestionsClearRequested() {
	      this.setState({
	        suggestions: []
	      });
	    }
	  }, {
	    key: 'handleSuggestionSelected',
	    value: function handleSuggestionSelected(event, _ref2) {
	      var suggestion = _ref2.suggestion,
	          suggestionValue = _ref2.suggestionValue;
	
	      this.props.showFaqItem(suggestion);
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event, _ref3) {
	      var newValue = _ref3.newValue;
	
	      this.setState({
	        value: newValue
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          value = _state.value,
	          suggestions = _state.suggestions;
	
	
	      var inputProps = {
	        value: value,
	        onChange: this.handleChange,
	        placeholder: (0, _proxyCounterpart.proxyCounterpart)('SEARCH_FAQ')
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'search-wrapper' },
	        _react2.default.createElement(_reactAutosuggest2.default, {
	          suggestions: suggestions,
	          onSuggestionsFetchRequested: this.handleSuggestionsFetchRequested,
	          onSuggestionsClearRequested: this.handleSuggestionsClearRequested,
	          onSuggestionSelected: this.handleSuggestionSelected,
	          getSuggestionValue: this.getSuggestionValue,
	          renderSuggestion: this.renderSuggestion,
	          shouldRenderSuggestions: this.shouldRenderSuggestions,
	          inputProps: inputProps
	        }),
	        _ref4
	      );
	    }
	  }]);
	  return FaqAutosuggest;
	}(_react2.default.Component);
	
	exports.default = FaqAutosuggest;

/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(27);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _faqItem = __webpack_require__(890);
	
	var _faqItem2 = _interopRequireDefault(_faqItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaqGroup = function (_React$Component) {
	  (0, _inherits3.default)(FaqGroup, _React$Component);
	
	  function FaqGroup(props) {
	    (0, _classCallCheck3.default)(this, FaqGroup);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (FaqGroup.__proto__ || (0, _getPrototypeOf2.default)(FaqGroup)).call(this, props));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(FaqGroup, [{
	    key: 'handleClick',
	    value: function handleClick() {
	      this.props.toggle(this.props.id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'dl',
	        null,
	        _react2.default.createElement(
	          'dt',
	          { className: this.props.isActive ? 'open' : null, onClick: this.handleClick },
	          _react2.default.createElement(
	            'a',
	            null,
	            this.props.title
	          )
	        ),
	        _react2.default.createElement(
	          'dd',
	          null,
	          _react2.default.createElement(
	            'dl',
	            { className: 'accordion' },
	            this.props.questionGroup.map(function (question) {
	              if (question.q) {
	                return _react2.default.createElement(_faqItem2.default, (0, _extends3.default)({
	                  key: question.id
	                }, question, {
	                  toggle: _this2.props.toggleFaqItem,
	                  addRef: _this2.props.addFaqItemRef
	                }));
	              }
	            })
	          )
	        )
	      );
	    }
	  }]);
	  return FaqGroup;
	}(_react2.default.Component);
	
	exports.default = FaqGroup;

/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _htmlReactParser = __webpack_require__(1328);
	
	var _htmlReactParser2 = _interopRequireDefault(_htmlReactParser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaqItem = function (_React$Component) {
	  (0, _inherits3.default)(FaqItem, _React$Component);
	
	  function FaqItem(props) {
	    (0, _classCallCheck3.default)(this, FaqItem);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (FaqItem.__proto__ || (0, _getPrototypeOf2.default)(FaqItem)).call(this, props));
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(FaqItem, [{
	    key: 'handleRef',
	    value: function handleRef(ref) {
	      this.props.addRef(this.props, ref);
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick() {
	      this.props.toggle(this.props.id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'dl',
	        { className: 'acoordion', ref: this.handleRef },
	        _react2.default.createElement(
	          'dt',
	          { className: this.props.isActive ? 'open' : null },
	          _react2.default.createElement(
	            'a',
	            { onClick: this.handleClick },
	            this.props.q
	          )
	        ),
	        _react2.default.createElement(
	          'dd',
	          null,
	          (0, _htmlReactParser2.default)(this.props.a)
	        )
	      );
	    }
	  }]);
	  return FaqItem;
	}(_react2.default.Component);
	
	exports.default = FaqItem;

/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(27);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _faqAutosuggest = __webpack_require__(888);
	
	var _faqAutosuggest2 = _interopRequireDefault(_faqAutosuggest);
	
	var _faqGroup = __webpack_require__(889);
	
	var _faqGroup2 = _interopRequireDefault(_faqGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'h2',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'FAQ' })
	);
	
	var FaqPage = function (_React$Component) {
	  (0, _inherits3.default)(FaqPage, _React$Component);
	
	  function FaqPage(props) {
	    (0, _classCallCheck3.default)(this, FaqPage);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (FaqPage.__proto__ || (0, _getPrototypeOf2.default)(FaqPage)).call(this, props));
	
	    _this.state = {
	      faqs: _this.props.faqs
	    };
	
	    _this.faqItemRefs = {};
	
	    _this.addFaqItemRef = _this.addFaqItemRef.bind(_this);
	    _this.toggleFaqGroup = _this.toggleFaqGroup.bind(_this);
	    _this.toggleFaqItem = _this.toggleFaqItem.bind(_this);
	    _this.showFaqItem = _this.showFaqItem.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(FaqPage, [{
	    key: 'addFaqItemRef',
	    value: function addFaqItemRef(faqItem, ref) {
	      var obj = {};
	
	      obj[faqItem.id] = ref;
	
	      this.faqItemRefs[faqItem.groupId] = (0, _extends3.default)({}, this.faqItemRefs[faqItem.groupId], obj);
	    }
	  }, {
	    key: 'toggleFaqGroup',
	    value: function toggleFaqGroup(id) {
	      var faqs = this.state.faqs.map(function (faq) {
	        if (faq.id === id) {
	          faq.isActive = !faq.isActive;
	        }
	
	        return faq;
	      });
	
	      this.setState({
	        faqs: faqs
	      });
	    }
	  }, {
	    key: 'toggleFaqItem',
	    value: function toggleFaqItem(id) {
	      var faqs = this.state.faqs.map(function (faq) {
	        faq.questionGroup = faq.questionGroup.map(function (question) {
	          if (question.id === id) {
	            question.isActive = !question.isActive;
	          }
	
	          return question;
	        });
	
	        return faq;
	      });
	
	      this.setState({
	        faqs: faqs
	      });
	    }
	  }, {
	    key: 'showFaqItem',
	    value: function showFaqItem(suggestion) {
	      var _this2 = this;
	
	      var faqs = this.state.faqs.map(function (faq) {
	        if (faq.id === suggestion.groupId) {
	          faq.isActive = true;
	        }
	
	        faq.questionGroup = faq.questionGroup.map(function (question) {
	          if (question.id === suggestion.id) {
	            question.isActive = true;
	          }
	
	          return question;
	        });
	
	        return faq;
	      });
	
	      this.setState({
	        faqs: faqs
	      }, function () {
	        return _this2.scrollToFaqItem(suggestion);
	      });
	    }
	  }, {
	    key: 'scrollToFaqItem',
	    value: function scrollToFaqItem(suggestion) {
	      var item = this.faqItemRefs[suggestion.groupId][suggestion.id];
	      var header = document.querySelector('.page-header.sticky');
	
	      window.scrollTo(0, item.getBoundingClientRect().top - header.offsetHeight);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'faq-page' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-10' },
	              _ref,
	              _react2.default.createElement(_faqAutosuggest2.default, {
	                faqs: this.state.faqs,
	                showFaqItem: this.showFaqItem
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: 'accordion' },
	                this.state.faqs.map(function (group) {
	                  return _react2.default.createElement(_faqGroup2.default, (0, _extends3.default)({
	                    key: group.id
	                  }, group, {
	                    toggle: _this3.toggleFaqGroup,
	                    toggleFaqItem: _this3.toggleFaqItem,
	                    addFaqItemRef: _this3.addFaqItemRef
	                  }));
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return FaqPage;
	}(_react2.default.Component);
	
	exports.default = FaqPage;

/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _faqPage = __webpack_require__(891);
	
	var _faqPage2 = _interopRequireDefault(_faqPage);
	
	var _components = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_components.Spinner, { size: 100 });
	
	var Faq = function (_React$Component) {
	  (0, _inherits3.default)(Faq, _React$Component);
	
	  function Faq(props) {
	    (0, _classCallCheck3.default)(this, Faq);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Faq.__proto__ || (0, _getPrototypeOf2.default)(Faq)).call(this, props));
	
	    _this.state = {
	      faqs: [],
	      pendingRequest: null
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Faq, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetch();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.pendingRequest && this.state.pendingRequest.cancel) {
	        this.state.pendingRequest.cancel();
	      }
	    }
	  }, {
	    key: 'fetch',
	    value: function fetch() {
	      var _this2 = this;
	
	      var pendingRequest = void 0;
	
	      pendingRequest = _frilansFinans.FaqService.get();
	      pendingRequest.promise.then(function (response) {
	        _this2.setState({
	          faqs: response
	        });
	      }).catch(function (err) {
	        console.error(err);
	      });
	
	      this.setState({
	        pendingRequest: pendingRequest
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.state.faqs.length > 0 ? _react2.default.createElement(_faqPage2.default, { faqs: this.state.faqs }) : _ref;
	    }
	  }]);
	  return Faq;
	}(_react2.default.Component);
	
	exports.default = Faq;

/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ForgotPasswordView = undefined;
	
	var _assign = __webpack_require__(22);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _components = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_components.GeneralError, null); /**
	                                                                           * Created by staffanrantzow on 07/10/16.
	                                                                           */
	
	var _ref2 = _react2.default.createElement(
	  'p',
	  { className: 'info' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'RESET_PASSWORD_SUCCESS' })
	);
	
	var _ref3 = _react2.default.createElement(
	  'p',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'RESET_PASSWORD_TEXT' })
	);
	
	var _ref4 = _react2.default.createElement(
	  'div',
	  { className: 'row' },
	  _react2.default.createElement(
	    'div',
	    { className: 'col-sm-6 col-sm-push-3' },
	    _react2.default.createElement(
	      'h2',
	      null,
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'RESET_PASSWORD' })
	    )
	  )
	);
	
	var ForgotPasswordView = exports.ForgotPasswordView = function (_React$Component) {
	  (0, _inherits3.default)(ForgotPasswordView, _React$Component);
	
	  function ForgotPasswordView(props) {
	    (0, _classCallCheck3.default)(this, ForgotPasswordView);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ForgotPasswordView.__proto__ || (0, _getPrototypeOf2.default)(ForgotPasswordView)).call(this, props));
	
	    _this.state = {
	      formValues: {
	        email: {
	          value: '',
	          valid: false
	        }
	      },
	      showErrorWithoutBlur: false,
	      error: false,
	      posted: false,
	      loading: false
	    };
	
	    _this.callback = _this.callback.bind(_this);
	    _this.submitForm = _this.submitForm.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(ForgotPasswordView, [{
	    key: 'callback',
	    value: function callback(name, values) {
	      var tempFormValues = this.state.formValues;
	
	      (0, _assign2.default)(tempFormValues[name], values);
	      this.setState({ formValues: tempFormValues });
	    }
	  }, {
	    key: 'submitForm',
	    value: function submitForm(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	
	      this.setState({ showErrorWithoutBlur: true }, function () {
	        if (_frilansFinans.Utils.validateInputValues(_this2.state.formValues)) {
	          _this2.setState({
	            loading: true,
	            posted: false,
	            error: false
	          }, _this2.post);
	        }
	      });
	    }
	  }, {
	    key: 'post',
	    value: function post() {
	      _frilansFinans.UserService.resetPassword(this.state.formValues.email.value).then(this.handleSuccess.bind(this)).catch(this.handleError.bind(this));
	    }
	  }, {
	    key: 'handleSuccess',
	    value: function handleSuccess() {
	      this.setState({
	        loading: false,
	        posted: true,
	        error: false
	      });
	    }
	  }, {
	    key: 'handleError',
	    value: function handleError() {
	      this.setState({
	        loading: false,
	        posted: true,
	        error: true
	      });
	    }
	  }, {
	    key: 'renderPostError',
	    value: function renderPostError() {
	      if (this.state.error) {
	        return _ref;
	      }
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      if (this.state.posted) {
	        return _ref2;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _ref3,
	        _react2.default.createElement(
	          'form',
	          { noValidate: true, onSubmit: this.submitForm },
	          _react2.default.createElement(_components.InputField, { type: 'email', name: 'email', value: this.state.formValues.email.value,
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('EMAIL'), callback: this.callback,
	            required: 'true', minLength: '3', errorMessage: (0, _proxyCounterpart.proxyCounterpart)('EMAIL_ERROR'),
	            showErrorWithoutBlur: this.state.showErrorWithoutBlur }),
	          this.renderPostError(),
	          _react2.default.createElement(_components.SpinnerButton, { text: (0, _proxyCounterpart.proxyCounterpart)('SEND'),
	            loading: this.state.loading, classes: 'btn' })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'container forgot-password' },
	        _ref4,
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6 col-sm-push-3' },
	            this.renderContent()
	          )
	        )
	      );
	    }
	  }]);
	  return ForgotPasswordView;
	}(_react2.default.Component);
	
	exports.default = ForgotPasswordView;

/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SetNewPassword = undefined;
	
	var _assign = __webpack_require__(22);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _components = __webpack_require__(13);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _reactRouter = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 16/03/16.
	 */
	
	var _ref = _react2.default.createElement(
	  'p',
	  { className: 'error show' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PASSWORD_NOT_EQUAL' })
	);
	
	var _ref2 = _react2.default.createElement(
	  'div',
	  null,
	  _react2.default.createElement(
	    'p',
	    { className: 'info' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PASSWORD_UPDATED' })
	  ),
	  _react2.default.createElement(
	    _reactRouter.Link,
	    { to: 'login', className: 'btn' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'LOGIN' })
	  )
	);
	
	var _ref3 = _react2.default.createElement(_components.GeneralError, null);
	
	var _ref4 = _react2.default.createElement(
	  'h2',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CREATE_PASSWORD' })
	);
	
	var _ref5 = _react2.default.createElement(
	  'p',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PASSWORD_ERROR' })
	);
	
	var SetNewPassword = exports.SetNewPassword = function (_React$Component) {
	  (0, _inherits3.default)(SetNewPassword, _React$Component);
	
	  function SetNewPassword(props) {
	    (0, _classCallCheck3.default)(this, SetNewPassword);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SetNewPassword.__proto__ || (0, _getPrototypeOf2.default)(SetNewPassword)).call(this, props));
	
	    _this.state = {
	      formValues: {
	        password: {},
	        repeatPassword: {}
	      },
	      passwordNotEqual: false,
	      posting: false,
	      postError: false,
	      updated: false,
	      showErrorWithoutBlur: false
	    };
	
	    _this.onSubmit = _this.onSubmit.bind(_this);
	    _this.callback = _this.callback.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(SetNewPassword, [{
	    key: 'callback',
	    value: function callback(name, values) {
	      var _this2 = this;
	
	      var tempFormValues = this.state.formValues;
	
	      (0, _assign2.default)(tempFormValues[name], values);
	      this.setState({ formValues: tempFormValues }, function () {
	        if (_this2.state.showErrorWithoutBlur) {
	          _this2.validatePassword();
	        }
	      });
	    }
	  }, {
	    key: 'validatePassword',
	    value: function validatePassword() {
	      var equal = this.state.formValues.password.value === this.state.formValues.repeatPassword.value;
	
	      this.setState({
	        passwordNotEqual: !equal
	      });
	
	      return equal;
	    }
	  }, {
	    key: 'postPassword',
	    value: function postPassword() {
	      _frilansFinans.UserService.changePassword(this.props.location.query.id, this.props.location.query.token, this.state.formValues.password.value).then(this.handleSuccess.bind(this)).catch(this.handleError.bind(this));
	
	      this.setState({
	        posting: true,
	        updated: false,
	        postError: false
	      });
	    }
	  }, {
	    key: 'handleSuccess',
	    value: function handleSuccess(response) {
	      this.setState({
	        posting: false,
	        updated: true,
	        postError: false
	      });
	
	      _frilansFinans.UserService.fetchUser();
	    }
	  }, {
	    key: 'handleError',
	    value: function handleError() {
	      this.setState({
	        posting: false,
	        updated: false,
	        postError: true
	      });
	    }
	  }, {
	    key: 'onSubmit',
	    value: function onSubmit(e) {
	      var _this3 = this;
	
	      e.preventDefault();
	
	      this.setState({ showErrorWithoutBlur: true }, function () {
	        if (_frilansFinans.Utils.validateInputValues(_this3.state.formValues) && _this3.validatePassword()) {
	          _this3.setState({
	            loading: true
	          }, _this3.postPassword);
	        }
	      });
	    }
	  }, {
	    key: 'renderError',
	    value: function renderError() {
	      if (this.state.passwordNotEqual) {
	        return _ref;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'renderPostSuccess',
	    value: function renderPostSuccess() {
	      if (!this.state.posting && this.state.updated) {
	        return _ref2;
	      }
	    }
	  }, {
	    key: 'renderForm',
	    value: function renderForm() {
	      var postError = this.state.postError ? _ref3 : false;
	
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: this.onSubmit },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-row' },
	          _react2.default.createElement(_components.InputField, { type: 'password', name: 'password',
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('PASSWORD'), callback: this.callback,
	            required: 'true', minLength: '12', validationType: 'passwordRegistration',
	            errorMessage: (0, _proxyCounterpart.proxyCounterpart)('PASSWORD_ERROR_ORIGINAL'),
	            showErrorWithoutBlur: this.state.showErrorWithoutBlur }),
	          _react2.default.createElement(_components.InputField, { type: 'password', name: 'repeatPassword',
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('REPEAT_PASSWORD'), callback: this.callback,
	            required: 'true', minLength: '12', validationType: 'passwordRegistration',
	            errorMessage: (0, _proxyCounterpart.proxyCounterpart)('PASSWORD_ERROR_REPEAT'),
	            showErrorWithoutBlur: this.state.showErrorWithoutBlur })
	        ),
	        this.renderError(),
	        postError,
	        _react2.default.createElement(
	          'div',
	          { className: 'button-wrapper' },
	          _react2.default.createElement(_components.SpinnerButton, { text: (0, _proxyCounterpart.proxyCounterpart)('SEND'),
	            loading: this.state.posting, classes: 'btn' })
	        )
	      );
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      if (!this.state.posting && this.state.updated && !this.state.postError) {
	        return this.renderPostSuccess();
	      }
	
	      return this.renderForm();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'container set-new-password' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6 col-sm-push-3' },
	            _ref4,
	            _ref5,
	            this.renderContent()
	          )
	        )
	      );
	    }
	  }]);
	  return SetNewPassword;
	}(_react2.default.Component);
	
	exports.default = SetNewPassword;

/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InsurancesPage = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _reactTabs = __webpack_require__(645);
	
	var _counterpart = __webpack_require__(86);
	
	var _counterpart2 = _interopRequireDefault(_counterpart);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InsurancesPage = exports.InsurancesPage = function (_React$Component) {
	  (0, _inherits3.default)(InsurancesPage, _React$Component);
	
	  function InsurancesPage(props) {
	    (0, _classCallCheck3.default)(this, InsurancesPage);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (InsurancesPage.__proto__ || (0, _getPrototypeOf2.default)(InsurancesPage)).call(this, props));
	
	    _this.state = {
	      page: null,
	      pendingRequest: null
	    };
	
	    _this.renderTabPanel = _this.renderTabPanel.bind(_this);
	    _this.renderLetterBox = _this.renderLetterBox.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(InsurancesPage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetch();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.pendingRequest && this.state.pendingRequest.cancel) {
	        this.state.pendingRequest.cancel();
	      }
	    }
	  }, {
	    key: 'fetch',
	    value: function fetch() {
	      var _this2 = this;
	
	      var pageID = 293;
	      var pendingRequest = void 0;
	
	      if (_counterpart2.default.getLocale() === 'en') {
	        pageID = 523;
	      }
	      pendingRequest = _frilansFinans.InsurancesPageService.get(pageID);
	      pendingRequest.promise.then(function (response) {
	        _this2.setState({
	          page: response
	        });
	      }).catch(function () {});
	
	      this.setState({
	        pendingRequest: pendingRequest
	      });
	    }
	  }, {
	    key: 'createMarkup',
	    value: function createMarkup(html) {
	      return { __html: html };
	    }
	  }, {
	    key: 'renderLetterBox',
	    value: function renderLetterBox(page) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'insurances-letters' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-md-6 col-md-offset-3' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              page.insurancesLetterButton
	            ),
	            _react2.default.createElement('div', { dangerouslySetInnerHTML: this.createMarkup(page.insurancesLetterBox) })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderHero',
	    value: function renderHero(page) {
	      var sectionStyle = {
	        backgroundImage: 'url(' + page.insurancesImage + ')'
	      };
	      return _react2.default.createElement(
	        'section',
	        { className: 'page-hero', style: sectionStyle },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'p',
	            null,
	            page.insurancesIngress
	          ),
	          _react2.default.createElement(
	            'h1',
	            { className: 'white' },
	            page.title
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderIntroText',
	    value: function renderIntroText(page) {
	      return _react2.default.createElement(
	        'section',
	        { className: 'insurances-text' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12' },
	              _react2.default.createElement(
	                'p',
	                null,
	                page.insurancesText
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderTab',
	    value: function renderTab(section, i) {
	      return _react2.default.createElement(
	        _reactTabs.Tab,
	        { key: i },
	        _react2.default.createElement(
	          'button',
	          { className: 'tab-btn' },
	          section.insurances_section_title
	        )
	      );
	    }
	  }, {
	    key: 'renderTabPanel',
	    value: function renderTabPanel(section, i) {
	      return _react2.default.createElement(
	        _reactTabs.TabPanel,
	        { key: i },
	        _react2.default.createElement('div', { dangerouslySetInnerHTML: this.createMarkup(section.insurances_section_text) })
	      );
	    }
	  }, {
	    key: 'renderTabs',
	    value: function renderTabs(page) {
	      return _react2.default.createElement(
	        _reactTabs.Tabs,
	        null,
	        _react2.default.createElement(
	          _reactTabs.TabList,
	          { className: 'row' },
	          page.insurancesSections.map(this.renderTab)
	        ),
	        page.insurancesSections.map(this.renderTabPanel)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.page) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'insurances-page' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            (0, _proxyCounterpart.proxyCounterpart)('INSURANCES')
	          ),
	          this.renderIntroText(this.state.page),
	          this.renderTabs(this.state.page)
	        );
	      }
	
	      return false;
	    }
	  }]);
	  return InsurancesPage;
	}(_react2.default.Component);
	
	exports.default = InsurancesPage;

/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Insurances = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _insurancesPage = __webpack_require__(895);
	
	var _insurancesPage2 = _interopRequireDefault(_insurancesPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'insurances' },
	  _react2.default.createElement(_insurancesPage2.default, null)
	);
	
	var Insurances = exports.Insurances = function (_React$Component) {
	  (0, _inherits3.default)(Insurances, _React$Component);
	
	  function Insurances() {
	    (0, _classCallCheck3.default)(this, Insurances);
	    return (0, _possibleConstructorReturn3.default)(this, (Insurances.__proto__ || (0, _getPrototypeOf2.default)(Insurances)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Insurances, [{
	    key: 'render',
	    value: function render() {
	      return _ref;
	    }
	  }]);
	  return Insurances;
	}(_react2.default.Component);
	
	exports.default = Insurances;

/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InvoiceCopy = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _frilansFinans = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'header',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_COPY_DOWNLOAD' })
	);
	
	var _ref2 = _react2.default.createElement(
	  'section',
	  { className: 'about-invoice-copy-page' },
	  _react2.default.createElement(
	    'p',
	    null,
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_COPY_ABOUT_PAGE' })
	  )
	);
	
	var _ref3 = _react2.default.createElement(
	  'p',
	  { className: 'error' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_COPY_COULD_NOT_FIND_INVOICE' })
	);
	
	var _ref4 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_COPY_SUBMIT' });
	
	var InvoiceCopy = exports.InvoiceCopy = function (_React$Component) {
	  (0, _inherits3.default)(InvoiceCopy, _React$Component);
	
	  function InvoiceCopy(props) {
	    (0, _classCallCheck3.default)(this, InvoiceCopy);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (InvoiceCopy.__proto__ || (0, _getPrototypeOf2.default)(InvoiceCopy)).call(this, props));
	
	    _this.handleInvoiceNumberChange = function (event) {
	      _this.setState({ ocrNumber: event.target.value });
	    };
	
	    _this.handleCompanyIdChange = function (event) {
	      _this.setState({ companyId: event.target.value });
	    };
	
	    _this.getPdf = function () {
	      _this.setState({ failed: false });
	      _frilansFinans.InvoiceCopyService.get(_this.state.ocrNumber, _this.state.companyId).then(function (response) {
	        window.open(response.url);
	      }, function () {
	        _this.setState({ failed: true });
	      });
	    };
	
	    _this.state = {
	      ocrNumber: '',
	      companyId: '',
	      failed: false
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(InvoiceCopy, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'invoice-copy' },
	        _ref,
	        _react2.default.createElement(
	          'section',
	          { className: 'logo' },
	          _react2.default.createElement('img', { src: __webpack_require__(316), alt: 'Frilans Finans-logotyp' })
	        ),
	        _ref2,
	        _react2.default.createElement(
	          'section',
	          null,
	          _react2.default.createElement('input', {
	            type: 'text',
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('INVOICE_COPY_ENTER_OCR_NUMBER'),
	            name: 'ocrNumber',
	            value: this.state.ocrNumber,
	            onChange: this.handleInvoiceNumberChange
	          }),
	          _react2.default.createElement('input', {
	            type: 'text',
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('INVOICE_COPY_ENTER_COMPANY_ID'),
	            name: 'companyId',
	            value: this.state.companyId,
	            onChange: this.handleCompanyIdChange
	          }),
	          this.state.failed && _ref3,
	          _react2.default.createElement(
	            'a',
	            { className: 'btn', onClick: this.getPdf },
	            _ref4
	          )
	        )
	      );
	    }
	  }]);
	  return InvoiceCopy;
	}(_react2.default.Component);
	
	exports.default = InvoiceCopy;

/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(12);
	
	var _index = __webpack_require__(43);
	
	var _amount = __webpack_require__(899);
	
	var _amount2 = _interopRequireDefault(_amount);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    amount: state.invoice.amount,
	    currencyId: state.invoice.currencyId,
	    currencyName: state.invoice.currencyName,
	    currencyAmount: state.invoice.currencyAmount,
	    user: state.user,
	    invoice: state.invoice,
	    taxkeys: state.taxkeys,
	    submitted: state.invoice.submitted
	  };
	} /**
	   * Created by eriksundqvist on 24/05/16.
	   */
	;
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    setAmount: function setAmount(amount) {
	      return dispatch((0, _index.setAmount)(amount));
	    },
	    setCurrencyId: function setCurrencyId(currencyId) {
	      return dispatch((0, _index.setCurrencyId)(currencyId));
	    },
	    setCurrencyName: function setCurrencyName(currencyName) {
	      return dispatch((0, _index.setCurrencyName)(currencyName));
	    },
	    setCurrencyAmount: function setCurrencyAmount(currencyAmount) {
	      return dispatch((0, _index.setCurrencyAmount)(currencyAmount));
	    },
	    setTaxId: function setTaxId(taxId) {
	      return dispatch((0, _index.setTaxId)(taxId));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_amount2.default);

/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Amount = undefined;
	
	var _getIterator2 = __webpack_require__(18);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _amountHelper = __webpack_require__(58);
	
	var _readMoreModal = __webpack_require__(226);
	
	var _readMoreModal2 = _interopRequireDefault(_readMoreModal);
	
	var _invoiceToolHelper = __webpack_require__(50);
	
	var _invoiceValidator = __webpack_require__(91);
	
	var _invoiceValidator2 = _interopRequireDefault(_invoiceValidator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_COUNTRY = 'SWEDEN'; /**
	                                 * Created by eriksundqvist on 11/05/16.
	                                 */
	
	var DEFAULT_CURRENCY_ID = 1;
	var DEFAULT_CURRENCY_DEFAULT_TAX_ID = 1;
	var NON_DEFAULT_CURRENCY_DEFAULT_TAX_ID = 4;
	
	var _ref = _react2.default.createElement(
	  'p',
	  { className: 'error' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_ERROR_AMOUNT' })
	);
	
	var _ref2 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'DEFAULT_CURRENCY_NAME_SHORT' });
	
	var _ref3 = _react2.default.createElement('div', null);
	
	var _ref4 = _react2.default.createElement(
	  'div',
	  { className: 'left-bg' },
	  _react2.default.createElement(
	    'div',
	    { className: 'text-holder' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'AMOUNT_TO_BILL_EXCL_VAT' })
	  )
	);
	
	var _ref5 = _react2.default.createElement(_reactTranslateComponent2.default, { component: 'p', content: 'CURRENCY' });
	
	var _ref6 = _react2.default.createElement(
	  'p',
	  null,
	  ': '
	);
	
	var _ref7 = _react2.default.createElement(_reactTranslateComponent2.default, { component: 'p', content: 'VAT' });
	
	var _ref8 = _react2.default.createElement(
	  'p',
	  null,
	  ': '
	);
	
	var Amount = exports.Amount = function (_React$Component) {
	  (0, _inherits3.default)(Amount, _React$Component);
	
	  function Amount(props) {
	    (0, _classCallCheck3.default)(this, Amount);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Amount.__proto__ || (0, _getPrototypeOf2.default)(Amount)).call(this, props));
	
	    _this.state = {
	      activeCurrency: null,
	      activeCurrencyId: null,
	      currencies: [],
	      renderModal: false,
	      amountTouched: false
	    };
	
	    _this.billAmountInputBlur = _this.billAmountInputBlur.bind(_this);
	    _this.renderCurrencyVat = _this.renderCurrencyVat.bind(_this);
	    _this.setActiveCurrency = _this.setActiveCurrency.bind(_this);
	    _this.setTaxId = _this.setTaxId.bind(_this);
	    _this.toggleModal = _this.toggleModal.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(Amount, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchCurrencies();
	      this.props.setTaxId(DEFAULT_CURRENCY_DEFAULT_TAX_ID);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (!this.state.activeCurrency) {
	        return;
	      }
	
	      // On amount updated
	      if (nextProps.currencyAmount !== 0 && this.props.currencyAmount !== nextProps.currencyAmount) {
	        this.setBillAmountToField(nextProps.currencyAmount);
	      }
	
	      // On currency updated. Set the new currency object and update amount in store
	      if (this.props.invoice.currencyId !== nextProps.invoice.currencyId && this.state.currencies.length > 0) {
	        var currency = null;
	
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(this.state.currencies), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var c = _step.value;
	
	            if (parseInt(c.id) === parseInt(nextProps.currencyId)) {
	              currency = c;
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        if (currency) {
	          this.setState({
	            activeCurrencyId: nextProps.currencyId,
	            activeCurrency: currency
	          }, function () {
	            _this2.storeBillAmount(_this2.refs.billAmountInput.value);
	          });
	        }
	      }
	
	      if ((this.props.invoice.hsd.rot !== nextProps.invoice.hsd.rot || this.props.invoice.hsd.rut !== nextProps.invoice.hsd.rut) && nextProps.invoice.hsd.rot || nextProps.invoice.hsd.rut) {
	        if (nextProps.invoice.taxId !== DEFAULT_CURRENCY_DEFAULT_TAX_ID) {
	          this.props.setTaxId(DEFAULT_CURRENCY_DEFAULT_TAX_ID);
	        }
	      }
	    }
	  }, {
	    key: 'fetchCurrencies',
	    value: function fetchCurrencies() {
	      var _this3 = this;
	
	      _frilansFinans.CurrenciesService.get().then(function (response) {
	        return _this3.handleCurrenciesResponse(response);
	      });
	    }
	  }, {
	    key: 'handleCurrenciesResponse',
	    value: function handleCurrenciesResponse(apiResult) {
	      var _this4 = this;
	
	      var standardCurrency;
	
	      for (var i = 0; i < apiResult.collection.length; i++) {
	        if (apiResult.collection[i].standard === true) {
	          standardCurrency = apiResult.collection[i];
	          break;
	        }
	      }
	      this.setState({
	        activeCurrency: standardCurrency,
	        currencies: apiResult.collection
	      }, function () {
	        _this4.storeCurrencyId(standardCurrency.id);
	        _this4.storeCurrencyName(standardCurrency.name);
	      });
	    }
	  }, {
	    key: 'storeCurrencyId',
	    value: function storeCurrencyId(currencyId) {
	      this.props.setCurrencyId(parseInt(currencyId));
	      if (!this.props.invoice.initializing && parseInt(currencyId) !== DEFAULT_CURRENCY_DEFAULT_TAX_ID) {
	        this.toggleModal();
	      }
	    }
	  }, {
	    key: 'storeCurrencyName',
	    value: function storeCurrencyName(currencyName) {
	      this.props.setCurrencyName(currencyName);
	    }
	  }, {
	    key: 'getCurrencyById',
	    value: function getCurrencyById(id) {
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(this.state.currencies), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var currencyEntity = _step2.value;
	
	          if (currencyEntity.id === id) {
	            return currencyEntity;
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: 'setActiveCurrency',
	    value: function setActiveCurrency(event) {
	      var _this5 = this;
	
	      var currency = this.getCurrencyById(event.target.value);
	
	      /**
	      * Currency dictate VAT in a way that can't be directly read from the currency data
	      * Therefore a currency change will have to trigger a tax change in cases when it is not the default currency
	      */
	      if (currency.id !== DEFAULT_CURRENCY_ID) {
	        this.props.setTaxId(NON_DEFAULT_CURRENCY_DEFAULT_TAX_ID);
	      }
	
	      this.setState({
	        activeCurrency: currency,
	        activeCurrencyId: currency.id
	      }, function () {
	        _this5.storeCurrencyId(currency.id);
	        _this5.storeCurrencyName(currency.name);
	      });
	    }
	  }, {
	    key: 'billAmountInputBlur',
	    value: function billAmountInputBlur(event) {
	      var amountValue = event.target.value;
	      amountValue = (0, _invoiceToolHelper.reformatInputValue)(amountValue);
	      this.storeBillAmount(amountValue);
	
	      this.setState({
	        amountTouched: true
	      });
	    }
	
	    /**
	     * Store the amount from the input field in the store. Multiply with the current exchange rate
	     */
	
	  }, {
	    key: 'storeBillAmount',
	    value: function storeBillAmount(billAmount) {
	      if (!this.state.activeCurrency) {
	        return;
	      }
	      var storeAmount = this.state.activeCurrency.exchangeRate * billAmount;
	
	      this.props.setCurrencyAmount(billAmount);
	      this.props.setAmount(storeAmount);
	    }
	
	    /**
	     * When amount is updated from somewhere else. Take the store value and divide with current exchange rate
	     */
	
	  }, {
	    key: 'setBillAmountToField',
	    value: function setBillAmountToField(billAmount) {
	      if (billAmount !== 0) {
	        this.refs.billAmountInput.value = (0, _amountHelper.toMoney)(billAmount);
	      } else {
	        this.refs.billAmountInput.value = '0';
	      }
	    }
	  }, {
	    key: 'setTaxId',
	    value: function setTaxId(event) {
	      this.props.setTaxId(parseInt(event.target.value));
	      this.toggleModal();
	    }
	  }, {
	    key: 'toggleModal',
	    value: function toggleModal(e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.setState({
	        renderModal: !this.state.renderModal
	      });
	    }
	  }, {
	    key: 'focus',
	    value: function focus(e) {
	      e.target.select();
	    }
	  }, {
	    key: 'renderError',
	    value: function renderError() {
	      if ((this.props.submitted || this.state.amountTouched) && !_invoiceValidator2.default.validateAmount(this.props.amount)) {
	        return _ref;
	      }
	    }
	  }, {
	    key: 'renderModal',
	    value: function renderModal() {
	      if (this.state.renderModal) {
	        return _react2.default.createElement(_readMoreModal2.default, {
	          close: this.toggleModal,
	          text: _readMoreModal.VAT
	        });
	      }
	    }
	  }, {
	    key: 'renderCurrencyVat',
	    value: function renderCurrencyVat(amountIncVat) {
	      var hide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'hide-mobile';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'currency-vat-right ' + hide },
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(_reactTranslateComponent2.default, { content: this.props.invoice.taxId === NON_DEFAULT_CURRENCY_DEFAULT_TAX_ID ? 'AMOUNT' : 'AMOUNT_INCL_VAT'
	          }),
	          ' ',
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _amountHelper.toMoney)(amountIncVat)
	          ),
	          ' ',
	          _ref2
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.state.activeCurrency) {
	        return _ref3;
	      }
	
	      var hsdAmount = void 0;
	      var customer = this.props.invoice.customerEntity;
	      var country = customer != null ? customer.address.country : false;
	      var hsdAmountExclVat = this.props.invoice.amountAfterHsd || 0;
	      var hsdAmountIncVat = hsdAmountExclVat ? Math.round(hsdAmountExclVat * (1 + (0, _invoiceToolHelper.getVatById)(this.props.invoice.taxId) / 100)) : 0;
	      var amountIncVat = hsdAmountIncVat || this.props.invoice.amountIncVat;
	
	      if ((country === 'SWEDEN' || !country) && (this.props.invoice.hsd.rot || this.props.invoice.hsd.rut)) {
	        var hsdTextType = this.props.invoice.hsd.rot ? 'ROT' : 'RUT';
	        var hsdText = 'AMOUNT_TO_BILL_HSD_' + hsdTextType + '_EXCL_VAT';
	        var hsdValue = (0, _amountHelper.toMoney)(this.props.invoice.amountAfterHsd || 0);
	        var hsdAmountValue = hsdValue + ' ' + this.state.activeCurrency.name;
	        hsdAmount = _react2.default.createElement(
	          'div',
	          { className: 'hsd-amount' },
	          _react2.default.createElement(
	            'div',
	            { className: 'left-bg' },
	            _react2.default.createElement(
	              'div',
	              { className: 'text-holder' },
	              _react2.default.createElement(_reactTranslateComponent2.default, { content: hsdText })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'right-bg' },
	            _react2.default.createElement(
	              'div',
	              { className: 'text-holder' },
	              _react2.default.createElement(
	                'span',
	                null,
	                hsdAmountValue
	              )
	            )
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'amount-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'amount blue-box' },
	          _ref4,
	          _react2.default.createElement(
	            'div',
	            { className: 'right-bg' },
	            _react2.default.createElement(
	              'div',
	              {
	                className: 'input-holder currency-input-holder',
	                'data-currency': this.state.activeCurrency.name },
	              _react2.default.createElement('input', { type: 'text',
	                onBlur: this.billAmountInputBlur,
	                onClick: this.focus,
	                name: 'amount',
	                defaultValue: '0',
	                ref: 'billAmountInput'
	              })
	            ),
	            this.renderCurrencyVat(amountIncVat, 'hide-until-mobile')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'currency-vat' },
	          _react2.default.createElement(
	            'div',
	            { className: 'currency-vat-left' },
	            _react2.default.createElement(
	              'div',
	              { className: 'currency-vat-select-holder' },
	              _react2.default.createElement(
	                'div',
	                { className: 'currency-vat-p-select' },
	                _ref5,
	                _ref6,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'select-btn-wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'styled-amount-select' },
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(
	                        'select',
	                        {
	                          value: this.state.activeCurrencyId ? this.state.activeCurrencyId : DEFAULT_CURRENCY_ID,
	                          onChange: this.setActiveCurrency },
	                        this.state.currencies.map(function (item, i) {
	                          return _react2.default.createElement(
	                            'option',
	                            { value: item.id, key: i },
	                            item.name
	                          );
	                        })
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'currency-vat-p-select' },
	                _ref7,
	                _ref8,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'select-btn-wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'styled-amount-select' },
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(
	                        'select',
	                        {
	                          value: this.props.invoice.taxId,
	                          onChange: this.setTaxId,
	                          disabled: this.state.activeCurrencyId !== DEFAULT_CURRENCY_ID || this.props.invoice.customerEntity !== null && this.props.invoice.customerEntity.address.country !== DEFAULT_COUNTRY || this.props.invoice.hsd.rot || this.props.invoice.hsd.rut },
	                        _invoiceToolHelper.vat.map(function (item, i) {
	                          return _react2.default.createElement(
	                            'option',
	                            { value: item.id, key: i },
	                            item.value,
	                            '%'
	                          );
	                        })
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          this.renderCurrencyVat(amountIncVat)
	        ),
	        hsdAmount,
	        this.renderError(),
	        this.renderModal()
	      );
	    }
	  }]);
	  return Amount;
	}(_react2.default.Component);
	
	exports.default = Amount;

/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ContactInformation = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(13);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'input-row-container' },
	  _react2.default.createElement(_reactTranslateComponent2.default, {
	    className: 'invoicing-description',
	    content: 'COMPLETE_INFORMATION_ORDER_TOOL_CONTACT_INFO_DESCRIPTION'
	  })
	);
	
	var ContactInformation = exports.ContactInformation = function (_React$Component) {
	  (0, _inherits3.default)(ContactInformation, _React$Component);
	
	  function ContactInformation() {
	    (0, _classCallCheck3.default)(this, ContactInformation);
	    return (0, _possibleConstructorReturn3.default)(this, (ContactInformation.__proto__ || (0, _getPrototypeOf2.default)(ContactInformation)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ContactInformation, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal-information-container' },
	        _ref,
	        _react2.default.createElement(
	          'div',
	          { className: 'input-row-container' },
	          _react2.default.createElement(_components.InputField, {
	            type: 'tel',
	            name: 'cellphone',
	            value: this.props.userData.cellphone.value,
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('TELEPHONE_NR'),
	            callback: this.props.callback,
	            required: 'true',
	            minLength: '2',
	            errorMessage: (0, _proxyCounterpart.proxyCounterpart)('TELEPHONE_ERROR'),
	            showErrorWithoutBlur: this.props.showErrorWithoutBlur
	          }),
	          _react2.default.createElement(_components.InputField, {
	            type: 'text',
	            name: 'street',
	            value: this.props.userData.street.value,
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('STREET_ADDRESS'),
	            callback: this.props.callback,
	            required: 'true',
	            minLength: '2',
	            errorMessage: (0, _proxyCounterpart.proxyCounterpart)('ADDRESS_ERROR'),
	            showErrorWithoutBlur: this.props.showErrorWithoutBlur
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'input-row-container' },
	          _react2.default.createElement(_components.InputField, {
	            type: 'text',
	            name: 'city',
	            value: this.props.userData.city.value,
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('CITY'),
	            callback: this.props.callback,
	            required: 'true',
	            minLength: '2',
	            errorMessage: (0, _proxyCounterpart.proxyCounterpart)('CITY_ERROR'),
	            showErrorWithoutBlur: this.props.showErrorWithoutBlur
	          }),
	          _react2.default.createElement(_components.InputField, {
	            type: 'text',
	            name: 'zip',
	            value: this.props.userData.zip.value,
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('POSTAL_CODE'),
	            callback: this.props.callback,
	            required: 'true',
	            minLength: '2',
	            errorMessage: (0, _proxyCounterpart.proxyCounterpart)('POSTAL_CODE_ERROR'),
	            showErrorWithoutBlur: this.props.showErrorWithoutBlur
	          })
	        )
	      );
	    }
	  }]);
	  return ContactInformation;
	}(_react2.default.Component);
	
	exports.default = ContactInformation;

/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InvoiceToolCompleteInformationModal = undefined;
	
	var _isInteger = __webpack_require__(1002);
	
	var _isInteger2 = _interopRequireDefault(_isInteger);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _components = __webpack_require__(13);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _utils = __webpack_require__(29);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _bankInfo = __webpack_require__(163);
	
	var _bankInfoForm = __webpack_require__(231);
	
	var _bankInfoForm2 = _interopRequireDefault(_bankInfoForm);
	
	var _contactInformation = __webpack_require__(900);
	
	var _contactInformation2 = _interopRequireDefault(_contactInformation);
	
	var _modalContainer = __webpack_require__(162);
	
	var _modalContainer2 = _interopRequireDefault(_modalContainer);
	
	var _invoicingInformation = __webpack_require__(904);
	
	var _invoicingInformation2 = _interopRequireDefault(_invoicingInformation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'modal-information-container' },
	  _react2.default.createElement(
	    'div',
	    { className: 'input-row-container' },
	    _react2.default.createElement(_reactTranslateComponent2.default, {
	      className: 'invoicing-description',
	      content: 'COMPLETE_INFORMATION_ORDER_TOOL_SALARY_INFO_DESCRIPTION'
	    })
	  ),
	  _react2.default.createElement(_bankInfoForm2.default, {
	    syncBankInfo: true
	  })
	);
	
	var InvoiceToolCompleteInformationModal = exports.InvoiceToolCompleteInformationModal = function (_React$Component) {
	  (0, _inherits3.default)(InvoiceToolCompleteInformationModal, _React$Component);
	
	  function InvoiceToolCompleteInformationModal(props) {
	    (0, _classCallCheck3.default)(this, InvoiceToolCompleteInformationModal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (InvoiceToolCompleteInformationModal.__proto__ || (0, _getPrototypeOf2.default)(InvoiceToolCompleteInformationModal)).call(this, props));
	
	    _this.state = {
	      userData: _this.userDataTemplate(),
	      showErrorWithoutBlur: false,
	      loading: false,
	      postError: false,
	      currentPage: 1
	    };
	
	    _this.callback = _this.callback.bind(_this);
	    _this.clickPrevious = _this.clickPrevious.bind(_this);
	    _this.clickNext = _this.clickNext.bind(_this);
	    _this.submitForm = _this.submitForm.bind(_this);
	    _this.setCountry = _this.setCountry.bind(_this);
	    _this.handleSuccess = _this.handleSuccess.bind(_this);
	    _this.handleError = _this.handleError.bind(_this);
	    _this.createInvoice = _this.createInvoice.bind(_this);
	    _this.resetState = _this.resetState.bind(_this);
	    _this.renderBody = _this.renderBody.bind(_this);
	    _this.hasValidBankInfo = _this.hasValidBankInfo.bind(_this);
	    _this.hasProfessionId = _this.hasProfessionId.bind(_this);
	    _this.setPage = _this.setPage.bind(_this);
	    _this.pageIsValid = _this.pageIsValid.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(InvoiceToolCompleteInformationModal, [{
	    key: 'userDataTemplate',
	    value: function userDataTemplate() {
	      return {
	        cellphone: this.props.user.cellphone ? { value: this.props.user.cellphone, valid: true } : { value: '', valid: false },
	        city: this.props.user.address.city ? { value: this.props.user.address.city, valid: true } : { value: '', valid: false },
	        street: this.props.user.address.street ? { value: this.props.user.address.street, valid: true } : { value: '', valid: false },
	        zip: this.props.user.address.zip ? { value: this.props.user.address.zip, valid: true } : { value: '', valid: false },
	        profession: this.props.user.professionId ? { value: this.props.user.professionTitle, valid: true, id: this.props.user.professionId } : { value: '', valid: false, id: null },
	        saveVacationPay: this.props.user.saveVacationPay ? { value: this.props.user.saveVacationPay, valid: true } : { value: null, valid: false }
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.fetchBanks();
	    }
	  }, {
	    key: 'setCountry',
	    value: function setCountry(country) {
	      this.callback('country', { value: country, valid: true });
	    }
	  }, {
	    key: 'resetState',
	    value: function resetState() {
	      this.setState({
	        userData: this.userDataTemplate(),
	        showErrorWithoutBlur: false,
	        loading: false
	      });
	    }
	  }, {
	    key: 'createInvoice',
	    value: function createInvoice() {
	      if (this.props.preReport) {
	        this.props.saveInvoice();
	      } else {
	        this.props.createInvoice();
	      }
	    }
	  }, {
	    key: 'callback',
	    value: function callback(name, values) {
	      var tempFormValues = this.state.userData;
	      tempFormValues[name] = values;
	      this.setState({ userData: tempFormValues });
	    }
	  }, {
	    key: 'clickPrevious',
	    value: function clickPrevious() {
	      if (this.state.currentPage === 1) {
	        this.resetState();
	        this.props.toggleModal(false);
	      } else {
	        this.setState({
	          currentPage: this.state.currentPage - 1
	        });
	      }
	    }
	  }, {
	    key: 'setPage',
	    value: function setPage(event) {
	      var currentPage = this.state.currentPage;
	      var targetPage = parseInt(event.target.id);
	
	      if (event && event.target) {
	        if (this.state.currentPage === 1 && this.hasValidUserInfo()) {
	          if (targetPage === 2 || this.hasValidUserInfo() && targetPage === 3) {
	            currentPage = targetPage;
	          }
	        }
	
	        if (this.state.currentPage === 2) {
	          if (targetPage === 1 || this.hasValidBankInfo() && targetPage === 3) {
	            currentPage = targetPage;
	          }
	        }
	
	        if (this.state.currentPage === 3) {
	          currentPage = targetPage;
	        }
	      }
	
	      this.setState({
	        showErrorWithoutBlur: false,
	        currentPage: currentPage
	      });
	    }
	  }, {
	    key: 'pageIsValid',
	    value: function pageIsValid() {
	      switch (this.state.currentPage) {
	        case 1:
	          return this.hasValidUserInfo();
	        case 2:
	          return this.hasValidBankInfo();
	        case 3:
	          return _utils2.default.validateInputValues(this.state.userData) && this.hasValidBankInfo() && this.hasProfessionId();
	        default:
	          return false;
	      }
	    }
	  }, {
	    key: 'clickNext',
	    value: function clickNext(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	      this.setState({ showErrorWithoutBlur: true }, function () {
	        if (_this2.state.currentPage === 1 && _this2.pageIsValid()) {
	          _this2.setState({
	            showErrorWithoutBlur: false,
	            currentPage: _this2.state.currentPage + 1
	          });
	        }
	
	        if (_this2.state.currentPage === 2 && _this2.pageIsValid()) {
	          _this2.setState({
	            showErrorWithoutBlur: false,
	            currentPage: _this2.state.currentPage + 1
	          });
	        }
	
	        if (_this2.state.currentPage === 3 && _this2.pageIsValid()) {
	          _this2.setState({
	            showErrorWithoutBlur: false
	          });
	          _this2.submitForm();
	        }
	      });
	    }
	  }, {
	    key: 'hasProfessionId',
	    value: function hasProfessionId() {
	      if (!this.props.user.professionId && (0, _isInteger2.default)(+this.state.userData.profession.id) || this.props.user.professionId) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'hasValidBankInfo',
	    value: function hasValidBankInfo() {
	      return this.props.bankInfo.accountNumber.isValid && this.props.bankInfo.clearingNumber.isValid;
	    }
	  }, {
	    key: 'hasValidUserInfo',
	    value: function hasValidUserInfo() {
	      return this.state.userData.cellphone.valid && this.state.userData.city.valid && this.state.userData.street.valid && this.state.userData.zip.valid;
	    }
	  }, {
	    key: 'submitForm',
	    value: function submitForm() {
	      var userData = _utils2.default.getPostParams(this.state.userData);
	      var isInternationalAccount = this.props.bankInfo.selectedBank === 'IBAN';
	
	      var userUpdateData = {
	        city: userData.city,
	        country: userData.country,
	        street: userData.street,
	        zip: userData.zip,
	        professionId: this.state.userData.profession ? this.state.userData.profession.id : null,
	        accountNr: !isInternationalAccount ? this.props.bankInfo.accountNumber.value : null,
	        accountClearingNr: !isInternationalAccount ? this.props.bankInfo.clearingNumber.value : null,
	        bic: isInternationalAccount ? this.props.bankInfo.clearingNumber.value : null,
	        iban: isInternationalAccount ? this.props.bankInfo.accountNumber.value : null,
	        saveVacationPay: userData.saveVacationPay,
	        cellphone: userData.cellphone
	      };
	
	      userUpdateData.internationalAccount = isInternationalAccount ? 'on' : 'off';
	
	      this.setState({
	        loading: true,
	        postError: false
	      });
	
	      _frilansFinans.UserService.update(userUpdateData).then(this.handleSuccess).catch(this.handleError);
	    }
	  }, {
	    key: 'handleSuccess',
	    value: function handleSuccess() {
	      this.setState({
	        loading: false
	      });
	
	      this.createInvoice();
	    }
	  }, {
	    key: 'handleError',
	    value: function handleError(error) {
	      var errors = _frilansFinans.UserService.getError(error);
	
	      this.setState({
	        loading: false,
	        error: true,
	        errorMessage: errors
	      });
	    }
	  }, {
	    key: 'getHeaderSlot',
	    value: function getHeaderSlot() {
	      var defaultStyle = 'complete-information-modal-progress-item';
	      var firstItem = 'active';
	      var secondItem = '';
	      var thirdItem = '';
	
	      if (this.state.currentPage === 2) {
	        firstItem = 'visited';
	        secondItem = 'active';
	        thirdItem = '';
	      }
	
	      if (this.state.currentPage === 3) {
	        firstItem = 'visited';
	        secondItem = 'visited';
	        thirdItem = 'active';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'complete-information-modal-progress' },
	        _react2.default.createElement(_reactTranslateComponent2.default, {
	          className: defaultStyle + ' ' + firstItem,
	          onClick: this.setPage,
	          id: 1,
	          content: 'COMPLETE_INFORMATION_ORDER_TOOL_CONTACT_INFO_TAB'
	        }),
	        _react2.default.createElement(_reactTranslateComponent2.default, {
	          className: defaultStyle + ' ' + secondItem,
	          onClick: this.setPage,
	          id: 2,
	          content: 'COMPLETE_INFORMATION_ORDER_TOOL_SALARY_INFO_TAB'
	        }),
	        _react2.default.createElement(_reactTranslateComponent2.default, {
	          className: defaultStyle + ' ' + thirdItem,
	          onClick: this.setPage,
	          id: 3,
	          content: 'COMPLETE_INFORMATION_ORDER_TOOL_INVOICING_INFO_TAB'
	        })
	      );
	    }
	  }, {
	    key: 'renderBody',
	    value: function renderBody() {
	      switch (this.state.currentPage) {
	        case 1:
	          return _react2.default.createElement(_contactInformation2.default, {
	            userData: this.state.userData,
	            showErrorWithoutBlur: this.state.showErrorWithoutBlur,
	            callback: this.callback
	          });
	        case 2:
	          return _ref;
	        case 3:
	          return _react2.default.createElement(_invoicingInformation2.default, {
	            userData: this.state.userData,
	            showErrorWithoutBlur: this.state.showErrorWithoutBlur,
	            callback: this.callback
	          });
	        default:
	          return null;
	
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.invoiceToolCompleteInformationModalIsOpen) {
	        return _react2.default.createElement(
	          _modalContainer2.default,
	          {
	            isOpen: true,
	            callback: this.props.toggleModal,
	            title: 'COMPLETE_INFORMATION_ORDER_TOOL_TITLE',
	            classes: 'complete-information-modal',
	            headerSlot: this.getHeaderSlot(),
	            titleMargin: true
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'complete-information-modal-content' },
	            _react2.default.createElement(
	              'form',
	              { noValidate: true, onSubmit: this.submitForm },
	              this.renderBody()
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'new-modal-button-container' },
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn white no-border',
	                onClick: this.clickPrevious },
	              _react2.default.createElement(_reactTranslateComponent2.default, { content: this.state.currentPage === 1 ? 'CLOSE' : 'BACK' })
	            ),
	            _react2.default.createElement(_components.SpinnerButton, {
	              text: this.state.currentPage === 3 ? (0, _proxyCounterpart.proxyCounterpart)('CREATE_INVOICE') : (0, _proxyCounterpart.proxyCounterpart)('NEXT'),
	              loading: this.state.loading,
	              classes: 'btn',
	              callback: this.clickNext,
	              disabled: !this.pageIsValid()
	            })
	          )
	        );
	      } else {
	        return null;
	      }
	    }
	  }]);
	  return InvoiceToolCompleteInformationModal;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(_ref2) {
	  var bankInfo = _ref2.bankInfo;
	  return {
	    bankInfo: bankInfo,
	    isValid: bankInfo.clearingNumber.isValid && bankInfo.accountNumber.isValid
	  };
	};
	
	var mapDispatchToProps = {
	  fetchBanks: _bankInfo.fetchBanks
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(InvoiceToolCompleteInformationModal);

/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InvoiceToolSelectVacationInformationModal = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _modalContainer = __webpack_require__(162);
	
	var _modalContainer2 = _interopRequireDefault(_modalContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'modal-information-container' },
	  _react2.default.createElement(
	    'div',
	    { className: 'input-row-container' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'MODAL_VACATION_INFORMATION_BODY', className: 'invoicing-description' })
	  )
	);
	
	var InvoiceToolSelectVacationInformationModal = exports.InvoiceToolSelectVacationInformationModal = function (_React$Component) {
	  (0, _inherits3.default)(InvoiceToolSelectVacationInformationModal, _React$Component);
	
	  function InvoiceToolSelectVacationInformationModal() {
	    (0, _classCallCheck3.default)(this, InvoiceToolSelectVacationInformationModal);
	    return (0, _possibleConstructorReturn3.default)(this, (InvoiceToolSelectVacationInformationModal.__proto__ || (0, _getPrototypeOf2.default)(InvoiceToolSelectVacationInformationModal)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(InvoiceToolSelectVacationInformationModal, [{
	    key: 'render',
	    value: function render() {
	      if (this.props.isOpen) {
	        return _react2.default.createElement(
	          _modalContainer2.default,
	          {
	            isOpen: true,
	            callback: this.props.toggleModal,
	            title: 'MODAL_VACATION_INFORMATION_TITLE',
	            classes: 'complete-information-modal'
	          },
	          _ref
	        );
	      } else {
	        return null;
	      }
	    }
	  }]);
	  return InvoiceToolSelectVacationInformationModal;
	}(_react2.default.Component);
	
	exports.default = InvoiceToolSelectVacationInformationModal;

/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InvoiceToolSelectVacationModal = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _utils = __webpack_require__(29);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _modalContainer = __webpack_require__(162);
	
	var _modalContainer2 = _interopRequireDefault(_modalContainer);
	
	var _saveVacationOptions = __webpack_require__(380);
	
	var _saveVacationOptions2 = _interopRequireDefault(_saveVacationOptions);
	
	var _spinnerButton = __webpack_require__(97);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'input-row-container' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'MODAL_SAVE_VACATION_BODY', className: 'invoicing-description' })
	);
	
	var InvoiceToolSelectVacationModal = exports.InvoiceToolSelectVacationModal = function (_React$Component) {
	  (0, _inherits3.default)(InvoiceToolSelectVacationModal, _React$Component);
	
	  function InvoiceToolSelectVacationModal(props) {
	    (0, _classCallCheck3.default)(this, InvoiceToolSelectVacationModal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (InvoiceToolSelectVacationModal.__proto__ || (0, _getPrototypeOf2.default)(InvoiceToolSelectVacationModal)).call(this, props));
	
	    _this.state = {
	      userData: {
	        saveVacationPay: props.user.saveVacationPay ? { value: props.user.saveVacationPay, valid: true } : { value: null, valid: false }
	      },
	      loading: false
	    };
	
	    _this.callback = _this.callback.bind(_this);
	    _this.submit = _this.submit.bind(_this);
	    _this.handleSuccess = _this.handleSuccess.bind(_this);
	    _this.handleError = _this.handleError.bind(_this);
	    _this.resetState = _this.resetState.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(InvoiceToolSelectVacationModal, [{
	    key: 'resetState',
	    value: function resetState() {
	      this.setState({
	        userData: {
	          saveVacationPay: this.props.user.saveVacationPay ? { value: this.props.user.saveVacationPay, valid: true } : { value: null, valid: false }
	        }
	      });
	    }
	  }, {
	    key: 'callback',
	    value: function callback(name, values) {
	      var tempFormValues = this.state.userData;
	      tempFormValues[name] = values;
	      this.setState({ userData: tempFormValues });
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var userData = _utils2.default.getPostParams(this.state.userData);
	
	      var userUpdateData = {
	        saveVacationPay: userData.saveVacationPay
	      };
	
	      this.setState({
	        loading: true,
	        postError: false
	      });
	
	      _frilansFinans.UserService.update(userUpdateData).then(this.handleSuccess).catch(this.handleError);
	    }
	  }, {
	    key: 'handleSuccess',
	    value: function handleSuccess() {
	      this.setState({
	        loading: false
	      });
	      this.props.callback();
	      this.props.toggleModal(false);
	    }
	  }, {
	    key: 'handleError',
	    value: function handleError(error) {
	      var errors = _frilansFinans.UserService.getError(error);
	
	      this.setState({
	        loading: false,
	        error: true,
	        errorMessage: errors
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.isOpen) {
	        return _react2.default.createElement(
	          _modalContainer2.default,
	          {
	            isOpen: true,
	            hideClose: true,
	            callback: this.props.toggleModal,
	            title: 'MODAL_SAVE_VACATION_TITLE',
	            classes: 'complete-information-modal'
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-information-container' },
	            _ref,
	            _react2.default.createElement(
	              'div',
	              { className: 'input-row-container top-divider' },
	              _react2.default.createElement(_saveVacationOptions2.default, {
	                callback: this.callback,
	                userData: this.state.userData,
	                reverseButtonOrder: true,
	                hideTitle: true
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'new-modal-button-container no-margin top-divider' },
	              _react2.default.createElement(_spinnerButton.SpinnerButton, {
	                text: (0, _proxyCounterpart.proxyCounterpart)('SAVE'),
	                loading: this.state.loading,
	                classes: 'btn',
	                callback: this.submit,
	                disabled: !this.state.userData.saveVacationPay.valid
	              })
	            )
	          )
	        );
	      } else {
	        return null;
	      }
	    }
	  }]);
	  return InvoiceToolSelectVacationModal;
	}(_react2.default.Component);
	
	exports.default = InvoiceToolSelectVacationModal;

/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InvoicingInformation = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(13);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _saveVacationOptions = __webpack_require__(380);
	
	var _saveVacationOptions2 = _interopRequireDefault(_saveVacationOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'input-row-container' },
	  _react2.default.createElement(_reactTranslateComponent2.default, {
	    className: 'invoicing-description',
	    content: 'COMPLETE_INFORMATION_ORDER_TOOL_INVOICING_INFO_DESCRIPTION'
	  })
	);
	
	var _ref2 = _react2.default.createElement(
	  'div',
	  { className: 'input-row-container invoicing-sub-description' },
	  _react2.default.createElement(_reactTranslateComponent2.default, {
	    className: 'invoicing-sub-description',
	    content: 'COMPLETE_INFORMATION_ORDER_TOOL_INVOICING_INFO_SUB_DESCRIPTION'
	  })
	);
	
	var _ref3 = _react2.default.createElement(
	  'div',
	  { className: 'input-row-column justify-center' },
	  _react2.default.createElement(_reactTranslateComponent2.default, {
	    className: 'invoicing-sub-description box-container',
	    content: 'COMPLETE_INFORMATION_ORDER_TOOL_INVOICING_INFO_SAVE_VACATION_INFO'
	  })
	);
	
	var InvoicingInformation = exports.InvoicingInformation = function (_React$Component) {
	  (0, _inherits3.default)(InvoicingInformation, _React$Component);
	
	  function InvoicingInformation() {
	    (0, _classCallCheck3.default)(this, InvoicingInformation);
	    return (0, _possibleConstructorReturn3.default)(this, (InvoicingInformation.__proto__ || (0, _getPrototypeOf2.default)(InvoicingInformation)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(InvoicingInformation, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal-information-container' },
	        _ref,
	        _react2.default.createElement(
	          'div',
	          { className: 'input-row-container' },
	          _react2.default.createElement(_components.Profession, {
	            value: this.props.userData.profession.value,
	            name: 'profession',
	            showErrorWithoutBlur: this.props.showErrorWithoutBlur,
	            callback: this.props.callback })
	        ),
	        _ref2,
	        _react2.default.createElement(
	          'div',
	          { className: 'input-row-container top-divider mobile-column' },
	          _react2.default.createElement(_saveVacationOptions2.default, {
	            callback: this.props.callback,
	            userData: this.props.userData
	          }),
	          _ref3
	        )
	      );
	    }
	  }]);
	  return InvoicingInformation;
	}(_react2.default.Component);
	
	exports.default = InvoicingInformation;

/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VacationInformationButton = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invoiceToolSelectVacationInformationModal = __webpack_require__(902);
	
	var _invoiceToolSelectVacationInformationModal2 = _interopRequireDefault(_invoiceToolSelectVacationInformationModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VacationInformationButton = exports.VacationInformationButton = function (_React$Component) {
	  (0, _inherits3.default)(VacationInformationButton, _React$Component);
	
	  function VacationInformationButton(props) {
	    (0, _classCallCheck3.default)(this, VacationInformationButton);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (VacationInformationButton.__proto__ || (0, _getPrototypeOf2.default)(VacationInformationButton)).call(this, props));
	
	    _this.state = {
	      vacationInformationModalIsOpen: false
	    };
	
	    _this.openVacationInformationModal = _this.openVacationInformationModal.bind(_this);
	    _this.setVacationInformationModal = _this.setVacationInformationModal.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(VacationInformationButton, [{
	    key: 'openVacationInformationModal',
	    value: function openVacationInformationModal(e) {
	      e.preventDefault();
	      this.setVacationInformationModal(true);
	    }
	  }, {
	    key: 'setVacationInformationModal',
	    value: function setVacationInformationModal(value) {
	      this.setState({
	        vacationInformationModalIsOpen: value
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'button',
	        {
	          className: 'tooltip-info-button',
	          onClick: this.openVacationInformationModal },
	        _react2.default.createElement(_invoiceToolSelectVacationInformationModal2.default, {
	          isOpen: this.state.vacationInformationModalIsOpen,
	          toggleModal: this.setVacationInformationModal
	        })
	      );
	    }
	  }]);
	  return VacationInformationButton;
	}(_react2.default.Component);
	
	exports.default = VacationInformationButton;

/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EditCustomer = undefined;
	
	var _assign = __webpack_require__(22);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _components = __webpack_require__(13);
	
	var _frilansFinans = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_COUNTRY_FOR_NEW_CUSTOMERS = 'SWEDEN';
	
	var _ref = _react2.default.createElement(
	  'h2',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'EDIT_INFO' })
	);
	
	var _ref2 = _react2.default.createElement(
	  'h2',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CUSTOMER_ADD' })
	);
	
	var _ref3 = _react2.default.createElement(
	  'p',
	  { className: 'error' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'COUNTRY_ERROR' })
	);
	
	var _ref4 = _react2.default.createElement(_components.GeneralError, null);
	
	var _ref5 = _react2.default.createElement(
	  'p',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'NEW_CUSTOMER_INFO' })
	);
	
	var _ref6 = _react2.default.createElement(
	  'span',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CLOSE' })
	);
	
	var EditCustomer = exports.EditCustomer = function (_React$Component) {
	  (0, _inherits3.default)(EditCustomer, _React$Component);
	
	  function EditCustomer(props, context) {
	    (0, _classCallCheck3.default)(this, EditCustomer);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (EditCustomer.__proto__ || (0, _getPrototypeOf2.default)(EditCustomer)).call(this, props, context));
	
	    _this.state = {
	      customer: _this.prepareCustomer(),
	      showErrorWithoutBlur: false,
	      posting: false,
	      postError: false,
	      errorMessage: null
	    };
	
	    _this.newValueFromChild = _this.newValueFromChild.bind(_this);
	    _this.setCountry = _this.setCountry.bind(_this);
	    _this.setPayTerms = _this.setPayTerms.bind(_this);
	    _this.clickSubmit = _this.clickSubmit.bind(_this);
	    _this.handlePostSuccess = _this.handlePostSuccess.bind(_this);
	    _this.handlePostError = _this.handlePostError.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(EditCustomer, [{
	    key: 'prepareCustomer',
	    value: function prepareCustomer() {
	      var customer = void 0;
	
	      if (this.props.edit) {
	        customer = {
	          id: this.props.customer.id,
	          name: this.props.customer.name,
	          vatNr: this.props.customer.vatNr,
	          co: this.props.customer.address.co,
	          street: this.props.customer.address.street,
	          zip: this.props.customer.address.zip,
	          city: this.props.customer.address.city,
	          country: this.props.customer.address.country,
	          contact: this.props.customer.contact,
	          sendToEmail: this.props.customer.sendToEmail,
	          sendToEmailSecondary: this.props.customer.sendToEmailSecondary,
	          phone: this.props.customer.phone,
	          payTerms: this.props.customer.payTerms
	        };
	      } else {
	        customer = {
	          name: '',
	          vatNr: '',
	          co: '',
	          street: '',
	          zip: '',
	          city: '',
	          country: DEFAULT_COUNTRY_FOR_NEW_CUSTOMERS,
	          contact: '',
	          sendToEmail: '',
	          sendToEmailSecondary: '',
	          phone: '',
	          payTerms: 30
	        };
	      }
	
	      return _frilansFinans.Utils.getInputValueObjects(customer);
	    }
	  }, {
	    key: 'newValueFromChild',
	    value: function newValueFromChild(name, values) {
	      var tempFormValues = this.state.customer;
	
	      (0, _assign2.default)(tempFormValues[name], values);
	      this.setState({ customer: tempFormValues });
	    }
	  }, {
	    key: 'setCountry',
	    value: function setCountry(country) {
	      this.newValueFromChild('country', { value: country, valid: true });
	    }
	  }, {
	    key: 'setPayTerms',
	    value: function setPayTerms(payTerms) {
	      this.newValueFromChild('payTerms', { value: payTerms, valid: true });
	    }
	  }, {
	    key: 'submitForm',
	    value: function submitForm() {
	      var _this2 = this;
	
	      var params = _frilansFinans.Utils.getPostParams(this.state.customer);
	      params.userId = this.context.user.id;
	
	      this.setState({
	        posting: true,
	        postError: false
	      });
	
	      if (this.props.edit) {
	        _frilansFinans.CustomerService.updateBillingEmails(params.id, params).then(function () {
	          _frilansFinans.CustomerService.update(params.id, params).then(function (customer) {
	            return customer;
	          }).then(_this2.handlePostSuccess).catch(_this2.handlePostError);
	        });
	      } else {
	        _frilansFinans.CustomerService.post(params).then(function (customer) {
	          _frilansFinans.CustomerService.updateBillingEmails(customer.id, params);
	          // We append secondary email to the customer response as we dont have it after posting
	          customer.sendToEmailSecondary = params.sendToEmailSecondary || '';
	          return customer;
	        }).then(this.handlePostSuccess).catch(this.handlePostError);
	      }
	    }
	  }, {
	    key: 'handlePostSuccess',
	    value: function handlePostSuccess(customer) {
	      this.props.callback(customer);
	    }
	  }, {
	    key: 'handlePostError',
	    value: function handlePostError(error) {
	      var errors = _frilansFinans.CustomerService.getError(error);
	
	      this.setState({
	        posting: false,
	        postError: true,
	        errorMessage: errors
	      });
	    }
	  }, {
	    key: 'clickSubmit',
	    value: function clickSubmit(e) {
	      var _this3 = this;
	
	      e.preventDefault();
	
	      this.setState({ showErrorWithoutBlur: true }, function () {
	        if (_frilansFinans.Utils.validateInputValues(_this3.state.customer)) {
	          _this3.submitForm();
	        }
	      });
	    }
	  }, {
	    key: 'renderHeading',
	    value: function renderHeading() {
	      if (this.props.edit) {
	        return _ref;
	      }
	
	      return _ref2;
	    }
	  }, {
	    key: 'renderCountryError',
	    value: function renderCountryError() {
	      if (this.state.countryError) {
	        return _ref3;
	      }
	    }
	  }, {
	    key: 'renderPostError',
	    value: function renderPostError() {
	      if (this.state.postError) {
	        if (!this.state.errorMessage) {
	          return _ref4;
	        } else {
	          return _react2.default.createElement(
	            'div',
	            null,
	            this.state.errorMessage.map(function (error, i) {
	              return _react2.default.createElement(
	                'p',
	                { className: 'error', key: i },
	                error
	              );
	            })
	          );
	        }
	      }
	    }
	  }, {
	    key: 'renderNewCustomerInfo',
	    value: function renderNewCustomerInfo() {
	      if (this.props.edit) {
	        return;
	      }
	      return _ref5;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var disableVatInput = this.props.edit && this.props.customer.vatNr.length > 0 ? 'true' : 'false';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'edit-customer' },
	        this.renderHeading(),
	        this.renderNewCustomerInfo(),
	        _react2.default.createElement(
	          'form',
	          { noValidate: true, onSubmit: this.clickSubmit },
	          _react2.default.createElement(_components.InputField, { type: 'text', name: 'name', value: this.state.customer.name.value,
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('NAME'), callback: this.newValueFromChild,
	            required: 'true', minLength: '3', maxLength: '50', errorMessage: (0, _proxyCounterpart.proxyCounterpart)('NAME_ERROR'),
	            showErrorWithoutBlur: this.state.showErrorWithoutBlur }),
	          _react2.default.createElement(_components.InputField, { type: 'text', name: 'vatNr', value: this.state.customer.vatNr.value,
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('ORG_NR'), callback: this.newValueFromChild,
	            required: 'false', errorMessage: (0, _proxyCounterpart.proxyCounterpart)('ORG_NR_ERROR'),
	            showErrorWithoutBlur: this.state.showErrorWithoutBlur, disabled: disableVatInput }),
	          _react2.default.createElement(_components.InputField, { type: 'text', name: 'contact', value: this.state.customer.contact.value,
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('REF'), callback: this.newValueFromChild,
	            required: 'true', maxLength: '30', minLength: '0', errorMessage: (0, _proxyCounterpart.proxyCounterpart)('REF_ERROR'),
	            showErrorWithoutBlur: this.state.showErrorWithoutBlur }),
	          _react2.default.createElement(_components.InputField, { type: 'text', name: 'phone', value: this.state.customer.phone.value,
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('TELEPHONE_NR'), callback: this.newValueFromChild,
	            required: 'true', minLength: '0', errorMessage: (0, _proxyCounterpart.proxyCounterpart)('TELEPHONE_ERROR'),
	            showErrorWithoutBlur: this.state.showErrorWithoutBlur }),
	          _react2.default.createElement(_components.InputField, { type: 'text', name: 'sendToEmail', value: this.state.customer.sendToEmail.value,
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('EMAIL_BILLING'), callback: this.newValueFromChild,
	            required: 'true', minLength: '0', errorMessage: (0, _proxyCounterpart.proxyCounterpart)('EMAIL_ERROR'),
	            showErrorWithoutBlur: this.state.showErrorWithoutBlur }),
	          _react2.default.createElement(_components.InputField, { type: 'text', name: 'sendToEmailSecondary', value: this.state.customer.sendToEmailSecondary.value,
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('EMAIL_BILLING_SECONDARY'), callback: this.newValueFromChild,
	            required: 'false', minLength: '0', errorMessage: (0, _proxyCounterpart.proxyCounterpart)('EMAIL_ERROR'),
	            showErrorWithoutBlur: this.state.showErrorWithoutBlur }),
	          _react2.default.createElement(_components.InputField, { type: 'text', name: 'co', value: this.state.customer.co.value,
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('CO'), callback: this.newValueFromChild,
	            required: 'false', errorMessage: (0, _proxyCounterpart.proxyCounterpart)('CO_ERROR'),
	            showErrorWithoutBlur: this.state.showErrorWithoutBlur }),
	          _react2.default.createElement(_components.InputField, { type: 'text', name: 'street', value: this.state.customer.street.value,
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('ADDRESS'), callback: this.newValueFromChild,
	            required: 'true', minLength: '3', maxLength: '50', errorMessage: (0, _proxyCounterpart.proxyCounterpart)('ADDRESS_ERROR'),
	            showErrorWithoutBlur: this.state.showErrorWithoutBlur }),
	          _react2.default.createElement(_components.InputField, { type: 'text', name: 'zip', value: this.state.customer.zip.value,
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('POSTAL_CODE'), callback: this.newValueFromChild,
	            required: 'true', minLength: '3', errorMessage: (0, _proxyCounterpart.proxyCounterpart)('POSTAL_CODE_ERROR'),
	            showErrorWithoutBlur: this.state.showErrorWithoutBlur }),
	          _react2.default.createElement(_components.InputField, { type: 'text', name: 'city', value: this.state.customer.city.value,
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('CITY'), callback: this.newValueFromChild,
	            required: 'true', minLength: '2', maxLength: '40', errorMessage: (0, _proxyCounterpart.proxyCounterpart)('CITY_ERROR'),
	            showErrorWithoutBlur: this.state.showErrorWithoutBlur }),
	          _react2.default.createElement(_components.CountryPicker, {
	            setCountry: this.setCountry,
	            countryName: this.state.customer.country.value,
	            showErrorWithoutBlur: this.state.showErrorWithoutBlur
	          }),
	          _react2.default.createElement(_components.PayTermsPicker, {
	            setPayTerms: this.setPayTerms,
	            payTerms: this.state.customer.payTerms.value,
	            showErrorWithoutBlur: this.state.showErrorWithoutBlur
	          }),
	          this.renderPostError(),
	          this.renderCountryError(),
	          _react2.default.createElement(
	            'div',
	            { className: 'edit-customer-buttons' },
	            _react2.default.createElement(_components.SpinnerButton, { text: (0, _proxyCounterpart.proxyCounterpart)('SAVE'),
	              loading: this.state.posting, classes: 'btn' }),
	            _react2.default.createElement(
	              'a',
	              { className: 'btn outlined blue', onClick: this.props.onCloseModal },
	              _ref6
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return EditCustomer;
	}(_react2.default.Component);
	
	EditCustomer.contextTypes = {
	  user: _react.PropTypes.object.isRequired
	};
	exports.default = EditCustomer;

/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(12);
	
	var _index = __webpack_require__(43);
	
	var _pickCustomer = __webpack_require__(908);
	
	var _pickCustomer2 = _interopRequireDefault(_pickCustomer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    customerEntity: state.invoice.customerEntity,
	    customerId: state.invoice.customerId,
	    submitted: state.invoice.submitted,
	    user: state.user
	  };
	} /**
	   * Created by eriksundqvist on 24/05/16.
	   */
	;
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    setCustomerId: function setCustomerId(customerId) {
	      return dispatch((0, _index.setCustomerId)(customerId));
	    },
	    setCustomerEntity: function setCustomerEntity(customerEntity) {
	      return dispatch((0, _index.setCustomerEntity)(customerEntity));
	    },
	    setSendToEmail: function setSendToEmail(email) {
	      return dispatch((0, _index.setSendToEmail)(email));
	    },
	    setSendToEmailSecondary: function setSendToEmailSecondary(email) {
	      return dispatch((0, _index.setSendToEmailSecondary)(email));
	    },
	    setCompanyPhone: function setCompanyPhone(companyPhone) {
	      return dispatch((0, _index.setCompanyPhone)(companyPhone));
	    },
	    setMessageType: function setMessageType(messageType) {
	      return dispatch((0, _index.setMessageType)(messageType));
	    },
	    setEinvoiceAddress: function setEinvoiceAddress(eInvoiceAddress) {
	      return dispatch((0, _index.setEinvoiceAddress)(eInvoiceAddress));
	    },
	    setPoNumber: function setPoNumber(poNumber) {
	      return dispatch((0, _index.setPoNumber)(poNumber));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_pickCustomer2.default);

/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PickCustomer = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _customerService = __webpack_require__(218);
	
	var _customerService2 = _interopRequireDefault(_customerService);
	
	var _spinner = __webpack_require__(57);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _generalError = __webpack_require__(63);
	
	var _generalError2 = _interopRequireDefault(_generalError);
	
	var _reactModal = __webpack_require__(30);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _reactSelect = __webpack_require__(1512);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	__webpack_require__(1300);
	
	var _editCustomer = __webpack_require__(906);
	
	var _editCustomer2 = _interopRequireDefault(_editCustomer);
	
	var _lodash = __webpack_require__(40);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _invoiceValidator = __webpack_require__(91);
	
	var _invoiceValidator2 = _interopRequireDefault(_invoiceValidator);
	
	var _pointer = __webpack_require__(740);
	
	var _pointer2 = _interopRequireDefault(_pointer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'col-sm-12' },
	  _react2.default.createElement(
	    'p',
	    { className: 'error' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_ERROR_CUSTOMER' })
	  )
	);
	
	var _ref2 = _react2.default.createElement(
	  'div',
	  { className: 'loader-wrapper' },
	  _react2.default.createElement(_spinner2.default, null)
	);
	
	var _ref3 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'REF' });
	
	var _ref4 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'EDIT_INFO' });
	
	var _ref5 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CUSTOMER_SELECT_NOTFOUND' });
	
	var _ref6 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CUSTOMER_SELECT_LABEL' });
	
	var _ref7 = _react2.default.createElement(
	  'p',
	  { className: 'dark-bold' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CHOOSE_CUSTOMER' })
	);
	
	var _ref8 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CUSTOMER_ADD' });
	
	var _ref9 = _react2.default.createElement(_pointer2.default, { color: 'primary' });
	
	var _ref10 = _react2.default.createElement(
	  'div',
	  { className: 'row' },
	  _react2.default.createElement(_generalError2.default, null)
	);
	
	var _ref11 = _react2.default.createElement(
	  'h3',
	  { className: 'form-header' },
	  _react2.default.createElement(
	    'span',
	    null,
	    '1'
	  ),
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CUSTOMER' })
	);
	
	var PickCustomer = exports.PickCustomer = function (_React$Component) {
	  (0, _inherits3.default)(PickCustomer, _React$Component);
	
	  function PickCustomer(props) {
	    (0, _classCallCheck3.default)(this, PickCustomer);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PickCustomer.__proto__ || (0, _getPrototypeOf2.default)(PickCustomer)).call(this, props));
	
	    _this.handleChange = function (selectedOption) {
	      _this.setState({ selectedOption: selectedOption });
	      _this.setChosenCustomer(selectedOption);
	    };
	
	    _this.state = {
	      fetching: false,
	      customers: [],
	      contentFetched: false,
	      page: 1,
	      pageRange: 5,
	      meta: {
	        totalPages: 1
	      },
	      chosenCustomer: null,
	      modalIsOpen: false,
	      editCustomer: true,
	      pendingRequestFetchCustomers: null,
	      pendingRequestFetchCustomersById: null,
	      customerIdFetchOnLoad: null,
	      selectedOption: '',
	      searchValue: ''
	    };
	
	    _this.fetchCustomers = _this.fetchCustomers.bind(_this);
	    _this.setChosenCustomer = _this.setChosenCustomer.bind(_this);
	    _this.editCustomer = _this.editCustomer.bind(_this);
	    _this.createCustomer = _this.createCustomer.bind(_this);
	    _this.onCloseModal = _this.onCloseModal.bind(_this);
	    _this.updateCustomer = _this.updateCustomer.bind(_this);
	    _this.showMore = _this.showMore.bind(_this);
	    _this.renderCustomerList = _this.renderCustomerList.bind(_this);
	    _this.saveCustomerEntityToRedux = _this.saveCustomerEntityToRedux.bind(_this);
	    _this.setChosenCustomerById = _this.setChosenCustomerById.bind(_this);
	    _this.searchCustomer = _this.searchCustomer.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(PickCustomer, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      if (props.customerId > 0) {
	        if (this.state.customers.length === 0) {
	          this.setState({
	            customerIdFetchOnLoad: props.customerId
	          });
	        } else if (!this.state.chosenCustomer) {
	          this.setChosenCustomerById(props.customerId);
	        }
	      }
	    }
	  }, {
	    key: 'saveCustomerEntityToRedux',
	    value: function saveCustomerEntityToRedux() {
	      this.props.setCustomerEntity(this.state.chosenCustomer);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchCustomers();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.pendingRequestFetchCustomers && this.state.pendingRequestFetchCustomers.cancel) {
	        this.state.pendingRequestFetchCustomers.cancel();
	      }
	
	      if (this.state.pendingRequestFetchCustomersById && this.state.pendingRequestFetchCustomersById.cancel) {
	        this.state.pendingRequestFetchCustomersById.cancel();
	      }
	    }
	  }, {
	    key: 'fetchCustomers',
	    value: function fetchCustomers() {
	      var _this2 = this;
	
	      var userId = +this.props.user.id;
	      var pendingRequestFetchCustomers = _customerService2.default.get(userId, this.state.page, 200, this.state.searchValue);
	      pendingRequestFetchCustomers.promise.then(function (response) {
	        return _this2.handleResponse(response);
	      });
	      this.setState({
	        pendingRequestFetchCustomers: pendingRequestFetchCustomers
	      });
	    }
	  }, {
	    key: 'handleResponse',
	    value: function handleResponse(apiResult) {
	      var _this3 = this;
	
	      this.setState({
	        fetching: false,
	        customers: this.state.page === 1 ? apiResult.collection : this.state.customers.concat(apiResult.collection),
	        contentFetched: true,
	        total: apiResult.meta.total,
	        totalPages: Math.ceil(apiResult.meta.total / apiResult.meta.currentPage),
	        meta: apiResult.meta
	      }, function () {
	        if (_this3.state.customerIdFetchOnLoad && !_this3.state.chosenCustomer) {
	          _this3.setChosenCustomerById(_this3.state.customerIdFetchOnLoad);
	        }
	      });
	    }
	  }, {
	    key: 'setChosenCustomerById',
	    value: function setChosenCustomerById(id) {
	      var _this4 = this;
	
	      var chosenCustomer = this.state.customers.find(function (customer) {
	        return parseInt(id) === parseInt(customer.id);
	      });
	
	      if (chosenCustomer) {
	        this.setState({
	          chosenCustomer: chosenCustomer
	        });
	        this.props.setCustomerEntity(chosenCustomer);
	
	        this.props.setSendToEmail(chosenCustomer.sendToEmail);
	        this.props.setSendToEmailSecondary(chosenCustomer.sendToEmailSecondary);
	      } else {
	        var pendingRequest = _customerService2.default.getById(id);
	        pendingRequest.promise.then(function (response) {
	          _this4.setState({
	            chosenCustomer: response,
	            customerIdFetchOnLoad: null
	          }, _this4.saveCustomerEntityToRedux);
	        });
	
	        this.setState({
	          pendingRequestFetchCustomersById: pendingRequest
	        });
	      }
	    }
	  }, {
	    key: 'setChosenCustomer',
	    value: function setChosenCustomer(e) {
	      var chosenCustomer = this.state.customers.find(function (customer) {
	        return e.id === customer.id;
	      });
	
	      this.selectCustomer(chosenCustomer);
	    }
	  }, {
	    key: 'selectCustomer',
	    value: function selectCustomer(customer) {
	      this.setState({
	        chosenCustomer: customer
	      });
	
	      this.props.setCustomerId(parseInt(customer.id));
	      this.props.setCustomerEntity(customer);
	
	      this.props.setSendToEmail(customer.sendToEmail);
	      this.props.setSendToEmailSecondary(customer.sendToEmailSecondary);
	
	      if (customer.phone) {
	        this.props.setCompanyPhone(customer.phone);
	      }
	
	      this.props.setMessageType(customer.messageType);
	
	      this.props.setEinvoiceAddress(customer.eInvoiceAddress);
	      this.props.setPoNumber(customer.poNumber);
	    }
	  }, {
	    key: 'updateCustomer',
	    value: function updateCustomer(updatedCustomer) {
	      var _this5 = this;
	
	      var customers = this.state.customers;
	
	      if (this.state.editCustomer) {
	        var customerIndex = _lodash2.default.findIndex(customers, function (o) {
	          return o.id === updatedCustomer.id;
	        });
	        customers[customerIndex] = updatedCustomer;
	      } else {
	        customers.push(updatedCustomer);
	      }
	
	      this.setState({
	        customers: customers
	      }, function () {
	        _this5.selectCustomer(updatedCustomer);
	        _this5.onCloseModal();
	      });
	    }
	  }, {
	    key: 'editCustomer',
	    value: function editCustomer(e) {
	      e.preventDefault();
	
	      this.setState({
	        modalIsOpen: true,
	        editCustomer: true
	      });
	    }
	  }, {
	    key: 'createCustomer',
	    value: function createCustomer(e) {
	      e.preventDefault();
	
	      this.setState({
	        modalIsOpen: true,
	        editCustomer: false
	      });
	    }
	  }, {
	    key: 'onCloseModal',
	    value: function onCloseModal() {
	      this.setState({
	        modalIsOpen: false
	      });
	    }
	  }, {
	    key: 'searchCustomer',
	    value: function searchCustomer(searchValue) {
	      this.setState({
	        page: 1,
	        searchValue: searchValue
	      }, this.fetchCustomers);
	    }
	  }, {
	    key: 'showMore',
	    value: function showMore() {
	      this.setState({
	        page: this.state.page + 1
	      }, this.fetchCustomers);
	    }
	  }, {
	    key: 'renderError',
	    value: function renderError() {
	      if (this.props.submitted && !_invoiceValidator2.default.validateCustomer(this.props.customerId)) {
	        return _ref;
	      }
	    }
	  }, {
	    key: 'renderModal',
	    value: function renderModal() {
	      return _react2.default.createElement(
	        _reactModal2.default,
	        {
	          className: 'modal',
	          contentLabel: '',
	          isOpen: this.state.modalIsOpen,
	          shouldCloseOnOverlayClick: false,
	          onRequestClose: this.onCloseModal },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-content' },
	          _react2.default.createElement('button', { className: 'close', onClick: this.onCloseModal }),
	          _react2.default.createElement(_editCustomer2.default, {
	            edit: this.state.editCustomer,
	            customer: this.state.chosenCustomer,
	            callback: this.updateCustomer,
	            onCloseModal: this.onCloseModal })
	        )
	      );
	    }
	  }, {
	    key: 'renderLoader',
	    value: function renderLoader() {
	      if (this.state.fetching) {
	        return _ref2;
	      }
	    }
	  }, {
	    key: 'renderCustomer',
	    value: function renderCustomer() {
	      var customer = this.state.chosenCustomer;
	
	      if (customer && customer.id) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'p',
	            { className: 'dark-bold' },
	            customer.name
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            customer.vatNr
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            customer.address.co
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            customer.address.street
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            customer.address.zip,
	            ' ',
	            customer.address.city
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _ref3,
	            ': ',
	            customer.contact
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            customer.sendToEmail
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: '#', className: 'edit-customer', onClick: this.editCustomer },
	            _ref4
	          )
	        );
	      }
	
	      return false;
	    }
	  }, {
	    key: 'renderCustomerList',
	    value: function renderCustomerList() {
	      /*eslint-disable */
	      var options = this.state.customers.map(function (customer) {
	        return { value: customer.id, label: customer.name };
	      });
	      /* eslint-enable */
	
	      var debounceCustomer = _lodash2.default.debounce(this.searchCustomer, 500);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        !this.state.fetching && _react2.default.createElement(_reactSelect2.default, {
	          name: 'form-field-name',
	          clearable: false,
	          value: this.state.chosenCustomer,
	          onChange: this.handleChange,
	          searchable: this.state.searchable,
	          labelKey: 'name',
	          valueKey: 'id',
	          noResultsText: _ref5,
	          placeholder: _ref6,
	          options: this.state.customers,
	          onMenuScrollToBottom: this.showMore,
	          scrollMenuIntoView: false,
	          onInputChange: debounceCustomer
	        })
	      );
	    }
	  }, {
	    key: 'renderForm',
	    value: function renderForm() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-6 customer-box-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'customer-box first-box' },
	            _ref7,
	            this.renderCustomerList()
	          ),
	          this.renderLoader(),
	          _react2.default.createElement(
	            'a',
	            { href: '#', className: 'pointer-link-large', onClick: this.createCustomer },
	            _ref8,
	            _ref9
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-6' },
	          _react2.default.createElement(
	            'div',
	            { className: 'customer-box second-box' },
	            this.renderCustomer()
	          )
	        ),
	        this.renderModal()
	      );
	    }
	  }, {
	    key: 'getContent',
	    value: function getContent() {
	      if (this.state.fetchError) {
	        return _ref10;
	      }
	
	      return this.renderForm();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var content = this.getContent();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'pick-customer section-padding' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12' },
	          _ref11,
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(_reactTranslateComponent2.default, { content: this.props.translationPrefix + 'CUSTOMER_TEXT' })
	          )
	        ),
	        content,
	        this.renderError()
	      );
	    }
	  }]);
	  return PickCustomer;
	}(_react2.default.Component);
	
	exports.default = PickCustomer;

/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(12);
	
	var _addCoworker = __webpack_require__(910);
	
	var _addCoworker2 = _interopRequireDefault(_addCoworker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by eriksundqvist on 12/10/16.
	 */
	/**
	 * Created by eriksundqvist on 12/10/16.
	 */
	function mapStateToProps(state) {
	  return {
	    invoice: state.invoice
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(_addCoworker2.default);

/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AddCoworker = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _components = __webpack_require__(13);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ = __webpack_require__(40); /**
	                            * Created by eriksundqvist on 28/06/16.
	                            */
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'spinner' },
	  _react2.default.createElement(_components.Spinner, { size: 25 })
	);
	
	var _ref2 = _react2.default.createElement(
	  'h3',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SEARCH_COWORKER' })
	);
	
	var _ref3 = _react2.default.createElement(
	  'h2',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ADD_COWORKER' })
	);
	
	var _ref4 = _react2.default.createElement('hr', null);
	
	var _ref5 = _react2.default.createElement(
	  'span',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ADD_NEW_COWORKER' })
	);
	
	var _ref6 = _react2.default.createElement(
	  'span',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CLOSE' })
	);
	
	var AddCoworker = exports.AddCoworker = function (_React$Component) {
	  (0, _inherits3.default)(AddCoworker, _React$Component);
	
	  function AddCoworker(props) {
	    (0, _classCallCheck3.default)(this, AddCoworker);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (AddCoworker.__proto__ || (0, _getPrototypeOf2.default)(AddCoworker)).call(this, props));
	
	    _this.coworkerSearch = function (e) {
	      var value = e.target.value;
	      if (value.length >= 3) {
	        _this.setState({
	          fetching: true
	        }, function () {
	          var _this2 = this;
	
	          _frilansFinans.WorkerService.searchByLastName(value).then(function (response) {
	            _this2.setState({
	              coworkerSearch: true
	            });
	            _this2.handleFetchWorkersResponse(response);
	          }).catch(function () {
	            _this2.setState({
	              fetchError: true,
	              fetching: false
	            });
	          });
	        });
	      }
	    };
	
	    _this.state = {
	      fetching: true,
	      coworkers: [],
	      total: null,
	      perPage: null,
	      addingCoworker: false,
	      selectedCoworker: null,
	      coworkerSearch: false
	    };
	
	    _this.addCoworker = _this.addCoworker.bind(_this);
	    _this.parseInvoiceUsers = _this.parseInvoiceUsers.bind(_this);
	    _this.handleCoworkerChange = _this.handleCoworkerChange.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(AddCoworker, [{
	    key: 'parseInvoiceUsers',
	    value: function parseInvoiceUsers(invoice) {
	      var _this3 = this;
	
	      var invoiceUsers = this.state.coworkers;
	      if (invoice && invoice.invoiceUser) {
	        var _loop = function _loop(i) {
	          var invoiceUser = invoice.invoiceUser[i];
	          var existingUser = _.find(_this3.state.coworkers, function (o) {
	            o.id === parseInt(invoiceUser.userId);
	          });
	          if (existingUser) {
	            invoiceUsers[existingUser.id].disabledInSelect;
	          } else {
	            invoiceUsers.push({
	              id: parseInt(invoiceUser.userId),
	              disabledInSelect: true
	            });
	          }
	        };
	
	        for (var i = 0; i < invoice.invoiceUser.length; i++) {
	          _loop(i);
	        }
	      }
	
	      this.setState({
	        coworkers: invoiceUsers
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.parseInvoiceUsers(this.props.invoice);
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.fetchCoworkers();
	    }
	  }, {
	    key: 'fetchCoworkers',
	    value: function fetchCoworkers() {
	      this.setState({
	        fetching: true
	      }, function () {
	        var _this4 = this;
	
	        _frilansFinans.WorkerService.get(this.state.page).then(function (response) {
	          _this4.handleFetchWorkersResponse(response);
	        }).catch(function () {
	          _this4.setState({
	            fetchError: true,
	            fetching: false
	          });
	        });
	      });
	    }
	  }, {
	    key: 'handleFetchWorkersResponse',
	    value: function handleFetchWorkersResponse(apiResult) {
	      var _this5 = this;
	
	      var coworkers = [];
	      apiResult.collection.forEach(function (result) {
	        if (!_this5.props.invoice.invoiceUser.find(function (worker) {
	          return +worker.userId === +result.id;
	        })) {
	          coworkers.push(result);
	        }
	      });
	      this.setState({
	        coworkers: coworkers,
	        fetching: false,
	        fetchError: false
	      });
	
	      if (!this.state.coworkerSearch) {
	        this.setState({
	          total: apiResult.meta.total,
	          perPage: apiResult.meta.perPage
	        });
	      }
	      this.setSelectedCoworker(coworkers.slice(0).shift());
	    }
	  }, {
	    key: 'addCoworker',
	    value: function addCoworker() {
	      var _this6 = this;
	
	      this.setState({
	        addingCoworker: true
	      }, function () {
	        var selectedCoworkerId = _this6.refs.coworker.value;
	        _this6.props.addCoworker(_this6.getCoworker(selectedCoworkerId));
	      });
	    }
	  }, {
	    key: 'getCoworker',
	    value: function getCoworker(selectedCoworkerId) {
	      return _.find(this.state.coworkers, function (o) {
	        return selectedCoworkerId === o.id;
	      });
	    }
	  }, {
	    key: 'renderSpinner',
	    value: function renderSpinner() {
	      if (this.state.fetching) {
	        return _ref;
	      }
	    }
	  }, {
	    key: 'handleCoworkerChange',
	    value: function handleCoworkerChange(e) {
	      this.setSelectedCoworker(this.getCoworker(e.target.value));
	    }
	  }, {
	    key: 'setSelectedCoworker',
	    value: function setSelectedCoworker(coworker) {
	      this.setState({
	        selectedCoworker: coworker
	      });
	    }
	  }, {
	    key: 'addButtonText',
	    value: function addButtonText() {
	      var text = (0, _proxyCounterpart.proxyCounterpart)('ADD');
	      var name = '';
	
	      if (this.state.selectedCoworker) {
	        if (!this.state.selectedCoworker.disabledInSelect) {
	          name += ' ' + this.state.selectedCoworker.firstName;
	          name += ' ' + this.state.selectedCoworker.lastName;
	        } else {
	          this.state.coworkers.forEach(function (worker) {
	            if (!worker.disabledInSelect) {
	              if (name.length < 5) {
	                name += ' ' + worker.firstName;
	                name += ' ' + worker.lastName;
	              }
	            }
	          });
	        }
	      }
	
	      return text + name;
	    }
	  }, {
	    key: 'renderCoworkerSelect',
	    value: function renderCoworkerSelect() {
	      var select = null;
	      var search = null;
	      var state = this.state;
	
	      if (state.total > state.perPage) {
	        search = _react2.default.createElement(
	          'div',
	          null,
	          _ref2,
	          _react2.default.createElement('input', { type: 'text', onChange: this.coworkerSearch })
	        );
	      }
	
	      if (!state.fetching) {
	        if (state.coworkers.length) {
	          if (state.total <= state.perPage || state.coworkerSearch) {
	            select = _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'styled-select' },
	                _react2.default.createElement(
	                  'select',
	                  {
	                    ref: 'coworker',
	                    onChange: this.handleCoworkerChange },
	                  state.coworkers.map(function (item, i) {
	                    return _react2.default.createElement(
	                      'option',
	                      {
	                        value: item.id,
	                        key: i,
	                        disabled: item.disabledInSelect },
	                      item.fullNamePersonalCode
	                    );
	                  })
	                )
	              ),
	              _react2.default.createElement(_components.SpinnerButton, {
	                text: this.addButtonText(),
	                graySpinner: 'true',
	                loading: this.state.addingCoworker,
	                classes: 'btn outlined blue',
	                callback: this.addCoworker
	              })
	            );
	          }
	        } else {
	          select = _react2.default.createElement(
	            'span',
	            null,
	            (0, _proxyCounterpart.proxyCounterpart)('NO_COWORKERS_ADD_NEW_BELOW')
	          );
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'coworker-select-wrapper' },
	        search,
	        select,
	        this.renderSpinner()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'addCoworker' },
	        _ref3,
	        this.renderCoworkerSelect(),
	        _ref4,
	        _react2.default.createElement(
	          'div',
	          { className: 'button-holder' },
	          _react2.default.createElement(
	            'div',
	            { className: 'btns-left' },
	            _react2.default.createElement(
	              'a',
	              { className: 'btn', onClick: this.props.addNewCoworker },
	              _ref5
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'btns-right' },
	            _react2.default.createElement(
	              'a',
	              { className: 'btn outlined blue close-btn', onClick: this.props.close },
	              _ref6
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return AddCoworker;
	}(_react2.default.Component);
	
	exports.default = AddCoworker;

/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(12);
	
	var _addNewCoworker = __webpack_require__(912);
	
	var _addNewCoworker2 = _interopRequireDefault(_addNewCoworker);
	
	var _index = __webpack_require__(375);
	
	var _bankInfo = __webpack_require__(163);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    bankInfo: state.bankInfo,
	    validationErrors: state.validationError,
	    taxkeys: state.taxkeys
	  };
	};
	
	var mapDispatchToProps = {
	  setValidationErrors: _index.setValidationErrors,
	  clearValidationErrors: _index.clearValidationErrors,
	  setClearingNumberSuppressError: _bankInfo.setClearingNumberSuppressError,
	  setAccountNumberSuppressError: _bankInfo.setAccountNumberSuppressError,
	  resetBankInfo: _bankInfo.reset
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_addNewCoworker2.default);

/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AddNewCoworker = undefined;
	
	var _assign = __webpack_require__(22);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _components = __webpack_require__(13);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _bankInfoForm = __webpack_require__(231);
	
	var _bankInfoForm2 = _interopRequireDefault(_bankInfoForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'p',
	  { className: 'error' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'COUNTRY_ERROR' })
	);
	
	var _ref2 = _react2.default.createElement(
	  'h2',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ADD_COWORKER' })
	);
	
	var _ref3 = _react2.default.createElement('hr', null);
	
	var _ref4 = _react2.default.createElement('hr', null);
	
	var _ref5 = _react2.default.createElement(_bankInfoForm2.default, null);
	
	var _ref6 = _react2.default.createElement('span', null);
	
	var _ref7 = _react2.default.createElement(
	  'span',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CLOSE' })
	);
	
	var AddNewCoworker = exports.AddNewCoworker = function (_React$Component) {
	  (0, _inherits3.default)(AddNewCoworker, _React$Component);
	
	  function AddNewCoworker(props) {
	    (0, _classCallCheck3.default)(this, AddNewCoworker);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (AddNewCoworker.__proto__ || (0, _getPrototypeOf2.default)(AddNewCoworker)).call(this, props));
	
	    _this.state = {
	      formData: {
	        firstName: {},
	        lastName: {},
	        cellphone: {},
	        street: {},
	        city: {},
	        co: {},
	        zip: {},
	        socialSecurityNumber: {},
	        professionId: {},
	        email: {},
	        country: {}
	      },
	      showErrorWithoutBlur: false,
	      posting: false,
	      countryError: false,
	      postError: false,
	      acceptAddCoworker: false
	    };
	
	    _this.saveNewCoworker = _this.saveNewCoworker.bind(_this);
	    _this.inputFieldChange = _this.inputFieldChange.bind(_this);
	    _this.setCountry = _this.setCountry.bind(_this);
	    _this.onSubmit = _this.onSubmit.bind(_this);
	    _this.handlePostError = _this.handlePostError.bind(_this);
	    _this.handleAcceptAddCoworkerClick = _this.handleAcceptAddCoworkerClick.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(AddNewCoworker, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.resetBankInfo();
	    }
	  }, {
	    key: 'getBankInfoFields',
	    value: function getBankInfoFields() {
	      if (this.props.bankInfo.selectedBank === 'IBAN') {
	        return {
	          internationalAccount: 'on',
	          bic: this.props.bankInfo.clearingNumber.value,
	          iban: this.props.bankInfo.accountNumber.value
	        };
	      }
	
	      return {
	        internationalAccount: 'off',
	        accountClearingNumber: this.props.bankInfo.clearingNumber.value,
	        accountNumber: this.props.bankInfo.accountNumber.value
	      };
	    }
	  }, {
	    key: 'saveNewCoworker',
	    value: function saveNewCoworker() {
	      var _this2 = this;
	
	      var params = _frilansFinans.Utils.getPostParams(this.state.formData);
	      params = (0, _assign2.default)(params, this.getBankInfoFields());
	      params.professionId = this.state.formData.professionId.id;
	      this.setState({
	        posting: true
	      }, function () {
	        _frilansFinans.WorkerService.post(params).then(function () {
	          _this2.props.clearValidationErrors();
	          _this2.props.resetBankInfo();
	          _this2.props.close();
	        }).catch(_this2.handlePostError);
	      });
	    }
	  }, {
	    key: 'handlePostError',
	    value: function handlePostError(error) {
	      var errors = _frilansFinans.WorkerService.getError(error);
	
	      if (error.response.status === 422) {
	        this.props.setValidationErrors(error.response.data);
	      };
	
	      this.setState({
	        postError: true,
	        posting: false,
	        errorMessage: errors
	      });
	    }
	  }, {
	    key: 'setCountry',
	    value: function setCountry(countryId) {
	      this.inputFieldChange('country', { value: countryId, valid: true });
	    }
	  }, {
	    key: 'validateCountry',
	    value: function validateCountry() {
	      var countryInvalid = !this.state.formData.country.value;
	
	      this.setState({
	        countryError: countryInvalid
	      });
	
	      return !countryInvalid;
	    }
	  }, {
	    key: 'inputFieldChange',
	    value: function inputFieldChange(name, values) {
	      var tempFormValues = this.state.formData;
	      name = name.replace('add-worker-', '');
	
	      (0, _assign2.default)(tempFormValues[name], values);
	      this.setState({ formData: tempFormValues });
	    }
	  }, {
	    key: 'onSubmit',
	    value: function onSubmit(e) {
	      var _this3 = this;
	
	      e.preventDefault();
	
	      this.props.setClearingNumberSuppressError(false);
	      this.props.setAccountNumberSuppressError(false);
	
	      this.setState({
	        showErrorWithoutBlur: true
	      }, function () {
	        if (_this3.validateCountry() && _frilansFinans.Utils.validateInputValues(_this3.state.formData) && _this3.props.bankInfo.clearingNumber.isValid && _this3.props.bankInfo.accountNumber.isValid && _this3.state.formData.professionId.id) {
	          _this3.saveNewCoworker();
	        }
	      });
	    }
	  }, {
	    key: 'handleAcceptAddCoworkerClick',
	    value: function handleAcceptAddCoworkerClick(e) {
	      this.setState({
	        acceptAddCoworker: e.target.checked
	      });
	    }
	  }, {
	    key: 'renderCountryError',
	    value: function renderCountryError() {
	      if (this.state.countryError) {
	        return _ref;
	      }
	    }
	  }, {
	    key: 'renderPostError',
	    value: function renderPostError() {
	      if (this.state.postError) {
	        if (!this.state.errorMessage) {
	          return _react2.default.createElement(_components.ValidationError, { errors: this.props.validationErrors });
	        } else {
	          return _react2.default.createElement(
	            'div',
	            null,
	            this.state.errorMessage.map(function (error, i) {
	              return _react2.default.createElement(
	                'p',
	                { className: 'error', key: i },
	                error
	              );
	            })
	          );
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'addNewCoworker' },
	        _react2.default.createElement(
	          'form',
	          { noValidate: true, onSubmit: this.onSubmit },
	          _ref2,
	          _react2.default.createElement(
	            'div',
	            { className: 'addNewCoworkerFields' },
	            _react2.default.createElement(_components.InputField, { type: 'text', name: 'add-worker-firstName',
	              placeholder: (0, _proxyCounterpart.proxyCounterpart)('FIRST_NAME'),
	              required: 'true', minLength: '2',
	              validationType: 'text',
	              callback: this.inputFieldChange,
	              errorMessage: (0, _proxyCounterpart.proxyCounterpart)('FIRST_NAME_ERROR'),
	              showErrorWithoutBlur: this.state.showErrorWithoutBlur
	            }),
	            _react2.default.createElement(_components.InputField, { type: 'text', name: 'add-worker-lastName',
	              placeholder: (0, _proxyCounterpart.proxyCounterpart)('LAST_NAME'),
	              required: 'true', minLength: '2',
	              validationType: 'text',
	              callback: this.inputFieldChange,
	              errorMessage: (0, _proxyCounterpart.proxyCounterpart)('LAST_NAME_ERROR'),
	              showErrorWithoutBlur: this.state.showErrorWithoutBlur
	            }),
	            _react2.default.createElement(_components.InputField, { type: 'text', name: 'add-worker-cellphone',
	              placeholder: (0, _proxyCounterpart.proxyCounterpart)('MOBILE_PHONE'),
	              required: 'true', minLength: '0',
	              validationType: 'tel',
	              callback: this.inputFieldChange,
	              errorMessage: (0, _proxyCounterpart.proxyCounterpart)('"VALIDATION_CELLPHONE_PHONENUMBER"'),
	              showErrorWithoutBlur: this.state.showErrorWithoutBlur
	            }),
	            _react2.default.createElement(_components.InputField, { type: 'text', name: 'add-worker-socialSecurityNumber',
	              placeholder: (0, _proxyCounterpart.proxyCounterpart)('PERSONAL_NUMBER') + '(' + (0, _proxyCounterpart.proxyCounterpart)('PERSONAL_NUMBER_FORMAT') + ')',
	              required: 'true', minLength: '3',
	              validationType: 'personalNumber',
	              callback: this.inputFieldChange,
	              errorMessage: (0, _proxyCounterpart.proxyCounterpart)('PERSONAL_NUMBER_ERROR'),
	              showErrorWithoutBlur: this.state.showErrorWithoutBlur
	            }),
	            _react2.default.createElement(_components.InputField, { type: 'text', name: 'add-worker-email',
	              placeholder: (0, _proxyCounterpart.proxyCounterpart)('EMAIL'),
	              required: 'false',
	              validationType: 'email',
	              errorMessage: (0, _proxyCounterpart.proxyCounterpart)('EMAIL_INVALID_ERROR'),
	              callback: this.inputFieldChange,
	              showErrorWithoutBlur: this.state.showErrorWithoutBlur
	            }),
	            _react2.default.createElement(_components.Profession, { value: '', name: 'add-worker-professionId',
	              showErrorWithoutBlur: this.state.showErrorWithoutBlur, callback: this.inputFieldChange })
	          ),
	          _ref3,
	          _react2.default.createElement(
	            'div',
	            { className: 'addNewCoworkerFields' },
	            _react2.default.createElement(_components.InputField, { type: 'text', name: 'add-worker-street',
	              placeholder: (0, _proxyCounterpart.proxyCounterpart)('STREET_ADDRESS'),
	              required: 'true', minLength: '3',
	              validationType: 'text',
	              errorMessage: (0, _proxyCounterpart.proxyCounterpart)('ADDRESS_ERROR'),
	              callback: this.inputFieldChange,
	              showErrorWithoutBlur: this.state.showErrorWithoutBlur
	            }),
	            _react2.default.createElement(_components.InputField, { type: 'text', name: 'add-worker-co',
	              placeholder: (0, _proxyCounterpart.proxyCounterpart)('CO'),
	              required: 'true', minLength: '0',
	              validationType: 'text',
	              callback: this.inputFieldChange,
	              showErrorWithoutBlur: this.state.showErrorWithoutBlur
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'input-wrapper' },
	              _react2.default.createElement(_components.InputField, { type: 'text', name: 'add-worker-zip',
	                placeholder: (0, _proxyCounterpart.proxyCounterpart)('POSTAL_CODE_ABBR'),
	                required: 'true', minLength: '3',
	                errorMessage: (0, _proxyCounterpart.proxyCounterpart)('POSTAL_CODE_ERROR'),
	                validationType: 'text',
	                callback: this.inputFieldChange,
	                showErrorWithoutBlur: this.state.showErrorWithoutBlur
	              }),
	              _react2.default.createElement(_components.InputField, { type: 'text', name: 'add-worker-city',
	                placeholder: (0, _proxyCounterpart.proxyCounterpart)('CITY'),
	                required: 'true', minLength: '3',
	                validationType: 'text',
	                errorMessage: (0, _proxyCounterpart.proxyCounterpart)('CITY_ERROR'),
	                callback: this.inputFieldChange,
	                showErrorWithoutBlur: this.state.showErrorWithoutBlur
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'input-wrapper add-new-coworker-country' },
	              _react2.default.createElement(_components.CountryPicker, {
	                defaultValue: 'SWEDEN',
	                showErrorWithoutBlur: this.state.showErrorWithoutBlur,
	                setCountry: this.setCountry })
	            )
	          ),
	          _ref4,
	          _ref5,
	          this.renderCountryError(),
	          this.renderPostError(),
	          _react2.default.createElement(
	            'div',
	            { className: 'checkbox-holder' },
	            _react2.default.createElement('input', {
	              id: 'agree-add-coworker',
	              type: 'checkbox',
	              name: 'agree-add-coworker',
	              value: this.state.acceptAddCoworker,
	              onClick: this.handleAcceptAddCoworkerClick }),
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'agree-add-coworker' },
	              _ref6,
	              (0, _proxyCounterpart.proxyCounterpart)('ACCEPT_NEW_COWORKER')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'button-holder' },
	            _react2.default.createElement(
	              'a',
	              { className: 'btn outlined blue', onClick: this.props.close },
	              _ref7
	            ),
	            _react2.default.createElement(_components.SpinnerButton, { text: (0, _proxyCounterpart.proxyCounterpart)('ADD'),
	              loading: this.state.posting, disabled: !this.state.acceptAddCoworker, classes: 'btn' })
	          )
	        )
	      );
	    }
	  }]);
	  return AddNewCoworker;
	}(_react2.default.Component);
	
	exports.default = AddNewCoworker;

/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(12);
	
	var _distribution = __webpack_require__(914);
	
	var _distribution2 = _interopRequireDefault(_distribution);
	
	var _index = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    taxkeys: state.taxkeys,
	    invoice: state.invoice,
	    user: state.user
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    setTaxKeyId: function setTaxKeyId(taxkeyId) {
	      return dispatch((0, _index.setTaxKeyId)(taxkeyId));
	    },
	    setInvoiceUser: function setInvoiceUser(invoiceUsers) {
	      return dispatch((0, _index.setInvoiceUser)(invoiceUsers));
	    },
	    setAmount: function setAmount(invoiceAmount) {
	      return dispatch((0, _index.setAmount)(invoiceAmount));
	    },
	    setAmountIncVat: function setAmountIncVat(amountIncVat) {
	      return dispatch((0, _index.setAmountIncVat)(amountIncVat));
	    },
	    setLockAmountDistribution: function setLockAmountDistribution(lockAmountDistribution) {
	      return dispatch((0, _index.setLockAmountDistribution)(lockAmountDistribution));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_distribution2.default);

/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Distribution = undefined;
	
	var _getIterator2 = __webpack_require__(18);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _assign = __webpack_require__(22);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(233);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _reactModal = __webpack_require__(30);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _addCoworkerContainer = __webpack_require__(909);
	
	var _addCoworkerContainer2 = _interopRequireDefault(_addCoworkerContainer);
	
	var _addNewCoworkerContainer = __webpack_require__(911);
	
	var _addNewCoworkerContainer2 = _interopRequireDefault(_addNewCoworkerContainer);
	
	var _invoiceUserEntity = __webpack_require__(221);
	
	var _invoiceUserEntity2 = _interopRequireDefault(_invoiceUserEntity);
	
	var _components = __webpack_require__(13);
	
	var _helper = __webpack_require__(363);
	
	var _amountHelper = __webpack_require__(58);
	
	var _supplierLedgerContainer = __webpack_require__(922);
	
	var _supplierLedgerContainer2 = _interopRequireDefault(_supplierLedgerContainer);
	
	var _taxkeyService = __webpack_require__(119);
	
	var _taxkeyService2 = _interopRequireDefault(_taxkeyService);
	
	var _invoiceToolHelper = __webpack_require__(50);
	
	var _invoiceValidator = __webpack_require__(91);
	
	var _invoiceValidator2 = _interopRequireDefault(_invoiceValidator);
	
	var _distributionRows = __webpack_require__(916);
	
	var DistributionRows = _interopRequireWildcard(_distributionRows);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ = __webpack_require__(40); /**
	                            * Created by eriksundqvist on 13/05/16.
	                            */
	
	var CALCULATED_ITP = 'calculated-itp';
	var CALCULATED_ITP_TAX = 'calculated-itp-tax';
	var CALCULATED_VACATION_GROSS = 'calculated-vacation-gross';
	var CALCULATED_TAX = 'calculated-tax';
	var CALCULATED_EXPENSE = 'calculated-expense';
	var CALCULATED_TO_PAY = 'calculated-to-pay';
	var CALCULATED_TOTAL = 'calculated-total';
	var CALCULATED_INVOICERY_FEE = 'calculated_invoicery_fee';
	var CALCULATED_DISCOUNT = 'calculated_discount';
	var CALCULATED_PAYROLL_TAX = 'calculated_payroll_tax';
	var UPDATE_TAX_KEY = 'update-tax-key';
	var UPDATE_GROSS_SALARY = 'update-gross-salary';
	var UPDATE_NET_SALARY = 'update-net-salary';
	var UPDATE_ALLOWANCE = 'update-allowance';
	var UPDATE_TRAVEL = 'update-travel';
	var HOURLY_SALARY_VACATION_INCLUDED = 'hourly-salary-vacation-included';
	var HOURLY_SALARY_VACATION_EXCLUDED = 'hourly-salary-vacation-excluded';
	
	var _ref = _react2.default.createElement('div', { className: 'coworkers-divider' });
	
	var _ref2 = _react2.default.createElement(DistributionRows.Divider, null);
	
	var _ref3 = _react2.default.createElement(_reactTranslateComponent2.default, { className: 'bold', content: 'AMOUNT_TO_BILL_EXCL_VAT' });
	
	var _ref4 = _react2.default.createElement(DistributionRows.Divider, null);
	
	var _ref5 = _react2.default.createElement(DistributionRows.Divider, null);
	
	var _ref6 = _react2.default.createElement(DistributionRows.Divider, null);
	
	var _ref7 = _react2.default.createElement(DistributionRows.Divider, null);
	
	var _ref8 = _react2.default.createElement(DistributionRows.Divider, null);
	
	var _ref9 = _react2.default.createElement(DistributionRows.Divider, null);
	
	var _ref10 = _react2.default.createElement(DistributionRows.Divider, null);
	
	var _ref11 = _react2.default.createElement(
	  'div',
	  { className: 'details-row' },
	  _react2.default.createElement('div', { className: 'details-top-border' })
	);
	
	var _ref12 = _react2.default.createElement(
	  'p',
	  { className: 'error' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_ERROR_NEGATIVE_SALARY' })
	);
	
	var _ref13 = _react2.default.createElement(
	  'span',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { className: 'bold', content: 'TO_PAY_TO_MY_ACCOUNT' })
	);
	
	var _ref14 = _react2.default.createElement(_reactTranslateComponent2.default, { className: 'dark', content: 'ORDER_TOOL_TO_BE_PAID_ITP' });
	
	var _ref15 = _react2.default.createElement(_reactTranslateComponent2.default, { className: 'dark', content: 'ORDER_TOOL_TO_BE_PAID_VACATION' });
	
	var _ref16 = _react2.default.createElement(
	  'div',
	  { className: 'left-bg slim' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { className: 'dark', content: 'ORDER_TOOL_TO_BE_PAID_TOTAL' })
	);
	
	var _ref17 = _react2.default.createElement(
	  'div',
	  { className: 'left-bg slim' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { className: 'bold', content: 'TO_PAY_WORKER' })
	);
	
	var _ref18 = _react2.default.createElement(
	  'div',
	  { className: 'left-bg slim' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { className: 'dark', content: 'ORDER_TOOL_TO_BE_PAID_ITP_WORKER' })
	);
	
	var _ref19 = _react2.default.createElement(
	  'div',
	  { className: 'left-bg slim' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { className: 'dark', content: 'ORDER_TOOL_TO_BE_PAID_VACATION_WORKER' })
	);
	
	var _ref20 = _react2.default.createElement(
	  'div',
	  { className: 'left-bg slim' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { className: 'dark', content: 'ORDER_TOOL_TO_BE_PAID_TOTAL_WORKER' })
	);
	
	var _ref21 = _react2.default.createElement('span', null);
	
	var _ref22 = _react2.default.createElement(
	  'h3',
	  { className: 'form-header' },
	  _react2.default.createElement(
	    'span',
	    null,
	    '3'
	  ),
	  ' ',
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'MONEY_DISTRIBUTION' })
	);
	
	var _ref23 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SHOW_DETAILS' });
	
	var _ref24 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'HIDE_DETAILS' });
	
	var _ref25 = _react2.default.createElement(_reactTranslateComponent2.default, { className: 'bold', content: 'AMOUNT_TO_BILL_EXCL_VAT' });
	
	var _ref26 = _react2.default.createElement(DistributionRows.Divider, null);
	
	var _ref27 = _react2.default.createElement(DistributionRows.Divider, null);
	
	var _ref28 = _react2.default.createElement(DistributionRows.Divider, null);
	
	var _ref29 = _react2.default.createElement(DistributionRows.Divider, null);
	
	var _ref30 = _react2.default.createElement(DistributionRows.Divider, null);
	
	var _ref31 = _react2.default.createElement(DistributionRows.Divider, null);
	
	var _ref32 = _react2.default.createElement(DistributionRows.Divider, null);
	
	var _ref33 = _react2.default.createElement(DistributionRows.Divider, null);
	
	var _ref34 = _react2.default.createElement(DistributionRows.Divider, null);
	
	var _ref35 = _react2.default.createElement(DistributionRows.Divider, null);
	
	var _ref36 = _react2.default.createElement('div', null);
	
	var Distribution = exports.Distribution = function (_React$Component) {
	  (0, _inherits3.default)(Distribution, _React$Component);
	
	  function Distribution(props) {
	    (0, _classCallCheck3.default)(this, Distribution);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Distribution.__proto__ || (0, _getPrototypeOf2.default)(Distribution)).call(this, props));
	
	    _this.state = {
	      addCoworkersModalIsOpen: false,
	      addNewCoworkersModalIsOpen: false,
	      userTaxKey: props.user.defaultTaxkeyId,
	      justCalculated: null,
	      currencyName: 'SEK',
	      travelDeductionInfoRef: null,
	      changeValue: {
	        userId: null,
	        value: 0,
	        type: null
	      },
	      hideCalculation: true,
	      showLowHourlySalaryModal: true
	    };
	
	    _this.toggleDetails = _this.toggleDetails.bind(_this);
	    _this.toggleCalculation = _this.toggleCalculation.bind(_this);
	    _this.savedNewCoworker = _this.savedNewCoworker.bind(_this);
	    _this.onOpenAddCoworkerModal = _this.onOpenAddCoworkerModal.bind(_this);
	    _this.onCloseAddCoworkerModal = _this.onCloseAddCoworkerModal.bind(_this);
	    _this.onOpenAddNewCoworkerModal = _this.onOpenAddNewCoworkerModal.bind(_this);
	    _this.onCloseAddNewCoworkerModal = _this.onCloseAddNewCoworkerModal.bind(_this);
	    _this.getCoworkers = _this.getCoworkers.bind(_this);
	    _this.addCoworker = _this.addCoworker.bind(_this);
	    _this.getOmrKeys = _this.getOmrKeys.bind(_this);
	    _this.removeCoworker = _this.removeCoworker.bind(_this);
	    _this.amountInputBlur = _this.amountInputBlur.bind(_this);
	    _this.updateAmountFieldCurrency = _this.updateAmountFieldCurrency.bind(_this);
	    _this.setUserTaxKeyId = _this.setUserTaxKeyId.bind(_this);
	    _this.setInvoiceUserTaxKeyId = _this.setInvoiceUserTaxKeyId.bind(_this);
	    _this.setTaxKeyId = _this.setTaxKeyId.bind(_this);
	    _this.dummyOnChange = _this.dummyOnChange.bind(_this);
	    _this.lockAmountDistributionClick = _this.lockAmountDistributionClick.bind(_this);
	    _this.createInvoiceUserEntity = _this.createInvoiceUserEntity.bind(_this);
	    _this.getCalculationData = _this.getCalculationData.bind(_this);
	    _this.getHourlySalaryVacationExcluded = _this.getHourlySalaryVacationExcluded.bind(_this);
	    _this.grossSalaryInputBlur = _this.grossSalaryInputBlur.bind(_this);
	    _this.netSalaryInputBlur = _this.netSalaryInputBlur.bind(_this);
	    _this.allowanceBlur = _this.allowanceBlur.bind(_this);
	    _this.travelBlur = _this.travelBlur.bind(_this);
	    _this.setLockAmountDistribution = _this.setLockAmountDistribution.bind(_this);
	    _this.getTaxKeyIdByUserId = _this.getTaxKeyIdByUserId.bind(_this);
	    _this.updateInvoiceUser = _this.updateInvoiceUser.bind(_this);
	    _this.disableOnLock = _this.disableOnLock.bind(_this);
	    _this.renderLowHourlySalaryModal = _this.renderLowHourlySalaryModal.bind(_this);
	    _this.closeLowHourlySalaryModal = _this.closeLowHourlySalaryModal.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(Distribution, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!_.isEqual(nextProps, this.props)) {
	        if (!_.isEqual(nextProps.invoice.invoiceUser, this.props.invoice.invoiceUser)) {
	          for (var i = 0; i < nextProps.invoice.invoiceUser.length; i++) {
	            var user = nextProps.invoice.invoiceUser[i];
	            var prevUser = this.props.invoice.invoiceUser[i];
	            if (user.calculation && prevUser && !_.isEqual(user.calculation, prevUser.calculation)) {
	              this.refs['invoice-amount-' + user.userId].value = (0, _amountHelper.toMoney)(user.calculation.amount);
	            }
	
	            if (user && prevUser && !_.isEqual(user.taxkeys, prevUser.taxkeys)) {
	              this.setTaxKeyId(user.id, user.defaultTaxkeyId);
	            }
	          }
	        }
	
	        if (nextProps.invoice.lockAmountDistribution) {
	          var nextLockAmountLength = (0, _keys2.default)(nextProps.invoice.lockAmountDistribution).length;
	          var prevLockAmountLength = (0, _keys2.default)(this.props.invoice.lockAmountDistribution).length;
	          if (nextLockAmountLength !== prevLockAmountLength) {
	            for (var userId in nextProps.invoice.lockAmountDistribution) {
	              this.refs['lock-amount-distribution-' + userId].checked = true;
	            }
	          }
	        }
	
	        var taxKeyHasChanged = nextProps.user.defaultTaxkeyId !== this.props.user.defaultTaxkeyId;
	
	        if (!nextProps.invoice.invoiceId && taxKeyHasChanged) {
	          this.setState({ userTaxKey: nextProps.user.defaultTaxkeyId });
	          this.setTaxKeyId(nextProps.user.id, nextProps.user.defaultTaxkeyId);
	        } else if (nextProps.invoice.invoiceId) {
	          this.setState({ userTaxKey: this.getTaxKeyIdByUserId(nextProps.user.id) });
	        }
	      }
	    }
	  }, {
	    key: 'createInvoiceUserEntity',
	    value: function createInvoiceUserEntity(workerEntity) {
	      var invoiceUserEntity = new _invoiceUserEntity2.default(0, workerEntity.address ? workerEntity.address.co : workerEntity.co, workerEntity.address ? workerEntity.address.street : workerEntity.street, workerEntity.address ? workerEntity.address.zip : workerEntity.street, workerEntity.address ? workerEntity.address.city : workerEntity.street, workerEntity.address ? workerEntity.address.country : workerEntity.street, null, workerEntity.id, 0, workerEntity.defaultTaxkeyId, 0, workerEntity.firstName, workerEntity.lastName, workerEntity.accountClearingNumber || workerEntity.accountClearingNr, workerEntity.accountNumber || workerEntity.accountNr, null, false, '', workerEntity.saveVacationPay, workerEntity.saveItp, workerEntity.itpRate);
	
	      return invoiceUserEntity;
	    }
	  }, {
	    key: 'toggleDetails',
	    value: function toggleDetails() {
	      var hideDetailsStyle = this.refs.hideDetails.offsetParent ? 'none' : 'block';
	      var showDetailsStyle = this.refs.showDetails.offsetParent ? 'none' : 'block';
	      var showSummationStyle = this.refs.showSummation.offsetParent ? 'none' : 'flex';
	      var detailsStyle = this.refs.details.offsetParent ? 'none' : 'block';
	
	      this.refs.hideDetails.style.display = hideDetailsStyle;
	      this.refs.showDetails.style.display = showDetailsStyle;
	      this.refs.showSummation.style.display = showSummationStyle;
	      this.refs.details.style.display = detailsStyle;
	    }
	  }, {
	    key: 'toggleCalculation',
	    value: function toggleCalculation() {
	      var calculationStyle = this.refs.calculation.offsetParent ? 'none' : 'block';
	      this.refs.calculation.style.display = calculationStyle;
	
	      this.setState({
	        hideCalculation: !this.state.hideCalculation
	      });
	    }
	  }, {
	    key: 'renderAddCoworkerModal',
	    value: function renderAddCoworkerModal() {
	      return _react2.default.createElement(
	        _reactModal2.default,
	        {
	          className: 'modal',
	          contentLabel: '',
	          isOpen: this.state.addCoworkersModalIsOpen },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-content' },
	          _react2.default.createElement('button', { className: 'close', onClick: this.onCloseAddCoworkerModal }),
	          _react2.default.createElement(_addCoworkerContainer2.default, {
	            close: this.onCloseAddCoworkerModal,
	            addNewCoworker: this.onOpenAddNewCoworkerModal,
	            addCoworker: this.addCoworker })
	        )
	      );
	    }
	  }, {
	    key: 'renderAddNewCoworkerModal',
	    value: function renderAddNewCoworkerModal() {
	      return _react2.default.createElement(
	        _reactModal2.default,
	        {
	          className: 'modal',
	          contentLabel: '',
	          isOpen: this.state.addNewCoworkersModalIsOpen },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-content' },
	          _react2.default.createElement('button', { className: 'close', onClick: this.onCloseAddNewCoworkerModal }),
	          _react2.default.createElement(_addNewCoworkerContainer2.default, { close: this.onCloseAddNewCoworkerModal, savedNewCoworker: this.savedNewCoworker })
	        )
	      );
	    }
	  }, {
	    key: 'addCoworker',
	    value: function addCoworker(workerEntity) {
	      var _this2 = this;
	
	      _taxkeyService2.default.getWorkerTaxkeys(workerEntity.id).then(function (response) {
	        var newInvoiceUser = _this2.createInvoiceUserEntity(workerEntity);
	        newInvoiceUser.taxkeys = response;
	        var invoiceUser = _.map(_this2.props.invoice.invoiceUser, function (user) {
	          return (0, _assign2.default)({}, user);
	        });
	        invoiceUser.push(newInvoiceUser);
	        _this2.props.setInvoiceUser(invoiceUser);
	        _this2.onCloseAddCoworkerModal();
	      });
	    }
	  }, {
	    key: 'savedNewCoworker',
	    value: function savedNewCoworker() {
	      this.onOpenAddCoworkerModal();
	    }
	  }, {
	    key: 'onOpenAddCoworkerModal',
	    value: function onOpenAddCoworkerModal(event) {
	      this.setState({
	        addNewCoworkersModalIsOpen: false,
	        addCoworkersModalIsOpen: true
	      });
	    }
	  }, {
	    key: 'onOpenAddNewCoworkerModal',
	    value: function onOpenAddNewCoworkerModal(event) {
	      this.setState({
	        addCoworkersModalIsOpen: false,
	        addNewCoworkersModalIsOpen: true
	      });
	    }
	  }, {
	    key: 'onCloseAddCoworkerModal',
	    value: function onCloseAddCoworkerModal(event) {
	      this.setState({
	        addCoworkersModalIsOpen: false
	      });
	    }
	  }, {
	    key: 'onCloseAddNewCoworkerModal',
	    value: function onCloseAddNewCoworkerModal(event) {
	      this.setState({
	        addNewCoworkersModalIsOpen: false,
	        addCoworkersModalIsOpen: true
	      });
	    }
	  }, {
	    key: 'setLockAmountDistribution',
	    value: function setLockAmountDistribution(userId, forceSetting) {
	      var lockAmountDistribution = (0, _assign2.default)({}, this.props.invoice.lockAmountDistribution);
	      var forceLock = !(forceSetting === undefined || forceSetting === false);
	
	      if (lockAmountDistribution[userId] === undefined && !forceLock) {
	        delete lockAmountDistribution[userId];
	      } else if (lockAmountDistribution[userId] && forceLock) {
	        delete lockAmountDistribution[userId];
	      } else {
	        lockAmountDistribution[userId] = true;
	        this.refs['lock-amount-distribution-' + userId].checked = true;
	      }
	
	      this.props.setLockAmountDistribution(lockAmountDistribution);
	    }
	  }, {
	    key: 'lockAmountDistributionClick',
	    value: function lockAmountDistributionClick(event) {
	      var invoiceUserId = event.target.id.replace('lock-amount-distribution-', '');
	      this.setLockAmountDistribution(invoiceUserId, true);
	    }
	  }, {
	    key: 'removeCoworker',
	    value: function removeCoworker(invoiceUserId) {
	      var invoiceUser = _.map(this.props.invoice.invoiceUser, function (user) {
	        return (0, _assign2.default)({}, user);
	      });
	      invoiceUser = _.remove(invoiceUser, function (o) {
	        return parseInt(o.userId) !== parseInt(invoiceUserId);
	      });
	      this.setLockAmountDistribution(invoiceUserId, false);
	      this.props.setInvoiceUser(invoiceUser);
	    }
	  }, {
	    key: 'getOmrKeys',
	    value: function getOmrKeys(taxkeys) {
	      return taxkeys.map(function (taxkey, i) {
	        var taxKeyName = taxkey.taxkeyName;
	
	        if (taxkey.payrollTax === 19.73) {
	          taxKeyName = taxkey.taxAmount + '%, 19-23 ' + (0, _proxyCounterpart.proxyCounterpart)('YEARS');
	        }
	
	        return _react2.default.createElement(
	          'option',
	          { value: taxkey.id, key: i },
	          taxKeyName
	        );
	      });
	    }
	  }, {
	    key: 'amountInputBlur',
	    value: function amountInputBlur(event) {
	      var total = event.target.value;
	      total = (0, _invoiceToolHelper.reformatInputValue)(total);
	      var allInvoiceUser = _.map(this.props.invoice.invoiceUser, function (user) {
	        return (0, _assign2.default)({}, user);
	      });
	
	      var invoiceUserId = event.target.id.replace('invoice-amount-', '');
	      this.setLockAmountDistribution(invoiceUserId, false);
	      var invoiceUserEntity = void 0;
	
	      for (var i = 0; i < allInvoiceUser.length; i++) {
	        if (parseInt(allInvoiceUser[i].userId) === parseInt(invoiceUserId)) {
	          invoiceUserEntity = allInvoiceUser[i];
	        }
	      }
	
	      invoiceUserEntity.total = total;
	      this.refs['invoice-amount-' + invoiceUserId].value = total;
	
	      var invoiceUser = (0, _helper.processInvoiceUser)(invoiceUserEntity, allInvoiceUser);
	
	      this.props.setInvoiceUser(invoiceUser);
	    }
	  }, {
	    key: 'updateAmountFieldCurrency',
	    value: function updateAmountFieldCurrency() {
	      var allInvoiceUser = _.map(this.props.invoice.invoiceUser, function (user) {
	        return (0, _assign2.default)({}, user);
	      });
	      for (var i = 0; i < allInvoiceUser.length; i++) {
	        var amountInput = this.refs['invoice-amount-' + allInvoiceUser[i].userId];
	        if (amountInput) {
	          amountInput.value = amountInput.value;
	        }
	      }
	    }
	  }, {
	    key: 'setUserTaxKeyId',
	    value: function setUserTaxKeyId(event) {
	      var invoiceUserId = event.target.id.replace('invoice-taxkeyid-', '');
	      var taxkeyId = event.target.value;
	      this.setState({ userTaxKey: taxkeyId });
	      this.setTaxKeyId(invoiceUserId, taxkeyId);
	    }
	  }, {
	    key: 'setInvoiceUserTaxKeyId',
	    value: function setInvoiceUserTaxKeyId(event) {
	      var invoiceUserId = event.target.id.replace('invoice-taxkeyid-', '');
	      var taxkeyId = event.target.value;
	      this.setTaxKeyId(invoiceUserId, taxkeyId);
	    }
	  }, {
	    key: 'setTaxKeyId',
	    value: function setTaxKeyId(userId, taxkeyId) {
	      this.updateInvoiceUser(userId, UPDATE_TAX_KEY, taxkeyId);
	    }
	
	    /*
	    Needed to avoid warning on inputs only using onBlur
	     */
	
	  }, {
	    key: 'dummyOnChange',
	    value: function dummyOnChange(e) {}
	  }, {
	    key: 'updateInvoiceUser',
	    value: function updateInvoiceUser(invoiceUserId, update, value) {
	      var allInvoiceUser = _.map(this.props.invoice.invoiceUser, function (user) {
	        return (0, _assign2.default)({}, user);
	      });
	
	      var invoiceUserPostEntity = void 0;
	      for (var i = 0; i < allInvoiceUser.length; i++) {
	        if (parseInt(invoiceUserId) === parseInt(allInvoiceUser[i].userId)) {
	          invoiceUserPostEntity = allInvoiceUser[i];
	        }
	      }
	
	      var invoiceUser = [];
	
	      if (invoiceUserPostEntity) {
	        switch (update) {
	          case UPDATE_TAX_KEY:
	            var taxKey = void 0;
	            for (var _i = 0; _i < invoiceUserPostEntity.taxkeys.length; _i++) {
	              if (parseInt(invoiceUserPostEntity.taxkeys[_i].id) === parseInt(value)) {
	                taxKey = invoiceUserPostEntity.taxkeys[_i];
	                break;
	              }
	            }
	
	            if (taxKey) {
	              invoiceUserPostEntity.taxkeyId = taxKey.id;
	              invoiceUserPostEntity.payroll_tax = taxKey.payrollTax;
	            }
	            break;
	
	          case UPDATE_GROSS_SALARY:
	            invoiceUserPostEntity.gross = value;
	            break;
	
	          case UPDATE_NET_SALARY:
	            invoiceUserPostEntity.net = value;
	            break;
	
	          case UPDATE_ALLOWANCE:
	            invoiceUserPostEntity.allowance = value;
	            break;
	
	          case UPDATE_TRAVEL:
	            invoiceUserPostEntity.travel = value;
	            break;
	        }
	
	        invoiceUser = (0, _helper.processInvoiceUser)(invoiceUserPostEntity, allInvoiceUser);
	        this.props.setInvoiceUser(invoiceUser);
	      }
	    }
	  }, {
	    key: 'grossSalaryInputBlur',
	    value: function grossSalaryInputBlur(event) {
	      var invoiceUserId = event.target.id.replace('invoice-gross-', '');
	      var grossSalaryValue = event.target.value;
	
	      grossSalaryValue = (0, _invoiceToolHelper.reformatInputValue)(grossSalaryValue);
	
	      this.setLockAmountDistribution(invoiceUserId, false);
	      this.updateInvoiceUser(invoiceUserId, UPDATE_GROSS_SALARY, grossSalaryValue);
	    }
	  }, {
	    key: 'netSalaryInputBlur',
	    value: function netSalaryInputBlur(event) {
	      var invoiceUserId = event.target.id.replace('invoice-net-', '');
	      var netSalaryValue = event.target.value;
	
	      netSalaryValue = (0, _invoiceToolHelper.reformatInputValue)(netSalaryValue);
	
	      this.setLockAmountDistribution(invoiceUserId, false);
	      this.updateInvoiceUser(invoiceUserId, UPDATE_NET_SALARY, netSalaryValue);
	    }
	  }, {
	    key: 'disableOnLock',
	    value: function disableOnLock(userId) {
	      return this.props.invoice.lockAmountDistribution[userId] !== undefined;
	    }
	  }, {
	    key: 'allowanceBlur',
	    value: function allowanceBlur(event) {
	      var invoiceUserId = event.target.id.replace('invoice-allowance-', '');
	      var allowanceValue = event.target.value;
	
	      allowanceValue = (0, _invoiceToolHelper.reformatInputValue)(allowanceValue);
	
	      if (allowanceValue === null) {
	        this.refs[event.target.id].value = '0';
	        allowanceValue = 0;
	      }
	
	      this.updateInvoiceUser(invoiceUserId, UPDATE_ALLOWANCE, allowanceValue);
	    }
	  }, {
	    key: 'travelBlur',
	    value: function travelBlur(event) {
	      var invoiceUserId = event.target.id.replace('invoice-travel-', '');
	      var travelValue = event.target.value;
	
	      travelValue = (0, _invoiceToolHelper.reformatInputValue)(travelValue);
	
	      if (travelValue === null) {
	        this.refs[event.target.id].value = '0';
	        travelValue = 0;
	      }
	
	      this.updateInvoiceUser(invoiceUserId, UPDATE_TRAVEL, travelValue);
	    }
	  }, {
	    key: 'focus',
	    value: function focus(e) {
	      e.target.select();
	    }
	  }, {
	    key: 'setChangeValue',
	    value: function setChangeValue(value, userId, type) {
	      this.setState({
	        changeValue: {
	          type: type,
	          value: value,
	          userId: userId
	        }
	      });
	    }
	  }, {
	    key: 'getCoworkers',
	    value: function getCoworkers() {
	      var getOmrKeys = this.getOmrKeys;
	      var removeCoworker = this.removeCoworker;
	      var amountInputBlur = this.amountInputBlur;
	      var setInvoiceUserTaxKeyId = this.setInvoiceUserTaxKeyId;
	      var currencyName = this.state.currencyName;
	      var changeValue = this.state.changeValue;
	      var setChangeValue = this.setChangeValue.bind(this);
	      var loggedInUserId = this.props.user.id;
	      var getCalculationData = this.getCalculationData;
	      var grossSalaryInputBlur = this.grossSalaryInputBlur;
	      var netSalaryInputBlur = this.netSalaryInputBlur;
	      var allowanceBlur = this.allowanceBlur;
	      var travelBlur = this.travelBlur;
	      var disableOnLock = this.disableOnLock;
	      var focus = this.focus;
	      var renderWorkerSumAccount = this.renderWorkerSumAccount;
	      var renderWorkerSumItp = this.renderWorkerSumItp;
	      var renderWorkerSumVacation = this.renderWorkerSumVacation;
	      var renderworkerSumTotal = this.renderworkerSumTotal;
	      var renderLockAmountContainer = this.renderLockAmountContainer.bind(this);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.invoice.invoiceUser.map(function (invoiceUser, i) {
	          if (parseInt(invoiceUser.userId) === parseInt(loggedInUserId)) {
	            return;
	          }
	
	          return _react2.default.createElement(
	            'div',
	            { key: i },
	            _ref,
	            _react2.default.createElement(DistributionRows.CoworkerName, {
	              invoiceUser: invoiceUser,
	              coworkerId: +invoiceUser.userId,
	              removeCoworker: removeCoworker
	            }),
	            _ref2,
	            _react2.default.createElement(
	              'div',
	              { className: 'invoice-amount' },
	              _react2.default.createElement(
	                'div',
	                { className: 'details-left' },
	                _ref3,
	                renderLockAmountContainer('hide-until-mobile', invoiceUser.userId)
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'details-right' },
	                renderLockAmountContainer('hide-mobile', invoiceUser.userId),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'currency-input-holder', 'data-currency': currencyName },
	                  _react2.default.createElement('input', {
	                    type: 'text',
	                    id: 'invoice-amount-' + invoiceUser.userId,
	                    ref: 'invoice-amount-' + invoiceUser.userId,
	                    onBlur: amountInputBlur,
	                    disabled: disableOnLock(invoiceUser.userId),
	                    onClick: focus,
	                    defaultValue: '0'
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(DistributionRows.InvoiceryFee, {
	              calculation: getCalculationData(invoiceUser.userId, CALCULATED_INVOICERY_FEE)
	            }),
	            _ref4,
	            _react2.default.createElement(DistributionRows.PayrollTax, {
	              calculation: getCalculationData(invoiceUser.userId, CALCULATED_PAYROLL_TAX)
	            }),
	            _ref5,
	            _react2.default.createElement(DistributionRows.Gross, {
	              invoiceUser: invoiceUser,
	              value: changeValue,
	              disabled: disableOnLock(invoiceUser.userId),
	              focus: focus,
	              currencyName: currencyName,
	              onBlur: grossSalaryInputBlur,
	              onChange: function onChange(event) {
	                setChangeValue(event.target.value, invoiceUser.userId, 'GROSS');
	              }
	            }),
	            _ref6,
	            _react2.default.createElement(DistributionRows.SelectTax, {
	              title: 'OMR_KEY',
	              invoiceUser: invoiceUser,
	              onChange: setInvoiceUserTaxKeyId,
	              disabled: disableOnLock(invoiceUser.userId),
	              options: getOmrKeys(invoiceUser.taxkeys)
	            }),
	            _ref7,
	            _react2.default.createElement(DistributionRows.Tax, {
	              calculation: getCalculationData(invoiceUser.userId, CALCULATED_TAX)
	            }),
	            _ref8,
	            _react2.default.createElement(DistributionRows.Net, {
	              invoiceUser: invoiceUser,
	              value: changeValue,
	              disabled: disableOnLock(invoiceUser.userId),
	              focus: focus,
	              currencyName: currencyName,
	              onBlur: netSalaryInputBlur,
	              onChange: function onChange(event) {
	                setChangeValue(event.target.value, invoiceUser.userId, 'NET');
	              }
	            }),
	            _ref9,
	            _react2.default.createElement(DistributionRows.Allowance, {
	              invoiceUser: invoiceUser,
	              value: changeValue,
	              disabled: disableOnLock(invoiceUser.userId),
	              focus: focus,
	              currencyName: currencyName,
	              onBlur: allowanceBlur,
	              onChange: function onChange(event) {
	                setChangeValue(event.target.value, invoiceUser.userId, 'ALLOWANCE');
	              }
	            }),
	            _ref10,
	            _react2.default.createElement(DistributionRows.Travel, {
	              invoiceUser: invoiceUser,
	              value: changeValue,
	              disabled: disableOnLock(invoiceUser.userId),
	              focus: focus,
	              currencyName: currencyName,
	              onBlur: travelBlur,
	              onChange: function onChange(event) {
	                setChangeValue(event.target.value, invoiceUser.userId, 'TRAVEL');
	              }
	            }),
	            _react2.default.createElement('div', { style: { clear: 'both' } }),
	            _ref11,
	            renderWorkerSumAccount(getCalculationData(invoiceUser.userId, CALCULATED_TO_PAY)),
	            renderWorkerSumItp(invoiceUser, getCalculationData(invoiceUser.userId, CALCULATED_ITP)),
	            renderWorkerSumVacation(invoiceUser, getCalculationData(invoiceUser.userId, CALCULATED_VACATION_GROSS)),
	            renderworkerSumTotal(invoiceUser, getCalculationData(invoiceUser.userId, CALCULATED_TOTAL))
	          );
	        })
	      );
	    }
	  }, {
	    key: 'getCalculationData',
	    value: function getCalculationData(userId, data) {
	      var user = void 0;
	      for (var i = 0; i < this.props.invoice.invoiceUser.length; i++) {
	        if (parseInt(this.props.invoice.invoiceUser[i].userId) === parseInt(userId)) {
	          user = this.props.invoice.invoiceUser[i];
	          break;
	        }
	      }
	
	      var originalFee = 6.0;
	      var discountFee = 0;
	      var invoiceUserTaxKey = user.taxkeys.find(function (taxkey) {
	        return +taxkey.id === user.taxkeyId;
	      });
	      if (invoiceUserTaxKey) {
	        originalFee = this.props.invoice.expressPayment ? invoiceUserTaxKey.feeExpress + invoiceUserTaxKey.feeDiscount : invoiceUserTaxKey.fee + invoiceUserTaxKey.feeDiscount;
	        discountFee = invoiceUserTaxKey.feeDiscount;
	      }
	
	      var value = void 0;
	
	      if (user && user.calculation) {
	        switch (data) {
	          case CALCULATED_ITP:
	            value = +user.calculation.itp;
	            break;
	          case CALCULATED_ITP_TAX:
	            value = +user.calculation.itpTax;
	            break;
	          case CALCULATED_VACATION_GROSS:
	            value = +user.calculation.vacationGross;
	            break;
	          case CALCULATED_TAX:
	            value = +user.calculation.tax;
	            break;
	          case CALCULATED_EXPENSE:
	            value = +user.calculation.expense;
	            break;
	          case CALCULATED_TO_PAY:
	            value = +user.calculation.toPay;
	            break;
	          case CALCULATED_TOTAL:
	            value = +(user.calculation.toPay + user.calculation.itp + user.calculation.vacationGross);
	            break;
	          case CALCULATED_INVOICERY_FEE:
	            value = +(user.calculation.amount * (originalFee / 100));
	            break;
	          case CALCULATED_DISCOUNT:
	            value = -(user.calculation.amount * (discountFee / 100));
	            break;
	          case CALCULATED_PAYROLL_TAX:
	            value = +user.calculation.totalPayrollTax;
	            break;
	          case HOURLY_SALARY_VACATION_INCLUDED:
	            value = this.getHourlySalary(user.calculation.gross + user.calculation.vacationGross);
	            break;
	          case HOURLY_SALARY_VACATION_EXCLUDED:
	            value = this.getHourlySalaryVacationExcluded(user);
	            break;
	        }
	      }
	
	      if (value === undefined) {
	        value = 0;
	      }
	
	      if ([HOURLY_SALARY_VACATION_INCLUDED, HOURLY_SALARY_VACATION_EXCLUDED].includes(data)) {
	        return value ? (0, _amountHelper.toMoney)(value) + ' ' + this.state.currencyName : '-';
	      }
	
	      return (0, _amountHelper.toMoney)(value) + ' ' + this.state.currencyName;
	    }
	  }, {
	    key: 'getHourlySalaryVacationExcluded',
	    value: function getHourlySalaryVacationExcluded(user) {
	      var value = 0;
	      if (user.calculation.vacationGross === 0) {
	        value = this.getHourlySalary(user.calculation.gross / 1.12);
	      } else {
	        value = this.getHourlySalary(user.calculation.gross);
	      }
	      return value;
	    }
	  }, {
	    key: 'getHourlySalary',
	    value: function getHourlySalary(amount) {
	      var invoiceDates = this.props.invoice.invoiceDate;
	      var value = 0;
	      if (invoiceDates.length) {
	        var hoursWorked = invoiceDates.reduce(function (previous, current) {
	          return previous + current.hours;
	        }, 0);
	        value = +amount / hoursWorked;
	      }
	      return value;
	    }
	  }, {
	    key: 'getTaxKeyIdByUserId',
	    value: function getTaxKeyIdByUserId(userId) {
	      var invoiceUser = void 0;
	      for (var i = 0; i < this.props.invoice.invoiceUser.length; i++) {
	        if (parseInt(this.props.invoice.invoiceUser[i].userId) === parseInt(userId)) {
	          invoiceUser = this.props.invoice.invoiceUser[i];
	          break;
	        }
	      }
	
	      return invoiceUser && invoiceUser.taxkeyId ? invoiceUser.taxkeyId : '';
	    }
	  }, {
	    key: 'getInvoiceOwnerAmount',
	    value: function getInvoiceOwnerAmount(userId) {
	      var invoiceOwnerAmount = 0;
	      var invoiceUser = this.props.invoice.invoiceUser;
	      for (var i = 0; i < invoiceUser.length; i++) {
	        if (invoiceUser[i].calculation && parseInt(invoiceUser[i].userId) === parseInt(userId)) {
	          invoiceOwnerAmount = invoiceUser[i].calculation.amount;
	          break;
	        }
	      }
	      return invoiceOwnerAmount;
	    }
	  }, {
	    key: 'getTotalExpenses',
	    value: function getTotalExpenses(userId) {
	      var totalExpenses = 0;
	      var invoiceUser = this.props.invoice.invoiceUser;
	      for (var i = 0; i < invoiceUser.length; i++) {
	        if (invoiceUser[i].calculation && parseInt(invoiceUser[i].userId) === parseInt(userId)) {
	          totalExpenses = invoiceUser[i].calculation.expense;
	          break;
	        }
	      }
	      return totalExpenses;
	    }
	  }, {
	    key: 'renderError',
	    value: function renderError() {
	      if (!_invoiceValidator2.default.validatePositiveAmount(this.props.invoice.invoiceUser)) {
	        return _ref12;
	      }
	    }
	  }, {
	    key: 'renderSumAccount',
	    value: function renderSumAccount(user, value) {
	      var slimBox = user.saveVacationPay || user.saveITP || user.saveItp ? ' slim' : '';
	      return _react2.default.createElement(
	        'div',
	        { className: 'green-box' },
	        _react2.default.createElement(
	          'div',
	          { className: 'left-bg' + slimBox },
	          _ref13
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'right-bg' + slimBox },
	          _react2.default.createElement(
	            'span',
	            { className: 'bold' },
	            value
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderSumItp',
	    value: function renderSumItp(user, value) {
	      if (user.saveITP || user.saveItp) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'green-box light' },
	          _react2.default.createElement(
	            'div',
	            { className: 'left-bg slim' },
	            _ref14,
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(_components.ToolTip, { id: 'toSaveToItp',
	                buttonClasses: 'tooltip-info-button',
	                msg: (0, _proxyCounterpart.proxyCounterpart)('TOOLTIP_ORDER_TOOL_TO_BE_PAID_ITP') })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'right-bg slim' },
	            _react2.default.createElement(
	              'span',
	              { className: 'dark' },
	              '+ ',
	              value
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderSumVacation',
	    value: function renderSumVacation(user, value) {
	      if (user.saveVacationPay) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'green-box light' },
	          _react2.default.createElement(
	            'div',
	            { className: 'left-bg slim' },
	            _ref15,
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(_components.ToolTip, { id: 'toSaveToVacation',
	                buttonClasses: 'tooltip-info-button',
	                msg: (0, _proxyCounterpart.proxyCounterpart)('TOOLTIP_ORDER_TOOL_TO_BE_PAID_VACATION') })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'right-bg slim' },
	            _react2.default.createElement(
	              'span',
	              { className: 'dark' },
	              '+ ',
	              value
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderSumTotal',
	    value: function renderSumTotal(user, value) {
	      if (user.saveVacationPay || user.saveITP || user.saveItp) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'green-box white' },
	          _ref16,
	          _react2.default.createElement(
	            'div',
	            { className: 'right-bg slim' },
	            _react2.default.createElement(
	              'span',
	              { className: 'dark' },
	              '= ',
	              value
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderWorkerSumAccount',
	    value: function renderWorkerSumAccount(value) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'green-box' },
	        _ref17,
	        _react2.default.createElement(
	          'div',
	          { className: 'right-bg slim' },
	          _react2.default.createElement(
	            'span',
	            { className: 'bold' },
	            value
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderWorkerSumItp',
	    value: function renderWorkerSumItp(user, value) {
	      if (user.saveITP || user.saveItp) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'green-box light' },
	          _ref18,
	          _react2.default.createElement(
	            'div',
	            { className: 'right-bg slim' },
	            _react2.default.createElement(
	              'span',
	              { className: 'dark' },
	              '+ ',
	              value
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderWorkerSumVacation',
	    value: function renderWorkerSumVacation(user, value) {
	      if (user.saveVacationPay) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'green-box light' },
	          _ref19,
	          _react2.default.createElement(
	            'div',
	            { className: 'right-bg slim' },
	            _react2.default.createElement(
	              'span',
	              { className: 'dark' },
	              '+ ',
	              value
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderworkerSumTotal',
	    value: function renderworkerSumTotal(user, value) {
	      if (user.saveVacationPay || user.saveITP || user.saveItp) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'green-box white' },
	          _ref20,
	          _react2.default.createElement(
	            'div',
	            { className: 'right-bg slim' },
	            _react2.default.createElement(
	              'span',
	              { className: 'dark' },
	              '= ',
	              value
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'getOutlaySum',
	    value: function getOutlaySum(supplierLedgers) {
	      var sum = 0;
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(supplierLedgers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var s = _step.value;
	
	          sum += parseFloat(s.amount);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return sum;
	    }
	  }, {
	    key: 'renderOutlaySum',
	    value: function renderOutlaySum() {
	      var sum = this.getOutlaySum(this.props.invoice.supplierLedger);
	      return _react2.default.createElement(
	        'span',
	        null,
	        (0, _amountHelper.toMoney)(sum),
	        ' ',
	        this.state.currencyName
	      );
	    }
	  }, {
	    key: 'renderLockAmountContainer',
	    value: function renderLockAmountContainer(hide, userId) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'lock-amount-container ' + hide },
	        _react2.default.createElement(_components.ToolTip, { id: 'checkbox', msg: (0, _proxyCounterpart.proxyCounterpart)('TOOLTIP_CHECKBOX') }),
	        _react2.default.createElement(
	          'p',
	          { 'data-tip': (0, _proxyCounterpart.proxyCounterpart)('LOCK_AMOUNT') },
	          _react2.default.createElement('input', {
	            type: 'checkbox',
	            name: 'lock-amount-distribution',
	            id: 'lock-amount-distribution-' + userId,
	            ref: 'lock-amount-distribution-' + userId,
	            onClick: this.lockAmountDistributionClick }),
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'lock-amount-distribution-' + userId },
	            _ref21
	          )
	        )
	      );
	    }
	  }, {
	    key: 'closeLowHourlySalaryModal',
	    value: function closeLowHourlySalaryModal() {
	      this.setState({
	        showLowHourlySalaryModal: false
	      });
	    }
	  }, {
	    key: 'renderLowHourlySalaryModal',
	    value: function renderLowHourlySalaryModal() {
	      var invoiceUser = this.props.invoice.invoiceUser[0];
	
	      if (invoiceUser.calculation) {
	        var hourlySalary = this.getHourlySalaryVacationExcluded(invoiceUser);
	        var lowHourlySalaryAmount = (0, _amountHelper.getLowHourlySalaryAmount)(this.props.user);
	        var gross = invoiceUser.calculation.gross;
	        var amount = invoiceUser.calculation.amount;
	        var hours = gross / hourlySalary;
	        var hoursNeeded = gross / lowHourlySalaryAmount;
	        var amountNeeded = amount / hoursNeeded * hours;
	
	        if (this.state.showLowHourlySalaryModal && hourlySalary !== 0 && hourlySalary < lowHourlySalaryAmount) {
	          return _react2.default.createElement(_components.CloseModal, {
	            headline: (0, _proxyCounterpart.proxyCounterpart)('LOW_HOURLY_SALARY_MODAL_TITLE'),
	            body: (0, _proxyCounterpart.proxyCounterpart)('LOW_HOURLY_SALARY_MODAL_BODY', {
	              minimumHourlySalary: lowHourlySalaryAmount,
	              currentHourlySalary: '' + (0, _amountHelper.toMoney)(hourlySalary),
	              addAmount: '' + (0, _amountHelper.toMoney)(amountNeeded - amount),
	              removeHours: '' + (0, _amountHelper.toMoney)(hours - hoursNeeded)
	            }),
	            close: this.closeLowHourlySalaryModal
	          });
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var coworkers = this.getCoworkers.bind(this);
	      var getOmrKeys = this.getOmrKeys;
	      var getCalculationData = this.getCalculationData;
	      var setUserTaxKeyId = this.setUserTaxKeyId;
	      var disableOnLock = this.disableOnLock;
	
	      var invoiceUser = this.props.invoice.invoiceUser.find(function (invoiceUser) {
	        return +invoiceUser.userId === +_this3.props.user.id;
	      });
	      if (invoiceUser) {
	        var taxkey = invoiceUser.taxkeys.find(function (taxkey) {
	          return +taxkey.id === invoiceUser.taxkeyId;
	        });
	        var discount = void 0;
	        if (taxkey) {
	          discount = +taxkey.feeDiscount;
	        }
	        return _react2.default.createElement(
	          'div',
	          { className: 'distribution-holder' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _ref22,
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(_reactTranslateComponent2.default, { content: this.props.translationPrefix + 'MONEY_DISTRIBUTION_TEXT' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'distribution' },
	            _react2.default.createElement(
	              'div',
	              { className: 'hide-show-details' },
	              _react2.default.createElement(
	                'div',
	                { className: 'showDetails', ref: 'showDetails', onClick: this.toggleDetails },
	                '+ ',
	                _ref23
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'hideDetails', ref: 'hideDetails', onClick: this.toggleDetails },
	                '- ',
	                _ref24
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'details detailsDisplayNone', ref: 'details' },
	              _react2.default.createElement(
	                'div',
	                { className: 'invoice-amount' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'details-left' },
	                  _ref25,
	                  this.renderLockAmountContainer('hide-until-mobile', invoiceUser.userId)
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'details-right' },
	                  this.renderLockAmountContainer('hide-mobile', invoiceUser.userId),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'currency-input-holder', 'data-currency': this.state.currencyName },
	                    _react2.default.createElement('input', {
	                      type: 'text',
	                      id: 'invoice-amount-' + invoiceUser.userId,
	                      ref: 'invoice-amount-' + invoiceUser.userId,
	                      onBlur: this.amountInputBlur,
	                      defaultValue: '0',
	                      disabled: disableOnLock(invoiceUser.userId),
	                      onClick: this.focus
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(DistributionRows.AddCoworker, { onClick: this.onOpenAddCoworkerModal }),
	              _react2.default.createElement(_supplierLedgerContainer2.default, { currencyName: this.state.currencyName }),
	              _ref26,
	              _react2.default.createElement(DistributionRows.DeductionAmount, { calculation: this.renderOutlaySum() }),
	              _ref27,
	              _react2.default.createElement(DistributionRows.Allowance, {
	                invoiceUser: invoiceUser,
	                value: this.state.changeValue,
	                disabled: disableOnLock(invoiceUser.userId),
	                focus: this.focus,
	                currencyName: this.state.currencyName,
	                onBlur: this.allowanceBlur,
	                onChange: function onChange(event) {
	                  this.setChangeValue(event.target.value, invoiceUser.userId, 'ALLOWANCE');
	                },
	                tooltipMessage: 'TOOLTIP_ALLOWANCE'
	              }),
	              _ref28,
	              _react2.default.createElement(DistributionRows.Travel, {
	                invoiceUser: invoiceUser,
	                value: this.state.changeValue,
	                disabled: disableOnLock(invoiceUser.userId),
	                focus: this.focus,
	                currencyName: this.state.currencyName,
	                onBlur: this.travelBlur,
	                onChange: function onChange(event) {
	                  this.setChangeValue(event.target.value, invoiceUser.userId, 'TRAVEL');
	                }
	              }),
	              _ref29,
	              _react2.default.createElement(DistributionRows.ToggleSummation, {
	                onClick: this.toggleCalculation,
	                hideCalculation: this.state.hideCalculation
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: 'calculationDisplayNone', ref: 'calculation' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'arrow' },
	                  _react2.default.createElement(DistributionRows.InvoiceryFee, {
	                    calculation: getCalculationData(invoiceUser.userId, CALCULATED_INVOICERY_FEE)
	                  }),
	                  _react2.default.createElement(DistributionRows.RewardsDiscount, {
	                    calculation: getCalculationData(invoiceUser.userId, CALCULATED_DISCOUNT),
	                    discount: discount
	                  }),
	                  _react2.default.createElement(DistributionRows.Divider, {
	                    hide: true,
	                    discount: discount
	                  }),
	                  _react2.default.createElement(DistributionRows.PayrollTax, {
	                    calculation: getCalculationData(invoiceUser.userId, CALCULATED_PAYROLL_TAX)
	                  }),
	                  _ref30,
	                  _react2.default.createElement(DistributionRows.PensionTax, {
	                    calculation: getCalculationData(invoiceUser.userId, CALCULATED_ITP_TAX)
	                  }),
	                  _ref31,
	                  _react2.default.createElement(DistributionRows.Pension, {
	                    calculation: getCalculationData(invoiceUser.userId, CALCULATED_ITP)
	                  }),
	                  _ref32,
	                  _react2.default.createElement(DistributionRows.Gross, {
	                    invoiceUser: invoiceUser,
	                    value: this.state.changeValue,
	                    disabled: disableOnLock(invoiceUser.userId),
	                    focus: this.focus,
	                    currencyName: this.state.currencyName,
	                    onBlur: this.grossSalaryInputBlur,
	                    onChange: function onChange(event) {
	                      this.setChangeValue(event.target.value, invoiceUser.userId, 'GROSS');
	                    },
	                    tooltipMessage: (0, _proxyCounterpart.proxyCounterpart)('TOOLTIP_GROSS')
	                  }),
	                  _react2.default.createElement(DistributionRows.HourlySalary, {
	                    title: 'CALCULATION_HOURLY_SALARY_VACATION_INCLUDED',
	                    calculation: getCalculationData(invoiceUser.userId, HOURLY_SALARY_VACATION_INCLUDED)
	                  }),
	                  _react2.default.createElement(DistributionRows.HourlySalary, {
	                    title: 'CALCULATION_HOURLY_SALARY_VACATION_EXCLUDED',
	                    calculation: getCalculationData(invoiceUser.userId, HOURLY_SALARY_VACATION_EXCLUDED)
	                  }),
	                  _ref33,
	                  _react2.default.createElement(DistributionRows.Tax, { calculation: getCalculationData(invoiceUser.userId, CALCULATED_TAX) }),
	                  _ref34,
	                  _react2.default.createElement(DistributionRows.SelectTax, {
	                    title: 'OMR_KEY',
	                    invoiceUser: invoiceUser,
	                    onChange: setUserTaxKeyId,
	                    disabled: disableOnLock(invoiceUser.userId),
	                    options: getOmrKeys(this.props.taxkeys)
	                  }),
	                  _ref35,
	                  _react2.default.createElement(DistributionRows.Vacation, {
	                    saveVacation: !!this.props.user.saveVacationPay,
	                    calculation: getCalculationData(invoiceUser.userId, CALCULATED_VACATION_GROSS)
	                  }),
	                  _react2.default.createElement(DistributionRows.Divider, {
	                    hide: true,
	                    saveVacationPay: !!this.props.user.saveVacationPay
	                  }),
	                  _react2.default.createElement(DistributionRows.Net, {
	                    invoiceUser: invoiceUser,
	                    value: this.state.changeValue,
	                    disabled: disableOnLock(invoiceUser.userId),
	                    focus: this.focus,
	                    currencyName: this.state.currencyName,
	                    onBlur: this.netSalaryInputBlur,
	                    onChange: function onChange(event) {
	                      this.setChangeValue(event.target.value, invoiceUser.userId, 'NET');
	                    },
	                    tooltipMessage: (0, _proxyCounterpart.proxyCounterpart)('TOOLTIP_NET')
	                  })
	                )
	              ),
	              _react2.default.createElement('div', { style: { clear: 'both' } }),
	              _react2.default.createElement(
	                'div',
	                null,
	                this.renderSumAccount(this.props.user, getCalculationData(invoiceUser.userId, CALCULATED_TO_PAY)),
	                this.renderSumItp(this.props.user, getCalculationData(invoiceUser.userId, CALCULATED_ITP)),
	                this.renderSumVacation(this.props.user, getCalculationData(invoiceUser.userId, CALCULATED_VACATION_GROSS)),
	                this.renderSumTotal(this.props.user, getCalculationData(invoiceUser.userId, CALCULATED_TOTAL))
	              ),
	              coworkers()
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'showSummation', ref: 'showSummation' },
	              this.renderSumAccount(this.props.user, getCalculationData(invoiceUser.userId, CALCULATED_TO_PAY)),
	              this.renderSumItp(this.props.user, getCalculationData(invoiceUser.userId, CALCULATED_ITP)),
	              this.renderSumVacation(this.props.user, getCalculationData(invoiceUser.userId, CALCULATED_VACATION_GROSS)),
	              this.renderSumTotal(this.props.user, getCalculationData(invoiceUser.userId, CALCULATED_TOTAL))
	            ),
	            this.renderError()
	          ),
	          this.renderAddCoworkerModal(),
	          this.renderAddNewCoworkerModal(),
	          this.renderLowHourlySalaryModal()
	        );
	      }
	      return _ref36;
	    }
	  }]);
	  return Distribution;
	}(_react2.default.Component);
	
	exports.default = Distribution;

/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RemoveCoworkerButton = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RemoveCoworkerButton = exports.RemoveCoworkerButton = function (_React$Component) {
	  (0, _inherits3.default)(RemoveCoworkerButton, _React$Component);
	
	  function RemoveCoworkerButton(props) {
	    (0, _classCallCheck3.default)(this, RemoveCoworkerButton);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (RemoveCoworkerButton.__proto__ || (0, _getPrototypeOf2.default)(RemoveCoworkerButton)).call(this, props));
	
	    _this.removeCoworker = _this.removeCoworker.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(RemoveCoworkerButton, [{
	    key: 'removeCoworker',
	    value: function removeCoworker() {
	      this.props.removeCoworker(this.props.coworkerId);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('button', { className: 'close', onClick: this.removeCoworker });
	    }
	  }]);
	  return RemoveCoworkerButton;
	}(_react2.default.Component); /**
	                               * Created by eriksundqvist on 29/06/16.
	                               */
	
	
	exports.default = RemoveCoworkerButton;

/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Vacation = exports.Travel = exports.ToggleSummation = exports.Tax = exports.SelectTax = exports.RewardsDiscount = exports.PensionTax = exports.Pension = exports.PayrollTax = exports.Net = exports.InvoiceryFee = exports.HourlySalary = exports.Gross = exports.Divider = exports.DeductionAmount = exports.CoworkerName = exports.Allowance = exports.AddCoworker = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _removeCoworkerButton = __webpack_require__(915);
	
	var _removeCoworkerButton2 = _interopRequireDefault(_removeCoworkerButton);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _components = __webpack_require__(13);
	
	var _amountHelper = __webpack_require__(58);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function generateInputRow(props, title, id, value) {
	  var toolTip = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
	  var extraDescription = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
	  var detailsRowClass = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
	
	  return _react2.default.createElement(InputRow, {
	    title: title,
	    extraDescription: extraDescription,
	    detailsRowClass: detailsRowClass,
	    id: id,
	    value: value,
	    disabled: props.disabled,
	    focus: props.focus,
	    currencyName: props.currencyName,
	    onBlur: props.onBlur,
	    onChange: props.onChange,
	    toolTip: toolTip
	  });
	}
	
	function DetailsRow(props) {
	  var title = null;
	  var detailsRowClass = props.detailsRowClass || '';
	  if (props.title) {
	    if (props.onClick) {
	      title = _react2.default.createElement(
	        'b',
	        null,
	        _react2.default.createElement(
	          'a',
	          { onClick: props.onClick },
	          _react2.default.createElement(
	            'span',
	            null,
	            '+ ',
	            _react2.default.createElement(_reactTranslateComponent2.default, { content: props.title })
	          )
	        )
	      );
	    } else {
	      title = _react2.default.createElement(_reactTranslateComponent2.default, { content: props.title });
	    }
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'details-row ' + detailsRowClass },
	    _react2.default.createElement(
	      'div',
	      { className: 'details-left' },
	      title,
	      props.left
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'details-right' },
	      props.right
	    )
	  );
	}
	
	function InputRow(props) {
	  var title = null;
	  var extraDescription = props.extraDescription || null;
	  var toolTip = props.toolTip || null;
	  var detailsRowClass = props.detailsRowClass || '';
	  if (props.title) {
	    title = _react2.default.createElement(_reactTranslateComponent2.default, { content: props.title });
	  }
	
	  var value = props.value;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'details-row ' + detailsRowClass },
	    _react2.default.createElement(
	      'div',
	      { className: 'details-left' },
	      title,
	      extraDescription,
	      toolTip
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'details-right' },
	      _react2.default.createElement(
	        'div',
	        { className: 'currency-input-holder', 'data-currency': props.currencyName },
	        _react2.default.createElement('input', { type: 'text',
	          id: props.id,
	          disabled: props.disabled,
	          onBlur: props.onBlur,
	          onClick: props.focus,
	          value: (0, _amountHelper.toMoney)(value),
	          onChange: props.onChange
	        })
	      )
	    )
	  );
	}
	
	function SelectRow(props) {
	  var title = null;
	  var left = props.left || null;
	  if (props.title) {
	    title = _react2.default.createElement(_reactTranslateComponent2.default, { content: props.title });
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'details-row' },
	    _react2.default.createElement(
	      'div',
	      { className: 'details-left' },
	      title,
	      left
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'details-right' },
	      _react2.default.createElement(
	        'div',
	        { className: 'styled-select' },
	        _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'select',
	            { id: props.id,
	              value: props.value,
	              onChange: props.onChange,
	              disabled: props.disabled
	            },
	            props.options
	          )
	        )
	      )
	    )
	  );
	}
	
	// List Rows
	
	function AddCoworker(props) {
	  return _react2.default.createElement(DetailsRow, {
	    title: 'ADD_COWORKER',
	    onClick: props.onClick,
	    left: _react2.default.createElement(_components.ToolTip, {
	      id: 'worker',
	      buttonClasses: 'tooltip-info-button',
	      msg: (0, _proxyCounterpart.proxyCounterpart)('TOOLTIP_WORKER')
	    })
	  });
	}
	
	function Allowance(props) {
	  var value = props.invoiceUser.calculation ? props.invoiceUser.calculation.allowance : 0;
	  if (props.value.userId === props.invoiceUser.userId && props.value.value !== 0 && props.value.type === 'ALLOWANCE') {
	    value = props.value.value;
	  }
	
	  return generateInputRow(props, 'ALLOWANCE', 'invoice-allowance-' + props.invoiceUser.userId, value, _react2.default.createElement(_components.ToolTip, { id: 'allowance', msg: (0, _proxyCounterpart.proxyCounterpart)('TOOLTIP_ALLOWANCE') }));
	}
	
	function CoworkerName(props) {
	  return _react2.default.createElement(DetailsRow, {
	    left: _react2.default.createElement(
	      'h3',
	      null,
	      props.invoiceUser.firstName,
	      ' ',
	      props.invoiceUser.lastName
	    ),
	    right: _react2.default.createElement(_removeCoworkerButton2.default, {
	      coworkerId: parseInt(props.coworkerId),
	      removeCoworker: props.removeCoworker })
	  });
	}
	
	function DeductionAmount(props) {
	  return _react2.default.createElement(DetailsRow, {
	    title: 'DEDUCTION_AMOUNT'
	    // left={<ToolTip id='deduction' msg={proxyCounterpart('TOOLTIP_DEDUCTION')}/>}
	    , right: props.calculation
	  });
	}
	
	var _ref = _react2.default.createElement('hr', { className: 'thin-line' });
	
	function Divider(props) {
	  if (!props.saveVacationPay && !props.discount && props.hide) return null;
	  return _ref;
	}
	
	function Gross(props) {
	  var value = props.invoiceUser.calculation ? props.invoiceUser.calculation.gross : 0;
	  if (props.value.userId === props.invoiceUser.userId && props.value.value !== 0 && props.value.type === 'GROSS') {
	    value = props.value.value;
	  }
	  return generateInputRow(props, 'GROSS_SALARY', 'invoice-gross-' + props.invoiceUser.userId, value, _react2.default.createElement(_components.ToolTip, { id: 'gross_salary', msg: (0, _proxyCounterpart.proxyCounterpart)('TOOLTIP_CALCULATION_GROSS_SALARY') }));
	}
	
	function HourlySalary(props) {
	  return _react2.default.createElement(DetailsRow, {
	    title: props.title,
	    right: props.calculation,
	    detailsRowClass: 'doublePadding'
	  });
	}
	
	function InvoiceryFee(props) {
	  return _react2.default.createElement(DetailsRow, {
	    title: 'CALCULATION_INVOICERY_FEE',
	    left: _react2.default.createElement(_components.ToolTip, { id: 'invoicery_fee', msg: (0, _proxyCounterpart.proxyCounterpart)('TOOLTIP_CALCULATION_INVOICERY_FEE') }),
	    right: props.calculation
	  });
	}
	
	function RewardsDiscount(props) {
	  if (props.discount !== 0) {
	    return _react2.default.createElement(DetailsRow, {
	      title: 'CALCULATION_REWARDS_DISCOUNT',
	      left: _react2.default.createElement(_components.ToolTip, { id: 'rewards_discpunt', msg: (0, _proxyCounterpart.proxyCounterpart)('TOOLTIP_CALCULATION_REWARDS_DISCOUNT') }),
	      right: props.calculation,
	      detailsRowClass: 'doublePaddingLeft'
	    });
	  }
	  return null;
	}
	
	function Net(props) {
	  var value = props.invoiceUser.calculation ? props.invoiceUser.calculation.net : 0;
	  if (props.value.userId === props.invoiceUser.userId && props.value.value !== 0 && props.value.type === 'NET') {
	    value = props.value.value;
	  }
	  return generateInputRow(props, 'NET_SALARY', 'invoice-net-' + props.invoiceUser.userId, value, _react2.default.createElement(_components.ToolTip, { id: 'net_salary', msg: (0, _proxyCounterpart.proxyCounterpart)('TOOLTIP_CALCULATION_NET_SALARY') }));
	}
	
	function PayrollTax(props) {
	  return _react2.default.createElement(DetailsRow, {
	    title: 'CALCULATION_PAYROLL_TAX',
	    left: _react2.default.createElement(_components.ToolTip, { id: 'payroll_tax', msg: (0, _proxyCounterpart.proxyCounterpart)('TOOLTIP_CALCULTAION_PAYROLL_TAX') }),
	    right: props.calculation
	  });
	}
	
	function Pension(props) {
	  return _react2.default.createElement(DetailsRow, {
	    title: 'PENSION',
	    left: _react2.default.createElement(_components.ToolTip, { id: 'itp', msg: (0, _proxyCounterpart.proxyCounterpart)('TOOLTIP_ITP') }),
	    right: props.calculation
	  });
	}
	
	function PensionTax(props) {
	  return _react2.default.createElement(DetailsRow, {
	    title: 'CALCULATION_SPECIAL_PENSION_TAX',
	    right: props.calculation,
	    left: _react2.default.createElement(_components.ToolTip, { id: 'special_pension_tax', msg: (0, _proxyCounterpart.proxyCounterpart)('TOOLTIP_CALCULATION_SPECIAL_PENSION_TAX') })
	  });
	}
	
	function SelectTax(props) {
	  return _react2.default.createElement(SelectRow, {
	    title: props.title,
	    id: 'invoice-taxkeyid-' + props.invoiceUser.userId,
	    value: props.invoiceUser.taxkeyId,
	    onChange: props.onChange,
	    disabled: props.disabled,
	    options: props.options
	  });
	}
	
	function Tax(props) {
	  return _react2.default.createElement(DetailsRow, {
	    title: 'CALCULATION_INCOME_TAX',
	    left: _react2.default.createElement(_components.ToolTip, { id: 'tax', msg: (0, _proxyCounterpart.proxyCounterpart)('TOOLTIP_CALCULATION_INCOME_TAX') }),
	    right: props.calculation
	  });
	}
	
	var _ref2 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SHOW_CALCULATION' });
	
	var _ref3 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'HIDE_CALCULATION' });
	
	function ToggleSummation(props) {
	  var showCalculation = !props.hideCalculation ? 'hidden' : '';
	  var hideCalculation = props.hideCalculation ? 'hidden' : '';
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'hide-show-calculation' },
	    _react2.default.createElement(
	      'div',
	      { className: 'showCalculation ' + showCalculation, onClick: props.onClick },
	      '+ ',
	      _ref2
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'hideCalculation ' + hideCalculation, onClick: props.onClick },
	      '- ',
	      _ref3
	    )
	  );
	}
	
	function ExtraDescription(props) {
	  return _react2.default.createElement(
	    'span',
	    { className: 'extra-description' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: props.text }),
	    ' ',
	    _react2.default.createElement(
	      'a',
	      {
	        target: '_blank',
	        href: (0, _proxyCounterpart.proxyCounterpart)(props.linkUrl)
	      },
	      (0, _proxyCounterpart.proxyCounterpart)(props.linkText)
	    )
	  );
	}
	
	var _ref4 = _react2.default.createElement(ExtraDescription, {
	  text: 'TRAVEL_ALLOWANCE_REMEMBER',
	  linkText: 'TRAVEL_ALLOWANCE_REMEMBER_LINK_TEXT',
	  linkUrl: 'TRAVEL_ALLOWANCE_REMEMBER_LINK_URL'
	});
	
	function Travel(props) {
	  var value = props.invoiceUser.calculation ? props.invoiceUser.calculation.travel : 0;
	  if (props.value.userId === props.invoiceUser.userId && props.value.value !== 0 && props.value.type === 'TRAVEL') {
	    value = props.value.value;
	  }
	
	  return generateInputRow(props, 'TRAVEL_ALLOWANCE', 'invoice-travel-' + props.invoiceUser.userId, value, _react2.default.createElement(_components.ToolTip, {
	    id: 'travel',
	    msg: (0, _proxyCounterpart.proxyCounterpart)('TOOLTIP_TRAVEL_ALLOWANCE')
	  }), _ref4, 'with-extra-description');
	}
	
	function Vacation(props) {
	  if (props.saveVacation) {
	    return _react2.default.createElement(DetailsRow, {
	      title: 'VACATION_MONEY',
	      left: _react2.default.createElement(_components.ToolTip, { id: 'vacation', msg: (0, _proxyCounterpart.proxyCounterpart)('TOOLTIP_VACATION') }),
	      right: props.calculation
	    });
	  }
	  return null;
	}
	
	// PropTypes
	exports.AddCoworker = AddCoworker;
	exports.Allowance = Allowance;
	exports.CoworkerName = CoworkerName;
	exports.DeductionAmount = DeductionAmount;
	exports.Divider = Divider;
	exports.Gross = Gross;
	exports.HourlySalary = HourlySalary;
	exports.InvoiceryFee = InvoiceryFee;
	exports.Net = Net;
	exports.PayrollTax = PayrollTax;
	exports.Pension = Pension;
	exports.PensionTax = PensionTax;
	exports.RewardsDiscount = RewardsDiscount;
	exports.SelectTax = SelectTax;
	exports.Tax = Tax;
	exports.ToggleSummation = ToggleSummation;
	exports.Travel = Travel;
	exports.Vacation = Vacation;

/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SupplierLedgerFileUpload = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// https://github.com/okonet/react-dropzone
	var Dropzone = __webpack_require__(619);
	
	var _ref = _react2.default.createElement('div', { className: 'cornerimage remove-link' });
	
	var _ref2 = _react2.default.createElement('div', { className: 'new_line' });
	
	var _ref3 = _react2.default.createElement(
	  'div',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ADD_DEDUCTION_RECEIPT' })
	);
	
	var _ref4 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'DEDUCTION_FILE_ERROR' });
	
	var SupplierLedgerFileUpload = exports.SupplierLedgerFileUpload = function (_React$Component) {
	  (0, _inherits3.default)(SupplierLedgerFileUpload, _React$Component);
	
	  function SupplierLedgerFileUpload(props) {
	    (0, _classCallCheck3.default)(this, SupplierLedgerFileUpload);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SupplierLedgerFileUpload.__proto__ || (0, _getPrototypeOf2.default)(SupplierLedgerFileUpload)).call(this, props));
	
	    _this.state = {
	      files: [],
	      invalidFile: false
	    };
	
	    _this.onDrop = _this.onDrop.bind(_this);
	    _this.delete = _this.delete.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(SupplierLedgerFileUpload, [{
	    key: 'validate',
	    value: function validate(file) {
	      var validFileExtensions = void 0,
	          validFileSize = void 0,
	          typeValid = void 0;
	
	      validFileExtensions = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/svg+xml', 'text/plain', 'application/msword', 'application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessing', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
	      validFileSize = 2097152;
	      typeValid = false;
	
	      if (file.size > validFileSize) {
	        return false;
	      }
	
	      for (var i = 0; i < validFileExtensions.length; i++) {
	        if (file.type === validFileExtensions[i]) {
	          typeValid = true;
	          break;
	        }
	      }
	
	      return typeValid;
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(e) {
	      e.preventDefault();
	      this.setState({
	        files: [],
	        invalidFile: false
	      });
	
	      this.props.delete();
	    }
	  }, {
	    key: 'onDrop',
	    value: function onDrop(files) {
	      if (this.validate(files[0])) {
	        this.setState({
	          files: files,
	          invalidFile: false,
	          imageSrc: files[0].preview
	        });
	
	        this.props.set(files[0]);
	      } else {
	        this.setState({ invalidFile: true });
	      }
	    }
	  }, {
	    key: 'renderDeleteButton',
	    value: function renderDeleteButton() {
	      if (this.props.imageSrc) {
	        return _react2.default.createElement(
	          'button',
	          { className: 'menu-btn close-menu', onClick: this.delete },
	          _ref
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'upload-supplier-ledger-file' },
	        _react2.default.createElement(
	          'div',
	          { className: 'containerdiv' },
	          _react2.default.createElement('img', { src: this.props.imageSrc, alt: '' }),
	          this.renderDeleteButton()
	        ),
	        _ref2,
	        _react2.default.createElement(
	          Dropzone,
	          { ref: 'dropzone', onDrop: this.onDrop, className: 'drop-zone', multiple: false },
	          _ref3
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: this.state.invalidFile ? 'error show' : 'error' },
	          _ref4
	        )
	      );
	    }
	  }]);
	  return SupplierLedgerFileUpload;
	}(_react2.default.Component);
	
	exports.default = SupplierLedgerFileUpload;

/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(12);
	
	var _index = __webpack_require__(43);
	
	var _supplierLedgerForm = __webpack_require__(919);
	
	var _supplierLedgerForm2 = _interopRequireDefault(_supplierLedgerForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    invoice: state.invoice
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    setSupplierLedger: function setSupplierLedger(supplierLedger) {
	      return dispatch((0, _index.setSupplierLedger)(supplierLedger));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_supplierLedgerForm2.default);

/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(18);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _assign = __webpack_require__(22);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _supplierLedgerTypePickerContainer = __webpack_require__(924);
	
	var _supplierLedgerTypePickerContainer2 = _interopRequireDefault(_supplierLedgerTypePickerContainer);
	
	var _supplierLedgerFileUpload = __webpack_require__(917);
	
	var _supplierLedgerFileUpload2 = _interopRequireDefault(_supplierLedgerFileUpload);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _components = __webpack_require__(13);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _amountHelper = __webpack_require__(58);
	
	var _invoiceToolHelper = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'row' },
	  _react2.default.createElement(
	    'div',
	    { className: 'col-sm-12 post-error' },
	    _react2.default.createElement(_components.GeneralError, null)
	  )
	); /**
	    * Created by staffanrantzow on 10/11/16.
	    */
	
	var _ref2 = _react2.default.createElement(
	  'label',
	  { htmlFor: 'file-confirmation', className: 'small-label' },
	  _react2.default.createElement('span', null),
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'DEDUCTION_FILE_CONFIRMATION' })
	);
	
	var _ref3 = _react2.default.createElement(
	  'p',
	  { className: 'error deduction-file-confirmation-error' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'DEDUCTION_FILE_CONFIRMATION_ERROR' })
	);
	
	var _ref4 = _react2.default.createElement('div', { className: 'col-xs-6' });
	
	var SupplierLedgerForm = function (_React$Component) {
	  (0, _inherits3.default)(SupplierLedgerForm, _React$Component);
	
	  function SupplierLedgerForm(props, context) {
	    (0, _classCallCheck3.default)(this, SupplierLedgerForm);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SupplierLedgerForm.__proto__ || (0, _getPrototypeOf2.default)(SupplierLedgerForm)).call(this, props, context));
	
	    _this.state = {
	      formValues: {
	        supplierName: {},
	        amount: {}
	      },
	      type: null,
	      typeId: null,
	      typeValid: false,
	      exclVat: '',
	      taxes: null,
	      taxPercent: null,
	      file: null,
	      fileConfirmation: false,
	      fileValid: true,
	      showErrorWithoutBlur: false,
	      showErrorForTaxType: false,
	      posting: false,
	      postError: false,
	      imageSrc: false
	    };
	
	    _this.setType = _this.setType.bind(_this);
	    _this.clearValues = _this.clearValues.bind(_this);
	    _this.onSubmit = _this.onSubmit.bind(_this);
	    _this.callback = _this.callback.bind(_this);
	    _this.onKeyUp = _this.amountOnKeyUp.bind(_this);
	    _this.setFile = _this.setFile.bind(_this);
	    _this.deleteFile = _this.deleteFile.bind(_this);
	    _this.sumbitSupplierLedgerFile = _this.sumbitSupplierLedgerFile.bind(_this);
	    _this.checkboxClick = _this.checkboxClick.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(SupplierLedgerForm, [{
	    key: 'amountOnKeyUp',
	    value: function amountOnKeyUp(event) {
	      var amountValue = event.target.value;
	
	      event.target.value = (0, _invoiceToolHelper.reformatInputValue)(amountValue);
	    }
	  }, {
	    key: 'callback',
	    value: function callback(name, values) {
	      var tempFormValues = this.state.formValues;
	      (0, _assign2.default)(tempFormValues[name], values);
	      this.setState({ formValues: tempFormValues }, this.updateExclVat);
	    }
	  }, {
	    key: 'clearValues',
	    value: function clearValues(e) {
	      if (e) {
	        e.preventDefault;
	      }
	
	      this.setState({
	        showErrorWithoutBlur: false,
	        showErrorForTaxType: false,
	        formValues: {
	          supplierName: {
	            value: '',
	            valid: false
	          },
	          amount: {
	            value: '',
	            valid: false
	          }
	        },
	        exclVat: '',
	        typeId: 'default',
	        file: null,
	        fileConfirmation: false,
	        fileValid: true,
	        imageSrc: false
	      });
	    }
	  }, {
	    key: 'setType',
	    value: function setType(type) {
	      var _this2 = this;
	
	      if (this.state.taxes) {
	        this.setTypeAndTax(type, this.state.taxes);
	      } else {
	        _frilansFinans.TaxService.get().then(function (response) {
	          _this2.setState({
	            taxes: response
	          }, function () {
	            _this2.setTypeAndTax(type, _this2.state.taxes);
	          });
	        }).catch(function (error) {
	          console.log(error);
	        });
	      }
	    }
	
	    /**
	     * Set typeId and find the tax percent
	     */
	
	  }, {
	    key: 'setTypeAndTax',
	    value: function setTypeAndTax(type, taxes) {
	      var taxPercent = null;
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(taxes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var tax = _step.value;
	
	          if (parseInt(tax.id) === parseInt(type.taxId)) {
	            taxPercent = tax.percent;
	            break;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      if (type) {
	        this.setState({
	          type: type,
	          taxPercent: taxPercent,
	          typeValid: true,
	          typeId: type.id,
	          showErrorForTaxType: false
	        }, this.updateExclVat);
	        return;
	      }
	      this.setState({
	        type: type,
	        showErrorForTaxType: true
	      });
	    }
	  }, {
	    key: 'setFile',
	    value: function setFile(file) {
	      this.setState({ file: file, imageSrc: file.preview });
	    }
	  }, {
	    key: 'deleteFile',
	    value: function deleteFile() {
	      this.setState({ file: null, imageSrc: false, fileValid: true });
	    }
	  }, {
	    key: 'sumbitSupplierLedgerFile',
	    value: function sumbitSupplierLedgerFile(file, supplierLedgerId) {
	      var reader = new FileReader();
	      var self = this;
	
	      reader.onload = function (e) {
	        _frilansFinans.SupplierLedgerService.postFile({
	          file: e.target.result,
	          user_id: self.context.user.id
	        }, supplierLedgerId);
	      };
	
	      reader.readAsDataURL(this.state.file);
	    }
	
	    /**
	     * Calculate and set the excluding vat value
	     */
	
	  }, {
	    key: 'updateExclVat',
	    value: function updateExclVat() {
	      if (this.state.formValues.amount.value && this.state.taxPercent != null) {
	        var val = parseFloat(this.state.formValues.amount.value);
	        var exclVat = 100 * val / (100 + this.state.taxPercent);
	        this.setState({
	          exclVat: (0, _amountHelper.toMoney)(exclVat)
	        });
	      }
	    }
	  }, {
	    key: 'validate',
	    value: function validate() {
	      // Validate amount and supplier name
	      var inputFormValuesValid = _frilansFinans.Utils.validateInputValues(this.state.formValues);
	      var typeValid = false;
	
	      // Validate type (category)
	      if (!this.state.type) {
	        this.setState({
	          showErrorForTaxType: true
	        });
	      }
	      if (this.state.type && this.state.type.hasOwnProperty('id')) {
	        typeValid = true;
	      }
	
	      this.setState({
	        typeValid: typeValid
	      });
	
	      var fileValid = this.state.file ? this.state.fileConfirmation : true;
	
	      this.setState({
	        fileValid: fileValid
	      });
	
	      return inputFormValuesValid && typeValid && fileValid;
	    }
	  }, {
	    key: 'onSubmit',
	    value: function onSubmit(e) {
	      var _this3 = this;
	
	      e.preventDefault();
	
	      this.setState({
	        showErrorWithoutBlur: true
	      }, function () {
	        if (_this3.validate()) {
	          var params = _frilansFinans.Utils.getPostParams(_this3.state.formValues);
	
	          params.supplierLedgerTypeId = _this3.state.type.id;
	          params.taxId = _this3.state.type.taxId;
	
	          _this3.setState({
	            posting: true
	          });
	
	          _frilansFinans.SupplierLedgerService.post(params, _this3.context.user.id).then(function (response) {
	            var arr = _this3.props.invoice.supplierLedger ? _this3.props.invoice.supplierLedger.slice(0) : [];
	
	            if (_this3.state.file) {
	              _this3.sumbitSupplierLedgerFile(_this3.state.file, response.id);
	            }
	
	            arr.push(response);
	            response.file = _this3.state.file;
	            _this3.props.setSupplierLedger(arr);
	            _this3.clearValues();
	
	            _this3.setState({
	              posting: false,
	              postError: false,
	              type: null
	            });
	          }).catch(function () {
	            _this3.setState({
	              postError: true,
	              posting: false
	            });
	          });
	        }
	      });
	    }
	  }, {
	    key: 'renderError',
	    value: function renderError() {
	      if (this.state.postError) {
	        return _ref;
	      }
	    }
	  }, {
	    key: 'checkboxClick',
	    value: function checkboxClick() {
	      this.setState({
	        fileConfirmation: !this.state.fileConfirmation
	      });
	    }
	  }, {
	    key: 'renderFileConfirmationCheckbox',
	    value: function renderFileConfirmationCheckbox() {
	      if (this.state.file) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12' },
	            _react2.default.createElement('input', { id: 'file-confirmation', type: 'checkbox', name: 'file-confirmation', onChange: this.onChange,
	              checked: this.state.fileConfirmation, onClick: this.checkboxClick }),
	            _ref2
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderFileConfirmationError',
	    value: function renderFileConfirmationError() {
	      if (this.state.showErrorWithoutBlur && !this.state.fileValid) {
	        return _ref3;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'form',
	        { noValidate: true },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6' },
	            _react2.default.createElement(_supplierLedgerTypePickerContainer2.default, {
	              setType: this.setType,
	              typeId: this.state.typeId,
	              showErrorWithoutBlur: this.state.showErrorForTaxType,
	              errorMessage: (0, _proxyCounterpart.proxyCounterpart)('DEDUCTION_CATEGORY_ERROR')
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6' },
	            _react2.default.createElement(_components.InputField, { type: 'text', name: 'supplierName', value: this.state.formValues.supplierName.value,
	              placeholder: (0, _proxyCounterpart.proxyCounterpart)('SUPPLIER'), callback: this.callback,
	              required: 'true', minLength: '2', errorMessage: (0, _proxyCounterpart.proxyCounterpart)('SUPPLIER_ERROR'),
	              showErrorWithoutBlur: this.state.showErrorWithoutBlur })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6' },
	            _react2.default.createElement(_components.InputField, { type: 'text', name: 'amount', validationType: 'decimal', value: this.state.formValues.amount.value,
	              placeholder: (0, _proxyCounterpart.proxyCounterpart)('INC_VAT'), callback: this.callback,
	              onKeyUp: this.amountOnKeyUp,
	              required: 'true', minLength: '1', errorMessage: (0, _proxyCounterpart.proxyCounterpart)('VALUE_ERROR'),
	              showErrorWithoutBlur: this.state.showErrorWithoutBlur,
	              ref: 'amount-holder' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6' },
	            _react2.default.createElement(
	              'div',
	              { className: 'input-wrapper' },
	              _react2.default.createElement('input', { disabled: true, type: 'text', value: this.state.exclVat, name: 'exclVat', required: true, minLength: '1' }),
	              _react2.default.createElement('label', {
	                htmlFor: 'exclVat',
	                placeholder: (0, _proxyCounterpart.proxyCounterpart)('EXCL_VAT'),
	                alt: (0, _proxyCounterpart.proxyCounterpart)('EXCL_VAT') })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(_supplierLedgerFileUpload2.default, { set: this.setFile, 'delete': this.deleteFile, imageSrc: this.state.imageSrc })
	        ),
	        this.renderFileConfirmationCheckbox(),
	        this.renderFileConfirmationError(),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _ref4,
	          _react2.default.createElement(
	            'div',
	            { onClick: this.onSubmit, className: 'col-xs-6 right-btn-wrapper' },
	            _react2.default.createElement(_components.SpinnerButton, { text: (0, _proxyCounterpart.proxyCounterpart)('ADD'),
	              loading: this.state.posting, classes: 'btn' })
	          )
	        ),
	        this.renderError()
	      );
	    }
	  }]);
	  return SupplierLedgerForm;
	}(_react2.default.Component);
	
	SupplierLedgerForm.contextTypes = {
	  user: _react.PropTypes.object.isRequired
	};
	exports.default = SupplierLedgerForm;

/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(18);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _components = __webpack_require__(13);
	
	var _errorMessage = __webpack_require__(160);
	
	var _errorMessage2 = _interopRequireDefault(_errorMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_components.GeneralError, null); /**
	                                                                           * Created by staffanrantzow on 10/11/16.
	                                                                           */
	
	var _ref2 = _react2.default.createElement(
	  'option',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PICK_DEDUCTION_CATEGORY' })
	);
	
	var _ref3 = _react2.default.createElement(
	  'label',
	  { htmlFor: 'type-picker' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'DEDUCTION_CATEGORY' })
	);
	
	var SupplierLedgerTypePicker = function (_React$Component) {
	  (0, _inherits3.default)(SupplierLedgerTypePicker, _React$Component);
	
	  function SupplierLedgerTypePicker(props) {
	    (0, _classCallCheck3.default)(this, SupplierLedgerTypePicker);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SupplierLedgerTypePicker.__proto__ || (0, _getPrototypeOf2.default)(SupplierLedgerTypePicker)).call(this, props));
	
	    _this.state = {
	      fetching: true,
	      fetchError: false,
	      types: [],
	      typeEntities: [],
	      selectValue: ''
	    };
	
	    _this.handleResponse = _this.handleResponse.bind(_this);
	    _this.setType = _this.setType.bind(_this);
	    _this.renderOption = _this.renderOption.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(SupplierLedgerTypePicker, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // Used to reset the select
	      if (nextProps.typeId === 'default') {
	        this.setState({
	          selectValue: nextProps.typeId
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchTypes();
	    }
	  }, {
	    key: 'fetchTypes',
	    value: function fetchTypes() {
	      var _this2 = this;
	
	      _frilansFinans.SupplierLedgerService.getTypes().then(this.handleResponse).catch(function () {
	        _this2.setState({
	          fetching: false,
	          fetchError: true
	        });
	      });
	    }
	  }, {
	    key: 'handleResponse',
	    value: function handleResponse(types) {
	      var t = [];
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(types), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var type = _step.value;
	
	          t.push({
	            disabled: false,
	            id: type.id,
	            name: type.displayName,
	            taxId: type.taxId,
	            value: type.id,
	            isRotRut: type.isRotRut
	          });
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      this.setState({
	        types: t,
	        typeEntities: types,
	        fetching: false,
	        fetchError: false
	      });
	    }
	  }, {
	    key: 'setType',
	    value: function setType(e) {
	      this.setState({
	        selectValue: e.target.value
	      });
	
	      if (!parseInt(e.target.value)) {
	        this.props.setType(false);
	      } else {
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = (0, _getIterator3.default)(this.state.typeEntities), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var type = _step2.value;
	
	            if (parseInt(type.id) === parseInt(e.target.value)) {
	              this.props.setType(type);
	              break;
	            }
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	      }
	    }
	  }, {
	    key: 'renderOption',
	    value: function renderOption(type, i) {
	      var isRotOrRutInvoice = this.props.hsd.rot || this.props.hsd.rut;
	      var shouldRender = type.isRotRut && isRotOrRutInvoice || !type.isRotRut;
	
	      // Render depending on type
	      if (shouldRender) {
	        return _react2.default.createElement(
	          'option',
	          {
	            disabled: type.disabled,
	            value: type.value,
	            key: i },
	          _react2.default.createElement(_reactTranslateComponent2.default, { content: 'DEDUCTION_CATEGORY_' + type.id })
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.fetchError) {
	        return _ref;
	      }
	      if (this.state.types.length > 0) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'input-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: '' },
	            _react2.default.createElement(
	              'div',
	              { className: 'styled-select' },
	              _react2.default.createElement(
	                'select',
	                {
	                  name: 'type-picker',
	                  value: this.state.selectValue ? this.state.selectValue : 'default',
	                  onChange: this.setType },
	                _ref2,
	                this.state.types.map(this.renderOption)
	              ),
	              _ref3
	            )
	          ),
	          _react2.default.createElement(_errorMessage2.default, {
	            show: !!this.props.showErrorWithoutBlur && !!this.props.errorMessage,
	            errorMessage: this.props.errorMessage })
	        );
	      }
	
	      return false;
	    }
	  }]);
	  return SupplierLedgerTypePicker;
	}(_react2.default.Component);
	
	exports.default = SupplierLedgerTypePicker;

/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(18);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _components = __webpack_require__(13);
	
	var _amountHelper = __webpack_require__(58);
	
	var _invoiceToolHelper = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 10/11/16.
	 */
	
	var _ref = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SEK_SHORT' });
	
	var _ref2 = _react2.default.createElement(_components.GeneralError, null);
	
	var _ref3 = _react2.default.createElement(
	  'th',
	  { className: 'col-levid' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'LEV_ID' })
	);
	
	var _ref4 = _react2.default.createElement(
	  'th',
	  { className: 'col-supplier' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SUPPLIER' })
	);
	
	var _ref5 = _react2.default.createElement(
	  'th',
	  { className: 'col-sum' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INC_VAT' })
	);
	
	var _ref6 = _react2.default.createElement(
	  'th',
	  { className: 'col-appended-files' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'DEDUCTION_APPENDED_FILES' })
	);
	
	var _ref7 = _react2.default.createElement(
	  'th',
	  { className: 'col-delete' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'DELETE' })
	);
	
	var SupplierLedgerList = function (_React$Component) {
	  (0, _inherits3.default)(SupplierLedgerList, _React$Component);
	
	  function SupplierLedgerList(props) {
	    (0, _classCallCheck3.default)(this, SupplierLedgerList);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SupplierLedgerList.__proto__ || (0, _getPrototypeOf2.default)(SupplierLedgerList)).call(this, props));
	
	    _this.state = {
	      supplierLedger: props.supplierLedger,
	      types: [],
	      fetching: true,
	      fetchError: false
	    };
	
	    _this.renderRow = _this.renderRow.bind(_this);
	    _this.onDeleteClick = _this.onDeleteClick.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(SupplierLedgerList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchTypes();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.state.types.length > 0) {
	        this.setState({
	          supplierLedger: this.addTypeName(nextProps.supplierLedger, this.state.types)
	        });
	      }
	    }
	  }, {
	    key: 'fetchTypes',
	    value: function fetchTypes() {
	      var _this2 = this;
	
	      _frilansFinans.SupplierLedgerService.getTypes().then(function (types) {
	        _this2.setState({
	          types: types,
	          supplierLedger: _this2.addTypeName(_this2.props.supplierLedger, types),
	          fetching: false,
	          fetchError: false
	        });
	      }).catch(function () {
	        _this2.setState({
	          fetching: false,
	          fetchError: true
	        });
	      });
	    }
	
	    /**
	     * Loop through the types and add the display name to the supplier ledgers
	     * @param ledgers
	     * @param types supplier ledger categories/types
	     * @returns {*}
	     */
	
	  }, {
	    key: 'addTypeName',
	    value: function addTypeName(ledgers, types) {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(ledgers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var l = _step.value;
	
	          var typeId = parseInt(l.supplierLedgerTypeId);
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = (0, _getIterator3.default)(types), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var t = _step2.value;
	
	              if (typeId === parseInt(t.id)) {
	                l.typeName = t.displayName;
	              }
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return ledgers;
	    }
	  }, {
	    key: 'onDeleteClick',
	    value: function onDeleteClick(e) {
	      e.preventDefault();
	
	      var index = parseInt(e.target.getAttribute('data-index'));
	      var arr = this.props.supplierLedger.slice(0);
	
	      arr.splice(index, 1);
	      this.props.setSupplierLedger(arr);
	    }
	  }, {
	    key: 'renderRow',
	    value: function renderRow(s, i) {
	      return _react2.default.createElement(
	        'tr',
	        { key: i },
	        _react2.default.createElement(
	          'td',
	          { className: 'col-levid' },
	          s.id
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'col-supplier' },
	          s.supplierName
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'col-sum' },
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _amountHelper.toMoney)(s.amount * (1 + (0, _invoiceToolHelper.getVatById)(s.taxId) / 100)),
	            ' ',
	            _ref
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(_reactTranslateComponent2.default, { content: s.file ? 'YES' : 'NO' })
	        ),
	        this.props.showDelete && _react2.default.createElement(
	          'td',
	          { className: 'col-delete' },
	          _react2.default.createElement('a', { href: '/', className: 'remove-link', 'data-index': i, onClick: this.onDeleteClick })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // Don't show the table until we have both ledgers and types
	      if (this.state.supplierLedger.length === 0 || this.state.types.length === 0) {
	        return false;
	      }
	
	      if (this.state.fetchError) {
	        return _ref2;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'table-wrapper mobile-full-width-table' },
	        _react2.default.createElement(
	          'table',
	          { className: 'standard-table' },
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _ref3,
	              _ref4,
	              _ref5,
	              _ref6,
	              this.props.showDelete && _ref7
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            this.state.supplierLedger.map(this.renderRow)
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'defaultProps',
	    get: function get() {
	      return {
	        showDelete: true
	      };
	    }
	  }]);
	  return SupplierLedgerList;
	}(_react2.default.Component);
	
	exports.default = SupplierLedgerList;

/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(12);
	
	var _supplierLedger = __webpack_require__(925);
	
	var _supplierLedger2 = _interopRequireDefault(_supplierLedger);
	
	var _index = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    supplierLedger: state.invoice.supplierLedger
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    setSupplierLedger: function setSupplierLedger(supplierLedger) {
	      return dispatch((0, _index.setSupplierLedger)(supplierLedger));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_supplierLedger2.default);

/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(30);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _supplierLedgerFormContainer = __webpack_require__(918);
	
	var _supplierLedgerFormContainer2 = _interopRequireDefault(_supplierLedgerFormContainer);
	
	var _supplierLedgerListContainer = __webpack_require__(381);
	
	var _supplierLedgerListContainer2 = _interopRequireDefault(_supplierLedgerListContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 10/11/16.
	 */
	
	var _ref = _react2.default.createElement('br', null);
	
	var _ref2 = _react2.default.createElement(
	  'div',
	  { className: 'heading-wrapper' },
	  _react2.default.createElement(
	    'h2',
	    null,
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ADD_DEDUCTION' })
	  )
	);
	
	var _ref3 = _react2.default.createElement(_supplierLedgerListContainer2.default, null);
	
	var SupplierLedgerModal = function (_React$Component) {
	  (0, _inherits3.default)(SupplierLedgerModal, _React$Component);
	
	  function SupplierLedgerModal() {
	    (0, _classCallCheck3.default)(this, SupplierLedgerModal);
	    return (0, _possibleConstructorReturn3.default)(this, (SupplierLedgerModal.__proto__ || (0, _getPrototypeOf2.default)(SupplierLedgerModal)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SupplierLedgerModal, [{
	    key: 'renderDeductionInfo',
	    value: function renderDeductionInfo() {
	      return _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement('span', {
	          dangerouslySetInnerHTML: { __html: (0, _proxyCounterpart.proxyCounterpart)('DEDUCTION_FILE_INFO') } }),
	        _ref
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactModal2.default,
	        {
	          className: 'modal modal-extra-wide',
	          isOpen: true,
	          contentLabel: '',
	          onRequestClose: this.reject },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-content supplier-ledger-modal' },
	          _react2.default.createElement('button', { className: 'close', onClick: this.props.close }),
	          _ref2,
	          this.renderDeductionInfo(),
	          _react2.default.createElement(_supplierLedgerFormContainer2.default, { close: this.props.close }),
	          _ref3
	        )
	      );
	    }
	  }]);
	  return SupplierLedgerModal;
	}(_react2.default.Component);
	
	exports.default = SupplierLedgerModal;

/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(12);
	
	var _supplierLedgerTypePicker = __webpack_require__(920);
	
	var _supplierLedgerTypePicker2 = _interopRequireDefault(_supplierLedgerTypePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    hsd: state.invoice.hsd
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(_supplierLedgerTypePicker2.default);

/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _supplierLedgerModal = __webpack_require__(923);
	
	var _supplierLedgerModal2 = _interopRequireDefault(_supplierLedgerModal);
	
	var _components = __webpack_require__(13);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SupplierLedger = function (_React$Component) {
	  (0, _inherits3.default)(SupplierLedger, _React$Component);
	
	  function SupplierLedger(props) {
	    (0, _classCallCheck3.default)(this, SupplierLedger);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SupplierLedger.__proto__ || (0, _getPrototypeOf2.default)(SupplierLedger)).call(this, props));
	
	    _this.state = {
	      showModal: false
	    };
	
	    _this.toggleModal = _this.toggleModal.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(SupplierLedger, [{
	    key: 'toggleModal',
	    value: function toggleModal(e) {
	      if (e) e.preventDefault();
	      this.setState({
	        showModal: !this.state.showModal
	      });
	    }
	  }, {
	    key: 'renderModal',
	    value: function renderModal() {
	      if (this.state.showModal) return _react2.default.createElement(_supplierLedgerModal2.default, { close: this.toggleModal });
	    }
	  }, {
	    key: 'button',
	    value: function button() {
	      var translate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ADD_DEDUCTION';
	
	      return _react2.default.createElement(
	        'b',
	        null,
	        _react2.default.createElement(
	          'a',
	          { onClick: this.toggleModal },
	          '+ ',
	          _react2.default.createElement(_reactTranslateComponent2.default, { content: translate })
	        )
	      );
	    }
	  }, {
	    key: 'renderButton',
	    value: function renderButton() {
	      if (!this.props.supplierLedger.length) return this.button();
	      return this.button('EDIT_DEDUCTION');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'details-row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'details-left' },
	          this.renderButton(),
	          _react2.default.createElement(_components.ToolTip, { id: 'deduction', msg: (0, _proxyCounterpart.proxyCounterpart)('TOOLTIP_DEDUCTION') })
	        ),
	        this.renderModal()
	      );
	    }
	  }]);
	  return SupplierLedger;
	}(_react2.default.Component); /**
	                               * Created by staffanrantzow on 09/11/16.
	                               */
	
	exports.default = SupplierLedger;

/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(12);
	
	var _agreementDraft = __webpack_require__(928);
	
	var _agreementDraft2 = _interopRequireDefault(_agreementDraft);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 01/12/16.
	 */
	
	function mapStateToProps(state) {
	  return {
	    invoice: state.invoice,
	    i18n: state.i18n
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(_agreementDraft2.default);

/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(30);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'p',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_TERMS_AND_CONDITIONS_EMPTY' })
	);
	
	var _ref2 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CLOSE' });
	
	var AgreementDraftModal = function (_React$Component) {
	  (0, _inherits3.default)(AgreementDraftModal, _React$Component);
	
	  function AgreementDraftModal() {
	    (0, _classCallCheck3.default)(this, AgreementDraftModal);
	    return (0, _possibleConstructorReturn3.default)(this, (AgreementDraftModal.__proto__ || (0, _getPrototypeOf2.default)(AgreementDraftModal)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AgreementDraftModal, [{
	    key: 'createMarkup',
	    value: function createMarkup(html) {
	      return { __html: html };
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      if (this.props.agreementDraft) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h2',
	            null,
	            this.props.agreementDraft.headline
	          ),
	          _react2.default.createElement('p', { dangerouslySetInnerHTML: this.createMarkup(this.props.agreementDraft.text) })
	        );
	      }
	
	      return _ref;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactModal2.default,
	        {
	          className: 'modal',
	          contentLabel: '',
	          isOpen: true,
	          onRequestClose: this.props.close },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-content confirm-modal' },
	          _react2.default.createElement('button', { className: 'close', onClick: this.props.close }),
	          this.renderContent(),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn', onClick: this.props.close },
	            _ref2
	          )
	        )
	      );
	    }
	  }]);
	  return AgreementDraftModal;
	}(_react2.default.Component);
	
	exports.default = AgreementDraftModal;

/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _invoiceValidator = __webpack_require__(91);
	
	var _invoiceValidator2 = _interopRequireDefault(_invoiceValidator);
	
	var _agreementDraftModal = __webpack_require__(927);
	
	var _agreementDraftModal2 = _interopRequireDefault(_agreementDraftModal);
	
	var _frilansFinans = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ = __webpack_require__(40);
	
	var _ref = _react2.default.createElement(_reactTranslateComponent2.default, { component: 'div', className: 'terms-text', content: 'INVOICE_TERMS_AND_CONDITIONS_4' });
	
	var _ref2 = _react2.default.createElement(
	  'p',
	  { className: 'error' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'GENERAL_ERROR', component: 'div' })
	);
	
	var _ref3 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'HAVE_READ', component: 'div', className: 'display-inline' });
	
	var _ref4 = _react2.default.createElement(_reactTranslateComponent2.default, { component: 'div', className: 'terms-text', content: 'INVOICE_TERMS_AND_CONDITIONS_2_INCL' });
	
	var _ref5 = _react2.default.createElement(_reactTranslateComponent2.default, { component: 'div', className: 'terms-text', content: 'INVOICE_TERMS_AND_CONDITIONS_1' });
	
	var _ref6 = _react2.default.createElement(_reactTranslateComponent2.default, { component: 'div', className: 'terms-text', content: 'INVOICE_TERMS_AND_CONDITIONS_AND' });
	
	var AgreementDraft = function (_React$Component) {
	  (0, _inherits3.default)(AgreementDraft, _React$Component);
	
	  function AgreementDraft(props, context) {
	    (0, _classCallCheck3.default)(this, AgreementDraft);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (AgreementDraft.__proto__ || (0, _getPrototypeOf2.default)(AgreementDraft)).call(this, props, context));
	
	    _this.state = {
	      agreementDraft: [],
	      index: 0,
	      showModal: false,
	      fetchError: false
	    };
	
	    _this.toggleModal = _this.toggleModal.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(AgreementDraft, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchDraft(this.props.invoice);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // Check for diffs among the props we are interested in
	      if (nextProps.invoice.customerId !== this.props.invoice.customerId || nextProps.invoice.specification !== this.props.invoice.specification || nextProps.i18n.locale !== this.props.i18n.locale || !_.isEqual(nextProps.invoice.invoiceDate, this.props.invoice.invoiceDate)) {
	        this.fetchDraft(nextProps.invoice);
	      }
	    }
	  }, {
	    key: 'fetchDraft',
	    value: function fetchDraft(invoice) {
	      if (this.allParamsSet(invoice)) {
	        this.startRequestTimeout();
	      }
	    }
	
	    /**
	     * Check if all needed parameters to make the request are set
	     */
	
	  }, {
	    key: 'allParamsSet',
	    value: function allParamsSet(invoice) {
	      // Company ID
	      if (!_invoiceValidator2.default.validateCustomer(invoice.customerId)) {
	        return false;
	      }
	      // Specification
	      if (!_invoiceValidator2.default.validateSpecification(invoice.specification)) {
	        return false;
	      }
	      // Invoice date
	      if (!_invoiceValidator2.default.validateInvoiceDate(invoice.invoiceDate)) {
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'startRequestTimeout',
	    value: function startRequestTimeout() {
	      if (this.requestTimeout) {
	        window.clearTimeout(this.requestTimeout);
	      }
	
	      this.requestTimeout = setTimeout(this.makeRequest.bind(this), 500);
	    }
	  }, {
	    key: 'makeRequest',
	    value: function makeRequest() {
	      var _this2 = this;
	
	      var invoice = this.props.invoice;
	
	      if (this.allParamsSet(invoice)) {
	        var params = {
	          userId: this.context.user.id,
	          customerId: invoice.customerId,
	          specification: invoice.specification,
	          firstWorkDate: invoice.invoiceDate[0].date,
	          lastWorkDate: invoice.invoiceDate[invoice.invoiceDate.length - 1].date,
	          languageId: this.props.i18n.locale === 'se' ? 1 : 3
	        };
	
	        _frilansFinans.AgreementDraftService.post(params).then(function (response) {
	          _this2.setState({
	            agreementDraft: response,
	            fetchError: false
	          });
	        }).catch(function () {
	          _this2.setState({
	            fetchError: true
	          });
	        });
	      }
	    }
	  }, {
	    key: 'toggleModal',
	    value: function toggleModal(e) {
	      var index = 0;
	
	      if (e) {
	        e.preventDefault();
	        index = parseInt(e.target.parentElement.getAttribute('data-index'));
	      }
	
	      this.setState({
	        showModal: !this.state.showModal,
	        index: index
	      });
	    }
	  }, {
	    key: 'renderModal',
	    value: function renderModal() {
	      if (this.state.showModal) {
	        return _react2.default.createElement(_agreementDraftModal2.default, {
	          agreementDraft: this.state.agreementDraft[this.state.index],
	          close: this.toggleModal });
	      }
	    }
	  }, {
	    key: 'renderPrivacyPolicyDocumentLink',
	    value: function renderPrivacyPolicyDocumentLink() {
	      var documentUrl = this.props.i18n.locale === 'en' ? '/Bilaga_behandling_av_personuppgifter_ENGELSKA.pdf' : '/Bilaga_behandling_av_personuppgifter_SVENSKA.pdf';
	
	      return _react2.default.createElement(
	        'a',
	        { href: documentUrl, target: '_blank' },
	        _ref
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.fetchError) {
	        return _ref2;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'display-inline agreement-draft' },
	        _ref3,
	        _react2.default.createElement(
	          'a',
	          { href: '#', onClick: this.toggleModal, 'data-index': '1' },
	          _ref4
	        ),
	        ',',
	        _react2.default.createElement(
	          'a',
	          { href: '#', onClick: this.toggleModal, 'data-index': '0' },
	          _ref5
	        ),
	        _ref6,
	        this.renderPrivacyPolicyDocumentLink(),
	        this.renderModal()
	      );
	    }
	  }]);
	  return AgreementDraft;
	}(_react2.default.Component);
	
	AgreementDraft.contextTypes = {
	  user: _react.PropTypes.object.isRequired
	};
	exports.default = AgreementDraft;

/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(12);
	
	var _index = __webpack_require__(43);
	
	var _footer = __webpack_require__(930);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    invoiceId: state.invoice.invoiceId,
	    submitted: state.invoice.submitted,
	    termsAccepted: state.invoice.termsAccepted,
	    valid: state.invoice.valid,
	    posting: state.invoice.posting,
	    postError: state.invoice.postError,
	    validationErrors: state.validationError,
	    invoice: state.invoice
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    setSubmitted: function setSubmitted(submitted) {
	      return dispatch((0, _index.setSubmitted)(submitted));
	    },
	    setTermsAccepted: function setTermsAccepted(termsAccepted) {
	      return dispatch((0, _index.setTermsAccepted)(termsAccepted));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_footer2.default);

/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Footer = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _components = __webpack_require__(13);
	
	var _agreementDraftContainer = __webpack_require__(926);
	
	var _agreementDraftContainer2 = _interopRequireDefault(_agreementDraftContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'p',
	  { className: 'error' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ACCEPT_TERMS' })
	);
	
	var _ref2 = _react2.default.createElement(
	  'p',
	  { className: 'error' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_NOT_VALID' })
	);
	
	var _ref3 = _react2.default.createElement(
	  'span',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_TOOL_PREVIEW_INVOICE_TEXTLINK' })
	);
	
	var _ref4 = _react2.default.createElement(
	  'label',
	  { htmlFor: 'terms-conditions' },
	  _react2.default.createElement('span', null),
	  _react2.default.createElement(_agreementDraftContainer2.default, null)
	);
	
	var Footer = exports.Footer = function (_React$Component) {
	  (0, _inherits3.default)(Footer, _React$Component);
	
	  function Footer(props, context) {
	    (0, _classCallCheck3.default)(this, Footer);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Footer.__proto__ || (0, _getPrototypeOf2.default)(Footer)).call(this, props, context));
	
	    _this.state = {
	      termsAccepted: false,
	      submitted: false,
	      renderConfirmModal: false,
	      preReport: false
	    };
	
	    _this.onCloseClick = _this.onCloseClick.bind(_this);
	    _this.closeModal = _this.closeModal.bind(_this);
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.setPreReportTrue = _this.setPreReportTrue.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(Footer, [{
	    key: 'handleClick',
	    value: function handleClick(e) {
	      this.setState({
	        termsAccepted: e.target.checked,
	        submitted: false
	      });
	      this.props.setTermsAccepted(e.target.checked);
	    }
	
	    /**
	     * Required function when you have the checked attribute on a checkbox
	     */
	
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {}
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (!prevProps.invoice.preReport && this.props.invoice.preReport) {
	        if (!this.state.preReport) {
	          this.setPreReportTrue();
	        }
	      }
	    }
	  }, {
	    key: 'setPreReportTrue',
	    value: function setPreReportTrue() {
	      this.setState({
	        preReport: true
	      });
	    }
	  }, {
	    key: 'renderTermsError',
	    value: function renderTermsError() {
	      if (this.props.invoice.submitted && !this.props.invoice.termsAccepted) {
	        return _ref;
	      }
	    }
	  }, {
	    key: 'renderInvoiceError',
	    value: function renderInvoiceError() {
	      if (this.state.submitted && !this.props.valid) {
	        return _ref2;
	      }
	    }
	  }, {
	    key: 'renderInvoiceButtonPreReport',
	    value: function renderInvoiceButtonPreReport() {
	      if (this.props.registerAssignmentTool) {
	        var saveUpdateStr = this.props.invoiceId ? 'UPDATE_INVOICE' : 'REGISTER_SAVE_DRAFT';
	        var classes = 'btn outlined blue';
	
	        if (this.props.registerAssignmentTool) {
	          saveUpdateStr = this.props.invoiceId ? this.props.translationPrefix + 'UPDATE_INVOICE' : this.props.translationPrefix + 'REGISTER_SAVE_DRAFT';
	          classes = 'btn';
	        }
	
	        return _react2.default.createElement(_components.SpinnerButton, {
	          text: (0, _proxyCounterpart.proxyCounterpart)(saveUpdateStr), graySpinner: 'true',
	          loading: this.props.posting && this.props.invoice.preReport,
	          classes: classes,
	          callback: this.props.onClickSave });
	      }
	    }
	  }, {
	    key: 'renderInvoiceButtonCreate',
	    value: function renderInvoiceButtonCreate() {
	      if (this.props.registerAssignmentTool) {
	        return;
	      }
	
	      var shouldUpdate = this.props.invoiceId && !this.state.preReport;
	
	      var sendInvoiceText = null;
	
	      if (shouldUpdate) {
	        sendInvoiceText = 'UPDATE_INVOICE';
	      } else if (this.props.invoiceId && this.state.preReport) {
	        sendInvoiceText = 'INVOICE_TOOL_CREATE_INVOICE_BUTTON';
	      } else {
	        sendInvoiceText = 'INVOICE_TOOL_COMPLETE_BUTTON';
	      }
	
	      return _react2.default.createElement(_components.SpinnerButton, {
	        text: (0, _proxyCounterpart.proxyCounterpart)(sendInvoiceText),
	        loading: this.props.posting && !this.props.invoice.preReport,
	        classes: 'btn',
	        callback: this.props.openSendModal
	      });
	    }
	  }, {
	    key: 'renderPreviewButton',
	    value: function renderPreviewButton() {
	      if (!this.props.registerAssignmentTool) {
	        return _react2.default.createElement(
	          'button',
	          { className: 'invoice-tool-preview-invoice-link', onClick: this.props.openPreviewModal },
	          _ref3
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderCancelButton',
	    value: function renderCancelButton() {
	      return _react2.default.createElement(
	        'button',
	        { className: 'btn outlined blue', onClick: this.onCloseClick },
	        _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(_reactTranslateComponent2.default, { content: this.props.translationPrefix + 'CANCEL_BUTTON' })
	        )
	      );
	    }
	  }, {
	    key: 'renderPostError',
	    value: function renderPostError() {
	      if (this.props.postError) {
	        return _react2.default.createElement(_components.ValidationError, { errors: this.props.validationErrors });
	      }
	    }
	  }, {
	    key: 'onCloseClick',
	    value: function onCloseClick() {
	      this.setState({
	        renderConfirmModal: true
	      });
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal(confirm) {
	      if (confirm) {
	        this.context.router.replace('/activities');
	      } else {
	        this.setState({
	          renderConfirmModal: false
	        });
	      }
	    }
	  }, {
	    key: 'renderConfirmModal',
	    value: function renderConfirmModal() {
	      if (this.state.renderConfirmModal) {
	        return _react2.default.createElement(_components.ConfirmModal, { callback: this.closeModal, message: (0, _proxyCounterpart.proxyCounterpart)('CONFIRM_CLOSE_TOOL') });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'invoice-footer section-padding' },
	        _react2.default.createElement(
	          'div',
	          { className: 'checkbox-holder' },
	          _react2.default.createElement('input', {
	            id: 'terms-conditions',
	            type: 'checkbox', onChange: this.onChange,
	            name: 'rot', value: this.state.termsAccepted, onClick: this.handleClick }),
	          _ref4
	        ),
	        this.renderTermsError(),
	        this.renderInvoiceError(),
	        this.renderPostError(),
	        this.renderPreviewButton(),
	        _react2.default.createElement(
	          'div',
	          { className: 'button-holder' },
	          this.renderCancelButton(),
	          this.renderInvoiceButtonPreReport(),
	          this.renderInvoiceButtonCreate()
	        ),
	        this.renderConfirmModal()
	      );
	    }
	  }]);
	  return Footer;
	}(_react2.default.Component);
	
	Footer.contextTypes = {
	  router: _react.PropTypes.object.isRequired
	};
	exports.default = Footer;

/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InvoiceToolHeader = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cog = __webpack_require__(732);
	
	var _cog2 = _interopRequireDefault(_cog);
	
	var _close = __webpack_require__(213);
	
	var _close2 = _interopRequireDefault(_close);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _components = __webpack_require__(13);
	
	var _variables = __webpack_require__(47);
	
	var variables = _interopRequireWildcard(_variables);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_cog2.default, { width: '36', height: '36' });
	
	var _ref2 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ACCOUNT_SETTINGS' });
	
	var _ref3 = _react2.default.createElement(_close2.default, { color: '#FFFFFF' });
	
	var InvoiceToolHeader = exports.InvoiceToolHeader = function (_React$Component) {
	  (0, _inherits3.default)(InvoiceToolHeader, _React$Component);
	
	  function InvoiceToolHeader(props, context) {
	    (0, _classCallCheck3.default)(this, InvoiceToolHeader);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (InvoiceToolHeader.__proto__ || (0, _getPrototypeOf2.default)(InvoiceToolHeader)).call(this, props, context));
	
	    _this.state = {
	      renderConfirmModal: false
	    };
	
	    _this.onCloseClick = _this.onCloseClick.bind(_this);
	    _this.closeModal = _this.closeModal.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(InvoiceToolHeader, [{
	    key: 'onCloseClick',
	    value: function onCloseClick() {
	      this.setState({
	        renderConfirmModal: true
	      });
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal(confirm) {
	      if (confirm) {
	        this.context.router.replace('/activities');
	      } else {
	        this.setState({
	          renderConfirmModal: false
	        });
	      }
	    }
	  }, {
	    key: 'renderConfirmModal',
	    value: function renderConfirmModal() {
	      if (this.state.renderConfirmModal) {
	        return _react2.default.createElement(_components.ConfirmModal, { callback: this.closeModal, message: (0, _proxyCounterpart.proxyCounterpart)('CONFIRM_CLOSE_TOOL') });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'header',
	        { className: 'page-header' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'a',
	            { href: '#', className: 'account-link-mobile', onClick: this.props.openSettingsModal },
	            _ref
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: variables.frontUrl, className: 'logo center-logo' },
	            _react2.default.createElement(
	              'object',
	              { type: 'image/svg+xml',
	                data: __webpack_require__(658),
	                alt: 'Frilans Finans-logotyp' },
	              _react2.default.createElement('img', { src: __webpack_require__(207), alt: 'Frilans Finans-logotyp' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'right hide-tablet' },
	            _react2.default.createElement(
	              'a',
	              { href: '#',
	                className: 'account-link',
	                onClick: this.props.openSettingsModal },
	              _ref2
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: 'btn outlined', onClick: this.onCloseClick },
	              _react2.default.createElement(_reactTranslateComponent2.default, { content: this.props.translationPrefix + 'CLOSE_INVOICE_TOOL' })
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'close-tool', onClick: this.onCloseClick },
	            _ref3
	          )
	        ),
	        this.renderConfirmModal()
	      );
	    }
	  }]);
	  return InvoiceToolHeader;
	}(_react2.default.Component);
	
	InvoiceToolHeader.contextTypes = {
	  router: _react.PropTypes.object.isRequired
	};
	exports.default = InvoiceToolHeader;

/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(12);
	
	var _index = __webpack_require__(43);
	
	var _hsd = __webpack_require__(933);
	
	var _hsd2 = _interopRequireDefault(_hsd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    expressPayment: state.invoice.expressPayment,
	    rot: state.invoice.hsd.rot,
	    rut: state.invoice.hsd.rut,
	    data: state.invoice.hsd.data,
	    apartmentNumber: state.invoice.hsd.apartmentNumber,
	    cooperativeApartmentRegistrationNumber: state.invoice.hsd.cooperativeApartmentRegistrationNumber,
	    accommodationType: state.invoice.hsd.accommodationType,
	    submitted: state.invoice.submitted
	  };
	} /**
	   * Created by eriksundqvist on 25/05/16.
	   */
	;
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    setExpressPayment: function setExpressPayment(expressPayment) {
	      return dispatch((0, _index.setExpressPayment)(expressPayment));
	    },
	    setRot: function setRot(rot, data, apartmentNumber, cooperativeApartmentRegistrationNumber, accommodationType) {
	      return dispatch((0, _index.setRot)(rot, data, apartmentNumber, cooperativeApartmentRegistrationNumber, accommodationType));
	    },
	    setRut: function setRut(rut) {
	      return dispatch((0, _index.setRut)(rut));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_hsd2.default);

/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Hsd = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _readMoreModal = __webpack_require__(226);
	
	var _readMoreModal2 = _interopRequireDefault(_readMoreModal);
	
	var _invoiceValidator = __webpack_require__(91);
	
	var _invoiceValidator2 = _interopRequireDefault(_invoiceValidator);
	
	var _lodash = __webpack_require__(40);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'p',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'HSD_CHOOSE_ACCOMMODATION' })
	);
	
	var _ref2 = _react2.default.createElement(
	  'label',
	  { htmlFor: 'house' },
	  _react2.default.createElement('span', null),
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'HSD_PROPERTY' })
	);
	
	var _ref3 = _react2.default.createElement(
	  'label',
	  { htmlFor: 'apartment' },
	  _react2.default.createElement('span', null),
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'HSD_APARTMENT' })
	);
	
	var _ref4 = _react2.default.createElement(
	  'h3',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ROT_RUT' })
	);
	
	var _ref5 = _react2.default.createElement(
	  'label',
	  { htmlFor: 'rot' },
	  _react2.default.createElement('span', null),
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ROT' })
	);
	
	var _ref6 = _react2.default.createElement(
	  'label',
	  { htmlFor: 'rut' },
	  _react2.default.createElement('span', null),
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'RUT' })
	);
	
	var _ref7 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ROT_RUT_READ_MORE' });
	
	var Hsd = exports.Hsd = function (_React$Component) {
	  (0, _inherits3.default)(Hsd, _React$Component);
	
	  function Hsd(props, context) {
	    (0, _classCallCheck3.default)(this, Hsd);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Hsd.__proto__ || (0, _getPrototypeOf2.default)(Hsd)).call(this, props, context));
	
	    _this.state = {
	      renderModal: false,
	      renderExpressModal: false
	    };
	
	    _this.toggleModal = _this.toggleModal.bind(_this);
	    _this.renderModal = _this.renderModal.bind(_this);
	    _this.toggleExpressModal = _this.toggleExpressModal.bind(_this);
	    _this.renderExpressModal = _this.renderExpressModal.bind(_this);
	
	    _this.onChangeType = _this.onChangeType.bind(_this);
	    _this.onKeyUpData = _this.onKeyUpData.bind(_this);
	    _this.onKeyUpApartmentNumber = _this.onKeyUpApartmentNumber.bind(_this);
	    _this.onChangeAccommodationType = _this.onChangeAccommodationType.bind(_this);
	    _this.onKeyUpCooperativeApartmentRegistrationNumber = _this.onKeyUpCooperativeApartmentRegistrationNumber.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(Hsd, [{
	    key: 'toggleModal',
	    value: function toggleModal() {
	      this.setState({
	        renderModal: !this.state.renderModal
	      });
	    }
	  }, {
	    key: 'toggleExpressModal',
	    value: function toggleExpressModal() {
	      this.setState({
	        renderExpressModal: !this.state.renderExpressModal
	      });
	    }
	  }, {
	    key: 'renderModal',
	    value: function renderModal() {
	      if (this.state.renderModal) {
	        return _react2.default.createElement(_readMoreModal2.default, {
	          close: this.toggleModal,
	          text: _readMoreModal.ROT_RUT
	        });
	      }
	    }
	  }, {
	    key: 'renderExpressModal',
	    value: function renderExpressModal() {
	      if (this.state.renderExpressModal) {
	        return _react2.default.createElement(_readMoreModal2.default, {
	          close: this.toggleExpressModal,
	          text: _readMoreModal.EXPRESS_NOT_ROT_RUT
	        });
	      }
	    }
	  }, {
	    key: 'onChangeType',
	    value: function onChangeType(e) {
	      switch (e.target.value) {
	        case 'rot':
	          this.props.setRot(e.target.checked, this.props.data, this.props.apartmentNumber, this.props.cooperativeApartmentRegistrationNumber, _lodash2.default.isEmpty(this.props.accommodationType) ? 'house' : this.props.accommodationType);
	          break;
	        case 'rut':
	          this.props.setRut(e.target.checked);
	          break;
	      }
	
	      if (e.target.checked && this.props.expressPayment) {
	        this.toggleExpressModal();
	        this.props.setExpressPayment(false);
	      }
	    }
	  }, {
	    key: 'onChangeAccommodationType',
	    value: function onChangeAccommodationType(e) {
	      this.props.setRot(this.props.rot, '', '', '', e.target.value);
	    }
	  }, {
	    key: 'onKeyUpData',
	    value: function onKeyUpData(e) {
	      this.props.setRot(this.props.rot, e.target.value, this.props.apartmentNumber, this.props.cooperativeApartmentRegistrationNumber, this.props.accommodationType);
	    }
	  }, {
	    key: 'onKeyUpApartmentNumber',
	    value: function onKeyUpApartmentNumber(e) {
	      this.props.setRot(this.props.rot, this.props.data, e.target.value, this.props.cooperativeApartmentRegistrationNumber, this.props.accommodationType);
	    }
	  }, {
	    key: 'onKeyUpCooperativeApartmentRegistrationNumber',
	    value: function onKeyUpCooperativeApartmentRegistrationNumber(e) {
	      this.props.setRot(this.props.rot, this.props.data, this.props.apartmentNumber, e.target.value, this.props.accommodationType);
	    }
	  }, {
	    key: 'renderError',
	    value: function renderError() {
	      var errorKey = void 0;
	      var map = [this.props.rot, this.props.data, this.props.accommodationType, this.props.apartmentNumber, this.props.cooperativeApartmentRegistrationNumber];
	
	      if (this.props.submitted && !_invoiceValidator2.default.validateHsd.apply(_invoiceValidator2.default, map)) {
	        if (this.props.accommodationType === 'house') {
	          errorKey = 'INVOICE_HSD_ROT_HOUSE';
	        } else if (this.props.accommodationType === 'apartment') {
	          errorKey = 'INVOICE_HSD_ROT_APARTMENT';
	        }
	
	        return _react2.default.createElement(
	          'p',
	          { className: 'error' },
	          _react2.default.createElement(_reactTranslateComponent2.default, { content: errorKey })
	        );
	      }
	    }
	  }, {
	    key: 'renderRot',
	    value: function renderRot() {
	      var datainputAccommodationHouse = void 0;
	      var datainputAccommodationApartment = void 0;
	
	      if (this.props.accommodationType === 'house') {
	        datainputAccommodationHouse = _react2.default.createElement('input', { type: 'text',
	          name: 'data',
	          onKeyUp: this.onKeyUpData,
	          defaultValue: this.props.data,
	          placeholder: (0, _proxyCounterpart.proxyCounterpart)('HSD_PROPERTY_LABEL') });
	      }
	
	      if (this.props.accommodationType === 'apartment') {
	        datainputAccommodationApartment = _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('input', { type: 'text',
	            name: 'cooperativeApartmentRegistrationNumber',
	            onKeyUp: this.onKeyUpCooperativeApartmentRegistrationNumber,
	            defaultValue: this.props.cooperativeApartmentRegistrationNumber,
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('HSD_BRF_ORG_NUMBER') }),
	          _react2.default.createElement('input', { type: 'text',
	            name: 'apartmentNumber',
	            onKeyUp: this.onKeyUpApartmentNumber,
	            defaultValue: this.props.apartmentNumber,
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('HSD_BRF_APARTMENT_NUMBER') })
	        );
	      }
	
	      if (this.props.rot) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'hsd-accommodation' },
	          _ref,
	          _react2.default.createElement(
	            'div',
	            { className: 'checkbox-wrapper' },
	            _react2.default.createElement('input', { id: 'house',
	              type: 'checkbox',
	              name: 'hsd_rot_type_of_accommodation',
	              value: 'house',
	              onChange: this.onChangeAccommodationType,
	              checked: this.props.accommodationType === 'house' }),
	            _ref2
	          ),
	          datainputAccommodationHouse,
	          _react2.default.createElement(
	            'div',
	            { className: 'checkbox-wrapper' },
	            _react2.default.createElement('input', { id: 'apartment',
	              type: 'checkbox',
	              name: 'hsd_rot_type_of_accommodation',
	              value: 'apartment',
	              onChange: this.onChangeAccommodationType,
	              checked: this.props.accommodationType === 'apartment' }),
	            _ref3
	          ),
	          datainputAccommodationApartment
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'hsd-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'hsd' },
	          _ref4,
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(_reactTranslateComponent2.default, { content: this.props.translationPrefix + 'ROT_RUT_TEXT' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'checkbox-wrapper' },
	            _react2.default.createElement('input', { id: 'rot',
	              type: 'checkbox',
	              name: 'hsd',
	              value: 'rot',
	              onChange: this.onChangeType,
	              checked: this.props.rot }),
	            _ref5
	          ),
	          this.renderRot(),
	          _react2.default.createElement(
	            'div',
	            { className: 'checkbox-wrapper' },
	            _react2.default.createElement('input', { id: 'rut',
	              type: 'checkbox',
	              name: 'hsd',
	              value: 'rut',
	              onChange: this.onChangeType,
	              checked: this.props.rut }),
	            _ref6
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'hsd-link' },
	          _react2.default.createElement(
	            'button',
	            { className: 'pointer-link', onClick: this.toggleModal },
	            _ref7
	          )
	        ),
	        this.renderError(),
	        this.renderModal(),
	        this.renderExpressModal()
	      );
	    }
	  }]);
	  return Hsd;
	}(_react2.default.Component);
	
	exports.default = Hsd;

/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PartTwo = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _distributionContainer = __webpack_require__(913);
	
	var _distributionContainer2 = _interopRequireDefault(_distributionContainer);
	
	var _footerContainer = __webpack_require__(929);
	
	var _footerContainer2 = _interopRequireDefault(_footerContainer);
	
	var _offersContainer = __webpack_require__(939);
	
	var _offersContainer2 = _interopRequireDefault(_offersContainer);
	
	var _invoicing = __webpack_require__(937);
	
	var _invoicing2 = _interopRequireDefault(_invoicing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'section-padding' },
	  _react2.default.createElement(
	    'div',
	    { className: 'col-sm-12' },
	    _react2.default.createElement(_offersContainer2.default, null)
	  )
	);
	
	var PartTwo = exports.PartTwo = function (_React$Component) {
	  (0, _inherits3.default)(PartTwo, _React$Component);
	
	  function PartTwo() {
	    (0, _classCallCheck3.default)(this, PartTwo);
	    return (0, _possibleConstructorReturn3.default)(this, (PartTwo.__proto__ || (0, _getPrototypeOf2.default)(PartTwo)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PartTwo, [{
	    key: 'renderOffersContainer',
	    value: function renderOffersContainer() {
	      if (!this.props.registerAssignmentTool) {
	        return _ref;
	      }
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'tool-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'tool-content container payment-details-bottom' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section-padding' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12' },
	              _react2.default.createElement(_distributionContainer2.default, {
	                translationPrefix: this.props.translationPrefix
	              })
	            )
	          ),
	          this.renderOffersContainer(),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12' },
	            _react2.default.createElement(_invoicing2.default, {
	              translationPrefix: this.props.translationPrefix
	            })
	          ),
	          _react2.default.createElement(_footerContainer2.default, {
	            postInvoice: this.props.postInvoice,
	            openPreviewModal: this.props.openPreviewModal,
	            closePreviewModal: this.props.closePreviewModal,
	            openSendModal: this.props.openSendModal,
	            closeSendModal: this.props.closeSendModal,
	            onClickSave: this.props.onClickSave,
	            translationPrefix: this.props.translationPrefix,
	            registerAssignmentTool: this.props.registerAssignmentTool
	          })
	        )
	      );
	    }
	  }]);
	  return PartTwo;
	}(_react2.default.Component);
	
	exports.default = PartTwo;

/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(12);
	
	var _index = __webpack_require__(43);
	
	var _invoiceTool = __webpack_require__(936);
	
	var _invoiceTool2 = _interopRequireDefault(_invoiceTool);
	
	var _index2 = __webpack_require__(375);
	
	var _index3 = __webpack_require__(837);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    user: state.user,
	    taxkeys: state.taxkeys,
	    invoice: state.invoice,
	    currencies: state.currencies
	  };
	} /**
	   * Created by eriksundqvist on 25/05/16.
	   */
	;
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    setUserId: function setUserId(userId) {
	      return dispatch((0, _index.setUserId)(userId));
	    },
	    setTaxId: function setTaxId(taxId) {
	      return dispatch((0, _index.setTaxId)(taxId));
	    },
	    setSaveVacationPay: function setSaveVacationPay(saveVacationPay) {
	      return dispatch((0, _index.setSaveVacationPay)(saveVacationPay));
	    },
	    setAmount: function setAmount(amount) {
	      return dispatch((0, _index.setAmount)(amount));
	    },
	    setCustomerId: function setCustomerId(customerId) {
	      return dispatch((0, _index.setCustomerId)(customerId));
	    },
	    setCurrencyId: function setCurrencyId(currencyId) {
	      return dispatch((0, _index.setCurrencyId)(currencyId));
	    },
	    setCurrencyName: function setCurrencyName(currencyName) {
	      return dispatch((0, _index.setCurrencyName)(currencyName));
	    },
	    setCurrencyAmount: function setCurrencyAmount(currencyAmount) {
	      return dispatch((0, _index.setCurrencyAmount)(currencyAmount));
	    },
	    setSpecification: function setSpecification(specification) {
	      return dispatch((0, _index.setSpecification)(specification));
	    },
	    setInvoiceDate: function setInvoiceDate(date) {
	      return dispatch((0, _index.setInvoiceDate)(date));
	    },
	    setInvoiceUser: function setInvoiceUser(invoiceUser) {
	      return dispatch((0, _index.setInvoiceUser)(invoiceUser));
	    },
	    setInvoiceId: function setInvoiceId(invoiceId) {
	      return dispatch((0, _index.setInvoiceId)(invoiceId));
	    },
	    setSupplierLedger: function setSupplierLedger(supplierLedger) {
	      return dispatch((0, _index.setSupplierLedger)(supplierLedger));
	    },
	    setValid: function setValid(valid) {
	      return dispatch((0, _index.setValid)(valid));
	    },
	    setPosting: function setPosting(posting) {
	      return dispatch((0, _index.setPosting)(posting));
	    },
	    setPostError: function setPostError(postError) {
	      return dispatch((0, _index.setPostError)(postError));
	    },
	    setValidationErrors: function setValidationErrors(validationError) {
	      return dispatch((0, _index2.setValidationErrors)(validationError));
	    },
	    clearValidationErrors: function clearValidationErrors() {
	      return dispatch((0, _index2.clearValidationErrors)());
	    },
	    clear: function clear() {
	      return dispatch((0, _index.clear)());
	    },
	    setLockAmountDistribution: function setLockAmountDistribution(lockAmountDistribution) {
	      return dispatch((0, _index.setLockAmountDistribution)(lockAmountDistribution));
	    },
	    setInitializing: function setInitializing(initializing) {
	      return dispatch((0, _index.setInitializing)(initializing));
	    },
	    setRut: function setRut(rut) {
	      return dispatch((0, _index.setRut)(rut));
	    },
	    setRot: function setRot(rot, data, apartmentNumber, cooperativeApartmentRegistrationNumber, accommodationType) {
	      return dispatch((0, _index.setRot)(rot, data, apartmentNumber, cooperativeApartmentRegistrationNumber, accommodationType));
	    },
	    setSendToEmail: function setSendToEmail(sendToEmail) {
	      return dispatch((0, _index.setSendToEmail)(sendToEmail));
	    },
	    setSendToEmailSecondary: function setSendToEmailSecondary(sendToEmail) {
	      return dispatch((0, _index.setSendToEmailSecondary)(sendToEmail));
	    },
	    setSendToEmailBool: function setSendToEmailBool(sendToEmail) {
	      return dispatch((0, _index.setSendToEmailBool)(sendToEmail));
	    },
	    setEinvoiceAddress: function setEinvoiceAddress(einvoiceAddress) {
	      return dispatch((0, _index.setEinvoiceAddress)(einvoiceAddress));
	    },
	    setDisplayDates: function setDisplayDates(displayDates) {
	      return dispatch((0, _index.setDisplayDates)(displayDates));
	    },
	    setDisplayHours: function setDisplayHours(displayHours) {
	      return dispatch((0, _index.setDisplayHours)(displayHours));
	    },
	    setSubmitted: function setSubmitted(submitted) {
	      return dispatch((0, _index.setSubmitted)(submitted));
	    },
	    setPreReport: function setPreReport(preReport) {
	      return dispatch((0, _index.setPreReport)(preReport));
	    },
	    setPreReportedAt: function setPreReportedAt(preReportedAt) {
	      return dispatch((0, _index.setPreReportedAt)(preReportedAt));
	    },
	    setTermsAccepted: function setTermsAccepted(termsAccepted) {
	      return dispatch((0, _index.setTermsAccepted)(termsAccepted));
	    },
	    setExpressPayment: function setExpressPayment(expressPayment) {
	      return dispatch((0, _index.setExpressPayment)(expressPayment));
	    },
	    setSupplierLedgerTypes: function setSupplierLedgerTypes(types) {
	      return dispatch((0, _index3.setSupplierLedgerTypes)(types));
	    },
	    setCouponId: function setCouponId(couponId) {
	      return dispatch((0, _index.setCouponId)(couponId));
	    },
	    setMessageType: function setMessageType(messageType) {
	      return dispatch((0, _index.setMessageType)(messageType));
	    },
	    setSurveyAnswers: function setSurveyAnswers(answers, status) {
	      return dispatch((0, _index.setSurveyAnswers)(answers, status));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_invoiceTool2.default);

/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InvoiceTool = undefined;
	
	var _keys = __webpack_require__(233);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getIterator2 = __webpack_require__(18);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _toConsumableArray2 = __webpack_require__(120);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _regenerator = __webpack_require__(386);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray2 = __webpack_require__(385);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _asyncToGenerator2 = __webpack_require__(384);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _promise = __webpack_require__(72);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(20);
	
	var _invoiceToolHeader = __webpack_require__(931);
	
	var _invoiceToolHeader2 = _interopRequireDefault(_invoiceToolHeader);
	
	var _previewInvoice = __webpack_require__(941);
	
	var _previewInvoice2 = _interopRequireDefault(_previewInvoice);
	
	var _workDetailsContainer = __webpack_require__(952);
	
	var _workDetailsContainer2 = _interopRequireDefault(_workDetailsContainer);
	
	var _invoicePaymentDetails = __webpack_require__(934);
	
	var _invoicePaymentDetails2 = _interopRequireDefault(_invoicePaymentDetails);
	
	var _settingsTabWrapper = __webpack_require__(942);
	
	var _settingsTabWrapper2 = _interopRequireDefault(_settingsTabWrapper);
	
	var _reactModal = __webpack_require__(30);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _sentOrderModal = __webpack_require__(716);
	
	var _sentOrderModal2 = _interopRequireDefault(_sentOrderModal);
	
	var _confirmInvoiceModal = __webpack_require__(711);
	
	var _confirmInvoiceModal2 = _interopRequireDefault(_confirmInvoiceModal);
	
	var _exceededWorkingHoursSurveyModal = __webpack_require__(687);
	
	var _exceededWorkingHoursSurveyModal2 = _interopRequireDefault(_exceededWorkingHoursSurveyModal);
	
	var _confirmPreregisterModal = __webpack_require__(712);
	
	var _confirmPreregisterModal2 = _interopRequireDefault(_confirmPreregisterModal);
	
	var _registerAssignmentInfoModal = __webpack_require__(714);
	
	var _registerAssignmentInfoModal2 = _interopRequireDefault(_registerAssignmentInfoModal);
	
	var _invoiceToolCompleteInformationModal = __webpack_require__(901);
	
	var _invoiceToolCompleteInformationModal2 = _interopRequireDefault(_invoiceToolCompleteInformationModal);
	
	var _invoiceService = __webpack_require__(220);
	
	var _invoiceService2 = _interopRequireDefault(_invoiceService);
	
	var _customerService = __webpack_require__(218);
	
	var _customerService2 = _interopRequireDefault(_customerService);
	
	var _invoiceValidator = __webpack_require__(91);
	
	var _invoiceValidator2 = _interopRequireDefault(_invoiceValidator);
	
	var _invoiceCalculator = __webpack_require__(698);
	
	var _invoiceCalculator2 = _interopRequireDefault(_invoiceCalculator);
	
	var _taxkeyService = __webpack_require__(119);
	
	var _taxkeyService2 = _interopRequireDefault(_taxkeyService);
	
	var _supplierLedgerListContainer = __webpack_require__(381);
	
	var _supplierLedgerListContainer2 = _interopRequireDefault(_supplierLedgerListContainer);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _components = __webpack_require__(13);
	
	var _ssnr = __webpack_require__(945);
	
	var _ssnr2 = _interopRequireDefault(_ssnr);
	
	var _invoiceUserEntity = __webpack_require__(221);
	
	var _invoiceUserEntity2 = _interopRequireDefault(_invoiceUserEntity);
	
	var _counterpart = __webpack_require__(86);
	
	var _counterpart2 = _interopRequireDefault(_counterpart);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _invoiceToolHelper = __webpack_require__(50);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _entities = __webpack_require__(376);
	
	var entities = _interopRequireWildcard(_entities);
	
	var _cookieUtils = __webpack_require__(89);
	
	var _cookieUtils2 = _interopRequireDefault(_cookieUtils);
	
	var _workDateHelper = __webpack_require__(227);
	
	var _workDateHelper2 = _interopRequireDefault(_workDateHelper);
	
	var _invoiceToolSelectVacationModal = __webpack_require__(903);
	
	var _invoiceToolSelectVacationModal2 = _interopRequireDefault(_invoiceToolSelectVacationModal);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_COUNTRY = 'SWEDEN';
	var NON_DEFAULT_CURRENCY_DEFAULT_TAX_ID = 4;
	
	var _ref4 = _react2.default.createElement(_supplierLedgerListContainer2.default, { showDelete: false });
	
	var _ref5 = _react2.default.createElement(
	  'span',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CONTINUE' })
	);
	
	var _ref7 = _react2.default.createElement(
	  'div',
	  { className: 'container' },
	  _react2.default.createElement(
	    'div',
	    { className: 'row' },
	    _react2.default.createElement(
	      'div',
	      { className: 'col-sm-12' },
	      _react2.default.createElement(_components.GeneralError, null)
	    )
	  )
	);
	
	var _ref8 = _react2.default.createElement(
	  'p',
	  { className: 'title' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_TOOL_LOCK_INVOICE_ERROR_TITLE' })
	);
	
	var _ref9 = _react2.default.createElement('br', null);
	
	var _ref10 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_TOOL_LOCK_INVOICE_ERROR_MESSAGE' });
	
	var _ref11 = _react2.default.createElement('br', null);
	
	var _ref12 = _react2.default.createElement('br', null);
	
	var _ref13 = _react2.default.createElement(
	  _reactRouter.Link,
	  { to: '/activities' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'BACK' })
	);
	
	var _ref14 = _react2.default.createElement(_invoiceCalculator2.default, null);
	
	var InvoiceTool = exports.InvoiceTool = function (_React$Component) {
	  (0, _inherits3.default)(InvoiceTool, _React$Component);
	
	  function InvoiceTool(props, context) {
	    (0, _classCallCheck3.default)(this, InvoiceTool);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (InvoiceTool.__proto__ || (0, _getPrototypeOf2.default)(InvoiceTool)).call(this, props, context));
	
	    _this.getTotalHours = function () {
	      var hours = 0;
	      _this.props.invoice.invoiceDate.forEach(function (item) {
	        hours += item.hours;
	      });
	      return hours;
	    };
	
	    _this.getTotalGross = function () {
	      var gross = 0;
	      _this.props.invoice.invoiceUser.forEach(function (invoiceUser) {
	        gross += invoiceUser.calculation.gross;
	      });
	      return gross;
	    };
	
	    _this.state = {
	      fetchError: false,
	      coworkers: [],
	      settingsModalIsOpen: false,
	      previewModalIsOpen: false,
	      saveModalIsOpen: false,
	      sendModalIsOpen: false,
	      surveyModalIsOpen: false,
	      supplierLedgerListModalIsOpen: false,
	      ssnrModalIsOpen: false,
	      user: props.user,
	      taxkeys: props.taxkeys,
	      invoice: null,
	      invoiceLockError: false,
	      postedInvoiceId: null,
	      fetchingInvoice: false,
	      loading: false,
	      invoiceToolClientErrors: [],
	      preReportInvoice: false,
	      changedLanguage: false,
	      originalLang: _counterpart2.default.getLocale(),
	      sentPrereportModalIsOpen: false,
	      sentInvoiceModalIsOpen: false,
	      registerAssignmentTool: false,
	      registerAssignmentInfoModalIsOpen: false,
	      updated: false,
	      invoiceToolCompleteInformationModalIsOpen: false,
	      saveVacationModalIsOpen: false,
	      hasOpenedVacationModal: false,
	      userTotalHours: 0
	    };
	
	    _this.openSupplierLedgerListModal = _this.openSupplierLedgerListModal.bind(_this);
	    _this.closeSupplierLedgerListModal = _this.closeSupplierLedgerListModal.bind(_this);
	    _this.openSsnrModal = _this.openSsnrModal.bind(_this);
	    _this.closeSsnrModal = _this.closeSsnrModal.bind(_this);
	    _this.openSettingsModal = _this.openSettingsModal.bind(_this);
	    _this.closeSettingsModal = _this.closeSettingsModal.bind(_this);
	    _this.openPreviewModal = _this.openPreviewModal.bind(_this);
	    _this.closePreviewModal = _this.closePreviewModal.bind(_this);
	    _this.openSaveModal = _this.openSaveModal.bind(_this);
	    _this.closeSaveModal = _this.closeSaveModal.bind(_this);
	    _this.openSendModal = _this.openSendModal.bind(_this);
	    _this.closeSendModal = _this.closeSendModal.bind(_this);
	    _this.openSurveyModal = _this.openSurveyModal.bind(_this);
	    _this.closeSurveyModal = _this.closeSurveyModal.bind(_this);
	    _this.openSentInvoiceModal = _this.openSentInvoiceModal.bind(_this);
	    _this.closeSentPrereportModal = _this.closeSentPrereportModal.bind(_this);
	    _this.postInvoice = _this.postInvoice.bind(_this);
	    _this.addTaxkeysToInvoiceUsers = _this.addTaxkeysToInvoiceUsers.bind(_this);
	    _this.createInvoiceUserEntity = _this.createInvoiceUserEntity.bind(_this);
	    _this.onClickSend = _this.onClickSend.bind(_this);
	    _this.onClickSave = _this.onClickSave.bind(_this);
	    _this.onUnload = _this.onUnload.bind(_this);
	    _this.handleInvoiceError = _this.handleInvoiceError.bind(_this);
	    _this.openInvoiceToolCompleteInformationModal = _this.openInvoiceToolCompleteInformationModal.bind(_this);
	    _this.closeSentInvoiceModal = _this.closeSentInvoiceModal.bind(_this);
	    _this.setInvoiceToolCompleteInformationModal = _this.setInvoiceToolCompleteInformationModal.bind(_this);
	    _this.setSaveVacationModal = _this.setSaveVacationModal.bind(_this);
	    _this.setErrors = _this.setErrors.bind(_this);
	    _this.newEmptyInvoice = _this.newEmptyInvoice.bind(_this);
	    _this.newEmptyPreregister = _this.newEmptyPreregister.bind(_this);
	    _this.toggleSentPrereportModal = _this.toggleSentPrereportModal.bind(_this);
	    _this.toggleSentInvoiceModal = _this.toggleSentInvoiceModal.bind(_this);
	    _this.toggleRegisterAssignmentInfoModal = _this.toggleRegisterAssignmentInfoModal.bind(_this);
	    _this.renderUpdatedModal = _this.renderUpdatedModal.bind(_this);
	    _this.closeUpdatingModal = _this.closeUpdatingModal.bind(_this);
	    _this.scrollCalendar = _this.scrollCalendar.bind(_this);
	    _this.shouldDisplaySaveVacationModal = _this.shouldDisplaySaveVacationModal.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(InvoiceTool, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.location.pathname.includes('register')) {
	        this.setState({
	          registerAssignmentTool: true
	        });
	
	        if (!_cookieUtils2.default.getRegisterAssignmentToolVisited()) {
	          this.setState({
	            registerAssignmentInfoModalIsOpen: true
	          });
	          _cookieUtils2.default.setRegisterAssignmentToolVisited();
	        }
	      }
	
	      if (!this.props.params || this.props.params.id === undefined) {
	        // Clear redux form of any old data and add currently logged in user
	        this.props.clear();
	        var loggedInInvoiceUser = this.createInvoiceUserEntity(this.props.user);
	        loggedInInvoiceUser.taxkeys = this.props.taxkeys;
	        this.props.setInvoiceUser([loggedInInvoiceUser]);
	      }
	
	      if (this.props.params.id) {
	        var invoiceId = this.props.params.id;
	        _invoiceService2.default.lockInvoice(invoiceId).then(function (response) {
	          if (response.status !== 200) {
	            _this2.setState({
	              invoiceLockError: true
	            });
	          } else {
	            window.addEventListener('beforeunload', _this2.onUnload);
	          }
	        }).catch(function () {
	          // returns 423 when locked
	          _this2.setState({
	            invoiceLockError: true
	          });
	        });
	      }
	
	      _frilansFinans.SupplierLedgerService.getTypes().then(function (response) {
	        _this2.props.setSupplierLedgerTypes(response);
	      });
	
	      _frilansFinans.UserService.getHoursWorked(this.props.user.id, (0, _moment2.default)().subtract(1, 'years').format('YYYY-MM-DD'), (0, _moment2.default)().format('YYYY-MM-DD')).then(function (response) {
	        _this2.state.userTotalHours = response.data.sum;
	      });
	
	      if (!this.props.params || this.props.params.id === undefined) {
	        window.addEventListener('beforeunload', this.onUnload);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.clear();
	      if (this.props.params.id && !this.state.invoiceLockError) {
	        var invoiceId = this.props.params.id;
	        _invoiceService2.default.unlockInvoice(invoiceId).then(function () {}).catch(function () {
	          // catch to avoid error
	        });
	      }
	      window.removeEventListener('beforeunload', this.onUnload);
	    }
	  }, {
	    key: 'onUnload',
	    value: function onUnload(event) {
	      event.returnValue = 'ask-before-leaving';
	    }
	  }, {
	    key: 'createInvoiceUserEntity',
	    value: function createInvoiceUserEntity(workerEntity) {
	      var invoiceUserEntity = new _invoiceUserEntity2.default(0, workerEntity.address ? workerEntity.address.co : workerEntity.co, workerEntity.address ? workerEntity.address.street : workerEntity.street, workerEntity.address ? workerEntity.address.zip : workerEntity.street, workerEntity.address ? workerEntity.address.city : workerEntity.street, workerEntity.address ? workerEntity.address.country : workerEntity.street, null, workerEntity.id, 0, workerEntity.defaultTaxkeyId, 0, workerEntity.firstName, workerEntity.lastName, workerEntity.accountClearingNumber || workerEntity.accountClearingNr, workerEntity.accountNumber || workerEntity.accountNr, null, false, '', workerEntity.saveVacationPay, workerEntity.saveItp, workerEntity.itpRate);
	
	      return invoiceUserEntity;
	    }
	  }, {
	    key: 'addTaxkeysToInvoiceUsers',
	    value: function addTaxkeysToInvoiceUsers(workers) {
	      var _this3 = this;
	
	      var promises = [];
	
	      var workerIds = workers.map(function (user) {
	        return +user.userId;
	      }).filter(function (userId) {
	        return userId !== +_this3.props.user.id;
	      });
	      var invoiceOwner = workers.find(function (user) {
	        return +user.userId === +_this3.props.user.id;
	      });
	      invoiceOwner.taxkeys = this.props.taxkeys;
	
	      if (workerIds.length) {
	        promises.push(_taxkeyService2.default.getWorkersTaxkeys(workerIds).then(function (response) {
	          response.forEach(function (item) {
	            var user = workers.find(function (worker) {
	              return +worker.userId === +item.userId;
	            });
	            if (user) user.taxkeys = item.taxkeys;
	          });
	        }));
	      }
	
	      return _promise2.default.all(promises);
	    }
	  }, {
	    key: 'handleInvoiceResponse',
	    value: function handleInvoiceResponse(data, supplierLedgers) {
	      var currentExchangeRate = entities.selectById(this.props.currencies.list, data.currencyId).exchangeRate;
	      var currencyAdjustedAmount = data.currencyAmount * currentExchangeRate;
	      data.invoiceUsers = data.invoiceUsers.map(function (user) {
	        user.total = user.total / data.amount * currencyAdjustedAmount;
	        return user;
	      });
	
	      this.props.clear();
	      this.props.setInitializing(true);
	      this.props.setUserId(data.userId);
	      this.props.setTaxId(data.taxId);
	      this.props.setCustomerId(data.companyId);
	      this.props.setCurrencyId(data.currencyId);
	      this.props.setCurrencyName(data.currencyName);
	      this.props.setCurrencyAmount(data.currencyAmount);
	      this.props.setAmount(currencyAdjustedAmount);
	      this.props.setSpecification(data.specification);
	      this.props.setInvoiceDate(data.invoiceDates);
	      this.props.setInvoiceId(this.props.params.id);
	      this.props.setSupplierLedger(supplierLedgers);
	      this.props.setCouponId(data.couponId);
	      this.props.setInvoiceUser(data.invoiceUsers);
	      this.props.setInitializing(false);
	      this.props.setSendToEmail(data.sendToEmail);
	      this.props.setEinvoiceAddress(data.sendToEinvoiceAddress);
	      this.props.setDisplayDates(data.displayDates);
	      this.props.setDisplayHours(data.displayHours);
	
	      this.props.setPreReport(data.preReport);
	      this.props.setPreReportedAt(data.preReportedAt);
	      this.props.setMessageType(data.messageType);
	
	      this.handleWorkerLocking(currencyAdjustedAmount, data.invoiceUsers);
	
	      data.sendToEmailBool = data.sendToEmail.length >= 1;
	      this.props.setSendToEmailBool(data.sendToEmailBool);
	
	      if (data.hsd.rot) {
	        this.props.setRot(data.hsd.rot, data.hsd.data, data.hsd.apartmentNumber, data.hsd.cooperativeApartmentRegistrationNumber, data.hsd.accommodationType);
	      } else if (data.hsd.rut) {
	        this.props.setRut(data.hsd.rut);
	      }
	
	      if (data.invoiceUsers && data.invoiceUsers.length > 0 && typeof data.invoiceUsers[0].expressPayment !== 'undefined') {
	        this.props.setExpressPayment(data.invoiceUsers[0].expressPayment);
	      }
	
	      // We need to store this fields that are not saved in Redux because of the preview
	      this.setState({
	        invoice: data,
	        fetchingInvoice: false
	      });
	    }
	  }, {
	    key: 'handleWorkerLocking',
	    value: function handleWorkerLocking(currencyAdjustedAmount, invoiceUsers) {
	      if (!invoiceUsers.length) {
	        return;
	      }
	      var evenDividedAmount = currencyAdjustedAmount / invoiceUsers.length;
	      var shouldLock = invoiceUsers.some(function (invoiceUser) {
	        return invoiceUser.total !== evenDividedAmount;
	      });
	
	      if (shouldLock) {
	        var lockAmountDistribution = {};
	        invoiceUsers.forEach(function (invoiceUser) {
	          lockAmountDistribution[invoiceUser.userId] = true;
	        });
	        this.props.setLockAmountDistribution(lockAmountDistribution);
	      }
	    }
	  }, {
	    key: 'handleInvoiceError',
	    value: function handleInvoiceError(error) {
	      // Redirect on 403 Forbidden, otherwise show error
	      if (error.response && error.response.status === 403) {
	        this.context.router.replace('/activities');
	      } else if (error.response !== undefined) {
	        this.setState({
	          fetchError: true
	        });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this4 = this;
	
	      var invoiceNotLoaded = !nextProps.invoice.invoiceId;
	      var editingInvoice = nextProps.params && nextProps.params.id !== undefined;
	      var currenciesLoaded = nextProps.currencies.list.length;
	      var notFetchingInvoice = !this.state.fetchingInvoice;
	
	      if (invoiceNotLoaded && editingInvoice && currenciesLoaded && notFetchingInvoice) {
	        this.setState({
	          fetchingInvoice: true
	        }, (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	          var _ref2, _ref3, data, supplierLedger;
	
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  _context.prev = 0;
	                  _context.next = 3;
	                  return _promise2.default.all([_invoiceService2.default.getInvoiceByIdIncludeUsersDates(nextProps.params.id), _invoiceService2.default.getSupplierLedgersForInvoice(nextProps.params.id)]);
	
	                case 3:
	                  _ref2 = _context.sent;
	                  _ref3 = (0, _slicedToArray3.default)(_ref2, 2);
	                  data = _ref3[0];
	                  supplierLedger = _ref3[1];
	                  _context.next = 9;
	                  return _this4.addTaxkeysToInvoiceUsers(data.invoiceUsers);
	
	                case 9:
	                  _this4.handleInvoiceResponse(data, supplierLedger);
	                  _this4.fetchCoworkers(data.invoiceUsers);
	                  _context.next = 16;
	                  break;
	
	                case 13:
	                  _context.prev = 13;
	                  _context.t0 = _context['catch'](0);
	
	                  _this4.handleInvoiceError(_context.t0);
	
	                case 16:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this4, [[0, 13]]);
	        })));
	      }
	
	      this.setState({
	        user: nextProps.user,
	        taxkeys: nextProps.taxkeys
	      });
	      this.setUserDataToRedux(this.props.user);
	
	      this.setVatAccordingToCustomer(this.props.invoice.customerEntity, nextProps.invoice.customerEntity);
	
	      if (!nextProps.invoice.initializing) {
	        var invoiceData = this.getInvoiceData(nextProps.invoice);
	        this.validateInvoice(invoiceData);
	      }
	
	      if (nextProps.user.id && !nextProps.user.socialSecurityNr) {
	        this.openSsnrModal();
	      }
	    }
	  }, {
	    key: 'fetchCoworkers',
	    value: function fetchCoworkers(workers) {
	      var _this5 = this;
	
	      var invoiceCoworkers = workers.filter(function (worker) {
	        return +worker.userId !== +_this5.props.user.id;
	      });
	      // TODO create backend endpoint to get all workers in one go
	      invoiceCoworkers.forEach(function (coworker) {
	        _frilansFinans.WorkerService.getWorker(coworker.userId).then(function (response) {
	          _this5.handleFetchWorkerResponse(response);
	        }).catch(function () {
	          _this5.setState({
	            fetchError: true
	          });
	        });
	      });
	    }
	  }, {
	    key: 'handleFetchWorkerResponse',
	    value: function handleFetchWorkerResponse(response) {
	      var _this6 = this;
	
	      var coworkers = this.state.coworkers;
	      response.forEach(function (result) {
	        if (_this6.props.invoice.invoiceUser.find(function (worker) {
	          return +worker.userId === +result.id;
	        })) {
	          coworkers.push(result);
	        }
	      });
	
	      this.setState({
	        coworkers: coworkers
	      });
	    }
	  }, {
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        user: this.state.user,
	        taxkeys: this.state.taxkeys
	      };
	    }
	  }, {
	    key: 'setUserDataToRedux',
	    value: function setUserDataToRedux(user) {
	      if (!this.state.user && user) {
	        this.props.setUserId(user.id);
	        this.props.setSaveVacationPay(user.saveVacationPay);
	      }
	    }
	  }, {
	    key: 'setVatAccordingToCustomer',
	    value: function setVatAccordingToCustomer(prevCustomer, customer) {
	      if (prevCustomer !== customer && customer !== null) {
	        if (customer.address.country !== DEFAULT_COUNTRY) {
	          this.props.setTaxId(NON_DEFAULT_CURRENCY_DEFAULT_TAX_ID);
	        }
	      }
	    }
	  }, {
	    key: 'scrollToError',
	    value: function scrollToError() {
	      var errors = [].concat((0, _toConsumableArray3.default)(document.querySelectorAll('.error'))).filter(function (element) {
	        return element.classList.length === 1;
	      });
	
	      if (errors.length) {
	        window.scrollTo(0, errors[0].getBoundingClientRect().top + window.scrollY - 300);
	      }
	    }
	  }, {
	    key: 'scrollCalendar',
	    value: function scrollCalendar() {
	      this.setState({
	        surveyModalIsOpen: false
	      });
	
	      var calendar = document.querySelector('.work-date');
	
	      window.scrollTo(0, calendar.getBoundingClientRect().top + window.scrollY - 30);
	    }
	  }, {
	    key: 'validateInvoice',
	    value: function validateInvoice(invoice) {
	      var isValid = _invoiceValidator2.default.invoiceIsValid(invoice);
	
	      if (this.props.invoice.valid !== isValid) {
	        this.props.setValid(isValid);
	      }
	
	      if (!isValid) {
	        this.scrollToError();
	      }
	
	      return isValid;
	    }
	  }, {
	    key: 'renderSettingsModal',
	    value: function renderSettingsModal() {
	      if (this.state.settingsModalIsOpen) {
	        return _react2.default.createElement(
	          _reactModal2.default,
	          {
	            className: 'modal modal-wide settings-tab-modal',
	            contentLabel: '',
	            isOpen: this.state.settingsModalIsOpen,
	            onRequestClose: this.closeSettingsModal },
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-content' },
	            _react2.default.createElement(_settingsTabWrapper2.default, { closeSettingsModal: this.closeSettingsModal })
	          )
	        );
	      }
	    }
	  }, {
	    key: 'closeUpdatingModal',
	    value: function closeUpdatingModal() {
	      this.setState({
	        updated: false
	      });
	      if (this.state.registerAssignmentTool) {
	        this.redirectToPostedPrereport();
	      } else {
	        this.redirectToPostedInvoice();
	      }
	    }
	  }, {
	    key: 'renderUpdatedModal',
	    value: function renderUpdatedModal() {
	      var title = (0, _proxyCounterpart.proxyCounterpart)('INVOICE_TOOL_INVOICE_UPDATED_TITLE');
	      var body = (0, _proxyCounterpart.proxyCounterpart)('INVOICE_TOOL_INVOICE_UPDATED_BODY');
	      if (this.state.registerAssignmentTool) {
	        title = (0, _proxyCounterpart.proxyCounterpart)('INVOICE_TOOL_ASSIGNMENT_UPDATED_TITLE');
	        body = (0, _proxyCounterpart.proxyCounterpart)('INVOICE_TOOL_ASSIGNMENT_UPDATED_BODY');
	      }
	
	      if (this.state.updated) {
	        return _react2.default.createElement(_components.CloseModal, {
	          headline: title,
	          body: body,
	          close: this.closeUpdatingModal
	        });
	      }
	    }
	  }, {
	    key: 'renderSendModal',
	    value: function renderSendModal() {
	      if (this.state.sendModalIsOpen) {
	        var currentExchangeRate = entities.selectById(this.props.currencies.list, this.props.invoice.currencyId).exchangeRate;
	        var currencyAmount = (this.props.invoice.amount / currentExchangeRate).toFixed(2);
	
	        return _react2.default.createElement(_confirmInvoiceModal2.default, {
	          customer: this.props.invoice.customerEntity,
	          amount: currencyAmount + ' ' + this.props.invoice.currencyName,
	          invoice: this.props.invoice,
	          callback: this.closeSendModal
	        });
	      }
	    }
	  }, {
	    key: 'renderSurveyModal',
	    value: function renderSurveyModal() {
	      var _this7 = this;
	
	      var callback = function callback(answers, status) {
	        return _this7.closeSurveyModal(answers, status);
	      };
	
	      if (this.state.surveyModalIsOpen) {
	        return _react2.default.createElement(_exceededWorkingHoursSurveyModal2.default, {
	          callback: callback,
	          scrollCalendar: this.scrollCalendar
	        });
	      }
	    }
	  }, {
	    key: 'renderSaveModal',
	    value: function renderSaveModal() {
	      if (this.state.saveModalIsOpen) {
	        var currentExchangeRate = entities.selectById(this.props.currencies.list, this.props.invoice.currencyId).exchangeRate;
	        var currencyAmount = (this.props.invoice.amount / currentExchangeRate).toFixed(2);
	
	        var sortedWorkDates = this.props.invoice.invoiceDate.sort(function (date1, date2) {
	          return date1.date - date2.date;
	        });
	        var firstWorkDate = sortedWorkDates[0].date;
	        var lastWorkDate = sortedWorkDates[sortedWorkDates.length - 1].date;
	
	        return _react2.default.createElement(_confirmPreregisterModal2.default, {
	          customer: this.props.invoice.customerEntity,
	          amount: currencyAmount + ' ' + this.props.invoice.currencyName,
	          firstWorkDate: firstWorkDate,
	          lastWorkDate: lastWorkDate,
	          callback: this.closeSaveModal
	        });
	      }
	    }
	  }, {
	    key: 'renderInvoiceSentModal',
	    value: function renderInvoiceSentModal() {
	      if (this.state.sentInvoiceModalIsOpen) {
	        return _react2.default.createElement(_sentOrderModal2.default, {
	          close: this.closeSentInvoiceModal,
	          registerNew: this.newEmptyInvoice,
	          title: 'SENT_INVOICE_MODAL_TITLE',
	          translations: ['SENT_INVOICE_MODAL_INVOICE_CREATED', 'SENT_INVOICE_MODAL_INVOICE_REVIEWED_BY_FF', 'SENT_INVOICE_MODAL_SENT_TO_COMPANY'],
	          registerButtonText: 'SENT_INVOICE_MODAL_INVOICE_AGAIN_BTN',
	          doneButtonText: 'SENT_INVOICE_MODAL_DONE_BTN'
	        });
	      }
	    }
	  }, {
	    key: 'newEmptyInvoice',
	    value: function newEmptyInvoice() {
	      if (this.props.params.id) {
	        this.context.router.push('/invoice-tool');
	        window.removeEventListener('beforeunload', this.onUnload);
	        location.reload();
	      } else {
	        window.removeEventListener('beforeunload', this.onUnload);
	        location.reload();
	      }
	    }
	  }, {
	    key: 'renderPrereportSentModal',
	    value: function renderPrereportSentModal() {
	      if (this.state.sentPrereportModalIsOpen) {
	        return _react2.default.createElement(_sentOrderModal2.default, {
	          close: this.closeSentPrereportModal,
	          registerNew: this.newEmptyPreregister,
	          title: 'SENT_PREREPORT_MODAL_TITLE',
	          translations: ['SENT_PREREPORT_MODAL_REGISTERED', 'SENT_PREREPORT_MODAL_WORK_DONE', 'SENT_PREREPORT_MODAL_EASY_INVOICING'],
	          registerButtonText: 'SENT_PREREPORT_MODAL_PREREGISTER_AGAIN_BTN',
	          doneButtonText: 'SENT_PREREPORT_MODAL_DONE_BTN'
	        });
	      }
	    }
	  }, {
	    key: 'newEmptyPreregister',
	    value: function newEmptyPreregister() {
	      if (this.props.params.id) {
	        this.context.router.push('/register-assignment');
	        window.removeEventListener('beforeunload', this.onUnload);
	        location.reload();
	      } else {
	        window.removeEventListener('beforeunload', this.onUnload);
	        location.reload();
	      }
	    }
	  }, {
	    key: 'renderSsnrModal',
	    value: function renderSsnrModal() {
	      if (this.state.ssnrModalIsOpen) {
	        return _react2.default.createElement(_ssnr2.default, { onCloseModal: this.closeSsnrModal, isOpen: this.state.ssnrModalIsOpen });
	      }
	    }
	  }, {
	    key: 'renderPreviewModal',
	    value: function renderPreviewModal() {
	      if (this.state.previewModalIsOpen) {
	        return _react2.default.createElement(
	          _reactModal2.default,
	          {
	            className: 'modal modal-wide invoice-preview-modal',
	            contentLabel: '',
	            shouldCloseOnOverlayClick: true,
	            isOpen: this.state.previewModalIsOpen,
	            onRequestClose: this.closePreviewModal },
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-content' },
	            _react2.default.createElement(_previewInvoice2.default, {
	              previewInvoice: this.props.invoice,
	              previewSupplierLedgers: this.props.invoice.supplierLedger,
	              closePreviewModal: this.closePreviewModal })
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderSupplierLedgerListModal',
	    value: function renderSupplierLedgerListModal() {
	      if (this.state.supplierLedgerListModalIsOpen) {
	        return _react2.default.createElement(
	          _reactModal2.default,
	          {
	            className: 'modal supplier-ledger-list-modal',
	            contentLabel: '',
	            isOpen: this.state.supplierLedgerListModalIsOpen },
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-content' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              _react2.default.createElement(_reactTranslateComponent2.default, { content: !this.state.preReport ? 'INVOICE_SENT' : 'INVOICE_SAVED_MODAL_TEXT' })
	            ),
	            _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: (0, _proxyCounterpart.proxyCounterpart)('WRITE_DOWN_LEVID_ON_RECEIPT') } }),
	            _ref4,
	            _react2.default.createElement(
	              'div',
	              { className: 'right-btn-wrapper' },
	              _react2.default.createElement(
	                'a',
	                { className: 'btn blue continue-btn', onClick: this.closeSupplierLedgerListModal },
	                _ref5
	              )
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderRegisterAssignmentModal',
	    value: function renderRegisterAssignmentModal() {
	      if (this.state.registerAssignmentInfoModalIsOpen) {
	        return _react2.default.createElement(_registerAssignmentInfoModal2.default, { close: this.toggleRegisterAssignmentInfoModal });
	      }
	    }
	  }, {
	    key: 'getInvoiceUsers',
	    value: function getInvoiceUsers(invoiceUser, expressPayment) {
	      var _this8 = this;
	
	      var invoiceUsers = [];
	
	      var _loop = function _loop(i) {
	        var user = invoiceUser[i];
	        var isLoggedInUser = parseInt(user.userId) === parseInt(_this8.props.user.id);
	        var updatedWorker = _this8.state.coworkers.find(function (worker) {
	          return +worker.id === +user.userId;
	        });
	        if (updatedWorker) {
	          user.saveItp = updatedWorker.saveItp;
	        }
	
	        var itpSetting = false;
	        if (isLoggedInUser) {
	          itpSetting = _this8.props.user.saveITP;
	        } else if (user.saveItp) {
	          itpSetting = user.saveItp;
	        }
	
	        invoiceUsers.push({
	          user_id: parseInt(user.userId),
	          taxkey_id: user.taxkeyId,
	          total: String(user.total),
	          travel: +user.travel,
	          allowance: +user.allowance,
	          save_vacation_pay: _this8.props.user.saveVacationPay || false,
	          save_itp: itpSetting,
	          itp_rate: isLoggedInUser ? _this8.props.user.itpRate : _frilansFinans.UserSettingsConstants.itpRateDefault,
	          express_payment: expressPayment,
	          gross: user.gross
	        });
	      };
	
	      for (var i = 0; i < invoiceUser.length; i++) {
	        _loop(i);
	      }
	
	      return invoiceUsers;
	    }
	  }, {
	    key: 'getInvoiceDate',
	    value: function getInvoiceDate(invoiceDate) {
	      var returnDate = [];
	
	      for (var i = 0; i < invoiceDate.length; i++) {
	        var date = invoiceDate[i];
	        returnDate.push({
	          date: date.date,
	          hours: date.hours
	        });
	      }
	
	      return returnDate;
	    }
	  }, {
	    key: 'getSupplierLedgers',
	    value: function getSupplierLedgers(supplierLedger) {
	      var arr = [];
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(supplierLedger), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var s = _step.value;
	
	          arr.push({
	            supplier_name: s.supplierName,
	            user_id: this.props.user.id,
	            tax_id: s.taxId,
	            supplier_ledger_type_id: s.supplierLedgerTypeId,
	            amount: Math.round(s.amount / (1 + (0, _invoiceToolHelper.getVatById)(s.taxId) / 100)),
	            id: s.id
	          });
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return arr;
	    }
	  }, {
	    key: 'getHsdData',
	    value: function getHsdData(hsddata) {
	      return {
	        rot: hsddata.rot,
	        rut: hsddata.rut,
	        data: hsddata.data,
	        apartment_number: hsddata.apartmentNumber,
	        cooperative_apartment_registration_number: hsddata.cooperativeApartmentRegistrationNumber,
	        accommodation_type: hsddata.accommodationType
	      };
	    }
	  }, {
	    key: 'getInvoiceData',
	    value: function getInvoiceData(invoice) {
	      var invoiceUsers = this.getInvoiceUsers(invoice.invoiceUser, invoice.expressPayment);
	      var invoiceDate = this.getInvoiceDate(invoice.invoiceDate);
	      var supplierLedgers = this.getSupplierLedgers(invoice.supplierLedger);
	      var hsdData = this.getHsdData(invoice.hsd);
	      var data = {
	        specification: invoice.specification,
	        user_id: parseInt(this.props.user.id),
	        company_id: invoice.customerId,
	        currency_id: invoice.currencyId,
	        currency_amount: invoice.currencyAmount,
	        amount: invoice.amount,
	        tax_id: invoice.taxId,
	        invoiceuser: invoiceUsers,
	        invoicedate: invoiceDate,
	        hsd: hsdData,
	        display_dates: invoice.displayDates,
	        display_hours: invoice.displayHours,
	        message_type: invoice.messageType,
	        po_number: invoice.poNumber
	      };
	
	      if (invoice.surveys.status !== '' && invoice.surveys.questions_and_answers !== '') {
	        data.surveys = [invoice.surveys];
	      }
	
	      // Supplier Ledgers
	      if (supplierLedgers.length > 0) {
	        data.supplierledger = supplierLedgers;
	      }
	
	      // Coupon ID
	      if (invoice.couponId !== '') {
	        data.coupon_id = invoice.couponId;
	      }
	      // Billing email
	      if (invoice.messageType === 'email' && invoice.sendToEmail) {
	        data.send_to_email = invoice.sendToEmail;
	      }
	
	      // Secondary billing email
	      if (invoice.messageType === 'email' && invoice.sendToEmailSecondary) {
	        data.send_to_email_secondary = invoice.sendToEmailSecondary;
	      }
	
	      // Send To SMS
	      if (invoice.messageType === 'sms' && invoice.companyPhone) {
	        data.company_phone = invoice.companyPhone;
	      }
	
	      // Send To E-invoice
	      if (invoice.messageType === 'e-invoice' && invoice.einvoiceAddress) {
	        data.e_invoice_address = invoice.einvoiceAddress;
	      }
	
	      return data;
	    }
	  }, {
	    key: 'shouldDisplaySaveVacationModal',
	    value: function shouldDisplaySaveVacationModal() {
	      return this.props.user.saveVacationPay == null && !this.state.hasOpenedVacationModal && this.state.userTotalHours + this.getTotalHours() >= 480;
	    }
	  }, {
	    key: 'postInvoice',
	    value: function postInvoice(preReport, invoiceId) {
	      var _this9 = this;
	
	      var data = this.getInvoiceData(this.props.invoice);
	
	      var _ref6 = this.props.invoice.customerEntity ? this.props.invoice.customerEntity.address : {},
	          country = _ref6.country;
	
	      if (country !== 'SWEDEN' || !data.hsd.rot && !data.hsd.rut) {
	        delete data.hsd;
	      }
	
	      data.pre_report = preReport;
	      if (this.validateInvoice(data)) {
	        this.props.setPosting(true);
	        this.props.setPostError(false);
	        this.props.clearValidationErrors();
	        var method = invoiceId ? 'update' : 'post';
	        // REMOVE SET ERRORS FUNCTION AND IF/ELSE WHEN JUST ARRIVED HAS CHANGED THEIR SYSTEM.
	        this.setErrors();
	        if (this.shouldDisplaySaveVacationModal()) {
	          this.setSaveVacationModal(true);
	        } else if (!this.state.invoiceToolClientErrors.length) {
	          // Update customer billing emails
	          var emails = {
	            sendToEmail: data.send_to_email,
	            sendToEmailSecondary: data.send_to_email_secondary
	          };
	          _customerService2.default.updateBillingEmails(data.company_id, emails);
	          _invoiceService2.default[method](data, invoiceId).then(function (response) {
	            _customerService2.default.updateMessaging(data);
	            return response;
	          }).then(function (response) {
	            _this9.setPostedInvoiceId(response.data.data.id);
	            if (_this9.state.registerAssignmentTool && preReport && _this9.props.params.id || !_this9.state.registerAssignmentTool && !!_this9.props.params.id && !_this9.state.invoice.preReport) {
	              _this9.setState({
	                updated: true
	              });
	            } else {
	              _this9.openSentInvoiceModal();
	            }
	            _this9.props.setPosting(false);
	          }).catch(function (error) {
	            if (_this9.hasClientErrors(error.response.data.errors)) {
	              _this9.openInvoiceToolCompleteInformationModal(preReport);
	            }
	            _this9.props.setPosting(false);
	          });
	        } else {
	          this.openInvoiceToolCompleteInformationModal(preReport);
	          this.props.setPosting(false);
	        }
	      }
	    }
	
	    // REMOVE SET ERRORS FUNCTION AND IF/ELSE WHEN JUST ARRIVED HAS CHANGED THEIR SYSTEM.
	
	  }, {
	    key: 'setErrors',
	    value: function setErrors() {
	      this.state.invoiceToolClientErrors = [];
	      if (!this.state.user.email) this.state.invoiceToolClientErrors.push('email');
	      if (!this.state.user.address.city) this.state.invoiceToolClientErrors.push('city');
	      if (!this.state.user.address.street) this.state.invoiceToolClientErrors.push('street');
	      if (!this.state.user.address.zip) this.state.invoiceToolClientErrors.push('zip');
	      if (!this.state.user.address.country) this.state.invoiceToolClientErrors.push('country');
	      if (!this.state.user.accountClearingNr && this.state.user.internationalAccount === 'off') {
	        this.state.invoiceToolClientErrors.push('account_clearing_number');
	      }
	      if (!this.state.user.accountNr && this.state.user.internationalAccount === 'off') {
	        this.state.invoiceToolClientErrors.push('account_number');
	      }
	      if (!this.state.user.iban && this.state.user.internationalAccount === 'on') {
	        this.state.invoiceToolClientErrors.push('iban');
	      }
	      if (!this.state.user.bic && this.state.user.internationalAccount === 'on') {
	        this.state.invoiceToolClientErrors.push('bic');
	      }
	      if (!this.state.user.professionId) this.state.invoiceToolClientErrors.push('profession_id');
	    }
	  }, {
	    key: 'onClickSend',
	    value: function onClickSend() {
	      var _this10 = this;
	
	      var preReport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      this.setState({
	        invoiceToolCompleteInformationModalIsOpen: false,
	        submitted: true,
	        preReport: preReport
	      }, function () {
	        _this10.props.setSubmitted(true);
	        _this10.props.setPreReport(preReport);
	        if (_this10.props.invoice.termsAccepted) {
	          if (_this10.props.invoice.invoiceId) {
	            _this10.postInvoice(preReport, _this10.props.invoice.invoiceId);
	          } else {
	            _this10.postInvoice(preReport);
	          }
	        }
	      });
	    }
	  }, {
	    key: 'onClickSave',
	    value: function onClickSave() {
	      this.onClickSend(true);
	    }
	  }, {
	    key: 'setPostedInvoiceId',
	    value: function setPostedInvoiceId(invoiceId) {
	      this.setState({
	        postedInvoiceId: invoiceId
	      });
	    }
	  }, {
	    key: 'toggleSentPrereportModal',
	    value: function toggleSentPrereportModal() {
	      this.setState({
	        sentPrereportModalIsOpen: !this.state.sentPrereportModalIsOpen
	      });
	    }
	  }, {
	    key: 'toggleSentInvoiceModal',
	    value: function toggleSentInvoiceModal() {
	      this.setState({
	        sentInvoiceModalIsOpen: !this.state.sentInvoiceModalIsOpen
	      });
	    }
	  }, {
	    key: 'toggleRegisterAssignmentInfoModal',
	    value: function toggleRegisterAssignmentInfoModal() {
	      this.setState({
	        registerAssignmentInfoModalIsOpen: !this.state.registerAssignmentInfoModalIsOpen
	      });
	    }
	  }, {
	    key: 'openSentInvoiceModal',
	    value: function openSentInvoiceModal() {
	      if (this.props.invoice.supplierLedger.length && !this.state.preReport) {
	        this.openSupplierLedgerListModal();
	        return;
	      }
	      if (this.state.preReport) {
	        this.toggleSentPrereportModal();
	        return;
	      }
	      this.toggleSentInvoiceModal();
	    }
	  }, {
	    key: 'closeSentPrereportModal',
	    value: function closeSentPrereportModal() {
	      this.toggleSentPrereportModal();
	      this.redirectToPostedPrereport();
	    }
	  }, {
	    key: 'redirectToPostedPrereport',
	    value: function redirectToPostedPrereport() {
	      this.context.router.replace('/economy/register-assignment');
	    }
	  }, {
	    key: 'closeSentInvoiceModal',
	    value: function closeSentInvoiceModal() {
	      this.toggleSentInvoiceModal();
	      this.redirectToPostedInvoice();
	    }
	  }, {
	    key: 'redirectToPostedInvoice',
	    value: function redirectToPostedInvoice() {
	      this.context.router.replace('economy/invoices/' + this.state.postedInvoiceId);
	    }
	  }, {
	    key: 'openInvoiceToolCompleteInformationModal',
	    value: function openInvoiceToolCompleteInformationModal(preReport) {
	      this.setState({
	        invoiceToolCompleteInformationModalIsOpen: true,
	        preReportInvoice: preReport
	      });
	    }
	  }, {
	    key: 'setInvoiceToolCompleteInformationModal',
	    value: function setInvoiceToolCompleteInformationModal() {
	      this.setState({
	        invoiceToolCompleteInformationModalIsOpen: false
	      });
	    }
	  }, {
	    key: 'setSaveVacationModal',
	    value: function setSaveVacationModal(value) {
	      this.setState({
	        saveVacationModalIsOpen: value,
	        hasOpenedVacationModal: true
	      });
	    }
	  }, {
	    key: 'openSupplierLedgerListModal',
	    value: function openSupplierLedgerListModal() {
	      this.setState({
	        supplierLedgerListModalIsOpen: true
	      });
	    }
	  }, {
	    key: 'closeSupplierLedgerListModal',
	    value: function closeSupplierLedgerListModal() {
	      this.setState({
	        supplierLedgerListModalIsOpen: false
	      });
	      this.redirectToPostedInvoice();
	    }
	  }, {
	    key: 'openSsnrModal',
	    value: function openSsnrModal() {
	      this.setState({
	        ssnrModalIsOpen: true
	      });
	    }
	  }, {
	    key: 'closeSsnrModal',
	    value: function closeSsnrModal() {
	      if (!this.props.user.socialSecurityNr) {
	        this.context.router.replace('activities');
	      }
	
	      this.setState({
	        ssnrModalIsOpen: false
	      });
	    }
	  }, {
	    key: 'openSettingsModal',
	    value: function openSettingsModal() {
	      this.setState({
	        settingsModalIsOpen: true
	      });
	    }
	  }, {
	    key: 'closeSettingsModal',
	    value: function closeSettingsModal() {
	      this.setState({
	        settingsModalIsOpen: false
	      });
	    }
	  }, {
	    key: 'openPreviewModal',
	    value: function openPreviewModal() {
	      this.props.setSubmitted(true);
	
	      var data = this.getInvoiceData(this.props.invoice);
	      var customerAdressCountry = this.props.invoice.customerEntity ? this.props.invoice.customerEntity.address.country : null;
	      var isValidInvoice = this.validateInvoice(data);
	      if (!isValidInvoice) {
	        return false;
	      }
	      var viewportMeta = document.getElementById('viewport-meta');
	      document.body.classList.toggle('is-invoice-previewing');
	      viewportMeta.setAttribute('content', 'width=990');
	      this.setState({
	        previewModalIsOpen: isValidInvoice
	      });
	      if (customerAdressCountry && isValidInvoice) {
	        this.setState({
	          changedLanguage: true
	        });
	        customerAdressCountry !== 'SWEDEN' ? _counterpart2.default.setLocale('en') : _counterpart2.default.setLocale('se');
	      }
	    }
	  }, {
	    key: 'closePreviewModal',
	    value: function closePreviewModal() {
	      var viewportMeta = document.getElementById('viewport-meta');
	      document.body.classList.toggle('is-invoice-previewing');
	      viewportMeta.setAttribute('content', 'width=device-width, initial-scale=1, user-scalable=no');
	      this.setState({
	        previewModalIsOpen: false
	      });
	      if (this.state.changedLanguage) {
	        this.setState({
	          changedLanguage: false
	        });
	        _counterpart2.default.setLocale(this.state.originalLang);
	      }
	    }
	  }, {
	    key: 'openSendModal',
	    value: function openSendModal() {
	      this.props.setSubmitted(true);
	
	      var data = this.getInvoiceData(this.props.invoice);
	      var isValidInvoice = this.validateInvoice(data);
	      if (isValidInvoice && this.props.invoice.termsAccepted) {
	        if (this.props.params.id) {
	          this.onClickSend();
	        } else {
	          this.setState({
	            sendModalIsOpen: true
	          });
	        }
	      }
	    }
	  }, {
	    key: 'openSurveyModal',
	    value: function openSurveyModal() {
	      this.setState({
	        surveyModalIsOpen: true
	      });
	    }
	  }, {
	    key: 'openSaveModal',
	    value: function openSaveModal() {
	      this.props.setSubmitted(true);
	
	      var data = this.getInvoiceData(this.props.invoice);
	      var isValidInvoice = this.validateInvoice(data);
	      if (isValidInvoice && this.props.invoice.termsAccepted) {
	        if (this.props.params.id) {
	          this.onClickSend(true);
	        } else {
	          this.setState({
	            saveModalIsOpen: true
	          });
	        }
	      }
	    }
	  }, {
	    key: 'closeSendModal',
	    value: function closeSendModal(sendInvoice) {
	      this.setState({
	        sendModalIsOpen: false
	      });
	      if (sendInvoice) {
	        return this.onClickSend();
	      }
	    }
	  }, {
	    key: 'closeSaveModal',
	    value: function closeSaveModal(sendInvoice) {
	      this.setState({
	        saveModalIsOpen: false
	      });
	      if (sendInvoice) {
	        return this.onClickSend(true);
	      }
	    }
	  }, {
	    key: 'closeSurveyModal',
	    value: function closeSurveyModal(answers, status) {
	      if (!answers) {
	        this.setState({
	          surveyModalIsOpen: false,
	          saveModalIsOpen: false
	        });
	      } else {
	        this.props.setSurveyAnswers(answers, status);
	        this.setState({
	          surveyModalIsOpen: false,
	          sendModalIsOpen: true
	        });
	      }
	    }
	  }, {
	    key: 'renderError',
	    value: function renderError() {
	      if (this.state.fetchError) {
	        return _ref7;
	      }
	    }
	  }, {
	    key: 'hasClientErrors',
	    value: function hasClientErrors(errors) {
	      this.setState({
	        invoiceToolClientErrors: []
	      });
	      var userErrors = errors[0].detail.errors[(0, _keys2.default)(errors[0].detail.errors)[0]];
	      var clientErrors = [];
	
	      if (userErrors) {
	        for (var error in userErrors) {
	          clientErrors.push(error);
	        }
	      }
	
	      if (clientErrors.length) {
	        this.setState({
	          invoiceToolClientErrors: clientErrors
	        });
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'renderInvoiceLockError',
	    value: function renderInvoiceLockError() {
	      if (this.state.invoiceLockError) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'invoice-lock-error-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'invoice-lock-error' },
	            _react2.default.createElement('img', { src: __webpack_require__(656) }),
	            _ref8,
	            _ref9,
	            _ref10,
	            _ref11,
	            _ref12,
	            _ref13
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderInvoiceTool',
	    value: function renderInvoiceTool() {
	      var translationPrefix = this.state.registerAssignmentTool ? 'REGISTER_ASSIGNMENT_' : '';
	      var selectedDays = this.props.invoice ? _workDateHelper2.default.parseWorkDates(this.props.invoice.invoiceDate) : [];
	      var showSurveyModal = !this.state.registerAssignmentTool && (0, _invoiceToolHelper.hasExceededWorkingHours)(selectedDays);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'invoice-tool' },
	        _react2.default.createElement(_invoiceToolHeader2.default, {
	          translationPrefix: translationPrefix,
	          openSettingsModal: this.openSettingsModal,
	          closeSettingsModal: this.closeSettingsModal
	        }),
	        this.renderError(),
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(_workDetailsContainer2.default, {
	              registerAssignmentTool: this.state.registerAssignmentTool,
	              translationPrefix: translationPrefix
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row row-bottom-margin' },
	            _react2.default.createElement(_invoicePaymentDetails2.default, {
	              postInvoice: this.postInvoice,
	              openPreviewModal: this.openPreviewModal,
	              closePreviewModal: this.closePreviewModal,
	              openSendModal: showSurveyModal ? this.openSurveyModal : this.openSendModal,
	              closeSendModal: this.closeSendModal,
	              onClickSave: showSurveyModal ? this.openSurveyModal : this.openSaveModal,
	              translationPrefix: translationPrefix,
	              registerAssignmentTool: this.state.registerAssignmentTool
	            })
	          )
	        ),
	        _ref14,
	        this.renderSettingsModal(),
	        this.renderPreviewModal(),
	        this.renderSendModal(),
	        this.renderSaveModal(),
	        this.renderSurveyModal(),
	        this.renderInvoiceSentModal(),
	        this.renderPrereportSentModal(),
	        this.renderUpdatedModal(),
	        _react2.default.createElement(_invoiceToolSelectVacationModal2.default, {
	          isOpen: this.state.saveVacationModalIsOpen,
	          toggleModal: this.setSaveVacationModal,
	          user: this.state.user,
	          callback: this.postInvoice
	        }),
	        _react2.default.createElement(_invoiceToolCompleteInformationModal2.default, {
	          invoiceToolCompleteInformationModalIsOpen: this.state.invoiceToolCompleteInformationModalIsOpen,
	          preReport: this.state.preReportInvoice,
	          toggleModal: this.setInvoiceToolCompleteInformationModal,
	          createInvoice: this.onClickSend,
	          saveInvoice: this.onClickSave,
	          classes: 'right-btn-wrapper',
	          user: this.state.user
	        }),
	        this.renderSupplierLedgerListModal(),
	        this.renderSsnrModal(),
	        this.renderRegisterAssignmentModal()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.renderInvoiceLockError(),
	        this.renderInvoiceTool()
	      );
	    }
	  }]);
	  return InvoiceTool;
	}(_react2.default.Component);
	
	InvoiceTool.contextTypes = {
	  router: _react.PropTypes.object.isRequired
	};
	InvoiceTool.childContextTypes = {
	  user: _react2.default.PropTypes.object,
	  taxkeys: _react2.default.PropTypes.array
	};
	exports.default = InvoiceTool;

/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(12);
	
	var _invoice = __webpack_require__(43);
	
	var _invoicing = __webpack_require__(938);
	
	var _invoicing2 = _interopRequireDefault(_invoicing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(_ref) {
	  var invoice = _ref.invoice,
	      user = _ref.user;
	  return {
	    invoice: invoice,
	    user: user
	  };
	};
	
	var mapDispatchToProps = {
	  setSendToEmail: _invoice.setSendToEmail,
	  setSendToEmailSecondary: _invoice.setSendToEmailSecondary,
	  setSendToEmailBool: _invoice.setSendToEmailBool,
	  setCompanyPhone: _invoice.setCompanyPhone,
	  setMessageType: _invoice.setMessageType,
	  setEinvoiceAddress: _invoice.setEinvoiceAddress,
	  setPoNumber: _invoice.setPoNumber
	};
	
	var InvoicingContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_invoicing2.default);
	
	exports.default = InvoicingContainer;

/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Invoicing = undefined;
	
	var _assign = __webpack_require__(22);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _components = __webpack_require__(13);
	
	var _frilansFinans = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'short-description' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICING_SEND_INVOICE_BY_EMAIL' })
	);
	
	var _ref2 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICING_SEND_INVOICE_BY_SMS' });
	
	var _ref3 = _react2.default.createElement(
	  'div',
	  { className: 'short-description' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICING_CANT_SEND_INVOICE_BY_SMS' })
	);
	
	var _ref4 = _react2.default.createElement(
	  'div',
	  { className: 'short-description' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICING_SEND_INVOICE_BY_MAIL' })
	);
	
	var _ref5 = _react2.default.createElement(
	  'div',
	  { className: 'title' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICING_SEND_INVOICE_BY_MAIL_TO' })
	);
	
	var _ref6 = _react2.default.createElement(
	  'div',
	  null,
	  _react2.default.createElement(
	    'p',
	    { className: 'error-msg' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CHOOSE_CUSTOMER' })
	  )
	);
	
	var _ref7 = _react2.default.createElement(
	  'div',
	  { className: 'short-description' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICING_SEND_INVOICE_BY_E_INVOICE' })
	);
	
	var _ref8 = _react2.default.createElement('span', null);
	
	var _ref9 = _react2.default.createElement(
	  'h3',
	  { className: 'form-header' },
	  _react2.default.createElement(
	    'span',
	    null,
	    '4'
	  ),
	  ' ',
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICING' })
	);
	
	var Invoicing = exports.Invoicing = function (_React$Component) {
	  (0, _inherits3.default)(Invoicing, _React$Component);
	
	  function Invoicing(props) {
	    (0, _classCallCheck3.default)(this, Invoicing);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Invoicing.__proto__ || (0, _getPrototypeOf2.default)(Invoicing)).call(this, props));
	
	    _this.handleChange = function (name, values) {
	      var tempFormValues = _this.state.formValues;
	
	      (0, _assign2.default)(tempFormValues[name], values);
	      _this.setState({ formValues: tempFormValues }, function () {
	        if (name === 'email') {
	          _this.props.setSendToEmail(values.value);
	        }
	        if (name === 'emailSecondary') {
	          _this.props.setSendToEmailSecondary(values.value);
	        }
	        if (name === 'phone') {
	          _this.props.setCompanyPhone(values.value);
	        }
	        if (name === 'einvoice') {
	          _this.props.setEinvoiceAddress(values.value);
	        }
	        if (name === 'poNumber') {
	          _this.props.setPoNumber(values.value);
	        }
	      });
	    };
	
	    _this.isChecked = function (messageType) {
	      return messageType === _this.props.invoice.messageType;
	    };
	
	    _this.handleSelectionChange = function (event) {
	      _this.props.setMessageType(event.target.value);
	    };
	
	    _this.isCompany = function () {
	      if (_this.props.invoice.customerEntity) {
	        return _frilansFinans.Utils.isVatNumber(_this.props.invoice.customerEntity.vatNr);
	      }
	      return false;
	    };
	
	    _this.renderEmailSection = function () {
	      var radioRef = _this.state.radioRefs.email;
	      return _react2.default.createElement(
	        'div',
	        { className: 'message-type-row', onClick: function onClick() {
	            radioRef.click();
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'checkbox-container' },
	          _this.renderRadioButton(_this.messageTypes.email)
	        ),
	        !_this.isChecked(_this.messageTypes.email) && _ref,
	        _this.isChecked(_this.messageTypes.email) && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_components.InputField, { type: 'email',
	            name: 'email',
	            value: _this.state.formValues.email.value,
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('INVOICING_SEND_INVOICE_BY_EMAIL_TO'),
	            callback: _this.handleChange,
	            minLength: _this.isChecked(_this.messageTypes.email) ? '3' : '0',
	            required: _this.isChecked(_this.messageTypes.email) ? 'true' : 'false',
	            errorMessage: (0, _proxyCounterpart.proxyCounterpart)('EMAIL_ERROR'),
	            classes: 'invoicing-contact-fields',
	            showErrorWithoutBlur: _this.state.showErrorWithoutBlur
	          }),
	          _react2.default.createElement(_components.InputField, { type: 'email',
	            name: 'emailSecondary',
	            value: _this.state.formValues.emailSecondary.value,
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('INVOICING_SEND_INVOICE_BY_EMAIL_TO_SECONDARY'),
	            callback: _this.handleChange,
	            minLength: '0',
	            required: 'false',
	            classes: 'invoicing-contact-fields',
	            errorMessage: (0, _proxyCounterpart.proxyCounterpart)('EMAIL_ERROR'),
	            showErrorWithoutBlur: _this.state.showErrorWithoutBlur
	          })
	        )
	      );
	    };
	
	    _this.renderSwishSection = function () {
	      var radioRef = _this.state.radioRefs.sms;
	      var disabled = _this.isCompany();
	      var disabledClass = disabled ? 'disabled' : '';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'message-type-row ' + disabledClass, onClick: function onClick() {
	            radioRef.click();
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'checkbox-container' },
	          _this.renderRadioButton(_this.messageTypes.sms, disabled)
	        ),
	        !_this.isChecked(_this.messageTypes.sms) && !disabled && _react2.default.createElement(
	          'div',
	          { className: 'short-description' },
	          _ref2,
	          _react2.default.createElement('img', { src: __webpack_require__(659), width: '50px' })
	        ),
	        !_this.isChecked(_this.messageTypes.sms) && disabled && _ref3,
	        _this.isChecked(_this.messageTypes.sms) && _react2.default.createElement(
	          'div',
	          { className: 'short-description' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_components.InputField, { type: 'text',
	              name: 'phone',
	              validationType: 'phoneNumberSwedish',
	              value: _this.state.formValues.phone.value,
	              placeholder: (0, _proxyCounterpart.proxyCounterpart)('INVOICING_SEND_INVOICE_BY_SMS_TO'),
	              callback: _this.handleChange,
	              minLength: '3',
	              required: _this.isChecked(_this.messageTypes.sms) ? 'true' : 'false',
	              classes: 'invoicing-contact-fields',
	              errorMessage: (0, _proxyCounterpart.proxyCounterpart)('VALIDATION_COMPANY_PHONE_PHONENUMBER_SE_FALSE'),
	              showErrorWithoutBlur: _this.state.showErrorWithoutBlur
	            }),
	            _react2.default.createElement('div', {
	              className: 'message-type-description',
	              dangerouslySetInnerHTML: { __html: (0, _proxyCounterpart.proxyCounterpart)('INVOICING_MESSAGE_TYPE_SMS') }
	            })
	          ),
	          _react2.default.createElement('img', { src: __webpack_require__(659), width: '50px' })
	        )
	      );
	    };
	
	    _this.renderMailSection = function () {
	      var radioRef = _this.state.radioRefs.mail;
	      return _react2.default.createElement(
	        'div',
	        { className: 'message-type-row', onClick: function onClick() {
	            radioRef.click();
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'checkbox-container' },
	          _this.renderRadioButton(_this.messageTypes.mail)
	        ),
	        !_this.isChecked(_this.messageTypes.mail) && _ref4,
	        _this.isChecked(_this.messageTypes.mail) && _react2.default.createElement(
	          'div',
	          { className: 'text-area-container' },
	          _ref5,
	          _react2.default.createElement(
	            'div',
	            { className: 'invoicing-address' },
	            _this.props.invoice.customerEntity && _this.renderAddress(_this.props.invoice.customerEntity),
	            !_this.props.invoice.customerEntity && _ref6
	          )
	        )
	      );
	    };
	
	    _this.renderEinvoiceSection = function () {
	      var radioRef = _this.state.radioRefs['e-invoice'];
	      return _react2.default.createElement(
	        'div',
	        { className: 'message-type-row', onClick: function onClick() {
	            radioRef.click();
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'checkbox-container' },
	          _this.renderRadioButton(_this.messageTypes.einvoice)
	        ),
	        !_this.isChecked(_this.messageTypes.einvoice) && _ref7,
	        _this.isChecked(_this.messageTypes.einvoice) && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_components.InputField, { type: 'text',
	            name: 'einvoice',
	            value: _this.state.formValues.einvoice.value,
	            validationType: 'einvoice',
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('INVOICING_SEND_INVOICE_BY_E_INVOICE_TO'),
	            callback: _this.handleChange,
	            minLength: _this.isChecked(_this.messageTypes.einvoice) ? '10' : '0',
	            required: _this.isChecked(_this.messageTypes.einvoice) ? 'true' : 'false',
	            classes: 'invoicing-contact-fields',
	            errorMessage: _frilansFinans.Utils.containsAtSign(_this.state.formValues.einvoice.value) ? (0, _proxyCounterpart.proxyCounterpart)('NO_EMAIL_ERROR') : (0, _proxyCounterpart.proxyCounterpart)('EINVOICE_ERROR'),
	            showErrorWithoutBlur: _this.state.showErrorWithoutBlur
	          }),
	          _react2.default.createElement(_components.InputField, { type: 'text',
	            name: 'poNumber',
	            value: _this.state.formValues.poNumber.value,
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('PO_NUMBER'),
	            callback: _this.handleChange,
	            maxLength: _this.isChecked(_this.messageTypes.einvoice) ? '30' : '0',
	            required: 'false',
	            classes: 'invoicing-contact-fields extra-message-type-input',
	            errorMessage: (0, _proxyCounterpart.proxyCounterpart)('PO_NUMBER_ERROR'),
	            showErrorWithoutBlur: _this.state.showErrorWithoutBlur
	          }),
	          _react2.default.createElement('div', {
	            className: 'message-type-description',
	            dangerouslySetInnerHTML: { __html: (0, _proxyCounterpart.proxyCounterpart)('INVOICING_MESSAGE_TYPE_EINVOICE') }
	          })
	        )
	      );
	    };
	
	    _this.renderRadioButton = function (messageType, disabled) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'radio-btn-wrapper' },
	        _react2.default.createElement('input', {
	          id: messageType,
	          type: 'radio',
	          name: messageType,
	          value: messageType,
	          checked: _this.isChecked(messageType),
	          onChange: _this.handleSelectionChange,
	          disabled: disabled
	          /*eslint-disable */
	          , ref: function ref(input) {
	            _this.state.radioRefs[messageType] = input;
	          }
	          /*eslint-enable */
	        }),
	        _react2.default.createElement(
	          'label',
	          { className: 'radio-btn', htmlFor: messageType },
	          _ref8
	        )
	      );
	    };
	
	    _this.renderAddress = function (customer) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          { className: 'name' },
	          customer.name
	        ),
	        customer.address && _react2.default.createElement(
	          'div',
	          { className: 'address' },
	          _react2.default.createElement(
	            'p',
	            null,
	            customer.address.co
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            customer.address.street
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            customer.address.zip,
	            ' ',
	            customer.address.city,
	            ' ',
	            customer.address.country
	          )
	        )
	      );
	    };
	
	    _this.state = {
	      formValues: {
	        email: {},
	        emailSecondary: {},
	        phone: {},
	        einvoice: {},
	        poNumber: {}
	      },
	      showErrorWithoutBlur: false,
	      radioRefs: {}
	    };
	
	    _this.messageTypes = {
	      email: 'email',
	      sms: 'sms',
	      mail: 'mail',
	      einvoice: 'e-invoice'
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Invoicing, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.invoice.sendToEmail !== this.props.invoice.sendToEmail) {
	        this.handleChange('email', { value: nextProps.invoice.sendToEmail });
	      }
	
	      if (nextProps.invoice.sendToEmailSecondary !== this.props.invoice.sendToEmailSecondary) {
	        this.handleChange('emailSecondary', { value: nextProps.invoice.sendToEmailSecondary });
	      }
	
	      if (nextProps.invoice.companyPhone !== this.props.invoice.companyPhone) {
	        this.handleChange('phone', { value: nextProps.invoice.companyPhone });
	      }
	
	      if (nextProps.invoice.einvoiceAddress !== this.props.invoice.einvoiceAddress) {
	        this.handleChange('einvoice', { value: nextProps.invoice.einvoiceAddress });
	      }
	
	      if (nextProps.invoice.poNumber !== this.props.invoice.poNumber) {
	        this.handleChange('poNumber', { value: nextProps.invoice.poNumber });
	      }
	
	      if (nextProps.invoice.submitted && !this.state.showErrorWithoutBlur) {
	        this.setState({ showErrorWithoutBlur: true });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'invoicing section-padding' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _ref9,
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(_reactTranslateComponent2.default, { content: this.props.translationPrefix + 'INVOICING_TEXT' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'white-box left' },
	          this.renderEmailSection(),
	          this.renderMailSection(),
	          this.renderSwishSection(),
	          this.renderEinvoiceSection()
	        )
	      );
	    }
	  }]);
	  return Invoicing;
	}(_react2.default.Component);
	
	exports.default = Invoicing;

/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(12);
	
	var _index = __webpack_require__(43);
	
	var _offers = __webpack_require__(940);
	
	var _offers2 = _interopRequireDefault(_offers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    expressPayment: state.invoice.expressPayment,
	    couponId: state.invoice.couponId,
	    rot: state.invoice.hsd.rot,
	    rut: state.invoice.hsd.rut,
	    customer: state.invoice.customerEntity,
	    invoiceId: state.invoice.invoiceId
	  };
	} /**
	   * Created by eriksundqvist on 31/10/16.
	   */
	
	;
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    setExpressPayment: function setExpressPayment(expressPayment) {
	      return dispatch((0, _index.setExpressPayment)(expressPayment));
	    },
	    setCouponId: function setCouponId(couponId) {
	      return dispatch((0, _index.setCouponId)(couponId));
	    },
	    setCoupon: function setCoupon(coupon) {
	      return dispatch((0, _index.setCoupon)(coupon));
	    },
	    clearCoupon: function clearCoupon(coupon) {
	      return dispatch((0, _index.clearCoupon)(coupon));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_offers2.default);

/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Offers = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _reactRouter = __webpack_require__(20);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _components = __webpack_require__(13);
	
	var _readMoreModal = __webpack_require__(226);
	
	var _readMoreModal2 = _interopRequireDefault(_readMoreModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_COUNTRY = 'SWEDEN'; /**
	                                 * Created by eriksundqvist on 10/05/16.
	                                 */
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'coupon-image' },
	  _react2.default.createElement(_components.Spinner, { size: 25 })
	);
	
	var _ref2 = _react2.default.createElement('div', { className: 'coupon-image sprite-image thumbs-up' });
	
	var _ref3 = _react2.default.createElement('div', { className: 'coupon-image sprite-image thumbs-down' });
	
	var _ref4 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SAME_DAY_PAYMENT' });
	
	var _ref5 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'EXPRESS_PAYMENT_READ_MORE' });
	
	var _ref6 = _react2.default.createElement(
	  'label',
	  { htmlFor: 'express-betalning' },
	  _react2.default.createElement('span', null)
	);
	
	var _ref7 = _react2.default.createElement(
	  'p',
	  { className: 'black' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CAMPAIGN_CODE_TITLE' })
	);
	
	var Offers = exports.Offers = function (_React$Component) {
	  (0, _inherits3.default)(Offers, _React$Component);
	
	  function Offers(props) {
	    (0, _classCallCheck3.default)(this, Offers);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Offers.__proto__ || (0, _getPrototypeOf2.default)(Offers)).call(this, props));
	
	    _this.state = {
	      checkingCoupon: false,
	      couponValid: false,
	      renderModal: false
	    };
	
	    _this.expressPaymentClick = _this.expressPaymentClick.bind(_this);
	    _this.onChangeCouponId = _this.onChangeCouponId.bind(_this);
	    _this.toggleModal = _this.toggleModal.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(Offers, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.couponId !== this.props.couponId) {
	        this.startRequestTimeout();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.cannotUseExpressPayment() && this.props.expressPayment) {
	        this.props.setExpressPayment(false);
	      }
	    }
	  }, {
	    key: 'expressPaymentClick',
	    value: function expressPaymentClick(event) {
	      this.props.setExpressPayment(!this.props.expressPayment);
	    }
	  }, {
	    key: 'onChangeCouponId',
	    value: function onChangeCouponId(e) {
	      this.props.setCouponId(e.target.value);
	    }
	
	    /**
	     * Wait 300 ms since last input before making the request to
	     * the backend.
	     */
	
	  }, {
	    key: 'startRequestTimeout',
	    value: function startRequestTimeout() {
	      if (this.requestTimeout) {
	        window.clearTimeout(this.requestTimeout);
	      }
	
	      this.requestTimeout = setTimeout(this.checkCoupon.bind(this), 300);
	    }
	  }, {
	    key: 'checkCoupon',
	    value: function checkCoupon() {
	      var _this2 = this;
	
	      if (this.props.couponId !== '') {
	        this.setState({
	          checkingCoupon: true
	        });
	
	        _frilansFinans.CouponService.getById(this.props.couponId, this.props.invoiceId).then(function (coupon) {
	          _this2.setState({
	            couponValid: true,
	            checkingCoupon: false
	          });
	
	          _this2.props.setCoupon(coupon);
	        }).catch(function (e) {
	          _this2.setState({
	            couponValid: false,
	            checkingCoupon: false
	          });
	
	          _this2.props.clearCoupon();
	        });
	      } else {
	        this.props.clearCoupon();
	      }
	    }
	  }, {
	    key: 'toggleModal',
	    value: function toggleModal(e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.setState({
	        renderModal: !this.state.renderModal
	      });
	    }
	  }, {
	    key: 'renderModal',
	    value: function renderModal() {
	      if (this.state.renderModal) {
	        return _react2.default.createElement(_readMoreModal2.default, {
	          close: this.toggleModal,
	          text: _readMoreModal.EXPRESS
	        });
	      }
	    }
	  }, {
	    key: 'renderCouponImage',
	    value: function renderCouponImage() {
	      if (this.state.checkingCoupon) {
	        return _ref;
	      }
	      if (this.props.couponId !== '') {
	        if (this.state.couponValid) {
	          return _ref2;
	        } else {
	          return _ref3;
	        }
	      }
	    }
	  }, {
	    key: 'cannotUseExpressPayment',
	    value: function cannotUseExpressPayment() {
	      var _props = this.props,
	          customer = _props.customer,
	          rot = _props.rot,
	          rut = _props.rut;
	
	      var country = customer && customer.address && customer.address.country;
	      return rot || rut || country !== DEFAULT_COUNTRY && country !== null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var validClass = '';
	
	      if (this.props.couponId !== '') {
	        validClass = this.state.couponValid ? 'valid' : 'invalid';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'invoice-offers' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-4' },
	          _react2.default.createElement(
	            'p',
	            null,
	            _ref4,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '#', activeClassName: 'selected', onClick: this.toggleModal },
	              _ref5
	            )
	          ),
	          _react2.default.createElement('input', { id: 'express-betalning',
	            type: 'checkbox',
	            name: 'express-betalning',
	            value: this.props.expressPayment,
	            checked: this.props.expressPayment,
	            disabled: this.cannotUseExpressPayment(),
	            onClick: this.expressPaymentClick
	          }),
	          _ref6,
	          _react2.default.createElement('img', { src: __webpack_require__(1550), alt: 'Expressbetalning' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-4 coupon-wrapper' },
	          _ref7,
	          _react2.default.createElement('input', {
	            type: 'text',
	            className: validClass,
	            name: 'kampanjkod',
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('CAMPAIGN_CODE'),
	            value: this.props.couponId,
	            onChange: this.onChangeCouponId
	          }),
	          this.renderCouponImage()
	        ),
	        this.renderModal()
	      );
	    }
	  }]);
	  return Offers;
	}(_react2.default.Component);
	
	exports.default = Offers;

/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PreviewInvoice = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _invoiceToolHelper = __webpack_require__(50);
	
	var _amountHelper = __webpack_require__(58);
	
	var _components = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ = __webpack_require__(40);
	
	var _ref = _react2.default.createElement(_components.GeneralError, null);
	
	var _ref2 = _react2.default.createElement(
	  'div',
	  { className: 'loader-wrapper' },
	  _react2.default.createElement(_components.Spinner, null)
	);
	
	var _ref3 = _react2.default.createElement(
	  'div',
	  { className: 'ff-label' },
	  _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'p',
	      { className: 'ff-text-left' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_DESCRIPTION' })
	    )
	  ),
	  _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'p',
	      { className: 'ff-text-right' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_TOTAL_EXCL_VAT' })
	    )
	  )
	);
	
	var _ref4 = _react2.default.createElement(
	  'div',
	  { className: 'ff-footer-text ff-text-left' },
	  'Frilans Finans Sverige AB',
	  _react2.default.createElement('br', null),
	  'Dag Hammarskj\xF6lds v\xE4g 13, 752 37 Uppsala',
	  _react2.default.createElement('br', null),
	  'Tel: +46(0)771151000',
	  _react2.default.createElement('br', null),
	  'info@frilansfinans.se',
	  _react2.default.createElement('br', null)
	);
	
	var _ref5 = _react2.default.createElement(
	  'span',
	  null,
	  'Org.nr/Momsreg.nr',
	  _react2.default.createElement('br', null),
	  '556802-1199',
	  _react2.default.createElement('br', null),
	  'SE556802119901',
	  _react2.default.createElement('br', null),
	  'Godk\xE4nd f\xF6r F-skatt',
	  _react2.default.createElement('br', null),
	  'S\xE4te i Uppsala'
	);
	
	var _ref6 = _react2.default.createElement(
	  'span',
	  null,
	  'Org No./VAT No.',
	  _react2.default.createElement('br', null),
	  '556802-1199',
	  _react2.default.createElement('br', null),
	  'SE556802119901',
	  _react2.default.createElement('br', null),
	  'Approved for F-skatt',
	  _react2.default.createElement('br', null),
	  'Seated in Uppsala'
	);
	
	var _ref7 = _react2.default.createElement(
	  'div',
	  { className: 'ff-footer-text ff-text-left ff-text-bold' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_BANKGIRO' }),
	  ' ',
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_TOOL_GIRO' }),
	  _react2.default.createElement('br', null),
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_SWIFT_NO' }),
	  ' ',
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_TOOL_BIC' }),
	  _react2.default.createElement('br', null),
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_IBAN_NO' }),
	  ' ',
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_TOOL_IBAN' }),
	  _react2.default.createElement('br', null),
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_BANK_ACCOUNT_NO' }),
	  ' ',
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_TOOL_ACCOUNT_NUMBER' }),
	  _react2.default.createElement('br', null)
	);
	
	var _ref8 = _react2.default.createElement(
	  'div',
	  { className: 'faktura-box' },
	  _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h4',
	      { className: 'ff-text-left' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'invoice' })
	    )
	  ),
	  _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'p',
	      { className: 'ff-text-left' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_OCR_NUMBER' })
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'ff-text-left ff-text-large' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ADDED_LATER' })
	    )
	  ),
	  _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_INVOICE_NO' })
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'ff-text-large' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ADDED_LATER' })
	    )
	  ),
	  _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_DATE' })
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'ff-text-large' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ADDED_LATER' })
	    )
	  )
	);
	
	var _ref9 = _react2.default.createElement('br', null);
	
	var _ref10 = _react2.default.createElement(
	  'div',
	  { className: 'ff-text-left' },
	  _react2.default.createElement(
	    'p',
	    null,
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_YOUR_CUSTOMER_NO' })
	  ),
	  _react2.default.createElement(
	    'p',
	    null,
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_YOUR_REFERENCE' })
	  ),
	  _react2.default.createElement(
	    'p',
	    null,
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_OUR_REFERENCE' })
	  )
	);
	
	var _ref11 = _react2.default.createElement('br', null);
	
	var _ref12 = _react2.default.createElement(
	  'p',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_INVOICE_SERVICE' })
	);
	
	var _ref13 = _react2.default.createElement(
	  'div',
	  { className: 'ff-text-left' },
	  _react2.default.createElement(
	    'p',
	    { className: 'ff-text-bold' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_DUE_DATE' })
	  ),
	  _react2.default.createElement(
	    'p',
	    null,
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_PAYMENT_TERMS' })
	  ),
	  _react2.default.createElement(
	    'p',
	    null,
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_INTEREST_FEE' })
	  )
	);
	
	var _ref14 = _react2.default.createElement(
	  'p',
	  { className: 'ff-text-bold' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ADDED_LATER' })
	);
	
	var _ref15 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_DAYS_NET' });
	
	var _ref16 = _react2.default.createElement(
	  'p',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_INTEREST_FEE_VALUE' })
	);
	
	var _ref17 = _react2.default.createElement(
	  'div',
	  { className: 'ff-text-left' },
	  _react2.default.createElement(
	    'p',
	    null,
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_PAYMENT_REMINDER_FEE' })
	  )
	);
	
	var _ref18 = _react2.default.createElement(
	  'div',
	  { className: 'date-string' },
	  _react2.default.createElement('br', null)
	);
	
	var _ref19 = _react2.default.createElement(
	  'p',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_SPECIFICATION_ROT' })
	);
	
	var _ref20 = _react2.default.createElement(
	  'p',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_SPECIFICATION_RUT' })
	);
	
	var _ref21 = _react2.default.createElement('br', null);
	
	var _ref22 = _react2.default.createElement(
	  'p',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_IS_EU_CUSTOMER', fallback: ' ' })
	);
	
	var _ref23 = _react2.default.createElement(
	  'p',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_IS_NOT_EU_CUSTOMER', fallback: ' ' })
	);
	
	var _ref24 = _react2.default.createElement(
	  'p',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_TOTAL_EXCL_VAT' })
	);
	
	var _ref25 = _react2.default.createElement(
	  'p',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_VAT_RATE' })
	);
	
	var _ref26 = _react2.default.createElement(
	  'p',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_VAT' })
	);
	
	var _ref27 = _react2.default.createElement(
	  'p',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_ROUNDING' })
	);
	
	var _ref28 = _react2.default.createElement(
	  'p',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CURRENCY' })
	);
	
	var _ref29 = _react2.default.createElement(
	  'p',
	  { className: 'ff-text-bold' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_TOTAL_INCL_VAT' })
	);
	
	var _ref30 = _react2.default.createElement(
	  'div',
	  { className: 'ff-text-left' },
	  _react2.default.createElement(
	    'p',
	    { className: 'ff-text-bold ff-text-large' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_PLEASE_ALWAYS' })
	  ),
	  _react2.default.createElement(
	    'p',
	    { className: 'ff-text-large' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_COMMENTS_MADE' })
	  )
	);
	
	var PreviewInvoice = exports.PreviewInvoice = function (_React$Component) {
	  (0, _inherits3.default)(PreviewInvoice, _React$Component);
	
	  function PreviewInvoice(props, context) {
	    (0, _classCallCheck3.default)(this, PreviewInvoice);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PreviewInvoice.__proto__ || (0, _getPrototypeOf2.default)(PreviewInvoice)).call(this, props, context));
	
	    _this.isForeignCustomer = function () {
	      return typeof _this.state.invoice.customerEntity.address.country !== 'undefined' && _this.state.invoice.customerEntity.address.country !== 'SWEDEN';
	    };
	
	    _this.isEuNonSeCustomer = function () {
	      var euCountries = ['AUSTRIA', 'BELGIUM', 'BULGARIA', 'CROATIA', 'CYPRUS', 'CZECH REPUBLIC', 'DENMARK', 'ESTONIA', 'FINLAND', 'FRANCE', 'GERMANY', 'GREECE', 'HUNGARY', 'IRELAND', 'ITALY', 'LATVIA', 'LITHUANIA', 'LUXEMBURG', 'MALTA', 'NETHERLANDS', 'POLAND', 'PORTUGAL', 'ROMANIA', 'SLOVAKIA', 'SLOVENIA', 'SPAIN'];
	      var isEUCountry = false;
	      for (var i = 0; i < euCountries.length; i++) {
	        if (typeof _this.state.invoice.customerEntity.address.country !== 'undefined' && _this.state.invoice.customerEntity.address.country === euCountries[i]) {
	          isEUCountry = true;
	          break;
	        }
	      }
	      return isEUCountry;
	    };
	
	    _this.state = {
	      invoice: null,
	      user: context.user,
	      fetching: true,
	      fetchError: false
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(PreviewInvoice, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!_.isEqual(nextProps, this.props)) {
	        this.setState({ invoice: nextProps.previewInvoice });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({
	        fetching: false,
	        fetchError: false,
	        invoice: this.props.previewInvoice
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var content = this.getContent();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'invoice' },
	        content
	      );
	    }
	  }, {
	    key: 'getContent',
	    value: function getContent() {
	      if (this.state.fetching) {
	        return this.renderLoader();
	      }
	      if (this.state.fetchError) {
	        return _ref;
	      }
	
	      return this.renderInvoicePreview();
	    }
	  }, {
	    key: 'renderLoader',
	    value: function renderLoader() {
	      return _ref2;
	    }
	  }, {
	    key: 'renderInvoicePreview',
	    value: function renderInvoicePreview() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'container ff-doc' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row ' + (this.isEuNonSeCustomer() ? 'ff-no-margin-bottom' : 'invoice-header') },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-6' },
	              _react2.default.createElement(
	                'object',
	                { className: 'ff-logo', type: 'image/svg+xml',
	                  data: __webpack_require__(1575),
	                  alt: 'Frilans Finans-logotyp' },
	                _react2.default.createElement('img', { className: 'ff-logo', src: __webpack_require__(1551), alt: 'Frilans Finans-logotyp' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-6' },
	              this.renderInvoicePreviewCustomerDetails()
	            )
	          ),
	          this.renderInvoiceReferenceDetails(),
	          _ref3,
	          this.renderInvoiceDescription(),
	          this.renderInvoicePayment(),
	          _react2.default.createElement(
	            'div',
	            { className: 'adress-box' },
	            _ref4,
	            _react2.default.createElement(
	              'div',
	              { className: 'ff-footer-text ff-text-left' },
	              !this.isForeignCustomer() && _ref5,
	              this.isForeignCustomer() && _ref6
	            ),
	            _ref7
	          ),
	          this.renderInvoicePreviewClose()
	        )
	      );
	    }
	  }, {
	    key: 'renderInvoicePreviewCustomerDetails',
	    value: function renderInvoicePreviewCustomerDetails() {
	      var invoice = this.state.invoice;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _ref8,
	        _react2.default.createElement(
	          'div',
	          { className: 'ff-customer-adress ff-text-left' },
	          _react2.default.createElement(
	            'p',
	            { className: 'ff-text-large' },
	            invoice.customerEntity.name
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'ff-text-large' },
	            invoice.customerEntity.address.co.trim().length ? _react2.default.createElement(
	              'span',
	              null,
	              invoice.customerEntity.address.co
	            ) : null
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'ff-text-large' },
	            invoice.customerEntity.address.street
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'ff-text-large' },
	            invoice.customerEntity.address.zip,
	            ' ',
	            invoice.customerEntity.address.city
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'ff-text-large' },
	            invoice.customerEntity.address.country
	          ),
	          this.isEuNonSeCustomer() && _react2.default.createElement(
	            'div',
	            { className: 'vat-nr' },
	            _ref9,
	            _react2.default.createElement(
	              'p',
	              null,
	              invoice.customerEntity.vatNr
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderInvoiceReferenceDetails',
	    value: function renderInvoiceReferenceDetails() {
	      var invoice = this.state.invoice;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'reference-box' },
	          _ref10,
	          _react2.default.createElement(
	            'div',
	            { className: 'ff-text-left' },
	            _react2.default.createElement(
	              'p',
	              { className: 'ff-text-bold' },
	              invoice.customerId
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              invoice.customerEntity.contact || _ref11
	            ),
	            _ref12
	          ),
	          _ref13,
	          _react2.default.createElement(
	            'div',
	            { className: 'ff-text-left' },
	            _ref14,
	            _react2.default.createElement(
	              'p',
	              null,
	              invoice.customerEntity.payTerms,
	              ' ',
	              _ref15
	            ),
	            _ref16
	          ),
	          _ref17
	        )
	      );
	    }
	  }, {
	    key: 'renderInvoiceDescription',
	    value: function renderInvoiceDescription() {
	      var invoice = this.state.invoice;
	      var user = this.state.invoice.invoiceUser[0];
	      var dates = this.state.invoice.invoiceDate;
	      var displayDates = this.state.invoice.displayDates;
	      var displayHours = this.state.invoice.displayHours;
	      var dateString = [];
	
	      if (displayDates === 1) {
	        for (var i = 0; i < dates.length; i++) {
	          var hours = '';
	          if (displayHours === 1) {
	            hours = ' ' + dates[i].hours + 'h';
	          }
	          if (dates.length - 1 === i) {
	            dateString.push(_react2.default.createElement(
	              'div',
	              { className: 'date-string', key: i },
	              _react2.default.createElement(
	                'p',
	                null,
	                dates[i].date + hours
	              )
	            ));
	          } else {
	            dateString.push(_react2.default.createElement(
	              'div',
	              { className: 'date-string', key: i },
	              _react2.default.createElement(
	                'p',
	                null,
	                dates[i].date + hours + ', '
	              )
	            ));
	          }
	        }
	      } else {
	        dateString = dateString.splice(0, dateString.length);
	        dateString = _ref18;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'description-box' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ff-text-left description-text' },
	          _react2.default.createElement(
	            'p',
	            null,
	            user.firstName,
	            ' ',
	            user.lastName
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'date-box' },
	            dateString
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'specification-text' },
	            invoice.specification
	          ),
	          invoice.hsd.rot && _ref19,
	          invoice.hsd.rut && _ref20,
	          _ref21,
	          this.isEuNonSeCustomer() && _ref22,
	          !this.isEuNonSeCustomer() && _ref23
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ff-text-right' },
	          _react2.default.createElement(
	            'p',
	            null,
	            this.calculateInvoiceAmounts().netAmount
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderInvoicePayment',
	    value: function renderInvoicePayment() {
	      var invoice = this.state.invoice;
	      var vat = '0 %';
	      if (this.calculateInvoiceAmounts().vat && parseInt(this.calculateInvoiceAmounts().vat) !== 0) {
	        vat = this.calculateInvoiceAmounts().vat + ' %';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'payment-box' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ff-text-left' },
	          _ref24,
	          _react2.default.createElement(
	            'p',
	            null,
	            this.calculateInvoiceAmounts().netAmount
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ff-text-left' },
	          _ref25,
	          _react2.default.createElement(
	            'p',
	            null,
	            vat
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ff-text-left' },
	          _ref26,
	          _react2.default.createElement(
	            'p',
	            null,
	            Math.round(this.calculateInvoiceAmounts().vatAmount * 100) / 100
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ff-text-left' },
	          _ref27,
	          _react2.default.createElement(
	            'p',
	            null,
	            this.calculateInvoiceAmounts().roundedBy || '0'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ff-text-left' },
	          _ref28,
	          _react2.default.createElement(
	            'p',
	            { className: 'ff-text-bold' },
	            invoice.currencyName
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ff-text-right' },
	          _ref29,
	          _react2.default.createElement(
	            'p',
	            { className: 'ff-text-bold ff-text-large' },
	            this.calculateInvoiceAmounts().totalAmountRounded
	          )
	        ),
	        _ref30
	      );
	    }
	  }, {
	    key: 'calculateInvoiceAmounts',
	    value: function calculateInvoiceAmounts() {
	      var invoice = this.state.invoice;
	
	      var calcAmount = invoice.hsd.rot || invoice.hsd.rut ? invoice.amountAfterHsd : invoice.currencyAmount;
	
	      var netAmount = (0, _amountHelper.toMoney)(calcAmount, 2);
	      var taxableAmount = calcAmount;
	      var vat = (0, _invoiceToolHelper.getVatById)(invoice.taxId);
	      var vatAmount = calcAmount * ((0, _invoiceToolHelper.getVatById)(invoice.taxId) / 100);
	      var totalAmount = calcAmount + vatAmount;
	      var totalAmountRounded = (0, _amountHelper.toMoney)(calcAmount + vatAmount, 0);
	      var roundedBy = (0, _amountHelper.toMoney)(totalAmountRounded - totalAmount);
	
	      return {
	        netAmount: netAmount,
	        taxableAmount: vat === 0 ? '' : taxableAmount,
	        vat: vat === 0 ? '' : vat,
	        vatAmount: vatAmount === 0 ? '' : vatAmount,
	        totalAmount: totalAmount,
	        totalAmountRounded: totalAmountRounded,
	        roundedBy: roundedBy === 0 ? '' : roundedBy
	      };
	    }
	  }, {
	    key: 'renderInvoicePreviewClose',
	    value: function renderInvoicePreviewClose() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'btn-close-wrapper' },
	        _react2.default.createElement('button', { className: 'close', onClick: this.props.closePreviewModal })
	      );
	    }
	  }]);
	  return PreviewInvoice;
	}(_react2.default.Component);
	
	PreviewInvoice.contextTypes = {
	  user: _react.PropTypes.object.isRequired,
	  router: _react.PropTypes.object.isRequired
	};
	exports.default = PreviewInvoice;

/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SettingsTabWrapper = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _salaryInfo = __webpack_require__(232);
	
	var _salaryInfo2 = _interopRequireDefault(_salaryInfo);
	
	var _changePassword = __webpack_require__(228);
	
	var _changePassword2 = _interopRequireDefault(_changePassword);
	
	var _ownEmployment = __webpack_require__(229);
	
	var _ownEmployment2 = _interopRequireDefault(_ownEmployment);
	
	var _personalInfo = __webpack_require__(230);
	
	var _personalInfo2 = _interopRequireDefault(_personalInfo);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _Tabs = __webpack_require__(1382);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _Tab = __webpack_require__(1380);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_salaryInfo2.default, null);
	
	var _ref2 = _react2.default.createElement(_changePassword2.default, null);
	
	var _ref3 = _react2.default.createElement(_ownEmployment2.default, null);
	
	var _ref4 = _react2.default.createElement(_personalInfo2.default, null);
	
	var _ref5 = _react2.default.createElement(
	  'span',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CLOSE' })
	);
	
	var SettingsTabWrapper = exports.SettingsTabWrapper = function (_React$Component) {
	  (0, _inherits3.default)(SettingsTabWrapper, _React$Component);
	
	  function SettingsTabWrapper() {
	    (0, _classCallCheck3.default)(this, SettingsTabWrapper);
	    return (0, _possibleConstructorReturn3.default)(this, (SettingsTabWrapper.__proto__ || (0, _getPrototypeOf2.default)(SettingsTabWrapper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SettingsTabWrapper, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'settings-tab-wrapper' },
	        _react2.default.createElement(
	          _Tabs2.default,
	          { defaultActiveKey: 1, animation: false, id: 'settings-tap-wrapper' },
	          _react2.default.createElement(
	            _Tab2.default,
	            { eventKey: 1, title: (0, _proxyCounterpart.proxyCounterpart)('SALARY_INFO') },
	            _ref
	          ),
	          _react2.default.createElement(
	            _Tab2.default,
	            { eventKey: 2, title: (0, _proxyCounterpart.proxyCounterpart)('CHANGE_PASSWORD') },
	            _ref2
	          ),
	          _react2.default.createElement(
	            _Tab2.default,
	            { eventKey: 3, title: (0, _proxyCounterpart.proxyCounterpart)('OWN_EMPLOYMENT') },
	            _ref3
	          ),
	          _react2.default.createElement(
	            _Tab2.default,
	            { eventKey: 4, title: (0, _proxyCounterpart.proxyCounterpart)('PERSONAL_INFO') },
	            _ref4
	          )
	        ),
	        _react2.default.createElement(
	          'a',
	          { className: 'btn outlined blue', onClick: this.props.closeSettingsModal },
	          _ref5
	        )
	      );
	    }
	  }]);
	  return SettingsTabWrapper;
	}(_react2.default.Component);
	
	SettingsTabWrapper.contextTypes = {
	  user: _react.PropTypes.object.isRequired
	};
	exports.default = SettingsTabWrapper;

/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(12);
	
	var _index = __webpack_require__(43);
	
	var _specification = __webpack_require__(944);
	
	var _specification2 = _interopRequireDefault(_specification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    specification: state.invoice.specification,
	    submitted: state.invoice.submitted
	  };
	} /**
	   * Created by eriksundqvist on 25/05/16.
	   */
	;
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    setSpecification: function setSpecification(specification) {
	      return dispatch((0, _index.setSpecification)(specification));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_specification2.default);

/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Specification = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _invoiceValidator = __webpack_require__(91);
	
	var _invoiceValidator2 = _interopRequireDefault(_invoiceValidator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'p',
	  { className: 'error' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_ERROR_SPECIFICATION' })
	); /**
	    * Created by eriksundqvist on 10/05/16.
	    */
	
	var _ref2 = _react2.default.createElement(
	  'h3',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_DESCRIPTION' })
	);
	
	var Specification = exports.Specification = function (_React$Component) {
	  (0, _inherits3.default)(Specification, _React$Component);
	
	  function Specification(props) {
	    (0, _classCallCheck3.default)(this, Specification);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Specification.__proto__ || (0, _getPrototypeOf2.default)(Specification)).call(this, props));
	
	    _this.state = {
	      isExpanded: false,
	      specification: '',
	      specificationTouched: false
	    };
	
	    _this.setSpecification = _this.setSpecification.bind(_this);
	    _this.blurSpecification = _this.blurSpecification.bind(_this);
	    _this.toggleExpandedStyle = _this.toggleExpandedStyle.bind(_this);
	    _this.setSpecificationHeight = _this.setSpecificationHeight.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(Specification, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      this.setState({
	        specification: props.specification
	      });
	    }
	  }, {
	    key: 'setSpecification',
	    value: function setSpecification(event) {
	      this.props.setSpecification(event.target.value);
	      this.setSpecificationHeight(this.state.isExpanded);
	    }
	  }, {
	    key: 'blurSpecification',
	    value: function blurSpecification() {
	      this.setState({
	        specificationTouched: true
	      });
	    }
	  }, {
	    key: 'renderError',
	    value: function renderError() {
	      if ((this.state.specificationTouched || this.props.submitted) && !_invoiceValidator2.default.validateSpecification(this.state.specification)) {
	        return _ref;
	      }
	    }
	  }, {
	    key: 'toggleExpandedStyle',
	    value: function toggleExpandedStyle() {
	      this.setState({
	        isExpanded: !this.state.isExpanded
	      });
	
	      this.setSpecificationHeight(!this.state.isExpanded);
	    }
	  }, {
	    key: 'setSpecificationHeight',
	    value: function setSpecificationHeight(isExpanded) {
	      var specification = document.getElementsByClassName('invoice-tool-specification')[0];
	      if (isExpanded) {
	        specification.style.height = specification.scrollHeight + 'px';
	        specification.style.overflowY = 'hidden';
	      } else {
	        specification.style.height = '140px';
	        specification.style.overflowY = 'scroll';
	      }
	    }
	  }, {
	    key: 'renderExpandButton',
	    value: function renderExpandButton() {
	      var specification = document.getElementsByClassName('invoice-tool-specification')[0];
	
	      if (specification && specification.scrollHeight > 140) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'invoice-tool-specification-button-container' },
	          _react2.default.createElement(
	            'button',
	            { onClick: this.toggleExpandedStyle },
	            _react2.default.createElement('img', { src: this.state.isExpanded ? __webpack_require__(1573) : __webpack_require__(1566) })
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _ref2,
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(_reactTranslateComponent2.default, { content: this.props.translationPrefix + 'INVOICE_TEXT' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'invoice-tool-specification-container' },
	          _react2.default.createElement('textarea', {
	            className: 'invoice-tool-specification',
	            name: 'specification',
	            value: this.state.specification,
	            onChange: this.setSpecification,
	            onBlur: this.blurSpecification
	          }),
	          this.renderExpandButton()
	        ),
	        this.renderError()
	      );
	    }
	  }]);
	  return Specification;
	}(_react2.default.Component);
	
	exports.default = Specification;

/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Ssnr = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _components = __webpack_require__(13);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _reactModal = __webpack_require__(30);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_components.GeneralError, null);
	
	var _ref2 = _react2.default.createElement(
	  'h2',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SSNR_MODAL_HEADER' })
	);
	
	var _ref3 = _react2.default.createElement(
	  'p',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SSNR_MODAL_TEXT' })
	);
	
	var _ref4 = _react2.default.createElement(
	  'h6',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SSNR_MODAL_SMALL_TEXT' })
	);
	
	var Ssnr = exports.Ssnr = function (_React$Component) {
	  (0, _inherits3.default)(Ssnr, _React$Component);
	
	  function Ssnr(props, context) {
	    (0, _classCallCheck3.default)(this, Ssnr);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Ssnr.__proto__ || (0, _getPrototypeOf2.default)(Ssnr)).call(this, props, context));
	
	    _this.state = {
	      open: true,
	      showErrorWithoutBlur: false,
	      ssnr: { valid: false, value: '' },
	      posting: false,
	      postError: false,
	      activateSubmitButton: false
	    };
	
	    _this.callback = _this.callback.bind(_this);
	    _this.submitForm = _this.submitForm.bind(_this);
	    _this.clickSubmit = _this.clickSubmit.bind(_this);
	    _this.handleSuccess = _this.handleSuccess.bind(_this);
	    _this.handleError = _this.handleError.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(Ssnr, [{
	    key: 'callback',
	    value: function callback(name, values) {
	      this.setState({ ssnr: values, activateSubmitButton: !!values.valid });
	    }
	  }, {
	    key: 'clickSubmit',
	    value: function clickSubmit(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	
	      this.setState({ showErrorWithoutBlur: true }, function () {
	        if (_this2.state.ssnr.valid) {
	          _this2.submitForm();
	        }
	      });
	    }
	  }, {
	    key: 'submitForm',
	    value: function submitForm() {
	      var params = { 'socialSecurityNr': this.state.ssnr.value };
	
	      _frilansFinans.UserService.updateSsnr(params).then(this.handleSuccess).catch(this.handleError);
	
	      this.setState({
	        posting: true,
	        postError: false
	      });
	    }
	  }, {
	    key: 'handleSuccess',
	    value: function handleSuccess() {
	      this.setState({
	        posting: false,
	        postError: false
	      });
	
	      this.props.onCloseModal();
	    }
	  }, {
	    key: 'handleError',
	    value: function handleError(error) {
	      var errors = _frilansFinans.UserService.getError(error);
	
	      this.setState({
	        posting: false,
	        postError: true,
	        errorMessage: errors
	      });
	    }
	  }, {
	    key: 'renderPostError',
	    value: function renderPostError() {
	      if (this.state.postError) {
	        if (!this.state.errorMessage) {
	          return _ref;
	        } else {
	          return _react2.default.createElement(
	            'div',
	            null,
	            this.state.errorMessage.map(function (error, i) {
	              return _react2.default.createElement(
	                'p',
	                { className: 'error', key: i },
	                error
	              );
	            })
	          );
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var errorMessage = this.state.ssnr.value.replace(/\D+/g, '').length !== 12 ? 'PERSONAL_NUMBER_ERROR' : 'PERSONAL_NUMBER_ERROR_BACKEND';
	
	      return _react2.default.createElement(
	        _reactModal2.default,
	        {
	          className: 'modal-pop-complete-information',
	          contentLabel: '',
	          isOpen: this.state.open,
	          onRequestClose: this.props.onCloseModal },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-left-column' },
	          _ref2,
	          _ref3,
	          _react2.default.createElement(
	            'div',
	            { className: 'info-text-bottom' },
	            _ref4,
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_components.InputField, {
	                type: 'text',
	                inputMode: 'numeric',
	                validationType: 'personalNumber',
	                name: 'socialSecurityNr',
	                placeholder: (0, _proxyCounterpart.proxyCounterpart)('SSNR_MODAL_PLACEHOLDER'),
	                callback: this.callback,
	                required: 'true',
	                minLength: '3',
	                errorMessage: (0, _proxyCounterpart.proxyCounterpart)(errorMessage),
	                showErrorWithoutBlur: this.state.showErrorWithoutBlur }),
	              this.renderPostError(),
	              _react2.default.createElement(
	                'div',
	                { className: 'button-holder' },
	                _react2.default.createElement(_components.SpinnerButton, {
	                  text: (0, _proxyCounterpart.proxyCounterpart)('SAVE'),
	                  loading: this.state.posting,
	                  classes: 'btn cover',
	                  callback: this.clickSubmit,
	                  disabled: !this.state.activateSubmitButton
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-right-column' },
	          _react2.default.createElement('img', { src: (0, _proxyCounterpart.proxyCounterpart)('SSNR_MODAL_IMAGE') })
	        )
	      );
	    }
	  }]);
	  return Ssnr;
	}(_react2.default.Component);
	
	Ssnr.contextTypes = {
	  user: _react.PropTypes.object.isRequired
	
	};
	exports.default = Ssnr;

/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(12);
	
	var _index = __webpack_require__(43);
	
	var _workDate = __webpack_require__(951);
	
	var _workDate2 = _interopRequireDefault(_workDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    invoiceDate: state.invoice.invoiceDate,
	    submitted: state.invoice.submitted,
	    displayDates: state.invoice.displayDates,
	    displayHours: state.invoice.displayHours
	  };
	} /**
	   * Created by eriksundqvist on 25/05/16.
	   */
	;
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    setInvoiceDate: function setInvoiceDate(invoiceDate) {
	      return dispatch((0, _index.setInvoiceDate)(invoiceDate));
	    },
	    setDisplayDates: function setDisplayDates(displayDates) {
	      return dispatch((0, _index.setDisplayDates)(displayDates));
	    },
	    setDisplayHours: function setDisplayHours(displayHours) {
	      return dispatch((0, _index.setDisplayHours)(displayHours));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_workDate2.default);

/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(12);
	
	var _workDatePicker = __webpack_require__(948);
	
	var _workDatePicker2 = _interopRequireDefault(_workDatePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by eriksundqvist on 25/05/16.
	 */
	function mapStateToProps(state) {
	  return {
	    locale: state.i18n.locale
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(_workDatePicker2.default);

/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WorkDatePicker = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _reactNumericInput = __webpack_require__(621);
	
	var _reactNumericInput2 = _interopRequireDefault(_reactNumericInput);
	
	var _workDateRow = __webpack_require__(950);
	
	var _workDateRow2 = _interopRequireDefault(_workDateRow);
	
	var _workDateHelper = __webpack_require__(227);
	
	var _workDateHelper2 = _interopRequireDefault(_workDateHelper);
	
	var _reactDayPicker = __webpack_require__(1386);
	
	var _reactDayPicker2 = _interopRequireDefault(_reactDayPicker);
	
	var _moment = __webpack_require__(1393);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _moment3 = __webpack_require__(8);
	
	var _moment4 = _interopRequireDefault(_moment3);
	
	var _momentRange = __webpack_require__(1344);
	
	var _momentRange2 = _interopRequireDefault(_momentRange);
	
	var _dateformat = __webpack_require__(1280);
	
	var _dateformat2 = _interopRequireDefault(_dateformat);
	
	__webpack_require__(191);
	
	__webpack_require__(190);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import 'react-day-picker/lib/style.css';
	
	/*eslint-disable */
	var Weekday = function Weekday(_ref) {
	  var weekday = _ref.weekday,
	      className = _ref.className,
	      localeUtils = _ref.localeUtils,
	      locale = _ref.locale;
	
	  var weekdayName = localeUtils.formatWeekdayLong(weekday, locale);
	
	  return _react2.default.createElement(
	    'div',
	    { className: className, title: weekdayName },
	    weekdayName.slice(0, 1)
	  );
	};
	/*eslint-enable */
	
	var _ref2 = _react2.default.createElement(Weekday, null);
	
	var _ref3 = _react2.default.createElement(
	  'p',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'WORKED_HOURS' })
	);
	
	var _ref4 = _react2.default.createElement('hr', null);
	
	var _ref5 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'TOTAL_NR_OF_WORKHOURS' });
	
	var WorkDatePicker = exports.WorkDatePicker = function (_React$Component) {
	  (0, _inherits3.default)(WorkDatePicker, _React$Component);
	
	  function WorkDatePicker(props) {
	    (0, _classCallCheck3.default)(this, WorkDatePicker);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (WorkDatePicker.__proto__ || (0, _getPrototypeOf2.default)(WorkDatePicker)).call(this, props));
	
	    _this.selectDate = _this.selectDate.bind(_this);
	    _this.getDateString = _this.getDateString.bind(_this);
	    _this.addDates = _this.addDates.bind(_this);
	    _this.workHoursChange = _this.workHoursChange.bind(_this);
	    _this.selected = _this.selected.bind(_this);
	    _this.disabled = _this.disabled.bind(_this);
	    _this.handleWeekClicked = _this.handleWeekClicked.bind(_this);
	
	    var dayPickerLocale = void 0;
	
	    switch (_this.props.locale) {
	      case 'se':
	        dayPickerLocale = 'sv';
	        break;
	      default:
	        dayPickerLocale = 'en-gb';
	        break;
	    }
	
	    _this.state = {
	      from: null,
	      to: null,
	      workDates: _this.props.workDates,
	      workHours: 7.5,
	      selectedDays: [],
	      currentSelectedDays: {},
	      saveButtonStyle: { opacity: 1, pointerEvents: 'auto' },
	      dayPickerLocale: dayPickerLocale,
	      totalWorkHours: _this.props.totalWorkHours
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(WorkDatePicker, [{
	    key: 'addRange',
	    value: function addRange(range) {
	      this.setState({
	        currentSelectedDays: {
	          startDateString: this.getDateString(range.from),
	          startDate: range.from,
	          endDate: range.to || range.from
	        }
	      }, this.addDates);
	    }
	  }, {
	    key: 'addDate',
	    value: function addDate(day) {
	      var range = _reactDayPicker.DateUtils.addDayToRange(day, this.state);
	      this.addRange(range);
	    }
	  }, {
	    key: 'removeDate',
	    value: function removeDate(day) {
	      var _this2 = this;
	
	      var formattedDay = (0, _moment4.default)(day).format('YYYYMMDD');
	      this.props.selectedDays.forEach(function (selectedDay) {
	        if (selectedDay.startDateString === formattedDay) {
	          _this2.props.removeDays([selectedDay]);
	        }
	      });
	    }
	  }, {
	    key: 'selectDate',
	    value: function selectDate(day) {
	      if (this.selected(day)) {
	        return this.removeDate(day);
	      }
	      this.addDate(day);
	    }
	  }, {
	    key: 'toggleWeek',
	    value: function toggleWeek(days) {
	      var _this3 = this;
	
	      var currentMonth = this.getCurrentMonth();
	      var weekdays = days.slice(0, 5).filter(function (day) {
	        return day.getMonth() === currentMonth;
	      });
	      var selected = weekdays.filter(function (day) {
	        return _this3.getDate(day);
	      });
	      if (selected.length === weekdays.length) {
	        return this.removeWeek(weekdays);
	      }
	
	      this.addWeek(weekdays);
	    }
	  }, {
	    key: 'getDate',
	    value: function getDate(day) {
	      return this.props.selectedDays.filter(function (selectedDay) {
	        return day.toDateString() === selectedDay.startDate.toDateString();
	      }).shift();
	    }
	  }, {
	    key: 'getCurrentMonth',
	    value: function getCurrentMonth() {
	      // Sorry, showMonth not working
	      return this.refs.daypicker.state.currentMonth.getMonth();
	    }
	  }, {
	    key: 'addDates',
	    value: function addDates() {
	      var _this4 = this;
	
	      var days = this.getDates(this.state.currentSelectedDays.startDate, this.state.currentSelectedDays.endDate);
	      var selectedDays = [];
	      days.forEach(function (day) {
	        if (_this4.selected(day)) {
	          return;
	        }
	        _this4.props.selectDays({
	          startDateString: _this4.getDateString(day),
	          startDate: day,
	          endDate: day,
	          workHours: _this4.state.workHours,
	          displayDate: _workDateHelper2.default.formatDisplayDate(day, day)
	        });
	      });
	      this.setState({
	        selectedDays: this.state.selectedDays.concat(selectedDays)
	      });
	    }
	  }, {
	    key: 'getDates',
	    value: function getDates(startDate, endDate) {
	      // https://gist.github.com/miguelmota/7905510
	      var dates = [];
	      var currentDate = startDate;
	      var addDays = function addDays(days) {
	        var date = new Date(this.valueOf());
	        date.setDate(date.getDate() + days);
	        return date;
	      };
	
	      while (currentDate <= endDate) {
	        dates.push(currentDate);
	        currentDate = addDays.call(currentDate, 1);
	      }
	
	      return dates;
	    }
	  }, {
	    key: 'addWeek',
	    value: function addWeek(days) {
	      var range = _reactDayPicker.DateUtils.addDayToRange(days[0], this.state);
	      range = _reactDayPicker.DateUtils.addDayToRange(days[days.length - 1], range);
	      this.addRange(range);
	    }
	  }, {
	    key: 'removeWeek',
	    value: function removeWeek(days) {
	      var _this5 = this;
	
	      var remove = [];
	      days.forEach(function (day) {
	        return remove.push(_this5.getDate(day));
	      });
	      this.props.removeDays(remove);
	    }
	  }, {
	    key: 'getDateString',
	    value: function getDateString(date) {
	      return (0, _dateformat2.default)(date, 'yyyymmdd');
	    }
	    // Change standard workHours
	
	  }, {
	    key: 'workHoursChange',
	    value: function workHoursChange(workHours) {
	      if (workHours < 0.01) workHours = 0.01;
	      if (workHours > 24.00) workHours = 24.00;
	      this.setState({
	        workHours: workHours
	      });
	    }
	  }, {
	    key: 'selected',
	    value: function selected(day) {
	      for (var i = 0; i < this.props.selectedDays.length; i++) {
	        var startDate = this.props.selectedDays[i].startDate;
	        var endDate = (0, _moment4.default)(this.props.selectedDays[i].endDate).toDate();
	        endDate.setHours(12);
	        var thisRange = _moment4.default.range(startDate, endDate);
	        if (thisRange.contains(day)) {
	          return true;
	        }
	      }
	    }
	  }, {
	    key: 'disabled',
	    value: function disabled(day) {
	      for (var i = 0; i < this.state.selectedDays.length; i++) {
	        var startDate = this.state.selectedDays[i].startDate;
	        var endDate = (0, _moment4.default)(this.state.selectedDays[i].endDate).toDate();
	        endDate.setHours(12);
	        var thisRange = _moment4.default.range(startDate, endDate);
	        if (thisRange.contains(day)) {
	          return true;
	        }
	      }
	      return false;
	    }
	  }, {
	    key: 'handleWeekClicked',
	    value: function handleWeekClicked(week, days) {
	      this.toggleWeek(days);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var selected = this.selected;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'work-date-picker-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'work-date-picker' },
	            _react2.default.createElement(
	              'div',
	              { className: 'work-date-calendar' },
	              _react2.default.createElement(_reactDayPicker2.default, {
	                ref: 'daypicker',
	                numberOfMonths: 1,
	                modifiers: { selected: selected },
	                onDayClick: this.selectDate,
	                localeUtils: _moment2.default,
	                locale: this.state.dayPickerLocale,
	                pagedNavigation: true,
	                showWeekNumbers: true,
	                onWeekClick: this.handleWeekClicked,
	                weekdayElement: _ref2
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'work-date-details' },
	              _ref3,
	              _react2.default.createElement(_reactNumericInput2.default, {
	                snap: true,
	                min: 0.01,
	                step: 0.5,
	                max: 24,
	                precision: 2,
	                className: 'work-date-numeric-stepper',
	                value: this.state.workHours,
	                onChange: this.workHoursChange
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'day-list-wrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'day-list-container' },
	              _react2.default.createElement(
	                'ul',
	                { className: 'day-list' },
	                this.props.selectedDays.map(function (dateObj, i) {
	                  return _react2.default.createElement(_workDateRow2.default, {
	                    rowData: dateObj,
	                    removeDays: this.props.removeDays,
	                    editWorkHours: this.props.editWorkHours,
	                    key: i,
	                    daysIndex: i,
	                    day: dateObj
	                  });
	                }, this)
	              )
	            )
	          )
	        ),
	        _ref4,
	        _react2.default.createElement(
	          'div',
	          { className: 'work-date-total-hours-buttons' },
	          _react2.default.createElement(
	            'p',
	            null,
	            _ref5,
	            ': ',
	            this.props.totalWorkHours
	          )
	        )
	      );
	    }
	  }]);
	  return WorkDatePicker;
	}(_react2.default.Component);
	
	exports.default = WorkDatePicker;

/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WorkDateRemoveDayButton = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WorkDateRemoveDayButton = exports.WorkDateRemoveDayButton = function (_React$Component) {
	  (0, _inherits3.default)(WorkDateRemoveDayButton, _React$Component);
	
	  function WorkDateRemoveDayButton(props) {
	    (0, _classCallCheck3.default)(this, WorkDateRemoveDayButton);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (WorkDateRemoveDayButton.__proto__ || (0, _getPrototypeOf2.default)(WorkDateRemoveDayButton)).call(this, props));
	
	    _this.removeDays = _this.removeDays.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(WorkDateRemoveDayButton, [{
	    key: 'removeDays',
	    value: function removeDays(event) {
	      this.props.removeDays([this.props.day]);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('button', { onClick: this.removeDays, className: 'close' });
	    }
	  }]);
	  return WorkDateRemoveDayButton;
	}(_react2.default.Component); /**
	                               * Created by eriksundqvist on 01/07/16.
	                               */
	
	
	exports.default = WorkDateRemoveDayButton;

/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WorkDateRow = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactNumericInput = __webpack_require__(621);
	
	var _reactNumericInput2 = _interopRequireDefault(_reactNumericInput);
	
	var _workDateRemoveDayButton = __webpack_require__(949);
	
	var _workDateRemoveDayButton2 = _interopRequireDefault(_workDateRemoveDayButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WorkDateRow = exports.WorkDateRow = function (_React$Component) {
	  (0, _inherits3.default)(WorkDateRow, _React$Component);
	
	  function WorkDateRow(props) {
	    (0, _classCallCheck3.default)(this, WorkDateRow);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (WorkDateRow.__proto__ || (0, _getPrototypeOf2.default)(WorkDateRow)).call(this, props));
	
	    _this.state = {
	      workHours: _this.props.rowData.workHours
	    };
	
	    _this.editWorkHours = _this.editWorkHours.bind(_this);
	    _this.getSelectHoursOptions = _this.getSelectHoursOptions.bind(_this);
	    _this.editWorkHoursSelect = _this.editWorkHoursSelect.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(WorkDateRow, [{
	    key: 'editWorkHours',
	    value: function editWorkHours(workHours) {
	      this.setState({
	        workHours: workHours
	      });
	      this.props.editWorkHours(this.props.daysIndex, workHours);
	    }
	  }, {
	    key: 'editWorkHoursSelect',
	    value: function editWorkHoursSelect() {
	      this.editWorkHours(this.refs.workHoursSelect.value);
	    }
	  }, {
	    key: 'getSelectHoursOptions',
	    value: function getSelectHoursOptions() {
	      var options = [];
	      for (var i = 0.5; i <= 24; i = i + 0.5) {
	        options.push(_react2.default.createElement(
	          'option',
	          { value: i, key: i },
	          i
	        ));
	      }
	      return options;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(_workDateRemoveDayButton2.default, {
	          daysIndex: this.props.daysIndex,
	          day: this.props.day,
	          removeDays: this.props.removeDays
	        }),
	        _react2.default.createElement(
	          'p',
	          null,
	          this.props.rowData.displayDate
	        ),
	        _react2.default.createElement(_reactNumericInput2.default, {
	          min: 0.01,
	          step: 0.25,
	          max: 24,
	          precision: 2,
	          value: this.props.rowData.workHours,
	          onChange: this.editWorkHours
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'select-btn-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'styled-select' },
	            _react2.default.createElement(
	              'select',
	              { value: this.props.rowData.workHours, onChange: this.editWorkHoursSelect, ref: 'workHoursSelect' },
	              this.getSelectHoursOptions()
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return WorkDateRow;
	}(_react2.default.Component); /**
	                               * Created by eriksundqvist on 04/07/16.
	                               */
	
	
	exports.default = WorkDateRow;

/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WorkDate = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _workDatePickerContainer = __webpack_require__(947);
	
	var _workDatePickerContainer2 = _interopRequireDefault(_workDatePickerContainer);
	
	var _workDateHelper = __webpack_require__(227);
	
	var _workDateHelper2 = _interopRequireDefault(_workDateHelper);
	
	var _components = __webpack_require__(13);
	
	var _invoiceValidator = __webpack_require__(91);
	
	var _invoiceValidator2 = _interopRequireDefault(_invoiceValidator);
	
	var _invoiceToolHelper = __webpack_require__(50);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _lodash = __webpack_require__(40);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	__webpack_require__(191);
	
	__webpack_require__(190);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'p',
	  { className: 'error' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_ERROR_INVOICEDATE' })
	);
	
	var _ref2 = _react2.default.createElement(
	  'p',
	  { className: 'error' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_ERROR_INVOICEDATE_MAX_HOURS' })
	);
	
	var _ref3 = _react2.default.createElement(
	  'p',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SHOW_DATE' })
	);
	
	var _ref4 = _react2.default.createElement(
	  'label',
	  { htmlFor: 'show-date-alt-1' },
	  _react2.default.createElement('span', null),
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'YES' })
	);
	
	var _ref5 = _react2.default.createElement(
	  'label',
	  { htmlFor: 'show-date-alt-2' },
	  _react2.default.createElement('span', null),
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'NO' })
	);
	
	var _ref6 = _react2.default.createElement(
	  'p',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOCETOOL_SHOW_HOURS' })
	);
	
	var _ref7 = _react2.default.createElement(
	  'label',
	  { htmlFor: 'show-hour-alt-1' },
	  _react2.default.createElement('span', null),
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'YES' })
	);
	
	var _ref8 = _react2.default.createElement(
	  'label',
	  { htmlFor: 'show-hour-alt-2' },
	  _react2.default.createElement('span', null),
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'NO' })
	);
	
	var _ref9 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'WORKED_TIME' });
	
	var _ref10 = _react2.default.createElement(
	  'b',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, {
	    content: 'WORK_DATE_TEXT_LINK'
	  })
	);
	
	var WorkDate = exports.WorkDate = function (_React$Component) {
	  (0, _inherits3.default)(WorkDate, _React$Component);
	
	  function WorkDate(props) {
	    (0, _classCallCheck3.default)(this, WorkDate);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (WorkDate.__proto__ || (0, _getPrototypeOf2.default)(WorkDate)).call(this, props));
	
	    _this.state = {
	      workDates: [],
	      workDatesWithFutureDates: [],
	      selectedDays: [],
	      displayDates: 0,
	      displayHours: 0,
	      renderConfirmModal: false,
	      renderExceededWorkingHoursModal: false,
	      acceptedExceededWorkingHours: false,
	      futureWorkDateMessageShown: false,
	      totalWorkHours: '0',
	      readMoreHoursModalOpen: false
	    };
	
	    _this.onChangeShowDate = _this.onChangeShowDate.bind(_this);
	    _this.onChangeShowHour = _this.onChangeShowHour.bind(_this);
	    _this.openModal = _this.openModal.bind(_this);
	    _this.saveWorkDates = _this.saveWorkDates.bind(_this);
	    _this.renderWorkDate = _this.renderWorkDate.bind(_this);
	    _this.onCloseConfirmModal = _this.onCloseConfirmModal.bind(_this);
	    _this.onCloseExceededWorkingHoursModal = _this.onCloseExceededWorkingHoursModal.bind(_this);
	    _this.openConfirmModal = _this.openConfirmModal.bind(_this);
	    _this.renderConfirmModal = _this.renderConfirmModal.bind(_this);
	    _this.renderExceededWorkingHoursModal = _this.renderExceededWorkingHoursModal.bind(_this);
	    _this.selectDays = _this.selectDays.bind(_this);
	    _this.removeDays = _this.removeDays.bind(_this);
	    _this.editWorkHours = _this.editWorkHours.bind(_this);
	    _this.toggleReadMoreHoursModal = _this.toggleReadMoreHoursModal.bind(_this);
	    _this.renderReadMoreHoursModal = _this.renderReadMoreHoursModal.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(WorkDate, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      var selectedDays = _workDateHelper2.default.parseWorkDates(props.invoiceDate);
	
	      this.setState({
	        workDates: props.invoiceDate,
	        displayDates: props.displayDates,
	        displayHours: props.displayHours,
	        selectedDays: selectedDays,
	        renderExceededWorkingHoursModal: this.props.registerAssignmentTool ? (0, _invoiceToolHelper.hasExceededWorkingHours)(selectedDays) : false
	      }, this.getTotalWorkHours());
	    }
	  }, {
	    key: 'onChangeShowDate',
	    value: function onChangeShowDate(e) {
	      var displayDates = parseInt(e.currentTarget.value);
	      /**
	      * We are not allowed to display hours if we don't display dates
	      */
	      if (displayDates === 0) {
	        this.props.setDisplayHours(0);
	      }
	      this.props.setDisplayDates(displayDates);
	    }
	  }, {
	    key: 'onChangeShowHour',
	    value: function onChangeShowHour(e) {
	      this.props.setDisplayHours(parseInt(e.currentTarget.value));
	    }
	  }, {
	    key: 'openModal',
	    value: function openModal(e) {
	      e.preventDefault();
	    }
	  }, {
	    key: 'openConfirmModal',
	    value: function openConfirmModal() {
	      this.setState({
	        renderConfirmModal: true
	      });
	    }
	  }, {
	    key: 'onCloseConfirmModal',
	    value: function onCloseConfirmModal(responsValue) {
	      if (responsValue) {
	        this.doSaveWorkDates(this.state.workDatesWithFutureDates);
	      } else {
	        this.removeDays(this.state.workDatesWithFutureDates);
	      }
	      this.setState({
	        renderConfirmModal: false
	      });
	    }
	  }, {
	    key: 'onCloseExceededWorkingHoursModal',
	    value: function onCloseExceededWorkingHoursModal() {
	      this.setState({
	        renderExceededWorkingHoursModal: false,
	        acceptedExceededWorkingHours: true
	      });
	    }
	  }, {
	    key: 'selectDays',
	    value: function selectDays(selectedDay) {
	      this.state.selectedDays.push(selectedDay);
	      this.doSaveWorkDates();
	      this.getTotalWorkHours();
	    }
	  }, {
	    key: 'removeDays',
	    value: function removeDays(days) {
	      var _this2 = this;
	
	      days.forEach(function (day) {
	        if (!day.displayDate) {
	          day.displayDate = day.date;
	        }
	        var dayIndex = _this2.state.selectedDays.findIndex(function (sday) {
	          return sday.displayDate === day.displayDate;
	        });
	
	        if (dayIndex !== -1) {
	          _this2.state.selectedDays.splice(dayIndex, 1);
	        }
	      });
	
	      this.doSaveWorkDates();
	      this.getTotalWorkHours();
	    }
	  }, {
	    key: 'editWorkHours',
	    value: function editWorkHours(daysIndex, workHours) {
	      var selectedDays = this.state.selectedDays;
	      if (workHours < 0.01) workHours = 0.01;
	      if (workHours > 24.00) workHours = 24.00;
	      selectedDays[daysIndex].workHours = workHours;
	      this.setState({
	        selectedDays: selectedDays
	      }, this.doSaveWorkDates());
	    }
	  }, {
	    key: 'getTotalWorkHours',
	    value: function getTotalWorkHours() {
	      if (this.state !== null) {
	        var workHours = 0;
	        for (var i = 0; i < this.state.selectedDays.length; i++) {
	          var startDate = (0, _moment2.default)(this.state.selectedDays[i].startDate);
	          var endDate = (0, _moment2.default)(this.state.selectedDays[i].endDate);
	          workHours += (endDate.diff(startDate, 'days') + 1) * this.state.selectedDays[i].workHours;
	        }
	        this.setState({
	          totalWorkHours: workHours.toFixed(2)
	        });
	      }
	    }
	  }, {
	    key: 'doSaveWorkDates',
	    value: function doSaveWorkDates() {
	      var _this3 = this;
	
	      var extraDays = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      var workDates = [];
	      this.state.selectedDays.forEach(function (selectedDay) {
	        var startDate = (0, _moment2.default)(selectedDay.startDate);
	        workDates.push({
	          'hours': selectedDay.workHours,
	          'date': startDate.format('YYYY-MM-DD')
	        });
	      });
	
	      workDates = _lodash2.default.orderBy(workDates, 'date', 'asc');
	
	      if (extraDays.length > 1) {
	        extraDays.forEach(function (extraDay) {
	          if (!workDates.find(function (workDate) {
	            return workDate.date === extraDay.date;
	          })) {
	            workDates.push(extraDay);
	            _this3.state.selectedDays.push(extraDay);
	          }
	        });
	      }
	      this.saveWorkDates(workDates);
	    }
	  }, {
	    key: 'saveWorkDates',
	    value: function saveWorkDates(workDates) {
	      if (this.checkForFutureDates(workDates) && !this.state.futureWorkDateMessageShown && !this.props.registerAssignmentTool) {
	        this.openConfirmModal();
	      } else {
	        this.setState({
	          workDates: workDates
	        });
	        this.props.setInvoiceDate(workDates);
	      }
	    }
	  }, {
	    key: 'checkForFutureDates',
	    value: function checkForFutureDates(workDates) {
	      var futureWorkDates = [];
	      workDates.forEach(function (day) {
	        if ((0, _moment2.default)().isBefore(day.date)) {
	          futureWorkDates.push(day);
	        }
	      });
	      if (futureWorkDates.length) {
	        this.setState({
	          workDatesWithFutureDates: futureWorkDates,
	          futureWorkDateMessageShown: true
	        });
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'renderError',
	    value: function renderError() {
	      if (this.props.submitted && !_invoiceValidator2.default.validateInvoiceDate(this.props.invoiceDate)) {
	        return _ref;
	      }
	      if (this.props.submitted && !_invoiceValidator2.default.validateMaxHours(this.props.invoiceDate)) {
	        return _ref2;
	      }
	    }
	  }, {
	    key: 'renderConfirmModal',
	    value: function renderConfirmModal() {
	      if (this.state.renderConfirmModal) {
	        return _react2.default.createElement(_components.ConfirmModal, {
	          callback: this.onCloseConfirmModal,
	          message: (0, _proxyCounterpart.proxyCounterpart)('FUTURE_WORK_DATE'),
	          confirmButtonProps: { className: 'btn outlined white' },
	          confirmButtonText: (0, _proxyCounterpart.proxyCounterpart)('ACCEPT_FUTURE_DATES'),
	          rejectButtonProps: { className: 'btn' },
	          rejectButtonText: (0, _proxyCounterpart.proxyCounterpart)('BACK'),
	          reversedButtonOrder: true
	        });
	      }
	    }
	  }, {
	    key: 'renderExceededWorkingHoursModal',
	    value: function renderExceededWorkingHoursModal() {
	      if (this.state.renderExceededWorkingHoursModal && !this.state.acceptedExceededWorkingHours) {
	        return _react2.default.createElement(_components.ExceededWorkingHoursModal, {
	          callback: this.onCloseExceededWorkingHoursModal
	        });
	      }
	    }
	  }, {
	    key: 'renderDatePickerContainer',
	    value: function renderDatePickerContainer() {
	      return _react2.default.createElement(_workDatePickerContainer2.default, {
	        workDates: this.state.workDates,
	        saveWorkDates: this.saveWorkDates,
	        selectedDays: this.state.selectedDays,
	        selectDays: this.selectDays,
	        removeDays: this.removeDays,
	        editWorkHours: this.editWorkHours,
	        totalWorkHours: this.state.totalWorkHours
	      });
	    }
	  }, {
	    key: 'renderActions',
	    value: function renderActions() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'show-date-hours-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'show-date-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'radio-btn-wrapper' },
	            _ref3,
	            _react2.default.createElement(
	              'div',
	              { className: 'show-date-input' },
	              _react2.default.createElement('input', { id: 'show-date-alt-1', type: 'radio', name: 'show-date', value: 1,
	                checked: this.props.displayDates === 1,
	                onChange: this.onChangeShowDate }),
	              _ref4,
	              _react2.default.createElement('input', { id: 'show-date-alt-2', type: 'radio', name: 'show-date', value: 0,
	                checked: this.props.displayDates === 0,
	                onChange: this.onChangeShowDate }),
	              _ref5
	            )
	          ),
	          _react2.default.createElement(
	            _components.ToggleDisplay,
	            { show: this.props.displayDates === 1 },
	            _react2.default.createElement(
	              'div',
	              { className: 'radio-btn-wrapper' },
	              _ref6,
	              _react2.default.createElement(
	                'div',
	                { className: 'show-date-input' },
	                _react2.default.createElement('input', { id: 'show-hour-alt-1', type: 'radio', name: 'show-hour', value: 1,
	                  checked: this.props.displayHours === 1,
	                  onChange: this.onChangeShowHour }),
	                _ref7,
	                _react2.default.createElement('input', { id: 'show-hour-alt-2', type: 'radio', name: 'show-hour', value: 0,
	                  checked: this.props.displayHours === 0,
	                  onChange: this.onChangeShowHour }),
	                _ref8
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderWorkDate',
	    value: function renderWorkDate(item, i) {
	      return _react2.default.createElement(
	        'tr',
	        { key: i },
	        _react2.default.createElement(
	          'td',
	          null,
	          item.displayDate
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          item.totalHoursForPeriod
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement('i', { className: 'pen-link customer-link', onClick: this.openModal })
	        )
	      );
	    }
	  }, {
	    key: 'toggleReadMoreHoursModal',
	    value: function toggleReadMoreHoursModal() {
	      this.setState({
	        readMoreHoursModalOpen: !this.state.readMoreHoursModalOpen
	      });
	    }
	  }, {
	    key: 'renderReadMoreHoursModal',
	    value: function renderReadMoreHoursModal() {
	      if (this.state.readMoreHoursModalOpen) {
	        return _react2.default.createElement(_components.CloseModal, {
	          headline: (0, _proxyCounterpart.proxyCounterpart)('WORKING_HOURS_INFO_MODAL_TITLE'),
	          body: (0, _proxyCounterpart.proxyCounterpart)('WORKING_HOURS_INFO_MODAL_BODY'),
	          close: this.toggleReadMoreHoursModal
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'work-date' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          _ref9,
	          _react2.default.createElement(_components.ToolTip, { id: 'workdate_hours-info', msg: (0, _proxyCounterpart.proxyCounterpart)('WORKDATE_HOURS_INFO') })
	        ),
	        _react2.default.createElement(_reactTranslateComponent2.default, {
	          content: 'WORK_DATE_TEXT',
	          readMoreLink: _react2.default.createElement(
	            'a',
	            { onClick: this.toggleReadMoreHoursModal },
	            _ref10
	          )
	        }),
	        this.renderDatePickerContainer(),
	        this.renderActions(),
	        this.renderError(),
	        this.renderConfirmModal(),
	        this.renderExceededWorkingHoursModal(),
	        this.renderReadMoreHoursModal()
	      );
	    }
	  }]);
	  return WorkDate;
	}(_react2.default.Component);
	
	exports.default = WorkDate;

/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(12);
	
	var _workDetails = __webpack_require__(953);
	
	var _workDetails2 = _interopRequireDefault(_workDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by eriksundqvist on 25/05/16.
	 */
	function mapStateToProps(state) {
	  return {
	    user: state.user,
	    customer: state.invoice.customerEntity
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(_workDetails2.default);

/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WorkDetails = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _pickCustomerContainer = __webpack_require__(907);
	
	var _pickCustomerContainer2 = _interopRequireDefault(_pickCustomerContainer);
	
	var _workDateContainer = __webpack_require__(946);
	
	var _workDateContainer2 = _interopRequireDefault(_workDateContainer);
	
	var _hsdContainer = __webpack_require__(932);
	
	var _hsdContainer2 = _interopRequireDefault(_hsdContainer);
	
	var _specificationContainer = __webpack_require__(943);
	
	var _specificationContainer2 = _interopRequireDefault(_specificationContainer);
	
	var _amountContainer = __webpack_require__(898);
	
	var _amountContainer2 = _interopRequireDefault(_amountContainer);
	
	var _components = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'section-padding' },
	  _react2.default.createElement(
	    'div',
	    { className: 'col-sm-12' },
	    _react2.default.createElement(
	      'h3',
	      { className: 'form-header' },
	      _react2.default.createElement(
	        'span',
	        null,
	        '2'
	      ),
	      ' ',
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'INVOICE_SPEC' })
	    )
	  )
	);
	
	var _ref2 = _react2.default.createElement(_amountContainer2.default, null);
	
	var WorkDetails = exports.WorkDetails = function (_React$Component) {
	  (0, _inherits3.default)(WorkDetails, _React$Component);
	
	  function WorkDetails() {
	    (0, _classCallCheck3.default)(this, WorkDetails);
	    return (0, _possibleConstructorReturn3.default)(this, (WorkDetails.__proto__ || (0, _getPrototypeOf2.default)(WorkDetails)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(WorkDetails, [{
	    key: 'render',
	    value: function render() {
	      var countryAllowHsd = !this.props.customer || this.props.customer.address.country === 'SWEDEN';
	      var workDateClasses = this.props.user.displayHsd && countryAllowHsd ? 'work-details-col-wrapper work-details-rutrot-margin' : 'work-details-col-wrapper';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'tool-wrapper' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          _react2.default.createElement(_reactTranslateComponent2.default, { content: this.props.translationPrefix + 'INVOICE_TOOL' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'tool-content container' },
	          _react2.default.createElement(_pickCustomerContainer2.default, {
	            translationPrefix: this.props.translationPrefix
	          }),
	          _ref,
	          _react2.default.createElement(
	            'div',
	            { className: 'workdate-hsd' },
	            _react2.default.createElement(
	              'div',
	              { className: workDateClasses },
	              _react2.default.createElement(
	                'div',
	                { className: 'white-box' },
	                _react2.default.createElement(_workDateContainer2.default, {
	                  registerAssignmentTool: this.props.registerAssignmentTool,
	                  translationPrefix: this.props.translationPrefix
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _components.ToggleDisplay,
	              { show: countryAllowHsd },
	              _react2.default.createElement(
	                _components.ToggleDisplay,
	                { show: this.props.user.displayHsd },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'work-details-col-wrapper col-xs-4' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'white-box' },
	                    _react2.default.createElement(_hsdContainer2.default, {
	                      translationPrefix: this.props.translationPrefix
	                    })
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'work-details-col-wrapper col-xs-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'white-box' },
	              _react2.default.createElement(_specificationContainer2.default, {
	                translationPrefix: this.props.translationPrefix
	              })
	            )
	          ),
	          _ref2
	        )
	      );
	    }
	  }]);
	  return WorkDetails;
	}(_react2.default.Component);
	
	exports.default = WorkDetails;

/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _components = __webpack_require__(13);
	
	var _authentication = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 16/11/16.
	 */
	
	var _ref = _react2.default.createElement(
	  'p',
	  { className: 'error' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'LOGIN_FAILED' })
	);
	
	var _ref2 = _react2.default.createElement(_components.Spinner, null);
	
	var TokenLogin = function (_React$Component) {
	  (0, _inherits3.default)(TokenLogin, _React$Component);
	
	  function TokenLogin(props) {
	    (0, _classCallCheck3.default)(this, TokenLogin);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (TokenLogin.__proto__ || (0, _getPrototypeOf2.default)(TokenLogin)).call(this, props));
	
	    _this.state = {
	      loggingIn: true,
	      loginFailed: false
	    };
	
	    _this.handleSuccess = _this.handleSuccess.bind(_this);
	    _this.handleReject = _this.handleReject.bind(_this);
	    _this.goToLogin = _this.goToLogin.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(TokenLogin, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var linkLoginToken = this.props.params.token;
	
	      if (linkLoginToken) {
	        _authentication.authenticationService.logoutWithoutRedirect();
	        this.login(linkLoginToken);
	      } else {
	        this.context.router.push('login');
	      }
	    }
	  }, {
	    key: 'login',
	    value: function login(linkLoginToken) {
	      var _this2 = this;
	
	      _authentication.authenticationService.linkLogin(linkLoginToken).then(function (response) {
	        return _this2.handleSuccess(response);
	      }).catch(function () {
	        return _this2.handleReject();
	      });
	    }
	  }, {
	    key: 'handleSuccess',
	    value: function handleSuccess(response) {
	      if (response.status === 404) {
	        this.handleReject();
	        return false;
	      }
	      this.context.router.push('login');
	    }
	  }, {
	    key: 'handleReject',
	    value: function handleReject() {
	      _authentication.authenticationService.logoutWithoutRedirect();
	
	      this.setState({
	        loggingIn: false,
	        loginFailed: true
	      });
	    }
	  }, {
	    key: 'goToLogin',
	    value: function goToLogin() {
	      this.context.router.push('login');
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      if (this.state.loginFailed) {
	        return _ref;
	      }
	      if (this.state.loggingIn) {
	        return _ref2;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'link-login' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container link-login-container' },
	          this.renderContent()
	        )
	      );
	    }
	  }]);
	  return TokenLogin;
	}(_react2.default.Component);
	
	TokenLogin.contextTypes = {
	  router: _react.PropTypes.object.isRequired
	};
	exports.default = TokenLogin;

/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LoginView = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _components = __webpack_require__(13);
	
	var _authentication = __webpack_require__(64);
	
	var _reactRouter = __webpack_require__(20);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _loginBottomElement = __webpack_require__(165);
	
	var _loginBottomElement2 = _interopRequireDefault(_loginBottomElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'login-row-container' },
	  _react2.default.createElement(
	    'div',
	    { className: 'login-row-child' },
	    _react2.default.createElement(
	      _reactRouter.Link,
	      { to: 'forgot-password' },
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'FORGOT_PASSWORD' }),
	      '?'
	    )
	  )
	);
	
	var LoginView = exports.LoginView = function (_Component) {
	  (0, _inherits3.default)(LoginView, _Component);
	
	  function LoginView(props) {
	    (0, _classCallCheck3.default)(this, LoginView);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (LoginView.__proto__ || (0, _getPrototypeOf2.default)(LoginView)).call(this, props));
	
	    var defaultEmail = '';
	    var defaultPassword = '';
	
	    if (false) {
	      defaultEmail = process.env.DEV_LOGIN_EMAIL;
	      defaultPassword = process.env.DEV_LOGIN_PASSWORD;
	    }
	
	    _this.state = {
	      email: defaultEmail,
	      password: defaultPassword,
	
	      loading: false,
	      errorMessage: false,
	      successMessage: false,
	      remember: false
	    };
	
	    _this.handleChangeEmail = _this.handleChangeEmail.bind(_this);
	    _this.handleChangePassword = _this.handleChangePassword.bind(_this);
	    _this.submitForm = _this.submitForm.bind(_this);
	    _this.toggleRemember = _this.toggleRemember.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(LoginView, [{
	    key: 'handleChangeEmail',
	    value: function handleChangeEmail(event) {
	      this.setState({ email: event.target.value });
	    }
	  }, {
	    key: 'handleChangePassword',
	    value: function handleChangePassword(event) {
	      this.setState({ password: event.target.value });
	    }
	  }, {
	    key: 'removeSpaces',
	    value: function removeSpaces(str) {
	      return str.replace(/\s/g, '');
	    }
	  }, {
	    key: 'submitForm',
	    value: function submitForm(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	
	      this.setState({
	        loading: true,
	        errorMessage: false,
	        successMessage: false
	      });
	
	      _authentication.authenticationService.sendMagicLoginLink(this.removeSpaces(this.state.email), this.state.password).then(function (response) {
	        if (response.status) {
	          if (response.status === 201) {
	            _this2.setState({
	              loading: false,
	              successMessage: (0, _proxyCounterpart.proxyCounterpart)('LOGIN_LINK_SENT_CHECK_YOUR_EMAIL')
	            });
	            return;
	          }
	          var langCode = 'GENERAL_ERROR';
	          if (response.status === 403) {
	            langCode = 'LOGIN_403_ERROR';
	          }
	          if (response.status === 422) {
	            langCode = 'LOGIN_ERROR';
	          }
	          _this2.setState({
	            loading: false,
	            errorMessage: (0, _proxyCounterpart.proxyCounterpart)(langCode)
	          });
	          return;
	        }
	      }).catch(function (error) {
	        var langCode = 'GENERAL_ERROR';
	
	        if (error.status === 400) {
	          langCode = 'LOGIN_ERROR';
	        }
	
	        if (error.status === 403) {
	          langCode = 'LOGIN_403_ERROR';
	        }
	
	        _this2.setState({
	          loading: false,
	          errorMessage: (0, _proxyCounterpart.proxyCounterpart)(langCode)
	        });
	      });
	    }
	  }, {
	    key: 'toggleRemember',
	    value: function toggleRemember() {
	      this.setState({
	        remember: !this.state.remember
	      });
	    }
	  }, {
	    key: 'renderForm',
	    value: function renderForm() {
	      if (!this.state.successMessage) {
	        return _react2.default.createElement(
	          'form',
	          { action: '', method: 'POST', id: 'login-form' },
	          _react2.default.createElement(
	            'div',
	            { className: 'login-input-container' },
	            _react2.default.createElement('input', {
	              type: 'text',
	              name: 'email',
	              className: 'no-margin',
	              placeholder: (0, _proxyCounterpart.proxyCounterpart)('EMAIL'),
	              value: this.state.email,
	              onChange: this.handleChangeEmail,
	              autoCorrect: 'off',
	              autoComplete: 'off'
	            }),
	            _react2.default.createElement('input', {
	              type: 'password',
	              name: 'password',
	              autoComplete: 'off',
	              className: 'bottom-margin-only',
	              placeholder: (0, _proxyCounterpart.proxyCounterpart)('PASSWORD'),
	              value: this.state.password,
	              onChange: this.handleChangePassword
	            })
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'text-error' },
	            ' ',
	            this.state.errorMessage,
	            ' '
	          ),
	          _ref,
	          _react2.default.createElement(_components.SpinnerButton, {
	            id: 'login-button',
	            text: (0, _proxyCounterpart.proxyCounterpart)('LOGIN'),
	            loading: this.state.loading,
	            classes: 'btn cover',
	            callback: this.submitForm
	          }),
	          _react2.default.createElement(_loginBottomElement2.default, {
	            isLogin: true,
	            handleClick: this.props.switchView
	          })
	        );
	      }
	    }
	  }, {
	    key: 'renderSuccessMessage',
	    value: function renderSuccessMessage() {
	      if (this.state.successMessage) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'success-message-login-link-sent pre-wrap' },
	          this.state.successMessage
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.renderForm(),
	        this.renderSuccessMessage()
	      );
	    }
	  }]);
	  return LoginView;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    failedAuthentication: state.auth === null
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(LoginView);

/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _components = __webpack_require__(13);
	
	var _bankId = __webpack_require__(681);
	
	var _variables = __webpack_require__(47);
	
	var variables = _interopRequireWildcard(_variables);
	
	var _index = __webpack_require__(355);
	
	var _loginBottomElement = __webpack_require__(165);
	
	var _loginBottomElement2 = _interopRequireDefault(_loginBottomElement);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  null,
	  _react2.default.createElement(
	    'div',
	    { className: 'pt-20' },
	    _react2.default.createElement(_components.GeneralTerms, null)
	  )
	);
	
	var _ref2 = _react2.default.createElement(_bankId.BankId, null);
	
	var LoginWithEidView = function (_Component) {
	  (0, _inherits3.default)(LoginWithEidView, _Component);
	
	  function LoginWithEidView(props) {
	    (0, _classCallCheck3.default)(this, LoginWithEidView);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (LoginWithEidView.__proto__ || (0, _getPrototypeOf2.default)(LoginWithEidView)).call(this, props));
	
	    _this.state = {
	      isLoading: false,
	      isLoadingSameDevice: false
	    };
	
	    _this.renderBottomElement = _this.renderBottomElement.bind(_this);
	    _this.openEIDAuth = _this.openEIDAuth.bind(_this);
	    _this.openEIDAuthSameDevice = _this.openEIDAuthSameDevice.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(LoginWithEidView, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.clearError();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.setEntity({
	        sessionId: null,
	        redirectUrl: null,
	        autostart: null
	      });
	      this.props.cancel();
	    }
	  }, {
	    key: 'openEIDAuth',
	    value: function openEIDAuth() {
	      this.setState({
	        isLoading: true
	      });
	      var returnProtocol = variables.appEnv === 'development' ? 'http://' : 'https://';
	      var returnUrl = returnProtocol + variables.appUrl + '/eid-link-login';
	      var eidAuthUrl = variables.eidUrl + '/start-redirect?return_url=' + returnUrl;
	      window.location = eidAuthUrl;
	    }
	  }, {
	    key: 'openEIDAuthSameDevice',
	    value: function openEIDAuthSameDevice() {
	      this.setState({
	        isLoadingSameDevice: true
	      });
	      var returnProtocol = variables.appEnv === 'development' ? 'http://' : 'https://';
	      var returnUrl = returnProtocol + variables.appUrl + '/eid-link-login';
	      var eidAuthUrl = variables.eidUrl + '/start-redirect?acr_values=urn:grn:authn:se:bankid:same-device';
	      eidAuthUrl += '&return_url=' + returnUrl;
	      window.location = eidAuthUrl;
	    }
	  }, {
	    key: 'renderBottomElement',
	    value: function renderBottomElement() {
	      return _react2.default.createElement(_loginBottomElement2.default, {
	        isLogin: true,
	        isBankID: true,
	        handleClick: this.props.switchView
	      });
	    }
	  }, {
	    key: 'renderGeneralTerms',
	    value: function renderGeneralTerms() {
	      return _ref;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'login-input-container eid-buttons'
	          },
	          _react2.default.createElement(_components.SpinnerButton, {
	            id: 'login-button',
	            text: (0, _proxyCounterpart.proxyCounterpart)('BANK_ID_ANOTHER_DEVICE'),
	            loading: this.state.isLoading,
	            classes: 'btn',
	            callback: this.openEIDAuth
	          }),
	          _react2.default.createElement(_components.SpinnerButton, {
	            id: 'login-button-same-device',
	            text: (0, _proxyCounterpart.proxyCounterpart)('OPEN_BANK_ID'),
	            loading: this.state.isLoadingSameDevice,
	            classes: 'btn',
	            callback: this.openEIDAuthSameDevice
	          })
	        ),
	        this.renderBottomElement(),
	        _ref2
	      );
	    }
	  }]);
	  return LoginWithEidView;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    inProgress: state.bankId.inProgress
	  };
	}
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    requestLogin: function requestLogin(socialSecurityNr, createUser) {
	      return dispatch((0, _index.requestLogin)(socialSecurityNr, createUser));
	    },
	    setError: function setError(error) {
	      return dispatch((0, _index.setError)(error));
	    },
	    clearError: function clearError(force) {
	      return dispatch((0, _index.clearError)(force));
	    },
	    setEntity: function setEntity(entity) {
	      return dispatch((0, _index.setEntity)(entity));
	    },
	    cancel: function cancel() {
	      return dispatch((0, _index.cancel)());
	    },
	    setAuthType: function setAuthType(authType) {
	      return dispatch((0, _index.setAuthType)(authType));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LoginWithEidView);

/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(20);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _loginView = __webpack_require__(955);
	
	var _loginView2 = _interopRequireDefault(_loginView);
	
	var _loginWithEidView = __webpack_require__(956);
	
	var _loginWithEidView2 = _interopRequireDefault(_loginWithEidView);
	
	var _variables = __webpack_require__(47);
	
	var variables = _interopRequireWildcard(_variables);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_reactTranslateComponent2.default, { className: 'login-title', content: 'LOGIN' });
	
	var LoginDetails = function (_Component) {
	  (0, _inherits3.default)(LoginDetails, _Component);
	
	  function LoginDetails(props) {
	    (0, _classCallCheck3.default)(this, LoginDetails);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (LoginDetails.__proto__ || (0, _getPrototypeOf2.default)(LoginDetails)).call(this, props));
	
	    _this.state = {
	      show: _this.props.tab ? _this.props.tab : 'BANKID'
	    };
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(LoginDetails, [{
	    key: 'handleClick',
	    value: function handleClick(event) {
	      var id = event.target.id;
	      this.setState({
	        show: id
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var showContent = void 0;
	      if (this.state.show === 'BANKID') {
	        showContent = _react2.default.createElement(_loginWithEidView2.default, {
	          switchView: this.handleClick
	        });
	      } else {
	        showContent = _react2.default.createElement(_loginView2.default, {
	          switchView: this.handleClick
	        });
	      };
	
	      var loginSelectionButtonClass = 'login-title login-type-selection-button';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'login-details' },
	        _react2.default.createElement(
	          'div',
	          { className: 'login-top-section' },
	          _react2.default.createElement(
	            'a',
	            { href: variables.frontUrl, className: 'login-logo' },
	            _react2.default.createElement(
	              'object',
	              { type: 'image/svg+xml',
	                data: __webpack_require__(657),
	                alt: 'Frilans Finans-logotyp' },
	              _react2.default.createElement('img', { src: __webpack_require__(207), alt: 'Frilans Finans-logotyp' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'login-type-selection' },
	            _react2.default.createElement(_reactTranslateComponent2.default, {
	              id: 'BANKID',
	              className: loginSelectionButtonClass + ' active',
	              content: 'LOGIN',
	              onClick: this.handleClick
	            }),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/register' },
	              _react2.default.createElement(_reactTranslateComponent2.default, {
	                className: loginSelectionButtonClass,
	                content: 'CREATE_ACCOUNT'
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'login-bottom-section' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section-content' },
	            _ref,
	            showContent
	          )
	        )
	      );
	    }
	  }]);
	  return LoginDetails;
	}(_react.Component);
	
	exports.default = LoginDetails;

/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement('div', { className: 'login-information' });
	
	var LoginInformation = function (_Component) {
	  (0, _inherits3.default)(LoginInformation, _Component);
	
	  function LoginInformation() {
	    (0, _classCallCheck3.default)(this, LoginInformation);
	    return (0, _possibleConstructorReturn3.default)(this, (LoginInformation.__proto__ || (0, _getPrototypeOf2.default)(LoginInformation)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LoginInformation, [{
	    key: 'render',
	    value: function render() {
	      return _ref;
	    }
	  }]);
	  return LoginInformation;
	}(_react.Component);
	
	exports.default = LoginInformation;

/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _index = __webpack_require__(225);
	
	var _loginDetails = __webpack_require__(957);
	
	var _loginDetails2 = _interopRequireDefault(_loginDetails);
	
	var _loginInformation = __webpack_require__(958);
	
	var _loginInformation2 = _interopRequireDefault(_loginInformation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_loginInformation2.default, null);
	
	var LoginTabs = function (_Component) {
	  (0, _inherits3.default)(LoginTabs, _Component);
	
	  function LoginTabs() {
	    (0, _classCallCheck3.default)(this, LoginTabs);
	    return (0, _possibleConstructorReturn3.default)(this, (LoginTabs.__proto__ || (0, _getPrototypeOf2.default)(LoginTabs)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LoginTabs, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.setHideFooter();
	      this.props.setHideHeader();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'login-page page' },
	        _react2.default.createElement(
	          'div',
	          { className: 'login-container' },
	          _react2.default.createElement(_loginDetails2.default, {
	            tab: this.props.tab
	          }),
	          _ref
	        )
	      );
	    }
	  }]);
	  return LoginTabs;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    tab: state.router.locationBeforeTransitions.query.tab
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    setHideFooter: function setHideFooter() {
	      return dispatch((0, _index.setHideFooter)());
	    },
	    setHideHeader: function setHideHeader() {
	      return dispatch((0, _index.setHideHeader)());
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LoginTabs);

/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(20);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'loyalty-description-container' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { className: 'loyalty-description-title', content: 'LOYALTY_HOW_TO_TITLE' }),
	  _react2.default.createElement(_reactTranslateComponent2.default, { className: 'loyalty-description-text', content: 'LOYALTY_HOW_TO_DESCRIPTION' }),
	  _react2.default.createElement(
	    _reactRouter.Link,
	    { to: 'https://www.frilansfinans.se/together-ett-lojalitetsprogram/', target: '_blank' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { className: 'loyalty-description-link', content: 'LOYALTY_HOW_TO_LINK' })
	  )
	);
	
	var LoyaltyPointsDescription = function (_React$Component) {
	  (0, _inherits3.default)(LoyaltyPointsDescription, _React$Component);
	
	  function LoyaltyPointsDescription() {
	    (0, _classCallCheck3.default)(this, LoyaltyPointsDescription);
	    return (0, _possibleConstructorReturn3.default)(this, (LoyaltyPointsDescription.__proto__ || (0, _getPrototypeOf2.default)(LoyaltyPointsDescription)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LoyaltyPointsDescription, [{
	    key: 'render',
	    value: function render() {
	      return _ref;
	    }
	  }]);
	  return LoyaltyPointsDescription;
	}(_react2.default.Component);
	
	exports.default = LoyaltyPointsDescription;

/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(12);
	
	var _loyaltyPointsView = __webpack_require__(962);
	
	var _loyaltyPointsView2 = _interopRequireDefault(_loyaltyPointsView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    user: state.user
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(_loyaltyPointsView2.default);

/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _overview = __webpack_require__(968);
	
	var _overview2 = _interopRequireDefault(_overview);
	
	var _description = __webpack_require__(960);
	
	var _description2 = _interopRequireDefault(_description);
	
	var _pointsTables = __webpack_require__(971);
	
	var _pointsTables2 = _interopRequireDefault(_pointsTables);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_reactTranslateComponent2.default, { className: 'loyalty-points-overview-title', content: 'LOYALTY_POINTS_TITLE' });
	
	var _ref2 = _react2.default.createElement(_description2.default, null);
	
	var _ref3 = _react2.default.createElement(_pointsTables2.default, null);
	
	var LoyaltyPointsView = function (_React$Component) {
	  (0, _inherits3.default)(LoyaltyPointsView, _React$Component);
	
	  function LoyaltyPointsView() {
	    (0, _classCallCheck3.default)(this, LoyaltyPointsView);
	    return (0, _possibleConstructorReturn3.default)(this, (LoyaltyPointsView.__proto__ || (0, _getPrototypeOf2.default)(LoyaltyPointsView)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LoyaltyPointsView, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'loyalty-points-overview-container no-padding' },
	        _ref,
	        _react2.default.createElement(_overview2.default, { points: this.context.user.loyaltyPoints }),
	        _ref2,
	        _ref3
	      );
	    }
	  }]);
	  return LoyaltyPointsView;
	}(_react2.default.Component);
	
	LoyaltyPointsView.contextTypes = {
	  user: _react.PropTypes.object.isRequired
	};
	exports.default = LoyaltyPointsView;

/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _utils = __webpack_require__(29);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'loyalty-chart-title' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'LOYALTY_CHART_TITLE' }),
	  ':'
	);
	
	var _ref2 = _react2.default.createElement('path', {
	  className: 'loyalty-chart-circle',
	  strokeDasharray: '100, 100',
	  d: 'M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831'
	});
	
	var _ref3 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'LOYALTY_CHART_POINTS_OF' });
	
	var _ref4 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'LOYALTY_CHART_NEXT_LEVEL' });
	
	var LoyaltyPointsChart = function (_React$Component) {
	  (0, _inherits3.default)(LoyaltyPointsChart, _React$Component);
	
	  function LoyaltyPointsChart() {
	    (0, _classCallCheck3.default)(this, LoyaltyPointsChart);
	    return (0, _possibleConstructorReturn3.default)(this, (LoyaltyPointsChart.__proto__ || (0, _getPrototypeOf2.default)(LoyaltyPointsChart)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LoyaltyPointsChart, [{
	    key: 'percentageCount',
	    value: function percentageCount() {
	      var points = this.props.points;
	      if (points <= 100000) {
	        return this.getPercentage(0, 100000);
	      } else if (points > 100000 && points < 250000) {
	        return this.getPercentage(100000, 250000);
	      } else if (points > 250000 && points < 500000) {
	        return this.getPercentage(250000, 500000);
	      } else if (points > 500000 && points < 1000000) {
	        return this.getPercentage(500000, 1000000);
	      } else if (points > 1000000 && points < 1500000) {
	        return this.getPercentage(1000000, 1500000);
	      } else if (points > 1500000) {
	        return 100;
	      }
	    }
	  }, {
	    key: 'getPercentage',
	    value: function getPercentage(min, max) {
	      var decimals = (this.props.points - min) / (max - min);
	      var procentage = decimals * 100;
	      return procentage;
	    }
	  }, {
	    key: 'theLevel',
	    value: function theLevel() {
	      return this.props.levels[this.props.currentLevelIndex];
	    }
	  }, {
	    key: 'nextLevel',
	    value: function nextLevel() {
	      return this.props.levels[this.props.currentLevelIndex + 1];
	    }
	  }, {
	    key: 'nextlevelName',
	    value: function nextlevelName() {
	      var level = this.nextLevel();
	      var transKey = level ? level.title : '';
	      return _react2.default.createElement(_reactTranslateComponent2.default, { content: transKey });
	    }
	  }, {
	    key: 'nextLevelPoints',
	    value: function nextLevelPoints() {
	      var level = this.theLevel();
	      return level ? level.nextLevelPoints : '';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'loyalty-chart-wrapper' },
	        _ref,
	        _react2.default.createElement(
	          'div',
	          { className: 'loyalty-chart-stats-info' },
	          _react2.default.createElement(
	            'div',
	            { className: 'loyalty-chart-graph-container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'loyalty-chart-percent hide-mobile' },
	              _react2.default.createElement(
	                'svg',
	                {
	                  viewBox: '0 0 36 36',
	                  className: 'loyalty-chart-circular-chart'
	                },
	                _ref2,
	                _react2.default.createElement('path', {
	                  className: 'loyalty-chart-circle',
	                  strokeDasharray: this.percentageCount() + ', 100',
	                  d: 'M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831'
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'inside-chart-content' },
	              _react2.default.createElement(
	                'span',
	                { className: 'conent-chart-points' },
	                _utils2.default.numberWithSpaces(_utils2.default.floor(this.props.points))
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'conent-chart-points-of' },
	                _ref3,
	                ' ' + _utils2.default.numberWithSpaces(this.nextLevelPoints())
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loyalty-chart-next-level' },
	          _ref4,
	          '\xA0',
	          this.nextlevelName(),
	          ' (',
	          _utils2.default.numberWithSpaces(this.nextLevelPoints()),
	          ')'
	        )
	      );
	    }
	  }]);
	  return LoyaltyPointsChart;
	}(_react2.default.Component);
	
	exports.default = LoyaltyPointsChart;

/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref2 = _react2.default.createElement(_reactTranslateComponent2.default, {
	  className: 'loyalty-points-overview-included-title',
	  content: 'LOYALTY_ALWAYS_INCLUDED_TITLE' });
	
	var LoyaltyPointsOverviewIncluded = function (_React$Component) {
	  (0, _inherits3.default)(LoyaltyPointsOverviewIncluded, _React$Component);
	
	  function LoyaltyPointsOverviewIncluded() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, LoyaltyPointsOverviewIncluded);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LoyaltyPointsOverviewIncluded.__proto__ || (0, _getPrototypeOf2.default)(LoyaltyPointsOverviewIncluded)).call.apply(_ref, [this].concat(args))), _this), _this.includedItems = [{
	      icon: __webpack_require__(1560),
	      title: 'LOYALTY_ALWAYS_INCLUDED_FAST_PAYMENT'
	    }, {
	      icon: __webpack_require__(1567),
	      title: 'LOYALTY_ALWAYS_INCLUDED_ADVICE'
	    }, {
	      icon: __webpack_require__(1565),
	      title: 'LOYALTY_ALWAYS_INCLUDED_HOTLINE'
	    }, {
	      icon: __webpack_require__(1574),
	      title: 'LOYALTY_ALWAYS_INCLUDED_BENEFITS'
	    }], _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(LoyaltyPointsOverviewIncluded, [{
	    key: 'alwaysIncluded',
	    value: function alwaysIncluded() {
	      var alwaysIncluded = [];
	      this.includedItems.forEach(function (item) {
	        return alwaysIncluded.push(_react2.default.createElement(
	          'div',
	          { key: item.title, className: 'loyalty-points-overview-included-item' },
	          _react2.default.createElement('img', { src: item.icon }),
	          _react2.default.createElement(_reactTranslateComponent2.default, {
	            className: 'loyalty-points-overview-included-item-title',
	            content: item.title })
	        ));
	      });
	      return alwaysIncluded;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'loyalty-points-overview-included' },
	        _ref2,
	        this.alwaysIncluded()
	      );
	    }
	  }]);
	  return LoyaltyPointsOverviewIncluded;
	}(_react2.default.Component);
	
	exports.default = LoyaltyPointsOverviewIncluded;

/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoyaltyPointsLevelDescription = function (_React$Component) {
	  (0, _inherits3.default)(LoyaltyPointsLevelDescription, _React$Component);
	
	  function LoyaltyPointsLevelDescription() {
	    (0, _classCallCheck3.default)(this, LoyaltyPointsLevelDescription);
	    return (0, _possibleConstructorReturn3.default)(this, (LoyaltyPointsLevelDescription.__proto__ || (0, _getPrototypeOf2.default)(LoyaltyPointsLevelDescription)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LoyaltyPointsLevelDescription, [{
	    key: 'descriptionTitle',
	    value: function descriptionTitle() {
	      switch (this.props.selected) {
	        case 0:
	          return 'LOYALTY_TITLE_1';
	        case 1:
	          return 'LOYALTY_TITLE_2';
	        case 2:
	          return 'LOYALTY_TITLE_3';
	        case 3:
	          return 'LOYALTY_TITLE_4';
	        case 4:
	          return 'LOYALTY_TITLE_5';
	        case 5:
	          return 'LOYALTY_TITLE_6';
	        default:
	          return '';
	      }
	    }
	  }, {
	    key: 'descriptionText',
	    value: function descriptionText() {
	      switch (this.props.selected) {
	        case 0:
	          return 'LOYALTY_DESCRIPTION_1';
	        case 1:
	          return 'LOYALTY_DESCRIPTION_2';
	        case 2:
	          return 'LOYALTY_DESCRIPTION_3';
	        case 3:
	          return 'LOYALTY_DESCRIPTION_4';
	        case 4:
	          return 'LOYALTY_DESCRIPTION_5';
	        case 5:
	          return 'LOYALTY_DESCRIPTION_6';
	        default:
	          return '';
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.selected != null ? _react2.default.createElement(
	        'div',
	        { className: 'loyalty-points-overview-description-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'loyalty-points-overview-description-title' },
	          _react2.default.createElement(_reactTranslateComponent2.default, { content: this.descriptionTitle() })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loyalty-points-overview-description' },
	          _react2.default.createElement(_reactTranslateComponent2.default, { content: this.descriptionText() })
	        )
	      ) : null;
	    }
	  }]);
	  return LoyaltyPointsLevelDescription;
	}(_react2.default.Component);
	
	exports.default = LoyaltyPointsLevelDescription;

/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoyaltyPointsLevel = function (_React$Component) {
	  (0, _inherits3.default)(LoyaltyPointsLevel, _React$Component);
	
	  function LoyaltyPointsLevel(props) {
	    (0, _classCallCheck3.default)(this, LoyaltyPointsLevel);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (LoyaltyPointsLevel.__proto__ || (0, _getPrototypeOf2.default)(LoyaltyPointsLevel)).call(this, props));
	
	    _this.selectLevel = _this.selectLevel.bind(_this);
	    _this.renderTrailing = _this.renderTrailing.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(LoyaltyPointsLevel, [{
	    key: 'selectLevel',
	    value: function selectLevel() {
	      this.props.setSelectedLevel(this.props.levelNumber);
	    }
	  }, {
	    key: 'renderTrailing',
	    value: function renderTrailing() {
	      if (this.props.trailingText) {
	        return this.props.trailingText;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        {
	          key: this.props.level.title,
	          onClick: this.selectLevel,
	          className: 'loyalty-points-overview-level' + this.props.selected
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'level-title-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'level-icon' },
	            _react2.default.createElement('img', { src: this.props.level.icon })
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_reactTranslateComponent2.default, { className: 'level-title', content: this.props.level.title }),
	            _react2.default.createElement(
	              'p',
	              { className: 'level-points' },
	              this.props.level.pointsLabel
	            )
	          )
	        ),
	        this.renderTrailing()
	      );
	    }
	  }]);
	  return LoyaltyPointsLevel;
	}(_react2.default.Component);
	
	exports.default = LoyaltyPointsLevel;

/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _level = __webpack_require__(966);
	
	var _level2 = _interopRequireDefault(_level);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_reactTranslateComponent2.default, { className: 'level-trailing', content: 'LEVEL_CURRENT_LEVEL' });
	
	var _ref2 = _react2.default.createElement(_reactTranslateComponent2.default, { className: 'level-trailing', content: 'LEVEL_NEXT_LEVEL' });
	
	var LoyaltyPointsLevels = function (_React$Component) {
	  (0, _inherits3.default)(LoyaltyPointsLevels, _React$Component);
	
	  function LoyaltyPointsLevels() {
	    (0, _classCallCheck3.default)(this, LoyaltyPointsLevels);
	    return (0, _possibleConstructorReturn3.default)(this, (LoyaltyPointsLevels.__proto__ || (0, _getPrototypeOf2.default)(LoyaltyPointsLevels)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LoyaltyPointsLevels, [{
	    key: 'selectedLevel',
	    value: function selectedLevel(level) {
	      return level === this.props.selected ? ' active' : '';
	    }
	  }, {
	    key: 'trailingText',
	    value: function trailingText(level) {
	      if (level === this.props.currentLevelIndex) {
	        return _ref;
	      }
	
	      if (level === this.props.currentLevelIndex + 1) {
	        return _ref2;
	      }
	    }
	  }, {
	    key: 'renderLevels',
	    value: function renderLevels() {
	      var _this2 = this;
	
	      var levels = [];
	      this.props.levels.forEach(function (level, index) {
	        return levels.push(_react2.default.createElement(_level2.default, {
	          key: level.title,
	          level: level,
	          levelNumber: index,
	          selected: _this2.selectedLevel(index),
	          setSelectedLevel: _this2.props.setSelectedLevel,
	          trailingText: _this2.trailingText(index)
	        }));
	      });
	
	      return levels;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'loyalty-points-overview-levels' },
	        this.renderLevels()
	      );
	    }
	  }]);
	  return LoyaltyPointsLevels;
	}(_react2.default.Component);
	
	exports.default = LoyaltyPointsLevels;

/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _levels = __webpack_require__(967);
	
	var _levels2 = _interopRequireDefault(_levels);
	
	var _steps = __webpack_require__(969);
	
	var _steps2 = _interopRequireDefault(_steps);
	
	var _chart = __webpack_require__(963);
	
	var _chart2 = _interopRequireDefault(_chart);
	
	var _levelDescription = __webpack_require__(965);
	
	var _levelDescription2 = _interopRequireDefault(_levelDescription);
	
	var _included = __webpack_require__(964);
	
	var _included2 = _interopRequireDefault(_included);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'LOTALTY_START_LEVEL' });
	
	var _ref2 = _react2.default.createElement(_included2.default, null);
	
	var LoyaltyPointsOverview = function (_React$Component) {
	  (0, _inherits3.default)(LoyaltyPointsOverview, _React$Component);
	
	  function LoyaltyPointsOverview(props) {
	    (0, _classCallCheck3.default)(this, LoyaltyPointsOverview);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (LoyaltyPointsOverview.__proto__ || (0, _getPrototypeOf2.default)(LoyaltyPointsOverview)).call(this, props));
	
	    _this.levels = [{
	      icon: __webpack_require__(1568),
	      title: 'LOYALTY_TITLE_1',
	      pointsLabel: _ref,
	      points: 0,
	      nextLevelPoints: 100000
	    }, {
	      icon: __webpack_require__(1569),
	      title: 'LOYALTY_TITLE_2',
	      pointsLabel: '100 000',
	      points: 100000,
	      nextLevelPoints: 250000
	    }, {
	      icon: __webpack_require__(1572),
	      title: 'LOYALTY_TITLE_3',
	      pointsLabel: '250 000',
	      points: 250000,
	      nextLevelPoints: 500000
	    }, {
	      icon: __webpack_require__(1559),
	      title: 'LOYALTY_TITLE_4',
	      pointsLabel: '500 000',
	      points: 500000,
	      nextLevelPoints: 1000000
	    }, {
	      icon: __webpack_require__(1570),
	      title: 'LOYALTY_TITLE_5',
	      pointsLabel: '1 000 000',
	      points: 1000000,
	      nextLevelPoints: 1500000
	    }, {
	      icon: __webpack_require__(1571),
	      title: 'LOYALTY_TITLE_6',
	      pointsLabel: '1 500 000',
	      points: 1500000
	    }];
	
	
	    _this.state = {
	      selectedLevel: null,
	      currentLevelIndex: null
	    };
	
	    _this.setSelectedLevel = _this.setSelectedLevel.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(LoyaltyPointsOverview, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var currentLevelIndex = this.levels.findIndex(function (level) {
	        return level.points <= _this2.props.points && level.nextLevelPoints > _this2.props.points;
	      });
	      this.setState({
	        selectedLevel: currentLevelIndex,
	        currentLevelIndex: currentLevelIndex
	      });
	    }
	  }, {
	    key: 'setSelectedLevel',
	    value: function setSelectedLevel(level) {
	      this.setState({
	        selectedLevel: level
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'loyalty-points-overview' },
	        _react2.default.createElement(
	          'div',
	          { className: 'loyalty-points-overview-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'loyalty-points-overview-levels-container' },
	            _react2.default.createElement(_steps2.default, { points: this.props.points }),
	            _react2.default.createElement(_levels2.default, {
	              points: this.props.points,
	              selected: this.state.selectedLevel,
	              setSelectedLevel: this.setSelectedLevel,
	              levels: this.levels,
	              currentLevelIndex: this.state.currentLevelIndex
	            }),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_chart2.default, {
	                levels: this.levels,
	                points: this.props.points,
	                currentLevelIndex: this.state.currentLevelIndex
	              }),
	              _react2.default.createElement(_levelDescription2.default, { selected: this.state.selectedLevel })
	            )
	          )
	        ),
	        _ref2
	      );
	    }
	  }]);
	  return LoyaltyPointsOverview;
	}(_react2.default.Component);
	
	exports.default = LoyaltyPointsOverview;

/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _check = __webpack_require__(212);
	
	var _check2 = _interopRequireDefault(_check);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_check2.default, { width: '10', height: '10', colorSchema: 'white' });
	
	var LoyaltyPointsSteps = function (_React$Component) {
	  (0, _inherits3.default)(LoyaltyPointsSteps, _React$Component);
	
	  function LoyaltyPointsSteps() {
	    (0, _classCallCheck3.default)(this, LoyaltyPointsSteps);
	    return (0, _possibleConstructorReturn3.default)(this, (LoyaltyPointsSteps.__proto__ || (0, _getPrototypeOf2.default)(LoyaltyPointsSteps)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LoyaltyPointsSteps, [{
	    key: 'lineLength',
	    value: function lineLength(min, max) {
	      var fraction = (this.props.points - min) / (max - min);
	      if (fraction < 0) {
	        return 0;
	      }
	      return fraction > 1 ? 1 : fraction;
	    }
	  }, {
	    key: 'solidLineLength',
	    value: function solidLineLength(min, max) {
	      var lineLength = this.lineLength(min, max);
	      return lineLength * 62 + 'px';
	    }
	  }, {
	    key: 'dottedLineLength',
	    value: function dottedLineLength(min, max) {
	      var lineLength = this.lineLength(min, max);
	      return 62 - lineLength * 62 + 'px';
	    }
	  }, {
	    key: 'solidCircle',
	    value: function solidCircle(levelPoints) {
	      return this.props.points >= levelPoints ? ' solid' : '';
	    }
	  }, {
	    key: 'renderCheck',
	    value: function renderCheck(shouldRender) {
	      return shouldRender ? _ref : null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'loyalty-points-overview-current-points' },
	        _react2.default.createElement(
	          'div',
	          { className: 'current-point-circle' + this.solidCircle(0) },
	          this.renderCheck(this.solidCircle(0))
	        ),
	        _react2.default.createElement('div', { className: 'current-point-solid-line', style: { height: this.solidLineLength(0, 100000) } }),
	        _react2.default.createElement('div', { className: 'current-point-dotted-line', style: { height: this.dottedLineLength(0, 100000) } }),
	        _react2.default.createElement(
	          'div',
	          { className: 'current-point-circle' + this.solidCircle(100000) },
	          this.renderCheck(this.solidCircle(100000))
	        ),
	        _react2.default.createElement('div', { className: 'current-point-solid-line', style: { height: this.solidLineLength(100000, 250000) } }),
	        _react2.default.createElement('div', { className: 'current-point-dotted-line', style: { height: this.dottedLineLength(100000, 250000) } }),
	        _react2.default.createElement(
	          'div',
	          { className: 'current-point-circle' + this.solidCircle(250000) },
	          this.renderCheck(this.solidCircle(250000))
	        ),
	        _react2.default.createElement('div', { className: 'current-point-solid-line', style: { height: this.solidLineLength(250000, 500000) } }),
	        _react2.default.createElement('div', { className: 'current-point-dotted-line', style: { height: this.dottedLineLength(250000, 500000) } }),
	        _react2.default.createElement(
	          'div',
	          { className: 'current-point-circle' + this.solidCircle(500000) },
	          this.renderCheck(this.solidCircle(500000))
	        ),
	        _react2.default.createElement('div', { className: 'current-point-solid-line', style: { height: this.solidLineLength(500000, 1000000) } }),
	        _react2.default.createElement('div', { className: 'current-point-dotted-line', style: { height: this.dottedLineLength(500000, 1000000) } }),
	        _react2.default.createElement(
	          'div',
	          { className: 'current-point-circle' + this.solidCircle(1000000) },
	          this.renderCheck(this.solidCircle(1000000))
	        ),
	        _react2.default.createElement('div', { className: 'current-point-solid-line', style: { height: this.solidLineLength(1000000, 1500000) } }),
	        _react2.default.createElement('div', { className: 'current-point-dotted-line', style: { height: this.dottedLineLength(1000000, 1500000) } }),
	        _react2.default.createElement(
	          'div',
	          { className: 'current-point-circle' + this.solidCircle(1500000) },
	          this.renderCheck(this.solidCircle(1500000))
	        )
	      );
	    }
	  }]);
	  return LoyaltyPointsSteps;
	}(_react2.default.Component);
	
	exports.default = LoyaltyPointsSteps;

/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(20);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _showMoreButton = __webpack_require__(972);
	
	var _showMoreButton2 = _interopRequireDefault(_showMoreButton);
	
	var _utils = __webpack_require__(29);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoyaltyPointsTable = function (_React$Component) {
	  (0, _inherits3.default)(LoyaltyPointsTable, _React$Component);
	
	  function LoyaltyPointsTable(props) {
	    (0, _classCallCheck3.default)(this, LoyaltyPointsTable);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (LoyaltyPointsTable.__proto__ || (0, _getPrototypeOf2.default)(LoyaltyPointsTable)).call(this, props));
	
	    _this.renderShowMoreBtn = _this.renderShowMoreBtn.bind(_this);
	    _this.callCallback = _this.callCallback.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(LoyaltyPointsTable, [{
	    key: 'callCallback',
	    value: function callCallback(e) {
	      if (typeof this.props.callback === 'function') {
	        this.props.callback(e);
	      }
	    }
	  }, {
	    key: 'renderShowMoreBtn',
	    value: function renderShowMoreBtn() {
	      if (!this.props.metaState || this.props.rows.length <= 0) {
	        return this.noPointsRow();
	      }
	
	      if (this.props.fetching || !this.props.metaState.currentPage || this.props.metaState.currentPage >= this.props.metaState.totalPages) {
	        return null;
	      }
	
	      return _react2.default.createElement(_showMoreButton2.default, {
	        text: (0, _proxyCounterpart.proxyCounterpart)('LOYALTY_POINTS_TABLE_SHOW_MORE_POINTS'),
	        graySpinner: 'true',
	        loading: this.props.fetching || false,
	        classes: '',
	        callback: this.callCallback
	      });
	    }
	  }, {
	    key: 'noPointsRow',
	    value: function noPointsRow() {
	      var transKey = this.props.type === 'pending' ? 'LOYALTY_POINTS_TABLE_NO_PENDING_POINTS' : 'LOYALTY_POINTS_TABLE_NO_COMPLETE_POINTS';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'loyalty-points-no-more-info' },
	        (0, _proxyCounterpart.proxyCounterpart)(transKey)
	      );
	    }
	  }, {
	    key: 'noMoreInfoRow',
	    value: function noMoreInfoRow() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'loyalty-points-no-more-info' },
	        (0, _proxyCounterpart.proxyCounterpart)('LOYALTY_POINTS_TABLE_ALL_POINTS_ARE_LOADED')
	      );
	    }
	  }, {
	    key: 'getClickableLoyaltyableIdLink',
	    value: function getClickableLoyaltyableIdLink(pointRow) {
	      if (pointRow.loyaltyableType === 'App\\Models\\Invoice') {
	        return _react2.default.createElement(
	          _reactRouter.Link,
	          {
	            to: '/economy/invoices/' + pointRow.loyaltyableId },
	          pointRow.loyaltyableId
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'getCompanyName',
	    value: function getCompanyName(pointRow) {
	      if (pointRow.loyaltyableType === 'App\\Models\\Invoice') {
	        return pointRow.companyName;
	      }
	      return (0, _proxyCounterpart.proxyCounterpart)('LOYALTY_POINTS_TABLE_FRILANS_FINANS');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var pointsRows = [];
	      this.props.rows.forEach(function (pointRow) {
	        return pointsRows.push(_react2.default.createElement(
	          'div',
	          {
	            key: pointRow.id,
	            className: 'loyalty-points-table-row'
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'loyalty-points-table-column' },
	            (0, _moment2.default)(pointRow.createdAt).format('YYYY-MM-DD')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'loyalty-points-table-column' },
	            _this2.getCompanyName(pointRow)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'loyalty-points-table-column' },
	            _this2.getClickableLoyaltyableIdLink(pointRow)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'loyalty-points-table-column' },
	            _utils2.default.numberWithSpaces(_utils2.default.floor(+pointRow.amount * +pointRow.factor)),
	            ' p'
	          )
	        ));
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'loyalty-points-table' + (this.props.open ? '' : ' hidden') },
	        pointsRows,
	        this.renderShowMoreBtn()
	      );
	    }
	  }]);
	  return LoyaltyPointsTable;
	}(_react2.default.Component);
	
	exports.default = LoyaltyPointsTable;

/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _pointsTable = __webpack_require__(970);
	
	var _pointsTable2 = _interopRequireDefault(_pointsTable);
	
	var _tableHeader = __webpack_require__(973);
	
	var _tableHeader2 = _interopRequireDefault(_tableHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_reactTranslateComponent2.default, { className: 'loyalty-points-tables-title', content: 'LOYALTY_POINTS_TABLE_TITLE' });
	
	var LoyaltyPointsTables = function (_React$Component) {
	  (0, _inherits3.default)(LoyaltyPointsTables, _React$Component);
	
	  function LoyaltyPointsTables(props) {
	    (0, _classCallCheck3.default)(this, LoyaltyPointsTables);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (LoyaltyPointsTables.__proto__ || (0, _getPrototypeOf2.default)(LoyaltyPointsTables)).call(this, props));
	
	    _this.state = {
	      fetching: true,
	      fetchingMore: false,
	      fetchError: false,
	      pendingPoints: [],
	      metaPending: {
	        currentPage: 0,
	        totalPages: 0
	      },
	      completePoints: [],
	      metaComplete: {
	        currentPage: 0,
	        totalPages: 0
	      },
	      pendingRequest: null,
	      pendingOpen: false,
	      completedOpen: false
	    };
	
	    _this.fetchPoints = _this.fetchPoints.bind(_this);
	    _this.toggleTable = _this.toggleTable.bind(_this);
	    _this.handleResponse = _this.handleResponse.bind(_this);
	    _this.showMorePendingClick = _this.showMorePendingClick.bind(_this);
	    _this.showMoreCompleteClick = _this.showMoreCompleteClick.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(LoyaltyPointsTables, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchPoints(false);
	      this.fetchPoints(true);
	    }
	  }, {
	    key: 'fetchPoints',
	    value: function fetchPoints(paid) {
	      var _this2 = this;
	
	      var getPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      this.setState({
	        fetching: true
	      });
	      var page = getPage || 1;
	      var pendingRequest = void 0;
	      if (paid) {
	        pendingRequest = _frilansFinans.LoyaltyPointService.getComplete(page);
	      } else {
	        pendingRequest = _frilansFinans.LoyaltyPointService.getPending(page);
	      }
	      pendingRequest.promise.then(function (response) {
	        _this2.handleResponse(response, paid);
	      }).catch(function (error) {
	        if (error.response !== undefined) {
	          _this2.setState({
	            fetchError: true
	          });
	        }
	      });
	      this.setState({
	        pendingRequest: pendingRequest
	      });
	    }
	  }, {
	    key: 'handleResponse',
	    value: function handleResponse(response, paid) {
	      if (paid) {
	        this.handleCompletePoints(response);
	      } else {
	        this.handlePendingPoints(response);
	      }
	    }
	  }, {
	    key: 'handleCompletePoints',
	    value: function handleCompletePoints(response) {
	      var completePoints = this.state.completePoints;
	
	      response.collection.forEach(function (invoice) {
	        return completePoints.push(invoice);
	      });
	
	      this.setState({
	        fetching: false,
	        fetchError: false
	      });
	
	      if (response.collection) {
	        this.setState({
	          completePoints: completePoints,
	          metaComplete: response.meta
	        });
	      }
	    }
	  }, {
	    key: 'handlePendingPoints',
	    value: function handlePendingPoints(response) {
	      var pendingPoints = this.state.pendingPoints;
	
	      response.collection.forEach(function (invoice) {
	        return pendingPoints.push(invoice);
	      });
	
	      this.setState({
	        fetching: false,
	        fetchError: false
	      });
	
	      if (response.collection) {
	        this.setState({
	          pendingPoints: pendingPoints,
	          metaPending: response.meta
	        });
	      }
	    }
	  }, {
	    key: 'toggleTable',
	    value: function toggleTable(table) {
	      if (table === 'upcoming') {
	        this.setState({
	          pendingOpen: !this.state.pendingOpen
	        });
	      }
	
	      if (table === 'registered') {
	        this.setState({
	          completedOpen: !this.state.completedOpen
	        });
	      }
	    }
	  }, {
	    key: 'showMorePendingClick',
	    value: function showMorePendingClick() {
	      this.fetchPoints(false, this.state.metaPending.currentPage + 1);
	    }
	  }, {
	    key: 'showMoreCompleteClick',
	    value: function showMoreCompleteClick() {
	      this.fetchPoints(true, this.state.metaComplete.currentPage + 1);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'loyalty-points-tables-container' },
	        _ref,
	        _react2.default.createElement(_tableHeader2.default, {
	          title: 'LOYALTY_POINTS_TABLE_UPCOMING',
	          toggleTable: this.toggleTable,
	          tableType: 'upcoming',
	          open: this.state.pendingOpen
	        }),
	        _react2.default.createElement(_pointsTable2.default, {
	          type: 'pending',
	          rows: this.state.pendingPoints,
	          open: this.state.pendingOpen,
	          metaState: this.state.metaPending,
	          fetching: this.state.fetching,
	          callback: this.showMorePendingClick
	        }),
	        _react2.default.createElement(_tableHeader2.default, {
	          title: 'LOYALTY_POINTS_TABLE_REGISTERED',
	          toggleTable: this.toggleTable,
	          tableType: 'registered',
	          open: this.state.completedOpen
	        }),
	        _react2.default.createElement(_pointsTable2.default, {
	          type: 'complete',
	          rows: this.state.completePoints,
	          open: this.state.completedOpen,
	          metaState: this.state.metaComplete,
	          fetching: this.state.fetching,
	          callback: this.showMoreCompleteClick
	        })
	      );
	    }
	  }]);
	  return LoyaltyPointsTables;
	}(_react2.default.Component);
	
	exports.default = LoyaltyPointsTables;

/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ShowMoreButton = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ShowMoreButton = exports.ShowMoreButton = function (_React$Component) {
	  (0, _inherits3.default)(ShowMoreButton, _React$Component);
	
	  function ShowMoreButton(props) {
	    (0, _classCallCheck3.default)(this, ShowMoreButton);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ShowMoreButton.__proto__ || (0, _getPrototypeOf2.default)(ShowMoreButton)).call(this, props));
	
	    _this.callCallback = _this.callCallback.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(ShowMoreButton, [{
	    key: 'callCallback',
	    value: function callCallback(e) {
	      if (!this.props.loading && typeof this.props.callback === 'function') {
	        this.props.callback(e);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var classes = this.props.classes;
	
	      return _react2.default.createElement(
	        'button',
	        { id: this.props.id, type: this.props.type ? this.props.type : 'submit',
	          className: 'loyalty-points-show-more-button ' + { classes: classes },
	          onClick: this.callCallback,
	          disabled: this.props.disabled },
	        this.props.text
	      );
	    }
	  }]);
	  return ShowMoreButton;
	}(_react2.default.Component);
	
	exports.default = ShowMoreButton;

/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement('div', { className: 'loyalty-points-table-header-line' });
	
	var LoyaltyPointsTableHeader = function (_React$Component) {
	  (0, _inherits3.default)(LoyaltyPointsTableHeader, _React$Component);
	
	  function LoyaltyPointsTableHeader(props) {
	    (0, _classCallCheck3.default)(this, LoyaltyPointsTableHeader);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (LoyaltyPointsTableHeader.__proto__ || (0, _getPrototypeOf2.default)(LoyaltyPointsTableHeader)).call(this, props));
	
	    _this.toggleTable = _this.toggleTable.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(LoyaltyPointsTableHeader, [{
	    key: 'toggleTable',
	    value: function toggleTable() {
	      this.props.toggleTable(this.props.tableType);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var icon = this.props.open ? __webpack_require__(1558) : __webpack_require__(1555);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          onClick: this.toggleTable,
	          className: 'loyalty-points-table-header'
	        },
	        _react2.default.createElement(_reactTranslateComponent2.default, { className: 'loyalty-points-table-header-title', content: this.props.title }),
	        _ref,
	        _react2.default.createElement('img', { src: icon })
	      );
	    }
	  }]);
	  return LoyaltyPointsTableHeader;
	}(_react2.default.Component);
	
	exports.default = LoyaltyPointsTableHeader;

/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MissingView = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 24/03/16.
	 */
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'missing-page container page' },
	  _react2.default.createElement(
	    'div',
	    { className: 'col-sm-6 col-sm-push-3' },
	    _react2.default.createElement(
	      'h1',
	      null,
	      '404'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(_reactTranslateComponent2.default, { content: 'MISSING_PAGE' })
	    )
	  )
	);
	
	var MissingView = exports.MissingView = function (_React$Component) {
	  (0, _inherits3.default)(MissingView, _React$Component);
	
	  function MissingView() {
	    (0, _classCallCheck3.default)(this, MissingView);
	    return (0, _possibleConstructorReturn3.default)(this, (MissingView.__proto__ || (0, _getPrototypeOf2.default)(MissingView)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MissingView, [{
	    key: 'render',
	    value: function render() {
	      return _ref;
	    }
	  }]);
	  return MissingView;
	}(_react2.default.Component);
	
	exports.default = MissingView;

/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NewsList = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 21/03/16.
	 */
	
	var _ref = _react2.default.createElement(
	  'h2',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'NEWS' })
	);
	
	var NewsList = exports.NewsList = function (_React$Component) {
	  (0, _inherits3.default)(NewsList, _React$Component);
	
	  function NewsList() {
	    (0, _classCallCheck3.default)(this, NewsList);
	    return (0, _possibleConstructorReturn3.default)(this, (NewsList.__proto__ || (0, _getPrototypeOf2.default)(NewsList)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(NewsList, [{
	    key: 'loadHostedNewsRoom',
	    value: function loadHostedNewsRoom() {
	      if (!document.querySelectorAll('script[src="//frilans-finans-sverige-ab.mynewsdesk.com/hosted_newsroom.js"]').length) {
	        var s = document.createElement('script');
	        s.type = 'text/javascript';
	        s.async = true;
	        s.src = '//frilans-finans-sverige-ab.mynewsdesk.com/hosted_newsroom.js';
	        var i = document.getElementsByTagName('script')[0];
	        i.parentNode.insertBefore(s, i);
	      }
	    }
	  }, {
	    key: 'createMarkup',
	    value: function createMarkup(html) {
	      return { __html: html };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12' },
	          _react2.default.createElement(
	            'div',
	            { className: 'news-list-wrapper' },
	            _ref,
	            _react2.default.createElement(
	              'ul',
	              { className: 'news-list' },
	              _react2.default.createElement(
	                'script',
	                { type: 'text/javascript', charSet: 'utf-8', id: 'mnd-script' },
	                this.loadHostedNewsRoom()
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return NewsList;
	}(_react2.default.Component);
	
	exports.default = NewsList;

/***/ },
/* 976 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref2 = _react2.default.createElement(
	  'header',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PAYMENT_INVOICE_CREDITED_TITLE' })
	);
	
	var PaymentCredit = function PaymentCredit(_ref) {
	  var payment = _ref.payment;
	
	  var paidString = payment.invoice.data.fullPaymentDateTime ? 'PAID' : 'UNPAID';
	  return _react2.default.createElement(
	    'div',
	    { className: 'payment-page' },
	    _ref2,
	    _react2.default.createElement(
	      'section',
	      null,
	      _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: (0, _proxyCounterpart.proxyCounterpart)('PAYMENT_INVOICE_CREDITED_AND_' + paidString + '_MESSAGE') } })
	    )
	  );
	};
	
	exports.default = PaymentCredit;

/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref2 = _react2.default.createElement(
	  'header',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PAYMENT_ERROR_TITLE' })
	);
	
	var _ref3 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PAYMENT_ERROR_TRY_AGAIN' });
	
	var PaymentError = function PaymentError(_ref) {
	  var payment = _ref.payment;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'payment-page' },
	    _ref2,
	    _react2.default.createElement(
	      'section',
	      { className: 'general-error' },
	      _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: (0, _proxyCounterpart.proxyCounterpart)('PAYMENT_ERROR_MESSAGE') } }),
	      payment.invoice.data.uuid && _react2.default.createElement(
	        'a',
	        { className: 'btn', href: '/payment/' + payment.invoice.data.uuid },
	        _ref3
	      )
	    )
	  );
	};
	
	exports.default = PaymentError;

/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _payment = __webpack_require__(366);
	
	var _index = __webpack_require__(382);
	
	var _invoiceConstants = __webpack_require__(219);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref2 = _react2.default.createElement(_index.SpinnerPage, null);
	
	var PaymentPage = function (_React$Component) {
	  (0, _inherits3.default)(PaymentPage, _React$Component);
	
	  function PaymentPage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, PaymentPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PaymentPage.__proto__ || (0, _getPrototypeOf2.default)(PaymentPage)).call.apply(_ref, [this].concat(args))), _this), _this.componentDidMount = function () {
	      _this.props.fetchInvoice(_this.props.params.uuid, ['calculation', 'users', 'pdf']);
	    }, _this.cancel = function () {
	      _this.props.setStatus('cancelled');
	    }, _this.render = function () {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _this.props.componentToRender === 'spinner' && _ref2,
	        _this.props.componentToRender === 'paid' && _react2.default.createElement(_index.PaymentPaid, { invoice: _this.props.payment.invoice, createInvoiceEmail: _this.props.createInvoiceEmail }),
	        _this.props.componentToRender === 'start' && _react2.default.createElement(_index.PaymentStart, {
	          payment: _this.props.payment,
	          cancel: _this.cancel,
	          createPaymentRequest: _this.props.createPaymentRequest }),
	        _this.props.componentToRender === 'error' && _react2.default.createElement(_index.PaymentError, { payment: _this.props.payment }),
	        _this.props.componentToRender === 'cancel' && _react2.default.createElement(_index.PaymentCancel, { payment: _this.props.payment }),
	        _this.props.componentToRender === 'credit' && _react2.default.createElement(_index.PaymentCredit, { payment: _this.props.payment })
	      );
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  return PaymentPage;
	}(_react2.default.Component);
	
	var componentToRender = function componentToRender(payment) {
	  if (payment.invoice.status === 'error' || payment.paymentRequest.status === 'error') {
	    return 'error';
	  } else if (payment.status === 'cancelled') {
	    return 'cancel';
	  } else if (payment.invoice.status === 'success' && payment.invoice.data.status === _invoiceConstants.creditedPaymentStatus) {
	    return 'credit';
	  } else if (payment.invoice.status === 'success' && payment.invoice.data.paymentStatus === _invoiceConstants.paidPaymentStatus) {
	    return 'paid';
	  } else if (payment.invoice.status === 'success' && payment.invoice.data.paymentStatus !== _invoiceConstants.paidPaymentStatus) {
	    return 'start';
	  } else {
	    return 'spinner';
	  }
	};
	
	var mapStateToProps = function mapStateToProps(_ref3) {
	  var payment = _ref3.payment;
	  return {
	    payment: payment,
	    componentToRender: componentToRender(payment)
	  };
	};
	
	var mapDispatchToProps = {
	  fetchInvoice: _payment.fetchInvoice,
	  createPaymentRequest: _payment.createPaymentRequest,
	  createInvoiceEmail: _payment.createInvoiceEmail,
	  setStatus: _payment.setStatus
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PaymentPage);

/***/ },
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _inputField = __webpack_require__(330);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var _spinnerButton = __webpack_require__(97);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'header',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PAYMENT_PAID_TITLE' })
	);
	
	var _ref2 = _react2.default.createElement(
	  'section',
	  { className: 'main-text' },
	  _react2.default.createElement(
	    'div',
	    { className: 'thank-you' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PAYMENT_PAID_THANK_YOU_FOR_PAYMENT' })
	  ),
	  _react2.default.createElement(
	    'div',
	    { className: 'email' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PAYMENT_PAID_ENTER_EMAIL_FOR_INVOICE' })
	  )
	);
	
	var _ref3 = _react2.default.createElement(
	  'section',
	  { className: 'close-page' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PAYMENT_PAID_CAN_CLOSE_PAGE' })
	);
	
	var PaymentPaid = function (_React$Component) {
	  (0, _inherits3.default)(PaymentPaid, _React$Component);
	
	  function PaymentPaid(props) {
	    (0, _classCallCheck3.default)(this, PaymentPaid);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PaymentPaid.__proto__ || (0, _getPrototypeOf2.default)(PaymentPaid)).call(this, props));
	
	    _this.handleEmailInput = function (name, object) {
	      _this.setState({ email: object.value, valid: object.valid, emailSent: false });
	    };
	
	    _this.handleEmailSubmit = function () {
	      _this.setState({ loading: true });
	
	      if (_this.state.valid) {
	        var email = _this.state.email.trim();
	        _this.props.createInvoiceEmail(email).then(function () {
	          _this.setState({
	            emailSent: true,
	            loading: false
	          });
	        }, function () {
	          _this.setState({
	            loading: false
	          });
	        });
	      }
	    };
	
	    _this.renderEmailForm = function () {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'section',
	          { className: 'email-invoice' },
	          _react2.default.createElement(_inputField2.default, {
	            type: 'text',
	            validationType: 'email',
	            name: 'email',
	            placeholder: (0, _proxyCounterpart.proxyCounterpart)('EMAIL'),
	            showErrorWithoutBlur: false,
	            callback: _this.handleEmailInput,
	            required: 'true',
	            minLength: '3',
	            errorMessage: (0, _proxyCounterpart.proxyCounterpart)('EMAIL_ERROR')
	          })
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'buttons button-send-mail' },
	          _react2.default.createElement(_spinnerButton.SpinnerButton, {
	            text: (0, _proxyCounterpart.proxyCounterpart)('EMAIL_INVOICE_SPECIFICATION'),
	            loading: _this.state.loading,
	            classes: 'btn blue',
	            disabled: !_this.state.valid,
	            callback: _this.handleEmailSubmit
	          })
	        )
	      );
	    };
	
	    _this.renderTime = function (dateTime) {
	      return _react2.default.createElement(
	        'span',
	        null,
	        (0, _moment2.default)(dateTime).calendar()
	      );
	    };
	
	    _this.render = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'payment-page' },
	        _ref,
	        _react2.default.createElement(
	          'section',
	          { className: 'logo' },
	          _react2.default.createElement('img', { src: __webpack_require__(316), alt: 'Frilans Finans-logotyp' })
	        ),
	        !_this.state.emailSent && _ref2,
	        _this.state.emailSent && _react2.default.createElement(
	          'section',
	          { className: 'main-text' },
	          _react2.default.createElement('div', { className: 'email', dangerouslySetInnerHTML: { __html: (0, _proxyCounterpart.proxyCounterpart)('PAYMENT_PAID_EMAIL_INVOICE_SENT', { email: _this.state.email }) } })
	        ),
	        _this.renderEmailForm(),
	        _ref3
	      );
	    };
	
	    _this.state = {
	      email: null,
	      valid: false,
	      emailSent: false,
	      loading: false
	    };
	    return _this;
	  }
	
	  return PaymentPaid;
	}(_react2.default.Component);
	
	exports.default = PaymentPaid;

/***/ },
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'td',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PAYMENT_INVOICE_ROT_OR_RUT_DEDUCTION' }),
	  ':'
	);
	
	var _ref2 = _react2.default.createElement(
	  'td',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PAYMENT_START_INVOICE_AMOUNT_EXCL' }),
	  ':'
	);
	
	var _ref3 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'VAT' });
	
	var _ref4 = _react2.default.createElement(
	  'td',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PAYMENT_START_INVOICE_AMOUNT_INCL' }),
	  ':'
	);
	
	var _ref5 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PAYMENT_DOWNLOAD_PDF' });
	
	var _ref6 = _react2.default.createElement(
	  'div',
	  { className: 'plusgiro-info-text' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PAYMENT_PAY_WITH_PLUSGIRO' })
	);
	
	var _ref7 = _react2.default.createElement(
	  'tr',
	  null,
	  _react2.default.createElement(
	    'td',
	    null,
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PLUSGIRO' }),
	    ':'
	  ),
	  _react2.default.createElement(
	    'td',
	    null,
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PLUSGIRO_NUMBER' })
	  )
	);
	
	var _ref8 = _react2.default.createElement(
	  'tr',
	  null,
	  _react2.default.createElement(
	    'td',
	    null,
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PLUSGIRO_RECIPIENT' }),
	    ':'
	  ),
	  _react2.default.createElement(
	    'td',
	    null,
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PLUSGIRO_RECIPIENT_NAME' })
	  )
	);
	
	var _ref9 = _react2.default.createElement(
	  'td',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'OCR' }),
	  ':'
	);
	
	var _ref10 = _react2.default.createElement(
	  'td',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PAYMENT_PAGE_TO_PAY' }),
	  ':'
	);
	
	var _ref11 = _react2.default.createElement(
	  'header',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PAY_WITH_SWISH' })
	);
	
	var _ref12 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PAYMENT_PAGE_TO_PAY' });
	
	var _ref13 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PAY_WITH_SWISH' });
	
	var _ref14 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CANCEL' });
	
	var PaymentStart = function (_React$Component) {
	  (0, _inherits3.default)(PaymentStart, _React$Component);
	
	  function PaymentStart(props) {
	    (0, _classCallCheck3.default)(this, PaymentStart);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PaymentStart.__proto__ || (0, _getPrototypeOf2.default)(PaymentStart)).call(this, props));
	
	    _this.swishUrl = function () {
	      return 'swish://paymentrequest?token=' + _this.props.payment.paymentRequest.data.attributes.token + '&callbackurl=' + _this.swishCallbackUrl();
	    };
	
	    _this.swishCallbackUrl = function () {
	      return window.location.href + '/status';
	    };
	
	    _this.startPayment = function (event) {
	      event.preventDefault();
	      _this.props.createPaymentRequest(_this.props.payment.invoice.data.uuid).then(function () {
	        window.location.href = _this.swishUrl();
	      });
	    };
	
	    _this.toggleInvoiceSpecification = function () {
	      _this.setState({
	        showInvoiceSpecification: !_this.state.showInvoiceSpecification,
	        showPlusgiroInfo: false
	      });
	    };
	
	    _this.togglePlusgiroInfo = function () {
	      _this.setState({
	        showInvoiceSpecification: false,
	        showPlusgiroInfo: !_this.state.showPlusgiroInfo
	      });
	    };
	
	    _this.renderInvoiceSpecificationButton = function () {
	      var translationKey = _this.state.showInvoiceSpecification ? 'MINIMIZE' : 'SEE_INVOICE_SPECIFICATION';
	      return _react2.default.createElement(
	        'button',
	        { className: 'btn outlined blue', onClick: _this.toggleInvoiceSpecification },
	        _react2.default.createElement(_reactTranslateComponent2.default, { content: translationKey })
	      );
	    };
	
	    _this.renderInvoiceSpecification = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'invoice-specification' },
	        _react2.default.createElement(
	          'table',
	          null,
	          _react2.default.createElement(
	            'tbody',
	            null,
	            (_this.props.payment.invoice.data.calculation.is_rot || _this.props.payment.invoice.data.calculation.is_rut) && _react2.default.createElement(
	              'tr',
	              null,
	              _ref,
	              _react2.default.createElement(
	                'td',
	                null,
	                _this.props.payment.invoice.data.calculation.household_service_deducted_amount_including_vat,
	                '\xA0',
	                _this.props.payment.invoice.data.currencyName
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _ref2,
	              _react2.default.createElement(
	                'td',
	                null,
	                _this.props.payment.invoice.data.calculation.amount,
	                ' ',
	                _this.props.payment.invoice.data.currencyName
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                _ref3,
	                ' (',
	                _this.props.payment.invoice.data.taxPercent,
	                '%):'
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                _this.props.payment.invoice.data.calculation.vat,
	                ' ',
	                _this.props.payment.invoice.data.currencyName
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _ref4,
	              _react2.default.createElement(
	                'td',
	                null,
	                _this.props.payment.invoice.data.calculation.amount_including_vat,
	                '\xA0',
	                _this.props.payment.invoice.data.currencyName
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: _this.props.payment.invoice.data.pdfLink, className: 'btn btn-sm invoice-specification-download' },
	          _ref5
	        )
	      );
	    };
	
	    _this.renderPlusgiroButton = function () {
	      var translationKey = _this.state.showPlusgiroInfo ? 'MINIMIZE' : 'PAY_WITH_PLUSGIRO';
	      return _react2.default.createElement(
	        'button',
	        { className: 'btn outlined blue', onClick: _this.togglePlusgiroInfo },
	        _react2.default.createElement(_reactTranslateComponent2.default, { content: translationKey })
	      );
	    };
	
	    _this.renderPlusgiroInfo = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'plusgiro-info' },
	        _ref6,
	        _react2.default.createElement(
	          'table',
	          null,
	          _react2.default.createElement(
	            'tbody',
	            null,
	            _ref7,
	            _ref8,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _ref9,
	              _react2.default.createElement(
	                'td',
	                null,
	                _this.props.payment.invoice.data.ocr
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _ref10,
	              _react2.default.createElement(
	                'td',
	                null,
	                Math.round(_this.props.payment.invoice.data.calculation.amount_including_vat),
	                '\xA0',
	                _this.props.payment.invoice.data.currencyName
	              )
	            )
	          )
	        )
	      );
	    };
	
	    _this.render = function () {
	      var name = _this.props.payment.invoice.data.users.first_name + ' ' + _this.props.payment.invoice.data.users.last_name;
	      return _react2.default.createElement(
	        'div',
	        { className: 'payment-page' },
	        _ref11,
	        _react2.default.createElement(
	          'section',
	          { className: 'logo' },
	          _react2.default.createElement('img', { src: __webpack_require__(316), alt: 'Frilans Finans-logotyp' })
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'specification' },
	          _react2.default.createElement(
	            'div',
	            { className: 'specification-from' },
	            _react2.default.createElement(_reactTranslateComponent2.default, { name: name, content: 'PAYMENT_START_FROM_NAME' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'specification-description' },
	            _this.props.payment.invoice.data.specification
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'specification-amount' },
	            _ref12,
	            ':\xA0',
	            Math.round(_this.props.payment.invoice.data.calculation.amount_including_vat),
	            '\xA0',
	            _this.props.payment.invoice.data.currencyName
	          )
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'buttons' },
	          _react2.default.createElement(
	            'a',
	            { className: 'btn', onClick: _this.startPayment },
	            _ref13
	          ),
	          _this.renderInvoiceSpecificationButton(),
	          _this.state.showInvoiceSpecification && _this.renderInvoiceSpecification(),
	          _this.renderPlusgiroButton(),
	          _this.state.showPlusgiroInfo && _this.renderPlusgiroInfo()
	        ),
	        _react2.default.createElement(
	          'footer',
	          null,
	          _react2.default.createElement(
	            'a',
	            { className: 'generic-link', onClick: _this.props.cancel },
	            _ref14
	          )
	        )
	      );
	    };
	
	    _this.state = {
	      showInvoiceSpecification: false,
	      showPlusgiroInfo: false
	    };
	    return _this;
	  }
	
	  return PaymentStart;
	}(_react2.default.Component);
	
	exports.default = PaymentStart;

/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(72);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _payment = __webpack_require__(366);
	
	var _timer = __webpack_require__(841);
	
	var _index = __webpack_require__(382);
	
	var _invoiceConstants = __webpack_require__(219);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(_index.SpinnerPage, null);
	
	var PaymentStatusPage = function (_React$Component) {
	  (0, _inherits3.default)(PaymentStatusPage, _React$Component);
	
	  function PaymentStatusPage(props) {
	    (0, _classCallCheck3.default)(this, PaymentStatusPage);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PaymentStatusPage.__proto__ || (0, _getPrototypeOf2.default)(PaymentStatusPage)).call(this, props));
	
	    _this.componentDidMount = function () {
	      _this.props.fetchInvoice(_this.props.params.uuid, ['calculation']).then(function (invoice) {
	        if (invoice.paymentStatus !== _invoiceConstants.paidPaymentStatus) {
	          _this.props.startTimer(function (dispatch, getState) {
	            var _getState = getState(),
	                payment = _getState.payment;
	
	            if (payment.paymentRequest.data.status !== null) {
	              _this.props.stopTimer();
	              return _promise2.default.resolve();
	            }
	
	            return _this.props.getLatestPaymentRequest();
	          });
	        }
	      });
	    };
	
	    _this.render = function () {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _this.props.componentToRender === 'spinner' && _ref,
	        _this.props.componentToRender === 'paid' && _react2.default.createElement(_index.PaymentPaid, { invoice: _this.props.payment.invoice, createInvoiceEmail: _this.props.createInvoiceEmail }),
	        _this.props.componentToRender === 'start' && _react2.default.createElement(_index.PaymentStart, { payment: _this.props.payment }),
	        _this.props.componentToRender === 'error' && _react2.default.createElement(_index.PaymentError, { payment: _this.props.payment }),
	        _this.props.componentToRender === 'cancel' && _react2.default.createElement(_index.PaymentCancel, { payment: _this.props.payment }),
	        _this.props.componentToRender === 'credit' && _react2.default.createElement(_index.PaymentCredit, { payment: _this.props.payment })
	      );
	    };
	
	    _this.state = {
	      email: null,
	      status: null
	    };
	
	    _this.invoice = _this.props.payment.invoice.data;
	    return _this;
	  }
	
	  return PaymentStatusPage;
	}(_react2.default.Component);
	
	var componentToRender = function componentToRender(payment, timer) {
	  if (payment.invoice.status === 'error' || payment.paymentRequest.status === 'error' || timer.status === 'timeout') {
	    return 'error';
	  } else if (payment.invoice.status === 'success' && payment.invoice.data.status === _invoiceConstants.creditedPaymentStatus) {
	    return 'credit';
	  } else if (payment.invoice.status === 'success' && payment.invoice.data.paymentStatus === _invoiceConstants.paidPaymentStatus) {
	    return 'paid';
	  } else if (payment.invoice.status === 'success' && payment.paymentRequest.status === 'success') {
	    if (payment.paymentRequest.data.status === 'PAID') return 'paid';
	    if (payment.paymentRequest.data.status === 'ERROR') return 'error';
	    if (payment.paymentRequest.data.status === 'DECLINED') return 'cancel';
	    if (payment.paymentRequest.data.status === null) return 'spinner';
	    return 'error';
	  } else {
	    return 'spinner';
	  }
	};
	
	var mapStateToProps = function mapStateToProps(_ref2) {
	  var payment = _ref2.payment,
	      timer = _ref2.timer;
	  return {
	    payment: payment,
	    componentToRender: componentToRender(payment, timer)
	  };
	};
	
	var mapDispatchToProps = {
	  startTimer: _timer.startTimer,
	  stopTimer: _timer.stopTimer,
	  fetchInvoice: _payment.fetchInvoice,
	  getLatestPaymentRequest: _payment.getLatestPaymentRequest,
	  createInvoiceEmail: _payment.createInvoiceEmail
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PaymentStatusPage);

/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RegisterSettings = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _personalInfo = __webpack_require__(230);
	
	var _personalInfo2 = _interopRequireDefault(_personalInfo);
	
	var _salaryInfo = __webpack_require__(232);
	
	var _salaryInfo2 = _interopRequireDefault(_salaryInfo);
	
	var _ownEmployment = __webpack_require__(229);
	
	var _ownEmployment2 = _interopRequireDefault(_ownEmployment);
	
	var _changePassword = __webpack_require__(228);
	
	var _changePassword2 = _interopRequireDefault(_changePassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'register-settings' },
	  _react2.default.createElement(_personalInfo2.default, null),
	  _react2.default.createElement(_salaryInfo2.default, null),
	  _react2.default.createElement(_ownEmployment2.default, null),
	  _react2.default.createElement(_changePassword2.default, null)
	); /**
	    * Created by staffanrantzow on 15/03/16.
	    */
	
	
	var RegisterSettings = exports.RegisterSettings = function (_React$Component) {
	  (0, _inherits3.default)(RegisterSettings, _React$Component);
	
	  function RegisterSettings() {
	    (0, _classCallCheck3.default)(this, RegisterSettings);
	    return (0, _possibleConstructorReturn3.default)(this, (RegisterSettings.__proto__ || (0, _getPrototypeOf2.default)(RegisterSettings)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(RegisterSettings, [{
	    key: 'render',
	    value: function render() {
	      return _ref;
	    }
	  }]);
	  return RegisterSettings;
	}(_react2.default.Component);
	
	exports.default = RegisterSettings;

/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RegisterView = undefined;
	
	var _assign = __webpack_require__(22);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _components = __webpack_require__(13);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _utils = __webpack_require__(29);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _loginBottomElement = __webpack_require__(165);
	
	var _loginBottomElement2 = _interopRequireDefault(_loginBottomElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'p',
	  { className: 'error' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'PASSWORD_NOT_EQUAL' })
	);
	
	var _ref2 = _react2.default.createElement(
	  'p',
	  { className: 'error' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'EMAIL_NOT_EQUAL' })
	);
	
	var _ref3 = _react2.default.createElement(_components.GeneralError, null);
	
	var _ref4 = _react2.default.createElement(
	  'p',
	  { className: 'info' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'CREATE_ACCOUNT_SUCCESS_MSG' })
	);
	
	var _ref5 = _react2.default.createElement(
	  'label',
	  { htmlFor: 'privacy-policy' },
	  _react2.default.createElement('span', null)
	);
	
	var _ref6 = _react2.default.createElement(_components.PrivacyPolicy, null);
	
	var _ref7 = _react2.default.createElement(
	  'div',
	  { className: 'pt-20' },
	  _react2.default.createElement(_components.GeneralTerms, null)
	);
	
	var RegisterView = exports.RegisterView = function (_Component) {
	  (0, _inherits3.default)(RegisterView, _Component);
	
	  function RegisterView(props) {
	    (0, _classCallCheck3.default)(this, RegisterView);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (RegisterView.__proto__ || (0, _getPrototypeOf2.default)(RegisterView)).call(this, props));
	
	    _this.state = {
	      formValues: {
	        firstName: {
	          value: '',
	          valid: false
	        },
	        lastName: {
	          value: '',
	          valid: false
	        },
	        email: {
	          value: '',
	          valid: false
	        },
	        password: {}
	      },
	      emailNotEqual: false,
	      passwordNotEqual: false,
	      showErrorWithoutBlur: false,
	      hasAgreedToPrivacyPolicy: false,
	      error: false,
	      loading: false,
	      postSuccess: false
	    };
	
	    _this.callback = _this.callback.bind(_this);
	    _this.submitForm = _this.submitForm.bind(_this);
	    _this.toggleHasAgreedToPrivacyPolicy = _this.toggleHasAgreedToPrivacyPolicy.bind(_this);
	    _this.validInputs = _this.validInputs.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(RegisterView, [{
	    key: 'callback',
	    value: function callback(name, values) {
	      var tempFormValues = this.state.formValues;
	
	      (0, _assign2.default)(tempFormValues[name], values);
	      this.setState({ formValues: tempFormValues });
	    }
	  }, {
	    key: 'validInputs',
	    value: function validInputs() {
	      return this.state.formValues.firstName.value && this.state.formValues.firstName.valid && this.state.formValues.lastName.value && this.state.formValues.lastName.valid && this.state.formValues.email.value && this.state.formValues.email.valid && this.state.formValues.password.value && this.state.formValues.password.valid;
	    }
	  }, {
	    key: 'registerWithEmailGtmEvent',
	    value: function registerWithEmailGtmEvent(params) {
	      if (window.dataLayer) {
	        window.dataLayer.push({
	          'event': 'emailRegistration',
	          'userData': {
	            'email': params.email
	          }
	        });
	      }
	    }
	  }, {
	    key: 'registerUser',
	    value: function registerUser() {
	      var _this2 = this;
	
	      var params = _utils2.default.getPostParams(this.state.formValues);
	
	      _frilansFinans.UserService.post(params).then(function () {
	        _this2.setState({
	          postSuccess: true
	        });
	        _this2.registerWithEmailGtmEvent(params);
	      }).catch(function (error) {
	        var errors = _frilansFinans.UserService.getError(error);
	
	        _this2.setState({
	          error: true,
	          loading: false,
	          errorMessage: errors
	        });
	      });
	    }
	  }, {
	    key: 'toggleHasAgreedToPrivacyPolicy',
	    value: function toggleHasAgreedToPrivacyPolicy() {
	      this.setState({
	        hasAgreedToPrivacyPolicy: !this.state.hasAgreedToPrivacyPolicy
	      });
	    }
	  }, {
	    key: 'submitForm',
	    value: function submitForm(e) {
	      var _this3 = this;
	
	      e.preventDefault();
	
	      this.setState({ showErrorWithoutBlur: true }, function () {
	        if (_utils2.default.validateInputValues(_this3.state.formValues)) {
	          _this3.setState({
	            loading: true
	          }, _this3.registerUser);
	        }
	      });
	    }
	  }, {
	    key: 'renderPasswordError',
	    value: function renderPasswordError() {
	      if (this.state.passwordNotEqual) {
	        return _ref;
	      }
	    }
	  }, {
	    key: 'renderEmailError',
	    value: function renderEmailError() {
	      if (this.state.emailNotEqual) {
	        return _ref2;
	      }
	    }
	  }, {
	    key: 'renderError',
	    value: function renderError() {
	      if (this.state.error) {
	        if (!this.state.errorMessage) {
	          return _ref3;
	        } else {
	          return _react2.default.createElement(
	            'div',
	            null,
	            this.state.errorMessage.map(function (error, i) {
	              return _react2.default.createElement(
	                'p',
	                { className: 'error', key: i },
	                error
	              );
	            })
	          );
	        }
	      }
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      if (this.state.postSuccess) {
	        return _ref4;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'form',
	          { noValidate: true, onSubmit: this.submitForm },
	          _react2.default.createElement(
	            'div',
	            { className: 'register-input-row' },
	            _react2.default.createElement(_components.InputField, {
	              classes: 'register-form-field',
	              type: 'text',
	              name: 'firstName',
	              value: this.state.formValues.firstName.value,
	              placeholder: (0, _proxyCounterpart.proxyCounterpart)('FIRST_NAME'), callback: this.callback,
	              required: 'true',
	              minLength: '2',
	              errorMessage: (0, _proxyCounterpart.proxyCounterpart)('FIRST_NAME_ERROR'),
	              showErrorWithoutBlur: this.state.showErrorWithoutBlur
	            }),
	            _react2.default.createElement(_components.InputField, {
	              classes: 'register-form-field',
	              type: 'text',
	              name: 'lastName',
	              value: this.state.formValues.lastName.value,
	              placeholder: (0, _proxyCounterpart.proxyCounterpart)('LAST_NAME'),
	              callback: this.callback,
	              required: 'true',
	              minLength: '2',
	              errorMessage: (0, _proxyCounterpart.proxyCounterpart)('LAST_NAME_ERROR'),
	              showErrorWithoutBlur: this.state.showErrorWithoutBlur
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'register-input-row' },
	            _react2.default.createElement(_components.InputField, {
	              classes: 'register-form-field',
	              type: 'email',
	              validationType: 'email',
	              name: 'email',
	              value: this.state.formValues.email.value,
	              placeholder: (0, _proxyCounterpart.proxyCounterpart)('EMAIL'),
	              callback: this.callback,
	              required: 'true',
	              minLength: '5',
	              errorMessage: (0, _proxyCounterpart.proxyCounterpart)('EMAIL_ERROR'),
	              showErrorWithoutBlur: this.state.showErrorWithoutBlur
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'register-input-row' },
	            _react2.default.createElement(_components.InputField, {
	              classes: 'register-form-field',
	              type: 'password',
	              name: 'password',
	              placeholder: (0, _proxyCounterpart.proxyCounterpart)('PASSWORD'),
	              callback: this.callback,
	              required: 'true',
	              minLength: '12',
	              validationType: 'passwordRegistration',
	              errorMessage: (0, _proxyCounterpart.proxyCounterpart)('PASSWORD_ERROR'),
	              showErrorWithoutBlur: this.state.showErrorWithoutBlur,
	              showPasswordIcon: true
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'register-terms-container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'checkbox-holder checkbox-container' },
	              _react2.default.createElement('input', {
	                id: 'privacy-policy',
	                type: 'checkbox',
	                name: 'hasAgreedToPrivacyPolicy',
	                onClick: this.toggleHasAgreedToPrivacyPolicy
	              }),
	              _ref5,
	              _ref6
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            this.renderError(),
	            this.renderEmailError(),
	            this.renderPasswordError()
	          ),
	          _react2.default.createElement(_components.SpinnerButton, {
	            id: 'login-button',
	            text: (0, _proxyCounterpart.proxyCounterpart)('CREATE_ACCOUNT'),
	            loading: this.state.loading,
	            disabled: !this.validInputs() || !this.state.hasAgreedToPrivacyPolicy,
	            classes: 'btn cover' }),
	          _ref7,
	          _react2.default.createElement(_loginBottomElement2.default, { handleClick: this.props.switchView })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.renderContent();
	    }
	  }]);
	  return RegisterView;
	}(_react.Component);
	
	exports.default = RegisterView;

/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _components = __webpack_require__(13);
	
	var _variables = __webpack_require__(47);
	
	var variables = _interopRequireWildcard(_variables);
	
	var _loginBottomElement = __webpack_require__(165);
	
	var _loginBottomElement2 = _interopRequireDefault(_loginBottomElement);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  null,
	  _react2.default.createElement(
	    'div',
	    { className: 'pt-20' },
	    _react2.default.createElement(_components.GeneralTerms, null)
	  )
	);
	
	var _ref2 = _react2.default.createElement(
	  'label',
	  { htmlFor: 'privacy-policy' },
	  _react2.default.createElement('span', null)
	);
	
	var _ref3 = _react2.default.createElement(_components.PrivacyPolicy, null);
	
	var RegisterWithEidView = function (_Component) {
	  (0, _inherits3.default)(RegisterWithEidView, _Component);
	
	  function RegisterWithEidView(props) {
	    (0, _classCallCheck3.default)(this, RegisterWithEidView);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (RegisterWithEidView.__proto__ || (0, _getPrototypeOf2.default)(RegisterWithEidView)).call(this, props));
	
	    _this.state = {
	      hasAgreedToPrivacyPolicy: false,
	      isLoading: false
	    };
	
	    _this.toggleHasAgreedToPrivacyPolicy = _this.toggleHasAgreedToPrivacyPolicy.bind(_this);
	    _this.openEIDAuth = _this.openEIDAuth.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(RegisterWithEidView, [{
	    key: 'openEIDAuth',
	    value: function openEIDAuth() {
	      this.setState({
	        isLoading: true
	      });
	      var returnProtocol = variables.appEnv === 'development' ? 'http://' : 'https://';
	      var returnUrl = returnProtocol + variables.appUrl + '/eid-link-register';
	      var eidAuthUrl = variables.eidUrl + '/start-redirect?return_url=' + returnUrl;
	      window.location = eidAuthUrl;
	    }
	  }, {
	    key: 'toggleHasAgreedToPrivacyPolicy',
	    value: function toggleHasAgreedToPrivacyPolicy() {
	      this.setState({
	        hasAgreedToPrivacyPolicy: !this.state.hasAgreedToPrivacyPolicy
	      });
	    }
	  }, {
	    key: 'renderGeneralTerms',
	    value: function renderGeneralTerms() {
	      return _ref;
	    }
	  }, {
	    key: 'renderPrivacyPolicy',
	    value: function renderPrivacyPolicy() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'checkbox-holder checkbox-container' },
	        _react2.default.createElement('input', {
	          id: 'privacy-policy',
	          type: 'checkbox',
	          name: 'hasAgreedToPrivacyPolicy',
	          onClick: this.toggleHasAgreedToPrivacyPolicy
	        }),
	        _ref2,
	        _ref3
	      );
	    }
	  }, {
	    key: 'renderCreateAccountWithBankIdButton',
	    value: function renderCreateAccountWithBankIdButton() {
	      var isDisabled = !this.state.hasAgreedToPrivacyPolicy;
	
	      return _react2.default.createElement(_components.SpinnerButton, {
	        id: 'login-button',
	        text: (0, _proxyCounterpart.proxyCounterpart)('CREATE_ACCOUNT_WITH_BANKID'),
	        loading: this.state.isLoading,
	        classes: 'btn cover',
	        callback: this.openEIDAuth,
	        disabled: isDisabled
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.renderPrivacyPolicy(),
	        _react2.default.createElement(
	          'div',
	          null,
	          this.renderCreateAccountWithBankIdButton(),
	          this.renderGeneralTerms(),
	          _react2.default.createElement(_loginBottomElement2.default, {
	            isBankID: true,
	            handleClick: this.props.switchView
	          })
	        )
	      );
	    }
	  }]);
	  return RegisterWithEidView;
	}(_react.Component);
	
	exports.default = RegisterWithEidView;

/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _reactRedux = __webpack_require__(12);
	
	var _registerView = __webpack_require__(983);
	
	var _registerView2 = _interopRequireDefault(_registerView);
	
	var _registerWithEidView = __webpack_require__(984);
	
	var _registerWithEidView2 = _interopRequireDefault(_registerWithEidView);
	
	__webpack_require__(1298);
	
	var _reactRouter = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  _reactRouter.Link,
	  { to: '/login' },
	  _react2.default.createElement(_reactTranslateComponent2.default, {
	    className: 'register-type-selection-button',
	    content: 'LOGIN'
	  })
	);
	
	var _ref2 = _react2.default.createElement(_reactTranslateComponent2.default, { className: 'login-title', content: 'CREATE_ACCOUNT' });
	
	var RegisterDetails = function (_Component) {
	  (0, _inherits3.default)(RegisterDetails, _Component);
	
	  function RegisterDetails(props) {
	    (0, _classCallCheck3.default)(this, RegisterDetails);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (RegisterDetails.__proto__ || (0, _getPrototypeOf2.default)(RegisterDetails)).call(this, props));
	
	    _this.state = {
	      show: 'BANKID'
	    };
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(RegisterDetails, [{
	    key: 'handleClick',
	    value: function handleClick(event) {
	      var id = event.target.id;
	      this.setState({
	        show: id
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var showContent = void 0;
	      if (this.state.show === 'BANKID') {
	        showContent = _react2.default.createElement(_registerWithEidView2.default, {
	          switchView: this.handleClick
	        });
	      } else {
	        showContent = _react2.default.createElement(_registerView2.default, {
	          switchView: this.handleClick
	        });
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'register-details' },
	        _react2.default.createElement(
	          'div',
	          { className: 'register-top-section' },
	          _react2.default.createElement(
	            'div',
	            { className: 'register-logo' },
	            _react2.default.createElement(
	              'object',
	              { type: 'image/svg+xml',
	                data: __webpack_require__(657),
	                alt: 'Frilans Finans-logotyp' },
	              _react2.default.createElement('img', { src: __webpack_require__(207), alt: 'Frilans Finans-logotyp' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'login-type-selection' },
	            _ref,
	            _react2.default.createElement(_reactTranslateComponent2.default, {
	              id: 'BANKID',
	              className: 'register-type-selection-button active',
	              onClick: this.handleClick,
	              content: 'CREATE_ACCOUNT'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'register-bottom-section' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section-content' },
	            _ref2,
	            showContent
	          )
	        )
	      );
	    }
	  }]);
	  return RegisterDetails;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    tab: state.router.locationBeforeTransitions.query.tab
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(RegisterDetails);

/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _check = __webpack_require__(212);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _logoInvoiceWithoutCompany = __webpack_require__(737);
	
	var _logoInvoiceWithoutCompany2 = _interopRequireDefault(_logoInvoiceWithoutCompany);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'register-information' },
	  _react2.default.createElement(_logoInvoiceWithoutCompany2.default, { colorSchema: 'white' }),
	  _react2.default.createElement(
	    'ul',
	    { className: 'perk-list' },
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(_check2.default, { colorSchema: 'white' }),
	      _react2.default.createElement(_reactTranslateComponent2.default, {
	        className: 'perk-list-item',
	        content: 'LOGIN_REGISTER_PERK_FREE_ACCOUNT'
	      })
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(_check2.default, { colorSchema: 'white' }),
	      _react2.default.createElement(_reactTranslateComponent2.default, {
	        className: 'perk-list-item',
	        content: 'LOGIN_REGISTER_PERK_PAPERS'
	      })
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(_check2.default, { colorSchema: 'white' }),
	      _react2.default.createElement(_reactTranslateComponent2.default, {
	        className: 'perk-list-item',
	        content: 'LOGIN_REGISTER_PERK_WALLET'
	      })
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(_check2.default, { colorSchema: 'white' }),
	      _react2.default.createElement(_reactTranslateComponent2.default, {
	        className: 'perk-list-item',
	        content: 'LOGIN_REGISTER_PERK_JUMPING'
	      })
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(_check2.default, { colorSchema: 'white' }),
	      _react2.default.createElement(_reactTranslateComponent2.default, {
	        className: 'perk-list-item',
	        content: 'LOGIN_REGISTER_PERK_HEADPHONE'
	      })
	    )
	  )
	);
	
	var RegisterInformation = function (_Component) {
	  (0, _inherits3.default)(RegisterInformation, _Component);
	
	  function RegisterInformation() {
	    (0, _classCallCheck3.default)(this, RegisterInformation);
	    return (0, _possibleConstructorReturn3.default)(this, (RegisterInformation.__proto__ || (0, _getPrototypeOf2.default)(RegisterInformation)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(RegisterInformation, [{
	    key: 'render',
	    value: function render() {
	      return _ref;
	    }
	  }]);
	  return RegisterInformation;
	}(_react.Component);
	
	exports.default = RegisterInformation;

/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _index = __webpack_require__(225);
	
	var _registerDetails = __webpack_require__(985);
	
	var _registerDetails2 = _interopRequireDefault(_registerDetails);
	
	var _registerInformation = __webpack_require__(986);
	
	var _registerInformation2 = _interopRequireDefault(_registerInformation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'register-page page' },
	  _react2.default.createElement(
	    'div',
	    { className: 'register-container' },
	    _react2.default.createElement(_registerDetails2.default, null),
	    _react2.default.createElement(_registerInformation2.default, null)
	  )
	);
	
	var RegisterTabs = function (_Component) {
	  (0, _inherits3.default)(RegisterTabs, _Component);
	
	  function RegisterTabs() {
	    (0, _classCallCheck3.default)(this, RegisterTabs);
	    return (0, _possibleConstructorReturn3.default)(this, (RegisterTabs.__proto__ || (0, _getPrototypeOf2.default)(RegisterTabs)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(RegisterTabs, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.setHideFooter();
	      this.props.setHideHeader();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _ref;
	    }
	  }]);
	  return RegisterTabs;
	}(_react.Component);
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    setHideFooter: function setHideFooter() {
	      return dispatch((0, _index.setHideFooter)());
	    },
	    setHideHeader: function setHideHeader() {
	      return dispatch((0, _index.setHideHeader)());
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(RegisterTabs);

/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _components = __webpack_require__(13);
	
	var _frilansFinans = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'p',
	  { className: 'info' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'RESET_PASSWORD_SUCCESS' })
	);
	
	var _ref2 = _react2.default.createElement(_components.GeneralError, null);
	
	var ConfirmEmail = function (_Component) {
	  (0, _inherits3.default)(ConfirmEmail, _Component);
	
	  function ConfirmEmail(props) {
	    (0, _classCallCheck3.default)(this, ConfirmEmail);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ConfirmEmail.__proto__ || (0, _getPrototypeOf2.default)(ConfirmEmail)).call(this, props));
	
	    _this.state = {
	      loading: false,
	      error: true,
	      errorMessage: [(0, _proxyCounterpart.proxyCounterpart)('EMAIL_NOT_CONFIRMED', { email: _this.props.email })]
	    };
	
	    _this.resetPassword = _this.resetPassword.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(ConfirmEmail, [{
	    key: 'resetPassword',
	    value: function resetPassword(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	      this.setState({
	        loading: true
	      });
	
	      _frilansFinans.UserService.resetPassword(this.props.email).then(function () {
	        _this2.setState({
	          loading: false,
	          error: false
	        });
	      }).catch(function (error) {
	        var errors = _frilansFinans.UserService.getError(error);
	
	        _this2.setState({
	          loading: false,
	          error: true,
	          errorMessage: errors
	        });
	      });
	    }
	  }, {
	    key: 'success',
	    value: function success() {
	      return !this.state.error && !this.state.loading;
	    }
	  }, {
	    key: 'renderSuccess',
	    value: function renderSuccess() {
	      if (this.success()) {
	        return _ref;
	      }
	    }
	  }, {
	    key: 'renderError',
	    value: function renderError() {
	      if (this.state.error) {
	        if (!this.state.errorMessage) {
	          return _ref2;
	        } else {
	          return _react2.default.createElement(
	            'div',
	            null,
	            this.state.errorMessage.map(function (error, i) {
	              return _react2.default.createElement(
	                'p',
	                { className: 'error', key: i },
	                error
	              );
	            })
	          );
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.emailConfirmed) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'mb35' },
	          this.renderError(),
	          this.renderSuccess(),
	          _react2.default.createElement(_components.SpinnerButton, { text: (0, _proxyCounterpart.proxyCounterpart)('SEND_VERIFICATION_MAIL'),
	            loading: this.state.loading,
	            classes: 'btn',
	            disabled: this.success(),
	            callback: this.resetPassword })
	        );
	      } else {
	        return null;
	      }
	    }
	  }]);
	  return ConfirmEmail;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    email: state.user.email,
	    emailConfirmed: state.user.emailConfirmed
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ConfirmEmail);

/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UploadLogotype = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// https://github.com/okonet/react-dropzone
	/**
	 * Created by staffanrantzow on 16/03/16.
	 */
	
	var Dropzone = __webpack_require__(619);
	
	var _ref = _react2.default.createElement('div', { className: 'cornerimage remove-link' });
	
	var _ref2 = _react2.default.createElement(
	  'h3',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'USE_LOGO' })
	);
	
	var _ref3 = _react2.default.createElement(
	  'p',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'USE_LOGO_TEXT' })
	);
	
	var _ref4 = _react2.default.createElement('div', { className: 'new_line' });
	
	var _ref5 = _react2.default.createElement(
	  'div',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'LOGO_INSTRUCTIONS' })
	);
	
	var _ref6 = _react2.default.createElement(_reactTranslateComponent2.default, { content: 'LOGO_ERROR' });
	
	var UploadLogotype = exports.UploadLogotype = function (_React$Component) {
	  (0, _inherits3.default)(UploadLogotype, _React$Component);
	
	  function UploadLogotype(props) {
	    (0, _classCallCheck3.default)(this, UploadLogotype);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (UploadLogotype.__proto__ || (0, _getPrototypeOf2.default)(UploadLogotype)).call(this, props));
	
	    _this.state = {
	      files: [],
	      imageSrc: _this.props.imageSrc,
	      invalidFile: false,
	      logotypePreview: false,
	      logotypeDeleted: false
	    };
	
	    _this.showPreview = _this.showPreview.bind(_this);
	    _this.onDrop = _this.onDrop.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(UploadLogotype, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.logotypeDeleted !== this.props.logotypeDeleted) {
	        if (nextProps.logotypeDeleted) {
	          this.setState({
	            imageSrc: ''
	          });
	        }
	
	        this.setState({
	          logotypeDeleted: nextProps.logotypeDeleted
	        });
	      }
	
	      if (nextProps.logotypePreview !== this.state.logotypePreview) {
	        this.setState({
	          logotypePreview: nextProps.logotypePreview
	        });
	      }
	    }
	  }, {
	    key: 'validate',
	    value: function validate(file) {
	      var validFileExtensions, validFileSize, typeValid;
	
	      validFileExtensions = ['image/jpeg', 'image/jpg', 'image/png'];
	      validFileSize = 2097152;
	      typeValid = false;
	
	      if (file.size > validFileSize) {
	        return false;
	      }
	
	      for (var i = 0; i < validFileExtensions.length; i++) {
	        if (file.type === validFileExtensions[i]) {
	          typeValid = true;
	          break;
	        }
	      }
	
	      return typeValid;
	    }
	  }, {
	    key: 'onDrop',
	    value: function onDrop(files) {
	      if (this.validate(files[0])) {
	        this.setState({
	          files: files,
	          invalidFile: false
	        }, function () {
	          this.showPreview(this.state.files[0].preview);
	        });
	
	        this.props.setLogotype(files[0]);
	      } else {
	        this.setState({ invalidFile: true });
	      }
	    }
	  }, {
	    key: 'showPreview',
	    value: function showPreview(imageSrc) {
	      this.setState({
	        imageSrc: imageSrc,
	        logotypePreview: true
	      });
	    }
	  }, {
	    key: 'renderLogoDeleteButton',
	    value: function renderLogoDeleteButton() {
	      if (this.state.imageSrc && !this.state.logotypePreview) {
	        return _react2.default.createElement(
	          'button',
	          { className: 'menu-btn close-menu', onClick: this.props.deleteLogotype },
	          _ref
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'upload-logotype' },
	        _ref2,
	        _ref3,
	        _react2.default.createElement(
	          'div',
	          { className: 'containerdiv' },
	          _react2.default.createElement('img', { src: this.state.imageSrc, alt: '' }),
	          this.renderLogoDeleteButton()
	        ),
	        _ref4,
	        _react2.default.createElement(
	          Dropzone,
	          { ref: 'dropzone', onDrop: this.onDrop, className: 'drop-zone', multiple: false },
	          _ref5
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: this.state.invalidFile ? 'error show' : 'error' },
	          _ref6
	        )
	      );
	    }
	  }]);
	  return UploadLogotype;
	}(_react2.default.Component);
	
	exports.default = UploadLogotype;

/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _inputFieldSimple = __webpack_require__(329);
	
	var _inputFieldSimple2 = _interopRequireDefault(_inputFieldSimple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AccountNumberField = function (_React$Component) {
	  (0, _inherits3.default)(AccountNumberField, _React$Component);
	
	  function AccountNumberField(props, context) {
	    (0, _classCallCheck3.default)(this, AccountNumberField);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (AccountNumberField.__proto__ || (0, _getPrototypeOf2.default)(AccountNumberField)).call(this, props, context));
	
	    _this.state = {
	      name: 'accountNr',
	      type: 'text',
	      isDisabled: _this.props.selectedBank === 'INITIAL',
	      isVisible: true,
	      label: (0, _proxyCounterpart.proxyCounterpart)('ACCOUNT_NR_LABEL_' + props.selectedBank),
	      placeholder: (0, _proxyCounterpart.proxyCounterpart)('ACCOUNT_NR_PLACEHOLDER_' + props.selectedBank)
	    };
	
	    _this.accountNumberElement = null;
	    _this.setAccountNumberElement = _this.setAccountNumberElement.bind(_this);
	
	    _this.changedAccountNumber = _this.changedAccountNumber.bind(_this);
	    _this.blurredAccountNumber = _this.blurredAccountNumber.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(AccountNumberField, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.selectedBank !== nextProps.selectedBank) {
	        this.setState({
	          isDisabled: nextProps.selectedBank === 'INITIAL',
	          label: (0, _proxyCounterpart.proxyCounterpart)('ACCOUNT_NR_LABEL_' + nextProps.selectedBank),
	          placeholder: (0, _proxyCounterpart.proxyCounterpart)('ACCOUNT_NR_PLACEHOLDER_' + nextProps.selectedBank)
	        });
	      }
	    }
	  }, {
	    key: 'format',
	    value: function format(value) {
	      if (this.props.selectedBank === 'IBAN') {
	        value = value.toUpperCase();
	      }
	      return value.replace(/[ .,_-]/g, '').trim();
	    }
	  }, {
	    key: 'changedAccountNumber',
	    value: function changedAccountNumber(value) {
	      value = this.format(value);
	      this.props.changed(value);
	    }
	  }, {
	    key: 'blurredAccountNumber',
	    value: function blurredAccountNumber(value) {
	      value = this.format(value);
	      this.props.blurred(value);
	    }
	  }, {
	    key: 'setAccountNumberElement',
	    value: function setAccountNumberElement(el) {
	      if (el) {
	        this.accountNumberElement = el;
	      }
	    }
	  }, {
	    key: 'shouldShowError',
	    value: function shouldShowError() {
	      return !this.props.suppressError && !this.props.isValid;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_inputFieldSimple2.default, {
	        value: this.props.value,
	        errorMessage: this.props.errorMessage,
	        showError: this.shouldShowError(),
	
	        type: this.state.type,
	        name: this.state.name,
	        label: this.state.label,
	        placeholder: this.state.placeholder,
	        helpMessage: this.state.helpMessage,
	        isDisabled: this.state.isDisabled,
	        isVisible: this.state.isVisible,
	        element: this.setAccountNumberElement,
	
	        changed: this.changedAccountNumber,
	        blurred: this.blurredAccountNumber
	      });
	    }
	  }]);
	  return AccountNumberField;
	}(_react2.default.Component);
	
	exports.default = AccountNumberField;

/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ItpVacationCheckBoxes = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _components = __webpack_require__(13);
	
	var _frilansFinans = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'label',
	  { htmlFor: 'saveITP' },
	  _react2.default.createElement('span', null),
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SAVE_PENSION_CHECKBOX' })
	); /**
	    * Created by staffanrantzow on 16/03/16.
	    */
	
	var _ref2 = _react2.default.createElement(
	  'h3',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ITP' }),
	  _react2.default.createElement(
	    'a',
	    {
	      href: 'https://www.frilansfinans.se/fragor-och-svar/tjanstepension/',
	      target: '_blank'
	    },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'ITP_READ_MORE' })
	  )
	);
	
	var _ref3 = _react2.default.createElement(
	  'h3',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'VACATION_MONEY' }),
	  _react2.default.createElement(
	    'a',
	    {
	      href: 'https://www.frilansfinans.se/fragor-och-svar/semesterersattning/',
	      target: '_blank'
	    },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'VACATION_MONEY_READ_MORE' })
	  )
	);
	
	var _ref4 = _react2.default.createElement(
	  'label',
	  { htmlFor: 'saveVacationPay' },
	  _react2.default.createElement('span', { className: 'right' }),
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SAVE_VACATION_CHECKBOX' })
	);
	
	var ItpVacationCheckBoxes = exports.ItpVacationCheckBoxes = function (_React$Component) {
	  (0, _inherits3.default)(ItpVacationCheckBoxes, _React$Component);
	
	  function ItpVacationCheckBoxes(props) {
	    (0, _classCallCheck3.default)(this, ItpVacationCheckBoxes);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ItpVacationCheckBoxes.__proto__ || (0, _getPrototypeOf2.default)(ItpVacationCheckBoxes)).call(this, props));
	
	    var itpDefaultAsPercent = _frilansFinans.UserSettingsConstants.itpRateDefault * 100;
	    var defaultClasses = 'styled-wrapper right';
	
	    // Create options from 0.5 to 20
	    var itpRateOptions = [{ value: _frilansFinans.UserSettingsConstants.itpRateDefault, key: itpDefaultAsPercent + '% (standard)' }];
	    for (var i = 5; i <= 35; i++) {
	      itpRateOptions.push({
	        value: i / 100,
	        key: i + '%'
	      });
	    }
	
	    _this.state = {
	      values: _this.props.values,
	      itpRateOptions: itpRateOptions,
	      defaultClasses: defaultClasses
	    };
	
	    _this.callCallback = _this.callCallback.bind(_this);
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.renderItp = _this.renderItp.bind(_this);
	    _this.renderItpRates = _this.renderItpRates.bind(_this);
	    _this.renderItpSetting = _this.renderItpSetting.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(ItpVacationCheckBoxes, [{
	    key: 'handleClick',
	    value: function handleClick(e) {
	      var values, name;
	
	      values = this.state.values;
	      name = e.target.name;
	
	      values[name].value = e.target.checked;
	
	      this.setState({ values: values }, function () {
	        this.callCallback(name, values[name]);
	      });
	    }
	
	    /**
	     * Required function when you have the checked attribute on a checkbox
	     */
	
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {}
	  }, {
	    key: 'callCallback',
	    value: function callCallback(name, obj) {
	      this.props.callback(name, obj);
	    }
	  }, {
	    key: 'renderItpRates',
	    value: function renderItpRates() {
	      if (this.state.values.saveITP.value) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'input-wrapper margin-multiple-rows' },
	          _react2.default.createElement(_components.SelectBox, { name: 'itpRate', options: this.state.itpRateOptions,
	            callback: this.callCallback, errorMessage: (0, _proxyCounterpart.proxyCounterpart)('CALC_KEY_ERROR'),
	            required: 'true', value: this.state.values.itpRate.value,
	            showErrorWithoutBlur: this.props.showErrorWithoutBlur })
	        );
	      }
	    }
	  }, {
	    key: 'renderItpSetting',
	    value: function renderItpSetting() {
	      if (this.state.values.canChangeItp.value) {
	        return _react2.default.createElement(
	          'div',
	          { className: this.state.defaultClasses },
	          _react2.default.createElement('input', { id: 'saveITP', type: 'checkbox', name: 'saveITP', onChange: this.onChange,
	            value: this.state.values.saveITP.value,
	            checked: this.state.values.saveITP.value, onClick: this.handleClick
	          }),
	          _ref
	        );
	      }
	    }
	  }, {
	    key: 'renderItp',
	    value: function renderItp() {
	      if (!this.props.disableITP) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'section' },
	          _ref2,
	          this.renderItpSetting(),
	          this.renderItpRates()
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'setting-checkboxes' },
	        this.renderItp(),
	        _react2.default.createElement(
	          'div',
	          { className: 'section' },
	          _ref3,
	          _react2.default.createElement(
	            'div',
	            { className: this.state.defaultClasses },
	            _react2.default.createElement('input', { id: 'saveVacationPay', type: 'checkbox', name: 'saveVacationPay', onChange: this.onChange,
	              value: this.state.values.saveVacationPay.value,
	              checked: this.state.values.saveVacationPay.value, onClick: this.handleClick }),
	            _ref4
	          )
	        )
	      );
	    }
	  }]);
	  return ItpVacationCheckBoxes;
	}(_react2.default.Component);
	
	exports.default = ItpVacationCheckBoxes;

/***/ },
/* 992 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NotificationCheckBoxes = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by staffanrantzow on 16/03/16.
	 */
	
	var _ref = _react2.default.createElement(
	  'h3',
	  null,
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SALARY_INFORMATION' })
	);
	
	var _ref2 = _react2.default.createElement(
	  'label',
	  { htmlFor: 'receiveSmsNotifications' },
	  _react2.default.createElement('span', null),
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SALARY_INFORMATION_VIA_SMS' })
	);
	
	var _ref3 = _react2.default.createElement(
	  'label',
	  { htmlFor: 'receiveEmailNotifications' },
	  _react2.default.createElement('span', null),
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'SALARY_INFORMATION_VIA_EMAIL' })
	);
	
	var NotificationCheckBoxes = exports.NotificationCheckBoxes = function (_React$Component) {
	  (0, _inherits3.default)(NotificationCheckBoxes, _React$Component);
	
	  function NotificationCheckBoxes(props) {
	    (0, _classCallCheck3.default)(this, NotificationCheckBoxes);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (NotificationCheckBoxes.__proto__ || (0, _getPrototypeOf2.default)(NotificationCheckBoxes)).call(this, props));
	
	    _this.state = {
	      values: _this.props.values
	    };
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(NotificationCheckBoxes, [{
	    key: 'handleClick',
	    value: function handleClick(e) {
	      var values, name;
	
	      values = this.state.values;
	      name = e.target.name;
	
	      values[name].value = e.target.checked;
	
	      this.setState({ values: values }, function () {
	        this.callCallback(name, values[name]);
	      });
	    }
	
	    /**
	     * Required function when you have the checked attribute on a checkbox
	     */
	
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {}
	  }, {
	    key: 'callCallback',
	    value: function callCallback(name, obj) {
	      this.props.callback(name, obj);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var defaultClasses = 'styled-wrapper right';
	      return _react2.default.createElement(
	        'div',
	        { className: 'setting-checkboxes' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section' },
	          _ref,
	          _react2.default.createElement(
	            'div',
	            { className: defaultClasses },
	            _react2.default.createElement('input', {
	              type: 'checkbox',
	              id: 'receiveSmsNotifications',
	              name: 'receiveSmsNotifications',
	              onChange: this.onChange,
	              onClick: this.handleClick,
	              checked: this.state.values.receiveSmsNotifications.value
	            }),
	            _ref2
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: defaultClasses + ' margin-multiple-rows' },
	            _react2.default.createElement('input', {
	              type: 'checkbox',
	              id: 'receiveEmailNotifications',
	              name: 'receiveEmailNotifications',
	              onChange: this.onChange,
	              onClick: this.handleClick,
	              checked: this.state.values.receiveEmailNotifications.value
	            }),
	            _ref3
	          )
	        )
	      );
	    }
	  }]);
	  return NotificationCheckBoxes;
	}(_react2.default.Component);
	
	exports.default = NotificationCheckBoxes;

/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _inputFieldSimple = __webpack_require__(329);
	
	var _inputFieldSimple2 = _interopRequireDefault(_inputFieldSimple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClearingNumberField = function (_React$Component) {
	  (0, _inherits3.default)(ClearingNumberField, _React$Component);
	
	  function ClearingNumberField(props, context) {
	    (0, _classCallCheck3.default)(this, ClearingNumberField);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ClearingNumberField.__proto__ || (0, _getPrototypeOf2.default)(ClearingNumberField)).call(this, props, context));
	
	    _this.state = {
	      name: 'clearingNr',
	      type: 'text',
	      isDisabled: _this.props.selectedBank === 'INITIAL',
	      isVisible: _this.props.selectedBank !== 'NORDEA_PERSON',
	      label: (0, _proxyCounterpart.proxyCounterpart)('CLEARING_NR_LABEL_' + props.selectedBank),
	      placeholder: (0, _proxyCounterpart.proxyCounterpart)('CLEARING_NR_PLACEHOLDER_' + props.selectedBank)
	    };
	
	    _this.clearingNumberElement = null;
	    _this.setClearingNumberElement = _this.setClearingNumberElement.bind(_this);
	
	    _this.changedClearingNumber = _this.changedClearingNumber.bind(_this);
	    _this.blurredClearingNumber = _this.blurredClearingNumber.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(ClearingNumberField, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.selectedBank !== nextProps.selectedBank) {
	        this.setState({
	          isDisabled: nextProps.selectedBank === 'INITIAL',
	          isVisible: nextProps.selectedBank !== 'NORDEA_PERSON',
	          label: (0, _proxyCounterpart.proxyCounterpart)('CLEARING_NR_LABEL_' + nextProps.selectedBank),
	          placeholder: (0, _proxyCounterpart.proxyCounterpart)('CLEARING_NR_PLACEHOLDER_' + nextProps.selectedBank)
	        });
	
	        if (nextProps.selectedBank === 'NORDEA_PERSON') {
	          this.changedClearingNumber('3300');
	        }
	      }
	    }
	  }, {
	    key: 'format',
	    value: function format(value) {
	      if (this.props.selectedBank === 'IBAN') {
	        value = value.toUpperCase();
	      }
	      return value.replace(/[ .,_-]/g, '').trim();
	    }
	  }, {
	    key: 'changedClearingNumber',
	    value: function changedClearingNumber(value) {
	      value = this.format(value);
	      this.props.changed(value);
	    }
	  }, {
	    key: 'blurredClearingNumber',
	    value: function blurredClearingNumber(value) {
	      value = this.format(value);
	      this.props.blurred(value);
	    }
	  }, {
	    key: 'setClearingNumberElement',
	    value: function setClearingNumberElement(el) {
	      if (el) {
	        this.clearingNumberElement = el;
	      }
	    }
	  }, {
	    key: 'shouldShowError',
	    value: function shouldShowError() {
	      return !this.props.suppressError && !this.props.isValid;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_inputFieldSimple2.default, {
	        value: this.props.value,
	        errorMessage: this.props.errorMessage,
	        showError: this.shouldShowError(),
	
	        type: this.state.type,
	        name: this.state.name,
	        label: this.state.label,
	        placeholder: this.state.placeholder,
	        helpMessage: this.state.helpMessage,
	        isDisabled: this.state.isDisabled,
	        isVisible: this.state.isVisible,
	        element: this.setClearingNumberElement,
	
	        changed: this.changedClearingNumber,
	        blurred: this.blurredClearingNumber
	      });
	    }
	  }]);
	  return ClearingNumberField;
	}(_react2.default.Component);
	
	exports.default = ClearingNumberField;

/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	var _selectBank = __webpack_require__(1309);
	
	var _selectBank2 = _interopRequireDefault(_selectBank);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'label',
	  { htmlFor: 'bank-picker' },
	  _react2.default.createElement(_reactTranslateComponent2.default, { content: 'BANK' })
	);
	
	var SelectBank = function (_React$Component) {
	  (0, _inherits3.default)(SelectBank, _React$Component);
	
	  function SelectBank(props, context) {
	    (0, _classCallCheck3.default)(this, SelectBank);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SelectBank.__proto__ || (0, _getPrototypeOf2.default)(SelectBank)).call(this, props, context));
	
	    _this.handleChangedBank = _this.handleChangedBank.bind(_this);
	    _this.changedBank = _this.changedBank.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(SelectBank, [{
	    key: 'handleChangedBank',
	    value: function handleChangedBank(event) {
	      event.preventDefault();
	      var bank = event.target.value;
	      this.changedBank(bank);
	    }
	  }, {
	    key: 'changedBank',
	    value: function changedBank(value) {
	      this.props.changed(value);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'input-wrapper styled-select ' + _selectBank2.default.container },
	        _react2.default.createElement(
	          'select',
	          {
	            name: 'bank-picker',
	            value: this.props.value,
	            onChange: this.handleChangedBank,
	            className: _selectBank2.default.select },
	          _react2.default.createElement(
	            'option',
	            { disabled: 'true', value: 'INITIAL' },
	            (0, _proxyCounterpart.proxyCounterpart)('SELECT_BANK_INITIAL')
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 'HANDELSBANKEN' },
	            (0, _proxyCounterpart.proxyCounterpart)('SELECT_BANK_HANDELSBANKEN')
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 'NORDEA_PERSON' },
	            (0, _proxyCounterpart.proxyCounterpart)('SELECT_BANK_NORDEA_PERSON')
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 'NORDEA_KONTO' },
	            (0, _proxyCounterpart.proxyCounterpart)('SELECT_BANK_NORDEA_KONTO')
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 'SWEDBANK' },
	            (0, _proxyCounterpart.proxyCounterpart)('SELECT_BANK_SWEDBANK')
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 'SEB' },
	            (0, _proxyCounterpart.proxyCounterpart)('SELECT_BANK_SEB')
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 'IBAN' },
	            (0, _proxyCounterpart.proxyCounterpart)('SELECT_BANK_IBAN')
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 'OTHER' },
	            (0, _proxyCounterpart.proxyCounterpart)('SELECT_BANK_OTHER')
	          )
	        ),
	        _ref
	      );
	    }
	  }]);
	  return SelectBank;
	}(_react2.default.Component);
	
	exports.default = SelectBank;

/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SettingsWrapper = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SettingsWrapper = exports.SettingsWrapper = function (_React$Component) {
	  (0, _inherits3.default)(SettingsWrapper, _React$Component);
	
	  function SettingsWrapper() {
	    (0, _classCallCheck3.default)(this, SettingsWrapper);
	    return (0, _possibleConstructorReturn3.default)(this, (SettingsWrapper.__proto__ || (0, _getPrototypeOf2.default)(SettingsWrapper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SettingsWrapper, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'settings' },
	        this.props.children
	      );
	    }
	  }]);
	  return SettingsWrapper;
	}(_react2.default.Component);
	
	exports.default = SettingsWrapper;

/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTranslateComponent = __webpack_require__(7);
	
	var _reactTranslateComponent2 = _interopRequireDefault(_reactTranslateComponent);
	
	var _components = __webpack_require__(13);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _authentication = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'col-sm-8' },
	  _react2.default.createElement(
	    'p',
	    { className: 'error' },
	    _react2.default.createElement(_reactTranslateComponent2.default, { content: 'LOGIN_FAILED' })
	  )
	); /**
	    * Created by staffanrantzow on 16/11/16.
	    */
	
	var _ref2 = _react2.default.createElement(
	  'div',
	  { className: 'col-sm-12' },
	  _react2.default.createElement(_components.Spinner, null)
	);
	
	var TokenLogin = function (_React$Component) {
	  (0, _inherits3.default)(TokenLogin, _React$Component);
	
	  function TokenLogin(props) {
	    (0, _classCallCheck3.default)(this, TokenLogin);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (TokenLogin.__proto__ || (0, _getPrototypeOf2.default)(TokenLogin)).call(this, props));
	
	    _this.state = {
	      loggingIn: true,
	      loginFailed: false
	    };
	
	    _this.handleSuccess = _this.handleSuccess.bind(_this);
	    _this.handleError = _this.handleError.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(TokenLogin, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var accessToken = this.props.location.query.access_token;
	      var expiresIn = this.props.location.query.expires_in;
	
	      if (accessToken && expiresIn) {
	        _authentication.authenticationService.logout();
	        this.login(accessToken, expiresIn);
	      } else {
	        this.context.router.push('login');
	      }
	    }
	  }, {
	    key: 'login',
	    value: function login(accessToken, expiresIn) {
	      _authentication.authenticationService.tokenLogin(accessToken, expiresIn);
	      var handleSuccess = this.handleSuccess;
	      var handleError = this.handleError;
	
	      _frilansFinans.UserService.get().promise.then(function (user) {
	        _frilansFinans.TaxkeyService.get(user.id).then(handleSuccess).catch(handleError);
	      }).catch(handleError);
	    }
	  }, {
	    key: 'handleSuccess',
	    value: function handleSuccess() {
	      var redirectUrl = this.props.location.query.redirect;
	
	      if (!redirectUrl) {
	        redirectUrl = 'activities';
	      }
	
	      this.context.router.push(redirectUrl);
	    }
	  }, {
	    key: 'handleError',
	    value: function handleError() {
	      _authentication.authenticationService.logout();
	
	      this.setState({
	        loggingIn: false,
	        loginFailed: true
	      });
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      if (this.state.loginFailed) {
	        return _ref;
	      }
	      if (this.state.loggingIn) {
	        return _ref2;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'page-wrapper token-login mb35' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            this.renderContent()
	          )
	        )
	      );
	    }
	  }]);
	  return TokenLogin;
	}(_react2.default.Component);
	
	TokenLogin.contextTypes = {
	  router: _react.PropTypes.object.isRequired
	};
	exports.default = TokenLogin;

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WorkingEnvironmentPage = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _frilansFinans = __webpack_require__(11);
	
	var _reactTabs = __webpack_require__(645);
	
	var _counterpart = __webpack_require__(86);
	
	var _counterpart2 = _interopRequireDefault(_counterpart);
	
	var _proxyCounterpart = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WorkingEnvironmentPage = exports.WorkingEnvironmentPage = function (_React$Component) {
	  (0, _inherits3.default)(WorkingEnvironmentPage, _React$Component);
	
	  function WorkingEnvironmentPage(props) {
	    (0, _classCallCheck3.default)(this, WorkingEnvironmentPage);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (WorkingEnvironmentPage.__proto__ || (0, _getPrototypeOf2.default)(WorkingEnvironmentPage)).call(this, props));
	
	    _this.state = {
	      page: null,
	      pendingRequest: null
	    };
	
	    _this.renderTabPanel = _this.renderTabPanel.bind(_this);
	    _this.renderLetterBox = _this.renderLetterBox.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(WorkingEnvironmentPage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetch();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.pendingRequest && this.state.pendingRequest.cancel) {
	        this.state.pendingRequest.cancel();
	      }
	    }
	  }, {
	    key: 'fetch',
	    value: function fetch() {
	      var _this2 = this;
	
	      var pageID = 1729;
	      var pendingRequest = void 0;
	
	      if (_counterpart2.default.getLocale() === 'en') {
	        pageID = 1806;
	      }
	
	      pendingRequest = _frilansFinans.WorkingEnvironmentPageService.get(pageID);
	      pendingRequest.promise.then(function (response) {
	        _this2.setState({
	          page: response
	        });
	      }).catch(function () {});
	
	      this.setState({
	        pendingRequest: pendingRequest
	      });
	    }
	  }, {
	    key: 'createMarkup',
	    value: function createMarkup(html) {
	      return { __html: html };
	    }
	  }, {
	    key: 'renderLetterBox',
	    value: function renderLetterBox(page) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'insurances-letters' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-md-6 col-md-offset-3' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              page.letterButton
	            ),
	            _react2.default.createElement('div', { dangerouslySetInnerHTML: this.createMarkup(page.letterBox) })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderHero',
	    value: function renderHero(page) {
	      var sectionStyle = {
	        backgroundImage: 'url(' + page.image + ')'
	      };
	      return _react2.default.createElement(
	        'section',
	        { className: 'page-hero', style: sectionStyle },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'p',
	            null,
	            page.ingress
	          ),
	          _react2.default.createElement(
	            'h1',
	            { className: 'white' },
	            page.title
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderIntroText',
	    value: function renderIntroText(page) {
	      return _react2.default.createElement(
	        'section',
	        { className: 'insurances-text' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12' },
	              _react2.default.createElement(
	                'p',
	                null,
	                page.text
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderTab',
	    value: function renderTab(section, i) {
	      return _react2.default.createElement(
	        _reactTabs.Tab,
	        { key: i },
	        _react2.default.createElement(
	          'button',
	          { className: 'tab-btn' },
	          section.insurances_section_title
	        )
	      );
	    }
	  }, {
	    key: 'renderTabPanel',
	    value: function renderTabPanel(section, i) {
	      return _react2.default.createElement(
	        _reactTabs.TabPanel,
	        { key: i },
	        _react2.default.createElement('div', { dangerouslySetInnerHTML: this.createMarkup(section.insurances_section_text) })
	      );
	    }
	  }, {
	    key: 'renderTabs',
	    value: function renderTabs(page) {
	      return _react2.default.createElement(
	        _reactTabs.Tabs,
	        null,
	        _react2.default.createElement(
	          _reactTabs.TabList,
	          { className: 'row' },
	          page.sections.map(this.renderTab)
	        ),
	        page.sections.map(this.renderTabPanel)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.page) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'insurances-page' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            (0, _proxyCounterpart.proxyCounterpart)('WORKING_ENVIRONMENT')
	          ),
	          this.renderIntroText(this.state.page),
	          this.renderTabs(this.state.page)
	        );
	      }
	
	      return false;
	    }
	  }]);
	  return WorkingEnvironmentPage;
	}(_react2.default.Component);
	
	exports.default = WorkingEnvironmentPage;

/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WorkingEnvironment = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(3);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _workingEnvironmentPage = __webpack_require__(997);
	
	var _workingEnvironmentPage2 = _interopRequireDefault(_workingEnvironmentPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'working-environment' },
	  _react2.default.createElement(_workingEnvironmentPage2.default, null)
	);
	
	var WorkingEnvironment = exports.WorkingEnvironment = function (_React$Component) {
	  (0, _inherits3.default)(WorkingEnvironment, _React$Component);
	
	  function WorkingEnvironment() {
	    (0, _classCallCheck3.default)(this, WorkingEnvironment);
	    return (0, _possibleConstructorReturn3.default)(this, (WorkingEnvironment.__proto__ || (0, _getPrototypeOf2.default)(WorkingEnvironment)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(WorkingEnvironment, [{
	    key: 'render',
	    value: function render() {
	      return _ref;
	    }
	  }]);
	  return WorkingEnvironment;
	}(_react2.default.Component);
	
	exports.default = WorkingEnvironment;

/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(1274);
	
	__webpack_require__(1538);
	
	__webpack_require__(1013);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1014), __esModule: true };

/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1016), __esModule: true };

/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1018), __esModule: true };

/***/ },
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1020), __esModule: true };

/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1021), __esModule: true };

/***/ },
/* 1005 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1022), __esModule: true };

/***/ },
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1025), __esModule: true };

/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1027), __esModule: true };

/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1028), __esModule: true };

/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1029), __esModule: true };

/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g = (function() { return this })() || Function("return this")();
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(1011);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}


/***/ },
/* 1011 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // In sloppy mode, unbound `this` refers to the global object, fallback to
	  // Function constructor if we're in global strict mode. That is sadly a form
	  // of indirect eval which violates Content Security Policy.
	  (function() { return this })() || Function("return this")()
	);


/***/ },
/* 1012 */
/***/ function(module, exports) {

	/*!
	 * cookie
	 * Copyright(c) 2012-2014 Roman Shtylman
	 * Copyright(c) 2015 Douglas Christopher Wilson
	 * MIT Licensed
	 */
	
	'use strict';
	
	/**
	 * Module exports.
	 * @public
	 */
	
	exports.parse = parse;
	exports.serialize = serialize;
	
	/**
	 * Module variables.
	 * @private
	 */
	
	var decode = decodeURIComponent;
	var encode = encodeURIComponent;
	var pairSplitRegExp = /; */;
	
	/**
	 * RegExp to match field-content in RFC 7230 sec 3.2
	 *
	 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
	 * field-vchar   = VCHAR / obs-text
	 * obs-text      = %x80-FF
	 */
	
	var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
	
	/**
	 * Parse a cookie header.
	 *
	 * Parse the given cookie header string into an object
	 * The object has the various cookies as keys(names) => values
	 *
	 * @param {string} str
	 * @param {object} [options]
	 * @return {object}
	 * @public
	 */
	
	function parse(str, options) {
	  if (typeof str !== 'string') {
	    throw new TypeError('argument str must be a string');
	  }
	
	  var obj = {}
	  var opt = options || {};
	  var pairs = str.split(pairSplitRegExp);
	  var dec = opt.decode || decode;
	
	  for (var i = 0; i < pairs.length; i++) {
	    var pair = pairs[i];
	    var eq_idx = pair.indexOf('=');
	
	    // skip things that don't look like key=value
	    if (eq_idx < 0) {
	      continue;
	    }
	
	    var key = pair.substr(0, eq_idx).trim()
	    var val = pair.substr(++eq_idx, pair.length).trim();
	
	    // quoted values
	    if ('"' == val[0]) {
	      val = val.slice(1, -1);
	    }
	
	    // only assign once
	    if (undefined == obj[key]) {
	      obj[key] = tryDecode(val, dec);
	    }
	  }
	
	  return obj;
	}
	
	/**
	 * Serialize data into a cookie header.
	 *
	 * Serialize the a name value pair into a cookie string suitable for
	 * http headers. An optional options object specified cookie parameters.
	 *
	 * serialize('foo', 'bar', { httpOnly: true })
	 *   => "foo=bar; httpOnly"
	 *
	 * @param {string} name
	 * @param {string} val
	 * @param {object} [options]
	 * @return {string}
	 * @public
	 */
	
	function serialize(name, val, options) {
	  var opt = options || {};
	  var enc = opt.encode || encode;
	
	  if (typeof enc !== 'function') {
	    throw new TypeError('option encode is invalid');
	  }
	
	  if (!fieldContentRegExp.test(name)) {
	    throw new TypeError('argument name is invalid');
	  }
	
	  var value = enc(val);
	
	  if (value && !fieldContentRegExp.test(value)) {
	    throw new TypeError('argument val is invalid');
	  }
	
	  var str = name + '=' + value;
	
	  if (null != opt.maxAge) {
	    var maxAge = opt.maxAge - 0;
	    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
	    str += '; Max-Age=' + Math.floor(maxAge);
	  }
	
	  if (opt.domain) {
	    if (!fieldContentRegExp.test(opt.domain)) {
	      throw new TypeError('option domain is invalid');
	    }
	
	    str += '; Domain=' + opt.domain;
	  }
	
	  if (opt.path) {
	    if (!fieldContentRegExp.test(opt.path)) {
	      throw new TypeError('option path is invalid');
	    }
	
	    str += '; Path=' + opt.path;
	  }
	
	  if (opt.expires) {
	    if (typeof opt.expires.toUTCString !== 'function') {
	      throw new TypeError('option expires is invalid');
	    }
	
	    str += '; Expires=' + opt.expires.toUTCString();
	  }
	
	  if (opt.httpOnly) {
	    str += '; HttpOnly';
	  }
	
	  if (opt.secure) {
	    str += '; Secure';
	  }
	
	  if (opt.sameSite) {
	    var sameSite = typeof opt.sameSite === 'string'
	      ? opt.sameSite.toLowerCase() : opt.sameSite;
	
	    switch (sameSite) {
	      case true:
	        str += '; SameSite=Strict';
	        break;
	      case 'lax':
	        str += '; SameSite=Lax';
	        break;
	      case 'strict':
	        str += '; SameSite=Strict';
	        break;
	      default:
	        throw new TypeError('option sameSite is invalid');
	    }
	  }
	
	  return str;
	}
	
	/**
	 * Try decoding a string using a decoding function.
	 *
	 * @param {string} str
	 * @param {function} decode
	 * @private
	 */
	
	function tryDecode(str, decode) {
	  try {
	    return decode(str);
	  } catch (e) {
	    return str;
	  }
	}


/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1082);
	module.exports = __webpack_require__(77).RegExp.escape;


/***/ },
/* 1014 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(124);
	__webpack_require__(1056);
	module.exports = __webpack_require__(31).Array.from;


/***/ },
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(149);
	__webpack_require__(124);
	module.exports = __webpack_require__(1054);


/***/ },
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(149);
	__webpack_require__(124);
	module.exports = __webpack_require__(1055);


/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(31);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ },
/* 1018 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1058);
	module.exports = __webpack_require__(31).Number.isInteger;


/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1059);
	module.exports = __webpack_require__(31).Object.assign;


/***/ },
/* 1020 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1060);
	var $Object = __webpack_require__(31).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ },
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1061);
	var $Object = __webpack_require__(31).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1068);
	module.exports = __webpack_require__(31).Object.entries;


/***/ },
/* 1023 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1062);
	module.exports = __webpack_require__(31).Object.getPrototypeOf;


/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1063);
	module.exports = __webpack_require__(31).Object.keys;


/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1064);
	module.exports = __webpack_require__(31).Object.setPrototypeOf;


/***/ },
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(251);
	__webpack_require__(124);
	__webpack_require__(149);
	__webpack_require__(1065);
	__webpack_require__(1069);
	__webpack_require__(1070);
	module.exports = __webpack_require__(31).Promise;


/***/ },
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(251);
	__webpack_require__(124);
	__webpack_require__(149);
	__webpack_require__(1066);
	__webpack_require__(1073);
	__webpack_require__(1072);
	__webpack_require__(1071);
	module.exports = __webpack_require__(31).Set;


/***/ },
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1067);
	__webpack_require__(251);
	__webpack_require__(1074);
	__webpack_require__(1075);
	module.exports = __webpack_require__(31).Symbol;


/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(124);
	__webpack_require__(149);
	module.exports = __webpack_require__(249).f('iterator');


/***/ },
/* 1030 */
/***/ function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ },
/* 1031 */
[1581, 145],
/* 1032 */
[1582, 100, 171, 1053],
/* 1033 */
[1583, 83, 238, 123, 171, 1035],
/* 1034 */
[1584, 59, 390, 44],
/* 1035 */
[1585, 1034],
/* 1036 */
[1587, 65, 170, 243, 83, 234, 145, 239, 393, 402, 75, 240, 405],
/* 1037 */
[1588, 168, 1031],
/* 1038 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(48);
	var $export = __webpack_require__(39);
	var meta = __webpack_require__(240);
	var fails = __webpack_require__(98);
	var hide = __webpack_require__(93);
	var redefineAll = __webpack_require__(243);
	var forOf = __webpack_require__(145);
	var anInstance = __webpack_require__(234);
	var isObject = __webpack_require__(59);
	var setToStringTag = __webpack_require__(148);
	var dP = __webpack_require__(65).f;
	var each = __webpack_require__(1033)(0);
	var DESCRIPTORS = __webpack_require__(75);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    C = wrapper(function (target, iterable) {
	      anInstance(target, C, NAME, '_c');
	      target._c = new Base();
	      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
	    });
	    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
	      var IS_ADDER = KEY == 'add' || KEY == 'set';
	      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
	        anInstance(this, C, KEY);
	        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
	        var result = this._c[KEY](a === 0 ? 0 : a, b);
	        return IS_ADDER ? this : result;
	      });
	    });
	    IS_WEAK || dP(C.prototype, 'size', {
	      get: function () {
	        return this._c.size;
	      }
	    });
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F, O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ },
/* 1039 */
[1589, 65, 147],
/* 1040 */
[1593, 122, 242, 146],
/* 1041 */
416,
/* 1042 */
[1601, 59],
/* 1043 */
[1603, 170, 147, 148, 93, 44],
/* 1044 */
[1607, 48, 404, 144],
/* 1045 */
[1609, 122, 242, 146, 123, 238, 98],
/* 1046 */
[1612, 65, 74, 122, 75],
/* 1047 */
[1614, 100, 395],
/* 1048 */
[1620, 122, 100, 146],
/* 1049 */
[1622, 39, 143, 83, 145],
/* 1050 */
[1623, 39],
/* 1051 */
[1624, 59, 74, 83, 394],
/* 1052 */
[1629, 246, 235],
/* 1053 */
[1631, 246],
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(74);
	var get = __webpack_require__(250);
	module.exports = __webpack_require__(31).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(168);
	var ITERATOR = __webpack_require__(44)('iterator');
	var Iterators = __webpack_require__(121);
	module.exports = __webpack_require__(31).isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ },
/* 1056 */
[1641, 83, 39, 123, 391, 389, 171, 1039, 250, 392],
/* 1057 */
[1642, 1030, 393, 121, 100, 239],
/* 1058 */
[1643, 39, 1042],
/* 1059 */
[1644, 39, 1045],
/* 1060 */
[1645, 39, 170],
/* 1061 */
[1646, 39, 75, 65],
/* 1062 */
[1647, 123, 396, 398],
/* 1063 */
[1648, 123, 122, 398],
/* 1064 */
[1649, 39, 1051],
/* 1065 */
[1650, 169, 48, 83, 168, 39, 59, 143, 234, 145, 403, 404, 1044, 241, 399, 400, 44, 243, 148, 402, 31, 392],
/* 1066 */
[1651, 1036, 405, 1038],
/* 1067 */
[1653, 48, 99, 75, 39, 401, 240, 98, 245, 148, 172, 44, 249, 248, 1040, 390, 74, 59, 100, 247, 147, 170, 1047, 394, 65, 122, 395, 146, 242, 169, 93],
/* 1068 */
[1654, 39, 1048],
/* 1069 */
[1655, 39, 31, 48, 403, 400],
/* 1070 */
[1656, 39, 241, 399],
/* 1071 */
[1657, 1049],
/* 1072 */
[1658, 1050],
/* 1073 */
[1659, 39, 1037],
/* 1074 */
[1660, 248],
/* 1075 */
[1661, 248],
/* 1076 */
[1584, 24, 177, 28],
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(23);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(16);
	var toPrimitive = __webpack_require__(81);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ },
/* 1079 */
[1593, 106, 181, 152],
/* 1080 */
/***/ function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ },
/* 1081 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(9);
	var $re = __webpack_require__(1080)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ },
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(9);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(407) });
	
	__webpack_require__(94)('copyWithin');


/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9);
	var $every = __webpack_require__(76)(4);
	
	$export($export.P + $export.F * !__webpack_require__(68)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(9);
	
	$export($export.P, 'Array', { fill: __webpack_require__(252) });
	
	__webpack_require__(94)('fill');


/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9);
	var $filter = __webpack_require__(76)(2);
	
	$export($export.P + $export.F * !__webpack_require__(68)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(9);
	var $find = __webpack_require__(76)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(94)(KEY);


/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(9);
	var $find = __webpack_require__(76)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(94)(KEY);


/***/ },
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9);
	var $forEach = __webpack_require__(76)(0);
	var STRICT = __webpack_require__(68)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 1090 */
[1641, 67, 9, 38, 418, 260, 34, 254, 277, 179],
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9);
	var $indexOf = __webpack_require__(173)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(68)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(177) });


/***/ },
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(9);
	var toIObject = __webpack_require__(62);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(151) != Object || !__webpack_require__(68)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9);
	var toIObject = __webpack_require__(62);
	var toInteger = __webpack_require__(80);
	var toLength = __webpack_require__(34);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(68)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9);
	var $map = __webpack_require__(76)(1);
	
	$export($export.P + $export.F * !__webpack_require__(68)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9);
	var createProperty = __webpack_require__(254);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(23)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ },
/* 1097 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9);
	var $reduce = __webpack_require__(409);
	
	$export($export.P + $export.F * !__webpack_require__(68)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ },
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9);
	var $reduce = __webpack_require__(409);
	
	$export($export.P + $export.F * !__webpack_require__(68)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9);
	var html = __webpack_require__(258);
	var cof = __webpack_require__(66);
	var toAbsoluteIndex = __webpack_require__(110);
	var toLength = __webpack_require__(34);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(23)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9);
	var $some = __webpack_require__(76)(3);
	
	$export($export.P + $export.F * !__webpack_require__(68)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 1101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9);
	var aFunction = __webpack_require__(45);
	var toObject = __webpack_require__(38);
	var fails = __webpack_require__(23);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(68)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ },
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(109)('Array');


/***/ },
/* 1103 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ },
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(9);
	var toISOString = __webpack_require__(1077);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9);
	var toObject = __webpack_require__(38);
	var toPrimitive = __webpack_require__(81);
	
	$export($export.P + $export.F * __webpack_require__(23)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(28)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(52)(proto, TO_PRIMITIVE, __webpack_require__(1078));


/***/ },
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(53)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(9);
	
	$export($export.P, 'Function', { bind: __webpack_require__(410) });


/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(24);
	var getPrototypeOf = __webpack_require__(61);
	var HAS_INSTANCE = __webpack_require__(28)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(33).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(33).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(32) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(9);
	var log1p = __webpack_require__(421);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(9);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(9);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(9);
	var sign = __webpack_require__(264);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(9);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(9);
	var $expm1 = __webpack_require__(263);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', { fround: __webpack_require__(420) });


/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(9);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(9);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(23)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(421) });


/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', { sign: __webpack_require__(264) });


/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(9);
	var expm1 = __webpack_require__(263);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(23)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(9);
	var expm1 = __webpack_require__(263);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ },
/* 1127 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ },
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(19);
	var has = __webpack_require__(51);
	var cof = __webpack_require__(66);
	var inheritIfRequired = __webpack_require__(259);
	var toPrimitive = __webpack_require__(81);
	var fails = __webpack_require__(23);
	var gOPN = __webpack_require__(105).f;
	var gOPD = __webpack_require__(60).f;
	var dP = __webpack_require__(33).f;
	var $trim = __webpack_require__(127).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(104)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(32) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(53)(global, NUMBER, $Number);
	}


/***/ },
/* 1129 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(9);
	var _isFinite = __webpack_require__(19).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ },
/* 1131 */
[1643, 9, 417],
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(9);
	var isInteger = __webpack_require__(417);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ },
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9);
	var $parseFloat = __webpack_require__(429);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9);
	var $parseInt = __webpack_require__(430);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9);
	var toInteger = __webpack_require__(80);
	var aNumberValue = __webpack_require__(406);
	var repeat = __webpack_require__(271);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(23)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9);
	var $fails = __webpack_require__(23);
	var aNumberValue = __webpack_require__(406);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ },
/* 1140 */
[1644, 9, 423],
/* 1141 */
[1645, 9, 104],
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(32), 'Object', { defineProperties: __webpack_require__(424) });


/***/ },
/* 1143 */
[1646, 9, 32, 33],
/* 1144 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(24);
	var meta = __webpack_require__(95).onFreeze;
	
	__webpack_require__(79)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ },
/* 1145 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(62);
	var $getOwnPropertyDescriptor = __webpack_require__(60).f;
	
	__webpack_require__(79)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ },
/* 1146 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(79)('getOwnPropertyNames', function () {
	  return __webpack_require__(425).f;
	});


/***/ },
/* 1147 */
[1647, 38, 61, 79],
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(24);
	
	__webpack_require__(79)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ },
/* 1149 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(24);
	
	__webpack_require__(79)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(24);
	
	__webpack_require__(79)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ },
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(9);
	$export($export.S, 'Object', { is: __webpack_require__(1081) });


/***/ },
/* 1152 */
[1648, 38, 106, 79],
/* 1153 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(24);
	var meta = __webpack_require__(95).onFreeze;
	
	__webpack_require__(79)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ },
/* 1154 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(24);
	var meta = __webpack_require__(95).onFreeze;
	
	__webpack_require__(79)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ },
/* 1155 */
[1649, 9, 267],
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(150);
	var test = {};
	test[__webpack_require__(28)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(53)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ },
/* 1157 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9);
	var $parseFloat = __webpack_require__(429);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9);
	var $parseInt = __webpack_require__(430);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ },
/* 1159 */
[1650, 103, 19, 67, 150, 9, 24, 45, 101, 102, 185, 273, 265, 266, 431, 432, 28, 108, 126, 109, 77, 179],
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(9);
	var aFunction = __webpack_require__(45);
	var anObject = __webpack_require__(16);
	var rApply = (__webpack_require__(19).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(23)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ },
/* 1161 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(9);
	var create = __webpack_require__(104);
	var aFunction = __webpack_require__(45);
	var anObject = __webpack_require__(16);
	var isObject = __webpack_require__(24);
	var fails = __webpack_require__(23);
	var bind = __webpack_require__(410);
	var rConstruct = (__webpack_require__(19).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(33);
	var $export = __webpack_require__(9);
	var anObject = __webpack_require__(16);
	var toPrimitive = __webpack_require__(81);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(23)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 1163 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(9);
	var gOPD = __webpack_require__(60).f;
	var anObject = __webpack_require__(16);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ },
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(9);
	var anObject = __webpack_require__(16);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(261)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(60);
	var $export = __webpack_require__(9);
	var anObject = __webpack_require__(16);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ },
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(9);
	var getProto = __webpack_require__(61);
	var anObject = __webpack_require__(16);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(60);
	var getPrototypeOf = __webpack_require__(61);
	var has = __webpack_require__(51);
	var $export = __webpack_require__(9);
	var isObject = __webpack_require__(24);
	var anObject = __webpack_require__(16);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ },
/* 1169 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(9);
	var anObject = __webpack_require__(16);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ },
/* 1170 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(428) });


/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(9);
	var anObject = __webpack_require__(16);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 1172 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(9);
	var setProto = __webpack_require__(267);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 1173 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(33);
	var gOPD = __webpack_require__(60);
	var getPrototypeOf = __webpack_require__(61);
	var has = __webpack_require__(51);
	var $export = __webpack_require__(9);
	var createDesc = __webpack_require__(107);
	var anObject = __webpack_require__(16);
	var isObject = __webpack_require__(24);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
	    existingDescriptor.value = V;
	    dP.f(receiver, propertyKey, existingDescriptor);
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ },
/* 1174 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(19);
	var inheritIfRequired = __webpack_require__(259);
	var dP = __webpack_require__(33).f;
	var gOPN = __webpack_require__(105).f;
	var isRegExp = __webpack_require__(178);
	var $flags = __webpack_require__(176);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(32) && (!CORRECT_NEW || __webpack_require__(23)(function () {
	  re2[__webpack_require__(28)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(53)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(109)('RegExp');


/***/ },
/* 1175 */
/***/ function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(175)('match', 1, function (defined, MATCH, $match) {
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp) {
	    'use strict';
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});


/***/ },
/* 1176 */
/***/ function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(175)('replace', 2, function (defined, REPLACE, $replace) {
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue) {
	    'use strict';
	    var O = defined(this);
	    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});


/***/ },
/* 1177 */
/***/ function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(175)('search', 1, function (defined, SEARCH, $search) {
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp) {
	    'use strict';
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});


/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(175)('split', 2, function (defined, SPLIT, $split) {
	  'use strict';
	  var isRegExp = __webpack_require__(178);
	  var _split = $split;
	  var $push = [].push;
	  var $SPLIT = 'split';
	  var LENGTH = 'length';
	  var LAST_INDEX = 'lastIndex';
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while (match = separatorCopy.exec(string)) {
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          // eslint-disable-next-line no-loop-func
	          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
	            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
	          });
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    $split = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit) {
	    var O = defined(this);
	    var fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});


/***/ },
/* 1179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(437);
	var anObject = __webpack_require__(16);
	var $flags = __webpack_require__(176);
	var DESCRIPTORS = __webpack_require__(32);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(53)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(23)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ },
/* 1180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(54)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ },
/* 1181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(54)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ },
/* 1182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(54)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ },
/* 1183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(54)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ },
/* 1184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9);
	var $at = __webpack_require__(269)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 1185 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(9);
	var toLength = __webpack_require__(34);
	var context = __webpack_require__(270);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(257)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ },
/* 1186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(54)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ },
/* 1187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(54)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ },
/* 1188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(54)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ },
/* 1189 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9);
	var toAbsoluteIndex = __webpack_require__(110);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ },
/* 1190 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(9);
	var context = __webpack_require__(270);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(257)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ },
/* 1191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(54)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ },
/* 1192 */
[1652, 269, 262],
/* 1193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(54)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ },
/* 1194 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9);
	var toIObject = __webpack_require__(62);
	var toLength = __webpack_require__(34);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ },
/* 1195 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(271)
	});


/***/ },
/* 1196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(54)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ },
/* 1197 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(9);
	var toLength = __webpack_require__(34);
	var context = __webpack_require__(270);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(257)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ },
/* 1198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(54)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ },
/* 1199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(54)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ },
/* 1200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(54)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ },
/* 1201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(127)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ },
/* 1202 */
[1653, 19, 51, 32, 9, 53, 95, 23, 184, 126, 111, 28, 435, 276, 1079, 177, 16, 24, 62, 81, 107, 104, 425, 60, 33, 106, 105, 152, 181, 103, 52],
/* 1203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9);
	var $typed = __webpack_require__(186);
	var buffer = __webpack_require__(274);
	var anObject = __webpack_require__(16);
	var toAbsoluteIndex = __webpack_require__(110);
	var toLength = __webpack_require__(34);
	var isObject = __webpack_require__(24);
	var ArrayBuffer = __webpack_require__(19).ArrayBuffer;
	var speciesConstructor = __webpack_require__(185);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(23)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var final = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < final) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(109)(ARRAY_BUFFER);


/***/ },
/* 1204 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9);
	$export($export.G + $export.W + $export.F * !__webpack_require__(186).ABV, {
	  DataView: __webpack_require__(274).DataView
	});


/***/ },
/* 1205 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(85)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1206 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(85)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1207 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(85)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1208 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(85)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1209 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(85)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1210 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(85)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1211 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(85)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1212 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(85)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1213 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(85)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ },
/* 1214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(413);
	var validate = __webpack_require__(128);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(174)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ },
/* 1215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(9);
	var flattenIntoArray = __webpack_require__(414);
	var toObject = __webpack_require__(38);
	var toLength = __webpack_require__(34);
	var aFunction = __webpack_require__(45);
	var arraySpeciesCreate = __webpack_require__(253);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(94)('flatMap');


/***/ },
/* 1216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(9);
	var flattenIntoArray = __webpack_require__(414);
	var toObject = __webpack_require__(38);
	var toLength = __webpack_require__(34);
	var toInteger = __webpack_require__(80);
	var arraySpeciesCreate = __webpack_require__(253);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(94)('flatten');


/***/ },
/* 1217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(9);
	var $includes = __webpack_require__(173)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(94)('includes');


/***/ },
/* 1218 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(9);
	var microtask = __webpack_require__(265)();
	var process = __webpack_require__(19).process;
	var isNode = __webpack_require__(66)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ },
/* 1219 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(9);
	var cof = __webpack_require__(66);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ },
/* 1220 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(9);
	
	$export($export.G, { global: __webpack_require__(19) });


/***/ },
/* 1221 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(182)('Map');


/***/ },
/* 1222 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(183)('Map');


/***/ },
/* 1223 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(9);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(412)('Map') });


/***/ },
/* 1224 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ },
/* 1225 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ },
/* 1226 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(9);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ },
/* 1227 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(9);
	var scale = __webpack_require__(422);
	var fround = __webpack_require__(420);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ },
/* 1228 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ },
/* 1229 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ },
/* 1230 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ },
/* 1231 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ },
/* 1232 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(9);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ },
/* 1233 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', { scale: __webpack_require__(422) });


/***/ },
/* 1234 */
/***/ function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ },
/* 1235 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ },
/* 1236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9);
	var toObject = __webpack_require__(38);
	var aFunction = __webpack_require__(45);
	var $defineProperty = __webpack_require__(33);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(32) && $export($export.P + __webpack_require__(180), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 1237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9);
	var toObject = __webpack_require__(38);
	var aFunction = __webpack_require__(45);
	var $defineProperty = __webpack_require__(33);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(32) && $export($export.P + __webpack_require__(180), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 1238 */
[1654, 9, 427],
/* 1239 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(9);
	var ownKeys = __webpack_require__(428);
	var toIObject = __webpack_require__(62);
	var gOPD = __webpack_require__(60);
	var createProperty = __webpack_require__(254);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ },
/* 1240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9);
	var toObject = __webpack_require__(38);
	var toPrimitive = __webpack_require__(81);
	var getPrototypeOf = __webpack_require__(61);
	var getOwnPropertyDescriptor = __webpack_require__(60).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(32) && $export($export.P + __webpack_require__(180), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 1241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9);
	var toObject = __webpack_require__(38);
	var toPrimitive = __webpack_require__(81);
	var getPrototypeOf = __webpack_require__(61);
	var getOwnPropertyDescriptor = __webpack_require__(60).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(32) && $export($export.P + __webpack_require__(180), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 1242 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(9);
	var $values = __webpack_require__(427)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ },
/* 1243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(9);
	var global = __webpack_require__(19);
	var core = __webpack_require__(77);
	var microtask = __webpack_require__(265)();
	var OBSERVABLE = __webpack_require__(28)('observable');
	var aFunction = __webpack_require__(45);
	var anObject = __webpack_require__(16);
	var anInstance = __webpack_require__(101);
	var redefineAll = __webpack_require__(108);
	var hide = __webpack_require__(52);
	var forOf = __webpack_require__(102);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(109)('Observable');


/***/ },
/* 1244 */
[1655, 9, 77, 19, 185, 432],
/* 1245 */
[1656, 9, 266, 431],
/* 1246 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(84);
	var anObject = __webpack_require__(16);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ },
/* 1247 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(84);
	var anObject = __webpack_require__(16);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ },
/* 1248 */
/***/ function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(438);
	var from = __webpack_require__(408);
	var metadata = __webpack_require__(84);
	var anObject = __webpack_require__(16);
	var getPrototypeOf = __webpack_require__(61);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ },
/* 1249 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(84);
	var anObject = __webpack_require__(16);
	var getPrototypeOf = __webpack_require__(61);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 1250 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(84);
	var anObject = __webpack_require__(16);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ },
/* 1251 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(84);
	var anObject = __webpack_require__(16);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 1252 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(84);
	var anObject = __webpack_require__(16);
	var getPrototypeOf = __webpack_require__(61);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 1253 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(84);
	var anObject = __webpack_require__(16);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 1254 */
/***/ function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(84);
	var anObject = __webpack_require__(16);
	var aFunction = __webpack_require__(45);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ },
/* 1255 */
[1657, 182],
/* 1256 */
[1658, 183],
/* 1257 */
[1659, 9, 412],
/* 1258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(9);
	var $at = __webpack_require__(269)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 1259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(9);
	var defined = __webpack_require__(78);
	var toLength = __webpack_require__(34);
	var isRegExp = __webpack_require__(178);
	var getFlags = __webpack_require__(176);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(261)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ },
/* 1260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(9);
	var $pad = __webpack_require__(433);
	var userAgent = __webpack_require__(275);
	
	// https://github.com/zloirock/core-js/issues/280
	$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ },
/* 1261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(9);
	var $pad = __webpack_require__(433);
	var userAgent = __webpack_require__(275);
	
	// https://github.com/zloirock/core-js/issues/280
	$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ },
/* 1262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(127)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ },
/* 1263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(127)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ },
/* 1264 */
[1660, 276],
/* 1265 */
[1661, 276],
/* 1266 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(9);
	
	$export($export.S, 'System', { global: __webpack_require__(19) });


/***/ },
/* 1267 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(182)('WeakMap');


/***/ },
/* 1268 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(183)('WeakMap');


/***/ },
/* 1269 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(182)('WeakSet');


/***/ },
/* 1270 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(183)('WeakSet');


/***/ },
/* 1271 */
/***/ function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(278);
	var getKeys = __webpack_require__(106);
	var redefine = __webpack_require__(53);
	var global = __webpack_require__(19);
	var hide = __webpack_require__(52);
	var Iterators = __webpack_require__(125);
	var wks = __webpack_require__(28);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ },
/* 1272 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9);
	var $task = __webpack_require__(273);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ },
/* 1273 */
/***/ function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(19);
	var $export = __webpack_require__(9);
	var userAgent = __webpack_require__(275);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ },
/* 1274 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1202);
	__webpack_require__(1141);
	__webpack_require__(1143);
	__webpack_require__(1142);
	__webpack_require__(1145);
	__webpack_require__(1147);
	__webpack_require__(1152);
	__webpack_require__(1146);
	__webpack_require__(1144);
	__webpack_require__(1154);
	__webpack_require__(1153);
	__webpack_require__(1149);
	__webpack_require__(1150);
	__webpack_require__(1148);
	__webpack_require__(1140);
	__webpack_require__(1151);
	__webpack_require__(1155);
	__webpack_require__(1156);
	__webpack_require__(1108);
	__webpack_require__(1110);
	__webpack_require__(1109);
	__webpack_require__(1158);
	__webpack_require__(1157);
	__webpack_require__(1128);
	__webpack_require__(1138);
	__webpack_require__(1139);
	__webpack_require__(1129);
	__webpack_require__(1130);
	__webpack_require__(1131);
	__webpack_require__(1132);
	__webpack_require__(1133);
	__webpack_require__(1134);
	__webpack_require__(1135);
	__webpack_require__(1136);
	__webpack_require__(1137);
	__webpack_require__(1111);
	__webpack_require__(1112);
	__webpack_require__(1113);
	__webpack_require__(1114);
	__webpack_require__(1115);
	__webpack_require__(1116);
	__webpack_require__(1117);
	__webpack_require__(1118);
	__webpack_require__(1119);
	__webpack_require__(1120);
	__webpack_require__(1121);
	__webpack_require__(1122);
	__webpack_require__(1123);
	__webpack_require__(1124);
	__webpack_require__(1125);
	__webpack_require__(1126);
	__webpack_require__(1127);
	__webpack_require__(1189);
	__webpack_require__(1194);
	__webpack_require__(1201);
	__webpack_require__(1192);
	__webpack_require__(1184);
	__webpack_require__(1185);
	__webpack_require__(1190);
	__webpack_require__(1195);
	__webpack_require__(1197);
	__webpack_require__(1180);
	__webpack_require__(1181);
	__webpack_require__(1182);
	__webpack_require__(1183);
	__webpack_require__(1186);
	__webpack_require__(1187);
	__webpack_require__(1188);
	__webpack_require__(1191);
	__webpack_require__(1193);
	__webpack_require__(1196);
	__webpack_require__(1198);
	__webpack_require__(1199);
	__webpack_require__(1200);
	__webpack_require__(1103);
	__webpack_require__(1105);
	__webpack_require__(1104);
	__webpack_require__(1107);
	__webpack_require__(1106);
	__webpack_require__(1092);
	__webpack_require__(1090);
	__webpack_require__(1096);
	__webpack_require__(1093);
	__webpack_require__(1099);
	__webpack_require__(1101);
	__webpack_require__(1089);
	__webpack_require__(1095);
	__webpack_require__(1086);
	__webpack_require__(1100);
	__webpack_require__(1084);
	__webpack_require__(1098);
	__webpack_require__(1097);
	__webpack_require__(1091);
	__webpack_require__(1094);
	__webpack_require__(1083);
	__webpack_require__(1085);
	__webpack_require__(1088);
	__webpack_require__(1087);
	__webpack_require__(1102);
	__webpack_require__(278);
	__webpack_require__(1174);
	__webpack_require__(1179);
	__webpack_require__(437);
	__webpack_require__(1175);
	__webpack_require__(1176);
	__webpack_require__(1177);
	__webpack_require__(1178);
	__webpack_require__(1159);
	__webpack_require__(436);
	__webpack_require__(438);
	__webpack_require__(439);
	__webpack_require__(1214);
	__webpack_require__(1203);
	__webpack_require__(1204);
	__webpack_require__(1209);
	__webpack_require__(1212);
	__webpack_require__(1213);
	__webpack_require__(1207);
	__webpack_require__(1210);
	__webpack_require__(1208);
	__webpack_require__(1211);
	__webpack_require__(1205);
	__webpack_require__(1206);
	__webpack_require__(1160);
	__webpack_require__(1161);
	__webpack_require__(1162);
	__webpack_require__(1163);
	__webpack_require__(1164);
	__webpack_require__(1167);
	__webpack_require__(1165);
	__webpack_require__(1166);
	__webpack_require__(1168);
	__webpack_require__(1169);
	__webpack_require__(1170);
	__webpack_require__(1171);
	__webpack_require__(1173);
	__webpack_require__(1172);
	__webpack_require__(1217);
	__webpack_require__(1215);
	__webpack_require__(1216);
	__webpack_require__(1258);
	__webpack_require__(1261);
	__webpack_require__(1260);
	__webpack_require__(1262);
	__webpack_require__(1263);
	__webpack_require__(1259);
	__webpack_require__(1264);
	__webpack_require__(1265);
	__webpack_require__(1239);
	__webpack_require__(1242);
	__webpack_require__(1238);
	__webpack_require__(1236);
	__webpack_require__(1237);
	__webpack_require__(1240);
	__webpack_require__(1241);
	__webpack_require__(1223);
	__webpack_require__(1257);
	__webpack_require__(1222);
	__webpack_require__(1256);
	__webpack_require__(1268);
	__webpack_require__(1270);
	__webpack_require__(1221);
	__webpack_require__(1255);
	__webpack_require__(1267);
	__webpack_require__(1269);
	__webpack_require__(1220);
	__webpack_require__(1266);
	__webpack_require__(1219);
	__webpack_require__(1224);
	__webpack_require__(1225);
	__webpack_require__(1226);
	__webpack_require__(1227);
	__webpack_require__(1228);
	__webpack_require__(1230);
	__webpack_require__(1229);
	__webpack_require__(1231);
	__webpack_require__(1232);
	__webpack_require__(1233);
	__webpack_require__(1235);
	__webpack_require__(1234);
	__webpack_require__(1244);
	__webpack_require__(1245);
	__webpack_require__(1246);
	__webpack_require__(1247);
	__webpack_require__(1249);
	__webpack_require__(1248);
	__webpack_require__(1251);
	__webpack_require__(1250);
	__webpack_require__(1252);
	__webpack_require__(1253);
	__webpack_require__(1254);
	__webpack_require__(1218);
	__webpack_require__(1243);
	__webpack_require__(1273);
	__webpack_require__(1272);
	__webpack_require__(1271);
	module.exports = __webpack_require__(77);


/***/ },
/* 1275 */
/***/ function(module, exports, __webpack_require__) {

	// The translations in this file are added by default.
	
	'use strict';
	
	module.exports = {
	  counterpart: {
	    names: __webpack_require__(440),
	    pluralize: __webpack_require__(1346),
	
	    formats: {
	      date: {
	        'default':  '%a, %e %b %Y',
	        long:       '%A, %B %o, %Y',
	        short:      '%b %e'
	      },
	
	      time: {
	        'default':  '%H:%M',
	        long:       '%H:%M:%S %z',
	        short:      '%H:%M'
	      },
	
	      datetime: {
	        'default':  '%a, %e %b %Y %H:%M',
	        long:       '%A, %B %o, %Y %H:%M:%S %z',
	        short:      '%e %b %H:%M'
	      }
	    }
	  }
	};


/***/ },
/* 1276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var dateNames = __webpack_require__(1279);
	
	function strftime(date, format, names) {
	  var timestamp = date.getTime();
	
	  names = names || dateNames;
	
	  return format.replace(/%([-_0]?.)/g, function(_, c) {
	    var padding = null;
	
	    if (c.length == 2) {
	      switch (c[0]) {
	        case '-': padding = '';  break;
	        case '_': padding = ' '; break;
	        case '0': padding = '0'; break;
	        default: return _; // should never reach this one
	      }
	
	      c = c[1];
	    }
	
	    switch (c) {
	      case 'A': return names.days[date.getDay()];
	      case 'a': return names.abbreviated_days[date.getDay()];
	      case 'B': return names.months[date.getMonth()];
	      case 'b': return names.abbreviated_months[date.getMonth()];
	      case 'C': return pad(Math.floor(date.getFullYear() / 100), padding);
	      case 'D': return strftime(date, '%m/%d/%y');
	      case 'd': return pad(date.getDate(), padding);
	      case 'e': return date.getDate();
	      case 'F': return strftime(date, '%Y-%m-%d');
	      case 'H': return pad(date.getHours(), padding);
	      case 'h': return names.abbreviated_months[date.getMonth()];
	      case 'I': return pad(hours12(date), padding);
	      case 'j': return pad(Math.ceil((date.getTime() - (new Date(date.getFullYear(), 0, 1)).getTime()) / (1000 * 60 * 60 * 24)), 3);
	      case 'k': return pad(date.getHours(), padding === null ? ' ' : padding);
	      case 'L': return pad(Math.floor(timestamp % 1000), 3);
	      case 'l': return pad(hours12(date), padding === null ? ' ' : padding);
	      case 'M': return pad(date.getMinutes(), padding);
	      case 'm': return pad(date.getMonth() + 1, padding);
	      case 'n': return '\n';
	      case 'o': return String(date.getDate()) + ordinal(date.getDate());
	      case 'P': return date.getHours() < 12 ? names.am.toLowerCase() : names.pm.toLowerCase();
	      case 'p': return date.getHours() < 12 ? names.am.toUpperCase() : names.pm.toUpperCase();
	      case 'R': return strftime(date, '%H:%M');
	      case 'r': return strftime(date, '%I:%M:%S %p');
	      case 'S': return pad(date.getSeconds(), padding);
	      case 's': return Math.floor(timestamp / 1000);
	      case 'T': return strftime(date, '%H:%M:%S');
	      case 't': return '\t';
	      case 'U': return pad(weekNumber(date, 'sunday'), padding);
	      case 'u': return date.getDay() === 0 ? 7 : date.getDay();
	      case 'v': return strftime(date, '%e-%b-%Y');
	      case 'W': return pad(weekNumber(date, 'monday'), padding);
	      case 'w': return date.getDay();
	      case 'Y': return date.getFullYear();
	      case 'y': var y = String(date.getFullYear()); return y.slice(y.length - 2);
	      case 'Z': var tzString = date.toString().match(/\((\w+)\)/); return tzString && tzString[1] || '';
	      case 'z': var off = date.getTimezoneOffset(); return (off > 0 ? '-' : '+') + pad(Math.round(Math.abs(off / 60)), 2) + ':' + pad(off % 60, 2);
	      default: return c;
	    }
	  });
	}
	
	function pad(n, padding, length) {
	  if (typeof padding === 'number') {
	    length = padding;
	    padding = '0';
	  }
	
	  if (padding === null) {
	    padding = '0';
	  }
	
	  length = length || 2;
	
	  var s = String(n);
	
	  if (padding) {
	    while (s.length < length) {
	      s = padding + s;
	    }
	  }
	
	  return s;
	}
	
	function hours12(date) {
	  var hour = date.getHours();
	
	  if (hour === 0) {
	    hour = 12;
	  } else if (hour > 12) {
	    hour -= 12;
	  }
	
	  return hour;
	}
	
	function ordinal(n) {
	  var i = n % 10, ii = n % 100;
	
	  if ((ii >= 11 && ii <= 13) || i === 0 || i >= 4) {
	    return 'th';
	  }
	
	  switch (i) {
	    case 1: return 'st';
	    case 2: return 'nd';
	    case 3: return 'rd';
	  }
	}
	
	function weekNumber(date, firstWeekday) {
	  firstWeekday = firstWeekday || 'sunday';
	
	  var wday = date.getDay();
	
	  if (firstWeekday == 'monday') {
	    if (wday === 0) { // Sunday
	      wday = 6;
	    } else {
	      wday--;
	    }
	  }
	
	  var
	    firstDayOfYear = new Date(date.getFullYear(), 0, 1),
	    yday = (date - firstDayOfYear) / 86400000,
	    weekNum = (yday + 7 - wday) / 7;
	
	  return Math.floor(weekNum);
	}
	
	module.exports = strftime;


/***/ },
/* 1277 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(26);
	
	var emptyObject = __webpack_require__(130);
	var _invariant = __webpack_require__(15);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 1278 */
/***/ function(module, exports) {

	// http://www.w3.org/TR/CSS21/grammar.html
	// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
	var commentre = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g
	
	module.exports = function(css, options){
	  options = options || {};
	
	  /**
	   * Positional.
	   */
	
	  var lineno = 1;
	  var column = 1;
	
	  /**
	   * Update lineno and column based on `str`.
	   */
	
	  function updatePosition(str) {
	    var lines = str.match(/\n/g);
	    if (lines) lineno += lines.length;
	    var i = str.lastIndexOf('\n');
	    column = ~i ? str.length - i : column + str.length;
	  }
	
	  /**
	   * Mark position and patch `node.position`.
	   */
	
	  function position() {
	    var start = { line: lineno, column: column };
	    return function(node){
	      node.position = new Position(start);
	      whitespace();
	      return node;
	    };
	  }
	
	  /**
	   * Store position information for a node
	   */
	
	  function Position(start) {
	    this.start = start;
	    this.end = { line: lineno, column: column };
	    this.source = options.source;
	  }
	
	  /**
	   * Non-enumerable source string
	   */
	
	  Position.prototype.content = css;
	
	  /**
	   * Error `msg`.
	   */
	
	  var errorsList = [];
	
	  function error(msg) {
	    var err = new Error(options.source + ':' + lineno + ':' + column + ': ' + msg);
	    err.reason = msg;
	    err.filename = options.source;
	    err.line = lineno;
	    err.column = column;
	    err.source = css;
	
	    if (options.silent) {
	      errorsList.push(err);
	    } else {
	      throw err;
	    }
	  }
	
	  /**
	   * Parse stylesheet.
	   */
	
	  function stylesheet() {
	    var rulesList = rules();
	
	    return {
	      type: 'stylesheet',
	      stylesheet: {
	        rules: rulesList,
	        parsingErrors: errorsList
	      }
	    };
	  }
	
	  /**
	   * Opening brace.
	   */
	
	  function open() {
	    return match(/^{\s*/);
	  }
	
	  /**
	   * Closing brace.
	   */
	
	  function close() {
	    return match(/^}/);
	  }
	
	  /**
	   * Parse ruleset.
	   */
	
	  function rules() {
	    var node;
	    var rules = [];
	    whitespace();
	    comments(rules);
	    while (css.length && css.charAt(0) != '}' && (node = atrule() || rule())) {
	      if (node !== false) {
	        rules.push(node);
	        comments(rules);
	      }
	    }
	    return rules;
	  }
	
	  /**
	   * Match `re` and return captures.
	   */
	
	  function match(re) {
	    var m = re.exec(css);
	    if (!m) return;
	    var str = m[0];
	    updatePosition(str);
	    css = css.slice(str.length);
	    return m;
	  }
	
	  /**
	   * Parse whitespace.
	   */
	
	  function whitespace() {
	    match(/^\s*/);
	  }
	
	  /**
	   * Parse comments;
	   */
	
	  function comments(rules) {
	    var c;
	    rules = rules || [];
	    while (c = comment()) {
	      if (c !== false) {
	        rules.push(c);
	      }
	    }
	    return rules;
	  }
	
	  /**
	   * Parse comment.
	   */
	
	  function comment() {
	    var pos = position();
	    if ('/' != css.charAt(0) || '*' != css.charAt(1)) return;
	
	    var i = 2;
	    while ("" != css.charAt(i) && ('*' != css.charAt(i) || '/' != css.charAt(i + 1))) ++i;
	    i += 2;
	
	    if ("" === css.charAt(i-1)) {
	      return error('End of comment missing');
	    }
	
	    var str = css.slice(2, i - 2);
	    column += 2;
	    updatePosition(str);
	    css = css.slice(i);
	    column += 2;
	
	    return pos({
	      type: 'comment',
	      comment: str
	    });
	  }
	
	  /**
	   * Parse selector.
	   */
	
	  function selector() {
	    var m = match(/^([^{]+)/);
	    if (!m) return;
	    /* @fix Remove all comments from selectors
	     * http://ostermiller.org/findcomment.html */
	    return trim(m[0])
	      .replace(/\/\*([^*]|[\r\n]|(\*+([^*/]|[\r\n])))*\*\/+/g, '')
	      .replace(/"(?:\\"|[^"])*"|'(?:\\'|[^'])*'/g, function(m) {
	        return m.replace(/,/g, '\u200C');
	      })
	      .split(/\s*(?![^(]*\)),\s*/)
	      .map(function(s) {
	        return s.replace(/\u200C/g, ',');
	      });
	  }
	
	  /**
	   * Parse declaration.
	   */
	
	  function declaration() {
	    var pos = position();
	
	    // prop
	    var prop = match(/^(\*?[-#\/\*\\\w]+(\[[0-9a-z_-]+\])?)\s*/);
	    if (!prop) return;
	    prop = trim(prop[0]);
	
	    // :
	    if (!match(/^:\s*/)) return error("property missing ':'");
	
	    // val
	    var val = match(/^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^\)]*?\)|[^};])+)/);
	
	    var ret = pos({
	      type: 'declaration',
	      property: prop.replace(commentre, ''),
	      value: val ? trim(val[0]).replace(commentre, '') : ''
	    });
	
	    // ;
	    match(/^[;\s]*/);
	
	    return ret;
	  }
	
	  /**
	   * Parse declarations.
	   */
	
	  function declarations() {
	    var decls = [];
	
	    if (!open()) return error("missing '{'");
	    comments(decls);
	
	    // declarations
	    var decl;
	    while (decl = declaration()) {
	      if (decl !== false) {
	        decls.push(decl);
	        comments(decls);
	      }
	    }
	
	    if (!close()) return error("missing '}'");
	    return decls;
	  }
	
	  /**
	   * Parse keyframe.
	   */
	
	  function keyframe() {
	    var m;
	    var vals = [];
	    var pos = position();
	
	    while (m = match(/^((\d+\.\d+|\.\d+|\d+)%?|[a-z]+)\s*/)) {
	      vals.push(m[1]);
	      match(/^,\s*/);
	    }
	
	    if (!vals.length) return;
	
	    return pos({
	      type: 'keyframe',
	      values: vals,
	      declarations: declarations()
	    });
	  }
	
	  /**
	   * Parse keyframes.
	   */
	
	  function atkeyframes() {
	    var pos = position();
	    var m = match(/^@([-\w]+)?keyframes\s*/);
	
	    if (!m) return;
	    var vendor = m[1];
	
	    // identifier
	    var m = match(/^([-\w]+)\s*/);
	    if (!m) return error("@keyframes missing name");
	    var name = m[1];
	
	    if (!open()) return error("@keyframes missing '{'");
	
	    var frame;
	    var frames = comments();
	    while (frame = keyframe()) {
	      frames.push(frame);
	      frames = frames.concat(comments());
	    }
	
	    if (!close()) return error("@keyframes missing '}'");
	
	    return pos({
	      type: 'keyframes',
	      name: name,
	      vendor: vendor,
	      keyframes: frames
	    });
	  }
	
	  /**
	   * Parse supports.
	   */
	
	  function atsupports() {
	    var pos = position();
	    var m = match(/^@supports *([^{]+)/);
	
	    if (!m) return;
	    var supports = trim(m[1]);
	
	    if (!open()) return error("@supports missing '{'");
	
	    var style = comments().concat(rules());
	
	    if (!close()) return error("@supports missing '}'");
	
	    return pos({
	      type: 'supports',
	      supports: supports,
	      rules: style
	    });
	  }
	
	  /**
	   * Parse host.
	   */
	
	  function athost() {
	    var pos = position();
	    var m = match(/^@host\s*/);
	
	    if (!m) return;
	
	    if (!open()) return error("@host missing '{'");
	
	    var style = comments().concat(rules());
	
	    if (!close()) return error("@host missing '}'");
	
	    return pos({
	      type: 'host',
	      rules: style
	    });
	  }
	
	  /**
	   * Parse media.
	   */
	
	  function atmedia() {
	    var pos = position();
	    var m = match(/^@media *([^{]+)/);
	
	    if (!m) return;
	    var media = trim(m[1]);
	
	    if (!open()) return error("@media missing '{'");
	
	    var style = comments().concat(rules());
	
	    if (!close()) return error("@media missing '}'");
	
	    return pos({
	      type: 'media',
	      media: media,
	      rules: style
	    });
	  }
	
	
	  /**
	   * Parse custom-media.
	   */
	
	  function atcustommedia() {
	    var pos = position();
	    var m = match(/^@custom-media\s+(--[^\s]+)\s*([^{;]+);/);
	    if (!m) return;
	
	    return pos({
	      type: 'custom-media',
	      name: trim(m[1]),
	      media: trim(m[2])
	    });
	  }
	
	  /**
	   * Parse paged media.
	   */
	
	  function atpage() {
	    var pos = position();
	    var m = match(/^@page */);
	    if (!m) return;
	
	    var sel = selector() || [];
	
	    if (!open()) return error("@page missing '{'");
	    var decls = comments();
	
	    // declarations
	    var decl;
	    while (decl = declaration()) {
	      decls.push(decl);
	      decls = decls.concat(comments());
	    }
	
	    if (!close()) return error("@page missing '}'");
	
	    return pos({
	      type: 'page',
	      selectors: sel,
	      declarations: decls
	    });
	  }
	
	  /**
	   * Parse document.
	   */
	
	  function atdocument() {
	    var pos = position();
	    var m = match(/^@([-\w]+)?document *([^{]+)/);
	    if (!m) return;
	
	    var vendor = trim(m[1]);
	    var doc = trim(m[2]);
	
	    if (!open()) return error("@document missing '{'");
	
	    var style = comments().concat(rules());
	
	    if (!close()) return error("@document missing '}'");
	
	    return pos({
	      type: 'document',
	      document: doc,
	      vendor: vendor,
	      rules: style
	    });
	  }
	
	  /**
	   * Parse font-face.
	   */
	
	  function atfontface() {
	    var pos = position();
	    var m = match(/^@font-face\s*/);
	    if (!m) return;
	
	    if (!open()) return error("@font-face missing '{'");
	    var decls = comments();
	
	    // declarations
	    var decl;
	    while (decl = declaration()) {
	      decls.push(decl);
	      decls = decls.concat(comments());
	    }
	
	    if (!close()) return error("@font-face missing '}'");
	
	    return pos({
	      type: 'font-face',
	      declarations: decls
	    });
	  }
	
	  /**
	   * Parse import
	   */
	
	  var atimport = _compileAtrule('import');
	
	  /**
	   * Parse charset
	   */
	
	  var atcharset = _compileAtrule('charset');
	
	  /**
	   * Parse namespace
	   */
	
	  var atnamespace = _compileAtrule('namespace');
	
	  /**
	   * Parse non-block at-rules
	   */
	
	
	  function _compileAtrule(name) {
	    var re = new RegExp('^@' + name + '\\s*([^;]+);');
	    return function() {
	      var pos = position();
	      var m = match(re);
	      if (!m) return;
	      var ret = { type: name };
	      ret[name] = m[1].trim();
	      return pos(ret);
	    }
	  }
	
	  /**
	   * Parse at rule.
	   */
	
	  function atrule() {
	    if (css[0] != '@') return;
	
	    return atkeyframes()
	      || atmedia()
	      || atcustommedia()
	      || atsupports()
	      || atimport()
	      || atcharset()
	      || atnamespace()
	      || atdocument()
	      || atpage()
	      || athost()
	      || atfontface();
	  }
	
	  /**
	   * Parse rule.
	   */
	
	  function rule() {
	    var pos = position();
	    var sel = selector();
	
	    if (!sel) return error('selector missing');
	    comments();
	
	    return pos({
	      type: 'rule',
	      selectors: sel,
	      declarations: declarations()
	    });
	  }
	
	  return addParent(stylesheet());
	};
	
	/**
	 * Trim `str`.
	 */
	
	function trim(str) {
	  return str ? str.replace(/^\s+|\s+$/g, '') : '';
	}
	
	/**
	 * Adds non-enumerable parent node reference to each node.
	 */
	
	function addParent(obj, parent) {
	  var isNode = obj && typeof obj.type === 'string';
	  var childParent = isNode ? obj : parent;
	
	  for (var k in obj) {
	    var value = obj[k];
	    if (Array.isArray(value)) {
	      value.forEach(function(v) { addParent(v, childParent); });
	    } else if (value && typeof value === 'object') {
	      addParent(value, childParent);
	    }
	  }
	
	  if (isNode) {
	    Object.defineProperty(obj, 'parent', {
	      configurable: true,
	      writable: true,
	      enumerable: false,
	      value: parent || null
	    });
	  }
	
	  return obj;
	}


/***/ },
/* 1279 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = __webpack_require__(440);


/***/ },
/* 1280 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * Date Format 1.2.3
	 * (c) 2007-2009 Steven Levithan <stevenlevithan.com>
	 * MIT license
	 *
	 * Includes enhancements by Scott Trenda <scott.trenda.net>
	 * and Kris Kowal <cixar.com/~kris.kowal/>
	 *
	 * Accepts a date, a mask, or a date and a mask.
	 * Returns a formatted version of the given date.
	 * The date defaults to the current date/time.
	 * The mask defaults to dateFormat.masks.default.
	 */
	
	(function(global) {
	  'use strict';
	
	  var dateFormat = (function() {
	      var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZWN]|'[^']*'|'[^']*'/g;
	      var timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g;
	      var timezoneClip = /[^-+\dA-Z]/g;
	  
	      // Regexes and supporting functions are cached through closure
	      return function (date, mask, utc, gmt) {
	  
	        // You can't provide utc if you skip other args (use the 'UTC:' mask prefix)
	        if (arguments.length === 1 && kindOf(date) === 'string' && !/\d/.test(date)) {
	          mask = date;
	          date = undefined;
	        }
	  
	        date = date || new Date;
	  
	        if(!(date instanceof Date)) {
	          date = new Date(date);
	        }
	  
	        if (isNaN(date)) {
	          throw TypeError('Invalid date');
	        }
	  
	        mask = String(dateFormat.masks[mask] || mask || dateFormat.masks['default']);
	  
	        // Allow setting the utc/gmt argument via the mask
	        var maskSlice = mask.slice(0, 4);
	        if (maskSlice === 'UTC:' || maskSlice === 'GMT:') {
	          mask = mask.slice(4);
	          utc = true;
	          if (maskSlice === 'GMT:') {
	            gmt = true;
	          }
	        }
	  
	        var _ = utc ? 'getUTC' : 'get';
	        var d = date[_ + 'Date']();
	        var D = date[_ + 'Day']();
	        var m = date[_ + 'Month']();
	        var y = date[_ + 'FullYear']();
	        var H = date[_ + 'Hours']();
	        var M = date[_ + 'Minutes']();
	        var s = date[_ + 'Seconds']();
	        var L = date[_ + 'Milliseconds']();
	        var o = utc ? 0 : date.getTimezoneOffset();
	        var W = getWeek(date);
	        var N = getDayOfWeek(date);
	        var flags = {
	          d:    d,
	          dd:   pad(d),
	          ddd:  dateFormat.i18n.dayNames[D],
	          dddd: dateFormat.i18n.dayNames[D + 7],
	          m:    m + 1,
	          mm:   pad(m + 1),
	          mmm:  dateFormat.i18n.monthNames[m],
	          mmmm: dateFormat.i18n.monthNames[m + 12],
	          yy:   String(y).slice(2),
	          yyyy: y,
	          h:    H % 12 || 12,
	          hh:   pad(H % 12 || 12),
	          H:    H,
	          HH:   pad(H),
	          M:    M,
	          MM:   pad(M),
	          s:    s,
	          ss:   pad(s),
	          l:    pad(L, 3),
	          L:    pad(Math.round(L / 10)),
	          t:    H < 12 ? 'a'  : 'p',
	          tt:   H < 12 ? 'am' : 'pm',
	          T:    H < 12 ? 'A'  : 'P',
	          TT:   H < 12 ? 'AM' : 'PM',
	          Z:    gmt ? 'GMT' : utc ? 'UTC' : (String(date).match(timezone) || ['']).pop().replace(timezoneClip, ''),
	          o:    (o > 0 ? '-' : '+') + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
	          S:    ['th', 'st', 'nd', 'rd'][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10],
	          W:    W,
	          N:    N
	        };
	  
	        return mask.replace(token, function (match) {
	          if (match in flags) {
	            return flags[match];
	          }
	          return match.slice(1, match.length - 1);
	        });
	      };
	    })();
	
	  dateFormat.masks = {
	    'default':               'ddd mmm dd yyyy HH:MM:ss',
	    'shortDate':             'm/d/yy',
	    'mediumDate':            'mmm d, yyyy',
	    'longDate':              'mmmm d, yyyy',
	    'fullDate':              'dddd, mmmm d, yyyy',
	    'shortTime':             'h:MM TT',
	    'mediumTime':            'h:MM:ss TT',
	    'longTime':              'h:MM:ss TT Z',
	    'isoDate':               'yyyy-mm-dd',
	    'isoTime':               'HH:MM:ss',
	    'isoDateTime':           'yyyy-mm-dd\'T\'HH:MM:sso',
	    'isoUtcDateTime':        'UTC:yyyy-mm-dd\'T\'HH:MM:ss\'Z\'',
	    'expiresHeaderFormat':   'ddd, dd mmm yyyy HH:MM:ss Z'
	  };
	
	  // Internationalization strings
	  dateFormat.i18n = {
	    dayNames: [
	      'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat',
	      'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
	    ],
	    monthNames: [
	      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
	      'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
	    ]
	  };
	
	function pad(val, len) {
	  val = String(val);
	  len = len || 2;
	  while (val.length < len) {
	    val = '0' + val;
	  }
	  return val;
	}
	
	/**
	 * Get the ISO 8601 week number
	 * Based on comments from
	 * http://techblog.procurios.nl/k/n618/news/view/33796/14863/Calculate-ISO-8601-week-and-year-in-javascript.html
	 *
	 * @param  {Object} `date`
	 * @return {Number}
	 */
	function getWeek(date) {
	  // Remove time components of date
	  var targetThursday = new Date(date.getFullYear(), date.getMonth(), date.getDate());
	
	  // Change date to Thursday same week
	  targetThursday.setDate(targetThursday.getDate() - ((targetThursday.getDay() + 6) % 7) + 3);
	
	  // Take January 4th as it is always in week 1 (see ISO 8601)
	  var firstThursday = new Date(targetThursday.getFullYear(), 0, 4);
	
	  // Change date to Thursday same week
	  firstThursday.setDate(firstThursday.getDate() - ((firstThursday.getDay() + 6) % 7) + 3);
	
	  // Check if daylight-saving-time-switch occured and correct for it
	  var ds = targetThursday.getTimezoneOffset() - firstThursday.getTimezoneOffset();
	  targetThursday.setHours(targetThursday.getHours() - ds);
	
	  // Number of weeks between target Thursday and first Thursday
	  var weekDiff = (targetThursday - firstThursday) / (86400000*7);
	  return 1 + Math.floor(weekDiff);
	}
	
	/**
	 * Get ISO-8601 numeric representation of the day of the week
	 * 1 (for Monday) through 7 (for Sunday)
	 * 
	 * @param  {Object} `date`
	 * @return {Number}
	 */
	function getDayOfWeek(date) {
	  var dow = date.getDay();
	  if(dow === 0) {
	    dow = 7;
	  }
	  return dow;
	}
	
	/**
	 * kind-of shortcut
	 * @param  {*} val
	 * @return {String}
	 */
	function kindOf(val) {
	  if (val === null) {
	    return 'null';
	  }
	
	  if (val === undefined) {
	    return 'undefined';
	  }
	
	  if (typeof val !== 'object') {
	    return typeof val;
	  }
	
	  if (Array.isArray(val)) {
	    return 'array';
	  }
	
	  return {}.toString.call(val)
	    .slice(8, -1).toLowerCase();
	};
	
	
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return dateFormat;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = dateFormat;
	  } else {
	    global.dateFormat = dateFormat;
	  }
	})(this);


/***/ },
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(187);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var off = function off() {};
	if (_inDOM2.default) {
	  off = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  }();
	}
	
	exports.default = off;
	module.exports = exports['default'];

/***/ },
/* 1285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = offsetParent;
	
	var _ownerDocument = __webpack_require__(279);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _style = __webpack_require__(444);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function offsetParent(node) {
	  var doc = (0, _ownerDocument2.default)(node),
	      offsetParent = node && node.offsetParent;
	
	  while (offsetParent && nodeName(node) !== 'html' && (0, _style2.default)(offsetParent, 'position') === 'static') {
	    offsetParent = offsetParent.offsetParent;
	  }
	
	  return offsetParent || doc.documentElement;
	}
	module.exports = exports['default'];

/***/ },
/* 1286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = position;
	
	var _offset = __webpack_require__(442);
	
	var _offset2 = _interopRequireDefault(_offset);
	
	var _offsetParent = __webpack_require__(1285);
	
	var _offsetParent2 = _interopRequireDefault(_offsetParent);
	
	var _scrollTop = __webpack_require__(443);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _scrollLeft = __webpack_require__(1287);
	
	var _scrollLeft2 = _interopRequireDefault(_scrollLeft);
	
	var _style = __webpack_require__(444);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function position(node, offsetParent) {
	  var parentOffset = { top: 0, left: 0 },
	      offset;
	
	  // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
	  // because it is its only offset parent
	  if ((0, _style2.default)(node, 'position') === 'fixed') {
	    offset = node.getBoundingClientRect();
	  } else {
	    offsetParent = offsetParent || (0, _offsetParent2.default)(node);
	    offset = (0, _offset2.default)(node);
	
	    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset2.default)(offsetParent);
	
	    parentOffset.top += parseInt((0, _style2.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop2.default)(offsetParent) || 0;
	    parentOffset.left += parseInt((0, _style2.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft2.default)(offsetParent) || 0;
	  }
	
	  // Subtract parent offsets and node margins
	  return _extends({}, offset, {
	    top: offset.top - parentOffset.top - (parseInt((0, _style2.default)(node, 'marginTop'), 10) || 0),
	    left: offset.left - parentOffset.left - (parseInt((0, _style2.default)(node, 'marginLeft'), 10) || 0)
	  });
	}
	module.exports = exports['default'];

/***/ },
/* 1287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = scrollTop;
	
	var _isWindow = __webpack_require__(281);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow2.default)(node);
	
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	}
	module.exports = exports['default'];

/***/ },
/* 1288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = _getComputedStyle;
	
	var _camelizeStyle = __webpack_require__(446);
	
	var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rposition = /^(top|right|bottom|left)$/;
	var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
	function _getComputedStyle(node) {
	  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
	  var doc = node.ownerDocument;
	
	  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
	    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
	    getPropertyValue: function getPropertyValue(prop) {
	      var style = node.style;
	
	      prop = (0, _camelizeStyle2.default)(prop);
	
	      if (prop == 'float') prop = 'styleFloat';
	
	      var current = node.currentStyle[prop] || null;
	
	      if (current == null && style && style[prop]) current = style[prop];
	
	      if (rnumnonpx.test(current) && !rposition.test(prop)) {
	        // Remember the original values
	        var left = style.left;
	        var runStyle = node.runtimeStyle;
	        var rsLeft = runStyle && runStyle.left;
	
	        // Put in the new values to get a computed value out
	        if (rsLeft) runStyle.left = node.currentStyle.left;
	
	        style.left = prop === 'fontSize' ? '1em' : current;
	        current = style.pixelLeft + 'px';
	
	        // Revert the changed values
	        style.left = left;
	        if (rsLeft) runStyle.left = rsLeft;
	      }
	
	      return current;
	    }
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 1289 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = removeStyle;
	function removeStyle(node, key) {
	  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
	}
	module.exports = exports['default'];

/***/ },
/* 1290 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isTransform;
	var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
	
	function isTransform(property) {
	  return !!(property && supportedTransforms.test(property));
	}
	module.exports = exports["default"];

/***/ },
/* 1291 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = camelize;
	var rHyphen = /-(.)/g;
	
	function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	}
	module.exports = exports["default"];

/***/ },
/* 1292 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hyphenate;
	
	var rUpper = /([A-Z])/g;
	
	function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	}
	module.exports = exports['default'];

/***/ },
/* 1293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hyphenateStyleName;
	
	var _hyphenate = __webpack_require__(1292);
	
	var _hyphenate2 = _interopRequireDefault(_hyphenate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var msPattern = /^ms-/; /**
	                         * Copyright 2013-2014, Facebook, Inc.
	                         * All rights reserved.
	                         * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	                         */
	
	function hyphenateStyleName(string) {
	  return (0, _hyphenate2.default)(string).replace(msPattern, '-ms-');
	}
	module.exports = exports['default'];

/***/ },
/* 1294 */
/***/ function(module, exports) {

	module.exports = function(opts) {
	  return new ElementClass(opts)
	}
	
	function indexOf(arr, prop) {
	  if (arr.indexOf) return arr.indexOf(prop)
	  for (var i = 0, len = arr.length; i < len; i++)
	    if (arr[i] === prop) return i
	  return -1
	}
	
	function ElementClass(opts) {
	  if (!(this instanceof ElementClass)) return new ElementClass(opts)
	  var self = this
	  if (!opts) opts = {}
	
	  // similar doing instanceof HTMLElement but works in IE8
	  if (opts.nodeType) opts = {el: opts}
	
	  this.opts = opts
	  this.el = opts.el || document.body
	  if (typeof this.el !== 'object') this.el = document.querySelector(this.el)
	}
	
	ElementClass.prototype.add = function(className) {
	  var el = this.el
	  if (!el) return
	  if (el.className === "") return el.className = className
	  var classes = el.className.split(' ')
	  if (indexOf(classes, className) > -1) return classes
	  classes.push(className)
	  el.className = classes.join(' ')
	  return classes
	}
	
	ElementClass.prototype.remove = function(className) {
	  var el = this.el
	  if (!el) return
	  if (el.className === "") return
	  var classes = el.className.split(' ')
	  var idx = indexOf(classes, className)
	  if (idx > -1) classes.splice(idx, 1)
	  el.className = classes.join(' ')
	  return classes
	}
	
	ElementClass.prototype.has = function(className) {
	  var el = this.el
	  if (!el) return
	  var classes = el.className.split(' ')
	  return indexOf(classes, className) > -1
	}
	
	ElementClass.prototype.toggle = function(className) {
	  var el = this.el
	  if (!el) return
	  if (this.has(className)) this.remove(className)
	  else this.add(className)
	}


/***/ },
/* 1295 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, global) {/*!
	 * @overview es6-promise - a tiny implementation of Promises/A+.
	 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
	 * @license   Licensed under MIT license
	 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
	 * @version   v4.2.4+314e4831
	 */
	
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.ES6Promise = factory());
	}(this, (function () { 'use strict';
	
	function objectOrFunction(x) {
	  var type = typeof x;
	  return x !== null && (type === 'object' || type === 'function');
	}
	
	function isFunction(x) {
	  return typeof x === 'function';
	}
	
	
	
	var _isArray = void 0;
	if (Array.isArray) {
	  _isArray = Array.isArray;
	} else {
	  _isArray = function (x) {
	    return Object.prototype.toString.call(x) === '[object Array]';
	  };
	}
	
	var isArray = _isArray;
	
	var len = 0;
	var vertxNext = void 0;
	var customSchedulerFn = void 0;
	
	var asap = function asap(callback, arg) {
	  queue[len] = callback;
	  queue[len + 1] = arg;
	  len += 2;
	  if (len === 2) {
	    // If len is 2, that means that we need to schedule an async flush.
	    // If additional callbacks are queued before the queue is flushed, they
	    // will be processed by this flush that we are scheduling.
	    if (customSchedulerFn) {
	      customSchedulerFn(flush);
	    } else {
	      scheduleFlush();
	    }
	  }
	};
	
	function setScheduler(scheduleFn) {
	  customSchedulerFn = scheduleFn;
	}
	
	function setAsap(asapFn) {
	  asap = asapFn;
	}
	
	var browserWindow = typeof window !== 'undefined' ? window : undefined;
	var browserGlobal = browserWindow || {};
	var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
	var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';
	
	// test for web worker but not in IE10
	var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';
	
	// node
	function useNextTick() {
	  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
	  // see https://github.com/cujojs/when/issues/410 for details
	  return function () {
	    return process.nextTick(flush);
	  };
	}
	
	// vertx
	function useVertxTimer() {
	  if (typeof vertxNext !== 'undefined') {
	    return function () {
	      vertxNext(flush);
	    };
	  }
	
	  return useSetTimeout();
	}
	
	function useMutationObserver() {
	  var iterations = 0;
	  var observer = new BrowserMutationObserver(flush);
	  var node = document.createTextNode('');
	  observer.observe(node, { characterData: true });
	
	  return function () {
	    node.data = iterations = ++iterations % 2;
	  };
	}
	
	// web worker
	function useMessageChannel() {
	  var channel = new MessageChannel();
	  channel.port1.onmessage = flush;
	  return function () {
	    return channel.port2.postMessage(0);
	  };
	}
	
	function useSetTimeout() {
	  // Store setTimeout reference so es6-promise will be unaffected by
	  // other code modifying setTimeout (like sinon.useFakeTimers())
	  var globalSetTimeout = setTimeout;
	  return function () {
	    return globalSetTimeout(flush, 1);
	  };
	}
	
	var queue = new Array(1000);
	function flush() {
	  for (var i = 0; i < len; i += 2) {
	    var callback = queue[i];
	    var arg = queue[i + 1];
	
	    callback(arg);
	
	    queue[i] = undefined;
	    queue[i + 1] = undefined;
	  }
	
	  len = 0;
	}
	
	function attemptVertx() {
	  try {
	    var vertx = Function('return this')().require('vertx');
	    vertxNext = vertx.runOnLoop || vertx.runOnContext;
	    return useVertxTimer();
	  } catch (e) {
	    return useSetTimeout();
	  }
	}
	
	var scheduleFlush = void 0;
	// Decide what async method to use to triggering processing of queued callbacks:
	if (isNode) {
	  scheduleFlush = useNextTick();
	} else if (BrowserMutationObserver) {
	  scheduleFlush = useMutationObserver();
	} else if (isWorker) {
	  scheduleFlush = useMessageChannel();
	} else if (browserWindow === undefined && "function" === 'function') {
	  scheduleFlush = attemptVertx();
	} else {
	  scheduleFlush = useSetTimeout();
	}
	
	function then(onFulfillment, onRejection) {
	  var parent = this;
	
	  var child = new this.constructor(noop);
	
	  if (child[PROMISE_ID] === undefined) {
	    makePromise(child);
	  }
	
	  var _state = parent._state;
	
	
	  if (_state) {
	    var callback = arguments[_state - 1];
	    asap(function () {
	      return invokeCallback(_state, child, callback, parent._result);
	    });
	  } else {
	    subscribe(parent, child, onFulfillment, onRejection);
	  }
	
	  return child;
	}
	
	/**
	  `Promise.resolve` returns a promise that will become resolved with the
	  passed `value`. It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    resolve(1);
	  });
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.resolve(1);
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  @method resolve
	  @static
	  @param {Any} value value that the returned promise will be resolved with
	  Useful for tooling.
	  @return {Promise} a promise that will become fulfilled with the given
	  `value`
	*/
	function resolve$1(object) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  if (object && typeof object === 'object' && object.constructor === Constructor) {
	    return object;
	  }
	
	  var promise = new Constructor(noop);
	  resolve(promise, object);
	  return promise;
	}
	
	var PROMISE_ID = Math.random().toString(36).substring(2);
	
	function noop() {}
	
	var PENDING = void 0;
	var FULFILLED = 1;
	var REJECTED = 2;
	
	var TRY_CATCH_ERROR = { error: null };
	
	function selfFulfillment() {
	  return new TypeError("You cannot resolve a promise with itself");
	}
	
	function cannotReturnOwn() {
	  return new TypeError('A promises callback cannot return that same promise.');
	}
	
	function getThen(promise) {
	  try {
	    return promise.then;
	  } catch (error) {
	    TRY_CATCH_ERROR.error = error;
	    return TRY_CATCH_ERROR;
	  }
	}
	
	function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
	  try {
	    then$$1.call(value, fulfillmentHandler, rejectionHandler);
	  } catch (e) {
	    return e;
	  }
	}
	
	function handleForeignThenable(promise, thenable, then$$1) {
	  asap(function (promise) {
	    var sealed = false;
	    var error = tryThen(then$$1, thenable, function (value) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	      if (thenable !== value) {
	        resolve(promise, value);
	      } else {
	        fulfill(promise, value);
	      }
	    }, function (reason) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	
	      reject(promise, reason);
	    }, 'Settle: ' + (promise._label || ' unknown promise'));
	
	    if (!sealed && error) {
	      sealed = true;
	      reject(promise, error);
	    }
	  }, promise);
	}
	
	function handleOwnThenable(promise, thenable) {
	  if (thenable._state === FULFILLED) {
	    fulfill(promise, thenable._result);
	  } else if (thenable._state === REJECTED) {
	    reject(promise, thenable._result);
	  } else {
	    subscribe(thenable, undefined, function (value) {
	      return resolve(promise, value);
	    }, function (reason) {
	      return reject(promise, reason);
	    });
	  }
	}
	
	function handleMaybeThenable(promise, maybeThenable, then$$1) {
	  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
	    handleOwnThenable(promise, maybeThenable);
	  } else {
	    if (then$$1 === TRY_CATCH_ERROR) {
	      reject(promise, TRY_CATCH_ERROR.error);
	      TRY_CATCH_ERROR.error = null;
	    } else if (then$$1 === undefined) {
	      fulfill(promise, maybeThenable);
	    } else if (isFunction(then$$1)) {
	      handleForeignThenable(promise, maybeThenable, then$$1);
	    } else {
	      fulfill(promise, maybeThenable);
	    }
	  }
	}
	
	function resolve(promise, value) {
	  if (promise === value) {
	    reject(promise, selfFulfillment());
	  } else if (objectOrFunction(value)) {
	    handleMaybeThenable(promise, value, getThen(value));
	  } else {
	    fulfill(promise, value);
	  }
	}
	
	function publishRejection(promise) {
	  if (promise._onerror) {
	    promise._onerror(promise._result);
	  }
	
	  publish(promise);
	}
	
	function fulfill(promise, value) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	
	  promise._result = value;
	  promise._state = FULFILLED;
	
	  if (promise._subscribers.length !== 0) {
	    asap(publish, promise);
	  }
	}
	
	function reject(promise, reason) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	  promise._state = REJECTED;
	  promise._result = reason;
	
	  asap(publishRejection, promise);
	}
	
	function subscribe(parent, child, onFulfillment, onRejection) {
	  var _subscribers = parent._subscribers;
	  var length = _subscribers.length;
	
	
	  parent._onerror = null;
	
	  _subscribers[length] = child;
	  _subscribers[length + FULFILLED] = onFulfillment;
	  _subscribers[length + REJECTED] = onRejection;
	
	  if (length === 0 && parent._state) {
	    asap(publish, parent);
	  }
	}
	
	function publish(promise) {
	  var subscribers = promise._subscribers;
	  var settled = promise._state;
	
	  if (subscribers.length === 0) {
	    return;
	  }
	
	  var child = void 0,
	      callback = void 0,
	      detail = promise._result;
	
	  for (var i = 0; i < subscribers.length; i += 3) {
	    child = subscribers[i];
	    callback = subscribers[i + settled];
	
	    if (child) {
	      invokeCallback(settled, child, callback, detail);
	    } else {
	      callback(detail);
	    }
	  }
	
	  promise._subscribers.length = 0;
	}
	
	function tryCatch(callback, detail) {
	  try {
	    return callback(detail);
	  } catch (e) {
	    TRY_CATCH_ERROR.error = e;
	    return TRY_CATCH_ERROR;
	  }
	}
	
	function invokeCallback(settled, promise, callback, detail) {
	  var hasCallback = isFunction(callback),
	      value = void 0,
	      error = void 0,
	      succeeded = void 0,
	      failed = void 0;
	
	  if (hasCallback) {
	    value = tryCatch(callback, detail);
	
	    if (value === TRY_CATCH_ERROR) {
	      failed = true;
	      error = value.error;
	      value.error = null;
	    } else {
	      succeeded = true;
	    }
	
	    if (promise === value) {
	      reject(promise, cannotReturnOwn());
	      return;
	    }
	  } else {
	    value = detail;
	    succeeded = true;
	  }
	
	  if (promise._state !== PENDING) {
	    // noop
	  } else if (hasCallback && succeeded) {
	    resolve(promise, value);
	  } else if (failed) {
	    reject(promise, error);
	  } else if (settled === FULFILLED) {
	    fulfill(promise, value);
	  } else if (settled === REJECTED) {
	    reject(promise, value);
	  }
	}
	
	function initializePromise(promise, resolver) {
	  try {
	    resolver(function resolvePromise(value) {
	      resolve(promise, value);
	    }, function rejectPromise(reason) {
	      reject(promise, reason);
	    });
	  } catch (e) {
	    reject(promise, e);
	  }
	}
	
	var id = 0;
	function nextId() {
	  return id++;
	}
	
	function makePromise(promise) {
	  promise[PROMISE_ID] = id++;
	  promise._state = undefined;
	  promise._result = undefined;
	  promise._subscribers = [];
	}
	
	function validationError() {
	  return new Error('Array Methods must be provided an Array');
	}
	
	var Enumerator = function () {
	  function Enumerator(Constructor, input) {
	    this._instanceConstructor = Constructor;
	    this.promise = new Constructor(noop);
	
	    if (!this.promise[PROMISE_ID]) {
	      makePromise(this.promise);
	    }
	
	    if (isArray(input)) {
	      this.length = input.length;
	      this._remaining = input.length;
	
	      this._result = new Array(this.length);
	
	      if (this.length === 0) {
	        fulfill(this.promise, this._result);
	      } else {
	        this.length = this.length || 0;
	        this._enumerate(input);
	        if (this._remaining === 0) {
	          fulfill(this.promise, this._result);
	        }
	      }
	    } else {
	      reject(this.promise, validationError());
	    }
	  }
	
	  Enumerator.prototype._enumerate = function _enumerate(input) {
	    for (var i = 0; this._state === PENDING && i < input.length; i++) {
	      this._eachEntry(input[i], i);
	    }
	  };
	
	  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
	    var c = this._instanceConstructor;
	    var resolve$$1 = c.resolve;
	
	
	    if (resolve$$1 === resolve$1) {
	      var _then = getThen(entry);
	
	      if (_then === then && entry._state !== PENDING) {
	        this._settledAt(entry._state, i, entry._result);
	      } else if (typeof _then !== 'function') {
	        this._remaining--;
	        this._result[i] = entry;
	      } else if (c === Promise$1) {
	        var promise = new c(noop);
	        handleMaybeThenable(promise, entry, _then);
	        this._willSettleAt(promise, i);
	      } else {
	        this._willSettleAt(new c(function (resolve$$1) {
	          return resolve$$1(entry);
	        }), i);
	      }
	    } else {
	      this._willSettleAt(resolve$$1(entry), i);
	    }
	  };
	
	  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
	    var promise = this.promise;
	
	
	    if (promise._state === PENDING) {
	      this._remaining--;
	
	      if (state === REJECTED) {
	        reject(promise, value);
	      } else {
	        this._result[i] = value;
	      }
	    }
	
	    if (this._remaining === 0) {
	      fulfill(promise, this._result);
	    }
	  };
	
	  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
	    var enumerator = this;
	
	    subscribe(promise, undefined, function (value) {
	      return enumerator._settledAt(FULFILLED, i, value);
	    }, function (reason) {
	      return enumerator._settledAt(REJECTED, i, reason);
	    });
	  };
	
	  return Enumerator;
	}();
	
	/**
	  `Promise.all` accepts an array of promises, and returns a new promise which
	  is fulfilled with an array of fulfillment values for the passed promises, or
	  rejected with the reason of the first passed promise to be rejected. It casts all
	  elements of the passed iterable to promises as it runs this algorithm.
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = resolve(2);
	  let promise3 = resolve(3);
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // The array here would be [ 1, 2, 3 ];
	  });
	  ```
	
	  If any of the `promises` given to `all` are rejected, the first promise
	  that is rejected will be given as an argument to the returned promises's
	  rejection handler. For example:
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = reject(new Error("2"));
	  let promise3 = reject(new Error("3"));
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // Code here never runs because there are rejected promises!
	  }, function(error) {
	    // error.message === "2"
	  });
	  ```
	
	  @method all
	  @static
	  @param {Array} entries array of promises
	  @param {String} label optional string for labeling the promise.
	  Useful for tooling.
	  @return {Promise} promise that is fulfilled when all `promises` have been
	  fulfilled, or rejected if any of them become rejected.
	  @static
	*/
	function all(entries) {
	  return new Enumerator(this, entries).promise;
	}
	
	/**
	  `Promise.race` returns a new promise which is settled in the same way as the
	  first passed promise to settle.
	
	  Example:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 2');
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // result === 'promise 2' because it was resolved before promise1
	    // was resolved.
	  });
	  ```
	
	  `Promise.race` is deterministic in that only the state of the first
	  settled promise matters. For example, even if other promises given to the
	  `promises` array argument are resolved, but the first settled promise has
	  become rejected before the other promises became fulfilled, the returned
	  promise will become rejected:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      reject(new Error('promise 2'));
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // Code here never runs
	  }, function(reason){
	    // reason.message === 'promise 2' because promise 2 became rejected before
	    // promise 1 became fulfilled
	  });
	  ```
	
	  An example real-world use case is implementing timeouts:
	
	  ```javascript
	  Promise.race([ajax('foo.json'), timeout(5000)])
	  ```
	
	  @method race
	  @static
	  @param {Array} promises array of promises to observe
	  Useful for tooling.
	  @return {Promise} a promise which settles in the same way as the first passed
	  promise to settle.
	*/
	function race(entries) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  if (!isArray(entries)) {
	    return new Constructor(function (_, reject) {
	      return reject(new TypeError('You must pass an array to race.'));
	    });
	  } else {
	    return new Constructor(function (resolve, reject) {
	      var length = entries.length;
	      for (var i = 0; i < length; i++) {
	        Constructor.resolve(entries[i]).then(resolve, reject);
	      }
	    });
	  }
	}
	
	/**
	  `Promise.reject` returns a promise rejected with the passed `reason`.
	  It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    reject(new Error('WHOOPS'));
	  });
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.reject(new Error('WHOOPS'));
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  @method reject
	  @static
	  @param {Any} reason value that the returned promise will be rejected with.
	  Useful for tooling.
	  @return {Promise} a promise rejected with the given `reason`.
	*/
	function reject$1(reason) {
	  /*jshint validthis:true */
	  var Constructor = this;
	  var promise = new Constructor(noop);
	  reject(promise, reason);
	  return promise;
	}
	
	function needsResolver() {
	  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
	}
	
	function needsNew() {
	  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
	}
	
	/**
	  Promise objects represent the eventual result of an asynchronous operation. The
	  primary way of interacting with a promise is through its `then` method, which
	  registers callbacks to receive either a promise's eventual value or the reason
	  why the promise cannot be fulfilled.
	
	  Terminology
	  -----------
	
	  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
	  - `thenable` is an object or function that defines a `then` method.
	  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
	  - `exception` is a value that is thrown using the throw statement.
	  - `reason` is a value that indicates why a promise was rejected.
	  - `settled` the final resting state of a promise, fulfilled or rejected.
	
	  A promise can be in one of three states: pending, fulfilled, or rejected.
	
	  Promises that are fulfilled have a fulfillment value and are in the fulfilled
	  state.  Promises that are rejected have a rejection reason and are in the
	  rejected state.  A fulfillment value is never a thenable.
	
	  Promises can also be said to *resolve* a value.  If this value is also a
	  promise, then the original promise's settled state will match the value's
	  settled state.  So a promise that *resolves* a promise that rejects will
	  itself reject, and a promise that *resolves* a promise that fulfills will
	  itself fulfill.
	
	
	  Basic Usage:
	  ------------
	
	  ```js
	  let promise = new Promise(function(resolve, reject) {
	    // on success
	    resolve(value);
	
	    // on failure
	    reject(reason);
	  });
	
	  promise.then(function(value) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Advanced Usage:
	  ---------------
	
	  Promises shine when abstracting away asynchronous interactions such as
	  `XMLHttpRequest`s.
	
	  ```js
	  function getJSON(url) {
	    return new Promise(function(resolve, reject){
	      let xhr = new XMLHttpRequest();
	
	      xhr.open('GET', url);
	      xhr.onreadystatechange = handler;
	      xhr.responseType = 'json';
	      xhr.setRequestHeader('Accept', 'application/json');
	      xhr.send();
	
	      function handler() {
	        if (this.readyState === this.DONE) {
	          if (this.status === 200) {
	            resolve(this.response);
	          } else {
	            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
	          }
	        }
	      };
	    });
	  }
	
	  getJSON('/posts.json').then(function(json) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Unlike callbacks, promises are great composable primitives.
	
	  ```js
	  Promise.all([
	    getJSON('/posts'),
	    getJSON('/comments')
	  ]).then(function(values){
	    values[0] // => postsJSON
	    values[1] // => commentsJSON
	
	    return values;
	  });
	  ```
	
	  @class Promise
	  @param {Function} resolver
	  Useful for tooling.
	  @constructor
	*/
	
	var Promise$1 = function () {
	  function Promise(resolver) {
	    this[PROMISE_ID] = nextId();
	    this._result = this._state = undefined;
	    this._subscribers = [];
	
	    if (noop !== resolver) {
	      typeof resolver !== 'function' && needsResolver();
	      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
	    }
	  }
	
	  /**
	  The primary way of interacting with a promise is through its `then` method,
	  which registers callbacks to receive either a promise's eventual value or the
	  reason why the promise cannot be fulfilled.
	   ```js
	  findUser().then(function(user){
	    // user is available
	  }, function(reason){
	    // user is unavailable, and you are given the reason why
	  });
	  ```
	   Chaining
	  --------
	   The return value of `then` is itself a promise.  This second, 'downstream'
	  promise is resolved with the return value of the first promise's fulfillment
	  or rejection handler, or rejected if the handler throws an exception.
	   ```js
	  findUser().then(function (user) {
	    return user.name;
	  }, function (reason) {
	    return 'default name';
	  }).then(function (userName) {
	    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
	    // will be `'default name'`
	  });
	   findUser().then(function (user) {
	    throw new Error('Found user, but still unhappy');
	  }, function (reason) {
	    throw new Error('`findUser` rejected and we're unhappy');
	  }).then(function (value) {
	    // never reached
	  }, function (reason) {
	    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
	    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
	  });
	  ```
	  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
	   ```js
	  findUser().then(function (user) {
	    throw new PedagogicalException('Upstream error');
	  }).then(function (value) {
	    // never reached
	  }).then(function (value) {
	    // never reached
	  }, function (reason) {
	    // The `PedgagocialException` is propagated all the way down to here
	  });
	  ```
	   Assimilation
	  ------------
	   Sometimes the value you want to propagate to a downstream promise can only be
	  retrieved asynchronously. This can be achieved by returning a promise in the
	  fulfillment or rejection handler. The downstream promise will then be pending
	  until the returned promise is settled. This is called *assimilation*.
	   ```js
	  findUser().then(function (user) {
	    return findCommentsByAuthor(user);
	  }).then(function (comments) {
	    // The user's comments are now available
	  });
	  ```
	   If the assimliated promise rejects, then the downstream promise will also reject.
	   ```js
	  findUser().then(function (user) {
	    return findCommentsByAuthor(user);
	  }).then(function (comments) {
	    // If `findCommentsByAuthor` fulfills, we'll have the value here
	  }, function (reason) {
	    // If `findCommentsByAuthor` rejects, we'll have the reason here
	  });
	  ```
	   Simple Example
	  --------------
	   Synchronous Example
	   ```javascript
	  let result;
	   try {
	    result = findResult();
	    // success
	  } catch(reason) {
	    // failure
	  }
	  ```
	   Errback Example
	   ```js
	  findResult(function(result, err){
	    if (err) {
	      // failure
	    } else {
	      // success
	    }
	  });
	  ```
	   Promise Example;
	   ```javascript
	  findResult().then(function(result){
	    // success
	  }, function(reason){
	    // failure
	  });
	  ```
	   Advanced Example
	  --------------
	   Synchronous Example
	   ```javascript
	  let author, books;
	   try {
	    author = findAuthor();
	    books  = findBooksByAuthor(author);
	    // success
	  } catch(reason) {
	    // failure
	  }
	  ```
	   Errback Example
	   ```js
	   function foundBooks(books) {
	   }
	   function failure(reason) {
	   }
	   findAuthor(function(author, err){
	    if (err) {
	      failure(err);
	      // failure
	    } else {
	      try {
	        findBoooksByAuthor(author, function(books, err) {
	          if (err) {
	            failure(err);
	          } else {
	            try {
	              foundBooks(books);
	            } catch(reason) {
	              failure(reason);
	            }
	          }
	        });
	      } catch(error) {
	        failure(err);
	      }
	      // success
	    }
	  });
	  ```
	   Promise Example;
	   ```javascript
	  findAuthor().
	    then(findBooksByAuthor).
	    then(function(books){
	      // found books
	  }).catch(function(reason){
	    // something went wrong
	  });
	  ```
	   @method then
	  @param {Function} onFulfilled
	  @param {Function} onRejected
	  Useful for tooling.
	  @return {Promise}
	  */
	
	  /**
	  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
	  as the catch block of a try/catch statement.
	  ```js
	  function findAuthor(){
	  throw new Error('couldn't find that author');
	  }
	  // synchronous
	  try {
	  findAuthor();
	  } catch(reason) {
	  // something went wrong
	  }
	  // async with promises
	  findAuthor().catch(function(reason){
	  // something went wrong
	  });
	  ```
	  @method catch
	  @param {Function} onRejection
	  Useful for tooling.
	  @return {Promise}
	  */
	
	
	  Promise.prototype.catch = function _catch(onRejection) {
	    return this.then(null, onRejection);
	  };
	
	  /**
	    `finally` will be invoked regardless of the promise's fate just as native
	    try/catch/finally behaves
	  
	    Synchronous example:
	  
	    ```js
	    findAuthor() {
	      if (Math.random() > 0.5) {
	        throw new Error();
	      }
	      return new Author();
	    }
	  
	    try {
	      return findAuthor(); // succeed or fail
	    } catch(error) {
	      return findOtherAuther();
	    } finally {
	      // always runs
	      // doesn't affect the return value
	    }
	    ```
	  
	    Asynchronous example:
	  
	    ```js
	    findAuthor().catch(function(reason){
	      return findOtherAuther();
	    }).finally(function(){
	      // author was either found, or not
	    });
	    ```
	  
	    @method finally
	    @param {Function} callback
	    @return {Promise}
	  */
	
	
	  Promise.prototype.finally = function _finally(callback) {
	    var promise = this;
	    var constructor = promise.constructor;
	
	    return promise.then(function (value) {
	      return constructor.resolve(callback()).then(function () {
	        return value;
	      });
	    }, function (reason) {
	      return constructor.resolve(callback()).then(function () {
	        throw reason;
	      });
	    });
	  };
	
	  return Promise;
	}();
	
	Promise$1.prototype.then = then;
	Promise$1.all = all;
	Promise$1.race = race;
	Promise$1.resolve = resolve$1;
	Promise$1.reject = reject$1;
	Promise$1._setScheduler = setScheduler;
	Promise$1._setAsap = setAsap;
	Promise$1._asap = asap;
	
	/*global self*/
	function polyfill() {
	  var local = void 0;
	
	  if (typeof global !== 'undefined') {
	    local = global;
	  } else if (typeof self !== 'undefined') {
	    local = self;
	  } else {
	    try {
	      local = Function('return this')();
	    } catch (e) {
	      throw new Error('polyfill failed because global object is unavailable in this environment');
	    }
	  }
	
	  var P = local.Promise;
	
	  if (P) {
	    var promiseToString = null;
	    try {
	      promiseToString = Object.prototype.toString.call(P.resolve());
	    } catch (e) {
	      // silently ignored
	    }
	
	    if (promiseToString === '[object Promise]' && !P.cast) {
	      return;
	    }
	  }
	
	  local.Promise = Promise$1;
	}
	
	// Strange compat..
	Promise$1.polyfill = polyfill;
	Promise$1.Promise = Promise$1;
	
	return Promise$1;
	
	})));
	
	
	
	//# sourceMappingURL=es6-promise.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(132), (function() { return this; }())))

/***/ },
/* 1296 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ },
/* 1297 */
/***/ function(module, exports) {

	'use strict';
	
	var hasOwn = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	
	var isArray = function isArray(arr) {
		if (typeof Array.isArray === 'function') {
			return Array.isArray(arr);
		}
	
		return toStr.call(arr) === '[object Array]';
	};
	
	var isPlainObject = function isPlainObject(obj) {
		if (!obj || toStr.call(obj) !== '[object Object]') {
			return false;
		}
	
		var hasOwnConstructor = hasOwn.call(obj, 'constructor');
		var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
		// Not own constructor property must be Object
		if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
			return false;
		}
	
		// Own properties are enumerated firstly, so to speed up,
		// if last one is own, then all properties are own.
		var key;
		for (key in obj) { /**/ }
	
		return typeof key === 'undefined' || hasOwn.call(obj, key);
	};
	
	module.exports = function extend() {
		var options, name, src, copy, copyIsArray, clone;
		var target = arguments[0];
		var i = 1;
		var length = arguments.length;
		var deep = false;
	
		// Handle a deep copy situation
		if (typeof target === 'boolean') {
			deep = target;
			target = arguments[1] || {};
			// skip the boolean and the target
			i = 2;
		}
		if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
			target = {};
		}
	
		for (; i < length; ++i) {
			options = arguments[i];
			// Only deal with non-null/undefined values
			if (options != null) {
				// Extend the base object
				for (name in options) {
					src = target[name];
					copy = options[name];
	
					// Prevent never-ending loop
					if (target !== copy) {
						// Recurse if we're merging plain objects or arrays
						if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
							if (copyIsArray) {
								copyIsArray = false;
								clone = src && isArray(src) ? src : [];
							} else {
								clone = src && isPlainObject(src) ? src : {};
							}
	
							// Never move original objects, clone them
							target[name] = extend(deep, clone, copy);
	
						// Don't bring in undefined values
						} else if (typeof copy !== 'undefined') {
							target[name] = copy;
						}
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};


/***/ },
/* 1298 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1299 */
1298,
/* 1300 */
1298,
/* 1301 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"label":"input-field-simple__label___2Qnd3","wrapper":"input-field-simple__wrapper___1_ivW","is-error":"input-field-simple__is-error___278hQ","input":"input-field-simple__input___2D0vn","has-help":"input-field-simple__has-help___1OlGu","icon":"input-field-simple__icon___O0ZRo","icon-error":"input-field-simple__icon-error___1NH37","icon-help":"input-field-simple__icon-help___35iPf"};

/***/ },
/* 1302 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"validation-error":"input-field__validation-error___2oWSR"};

/***/ },
/* 1303 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"spinner":"profession-loading__spinner___2OY3T","rotation":"profession-loading__rotation___1_5qD","container":"profession-loading__container___1tSj9","suggestionContainer":"profession-loading__suggestionContainer____R6dp","suggestion":"profession-loading__suggestion___205v7","suggestionFocused":"profession-loading__suggestionFocused___3tYhx","sectionSuggestionsContainer":"profession-loading__sectionSuggestionsContainer___vhHJ8"};

/***/ },
/* 1304 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"profession__container___2LnUY","suggestionContainer":"profession__suggestionContainer___AT64L","suggestion":"profession__suggestion___2zcgD","suggestionFocused":"profession__suggestionFocused___6cJ8R","sectionSuggestionsContainer":"profession__sectionSuggestionsContainer___2YS-8"};

/***/ },
/* 1305 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"spinner":"SpinnerButton__spinner___1schW","rotation":"SpinnerButton__rotation___2zQjN","spinnerButton":"SpinnerButton__spinnerButton___1iuDk","spinnerText":"SpinnerButton__spinnerText___3bq_J","spinnerElement":"SpinnerButton__spinnerElement___3sBdx","show":"SpinnerButton__show___2JVnS","spinnerButtonGray":"SpinnerButton__spinnerButtonGray___2SmCz"};

/***/ },
/* 1306 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"spinner":"spinner__spinner___3II-1","rotation":"spinner__rotation___1n7pu"};

/***/ },
/* 1307 */
1298,
/* 1308 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"text-body":"change-password__text-body___1z-kt"};

/***/ },
/* 1309 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"select-bank__container___3vImx","select":"select-bank__select___3gKr0"};

/***/ },
/* 1310 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 1311 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(1310);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 1312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(1320);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 1313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(15);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 1314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(49);
	
	var createArrayFromMixed = __webpack_require__(1313);
	var getMarkupWrap = __webpack_require__(1315);
	var invariant = __webpack_require__(15);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 1315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(49);
	
	var invariant = __webpack_require__(15);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 1316 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 1317 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 1318 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(1317);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 1319 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 1320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(1319);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 1321 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Module dependencies.
	 */
	var utilities = __webpack_require__(459);
	var detectIE = utilities.isIE;
	
	/**
	 * Constants.
	 */
	var HTML_TAG_NAME = 'html';
	var BODY_TAG_NAME = 'body';
	var HEAD_TAG_NAME = 'head';
	var FIRST_TAG_REGEX = /<([a-zA-Z]+[0-9]?)/; // e.g., <h1>
	var HEAD_REGEX = /<\/head>/i;
	var BODY_REGEX = /<\/body>/i;
	// http://www.w3.org/TR/html/syntax.html#void-elements
	var VOID_ELEMENTS_REGEX = /<(area|base|br|col|embed|hr|img|input|keygen|link|menuitem|meta|param|source|track|wbr)(.*?)\/?>/gi;
	
	// browser support
	var isIE = detectIE();
	var isIE9 = detectIE(9);
	
	/**
	 * DOMParser (performance: slow).
	 *
	 * https://developer.mozilla.org/docs/Web/API/DOMParser#Parsing_an_SVG_or_HTML_document
	 */
	var parseFromString;
	if (typeof window.DOMParser === 'function') {
	    var domParser = new window.DOMParser();
	    // IE9 does not support 'text/html' MIME type
	    // https://msdn.microsoft.com/en-us/library/ff975278(v=vs.85).aspx
	    var MIME_TYPE = isIE9 ? 'text/xml' : 'text/html';
	
	    /**
	     * Creates an HTML document using `DOMParser.parseFromString`.
	     *
	     * @param  {String} html      - The HTML string.
	     * @param  {String} [tagName] - The element to render the HTML (with 'body' as fallback).
	     * @return {HTMLDocument}
	     */
	    parseFromString = function domStringParser(html, tagName) {
	        if (tagName) {
	            html = ['<', tagName, '>', html, '</', tagName, '>'].join('');
	        }
	        // because IE9 only supports MIME type 'text/xml', void elements need to be self-closed
	        if (isIE9) {
	            html = html.replace(VOID_ELEMENTS_REGEX, '<$1$2$3/>');
	        }
	        return domParser.parseFromString(html, MIME_TYPE);
	    };
	}
	
	/**
	 * DOMImplementation (performance: fair).
	 *
	 * https://developer.mozilla.org/docs/Web/API/DOMImplementation/createHTMLDocument
	 */
	var parseFromDocument;
	if (typeof document.implementation === 'object') {
	    // title parameter is required in IE
	    // https://msdn.microsoft.com/en-us/library/ff975457(v=vs.85).aspx
	    var doc = document.implementation.createHTMLDocument(isIE ? 'HTML_DOM_PARSER_TITLE' : undefined);
	
	    /**
	     * Use HTML document created by `document.implementation.createHTMLDocument`.
	     *
	     * @param  {String} html      - The HTML string.
	     * @param  {String} [tagName] - The element to render the HTML (with 'body' as fallback).
	     * @return {HTMLDocument}
	     */
	    parseFromDocument = function createHTMLDocument(html, tagName) {
	        if (tagName) {
	            doc.documentElement.getElementsByTagName(tagName)[0].innerHTML = html;
	            return doc;
	        }
	
	        try {
	            doc.documentElement.innerHTML = html;
	            return doc;
	        // fallback when certain elements in `documentElement` are read-only (IE9)
	        } catch (err) {
	            if (parseFromString) return parseFromString(html);
	        }
	    };
	}
	
	/**
	 * Template (performance: fast).
	 *
	 * https://developer.mozilla.org/docs/Web/HTML/Element/template
	 */
	var parseFromTemplate;
	var template = document.createElement('template');
	if (template.content) {
	
	    /**
	     * Uses a template element (content fragment) to parse HTML.
	     *
	     * @param  {String} html - The HTML string.
	     * @return {NodeList}
	     */
	    parseFromTemplate = function templateParser(html) {
	        template.innerHTML = html;
	        return template.content.childNodes;
	    };
	}
	
	/** Fallback document parser. */
	var parseWithFallback = parseFromDocument || parseFromString;
	
	/**
	 * Parses HTML string to DOM nodes.
	 *
	 * @param  {String} html      - The HTML string.
	 * @param  {String} [tagName] - The tag name.
	 * @return {NodeList|Array}
	 */
	module.exports = function domparser(html) {
	    // try to match first tag
	    var tagName;
	    var match = html.match(FIRST_TAG_REGEX);
	    if (match && match[1]) {
	        tagName = match[1].toLowerCase();
	    }
	
	    var doc;
	    var element;
	    var elements;
	
	    switch (tagName) {
	        case HTML_TAG_NAME:
	            if (parseFromString) {
	                doc = parseFromString(html);
	
	                // the created document may come with filler head/body elements,
	                // so ake sure to remove them if they don't actually exist
	                if (!HEAD_REGEX.test(html)) {
	                    element = doc.getElementsByTagName(HEAD_TAG_NAME)[0];
	                    if (element) element.parentNode.removeChild(element);
	                }
	                if (!BODY_REGEX.test(html)) {
	                    element = doc.getElementsByTagName(BODY_TAG_NAME)[0];
	                    if (element) element.parentNode.removeChild(element);
	                }
	
	                return doc.getElementsByTagName(HTML_TAG_NAME);
	            }
	            break;
	
	        case HEAD_TAG_NAME:
	            if (parseWithFallback) {
	                elements = parseWithFallback(html).getElementsByTagName(HEAD_TAG_NAME);
	
	                // account for possibility of sibling
	                if (BODY_REGEX.test(html)) {
	                    return elements[0].parentNode.childNodes;
	                }
	                return elements;
	            }
	            break;
	
	        case BODY_TAG_NAME:
	            if (parseWithFallback) {
	                elements = parseWithFallback(html).getElementsByTagName(BODY_TAG_NAME);
	
	                // account for possibility of sibling (return both body and head)
	                if (HEAD_REGEX.test(html)) {
	                    return elements[0].parentNode.childNodes;
	                }
	                return elements;
	            }
	            break;
	
	        // low-level tag or text
	        default:
	            if (parseFromTemplate) return parseFromTemplate(html);
	            if (parseWithFallback) {
	                return parseWithFallback(html, BODY_TAG_NAME).getElementsByTagName(BODY_TAG_NAME)[0].childNodes;
	            }
	            break;
	    }
	
	    return [];
	};


/***/ },
/* 1327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Module dependencies.
	 */
	var domparser = __webpack_require__(1326);
	var utilities = __webpack_require__(459);
	var formatDOM = utilities.formatDOM;
	var isIE9 = utilities.isIE(9);
	
	/**
	 * Constants.
	 */
	var DIRECTIVE_REGEX = /<(![a-zA-Z\s]+)>/; // e.g., <!doctype html>
	
	/**
	 * Parses HTML and reformats DOM nodes output.
	 *
	 * @param  {String} html - The HTML string.
	 * @return {Array}       - The formatted DOM nodes.
	 */
	module.exports = function parseDOM(html) {
	    if (typeof html !== 'string') {
	        throw new TypeError('First argument must be a string.');
	    }
	    if (!html) return [];
	
	    // match directive
	    var match = html.match(DIRECTIVE_REGEX);
	    var directive;
	    if (match && match[1]) {
	        directive = match[1];
	
	        // remove directive in IE9 because DOMParser uses
	        // MIME type 'text/xml' instead of 'text/html'
	        if (isIE9) {
	            html = html.replace(match[0], '');
	        }
	    }
	
	    return formatDOM(domparser(html), null, directive);
	};


/***/ },
/* 1328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Module dependencies.
	 */
	var domToReact = __webpack_require__(1330);
	var htmlToDOM = __webpack_require__(1327);
	
	// decode HTML entities by default for `htmlparser2`
	var domParserOptions = { decodeEntities: true };
	
	/**
	 * Convert HTML string to React elements.
	 *
	 * @param  {String}   html              - The HTML string.
	 * @param  {Object}   [options]         - The additional options.
	 * @param  {Function} [options.replace] - The replace method.
	 * @return {ReactElement|Array}
	 */
	function HTMLReactParser(html, options) {
	    if (typeof html !== 'string') {
	        throw new TypeError('First argument must be a string');
	    }
	    return domToReact(htmlToDOM(html, domParserOptions), options);
	}
	
	/**
	 * Export HTML to React parser.
	 */
	module.exports = HTMLReactParser;


/***/ },
/* 1329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Module dependencies.
	 */
	var utilities = __webpack_require__(460);
	var propertyConfig = __webpack_require__(1331);
	var styleToObject = __webpack_require__(1543);
	var config = propertyConfig.config;
	var isCustomAttribute = propertyConfig.HTMLDOMPropertyConfig.isCustomAttribute;
	
	/**
	 * Make attributes compatible with React props.
	 *
	 * @param  {Object} attributes - The attributes.
	 * @return {Object}            - The props.
	 */
	function attributesToProps(attributes) {
	    attributes = attributes || {};
	    var props = {};
	    var propertyName;
	    var propertyValue;
	    var reactProperty;
	
	    for (propertyName in attributes) {
	        propertyValue = attributes[propertyName];
	
	        // custom attributes (`data-` and `aria-`)
	        if (isCustomAttribute(propertyName)) {
	            props[propertyName] = propertyValue;
	            continue;
	        }
	
	        // make HTML DOM attribute/property consistent with React attribute/property
	        reactProperty = config.html[propertyName.toLowerCase()];
	        if (reactProperty) {
	            props[reactProperty] = propertyValue;
	            continue;
	        }
	
	        // make SVG DOM attribute/property consistent with React attribute/property
	        reactProperty = config.svg[propertyName];
	        if (reactProperty) {
	            props[reactProperty] = propertyValue;
	        }
	    }
	
	    // convert inline style to object
	    if (attributes.style) {
	        props.style = cssToJs(attributes.style);
	    }
	
	    return props;
	}
	
	/**
	 * Convert CSS style string to JS style object.
	 *
	 * @param  {String} style - The CSS style.
	 * @return {Object}       - The JS style object.
	 */
	function cssToJs(style) {
	    if (typeof style !== 'string') {
	        throw new Error('`cssToJs`: first argument must be a string. ');
	    }
	
	    var styleObj = {};
	
	    styleToObject(style, function(propName, propValue) {
	        // Check if it's not a comment node
	        if (propName && propValue) {
	            styleObj[utilities.camelCase(propName)] = propValue;
	        }
	    });
	
	    return styleObj;
	}
	
	/**
	 * Export attributes to props helper.
	 */
	module.exports = attributesToProps;


/***/ },
/* 1330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Module dependencies.
	 */
	var React = __webpack_require__(1);
	var attributesToProps = __webpack_require__(1329);
	
	/**
	 * Convert DOM nodes to React elements.
	 *
	 * @param  {Array}    nodes             - The DOM nodes.
	 * @param  {Object}   [options]         - The additional options.
	 * @param  {Function} [options.replace] - The replace method.
	 * @return {ReactElement|Array}
	 */
	function domToReact(nodes, options) {
	    options = options || {};
	    var result = [];
	    var node;
	    var isReplacePresent = typeof options.replace === 'function';
	    var replacement;
	    var props;
	    var children;
	
	    for (var i = 0, len = nodes.length; i < len; i++) {
	        node = nodes[i];
	
	        // replace with custom React element (if applicable)
	        if (isReplacePresent) {
	            replacement = options.replace(node);
	
	            if (React.isValidElement(replacement)) {
	                // specify a "key" prop if element has siblings
	                // https://fb.me/react-warning-keys
	                if (len > 1) {
	                    replacement = React.cloneElement(replacement, { key: i });
	                }
	                result.push(replacement);
	                continue;
	            }
	        }
	
	        if (node.type === 'text') {
	            result.push(node.data);
	            continue;
	        }
	
	        // update values
	        props = attributesToProps(node.attribs);
	        children = null;
	
	        // node type for <script> is "script"
	        // node type for <style> is "style"
	        if (node.type === 'script' || node.type === 'style') {
	            // prevent text in <script> or <style> from being escaped
	            // https://facebook.github.io/react/tips/dangerously-set-inner-html.html
	            if (node.children[0]) {
	                props.dangerouslySetInnerHTML = {
	                    __html: node.children[0].data
	                };
	            }
	
	        } else if (node.type === 'tag') {
	            // setting textarea value in children is an antipattern in React
	            // https://facebook.github.io/react/docs/forms.html#why-textarea-value
	            if (node.name === 'textarea' && node.children[0]) {
	                props.defaultValue = node.children[0].data;
	
	            // continue recursion of creating React elements (if applicable)
	            } else if (node.children && node.children.length) {
	                children = domToReact(node.children, options);
	            }
	
	        // skip all other cases (e.g., comment)
	        } else {
	            continue;
	        }
	
	        // specify a "key" prop if element has siblings
	        // https://fb.me/react-warning-keys
	        if (len > 1) {
	            props.key = i;
	        }
	
	        result.push(
	            React.createElement(node.name, props, children)
	        );
	    }
	
	    if (result.length === 1) {
	        return result[0];
	    } else {
	        return result;
	    }
	}
	
	/**
	 * Export DOM to React parser.
	 */
	module.exports = domToReact;


/***/ },
/* 1331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Module dependencies.
	 */
	var utilities = __webpack_require__(460);
	
	// HTML and SVG DOM Property Configs
	var HTMLDOMPropertyConfig = __webpack_require__(1395);
	var SVGDOMPropertyConfig = __webpack_require__(1396);
	
	var config = {
	    html: {},
	    svg: {}
	};
	
	var propertyName;
	
	/**
	 * HTML DOM property config.
	 * https://github.com/facebook/react/blob/master/src/renderers/dom/shared/HTMLDOMPropertyConfig.js
	 */
	
	// first map out the HTML attribute names
	// e.g., { className: 'class' } => { 'class': 'className' }
	config.html = utilities.invertObject(
	    HTMLDOMPropertyConfig.DOMAttributeNames
	);
	
	// then map out the rest of the HTML properties
	// e.g., { readOnly: 0 } => { readonly: 'readOnly' }
	for (propertyName in HTMLDOMPropertyConfig.Properties) {
	    // lowercase to make matching property names easier
	    config.html[propertyName.toLowerCase()] = propertyName;
	}
	
	/**
	 * SVG DOM property config.
	 * https://github.com/facebook/react/blob/master/src/renderers/dom/shared/SVGDOMPropertyConfig.js
	 */
	
	// first map out the SVG attribute names
	// e.g., { fontSize: 'font-size' } => { 'font-size': 'fontSize' }
	config.svg = utilities.invertObject(
	    SVGDOMPropertyConfig.DOMAttributeNames
	);
	
	// then map out the rest of the SVG properties
	// e.g., { fillRule: 0 } => { fillRule: 'fillRule' }
	for (propertyName in SVGDOMPropertyConfig.Properties) {
	    // do not lowercase as some svg properties are camel cased
	    config.html[propertyName] = propertyName;
	}
	
	/**
	 * Export property configs.
	 */
	module.exports = {
	    config: config,
	    HTMLDOMPropertyConfig: HTMLDOMPropertyConfig,
	    SVGDOMPropertyConfig: SVGDOMPropertyConfig
	};


/***/ },
/* 1332 */
/***/ function(module, exports) {

	
	var indexOf = [].indexOf;
	
	module.exports = function(arr, obj){
	  if (indexOf) return arr.indexOf(obj);
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	};

/***/ },
/* 1333 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Coding standard for this project defined @ https://github.com/MatthewSH/standards/blob/master/JavaScript.md
	'use strict';
	
	exports = module.exports = !!(typeof process !== 'undefined' && process.versions && process.versions.node);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(132)))

/***/ },
/* 1334 */
/***/ function(module, exports, __webpack_require__) {

	!(function() {
	  function jss(blocks) {
	    var css = [];
	    for (var block in blocks)
	      css.push(createStyleBlock(block, blocks[block]));
	    injectCSS(css);
	  }
	
	  function createStyleBlock(selector, rules) {
	    return selector + ' {\n' + parseRules(rules) + '\n}';
	  }
	
	  function parseRules(rules) {
	    var css = [];
	    for (var rule in rules)
	      css.push('  '+rule+': '+rules[rule]+';');
	    return css.join('\n');
	  }
	
	  function injectCSS(css) {
	    var style = document.getElementById('jss-styles');
	    if (!style) {
	      style = document.createElement('style');
	      style.setAttribute('id', 'jss-styles');
	      var head = document.getElementsByTagName('head')[0];
	      head.insertBefore(style, head.firstChild);
	    }
	    var node = document.createTextNode(css.join('\n\n'));
	    style.appendChild(node);
	  }
	
	  if (true)
	    module.exports = jss;
	  else
	    window.jss = jss;
	
	})();
	


/***/ },
/* 1335 */
/***/ function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	exports = module.exports = function(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ },
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module unless amdModuleId is set
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = function (a0) {
	      return (root['DateRange'] = factory(a0));
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory(require("moment"));
	  } else {
	    root['DateRange'] = factory(moment);
	  }
	}(this, function (moment) {
	
	//-----------------------------------------------------------------------------
	// Contstants
	//-----------------------------------------------------------------------------
	
	
	
	var INTERVALS = {
	  year:   true,
	  month:  true,
	  week:   true,
	  day:    true,
	  hour:   true,
	  minute: true,
	  second: true
	};
	
	
	//-----------------------------------------------------------------------------
	// Date Ranges
	//-----------------------------------------------------------------------------
	
	/**
	 * DateRange class to store ranges and query dates.
	 *
	 * @constructor
	 * @param {(Moment|Date)} start Start of interval
	 * @param {(Moment|Date)} end End of interval
	 *//**
	 * DateRange class to store ranges and query dates.
	 *
	 * @constructor
	 * @param {!Array} range Array containing start and end dates.
	 *//**
	 * DateRange class to store ranges and query dates.
	 *
	 * @constructor
	 * @param {!String} range String formatted as an IS0 8601 time interval
	 */
	function DateRange(start, end) {
	  var parts;
	  var s = start;
	  var e = end;
	
	  if (arguments.length === 1 || end === undefined) {
	    if (typeof start === 'object' && start.length === 2) {
	      s = start[0];
	      e = start[1];
	    }
	    else if (typeof start === 'string') {
	      parts = start.split('/');
	      s = parts[0];
	      e = parts[1];
	    }
	  }
	
	  this.start = (s === null) ? moment(-8640000000000000) : moment(s);
	  this.end   = (e === null) ? moment(8640000000000000) : moment(e);
	}
	
	/**
	 * Constructor for prototype.
	 *
	 * @type {DateRange}
	 */
	DateRange.prototype.constructor = DateRange;
	
	/**
	 * Deep clone range.
	 *
	 * @return {!DateRange}
	 */
	DateRange.prototype.clone = function() {
	  return moment().range(this.start, this.end);
	};
	
	/**
	 * Determine if the current interval contains a given moment/date/range.
	 *
	 * @param {(Moment|Date|DateRange)} other Date to check
	 * @param {!boolean} exclusive True if the to value is exclusive
	 *
	 * @return {!boolean}
	 */
	DateRange.prototype.contains = function(other, exclusive) {
	  var start = this.start;
	  var end   = this.end;
	
	  if (other instanceof DateRange) {
	    return start <= other.start && (end > other.end || (end.isSame(other.end) && !exclusive));
	  }
	  else {
	    return start <= other && (end > other || (end.isSame(other) && !exclusive));
	  }
	};
	
	/**
	 * Determine if the current date range overlaps a given date range.
	 *
	 * @param {!DateRange} range Date range to check
	 *
	 * @return {!boolean}
	 */
	DateRange.prototype.overlaps = function(range) {
	  return this.intersect(range) !== null;
	};
	
	/**
	 * Determine the intersecting periods from one or more date ranges.
	 *
	 * @param {!DateRange} other A date range to intersect with this one
	 *
	 * @return {DateRange} Returns the intersecting date or `null` if the ranges do
	 *                     not intersect
	 */
	DateRange.prototype.intersect = function(other) {
	  var start = this.start;
	  var end   = this.end;
	
	  if ((start <= other.start) && (other.start < end) && (end < other.end)) {
	    return new DateRange(other.start, end);
	  }
	  else if ((other.start < start) && (start < other.end) && (other.end <= end)) {
	    return new DateRange(start, other.end);
	  }
	  else if ((other.start < start) && (start <= end) && (end < other.end)) {
	    return this;
	  }
	  else if ((start <= other.start) && (other.start <= other.end) && (other.end <= end)) {
	    return other;
	  }
	
	  return null;
	};
	
	/**
	 * Merge date ranges if they intersect.
	 *
	 * @param {!DateRange} other A date range to add to this one
	 *
	 * @return {DateRange} Returns the new `DateRange` or `null` if they do not
	 *                     overlap
	 */
	DateRange.prototype.add = function(other) {
	  if (this.overlaps(other)) {
	    return new DateRange(moment.min(this.start, other.start), moment.max(this.end, other.end));
	  }
	
	  return null;
	};
	
	/**
	 * Subtract one range from another.
	 *
	 * @param {!DateRange} other A date range to substract from this one
	 *
	 * @return {!Array<DateRange>}
	 */
	DateRange.prototype.subtract = function(other) {
	  var start = this.start;
	  var end   = this.end;
	
	  if (this.intersect(other) === null) {
	    return [this];
	  }
	  else if ((other.start <= start) && (start < end) && (end <= other.end)) {
	    return [];
	  }
	  else if ((other.start <= start) && (start < other.end) && (other.end < end)) {
	    return [new DateRange(other.end, end)];
	  }
	  else if ((start < other.start) && (other.start < end) && (end <= other.end)) {
	    return [new DateRange(start, other.start)];
	  }
	  else if ((start < other.start) && (other.start < other.end) && (other.end < end)) {
	    return [new DateRange(start, other.start), new DateRange(other.end, end)];
	  }
	  else if ((start < other.start) && (other.start < end) && (other.end < end)) {
	    return [new DateRange(start, other.start), new DateRange(other.start, end)];
	  }
	};
	
	/**
	 * Build a n array of dates.
	 *
	 * @param {(!DateRange|String)} range Date range to be used for iteration or
	 *                                    shorthand string (shorthands:
	 *                                    http://momentjs.com/docs/#/manipulating/add/)
	 * @param {!boolean} exclusive Indicate that the end of the range should not
	 *                             be included in the iter.
	 *
	 * @return {!Array}
	 */
	DateRange.prototype.toArray = function(by, exclusive) {
	  var acc = [];
	  this.by(by, function(unit) {
	    acc.push(unit);
	  }, exclusive);
	  return acc;
	};
	
	/**
	 * Iterate over the date range by a given date range, executing a function
	 * for each sub-range.
	 *
	 * @param {(!DateRange|String)} range Date range to be used for iteration or
	 *                                    shorthand string (shorthands:
	 *                                    http://momentjs.com/docs/#/manipulating/add/)
	 * @param {!DateRange~by} hollaback Callback
	 * @param {!boolean} exclusive Indicate that the end of the range should not
	 *                             be included in the iter.
	 *
	 * @return {DateRange} `this`
	 */
	DateRange.prototype.by = function(range, hollaback, exclusive) {
	  if (typeof range === 'string') {
	    _byString.call(this, range, hollaback, exclusive);
	  }
	  else {
	    _byRange.call(this, range, hollaback, exclusive);
	  }
	  return this;
	};
	
	
	/**
	 * Callback executed for each sub-range.
	 *
	 * @callback DateRange~by
	 *
	 * @param {!Moment} current Current moment object for iteration
	 */
	
	/**
	 * @private
	 */
	function _byString(interval, hollaback, exclusive) {
	  var current = moment(this.start);
	
	  while (this.contains(current, exclusive)) {
	    hollaback.call(this, current.clone());
	    current.add(1, interval);
	  }
	}
	
	/**
	 * @private
	 */
	function _byRange(interval, hollaback, exclusive) {
	  var div = this / interval;
	  var l = Math.floor(div);
	
	  if (l === Infinity) { return; }
	  if (l === div && exclusive) {
	    l--;
	  }
	
	  for (var i = 0; i <= l; i++) {
	    hollaback.call(this, moment(this.start.valueOf() + interval.valueOf() * i));
	  }
	}
	
	/**
	 * Date range formatted as an [ISO8601 Time
	 * Interval](http://en.wikipedia.org/wiki/ISO_8601#Time_intervals).
	 *
	 * @return {!String}
	 */
	DateRange.prototype.toString = function() {
	  return this.start.format() + '/' + this.end.format();
	};
	
	/**
	 * Date range in milliseconds. Allows basic coercion math of date ranges.
	 *
	 * @return {!number}
	 */
	DateRange.prototype.valueOf = function() {
	  return this.end - this.start;
	};
	
	/**
	 * Center date of the range.
	 *
	 * @return {!Moment}
	 */
	DateRange.prototype.center = function() {
	  var center = this.start + this.diff() / 2;
	  return moment(center);
	};
	
	/**
	 * Date range toDate
	 *
	 * @return {!Array<Date>}
	 */
	DateRange.prototype.toDate = function() {
	  return [this.start.toDate(), this.end.toDate()];
	};
	
	/**
	 * Determine if this date range is the same as another.
	 *
	 * @param {!DateRange} other Another date range to compare to
	 *
	 * @return {!boolean}
	 */
	DateRange.prototype.isSame = function(other) {
	  return this.start.isSame(other.start) && this.end.isSame(other.end);
	};
	
	/**
	 * The difference of the end vs start.
	 *
	 * @param {number} unit Unit of difference, if no unit is passed in
	 *                      milliseconds are returned. E.g.: `"days"`, `"months"`,
	 *                      etc...
	 *
	 * @return {!number}
	 */
	DateRange.prototype.diff = function(unit) {
	  return this.end.diff(this.start, unit);
	};
	
	
	//-----------------------------------------------------------------------------
	// Moment Extensions
	//-----------------------------------------------------------------------------
	
	/**
	 * Build a date range.
	 *
	 * @param {(Moment|Date)} start Start of range
	 * @param {(Moment|Date)} end End of range
	 *
	 * @this {Moment}
	 *
	 * @return {!DateRange}
	 */
	moment.range = function(start, end) {
	  if (start in INTERVALS) {
	    return new DateRange(moment(this).startOf(start), moment(this).endOf(start));
	  }
	  else {
	    return new DateRange(start, end);
	  }
	};
	
	/**
	 * Expose constructor
	 *
	 * @const
	 */
	moment.range.constructor = DateRange;
	
	/**
	 * @deprecated
	 */
	moment.fn.range = moment.range;
	
	/**
	 * Check if the current moment is within a given date range.
	 *
	 * @param {!DateRange} range Date range to check
	 *
	 * @this {Moment}
	 *
	 * @return {!boolean}
	 */
	moment.fn.within = function(range) {
	  return range.contains(this._d);
	};
	
	
	//-----------------------------------------------------------------------------
	// Export
	//-----------------------------------------------------------------------------
	
	
	
	return DateRange;
	
	}));


/***/ },
/* 1345 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 463,
		"./af.js": 463,
		"./ar": 470,
		"./ar-dz": 464,
		"./ar-dz.js": 464,
		"./ar-kw": 465,
		"./ar-kw.js": 465,
		"./ar-ly": 466,
		"./ar-ly.js": 466,
		"./ar-ma": 467,
		"./ar-ma.js": 467,
		"./ar-sa": 468,
		"./ar-sa.js": 468,
		"./ar-tn": 469,
		"./ar-tn.js": 469,
		"./ar.js": 470,
		"./az": 471,
		"./az.js": 471,
		"./be": 472,
		"./be.js": 472,
		"./bg": 473,
		"./bg.js": 473,
		"./bm": 474,
		"./bm.js": 474,
		"./bn": 475,
		"./bn.js": 475,
		"./bo": 476,
		"./bo.js": 476,
		"./br": 477,
		"./br.js": 477,
		"./bs": 478,
		"./bs.js": 478,
		"./ca": 479,
		"./ca.js": 479,
		"./cs": 480,
		"./cs.js": 480,
		"./cv": 481,
		"./cv.js": 481,
		"./cy": 482,
		"./cy.js": 482,
		"./da": 483,
		"./da.js": 483,
		"./de": 486,
		"./de-at": 484,
		"./de-at.js": 484,
		"./de-ch": 485,
		"./de-ch.js": 485,
		"./de.js": 486,
		"./dv": 487,
		"./dv.js": 487,
		"./el": 488,
		"./el.js": 488,
		"./en-au": 489,
		"./en-au.js": 489,
		"./en-ca": 490,
		"./en-ca.js": 490,
		"./en-gb": 190,
		"./en-gb.js": 190,
		"./en-ie": 491,
		"./en-ie.js": 491,
		"./en-il": 492,
		"./en-il.js": 492,
		"./en-nz": 493,
		"./en-nz.js": 493,
		"./eo": 494,
		"./eo.js": 494,
		"./es": 497,
		"./es-do": 495,
		"./es-do.js": 495,
		"./es-us": 496,
		"./es-us.js": 496,
		"./es.js": 497,
		"./et": 498,
		"./et.js": 498,
		"./eu": 499,
		"./eu.js": 499,
		"./fa": 500,
		"./fa.js": 500,
		"./fi": 501,
		"./fi.js": 501,
		"./fo": 502,
		"./fo.js": 502,
		"./fr": 505,
		"./fr-ca": 503,
		"./fr-ca.js": 503,
		"./fr-ch": 504,
		"./fr-ch.js": 504,
		"./fr.js": 505,
		"./fy": 506,
		"./fy.js": 506,
		"./gd": 507,
		"./gd.js": 507,
		"./gl": 508,
		"./gl.js": 508,
		"./gom-latn": 509,
		"./gom-latn.js": 509,
		"./gu": 510,
		"./gu.js": 510,
		"./he": 511,
		"./he.js": 511,
		"./hi": 512,
		"./hi.js": 512,
		"./hr": 513,
		"./hr.js": 513,
		"./hu": 514,
		"./hu.js": 514,
		"./hy-am": 515,
		"./hy-am.js": 515,
		"./id": 516,
		"./id.js": 516,
		"./is": 517,
		"./is.js": 517,
		"./it": 518,
		"./it.js": 518,
		"./ja": 519,
		"./ja.js": 519,
		"./jv": 520,
		"./jv.js": 520,
		"./ka": 521,
		"./ka.js": 521,
		"./kk": 522,
		"./kk.js": 522,
		"./km": 523,
		"./km.js": 523,
		"./kn": 524,
		"./kn.js": 524,
		"./ko": 525,
		"./ko.js": 525,
		"./ky": 526,
		"./ky.js": 526,
		"./lb": 527,
		"./lb.js": 527,
		"./lo": 528,
		"./lo.js": 528,
		"./lt": 529,
		"./lt.js": 529,
		"./lv": 530,
		"./lv.js": 530,
		"./me": 531,
		"./me.js": 531,
		"./mi": 532,
		"./mi.js": 532,
		"./mk": 533,
		"./mk.js": 533,
		"./ml": 534,
		"./ml.js": 534,
		"./mr": 535,
		"./mr.js": 535,
		"./ms": 537,
		"./ms-my": 536,
		"./ms-my.js": 536,
		"./ms.js": 537,
		"./mt": 538,
		"./mt.js": 538,
		"./my": 539,
		"./my.js": 539,
		"./nb": 540,
		"./nb.js": 540,
		"./ne": 541,
		"./ne.js": 541,
		"./nl": 543,
		"./nl-be": 542,
		"./nl-be.js": 542,
		"./nl.js": 543,
		"./nn": 544,
		"./nn.js": 544,
		"./pa-in": 545,
		"./pa-in.js": 545,
		"./pl": 546,
		"./pl.js": 546,
		"./pt": 548,
		"./pt-br": 547,
		"./pt-br.js": 547,
		"./pt.js": 548,
		"./ro": 549,
		"./ro.js": 549,
		"./ru": 550,
		"./ru.js": 550,
		"./sd": 551,
		"./sd.js": 551,
		"./se": 552,
		"./se.js": 552,
		"./si": 553,
		"./si.js": 553,
		"./sk": 554,
		"./sk.js": 554,
		"./sl": 555,
		"./sl.js": 555,
		"./sq": 556,
		"./sq.js": 556,
		"./sr": 558,
		"./sr-cyrl": 557,
		"./sr-cyrl.js": 557,
		"./sr.js": 558,
		"./ss": 559,
		"./ss.js": 559,
		"./sv": 191,
		"./sv.js": 191,
		"./sw": 560,
		"./sw.js": 560,
		"./ta": 561,
		"./ta.js": 561,
		"./te": 562,
		"./te.js": 562,
		"./tet": 563,
		"./tet.js": 563,
		"./tg": 564,
		"./tg.js": 564,
		"./th": 565,
		"./th.js": 565,
		"./tl-ph": 566,
		"./tl-ph.js": 566,
		"./tlh": 567,
		"./tlh.js": 567,
		"./tr": 568,
		"./tr.js": 568,
		"./tzl": 569,
		"./tzl.js": 569,
		"./tzm": 571,
		"./tzm-latn": 570,
		"./tzm-latn.js": 570,
		"./tzm.js": 571,
		"./ug-cn": 572,
		"./ug-cn.js": 572,
		"./uk": 573,
		"./uk.js": 573,
		"./ur": 574,
		"./ur.js": 574,
		"./uz": 576,
		"./uz-latn": 575,
		"./uz-latn.js": 575,
		"./uz.js": 576,
		"./vi": 577,
		"./vi.js": 577,
		"./x-pseudo": 578,
		"./x-pseudo.js": 578,
		"./yo": 579,
		"./yo.js": 579,
		"./zh-cn": 580,
		"./zh-cn.js": 580,
		"./zh-hk": 581,
		"./zh-hk.js": 581,
		"./zh-tw": 582,
		"./zh-tw.js": 582
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1345;


/***/ },
/* 1346 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(entry, count) {
	  var key;
	
	  if (count === 0 && 'zero' in entry) {
	    key = 'zero';
	  }
	
	  key = key || (count === 1 ? 'one' : 'other');
	
	  return entry[key];
	};


/***/ },
/* 1347 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.14.2
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Popper = factory());
	}(this, (function () { 'use strict';
	
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
	
	var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	var timeoutDuration = 0;
	for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	    timeoutDuration = 1;
	    break;
	  }
	}
	
	function microtaskDebounce(fn) {
	  var called = false;
	  return function () {
	    if (called) {
	      return;
	    }
	    called = true;
	    window.Promise.resolve().then(function () {
	      called = false;
	      fn();
	    });
	  };
	}
	
	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}
	
	var supportsMicroTasks = isBrowser && window.Promise;
	
	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var css = getComputedStyle(element, null);
	  return property ? css[property] : css;
	}
	
	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}
	
	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element) {
	    return document.body;
	  }
	
	  switch (element.nodeName) {
	    case 'HTML':
	    case 'BODY':
	      return element.ownerDocument.body;
	    case '#document':
	      return element.body;
	  }
	
	  // Firefox want us to check `-x` and `-y` variations as well
	
	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;
	
	  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }
	
	  return getScrollParent(getParentNode(element));
	}
	
	var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
	var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
	
	/**
	 * Determines if the browser is Internet Explorer
	 * @method
	 * @memberof Popper.Utils
	 * @param {Number} version to check
	 * @returns {Boolean} isIE
	 */
	function isIE(version) {
	  if (version === 11) {
	    return isIE11;
	  }
	  if (version === 10) {
	    return isIE10;
	  }
	  return isIE11 || isIE10;
	}
	
	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  if (!element) {
	    return document.documentElement;
	  }
	
	  var noOffsetParent = isIE(10) ? document.body : null;
	
	  // NOTE: 1 DOM access here
	  var offsetParent = element.offsetParent;
	  // Skip hidden elements which don't have an offsetParent
	  while (offsetParent === noOffsetParent && element.nextElementSibling) {
	    offsetParent = (element = element.nextElementSibling).offsetParent;
	  }
	
	  var nodeName = offsetParent && offsetParent.nodeName;
	
	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    return element ? element.ownerDocument.documentElement : document.documentElement;
	  }
	
	  // .offsetParent will return the closest TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }
	
	  return offsetParent;
	}
	
	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}
	
	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }
	
	  return node;
	}
	
	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return document.documentElement;
	  }
	
	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;
	
	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;
	
	  // Both nodes are inside #document
	
	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }
	
	    return getOffsetParent(commonAncestorContainer);
	  }
	
	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}
	
	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = element.ownerDocument.documentElement;
	    var scrollingElement = element.ownerDocument.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }
	
	  return element[upperSide];
	}
	
	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}
	
	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */
	
	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
	}
	
	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? html['offset' + axis] + computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')] + computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')] : 0);
	}
	
	function getWindowSizes() {
	  var body = document.body;
	  var html = document.documentElement;
	  var computedStyle = isIE(10) && getComputedStyle(html);
	
	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}
	
	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};
	
	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  try {
	    if (isIE(10)) {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } else {
	      rect = element.getBoundingClientRect();
	    }
	  } catch (e) {}
	
	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	
	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes() : {};
	  var width = sizes.width || element.clientWidth || result.right - result.left;
	  var height = sizes.height || element.clientHeight || result.bottom - result.top;
	
	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;
	
	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');
	
	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }
	
	  return getClientRect(result);
	}
	
	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var isIE10 = isIE(10);
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);
	
	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
	  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);
	
	  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
	  if (fixedPosition && parent.nodeName === 'HTML') {
	    parentRect.top = Math.max(parentRect.top, 0);
	    parentRect.left = Math.max(parentRect.left, 0);
	  }
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;
	
	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = parseFloat(styles.marginTop, 10);
	    var marginLeft = parseFloat(styles.marginLeft, 10);
	
	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;
	
	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }
	
	  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }
	
	  return offsets;
	}
	
	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var html = element.ownerDocument.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	  var scrollTop = !excludeScroll ? getScroll(html) : 0;
	  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
	
	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };
	
	  return getClientRect(offset);
	}
	
	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  return isFixed(getParentNode(element));
	}
	
	/**
	 * Finds the first parent of an element that has a transformed property defined
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} first transformed parent or documentElement
	 */
	
	function getFixedPositionOffsetParent(element) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element || !element.parentElement || isIE()) {
	    return document.documentElement;
	  }
	  var el = element.parentElement;
	  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
	    el = el.parentElement;
	  }
	  return el || document.documentElement;
	}
	
	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @param {Boolean} fixedPosition - Is in fixed position mode
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  // NOTE: 1 DOM access here
	
	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
	
	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(reference));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = popper.ownerDocument.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }
	
	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
	
	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;
	
	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }
	
	  // Add paddings
	  boundaries.left += padding;
	  boundaries.top += padding;
	  boundaries.right -= padding;
	  boundaries.bottom -= padding;
	
	  return boundaries;
	}
	
	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return width * height;
	}
	
	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }
	
	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };
	
	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });
	
	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });
	
	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	  var variation = placement.split('-')[1];
	
	  return computedPlacement + (variation ? '-' + variation : '');
	}
	
	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @param {Element} fixedPosition - is in fixed position mode
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
	}
	
	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var styles = getComputedStyle(element);
	  var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
	  var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}
	
	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];
	
	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);
	
	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };
	
	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }
	
	  return popperOffsets;
	}
	
	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }
	
	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}
	
	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }
	
	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}
	
	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	  modifiersToRun.forEach(function (modifier) {
	    if (modifier['function']) {
	      // eslint-disable-line dot-notation
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);
	
	      data = fn(data, modifier);
	    }
	  });
	
	  return data;
	}
	
	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}
	
	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }
	
	  var data = {
	    instance: this,
	    styles: {},
	    arrowStyles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };
	
	  // NOTE: DOM access here
	  // resets the popper's position so that the document size can be calculated excluding
	  // the size of the popper element itself
	  var popperStyles = this.popper.style;
	  popperStyles.top = '';
	  popperStyles.left = '';
	  popperStyles[getSupportedPropertyName('transform')] = '';
	
	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;
	
	  data.positionFixed = this.options.positionFixed;
	
	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
	
	  // run the modifiers
	  data = runModifiers(this.modifiers, data);
	
	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}
	
	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}
	
	/**
	 * Destroy the popper
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;
	
	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style.left = '';
	    this.popper.style.right = '';
	    this.popper.style.bottom = '';
	    this.popper.style.willChange = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }
	
	  this.disableEventListeners();
	
	  // remove the popper if user explicity asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}
	
	/**
	 * Get the window associated with the element
	 * @argument {Element} element
	 * @returns {Window}
	 */
	function getWindow(element) {
	  var ownerDocument = element.ownerDocument;
	  return ownerDocument ? ownerDocument.defaultView : window;
	}
	
	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	  target.addEventListener(event, callback, { passive: true });
	
	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}
	
	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
	
	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;
	
	  return state;
	}
	
	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}
	
	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  getWindow(reference).removeEventListener('resize', state.updateBound);
	
	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });
	
	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}
	
	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger onUpdate callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}
	
	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}
	
	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);
	
	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);
	
	  // if arrowElement is defined and arrowStyles has some properties
	  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	    setStyles(data.arrowElement, data.arrowStyles);
	  }
	
	  return data;
	}
	
	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	  popper.setAttribute('x-placement', placement);
	
	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });
	
	  return options;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;
	
	  // Remove this legacy support in Popper.js v2
	
	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);
	
	  // Styles
	  var styles = {
	    position: popper.position
	  };
	
	  // Avoid blurry text by using full pixel integers.
	  // For pixel-perfect positioning, top/bottom prefers rounded
	  // values, while left/right prefers floored values.
	  var offsets = {
	    left: Math.floor(popper.left),
	    top: Math.round(popper.top),
	    bottom: Math.round(popper.bottom),
	    right: Math.floor(popper.right)
	  };
	
	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';
	
	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');
	
	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    top = -offsetParentRect.height + offsets.bottom;
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    left = -offsetParentRect.width + offsets.right;
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }
	
	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };
	
	  // Update `data` attributes, styles and arrowStyles
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
	
	  return data;
	}
	
	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });
	
	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });
	
	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  var _data$offsets$arrow;
	
	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }
	
	  var arrowElement = options.element;
	
	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);
	
	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }
	
	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	  var len = isVertical ? 'height' : 'width';
	  var sideCapitalized = isVertical ? 'Top' : 'Left';
	  var side = sideCapitalized.toLowerCase();
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	  //
	  // extends keepTogether behavior making sure the popper and its
	  // reference have enough pixels in conjuction
	  //
	
	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	  data.offsets.popper = getClientRect(data.offsets.popper);
	
	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	  // Compute the sideValue using the updated popper offsets
	  // take popper margin in account because we don't have this info available
	  var css = getStyleComputedProperty(data.instance.popper);
	  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
	  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
	  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
	
	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	  data.arrowElement = arrowElement;
	  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
	
	  return data;
	}
	
	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}
	
	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-right` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);
	
	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}
	
	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }
	
	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
	
	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';
	
	  var flipOrder = [];
	
	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }
	
	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }
	
	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);
	
	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;
	
	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;
	
	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }
	
	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }
	
	      data.placement = placement + (variation ? '-' + variation : '');
	
	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';
	
	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }
	
	  return data;
	}
	
	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];
	
	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }
	
	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }
	
	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}
	
	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];
	
	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });
	
	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));
	
	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }
	
	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });
	
	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var basePlacement = placement.split('-')[0];
	
	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }
	
	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }
	
	  data.popper = popper;
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
	  options.boundaries = boundaries;
	
	  var order = options.priority;
	  var popper = data.offsets.popper;
	
	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };
	
	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });
	
	  data.offsets.popper = popper;
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];
	
	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;
	
	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };
	
	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }
	
	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;
	
	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }
	
	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }
	
	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);
	
	  return data;
	}
	
	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */
	
	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },
	
	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unitless, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the height.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	   * > More on this [reading this issue](https://github.com/FezVrasta/popper.js/issues/373)
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },
	
	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * An scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper this makes sure the popper has always a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier, can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },
	
	  /**
	   * Modifier used to make sure the reference and its popper stay near eachothers
	   * without leaving any gap between the two. Expecially useful when the arrow is
	   * enabled and you want to assure it to point to its reference element.
	   * It cares only about the first axis, you can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },
	
	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjuction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },
	
	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations).
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position,
	     * the popper will never be placed outside of the defined boundaries
	     * (except if keepTogether is enabled)
	     */
	    boundariesElement: 'viewport'
	  },
	
	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },
	
	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },
	
	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3d transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties.
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },
	
	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define you own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3d transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties.
	     */
	    gpuAcceleration: undefined
	  }
	};
	
	/**
	 * The `dataObject` is an object containing all the informations used by Popper.js
	 * this object get passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper.
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper, it expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow, it expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements.
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */
	
	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overriden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass as 3rd argument an object with the same
	 * structure of this object, example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',
	
	  /**
	   * Set this to true if you want popper to position it self in 'fixed' mode
	   * @prop {Boolean} positionFixed=false
	   */
	  positionFixed: false,
	
	  /**
	   * Whether events (resize, scroll) are initially enabled
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,
	
	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,
	
	  /**
	   * Callback called when the popper is created.<br />
	   * By default, is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},
	
	  /**
	   * Callback called when the popper is updated, this callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},
	
	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};
	
	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */
	
	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */
	
	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Create a new Popper.js instance
	   * @class Popper
	   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
	   * @param {HTMLElement} popper - The HTML element used as popper.
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);
	
	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };
	
	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));
	
	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);
	
	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };
	
	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference && reference.jquery ? reference[0] : reference;
	    this.popper = popper && popper.jquery ? popper[0] : popper;
	
	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });
	
	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });
	
	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });
	
	    // fire the first update to position the popper in the right place
	    this.update();
	
	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }
	
	    this.state.eventsEnabled = eventsEnabled;
	  }
	
	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs
	
	
	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }
	
	    /**
	     * Schedule an update, it will run on the next UI update available
	     * @method scheduleUpdate
	     * @memberof Popper
	     */
	
	
	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */
	
	  }]);
	  return Popper;
	}();
	
	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */
	
	
	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;
	
	return Popper;
	
	})));
	//# sourceMappingURL=popper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */
/***/ function(module, exports) {

	function RavenConfigError(message) {
	  this.name = 'RavenConfigError';
	  this.message = message;
	}
	RavenConfigError.prototype = new Error();
	RavenConfigError.prototype.constructor = RavenConfigError;
	
	module.exports = RavenConfigError;


/***/ },
/* 1352 */
/***/ function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(288);
	
	var wrapMethod = function(console, level, callback) {
	  var originalConsoleLevel = console[level];
	  var originalConsole = console;
	
	  if (!(level in console)) {
	    return;
	  }
	
	  var sentryLevel = level === 'warn' ? 'warning' : level;
	
	  console[level] = function() {
	    var args = [].slice.call(arguments);
	
	    var msg = utils.safeJoin(args, ' ');
	    var data = {level: sentryLevel, logger: 'console', extra: {arguments: args}};
	
	    if (level === 'assert') {
	      if (args[0] === false) {
	        // Default browsers message
	        msg =
	          'Assertion failed: ' + (utils.safeJoin(args.slice(1), ' ') || 'console.assert');
	        data.extra.arguments = args.slice(1);
	        callback && callback(msg, data);
	      }
	    } else {
	      callback && callback(msg, data);
	    }
	
	    // this fails for some browsers. :(
	    if (originalConsoleLevel) {
	      // IE9 doesn't allow calling apply on console functions directly
	      // See: https://stackoverflow.com/questions/5472938/does-ie9-support-console-log-and-is-it-a-real-function#answer-5473193
	      Function.prototype.apply.call(originalConsoleLevel, originalConsole, args);
	    }
	  };
	};
	
	module.exports = {
	  wrapMethod: wrapMethod
	};


/***/ },
/* 1353 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*global XDomainRequest:false */
	
	var TraceKit = __webpack_require__(1354);
	var stringify = __webpack_require__(583);
	var md5 = __webpack_require__(1355);
	var RavenConfigError = __webpack_require__(1351);
	
	var utils = __webpack_require__(288);
	var isError = utils.isError;
	var isObject = utils.isObject;
	var isPlainObject = utils.isPlainObject;
	var isErrorEvent = utils.isErrorEvent;
	var isUndefined = utils.isUndefined;
	var isFunction = utils.isFunction;
	var isString = utils.isString;
	var isArray = utils.isArray;
	var isEmptyObject = utils.isEmptyObject;
	var each = utils.each;
	var objectMerge = utils.objectMerge;
	var truncate = utils.truncate;
	var objectFrozen = utils.objectFrozen;
	var hasKey = utils.hasKey;
	var joinRegExp = utils.joinRegExp;
	var urlencode = utils.urlencode;
	var uuid4 = utils.uuid4;
	var htmlTreeAsString = utils.htmlTreeAsString;
	var isSameException = utils.isSameException;
	var isSameStacktrace = utils.isSameStacktrace;
	var parseUrl = utils.parseUrl;
	var fill = utils.fill;
	var supportsFetch = utils.supportsFetch;
	var supportsReferrerPolicy = utils.supportsReferrerPolicy;
	var serializeKeysForMessage = utils.serializeKeysForMessage;
	var serializeException = utils.serializeException;
	
	var wrapConsoleMethod = __webpack_require__(1352).wrapMethod;
	
	var dsnKeys = 'source protocol user pass host port path'.split(' '),
	  dsnPattern = /^(?:(\w+):)?\/\/(?:(\w+)(:\w+)?@)?([\w\.-]+)(?::(\d+))?(\/.*)/;
	
	function now() {
	  return +new Date();
	}
	
	// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
	var _window =
	  typeof window !== 'undefined'
	    ? window
	    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	var _document = _window.document;
	var _navigator = _window.navigator;
	
	function keepOriginalCallback(original, callback) {
	  return isFunction(callback)
	    ? function(data) {
	        return callback(data, original);
	      }
	    : callback;
	}
	
	// First, check for JSON support
	// If there is no JSON, we no-op the core features of Raven
	// since JSON is required to encode the payload
	function Raven() {
	  this._hasJSON = !!(typeof JSON === 'object' && JSON.stringify);
	  // Raven can run in contexts where there's no document (react-native)
	  this._hasDocument = !isUndefined(_document);
	  this._hasNavigator = !isUndefined(_navigator);
	  this._lastCapturedException = null;
	  this._lastData = null;
	  this._lastEventId = null;
	  this._globalServer = null;
	  this._globalKey = null;
	  this._globalProject = null;
	  this._globalContext = {};
	  this._globalOptions = {
	    // SENTRY_RELEASE can be injected by https://github.com/getsentry/sentry-webpack-plugin
	    release: _window.SENTRY_RELEASE && _window.SENTRY_RELEASE.id,
	    logger: 'javascript',
	    ignoreErrors: [],
	    ignoreUrls: [],
	    whitelistUrls: [],
	    includePaths: [],
	    headers: null,
	    collectWindowErrors: true,
	    captureUnhandledRejections: true,
	    maxMessageLength: 0,
	
	    // By default, truncates URL values to 250 chars
	    maxUrlLength: 250,
	    stackTraceLimit: 50,
	    autoBreadcrumbs: true,
	    instrument: true,
	    sampleRate: 1
	  };
	  this._fetchDefaults = {
	    method: 'POST',
	    keepalive: true,
	    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
	    // https://caniuse.com/#feat=referrer-policy
	    // It doesn't. And it throw exception instead of ignoring this parameter...
	    // REF: https://github.com/getsentry/raven-js/issues/1233
	    referrerPolicy: supportsReferrerPolicy() ? 'origin' : ''
	  };
	  this._ignoreOnError = 0;
	  this._isRavenInstalled = false;
	  this._originalErrorStackTraceLimit = Error.stackTraceLimit;
	  // capture references to window.console *and* all its methods first
	  // before the console plugin has a chance to monkey patch
	  this._originalConsole = _window.console || {};
	  this._originalConsoleMethods = {};
	  this._plugins = [];
	  this._startTime = now();
	  this._wrappedBuiltIns = [];
	  this._breadcrumbs = [];
	  this._lastCapturedEvent = null;
	  this._keypressTimeout;
	  this._location = _window.location;
	  this._lastHref = this._location && this._location.href;
	  this._resetBackoff();
	
	  // eslint-disable-next-line guard-for-in
	  for (var method in this._originalConsole) {
	    this._originalConsoleMethods[method] = this._originalConsole[method];
	  }
	}
	
	/*
	 * The core Raven singleton
	 *
	 * @this {Raven}
	 */
	
	Raven.prototype = {
	  // Hardcode version string so that raven source can be loaded directly via
	  // webpack (using a build step causes webpack #1617). Grunt verifies that
	  // this value matches package.json during build.
	  //   See: https://github.com/getsentry/raven-js/issues/465
	  VERSION: '3.23.3',
	
	  debug: false,
	
	  TraceKit: TraceKit, // alias to TraceKit
	
	  /*
	     * Configure Raven with a DSN and extra options
	     *
	     * @param {string} dsn The public Sentry DSN
	     * @param {object} options Set of global options [optional]
	     * @return {Raven}
	     */
	  config: function(dsn, options) {
	    var self = this;
	
	    if (self._globalServer) {
	      this._logDebug('error', 'Error: Raven has already been configured');
	      return self;
	    }
	    if (!dsn) return self;
	
	    var globalOptions = self._globalOptions;
	
	    // merge in options
	    if (options) {
	      each(options, function(key, value) {
	        // tags and extra are special and need to be put into context
	        if (key === 'tags' || key === 'extra' || key === 'user') {
	          self._globalContext[key] = value;
	        } else {
	          globalOptions[key] = value;
	        }
	      });
	    }
	
	    self.setDSN(dsn);
	
	    // "Script error." is hard coded into browsers for errors that it can't read.
	    // this is the result of a script being pulled in from an external domain and CORS.
	    globalOptions.ignoreErrors.push(/^Script error\.?$/);
	    globalOptions.ignoreErrors.push(/^Javascript error: Script error\.? on line 0$/);
	
	    // join regexp rules into one big rule
	    globalOptions.ignoreErrors = joinRegExp(globalOptions.ignoreErrors);
	    globalOptions.ignoreUrls = globalOptions.ignoreUrls.length
	      ? joinRegExp(globalOptions.ignoreUrls)
	      : false;
	    globalOptions.whitelistUrls = globalOptions.whitelistUrls.length
	      ? joinRegExp(globalOptions.whitelistUrls)
	      : false;
	    globalOptions.includePaths = joinRegExp(globalOptions.includePaths);
	    globalOptions.maxBreadcrumbs = Math.max(
	      0,
	      Math.min(globalOptions.maxBreadcrumbs || 100, 100)
	    ); // default and hard limit is 100
	
	    var autoBreadcrumbDefaults = {
	      xhr: true,
	      console: true,
	      dom: true,
	      location: true,
	      sentry: true
	    };
	
	    var autoBreadcrumbs = globalOptions.autoBreadcrumbs;
	    if ({}.toString.call(autoBreadcrumbs) === '[object Object]') {
	      autoBreadcrumbs = objectMerge(autoBreadcrumbDefaults, autoBreadcrumbs);
	    } else if (autoBreadcrumbs !== false) {
	      autoBreadcrumbs = autoBreadcrumbDefaults;
	    }
	    globalOptions.autoBreadcrumbs = autoBreadcrumbs;
	
	    var instrumentDefaults = {
	      tryCatch: true
	    };
	
	    var instrument = globalOptions.instrument;
	    if ({}.toString.call(instrument) === '[object Object]') {
	      instrument = objectMerge(instrumentDefaults, instrument);
	    } else if (instrument !== false) {
	      instrument = instrumentDefaults;
	    }
	    globalOptions.instrument = instrument;
	
	    TraceKit.collectWindowErrors = !!globalOptions.collectWindowErrors;
	
	    // return for chaining
	    return self;
	  },
	
	  /*
	     * Installs a global window.onerror error handler
	     * to capture and report uncaught exceptions.
	     * At this point, install() is required to be called due
	     * to the way TraceKit is set up.
	     *
	     * @return {Raven}
	     */
	  install: function() {
	    var self = this;
	    if (self.isSetup() && !self._isRavenInstalled) {
	      TraceKit.report.subscribe(function() {
	        self._handleOnErrorStackInfo.apply(self, arguments);
	      });
	
	      if (self._globalOptions.captureUnhandledRejections) {
	        self._attachPromiseRejectionHandler();
	      }
	
	      self._patchFunctionToString();
	
	      if (self._globalOptions.instrument && self._globalOptions.instrument.tryCatch) {
	        self._instrumentTryCatch();
	      }
	
	      if (self._globalOptions.autoBreadcrumbs) self._instrumentBreadcrumbs();
	
	      // Install all of the plugins
	      self._drainPlugins();
	
	      self._isRavenInstalled = true;
	    }
	
	    Error.stackTraceLimit = self._globalOptions.stackTraceLimit;
	    return this;
	  },
	
	  /*
	     * Set the DSN (can be called multiple time unlike config)
	     *
	     * @param {string} dsn The public Sentry DSN
	     */
	  setDSN: function(dsn) {
	    var self = this,
	      uri = self._parseDSN(dsn),
	      lastSlash = uri.path.lastIndexOf('/'),
	      path = uri.path.substr(1, lastSlash);
	
	    self._dsn = dsn;
	    self._globalKey = uri.user;
	    self._globalSecret = uri.pass && uri.pass.substr(1);
	    self._globalProject = uri.path.substr(lastSlash + 1);
	
	    self._globalServer = self._getGlobalServer(uri);
	
	    self._globalEndpoint =
	      self._globalServer + '/' + path + 'api/' + self._globalProject + '/store/';
	
	    // Reset backoff state since we may be pointing at a
	    // new project/server
	    this._resetBackoff();
	  },
	
	  /*
	     * Wrap code within a context so Raven can capture errors
	     * reliably across domains that is executed immediately.
	     *
	     * @param {object} options A specific set of options for this context [optional]
	     * @param {function} func The callback to be immediately executed within the context
	     * @param {array} args An array of arguments to be called with the callback [optional]
	     */
	  context: function(options, func, args) {
	    if (isFunction(options)) {
	      args = func || [];
	      func = options;
	      options = undefined;
	    }
	
	    return this.wrap(options, func).apply(this, args);
	  },
	
	  /*
	     * Wrap code within a context and returns back a new function to be executed
	     *
	     * @param {object} options A specific set of options for this context [optional]
	     * @param {function} func The function to be wrapped in a new context
	     * @param {function} func A function to call before the try/catch wrapper [optional, private]
	     * @return {function} The newly wrapped functions with a context
	     */
	  wrap: function(options, func, _before) {
	    var self = this;
	    // 1 argument has been passed, and it's not a function
	    // so just return it
	    if (isUndefined(func) && !isFunction(options)) {
	      return options;
	    }
	
	    // options is optional
	    if (isFunction(options)) {
	      func = options;
	      options = undefined;
	    }
	
	    // At this point, we've passed along 2 arguments, and the second one
	    // is not a function either, so we'll just return the second argument.
	    if (!isFunction(func)) {
	      return func;
	    }
	
	    // We don't wanna wrap it twice!
	    try {
	      if (func.__raven__) {
	        return func;
	      }
	
	      // If this has already been wrapped in the past, return that
	      if (func.__raven_wrapper__) {
	        return func.__raven_wrapper__;
	      }
	    } catch (e) {
	      // Just accessing custom props in some Selenium environments
	      // can cause a "Permission denied" exception (see raven-js#495).
	      // Bail on wrapping and return the function as-is (defers to window.onerror).
	      return func;
	    }
	
	    function wrapped() {
	      var args = [],
	        i = arguments.length,
	        deep = !options || (options && options.deep !== false);
	
	      if (_before && isFunction(_before)) {
	        _before.apply(this, arguments);
	      }
	
	      // Recursively wrap all of a function's arguments that are
	      // functions themselves.
	      while (i--) args[i] = deep ? self.wrap(options, arguments[i]) : arguments[i];
	
	      try {
	        // Attempt to invoke user-land function
	        // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
	        //       means Raven caught an error invoking your application code. This is
	        //       expected behavior and NOT indicative of a bug with Raven.js.
	        return func.apply(this, args);
	      } catch (e) {
	        self._ignoreNextOnError();
	        self.captureException(e, options);
	        throw e;
	      }
	    }
	
	    // copy over properties of the old function
	    for (var property in func) {
	      if (hasKey(func, property)) {
	        wrapped[property] = func[property];
	      }
	    }
	    wrapped.prototype = func.prototype;
	
	    func.__raven_wrapper__ = wrapped;
	    // Signal that this function has been wrapped/filled already
	    // for both debugging and to prevent it to being wrapped/filled twice
	    wrapped.__raven__ = true;
	    wrapped.__orig__ = func;
	
	    return wrapped;
	  },
	
	  /**
	   * Uninstalls the global error handler.
	   *
	   * @return {Raven}
	   */
	  uninstall: function() {
	    TraceKit.report.uninstall();
	
	    this._detachPromiseRejectionHandler();
	    this._unpatchFunctionToString();
	    this._restoreBuiltIns();
	    this._restoreConsole();
	
	    Error.stackTraceLimit = this._originalErrorStackTraceLimit;
	    this._isRavenInstalled = false;
	
	    return this;
	  },
	
	  /**
	   * Callback used for `unhandledrejection` event
	   *
	   * @param {PromiseRejectionEvent} event An object containing
	   *   promise: the Promise that was rejected
	   *   reason: the value with which the Promise was rejected
	   * @return void
	   */
	  _promiseRejectionHandler: function(event) {
	    this._logDebug('debug', 'Raven caught unhandled promise rejection:', event);
	    this.captureException(event.reason);
	  },
	
	  /**
	   * Installs the global promise rejection handler.
	   *
	   * @return {raven}
	   */
	  _attachPromiseRejectionHandler: function() {
	    this._promiseRejectionHandler = this._promiseRejectionHandler.bind(this);
	    _window.addEventListener &&
	      _window.addEventListener('unhandledrejection', this._promiseRejectionHandler);
	    return this;
	  },
	
	  /**
	   * Uninstalls the global promise rejection handler.
	   *
	   * @return {raven}
	   */
	  _detachPromiseRejectionHandler: function() {
	    _window.removeEventListener &&
	      _window.removeEventListener('unhandledrejection', this._promiseRejectionHandler);
	    return this;
	  },
	
	  /**
	   * Manually capture an exception and send it over to Sentry
	   *
	   * @param {error} ex An exception to be logged
	   * @param {object} options A specific set of options for this error [optional]
	   * @return {Raven}
	   */
	  captureException: function(ex, options) {
	    options = objectMerge({trimHeadFrames: 0}, options ? options : {});
	
	    if (isErrorEvent(ex) && ex.error) {
	      // If it is an ErrorEvent with `error` property, extract it to get actual Error
	      ex = ex.error;
	    } else if (isError(ex)) {
	      // we have a real Error object
	      ex = ex;
	    } else if (isPlainObject(ex)) {
	      // If it is plain Object, serialize it manually and extract options
	      // This will allow us to group events based on top-level keys
	      // which is much better than creating new group when any key/value change
	      options = this._getCaptureExceptionOptionsFromPlainObject(options, ex);
	      ex = new Error(options.message);
	    } else {
	      // If none of previous checks were valid, then it means that
	      // it's not a plain Object
	      // it's not a valid ErrorEvent (one with an error property)
	      // it's not an Error
	      // So bail out and capture it as a simple message:
	      return this.captureMessage(
	        ex,
	        objectMerge(options, {
	          stacktrace: true, // if we fall back to captureMessage, default to attempting a new trace
	          trimHeadFrames: options.trimHeadFrames + 1
	        })
	      );
	    }
	
	    // Store the raw exception object for potential debugging and introspection
	    this._lastCapturedException = ex;
	
	    // TraceKit.report will re-raise any exception passed to it,
	    // which means you have to wrap it in try/catch. Instead, we
	    // can wrap it here and only re-raise if TraceKit.report
	    // raises an exception different from the one we asked to
	    // report on.
	    try {
	      var stack = TraceKit.computeStackTrace(ex);
	      this._handleStackInfo(stack, options);
	    } catch (ex1) {
	      if (ex !== ex1) {
	        throw ex1;
	      }
	    }
	
	    return this;
	  },
	
	  _getCaptureExceptionOptionsFromPlainObject: function(currentOptions, ex) {
	    var exKeys = Object.keys(ex).sort();
	    var options = objectMerge(currentOptions, {
	      message:
	        'Non-Error exception captured with keys: ' + serializeKeysForMessage(exKeys),
	      fingerprint: [md5(exKeys)],
	      extra: currentOptions.extra || {}
	    });
	    options.extra.__serialized__ = serializeException(ex);
	
	    return options;
	  },
	
	  /*
	     * Manually send a message to Sentry
	     *
	     * @param {string} msg A plain message to be captured in Sentry
	     * @param {object} options A specific set of options for this message [optional]
	     * @return {Raven}
	     */
	  captureMessage: function(msg, options) {
	    // config() automagically converts ignoreErrors from a list to a RegExp so we need to test for an
	    // early call; we'll error on the side of logging anything called before configuration since it's
	    // probably something you should see:
	    if (
	      !!this._globalOptions.ignoreErrors.test &&
	      this._globalOptions.ignoreErrors.test(msg)
	    ) {
	      return;
	    }
	
	    options = options || {};
	    msg = msg + ''; // Make sure it's actually a string
	
	    var data = objectMerge(
	      {
	        message: msg
	      },
	      options
	    );
	
	    var ex;
	    // Generate a "synthetic" stack trace from this point.
	    // NOTE: If you are a Sentry user, and you are seeing this stack frame, it is NOT indicative
	    //       of a bug with Raven.js. Sentry generates synthetic traces either by configuration,
	    //       or if it catches a thrown object without a "stack" property.
	    try {
	      throw new Error(msg);
	    } catch (ex1) {
	      ex = ex1;
	    }
	
	    // null exception name so `Error` isn't prefixed to msg
	    ex.name = null;
	    var stack = TraceKit.computeStackTrace(ex);
	
	    // stack[0] is `throw new Error(msg)` call itself, we are interested in the frame that was just before that, stack[1]
	    var initialCall = isArray(stack.stack) && stack.stack[1];
	    var fileurl = (initialCall && initialCall.url) || '';
	
	    if (
	      !!this._globalOptions.ignoreUrls.test &&
	      this._globalOptions.ignoreUrls.test(fileurl)
	    ) {
	      return;
	    }
	
	    if (
	      !!this._globalOptions.whitelistUrls.test &&
	      !this._globalOptions.whitelistUrls.test(fileurl)
	    ) {
	      return;
	    }
	
	    if (this._globalOptions.stacktrace || (options && options.stacktrace)) {
	      // fingerprint on msg, not stack trace (legacy behavior, could be revisited)
	      data.fingerprint = data.fingerprint == null ? msg : data.fingerprint;
	
	      options = objectMerge(
	        {
	          trimHeadFrames: 0
	        },
	        options
	      );
	      // Since we know this is a synthetic trace, the top frame (this function call)
	      // MUST be from Raven.js, so mark it for trimming
	      // We add to the trim counter so that callers can choose to trim extra frames, such
	      // as utility functions.
	      options.trimHeadFrames += 1;
	
	      var frames = this._prepareFrames(stack, options);
	      data.stacktrace = {
	        // Sentry expects frames oldest to newest
	        frames: frames.reverse()
	      };
	    }
	
	    // Make sure that fingerprint is always wrapped in an array
	    if (data.fingerprint) {
	      data.fingerprint = isArray(data.fingerprint)
	        ? data.fingerprint
	        : [data.fingerprint];
	    }
	
	    // Fire away!
	    this._send(data);
	
	    return this;
	  },
	
	  captureBreadcrumb: function(obj) {
	    var crumb = objectMerge(
	      {
	        timestamp: now() / 1000
	      },
	      obj
	    );
	
	    if (isFunction(this._globalOptions.breadcrumbCallback)) {
	      var result = this._globalOptions.breadcrumbCallback(crumb);
	
	      if (isObject(result) && !isEmptyObject(result)) {
	        crumb = result;
	      } else if (result === false) {
	        return this;
	      }
	    }
	
	    this._breadcrumbs.push(crumb);
	    if (this._breadcrumbs.length > this._globalOptions.maxBreadcrumbs) {
	      this._breadcrumbs.shift();
	    }
	    return this;
	  },
	
	  addPlugin: function(plugin /*arg1, arg2, ... argN*/) {
	    var pluginArgs = [].slice.call(arguments, 1);
	
	    this._plugins.push([plugin, pluginArgs]);
	    if (this._isRavenInstalled) {
	      this._drainPlugins();
	    }
	
	    return this;
	  },
	
	  /*
	     * Set/clear a user to be sent along with the payload.
	     *
	     * @param {object} user An object representing user data [optional]
	     * @return {Raven}
	     */
	  setUserContext: function(user) {
	    // Intentionally do not merge here since that's an unexpected behavior.
	    this._globalContext.user = user;
	
	    return this;
	  },
	
	  /*
	     * Merge extra attributes to be sent along with the payload.
	     *
	     * @param {object} extra An object representing extra data [optional]
	     * @return {Raven}
	     */
	  setExtraContext: function(extra) {
	    this._mergeContext('extra', extra);
	
	    return this;
	  },
	
	  /*
	     * Merge tags to be sent along with the payload.
	     *
	     * @param {object} tags An object representing tags [optional]
	     * @return {Raven}
	     */
	  setTagsContext: function(tags) {
	    this._mergeContext('tags', tags);
	
	    return this;
	  },
	
	  /*
	     * Clear all of the context.
	     *
	     * @return {Raven}
	     */
	  clearContext: function() {
	    this._globalContext = {};
	
	    return this;
	  },
	
	  /*
	     * Get a copy of the current context. This cannot be mutated.
	     *
	     * @return {object} copy of context
	     */
	  getContext: function() {
	    // lol javascript
	    return JSON.parse(stringify(this._globalContext));
	  },
	
	  /*
	     * Set environment of application
	     *
	     * @param {string} environment Typically something like 'production'.
	     * @return {Raven}
	     */
	  setEnvironment: function(environment) {
	    this._globalOptions.environment = environment;
	
	    return this;
	  },
	
	  /*
	     * Set release version of application
	     *
	     * @param {string} release Typically something like a git SHA to identify version
	     * @return {Raven}
	     */
	  setRelease: function(release) {
	    this._globalOptions.release = release;
	
	    return this;
	  },
	
	  /*
	     * Set the dataCallback option
	     *
	     * @param {function} callback The callback to run which allows the
	     *                            data blob to be mutated before sending
	     * @return {Raven}
	     */
	  setDataCallback: function(callback) {
	    var original = this._globalOptions.dataCallback;
	    this._globalOptions.dataCallback = keepOriginalCallback(original, callback);
	    return this;
	  },
	
	  /*
	     * Set the breadcrumbCallback option
	     *
	     * @param {function} callback The callback to run which allows filtering
	     *                            or mutating breadcrumbs
	     * @return {Raven}
	     */
	  setBreadcrumbCallback: function(callback) {
	    var original = this._globalOptions.breadcrumbCallback;
	    this._globalOptions.breadcrumbCallback = keepOriginalCallback(original, callback);
	    return this;
	  },
	
	  /*
	     * Set the shouldSendCallback option
	     *
	     * @param {function} callback The callback to run which allows
	     *                            introspecting the blob before sending
	     * @return {Raven}
	     */
	  setShouldSendCallback: function(callback) {
	    var original = this._globalOptions.shouldSendCallback;
	    this._globalOptions.shouldSendCallback = keepOriginalCallback(original, callback);
	    return this;
	  },
	
	  /**
	   * Override the default HTTP transport mechanism that transmits data
	   * to the Sentry server.
	   *
	   * @param {function} transport Function invoked instead of the default
	   *                             `makeRequest` handler.
	   *
	   * @return {Raven}
	   */
	  setTransport: function(transport) {
	    this._globalOptions.transport = transport;
	
	    return this;
	  },
	
	  /*
	     * Get the latest raw exception that was captured by Raven.
	     *
	     * @return {error}
	     */
	  lastException: function() {
	    return this._lastCapturedException;
	  },
	
	  /*
	     * Get the last event id
	     *
	     * @return {string}
	     */
	  lastEventId: function() {
	    return this._lastEventId;
	  },
	
	  /*
	     * Determine if Raven is setup and ready to go.
	     *
	     * @return {boolean}
	     */
	  isSetup: function() {
	    if (!this._hasJSON) return false; // needs JSON support
	    if (!this._globalServer) {
	      if (!this.ravenNotConfiguredError) {
	        this.ravenNotConfiguredError = true;
	        this._logDebug('error', 'Error: Raven has not been configured.');
	      }
	      return false;
	    }
	    return true;
	  },
	
	  afterLoad: function() {
	    // TODO: remove window dependence?
	
	    // Attempt to initialize Raven on load
	    var RavenConfig = _window.RavenConfig;
	    if (RavenConfig) {
	      this.config(RavenConfig.dsn, RavenConfig.config).install();
	    }
	  },
	
	  showReportDialog: function(options) {
	    if (
	      !_document // doesn't work without a document (React native)
	    )
	      return;
	
	    options = options || {};
	
	    var lastEventId = options.eventId || this.lastEventId();
	    if (!lastEventId) {
	      throw new RavenConfigError('Missing eventId');
	    }
	
	    var dsn = options.dsn || this._dsn;
	    if (!dsn) {
	      throw new RavenConfigError('Missing DSN');
	    }
	
	    var encode = encodeURIComponent;
	    var qs = '';
	    qs += '?eventId=' + encode(lastEventId);
	    qs += '&dsn=' + encode(dsn);
	
	    var user = options.user || this._globalContext.user;
	    if (user) {
	      if (user.name) qs += '&name=' + encode(user.name);
	      if (user.email) qs += '&email=' + encode(user.email);
	    }
	
	    var globalServer = this._getGlobalServer(this._parseDSN(dsn));
	
	    var script = _document.createElement('script');
	    script.async = true;
	    script.src = globalServer + '/api/embed/error-page/' + qs;
	    (_document.head || _document.body).appendChild(script);
	  },
	
	  /**** Private functions ****/
	  _ignoreNextOnError: function() {
	    var self = this;
	    this._ignoreOnError += 1;
	    setTimeout(function() {
	      // onerror should trigger before setTimeout
	      self._ignoreOnError -= 1;
	    });
	  },
	
	  _triggerEvent: function(eventType, options) {
	    // NOTE: `event` is a native browser thing, so let's avoid conflicting wiht it
	    var evt, key;
	
	    if (!this._hasDocument) return;
	
	    options = options || {};
	
	    eventType = 'raven' + eventType.substr(0, 1).toUpperCase() + eventType.substr(1);
	
	    if (_document.createEvent) {
	      evt = _document.createEvent('HTMLEvents');
	      evt.initEvent(eventType, true, true);
	    } else {
	      evt = _document.createEventObject();
	      evt.eventType = eventType;
	    }
	
	    for (key in options)
	      if (hasKey(options, key)) {
	        evt[key] = options[key];
	      }
	
	    if (_document.createEvent) {
	      // IE9 if standards
	      _document.dispatchEvent(evt);
	    } else {
	      // IE8 regardless of Quirks or Standards
	      // IE9 if quirks
	      try {
	        _document.fireEvent('on' + evt.eventType.toLowerCase(), evt);
	      } catch (e) {
	        // Do nothing
	      }
	    }
	  },
	
	  /**
	   * Wraps addEventListener to capture UI breadcrumbs
	   * @param evtName the event name (e.g. "click")
	   * @returns {Function}
	   * @private
	   */
	  _breadcrumbEventHandler: function(evtName) {
	    var self = this;
	    return function(evt) {
	      // reset keypress timeout; e.g. triggering a 'click' after
	      // a 'keypress' will reset the keypress debounce so that a new
	      // set of keypresses can be recorded
	      self._keypressTimeout = null;
	
	      // It's possible this handler might trigger multiple times for the same
	      // event (e.g. event propagation through node ancestors). Ignore if we've
	      // already captured the event.
	      if (self._lastCapturedEvent === evt) return;
	
	      self._lastCapturedEvent = evt;
	
	      // try/catch both:
	      // - accessing evt.target (see getsentry/raven-js#838, #768)
	      // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
	      //   can throw an exception in some circumstances.
	      var target;
	      try {
	        target = htmlTreeAsString(evt.target);
	      } catch (e) {
	        target = '<unknown>';
	      }
	
	      self.captureBreadcrumb({
	        category: 'ui.' + evtName, // e.g. ui.click, ui.input
	        message: target
	      });
	    };
	  },
	
	  /**
	   * Wraps addEventListener to capture keypress UI events
	   * @returns {Function}
	   * @private
	   */
	  _keypressEventHandler: function() {
	    var self = this,
	      debounceDuration = 1000; // milliseconds
	
	    // TODO: if somehow user switches keypress target before
	    //       debounce timeout is triggered, we will only capture
	    //       a single breadcrumb from the FIRST target (acceptable?)
	    return function(evt) {
	      var target;
	      try {
	        target = evt.target;
	      } catch (e) {
	        // just accessing event properties can throw an exception in some rare circumstances
	        // see: https://github.com/getsentry/raven-js/issues/838
	        return;
	      }
	      var tagName = target && target.tagName;
	
	      // only consider keypress events on actual input elements
	      // this will disregard keypresses targeting body (e.g. tabbing
	      // through elements, hotkeys, etc)
	      if (
	        !tagName ||
	        (tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)
	      )
	        return;
	
	      // record first keypress in a series, but ignore subsequent
	      // keypresses until debounce clears
	      var timeout = self._keypressTimeout;
	      if (!timeout) {
	        self._breadcrumbEventHandler('input')(evt);
	      }
	      clearTimeout(timeout);
	      self._keypressTimeout = setTimeout(function() {
	        self._keypressTimeout = null;
	      }, debounceDuration);
	    };
	  },
	
	  /**
	   * Captures a breadcrumb of type "navigation", normalizing input URLs
	   * @param to the originating URL
	   * @param from the target URL
	   * @private
	   */
	  _captureUrlChange: function(from, to) {
	    var parsedLoc = parseUrl(this._location.href);
	    var parsedTo = parseUrl(to);
	    var parsedFrom = parseUrl(from);
	
	    // because onpopstate only tells you the "new" (to) value of location.href, and
	    // not the previous (from) value, we need to track the value of the current URL
	    // state ourselves
	    this._lastHref = to;
	
	    // Use only the path component of the URL if the URL matches the current
	    // document (almost all the time when using pushState)
	    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host)
	      to = parsedTo.relative;
	    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host)
	      from = parsedFrom.relative;
	
	    this.captureBreadcrumb({
	      category: 'navigation',
	      data: {
	        to: to,
	        from: from
	      }
	    });
	  },
	
	  _patchFunctionToString: function() {
	    var self = this;
	    self._originalFunctionToString = Function.prototype.toString;
	    // eslint-disable-next-line no-extend-native
	    Function.prototype.toString = function() {
	      if (typeof this === 'function' && this.__raven__) {
	        return self._originalFunctionToString.apply(this.__orig__, arguments);
	      }
	      return self._originalFunctionToString.apply(this, arguments);
	    };
	  },
	
	  _unpatchFunctionToString: function() {
	    if (this._originalFunctionToString) {
	      // eslint-disable-next-line no-extend-native
	      Function.prototype.toString = this._originalFunctionToString;
	    }
	  },
	
	  /**
	   * Wrap timer functions and event targets to catch errors and provide
	   * better metadata.
	   */
	  _instrumentTryCatch: function() {
	    var self = this;
	
	    var wrappedBuiltIns = self._wrappedBuiltIns;
	
	    function wrapTimeFn(orig) {
	      return function(fn, t) {
	        // preserve arity
	        // Make a copy of the arguments to prevent deoptimization
	        // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
	        var args = new Array(arguments.length);
	        for (var i = 0; i < args.length; ++i) {
	          args[i] = arguments[i];
	        }
	        var originalCallback = args[0];
	        if (isFunction(originalCallback)) {
	          args[0] = self.wrap(originalCallback);
	        }
	
	        // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
	        // also supports only two arguments and doesn't care what this is, so we
	        // can just call the original function directly.
	        if (orig.apply) {
	          return orig.apply(this, args);
	        } else {
	          return orig(args[0], args[1]);
	        }
	      };
	    }
	
	    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;
	
	    function wrapEventTarget(global) {
	      var proto = _window[global] && _window[global].prototype;
	      if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
	        fill(
	          proto,
	          'addEventListener',
	          function(orig) {
	            return function(evtName, fn, capture, secure) {
	              // preserve arity
	              try {
	                if (fn && fn.handleEvent) {
	                  fn.handleEvent = self.wrap(fn.handleEvent);
	                }
	              } catch (err) {
	                // can sometimes get 'Permission denied to access property "handle Event'
	              }
	
	              // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
	              // so that we don't have more than one wrapper function
	              var before, clickHandler, keypressHandler;
	
	              if (
	                autoBreadcrumbs &&
	                autoBreadcrumbs.dom &&
	                (global === 'EventTarget' || global === 'Node')
	              ) {
	                // NOTE: generating multiple handlers per addEventListener invocation, should
	                //       revisit and verify we can just use one (almost certainly)
	                clickHandler = self._breadcrumbEventHandler('click');
	                keypressHandler = self._keypressEventHandler();
	                before = function(evt) {
	                  // need to intercept every DOM event in `before` argument, in case that
	                  // same wrapped method is re-used for different events (e.g. mousemove THEN click)
	                  // see #724
	                  if (!evt) return;
	
	                  var eventType;
	                  try {
	                    eventType = evt.type;
	                  } catch (e) {
	                    // just accessing event properties can throw an exception in some rare circumstances
	                    // see: https://github.com/getsentry/raven-js/issues/838
	                    return;
	                  }
	                  if (eventType === 'click') return clickHandler(evt);
	                  else if (eventType === 'keypress') return keypressHandler(evt);
	                };
	              }
	              return orig.call(
	                this,
	                evtName,
	                self.wrap(fn, undefined, before),
	                capture,
	                secure
	              );
	            };
	          },
	          wrappedBuiltIns
	        );
	        fill(
	          proto,
	          'removeEventListener',
	          function(orig) {
	            return function(evt, fn, capture, secure) {
	              try {
	                fn = fn && (fn.__raven_wrapper__ ? fn.__raven_wrapper__ : fn);
	              } catch (e) {
	                // ignore, accessing __raven_wrapper__ will throw in some Selenium environments
	              }
	              return orig.call(this, evt, fn, capture, secure);
	            };
	          },
	          wrappedBuiltIns
	        );
	      }
	    }
	
	    fill(_window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
	    fill(_window, 'setInterval', wrapTimeFn, wrappedBuiltIns);
	    if (_window.requestAnimationFrame) {
	      fill(
	        _window,
	        'requestAnimationFrame',
	        function(orig) {
	          return function(cb) {
	            return orig(self.wrap(cb));
	          };
	        },
	        wrappedBuiltIns
	      );
	    }
	
	    // event targets borrowed from bugsnag-js:
	    // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
	    var eventTargets = [
	      'EventTarget',
	      'Window',
	      'Node',
	      'ApplicationCache',
	      'AudioTrackList',
	      'ChannelMergerNode',
	      'CryptoOperation',
	      'EventSource',
	      'FileReader',
	      'HTMLUnknownElement',
	      'IDBDatabase',
	      'IDBRequest',
	      'IDBTransaction',
	      'KeyOperation',
	      'MediaController',
	      'MessagePort',
	      'ModalWindow',
	      'Notification',
	      'SVGElementInstance',
	      'Screen',
	      'TextTrack',
	      'TextTrackCue',
	      'TextTrackList',
	      'WebSocket',
	      'WebSocketWorker',
	      'Worker',
	      'XMLHttpRequest',
	      'XMLHttpRequestEventTarget',
	      'XMLHttpRequestUpload'
	    ];
	    for (var i = 0; i < eventTargets.length; i++) {
	      wrapEventTarget(eventTargets[i]);
	    }
	  },
	
	  /**
	   * Instrument browser built-ins w/ breadcrumb capturing
	   *  - XMLHttpRequests
	   *  - DOM interactions (click/typing)
	   *  - window.location changes
	   *  - console
	   *
	   * Can be disabled or individually configured via the `autoBreadcrumbs` config option
	   */
	  _instrumentBreadcrumbs: function() {
	    var self = this;
	    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;
	
	    var wrappedBuiltIns = self._wrappedBuiltIns;
	
	    function wrapProp(prop, xhr) {
	      if (prop in xhr && isFunction(xhr[prop])) {
	        fill(xhr, prop, function(orig) {
	          return self.wrap(orig);
	        }); // intentionally don't track filled methods on XHR instances
	      }
	    }
	
	    if (autoBreadcrumbs.xhr && 'XMLHttpRequest' in _window) {
	      var xhrproto = XMLHttpRequest.prototype;
	      fill(
	        xhrproto,
	        'open',
	        function(origOpen) {
	          return function(method, url) {
	            // preserve arity
	
	            // if Sentry key appears in URL, don't capture
	            if (isString(url) && url.indexOf(self._globalKey) === -1) {
	              this.__raven_xhr = {
	                method: method,
	                url: url,
	                status_code: null
	              };
	            }
	
	            return origOpen.apply(this, arguments);
	          };
	        },
	        wrappedBuiltIns
	      );
	
	      fill(
	        xhrproto,
	        'send',
	        function(origSend) {
	          return function() {
	            // preserve arity
	            var xhr = this;
	
	            function onreadystatechangeHandler() {
	              if (xhr.__raven_xhr && xhr.readyState === 4) {
	                try {
	                  // touching statusCode in some platforms throws
	                  // an exception
	                  xhr.__raven_xhr.status_code = xhr.status;
	                } catch (e) {
	                  /* do nothing */
	                }
	
	                self.captureBreadcrumb({
	                  type: 'http',
	                  category: 'xhr',
	                  data: xhr.__raven_xhr
	                });
	              }
	            }
	
	            var props = ['onload', 'onerror', 'onprogress'];
	            for (var j = 0; j < props.length; j++) {
	              wrapProp(props[j], xhr);
	            }
	
	            if ('onreadystatechange' in xhr && isFunction(xhr.onreadystatechange)) {
	              fill(
	                xhr,
	                'onreadystatechange',
	                function(orig) {
	                  return self.wrap(orig, undefined, onreadystatechangeHandler);
	                } /* intentionally don't track this instrumentation */
	              );
	            } else {
	              // if onreadystatechange wasn't actually set by the page on this xhr, we
	              // are free to set our own and capture the breadcrumb
	              xhr.onreadystatechange = onreadystatechangeHandler;
	            }
	
	            return origSend.apply(this, arguments);
	          };
	        },
	        wrappedBuiltIns
	      );
	    }
	
	    if (autoBreadcrumbs.xhr && supportsFetch()) {
	      fill(
	        _window,
	        'fetch',
	        function(origFetch) {
	          return function() {
	            // preserve arity
	            // Make a copy of the arguments to prevent deoptimization
	            // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
	            var args = new Array(arguments.length);
	            for (var i = 0; i < args.length; ++i) {
	              args[i] = arguments[i];
	            }
	
	            var fetchInput = args[0];
	            var method = 'GET';
	            var url;
	
	            if (typeof fetchInput === 'string') {
	              url = fetchInput;
	            } else if ('Request' in _window && fetchInput instanceof _window.Request) {
	              url = fetchInput.url;
	              if (fetchInput.method) {
	                method = fetchInput.method;
	              }
	            } else {
	              url = '' + fetchInput;
	            }
	
	            // if Sentry key appears in URL, don't capture, as it's our own request
	            if (url.indexOf(self._globalKey) !== -1) {
	              return origFetch.apply(this, args);
	            }
	
	            if (args[1] && args[1].method) {
	              method = args[1].method;
	            }
	
	            var fetchData = {
	              method: method,
	              url: url,
	              status_code: null
	            };
	
	            return origFetch.apply(this, args).then(function(response) {
	              fetchData.status_code = response.status;
	
	              self.captureBreadcrumb({
	                type: 'http',
	                category: 'fetch',
	                data: fetchData
	              });
	
	              return response;
	            });
	          };
	        },
	        wrappedBuiltIns
	      );
	    }
	
	    // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
	    // to the document. Do this before we instrument addEventListener.
	    if (autoBreadcrumbs.dom && this._hasDocument) {
	      if (_document.addEventListener) {
	        _document.addEventListener('click', self._breadcrumbEventHandler('click'), false);
	        _document.addEventListener('keypress', self._keypressEventHandler(), false);
	      } else {
	        // IE8 Compatibility
	        _document.attachEvent('onclick', self._breadcrumbEventHandler('click'));
	        _document.attachEvent('onkeypress', self._keypressEventHandler());
	      }
	    }
	
	    // record navigation (URL) changes
	    // NOTE: in Chrome App environment, touching history.pushState, *even inside
	    //       a try/catch block*, will cause Chrome to output an error to console.error
	    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
	    var chrome = _window.chrome;
	    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
	    var hasPushAndReplaceState =
	      !isChromePackagedApp &&
	      _window.history &&
	      history.pushState &&
	      history.replaceState;
	    if (autoBreadcrumbs.location && hasPushAndReplaceState) {
	      // TODO: remove onpopstate handler on uninstall()
	      var oldOnPopState = _window.onpopstate;
	      _window.onpopstate = function() {
	        var currentHref = self._location.href;
	        self._captureUrlChange(self._lastHref, currentHref);
	
	        if (oldOnPopState) {
	          return oldOnPopState.apply(this, arguments);
	        }
	      };
	
	      var historyReplacementFunction = function(origHistFunction) {
	        // note history.pushState.length is 0; intentionally not declaring
	        // params to preserve 0 arity
	        return function(/* state, title, url */) {
	          var url = arguments.length > 2 ? arguments[2] : undefined;
	
	          // url argument is optional
	          if (url) {
	            // coerce to string (this is what pushState does)
	            self._captureUrlChange(self._lastHref, url + '');
	          }
	
	          return origHistFunction.apply(this, arguments);
	        };
	      };
	
	      fill(history, 'pushState', historyReplacementFunction, wrappedBuiltIns);
	      fill(history, 'replaceState', historyReplacementFunction, wrappedBuiltIns);
	    }
	
	    if (autoBreadcrumbs.console && 'console' in _window && console.log) {
	      // console
	      var consoleMethodCallback = function(msg, data) {
	        self.captureBreadcrumb({
	          message: msg,
	          level: data.level,
	          category: 'console'
	        });
	      };
	
	      each(['debug', 'info', 'warn', 'error', 'log'], function(_, level) {
	        wrapConsoleMethod(console, level, consoleMethodCallback);
	      });
	    }
	  },
	
	  _restoreBuiltIns: function() {
	    // restore any wrapped builtins
	    var builtin;
	    while (this._wrappedBuiltIns.length) {
	      builtin = this._wrappedBuiltIns.shift();
	
	      var obj = builtin[0],
	        name = builtin[1],
	        orig = builtin[2];
	
	      obj[name] = orig;
	    }
	  },
	
	  _restoreConsole: function() {
	    // eslint-disable-next-line guard-for-in
	    for (var method in this._originalConsoleMethods) {
	      this._originalConsole[method] = this._originalConsoleMethods[method];
	    }
	  },
	
	  _drainPlugins: function() {
	    var self = this;
	
	    // FIX ME TODO
	    each(this._plugins, function(_, plugin) {
	      var installer = plugin[0];
	      var args = plugin[1];
	      installer.apply(self, [self].concat(args));
	    });
	  },
	
	  _parseDSN: function(str) {
	    var m = dsnPattern.exec(str),
	      dsn = {},
	      i = 7;
	
	    try {
	      while (i--) dsn[dsnKeys[i]] = m[i] || '';
	    } catch (e) {
	      throw new RavenConfigError('Invalid DSN: ' + str);
	    }
	
	    if (dsn.pass && !this._globalOptions.allowSecretKey) {
	      throw new RavenConfigError(
	        'Do not specify your secret key in the DSN. See: http://bit.ly/raven-secret-key'
	      );
	    }
	
	    return dsn;
	  },
	
	  _getGlobalServer: function(uri) {
	    // assemble the endpoint from the uri pieces
	    var globalServer = '//' + uri.host + (uri.port ? ':' + uri.port : '');
	
	    if (uri.protocol) {
	      globalServer = uri.protocol + ':' + globalServer;
	    }
	    return globalServer;
	  },
	
	  _handleOnErrorStackInfo: function() {
	    // if we are intentionally ignoring errors via onerror, bail out
	    if (!this._ignoreOnError) {
	      this._handleStackInfo.apply(this, arguments);
	    }
	  },
	
	  _handleStackInfo: function(stackInfo, options) {
	    var frames = this._prepareFrames(stackInfo, options);
	
	    this._triggerEvent('handle', {
	      stackInfo: stackInfo,
	      options: options
	    });
	
	    this._processException(
	      stackInfo.name,
	      stackInfo.message,
	      stackInfo.url,
	      stackInfo.lineno,
	      frames,
	      options
	    );
	  },
	
	  _prepareFrames: function(stackInfo, options) {
	    var self = this;
	    var frames = [];
	    if (stackInfo.stack && stackInfo.stack.length) {
	      each(stackInfo.stack, function(i, stack) {
	        var frame = self._normalizeFrame(stack, stackInfo.url);
	        if (frame) {
	          frames.push(frame);
	        }
	      });
	
	      // e.g. frames captured via captureMessage throw
	      if (options && options.trimHeadFrames) {
	        for (var j = 0; j < options.trimHeadFrames && j < frames.length; j++) {
	          frames[j].in_app = false;
	        }
	      }
	    }
	    frames = frames.slice(0, this._globalOptions.stackTraceLimit);
	    return frames;
	  },
	
	  _normalizeFrame: function(frame, stackInfoUrl) {
	    // normalize the frames data
	    var normalized = {
	      filename: frame.url,
	      lineno: frame.line,
	      colno: frame.column,
	      function: frame.func || '?'
	    };
	
	    // Case when we don't have any information about the error
	    // E.g. throwing a string or raw object, instead of an `Error` in Firefox
	    // Generating synthetic error doesn't add any value here
	    //
	    // We should probably somehow let a user know that they should fix their code
	    if (!frame.url) {
	      normalized.filename = stackInfoUrl; // fallback to whole stacks url from onerror handler
	    }
	
	    normalized.in_app = !// determine if an exception came from outside of our app
	    // first we check the global includePaths list.
	    (
	      (!!this._globalOptions.includePaths.test &&
	        !this._globalOptions.includePaths.test(normalized.filename)) ||
	      // Now we check for fun, if the function name is Raven or TraceKit
	      /(Raven|TraceKit)\./.test(normalized['function']) ||
	      // finally, we do a last ditch effort and check for raven.min.js
	      /raven\.(min\.)?js$/.test(normalized.filename)
	    );
	
	    return normalized;
	  },
	
	  _processException: function(type, message, fileurl, lineno, frames, options) {
	    var prefixedMessage = (type ? type + ': ' : '') + (message || '');
	    if (
	      !!this._globalOptions.ignoreErrors.test &&
	      (this._globalOptions.ignoreErrors.test(message) ||
	        this._globalOptions.ignoreErrors.test(prefixedMessage))
	    ) {
	      return;
	    }
	
	    var stacktrace;
	
	    if (frames && frames.length) {
	      fileurl = frames[0].filename || fileurl;
	      // Sentry expects frames oldest to newest
	      // and JS sends them as newest to oldest
	      frames.reverse();
	      stacktrace = {frames: frames};
	    } else if (fileurl) {
	      stacktrace = {
	        frames: [
	          {
	            filename: fileurl,
	            lineno: lineno,
	            in_app: true
	          }
	        ]
	      };
	    }
	
	    if (
	      !!this._globalOptions.ignoreUrls.test &&
	      this._globalOptions.ignoreUrls.test(fileurl)
	    ) {
	      return;
	    }
	
	    if (
	      !!this._globalOptions.whitelistUrls.test &&
	      !this._globalOptions.whitelistUrls.test(fileurl)
	    ) {
	      return;
	    }
	
	    var data = objectMerge(
	      {
	        // sentry.interfaces.Exception
	        exception: {
	          values: [
	            {
	              type: type,
	              value: message,
	              stacktrace: stacktrace
	            }
	          ]
	        },
	        culprit: fileurl
	      },
	      options
	    );
	
	    // Fire away!
	    this._send(data);
	  },
	
	  _trimPacket: function(data) {
	    // For now, we only want to truncate the two different messages
	    // but this could/should be expanded to just trim everything
	    var max = this._globalOptions.maxMessageLength;
	    if (data.message) {
	      data.message = truncate(data.message, max);
	    }
	    if (data.exception) {
	      var exception = data.exception.values[0];
	      exception.value = truncate(exception.value, max);
	    }
	
	    var request = data.request;
	    if (request) {
	      if (request.url) {
	        request.url = truncate(request.url, this._globalOptions.maxUrlLength);
	      }
	      if (request.Referer) {
	        request.Referer = truncate(request.Referer, this._globalOptions.maxUrlLength);
	      }
	    }
	
	    if (data.breadcrumbs && data.breadcrumbs.values)
	      this._trimBreadcrumbs(data.breadcrumbs);
	
	    return data;
	  },
	
	  /**
	   * Truncate breadcrumb values (right now just URLs)
	   */
	  _trimBreadcrumbs: function(breadcrumbs) {
	    // known breadcrumb properties with urls
	    // TODO: also consider arbitrary prop values that start with (https?)?://
	    var urlProps = ['to', 'from', 'url'],
	      urlProp,
	      crumb,
	      data;
	
	    for (var i = 0; i < breadcrumbs.values.length; ++i) {
	      crumb = breadcrumbs.values[i];
	      if (
	        !crumb.hasOwnProperty('data') ||
	        !isObject(crumb.data) ||
	        objectFrozen(crumb.data)
	      )
	        continue;
	
	      data = objectMerge({}, crumb.data);
	      for (var j = 0; j < urlProps.length; ++j) {
	        urlProp = urlProps[j];
	        if (data.hasOwnProperty(urlProp) && data[urlProp]) {
	          data[urlProp] = truncate(data[urlProp], this._globalOptions.maxUrlLength);
	        }
	      }
	      breadcrumbs.values[i].data = data;
	    }
	  },
	
	  _getHttpData: function() {
	    if (!this._hasNavigator && !this._hasDocument) return;
	    var httpData = {};
	
	    if (this._hasNavigator && _navigator.userAgent) {
	      httpData.headers = {
	        'User-Agent': navigator.userAgent
	      };
	    }
	
	    // Check in `window` instead of `document`, as we may be in ServiceWorker environment
	    if (_window.location && _window.location.href) {
	      httpData.url = _window.location.href;
	    }
	
	    if (this._hasDocument && _document.referrer) {
	      if (!httpData.headers) httpData.headers = {};
	      httpData.headers.Referer = _document.referrer;
	    }
	
	    return httpData;
	  },
	
	  _resetBackoff: function() {
	    this._backoffDuration = 0;
	    this._backoffStart = null;
	  },
	
	  _shouldBackoff: function() {
	    return this._backoffDuration && now() - this._backoffStart < this._backoffDuration;
	  },
	
	  /**
	   * Returns true if the in-process data payload matches the signature
	   * of the previously-sent data
	   *
	   * NOTE: This has to be done at this level because TraceKit can generate
	   *       data from window.onerror WITHOUT an exception object (IE8, IE9,
	   *       other old browsers). This can take the form of an "exception"
	   *       data object with a single frame (derived from the onerror args).
	   */
	  _isRepeatData: function(current) {
	    var last = this._lastData;
	
	    if (
	      !last ||
	      current.message !== last.message || // defined for captureMessage
	      current.culprit !== last.culprit // defined for captureException/onerror
	    )
	      return false;
	
	    // Stacktrace interface (i.e. from captureMessage)
	    if (current.stacktrace || last.stacktrace) {
	      return isSameStacktrace(current.stacktrace, last.stacktrace);
	    } else if (current.exception || last.exception) {
	      // Exception interface (i.e. from captureException/onerror)
	      return isSameException(current.exception, last.exception);
	    }
	
	    return true;
	  },
	
	  _setBackoffState: function(request) {
	    // If we are already in a backoff state, don't change anything
	    if (this._shouldBackoff()) {
	      return;
	    }
	
	    var status = request.status;
	
	    // 400 - project_id doesn't exist or some other fatal
	    // 401 - invalid/revoked dsn
	    // 429 - too many requests
	    if (!(status === 400 || status === 401 || status === 429)) return;
	
	    var retry;
	    try {
	      // If Retry-After is not in Access-Control-Expose-Headers, most
	      // browsers will throw an exception trying to access it
	      if (supportsFetch()) {
	        retry = request.headers.get('Retry-After');
	      } else {
	        retry = request.getResponseHeader('Retry-After');
	      }
	
	      // Retry-After is returned in seconds
	      retry = parseInt(retry, 10) * 1000;
	    } catch (e) {
	      /* eslint no-empty:0 */
	    }
	
	    this._backoffDuration = retry
	      ? // If Sentry server returned a Retry-After value, use it
	        retry
	      : // Otherwise, double the last backoff duration (starts at 1 sec)
	        this._backoffDuration * 2 || 1000;
	
	    this._backoffStart = now();
	  },
	
	  _send: function(data) {
	    var globalOptions = this._globalOptions;
	
	    var baseData = {
	        project: this._globalProject,
	        logger: globalOptions.logger,
	        platform: 'javascript'
	      },
	      httpData = this._getHttpData();
	
	    if (httpData) {
	      baseData.request = httpData;
	    }
	
	    // HACK: delete `trimHeadFrames` to prevent from appearing in outbound payload
	    if (data.trimHeadFrames) delete data.trimHeadFrames;
	
	    data = objectMerge(baseData, data);
	
	    // Merge in the tags and extra separately since objectMerge doesn't handle a deep merge
	    data.tags = objectMerge(objectMerge({}, this._globalContext.tags), data.tags);
	    data.extra = objectMerge(objectMerge({}, this._globalContext.extra), data.extra);
	
	    // Send along our own collected metadata with extra
	    data.extra['session:duration'] = now() - this._startTime;
	
	    if (this._breadcrumbs && this._breadcrumbs.length > 0) {
	      // intentionally make shallow copy so that additions
	      // to breadcrumbs aren't accidentally sent in this request
	      data.breadcrumbs = {
	        values: [].slice.call(this._breadcrumbs, 0)
	      };
	    }
	
	    if (this._globalContext.user) {
	      // sentry.interfaces.User
	      data.user = this._globalContext.user;
	    }
	
	    // Include the environment if it's defined in globalOptions
	    if (globalOptions.environment) data.environment = globalOptions.environment;
	
	    // Include the release if it's defined in globalOptions
	    if (globalOptions.release) data.release = globalOptions.release;
	
	    // Include server_name if it's defined in globalOptions
	    if (globalOptions.serverName) data.server_name = globalOptions.serverName;
	
	    // Cleanup empty properties before sending them to the server
	    Object.keys(data).forEach(function(key) {
	      if (data[key] == null || data[key] === '' || isEmptyObject(data[key])) {
	        delete data[key];
	      }
	    });
	
	    if (isFunction(globalOptions.dataCallback)) {
	      data = globalOptions.dataCallback(data) || data;
	    }
	
	    // Why??????????
	    if (!data || isEmptyObject(data)) {
	      return;
	    }
	
	    // Check if the request should be filtered or not
	    if (
	      isFunction(globalOptions.shouldSendCallback) &&
	      !globalOptions.shouldSendCallback(data)
	    ) {
	      return;
	    }
	
	    // Backoff state: Sentry server previously responded w/ an error (e.g. 429 - too many requests),
	    // so drop requests until "cool-off" period has elapsed.
	    if (this._shouldBackoff()) {
	      this._logDebug('warn', 'Raven dropped error due to backoff: ', data);
	      return;
	    }
	
	    if (typeof globalOptions.sampleRate === 'number') {
	      if (Math.random() < globalOptions.sampleRate) {
	        this._sendProcessedPayload(data);
	      }
	    } else {
	      this._sendProcessedPayload(data);
	    }
	  },
	
	  _getUuid: function() {
	    return uuid4();
	  },
	
	  _sendProcessedPayload: function(data, callback) {
	    var self = this;
	    var globalOptions = this._globalOptions;
	
	    if (!this.isSetup()) return;
	
	    // Try and clean up the packet before sending by truncating long values
	    data = this._trimPacket(data);
	
	    // ideally duplicate error testing should occur *before* dataCallback/shouldSendCallback,
	    // but this would require copying an un-truncated copy of the data packet, which can be
	    // arbitrarily deep (extra_data) -- could be worthwhile? will revisit
	    if (!this._globalOptions.allowDuplicates && this._isRepeatData(data)) {
	      this._logDebug('warn', 'Raven dropped repeat event: ', data);
	      return;
	    }
	
	    // Send along an event_id if not explicitly passed.
	    // This event_id can be used to reference the error within Sentry itself.
	    // Set lastEventId after we know the error should actually be sent
	    this._lastEventId = data.event_id || (data.event_id = this._getUuid());
	
	    // Store outbound payload after trim
	    this._lastData = data;
	
	    this._logDebug('debug', 'Raven about to send:', data);
	
	    var auth = {
	      sentry_version: '7',
	      sentry_client: 'raven-js/' + this.VERSION,
	      sentry_key: this._globalKey
	    };
	
	    if (this._globalSecret) {
	      auth.sentry_secret = this._globalSecret;
	    }
	
	    var exception = data.exception && data.exception.values[0];
	
	    // only capture 'sentry' breadcrumb is autoBreadcrumbs is truthy
	    if (
	      this._globalOptions.autoBreadcrumbs &&
	      this._globalOptions.autoBreadcrumbs.sentry
	    ) {
	      this.captureBreadcrumb({
	        category: 'sentry',
	        message: exception
	          ? (exception.type ? exception.type + ': ' : '') + exception.value
	          : data.message,
	        event_id: data.event_id,
	        level: data.level || 'error' // presume error unless specified
	      });
	    }
	
	    var url = this._globalEndpoint;
	    (globalOptions.transport || this._makeRequest).call(this, {
	      url: url,
	      auth: auth,
	      data: data,
	      options: globalOptions,
	      onSuccess: function success() {
	        self._resetBackoff();
	
	        self._triggerEvent('success', {
	          data: data,
	          src: url
	        });
	        callback && callback();
	      },
	      onError: function failure(error) {
	        self._logDebug('error', 'Raven transport failed to send: ', error);
	
	        if (error.request) {
	          self._setBackoffState(error.request);
	        }
	
	        self._triggerEvent('failure', {
	          data: data,
	          src: url
	        });
	        error = error || new Error('Raven send failed (no additional details provided)');
	        callback && callback(error);
	      }
	    });
	  },
	
	  _makeRequest: function(opts) {
	    // Auth is intentionally sent as part of query string (NOT as custom HTTP header) to avoid preflight CORS requests
	    var url = opts.url + '?' + urlencode(opts.auth);
	
	    var evaluatedHeaders = null;
	    var evaluatedFetchParameters = {};
	
	    if (opts.options.headers) {
	      evaluatedHeaders = this._evaluateHash(opts.options.headers);
	    }
	
	    if (opts.options.fetchParameters) {
	      evaluatedFetchParameters = this._evaluateHash(opts.options.fetchParameters);
	    }
	
	    if (supportsFetch()) {
	      evaluatedFetchParameters.body = stringify(opts.data);
	
	      var defaultFetchOptions = objectMerge({}, this._fetchDefaults);
	      var fetchOptions = objectMerge(defaultFetchOptions, evaluatedFetchParameters);
	
	      if (evaluatedHeaders) {
	        fetchOptions.headers = evaluatedHeaders;
	      }
	
	      return _window
	        .fetch(url, fetchOptions)
	        .then(function(response) {
	          if (response.ok) {
	            opts.onSuccess && opts.onSuccess();
	          } else {
	            var error = new Error('Sentry error code: ' + response.status);
	            // It's called request only to keep compatibility with XHR interface
	            // and not add more redundant checks in setBackoffState method
	            error.request = response;
	            opts.onError && opts.onError(error);
	          }
	        })
	        ['catch'](function() {
	          opts.onError &&
	            opts.onError(new Error('Sentry error code: network unavailable'));
	        });
	    }
	
	    var request = _window.XMLHttpRequest && new _window.XMLHttpRequest();
	    if (!request) return;
	
	    // if browser doesn't support CORS (e.g. IE7), we are out of luck
	    var hasCORS = 'withCredentials' in request || typeof XDomainRequest !== 'undefined';
	
	    if (!hasCORS) return;
	
	    if ('withCredentials' in request) {
	      request.onreadystatechange = function() {
	        if (request.readyState !== 4) {
	          return;
	        } else if (request.status === 200) {
	          opts.onSuccess && opts.onSuccess();
	        } else if (opts.onError) {
	          var err = new Error('Sentry error code: ' + request.status);
	          err.request = request;
	          opts.onError(err);
	        }
	      };
	    } else {
	      request = new XDomainRequest();
	      // xdomainrequest cannot go http -> https (or vice versa),
	      // so always use protocol relative
	      url = url.replace(/^https?:/, '');
	
	      // onreadystatechange not supported by XDomainRequest
	      if (opts.onSuccess) {
	        request.onload = opts.onSuccess;
	      }
	      if (opts.onError) {
	        request.onerror = function() {
	          var err = new Error('Sentry error code: XDomainRequest');
	          err.request = request;
	          opts.onError(err);
	        };
	      }
	    }
	
	    request.open('POST', url);
	
	    if (evaluatedHeaders) {
	      each(evaluatedHeaders, function(key, value) {
	        request.setRequestHeader(key, value);
	      });
	    }
	
	    request.send(stringify(opts.data));
	  },
	
	  _evaluateHash: function(hash) {
	    var evaluated = {};
	
	    for (var key in hash) {
	      if (hash.hasOwnProperty(key)) {
	        var value = hash[key];
	        evaluated[key] = typeof value === 'function' ? value() : value;
	      }
	    }
	
	    return evaluated;
	  },
	
	  _logDebug: function(level) {
	    if (this._originalConsoleMethods[level] && this.debug) {
	      // In IE<10 console methods do not have their own 'apply' method
	      Function.prototype.apply.call(
	        this._originalConsoleMethods[level],
	        this._originalConsole,
	        [].slice.call(arguments, 1)
	      );
	    }
	  },
	
	  _mergeContext: function(key, context) {
	    if (isUndefined(context)) {
	      delete this._globalContext[key];
	    } else {
	      this._globalContext[key] = objectMerge(this._globalContext[key] || {}, context);
	    }
	  }
	};
	
	// Deprecations
	Raven.prototype.setUser = Raven.prototype.setUserContext;
	Raven.prototype.setReleaseContext = Raven.prototype.setRelease;
	
	module.exports = Raven;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1354 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var utils = __webpack_require__(288);
	
	/*
	 TraceKit - Cross brower stack traces
	
	 This was originally forked from github.com/occ/TraceKit, but has since been
	 largely re-written and is now maintained as part of raven-js.  Tests for
	 this are in test/vendor.
	
	 MIT license
	*/
	
	var TraceKit = {
	  collectWindowErrors: true,
	  debug: false
	};
	
	// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
	var _window =
	  typeof window !== 'undefined'
	    ? window
	    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	// global reference to slice
	var _slice = [].slice;
	var UNKNOWN_FUNCTION = '?';
	
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
	var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;
	
	function getLocationHref() {
	  if (typeof document === 'undefined' || document.location == null) return '';
	
	  return document.location.href;
	}
	
	/**
	 * TraceKit.report: cross-browser processing of unhandled exceptions
	 *
	 * Syntax:
	 *   TraceKit.report.subscribe(function(stackInfo) { ... })
	 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
	 *   TraceKit.report(exception)
	 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
	 *
	 * Supports:
	 *   - Firefox: full stack trace with line numbers, plus column number
	 *              on top frame; column number is not guaranteed
	 *   - Opera:   full stack trace with line and column numbers
	 *   - Chrome:  full stack trace with line and column numbers
	 *   - Safari:  line and column number for the top frame only; some frames
	 *              may be missing, and column number is not guaranteed
	 *   - IE:      line and column number for the top frame only; some frames
	 *              may be missing, and column number is not guaranteed
	 *
	 * In theory, TraceKit should work on all of the following versions:
	 *   - IE5.5+ (only 8.0 tested)
	 *   - Firefox 0.9+ (only 3.5+ tested)
	 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
	 *     Exceptions Have Stacktrace to be enabled in opera:config)
	 *   - Safari 3+ (only 4+ tested)
	 *   - Chrome 1+ (only 5+ tested)
	 *   - Konqueror 3.5+ (untested)
	 *
	 * Requires TraceKit.computeStackTrace.
	 *
	 * Tries to catch all unhandled exceptions and report them to the
	 * subscribed handlers. Please note that TraceKit.report will rethrow the
	 * exception. This is REQUIRED in order to get a useful stack trace in IE.
	 * If the exception does not reach the top of the browser, you will only
	 * get a stack trace from the point where TraceKit.report was called.
	 *
	 * Handlers receive a stackInfo object as described in the
	 * TraceKit.computeStackTrace docs.
	 */
	TraceKit.report = (function reportModuleWrapper() {
	  var handlers = [],
	    lastArgs = null,
	    lastException = null,
	    lastExceptionStack = null;
	
	  /**
	   * Add a crash handler.
	   * @param {Function} handler
	   */
	  function subscribe(handler) {
	    installGlobalHandler();
	    handlers.push(handler);
	  }
	
	  /**
	   * Remove a crash handler.
	   * @param {Function} handler
	   */
	  function unsubscribe(handler) {
	    for (var i = handlers.length - 1; i >= 0; --i) {
	      if (handlers[i] === handler) {
	        handlers.splice(i, 1);
	      }
	    }
	  }
	
	  /**
	   * Remove all crash handlers.
	   */
	  function unsubscribeAll() {
	    uninstallGlobalHandler();
	    handlers = [];
	  }
	
	  /**
	   * Dispatch stack information to all handlers.
	   * @param {Object.<string, *>} stack
	   */
	  function notifyHandlers(stack, isWindowError) {
	    var exception = null;
	    if (isWindowError && !TraceKit.collectWindowErrors) {
	      return;
	    }
	    for (var i in handlers) {
	      if (handlers.hasOwnProperty(i)) {
	        try {
	          handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
	        } catch (inner) {
	          exception = inner;
	        }
	      }
	    }
	
	    if (exception) {
	      throw exception;
	    }
	  }
	
	  var _oldOnerrorHandler, _onErrorHandlerInstalled;
	
	  /**
	   * Ensures all global unhandled exceptions are recorded.
	   * Supported by Gecko and IE.
	   * @param {string} msg Error message.
	   * @param {string} url URL of script that generated the exception.
	   * @param {(number|string)} lineNo The line number at which the error
	   * occurred.
	   * @param {?(number|string)} colNo The column number at which the error
	   * occurred.
	   * @param {?Error} ex The actual Error object.
	   */
	  function traceKitWindowOnError(msg, url, lineNo, colNo, ex) {
	    var stack = null;
	    // If 'ex' is ErrorEvent, get real Error from inside
	    var exception = utils.isErrorEvent(ex) ? ex.error : ex;
	    // If 'msg' is ErrorEvent, get real message from inside
	    var message = utils.isErrorEvent(msg) ? msg.message : msg;
	
	    if (lastExceptionStack) {
	      TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(
	        lastExceptionStack,
	        url,
	        lineNo,
	        message
	      );
	      processLastException();
	    } else if (exception && utils.isError(exception)) {
	      // non-string `exception` arg; attempt to extract stack trace
	
	      // New chrome and blink send along a real error object
	      // Let's just report that like a normal error.
	      // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
	      stack = TraceKit.computeStackTrace(exception);
	      notifyHandlers(stack, true);
	    } else {
	      var location = {
	        url: url,
	        line: lineNo,
	        column: colNo
	      };
	
	      var name = undefined;
	      var groups;
	
	      if ({}.toString.call(message) === '[object String]') {
	        var groups = message.match(ERROR_TYPES_RE);
	        if (groups) {
	          name = groups[1];
	          message = groups[2];
	        }
	      }
	
	      location.func = UNKNOWN_FUNCTION;
	
	      stack = {
	        name: name,
	        message: message,
	        url: getLocationHref(),
	        stack: [location]
	      };
	      notifyHandlers(stack, true);
	    }
	
	    if (_oldOnerrorHandler) {
	      return _oldOnerrorHandler.apply(this, arguments);
	    }
	
	    return false;
	  }
	
	  function installGlobalHandler() {
	    if (_onErrorHandlerInstalled) {
	      return;
	    }
	    _oldOnerrorHandler = _window.onerror;
	    _window.onerror = traceKitWindowOnError;
	    _onErrorHandlerInstalled = true;
	  }
	
	  function uninstallGlobalHandler() {
	    if (!_onErrorHandlerInstalled) {
	      return;
	    }
	    _window.onerror = _oldOnerrorHandler;
	    _onErrorHandlerInstalled = false;
	    _oldOnerrorHandler = undefined;
	  }
	
	  function processLastException() {
	    var _lastExceptionStack = lastExceptionStack,
	      _lastArgs = lastArgs;
	    lastArgs = null;
	    lastExceptionStack = null;
	    lastException = null;
	    notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
	  }
	
	  /**
	   * Reports an unhandled Error to TraceKit.
	   * @param {Error} ex
	   * @param {?boolean} rethrow If false, do not re-throw the exception.
	   * Only used for window.onerror to not cause an infinite loop of
	   * rethrowing.
	   */
	  function report(ex, rethrow) {
	    var args = _slice.call(arguments, 1);
	    if (lastExceptionStack) {
	      if (lastException === ex) {
	        return; // already caught by an inner catch block, ignore
	      } else {
	        processLastException();
	      }
	    }
	
	    var stack = TraceKit.computeStackTrace(ex);
	    lastExceptionStack = stack;
	    lastException = ex;
	    lastArgs = args;
	
	    // If the stack trace is incomplete, wait for 2 seconds for
	    // slow slow IE to see if onerror occurs or not before reporting
	    // this exception; otherwise, we will end up with an incomplete
	    // stack trace
	    setTimeout(function() {
	      if (lastException === ex) {
	        processLastException();
	      }
	    }, stack.incomplete ? 2000 : 0);
	
	    if (rethrow !== false) {
	      throw ex; // re-throw to propagate to the top level (and cause window.onerror)
	    }
	  }
	
	  report.subscribe = subscribe;
	  report.unsubscribe = unsubscribe;
	  report.uninstall = unsubscribeAll;
	  return report;
	})();
	
	/**
	 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
	 *
	 * Syntax:
	 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
	 * Returns:
	 *   s.name              - exception name
	 *   s.message           - exception message
	 *   s.stack[i].url      - JavaScript or HTML file URL
	 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
	 *   s.stack[i].args     - arguments passed to the function, if known
	 *   s.stack[i].line     - line number, if known
	 *   s.stack[i].column   - column number, if known
	 *
	 * Supports:
	 *   - Firefox:  full stack trace with line numbers and unreliable column
	 *               number on top frame
	 *   - Opera 10: full stack trace with line and column numbers
	 *   - Opera 9-: full stack trace with line numbers
	 *   - Chrome:   full stack trace with line and column numbers
	 *   - Safari:   line and column number for the topmost stacktrace element
	 *               only
	 *   - IE:       no line numbers whatsoever
	 *
	 * Tries to guess names of anonymous functions by looking for assignments
	 * in the source code. In IE and Safari, we have to guess source file names
	 * by searching for function bodies inside all page scripts. This will not
	 * work for scripts that are loaded cross-domain.
	 * Here be dragons: some function names may be guessed incorrectly, and
	 * duplicate functions may be mismatched.
	 *
	 * TraceKit.computeStackTrace should only be used for tracing purposes.
	 * Logging of unhandled exceptions should be done with TraceKit.report,
	 * which builds on top of TraceKit.computeStackTrace and provides better
	 * IE support by utilizing the window.onerror event to retrieve information
	 * about the top of the stack.
	 *
	 * Note: In IE and Safari, no stack trace is recorded on the Error object,
	 * so computeStackTrace instead walks its *own* chain of callers.
	 * This means that:
	 *  * in Safari, some methods may be missing from the stack trace;
	 *  * in IE, the topmost function in the stack trace will always be the
	 *    caller of computeStackTrace.
	 *
	 * This is okay for tracing (because you are likely to be calling
	 * computeStackTrace from the function you want to be the topmost element
	 * of the stack trace anyway), but not okay for logging unhandled
	 * exceptions (because your catch block will likely be far away from the
	 * inner function that actually caused the exception).
	 *
	 */
	TraceKit.computeStackTrace = (function computeStackTraceWrapper() {
	  // Contents of Exception in various browsers.
	  //
	  // SAFARI:
	  // ex.message = Can't find variable: qq
	  // ex.line = 59
	  // ex.sourceId = 580238192
	  // ex.sourceURL = http://...
	  // ex.expressionBeginOffset = 96
	  // ex.expressionCaretOffset = 98
	  // ex.expressionEndOffset = 98
	  // ex.name = ReferenceError
	  //
	  // FIREFOX:
	  // ex.message = qq is not defined
	  // ex.fileName = http://...
	  // ex.lineNumber = 59
	  // ex.columnNumber = 69
	  // ex.stack = ...stack trace... (see the example below)
	  // ex.name = ReferenceError
	  //
	  // CHROME:
	  // ex.message = qq is not defined
	  // ex.name = ReferenceError
	  // ex.type = not_defined
	  // ex.arguments = ['aa']
	  // ex.stack = ...stack trace...
	  //
	  // INTERNET EXPLORER:
	  // ex.message = ...
	  // ex.name = ReferenceError
	  //
	  // OPERA:
	  // ex.message = ...message... (see the example below)
	  // ex.name = ReferenceError
	  // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
	  // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'
	
	  /**
	   * Computes stack trace information from the stack property.
	   * Chrome and Gecko use this property.
	   * @param {Error} ex
	   * @return {?Object.<string, *>} Stack trace information.
	   */
	  function computeStackTraceFromStackProp(ex) {
	    if (typeof ex.stack === 'undefined' || !ex.stack) return;
	
	    var chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|[a-z]:|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
	    var winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx(?:-web)|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
	    // NOTE: blob urls are now supposed to always have an origin, therefore it's format
	    // which is `blob:http://url/path/with-some-uuid`, is matched by `blob.*?:\/` as well
	    var gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i;
	    // Used to additionally parse URL/line/column from eval frames
	    var geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
	    var chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
	    var lines = ex.stack.split('\n');
	    var stack = [];
	    var submatch;
	    var parts;
	    var element;
	    var reference = /^(.*) is undefined$/.exec(ex.message);
	
	    for (var i = 0, j = lines.length; i < j; ++i) {
	      if ((parts = chrome.exec(lines[i]))) {
	        var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
	        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
	        if (isEval && (submatch = chromeEval.exec(parts[2]))) {
	          // throw out eval line/column and use top-most line/column number
	          parts[2] = submatch[1]; // url
	          parts[3] = submatch[2]; // line
	          parts[4] = submatch[3]; // column
	        }
	        element = {
	          url: !isNative ? parts[2] : null,
	          func: parts[1] || UNKNOWN_FUNCTION,
	          args: isNative ? [parts[2]] : [],
	          line: parts[3] ? +parts[3] : null,
	          column: parts[4] ? +parts[4] : null
	        };
	      } else if ((parts = winjs.exec(lines[i]))) {
	        element = {
	          url: parts[2],
	          func: parts[1] || UNKNOWN_FUNCTION,
	          args: [],
	          line: +parts[3],
	          column: parts[4] ? +parts[4] : null
	        };
	      } else if ((parts = gecko.exec(lines[i]))) {
	        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
	        if (isEval && (submatch = geckoEval.exec(parts[3]))) {
	          // throw out eval line/column and use top-most line number
	          parts[3] = submatch[1];
	          parts[4] = submatch[2];
	          parts[5] = null; // no column when eval
	        } else if (i === 0 && !parts[5] && typeof ex.columnNumber !== 'undefined') {
	          // FireFox uses this awesome columnNumber property for its top frame
	          // Also note, Firefox's column number is 0-based and everything else expects 1-based,
	          // so adding 1
	          // NOTE: this hack doesn't work if top-most frame is eval
	          stack[0].column = ex.columnNumber + 1;
	        }
	        element = {
	          url: parts[3],
	          func: parts[1] || UNKNOWN_FUNCTION,
	          args: parts[2] ? parts[2].split(',') : [],
	          line: parts[4] ? +parts[4] : null,
	          column: parts[5] ? +parts[5] : null
	        };
	      } else {
	        continue;
	      }
	
	      if (!element.func && element.line) {
	        element.func = UNKNOWN_FUNCTION;
	      }
	
	      stack.push(element);
	    }
	
	    if (!stack.length) {
	      return null;
	    }
	
	    return {
	      name: ex.name,
	      message: ex.message,
	      url: getLocationHref(),
	      stack: stack
	    };
	  }
	
	  /**
	   * Adds information about the first frame to incomplete stack traces.
	   * Safari and IE require this to get complete data on the first frame.
	   * @param {Object.<string, *>} stackInfo Stack trace information from
	   * one of the compute* methods.
	   * @param {string} url The URL of the script that caused an error.
	   * @param {(number|string)} lineNo The line number of the script that
	   * caused an error.
	   * @param {string=} message The error generated by the browser, which
	   * hopefully contains the name of the object that caused the error.
	   * @return {boolean} Whether or not the stack information was
	   * augmented.
	   */
	  function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
	    var initial = {
	      url: url,
	      line: lineNo
	    };
	
	    if (initial.url && initial.line) {
	      stackInfo.incomplete = false;
	
	      if (!initial.func) {
	        initial.func = UNKNOWN_FUNCTION;
	      }
	
	      if (stackInfo.stack.length > 0) {
	        if (stackInfo.stack[0].url === initial.url) {
	          if (stackInfo.stack[0].line === initial.line) {
	            return false; // already in stack trace
	          } else if (
	            !stackInfo.stack[0].line &&
	            stackInfo.stack[0].func === initial.func
	          ) {
	            stackInfo.stack[0].line = initial.line;
	            return false;
	          }
	        }
	      }
	
	      stackInfo.stack.unshift(initial);
	      stackInfo.partial = true;
	      return true;
	    } else {
	      stackInfo.incomplete = true;
	    }
	
	    return false;
	  }
	
	  /**
	   * Computes stack trace information by walking the arguments.caller
	   * chain at the time the exception occurred. This will cause earlier
	   * frames to be missed but is the only way to get any stack trace in
	   * Safari and IE. The top frame is restored by
	   * {@link augmentStackTraceWithInitialElement}.
	   * @param {Error} ex
	   * @return {?Object.<string, *>} Stack trace information.
	   */
	  function computeStackTraceByWalkingCallerChain(ex, depth) {
	    var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
	      stack = [],
	      funcs = {},
	      recursion = false,
	      parts,
	      item,
	      source;
	
	    for (
	      var curr = computeStackTraceByWalkingCallerChain.caller;
	      curr && !recursion;
	      curr = curr.caller
	    ) {
	      if (curr === computeStackTrace || curr === TraceKit.report) {
	        // console.log('skipping internal function');
	        continue;
	      }
	
	      item = {
	        url: null,
	        func: UNKNOWN_FUNCTION,
	        line: null,
	        column: null
	      };
	
	      if (curr.name) {
	        item.func = curr.name;
	      } else if ((parts = functionName.exec(curr.toString()))) {
	        item.func = parts[1];
	      }
	
	      if (typeof item.func === 'undefined') {
	        try {
	          item.func = parts.input.substring(0, parts.input.indexOf('{'));
	        } catch (e) {}
	      }
	
	      if (funcs['' + curr]) {
	        recursion = true;
	      } else {
	        funcs['' + curr] = true;
	      }
	
	      stack.push(item);
	    }
	
	    if (depth) {
	      // console.log('depth is ' + depth);
	      // console.log('stack is ' + stack.length);
	      stack.splice(0, depth);
	    }
	
	    var result = {
	      name: ex.name,
	      message: ex.message,
	      url: getLocationHref(),
	      stack: stack
	    };
	    augmentStackTraceWithInitialElement(
	      result,
	      ex.sourceURL || ex.fileName,
	      ex.line || ex.lineNumber,
	      ex.message || ex.description
	    );
	    return result;
	  }
	
	  /**
	   * Computes a stack trace for an exception.
	   * @param {Error} ex
	   * @param {(string|number)=} depth
	   */
	  function computeStackTrace(ex, depth) {
	    var stack = null;
	    depth = depth == null ? 0 : +depth;
	
	    try {
	      stack = computeStackTraceFromStackProp(ex);
	      if (stack) {
	        return stack;
	      }
	    } catch (e) {
	      if (TraceKit.debug) {
	        throw e;
	      }
	    }
	
	    try {
	      stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
	      if (stack) {
	        return stack;
	      }
	    } catch (e) {
	      if (TraceKit.debug) {
	        throw e;
	      }
	    }
	    return {
	      name: ex.name,
	      message: ex.message,
	      url: getLocationHref()
	    };
	  }
	
	  computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
	  computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;
	
	  return computeStackTrace;
	})();
	
	module.exports = TraceKit;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1355 */
/***/ function(module, exports) {

	/*
	 * JavaScript MD5
	 * https://github.com/blueimp/JavaScript-MD5
	 *
	 * Copyright 2011, Sebastian Tschan
	 * https://blueimp.net
	 *
	 * Licensed under the MIT license:
	 * https://opensource.org/licenses/MIT
	 *
	 * Based on
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */
	
	/*
	* Add integers, wrapping at 2^32. This uses 16-bit operations internally
	* to work around bugs in some JS interpreters.
	*/
	function safeAdd(x, y) {
	  var lsw = (x & 0xffff) + (y & 0xffff);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return (msw << 16) | (lsw & 0xffff);
	}
	
	/*
	* Bitwise rotate a 32-bit number to the left.
	*/
	function bitRotateLeft(num, cnt) {
	  return (num << cnt) | (num >>> (32 - cnt));
	}
	
	/*
	* These functions implement the four basic operations the algorithm uses.
	*/
	function md5cmn(q, a, b, x, s, t) {
	  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
	}
	function md5ff(a, b, c, d, x, s, t) {
	  return md5cmn((b & c) | (~b & d), a, b, x, s, t);
	}
	function md5gg(a, b, c, d, x, s, t) {
	  return md5cmn((b & d) | (c & ~d), a, b, x, s, t);
	}
	function md5hh(a, b, c, d, x, s, t) {
	  return md5cmn(b ^ c ^ d, a, b, x, s, t);
	}
	function md5ii(a, b, c, d, x, s, t) {
	  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
	}
	
	/*
	* Calculate the MD5 of an array of little-endian words, and a bit length.
	*/
	function binlMD5(x, len) {
	  /* append padding */
	  x[len >> 5] |= 0x80 << (len % 32);
	  x[(((len + 64) >>> 9) << 4) + 14] = len;
	
	  var i;
	  var olda;
	  var oldb;
	  var oldc;
	  var oldd;
	  var a = 1732584193;
	  var b = -271733879;
	  var c = -1732584194;
	  var d = 271733878;
	
	  for (i = 0; i < x.length; i += 16) {
	    olda = a;
	    oldb = b;
	    oldc = c;
	    oldd = d;
	
	    a = md5ff(a, b, c, d, x[i], 7, -680876936);
	    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
	    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
	    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
	    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
	    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
	    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
	    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
	    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
	    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
	    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
	    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
	    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
	    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
	    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
	    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
	
	    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
	    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
	    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
	    b = md5gg(b, c, d, a, x[i], 20, -373897302);
	    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
	    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
	    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
	    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
	    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
	    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
	    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
	    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
	    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
	    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
	    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
	    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
	
	    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
	    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
	    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
	    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
	    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
	    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
	    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
	    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
	    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
	    d = md5hh(d, a, b, c, x[i], 11, -358537222);
	    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
	    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
	    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
	    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
	    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
	    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
	
	    a = md5ii(a, b, c, d, x[i], 6, -198630844);
	    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
	    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
	    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
	    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
	    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
	    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
	    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
	    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
	    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
	    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
	    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
	    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
	    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
	    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
	    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
	
	    a = safeAdd(a, olda);
	    b = safeAdd(b, oldb);
	    c = safeAdd(c, oldc);
	    d = safeAdd(d, oldd);
	  }
	  return [a, b, c, d];
	}
	
	/*
	* Convert an array of little-endian words to a string
	*/
	function binl2rstr(input) {
	  var i;
	  var output = '';
	  var length32 = input.length * 32;
	  for (i = 0; i < length32; i += 8) {
	    output += String.fromCharCode((input[i >> 5] >>> (i % 32)) & 0xff);
	  }
	  return output;
	}
	
	/*
	* Convert a raw string to an array of little-endian words
	* Characters >255 have their high-byte silently ignored.
	*/
	function rstr2binl(input) {
	  var i;
	  var output = [];
	  output[(input.length >> 2) - 1] = undefined;
	  for (i = 0; i < output.length; i += 1) {
	    output[i] = 0;
	  }
	  var length8 = input.length * 8;
	  for (i = 0; i < length8; i += 8) {
	    output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << (i % 32);
	  }
	  return output;
	}
	
	/*
	* Calculate the MD5 of a raw string
	*/
	function rstrMD5(s) {
	  return binl2rstr(binlMD5(rstr2binl(s), s.length * 8));
	}
	
	/*
	* Calculate the HMAC-MD5, of a key and some data (raw strings)
	*/
	function rstrHMACMD5(key, data) {
	  var i;
	  var bkey = rstr2binl(key);
	  var ipad = [];
	  var opad = [];
	  var hash;
	  ipad[15] = opad[15] = undefined;
	  if (bkey.length > 16) {
	    bkey = binlMD5(bkey, key.length * 8);
	  }
	  for (i = 0; i < 16; i += 1) {
	    ipad[i] = bkey[i] ^ 0x36363636;
	    opad[i] = bkey[i] ^ 0x5c5c5c5c;
	  }
	  hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
	  return binl2rstr(binlMD5(opad.concat(hash), 512 + 128));
	}
	
	/*
	* Convert a raw string to a hex string
	*/
	function rstr2hex(input) {
	  var hexTab = '0123456789abcdef';
	  var output = '';
	  var x;
	  var i;
	  for (i = 0; i < input.length; i += 1) {
	    x = input.charCodeAt(i);
	    output += hexTab.charAt((x >>> 4) & 0x0f) + hexTab.charAt(x & 0x0f);
	  }
	  return output;
	}
	
	/*
	* Encode a string as utf-8
	*/
	function str2rstrUTF8(input) {
	  return unescape(encodeURIComponent(input));
	}
	
	/*
	* Take string arguments and return either raw or hex encoded strings
	*/
	function rawMD5(s) {
	  return rstrMD5(str2rstrUTF8(s));
	}
	function hexMD5(s) {
	  return rstr2hex(rawMD5(s));
	}
	function rawHMACMD5(k, d) {
	  return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d));
	}
	function hexHMACMD5(k, d) {
	  return rstr2hex(rawHMACMD5(k, d));
	}
	
	function md5(string, key, raw) {
	  if (!key) {
	    if (!raw) {
	      return hexMD5(string);
	    }
	    return rawMD5(string);
	  }
	  if (!raw) {
	    return hexHMACMD5(key, string);
	  }
	  return rawHMACMD5(key, string);
	}
	
	module.exports = md5;


/***/ },
/* 1356 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	
	var REACT_ELEMENT_TYPE =
	  (typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element')) ||
	  0xeac7;
	
	var emptyFunction = __webpack_require__(55);
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(21);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	var didWarnAboutMaps = false;
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	function getIteratorFn(maybeIterable) {
	  var iteratorFn =
	    maybeIterable &&
	    ((ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL]) ||
	      maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function(match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	function traverseAllChildrenImpl(
	  children,
	  nameSoFar,
	  callback,
	  traverseContext
	) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (
	    children === null ||
	    type === 'string' ||
	    type === 'number' ||
	    // The following is inlined from ReactElement. This means we can optimize
	    // some checks. React Fiber also inlines this logic for similar purposes.
	    (type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE)
	  ) {
	    callback(
	      traverseContext,
	      children,
	      // If it's the only child, treat the name as if it was wrapped in an array
	      // so that it's consistent if the number of children grows.
	      nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar
	    );
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(
	        child,
	        nextName,
	        callback,
	        traverseContext
	      );
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      if (false) {
	        // Warn about using Maps as children
	        if (iteratorFn === children.entries) {
	          warning(
	            didWarnAboutMaps,
	            'Using Maps as children is unsupported and will likely yield ' +
	              'unexpected results. Convert it to a sequence/iterable of keyed ' +
	              'ReactElements instead.'
	          );
	          didWarnAboutMaps = true;
	        }
	      }
	
	      var iterator = iteratorFn.call(children);
	      var step;
	      var ii = 0;
	      while (!(step = iterator.next()).done) {
	        child = step.value;
	        nextName = nextNamePrefix + getComponentKey(child, ii++);
	        subtreeCount += traverseAllChildrenImpl(
	          child,
	          nextName,
	          callback,
	          traverseContext
	        );
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum =
	          ' If you meant to render a collection of children, use an array ' +
	          'instead or wrap the object using createFragment(object) from the ' +
	          'React add-ons.';
	      }
	      var childrenString = '' + children;
	      invariant(
	        false,
	        'Objects are not valid as a React child (found: %s).%s',
	        childrenString === '[object Object]'
	          ? 'object with keys {' + Object.keys(children).join(', ') + '}'
	          : childrenString,
	        addendum
	      );
	    }
	  }
	
	  return subtreeCount;
	}
	
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	function cloneAndReplaceKey(oldElement, newKey) {
	  return React.cloneElement(
	    oldElement,
	    {key: newKey},
	    oldElement.props !== undefined ? oldElement.props.children : undefined
	  );
	}
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	var oneArgumentPooler = function(copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var addPoolingTo = function addPoolingTo(CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var standardReleaser = function standardReleaser(instance) {
	  var Klass = this;
	  invariant(
	    instance instanceof Klass,
	    'Trying to release an instance into a pool of a different type.'
	  );
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var fourArgumentPooler = function fourArgumentPooler(a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function() {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result;
	  var keyPrefix = bookKeeping.keyPrefix;
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(
	      mappedChild,
	      result,
	      childKey,
	      emptyFunction.thatReturnsArgument
	    );
	  } else if (mappedChild != null) {
	    if (React.isValidElement(mappedChild)) {
	      mappedChild = cloneAndReplaceKey(
	        mappedChild,
	        // Keep both the (mapped) and old keys if they differ, just as
	        // traverseAllChildren used to do for objects as children
	        keyPrefix +
	          (mappedChild.key && (!child || child.key !== mappedChild.key)
	            ? escapeUserProvidedKey(mappedChild.key) + '/'
	            : '') +
	          childKey
	      );
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(
	    array,
	    escapedPrefix,
	    func,
	    context
	  );
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	var numericPropertyRegex = /^\d+$/;
	
	var warnedAboutNumeric = false;
	
	function createReactFragment(object) {
	  if (typeof object !== 'object' || !object || Array.isArray(object)) {
	    warning(
	      false,
	      'React.addons.createFragment only accepts a single object. Got: %s',
	      object
	    );
	    return object;
	  }
	  if (React.isValidElement(object)) {
	    warning(
	      false,
	      'React.addons.createFragment does not accept a ReactElement ' +
	        'without a wrapper object.'
	    );
	    return object;
	  }
	
	  invariant(
	    object.nodeType !== 1,
	    'React.addons.createFragment(...): Encountered an invalid child; DOM ' +
	      'elements are not valid children of React components.'
	  );
	
	  var result = [];
	
	  for (var key in object) {
	    if (false) {
	      if (!warnedAboutNumeric && numericPropertyRegex.test(key)) {
	        warning(
	          false,
	          'React.addons.createFragment(...): Child objects should have ' +
	            'non-numeric keys so ordering is preserved.'
	        );
	        warnedAboutNumeric = true;
	      }
	    }
	    mapIntoWithKeyPrefixInternal(
	      object[key],
	      result,
	      key,
	      emptyFunction.thatReturnsArgument
	    );
	  }
	
	  return result;
	}
	
	module.exports = createReactFragment;


/***/ },
/* 1357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(1367);
	
	var _arrays = __webpack_require__(1540);
	
	var _arrays2 = _interopRequireDefault(_arrays);
	
	var _redux = __webpack_require__(585);
	
	var _reactAutowhatever = __webpack_require__(1374);
	
	var _reactAutowhatever2 = _interopRequireDefault(_reactAutowhatever);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    isFocused: state.isFocused,
	    isCollapsed: state.isCollapsed,
	    focusedSectionIndex: state.focusedSectionIndex,
	    focusedSuggestionIndex: state.focusedSuggestionIndex,
	    valueBeforeUpDown: state.valueBeforeUpDown
	  };
	};
	
	var Autosuggest = function (_Component) {
	  _inherits(Autosuggest, _Component);
	
	  function Autosuggest() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Autosuggest);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Autosuggest.__proto__ || Object.getPrototypeOf(Autosuggest)).call.apply(_ref, [this].concat(args))), _this), _this.onDocumentMouseDown = function (event) {
	      _this.justClickedOnSuggestionsContainer = false;
	
	      var node = event.detail && event.detail.target || // This is for testing only. Please show me a better way to emulate this.
	      event.target;
	
	      do {
	        if (node.getAttribute('data-suggestion-index') !== null) {
	          // Suggestion was clicked
	          return;
	        }
	
	        if (node === _this.suggestionsContainer) {
	          // Something else inside suggestions container was clicked
	          _this.justClickedOnSuggestionsContainer = true;
	          return;
	        }
	
	        node = node.parentNode;
	      } while (node !== null && node !== document);
	    }, _this.storeReferences = function (autowhatever) {
	      if (autowhatever !== null) {
	        var input = autowhatever.input;
	
	
	        _this.input = input;
	        _this.props.inputRef(input);
	
	        _this.suggestionsContainer = autowhatever.itemsContainer;
	      }
	    }, _this.onSuggestionMouseEnter = function (event, _ref2) {
	      var sectionIndex = _ref2.sectionIndex,
	          itemIndex = _ref2.itemIndex;
	
	      _this.props.updateFocusedSuggestion(sectionIndex, itemIndex);
	    }, _this.focusFirstSuggestion = function () {
	      _this.props.updateFocusedSuggestion(_this.props.multiSection ? 0 : null, 0);
	    }, _this.onSuggestionMouseDown = function () {
	      _this.justSelectedSuggestion = true;
	    }, _this.onSuggestionsClearRequested = function () {
	      var onSuggestionsClearRequested = _this.props.onSuggestionsClearRequested;
	
	
	      onSuggestionsClearRequested && onSuggestionsClearRequested();
	    }, _this.onSuggestionSelected = function (event, data) {
	      var _this$props = _this.props,
	          alwaysRenderSuggestions = _this$props.alwaysRenderSuggestions,
	          onSuggestionSelected = _this$props.onSuggestionSelected,
	          onSuggestionsFetchRequested = _this$props.onSuggestionsFetchRequested,
	          resetFocusedSuggestion = _this$props.resetFocusedSuggestion;
	
	
	      onSuggestionSelected && onSuggestionSelected(event, data);
	
	      if (alwaysRenderSuggestions) {
	        onSuggestionsFetchRequested({ value: data.suggestionValue });
	      } else {
	        _this.onSuggestionsClearRequested();
	      }
	
	      resetFocusedSuggestion();
	    }, _this.onSuggestionClick = function (event) {
	      var _this$props2 = _this.props,
	          alwaysRenderSuggestions = _this$props2.alwaysRenderSuggestions,
	          focusInputOnSuggestionClick = _this$props2.focusInputOnSuggestionClick,
	          closeSuggestions = _this$props2.closeSuggestions;
	
	      var _this$getSuggestionIn = _this.getSuggestionIndices(_this.findSuggestionElement(event.target)),
	          sectionIndex = _this$getSuggestionIn.sectionIndex,
	          suggestionIndex = _this$getSuggestionIn.suggestionIndex;
	
	      var clickedSuggestion = _this.getSuggestion(sectionIndex, suggestionIndex);
	      var clickedSuggestionValue = _this.props.getSuggestionValue(clickedSuggestion);
	
	      _this.maybeCallOnChange(event, clickedSuggestionValue, 'click');
	      _this.onSuggestionSelected(event, {
	        suggestion: clickedSuggestion,
	        suggestionValue: clickedSuggestionValue,
	        suggestionIndex: suggestionIndex,
	        sectionIndex: sectionIndex,
	        method: 'click'
	      });
	
	      if (!alwaysRenderSuggestions) {
	        closeSuggestions();
	      }
	
	      if (focusInputOnSuggestionClick === true) {
	        _this.input.focus();
	      } else {
	        _this.onBlur();
	      }
	
	      setTimeout(function () {
	        _this.justSelectedSuggestion = false;
	      });
	    }, _this.onBlur = function () {
	      var _this$props3 = _this.props,
	          inputProps = _this$props3.inputProps,
	          shouldRenderSuggestions = _this$props3.shouldRenderSuggestions,
	          inputBlurred = _this$props3.inputBlurred;
	      var value = inputProps.value,
	          onBlur = inputProps.onBlur;
	
	      var focusedSuggestion = _this.getFocusedSuggestion();
	
	      inputBlurred(shouldRenderSuggestions(value));
	      onBlur && onBlur(_this.blurEvent, { focusedSuggestion: focusedSuggestion });
	    }, _this.resetFocusedSuggestionOnMouseLeave = function () {
	      _this.props.resetFocusedSuggestion(false);
	    }, _this.itemProps = function (_ref3) {
	      var sectionIndex = _ref3.sectionIndex,
	          itemIndex = _ref3.itemIndex;
	
	      return {
	        'data-section-index': sectionIndex,
	        'data-suggestion-index': itemIndex,
	        onMouseEnter: _this.onSuggestionMouseEnter,
	        onMouseLeave: _this.resetFocusedSuggestionOnMouseLeave,
	        onMouseDown: _this.onSuggestionMouseDown,
	        onTouchStart: _this.onSuggestionMouseDown, // Because on iOS `onMouseDown` is not triggered
	        onClick: _this.onSuggestionClick
	      };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Autosuggest, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('mousedown', this.onDocumentMouseDown);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if ((0, _arrays2.default)(nextProps.suggestions, this.props.suggestions)) {
	        if (nextProps.focusFirstSuggestion && nextProps.suggestions.length > 0 && nextProps.focusedSuggestionIndex === null && nextProps.inputProps.value !== this.props.inputProps.value && nextProps.valueBeforeUpDown === this.props.valueBeforeUpDown) {
	          this.focusFirstSuggestion();
	        }
	      } else {
	        if (this.willRenderSuggestions(nextProps)) {
	          if (nextProps.focusFirstSuggestion) {
	            this.focusFirstSuggestion();
	          }
	
	          var isCollapsed = nextProps.isCollapsed,
	              revealSuggestions = nextProps.revealSuggestions;
	
	
	          if (isCollapsed && !this.justSelectedSuggestion) {
	            revealSuggestions();
	          }
	        } else {
	          nextProps.resetFocusedSuggestion();
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('mousedown', this.onDocumentMouseDown);
	    }
	  }, {
	    key: 'getSuggestion',
	    value: function getSuggestion(sectionIndex, suggestionIndex) {
	      var _props = this.props,
	          suggestions = _props.suggestions,
	          multiSection = _props.multiSection,
	          getSectionSuggestions = _props.getSectionSuggestions;
	
	
	      if (multiSection) {
	        return getSectionSuggestions(suggestions[sectionIndex])[suggestionIndex];
	      }
	
	      return suggestions[suggestionIndex];
	    }
	  }, {
	    key: 'getFocusedSuggestion',
	    value: function getFocusedSuggestion() {
	      var _props2 = this.props,
	          focusedSectionIndex = _props2.focusedSectionIndex,
	          focusedSuggestionIndex = _props2.focusedSuggestionIndex;
	
	
	      if (focusedSuggestionIndex === null) {
	        return null;
	      }
	
	      return this.getSuggestion(focusedSectionIndex, focusedSuggestionIndex);
	    }
	  }, {
	    key: 'getSuggestionValueByIndex',
	    value: function getSuggestionValueByIndex(sectionIndex, suggestionIndex) {
	      var getSuggestionValue = this.props.getSuggestionValue;
	
	
	      return getSuggestionValue(this.getSuggestion(sectionIndex, suggestionIndex));
	    }
	  }, {
	    key: 'getSuggestionIndices',
	    value: function getSuggestionIndices(suggestionElement) {
	      var sectionIndex = suggestionElement.getAttribute('data-section-index');
	      var suggestionIndex = suggestionElement.getAttribute('data-suggestion-index');
	
	      return {
	        sectionIndex: typeof sectionIndex === 'string' ? parseInt(sectionIndex, 10) : null,
	        suggestionIndex: parseInt(suggestionIndex, 10)
	      };
	    }
	  }, {
	    key: 'findSuggestionElement',
	    value: function findSuggestionElement(startNode) {
	      var node = startNode;
	
	      do {
	        if (node.getAttribute('data-suggestion-index') !== null) {
	          return node;
	        }
	
	        node = node.parentNode;
	      } while (node !== null);
	
	      console.error('Clicked element:', startNode); // eslint-disable-line no-console
	      throw new Error('Couldn\'t find suggestion element');
	    }
	  }, {
	    key: 'maybeCallOnChange',
	    value: function maybeCallOnChange(event, newValue, method) {
	      var _props$inputProps = this.props.inputProps,
	          value = _props$inputProps.value,
	          onChange = _props$inputProps.onChange;
	
	
	      if (newValue !== value) {
	        onChange(event, { newValue: newValue, method: method });
	      }
	    }
	  }, {
	    key: 'willRenderSuggestions',
	    value: function willRenderSuggestions(props) {
	      var suggestions = props.suggestions,
	          inputProps = props.inputProps,
	          shouldRenderSuggestions = props.shouldRenderSuggestions;
	      var value = inputProps.value;
	
	
	      return suggestions.length > 0 && shouldRenderSuggestions(value);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          suggestions = _props3.suggestions,
	          renderInputComponent = _props3.renderInputComponent,
	          renderSuggestionsContainer = _props3.renderSuggestionsContainer,
	          onSuggestionsFetchRequested = _props3.onSuggestionsFetchRequested,
	          renderSuggestion = _props3.renderSuggestion,
	          inputProps = _props3.inputProps,
	          shouldRenderSuggestions = _props3.shouldRenderSuggestions,
	          multiSection = _props3.multiSection,
	          renderSectionTitle = _props3.renderSectionTitle,
	          id = _props3.id,
	          getSectionSuggestions = _props3.getSectionSuggestions,
	          theme = _props3.theme,
	          isFocused = _props3.isFocused,
	          isCollapsed = _props3.isCollapsed,
	          focusedSectionIndex = _props3.focusedSectionIndex,
	          focusedSuggestionIndex = _props3.focusedSuggestionIndex,
	          valueBeforeUpDown = _props3.valueBeforeUpDown,
	          inputFocused = _props3.inputFocused,
	          inputChanged = _props3.inputChanged,
	          updateFocusedSuggestion = _props3.updateFocusedSuggestion,
	          resetFocusedSuggestion = _props3.resetFocusedSuggestion,
	          revealSuggestions = _props3.revealSuggestions,
	          closeSuggestions = _props3.closeSuggestions,
	          getSuggestionValue = _props3.getSuggestionValue,
	          alwaysRenderSuggestions = _props3.alwaysRenderSuggestions;
	      var value = inputProps.value,
	          _onFocus = inputProps.onFocus,
	          _onKeyDown = inputProps.onKeyDown;
	
	      var willRenderSuggestions = this.willRenderSuggestions(this.props);
	      var isOpen = alwaysRenderSuggestions || isFocused && !isCollapsed && willRenderSuggestions;
	      var items = isOpen ? suggestions : [];
	      var autowhateverInputProps = _extends({}, inputProps, {
	        onFocus: function onFocus(event) {
	          if (!_this2.justSelectedSuggestion && !_this2.justClickedOnSuggestionsContainer) {
	            inputFocused(shouldRenderSuggestions(value));
	            _onFocus && _onFocus(event);
	
	            if (shouldRenderSuggestions(value)) {
	              onSuggestionsFetchRequested({ value: value });
	            }
	          }
	        },
	        onBlur: function onBlur(event) {
	          if (_this2.justClickedOnSuggestionsContainer) {
	            _this2.input.focus();
	            return;
	          }
	
	          _this2.blurEvent = event;
	
	          if (!_this2.justSelectedSuggestion) {
	            _this2.onBlur();
	            _this2.onSuggestionsClearRequested();
	          }
	        },
	        onChange: function onChange(event) {
	          var value = event.target.value;
	
	          var shouldRender = shouldRenderSuggestions(value);
	
	          _this2.maybeCallOnChange(event, value, 'type');
	          inputChanged(shouldRender);
	
	          if (shouldRender) {
	            onSuggestionsFetchRequested({ value: value });
	          } else {
	            _this2.onSuggestionsClearRequested();
	          }
	        },
	        onKeyDown: function onKeyDown(event, data) {
	          switch (event.key) {
	            case 'ArrowDown':
	            case 'ArrowUp':
	              if (isCollapsed) {
	                if (shouldRenderSuggestions(value)) {
	                  onSuggestionsFetchRequested({ value: value });
	                  revealSuggestions();
	                }
	              } else if (suggestions.length > 0) {
	                var newFocusedSectionIndex = data.newFocusedSectionIndex,
	                    newFocusedItemIndex = data.newFocusedItemIndex;
	
	
	                var newValue = void 0;
	
	                if (newFocusedItemIndex === null) {
	                  // valueBeforeUpDown can be null if, for example, user
	                  // hovers on the first suggestion and then pressed Up.
	                  // If that happens, use the original input value.
	                  newValue = valueBeforeUpDown === null ? value : valueBeforeUpDown;
	                } else {
	                  newValue = _this2.getSuggestionValueByIndex(newFocusedSectionIndex, newFocusedItemIndex);
	                }
	
	                updateFocusedSuggestion(newFocusedSectionIndex, newFocusedItemIndex, value);
	                _this2.maybeCallOnChange(event, newValue, event.key === 'ArrowDown' ? 'down' : 'up');
	              }
	
	              event.preventDefault(); // Prevents the cursor from moving
	
	              break;
	
	            case 'Enter':
	              {
	                var focusedSuggestion = _this2.getFocusedSuggestion();
	
	                if (isOpen && !alwaysRenderSuggestions) {
	                  closeSuggestions();
	                }
	
	                if (focusedSuggestion !== null) {
	                  var _newValue = getSuggestionValue(focusedSuggestion);
	
	                  _this2.maybeCallOnChange(event, _newValue, 'enter');
	
	                  _this2.onSuggestionSelected(event, {
	                    suggestion: focusedSuggestion,
	                    suggestionValue: _newValue,
	                    suggestionIndex: focusedSuggestionIndex,
	                    sectionIndex: focusedSectionIndex,
	                    method: 'enter'
	                  });
	
	                  _this2.justSelectedSuggestion = true;
	
	                  setTimeout(function () {
	                    _this2.justSelectedSuggestion = false;
	                  });
	                }
	
	                break;
	              }
	
	            case 'Escape':
	              {
	                if (isOpen) {
	                  // If input.type === 'search', the browser clears the input
	                  // when Escape is pressed. We want to disable this default
	                  // behaviour so that, when suggestions are shown, we just hide
	                  // them, without clearing the input.
	                  event.preventDefault();
	                }
	
	                var willCloseSuggestions = isOpen && !alwaysRenderSuggestions;
	
	                if (valueBeforeUpDown === null) {
	                  // Didn't interact with Up/Down
	                  if (!willCloseSuggestions) {
	                    var _newValue2 = '';
	
	                    _this2.maybeCallOnChange(event, _newValue2, 'escape');
	
	                    if (shouldRenderSuggestions(_newValue2)) {
	                      onSuggestionsFetchRequested({ value: _newValue2 });
	                    } else {
	                      _this2.onSuggestionsClearRequested();
	                    }
	                  }
	                } else {
	                  // Interacted with Up/Down
	                  _this2.maybeCallOnChange(event, valueBeforeUpDown, 'escape');
	                }
	
	                if (willCloseSuggestions) {
	                  _this2.onSuggestionsClearRequested();
	                  closeSuggestions();
	                } else {
	                  resetFocusedSuggestion();
	                }
	
	                break;
	              }
	          }
	
	          _onKeyDown && _onKeyDown(event);
	        }
	      });
	      var renderSuggestionData = {
	        query: (valueBeforeUpDown || value).trim()
	      };
	
	      return _react2.default.createElement(_reactAutowhatever2.default, {
	        multiSection: multiSection,
	        items: items,
	        renderInputComponent: renderInputComponent,
	        renderItemsContainer: renderSuggestionsContainer,
	        renderItem: renderSuggestion,
	        renderItemData: renderSuggestionData,
	        renderSectionTitle: renderSectionTitle,
	        getSectionItems: getSectionSuggestions,
	        focusedSectionIndex: focusedSectionIndex,
	        focusedItemIndex: focusedSuggestionIndex,
	        inputProps: autowhateverInputProps,
	        itemProps: this.itemProps,
	        theme: theme,
	        id: id,
	        ref: this.storeReferences
	      });
	    }
	  }]);
	
	  return Autosuggest;
	}(_react.Component);
	
	Autosuggest.propTypes = {
	  suggestions: _react.PropTypes.array.isRequired,
	  onSuggestionsFetchRequested: _react.PropTypes.func.isRequired,
	  onSuggestionsClearRequested: _react.PropTypes.func,
	  onSuggestionSelected: _react.PropTypes.func,
	  renderInputComponent: _react.PropTypes.func,
	  renderSuggestionsContainer: _react.PropTypes.func,
	  getSuggestionValue: _react.PropTypes.func.isRequired,
	  renderSuggestion: _react.PropTypes.func.isRequired,
	  inputProps: _react.PropTypes.object.isRequired,
	  shouldRenderSuggestions: _react.PropTypes.func.isRequired,
	  alwaysRenderSuggestions: _react.PropTypes.bool.isRequired,
	  multiSection: _react.PropTypes.bool.isRequired,
	  renderSectionTitle: _react.PropTypes.func,
	  getSectionSuggestions: _react.PropTypes.func,
	  focusInputOnSuggestionClick: _react.PropTypes.bool.isRequired,
	  focusFirstSuggestion: _react.PropTypes.bool.isRequired,
	  theme: _react.PropTypes.object.isRequired,
	  id: _react.PropTypes.string.isRequired,
	  inputRef: _react.PropTypes.func.isRequired,
	
	  isFocused: _react.PropTypes.bool.isRequired,
	  isCollapsed: _react.PropTypes.bool.isRequired,
	  focusedSectionIndex: _react.PropTypes.number,
	  focusedSuggestionIndex: _react.PropTypes.number,
	  valueBeforeUpDown: _react.PropTypes.string,
	
	  inputFocused: _react.PropTypes.func.isRequired,
	  inputBlurred: _react.PropTypes.func.isRequired,
	  inputChanged: _react.PropTypes.func.isRequired,
	  updateFocusedSuggestion: _react.PropTypes.func.isRequired,
	  resetFocusedSuggestion: _react.PropTypes.func.isRequired,
	  revealSuggestions: _react.PropTypes.func.isRequired,
	  closeSuggestions: _react.PropTypes.func.isRequired
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, _redux.actionCreators)(Autosuggest);

/***/ },
/* 1358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(142);
	
	var _redux2 = __webpack_require__(585);
	
	var _redux3 = _interopRequireDefault(_redux2);
	
	var _Autosuggest = __webpack_require__(1357);
	
	var _Autosuggest2 = _interopRequireDefault(_Autosuggest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var alwaysTrue = function alwaysTrue() {
	  return true;
	};
	var defaultShouldRenderSuggestions = function defaultShouldRenderSuggestions(value) {
	  return value.trim().length > 0;
	};
	var defaultTheme = {
	  container: 'react-autosuggest__container',
	  containerOpen: 'react-autosuggest__container--open',
	  input: 'react-autosuggest__input',
	  suggestionsContainer: 'react-autosuggest__suggestions-container',
	  suggestionsList: 'react-autosuggest__suggestions-list',
	  suggestion: 'react-autosuggest__suggestion',
	  suggestionFocused: 'react-autosuggest__suggestion--focused',
	  sectionContainer: 'react-autosuggest__section-container',
	  sectionTitle: 'react-autosuggest__section-title'
	};
	
	var mapToAutowhateverTheme = function mapToAutowhateverTheme(theme) {
	  var result = {};
	
	  for (var key in theme) {
	    switch (key) {
	      case 'suggestionsContainer':
	        result['itemsContainer'] = theme[key];
	        break;
	
	      case 'suggestion':
	        result['item'] = theme[key];
	        break;
	
	      case 'suggestionFocused':
	        result['itemFocused'] = theme[key];
	        break;
	
	      case 'suggestionsList':
	        result['itemsList'] = theme[key];
	        break;
	
	      default:
	        result[key] = theme[key];
	    }
	  }
	
	  return result;
	};
	
	var AutosuggestContainer = function (_Component) {
	  _inherits(AutosuggestContainer, _Component);
	
	  function AutosuggestContainer(_ref) {
	    var alwaysRenderSuggestions = _ref.alwaysRenderSuggestions;
	
	    _classCallCheck(this, AutosuggestContainer);
	
	    var _this = _possibleConstructorReturn(this, (AutosuggestContainer.__proto__ || Object.getPrototypeOf(AutosuggestContainer)).call(this));
	
	    _this.storeInputReference = function (input) {
	      _this.input = input;
	    };
	
	    var initialState = {
	      isFocused: false,
	      isCollapsed: !alwaysRenderSuggestions,
	      focusedSectionIndex: null,
	      focusedSuggestionIndex: null,
	      valueBeforeUpDown: null
	    };
	
	    _this.store = (0, _redux.createStore)(_redux3.default, initialState);
	    return _this;
	  }
	
	  _createClass(AutosuggestContainer, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          suggestions = _props.suggestions,
	          onSuggestionsFetchRequested = _props.onSuggestionsFetchRequested,
	          onSuggestionsClearRequested = _props.onSuggestionsClearRequested,
	          multiSection = _props.multiSection,
	          shouldRenderSuggestions = _props.shouldRenderSuggestions,
	          renderInputComponent = _props.renderInputComponent,
	          renderSuggestionsContainer = _props.renderSuggestionsContainer,
	          getSuggestionValue = _props.getSuggestionValue,
	          renderSuggestion = _props.renderSuggestion,
	          renderSectionTitle = _props.renderSectionTitle,
	          getSectionSuggestions = _props.getSectionSuggestions,
	          inputProps = _props.inputProps,
	          onSuggestionSelected = _props.onSuggestionSelected,
	          focusInputOnSuggestionClick = _props.focusInputOnSuggestionClick,
	          focusFirstSuggestion = _props.focusFirstSuggestion,
	          alwaysRenderSuggestions = _props.alwaysRenderSuggestions,
	          theme = _props.theme,
	          id = _props.id;
	
	
	      return _react2.default.createElement(_Autosuggest2.default, {
	        suggestions: suggestions,
	        onSuggestionsFetchRequested: onSuggestionsFetchRequested,
	        onSuggestionsClearRequested: onSuggestionsClearRequested,
	        multiSection: multiSection,
	        shouldRenderSuggestions: alwaysRenderSuggestions ? alwaysTrue : shouldRenderSuggestions,
	        alwaysRenderSuggestions: alwaysRenderSuggestions,
	        renderInputComponent: renderInputComponent,
	        renderSuggestionsContainer: renderSuggestionsContainer,
	        getSuggestionValue: getSuggestionValue,
	        renderSuggestion: renderSuggestion,
	        renderSectionTitle: renderSectionTitle,
	        getSectionSuggestions: getSectionSuggestions,
	        inputProps: inputProps,
	        onSuggestionSelected: onSuggestionSelected,
	        focusInputOnSuggestionClick: focusInputOnSuggestionClick,
	        focusFirstSuggestion: focusFirstSuggestion,
	        theme: mapToAutowhateverTheme(theme),
	        id: id,
	        inputRef: this.storeInputReference,
	        store: this.store
	      });
	    }
	  }]);
	
	  return AutosuggestContainer;
	}(_react.Component);
	
	AutosuggestContainer.propTypes = {
	  suggestions: _react.PropTypes.array.isRequired,
	  onSuggestionsFetchRequested: function onSuggestionsFetchRequested(props, propName) {
	    var onSuggestionsFetchRequested = props[propName];
	
	    if (typeof onSuggestionsFetchRequested !== 'function') {
	      throw new Error('\'onSuggestionsFetchRequested\' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsFetchRequestedProp');
	    }
	  },
	  onSuggestionsClearRequested: function onSuggestionsClearRequested(props, propName) {
	    var onSuggestionsClearRequested = props[propName];
	
	    if (props.alwaysRenderSuggestions === false && typeof onSuggestionsClearRequested !== 'function') {
	      throw new Error('\'onSuggestionsClearRequested\' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsClearRequestedProp');
	    }
	  },
	  onSuggestionSelected: _react.PropTypes.func,
	  renderInputComponent: _react.PropTypes.func,
	  renderSuggestionsContainer: _react.PropTypes.func,
	  getSuggestionValue: _react.PropTypes.func.isRequired,
	  renderSuggestion: _react.PropTypes.func.isRequired,
	  inputProps: function inputProps(props, propName) {
	    var inputProps = props[propName];
	
	    if (!inputProps.hasOwnProperty('value')) {
	      throw new Error('\'inputProps\' must have \'value\'.');
	    }
	
	    if (!inputProps.hasOwnProperty('onChange')) {
	      throw new Error('\'inputProps\' must have \'onChange\'.');
	    }
	  },
	  shouldRenderSuggestions: _react.PropTypes.func,
	  alwaysRenderSuggestions: _react.PropTypes.bool,
	  multiSection: _react.PropTypes.bool,
	  renderSectionTitle: function renderSectionTitle(props, propName) {
	    var renderSectionTitle = props[propName];
	
	    if (props.multiSection === true && typeof renderSectionTitle !== 'function') {
	      throw new Error('\'renderSectionTitle\' must be implemented. See: https://github.com/moroshko/react-autosuggest#renderSectionTitleProp');
	    }
	  },
	  getSectionSuggestions: function getSectionSuggestions(props, propName) {
	    var getSectionSuggestions = props[propName];
	
	    if (props.multiSection === true && typeof getSectionSuggestions !== 'function') {
	      throw new Error('\'getSectionSuggestions\' must be implemented. See: https://github.com/moroshko/react-autosuggest#getSectionSuggestionsProp');
	    }
	  },
	  focusInputOnSuggestionClick: _react.PropTypes.bool,
	  focusFirstSuggestion: _react.PropTypes.bool,
	  theme: _react.PropTypes.object,
	  id: _react.PropTypes.string
	};
	AutosuggestContainer.defaultProps = {
	  shouldRenderSuggestions: defaultShouldRenderSuggestions,
	  alwaysRenderSuggestions: false,
	  multiSection: false,
	  focusInputOnSuggestionClick: true,
	  focusFirstSuggestion: false,
	  theme: defaultTheme,
	  id: '1'
	};
	exports.default = AutosuggestContainer;

/***/ },
/* 1359 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ },
/* 1360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createProvider = createProvider;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PropTypes = __webpack_require__(588);
	
	var _warning = __webpack_require__(289);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	function createProvider() {
	  var _Provider$childContex;
	
	  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
	  var subKey = arguments[1];
	
	  var subscriptionKey = subKey || storeKey + 'Subscription';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
	    };
	
	    function Provider(props, context) {
	      _classCallCheck(this, Provider);
	
	      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	      _this[storeKey] = props.store;
	      return _this;
	    }
	
	    Provider.prototype.render = function render() {
	      return _react.Children.only(this.props.children);
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  if (false) {
	    Provider.prototype.componentWillReceiveProps = function (nextProps) {
	      if (this[storeKey] !== nextProps.store) {
	        warnAboutReceivingStore();
	      }
	    };
	  }
	
	  Provider.propTypes = {
	    store: _PropTypes.storeShape.isRequired,
	    children: _propTypes2.default.element.isRequired
	  };
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);
	
	  return Provider;
	}
	
	exports.default = createProvider();

/***/ },
/* 1361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createConnect = createConnect;
	
	var _connectAdvanced = __webpack_require__(586);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _shallowEqual = __webpack_require__(1369);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _mapDispatchToProps = __webpack_require__(1362);
	
	var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);
	
	var _mapStateToProps = __webpack_require__(1363);
	
	var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);
	
	var _mergeProps = __webpack_require__(1364);
	
	var _mergeProps2 = _interopRequireDefault(_mergeProps);
	
	var _selectorFactory = __webpack_require__(1365);
	
	var _selectorFactory2 = _interopRequireDefault(_selectorFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	}
	
	// createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	function createConnect() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === undefined ? _connectAdvanced2.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? _mapStateToProps2.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? _mapDispatchToProps2.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === undefined ? _mergeProps2.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === undefined ? _selectorFactory2.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
	        _ref2$pure = _ref2.pure,
	        pure = _ref2$pure === undefined ? true : _ref2$pure,
	        _ref2$areStatesEqual = _ref2.areStatesEqual,
	        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
	        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
	        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? _shallowEqual2.default : _ref2$areOwnPropsEqua,
	        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
	        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? _shallowEqual2.default : _ref2$areStatePropsEq,
	        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
	        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? _shallowEqual2.default : _ref2$areMergedPropsE,
	        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);
	
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	
	    return connectHOC(selectorFactory, _extends({
	      // used in error messages
	      methodName: 'connect',
	
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return 'Connect(' + name + ')';
	      },
	
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	
	    }, extraOptions));
	  };
	}
	
	exports.default = createConnect();

/***/ },
/* 1362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	
	var _redux = __webpack_require__(142);
	
	var _wrapMapToProps = __webpack_require__(587);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return { dispatch: dispatch };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	exports.default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

/***/ },
/* 1363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	
	var _wrapMapToProps = __webpack_require__(587);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	exports.default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

/***/ },
/* 1364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	
	var _verifyPlainObject = __webpack_require__(589);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return _extends({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	
	    var hasRunOnce = false;
	    var mergedProps = void 0;
	
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	
	        if (false) (0, _verifyPlainObject2.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	exports.default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

/***/ },
/* 1365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _verifySubselectors = __webpack_require__(1366);
	
	var _verifySubselectors2 = _interopRequireDefault(_verifySubselectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	
	  var hasRunAtLeastOnce = false;
	  var state = void 0;
	  var ownProps = void 0;
	  var stateProps = void 0;
	  var dispatchProps = void 0;
	  var mergedProps = void 0;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	}
	
	// TODO: Add more comments
	
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);
	
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors2.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ },
/* 1366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = __webpack_require__(289);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning2.default)('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ },
/* 1367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.connectAdvanced = exports.createProvider = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(1360);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connectAdvanced = __webpack_require__(586);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _connect = __webpack_require__(1361);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Provider = _Provider2.default;
	exports.createProvider = _Provider.createProvider;
	exports.connectAdvanced = _connectAdvanced2.default;
	exports.connect = _connect2.default;

/***/ },
/* 1368 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    get: function get() {
	      return next;
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription = function () {
	  function Subscription(store, parentSub, onStateChange) {
	    _classCallCheck(this, Subscription);
	
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  Subscription.prototype.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  Subscription.prototype.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ },
/* 1369 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 1370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sectionIterator = __webpack_require__(1539);
	
	var _sectionIterator2 = _interopRequireDefault(_sectionIterator);
	
	var _reactThemeable = __webpack_require__(1520);
	
	var _reactThemeable2 = _interopRequireDefault(_reactThemeable);
	
	var _SectionTitle = __webpack_require__(1373);
	
	var _SectionTitle2 = _interopRequireDefault(_SectionTitle);
	
	var _ItemsList = __webpack_require__(1372);
	
	var _ItemsList2 = _interopRequireDefault(_ItemsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var alwaysTrue = function alwaysTrue() {
	  return true;
	};
	var emptyObject = {};
	var defaultRenderInputComponent = function defaultRenderInputComponent(props) {
	  return _react2.default.createElement('input', props);
	};
	var defaultRenderItemsContainer = function defaultRenderItemsContainer(props) {
	  return _react2.default.createElement('div', props);
	};
	var defaultTheme = {
	  container: 'react-autowhatever__container',
	  containerOpen: 'react-autowhatever__container--open',
	  input: 'react-autowhatever__input',
	  itemsContainer: 'react-autowhatever__items-container',
	  itemsList: 'react-autowhatever__items-list',
	  item: 'react-autowhatever__item',
	  itemFocused: 'react-autowhatever__item--focused',
	  sectionContainer: 'react-autowhatever__section-container',
	  sectionTitle: 'react-autowhatever__section-title'
	};
	
	var Autowhatever = function (_Component) {
	  _inherits(Autowhatever, _Component);
	
	  function Autowhatever(props) {
	    _classCallCheck(this, Autowhatever);
	
	    var _this = _possibleConstructorReturn(this, (Autowhatever.__proto__ || Object.getPrototypeOf(Autowhatever)).call(this, props));
	
	    _this.focusedItem = null;
	
	    _this.setSectionsItems(props);
	    _this.setSectionIterator(props);
	    _this.setTheme(props);
	
	    _this.onKeyDown = _this.onKeyDown.bind(_this);
	    _this.storeInputReference = _this.storeInputReference.bind(_this);
	    _this.storeItemsContainerReference = _this.storeItemsContainerReference.bind(_this);
	    _this.onFocusedItemChange = _this.onFocusedItemChange.bind(_this);
	    _this.getItemId = _this.getItemId.bind(_this);
	    return _this;
	  }
	
	  _createClass(Autowhatever, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.ensureFocusedItemIsVisible();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.items !== this.props.items) {
	        this.setSectionsItems(nextProps);
	      }
	
	      if (nextProps.items !== this.props.items || nextProps.multiSection !== this.props.multiSection) {
	        this.setSectionIterator(nextProps);
	      }
	
	      if (nextProps.theme !== this.props.theme) {
	        this.setTheme(nextProps);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.ensureFocusedItemIsVisible();
	    }
	  }, {
	    key: 'setSectionsItems',
	    value: function setSectionsItems(props) {
	      if (props.multiSection) {
	        this.sectionsItems = props.items.map(function (section) {
	          return props.getSectionItems(section);
	        });
	        this.sectionsLengths = this.sectionsItems.map(function (items) {
	          return items.length;
	        });
	        this.allSectionsAreEmpty = this.sectionsLengths.every(function (itemsCount) {
	          return itemsCount === 0;
	        });
	      }
	    }
	  }, {
	    key: 'setSectionIterator',
	    value: function setSectionIterator(props) {
	      this.sectionIterator = (0, _sectionIterator2.default)({
	        multiSection: props.multiSection,
	        data: props.multiSection ? this.sectionsLengths : props.items.length
	      });
	    }
	  }, {
	    key: 'setTheme',
	    value: function setTheme(props) {
	      this.theme = (0, _reactThemeable2.default)(props.theme);
	    }
	  }, {
	    key: 'storeInputReference',
	    value: function storeInputReference(input) {
	      if (input !== null) {
	        this.input = input;
	      }
	    }
	  }, {
	    key: 'storeItemsContainerReference',
	    value: function storeItemsContainerReference(itemsContainer) {
	      if (itemsContainer !== null) {
	        this.itemsContainer = itemsContainer;
	      }
	    }
	  }, {
	    key: 'onFocusedItemChange',
	    value: function onFocusedItemChange(focusedItem) {
	      this.focusedItem = focusedItem;
	    }
	  }, {
	    key: 'getItemId',
	    value: function getItemId(sectionIndex, itemIndex) {
	      if (itemIndex === null) {
	        return null;
	      }
	
	      var id = this.props.id;
	
	      var section = sectionIndex === null ? '' : 'section-' + sectionIndex;
	
	      return 'react-autowhatever-' + id + '-' + section + '-item-' + itemIndex;
	    }
	  }, {
	    key: 'renderSections',
	    value: function renderSections() {
	      var _this2 = this;
	
	      if (this.allSectionsAreEmpty) {
	        return null;
	      }
	
	      var theme = this.theme;
	      var _props = this.props;
	      var id = _props.id;
	      var items = _props.items;
	      var renderItem = _props.renderItem;
	      var renderItemData = _props.renderItemData;
	      var shouldRenderSection = _props.shouldRenderSection;
	      var renderSectionTitle = _props.renderSectionTitle;
	      var focusedSectionIndex = _props.focusedSectionIndex;
	      var focusedItemIndex = _props.focusedItemIndex;
	      var itemProps = _props.itemProps;
	
	
	      return items.map(function (section, sectionIndex) {
	        if (!shouldRenderSection(section)) {
	          return null;
	        }
	
	        var keyPrefix = 'react-autowhatever-' + id + '-';
	        var sectionKeyPrefix = keyPrefix + 'section-' + sectionIndex + '-';
	
	        // `key` is provided by theme()
	        /* eslint-disable react/jsx-key */
	        return _react2.default.createElement(
	          'div',
	          theme(sectionKeyPrefix + 'container', 'sectionContainer'),
	          _react2.default.createElement(_SectionTitle2.default, {
	            section: section,
	            renderSectionTitle: renderSectionTitle,
	            theme: theme,
	            sectionKeyPrefix: sectionKeyPrefix
	          }),
	          _react2.default.createElement(_ItemsList2.default, {
	            items: _this2.sectionsItems[sectionIndex],
	            itemProps: itemProps,
	            renderItem: renderItem,
	            renderItemData: renderItemData,
	            sectionIndex: sectionIndex,
	            focusedItemIndex: focusedSectionIndex === sectionIndex ? focusedItemIndex : null,
	            onFocusedItemChange: _this2.onFocusedItemChange,
	            getItemId: _this2.getItemId,
	            theme: theme,
	            keyPrefix: keyPrefix,
	            ref: _this2.storeItemsListReference
	          })
	        );
	        /* eslint-enable react/jsx-key */
	      });
	    }
	  }, {
	    key: 'renderItems',
	    value: function renderItems() {
	      var items = this.props.items;
	
	
	      if (items.length === 0) {
	        return null;
	      }
	
	      var theme = this.theme;
	      var _props2 = this.props;
	      var id = _props2.id;
	      var renderItem = _props2.renderItem;
	      var renderItemData = _props2.renderItemData;
	      var focusedSectionIndex = _props2.focusedSectionIndex;
	      var focusedItemIndex = _props2.focusedItemIndex;
	      var itemProps = _props2.itemProps;
	
	
	      return _react2.default.createElement(_ItemsList2.default, {
	        items: items,
	        itemProps: itemProps,
	        renderItem: renderItem,
	        renderItemData: renderItemData,
	        focusedItemIndex: focusedSectionIndex === null ? focusedItemIndex : null,
	        onFocusedItemChange: this.onFocusedItemChange,
	        getItemId: this.getItemId,
	        theme: theme,
	        keyPrefix: 'react-autowhatever-' + id + '-'
	      });
	    }
	  }, {
	    key: 'onKeyDown',
	    value: function onKeyDown(event) {
	      var _props3 = this.props;
	      var inputProps = _props3.inputProps;
	      var focusedSectionIndex = _props3.focusedSectionIndex;
	      var focusedItemIndex = _props3.focusedItemIndex;
	
	
	      switch (event.key) {
	        case 'ArrowDown':
	        case 'ArrowUp':
	          {
	            var nextPrev = event.key === 'ArrowDown' ? 'next' : 'prev';
	
	            var _sectionIterator$next = this.sectionIterator[nextPrev]([focusedSectionIndex, focusedItemIndex]);
	
	            var _sectionIterator$next2 = _slicedToArray(_sectionIterator$next, 2);
	
	            var newFocusedSectionIndex = _sectionIterator$next2[0];
	            var newFocusedItemIndex = _sectionIterator$next2[1];
	
	
	            inputProps.onKeyDown(event, { newFocusedSectionIndex: newFocusedSectionIndex, newFocusedItemIndex: newFocusedItemIndex });
	            break;
	          }
	
	        default:
	          inputProps.onKeyDown(event, { focusedSectionIndex: focusedSectionIndex, focusedItemIndex: focusedItemIndex });
	      }
	    }
	  }, {
	    key: 'ensureFocusedItemIsVisible',
	    value: function ensureFocusedItemIsVisible() {
	      var focusedItem = this.focusedItem;
	
	
	      if (!focusedItem) {
	        return;
	      }
	
	      var itemsContainer = this.itemsContainer;
	
	      var itemOffsetRelativeToContainer = focusedItem.offsetParent === itemsContainer ? focusedItem.offsetTop : focusedItem.offsetTop - itemsContainer.offsetTop;
	
	      var scrollTop = itemsContainer.scrollTop; // Top of the visible area
	
	      if (itemOffsetRelativeToContainer < scrollTop) {
	        // Item is off the top of the visible area
	        scrollTop = itemOffsetRelativeToContainer;
	      } else if (itemOffsetRelativeToContainer + focusedItem.offsetHeight > scrollTop + itemsContainer.offsetHeight) {
	        // Item is off the bottom of the visible area
	        scrollTop = itemOffsetRelativeToContainer + focusedItem.offsetHeight - itemsContainer.offsetHeight;
	      }
	
	      if (scrollTop !== itemsContainer.scrollTop) {
	        itemsContainer.scrollTop = scrollTop;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var theme = this.theme;
	      var _props4 = this.props;
	      var id = _props4.id;
	      var multiSection = _props4.multiSection;
	      var renderInputComponent = _props4.renderInputComponent;
	      var renderItemsContainer = _props4.renderItemsContainer;
	      var focusedSectionIndex = _props4.focusedSectionIndex;
	      var focusedItemIndex = _props4.focusedItemIndex;
	
	      var renderedItems = multiSection ? this.renderSections() : this.renderItems();
	      var isOpen = renderedItems !== null;
	      var ariaActivedescendant = this.getItemId(focusedSectionIndex, focusedItemIndex);
	      var containerProps = theme('react-autowhatever-' + id + '-container', 'container', isOpen && 'containerOpen');
	      var itemsContainerId = 'react-autowhatever-' + id;
	      var inputComponent = renderInputComponent(_extends({
	        type: 'text',
	        value: '',
	        autoComplete: 'off',
	        role: 'combobox',
	        'aria-autocomplete': 'list',
	        'aria-owns': itemsContainerId,
	        'aria-expanded': isOpen,
	        'aria-haspopup': isOpen,
	        'aria-activedescendant': ariaActivedescendant
	      }, theme('react-autowhatever-' + id + '-input', 'input'), this.props.inputProps, {
	        onKeyDown: this.props.inputProps.onKeyDown && this.onKeyDown,
	        ref: this.storeInputReference
	      }));
	      var itemsContainer = renderItemsContainer(_extends({
	        id: itemsContainerId
	      }, theme('react-autowhatever-' + id + '-items-container', 'itemsContainer'), {
	        ref: this.storeItemsContainerReference,
	        children: renderedItems
	      }));
	
	      return _react2.default.createElement(
	        'div',
	        containerProps,
	        inputComponent,
	        itemsContainer
	      );
	    }
	  }]);
	
	  return Autowhatever;
	}(_react.Component);
	
	Autowhatever.propTypes = {
	  id: _react.PropTypes.string, // Used in aria-* attributes. If multiple Autowhatever's are rendered on a page, they must have unique ids.
	  multiSection: _react.PropTypes.bool, // Indicates whether a multi section layout should be rendered.
	  renderInputComponent: _react.PropTypes.func, // Renders the input component.
	  items: _react.PropTypes.array.isRequired, // Array of items or sections to render.
	  renderItemsContainer: _react.PropTypes.func, // Renders the items container.
	  renderItem: _react.PropTypes.func, // This function renders a single item.
	  renderItemData: _react.PropTypes.object, // Arbitrary data that will be passed to renderItem()
	  shouldRenderSection: _react.PropTypes.func, // This function gets a section and returns whether it should be rendered, or not.
	  renderSectionTitle: _react.PropTypes.func, // This function gets a section and renders its title.
	  getSectionItems: _react.PropTypes.func, // This function gets a section and returns its items, which will be passed into `renderItem` for rendering.
	  inputComponent: _react.PropTypes.func, // When specified, it is used to render the input element
	  inputProps: _react.PropTypes.object, // Arbitrary input props
	  itemProps: _react.PropTypes.oneOfType([// Arbitrary item props
	  _react.PropTypes.object, _react.PropTypes.func]),
	  focusedSectionIndex: _react.PropTypes.number, // Section index of the focused item
	  focusedItemIndex: _react.PropTypes.number, // Focused item index (within a section)
	  theme: _react.PropTypes.oneOfType([// Styles. See: https://github.com/markdalgleish/react-themeable
	  _react.PropTypes.object, _react.PropTypes.array])
	};
	Autowhatever.defaultProps = {
	  id: '1',
	  multiSection: false,
	  renderInputComponent: defaultRenderInputComponent,
	  renderItemsContainer: defaultRenderItemsContainer,
	  shouldRenderSection: alwaysTrue,
	  renderItem: function renderItem() {
	    throw new Error('`renderItem` must be provided');
	  },
	  renderItemData: emptyObject,
	  renderSectionTitle: function renderSectionTitle() {
	    throw new Error('`renderSectionTitle` must be provided');
	  },
	  getSectionItems: function getSectionItems() {
	    throw new Error('`getSectionItems` must be provided');
	  },
	  inputProps: emptyObject,
	  itemProps: emptyObject,
	  focusedSectionIndex: null,
	  focusedItemIndex: null,
	  theme: defaultTheme
	};
	exports.default = Autowhatever;

/***/ },
/* 1371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _compareObjects = __webpack_require__(290);
	
	var _compareObjects2 = _interopRequireDefault(_compareObjects);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Item = function (_Component) {
	  _inherits(Item, _Component);
	
	  function Item() {
	    _classCallCheck(this, Item);
	
	    var _this = _possibleConstructorReturn(this, (Item.__proto__ || Object.getPrototypeOf(Item)).call(this));
	
	    _this.storeItemReference = _this.storeItemReference.bind(_this);
	    _this.onMouseEnter = _this.onMouseEnter.bind(_this);
	    _this.onMouseLeave = _this.onMouseLeave.bind(_this);
	    _this.onMouseDown = _this.onMouseDown.bind(_this);
	    _this.onClick = _this.onClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Item, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return (0, _compareObjects2.default)(nextProps, this.props, ['renderItemData']);
	    }
	  }, {
	    key: 'storeItemReference',
	    value: function storeItemReference(item) {
	      if (item !== null) {
	        this.item = item;
	      }
	    }
	  }, {
	    key: 'onMouseEnter',
	    value: function onMouseEnter(event) {
	      var _props = this.props;
	      var sectionIndex = _props.sectionIndex;
	      var itemIndex = _props.itemIndex;
	
	
	      this.props.onMouseEnter(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
	    }
	  }, {
	    key: 'onMouseLeave',
	    value: function onMouseLeave(event) {
	      var _props2 = this.props;
	      var sectionIndex = _props2.sectionIndex;
	      var itemIndex = _props2.itemIndex;
	
	
	      this.props.onMouseLeave(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
	    }
	  }, {
	    key: 'onMouseDown',
	    value: function onMouseDown(event) {
	      var _props3 = this.props;
	      var sectionIndex = _props3.sectionIndex;
	      var itemIndex = _props3.itemIndex;
	
	
	      this.props.onMouseDown(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick(event) {
	      var _props4 = this.props;
	      var sectionIndex = _props4.sectionIndex;
	      var itemIndex = _props4.itemIndex;
	
	
	      this.props.onClick(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props;
	      var item = _props5.item;
	      var renderItem = _props5.renderItem;
	      var renderItemData = _props5.renderItemData;
	
	      var restProps = _objectWithoutProperties(_props5, ['item', 'renderItem', 'renderItemData']);
	
	      delete restProps.sectionIndex;
	      delete restProps.itemIndex;
	
	      if (typeof restProps.onMouseEnter === 'function') {
	        restProps.onMouseEnter = this.onMouseEnter;
	      }
	
	      if (typeof restProps.onMouseLeave === 'function') {
	        restProps.onMouseLeave = this.onMouseLeave;
	      }
	
	      if (typeof restProps.onMouseDown === 'function') {
	        restProps.onMouseDown = this.onMouseDown;
	      }
	
	      if (typeof restProps.onClick === 'function') {
	        restProps.onClick = this.onClick;
	      }
	
	      return _react2.default.createElement(
	        'li',
	        _extends({ role: 'option' }, restProps, { ref: this.storeItemReference }),
	        renderItem(item, renderItemData)
	      );
	    }
	  }]);
	
	  return Item;
	}(_react.Component);
	
	Item.propTypes = {
	  sectionIndex: _react.PropTypes.number,
	  itemIndex: _react.PropTypes.number.isRequired,
	  item: _react.PropTypes.any.isRequired,
	  renderItem: _react.PropTypes.func.isRequired,
	  renderItemData: _react.PropTypes.object.isRequired,
	  onMouseEnter: _react.PropTypes.func,
	  onMouseLeave: _react.PropTypes.func,
	  onMouseDown: _react.PropTypes.func,
	  onClick: _react.PropTypes.func
	};
	exports.default = Item;

/***/ },
/* 1372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Item = __webpack_require__(1371);
	
	var _Item2 = _interopRequireDefault(_Item);
	
	var _compareObjects = __webpack_require__(290);
	
	var _compareObjects2 = _interopRequireDefault(_compareObjects);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ItemsList = function (_Component) {
	  _inherits(ItemsList, _Component);
	
	  function ItemsList() {
	    _classCallCheck(this, ItemsList);
	
	    var _this = _possibleConstructorReturn(this, (ItemsList.__proto__ || Object.getPrototypeOf(ItemsList)).call(this));
	
	    _this.storeFocusedItemReference = _this.storeFocusedItemReference.bind(_this);
	    return _this;
	  }
	
	  _createClass(ItemsList, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return (0, _compareObjects2.default)(nextProps, this.props, ['itemProps']);
	    }
	  }, {
	    key: 'storeFocusedItemReference',
	    value: function storeFocusedItemReference(focusedItem) {
	      this.props.onFocusedItemChange(focusedItem === null ? null : focusedItem.item);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var items = _props.items;
	      var itemProps = _props.itemProps;
	      var renderItem = _props.renderItem;
	      var renderItemData = _props.renderItemData;
	      var sectionIndex = _props.sectionIndex;
	      var focusedItemIndex = _props.focusedItemIndex;
	      var getItemId = _props.getItemId;
	      var theme = _props.theme;
	      var keyPrefix = _props.keyPrefix;
	
	      var sectionPrefix = sectionIndex === null ? keyPrefix : keyPrefix + 'section-' + sectionIndex + '-';
	      var isItemPropsFunction = typeof itemProps === 'function';
	
	      return _react2.default.createElement(
	        'ul',
	        _extends({ role: 'listbox' }, theme(sectionPrefix + 'items-list', 'itemsList')),
	        items.map(function (item, itemIndex) {
	          var isFocused = itemIndex === focusedItemIndex;
	          var itemKey = sectionPrefix + 'item-' + itemIndex;
	          var itemPropsObj = isItemPropsFunction ? itemProps({ sectionIndex: sectionIndex, itemIndex: itemIndex }) : itemProps;
	          var allItemProps = _extends({
	            id: getItemId(sectionIndex, itemIndex)
	          }, theme(itemKey, 'item', isFocused && 'itemFocused'), itemPropsObj);
	
	          if (isFocused) {
	            allItemProps.ref = _this2.storeFocusedItemReference;
	          }
	
	          // `key` is provided by theme()
	          /* eslint-disable react/jsx-key */
	          return _react2.default.createElement(_Item2.default, _extends({}, allItemProps, {
	            sectionIndex: sectionIndex,
	            itemIndex: itemIndex,
	            item: item,
	            renderItem: renderItem,
	            renderItemData: renderItemData
	          }));
	          /* eslint-enable react/jsx-key */
	        })
	      );
	    }
	  }]);
	
	  return ItemsList;
	}(_react.Component);
	
	ItemsList.propTypes = {
	  items: _react.PropTypes.array.isRequired,
	  itemProps: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.func]),
	  renderItem: _react.PropTypes.func.isRequired,
	  renderItemData: _react.PropTypes.object.isRequired,
	  sectionIndex: _react.PropTypes.number,
	  focusedItemIndex: _react.PropTypes.number,
	  onFocusedItemChange: _react.PropTypes.func.isRequired,
	  getItemId: _react.PropTypes.func.isRequired,
	  theme: _react.PropTypes.func.isRequired,
	  keyPrefix: _react.PropTypes.string.isRequired
	};
	ItemsList.defaultProps = {
	  sectionIndex: null
	};
	exports.default = ItemsList;

/***/ },
/* 1373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _compareObjects = __webpack_require__(290);
	
	var _compareObjects2 = _interopRequireDefault(_compareObjects);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SectionTitle = function (_Component) {
	  _inherits(SectionTitle, _Component);
	
	  function SectionTitle() {
	    _classCallCheck(this, SectionTitle);
	
	    return _possibleConstructorReturn(this, (SectionTitle.__proto__ || Object.getPrototypeOf(SectionTitle)).apply(this, arguments));
	  }
	
	  _createClass(SectionTitle, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return (0, _compareObjects2.default)(nextProps, this.props);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var section = _props.section;
	      var renderSectionTitle = _props.renderSectionTitle;
	      var theme = _props.theme;
	      var sectionKeyPrefix = _props.sectionKeyPrefix;
	
	      var sectionTitle = renderSectionTitle(section);
	
	      if (!sectionTitle) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        theme(sectionKeyPrefix + 'title', 'sectionTitle'),
	        sectionTitle
	      );
	    }
	  }]);
	
	  return SectionTitle;
	}(_react.Component);
	
	SectionTitle.propTypes = {
	  section: _react.PropTypes.any.isRequired,
	  renderSectionTitle: _react.PropTypes.func.isRequired,
	  theme: _react.PropTypes.func.isRequired,
	  sectionKeyPrefix: _react.PropTypes.string.isRequired
	};
	exports.default = SectionTitle;

/***/ },
/* 1374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1370).default;

/***/ },
/* 1375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(27);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(73);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(37);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__(1335);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(46);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _all = __webpack_require__(1483);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _warning = __webpack_require__(208);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(154);
	
	var _createChainedFunction = __webpack_require__(192);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(593);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: Should we expose `<NavItem>` as `<Nav.Item>`?
	
	// TODO: This `bsStyle` is very unlike the others. Should we rename it?
	
	// TODO: `pullRight` and `pullLeft` don't render right outside of `navbar`.
	// Consider renaming or replacing them.
	
	var propTypes = {
	  /**
	   * Marks the NavItem with a matching `eventKey` as active. Has a
	   * higher precedence over `activeHref`.
	   */
	  activeKey: _propTypes2['default'].any,
	
	  /**
	   * Marks the child NavItem with a matching `href` prop as active.
	   */
	  activeHref: _propTypes2['default'].string,
	
	  /**
	   * NavItems are be positioned vertically.
	   */
	  stacked: _propTypes2['default'].bool,
	
	  justified: (0, _all2['default'])(_propTypes2['default'].bool, function (_ref) {
	    var justified = _ref.justified,
	        navbar = _ref.navbar;
	    return justified && navbar ? Error('justified navbar `Nav`s are not supported') : null;
	  }),
	
	  /**
	   * A callback fired when a NavItem is selected.
	   *
	   * ```js
	   * function (
	   * 	Any eventKey,
	   * 	SyntheticEvent event?
	   * )
	   * ```
	   */
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * ARIA role for the Nav, in the context of a TabContainer, the default will
	   * be set to "tablist", but can be overridden by the Nav when set explicitly.
	   *
	   * When the role is set to "tablist" NavItem focus is managed according to
	   * the ARIA authoring practices for tabs:
	   * https://www.w3.org/TR/2013/WD-wai-aria-practices-20130307/#tabpanel
	   */
	  role: _propTypes2['default'].string,
	
	  /**
	   * Apply styling an alignment for use in a Navbar. This prop will be set
	   * automatically when the Nav is used inside a Navbar.
	   */
	  navbar: _propTypes2['default'].bool,
	
	  /**
	   * Float the Nav to the right. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullRight: _propTypes2['default'].bool,
	
	  /**
	   * Float the Nav to the left. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullLeft: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  justified: false,
	  pullRight: false,
	  pullLeft: false,
	  stacked: false
	};
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    onSelect: _propTypes2['default'].func
	  }),
	
	  $bs_tabContainer: _propTypes2['default'].shape({
	    activeKey: _propTypes2['default'].any,
	    onSelect: _propTypes2['default'].func.isRequired,
	    getTabId: _propTypes2['default'].func.isRequired,
	    getPaneId: _propTypes2['default'].func.isRequired
	  })
	};
	
	var Nav = function (_React$Component) {
	  (0, _inherits3['default'])(Nav, _React$Component);
	
	  function Nav() {
	    (0, _classCallCheck3['default'])(this, Nav);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Nav.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    if (!this._needsRefocus) {
	      return;
	    }
	
	    this._needsRefocus = false;
	
	    var children = this.props.children;
	
	    var _getActiveProps = this.getActiveProps(),
	        activeKey = _getActiveProps.activeKey,
	        activeHref = _getActiveProps.activeHref;
	
	    var activeChild = _ValidComponentChildren2['default'].find(children, function (child) {
	      return _this2.isActive(child, activeKey, activeHref);
	    });
	
	    var childrenArray = _ValidComponentChildren2['default'].toArray(children);
	    var activeChildIndex = childrenArray.indexOf(activeChild);
	
	    var childNodes = _reactDom2['default'].findDOMNode(this).children;
	    var activeNode = childNodes && childNodes[activeChildIndex];
	
	    if (!activeNode || !activeNode.firstChild) {
	      return;
	    }
	
	    activeNode.firstChild.focus();
	  };
	
	  Nav.prototype.handleTabKeyDown = function handleTabKeyDown(onSelect, event) {
	    var nextActiveChild = void 0;
	
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.left:
	      case _keycode2['default'].codes.up:
	        nextActiveChild = this.getNextActiveChild(-1);
	        break;
	      case _keycode2['default'].codes.right:
	      case _keycode2['default'].codes.down:
	        nextActiveChild = this.getNextActiveChild(1);
	        break;
	      default:
	        // It was a different key; don't handle this keypress.
	        return;
	    }
	
	    event.preventDefault();
	
	    if (onSelect && nextActiveChild && nextActiveChild.props.eventKey != null) {
	      onSelect(nextActiveChild.props.eventKey);
	    }
	
	    this._needsRefocus = true;
	  };
	
	  Nav.prototype.getNextActiveChild = function getNextActiveChild(offset) {
	    var _this3 = this;
	
	    var children = this.props.children;
	
	    var validChildren = children.filter(function (child) {
	      return child.props.eventKey != null && !child.props.disabled;
	    });
	
	    var _getActiveProps2 = this.getActiveProps(),
	        activeKey = _getActiveProps2.activeKey,
	        activeHref = _getActiveProps2.activeHref;
	
	    var activeChild = _ValidComponentChildren2['default'].find(children, function (child) {
	      return _this3.isActive(child, activeKey, activeHref);
	    });
	
	    // This assumes the active child is not disabled.
	    var activeChildIndex = validChildren.indexOf(activeChild);
	    if (activeChildIndex === -1) {
	      // Something has gone wrong. Select the first valid child we can find.
	      return validChildren[0];
	    }
	
	    var nextIndex = activeChildIndex + offset;
	    var numValidChildren = validChildren.length;
	
	    if (nextIndex >= numValidChildren) {
	      nextIndex = 0;
	    } else if (nextIndex < 0) {
	      nextIndex = numValidChildren - 1;
	    }
	
	    return validChildren[nextIndex];
	  };
	
	  Nav.prototype.getActiveProps = function getActiveProps() {
	    var tabContainer = this.context.$bs_tabContainer;
	
	    if (tabContainer) {
	       false ? (0, _warning2['default'])(this.props.activeKey == null && !this.props.activeHref, 'Specifying a `<Nav>` `activeKey` or `activeHref` in the context of ' + 'a `<TabContainer>` is not supported. Instead use `<TabContainer ' + ('activeKey={' + this.props.activeKey + '} />`.')) : void 0;
	
	      return tabContainer;
	    }
	
	    return this.props;
	  };
	
	  Nav.prototype.isActive = function isActive(_ref2, activeKey, activeHref) {
	    var props = _ref2.props;
	
	    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
	      return true;
	    }
	
	    return props.active;
	  };
	
	  Nav.prototype.getTabProps = function getTabProps(child, tabContainer, navRole, active, onSelect) {
	    var _this4 = this;
	
	    if (!tabContainer && navRole !== 'tablist') {
	      // No tab props here.
	      return null;
	    }
	
	    var _child$props = child.props,
	        id = _child$props.id,
	        controls = _child$props['aria-controls'],
	        eventKey = _child$props.eventKey,
	        role = _child$props.role,
	        onKeyDown = _child$props.onKeyDown,
	        tabIndex = _child$props.tabIndex;
	
	
	    if (tabContainer) {
	       false ? (0, _warning2['default'])(!id && !controls, 'In the context of a `<TabContainer>`, `<NavItem>`s are given ' + 'generated `id` and `aria-controls` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly, provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
	
	      id = tabContainer.getTabId(eventKey);
	      controls = tabContainer.getPaneId(eventKey);
	    }
	
	    if (navRole === 'tablist') {
	      role = role || 'tab';
	      onKeyDown = (0, _createChainedFunction2['default'])(function (event) {
	        return _this4.handleTabKeyDown(onSelect, event);
	      }, onKeyDown);
	      tabIndex = active ? tabIndex : -1;
	    }
	
	    return {
	      id: id,
	      role: role,
	      onKeyDown: onKeyDown,
	      'aria-controls': controls,
	      tabIndex: tabIndex
	    };
	  };
	
	  Nav.prototype.render = function render() {
	    var _extends2,
	        _this5 = this;
	
	    var _props = this.props,
	        stacked = _props.stacked,
	        justified = _props.justified,
	        onSelect = _props.onSelect,
	        propsRole = _props.role,
	        propsNavbar = _props.navbar,
	        pullRight = _props.pullRight,
	        pullLeft = _props.pullLeft,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['stacked', 'justified', 'onSelect', 'role', 'navbar', 'pullRight', 'pullLeft', 'className', 'children']);
	
	
	    var tabContainer = this.context.$bs_tabContainer;
	    var role = propsRole || (tabContainer ? 'tablist' : null);
	
	    var _getActiveProps3 = this.getActiveProps(),
	        activeKey = _getActiveProps3.activeKey,
	        activeHref = _getActiveProps3.activeHref;
	
	    delete props.activeKey; // Accessed via this.getActiveProps().
	    delete props.activeHref; // Accessed via this.getActiveProps().
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'stacked')] = stacked, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2));
	
	    var navbar = propsNavbar != null ? propsNavbar : this.context.$bs_navbar;
	    var pullLeftClassName = void 0;
	    var pullRightClassName = void 0;
	
	    if (navbar) {
	      var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	      classes[(0, _bootstrapUtils.prefix)(navbarProps, 'nav')] = true;
	
	      pullRightClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'right');
	      pullLeftClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'left');
	    } else {
	      pullRightClassName = 'pull-right';
	      pullLeftClassName = 'pull-left';
	    }
	
	    classes[pullRightClassName] = pullRight;
	    classes[pullLeftClassName] = pullLeft;
	
	    return _react2['default'].createElement(
	      'ul',
	      (0, _extends4['default'])({}, elementProps, {
	        role: role,
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        var active = _this5.isActive(child, activeKey, activeHref);
	        var childOnSelect = (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect, navbar && navbar.onSelect, tabContainer && tabContainer.onSelect);
	
	        return (0, _react.cloneElement)(child, (0, _extends4['default'])({}, _this5.getTabProps(child, tabContainer, role, active, childOnSelect), {
	          active: active,
	          activeKey: activeKey,
	          activeHref: activeHref,
	          onSelect: childOnSelect
	        }));
	      })
	    );
	  };
	
	  return Nav;
	}(_react2['default'].Component);
	
	Nav.propTypes = propTypes;
	Nav.defaultProps = defaultProps;
	Nav.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('nav', (0, _bootstrapUtils.bsStyles)(['tabs', 'pills'], Nav));
	module.exports = exports['default'];

/***/ },
/* 1376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(27);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(73);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(37);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(1379);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(192);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  active: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  role: _propTypes2['default'].string,
	  href: _propTypes2['default'].string,
	  onClick: _propTypes2['default'].func,
	  onSelect: _propTypes2['default'].func,
	  eventKey: _propTypes2['default'].any
	};
	
	var defaultProps = {
	  active: false,
	  disabled: false
	};
	
	var NavItem = function (_React$Component) {
	  (0, _inherits3['default'])(NavItem, _React$Component);
	
	  function NavItem(props, context) {
	    (0, _classCallCheck3['default'])(this, NavItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  NavItem.prototype.handleClick = function handleClick(e) {
	    if (this.props.onSelect) {
	      e.preventDefault();
	
	      if (!this.props.disabled) {
	        this.props.onSelect(this.props.eventKey, e);
	      }
	    }
	  };
	
	  NavItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        disabled = _props.disabled,
	        onClick = _props.onClick,
	        className = _props.className,
	        style = _props.style,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'disabled', 'onClick', 'className', 'style']);
	
	
	    delete props.onSelect;
	    delete props.eventKey;
	
	    // These are injected down by `<Nav>` for building `<SubNav>`s.
	    delete props.activeKey;
	    delete props.activeHref;
	
	    if (!props.role) {
	      if (props.href === '#') {
	        props.role = 'button';
	      }
	    } else if (props.role === 'tab') {
	      props['aria-selected'] = active;
	    }
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        role: 'presentation',
	        className: (0, _classnames2['default'])(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return NavItem;
	}(_react2['default'].Component);
	
	NavItem.propTypes = propTypes;
	NavItem.defaultProps = defaultProps;
	
	exports['default'] = NavItem;
	module.exports = exports['default'];

/***/ },
/* 1377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(73);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(27);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(37);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Overlay = __webpack_require__(1472);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _elementType = __webpack_require__(159);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Fade = __webpack_require__(590);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Overlay2['default'].propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _propTypes2['default'].bool,
	  /**
	   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
	   */
	  rootClose: _propTypes2['default'].bool,
	  /**
	   * A callback invoked by the overlay when it wishes to be hidden. Required if
	   * `rootClose` is specified.
	   */
	  onHide: _propTypes2['default'].func,
	
	  /**
	   * Use animation
	   */
	  animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _propTypes2['default'].func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _propTypes2['default'].func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _propTypes2['default'].func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _propTypes2['default'].func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _propTypes2['default'].func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _propTypes2['default'].func,
	
	  /**
	   * Sets the direction of the Overlay.
	   */
	  placement: _propTypes2['default'].oneOf(['top', 'right', 'bottom', 'left'])
	});
	
	var defaultProps = {
	  animation: _Fade2['default'],
	  rootClose: false,
	  show: false,
	  placement: 'right'
	};
	
	var Overlay = function (_React$Component) {
	  (0, _inherits3['default'])(Overlay, _React$Component);
	
	  function Overlay() {
	    (0, _classCallCheck3['default'])(this, Overlay);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Overlay.prototype.render = function render() {
	    var _props = this.props,
	        animation = _props.animation,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['animation', 'children']);
	
	
	    var transition = animation === true ? _Fade2['default'] : animation || null;
	
	    var child = void 0;
	
	    if (!transition) {
	      child = (0, _react.cloneElement)(children, {
	        className: (0, _classnames2['default'])(children.props.className, 'in')
	      });
	    } else {
	      child = children;
	    }
	
	    return _react2['default'].createElement(
	      _Overlay2['default'],
	      (0, _extends3['default'])({}, props, {
	        transition: transition
	      }),
	      child
	    );
	  };
	
	  return Overlay;
	}(_react2['default'].Component);
	
	Overlay.propTypes = propTypes;
	Overlay.defaultProps = defaultProps;
	
	exports['default'] = Overlay;
	module.exports = exports['default'];

/***/ },
/* 1378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(73);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(27);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _contains = __webpack_require__(280);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(46);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(208);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Overlay = __webpack_require__(1377);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _createChainedFunction = __webpack_require__(192);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Check if value one is inside or equal to the of value
	 *
	 * @param {string} one
	 * @param {string|array} of
	 * @returns {boolean}
	 */
	function isOneOf(one, of) {
	  if (Array.isArray(of)) {
	    return of.indexOf(one) >= 0;
	  }
	  return one === of;
	}
	
	var triggerType = _propTypes2['default'].oneOf(['click', 'hover', 'focus']);
	
	var propTypes = (0, _extends3['default'])({}, _Overlay2['default'].propTypes, {
	
	  /**
	  * Specify which action or actions trigger Overlay visibility
	  */
	  trigger: _propTypes2['default'].oneOfType([triggerType, _propTypes2['default'].arrayOf(triggerType)]),
	
	  /**
	   * A millisecond delay amount to show and hide the Overlay once triggered
	   */
	  delay: _propTypes2['default'].number,
	  /**
	   * A millisecond delay amount before showing the Overlay once triggered.
	   */
	  delayShow: _propTypes2['default'].number,
	  /**
	   * A millisecond delay amount before hiding the Overlay once triggered.
	   */
	  delayHide: _propTypes2['default'].number,
	
	  // FIXME: This should be `defaultShow`.
	  /**
	   * The initial visibility state of the Overlay. For more nuanced visibility
	   * control, consider using the Overlay component directly.
	   */
	  defaultOverlayShown: _propTypes2['default'].bool,
	
	  /**
	   * An element or text to overlay next to the target.
	   */
	  overlay: _propTypes2['default'].node.isRequired,
	
	  /**
	   * @private
	   */
	  onBlur: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onClick: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onFocus: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onMouseOut: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onMouseOver: _propTypes2['default'].func,
	
	  // Overridden props from `<Overlay>`.
	  /**
	   * @private
	   */
	  target: _propTypes2['default'].oneOf([null]),
	  /**
	  * @private
	  */
	  onHide: _propTypes2['default'].oneOf([null]),
	  /**
	   * @private
	   */
	  show: _propTypes2['default'].oneOf([null])
	});
	
	var defaultProps = {
	  defaultOverlayShown: false,
	  trigger: ['hover', 'focus']
	};
	
	var OverlayTrigger = function (_React$Component) {
	  (0, _inherits3['default'])(OverlayTrigger, _React$Component);
	
	  function OverlayTrigger(props, context) {
	    (0, _classCallCheck3['default'])(this, OverlayTrigger);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleToggle = _this.handleToggle.bind(_this);
	    _this.handleDelayedShow = _this.handleDelayedShow.bind(_this);
	    _this.handleDelayedHide = _this.handleDelayedHide.bind(_this);
	    _this.handleHide = _this.handleHide.bind(_this);
	
	    _this.handleMouseOver = function (e) {
	      return _this.handleMouseOverOut(_this.handleDelayedShow, e);
	    };
	    _this.handleMouseOut = function (e) {
	      return _this.handleMouseOverOut(_this.handleDelayedHide, e);
	    };
	
	    _this._mountNode = null;
	
	    _this.state = {
	      show: props.defaultOverlayShown
	    };
	    return _this;
	  }
	
	  OverlayTrigger.prototype.componentDidMount = function componentDidMount() {
	    this._mountNode = document.createElement('div');
	    this.renderOverlay();
	  };
	
	  OverlayTrigger.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.renderOverlay();
	  };
	
	  OverlayTrigger.prototype.componentWillUnmount = function componentWillUnmount() {
	    _reactDom2['default'].unmountComponentAtNode(this._mountNode);
	    this._mountNode = null;
	
	    clearTimeout(this._hoverShowDelay);
	    clearTimeout(this._hoverHideDelay);
	  };
	
	  OverlayTrigger.prototype.handleToggle = function handleToggle() {
	    if (this.state.show) {
	      this.hide();
	    } else {
	      this.show();
	    }
	  };
	
	  OverlayTrigger.prototype.handleDelayedShow = function handleDelayedShow() {
	    var _this2 = this;
	
	    if (this._hoverHideDelay != null) {
	      clearTimeout(this._hoverHideDelay);
	      this._hoverHideDelay = null;
	      return;
	    }
	
	    if (this.state.show || this._hoverShowDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;
	
	    if (!delay) {
	      this.show();
	      return;
	    }
	
	    this._hoverShowDelay = setTimeout(function () {
	      _this2._hoverShowDelay = null;
	      _this2.show();
	    }, delay);
	  };
	
	  OverlayTrigger.prototype.handleDelayedHide = function handleDelayedHide() {
	    var _this3 = this;
	
	    if (this._hoverShowDelay != null) {
	      clearTimeout(this._hoverShowDelay);
	      this._hoverShowDelay = null;
	      return;
	    }
	
	    if (!this.state.show || this._hoverHideDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;
	
	    if (!delay) {
	      this.hide();
	      return;
	    }
	
	    this._hoverHideDelay = setTimeout(function () {
	      _this3._hoverHideDelay = null;
	      _this3.hide();
	    }, delay);
	  };
	
	  // Simple implementation of mouseEnter and mouseLeave.
	  // React's built version is broken: https://github.com/facebook/react/issues/4251
	  // for cases when the trigger is disabled and mouseOut/Over can cause flicker
	  // moving from one child element to another.
	
	
	  OverlayTrigger.prototype.handleMouseOverOut = function handleMouseOverOut(handler, e) {
	    var target = e.currentTarget;
	    var related = e.relatedTarget || e.nativeEvent.toElement;
	
	    if (!related || related !== target && !(0, _contains2['default'])(target, related)) {
	      handler(e);
	    }
	  };
	
	  OverlayTrigger.prototype.handleHide = function handleHide() {
	    this.hide();
	  };
	
	  OverlayTrigger.prototype.show = function show() {
	    this.setState({ show: true });
	  };
	
	  OverlayTrigger.prototype.hide = function hide() {
	    this.setState({ show: false });
	  };
	
	  OverlayTrigger.prototype.makeOverlay = function makeOverlay(overlay, props) {
	    return _react2['default'].createElement(
	      _Overlay2['default'],
	      (0, _extends3['default'])({}, props, {
	        show: this.state.show,
	        onHide: this.handleHide,
	        target: this
	      }),
	      overlay
	    );
	  };
	
	  OverlayTrigger.prototype.renderOverlay = function renderOverlay() {
	    _reactDom2['default'].unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
	  };
	
	  OverlayTrigger.prototype.render = function render() {
	    var _props = this.props,
	        trigger = _props.trigger,
	        overlay = _props.overlay,
	        children = _props.children,
	        onBlur = _props.onBlur,
	        onClick = _props.onClick,
	        onFocus = _props.onFocus,
	        onMouseOut = _props.onMouseOut,
	        onMouseOver = _props.onMouseOver,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['trigger', 'overlay', 'children', 'onBlur', 'onClick', 'onFocus', 'onMouseOut', 'onMouseOver']);
	
	
	    delete props.delay;
	    delete props.delayShow;
	    delete props.delayHide;
	    delete props.defaultOverlayShown;
	
	    var child = _react2['default'].Children.only(children);
	    var childProps = child.props;
	    var triggerProps = {};
	
	    if (this.state.show) {
	      triggerProps['aria-describedby'] = overlay.props.id;
	    }
	
	    // FIXME: The logic here for passing through handlers on this component is
	    // inconsistent. We shouldn't be passing any of these props through.
	
	    triggerProps.onClick = (0, _createChainedFunction2['default'])(childProps.onClick, onClick);
	
	    if (isOneOf('click', trigger)) {
	      triggerProps.onClick = (0, _createChainedFunction2['default'])(triggerProps.onClick, this.handleToggle);
	    }
	
	    if (isOneOf('hover', trigger)) {
	       false ? (0, _warning2['default'])(!(trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the ' + 'visibility of the overlay to just mouse users. Consider also ' + 'including the `"focus"` trigger so that touch and keyboard only ' + 'users can see the overlay as well.') : void 0;
	
	      triggerProps.onMouseOver = (0, _createChainedFunction2['default'])(childProps.onMouseOver, onMouseOver, this.handleMouseOver);
	      triggerProps.onMouseOut = (0, _createChainedFunction2['default'])(childProps.onMouseOut, onMouseOut, this.handleMouseOut);
	    }
	
	    if (isOneOf('focus', trigger)) {
	      triggerProps.onFocus = (0, _createChainedFunction2['default'])(childProps.onFocus, onFocus, this.handleDelayedShow);
	      triggerProps.onBlur = (0, _createChainedFunction2['default'])(childProps.onBlur, onBlur, this.handleDelayedHide);
	    }
	
	    this._overlay = this.makeOverlay(overlay, props);
	
	    return (0, _react.cloneElement)(child, triggerProps);
	  };
	
	  return OverlayTrigger;
	}(_react2['default'].Component);
	
	OverlayTrigger.propTypes = propTypes;
	OverlayTrigger.defaultProps = defaultProps;
	
	exports['default'] = OverlayTrigger;
	module.exports = exports['default'];

/***/ },
/* 1379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(27);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(73);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(159);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  href: _propTypes2['default'].string,
	  onClick: _propTypes2['default'].func,
	  disabled: _propTypes2['default'].bool,
	  role: _propTypes2['default'].string,
	  tabIndex: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * this is sort of silly but needed for Button
	   */
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'a'
	};
	
	function isTrivialHref(href) {
	  return !href || href.trim() === '#';
	}
	
	/**
	 * There are situations due to browser quirks or Bootstrap CSS where
	 * an anchor tag is needed, when semantically a button tag is the
	 * better choice. SafeAnchor ensures that when an anchor is used like a
	 * button its accessible. It also emulates input `disabled` behavior for
	 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
	 */
	
	var SafeAnchor = function (_React$Component) {
	  (0, _inherits3['default'])(SafeAnchor, _React$Component);
	
	  function SafeAnchor(props, context) {
	    (0, _classCallCheck3['default'])(this, SafeAnchor);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  SafeAnchor.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        href = _props.href,
	        onClick = _props.onClick;
	
	
	    if (disabled || isTrivialHref(href)) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      event.stopPropagation();
	      return;
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  SafeAnchor.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        disabled = _props2.disabled,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['componentClass', 'disabled']);
	
	
	    if (isTrivialHref(props.href)) {
	      props.role = props.role || 'button';
	      // we want to make sure there is a href attribute on the node
	      // otherwise, the cursor incorrectly styled (except with role='button')
	      props.href = props.href || '#';
	    }
	
	    if (disabled) {
	      props.tabIndex = -1;
	      props.style = (0, _extends3['default'])({ pointerEvents: 'none' }, props.style);
	    }
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, props, {
	      onClick: this.handleClick
	    }));
	  };
	
	  return SafeAnchor;
	}(_react2['default'].Component);
	
	SafeAnchor.propTypes = propTypes;
	SafeAnchor.defaultProps = defaultProps;
	
	exports['default'] = SafeAnchor;
	module.exports = exports['default'];

/***/ },
/* 1380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(27);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TabContainer = __webpack_require__(591);
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	var _TabContent = __webpack_require__(592);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _TabPane = __webpack_require__(1381);
	
	var _TabPane2 = _interopRequireDefault(_TabPane);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _TabPane2['default'].propTypes, {
	
	  disabled: _propTypes2['default'].bool,
	
	  title: _propTypes2['default'].node,
	
	  /**
	   * tabClassName is used as className for the associated NavItem
	   */
	  tabClassName: _propTypes2['default'].string
	});
	
	var Tab = function (_React$Component) {
	  (0, _inherits3['default'])(Tab, _React$Component);
	
	  function Tab() {
	    (0, _classCallCheck3['default'])(this, Tab);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Tab.prototype.render = function render() {
	    var props = (0, _extends3['default'])({}, this.props);
	
	    // These props are for the parent `<Tabs>` rather than the `<TabPane>`.
	    delete props.title;
	    delete props.disabled;
	    delete props.tabClassName;
	
	    return _react2['default'].createElement(_TabPane2['default'], props);
	  };
	
	  return Tab;
	}(_react2['default'].Component);
	
	Tab.propTypes = propTypes;
	
	Tab.Container = _TabContainer2['default'];
	Tab.Content = _TabContent2['default'];
	Tab.Pane = _TabPane2['default'];
	
	exports['default'] = Tab;
	module.exports = exports['default'];

/***/ },
/* 1381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(27);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(73);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(37);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(159);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _warning = __webpack_require__(208);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(154);
	
	var _createChainedFunction = __webpack_require__(192);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _Fade = __webpack_require__(590);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Uniquely identify the `<TabPane>` among its siblings.
	   */
	  eventKey: _propTypes2['default'].any,
	
	  /**
	   * Use animation when showing or hiding `<TabPane>`s. Use `false` to disable,
	   * `true` to enable the default `<Fade>` animation or any `<Transition>`
	   * component.
	   */
	  animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	
	  /** @private **/
	  id: _propTypes2['default'].string,
	
	  /** @private **/
	  'aria-labelledby': _propTypes2['default'].string,
	
	  /**
	   * If not explicitly specified and rendered in the context of a
	   * `<TabContent>`, the `bsClass` of the `<TabContent>` suffixed by `-pane`.
	   * If otherwise not explicitly specified, `tab-pane`.
	   */
	  bsClass: _propTypes2['default'].string,
	
	  /**
	   * Transition onEnter callback when animation is not `false`
	   */
	  onEnter: _propTypes2['default'].func,
	
	  /**
	   * Transition onEntering callback when animation is not `false`
	   */
	  onEntering: _propTypes2['default'].func,
	
	  /**
	   * Transition onEntered callback when animation is not `false`
	   */
	  onEntered: _propTypes2['default'].func,
	
	  /**
	   * Transition onExit callback when animation is not `false`
	   */
	  onExit: _propTypes2['default'].func,
	
	  /**
	   * Transition onExiting callback when animation is not `false`
	   */
	  onExiting: _propTypes2['default'].func,
	
	  /**
	   * Transition onExited callback when animation is not `false`
	   */
	  onExited: _propTypes2['default'].func,
	
	  /**
	   * Wait until the first "enter" transition to mount the tab (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount the tab (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _propTypes2['default'].bool
	};
	
	var contextTypes = {
	  $bs_tabContainer: _propTypes2['default'].shape({
	    getTabId: _propTypes2['default'].func,
	    getPaneId: _propTypes2['default'].func
	  }),
	  $bs_tabContent: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	    activeKey: _propTypes2['default'].any,
	    mountOnEnter: _propTypes2['default'].bool,
	    unmountOnExit: _propTypes2['default'].bool,
	    onPaneEnter: _propTypes2['default'].func.isRequired,
	    onPaneExited: _propTypes2['default'].func.isRequired,
	    exiting: _propTypes2['default'].bool.isRequired
	  })
	};
	
	/**
	 * We override the `<TabContainer>` context so `<Nav>`s in `<TabPane>`s don't
	 * conflict with the top level one.
	 */
	var childContextTypes = {
	  $bs_tabContainer: _propTypes2['default'].oneOf([null])
	};
	
	var TabPane = function (_React$Component) {
	  (0, _inherits3['default'])(TabPane, _React$Component);
	
	  function TabPane(props, context) {
	    (0, _classCallCheck3['default'])(this, TabPane);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleEnter = _this.handleEnter.bind(_this);
	    _this.handleExited = _this.handleExited.bind(_this);
	
	    _this['in'] = false;
	    return _this;
	  }
	
	  TabPane.prototype.getChildContext = function getChildContext() {
	    return {
	      $bs_tabContainer: null
	    };
	  };
	
	  TabPane.prototype.componentDidMount = function componentDidMount() {
	    if (this.shouldBeIn()) {
	      // In lieu of the action event firing.
	      this.handleEnter();
	    }
	  };
	
	  TabPane.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (this['in']) {
	      if (!this.shouldBeIn()) {
	        // We shouldn't be active any more. Notify the parent.
	        this.handleExited();
	      }
	    } else if (this.shouldBeIn()) {
	      // We are the active child. Notify the parent.
	      this.handleEnter();
	    }
	  };
	
	  TabPane.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this['in']) {
	      // In lieu of the action event firing.
	      this.handleExited();
	    }
	  };
	
	  TabPane.prototype.handleEnter = function handleEnter() {
	    var tabContent = this.context.$bs_tabContent;
	    if (!tabContent) {
	      return;
	    }
	
	    this['in'] = tabContent.onPaneEnter(this, this.props.eventKey);
	  };
	
	  TabPane.prototype.handleExited = function handleExited() {
	    var tabContent = this.context.$bs_tabContent;
	    if (!tabContent) {
	      return;
	    }
	
	    tabContent.onPaneExited(this);
	    this['in'] = false;
	  };
	
	  TabPane.prototype.getAnimation = function getAnimation() {
	    if (this.props.animation != null) {
	      return this.props.animation;
	    }
	
	    var tabContent = this.context.$bs_tabContent;
	    return tabContent && tabContent.animation;
	  };
	
	  TabPane.prototype.isActive = function isActive() {
	    var tabContent = this.context.$bs_tabContent;
	    var activeKey = tabContent && tabContent.activeKey;
	
	    return this.props.eventKey === activeKey;
	  };
	
	  TabPane.prototype.shouldBeIn = function shouldBeIn() {
	    return this.getAnimation() && this.isActive();
	  };
	
	  TabPane.prototype.render = function render() {
	    var _props = this.props,
	        eventKey = _props.eventKey,
	        className = _props.className,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onExited = _props.onExited,
	        propsMountOnEnter = _props.mountOnEnter,
	        propsUnmountOnExit = _props.unmountOnExit,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['eventKey', 'className', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited', 'mountOnEnter', 'unmountOnExit']);
	    var _context = this.context,
	        tabContent = _context.$bs_tabContent,
	        tabContainer = _context.$bs_tabContainer;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var active = this.isActive();
	    var animation = this.getAnimation();
	
	    var mountOnEnter = propsMountOnEnter != null ? propsMountOnEnter : tabContent && tabContent.mountOnEnter;
	    var unmountOnExit = propsUnmountOnExit != null ? propsUnmountOnExit : tabContent && tabContent.unmountOnExit;
	
	    if (!active && !animation && unmountOnExit) {
	      return null;
	    }
	
	    var Transition = animation === true ? _Fade2['default'] : animation || null;
	
	    if (tabContent) {
	      bsProps.bsClass = (0, _bootstrapUtils.prefix)(tabContent, 'pane');
	    }
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      active: active
	    });
	
	    if (tabContainer) {
	       false ? (0, _warning2['default'])(!elementProps.id && !elementProps['aria-labelledby'], 'In the context of a `<TabContainer>`, `<TabPanes>` are given ' + 'generated `id` and `aria-labelledby` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
	
	      elementProps.id = tabContainer.getPaneId(eventKey);
	      elementProps['aria-labelledby'] = tabContainer.getTabId(eventKey);
	    }
	
	    var pane = _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      role: 'tabpanel',
	      'aria-hidden': !active,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	
	    if (Transition) {
	      var exiting = tabContent && tabContent.exiting;
	
	      return _react2['default'].createElement(
	        Transition,
	        {
	          'in': active && !exiting,
	          onEnter: (0, _createChainedFunction2['default'])(this.handleEnter, onEnter),
	          onEntering: onEntering,
	          onEntered: onEntered,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: (0, _createChainedFunction2['default'])(this.handleExited, onExited),
	          mountOnEnter: mountOnEnter,
	          unmountOnExit: unmountOnExit
	        },
	        pane
	      );
	    }
	
	    return pane;
	  };
	
	  return TabPane;
	}(_react2['default'].Component);
	
	TabPane.propTypes = propTypes;
	TabPane.contextTypes = contextTypes;
	TabPane.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('tab-pane', TabPane);
	module.exports = exports['default'];

/***/ },
/* 1382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(27);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(73);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__(625);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _uncontrollable = __webpack_require__(654);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _Nav = __webpack_require__(1375);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _NavItem = __webpack_require__(1376);
	
	var _NavItem2 = _interopRequireDefault(_NavItem);
	
	var _TabContainer = __webpack_require__(591);
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	var _TabContent = __webpack_require__(592);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _bootstrapUtils = __webpack_require__(154);
	
	var _ValidComponentChildren = __webpack_require__(593);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TabContainer = _TabContainer2['default'].ControlledComponent;
	
	var propTypes = {
	  /**
	   * Mark the Tab with a matching `eventKey` as active.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _propTypes2['default'].any,
	
	  /**
	   * Navigation style
	   */
	  bsStyle: _propTypes2['default'].oneOf(['tabs', 'pills']),
	
	  animation: _propTypes2['default'].bool,
	
	  id: (0, _isRequiredForA11y2['default'])(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
	
	  /**
	   * Callback fired when a Tab is selected.
	   *
	   * ```js
	   * function (
	   * 	Any eventKey,
	   * 	SyntheticEvent event?
	   * )
	   * ```
	   *
	   * @controllable activeKey
	   */
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount tabs (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  bsStyle: 'tabs',
	  animation: true,
	  mountOnEnter: false,
	  unmountOnExit: false
	};
	
	function getDefaultActiveKey(children) {
	  var defaultActiveKey = void 0;
	  _ValidComponentChildren2['default'].forEach(children, function (child) {
	    if (defaultActiveKey == null) {
	      defaultActiveKey = child.props.eventKey;
	    }
	  });
	
	  return defaultActiveKey;
	}
	
	var Tabs = function (_React$Component) {
	  (0, _inherits3['default'])(Tabs, _React$Component);
	
	  function Tabs() {
	    (0, _classCallCheck3['default'])(this, Tabs);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Tabs.prototype.renderTab = function renderTab(child) {
	    var _child$props = child.props,
	        title = _child$props.title,
	        eventKey = _child$props.eventKey,
	        disabled = _child$props.disabled,
	        tabClassName = _child$props.tabClassName;
	
	    if (title == null) {
	      return null;
	    }
	
	    return _react2['default'].createElement(
	      _NavItem2['default'],
	      {
	        eventKey: eventKey,
	        disabled: disabled,
	        className: tabClassName
	      },
	      title
	    );
	  };
	
	  Tabs.prototype.render = function render() {
	    var _props = this.props,
	        id = _props.id,
	        onSelect = _props.onSelect,
	        animation = _props.animation,
	        mountOnEnter = _props.mountOnEnter,
	        unmountOnExit = _props.unmountOnExit,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        _props$activeKey = _props.activeKey,
	        activeKey = _props$activeKey === undefined ? getDefaultActiveKey(children) : _props$activeKey,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['id', 'onSelect', 'animation', 'mountOnEnter', 'unmountOnExit', 'bsClass', 'className', 'style', 'children', 'activeKey']);
	
	
	    return _react2['default'].createElement(
	      TabContainer,
	      {
	        id: id,
	        activeKey: activeKey,
	        onSelect: onSelect,
	        className: className,
	        style: style
	      },
	      _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          _Nav2['default'],
	          (0, _extends3['default'])({}, props, {
	            role: 'tablist'
	          }),
	          _ValidComponentChildren2['default'].map(children, this.renderTab)
	        ),
	        _react2['default'].createElement(
	          _TabContent2['default'],
	          {
	            bsClass: bsClass,
	            animation: animation,
	            mountOnEnter: mountOnEnter,
	            unmountOnExit: unmountOnExit
	          },
	          children
	        )
	      )
	    );
	  };
	
	  return Tabs;
	}(_react2['default'].Component);
	
	Tabs.propTypes = propTypes;
	Tabs.defaultProps = defaultProps;
	
	(0, _bootstrapUtils.bsClass)('tab', Tabs);
	
	exports['default'] = (0, _uncontrollable2['default'])(Tabs, { activeKey: 'onSelect' });
	module.exports = exports['default'];

/***/ },
/* 1383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(27);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(73);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(37);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__(625);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _bootstrapUtils = __webpack_require__(154);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * An html id attribute, necessary for accessibility
	   * @type {string|number}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2['default'])(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
	
	  /**
	   * Sets the direction the Tooltip is positioned towards.
	   */
	  placement: _propTypes2['default'].oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The "top" position value for the Tooltip.
	   */
	  positionTop: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * The "left" position value for the Tooltip.
	   */
	  positionLeft: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	
	  /**
	   * The "top" position value for the Tooltip arrow.
	   */
	  arrowOffsetTop: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * The "left" position value for the Tooltip arrow.
	   */
	  arrowOffsetLeft: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string])
	};
	
	var defaultProps = {
	  placement: 'right'
	};
	
	var Tooltip = function (_React$Component) {
	  (0, _inherits3['default'])(Tooltip, _React$Component);
	
	  function Tooltip() {
	    (0, _classCallCheck3['default'])(this, Tooltip);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Tooltip.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        placement = _props.placement,
	        positionTop = _props.positionTop,
	        positionLeft = _props.positionLeft,
	        arrowOffsetTop = _props.arrowOffsetTop,
	        arrowOffsetLeft = _props.arrowOffsetLeft,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
	
	    var outerStyle = (0, _extends4['default'])({
	      top: positionTop,
	      left: positionLeft
	    }, style);
	
	    var arrowStyle = {
	      top: arrowOffsetTop,
	      left: arrowOffsetLeft
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'tooltip',
	        className: (0, _classnames2['default'])(className, classes),
	        style: outerStyle
	      }),
	      _react2['default'].createElement('div', { className: (0, _bootstrapUtils.prefix)(bsProps, 'arrow'), style: arrowStyle }),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'inner') },
	        children
	      )
	    );
	  };
	
	  return Tooltip;
	}(_react2['default'].Component);
	
	Tooltip.propTypes = propTypes;
	Tooltip.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('tooltip', Tooltip);
	module.exports = exports['default'];

/***/ },
/* 1384 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var Size = exports.Size = {
	  LARGE: 'large',
	  SMALL: 'small',
	  XSMALL: 'xsmall'
	};
	
	var SIZE_MAP = exports.SIZE_MAP = {
	  large: 'lg',
	  medium: 'md',
	  small: 'sm',
	  xsmall: 'xs',
	  lg: 'lg',
	  md: 'md',
	  sm: 'sm',
	  xs: 'xs'
	};
	
	var DEVICE_SIZES = exports.DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];
	
	var State = exports.State = {
	  SUCCESS: 'success',
	  WARNING: 'warning',
	  DANGER: 'danger',
	  INFO: 'info'
	};
	
	var Style = exports.Style = {
	  DEFAULT: 'default',
	  PRIMARY: 'primary',
	  LINK: 'link',
	  INVERSE: 'inverse'
	};

/***/ },
/* 1385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = _interopDefault(__webpack_require__(1));
	var PropTypes = _interopDefault(__webpack_require__(14));
	var classnames = _interopDefault(__webpack_require__(37));
	var onClickOutside = _interopDefault(__webpack_require__(1471));
	var moment = _interopDefault(__webpack_require__(8));
	var reactPopper = __webpack_require__(1482);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	
	
	
	
	
	
	
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	
	
	
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	function generateYears(year, noOfYear, minDate, maxDate) {
	  var list = [];
	  for (var i = 0; i < 2 * noOfYear + 1; i++) {
	    var newYear = year + noOfYear - i;
	    var isInRange = true;
	
	    if (minDate) {
	      isInRange = minDate.year() <= newYear;
	    }
	
	    if (maxDate && isInRange) {
	      isInRange = maxDate.year() >= newYear;
	    }
	
	    if (isInRange) {
	      list.push(newYear);
	    }
	  }
	
	  return list;
	}
	
	var YearDropdownOptions = function (_React$Component) {
	  inherits(YearDropdownOptions, _React$Component);
	
	  function YearDropdownOptions(props) {
	    classCallCheck(this, YearDropdownOptions);
	
	    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.renderOptions = function () {
	      var selectedYear = _this.props.year;
	      var options = _this.state.yearsList.map(function (year) {
	        return React.createElement(
	          "div",
	          {
	            className: selectedYear === year ? "react-datepicker__year-option --selected_year" : "react-datepicker__year-option",
	            key: year,
	            ref: year,
	            onClick: _this.onChange.bind(_this, year)
	          },
	          selectedYear === year ? React.createElement(
	            "span",
	            { className: "react-datepicker__year-option--selected" },
	            "\u2713"
	          ) : "",
	          year
	        );
	      });
	
	      var minYear = _this.props.minDate ? _this.props.minDate.year() : null;
	      var maxYear = _this.props.maxDate ? _this.props.maxDate.year() : null;
	
	      if (!maxYear || !_this.state.yearsList.find(function (year) {
	        return year === maxYear;
	      })) {
	        options.unshift(React.createElement(
	          "div",
	          {
	            className: "react-datepicker__year-option",
	            ref: "upcoming",
	            key: "upcoming",
	            onClick: _this.incrementYears
	          },
	          React.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" })
	        ));
	      }
	
	      if (!minYear || !_this.state.yearsList.find(function (year) {
	        return year === minYear;
	      })) {
	        options.push(React.createElement(
	          "div",
	          {
	            className: "react-datepicker__year-option",
	            ref: "previous",
	            key: "previous",
	            onClick: _this.decrementYears
	          },
	          React.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" })
	        ));
	      }
	
	      return options;
	    };
	
	    _this.onChange = function (year) {
	      _this.props.onChange(year);
	    };
	
	    _this.handleClickOutside = function () {
	      _this.props.onCancel();
	    };
	
	    _this.shiftYears = function (amount) {
	      var years = _this.state.yearsList.map(function (year) {
	        return year + amount;
	      });
	
	      _this.setState({
	        yearsList: years
	      });
	    };
	
	    _this.incrementYears = function () {
	      return _this.shiftYears(1);
	    };
	
	    _this.decrementYears = function () {
	      return _this.shiftYears(-1);
	    };
	
	    var yearDropdownItemNumber = props.yearDropdownItemNumber,
	        scrollableYearDropdown = props.scrollableYearDropdown;
	
	    var noOfYear = yearDropdownItemNumber || (scrollableYearDropdown ? 10 : 5);
	
	    _this.state = {
	      yearsList: generateYears(_this.props.year, noOfYear, _this.props.minDate, _this.props.maxDate)
	    };
	    return _this;
	  }
	
	  YearDropdownOptions.prototype.render = function render() {
	    var dropdownClass = classnames({
	      "react-datepicker__year-dropdown": true,
	      "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
	    });
	
	    return React.createElement(
	      "div",
	      { className: dropdownClass },
	      this.renderOptions()
	    );
	  };
	
	  return YearDropdownOptions;
	}(React.Component);
	
	YearDropdownOptions.propTypes = {
	  minDate: PropTypes.object,
	  maxDate: PropTypes.object,
	  onCancel: PropTypes.func.isRequired,
	  onChange: PropTypes.func.isRequired,
	  scrollableYearDropdown: PropTypes.bool,
	  year: PropTypes.number.isRequired,
	  yearDropdownItemNumber: PropTypes.number
	};
	
	var dayOfWeekCodes = {
	  1: "mon",
	  2: "tue",
	  3: "wed",
	  4: "thu",
	  5: "fri",
	  6: "sat",
	  7: "sun"
	};
	
	// These functions are not exported so
	// that we avoid magic strings like 'days'
	function set$1(date, unit, to) {
	  return date.set(unit, to);
	}
	
	function add(date, amount, unit) {
	  return date.add(amount, unit);
	}
	
	function subtract(date, amount, unit) {
	  return date.subtract(amount, unit);
	}
	
	function get$1(date, unit) {
	  return date.get(unit);
	}
	
	function getStartOf(date, unit) {
	  return date.startOf(unit);
	}
	
	// ** Date Constructors **
	
	function newDate(point) {
	  return moment(point);
	}
	
	function newDateWithOffset(utcOffset) {
	  return moment().utc().utcOffset(utcOffset);
	}
	
	function now(maybeFixedUtcOffset) {
	  if (maybeFixedUtcOffset == null) {
	    return newDate();
	  }
	  return newDateWithOffset(maybeFixedUtcOffset);
	}
	
	function cloneDate(date) {
	  return date.clone();
	}
	
	function parseDate(value, _ref) {
	  var dateFormat = _ref.dateFormat,
	      locale = _ref.locale;
	
	  var m = moment(value, dateFormat, locale || moment.locale(), true);
	  return m.isValid() ? m : null;
	}
	
	// ** Date "Reflection" **
	
	function isMoment(date) {
	  return moment.isMoment(date);
	}
	
	function isDate(date) {
	  return moment.isDate(date);
	}
	
	// ** Date Formatting **
	
	function formatDate(date, format) {
	  return date.format(format);
	}
	
	function safeDateFormat(date, _ref2) {
	  var dateFormat = _ref2.dateFormat,
	      locale = _ref2.locale;
	
	  return date && date.clone().locale(locale || moment.locale()).format(Array.isArray(dateFormat) ? dateFormat[0] : dateFormat) || "";
	}
	
	// ** Date Setters **
	
	function setTime(date, _ref3) {
	  var hour = _ref3.hour,
	      minute = _ref3.minute,
	      second = _ref3.second;
	
	  date.set({ hour: hour, minute: minute, second: second });
	  return date;
	}
	
	function setMonth(date, month) {
	  return set$1(date, "month", month);
	}
	
	function setYear(date, year) {
	  return set$1(date, "year", year);
	}
	
	
	
	// ** Date Getters **
	
	function getSecond(date) {
	  return get$1(date, "second");
	}
	
	function getMinute(date) {
	  return get$1(date, "minute");
	}
	
	function getHour(date) {
	  return get$1(date, "hour");
	}
	
	// Returns day of week
	function getDay(date) {
	  return get$1(date, "day");
	}
	
	function getWeek(date) {
	  return get$1(date, "week");
	}
	
	function getMonth(date) {
	  return get$1(date, "month");
	}
	
	function getYear(date) {
	  return get$1(date, "year");
	}
	
	// Returns day of month
	function getDate(date) {
	  return get$1(date, "date");
	}
	
	
	
	function getDayOfWeekCode(day) {
	  return dayOfWeekCodes[day.isoWeekday()];
	}
	
	// *** Start of ***
	
	function getStartOfDay(date) {
	  return getStartOf(date, "day");
	}
	
	function getStartOfWeek(date) {
	  return getStartOf(date, "week");
	}
	function getStartOfMonth(date) {
	  return getStartOf(date, "month");
	}
	
	function getStartOfDate(date) {
	  return getStartOf(date, "date");
	}
	
	// *** End of ***
	
	
	
	
	
	// ** Date Math **
	
	// *** Addition ***
	
	function addMinutes(date, amount) {
	  return add(date, amount, "minutes");
	}
	
	function addHours(date, amount) {
	  return add(date, amount, "hours");
	}
	
	function addDays(date, amount) {
	  return add(date, amount, "days");
	}
	
	function addWeeks(date, amount) {
	  return add(date, amount, "weeks");
	}
	
	function addMonths(date, amount) {
	  return add(date, amount, "months");
	}
	
	function addYears(date, amount) {
	  return add(date, amount, "years");
	}
	
	// *** Subtraction ***
	function subtractDays(date, amount) {
	  return subtract(date, amount, "days");
	}
	
	function subtractWeeks(date, amount) {
	  return subtract(date, amount, "weeks");
	}
	
	function subtractMonths(date, amount) {
	  return subtract(date, amount, "months");
	}
	
	function subtractYears(date, amount) {
	  return subtract(date, amount, "years");
	}
	
	// ** Date Comparison **
	
	function isBefore(date1, date2) {
	  return date1.isBefore(date2);
	}
	
	function isAfter(date1, date2) {
	  return date1.isAfter(date2);
	}
	
	
	
	function isSameYear(date1, date2) {
	  if (date1 && date2) {
	    return date1.isSame(date2, "year");
	  } else {
	    return !date1 && !date2;
	  }
	}
	
	function isSameMonth(date1, date2) {
	  if (date1 && date2) {
	    return date1.isSame(date2, "month");
	  } else {
	    return !date1 && !date2;
	  }
	}
	
	function isSameDay(moment1, moment2) {
	  if (moment1 && moment2) {
	    return moment1.isSame(moment2, "day");
	  } else {
	    return !moment1 && !moment2;
	  }
	}
	
	
	
	function isDayInRange(day, startDate, endDate) {
	  var before = startDate.clone().startOf("day").subtract(1, "seconds");
	  var after = endDate.clone().startOf("day").add(1, "seconds");
	  return day.clone().startOf("day").isBetween(before, after);
	}
	
	// *** Diffing ***
	
	
	
	// ** Date Localization **
	
	function localizeDate(date, locale) {
	  return date.clone().locale(locale || moment.locale());
	}
	
	
	
	
	
	
	
	function getLocaleData(date) {
	  return date.localeData();
	}
	
	function getLocaleDataForLocale(locale) {
	  return moment.localeData(locale);
	}
	
	function getWeekdayMinInLocale(locale, date) {
	  return locale.weekdaysMin(date);
	}
	
	function getWeekdayShortInLocale(locale, date) {
	  return locale.weekdaysShort(date);
	}
	
	// TODO what is this format exactly?
	function getMonthInLocale(locale, date, format) {
	  return locale.months(date, format);
	}
	
	function getMonthShortInLocale(locale, date) {
	  return locale.monthsShort(date);
	}
	
	// ** Utils for some components **
	
	function isDayDisabled(day) {
	  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      minDate = _ref4.minDate,
	      maxDate = _ref4.maxDate,
	      excludeDates = _ref4.excludeDates,
	      includeDates = _ref4.includeDates,
	      filterDate = _ref4.filterDate;
	
	  return minDate && day.isBefore(minDate, "day") || maxDate && day.isAfter(maxDate, "day") || excludeDates && excludeDates.some(function (excludeDate) {
	    return isSameDay(day, excludeDate);
	  }) || includeDates && !includeDates.some(function (includeDate) {
	    return isSameDay(day, includeDate);
	  }) || filterDate && !filterDate(day.clone()) || false;
	}
	
	function isTimeDisabled(time, disabledTimes) {
	  var l = disabledTimes.length;
	  for (var i = 0; i < l; i++) {
	    if (disabledTimes[i].get("hours") === time.get("hours") && disabledTimes[i].get("minutes") === time.get("minutes")) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function isTimeInDisabledRange(time, _ref5) {
	  var minTime = _ref5.minTime,
	      maxTime = _ref5.maxTime;
	
	  if (!minTime || !maxTime) {
	    throw new Error("Both minTime and maxTime props required");
	  }
	
	  var base = moment().hours(0).minutes(0).seconds(0);
	  var baseTime = base.clone().hours(time.get("hours")).minutes(time.get("minutes"));
	  var min = base.clone().hours(minTime.get("hours")).minutes(minTime.get("minutes"));
	  var max = base.clone().hours(maxTime.get("hours")).minutes(maxTime.get("minutes"));
	
	  return !(baseTime.isSameOrAfter(min) && baseTime.isSameOrBefore(max));
	}
	
	function allDaysDisabledBefore(day, unit) {
	  var _ref6 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      minDate = _ref6.minDate,
	      includeDates = _ref6.includeDates;
	
	  var dateBefore = day.clone().subtract(1, unit);
	  return minDate && dateBefore.isBefore(minDate, unit) || includeDates && includeDates.every(function (includeDate) {
	    return dateBefore.isBefore(includeDate, unit);
	  }) || false;
	}
	
	function allDaysDisabledAfter(day, unit) {
	  var _ref7 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      maxDate = _ref7.maxDate,
	      includeDates = _ref7.includeDates;
	
	  var dateAfter = day.clone().add(1, unit);
	  return maxDate && dateAfter.isAfter(maxDate, unit) || includeDates && includeDates.every(function (includeDate) {
	    return dateAfter.isAfter(includeDate, unit);
	  }) || false;
	}
	
	function getEffectiveMinDate(_ref8) {
	  var minDate = _ref8.minDate,
	      includeDates = _ref8.includeDates;
	
	  if (includeDates && minDate) {
	    return moment.min(includeDates.filter(function (includeDate) {
	      return minDate.isSameOrBefore(includeDate, "day");
	    }));
	  } else if (includeDates) {
	    return moment.min(includeDates);
	  } else {
	    return minDate;
	  }
	}
	
	function getEffectiveMaxDate(_ref9) {
	  var maxDate = _ref9.maxDate,
	      includeDates = _ref9.includeDates;
	
	  if (includeDates && maxDate) {
	    return moment.max(includeDates.filter(function (includeDate) {
	      return maxDate.isSameOrAfter(includeDate, "day");
	    }));
	  } else if (includeDates) {
	    return moment.max(includeDates);
	  } else {
	    return maxDate;
	  }
	}
	
	function getHightLightDaysMap() {
	  var highlightDates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var defaultClassName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "react-datepicker__day--highlighted";
	
	  var dateClasses = new Map();
	  for (var i = 0, len = highlightDates.length; i < len; i++) {
	    var obj = highlightDates[i];
	    if (isMoment(obj)) {
	      var key = obj.format("MM.DD.YYYY");
	      var classNamesArr = dateClasses.get(key) || [];
	      if (!classNamesArr.includes(defaultClassName)) {
	        classNamesArr.push(defaultClassName);
	        dateClasses.set(key, classNamesArr);
	      }
	    } else if ((typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object") {
	      var keys = Object.keys(obj);
	      var className = keys[0];
	      var arrOfMoments = obj[keys[0]];
	      if (typeof className === "string" && arrOfMoments.constructor === Array) {
	        for (var k = 0, _len = arrOfMoments.length; k < _len; k++) {
	          var _key = arrOfMoments[k].format("MM.DD.YYYY");
	          var _classNamesArr = dateClasses.get(_key) || [];
	          if (!_classNamesArr.includes(className)) {
	            _classNamesArr.push(className);
	            dateClasses.set(_key, _classNamesArr);
	          }
	        }
	      }
	    }
	  }
	
	  return dateClasses;
	}
	
	function timesToInjectAfter(startOfDay, currentTime, currentMultiplier, intervals, injectedTimes) {
	  var l = injectedTimes.length;
	  var times = [];
	  for (var i = 0; i < l; i++) {
	    var injectedTime = addMinutes(addHours(cloneDate(startOfDay), getHour(injectedTimes[i])), getMinute(injectedTimes[i]));
	    var nextTime = addMinutes(cloneDate(startOfDay), (currentMultiplier + 1) * intervals);
	
	    if (injectedTime.isBetween(currentTime, nextTime)) {
	      times.push(injectedTimes[i]);
	    }
	  }
	
	  return times;
	}
	
	var WrappedYearDropdownOptions = onClickOutside(YearDropdownOptions);
	
	var YearDropdown = function (_React$Component) {
	  inherits(YearDropdown, _React$Component);
	
	  function YearDropdown() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, YearDropdown);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      dropdownVisible: false
	    }, _this.renderSelectOptions = function () {
	      var minYear = _this.props.minDate ? getYear(_this.props.minDate) : 1900;
	      var maxYear = _this.props.maxDate ? getYear(_this.props.maxDate) : 2100;
	
	      var options = [];
	      for (var i = minYear; i <= maxYear; i++) {
	        options.push(React.createElement(
	          "option",
	          { key: i, value: i },
	          i
	        ));
	      }
	      return options;
	    }, _this.onSelectChange = function (e) {
	      _this.onChange(e.target.value);
	    }, _this.renderSelectMode = function () {
	      return React.createElement(
	        "select",
	        {
	          value: _this.props.year,
	          className: "react-datepicker__year-select",
	          onChange: _this.onSelectChange
	        },
	        _this.renderSelectOptions()
	      );
	    }, _this.renderReadView = function (visible) {
	      return React.createElement(
	        "div",
	        {
	          key: "read",
	          style: { visibility: visible ? "visible" : "hidden" },
	          className: "react-datepicker__year-read-view",
	          onClick: function onClick(event) {
	            return _this.toggleDropdown(event);
	          }
	        },
	        React.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }),
	        React.createElement(
	          "span",
	          { className: "react-datepicker__year-read-view--selected-year" },
	          _this.props.year
	        )
	      );
	    }, _this.renderDropdown = function () {
	      return React.createElement(WrappedYearDropdownOptions, {
	        key: "dropdown",
	        ref: "options",
	        year: _this.props.year,
	        onChange: _this.onChange,
	        onCancel: _this.toggleDropdown,
	        minDate: _this.props.minDate,
	        maxDate: _this.props.maxDate,
	        scrollableYearDropdown: _this.props.scrollableYearDropdown,
	        yearDropdownItemNumber: _this.props.yearDropdownItemNumber
	      });
	    }, _this.renderScrollMode = function () {
	      var dropdownVisible = _this.state.dropdownVisible;
	
	      var result = [_this.renderReadView(!dropdownVisible)];
	      if (dropdownVisible) {
	        result.unshift(_this.renderDropdown());
	      }
	      return result;
	    }, _this.onChange = function (year) {
	      _this.toggleDropdown();
	      if (year === _this.props.year) return;
	      _this.props.onChange(year);
	    }, _this.toggleDropdown = function (event) {
	      _this.setState({
	        dropdownVisible: !_this.state.dropdownVisible
	      }, function () {
	        if (_this.props.adjustDateOnChange) {
	          _this.handleYearChange(_this.props.date, event);
	        }
	      });
	    }, _this.handleYearChange = function (date, event) {
	      _this.onSelect(date, event);
	      _this.setOpen();
	    }, _this.onSelect = function (date, event) {
	      if (_this.props.onSelect) {
	        _this.props.onSelect(date, event);
	      }
	    }, _this.setOpen = function () {
	      if (_this.props.setOpen) {
	        _this.props.setOpen(true);
	      }
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  YearDropdown.prototype.render = function render() {
	    var renderedDropdown = void 0;
	    switch (this.props.dropdownMode) {
	      case "scroll":
	        renderedDropdown = this.renderScrollMode();
	        break;
	      case "select":
	        renderedDropdown = this.renderSelectMode();
	        break;
	    }
	
	    return React.createElement(
	      "div",
	      {
	        className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--" + this.props.dropdownMode
	      },
	      renderedDropdown
	    );
	  };
	
	  return YearDropdown;
	}(React.Component);
	
	YearDropdown.propTypes = {
	  adjustDateOnChange: PropTypes.bool,
	  dropdownMode: PropTypes.oneOf(["scroll", "select"]).isRequired,
	  maxDate: PropTypes.object,
	  minDate: PropTypes.object,
	  onChange: PropTypes.func.isRequired,
	  scrollableYearDropdown: PropTypes.bool,
	  year: PropTypes.number.isRequired,
	  yearDropdownItemNumber: PropTypes.number,
	  date: PropTypes.object,
	  onSelect: PropTypes.func,
	  setOpen: PropTypes.func
	};
	
	var MonthDropdownOptions = function (_React$Component) {
	  inherits(MonthDropdownOptions, _React$Component);
	
	  function MonthDropdownOptions() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, MonthDropdownOptions);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.renderOptions = function () {
	      return _this.props.monthNames.map(function (month, i) {
	        return React.createElement(
	          "div",
	          {
	            className: _this.props.month === i ? "react-datepicker__month-option --selected_month" : "react-datepicker__month-option",
	            key: month,
	            ref: month,
	            onClick: _this.onChange.bind(_this, i)
	          },
	          _this.props.month === i ? React.createElement(
	            "span",
	            { className: "react-datepicker__month-option--selected" },
	            "\u2713"
	          ) : "",
	          month
	        );
	      });
	    }, _this.onChange = function (month) {
	      return _this.props.onChange(month);
	    }, _this.handleClickOutside = function () {
	      return _this.props.onCancel();
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  MonthDropdownOptions.prototype.render = function render() {
	    return React.createElement(
	      "div",
	      { className: "react-datepicker__month-dropdown" },
	      this.renderOptions()
	    );
	  };
	
	  return MonthDropdownOptions;
	}(React.Component);
	
	MonthDropdownOptions.propTypes = {
	  onCancel: PropTypes.func.isRequired,
	  onChange: PropTypes.func.isRequired,
	  month: PropTypes.number.isRequired,
	  monthNames: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired
	};
	
	var WrappedMonthDropdownOptions = onClickOutside(MonthDropdownOptions);
	
	var MonthDropdown = function (_React$Component) {
	  inherits(MonthDropdown, _React$Component);
	
	  function MonthDropdown() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, MonthDropdown);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      dropdownVisible: false
	    }, _this.renderSelectOptions = function (monthNames) {
	      return monthNames.map(function (M, i) {
	        return React.createElement(
	          "option",
	          { key: i, value: i },
	          M
	        );
	      });
	    }, _this.renderSelectMode = function (monthNames) {
	      return React.createElement(
	        "select",
	        {
	          value: _this.props.month,
	          className: "react-datepicker__month-select",
	          onChange: function onChange(e) {
	            return _this.onChange(e.target.value);
	          }
	        },
	        _this.renderSelectOptions(monthNames)
	      );
	    }, _this.renderReadView = function (visible, monthNames) {
	      return React.createElement(
	        "div",
	        {
	          key: "read",
	          style: { visibility: visible ? "visible" : "hidden" },
	          className: "react-datepicker__month-read-view",
	          onClick: _this.toggleDropdown
	        },
	        React.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }),
	        React.createElement(
	          "span",
	          { className: "react-datepicker__month-read-view--selected-month" },
	          monthNames[_this.props.month]
	        )
	      );
	    }, _this.renderDropdown = function (monthNames) {
	      return React.createElement(WrappedMonthDropdownOptions, {
	        key: "dropdown",
	        ref: "options",
	        month: _this.props.month,
	        monthNames: monthNames,
	        onChange: _this.onChange,
	        onCancel: _this.toggleDropdown
	      });
	    }, _this.renderScrollMode = function (monthNames) {
	      var dropdownVisible = _this.state.dropdownVisible;
	
	      var result = [_this.renderReadView(!dropdownVisible, monthNames)];
	      if (dropdownVisible) {
	        result.unshift(_this.renderDropdown(monthNames));
	      }
	      return result;
	    }, _this.onChange = function (month) {
	      _this.toggleDropdown();
	      if (month !== _this.props.month) {
	        _this.props.onChange(month);
	      }
	    }, _this.toggleDropdown = function () {
	      return _this.setState({
	        dropdownVisible: !_this.state.dropdownVisible
	      });
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  MonthDropdown.prototype.render = function render() {
	    var _this2 = this;
	
	    var localeData = getLocaleDataForLocale(this.props.locale);
	    var monthNames = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function (M) {
	      return getMonthShortInLocale(localeData, newDate({ M: M }));
	    } : function (M) {
	      return getMonthInLocale(localeData, newDate({ M: M }), _this2.props.dateFormat);
	    });
	
	    var renderedDropdown = void 0;
	    switch (this.props.dropdownMode) {
	      case "scroll":
	        renderedDropdown = this.renderScrollMode(monthNames);
	        break;
	      case "select":
	        renderedDropdown = this.renderSelectMode(monthNames);
	        break;
	    }
	
	    return React.createElement(
	      "div",
	      {
	        className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--" + this.props.dropdownMode
	      },
	      renderedDropdown
	    );
	  };
	
	  return MonthDropdown;
	}(React.Component);
	
	MonthDropdown.propTypes = {
	  dropdownMode: PropTypes.oneOf(["scroll", "select"]).isRequired,
	  locale: PropTypes.string,
	  dateFormat: PropTypes.string.isRequired,
	  month: PropTypes.number.isRequired,
	  onChange: PropTypes.func.isRequired,
	  useShortMonthInDropdown: PropTypes.bool
	};
	
	function generateMonthYears(minDate, maxDate) {
	  var list = [];
	
	  var currDate = getStartOfMonth(cloneDate(minDate));
	  var lastDate = getStartOfMonth(cloneDate(maxDate));
	
	  while (!isAfter(currDate, lastDate)) {
	    list.push(cloneDate(currDate));
	
	    addMonths(currDate, 1);
	  }
	
	  return list;
	}
	
	var MonthYearDropdownOptions = function (_React$Component) {
	  inherits(MonthYearDropdownOptions, _React$Component);
	
	  function MonthYearDropdownOptions(props) {
	    classCallCheck(this, MonthYearDropdownOptions);
	
	    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.renderOptions = function () {
	      return _this.state.monthYearsList.map(function (monthYear) {
	        var monthYearPoint = monthYear.valueOf();
	
	        var isSameMonthYear = isSameYear(_this.props.date, monthYear) && isSameMonth(_this.props.date, monthYear);
	
	        return React.createElement(
	          "div",
	          {
	            className: isSameMonthYear ? "react-datepicker__month-year-option --selected_month-year" : "react-datepicker__month-year-option",
	            key: monthYearPoint,
	            ref: monthYearPoint,
	            onClick: _this.onChange.bind(_this, monthYearPoint)
	          },
	          isSameMonthYear ? React.createElement(
	            "span",
	            { className: "react-datepicker__month-year-option--selected" },
	            "\u2713"
	          ) : "",
	          formatDate(monthYear, _this.props.dateFormat)
	        );
	      });
	    };
	
	    _this.onChange = function (monthYear) {
	      return _this.props.onChange(monthYear);
	    };
	
	    _this.handleClickOutside = function () {
	      _this.props.onCancel();
	    };
	
	    _this.state = {
	      monthYearsList: generateMonthYears(_this.props.minDate, _this.props.maxDate)
	    };
	    return _this;
	  }
	
	  MonthYearDropdownOptions.prototype.render = function render() {
	    var dropdownClass = classnames({
	      "react-datepicker__month-year-dropdown": true,
	      "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
	    });
	
	    return React.createElement(
	      "div",
	      { className: dropdownClass },
	      this.renderOptions()
	    );
	  };
	
	  return MonthYearDropdownOptions;
	}(React.Component);
	
	MonthYearDropdownOptions.propTypes = {
	  minDate: PropTypes.object.isRequired,
	  maxDate: PropTypes.object.isRequired,
	  onCancel: PropTypes.func.isRequired,
	  onChange: PropTypes.func.isRequired,
	  scrollableMonthYearDropdown: PropTypes.bool,
	  date: PropTypes.object.isRequired,
	  dateFormat: PropTypes.string.isRequired
	};
	
	var WrappedMonthYearDropdownOptions = onClickOutside(MonthYearDropdownOptions);
	
	var MonthYearDropdown = function (_React$Component) {
	  inherits(MonthYearDropdown, _React$Component);
	
	  function MonthYearDropdown() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, MonthYearDropdown);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      dropdownVisible: false
	    }, _this.renderSelectOptions = function () {
	      var currDate = getStartOfMonth(localizeDate(_this.props.minDate, _this.props.locale));
	      var lastDate = getStartOfMonth(localizeDate(_this.props.maxDate, _this.props.locale));
	
	      var options = [];
	
	      while (!isAfter(currDate, lastDate)) {
	        var timepoint = currDate.valueOf();
	        options.push(React.createElement(
	          "option",
	          { key: timepoint, value: timepoint },
	          formatDate(currDate, _this.props.dateFormat)
	        ));
	
	        addMonths(currDate, 1);
	      }
	
	      return options;
	    }, _this.onSelectChange = function (e) {
	      _this.onChange(e.target.value);
	    }, _this.renderSelectMode = function () {
	      return React.createElement(
	        "select",
	        {
	          value: getStartOfMonth(_this.props.date).valueOf(),
	          className: "react-datepicker__month-year-select",
	          onChange: _this.onSelectChange
	        },
	        _this.renderSelectOptions()
	      );
	    }, _this.renderReadView = function (visible) {
	      var yearMonth = formatDate(localizeDate(newDate(_this.props.date), _this.props.locale), _this.props.dateFormat);
	
	      return React.createElement(
	        "div",
	        {
	          key: "read",
	          style: { visibility: visible ? "visible" : "hidden" },
	          className: "react-datepicker__month-year-read-view",
	          onClick: function onClick(event) {
	            return _this.toggleDropdown(event);
	          }
	        },
	        React.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }),
	        React.createElement(
	          "span",
	          { className: "react-datepicker__month-year-read-view--selected-month-year" },
	          yearMonth
	        )
	      );
	    }, _this.renderDropdown = function () {
	      return React.createElement(WrappedMonthYearDropdownOptions, {
	        key: "dropdown",
	        ref: "options",
	        date: _this.props.date,
	        dateFormat: _this.props.dateFormat,
	        onChange: _this.onChange,
	        onCancel: _this.toggleDropdown,
	        minDate: localizeDate(_this.props.minDate, _this.props.locale),
	        maxDate: localizeDate(_this.props.maxDate, _this.props.locale),
	        scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown
	      });
	    }, _this.renderScrollMode = function () {
	      var dropdownVisible = _this.state.dropdownVisible;
	
	      var result = [_this.renderReadView(!dropdownVisible)];
	      if (dropdownVisible) {
	        result.unshift(_this.renderDropdown());
	      }
	      return result;
	    }, _this.onChange = function (monthYearPoint) {
	      _this.toggleDropdown();
	
	      var changedDate = newDate(parseInt(monthYearPoint));
	
	      if (isSameYear(_this.props.date, changedDate) && isSameMonth(_this.props.date, changedDate)) {
	        return;
	      }
	
	      _this.props.onChange(changedDate);
	    }, _this.toggleDropdown = function () {
	      return _this.setState({
	        dropdownVisible: !_this.state.dropdownVisible
	      });
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  MonthYearDropdown.prototype.render = function render() {
	    var renderedDropdown = void 0;
	    switch (this.props.dropdownMode) {
	      case "scroll":
	        renderedDropdown = this.renderScrollMode();
	        break;
	      case "select":
	        renderedDropdown = this.renderSelectMode();
	        break;
	    }
	
	    return React.createElement(
	      "div",
	      {
	        className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--" + this.props.dropdownMode
	      },
	      renderedDropdown
	    );
	  };
	
	  return MonthYearDropdown;
	}(React.Component);
	
	MonthYearDropdown.propTypes = {
	  dropdownMode: PropTypes.oneOf(["scroll", "select"]).isRequired,
	  dateFormat: PropTypes.string.isRequired,
	  locale: PropTypes.string,
	  maxDate: PropTypes.object.isRequired,
	  minDate: PropTypes.object.isRequired,
	  date: PropTypes.object.isRequired,
	  onChange: PropTypes.func.isRequired,
	  scrollableMonthYearDropdown: PropTypes.bool
	};
	
	var Day = function (_React$Component) {
	  inherits(Day, _React$Component);
	
	  function Day() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Day);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (!_this.isDisabled() && _this.props.onClick) {
	        _this.props.onClick(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.isDisabled() && _this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.isSameDay = function (other) {
	      return isSameDay(_this.props.day, other);
	    }, _this.isKeyboardSelected = function () {
	      return !_this.props.inline && !_this.isSameDay(_this.props.selected) && _this.isSameDay(_this.props.preSelection);
	    }, _this.isDisabled = function () {
	      return isDayDisabled(_this.props.day, _this.props);
	    }, _this.getHighLightedClass = function (defaultClassName) {
	      var _this$props = _this.props,
	          day = _this$props.day,
	          highlightDates = _this$props.highlightDates;
	
	
	      if (!highlightDates) {
	        return false;
	      }
	
	      // Looking for className in the Map of {'day string, 'className'}
	      var dayStr = day.format("MM.DD.YYYY");
	      return highlightDates.get(dayStr);
	    }, _this.isInRange = function () {
	      var _this$props2 = _this.props,
	          day = _this$props2.day,
	          startDate = _this$props2.startDate,
	          endDate = _this$props2.endDate;
	
	      if (!startDate || !endDate) {
	        return false;
	      }
	      return isDayInRange(day, startDate, endDate);
	    }, _this.isInSelectingRange = function () {
	      var _this$props3 = _this.props,
	          day = _this$props3.day,
	          selectsStart = _this$props3.selectsStart,
	          selectsEnd = _this$props3.selectsEnd,
	          selectingDate = _this$props3.selectingDate,
	          startDate = _this$props3.startDate,
	          endDate = _this$props3.endDate;
	
	
	      if (!(selectsStart || selectsEnd) || !selectingDate || _this.isDisabled()) {
	        return false;
	      }
	
	      if (selectsStart && endDate && selectingDate.isSameOrBefore(endDate)) {
	        return isDayInRange(day, selectingDate, endDate);
	      }
	
	      if (selectsEnd && startDate && selectingDate.isSameOrAfter(startDate)) {
	        return isDayInRange(day, startDate, selectingDate);
	      }
	
	      return false;
	    }, _this.isSelectingRangeStart = function () {
	      if (!_this.isInSelectingRange()) {
	        return false;
	      }
	
	      var _this$props4 = _this.props,
	          day = _this$props4.day,
	          selectingDate = _this$props4.selectingDate,
	          startDate = _this$props4.startDate,
	          selectsStart = _this$props4.selectsStart;
	
	
	      if (selectsStart) {
	        return isSameDay(day, selectingDate);
	      } else {
	        return isSameDay(day, startDate);
	      }
	    }, _this.isSelectingRangeEnd = function () {
	      if (!_this.isInSelectingRange()) {
	        return false;
	      }
	
	      var _this$props5 = _this.props,
	          day = _this$props5.day,
	          selectingDate = _this$props5.selectingDate,
	          endDate = _this$props5.endDate,
	          selectsEnd = _this$props5.selectsEnd;
	
	
	      if (selectsEnd) {
	        return isSameDay(day, selectingDate);
	      } else {
	        return isSameDay(day, endDate);
	      }
	    }, _this.isRangeStart = function () {
	      var _this$props6 = _this.props,
	          day = _this$props6.day,
	          startDate = _this$props6.startDate,
	          endDate = _this$props6.endDate;
	
	      if (!startDate || !endDate) {
	        return false;
	      }
	      return isSameDay(startDate, day);
	    }, _this.isRangeEnd = function () {
	      var _this$props7 = _this.props,
	          day = _this$props7.day,
	          startDate = _this$props7.startDate,
	          endDate = _this$props7.endDate;
	
	      if (!startDate || !endDate) {
	        return false;
	      }
	      return isSameDay(endDate, day);
	    }, _this.isWeekend = function () {
	      var weekday = getDay(_this.props.day);
	      return weekday === 0 || weekday === 6;
	    }, _this.isOutsideMonth = function () {
	      return _this.props.month !== undefined && _this.props.month !== getMonth(_this.props.day);
	    }, _this.getClassNames = function (date) {
	      var dayClassName = _this.props.dayClassName ? _this.props.dayClassName(date) : undefined;
	      return classnames("react-datepicker__day", dayClassName, "react-datepicker__day--" + getDayOfWeekCode(_this.props.day), {
	        "react-datepicker__day--disabled": _this.isDisabled(),
	        "react-datepicker__day--selected": _this.isSameDay(_this.props.selected),
	        "react-datepicker__day--keyboard-selected": _this.isKeyboardSelected(),
	        "react-datepicker__day--range-start": _this.isRangeStart(),
	        "react-datepicker__day--range-end": _this.isRangeEnd(),
	        "react-datepicker__day--in-range": _this.isInRange(),
	        "react-datepicker__day--in-selecting-range": _this.isInSelectingRange(),
	        "react-datepicker__day--selecting-range-start": _this.isSelectingRangeStart(),
	        "react-datepicker__day--selecting-range-end": _this.isSelectingRangeEnd(),
	        "react-datepicker__day--today": _this.isSameDay(now(_this.props.utcOffset)),
	        "react-datepicker__day--weekend": _this.isWeekend(),
	        "react-datepicker__day--outside-month": _this.isOutsideMonth()
	      }, _this.getHighLightedClass("react-datepicker__day--highlighted"));
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  Day.prototype.render = function render() {
	    return React.createElement(
	      "div",
	      {
	        className: this.getClassNames(this.props.day),
	        onClick: this.handleClick,
	        onMouseEnter: this.handleMouseEnter,
	        "aria-label": "day-" + getDate(this.props.day),
	        role: "option"
	      },
	      getDate(this.props.day)
	    );
	  };
	
	  return Day;
	}(React.Component);
	
	Day.propTypes = {
	  day: PropTypes.object.isRequired,
	  dayClassName: PropTypes.func,
	  endDate: PropTypes.object,
	  highlightDates: PropTypes.instanceOf(Map),
	  inline: PropTypes.bool,
	  month: PropTypes.number,
	  onClick: PropTypes.func,
	  onMouseEnter: PropTypes.func,
	  preSelection: PropTypes.object,
	  selected: PropTypes.object,
	  selectingDate: PropTypes.object,
	  selectsEnd: PropTypes.bool,
	  selectsStart: PropTypes.bool,
	  startDate: PropTypes.object,
	  utcOffset: PropTypes.number
	};
	
	var WeekNumber = function (_React$Component) {
	  inherits(WeekNumber, _React$Component);
	
	  function WeekNumber() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, WeekNumber);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(event);
	      }
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  WeekNumber.prototype.render = function render() {
	    var weekNumberClasses = {
	      "react-datepicker__week-number": true,
	      "react-datepicker__week-number--clickable": !!this.props.onClick
	    };
	    return React.createElement(
	      "div",
	      {
	        className: classnames(weekNumberClasses),
	        "aria-label": "week-" + this.props.weekNumber,
	        onClick: this.handleClick
	      },
	      this.props.weekNumber
	    );
	  };
	
	  return WeekNumber;
	}(React.Component);
	
	WeekNumber.propTypes = {
	  weekNumber: PropTypes.number.isRequired,
	  onClick: PropTypes.func
	};
	
	var Week = function (_React$Component) {
	  inherits(Week, _React$Component);
	
	  function Week() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Week);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleDayClick = function (day, event) {
	      if (_this.props.onDayClick) {
	        _this.props.onDayClick(day, event);
	      }
	    }, _this.handleDayMouseEnter = function (day) {
	      if (_this.props.onDayMouseEnter) {
	        _this.props.onDayMouseEnter(day);
	      }
	    }, _this.handleWeekClick = function (day, weekNumber, event) {
	      if (typeof _this.props.onWeekSelect === "function") {
	        _this.props.onWeekSelect(day, weekNumber, event);
	      }
	    }, _this.formatWeekNumber = function (startOfWeek) {
	      if (_this.props.formatWeekNumber) {
	        return _this.props.formatWeekNumber(startOfWeek);
	      }
	      return getWeek(startOfWeek);
	    }, _this.renderDays = function () {
	      var startOfWeek = getStartOfWeek(cloneDate(_this.props.day));
	      var days = [];
	      var weekNumber = _this.formatWeekNumber(startOfWeek);
	      if (_this.props.showWeekNumber) {
	        var onClickAction = _this.props.onWeekSelect ? _this.handleWeekClick.bind(_this, startOfWeek, weekNumber) : undefined;
	        days.push(React.createElement(WeekNumber, { key: "W", weekNumber: weekNumber, onClick: onClickAction }));
	      }
	      return days.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
	        var day = addDays(cloneDate(startOfWeek), offset);
	        return React.createElement(Day, {
	          key: offset,
	          day: day,
	          month: _this.props.month,
	          onClick: _this.handleDayClick.bind(_this, day),
	          onMouseEnter: _this.handleDayMouseEnter.bind(_this, day),
	          minDate: _this.props.minDate,
	          maxDate: _this.props.maxDate,
	          excludeDates: _this.props.excludeDates,
	          includeDates: _this.props.includeDates,
	          inline: _this.props.inline,
	          highlightDates: _this.props.highlightDates,
	          selectingDate: _this.props.selectingDate,
	          filterDate: _this.props.filterDate,
	          preSelection: _this.props.preSelection,
	          selected: _this.props.selected,
	          selectsStart: _this.props.selectsStart,
	          selectsEnd: _this.props.selectsEnd,
	          startDate: _this.props.startDate,
	          endDate: _this.props.endDate,
	          dayClassName: _this.props.dayClassName,
	          utcOffset: _this.props.utcOffset
	        });
	      }));
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  Week.prototype.render = function render() {
	    return React.createElement(
	      "div",
	      { className: "react-datepicker__week" },
	      this.renderDays()
	    );
	  };
	
	  return Week;
	}(React.Component);
	
	Week.propTypes = {
	  day: PropTypes.object.isRequired,
	  dayClassName: PropTypes.func,
	  endDate: PropTypes.object,
	  excludeDates: PropTypes.array,
	  filterDate: PropTypes.func,
	  formatWeekNumber: PropTypes.func,
	  highlightDates: PropTypes.instanceOf(Map),
	  includeDates: PropTypes.array,
	  inline: PropTypes.bool,
	  maxDate: PropTypes.object,
	  minDate: PropTypes.object,
	  month: PropTypes.number,
	  onDayClick: PropTypes.func,
	  onDayMouseEnter: PropTypes.func,
	  onWeekSelect: PropTypes.func,
	  preSelection: PropTypes.object,
	  selected: PropTypes.object,
	  selectingDate: PropTypes.object,
	  selectsEnd: PropTypes.bool,
	  selectsStart: PropTypes.bool,
	  showWeekNumber: PropTypes.bool,
	  startDate: PropTypes.object,
	  utcOffset: PropTypes.number
	};
	
	var FIXED_HEIGHT_STANDARD_WEEK_COUNT = 6;
	
	var Month = function (_React$Component) {
	  inherits(Month, _React$Component);
	
	  function Month() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Month);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleDayClick = function (day, event) {
	      if (_this.props.onDayClick) {
	        _this.props.onDayClick(day, event);
	      }
	    }, _this.handleDayMouseEnter = function (day) {
	      if (_this.props.onDayMouseEnter) {
	        _this.props.onDayMouseEnter(day);
	      }
	    }, _this.handleMouseLeave = function () {
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave();
	      }
	    }, _this.isWeekInMonth = function (startOfWeek) {
	      var day = _this.props.day;
	      var endOfWeek = addDays(cloneDate(startOfWeek), 6);
	      return isSameMonth(startOfWeek, day) || isSameMonth(endOfWeek, day);
	    }, _this.renderWeeks = function () {
	      var weeks = [];
	      var isFixedHeight = _this.props.fixedHeight;
	      var currentWeekStart = getStartOfWeek(getStartOfMonth(cloneDate(_this.props.day)));
	      var i = 0;
	      var breakAfterNextPush = false;
	
	      while (true) {
	        weeks.push(React.createElement(Week, {
	          key: i,
	          day: currentWeekStart,
	          month: getMonth(_this.props.day),
	          onDayClick: _this.handleDayClick,
	          onDayMouseEnter: _this.handleDayMouseEnter,
	          onWeekSelect: _this.props.onWeekSelect,
	          formatWeekNumber: _this.props.formatWeekNumber,
	          minDate: _this.props.minDate,
	          maxDate: _this.props.maxDate,
	          excludeDates: _this.props.excludeDates,
	          includeDates: _this.props.includeDates,
	          inline: _this.props.inline,
	          highlightDates: _this.props.highlightDates,
	          selectingDate: _this.props.selectingDate,
	          filterDate: _this.props.filterDate,
	          preSelection: _this.props.preSelection,
	          selected: _this.props.selected,
	          selectsStart: _this.props.selectsStart,
	          selectsEnd: _this.props.selectsEnd,
	          showWeekNumber: _this.props.showWeekNumbers,
	          startDate: _this.props.startDate,
	          endDate: _this.props.endDate,
	          dayClassName: _this.props.dayClassName,
	          utcOffset: _this.props.utcOffset
	        }));
	
	        if (breakAfterNextPush) break;
	
	        i++;
	        currentWeekStart = addWeeks(cloneDate(currentWeekStart), 1);
	
	        // If one of these conditions is true, we will either break on this week
	        // or break on the next week
	        var isFixedAndFinalWeek = isFixedHeight && i >= FIXED_HEIGHT_STANDARD_WEEK_COUNT;
	        var isNonFixedAndOutOfMonth = !isFixedHeight && !_this.isWeekInMonth(currentWeekStart);
	
	        if (isFixedAndFinalWeek || isNonFixedAndOutOfMonth) {
	          if (_this.props.peekNextMonth) {
	            breakAfterNextPush = true;
	          } else {
	            break;
	          }
	        }
	      }
	
	      return weeks;
	    }, _this.getClassNames = function () {
	      var _this$props = _this.props,
	          selectingDate = _this$props.selectingDate,
	          selectsStart = _this$props.selectsStart,
	          selectsEnd = _this$props.selectsEnd;
	
	      return classnames("react-datepicker__month", {
	        "react-datepicker__month--selecting-range": selectingDate && (selectsStart || selectsEnd)
	      });
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  Month.prototype.render = function render() {
	    return React.createElement(
	      "div",
	      {
	        className: this.getClassNames(),
	        onMouseLeave: this.handleMouseLeave,
	        role: "listbox"
	      },
	      this.renderWeeks()
	    );
	  };
	
	  return Month;
	}(React.Component);
	
	Month.propTypes = {
	  day: PropTypes.object.isRequired,
	  dayClassName: PropTypes.func,
	  endDate: PropTypes.object,
	  excludeDates: PropTypes.array,
	  filterDate: PropTypes.func,
	  fixedHeight: PropTypes.bool,
	  formatWeekNumber: PropTypes.func,
	  highlightDates: PropTypes.instanceOf(Map),
	  includeDates: PropTypes.array,
	  inline: PropTypes.bool,
	  maxDate: PropTypes.object,
	  minDate: PropTypes.object,
	  onDayClick: PropTypes.func,
	  onDayMouseEnter: PropTypes.func,
	  onMouseLeave: PropTypes.func,
	  onWeekSelect: PropTypes.func,
	  peekNextMonth: PropTypes.bool,
	  preSelection: PropTypes.object,
	  selected: PropTypes.object,
	  selectingDate: PropTypes.object,
	  selectsEnd: PropTypes.bool,
	  selectsStart: PropTypes.bool,
	  showWeekNumbers: PropTypes.bool,
	  startDate: PropTypes.object,
	  utcOffset: PropTypes.number
	};
	
	var Time = function (_React$Component) {
	  inherits(Time, _React$Component);
	
	  function Time() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Time);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (time) {
	      if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || _this.props.excludeTimes && isTimeDisabled(time, _this.props.excludeTimes) || _this.props.includeTimes && !isTimeDisabled(time, _this.props.includeTimes)) {
	        return;
	      }
	
	      _this.props.onChange(time);
	    }, _this.liClasses = function (time, currH, currM) {
	      var classes = ["react-datepicker__time-list-item"];
	
	      if (currH === getHour(time) && currM === getMinute(time)) {
	        classes.push("react-datepicker__time-list-item--selected");
	      }
	      if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || _this.props.excludeTimes && isTimeDisabled(time, _this.props.excludeTimes) || _this.props.includeTimes && !isTimeDisabled(time, _this.props.includeTimes)) {
	        classes.push("react-datepicker__time-list-item--disabled");
	      }
	      if (_this.props.injectTimes && (getHour(time) * 60 + getMinute(time)) % _this.props.intervals !== 0) {
	        classes.push("react-datepicker__time-list-item--injected");
	      }
	
	      return classes.join(" ");
	    }, _this.renderTimes = function () {
	      var times = [];
	      var format = _this.props.format ? _this.props.format : "hh:mm A";
	      var intervals = _this.props.intervals;
	      var activeTime = _this.props.selected ? _this.props.selected : newDate();
	      var currH = getHour(activeTime);
	      var currM = getMinute(activeTime);
	      var base = getStartOfDay(newDate());
	      var multiplier = 1440 / intervals;
	      var sortedInjectTimes = _this.props.injectTimes && _this.props.injectTimes.sort(function (a, b) {
	        return a - b;
	      });
	      for (var i = 0; i < multiplier; i++) {
	        var currentTime = addMinutes(cloneDate(base), i * intervals);
	        times.push(currentTime);
	
	        if (sortedInjectTimes) {
	          var timesToInject = timesToInjectAfter(base, currentTime, i, intervals, sortedInjectTimes);
	          times = times.concat(timesToInject);
	        }
	      }
	
	      return times.map(function (time, i) {
	        return React.createElement(
	          "li",
	          {
	            key: i,
	            onClick: _this.handleClick.bind(_this, time),
	            className: _this.liClasses(time, currH, currM)
	          },
	          formatDate(time, format)
	        );
	      });
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  Time.prototype.componentDidMount = function componentDidMount() {
	    // code to ensure selected time will always be in focus within time window when it first appears
	    var multiplier = 60 / this.props.intervals;
	    var currH = this.props.selected ? getHour(this.props.selected) : getHour(newDate());
	    this.list.scrollTop = 30 * (multiplier * currH);
	  };
	
	  Time.prototype.render = function render() {
	    var _this2 = this;
	
	    var height = null;
	    if (this.props.monthRef) {
	      height = this.props.monthRef.clientHeight - 39;
	    }
	
	    return React.createElement(
	      "div",
	      {
	        className: "react-datepicker__time-container " + (this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
	      },
	      React.createElement(
	        "div",
	        { className: "react-datepicker__header react-datepicker__header--time" },
	        React.createElement(
	          "div",
	          { className: "react-datepicker-time__header" },
	          this.props.timeCaption
	        )
	      ),
	      React.createElement(
	        "div",
	        { className: "react-datepicker__time" },
	        React.createElement(
	          "div",
	          { className: "react-datepicker__time-box" },
	          React.createElement(
	            "ul",
	            {
	              className: "react-datepicker__time-list",
	              ref: function ref(list) {
	                _this2.list = list;
	              },
	              style: height ? { height: height } : {}
	            },
	            this.renderTimes.bind(this)()
	          )
	        )
	      )
	    );
	  };
	
	  createClass(Time, null, [{
	    key: "defaultProps",
	    get: function get$$1() {
	      return {
	        intervals: 30,
	        onTimeChange: function onTimeChange() {},
	        todayButton: null,
	        timeCaption: "Time"
	      };
	    }
	  }]);
	  return Time;
	}(React.Component);
	
	Time.propTypes = {
	  format: PropTypes.string,
	  includeTimes: PropTypes.array,
	  intervals: PropTypes.number,
	  selected: PropTypes.object,
	  onChange: PropTypes.func,
	  todayButton: PropTypes.string,
	  minTime: PropTypes.object,
	  maxTime: PropTypes.object,
	  excludeTimes: PropTypes.array,
	  monthRef: PropTypes.object,
	  timeCaption: PropTypes.string,
	  injectTimes: PropTypes.array
	};
	
	var DROPDOWN_FOCUS_CLASSNAMES = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"];
	
	var isDropdownSelect = function isDropdownSelect() {
	  var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var classNames = (element.className || "").split(/\s+/);
	  return DROPDOWN_FOCUS_CLASSNAMES.some(function (testClassname) {
	    return classNames.indexOf(testClassname) >= 0;
	  });
	};
	
	var Calendar = function (_React$Component) {
	  inherits(Calendar, _React$Component);
	  createClass(Calendar, null, [{
	    key: "defaultProps",
	    get: function get$$1() {
	      return {
	        onDropdownFocus: function onDropdownFocus() {},
	        monthsShown: 1,
	        forceShowMonthNavigation: false,
	        timeCaption: "Time"
	      };
	    }
	  }]);
	
	  function Calendar(props) {
	    classCallCheck(this, Calendar);
	
	    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.handleClickOutside = function (event) {
	      _this.props.onClickOutside(event);
	    };
	
	    _this.handleDropdownFocus = function (event) {
	      if (isDropdownSelect(event.target)) {
	        _this.props.onDropdownFocus();
	      }
	    };
	
	    _this.getDateInView = function () {
	      var _this$props = _this.props,
	          preSelection = _this$props.preSelection,
	          selected = _this$props.selected,
	          openToDate = _this$props.openToDate,
	          utcOffset = _this$props.utcOffset;
	
	      var minDate = getEffectiveMinDate(_this.props);
	      var maxDate = getEffectiveMaxDate(_this.props);
	      var current = now(utcOffset);
	      var initialDate = openToDate || selected || preSelection;
	      if (initialDate) {
	        return initialDate;
	      } else {
	        if (minDate && isBefore(current, minDate)) {
	          return minDate;
	        } else if (maxDate && isAfter(current, maxDate)) {
	          return maxDate;
	        }
	      }
	      return current;
	    };
	
	    _this.localizeDate = function (date) {
	      return localizeDate(date, _this.props.locale);
	    };
	
	    _this.increaseMonth = function () {
	      _this.setState({
	        date: addMonths(cloneDate(_this.state.date), 1)
	      }, function () {
	        return _this.handleMonthChange(_this.state.date);
	      });
	    };
	
	    _this.decreaseMonth = function () {
	      _this.setState({
	        date: subtractMonths(cloneDate(_this.state.date), 1)
	      }, function () {
	        return _this.handleMonthChange(_this.state.date);
	      });
	    };
	
	    _this.handleDayClick = function (day, event) {
	      return _this.props.onSelect(day, event);
	    };
	
	    _this.handleDayMouseEnter = function (day) {
	      return _this.setState({ selectingDate: day });
	    };
	
	    _this.handleMonthMouseLeave = function () {
	      return _this.setState({ selectingDate: null });
	    };
	
	    _this.handleYearChange = function (date) {
	      if (_this.props.onYearChange) {
	        _this.props.onYearChange(date);
	      }
	    };
	
	    _this.handleMonthChange = function (date) {
	      if (_this.props.onMonthChange) {
	        _this.props.onMonthChange(date);
	      }
	      if (_this.props.adjustDateOnChange) {
	        if (_this.props.onSelect) {
	          _this.props.onSelect(date);
	        }
	        if (_this.props.setOpen) {
	          _this.props.setOpen(true);
	        }
	      }
	    };
	
	    _this.handleMonthYearChange = function (date) {
	      _this.handleYearChange(date);
	      _this.handleMonthChange(date);
	    };
	
	    _this.changeYear = function (year) {
	      _this.setState({
	        date: setYear(cloneDate(_this.state.date), year)
	      }, function () {
	        return _this.handleYearChange(_this.state.date);
	      });
	    };
	
	    _this.changeMonth = function (month) {
	      _this.setState({
	        date: setMonth(cloneDate(_this.state.date), month)
	      }, function () {
	        return _this.handleMonthChange(_this.state.date);
	      });
	    };
	
	    _this.changeMonthYear = function (monthYear) {
	      _this.setState({
	        date: setYear(setMonth(cloneDate(_this.state.date), getMonth(monthYear)), getYear(monthYear))
	      }, function () {
	        return _this.handleMonthYearChange(_this.state.date);
	      });
	    };
	
	    _this.header = function () {
	      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;
	
	      var startOfWeek = getStartOfWeek(cloneDate(date));
	      var dayNames = [];
	      if (_this.props.showWeekNumbers) {
	        dayNames.push(React.createElement(
	          "div",
	          { key: "W", className: "react-datepicker__day-name" },
	          _this.props.weekLabel || "#"
	        ));
	      }
	      return dayNames.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
	        var day = addDays(cloneDate(startOfWeek), offset);
	        var localeData = getLocaleData(day);
	        var weekDayName = _this.props.useWeekdaysShort ? getWeekdayShortInLocale(localeData, day) : getWeekdayMinInLocale(localeData, day);
	        return React.createElement(
	          "div",
	          { key: offset, className: "react-datepicker__day-name" },
	          weekDayName
	        );
	      }));
	    };
	
	    _this.renderPreviousMonthButton = function () {
	      var allPrevDaysDisabled = allDaysDisabledBefore(_this.state.date, "month", _this.props);
	
	      if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allPrevDaysDisabled || _this.props.showTimeSelectOnly) {
	        return;
	      }
	
	      var classes = ["react-datepicker__navigation", "react-datepicker__navigation--previous"];
	
	      var clickHandler = _this.decreaseMonth;
	
	      if (allPrevDaysDisabled && _this.props.showDisabledMonthNavigation) {
	        classes.push("react-datepicker__navigation--previous--disabled");
	        clickHandler = null;
	      }
	
	      return React.createElement("button", {
	        type: "button",
	        className: classes.join(" "),
	        onClick: clickHandler
	      });
	    };
	
	    _this.renderNextMonthButton = function () {
	      var allNextDaysDisabled = allDaysDisabledAfter(_this.state.date, "month", _this.props);
	
	      if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allNextDaysDisabled || _this.props.showTimeSelectOnly) {
	        return;
	      }
	
	      var classes = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
	      if (_this.props.showTimeSelect) {
	        classes.push("react-datepicker__navigation--next--with-time");
	      }
	      if (_this.props.todayButton) {
	        classes.push("react-datepicker__navigation--next--with-today-button");
	      }
	
	      var clickHandler = _this.increaseMonth;
	
	      if (allNextDaysDisabled && _this.props.showDisabledMonthNavigation) {
	        classes.push("react-datepicker__navigation--next--disabled");
	        clickHandler = null;
	      }
	
	      return React.createElement("button", {
	        type: "button",
	        className: classes.join(" "),
	        onClick: clickHandler
	      });
	    };
	
	    _this.renderCurrentMonth = function () {
	      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;
	
	      var classes = ["react-datepicker__current-month"];
	
	      if (_this.props.showYearDropdown) {
	        classes.push("react-datepicker__current-month--hasYearDropdown");
	      }
	      if (_this.props.showMonthDropdown) {
	        classes.push("react-datepicker__current-month--hasMonthDropdown");
	      }
	      if (_this.props.showMonthYearDropdown) {
	        classes.push("react-datepicker__current-month--hasMonthYearDropdown");
	      }
	      return React.createElement(
	        "div",
	        { className: classes.join(" ") },
	        formatDate(date, _this.props.dateFormat)
	      );
	    };
	
	    _this.renderYearDropdown = function () {
	      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (!_this.props.showYearDropdown || overrideHide) {
	        return;
	      }
	      return React.createElement(YearDropdown, {
	        adjustDateOnChange: _this.props.adjustDateOnChange,
	        date: _this.state.date,
	        onSelect: _this.props.onSelect,
	        setOpen: _this.props.setOpen,
	        dropdownMode: _this.props.dropdownMode,
	        onChange: _this.changeYear,
	        minDate: _this.props.minDate,
	        maxDate: _this.props.maxDate,
	        year: getYear(_this.state.date),
	        scrollableYearDropdown: _this.props.scrollableYearDropdown,
	        yearDropdownItemNumber: _this.props.yearDropdownItemNumber
	      });
	    };
	
	    _this.renderMonthDropdown = function () {
	      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (!_this.props.showMonthDropdown || overrideHide) {
	        return;
	      }
	      return React.createElement(MonthDropdown, {
	        dropdownMode: _this.props.dropdownMode,
	        locale: _this.props.locale,
	        dateFormat: _this.props.dateFormat,
	        onChange: _this.changeMonth,
	        month: getMonth(_this.state.date),
	        useShortMonthInDropdown: _this.props.useShortMonthInDropdown
	      });
	    };
	
	    _this.renderMonthYearDropdown = function () {
	      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (!_this.props.showMonthYearDropdown || overrideHide) {
	        return;
	      }
	      return React.createElement(MonthYearDropdown, {
	        dropdownMode: _this.props.dropdownMode,
	        locale: _this.props.locale,
	        dateFormat: _this.props.dateFormat,
	        onChange: _this.changeMonthYear,
	        minDate: _this.props.minDate,
	        maxDate: _this.props.maxDate,
	        date: _this.state.date,
	        scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown
	      });
	    };
	
	    _this.renderTodayButton = function () {
	      if (!_this.props.todayButton || _this.props.showTimeSelectOnly) {
	        return;
	      }
	      return React.createElement(
	        "div",
	        {
	          className: "react-datepicker__today-button",
	          onClick: function onClick(e) {
	            return _this.props.onSelect(getStartOfDate(now(_this.props.utcOffset)), e);
	          }
	        },
	        _this.props.todayButton
	      );
	    };
	
	    _this.renderMonths = function () {
	      if (_this.props.showTimeSelectOnly) {
	        return;
	      }
	
	      var monthList = [];
	      for (var i = 0; i < _this.props.monthsShown; ++i) {
	        var monthDate = addMonths(cloneDate(_this.state.date), i);
	        var monthKey = "month-" + i;
	        monthList.push(React.createElement(
	          "div",
	          {
	            key: monthKey,
	            ref: function ref(div) {
	              _this.monthContainer = div;
	            },
	            className: "react-datepicker__month-container"
	          },
	          React.createElement(
	            "div",
	            { className: "react-datepicker__header" },
	            _this.renderCurrentMonth(monthDate),
	            React.createElement(
	              "div",
	              {
	                className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--" + _this.props.dropdownMode,
	                onFocus: _this.handleDropdownFocus
	              },
	              _this.renderMonthDropdown(i !== 0),
	              _this.renderMonthYearDropdown(i !== 0),
	              _this.renderYearDropdown(i !== 0)
	            ),
	            React.createElement(
	              "div",
	              { className: "react-datepicker__day-names" },
	              _this.header(monthDate)
	            )
	          ),
	          React.createElement(Month, {
	            day: monthDate,
	            dayClassName: _this.props.dayClassName,
	            onDayClick: _this.handleDayClick,
	            onDayMouseEnter: _this.handleDayMouseEnter,
	            onMouseLeave: _this.handleMonthMouseLeave,
	            onWeekSelect: _this.props.onWeekSelect,
	            formatWeekNumber: _this.props.formatWeekNumber,
	            minDate: _this.props.minDate,
	            maxDate: _this.props.maxDate,
	            excludeDates: _this.props.excludeDates,
	            highlightDates: _this.props.highlightDates,
	            selectingDate: _this.state.selectingDate,
	            includeDates: _this.props.includeDates,
	            inline: _this.props.inline,
	            fixedHeight: _this.props.fixedHeight,
	            filterDate: _this.props.filterDate,
	            preSelection: _this.props.preSelection,
	            selected: _this.props.selected,
	            selectsStart: _this.props.selectsStart,
	            selectsEnd: _this.props.selectsEnd,
	            showWeekNumbers: _this.props.showWeekNumbers,
	            startDate: _this.props.startDate,
	            endDate: _this.props.endDate,
	            peekNextMonth: _this.props.peekNextMonth,
	            utcOffset: _this.props.utcOffset
	          })
	        ));
	      }
	      return monthList;
	    };
	
	    _this.renderTimeSection = function () {
	      if (_this.props.showTimeSelect) {
	        return React.createElement(Time, {
	          selected: _this.props.selected,
	          onChange: _this.props.onTimeChange,
	          format: _this.props.timeFormat,
	          includeTimes: _this.props.includeTimes,
	          intervals: _this.props.timeIntervals,
	          minTime: _this.props.minTime,
	          maxTime: _this.props.maxTime,
	          excludeTimes: _this.props.excludeTimes,
	          timeCaption: _this.props.timeCaption,
	          todayButton: _this.props.todayButton,
	          showMonthDropdown: _this.props.showMonthDropdown,
	          showMonthYearDropdown: _this.props.showMonthYearDropdown,
	          showYearDropdown: _this.props.showYearDropdown,
	          withPortal: _this.props.withPortal,
	          monthRef: _this.state.monthContainer,
	          injectTimes: _this.props.injectTimes
	        });
	      }
	    };
	
	    _this.state = {
	      date: _this.localizeDate(_this.getDateInView()),
	      selectingDate: null,
	      monthContainer: _this.monthContainer
	    };
	    return _this;
	  }
	
	  Calendar.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    // monthContainer height is needed in time component
	    // to determine the height for the ul in the time component
	    // setState here so height is given after final component
	    // layout is rendered
	    if (this.props.showTimeSelect) {
	      this.assignMonthContainer = function () {
	        _this2.setState({ monthContainer: _this2.monthContainer });
	      }();
	    }
	  };
	
	  Calendar.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.preSelection && !isSameDay(nextProps.preSelection, this.props.preSelection)) {
	      this.setState({
	        date: this.localizeDate(nextProps.preSelection)
	      });
	    } else if (nextProps.openToDate && !isSameDay(nextProps.openToDate, this.props.openToDate)) {
	      this.setState({
	        date: this.localizeDate(nextProps.openToDate)
	      });
	    }
	  };
	
	  Calendar.prototype.render = function render() {
	    return React.createElement(
	      "div",
	      {
	        className: classnames("react-datepicker", this.props.className, {
	          "react-datepicker--time-only": this.props.showTimeSelectOnly
	        })
	      },
	      React.createElement("div", { className: "react-datepicker__triangle" }),
	      this.renderPreviousMonthButton(),
	      this.renderNextMonthButton(),
	      this.renderMonths(),
	      this.renderTodayButton(),
	      this.renderTimeSection(),
	      this.props.children
	    );
	  };
	
	  return Calendar;
	}(React.Component);
	
	Calendar.propTypes = {
	  adjustDateOnChange: PropTypes.bool,
	  className: PropTypes.string,
	  children: PropTypes.node,
	  dateFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
	  dayClassName: PropTypes.func,
	  dropdownMode: PropTypes.oneOf(["scroll", "select"]),
	  endDate: PropTypes.object,
	  excludeDates: PropTypes.array,
	  filterDate: PropTypes.func,
	  fixedHeight: PropTypes.bool,
	  formatWeekNumber: PropTypes.func,
	  highlightDates: PropTypes.instanceOf(Map),
	  includeDates: PropTypes.array,
	  includeTimes: PropTypes.array,
	  injectTimes: PropTypes.array,
	  inline: PropTypes.bool,
	  locale: PropTypes.string,
	  maxDate: PropTypes.object,
	  minDate: PropTypes.object,
	  monthsShown: PropTypes.number,
	  onClickOutside: PropTypes.func.isRequired,
	  onMonthChange: PropTypes.func,
	  onYearChange: PropTypes.func,
	  forceShowMonthNavigation: PropTypes.bool,
	  onDropdownFocus: PropTypes.func,
	  onSelect: PropTypes.func.isRequired,
	  onWeekSelect: PropTypes.func,
	  showTimeSelect: PropTypes.bool,
	  showTimeSelectOnly: PropTypes.bool,
	  timeFormat: PropTypes.string,
	  timeIntervals: PropTypes.number,
	  onTimeChange: PropTypes.func,
	  minTime: PropTypes.object,
	  maxTime: PropTypes.object,
	  excludeTimes: PropTypes.array,
	  timeCaption: PropTypes.string,
	  openToDate: PropTypes.object,
	  peekNextMonth: PropTypes.bool,
	  scrollableYearDropdown: PropTypes.bool,
	  scrollableMonthYearDropdown: PropTypes.bool,
	  preSelection: PropTypes.object,
	  selected: PropTypes.object,
	  selectsEnd: PropTypes.bool,
	  selectsStart: PropTypes.bool,
	  showMonthDropdown: PropTypes.bool,
	  showMonthYearDropdown: PropTypes.bool,
	  showWeekNumbers: PropTypes.bool,
	  showYearDropdown: PropTypes.bool,
	  startDate: PropTypes.object,
	  todayButton: PropTypes.string,
	  useWeekdaysShort: PropTypes.bool,
	  withPortal: PropTypes.bool,
	  utcOffset: PropTypes.number,
	  weekLabel: PropTypes.string,
	  yearDropdownItemNumber: PropTypes.number,
	  setOpen: PropTypes.func,
	  useShortMonthInDropdown: PropTypes.bool,
	  showDisabledMonthNavigation: PropTypes.bool
	};
	
	var popperPlacementPositions = ["auto", "auto-left", "auto-right", "bottom", "bottom-end", "bottom-start", "left", "left-end", "left-start", "right", "right-end", "right-start", "top", "top-end", "top-start"];
	
	var PopperComponent = function (_React$Component) {
	  inherits(PopperComponent, _React$Component);
	
	  function PopperComponent() {
	    classCallCheck(this, PopperComponent);
	    return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PopperComponent.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        hidePopper = _props.hidePopper,
	        popperComponent = _props.popperComponent,
	        popperModifiers = _props.popperModifiers,
	        popperPlacement = _props.popperPlacement,
	        targetComponent = _props.targetComponent;
	
	
	    var popper = void 0;
	
	    if (!hidePopper) {
	      var classes = classnames("react-datepicker-popper", className);
	      popper = React.createElement(
	        reactPopper.Popper,
	        {
	          className: classes,
	          modifiers: popperModifiers,
	          placement: popperPlacement
	        },
	        popperComponent
	      );
	    }
	
	    if (this.props.popperContainer) {
	      popper = React.createElement(this.props.popperContainer, {}, popper);
	    }
	
	    return React.createElement(
	      reactPopper.Manager,
	      null,
	      React.createElement(
	        reactPopper.Target,
	        { className: "react-datepicker-wrapper" },
	        targetComponent
	      ),
	      popper
	    );
	  };
	
	  createClass(PopperComponent, null, [{
	    key: "defaultProps",
	    get: function get$$1() {
	      return {
	        hidePopper: true,
	        popperModifiers: {
	          preventOverflow: {
	            enabled: true,
	            escapeWithReference: true,
	            boundariesElement: "viewport"
	          }
	        },
	        popperPlacement: "bottom-start"
	      };
	    }
	  }]);
	  return PopperComponent;
	}(React.Component);
	
	PopperComponent.propTypes = {
	  className: PropTypes.string,
	  hidePopper: PropTypes.bool,
	  popperComponent: PropTypes.element,
	  popperModifiers: PropTypes.object, // <datepicker/> props
	  popperPlacement: PropTypes.oneOf(popperPlacementPositions), // <datepicker/> props
	  popperContainer: PropTypes.func,
	  targetComponent: PropTypes.element
	};
	
	var outsideClickIgnoreClass = "react-datepicker-ignore-onclickoutside";
	var WrappedCalendar = onClickOutside(Calendar);
	
	/**
	 * General datepicker component.
	 */
	
	var DatePicker = function (_React$Component) {
	  inherits(DatePicker, _React$Component);
	  createClass(DatePicker, null, [{
	    key: "defaultProps",
	    get: function get$$1() {
	      return {
	        allowSameDay: false,
	        dateFormat: "L",
	        dateFormatCalendar: "MMMM YYYY",
	        onChange: function onChange() {},
	
	        disabled: false,
	        disabledKeyboardNavigation: false,
	        dropdownMode: "scroll",
	        onFocus: function onFocus() {},
	        onBlur: function onBlur() {},
	        onKeyDown: function onKeyDown() {},
	        onSelect: function onSelect() {},
	        onClickOutside: function onClickOutside$$1() {},
	        onMonthChange: function onMonthChange() {},
	
	        preventOpenOnFocus: false,
	        onYearChange: function onYearChange() {},
	
	        monthsShown: 1,
	        withPortal: false,
	        shouldCloseOnSelect: true,
	        showTimeSelect: false,
	        timeIntervals: 30,
	        timeCaption: "Time"
	      };
	    }
	  }]);
	
	  function DatePicker(props) {
	    classCallCheck(this, DatePicker);
	
	    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.getPreSelection = function () {
	      return _this.props.openToDate ? newDate(_this.props.openToDate) : _this.props.selectsEnd && _this.props.startDate ? newDate(_this.props.startDate) : _this.props.selectsStart && _this.props.endDate ? newDate(_this.props.endDate) : now(_this.props.utcOffset);
	    };
	
	    _this.calcInitialState = function () {
	      var defaultPreSelection = _this.getPreSelection();
	      var minDate = getEffectiveMinDate(_this.props);
	      var maxDate = getEffectiveMaxDate(_this.props);
	      var boundedPreSelection = minDate && isBefore(defaultPreSelection, minDate) ? minDate : maxDate && isAfter(defaultPreSelection, maxDate) ? maxDate : defaultPreSelection;
	      return {
	        open: _this.props.startOpen || false,
	        preventFocus: false,
	        preSelection: _this.props.selected ? newDate(_this.props.selected) : boundedPreSelection,
	        // transforming highlighted days (perhaps nested array)
	        // to flat Map for faster access in day.jsx
	        highlightDates: getHightLightDaysMap(_this.props.highlightDates),
	        focused: false
	      };
	    };
	
	    _this.clearPreventFocusTimeout = function () {
	      if (_this.preventFocusTimeout) {
	        clearTimeout(_this.preventFocusTimeout);
	      }
	    };
	
	    _this.setFocus = function () {
	      if (_this.input.focus) {
	        _this.input.focus();
	      }
	    };
	
	    _this.setOpen = function (open) {
	      _this.setState({
	        open: open,
	        preSelection: open && _this.state.open ? _this.state.preSelection : _this.calcInitialState().preSelection
	      });
	    };
	
	    _this.handleFocus = function (event) {
	      if (!_this.state.preventFocus) {
	        _this.props.onFocus(event);
	        if (!_this.props.preventOpenOnFocus) {
	          _this.setOpen(true);
	        }
	      }
	      _this.setState({ focused: true });
	    };
	
	    _this.cancelFocusInput = function () {
	      clearTimeout(_this.inputFocusTimeout);
	      _this.inputFocusTimeout = null;
	    };
	
	    _this.deferFocusInput = function () {
	      _this.cancelFocusInput();
	      _this.inputFocusTimeout = setTimeout(function () {
	        return _this.setFocus();
	      }, 1);
	    };
	
	    _this.handleDropdownFocus = function () {
	      _this.cancelFocusInput();
	    };
	
	    _this.handleBlur = function (event) {
	      if (_this.state.open) {
	        _this.deferFocusInput();
	      } else {
	        _this.props.onBlur(event);
	      }
	      _this.setState({ focused: false });
	    };
	
	    _this.handleCalendarClickOutside = function (event) {
	      if (!_this.props.inline) {
	        _this.setOpen(false);
	      }
	      _this.props.onClickOutside(event);
	      if (_this.props.withPortal) {
	        event.preventDefault();
	      }
	    };
	
	    _this.handleChange = function () {
	      for (var _len = arguments.length, allArgs = Array(_len), _key = 0; _key < _len; _key++) {
	        allArgs[_key] = arguments[_key];
	      }
	
	      var event = allArgs[0];
	      if (_this.props.onChangeRaw) {
	        _this.props.onChangeRaw.apply(_this, allArgs);
	        if (typeof event.isDefaultPrevented !== "function" || event.isDefaultPrevented()) {
	          return;
	        }
	      }
	      _this.setState({ inputValue: event.target.value });
	      var date = parseDate(event.target.value, _this.props);
	      if (date || !event.target.value) {
	        _this.setSelected(date, event, true);
	      }
	    };
	
	    _this.handleSelect = function (date, event) {
	      // Preventing onFocus event to fix issue
	      // https://github.com/Hacker0x01/react-datepicker/issues/628
	      _this.setState({ preventFocus: true }, function () {
	        _this.preventFocusTimeout = setTimeout(function () {
	          return _this.setState({ preventFocus: false });
	        }, 50);
	        return _this.preventFocusTimeout;
	      });
	      _this.setSelected(date, event);
	      if (!_this.props.shouldCloseOnSelect || _this.props.showTimeSelect) {
	        _this.setPreSelection(date);
	      } else if (!_this.props.inline) {
	        _this.setOpen(false);
	      }
	    };
	
	    _this.setSelected = function (date, event, keepInput) {
	      var changedDate = date;
	
	      if (changedDate !== null && isDayDisabled(changedDate, _this.props)) {
	        return;
	      }
	
	      if (!isSameDay(_this.props.selected, changedDate) || _this.props.allowSameDay) {
	        if (changedDate !== null) {
	          if (_this.props.selected) {
	            var selected = _this.props.selected;
	            if (keepInput) selected = newDate(changedDate);
	            changedDate = setTime(newDate(changedDate), {
	              hour: getHour(selected),
	              minute: getMinute(selected),
	              second: getSecond(selected)
	            });
	          }
	          _this.setState({
	            preSelection: changedDate
	          });
	        }
	        _this.props.onChange(changedDate, event);
	      }
	
	      _this.props.onSelect(changedDate, event);
	
	      if (!keepInput) {
	        _this.setState({ inputValue: null });
	      }
	    };
	
	    _this.setPreSelection = function (date) {
	      var isDateRangePresent = typeof _this.props.minDate !== "undefined" && typeof _this.props.maxDate !== "undefined";
	      var isValidDateSelection = isDateRangePresent && date ? isDayInRange(date, _this.props.minDate, _this.props.maxDate) : true;
	      if (isValidDateSelection) {
	        _this.setState({
	          preSelection: date
	        });
	      }
	    };
	
	    _this.handleTimeChange = function (time) {
	      var selected = _this.props.selected ? _this.props.selected : _this.getPreSelection();
	      var changedDate = setTime(cloneDate(selected), {
	        hour: getHour(time),
	        minute: getMinute(time)
	      });
	
	      _this.setState({
	        preSelection: changedDate
	      });
	
	      _this.props.onChange(changedDate);
	      _this.setOpen(false);
	      _this.setState({ inputValue: null });
	    };
	
	    _this.onInputClick = function () {
	      if (!_this.props.disabled) {
	        _this.setOpen(true);
	      }
	    };
	
	    _this.onInputKeyDown = function (event) {
	      _this.props.onKeyDown(event);
	      var eventKey = event.key;
	      if (!_this.state.open && !_this.props.inline && !_this.props.preventOpenOnFocus) {
	        if (eventKey !== "Enter" && eventKey !== "Escape" && eventKey !== "Tab") {
	          _this.onInputClick();
	        }
	        return;
	      }
	      var copy = newDate(_this.state.preSelection);
	      if (eventKey === "Enter") {
	        event.preventDefault();
	        if (isMoment(_this.state.preSelection) || isDate(_this.state.preSelection)) {
	          _this.handleSelect(copy, event);
	          !_this.props.shouldCloseOnSelect && _this.setPreSelection(copy);
	        } else {
	          _this.setOpen(false);
	        }
	      } else if (eventKey === "Escape") {
	        event.preventDefault();
	        _this.setOpen(false);
	      } else if (eventKey === "Tab") {
	        _this.setOpen(false);
	      } else if (!_this.props.disabledKeyboardNavigation) {
	        var newSelection = void 0;
	        switch (eventKey) {
	          case "ArrowLeft":
	            event.preventDefault();
	            newSelection = subtractDays(copy, 1);
	            break;
	          case "ArrowRight":
	            event.preventDefault();
	            newSelection = addDays(copy, 1);
	            break;
	          case "ArrowUp":
	            event.preventDefault();
	            newSelection = subtractWeeks(copy, 1);
	            break;
	          case "ArrowDown":
	            event.preventDefault();
	            newSelection = addWeeks(copy, 1);
	            break;
	          case "PageUp":
	            event.preventDefault();
	            newSelection = subtractMonths(copy, 1);
	            break;
	          case "PageDown":
	            event.preventDefault();
	            newSelection = addMonths(copy, 1);
	            break;
	          case "Home":
	            event.preventDefault();
	            newSelection = subtractYears(copy, 1);
	            break;
	          case "End":
	            event.preventDefault();
	            newSelection = addYears(copy, 1);
	            break;
	        }
	        if (_this.props.adjustDateOnChange) {
	          _this.setSelected(newSelection);
	        }
	        _this.setPreSelection(newSelection);
	      }
	    };
	
	    _this.onClearClick = function (event) {
	      if (event) {
	        if (event.preventDefault) {
	          event.preventDefault();
	        }
	      }
	      _this.props.onChange(null, event);
	      _this.setState({ inputValue: null });
	    };
	
	    _this.clear = function () {
	      _this.onClearClick();
	    };
	
	    _this.renderCalendar = function () {
	      if (!_this.props.inline && (!_this.state.open || _this.props.disabled)) {
	        return null;
	      }
	      return React.createElement(
	        WrappedCalendar,
	        {
	          ref: function ref(elem) {
	            _this.calendar = elem;
	          },
	          locale: _this.props.locale,
	          adjustDateOnChange: _this.props.adjustDateOnChange,
	          setOpen: _this.setOpen,
	          dateFormat: _this.props.dateFormatCalendar,
	          useWeekdaysShort: _this.props.useWeekdaysShort,
	          dropdownMode: _this.props.dropdownMode,
	          selected: _this.props.selected,
	          preSelection: _this.state.preSelection,
	          onSelect: _this.handleSelect,
	          onWeekSelect: _this.props.onWeekSelect,
	          openToDate: _this.props.openToDate,
	          minDate: _this.props.minDate,
	          maxDate: _this.props.maxDate,
	          selectsStart: _this.props.selectsStart,
	          selectsEnd: _this.props.selectsEnd,
	          startDate: _this.props.startDate,
	          endDate: _this.props.endDate,
	          excludeDates: _this.props.excludeDates,
	          filterDate: _this.props.filterDate,
	          onClickOutside: _this.handleCalendarClickOutside,
	          formatWeekNumber: _this.props.formatWeekNumber,
	          highlightDates: _this.state.highlightDates,
	          includeDates: _this.props.includeDates,
	          includeTimes: _this.props.includeTimes,
	          injectTimes: _this.props.injectTimes,
	          inline: _this.props.inline,
	          peekNextMonth: _this.props.peekNextMonth,
	          showMonthDropdown: _this.props.showMonthDropdown,
	          useShortMonthInDropdown: _this.props.useShortMonthInDropdown,
	          showMonthYearDropdown: _this.props.showMonthYearDropdown,
	          showWeekNumbers: _this.props.showWeekNumbers,
	          showYearDropdown: _this.props.showYearDropdown,
	          withPortal: _this.props.withPortal,
	          forceShowMonthNavigation: _this.props.forceShowMonthNavigation,
	          showDisabledMonthNavigation: _this.props.showDisabledMonthNavigation,
	          scrollableYearDropdown: _this.props.scrollableYearDropdown,
	          scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown,
	          todayButton: _this.props.todayButton,
	          weekLabel: _this.props.weekLabel,
	          utcOffset: _this.props.utcOffset,
	          outsideClickIgnoreClass: outsideClickIgnoreClass,
	          fixedHeight: _this.props.fixedHeight,
	          monthsShown: _this.props.monthsShown,
	          onDropdownFocus: _this.handleDropdownFocus,
	          onMonthChange: _this.props.onMonthChange,
	          onYearChange: _this.props.onYearChange,
	          dayClassName: _this.props.dayClassName,
	          showTimeSelect: _this.props.showTimeSelect,
	          showTimeSelectOnly: _this.props.showTimeSelectOnly,
	          onTimeChange: _this.handleTimeChange,
	          timeFormat: _this.props.timeFormat,
	          timeIntervals: _this.props.timeIntervals,
	          minTime: _this.props.minTime,
	          maxTime: _this.props.maxTime,
	          excludeTimes: _this.props.excludeTimes,
	          timeCaption: _this.props.timeCaption,
	          className: _this.props.calendarClassName,
	          yearDropdownItemNumber: _this.props.yearDropdownItemNumber
	        },
	        _this.props.children
	      );
	    };
	
	    _this.renderDateInput = function () {
	      var _classnames, _React$cloneElement;
	
	      var className = classnames(_this.props.className, (_classnames = {}, _classnames[outsideClickIgnoreClass] = _this.state.open, _classnames));
	
	      var customInput = _this.props.customInput || React.createElement("input", { type: "text" });
	      var customInputRef = _this.props.customInputRef || "ref";
	      var inputValue = typeof _this.props.value === "string" ? _this.props.value : typeof _this.state.inputValue === "string" ? _this.state.inputValue : safeDateFormat(_this.props.selected, _this.props);
	
	      return React.cloneElement(customInput, (_React$cloneElement = {}, _React$cloneElement[customInputRef] = function (input) {
	        _this.input = input;
	      }, _React$cloneElement.value = inputValue, _React$cloneElement.onBlur = _this.handleBlur, _React$cloneElement.onChange = _this.handleChange, _React$cloneElement.onClick = _this.onInputClick, _React$cloneElement.onFocus = _this.handleFocus, _React$cloneElement.onKeyDown = _this.onInputKeyDown, _React$cloneElement.id = _this.props.id, _React$cloneElement.name = _this.props.name, _React$cloneElement.autoFocus = _this.props.autoFocus, _React$cloneElement.placeholder = _this.props.placeholderText, _React$cloneElement.disabled = _this.props.disabled, _React$cloneElement.autoComplete = _this.props.autoComplete, _React$cloneElement.className = className, _React$cloneElement.title = _this.props.title, _React$cloneElement.readOnly = _this.props.readOnly, _React$cloneElement.required = _this.props.required, _React$cloneElement.tabIndex = _this.props.tabIndex, _React$cloneElement));
	    };
	
	    _this.renderClearButton = function () {
	      if (_this.props.isClearable && _this.props.selected != null) {
	        return React.createElement("button", {
	          className: "react-datepicker__close-icon",
	          onClick: _this.onClearClick,
	          title: _this.props.clearButtonTitle,
	          tabIndex: -1
	        });
	      } else {
	        return null;
	      }
	    };
	
	    _this.state = _this.calcInitialState();
	    return _this;
	  }
	
	  DatePicker.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var currentMonth = this.props.selected && getMonth(this.props.selected);
	    var nextMonth = nextProps.selected && getMonth(nextProps.selected);
	    if (this.props.inline && currentMonth !== nextMonth) {
	      this.setPreSelection(nextProps.selected);
	    }
	    if (this.props.highlightDates !== nextProps.highlightDates) {
	      this.setState({
	        highlightDates: getHightLightDaysMap(nextProps.highlightDates)
	      });
	    }
	    if (!this.state.focused) this.setState({ inputValue: null });
	  };
	
	  DatePicker.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.clearPreventFocusTimeout();
	  };
	
	  DatePicker.prototype.render = function render() {
	    var calendar = this.renderCalendar();
	
	    if (this.props.inline && !this.props.withPortal) {
	      return calendar;
	    }
	
	    if (this.props.withPortal) {
	      return React.createElement(
	        "div",
	        null,
	        !this.props.inline ? React.createElement(
	          "div",
	          { className: "react-datepicker__input-container" },
	          this.renderDateInput(),
	          this.renderClearButton()
	        ) : null,
	        this.state.open || this.props.inline ? React.createElement(
	          "div",
	          { className: "react-datepicker__portal" },
	          calendar
	        ) : null
	      );
	    }
	
	    return React.createElement(PopperComponent, {
	      className: this.props.popperClassName,
	      hidePopper: !this.state.open || this.props.disabled,
	      popperModifiers: this.props.popperModifiers,
	      targetComponent: React.createElement(
	        "div",
	        { className: "react-datepicker__input-container" },
	        this.renderDateInput(),
	        this.renderClearButton()
	      ),
	      popperContainer: this.props.popperContainer,
	      popperComponent: calendar,
	      popperPlacement: this.props.popperPlacement
	    });
	  };
	
	  return DatePicker;
	}(React.Component);
	
	DatePicker.propTypes = {
	  adjustDateOnChange: PropTypes.bool,
	  allowSameDay: PropTypes.bool,
	  autoComplete: PropTypes.string,
	  autoFocus: PropTypes.bool,
	  calendarClassName: PropTypes.string,
	  children: PropTypes.node,
	  className: PropTypes.string,
	  customInput: PropTypes.element,
	  customInputRef: PropTypes.string,
	  // eslint-disable-next-line react/no-unused-prop-types
	  dateFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
	  dateFormatCalendar: PropTypes.string,
	  dayClassName: PropTypes.func,
	  disabled: PropTypes.bool,
	  disabledKeyboardNavigation: PropTypes.bool,
	  dropdownMode: PropTypes.oneOf(["scroll", "select"]).isRequired,
	  endDate: PropTypes.object,
	  excludeDates: PropTypes.array,
	  filterDate: PropTypes.func,
	  fixedHeight: PropTypes.bool,
	  formatWeekNumber: PropTypes.func,
	  highlightDates: PropTypes.array,
	  id: PropTypes.string,
	  includeDates: PropTypes.array,
	  includeTimes: PropTypes.array,
	  injectTimes: PropTypes.array,
	  inline: PropTypes.bool,
	  isClearable: PropTypes.bool,
	  locale: PropTypes.string,
	  maxDate: PropTypes.object,
	  minDate: PropTypes.object,
	  monthsShown: PropTypes.number,
	  name: PropTypes.string,
	  onBlur: PropTypes.func,
	  onChange: PropTypes.func.isRequired,
	  onSelect: PropTypes.func,
	  onWeekSelect: PropTypes.func,
	  onClickOutside: PropTypes.func,
	  onChangeRaw: PropTypes.func,
	  onFocus: PropTypes.func,
	  onKeyDown: PropTypes.func,
	  onMonthChange: PropTypes.func,
	  onYearChange: PropTypes.func,
	  openToDate: PropTypes.object,
	  peekNextMonth: PropTypes.bool,
	  placeholderText: PropTypes.string,
	  popperContainer: PropTypes.func,
	  popperClassName: PropTypes.string, // <PopperComponent/> props
	  popperModifiers: PropTypes.object, // <PopperComponent/> props
	  popperPlacement: PropTypes.oneOf(popperPlacementPositions), // <PopperComponent/> props
	  preventOpenOnFocus: PropTypes.bool,
	  readOnly: PropTypes.bool,
	  required: PropTypes.bool,
	  scrollableYearDropdown: PropTypes.bool,
	  scrollableMonthYearDropdown: PropTypes.bool,
	  selected: PropTypes.object,
	  selectsEnd: PropTypes.bool,
	  selectsStart: PropTypes.bool,
	  showMonthDropdown: PropTypes.bool,
	  showMonthYearDropdown: PropTypes.bool,
	  showWeekNumbers: PropTypes.bool,
	  showYearDropdown: PropTypes.bool,
	  forceShowMonthNavigation: PropTypes.bool,
	  showDisabledMonthNavigation: PropTypes.bool,
	  startDate: PropTypes.object,
	  startOpen: PropTypes.bool,
	  tabIndex: PropTypes.number,
	  timeCaption: PropTypes.string,
	  title: PropTypes.string,
	  todayButton: PropTypes.string,
	  useWeekdaysShort: PropTypes.bool,
	  utcOffset: PropTypes.number,
	  value: PropTypes.string,
	  weekLabel: PropTypes.string,
	  withPortal: PropTypes.bool,
	  yearDropdownItemNumber: PropTypes.number,
	  shouldCloseOnSelect: PropTypes.bool,
	  showTimeSelect: PropTypes.bool,
	  showTimeSelectOnly: PropTypes.bool,
	  timeFormat: PropTypes.string,
	  timeIntervals: PropTypes.number,
	  minTime: PropTypes.object,
	  maxTime: PropTypes.object,
	  excludeTimes: PropTypes.array,
	  useShortMonthInDropdown: PropTypes.bool,
	  clearButtonTitle: PropTypes.string
	};
	
	module.exports = DatePicker;


/***/ },
/* 1386 */
/***/ function(module, exports, __webpack_require__) {

	/*
	  Used as main file in package.json
	*/
	
	/* eslint-disable no-var */
	/* eslint-env node */
	
	var DayPicker = __webpack_require__(1389);
	var DateUtils = __webpack_require__(133);
	var LocaleUtils = __webpack_require__(194);
	var ModifiersUtils = __webpack_require__(291);
	var Weekday = __webpack_require__(596);
	var Navbar = __webpack_require__(595);
	var PropTypes = __webpack_require__(1391);
	
	module.exports = DayPicker;
	module.exports.DateUtils = DateUtils;
	module.exports.LocaleUtils = LocaleUtils;
	module.exports.ModifiersUtils = ModifiersUtils;
	module.exports.WeekdayPropTypes = Weekday.propTypes;
	module.exports.NavbarPropTypes = Navbar.propTypes;
	module.exports.PropTypes = PropTypes;


/***/ },
/* 1387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LocaleUtils = __webpack_require__(194);
	
	var _LocaleUtils2 = _interopRequireDefault(_LocaleUtils);
	
	var _keys = __webpack_require__(196);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Caption = function (_Component) {
	  _inherits(Caption, _Component);
	
	  function Caption(props) {
	    _classCallCheck(this, Caption);
	
	    var _this = _possibleConstructorReturn(this, (Caption.__proto__ || Object.getPrototypeOf(Caption)).call(this, props));
	
	    _this.handleKeyUp = _this.handleKeyUp.bind(_this);
	    return _this;
	  }
	
	  _createClass(Caption, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return nextProps.locale !== this.props.locale || nextProps.classNames !== this.props.classNames || nextProps.date.getMonth() !== this.props.date.getMonth() || nextProps.date.getFullYear() !== this.props.date.getFullYear();
	    }
	  }, {
	    key: 'handleKeyUp',
	    value: function handleKeyUp(e) {
	      if (e.keyCode === _keys.ENTER) {
	        this.props.onClick(e);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          classNames = _props.classNames,
	          date = _props.date,
	          months = _props.months,
	          locale = _props.locale,
	          localeUtils = _props.localeUtils,
	          onClick = _props.onClick;
	
	      return _react2.default.createElement(
	        'div',
	        { className: classNames.caption, role: 'heading' },
	        _react2.default.createElement(
	          'div',
	          { onClick: onClick, onKeyUp: this.handleKeyUp },
	          months ? months[date.getMonth()] + ' ' + date.getFullYear() : localeUtils.formatMonthTitle(date, locale)
	        )
	      );
	    }
	  }]);
	
	  return Caption;
	}(_react.Component);
	
	Caption.defaultProps = {
	  localeUtils: _LocaleUtils2.default
	};
	exports.default = Caption;
	Caption.propTypes =  false ? {
	  date: _propTypes2.default.instanceOf(Date),
	  months: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  locale: _propTypes2.default.string,
	  localeUtils: _propTypes2.default.object,
	  onClick: _propTypes2.default.func,
	  classNames: _propTypes2.default.shape({
	    caption: _propTypes2.default.string.isRequired
	  }).isRequired
	} : {};
	//# sourceMappingURL=Caption.js.map

/***/ },
/* 1388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DateUtils = __webpack_require__(133);
	
	var _Helpers = __webpack_require__(193);
	
	var _classNames = __webpack_require__(195);
	
	var _classNames2 = _interopRequireDefault(_classNames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable jsx-a11y/no-static-element-interactions, react/forbid-prop-types */
	
	function handleEvent(handler, day, modifiers) {
	  if (!handler) {
	    return undefined;
	  }
	  return function (e) {
	    e.persist();
	    handler(day, modifiers, e);
	  };
	}
	
	var Day = function (_Component) {
	  _inherits(Day, _Component);
	
	  function Day() {
	    _classCallCheck(this, Day);
	
	    return _possibleConstructorReturn(this, (Day.__proto__ || Object.getPrototypeOf(Day)).apply(this, arguments));
	  }
	
	  _createClass(Day, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var _this2 = this;
	
	      var propNames = Object.keys(this.props);
	      var nextPropNames = Object.keys(nextProps);
	      if (propNames.length !== nextPropNames.length) {
	        return true;
	      }
	      return propNames.some(function (name) {
	        if (name === 'modifiers' || name === 'modifiersStyles' || name === 'classNames') {
	          var prop = _this2.props[name];
	          var nextProp = nextProps[name];
	          var modifiers = Object.keys(prop);
	          var nextModifiers = Object.keys(nextProp);
	          if (modifiers.length !== nextModifiers.length) {
	            return true;
	          }
	          return modifiers.some(function (mod) {
	            return !(0, _Helpers.hasOwnProp)(nextProp, mod) || prop[mod] !== nextProp[mod];
	          });
	        }
	        if (name === 'day') {
	          return !(0, _DateUtils.isSameDay)(_this2.props[name], nextProps[name]);
	        }
	        return !(0, _Helpers.hasOwnProp)(nextProps, name) || _this2.props[name] !== nextProps[name];
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          classNames = _props.classNames,
	          modifiersStyles = _props.modifiersStyles,
	          day = _props.day,
	          tabIndex = _props.tabIndex,
	          empty = _props.empty,
	          modifiers = _props.modifiers,
	          onMouseEnter = _props.onMouseEnter,
	          onMouseLeave = _props.onMouseLeave,
	          onMouseUp = _props.onMouseUp,
	          onMouseDown = _props.onMouseDown,
	          onClick = _props.onClick,
	          onKeyDown = _props.onKeyDown,
	          onTouchStart = _props.onTouchStart,
	          onTouchEnd = _props.onTouchEnd,
	          onFocus = _props.onFocus,
	          ariaLabel = _props.ariaLabel,
	          ariaDisabled = _props.ariaDisabled,
	          ariaSelected = _props.ariaSelected,
	          children = _props.children;
	
	
	      var className = classNames.day;
	      if (classNames !== _classNames2.default) {
	        // When using CSS modules prefix the modifier as required by the BEM syntax
	        className += ' ' + Object.keys(modifiers).join(' ');
	      } else {
	        className += Object.keys(modifiers).map(function (modifier) {
	          return ' ' + className + '--' + modifier;
	        }).join('');
	      }
	
	      var style = void 0;
	      if (modifiersStyles) {
	        Object.keys(modifiers).filter(function (modifier) {
	          return !!modifiersStyles[modifier];
	        }).forEach(function (modifier) {
	          style = _extends({}, style, modifiersStyles[modifier]);
	        });
	      }
	
	      if (empty) {
	        return _react2.default.createElement('div', { 'aria-disabled': true, className: className, style: style });
	      }
	      return _react2.default.createElement(
	        'div',
	        {
	          className: className,
	          tabIndex: tabIndex,
	          style: style,
	          role: 'gridcell',
	          'aria-label': ariaLabel,
	          'aria-disabled': ariaDisabled,
	          'aria-selected': ariaSelected,
	          onClick: handleEvent(onClick, day, modifiers),
	          onKeyDown: handleEvent(onKeyDown, day, modifiers),
	          onMouseEnter: handleEvent(onMouseEnter, day, modifiers),
	          onMouseLeave: handleEvent(onMouseLeave, day, modifiers),
	          onMouseUp: handleEvent(onMouseUp, day, modifiers),
	          onMouseDown: handleEvent(onMouseDown, day, modifiers),
	          onTouchEnd: handleEvent(onTouchEnd, day, modifiers),
	          onTouchStart: handleEvent(onTouchStart, day, modifiers),
	          onFocus: handleEvent(onFocus, day, modifiers)
	        },
	        children
	      );
	    }
	  }]);
	
	  return Day;
	}(_react.Component);
	
	Day.defaultProps = {
	  tabIndex: -1
	};
	Day.defaultProps = {
	  modifiers: {},
	  modifiersStyles: {},
	  empty: false
	};
	exports.default = Day;
	Day.propTypes =  false ? {
	  classNames: _propTypes2.default.shape({
	    day: _propTypes2.default.string.isRequired
	  }).isRequired,
	
	  day: _propTypes2.default.instanceOf(Date).isRequired,
	  children: _propTypes2.default.node.isRequired,
	
	  ariaDisabled: _propTypes2.default.bool,
	  ariaLabel: _propTypes2.default.string,
	  ariaSelected: _propTypes2.default.bool,
	  empty: _propTypes2.default.bool,
	  modifiers: _propTypes2.default.object,
	  modifiersStyles: _propTypes2.default.object,
	  onClick: _propTypes2.default.func,
	  onKeyDown: _propTypes2.default.func,
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onMouseDown: _propTypes2.default.func,
	  onMouseUp: _propTypes2.default.func,
	  onTouchEnd: _propTypes2.default.func,
	  onTouchStart: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  tabIndex: _propTypes2.default.number
	} : {};
	//# sourceMappingURL=Day.js.map

/***/ },
/* 1389 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Caption = __webpack_require__(1387);
	
	var _Caption2 = _interopRequireDefault(_Caption);
	
	var _Navbar = __webpack_require__(595);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _Month = __webpack_require__(1390);
	
	var _Month2 = _interopRequireDefault(_Month);
	
	var _Weekday = __webpack_require__(596);
	
	var _Weekday2 = _interopRequireDefault(_Weekday);
	
	var _Helpers = __webpack_require__(193);
	
	var Helpers = _interopRequireWildcard(_Helpers);
	
	var _DateUtils = __webpack_require__(133);
	
	var DateUtils = _interopRequireWildcard(_DateUtils);
	
	var _LocaleUtils = __webpack_require__(194);
	
	var LocaleUtils = _interopRequireWildcard(_LocaleUtils);
	
	var _ModifiersUtils = __webpack_require__(291);
	
	var ModifiersUtils = _interopRequireWildcard(_ModifiersUtils);
	
	var _classNames = __webpack_require__(195);
	
	var _classNames2 = _interopRequireDefault(_classNames);
	
	var _keys = __webpack_require__(196);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DayPicker = function (_Component) {
	  _inherits(DayPicker, _Component);
	
	  function DayPicker(props) {
	    _classCallCheck(this, DayPicker);
	
	    var _this = _possibleConstructorReturn(this, (DayPicker.__proto__ || Object.getPrototypeOf(DayPicker)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = _this.getStateFromProps(props);
	    return _this;
	  }
	
	  _createClass(DayPicker, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.month !== nextProps.month) {
	        this.setState(this.getStateFromProps(nextProps));
	      }
	    }
	  }, {
	    key: 'getNextNavigableMonth',
	    value: function getNextNavigableMonth() {
	      return DateUtils.addMonths(this.state.currentMonth, this.props.numberOfMonths);
	    }
	  }, {
	    key: 'getPreviousNavigableMonth',
	    value: function getPreviousNavigableMonth() {
	      return DateUtils.addMonths(this.state.currentMonth, -1);
	    }
	  }, {
	    key: 'allowPreviousMonth',
	    value: function allowPreviousMonth() {
	      var previousMonth = DateUtils.addMonths(this.state.currentMonth, -1);
	      return this.allowMonth(previousMonth);
	    }
	  }, {
	    key: 'allowNextMonth',
	    value: function allowNextMonth() {
	      var nextMonth = DateUtils.addMonths(this.state.currentMonth, this.props.numberOfMonths);
	      return this.allowMonth(nextMonth);
	    }
	  }, {
	    key: 'allowMonth',
	    value: function allowMonth(d) {
	      var _props = this.props,
	          fromMonth = _props.fromMonth,
	          toMonth = _props.toMonth,
	          canChangeMonth = _props.canChangeMonth;
	
	      if (!canChangeMonth || fromMonth && Helpers.getMonthsDiff(fromMonth, d) < 0 || toMonth && Helpers.getMonthsDiff(toMonth, d) > 0) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'allowYearChange',
	    value: function allowYearChange() {
	      return this.props.canChangeMonth;
	    }
	  }, {
	    key: 'showMonth',
	    value: function showMonth(d, callback) {
	      var _this2 = this;
	
	      if (!this.allowMonth(d)) {
	        return;
	      }
	      this.setState({ currentMonth: Helpers.startOfMonth(d) }, function () {
	        if (callback) {
	          callback();
	        }
	        if (_this2.props.onMonthChange) {
	          _this2.props.onMonthChange(_this2.state.currentMonth);
	        }
	      });
	    }
	  }, {
	    key: 'showNextYear',
	    value: function showNextYear() {
	      if (!this.allowYearChange()) {
	        return;
	      }
	      var nextMonth = DateUtils.addMonths(this.state.currentMonth, 12);
	      this.showMonth(nextMonth);
	    }
	  }, {
	    key: 'showPreviousYear',
	    value: function showPreviousYear() {
	      if (!this.allowYearChange()) {
	        return;
	      }
	      var nextMonth = DateUtils.addMonths(this.state.currentMonth, -12);
	      this.showMonth(nextMonth);
	    }
	  }, {
	    key: 'focusFirstDayOfMonth',
	    value: function focusFirstDayOfMonth() {
	      Helpers.getDayNodes(this.dayPicker, this.props.classNames)[0].focus();
	    }
	  }, {
	    key: 'focusLastDayOfMonth',
	    value: function focusLastDayOfMonth() {
	      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
	      dayNodes[dayNodes.length - 1].focus();
	    }
	  }, {
	    key: 'focusPreviousDay',
	    value: function focusPreviousDay(dayNode) {
	      var _this3 = this;
	
	      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
	      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
	      if (dayNodeIndex === -1) return;
	      if (dayNodeIndex === 0) {
	        this.showPreviousMonth(function () {
	          return _this3.focusLastDayOfMonth();
	        });
	      } else {
	        dayNodes[dayNodeIndex - 1].focus();
	      }
	    }
	  }, {
	    key: 'focusNextDay',
	    value: function focusNextDay(dayNode) {
	      var _this4 = this;
	
	      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
	      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
	      if (dayNodeIndex === -1) return;
	      if (dayNodeIndex === dayNodes.length - 1) {
	        this.showNextMonth(function () {
	          return _this4.focusFirstDayOfMonth();
	        });
	      } else {
	        dayNodes[dayNodeIndex + 1].focus();
	      }
	    }
	  }, {
	    key: 'focusNextWeek',
	    value: function focusNextWeek(dayNode) {
	      var _this5 = this;
	
	      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
	      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
	      var isInLastWeekOfMonth = dayNodeIndex > dayNodes.length - 8;
	
	      if (isInLastWeekOfMonth) {
	        this.showNextMonth(function () {
	          var daysAfterIndex = dayNodes.length - dayNodeIndex;
	          var nextMonthDayNodeIndex = 7 - daysAfterIndex;
	          Helpers.getDayNodes(_this5.dayPicker, _this5.props.classNames)[nextMonthDayNodeIndex].focus();
	        });
	      } else {
	        dayNodes[dayNodeIndex + 7].focus();
	      }
	    }
	  }, {
	    key: 'focusPreviousWeek',
	    value: function focusPreviousWeek(dayNode) {
	      var _this6 = this;
	
	      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
	      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
	      var isInFirstWeekOfMonth = dayNodeIndex <= 6;
	
	      if (isInFirstWeekOfMonth) {
	        this.showPreviousMonth(function () {
	          var previousMonthDayNodes = Helpers.getDayNodes(_this6.dayPicker, _this6.props.classNames);
	          var startOfLastWeekOfMonth = previousMonthDayNodes.length - 7;
	          var previousMonthDayNodeIndex = startOfLastWeekOfMonth + dayNodeIndex;
	          previousMonthDayNodes[previousMonthDayNodeIndex].focus();
	        });
	      } else {
	        dayNodes[dayNodeIndex - 7].focus();
	      }
	    }
	
	    // Event handlers
	
	  }, {
	    key: 'handleOutsideDayClick',
	    value: function handleOutsideDayClick(day) {
	      var currentMonth = this.state.currentMonth;
	      var numberOfMonths = this.props.numberOfMonths;
	
	      var diffInMonths = Helpers.getMonthsDiff(currentMonth, day);
	      if (diffInMonths > 0 && diffInMonths >= numberOfMonths) {
	        this.showNextMonth();
	      } else if (diffInMonths < 0) {
	        this.showPreviousMonth();
	      }
	    }
	  }, {
	    key: 'renderNavbar',
	    value: function renderNavbar() {
	      var _props2 = this.props,
	          labels = _props2.labels,
	          locale = _props2.locale,
	          localeUtils = _props2.localeUtils,
	          canChangeMonth = _props2.canChangeMonth,
	          navbarElement = _props2.navbarElement,
	          attributes = _objectWithoutProperties(_props2, ['labels', 'locale', 'localeUtils', 'canChangeMonth', 'navbarElement']);
	
	      if (!canChangeMonth) return null;
	
	      var props = {
	        month: this.state.currentMonth,
	        classNames: this.props.classNames,
	        className: this.props.classNames.navBar,
	        nextMonth: this.getNextNavigableMonth(),
	        previousMonth: this.getPreviousNavigableMonth(),
	        showPreviousButton: this.allowPreviousMonth(),
	        showNextButton: this.allowNextMonth(),
	        onNextClick: this.showNextMonth,
	        onPreviousClick: this.showPreviousMonth,
	        dir: attributes.dir,
	        labels: labels,
	        locale: locale,
	        localeUtils: localeUtils
	      };
	      return _react2.default.isValidElement(navbarElement) ? _react2.default.cloneElement(navbarElement, props) : _react2.default.createElement(navbarElement, props);
	    }
	  }, {
	    key: 'renderMonths',
	    value: function renderMonths() {
	      var months = [];
	      var firstDayOfWeek = Helpers.getFirstDayOfWeekFromProps(this.props);
	      for (var i = 0; i < this.props.numberOfMonths; i += 1) {
	        var month = DateUtils.addMonths(this.state.currentMonth, i);
	        months.push(_react2.default.createElement(_Month2.default, _extends({
	          key: i
	        }, this.props, {
	          month: month,
	          firstDayOfWeek: firstDayOfWeek,
	          onDayKeyDown: this.handleDayKeyDown,
	          onDayClick: this.handleDayClick
	        })));
	      }
	
	      if (this.props.reverseMonths) {
	        months.reverse();
	      }
	      return months;
	    }
	  }, {
	    key: 'renderFooter',
	    value: function renderFooter() {
	      if (this.props.todayButton) {
	        return _react2.default.createElement(
	          'div',
	          { className: this.props.classNames.footer },
	          this.renderTodayButton()
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'renderTodayButton',
	    value: function renderTodayButton() {
	      return _react2.default.createElement(
	        'button',
	        {
	          type: 'button',
	          tabIndex: 0,
	          className: this.props.classNames.todayButton,
	          'aria-label': this.props.todayButton,
	          onClick: this.handleTodayButtonClick
	        },
	        this.props.todayButton
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var className = this.props.classNames.container;
	
	      if (!this.props.onDayClick) {
	        className = className + ' ' + this.props.classNames.interactionDisabled;
	      }
	      if (this.props.className) {
	        className = className + ' ' + this.props.className;
	      }
	      return _react2.default.createElement(
	        'div',
	        _extends({}, this.props.containerProps, {
	          className: className,
	          ref: function ref(el) {
	            return _this7.dayPicker = el;
	          },
	          lang: this.props.locale
	        }),
	        _react2.default.createElement(
	          'div',
	          {
	            className: this.props.classNames.wrapper,
	            tabIndex: this.props.canChangeMonth && this.props.tabIndex ? this.props.tabIndex : -1,
	            onKeyDown: this.handleKeyDown,
	            onFocus: this.props.onFocus,
	            onBlur: this.props.onBlur
	          },
	          this.renderNavbar(),
	          _react2.default.createElement(
	            'div',
	            { className: this.props.classNames.months },
	            this.renderMonths()
	          ),
	          this.renderFooter()
	        )
	      );
	    }
	  }]);
	
	  return DayPicker;
	}(_react.Component);
	
	DayPicker.VERSION = '7.1.4';
	DayPicker.defaultProps = {
	  classNames: _classNames2.default,
	  tabIndex: 0,
	  initialMonth: new Date(),
	  numberOfMonths: 1,
	  labels: {
	    previousMonth: 'Previous Month',
	    nextMonth: 'Next Month'
	  },
	  locale: 'en',
	  localeUtils: LocaleUtils,
	  showOutsideDays: false,
	  enableOutsideDaysClick: true,
	  fixedWeeks: false,
	  canChangeMonth: true,
	  reverseMonths: false,
	  pagedNavigation: false,
	  showWeekNumbers: false,
	  showWeekDays: true,
	  renderDay: function renderDay(day) {
	    return day.getDate();
	  },
	  renderWeek: function renderWeek(weekNumber) {
	    return weekNumber;
	  },
	  weekdayElement: _react2.default.createElement(_Weekday2.default, null),
	  navbarElement: _react2.default.createElement(_Navbar2.default, { classNames: _classNames2.default }),
	  captionElement: _react2.default.createElement(_Caption2.default, { classNames: _classNames2.default })
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this8 = this;
	
	  this.getStateFromProps = function (props) {
	    var initialMonth = Helpers.startOfMonth(props.month || props.initialMonth);
	    var currentMonth = initialMonth;
	
	    if (props.pagedNavigation && props.numberOfMonths > 1 && props.fromMonth) {
	      var diffInMonths = Helpers.getMonthsDiff(props.fromMonth, currentMonth);
	      currentMonth = DateUtils.addMonths(props.fromMonth, Math.floor(diffInMonths / props.numberOfMonths) * props.numberOfMonths);
	    } else if (props.toMonth && props.numberOfMonths > 1 && Helpers.getMonthsDiff(currentMonth, props.toMonth) <= 0) {
	      currentMonth = DateUtils.addMonths(props.toMonth, 1 - _this8.props.numberOfMonths);
	    }
	    return { currentMonth: currentMonth };
	  };
	
	  this.dayPicker = null;
	
	  this.showNextMonth = function (callback) {
	    if (!_this8.allowNextMonth()) {
	      return;
	    }
	    var deltaMonths = _this8.props.pagedNavigation ? _this8.props.numberOfMonths : 1;
	    var nextMonth = DateUtils.addMonths(_this8.state.currentMonth, deltaMonths);
	    _this8.showMonth(nextMonth, callback);
	  };
	
	  this.showPreviousMonth = function (callback) {
	    if (!_this8.allowPreviousMonth()) {
	      return;
	    }
	    var deltaMonths = _this8.props.pagedNavigation ? _this8.props.numberOfMonths : 1;
	    var previousMonth = DateUtils.addMonths(_this8.state.currentMonth, -deltaMonths);
	    _this8.showMonth(previousMonth, callback);
	  };
	
	  this.handleKeyDown = function (e) {
	    e.persist();
	
	    switch (e.keyCode) {
	      case _keys.LEFT:
	        _this8.showPreviousMonth();
	        break;
	      case _keys.RIGHT:
	        _this8.showNextMonth();
	        break;
	      case _keys.UP:
	        _this8.showPreviousYear();
	        break;
	      case _keys.DOWN:
	        _this8.showNextYear();
	        break;
	      default:
	        break;
	    }
	
	    if (_this8.props.onKeyDown) {
	      _this8.props.onKeyDown(e);
	    }
	  };
	
	  this.handleDayKeyDown = function (day, modifiers, e) {
	    e.persist();
	    switch (e.keyCode) {
	      case _keys.LEFT:
	        Helpers.cancelEvent(e);
	        _this8.focusPreviousDay(e.target);
	        break;
	      case _keys.RIGHT:
	        Helpers.cancelEvent(e);
	        _this8.focusNextDay(e.target);
	        break;
	      case _keys.UP:
	        Helpers.cancelEvent(e);
	        _this8.focusPreviousWeek(e.target);
	        break;
	      case _keys.DOWN:
	        Helpers.cancelEvent(e);
	        _this8.focusNextWeek(e.target);
	        break;
	      case _keys.ENTER:
	      case _keys.SPACE:
	        Helpers.cancelEvent(e);
	        if (_this8.props.onDayClick) {
	          _this8.handleDayClick(day, modifiers, e);
	        }
	        break;
	      default:
	        break;
	    }
	    if (_this8.props.onDayKeyDown) {
	      _this8.props.onDayKeyDown(day, modifiers, e);
	    }
	  };
	
	  this.handleDayClick = function (day, modifiers, e) {
	    e.persist();
	    if (modifiers[_this8.props.classNames.outside] && _this8.props.enableOutsideDaysClick) {
	      _this8.handleOutsideDayClick(day);
	    }
	    if (_this8.props.onDayClick) {
	      _this8.props.onDayClick(day, modifiers, e);
	    }
	  };
	
	  this.handleTodayButtonClick = function (e) {
	    var today = new Date();
	    var month = new Date(today.getFullYear(), today.getMonth());
	    _this8.showMonth(month);
	    e.target.blur();
	    if (_this8.props.onTodayButtonClick) {
	      e.persist();
	      _this8.props.onTodayButtonClick(new Date(today.getFullYear(), today.getMonth(), today.getDate()), ModifiersUtils.getModifiersForDay(today, _this8.props.modifiers), e);
	    }
	  };
	};
	
	exports.default = DayPicker;
	DayPicker.propTypes =  false ? {
	  // Rendering months
	  initialMonth: _propTypes2.default.instanceOf(Date),
	  month: _propTypes2.default.instanceOf(Date),
	  numberOfMonths: _propTypes2.default.number,
	  fromMonth: _propTypes2.default.instanceOf(Date),
	  toMonth: _propTypes2.default.instanceOf(Date),
	  canChangeMonth: _propTypes2.default.bool,
	  reverseMonths: _propTypes2.default.bool,
	  pagedNavigation: _propTypes2.default.bool,
	  todayButton: _propTypes2.default.string,
	  showWeekNumbers: _propTypes2.default.bool,
	  showWeekDays: _propTypes2.default.bool,
	
	  // Modifiers
	  selectedDays: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.array]),
	  disabledDays: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.array]),
	
	  modifiers: _propTypes2.default.object,
	  modifiersStyles: _propTypes2.default.object,
	
	  // Localization
	  dir: _propTypes2.default.string,
	  firstDayOfWeek: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5, 6]),
	  labels: _propTypes2.default.shape({
	    nextMonth: _propTypes2.default.string.isRequired,
	    previousMonth: _propTypes2.default.string.isRequired
	  }),
	  locale: _propTypes2.default.string,
	  localeUtils: _propTypes2.default.shape({
	    formatMonthTitle: _propTypes2.default.func,
	    formatWeekdayShort: _propTypes2.default.func,
	    formatWeekdayLong: _propTypes2.default.func,
	    getFirstDayOfWeek: _propTypes2.default.func
	  }),
	  months: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),
	
	  // Customization
	  showOutsideDays: _propTypes2.default.bool,
	  enableOutsideDaysClick: _propTypes2.default.bool,
	  fixedWeeks: _propTypes2.default.bool,
	
	  // CSS and HTML
	  classNames: _propTypes2.default.shape({
	    body: _propTypes2.default.string,
	    container: _propTypes2.default.string,
	    day: _propTypes2.default.string.isRequired,
	    disabled: _propTypes2.default.string.isRequired,
	    footer: _propTypes2.default.string,
	    interactionDisabled: _propTypes2.default.string,
	    months: _propTypes2.default.string,
	    month: _propTypes2.default.string,
	    navBar: _propTypes2.default.string,
	    outside: _propTypes2.default.string.isRequired,
	    selected: _propTypes2.default.string.isRequired,
	    today: _propTypes2.default.string.isRequired,
	    todayButton: _propTypes2.default.string,
	    week: _propTypes2.default.string,
	    wrapper: _propTypes2.default.string
	  }),
	  className: _propTypes2.default.string,
	  containerProps: _propTypes2.default.object,
	  tabIndex: _propTypes2.default.number,
	
	  // Custom elements
	  renderDay: _propTypes2.default.func,
	  renderWeek: _propTypes2.default.func,
	  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),
	  navbarElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),
	  captionElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),
	
	  // Events
	  onBlur: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  onKeyDown: _propTypes2.default.func,
	  onDayClick: _propTypes2.default.func,
	  onDayKeyDown: _propTypes2.default.func,
	  onDayMouseEnter: _propTypes2.default.func,
	  onDayMouseLeave: _propTypes2.default.func,
	  onDayMouseDown: _propTypes2.default.func,
	  onDayMouseUp: _propTypes2.default.func,
	  onDayTouchStart: _propTypes2.default.func,
	  onDayTouchEnd: _propTypes2.default.func,
	  onDayFocus: _propTypes2.default.func,
	  onMonthChange: _propTypes2.default.func,
	  onCaptionClick: _propTypes2.default.func,
	  onWeekClick: _propTypes2.default.func,
	  onTodayButtonClick: _propTypes2.default.func
	} : {};
	
	
	DayPicker.DateUtils = DateUtils;
	DayPicker.LocaleUtils = LocaleUtils;
	DayPicker.ModifiersUtils = ModifiersUtils;
	//# sourceMappingURL=DayPicker.js.map

/***/ },
/* 1390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Weekdays = __webpack_require__(1392);
	
	var _Weekdays2 = _interopRequireDefault(_Weekdays);
	
	var _Day = __webpack_require__(1388);
	
	var _Day2 = _interopRequireDefault(_Day);
	
	var _keys = __webpack_require__(196);
	
	var _ModifiersUtils = __webpack_require__(291);
	
	var ModifiersUtils = _interopRequireWildcard(_ModifiersUtils);
	
	var _Helpers = __webpack_require__(193);
	
	var Helpers = _interopRequireWildcard(_Helpers);
	
	var _DateUtils = __webpack_require__(133);
	
	var DateUtils = _interopRequireWildcard(_DateUtils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Month = function (_Component) {
	  _inherits(Month, _Component);
	
	  function Month() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Month);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Month.__proto__ || Object.getPrototypeOf(Month)).call.apply(_ref, [this].concat(args))), _this), _this.renderDay = function (day) {
	      var monthNumber = _this.props.month.getMonth();
	      var propModifiers = Helpers.getModifiersFromProps(_this.props);
	      var dayModifiers = ModifiersUtils.getModifiersForDay(day, propModifiers);
	      if (DateUtils.isSameDay(day, new Date()) && !Object.prototype.hasOwnProperty.call(propModifiers, _this.props.classNames.today)) {
	        dayModifiers.push(_this.props.classNames.today);
	      }
	      if (day.getMonth() !== monthNumber) {
	        dayModifiers.push(_this.props.classNames.outside);
	      }
	
	      var isOutside = day.getMonth() !== monthNumber;
	      var tabIndex = -1;
	      // Focus on the first day of the month
	      if (_this.props.onDayClick && !isOutside && day.getDate() === 1) {
	        tabIndex = _this.props.tabIndex; // eslint-disable-line prefer-destructuring
	      }
	      var key = '' + day.getFullYear() + day.getMonth() + day.getDate();
	      var modifiers = {};
	      dayModifiers.forEach(function (modifier) {
	        modifiers[modifier] = true;
	      });
	
	      return _react2.default.createElement(
	        _Day2.default,
	        {
	          key: '' + (isOutside ? 'outside-' : '') + key,
	          classNames: _this.props.classNames,
	          day: day,
	          modifiers: modifiers,
	          modifiersStyles: _this.props.modifiersStyles,
	          empty: isOutside && !_this.props.showOutsideDays && !_this.props.fixedWeeks,
	          tabIndex: tabIndex,
	          ariaLabel: _this.props.localeUtils.formatDay(day, _this.props.locale),
	          ariaDisabled: isOutside || dayModifiers.indexOf('disabled') > -1,
	          ariaSelected: dayModifiers.indexOf('selected') > -1,
	          onClick: _this.props.onDayClick,
	          onFocus: _this.props.onDayFocus,
	          onKeyDown: _this.props.onDayKeyDown,
	          onMouseEnter: _this.props.onDayMouseEnter,
	          onMouseLeave: _this.props.onDayMouseLeave,
	          onMouseDown: _this.props.onDayMouseDown,
	          onMouseUp: _this.props.onDayMouseUp,
	          onTouchEnd: _this.props.onDayTouchEnd,
	          onTouchStart: _this.props.onDayTouchStart
	        },
	        _this.props.renderDay(day, modifiers)
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Month, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          classNames = _props.classNames,
	          month = _props.month,
	          months = _props.months,
	          fixedWeeks = _props.fixedWeeks,
	          captionElement = _props.captionElement,
	          weekdayElement = _props.weekdayElement,
	          locale = _props.locale,
	          localeUtils = _props.localeUtils,
	          weekdaysLong = _props.weekdaysLong,
	          weekdaysShort = _props.weekdaysShort,
	          firstDayOfWeek = _props.firstDayOfWeek,
	          onCaptionClick = _props.onCaptionClick,
	          showWeekNumbers = _props.showWeekNumbers,
	          showWeekDays = _props.showWeekDays,
	          onWeekClick = _props.onWeekClick;
	
	
	      var captionProps = {
	        date: month,
	        classNames: classNames,
	        months: months,
	        localeUtils: localeUtils,
	        locale: locale,
	        onClick: onCaptionClick ? function (e) {
	          return onCaptionClick(month, e);
	        } : undefined
	      };
	      var caption = _react2.default.isValidElement(captionElement) ? _react2.default.cloneElement(captionElement, captionProps) : _react2.default.createElement(captionElement, captionProps);
	
	      var weeks = Helpers.getWeekArray(month, firstDayOfWeek, fixedWeeks);
	      return _react2.default.createElement(
	        'div',
	        { className: classNames.month, role: 'grid' },
	        caption,
	        showWeekDays && _react2.default.createElement(_Weekdays2.default, {
	          classNames: classNames,
	          weekdaysShort: weekdaysShort,
	          weekdaysLong: weekdaysLong,
	          firstDayOfWeek: firstDayOfWeek,
	          showWeekNumbers: showWeekNumbers,
	          locale: locale,
	          localeUtils: localeUtils,
	          weekdayElement: weekdayElement
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: classNames.body, role: 'rowgroup' },
	          weeks.map(function (week) {
	            var weekNumber = void 0;
	            if (showWeekNumbers) {
	              weekNumber = DateUtils.getWeekNumber(week[0]);
	            }
	            return _react2.default.createElement(
	              'div',
	              {
	                key: week[0].getTime(),
	                className: classNames.week,
	                role: 'row'
	              },
	              showWeekNumbers && _react2.default.createElement(
	                'div',
	                {
	                  className: classNames.weekNumber,
	                  tabIndex: 0,
	                  role: 'gridcell',
	                  onClick: onWeekClick ? function (e) {
	                    return onWeekClick(weekNumber, week, e);
	                  } : undefined,
	                  onKeyUp: onWeekClick ? function (e) {
	                    return e.keyCode === _keys.ENTER && onWeekClick(weekNumber, week, e);
	                  } : undefined
	                },
	                _this2.props.renderWeek(weekNumber, week, month)
	              ),
	              week.map(_this2.renderDay)
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return Month;
	}(_react.Component);
	
	exports.default = Month;
	Month.propTypes =  false ? {
	  classNames: _propTypes2.default.shape({
	    body: _propTypes2.default.string.isRequired,
	    month: _propTypes2.default.string.isRequired,
	    outside: _propTypes2.default.string.isRequired,
	    today: _propTypes2.default.string.isRequired,
	    week: _propTypes2.default.string.isRequired
	  }).isRequired,
	  tabIndex: _propTypes2.default.number,
	
	  month: _propTypes2.default.instanceOf(Date).isRequired,
	  months: _propTypes2.default.arrayOf(_propTypes2.default.string),
	
	  modifiersStyles: _propTypes2.default.object,
	
	  showWeekDays: _propTypes2.default.bool,
	  showOutsideDays: _propTypes2.default.bool,
	
	  renderDay: _propTypes2.default.func.isRequired,
	  renderWeek: _propTypes2.default.func.isRequired,
	
	  captionElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)]).isRequired,
	  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)]),
	
	  fixedWeeks: _propTypes2.default.bool,
	  showWeekNumbers: _propTypes2.default.bool,
	
	  locale: _propTypes2.default.string.isRequired,
	  localeUtils: _propTypes2.default.object.isRequired,
	  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  firstDayOfWeek: _propTypes2.default.number.isRequired,
	
	  onCaptionClick: _propTypes2.default.func,
	  onDayClick: _propTypes2.default.func,
	  onDayFocus: _propTypes2.default.func,
	  onDayKeyDown: _propTypes2.default.func,
	  onDayMouseEnter: _propTypes2.default.func,
	  onDayMouseLeave: _propTypes2.default.func,
	  onDayMouseDown: _propTypes2.default.func,
	  onDayMouseUp: _propTypes2.default.func,
	  onDayTouchEnd: _propTypes2.default.func,
	  onDayTouchStart: _propTypes2.default.func,
	  onWeekClick: _propTypes2.default.func
	} : {};
	//# sourceMappingURL=Month.js.map

/***/ },
/* 1391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ModifierPropType = undefined;
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PrimitiveTypes = {
	  localeUtils: _propTypes2.default.shape({
	    formatMonthTitle: _propTypes2.default.func,
	    formatWeekdayShort: _propTypes2.default.func,
	    formatWeekdayLong: _propTypes2.default.func,
	    getFirstDayOfWeek: _propTypes2.default.func
	  }),
	  range: _propTypes2.default.shape({
	    from: _propTypes2.default.instanceOf(Date),
	    to: _propTypes2.default.instanceOf(Date)
	  }),
	  after: _propTypes2.default.shape({
	    after: _propTypes2.default.instanceOf(Date)
	  }),
	  before: _propTypes2.default.shape({
	    before: _propTypes2.default.instanceOf(Date)
	  })
	};
	
	var ModifierPropType = exports.ModifierPropType = _propTypes2.default.oneOfType([PrimitiveTypes.after, PrimitiveTypes.before, PrimitiveTypes.range, _propTypes2.default.func, _propTypes2.default.array]);
	
	exports.default = PrimitiveTypes;
	//# sourceMappingURL=PropTypes.js.map

/***/ },
/* 1392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Weekdays = function (_Component) {
	  _inherits(Weekdays, _Component);
	
	  function Weekdays() {
	    _classCallCheck(this, Weekdays);
	
	    return _possibleConstructorReturn(this, (Weekdays.__proto__ || Object.getPrototypeOf(Weekdays)).apply(this, arguments));
	  }
	
	  _createClass(Weekdays, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props !== nextProps;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          classNames = _props.classNames,
	          firstDayOfWeek = _props.firstDayOfWeek,
	          showWeekNumbers = _props.showWeekNumbers,
	          weekdaysLong = _props.weekdaysLong,
	          weekdaysShort = _props.weekdaysShort,
	          locale = _props.locale,
	          localeUtils = _props.localeUtils,
	          weekdayElement = _props.weekdayElement;
	
	      var days = [];
	      for (var i = 0; i < 7; i += 1) {
	        var weekday = (i + firstDayOfWeek) % 7;
	        var elementProps = {
	          key: i,
	          className: classNames.weekday,
	          weekday: weekday,
	          weekdaysLong: weekdaysLong,
	          weekdaysShort: weekdaysShort,
	          localeUtils: localeUtils,
	          locale: locale
	        };
	        var element = _react2.default.isValidElement(weekdayElement) ? _react2.default.cloneElement(weekdayElement, elementProps) : _react2.default.createElement(weekdayElement, elementProps);
	        days.push(element);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: classNames.weekdays, role: 'rowgroup' },
	        _react2.default.createElement(
	          'div',
	          { className: classNames.weekdaysRow, role: 'row' },
	          showWeekNumbers && _react2.default.createElement('div', { className: classNames.weekday }),
	          days
	        )
	      );
	    }
	  }]);
	
	  return Weekdays;
	}(_react.Component);
	
	exports.default = Weekdays;
	Weekdays.propTypes =  false ? {
	  classNames: _propTypes2.default.shape({
	    weekday: _propTypes2.default.string.isRequired,
	    weekdays: _propTypes2.default.string.isRequired,
	    weekdaysRow: _propTypes2.default.string.isRequired
	  }).isRequired,
	
	  firstDayOfWeek: _propTypes2.default.number.isRequired,
	  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  showWeekNumbers: _propTypes2.default.bool,
	  locale: _propTypes2.default.string.isRequired,
	  localeUtils: _propTypes2.default.object.isRequired,
	  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)])
	} : {};
	//# sourceMappingURL=Weekdays.js.map

/***/ },
/* 1393 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-env node */
	
	module.exports = __webpack_require__(597);
	module.exports.localeUtils = __webpack_require__(597);


/***/ },
/* 1394 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(1397);
	
	var invariant = __webpack_require__(15);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 1395 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(1394);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 1396 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 1397 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 1398 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 1399 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(36);
	
	var focusNode = __webpack_require__(450);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 1400 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(156);
	var ExecutionEnvironment = __webpack_require__(49);
	var FallbackCompositionState = __webpack_require__(1406);
	var SyntheticCompositionEvent = __webpack_require__(1443);
	var SyntheticInputEvent = __webpack_require__(1446);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 1401 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(599);
	var ExecutionEnvironment = __webpack_require__(49);
	var ReactInstrumentation = __webpack_require__(70);
	
	var camelizeStyleName = __webpack_require__(1311);
	var dangerousStyleValue = __webpack_require__(1452);
	var hyphenateStyleName = __webpack_require__(1318);
	var memoizeStringOnly = __webpack_require__(1321);
	var warning = __webpack_require__(21);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 1402 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(155);
	var EventPropagators = __webpack_require__(156);
	var ExecutionEnvironment = __webpack_require__(49);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactUpdates = __webpack_require__(82);
	var SyntheticEvent = __webpack_require__(87);
	
	var getEventTarget = __webpack_require__(304);
	var isEventSupported = __webpack_require__(305);
	var isTextInputElement = __webpack_require__(616);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topInput') {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topClick') {
	    return targetInst;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 1403 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var DOMLazyTree = __webpack_require__(134);
	var ExecutionEnvironment = __webpack_require__(49);
	
	var createNodesFromMarkup = __webpack_require__(1314);
	var emptyFunction = __webpack_require__(55);
	var invariant = __webpack_require__(15);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 1404 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 1405 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(156);
	var ReactDOMComponentTree = __webpack_require__(36);
	var SyntheticMouseEvent = __webpack_require__(198);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 1406 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(26);
	
	var PooledClass = __webpack_require__(115);
	
	var getTextContentAccessor = __webpack_require__(614);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 1407 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(135);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {}
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 1408 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(136);
	
	var instantiateReactComponent = __webpack_require__(615);
	var KeyEscapeUtils = __webpack_require__(296);
	var shouldUpdateReactComponent = __webpack_require__(306);
	var traverseAllChildren = __webpack_require__(618);
	var warning = __webpack_require__(21);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","DEV_LOGIN_EMAIL":"","DEV_LOGIN_PASSWORD":""}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(646);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
	  ) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(132)))

/***/ },
/* 1409 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(292);
	var ReactDOMIDOperations = __webpack_require__(1416);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 1410 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25),
	    _assign = __webpack_require__(26);
	
	var React = __webpack_require__(139);
	var ReactComponentEnvironment = __webpack_require__(298);
	var ReactCurrentOwner = __webpack_require__(88);
	var ReactErrorUtils = __webpack_require__(299);
	var ReactInstanceMap = __webpack_require__(157);
	var ReactInstrumentation = __webpack_require__(70);
	var ReactNodeTypes = __webpack_require__(609);
	var ReactReconciler = __webpack_require__(136);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(130);
	var invariant = __webpack_require__(15);
	var shallowEqual = __webpack_require__(282);
	var shouldUpdateReactComponent = __webpack_require__(306);
	var warning = __webpack_require__(21);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'childContext');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 1411 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactDefaultInjection = __webpack_require__(1424);
	var ReactMount = __webpack_require__(608);
	var ReactReconciler = __webpack_require__(136);
	var ReactUpdates = __webpack_require__(82);
	var ReactVersion = __webpack_require__(1437);
	
	var findDOMNode = __webpack_require__(1453);
	var getHostComponentFromComposite = __webpack_require__(613);
	var renderSubtreeIntoContainer = __webpack_require__(1461);
	var warning = __webpack_require__(21);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 1412 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25),
	    _assign = __webpack_require__(26);
	
	var AutoFocusUtils = __webpack_require__(1399);
	var CSSPropertyOperations = __webpack_require__(1401);
	var DOMLazyTree = __webpack_require__(134);
	var DOMNamespaces = __webpack_require__(293);
	var DOMProperty = __webpack_require__(135);
	var DOMPropertyOperations = __webpack_require__(601);
	var EventPluginHub = __webpack_require__(155);
	var EventPluginRegistry = __webpack_require__(294);
	var ReactBrowserEventEmitter = __webpack_require__(197);
	var ReactDOMComponentFlags = __webpack_require__(602);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactDOMInput = __webpack_require__(1417);
	var ReactDOMOption = __webpack_require__(1418);
	var ReactDOMSelect = __webpack_require__(603);
	var ReactDOMTextarea = __webpack_require__(1421);
	var ReactInstrumentation = __webpack_require__(70);
	var ReactMultiChild = __webpack_require__(1430);
	var ReactServerRenderingTransaction = __webpack_require__(1435);
	
	var emptyFunction = __webpack_require__(55);
	var escapeTextContentForBrowser = __webpack_require__(200);
	var invariant = __webpack_require__(15);
	var isEventSupported = __webpack_require__(305);
	var shallowEqual = __webpack_require__(282);
	var validateDOMNesting = __webpack_require__(307);
	var warning = __webpack_require__(21);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 1413 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(307);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 1414 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(26);
	
	var DOMLazyTree = __webpack_require__(134);
	var ReactDOMComponentTree = __webpack_require__(36);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 1415 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 1416 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(292);
	var ReactDOMComponentTree = __webpack_require__(36);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 1417 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25),
	    _assign = __webpack_require__(26);
	
	var DOMPropertyOperations = __webpack_require__(601);
	var LinkedValueUtils = __webpack_require__(297);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactUpdates = __webpack_require__(82);
	
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(21);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	
	    if (false) {
	      inst._wrapperState.controlled = isControlled(props);
	    }
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 1418 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(26);
	
	var React = __webpack_require__(139);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactDOMSelect = __webpack_require__(603);
	
	var warning = __webpack_require__(21);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 1419 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(49);
	
	var getNodeForCharacterOffset = __webpack_require__(1458);
	var getTextContentAccessor = __webpack_require__(614);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 1420 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25),
	    _assign = __webpack_require__(26);
	
	var DOMChildrenOperations = __webpack_require__(292);
	var DOMLazyTree = __webpack_require__(134);
	var ReactDOMComponentTree = __webpack_require__(36);
	
	var escapeTextContentForBrowser = __webpack_require__(200);
	var invariant = __webpack_require__(15);
	var validateDOMNesting = __webpack_require__(307);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 1421 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25),
	    _assign = __webpack_require__(26);
	
	var LinkedValueUtils = __webpack_require__(297);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactUpdates = __webpack_require__(82);
	
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(21);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 1422 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var invariant = __webpack_require__(15);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 1423 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(26);
	
	var ReactUpdates = __webpack_require__(82);
	var Transaction = __webpack_require__(199);
	
	var emptyFunction = __webpack_require__(55);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 1424 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(1398);
	var BeforeInputEventPlugin = __webpack_require__(1400);
	var ChangeEventPlugin = __webpack_require__(1402);
	var DefaultEventPluginOrder = __webpack_require__(1404);
	var EnterLeaveEventPlugin = __webpack_require__(1405);
	var HTMLDOMPropertyConfig = __webpack_require__(1407);
	var ReactComponentBrowserEnvironment = __webpack_require__(1409);
	var ReactDOMComponent = __webpack_require__(1412);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactDOMEmptyComponent = __webpack_require__(1414);
	var ReactDOMTreeTraversal = __webpack_require__(1422);
	var ReactDOMTextComponent = __webpack_require__(1420);
	var ReactDefaultBatchingStrategy = __webpack_require__(1423);
	var ReactEventListener = __webpack_require__(1427);
	var ReactInjection = __webpack_require__(1428);
	var ReactReconcileTransaction = __webpack_require__(1433);
	var SVGDOMPropertyConfig = __webpack_require__(1438);
	var SelectEventPlugin = __webpack_require__(1439);
	var SimpleEventPlugin = __webpack_require__(1440);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 1425 */
647,
/* 1426 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(155);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 1427 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(26);
	
	var EventListener = __webpack_require__(449);
	var ExecutionEnvironment = __webpack_require__(49);
	var PooledClass = __webpack_require__(115);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactUpdates = __webpack_require__(82);
	
	var getEventTarget = __webpack_require__(304);
	var getUnboundedScrollPosition = __webpack_require__(1316);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 1428 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(135);
	var EventPluginHub = __webpack_require__(155);
	var EventPluginUtils = __webpack_require__(295);
	var ReactComponentEnvironment = __webpack_require__(298);
	var ReactEmptyComponent = __webpack_require__(604);
	var ReactBrowserEventEmitter = __webpack_require__(197);
	var ReactHostComponent = __webpack_require__(606);
	var ReactUpdates = __webpack_require__(82);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 1429 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(1451);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 1430 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var ReactComponentEnvironment = __webpack_require__(298);
	var ReactInstanceMap = __webpack_require__(157);
	var ReactInstrumentation = __webpack_require__(70);
	
	var ReactCurrentOwner = __webpack_require__(88);
	var ReactReconciler = __webpack_require__(136);
	var ReactChildReconciler = __webpack_require__(1408);
	
	var emptyFunction = __webpack_require__(55);
	var flattenChildren = __webpack_require__(1454);
	var invariant = __webpack_require__(15);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 1431 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var invariant = __webpack_require__(15);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 1432 */
1528,
/* 1433 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(26);
	
	var CallbackQueue = __webpack_require__(600);
	var PooledClass = __webpack_require__(115);
	var ReactBrowserEventEmitter = __webpack_require__(197);
	var ReactInputSelection = __webpack_require__(607);
	var ReactInstrumentation = __webpack_require__(70);
	var Transaction = __webpack_require__(199);
	var ReactUpdateQueue = __webpack_require__(300);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 1434 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(1431);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 1435 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(26);
	
	var PooledClass = __webpack_require__(115);
	var Transaction = __webpack_require__(199);
	var ReactInstrumentation = __webpack_require__(70);
	var ReactServerUpdateQueue = __webpack_require__(1436);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 1436 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(300);
	
	var warning = __webpack_require__(21);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 1437 */
1530,
/* 1438 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 1439 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(156);
	var ExecutionEnvironment = __webpack_require__(49);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactInputSelection = __webpack_require__(607);
	var SyntheticEvent = __webpack_require__(87);
	
	var getActiveElement = __webpack_require__(451);
	var isTextInputElement = __webpack_require__(616);
	var shallowEqual = __webpack_require__(282);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 1440 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var EventListener = __webpack_require__(449);
	var EventPropagators = __webpack_require__(156);
	var ReactDOMComponentTree = __webpack_require__(36);
	var SyntheticAnimationEvent = __webpack_require__(1441);
	var SyntheticClipboardEvent = __webpack_require__(1442);
	var SyntheticEvent = __webpack_require__(87);
	var SyntheticFocusEvent = __webpack_require__(1445);
	var SyntheticKeyboardEvent = __webpack_require__(1447);
	var SyntheticMouseEvent = __webpack_require__(198);
	var SyntheticDragEvent = __webpack_require__(1444);
	var SyntheticTouchEvent = __webpack_require__(1448);
	var SyntheticTransitionEvent = __webpack_require__(1449);
	var SyntheticUIEvent = __webpack_require__(158);
	var SyntheticWheelEvent = __webpack_require__(1450);
	
	var emptyFunction = __webpack_require__(55);
	var getEventCharCode = __webpack_require__(302);
	var invariant = __webpack_require__(15);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 1441 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(87);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 1442 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(87);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 1443 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(87);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 1444 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(198);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 1445 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(158);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 1446 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(87);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 1447 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(158);
	
	var getEventCharCode = __webpack_require__(302);
	var getEventKey = __webpack_require__(1455);
	var getEventModifierState = __webpack_require__(303);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 1448 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(158);
	
	var getEventModifierState = __webpack_require__(303);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 1449 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(87);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 1450 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(198);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 1451 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 1452 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(599);
	var warning = __webpack_require__(21);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 1453 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var ReactCurrentOwner = __webpack_require__(88);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactInstanceMap = __webpack_require__(157);
	
	var getHostComponentFromComposite = __webpack_require__(613);
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(21);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 1454 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(296);
	var traverseAllChildren = __webpack_require__(618);
	var warning = __webpack_require__(21);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","DEV_LOGIN_EMAIL":"","DEV_LOGIN_PASSWORD":""}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(646);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(132)))

/***/ },
/* 1455 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(302);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 1456 */
650,
/* 1457 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 1458 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 1459 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(49);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 1460 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(200);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 1461 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(608);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 1462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var sizerStyle = {
		position: 'absolute',
		top: 0,
		left: 0,
		visibility: 'hidden',
		height: 0,
		overflow: 'scroll',
		whiteSpace: 'pre'
	};
	
	var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];
	
	var cleanInputProps = function cleanInputProps(inputProps) {
		INPUT_PROPS_BLACKLIST.forEach(function (field) {
			return delete inputProps[field];
		});
		return inputProps;
	};
	
	var copyStyles = function copyStyles(styles, node) {
		node.style.fontSize = styles.fontSize;
		node.style.fontFamily = styles.fontFamily;
		node.style.fontWeight = styles.fontWeight;
		node.style.fontStyle = styles.fontStyle;
		node.style.letterSpacing = styles.letterSpacing;
		node.style.textTransform = styles.textTransform;
	};
	
	var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
	
	var generateId = function generateId() {
		// we only need an auto-generated ID for stylesheet injection, which is only
		// used for IE. so if the browser is not IE, this should return undefined.
		return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
	};
	
	var AutosizeInput = function (_Component) {
		_inherits(AutosizeInput, _Component);
	
		function AutosizeInput(props) {
			_classCallCheck(this, AutosizeInput);
	
			var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
	
			_this.inputRef = function (el) {
				_this.input = el;
				if (typeof _this.props.inputRef === 'function') {
					_this.props.inputRef(el);
				}
			};
	
			_this.placeHolderSizerRef = function (el) {
				_this.placeHolderSizer = el;
			};
	
			_this.sizerRef = function (el) {
				_this.sizer = el;
			};
	
			_this.state = {
				inputWidth: props.minWidth,
				inputId: props.id || generateId()
			};
			return _this;
		}
	
		_createClass(AutosizeInput, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.mounted = true;
				this.copyInputStyles();
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var id = nextProps.id;
	
				if (id !== this.props.id) {
					this.setState({ inputId: id || generateId() });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (prevState.inputWidth !== this.state.inputWidth) {
					if (typeof this.props.onAutosize === 'function') {
						this.props.onAutosize(this.state.inputWidth);
					}
				}
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'copyInputStyles',
			value: function copyInputStyles() {
				if (!this.mounted || !window.getComputedStyle) {
					return;
				}
				var inputStyles = this.input && window.getComputedStyle(this.input);
				if (!inputStyles) {
					return;
				}
				copyStyles(inputStyles, this.sizer);
				if (this.placeHolderSizer) {
					copyStyles(inputStyles, this.placeHolderSizer);
				}
			}
		}, {
			key: 'updateInputWidth',
			value: function updateInputWidth() {
				if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
					return;
				}
				var newInputWidth = void 0;
				if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
					newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
				} else {
					newInputWidth = this.sizer.scrollWidth + 2;
				}
				// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
				var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
				newInputWidth += extraWidth;
				if (newInputWidth < this.props.minWidth) {
					newInputWidth = this.props.minWidth;
				}
				if (newInputWidth !== this.state.inputWidth) {
					this.setState({
						inputWidth: newInputWidth
					});
				}
			}
		}, {
			key: 'getInput',
			value: function getInput() {
				return this.input;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.input.focus();
			}
		}, {
			key: 'blur',
			value: function blur() {
				this.input.blur();
			}
		}, {
			key: 'select',
			value: function select() {
				this.input.select();
			}
		}, {
			key: 'renderStyles',
			value: function renderStyles() {
				// this method injects styles to hide IE's clear indicator, which messes
				// with input size detection. the stylesheet is only injected when the
				// browser is IE, and can also be disabled by the `injectStyles` prop.
				var injectStyles = this.props.injectStyles;
	
				return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
						__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
					} }) : null;
			}
		}, {
			key: 'render',
			value: function render() {
				var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
					if (previousValue !== null && previousValue !== undefined) {
						return previousValue;
					}
					return currentValue;
				});
	
				var wrapperStyle = _extends({}, this.props.style);
				if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
	
				var inputStyle = _extends({
					boxSizing: 'content-box',
					width: this.state.inputWidth + 'px'
				}, this.props.inputStyle);
	
				var inputProps = _objectWithoutProperties(this.props, []);
	
				cleanInputProps(inputProps);
				inputProps.className = this.props.inputClassName;
				inputProps.id = this.state.inputId;
				inputProps.style = inputStyle;
	
				return _react2.default.createElement(
					'div',
					{ className: this.props.className, style: wrapperStyle },
					this.renderStyles(),
					_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
					_react2.default.createElement(
						'div',
						{ ref: this.sizerRef, style: sizerStyle },
						sizerValue
					),
					this.props.placeholder ? _react2.default.createElement(
						'div',
						{ ref: this.placeHolderSizerRef, style: sizerStyle },
						this.props.placeholder
					) : null
				);
			}
		}]);
	
		return AutosizeInput;
	}(_react.Component);
	
	AutosizeInput.propTypes = {
		className: _propTypes2.default.string, // className for the outer element
		defaultValue: _propTypes2.default.any, // default field value
		extraWidth: _propTypes2.default.oneOfType([// additional width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
		injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
		inputClassName: _propTypes2.default.string, // className for the input element
		inputRef: _propTypes2.default.func, // ref callback for the input element
		inputStyle: _propTypes2.default.object, // css styles for the input element
		minWidth: _propTypes2.default.oneOfType([// minimum width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
		onChange: _propTypes2.default.func, // onChange handler: function(event) {}
		placeholder: _propTypes2.default.string, // placeholder text
		placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
		style: _propTypes2.default.object, // css styles for the outer element
		value: _propTypes2.default.any // field value
	};
	AutosizeInput.defaultProps = {
		minWidth: 1,
		injectStyles: true
	};
	
	exports.default = AutosizeInput;

/***/ },
/* 1463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React     = __webpack_require__(1);
	var invariant = __webpack_require__(1464);
	var except    = __webpack_require__(448);
	var extend    = __webpack_require__(26);
	
	function isString(object) {
	  return Object.prototype.toString.call(object) === '[object String]';
	}
	
	var REGEXP = /\%\((.+?)\)s/;
	var OMITTED_PROPS = ['children', 'format', 'component', 'unsafe', 'with'];
	
	var Interpolate = React.createClass({
	  displayName: 'Interpolate',
	
	  getDefaultProps: function() {
	    return { component: 'span' };
	  },
	
	  render: function() {
	    var format         = this.props.children;
	    var parent         = this.props.component;
	    var unsafe         = this.props.unsafe === true;
	    var interpolations = extend({}, this.props, this.props.with);
	    var props          = except(this.props, OMITTED_PROPS);
	
	    var matches = [];
	    var children = [];
	
	    if (!isString(format)) {
	      format = this.props.format;
	    }
	
	    invariant(isString(format), 'Interpolate expects either a format string as only child or a `format` prop with a string value');
	
	    if (unsafe) {
	      var content = format.split(REGEXP).reduce(function(memo, match, index) {
	        var html;
	
	        if (index % 2 === 0) {
	          html = match;
	        } else {
	          html = interpolations[match];
	          matches.push(match);
	        }
	
	        if (React.isValidElement(html)) {
	          throw new Error('cannot interpolate a React component into unsafe text');
	        }
	
	        memo += html;
	
	        return memo;
	      }, '');
	
	      props.dangerouslySetInnerHTML = { __html: content };
	    } else {
	      format.split(REGEXP).reduce(function(memo, match, index) {
	        var child;
	
	        if (index % 2 === 0) {
	          if (match.length === 0) {
	            return memo;
	          }
	
	          child = match;
	        } else {
	          child = interpolations[match];
	          matches.push(match);
	        }
	
	        memo.push(child);
	
	        return memo;
	      }, children);
	    }
	
	    props = except(props, matches);
	
	    return React.createElement.apply(this, [parent, props].concat(children));
	  }
	});
	
	module.exports = Interpolate;


/***/ },
/* 1464 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule invariant
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 1465 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(46);
	var DOMFactories = __webpack_require__(598);
	var PropTypes = __webpack_require__(14);
	var ExecutionEnvironment = __webpack_require__(1296);
	var ModalPortal = React.createFactory(__webpack_require__(1466));
	var ariaAppHider = __webpack_require__(1467);
	var refCount = __webpack_require__(1469);
	var elementClass = __webpack_require__(1294);
	var renderSubtreeIntoContainer = __webpack_require__(46).unstable_renderSubtreeIntoContainer;
	var Assign = __webpack_require__(461);
	var createReactClass = __webpack_require__(129);
	
	var SafeHTMLElement = ExecutionEnvironment.canUseDOM ? window.HTMLElement : {};
	var AppElement = ExecutionEnvironment.canUseDOM ? document.body : {appendChild: function() {}};
	
	function getParentElement(parentSelector) {
	  return parentSelector();
	}
	
	var Modal = createReactClass({
	
	  displayName: 'Modal',
	  statics: {
	    setAppElement: function(element) {
	        AppElement = ariaAppHider.setElement(element);
	    },
	    injectCSS: function() {
	      "production" !== ("production")
	        && console.warn('React-Modal: injectCSS has been deprecated ' +
	                        'and no longer has any effect. It will be removed in a later version');
	    }
	  },
	
	  propTypes: {
	    isOpen: PropTypes.bool.isRequired,
	    style: PropTypes.shape({
	      content: PropTypes.object,
	      overlay: PropTypes.object
	    }),
	    portalClassName: PropTypes.string,
	    bodyOpenClassName: PropTypes.string,
	    appElement: PropTypes.instanceOf(SafeHTMLElement),
	    onAfterOpen: PropTypes.func,
	    onRequestClose: PropTypes.func,
	    closeTimeoutMS: PropTypes.number,
	    ariaHideApp: PropTypes.bool,
	    shouldCloseOnOverlayClick: PropTypes.bool,
	    parentSelector: PropTypes.func,
	    role: PropTypes.string,
	    contentLabel: PropTypes.string.isRequired
	  },
	
	  getDefaultProps: function () {
	    return {
	      isOpen: false,
	      portalClassName: 'ReactModalPortal',
	      bodyOpenClassName: 'ReactModal__Body--open',
	      ariaHideApp: true,
	      closeTimeoutMS: 0,
	      shouldCloseOnOverlayClick: true,
	      parentSelector: function () { return document.body; }
	    };
	  },
	
	  componentDidMount: function() {
	    this.node = document.createElement('div');
	    this.node.className = this.props.portalClassName;
	
	    if (this.props.isOpen) refCount.add(this);
	
	    var parent = getParentElement(this.props.parentSelector);
	    parent.appendChild(this.node);
	    this.renderPortal(this.props);
	  },
	
	  componentWillUpdate: function(newProps) {
	    if(newProps.portalClassName !== this.props.portalClassName) {
	      this.node.className = newProps.portalClassName;
	    }
	  },
	
	  componentWillReceiveProps: function(newProps) {
	    if (newProps.isOpen) refCount.add(this);
	    if (!newProps.isOpen) refCount.remove(this);
	    var currentParent = getParentElement(this.props.parentSelector);
	    var newParent = getParentElement(newProps.parentSelector);
	
	    if(newParent !== currentParent) {
	      currentParent.removeChild(this.node);
	      newParent.appendChild(this.node);
	    }
	
	    this.renderPortal(newProps);
	  },
	
	  componentWillUnmount: function() {
	    if (!this.node) return;
	
	    refCount.remove(this);
	
	    if (this.props.ariaHideApp) {
	      ariaAppHider.show(this.props.appElement);
	    }
	
	    var state = this.portal.state;
	    var now = Date.now();
	    var closesAt = state.isOpen && this.props.closeTimeoutMS
	      && (state.closesAt
	        || now + this.props.closeTimeoutMS);
	
	    if (closesAt) {
	      if (!state.beforeClose) {
	        this.portal.closeWithTimeout();
	      }
	
	      var that = this;
	      setTimeout(function() { that.removePortal(); }, closesAt - now);
	    } else {
	      this.removePortal();
	    }
	  },
	
	  removePortal: function() {
	    ReactDOM.unmountComponentAtNode(this.node);
	    var parent = getParentElement(this.props.parentSelector);
	    parent.removeChild(this.node);
	
	    if (refCount.count() === 0) {
	      elementClass(document.body).remove(this.props.bodyOpenClassName);
	    }
	  },
	
	  renderPortal: function(props) {
	    if (props.isOpen || refCount.count() > 0) {
	      elementClass(document.body).add(this.props.bodyOpenClassName);
	    } else {
	      elementClass(document.body).remove(this.props.bodyOpenClassName);
	    }
	
	    if (props.ariaHideApp) {
	      ariaAppHider.toggle(props.isOpen, props.appElement);
	    }
	
	    this.portal = renderSubtreeIntoContainer(this, ModalPortal(Assign({}, props, {defaultStyles: Modal.defaultStyles})), this.node);
	  },
	
	  render: function () {
	    return DOMFactories.noscript();
	  }
	});
	
	Modal.defaultStyles = {
	  overlay: {
	    position        : 'fixed',
	    top             : 0,
	    left            : 0,
	    right           : 0,
	    bottom          : 0,
	    backgroundColor : 'rgba(255, 255, 255, 0.75)'
	  },
	  content: {
	    position                : 'absolute',
	    top                     : '40px',
	    left                    : '40px',
	    right                   : '40px',
	    bottom                  : '40px',
	    border                  : '1px solid #ccc',
	    background              : '#fff',
	    overflow                : 'auto',
	    WebkitOverflowScrolling : 'touch',
	    borderRadius            : '4px',
	    outline                 : 'none',
	    padding                 : '20px'
	  }
	}
	
	module.exports = Modal


/***/ },
/* 1466 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var DOMFactories = __webpack_require__(598);
	var focusManager = __webpack_require__(1468);
	var scopeTab = __webpack_require__(1470);
	var Assign = __webpack_require__(461);
	var createReactClass = __webpack_require__(129);
	
	var div = DOMFactories.div;
	
	// so that our CSS is statically analyzable
	var CLASS_NAMES = {
	  overlay: 'ReactModal__Overlay',
	  content: 'ReactModal__Content'
	};
	
	var ModalPortal = module.exports = createReactClass({
	
	  displayName: 'ModalPortal',
	  shouldClose: null,
	
	  getDefaultProps: function() {
	    return {
	      style: {
	        overlay: {},
	        content: {}
	      }
	    };
	  },
	
	  getInitialState: function() {
	    return {
	      afterOpen: false,
	      beforeClose: false
	    };
	  },
	
	  componentDidMount: function() {
	    // Focus needs to be set when mounting and already open
	    if (this.props.isOpen) {
	      this.setFocusAfterRender(true);
	      this.open();
	    }
	  },
	
	  componentWillUnmount: function() {
	    clearTimeout(this.closeTimer);
	  },
	
	  componentWillReceiveProps: function(newProps) {
	    // Focus only needs to be set once when the modal is being opened
	    if (!this.props.isOpen && newProps.isOpen) {
	      this.setFocusAfterRender(true);
	      this.open();
	    } else if (this.props.isOpen && !newProps.isOpen) {
	      this.close();
	    }
	  },
	
	  componentDidUpdate: function () {
	    if (this.focusAfterRender) {
	      this.focusContent();
	      this.setFocusAfterRender(false);
	    }
	  },
	
	  setFocusAfterRender: function (focus) {
	    this.focusAfterRender = focus;
	  },
	
	  afterClose: function () {
	    focusManager.returnFocus();
	    focusManager.teardownScopedFocus();
	  },
	
	  open: function () {
	    if (this.state.afterOpen && this.state.beforeClose) {
	      clearTimeout(this.closeTimer);
	      this.setState({ beforeClose: false });
	    } else {
	      focusManager.setupScopedFocus(this.node);
	      focusManager.markForFocusLater();
	      this.setState({isOpen: true}, function() {
	        this.setState({afterOpen: true});
	
	        if (this.props.isOpen && this.props.onAfterOpen) {
	          this.props.onAfterOpen();
	        }
	      }.bind(this));
	    }
	  },
	
	  close: function() {
	    if (this.props.closeTimeoutMS > 0)
	      this.closeWithTimeout();
	    else
	      this.closeWithoutTimeout();
	  },
	
	  focusContent: function() {
	    // Don't steal focus from inner elements
	    if (!this.contentHasFocus()) {
	      this.refs.content.focus();
	    }
	  },
	
	  closeWithTimeout: function() {
	    var closesAt = Date.now() + this.props.closeTimeoutMS;
	    this.setState({beforeClose: true, closesAt: closesAt}, function() {
	      this.closeTimer = setTimeout(this.closeWithoutTimeout, this.state.closesAt - Date.now());
	    }.bind(this));
	  },
	
	  closeWithoutTimeout: function() {
	    this.setState({
	      beforeClose: false,
	      isOpen: false,
	      afterOpen: false,
	      closesAt: null
	    }, this.afterClose);
	  },
	
	  handleKeyDown: function(event) {
	    if (event.keyCode == 9 /*tab*/) scopeTab(this.refs.content, event);
	    if (event.keyCode == 27 /*esc*/) {
	      event.preventDefault();
	      this.requestClose(event);
	    }
	  },
	
	  handleOverlayOnClick: function (event) {
	    if (this.shouldClose === null) {
	      this.shouldClose = true;
	    }
	
	    if (this.shouldClose && this.props.shouldCloseOnOverlayClick) {
	      if (this.ownerHandlesClose())
	        this.requestClose(event);
	      else
	        this.focusContent();
	    }
	    this.shouldClose = null;
	  },
	
	  handleContentOnClick: function () {
	    this.shouldClose = false;
	  },
	
	  requestClose: function(event) {
	    if (this.ownerHandlesClose())
	      this.props.onRequestClose(event);
	  },
	
	  ownerHandlesClose: function() {
	    return this.props.onRequestClose;
	  },
	
	  shouldBeClosed: function() {
	    return !this.state.isOpen && !this.state.beforeClose;
	  },
	
	  contentHasFocus: function() {
	    return document.activeElement === this.refs.content || this.refs.content.contains(document.activeElement);
	  },
	
	  buildClassName: function(which, additional) {
	    var classNames = (typeof additional === 'object') ? additional : {
	      base: CLASS_NAMES[which],
	      afterOpen: CLASS_NAMES[which] + "--after-open",
	      beforeClose: CLASS_NAMES[which] + "--before-close"
	    };
	    var className = classNames.base;
	    if (this.state.afterOpen) { className += " " + classNames.afterOpen; }
	    if (this.state.beforeClose) { className += " " + classNames.beforeClose; }
	    return (typeof additional === 'string' && additional) ? [className, additional].join(" ") : className;
	  },
	
	  render: function() {
	    var contentStyles = (this.props.className) ? {} : this.props.defaultStyles.content;
	    var overlayStyles = (this.props.overlayClassName) ? {} : this.props.defaultStyles.overlay;
	
	    return this.shouldBeClosed() ? div() : (
	      div({
	        ref: "overlay",
	        className: this.buildClassName('overlay', this.props.overlayClassName),
	        style: Assign({}, overlayStyles, this.props.style.overlay || {}),
	        onClick: this.handleOverlayOnClick
	      },
	        div({
	          ref: "content",
	          style: Assign({}, contentStyles, this.props.style.content || {}),
	          className: this.buildClassName('content', this.props.className),
	          tabIndex: "-1",
	          onKeyDown: this.handleKeyDown,
	          onClick: this.handleContentOnClick,
	          role: this.props.role,
	          "aria-label": this.props.contentLabel
	        },
	          this.props.children
	        )
	      )
	    );
	  }
	});


/***/ },
/* 1467 */
/***/ function(module, exports) {

	var _element = typeof document !== 'undefined' ? document.body : null;
	
	function setElement(element) {
	  if (typeof element === 'string') {
	    var el = document.querySelectorAll(element);
	    element = 'length' in el ? el[0] : el;
	  }
	  _element = element || _element;
	  return _element;
	}
	
	function hide(appElement) {
	  validateElement(appElement);
	  (appElement || _element).setAttribute('aria-hidden', 'true');
	}
	
	function show(appElement) {
	  validateElement(appElement);
	  (appElement || _element).removeAttribute('aria-hidden');
	}
	
	function toggle(shouldHide, appElement) {
	  if (shouldHide)
	    hide(appElement);
	  else
	    show(appElement);
	}
	
	function validateElement(appElement) {
	  if (!appElement && !_element)
	    throw new Error('react-modal: You must set an element with `Modal.setAppElement(el)` to make this accessible');
	}
	
	function resetForTesting() {
	  _element = document.body;
	}
	
	exports.toggle = toggle;
	exports.setElement = setElement;
	exports.show = show;
	exports.hide = hide;
	exports.resetForTesting = resetForTesting;


/***/ },
/* 1468 */
/***/ function(module, exports, __webpack_require__) {

	var findTabbable = __webpack_require__(620);
	var focusLaterElements = [];
	var modalElement = null;
	var needToFocus = false;
	
	function handleBlur(event) {
	  needToFocus = true;
	}
	
	function handleFocus(event) {
	  if (needToFocus) {
	    needToFocus = false;
	    if (!modalElement) {
	      return;
	    }
	    // need to see how jQuery shims document.on('focusin') so we don't need the
	    // setTimeout, firefox doesn't support focusin, if it did, we could focus
	    // the element outside of a setTimeout. Side-effect of this implementation
	    // is that the document.body gets focus, and then we focus our element right
	    // after, seems fine.
	    setTimeout(function() {
	      if (modalElement.contains(document.activeElement))
	        return;
	      var el = (findTabbable(modalElement)[0] || modalElement);
	      el.focus();
	    }, 0);
	  }
	}
	
	exports.markForFocusLater = function() {
	  focusLaterElements.push(document.activeElement);
	};
	
	exports.returnFocus = function() {
	  var toFocus = null;
	  try {
	    toFocus = focusLaterElements.pop();
	    toFocus.focus();
	    return;
	  }
	  catch (e) {
	    console.warn('You tried to return focus to '+toFocus+' but it is not in the DOM anymore');
	  }
	};
	
	exports.setupScopedFocus = function(element) {
	  modalElement = element;
	
	  if (window.addEventListener) {
	    window.addEventListener('blur', handleBlur, false);
	    document.addEventListener('focus', handleFocus, true);
	  } else {
	    window.attachEvent('onBlur', handleBlur);
	    document.attachEvent('onFocus', handleFocus);
	  }
	};
	
	exports.teardownScopedFocus = function() {
	  modalElement = null;
	
	  if (window.addEventListener) {
	    window.removeEventListener('blur', handleBlur);
	    document.removeEventListener('focus', handleFocus);
	  } else {
	    window.detachEvent('onBlur', handleBlur);
	    document.detachEvent('onFocus', handleFocus);
	  }
	};


/***/ },
/* 1469 */
/***/ function(module, exports) {

	var modals = [];
	
	module.exports = {
	  add: function (element) {
	    if (modals.indexOf(element) === -1) {
	      modals.push(element);
	    }
	  },
	  remove: function (element) {
	    var index = modals.indexOf(element);
	    if (index === -1) {
	      return;
	    }
	    modals.splice(index, 1);
	  },
	  count: function () {
	    return modals.length;
	  }
	};


/***/ },
/* 1470 */
/***/ function(module, exports, __webpack_require__) {

	var findTabbable = __webpack_require__(620);
	
	module.exports = function(node, event) {
	  var tabbable = findTabbable(node);
	  if (!tabbable.length) {
	      event.preventDefault();
	      return;
	  }
	  var finalTabbable = tabbable[event.shiftKey ? 0 : tabbable.length - 1];
	  var leavingFinalTabbable = (
	    finalTabbable === document.activeElement ||
	    // handle immediate shift+tab after opening with mouse
	    node === document.activeElement
	  );
	  if (!leavingFinalTabbable) return;
	  event.preventDefault();
	  var target = tabbable[event.shiftKey ? tabbable.length - 1 : 0];
	  target.focus();
	};


/***/ },
/* 1471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var react = __webpack_require__(1);
	var reactDom = __webpack_require__(46);
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	/**
	 * Check whether some DOM node is our Component's node.
	 */
	function isNodeFound(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // SVG <use/> elements do not technically reside in the rendered DOM, so
	  // they do not have classList directly, but they offer a link to their
	  // corresponding element, which can have classList. This extra check is for
	  // that case.
	  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
	  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
	
	
	  if (current.correspondingElement) {
	    return current.correspondingElement.classList.contains(ignoreClass);
	  }
	
	  return current.classList.contains(ignoreClass);
	}
	/**
	 * Try to find our node in a hierarchy of nodes, returning the document
	 * node as highest node if our node is not found in the path up.
	 */
	
	function findHighest(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // If source=local then this event came from 'somewhere'
	  // inside and should be ignored. We could handle this with
	  // a layered approach, too, but that requires going back to
	  // thinking in terms of Dom node nesting, running counter
	  // to React's 'you shouldn't care about the DOM' philosophy.
	
	
	  while (current.parentNode) {
	    if (isNodeFound(current, componentNode, ignoreClass)) {
	      return true;
	    }
	
	    current = current.parentNode;
	  }
	
	  return current;
	}
	/**
	 * Check if the browser scrollbar was clicked
	 */
	
	function clickedScrollbar(evt) {
	  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
	}
	
	// ideally will get replaced with external dep
	// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
	var testPassiveEventSupport = function testPassiveEventSupport() {
	  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
	    return;
	  }
	
	  var passive = false;
	  var options = Object.defineProperty({}, 'passive', {
	    get: function get() {
	      passive = true;
	    }
	  });
	
	  var noop = function noop() {};
	
	  window.addEventListener('testPassiveEventSupport', noop, options);
	  window.removeEventListener('testPassiveEventSupport', noop, options);
	  return passive;
	};
	
	function autoInc(seed) {
	  if (seed === void 0) {
	    seed = 0;
	  }
	
	  return function () {
	    return ++seed;
	  };
	}
	
	var uid = autoInc();
	
	var passiveEventSupport;
	var handlersMap = {};
	var enabledInstances = {};
	var touchEvents = ['touchstart', 'touchmove'];
	var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
	/**
	 * Options for addEventHandler and removeEventHandler
	 */
	
	function getEventHandlerOptions(instance, eventName) {
	  var handlerOptions = null;
	  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;
	
	  if (isTouchEvent && passiveEventSupport) {
	    handlerOptions = {
	      passive: !instance.props.preventDefault
	    };
	  }
	
	  return handlerOptions;
	}
	/**
	 * This function generates the HOC function that you'll use
	 * in order to impart onOutsideClick listening to an
	 * arbitrary component. It gets called at the end of the
	 * bootstrapping code to yield an instance of the
	 * onClickOutsideHOC function defined inside setupHOC().
	 */
	
	
	function onClickOutsideHOC(WrappedComponent, config) {
	  var _class, _temp;
	
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inheritsLoose(onClickOutside, _Component);
	
	    function onClickOutside(props) {
	      var _this;
	
	      _this = _Component.call(this, props) || this;
	
	      _this.__outsideClickHandler = function (event) {
	        if (typeof _this.__clickOutsideHandlerProp === 'function') {
	          _this.__clickOutsideHandlerProp(event);
	
	          return;
	        }
	
	        var instance = _this.getInstance();
	
	        if (typeof instance.props.handleClickOutside === 'function') {
	          instance.props.handleClickOutside(event);
	          return;
	        }
	
	        if (typeof instance.handleClickOutside === 'function') {
	          instance.handleClickOutside(event);
	          return;
	        }
	
	        throw new Error('WrappedComponent lacks a handleClickOutside(event) function for processing outside click events.');
	      };
	
	      _this.enableOnClickOutside = function () {
	        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
	          return;
	        }
	
	        if (typeof passiveEventSupport === 'undefined') {
	          passiveEventSupport = testPassiveEventSupport();
	        }
	
	        enabledInstances[_this._uid] = true;
	        var events = _this.props.eventTypes;
	
	        if (!events.forEach) {
	          events = [events];
	        }
	
	        handlersMap[_this._uid] = function (event) {
	          if (_this.props.disableOnClickOutside) return;
	          if (_this.componentNode === null) return;
	
	          if (_this.props.preventDefault) {
	            event.preventDefault();
	          }
	
	          if (_this.props.stopPropagation) {
	            event.stopPropagation();
	          }
	
	          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
	          var current = event.target;
	
	          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
	            return;
	          }
	
	          _this.__outsideClickHandler(event);
	        };
	
	        events.forEach(function (eventName) {
	          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_this, eventName));
	        });
	      };
	
	      _this.disableOnClickOutside = function () {
	        delete enabledInstances[_this._uid];
	        var fn = handlersMap[_this._uid];
	
	        if (fn && typeof document !== 'undefined') {
	          var events = _this.props.eventTypes;
	
	          if (!events.forEach) {
	            events = [events];
	          }
	
	          events.forEach(function (eventName) {
	            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_this, eventName));
	          });
	          delete handlersMap[_this._uid];
	        }
	      };
	
	      _this.getRef = function (ref) {
	        return _this.instanceRef = ref;
	      };
	
	      _this._uid = uid();
	      return _this;
	    }
	    /**
	     * Access the WrappedComponent's instance.
	     */
	
	
	    var _proto = onClickOutside.prototype;
	
	    _proto.getInstance = function getInstance() {
	      if (!WrappedComponent.prototype.isReactComponent) {
	        return this;
	      }
	
	      var ref = this.instanceRef;
	      return ref.getInstance ? ref.getInstance() : ref;
	    };
	
	    /**
	     * Add click listeners to the current document,
	     * linked to this component's state.
	     */
	    _proto.componentDidMount = function componentDidMount() {
	      // If we are in an environment without a DOM such
	      // as shallow rendering or snapshots then we exit
	      // early to prevent any unhandled errors being thrown.
	      if (typeof document === 'undefined' || !document.createElement) {
	        return;
	      }
	
	      var instance = this.getInstance();
	
	      if (config && typeof config.handleClickOutside === 'function') {
	        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
	
	        if (typeof this.__clickOutsideHandlerProp !== 'function') {
	          throw new Error('WrappedComponent lacks a function for processing outside click events specified by the handleClickOutside config option.');
	        }
	      }
	
	      this.componentNode = reactDom.findDOMNode(this.getInstance());
	      this.enableOnClickOutside();
	    };
	
	    _proto.componentDidUpdate = function componentDidUpdate() {
	      this.componentNode = reactDom.findDOMNode(this.getInstance());
	    };
	    /**
	     * Remove all document's event listeners for this component
	     */
	
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      this.disableOnClickOutside();
	    };
	    /**
	     * Can be called to explicitly enable event listening
	     * for clicks and touches outside of this element.
	     */
	
	
	    /**
	     * Pass-through render
	     */
	    _proto.render = function render() {
	      // eslint-disable-next-line no-unused-vars
	      var _props = this.props,
	          excludeScrollbar = _props.excludeScrollbar,
	          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);
	
	      if (WrappedComponent.prototype.isReactComponent) {
	        props.ref = this.getRef;
	      } else {
	        props.wrappedRef = this.getRef;
	      }
	
	      props.disableOnClickOutside = this.disableOnClickOutside;
	      props.enableOnClickOutside = this.enableOnClickOutside;
	      return react.createElement(WrappedComponent, props);
	    };
	
	    return onClickOutside;
	  }(react.Component), _class.displayName = "OnClickOutside(" + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ")", _class.defaultProps = {
	    eventTypes: ['mousedown', 'touchstart'],
	    excludeScrollbar: config && config.excludeScrollbar || false,
	    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
	    preventDefault: false,
	    stopPropagation: false
	  }, _class.getClass = function () {
	    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
	  }, _temp;
	}
	
	exports.IGNORE_CLASS_NAME = IGNORE_CLASS_NAME;
	exports['default'] = onClickOutsideHOC;


/***/ },
/* 1472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Portal = __webpack_require__(1473);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Position = __webpack_require__(1474);
	
	var _Position2 = _interopRequireDefault(_Position);
	
	var _RootCloseWrapper = __webpack_require__(1475);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	var _elementType = __webpack_require__(159);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
	 */
	var Overlay = function (_React$Component) {
	  _inherits(Overlay, _React$Component);
	
	  function Overlay(props, context) {
	    _classCallCheck(this, Overlay);
	
	    var _this = _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call(this, props, context));
	
	    _this.state = { exited: !props.show };
	    _this.onHiddenListener = _this.handleHidden.bind(_this);
	    return _this;
	  }
	
	  _createClass(Overlay, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.show) {
	        this.setState({ exited: false });
	      } else if (!nextProps.transition) {
	        // Otherwise let handleHidden take care of marking exited.
	        this.setState({ exited: true });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          container = _props.container,
	          containerPadding = _props.containerPadding,
	          target = _props.target,
	          placement = _props.placement,
	          shouldUpdatePosition = _props.shouldUpdatePosition,
	          rootClose = _props.rootClose,
	          children = _props.children,
	          Transition = _props.transition,
	          props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);
	
	      // Don't un-render the overlay while it's transitioning out.
	
	
	      var mountOverlay = props.show || Transition && !this.state.exited;
	      if (!mountOverlay) {
	        // Don't bother showing anything if we don't have to.
	        return null;
	      }
	
	      var child = children;
	
	      // Position is be inner-most because it adds inline styles into the child,
	      // which the other wrappers don't forward correctly.
	      child = _react2.default.createElement(
	        _Position2.default,
	        { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
	        child
	      );
	
	      if (Transition) {
	        var onExit = props.onExit,
	            onExiting = props.onExiting,
	            onEnter = props.onEnter,
	            onEntering = props.onEntering,
	            onEntered = props.onEntered;
	
	        // This animates the child node by injecting props, so it must precede
	        // anything that adds a wrapping div.
	
	        child = _react2.default.createElement(
	          Transition,
	          {
	            'in': props.show,
	            transitionAppear: true,
	            onExit: onExit,
	            onExiting: onExiting,
	            onExited: this.onHiddenListener,
	            onEnter: onEnter,
	            onEntering: onEntering,
	            onEntered: onEntered
	          },
	          child
	        );
	      }
	
	      // This goes after everything else because it adds a wrapping div.
	      if (rootClose) {
	        child = _react2.default.createElement(
	          _RootCloseWrapper2.default,
	          { onRootClose: props.onHide },
	          child
	        );
	      }
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        { container: container },
	        child
	      );
	    }
	  }, {
	    key: 'handleHidden',
	    value: function handleHidden() {
	      this.setState({ exited: true });
	
	      if (this.props.onExited) {
	        var _props2;
	
	        (_props2 = this.props).onExited.apply(_props2, arguments);
	      }
	    }
	  }]);
	
	  return Overlay;
	}(_react2.default.Component);
	
	Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _react2.default.PropTypes.bool,
	
	  /**
	   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
	   */
	  rootClose: _react2.default.PropTypes.bool,
	
	  /**
	   * A Callback fired by the Overlay when it wishes to be hidden.
	   *
	   * __required__ when `rootClose` is `true`.
	   *
	   * @type func
	   */
	  onHide: function onHide(props) {
	    var propType = _react2.default.PropTypes.func;
	    if (props.rootClose) {
	      propType = propType.isRequired;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return propType.apply(undefined, [props].concat(args));
	  },
	
	
	  /**
	   * A `<Transition/>` component used to animate the overlay changes visibility.
	   */
	  transition: _elementType2.default,
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _react2.default.PropTypes.func
	});
	
	exports.default = Overlay;
	module.exports = exports['default'];

/***/ },
/* 1473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(46);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _componentOrElement = __webpack_require__(624);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _ownerDocument = __webpack_require__(202);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _getContainer = __webpack_require__(622);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
	 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
	 * The children of `<Portal/>` component will be appended to the `container` specified.
	 */
	var Portal = _react2.default.createClass({
	
	  displayName: 'Portal',
	
	  propTypes: {
	    /**
	     * A Node, Component instance, or function that returns either. The `container` will have the Portal children
	     * appended to it.
	     */
	    container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func])
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._renderOverlay();
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this._renderOverlay();
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this._overlayTarget && nextProps.container !== this.props.container) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this._unrenderOverlay();
	    this._unmountOverlayTarget();
	  },
	  _mountOverlayTarget: function _mountOverlayTarget() {
	    if (!this._overlayTarget) {
	      this._overlayTarget = document.createElement('div');
	      this._portalContainerNode = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  },
	  _unmountOverlayTarget: function _unmountOverlayTarget() {
	    if (this._overlayTarget) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._overlayTarget = null;
	    }
	    this._portalContainerNode = null;
	  },
	  _renderOverlay: function _renderOverlay() {
	
	    var overlay = !this.props.children ? null : _react2.default.Children.only(this.props.children);
	
	    // Save reference for future access.
	    if (overlay !== null) {
	      this._mountOverlayTarget();
	      this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, overlay, this._overlayTarget);
	    } else {
	      // Unrender if the component is null for transitions to null
	      this._unrenderOverlay();
	      this._unmountOverlayTarget();
	    }
	  },
	  _unrenderOverlay: function _unrenderOverlay() {
	    if (this._overlayTarget) {
	      _reactDom2.default.unmountComponentAtNode(this._overlayTarget);
	      this._overlayInstance = null;
	    }
	  },
	  render: function render() {
	    return null;
	  },
	  getMountNode: function getMountNode() {
	    return this._overlayTarget;
	  },
	  getOverlayDOMNode: function getOverlayDOMNode() {
	    if (!this.isMounted()) {
	      throw new Error('getOverlayDOMNode(): A component must be mounted to have a DOM node.');
	    }
	
	    if (this._overlayInstance) {
	      return _reactDom2.default.findDOMNode(this._overlayInstance);
	    }
	
	    return null;
	  }
	});
	
	exports.default = Portal;
	module.exports = exports['default'];

/***/ },
/* 1474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(37);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(46);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _componentOrElement = __webpack_require__(624);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _calculatePosition = __webpack_require__(1478);
	
	var _calculatePosition2 = _interopRequireDefault(_calculatePosition);
	
	var _getContainer = __webpack_require__(622);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(202);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The Position component calculates the coordinates for its child, to position
	 * it relative to a `target` component or node. Useful for creating callouts
	 * and tooltips, the Position component injects a `style` props with `left` and
	 * `top` values for positioning your component.
	 *
	 * It also injects "arrow" `left`, and `top` values for styling callout arrows
	 * for giving your components a sense of directionality.
	 */
	var Position = function (_React$Component) {
	  _inherits(Position, _React$Component);
	
	  function Position(props, context) {
	    _classCallCheck(this, Position);
	
	    var _this = _possibleConstructorReturn(this, (Position.__proto__ || Object.getPrototypeOf(Position)).call(this, props, context));
	
	    _this.state = {
	      positionLeft: 0,
	      positionTop: 0,
	      arrowOffsetLeft: null,
	      arrowOffsetTop: null
	    };
	
	    _this._needsFlush = false;
	    _this._lastTarget = null;
	    return _this;
	  }
	
	  _createClass(Position, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updatePosition(this.getTarget());
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this._needsFlush = true;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this._needsFlush) {
	        this._needsFlush = false;
	        this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          props = _objectWithoutProperties(_props, ['children', 'className']);
	
	      var _state = this.state,
	          positionLeft = _state.positionLeft,
	          positionTop = _state.positionTop,
	          arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);
	
	      // These should not be forwarded to the child.
	
	
	      delete props.target;
	      delete props.container;
	      delete props.containerPadding;
	      delete props.shouldUpdatePosition;
	
	      var child = _react2.default.Children.only(children);
	      return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
	        // FIXME: Don't forward `positionLeft` and `positionTop` via both props
	        // and `props.style`.
	        positionLeft: positionLeft,
	        positionTop: positionTop,
	        className: (0, _classnames2.default)(className, child.props.className),
	        style: _extends({}, child.props.style, {
	          left: positionLeft,
	          top: positionTop
	        })
	      }));
	    }
	  }, {
	    key: 'getTarget',
	    value: function getTarget() {
	      var target = this.props.target;
	
	      var targetElement = typeof target === 'function' ? target() : target;
	      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
	    }
	  }, {
	    key: 'maybeUpdatePosition',
	    value: function maybeUpdatePosition(placementChanged) {
	      var target = this.getTarget();
	
	      if (!this.props.shouldUpdatePosition && target === this._lastTarget && !placementChanged) {
	        return;
	      }
	
	      this.updatePosition(target);
	    }
	  }, {
	    key: 'updatePosition',
	    value: function updatePosition(target) {
	      this._lastTarget = target;
	
	      if (!target) {
	        this.setState({
	          positionLeft: 0,
	          positionTop: 0,
	          arrowOffsetLeft: null,
	          arrowOffsetTop: null
	        });
	
	        return;
	      }
	
	      var overlay = _reactDom2.default.findDOMNode(this);
	      var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
	
	      this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
	    }
	  }]);
	
	  return Position;
	}(_react2.default.Component);
	
	Position.propTypes = {
	  /**
	   * A node, element, or function that returns either. The child will be
	   * be positioned next to the `target` specified.
	   */
	  target: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	
	  /**
	   * "offsetParent" of the component
	   */
	  container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	  /**
	   * Minimum spacing in pixels between container border and component border
	   */
	  containerPadding: _react2.default.PropTypes.number,
	  /**
	   * How to position the component relative to the target
	   */
	  placement: _react2.default.PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	  /**
	   * Whether the position should be changed on each update
	   */
	  shouldUpdatePosition: _react2.default.PropTypes.bool
	};
	
	Position.displayName = 'Position';
	
	Position.defaultProps = {
	  containerPadding: 0,
	  placement: 'right',
	  shouldUpdatePosition: false
	};
	
	exports.default = Position;
	module.exports = exports['default'];

/***/ },
/* 1475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _contains = __webpack_require__(280);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(46);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _addEventListener = __webpack_require__(1477);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _ownerDocument = __webpack_require__(202);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var escapeKeyCode = 27;
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	/**
	 * The `<RootCloseWrapper/>` component registers your callback on the document
	 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
	 * style behavior where your callback is triggered when the user tries to
	 * interact with the rest of the document or hits the `esc` key.
	 */
	
	var RootCloseWrapper = function (_React$Component) {
	  _inherits(RootCloseWrapper, _React$Component);
	
	  function RootCloseWrapper(props, context) {
	    _classCallCheck(this, RootCloseWrapper);
	
	    var _this = _possibleConstructorReturn(this, (RootCloseWrapper.__proto__ || Object.getPrototypeOf(RootCloseWrapper)).call(this, props, context));
	
	    _this.handleMouseCapture = function (e) {
	      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
	    };
	
	    _this.handleMouse = function (e) {
	      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.handleKeyUp = function (e) {
	      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.preventMouseRootClose = false;
	    return _this;
	  }
	
	  _createClass(RootCloseWrapper, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.disabled) {
	        this.addEventListeners();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (!this.props.disabled && prevProps.disabled) {
	        this.addEventListeners();
	      } else if (this.props.disabled && !prevProps.disabled) {
	        this.removeEventListeners();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!this.props.disabled) {
	        this.removeEventListeners();
	      }
	    }
	  }, {
	    key: 'addEventListeners',
	    value: function addEventListeners() {
	      var event = this.props.event;
	
	      var doc = (0, _ownerDocument2.default)(this);
	
	      // Use capture for this listener so it fires before React's listener, to
	      // avoid false positives in the contains() check below if the target DOM
	      // element is removed in the React mouse callback.
	      this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, this.handleMouseCapture, true);
	
	      this.documentMouseListener = (0, _addEventListener2.default)(doc, event, this.handleMouse);
	
	      this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', this.handleKeyUp);
	    }
	  }, {
	    key: 'removeEventListeners',
	    value: function removeEventListeners() {
	      if (this.documentMouseCaptureListener) {
	        this.documentMouseCaptureListener.remove();
	      }
	
	      if (this.documentMouseListener) {
	        this.documentMouseListener.remove();
	      }
	
	      if (this.documentKeyupListener) {
	        this.documentKeyupListener.remove();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return RootCloseWrapper;
	}(_react2.default.Component);
	
	RootCloseWrapper.displayName = 'RootCloseWrapper';
	
	RootCloseWrapper.propTypes = {
	  /**
	   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
	   */
	  onRootClose: _react2.default.PropTypes.func,
	  /**
	   * Children to render.
	   */
	  children: _react2.default.PropTypes.element,
	  /**
	   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
	   */
	  disabled: _react2.default.PropTypes.bool,
	  /**
	   * Choose which document mouse event to bind to.
	   */
	  event: _react2.default.PropTypes.oneOf(['click', 'mousedown'])
	};
	
	RootCloseWrapper.defaultProps = {
	  event: 'click'
	};
	
	exports.default = RootCloseWrapper;
	module.exports = exports['default'];

/***/ },
/* 1476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(37);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _on = __webpack_require__(441);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _properties = __webpack_require__(445);
	
	var _properties2 = _interopRequireDefault(_properties);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(46);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var transitionEndEvent = _properties2.default.end;
	
	var UNMOUNTED = exports.UNMOUNTED = 0;
	var EXITED = exports.EXITED = 1;
	var ENTERING = exports.ENTERING = 2;
	var ENTERED = exports.ENTERED = 3;
	var EXITING = exports.EXITING = 4;
	
	/**
	 * The Transition component lets you define and run css transitions with a simple declarative api.
	 * It works similar to React's own [CSSTransitionGroup](http://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup)
	 * but is specifically optimized for transitioning a single child "in" or "out".
	 *
	 * You don't even need to use class based css transitions if you don't want to (but it is easiest).
	 * The extensive set of lifecycle callbacks means you have control over
	 * the transitioning now at each step of the way.
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, (Transition.__proto__ || Object.getPrototypeOf(Transition)).call(this, props, context));
	
	    var initialStatus = void 0;
	    _this.nextStatus = null;
	
	    if (props.in) {
	      if (props.transitionAppear) {
	        initialStatus = EXITED;
	        _this.nextStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  _createClass(Transition, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateStatus();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var status = this.state.status;
	
	
	      if (nextProps.in) {
	        if (status === UNMOUNTED) {
	          this.setState({ status: EXITED });
	        }
	        if (status !== ENTERING && status !== ENTERED) {
	          this.nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          this.nextStatus = EXITING;
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.updateStatus();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.cancelNextCallback();
	    }
	  }, {
	    key: 'updateStatus',
	    value: function updateStatus() {
	      var _this2 = this;
	
	      if (this.nextStatus !== null) {
	        // nextStatus will always be ENTERING or EXITING.
	        this.cancelNextCallback();
	        var node = _reactDom2.default.findDOMNode(this);
	
	        if (this.nextStatus === ENTERING) {
	          this.props.onEnter(node);
	
	          this.safeSetState({ status: ENTERING }, function () {
	            _this2.props.onEntering(node);
	
	            _this2.onTransitionEnd(node, function () {
	              _this2.safeSetState({ status: ENTERED }, function () {
	                _this2.props.onEntered(node);
	              });
	            });
	          });
	        } else {
	          this.props.onExit(node);
	
	          this.safeSetState({ status: EXITING }, function () {
	            _this2.props.onExiting(node);
	
	            _this2.onTransitionEnd(node, function () {
	              _this2.safeSetState({ status: EXITED }, function () {
	                _this2.props.onExited(node);
	              });
	            });
	          });
	        }
	
	        this.nextStatus = null;
	      } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	        this.setState({ status: UNMOUNTED });
	      }
	    }
	  }, {
	    key: 'cancelNextCallback',
	    value: function cancelNextCallback() {
	      if (this.nextCallback !== null) {
	        this.nextCallback.cancel();
	        this.nextCallback = null;
	      }
	    }
	  }, {
	    key: 'safeSetState',
	    value: function safeSetState(nextState, callback) {
	      // This shouldn't be necessary, but there are weird race conditions with
	      // setState callbacks and unmounting in testing, so always make sure that
	      // we can cancel any pending setState callbacks after we unmount.
	      this.setState(nextState, this.setNextCallback(callback));
	    }
	  }, {
	    key: 'setNextCallback',
	    value: function setNextCallback(callback) {
	      var _this3 = this;
	
	      var active = true;
	
	      this.nextCallback = function (event) {
	        if (active) {
	          active = false;
	          _this3.nextCallback = null;
	
	          callback(event);
	        }
	      };
	
	      this.nextCallback.cancel = function () {
	        active = false;
	      };
	
	      return this.nextCallback;
	    }
	  }, {
	    key: 'onTransitionEnd',
	    value: function onTransitionEnd(node, handler) {
	      this.setNextCallback(handler);
	
	      if (node) {
	        (0, _on2.default)(node, transitionEndEvent, this.nextCallback);
	        setTimeout(this.nextCallback, this.props.timeout);
	      } else {
	        setTimeout(this.nextCallback, 0);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var status = this.state.status;
	      if (status === UNMOUNTED) {
	        return null;
	      }
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          childProps = _objectWithoutProperties(_props, ['children', 'className']);
	
	      Object.keys(Transition.propTypes).forEach(function (key) {
	        return delete childProps[key];
	      });
	
	      var transitionClassName = void 0;
	      if (status === EXITED) {
	        transitionClassName = this.props.exitedClassName;
	      } else if (status === ENTERING) {
	        transitionClassName = this.props.enteringClassName;
	      } else if (status === ENTERED) {
	        transitionClassName = this.props.enteredClassName;
	      } else if (status === EXITING) {
	        transitionClassName = this.props.exitingClassName;
	      }
	
	      var child = _react2.default.Children.only(children);
	      return _react2.default.cloneElement(child, _extends({}, childProps, {
	        className: (0, _classnames2.default)(child.props.className, className, transitionClassName)
	      }));
	    }
	  }]);
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.propTypes = {
	  /**
	   * Show the component; triggers the enter or exit animation
	   */
	  in: _react2.default.PropTypes.bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _react2.default.PropTypes.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is not shown
	   */
	  unmountOnExit: _react2.default.PropTypes.bool,
	
	  /**
	   * Run the enter animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _react2.default.PropTypes.bool,
	
	  /**
	   * A Timeout for the animation, in milliseconds, to ensure that a node doesn't
	   * transition indefinately if the browser transitionEnd events are
	   * canceled or interrupted.
	   *
	   * By default this is set to a high number (5 seconds) as a failsafe. You should consider
	   * setting this to the duration of your animation (or a bit above it).
	   */
	  timeout: _react2.default.PropTypes.number,
	
	  /**
	   * CSS class or classes applied when the component is exited
	   */
	  exitedClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied while the component is exiting
	   */
	  exitingClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied when the component is entered
	   */
	  enteredClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied while the component is entering
	   */
	  enteringClassName: _react2.default.PropTypes.string,
	
	  /**
	   * Callback fired before the "entering" classes are applied
	   */
	  onEnter: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "entering" classes are applied
	   */
	  onEntering: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "enter" classes are applied
	   */
	  onEntered: _react2.default.PropTypes.func,
	  /**
	   * Callback fired before the "exiting" classes are applied
	   */
	  onExit: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "exiting" classes are applied
	   */
	  onExiting: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "exited" classes are applied
	   */
	  onExited: _react2.default.PropTypes.func
	};
	
	// Name the function so it is clearer in the documentation
	function noop() {}
	
	Transition.displayName = 'Transition';
	
	Transition.defaultProps = {
	  in: false,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  timeout: 5000,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	exports.default = Transition;

/***/ },
/* 1477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (node, event, handler, capture) {
	  (0, _on2.default)(node, event, handler, capture);
	
	  return {
	    remove: function remove() {
	      (0, _off2.default)(node, event, handler, capture);
	    }
	  };
	};
	
	var _on = __webpack_require__(441);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(1284);
	
	var _off2 = _interopRequireDefault(_off);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 1478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calculatePosition;
	
	var _offset = __webpack_require__(442);
	
	var _offset2 = _interopRequireDefault(_offset);
	
	var _position = __webpack_require__(1286);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _scrollTop = __webpack_require__(443);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _ownerDocument = __webpack_require__(202);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainerDimensions(containerNode) {
	  var width = void 0,
	      height = void 0,
	      scroll = void 0;
	
	  if (containerNode.tagName === 'BODY') {
	    width = window.innerWidth;
	    height = window.innerHeight;
	
	    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
	  } else {
	    var _getOffset = (0, _offset2.default)(containerNode);
	
	    width = _getOffset.width;
	    height = _getOffset.height;
	
	    scroll = (0, _scrollTop2.default)(containerNode);
	  }
	
	  return { width: width, height: height, scroll: scroll };
	}
	
	function getTopDelta(top, overlayHeight, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerScroll = containerDimensions.scroll;
	  var containerHeight = containerDimensions.height;
	
	  var topEdgeOffset = top - padding - containerScroll;
	  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;
	
	  if (topEdgeOffset < 0) {
	    return -topEdgeOffset;
	  } else if (bottomEdgeOffset > containerHeight) {
	    return containerHeight - bottomEdgeOffset;
	  } else {
	    return 0;
	  }
	}
	
	function getLeftDelta(left, overlayWidth, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerWidth = containerDimensions.width;
	
	  var leftEdgeOffset = left - padding;
	  var rightEdgeOffset = left + padding + overlayWidth;
	
	  if (leftEdgeOffset < 0) {
	    return -leftEdgeOffset;
	  } else if (rightEdgeOffset > containerWidth) {
	    return containerWidth - rightEdgeOffset;
	  }
	
	  return 0;
	}
	
	function calculatePosition(placement, overlayNode, target, container, padding) {
	  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);
	
	  var _getOffset2 = (0, _offset2.default)(overlayNode),
	      overlayHeight = _getOffset2.height,
	      overlayWidth = _getOffset2.width;
	
	  var positionLeft = void 0,
	      positionTop = void 0,
	      arrowOffsetLeft = void 0,
	      arrowOffsetTop = void 0;
	
	  if (placement === 'left' || placement === 'right') {
	    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;
	
	    if (placement === 'left') {
	      positionLeft = childOffset.left - overlayWidth;
	    } else {
	      positionLeft = childOffset.left + childOffset.width;
	    }
	
	    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);
	
	    positionTop += topDelta;
	    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
	    arrowOffsetLeft = void 0;
	  } else if (placement === 'top' || placement === 'bottom') {
	    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;
	
	    if (placement === 'top') {
	      positionTop = childOffset.top - overlayHeight;
	    } else {
	      positionTop = childOffset.top + childOffset.height;
	    }
	
	    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);
	
	    positionLeft += leftDelta;
	    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
	    arrowOffsetTop = void 0;
	  } else {
	    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
	  }
	
	  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
	}
	module.exports = exports['default'];

/***/ },
/* 1479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BreakView = function (_React$Component) {
	  _inherits(BreakView, _React$Component);
	
	  function BreakView() {
	    _classCallCheck(this, BreakView);
	
	    return _possibleConstructorReturn(this, (BreakView.__proto__ || Object.getPrototypeOf(BreakView)).apply(this, arguments));
	  }
	
	  _createClass(BreakView, [{
	    key: 'render',
	    value: function render() {
	      var label = this.props.breakLabel;
	      var className = this.props.breakClassName || 'break';
	
	      return _react2.default.createElement(
	        'li',
	        { className: className },
	        label
	      );
	    }
	  }]);
	
	  return BreakView;
	}(_react2.default.Component);
	
	exports.default = BreakView;
	;
	//# sourceMappingURL=BreakView.js.map

/***/ },
/* 1480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageView = function (_React$Component) {
	  _inherits(PageView, _React$Component);
	
	  function PageView() {
	    _classCallCheck(this, PageView);
	
	    return _possibleConstructorReturn(this, (PageView.__proto__ || Object.getPrototypeOf(PageView)).apply(this, arguments));
	  }
	
	  _createClass(PageView, [{
	    key: 'render',
	    value: function render() {
	      var linkClassName = this.props.pageLinkClassName;
	      var cssClassName = this.props.pageClassName;
	      var onClick = this.props.onClick;
	
	      if (this.props.selected) {
	        if (typeof cssClassName !== 'undefined') {
	          cssClassName = cssClassName + ' ' + this.props.activeClassName;
	        } else {
	          cssClassName = this.props.activeClassName;
	        }
	      }
	
	      return _react2.default.createElement(
	        'li',
	        { onClick: onClick, className: cssClassName },
	        _react2.default.createElement(
	          'a',
	          { className: linkClassName },
	          this.props.page
	        )
	      );
	    }
	  }]);
	
	  return PageView;
	}(_react2.default.Component);
	
	exports.default = PageView;
	;
	//# sourceMappingURL=PageView.js.map

/***/ },
/* 1481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(37);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactAddonsCreateFragment = __webpack_require__(1356);
	
	var _reactAddonsCreateFragment2 = _interopRequireDefault(_reactAddonsCreateFragment);
	
	var _PageView = __webpack_require__(1480);
	
	var _PageView2 = _interopRequireDefault(_PageView);
	
	var _BreakView = __webpack_require__(1479);
	
	var _BreakView2 = _interopRequireDefault(_BreakView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PaginationBoxView = function (_Component) {
	  _inherits(PaginationBoxView, _Component);
	
	  function PaginationBoxView(props) {
	    _classCallCheck(this, PaginationBoxView);
	
	    var _this = _possibleConstructorReturn(this, (PaginationBoxView.__proto__ || Object.getPrototypeOf(PaginationBoxView)).call(this, props));
	
	    _this.handlePreviousPage = function (evt) {
	      evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;
	      if (_this.state.selected > 0) {
	        _this.handlePageSelected(_this.state.selected - 1, evt);
	      }
	    };
	
	    _this.handleNextPage = function (evt) {
	      evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;
	      if (_this.state.selected < _this.props.pageNum - 1) {
	        _this.handlePageSelected(_this.state.selected + 1, evt);
	      }
	    };
	
	    _this.handlePageSelected = function (selected, evt) {
	      evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;
	
	      if (_this.state.selected === selected) return;
	
	      _this.setState({ selected: selected });
	
	      // Call the callback with the new selected item:
	      _this.callCallback(selected);
	    };
	
	    _this.callCallback = function (selectedItem) {
	      if (typeof _this.props.clickCallback !== "undefined" && typeof _this.props.clickCallback === "function") {
	        _this.props.clickCallback({ selected: selectedItem });
	      }
	    };
	
	    _this.pagination = function () {
	      var items = {};
	
	      if (_this.props.pageNum <= _this.props.pageRangeDisplayed) {
	
	        for (var index = 0; index < _this.props.pageNum; index++) {
	          items['key' + index] = _react2.default.createElement(_PageView2.default, {
	            onClick: _this.handlePageSelected.bind(null, index),
	            selected: _this.state.selected === index,
	            pageClassName: _this.props.pageClassName,
	            pageLinkClassName: _this.props.pageLinkClassName,
	            activeClassName: _this.props.activeClassName,
	            page: index + 1 });
	        }
	      } else {
	
	        var leftSide = _this.props.pageRangeDisplayed / 2;
	        var rightSide = _this.props.pageRangeDisplayed - leftSide;
	
	        if (_this.state.selected > _this.props.pageNum - _this.props.pageRangeDisplayed / 2) {
	          rightSide = _this.props.pageNum - _this.state.selected;
	          leftSide = _this.props.pageRangeDisplayed - rightSide;
	        } else if (_this.state.selected < _this.props.pageRangeDisplayed / 2) {
	          leftSide = _this.state.selected;
	          rightSide = _this.props.pageRangeDisplayed - leftSide;
	        }
	
	        var _index = void 0;
	        var page = void 0;
	        var breakView = void 0;
	
	        for (_index = 0; _index < _this.props.pageNum; _index++) {
	
	          page = _index + 1;
	
	          var pageView = _react2.default.createElement(_PageView2.default, {
	            onClick: _this.handlePageSelected.bind(null, _index),
	            selected: _this.state.selected === _index,
	            pageClassName: _this.props.pageClassName,
	            pageLinkClassName: _this.props.pageLinkClassName,
	            activeClassName: _this.props.activeClassName,
	            page: _index + 1 });
	
	          if (page <= _this.props.marginPagesDisplayed) {
	            items['key' + _index] = pageView;
	            continue;
	          }
	
	          if (page > _this.props.pageNum - _this.props.marginPagesDisplayed) {
	            items['key' + _index] = pageView;
	            continue;
	          }
	
	          if (_index >= _this.state.selected - leftSide && _index <= _this.state.selected + rightSide) {
	            items['key' + _index] = pageView;
	            continue;
	          }
	
	          var keys = Object.keys(items);
	          var breakLabelKey = keys[keys.length - 1];
	          var breakLabelValue = items[breakLabelKey];
	
	          if (_this.props.breakLabel && breakLabelValue !== breakView) {
	            breakView = _react2.default.createElement(_BreakView2.default, {
	              breakLabel: _this.props.breakLabel,
	              breakClassName: _this.props.breakClassName
	            });
	
	            items['key' + _index] = breakView;
	          }
	        }
	      }
	
	      return items;
	    };
	
	    _this.state = {
	      selected: props.initialSelected ? props.initialSelected : props.forceSelected ? props.forceSelected : 0
	    };
	    return _this;
	  }
	
	  _createClass(PaginationBoxView, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Call the callback with the initialSelected item:
	      if (typeof this.props.initialSelected !== 'undefined') {
	        this.callCallback(this.props.initialSelected);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (typeof nextProps.forceSelected !== 'undefined' && this.props.forceSelected !== nextProps.forceSelected) {
	        this.setState({ selected: nextProps.forceSelected });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var disabled = this.props.disabledClassName;
	
	      var previousClasses = (0, _classnames2.default)(this.props.previousClassName, _defineProperty({}, disabled, this.state.selected === 0));
	
	      var nextClasses = (0, _classnames2.default)(this.props.nextClassName, _defineProperty({}, disabled, this.state.selected === this.props.pageNum - 1));
	
	      return _react2.default.createElement(
	        'ul',
	        { className: this.props.containerClassName },
	        _react2.default.createElement(
	          'li',
	          { onClick: this.handlePreviousPage, className: previousClasses },
	          _react2.default.createElement(
	            'a',
	            { className: this.props.previousLinkClassName },
	            this.props.previousLabel
	          )
	        ),
	        (0, _reactAddonsCreateFragment2.default)(this.pagination()),
	        _react2.default.createElement(
	          'li',
	          { onClick: this.handleNextPage, className: nextClasses },
	          _react2.default.createElement(
	            'a',
	            { className: this.props.nextLinkClassName },
	            this.props.nextLabel
	          )
	        )
	      );
	    }
	  }]);
	
	  return PaginationBoxView;
	}(_react.Component);
	
	PaginationBoxView.propTypes = {
	  pageNum: _react.PropTypes.number.isRequired,
	  pageRangeDisplayed: _react.PropTypes.number.isRequired,
	  marginPagesDisplayed: _react.PropTypes.number.isRequired,
	  previousLabel: _react.PropTypes.node,
	  nextLabel: _react.PropTypes.node,
	  breakLabel: _react.PropTypes.node,
	  clickCallback: _react.PropTypes.func,
	  initialSelected: _react.PropTypes.number,
	  forceSelected: _react.PropTypes.number,
	  containerClassName: _react.PropTypes.string,
	  pageClassName: _react.PropTypes.string,
	  pageLinkClassName: _react.PropTypes.string,
	  activeClassName: _react.PropTypes.string,
	  previousClassName: _react.PropTypes.string,
	  nextClassName: _react.PropTypes.string,
	  previousLinkClassName: _react.PropTypes.string,
	  nextLinkClassName: _react.PropTypes.string,
	  disabledClassName: _react.PropTypes.string,
	  breakClassName: _react.PropTypes.string
	};
	PaginationBoxView.defaultProps = {
	  pageNum: 10,
	  pageRangeDisplayed: 2,
	  marginPagesDisplayed: 3,
	  activeClassName: "selected",
	  previousClassName: "previous",
	  nextClassName: "next",
	  previousLabel: "Previous",
	  nextLabel: "Next",
	  breakLabel: "...",
	  disabledClassName: "disabled"
	};
	exports.default = PaginationBoxView;
	;
	//# sourceMappingURL=PaginationBoxView.js.map

/***/ },
/* 1482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var react = __webpack_require__(1);
	var PropTypes = _interopDefault(__webpack_require__(14));
	var PopperJS = _interopDefault(__webpack_require__(1347));
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var Manager = function (_Component) {
	  inherits(Manager, _Component);
	
	  function Manager() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Manager);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Manager.__proto__ || Object.getPrototypeOf(Manager)).call.apply(_ref, [this].concat(args))), _this), _this._setTargetNode = function (node) {
	      _this._targetNode = node;
	    }, _this._getTargetNode = function () {
	      return _this._targetNode;
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  createClass(Manager, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        popperManager: {
	          setTargetNode: this._setTargetNode,
	          getTargetNode: this._getTargetNode
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          tag = _props.tag,
	          children = _props.children,
	          restProps = objectWithoutProperties(_props, ['tag', 'children']);
	
	      if (tag !== false) {
	        return react.createElement(tag, restProps, children);
	      } else {
	        return children;
	      }
	    }
	  }]);
	  return Manager;
	}(react.Component);
	
	Manager.childContextTypes = {
	  popperManager: PropTypes.object.isRequired
	};
	Manager.defaultProps = {
	  tag: 'div'
	};
	Manager.propTypes =  false ? {
	  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
	} : {};
	
	var Target = function Target(props, context) {
	  var _props$component = props.component,
	      component = _props$component === undefined ? 'div' : _props$component,
	      innerRef = props.innerRef,
	      children = props.children,
	      restProps = objectWithoutProperties(props, ['component', 'innerRef', 'children']);
	  var popperManager = context.popperManager;
	
	  var targetRef = function targetRef(node) {
	    popperManager.setTargetNode(node);
	    if (typeof innerRef === 'function') {
	      innerRef(node);
	    }
	  };
	
	  if (typeof children === 'function') {
	    var targetProps = { ref: targetRef };
	    return children({ targetProps: targetProps, restProps: restProps });
	  }
	
	  var componentProps = _extends({}, restProps);
	
	  if (typeof component === 'string') {
	    componentProps.ref = targetRef;
	  } else {
	    componentProps.innerRef = targetRef;
	  }
	
	  return react.createElement(component, componentProps, children);
	};
	
	Target.contextTypes = {
	  popperManager: PropTypes.object.isRequired
	};
	
	Target.propTypes = {
	  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
	  innerRef: PropTypes.func,
	  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
	};
	
	var placements = PopperJS.placements;
	
	var Popper = function (_Component) {
	  inherits(Popper, _Component);
	
	  function Popper() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Popper);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Popper.__proto__ || Object.getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._setArrowNode = function (node) {
	      _this._arrowNode = node;
	    }, _this._getTargetNode = function () {
	      if (_this.props.target) {
	        return _this.props.target;
	      } else if (!_this.context.popperManager || !_this.context.popperManager.getTargetNode()) {
	        throw new Error('Target missing. Popper must be given a target from the Popper Manager, or as a prop.');
	      }
	      return _this.context.popperManager.getTargetNode();
	    }, _this._getOffsets = function (data) {
	      return Object.keys(data.offsets).map(function (key) {
	        return data.offsets[key];
	      });
	    }, _this._isDataDirty = function (data) {
	      if (_this.state.data) {
	        return JSON.stringify(_this._getOffsets(_this.state.data)) !== JSON.stringify(_this._getOffsets(data));
	      } else {
	        return true;
	      }
	    }, _this._updateStateModifier = {
	      enabled: true,
	      order: 900,
	      fn: function fn(data) {
	        if (_this._isDataDirty(data)) {
	          _this.setState({ data: data });
	        }
	        return data;
	      }
	    }, _this._getPopperStyle = function () {
	      var data = _this.state.data;
	
	
	      if (!_this._popper || !data) {
	        return {
	          position: 'absolute',
	          pointerEvents: 'none',
	          opacity: 0
	        };
	      }
	
	      return _extends({
	        position: data.offsets.popper.position
	      }, data.styles);
	    }, _this._getPopperPlacement = function () {
	      return _this.state.data ? _this.state.data.placement : undefined;
	    }, _this._getPopperHide = function () {
	      return !!_this.state.data && _this.state.data.hide ? '' : undefined;
	    }, _this._getArrowStyle = function () {
	      if (!_this.state.data || !_this.state.data.offsets.arrow) {
	        return {};
	      } else {
	        var _this$state$data$offs = _this.state.data.offsets.arrow,
	            top = _this$state$data$offs.top,
	            left = _this$state$data$offs.left;
	
	        return { top: top, left: left };
	      }
	    }, _this._handlePopperRef = function (node) {
	      _this._popperNode = node;
	      if (node) {
	        _this._createPopper();
	      } else {
	        _this._destroyPopper();
	      }
	      if (_this.props.innerRef) {
	        _this.props.innerRef(node);
	      }
	    }, _this._scheduleUpdate = function () {
	      _this._popper && _this._popper.scheduleUpdate();
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  createClass(Popper, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        popper: {
	          setArrowNode: this._setArrowNode,
	          getArrowStyle: this._getArrowStyle
	        }
	      };
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(lastProps) {
	      if (lastProps.placement !== this.props.placement || lastProps.eventsEnabled !== this.props.eventsEnabled || lastProps.target !== this.props.target) {
	        this._destroyPopper();
	        this._createPopper();
	      }
	      if (lastProps.children !== this.props.children) {
	        this._scheduleUpdate();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._destroyPopper();
	    }
	  }, {
	    key: '_createPopper',
	    value: function _createPopper() {
	      var _this2 = this;
	
	      var _props = this.props,
	          placement = _props.placement,
	          eventsEnabled = _props.eventsEnabled;
	
	      var modifiers = _extends({}, this.props.modifiers, {
	        applyStyle: { enabled: false },
	        updateState: this._updateStateModifier
	      });
	      if (this._arrowNode) {
	        modifiers.arrow = _extends({}, this.props.modifiers.arrow || {}, {
	          element: this._arrowNode
	        });
	      }
	      this._popper = new PopperJS(this._getTargetNode(), this._popperNode, {
	        placement: placement,
	        eventsEnabled: eventsEnabled,
	        modifiers: modifiers
	      });
	
	      // TODO: look into setTimeout scheduleUpdate call, without it, the popper will not position properly on creation
	      setTimeout(function () {
	        return _this2._scheduleUpdate();
	      });
	    }
	  }, {
	    key: '_destroyPopper',
	    value: function _destroyPopper() {
	      if (this._popper) {
	        this._popper.destroy();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          component = _props2.component,
	          innerRef = _props2.innerRef,
	          placement = _props2.placement,
	          eventsEnabled = _props2.eventsEnabled,
	          modifiers = _props2.modifiers,
	          children = _props2.children,
	          restProps = objectWithoutProperties(_props2, ['component', 'innerRef', 'placement', 'eventsEnabled', 'modifiers', 'children']);
	
	      var popperStyle = this._getPopperStyle();
	      var popperPlacement = this._getPopperPlacement();
	      var popperHide = this._getPopperHide();
	
	      if (typeof children === 'function') {
	        var popperProps = {
	          ref: this._handlePopperRef,
	          style: popperStyle,
	          'data-placement': popperPlacement,
	          'data-x-out-of-boundaries': popperHide
	        };
	        return children({
	          popperProps: popperProps,
	          restProps: restProps,
	          scheduleUpdate: this._scheduleUpdate
	        });
	      }
	
	      var componentProps = _extends({}, restProps, {
	        style: _extends({}, restProps.style, popperStyle),
	        'data-placement': popperPlacement,
	        'data-x-out-of-boundaries': popperHide
	      });
	
	      if (typeof component === 'string') {
	        componentProps.ref = this._handlePopperRef;
	      } else {
	        componentProps.innerRef = this._handlePopperRef;
	      }
	
	      return react.createElement(component, componentProps, children);
	    }
	  }]);
	  return Popper;
	}(react.Component);
	
	Popper.contextTypes = {
	  popperManager: PropTypes.object
	};
	Popper.childContextTypes = {
	  popper: PropTypes.object.isRequired
	};
	Popper.defaultProps = {
	  component: 'div',
	  placement: 'bottom',
	  eventsEnabled: true,
	  modifiers: {}
	};
	Popper.propTypes =  false ? {
	  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
	  innerRef: PropTypes.func,
	  placement: PropTypes.oneOf(placements),
	  eventsEnabled: PropTypes.bool,
	  modifiers: PropTypes.object,
	  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
	  target: PropTypes.oneOfType([
	  // the following check is needed for SSR
	  PropTypes.instanceOf(typeof Element !== 'undefined' ? Element : Object), PropTypes.shape({
	    getBoundingClientRect: PropTypes.func.isRequired,
	    clientWidth: PropTypes.number.isRequired,
	    clientHeight: PropTypes.number.isRequired
	  })])
	} : {};
	
	var Arrow = function Arrow(props, context) {
	  var _props$component = props.component,
	      component = _props$component === undefined ? 'span' : _props$component,
	      innerRef = props.innerRef,
	      children = props.children,
	      restProps = objectWithoutProperties(props, ['component', 'innerRef', 'children']);
	  var popper = context.popper;
	
	  var arrowRef = function arrowRef(node) {
	    popper.setArrowNode(node);
	    if (typeof innerRef === 'function') {
	      innerRef(node);
	    }
	  };
	  var arrowStyle = popper.getArrowStyle();
	
	  if (typeof children === 'function') {
	    var arrowProps = {
	      ref: arrowRef,
	      style: arrowStyle
	    };
	    return children({ arrowProps: arrowProps, restProps: restProps });
	  }
	
	  var componentProps = _extends({}, restProps, {
	    style: _extends({}, arrowStyle, restProps.style)
	  });
	
	  if (typeof component === 'string') {
	    componentProps.ref = arrowRef;
	  } else {
	    componentProps.innerRef = arrowRef;
	  }
	
	  return react.createElement(component, componentProps, children);
	};
	
	Arrow.contextTypes = {
	  popper: PropTypes.object.isRequired
	};
	
	Arrow.propTypes = {
	  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
	  innerRef: PropTypes.func,
	  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
	};
	
	exports.Manager = Manager;
	exports.Target = Target;
	exports.Popper = Popper;
	exports.placements = placements;
	exports.Arrow = Arrow;
	//# sourceMappingURL=react-popper.js.map


/***/ },
/* 1483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = all;
	
	var _createChainableTypeChecker = __webpack_require__(308);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function all() {
	  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
	    validators[_key] = arguments[_key];
	  }
	
	  function allPropTypes() {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    var error = null;
	
	    validators.forEach(function (validator) {
	      if (error != null) {
	        return;
	      }
	
	      var result = validator.apply(undefined, args);
	      if (result != null) {
	        error = result;
	      }
	    });
	
	    return error;
	  }
	
	  return (0, _createChainableTypeChecker2.default)(allPropTypes);
	}

/***/ },
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Async = __webpack_require__(637);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _Creatable = __webpack_require__(638);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Select = __webpack_require__(205);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AsyncCreatableSelect = function (_React$Component) {
		_inherits(AsyncCreatableSelect, _React$Component);
	
		function AsyncCreatableSelect() {
			_classCallCheck(this, AsyncCreatableSelect);
	
			return _possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
		}
	
		_createClass(AsyncCreatableSelect, [{
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					_Async2.default,
					this.props,
					function (_ref) {
						var ref = _ref.ref,
						    asyncProps = _objectWithoutProperties(_ref, ['ref']);
	
						var asyncRef = ref;
						return _react2.default.createElement(
							_Creatable2.default,
							asyncProps,
							function (_ref2) {
								var ref = _ref2.ref,
								    creatableProps = _objectWithoutProperties(_ref2, ['ref']);
	
								var creatableRef = ref;
								return _this2.props.children(_extends({}, creatableProps, {
									ref: function ref(select) {
										creatableRef(select);
										asyncRef(select);
										_this2.select = select;
									}
								}));
							}
						);
					}
				);
			}
		}]);
	
		return AsyncCreatableSelect;
	}(_react2.default.Component);
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	AsyncCreatableSelect.propTypes = {
		children: _propTypes2.default.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	};
	
	AsyncCreatableSelect.defaultProps = {
		children: defaultChildren
	};
	
	exports.default = AsyncCreatableSelect;

/***/ },
/* 1512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.defaultFilterOptions = exports.defaultClearRenderer = exports.defaultArrowRenderer = exports.defaultMenuRenderer = exports.Option = exports.Value = exports.Creatable = exports.AsyncCreatable = exports.Async = undefined;
	
	var _Select = __webpack_require__(205);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Async = __webpack_require__(637);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _AsyncCreatable = __webpack_require__(1511);
	
	var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);
	
	var _Creatable = __webpack_require__(638);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Value = __webpack_require__(640);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	var _Option = __webpack_require__(639);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _defaultMenuRenderer = __webpack_require__(313);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _defaultArrowRenderer = __webpack_require__(641);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(642);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(312);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_Select2.default.Async = _Async2.default;
	_Select2.default.AsyncCreatable = _AsyncCreatable2.default;
	_Select2.default.Creatable = _Creatable2.default;
	_Select2.default.Value = _Value2.default;
	_Select2.default.Option = _Option2.default;
	
	exports.default = _Select2.default;
	exports.Async = _Async2.default;
	exports.AsyncCreatable = _AsyncCreatable2.default;
	exports.Creatable = _Creatable2.default;
	exports.Value = _Value2.default;
	exports.Option = _Option2.default;
	exports.defaultMenuRenderer = _defaultMenuRenderer2.default;
	exports.defaultArrowRenderer = _defaultArrowRenderer2.default;
	exports.defaultClearRenderer = _defaultClearRenderer2.default;
	exports.defaultFilterOptions = _defaultFilterOptions2.default;

/***/ },
/* 1513 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (event) {
		event.preventDefault();
		event.stopPropagation();
		if (event.target.tagName !== 'A' || !('href' in event.target)) {
			return;
		}
		if (event.target.target) {
			window.open(event.target.href, event.target.target);
		} else {
			window.location.href = event.target.href;
		}
	};

/***/ },
/* 1514 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var trim = function trim(str) {
	  return str.replace(/^\s+|\s+$/g, '');
	};
	
	exports.default = trim;

/***/ },
/* 1515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(129);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _classnames = __webpack_require__(37);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	module.exports = (0, _createReactClass2.default)({
	  displayName: 'TabPanel',
	
	  propTypes: {
	    children: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object, _propTypes2.default.string]),
	    className: _propTypes2.default.string,
	    id: _propTypes2.default.string,
	    selected: _propTypes2.default.bool,
	    style: _propTypes2.default.object,
	    tabId: _propTypes2.default.string
	  },
	
	  contextTypes: {
	    forceRenderTabPanel: _propTypes2.default.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      selected: false,
	      id: null,
	      tabId: null
	    };
	  },
	  render: function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        selected = _props.selected,
	        id = _props.id,
	        tabId = _props.tabId,
	        style = _props.style,
	        attributes = _objectWithoutProperties(_props, ['className', 'children', 'selected', 'id', 'tabId', 'style']);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, attributes, {
	        className: (0, _classnames2.default)('ReactTabs__TabPanel', className, {
	          'ReactTabs__TabPanel--selected': selected
	        }),
	        role: 'tabpanel',
	        id: id,
	        'aria-labelledby': tabId,
	        style: _extends({}, style, { display: selected ? null : 'none' })
	      }),
	      this.context.forceRenderTabPanel || selected ? children : null
	    );
	  }
	});

/***/ },
/* 1516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(129);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _reactDom = __webpack_require__(46);
	
	var _classnames = __webpack_require__(37);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _jsStylesheet = __webpack_require__(1334);
	
	var _jsStylesheet2 = _interopRequireDefault(_jsStylesheet);
	
	var _uuid = __webpack_require__(1519);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _childrenPropType = __webpack_require__(1517);
	
	var _childrenPropType2 = _interopRequireDefault(_childrenPropType);
	
	var _Tab = __webpack_require__(206);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// Determine if a node from event.target is a Tab element
	function isTabNode(node) {
	  return node.nodeName === 'LI' && node.getAttribute('role') === 'tab';
	}
	
	// Determine if a tab node is disabled
	function isTabDisabled(node) {
	  return node.getAttribute('aria-disabled') === 'true';
	}
	
	var useDefaultStyles = true;
	
	module.exports = (0, _createReactClass2.default)({
	  displayName: 'Tabs',
	
	  propTypes: {
	    className: _propTypes2.default.string,
	    selectedIndex: _propTypes2.default.number,
	    onSelect: _propTypes2.default.func,
	    focus: _propTypes2.default.bool,
	    children: _childrenPropType2.default,
	    forceRenderTabPanel: _propTypes2.default.bool
	  },
	
	  childContextTypes: {
	    forceRenderTabPanel: _propTypes2.default.bool
	  },
	
	  statics: {
	    setUseDefaultStyles: function setUseDefaultStyles(use) {
	      useDefaultStyles = use;
	    }
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      selectedIndex: -1,
	      focus: false,
	      forceRenderTabPanel: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    return this.copyPropsToState(this.props, this.state);
	  },
	  getChildContext: function getChildContext() {
	    return {
	      forceRenderTabPanel: this.props.forceRenderTabPanel
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    if (useDefaultStyles) {
	      (0, _jsStylesheet2.default)(__webpack_require__(1518)); // eslint-disable-line global-require
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    var _this = this;
	
	    // Use a transactional update to prevent race conditions
	    // when reading the state in copyPropsToState
	    // See https://github.com/reactjs/react-tabs/issues/51
	    this.setState(function (state) {
	      return _this.copyPropsToState(newProps, state);
	    });
	  },
	  setSelected: function setSelected(index, focus) {
	    // Don't do anything if nothing has changed
	    if (index === this.state.selectedIndex) return;
	    // Check index boundary
	    if (index < 0 || index >= this.getTabsCount()) return;
	
	    // Keep reference to last index for event handler
	    var last = this.state.selectedIndex;
	
	    // Check if the change event handler cancels the tab change
	    var cancel = false;
	
	    // Call change event handler
	    if (typeof this.props.onSelect === 'function') {
	      cancel = this.props.onSelect(index, last) === false;
	    }
	
	    if (!cancel) {
	      // Update selected index
	      this.setState({ selectedIndex: index, focus: focus === true });
	    }
	  },
	  getNextTab: function getNextTab(index) {
	    var count = this.getTabsCount();
	
	    // Look for non-disabled tab from index to the last tab on the right
	    for (var i = index + 1; i < count; i++) {
	      var tab = this.getTab(i);
	      if (!isTabDisabled((0, _reactDom.findDOMNode)(tab))) {
	        return i;
	      }
	    }
	
	    // If no tab found, continue searching from first on left to index
	    for (var _i = 0; _i < index; _i++) {
	      var _tab = this.getTab(_i);
	      if (!isTabDisabled((0, _reactDom.findDOMNode)(_tab))) {
	        return _i;
	      }
	    }
	
	    // No tabs are disabled, return index
	    return index;
	  },
	  getPrevTab: function getPrevTab(index) {
	    var i = index;
	
	    // Look for non-disabled tab from index to first tab on the left
	    while (i--) {
	      var tab = this.getTab(i);
	      if (!isTabDisabled((0, _reactDom.findDOMNode)(tab))) {
	        return i;
	      }
	    }
	
	    // If no tab found, continue searching from last tab on right to index
	    i = this.getTabsCount();
	    while (i-- > index) {
	      var _tab2 = this.getTab(i);
	      if (!isTabDisabled((0, _reactDom.findDOMNode)(_tab2))) {
	        return i;
	      }
	    }
	
	    // No tabs are disabled, return index
	    return index;
	  },
	  getTabsCount: function getTabsCount() {
	    return this.props.children && this.props.children[0] ? _react2.default.Children.count(this.props.children[0].props.children) : 0;
	  },
	  getPanelsCount: function getPanelsCount() {
	    return _react2.default.Children.count(this.props.children.slice(1));
	  },
	  getTabList: function getTabList() {
	    return this.refs.tablist;
	  },
	  getTab: function getTab(index) {
	    return this.refs['tabs-' + index];
	  },
	  getPanel: function getPanel(index) {
	    return this.refs['panels-' + index];
	  },
	  getChildren: function getChildren() {
	    var index = 0;
	    var count = 0;
	    var children = this.props.children;
	    var state = this.state;
	    var tabIds = this.tabIds = this.tabIds || [];
	    var panelIds = this.panelIds = this.panelIds || [];
	    var diff = this.tabIds.length - this.getTabsCount();
	
	    // Add ids if new tabs have been added
	    // Don't bother removing ids, just keep them in case they are added again
	    // This is more efficient, and keeps the uuid counter under control
	    while (diff++ < 0) {
	      tabIds.push((0, _uuid2.default)());
	      panelIds.push((0, _uuid2.default)());
	    }
	
	    // Map children to dynamically setup refs
	    return _react2.default.Children.map(children, function (child) {
	      // null happens when conditionally rendering TabPanel/Tab
	      // see https://github.com/reactjs/react-tabs/issues/37
	      if (child === null) {
	        return null;
	      }
	
	      var result = null;
	
	      // Clone TabList and Tab components to have refs
	      if (count++ === 0) {
	        // TODO try setting the uuid in the "constructor" for `Tab`/`TabPanel`
	        result = (0, _react.cloneElement)(child, {
	          ref: 'tablist',
	          children: _react2.default.Children.map(child.props.children, function (tab) {
	            // null happens when conditionally rendering TabPanel/Tab
	            // see https://github.com/reactjs/react-tabs/issues/37
	            if (tab === null) {
	              return null;
	            }
	
	            var ref = 'tabs-' + index;
	            var id = tabIds[index];
	            var panelId = panelIds[index];
	            var selected = state.selectedIndex === index;
	            var focus = selected && state.focus;
	
	            index++;
	
	            if (tab.type === _Tab2.default) {
	              return (0, _react.cloneElement)(tab, {
	                ref: ref,
	                id: id,
	                panelId: panelId,
	                selected: selected,
	                focus: focus
	              });
	            }
	
	            return tab;
	          })
	        });
	
	        // Reset index for panels
	        index = 0;
	      }
	      // Clone TabPanel components to have refs
	      else {
	          var ref = 'panels-' + index;
	          var id = panelIds[index];
	          var tabId = tabIds[index];
	          var selected = state.selectedIndex === index;
	
	          index++;
	
	          result = (0, _react.cloneElement)(child, {
	            ref: ref,
	            id: id,
	            tabId: tabId,
	            selected: selected
	          });
	        }
	
	      return result;
	    });
	  },
	  handleKeyDown: function handleKeyDown(e) {
	    if (this.isTabFromContainer(e.target)) {
	      var index = this.state.selectedIndex;
	      var preventDefault = false;
	
	      // Select next tab to the left
	      if (e.keyCode === 37 || e.keyCode === 38) {
	        index = this.getPrevTab(index);
	        preventDefault = true;
	      }
	      // Select next tab to the right
	      /* eslint brace-style:0 */
	      else if (e.keyCode === 39 || e.keyCode === 40) {
	          index = this.getNextTab(index);
	          preventDefault = true;
	        }
	
	      // This prevents scrollbars from moving around
	      if (preventDefault) {
	        e.preventDefault();
	      }
	
	      this.setSelected(index, true);
	    }
	  },
	  handleClick: function handleClick(e) {
	    var node = e.target;
	    do {
	      // eslint-disable-line no-cond-assign
	      if (this.isTabFromContainer(node)) {
	        if (isTabDisabled(node)) {
	          return;
	        }
	
	        var index = [].slice.call(node.parentNode.children).indexOf(node);
	        this.setSelected(index);
	        return;
	      }
	    } while ((node = node.parentNode) !== null);
	  },
	
	
	  // This is an anti-pattern, so sue me
	  copyPropsToState: function copyPropsToState(props, state) {
	    var selectedIndex = props.selectedIndex;
	
	    // If no selectedIndex prop was supplied, then try
	    // preserving the existing selectedIndex from state.
	    // If the state has not selectedIndex, default
	    // to the first tab in the TabList.
	    //
	    // TODO: Need automation testing around this
	    // Manual testing can be done using examples/focus
	    // See 'should preserve selectedIndex when typing' in specs/Tabs.spec.js
	    if (selectedIndex === -1) {
	      if (state && state.selectedIndex) {
	        selectedIndex = state.selectedIndex;
	      } else {
	        selectedIndex = 0;
	      }
	    }
	
	    return {
	      selectedIndex: selectedIndex,
	      focus: props.focus
	    };
	  },
	
	
	  /**
	   * Determine if a node from event.target is a Tab element for the current Tabs container.
	   * If the clicked element is not a Tab, it returns false.
	   * If it finds another Tabs container between the Tab and `this`, it returns false.
	   */
	  isTabFromContainer: function isTabFromContainer(node) {
	    // return immediately if the clicked element is not a Tab.
	    if (!isTabNode(node)) {
	      return false;
	    }
	
	    // Check if the first occurrence of a Tabs container is `this` one.
	    var nodeAncestor = node.parentElement;
	    var tabsNode = (0, _reactDom.findDOMNode)(this);
	    do {
	      if (nodeAncestor === tabsNode) return true;else if (nodeAncestor.getAttribute('data-tabs')) break;
	
	      nodeAncestor = nodeAncestor.parentElement;
	    } while (nodeAncestor);
	
	    return false;
	  },
	  render: function render() {
	    var _this2 = this;
	
	    // This fixes an issue with focus management.
	    //
	    // Ultimately, when focus is true, and an input has focus,
	    // and any change on that input causes a state change/re-render,
	    // focus gets sent back to the active tab, and input loses focus.
	    //
	    // Since the focus state only needs to be remembered
	    // for the current render, we can reset it once the
	    // render has happened.
	    //
	    // Don't use setState, because we don't want to re-render.
	    //
	    // See https://github.com/reactjs/react-tabs/pull/7
	    if (this.state.focus) {
	      setTimeout(function () {
	        _this2.state.focus = false;
	      }, 0);
	    }
	
	    var _props = this.props,
	        className = _props.className,
	        attributes = _objectWithoutProperties(_props, ['className']);
	
	    // Delete all known props, so they don't get added to DOM
	
	
	    delete attributes.selectedIndex;
	    delete attributes.onSelect;
	    delete attributes.focus;
	    delete attributes.children;
	    delete attributes.forceRenderTabPanel;
	    delete attributes.onClick;
	    delete attributes.onKeyDown;
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, attributes, {
	        className: (0, _classnames2.default)('ReactTabs', 'react-tabs', className),
	        onClick: this.handleClick,
	        onKeyDown: this.handleKeyDown,
	        'data-tabs': true
	      }),
	      this.getChildren()
	    );
	  }
	});

/***/ },
/* 1517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Tab = __webpack_require__(206);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _TabList = __webpack_require__(644);
	
	var _TabList2 = _interopRequireDefault(_TabList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function childrenPropTypes(props, propName) {
	  var error = void 0;
	  var tabsCount = 0;
	  var panelsCount = 0;
	  var children = props[propName];
	
	  _react2.default.Children.forEach(children, function (child) {
	    // null happens when conditionally rendering TabPanel/Tab
	    // see https://github.com/reactjs/react-tabs/issues/37
	    if (child === null) {
	      return;
	    }
	
	    if (child.type === _TabList2.default) {
	      _react2.default.Children.forEach(child.props.children, function (c) {
	        // null happens when conditionally rendering TabPanel/Tab
	        // see https://github.com/reactjs/react-tabs/issues/37
	        if (c === null) {
	          return;
	        }
	
	        if (c.type === _Tab2.default) {
	          tabsCount++;
	        }
	      });
	    } else if (child.type.displayName === 'TabPanel') {
	      panelsCount++;
	    } else {
	      error = new Error('Expected \'TabList\' or \'TabPanel\' but found \'' + (child.type.displayName || child.type) + '\'');
	    }
	  });
	
	  if (tabsCount !== panelsCount) {
	    error = new Error("There should be an equal number of 'Tabs' and 'TabPanels'." + ('Received ' + tabsCount + ' \'Tabs\' and ' + panelsCount + ' \'TabPanels\'.'));
	  }
	
	  return error;
	};

/***/ },
/* 1518 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  '.react-tabs [role=tablist]': {
	    'border-bottom': '1px solid #aaa',
	    margin: '0 0 10px',
	    padding: '0'
	  },
	
	  '.react-tabs [role=tab]': {
	    display: 'inline-block',
	    border: '1px solid transparent',
	    'border-bottom': 'none',
	    bottom: '-1px',
	    position: 'relative',
	    'list-style': 'none',
	    padding: '6px 12px',
	    cursor: 'pointer'
	  },
	
	  '.react-tabs [role=tab][aria-selected=true]': {
	    background: '#fff',
	    'border-color': '#aaa',
	    color: 'black',
	    'border-radius': '5px 5px 0 0',
	    '-moz-border-radius': '5px 5px 0 0',
	    '-webkit-border-radius': '5px 5px 0 0'
	  },
	
	  '.react-tabs [role=tab][aria-disabled=true]': {
	    color: 'GrayText',
	    cursor: 'default'
	  },
	
	  '.react-tabs [role=tab]:focus': {
	    'box-shadow': '0 0 5px hsl(208, 99%, 50%)',
	    'border-color': 'hsl(208, 99%, 50%)',
	    outline: 'none'
	  },
	
	  '.react-tabs [role=tab]:focus:after': {
	    content: '""',
	    position: 'absolute',
	    height: '5px',
	    left: '-4px',
	    right: '-4px',
	    bottom: '-5px',
	    background: '#fff'
	  }
	};

/***/ },
/* 1519 */
/***/ function(module, exports) {

	"use strict";
	
	// Get a universally unique identifier
	var count = 0;
	module.exports = function uuid() {
	  return "react-tabs-" + count++;
	};

/***/ },
/* 1520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	var _objectAssign = __webpack_require__(1521);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var truthy = function truthy(x) {
	  return x;
	};
	
	exports['default'] = function (input) {
	  var _ref = Array.isArray(input) && input.length === 2 ? input : [input, null];
	
	  var _ref2 = _slicedToArray(_ref, 2);
	
	  var theme = _ref2[0];
	  var classNameDecorator = _ref2[1];
	
	  return function (key) {
	    for (var _len = arguments.length, names = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      names[_key - 1] = arguments[_key];
	    }
	
	    var styles = names.map(function (name) {
	      return theme[name];
	    }).filter(truthy);
	
	    return typeof styles[0] === 'string' || typeof classNameDecorator === 'function' ? { key: key, className: classNameDecorator ? classNameDecorator.apply(undefined, _toConsumableArray(styles)) : styles.join(' ') } : { key: key, style: _objectAssign2['default'].apply(undefined, [{}].concat(_toConsumableArray(styles))) };
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 1521 */
/***/ function(module, exports) {

	'use strict';
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function ToObject(val) {
		if (val == null) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function ownEnumerableKeys(obj) {
		var keys = Object.getOwnPropertyNames(obj);
	
		if (Object.getOwnPropertySymbols) {
			keys = keys.concat(Object.getOwnPropertySymbols(obj));
		}
	
		return keys.filter(function (key) {
			return propIsEnumerable.call(obj, key);
		});
	}
	
	module.exports = Object.assign || function (target, source) {
		var from;
		var keys;
		var to = ToObject(target);
	
		for (var s = 1; s < arguments.length; s++) {
			from = arguments[s];
			keys = ownEnumerableKeys(Object(from));
	
			for (var i = 0; i < keys.length; i++) {
				to[keys[i]] = from[keys[i]];
			}
		}
	
		return to;
	};


/***/ },
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = createMiddleware;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _ravenJs = __webpack_require__(287);
	
	var _ravenJs2 = _interopRequireDefault(_ravenJs);
	
	var identity = function identity(stuff) {
	  return stuff;
	};
	
	function createMiddleware(dsn) {
	  var cfg = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	  var options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	  /*
	    Function that generates a crash reporter for Sentry.
	     dsn - private Sentry DSN.
	    cfg - object to configure Raven.
	    options - customize extra data sent to sentry
	      actionTransformer - tranform the action object to send; default to identity function
	      stateTransformer - transform the state object to send; default to identity function
	      logger - the logger to use for logging; default to console.error
	  */
	  if (!_ravenJs2['default'].isSetup()) {
	    if (!dsn) {
	      // Skip this middleware if there is no DSN.
	      console.error('[redux-raven-middleware] Sentry DSN required.');
	      return function (store) {
	        return function (next) {
	          return function (action) {
	            next(action);
	          };
	        };
	      };
	    }
	    _ravenJs2['default'].config(dsn, cfg).install();
	  }
	
	  return function (store) {
	    return function (next) {
	      return function (action) {
	        var _options$actionTransformer = options.actionTransformer;
	        var actionTransformer = _options$actionTransformer === undefined ? identity : _options$actionTransformer;
	        var _options$stateTransformer = options.stateTransformer;
	        var stateTransformer = _options$stateTransformer === undefined ? identity : _options$stateTransformer;
	        var _options$logger = options.logger;
	        var logger = _options$logger === undefined ? console.error.bind(console, '[redux-raven-middleware] Reporting error to Sentry:') : _options$logger;
	
	        try {
	          _ravenJs2['default'].captureBreadcrumb({
	            category: 'redux',
	            message: action.type
	          });
	
	          return next(action);
	        } catch (err) {
	          logger(err);
	
	          // Send the report.
	          _ravenJs2['default'].captureException(err, {
	            extra: {
	              action: actionTransformer(action),
	              state: stateTransformer(store.getState())
	            }
	          });
	        }
	      };
	    };
	  };
	}
	
	module.exports = exports['default'];


/***/ },
/* 1534 */
/***/ function(module, exports) {

	'use strict';
	
	function thunkMiddleware(_ref) {
	  var dispatch = _ref.dispatch;
	  var getState = _ref.getState;
	
	  return function (next) {
	    return function (action) {
	      return typeof action === 'function' ? action(dispatch, getState) : next(action);
	    };
	  };
	}
	
	module.exports = thunkMiddleware;

/***/ },
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1539 */
/***/ function(module, exports) {

	"use strict";
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	module.exports = function (_ref) {
	  var data = _ref.data;
	  var multiSection = _ref.multiSection;
	
	  function nextNonEmptySectionIndex(sectionIndex) {
	    if (sectionIndex === null) {
	      sectionIndex = 0;
	    } else {
	      sectionIndex++;
	    }
	
	    while (sectionIndex < data.length && data[sectionIndex] === 0) {
	      sectionIndex++;
	    }
	
	    return sectionIndex === data.length ? null : sectionIndex;
	  }
	
	  function prevNonEmptySectionIndex(sectionIndex) {
	    if (sectionIndex === null) {
	      sectionIndex = data.length - 1;
	    } else {
	      sectionIndex--;
	    }
	
	    while (sectionIndex >= 0 && data[sectionIndex] === 0) {
	      sectionIndex--;
	    }
	
	    return sectionIndex === -1 ? null : sectionIndex;
	  }
	
	  function next(position) {
	    var _position = _slicedToArray(position, 2);
	
	    var sectionIndex = _position[0];
	    var itemIndex = _position[1];
	
	
	    if (multiSection) {
	      if (itemIndex === null || itemIndex === data[sectionIndex] - 1) {
	        sectionIndex = nextNonEmptySectionIndex(sectionIndex);
	
	        if (sectionIndex === null) {
	          return [null, null];
	        }
	
	        return [sectionIndex, 0];
	      }
	
	      return [sectionIndex, itemIndex + 1];
	    }
	
	    if (data === 0 || itemIndex === data - 1) {
	      return [null, null];
	    }
	
	    if (itemIndex === null) {
	      return [null, 0];
	    }
	
	    return [null, itemIndex + 1];
	  }
	
	  function prev(position) {
	    var _position2 = _slicedToArray(position, 2);
	
	    var sectionIndex = _position2[0];
	    var itemIndex = _position2[1];
	
	
	    if (multiSection) {
	      if (itemIndex === null || itemIndex === 0) {
	        sectionIndex = prevNonEmptySectionIndex(sectionIndex);
	
	        if (sectionIndex === null) {
	          return [null, null];
	        }
	
	        return [sectionIndex, data[sectionIndex] - 1];
	      }
	
	      return [sectionIndex, itemIndex - 1];
	    }
	
	    if (data === 0 || itemIndex === 0) {
	      return [null, null];
	    }
	
	    if (itemIndex === null) {
	      return [null, data - 1];
	    }
	
	    return [null, itemIndex - 1];
	  }
	
	  function isLast(position) {
	    return next(position)[1] === null;
	  }
	
	  return {
	    next: next,
	    prev: prev,
	    isLast: isLast
	  };
	};


/***/ },
/* 1540 */
/***/ function(module, exports) {

	module.exports = function shallowEqualArrays(arrA, arrB) {
	  if (arrA === arrB) {
	    return true;
	  }
	
	  var len = arrA.length;
	
	  if (arrB.length !== len) {
	    return false;
	  }
	
	  for (var i = 0; i < len; i++) {
	    if (arrA[i] !== arrB[i]) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ },
/* 1541 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* global window, exports, define */
	
	!function() {
	    'use strict'
	
	    var re = {
	        not_string: /[^s]/,
	        not_bool: /[^t]/,
	        not_type: /[^T]/,
	        not_primitive: /[^v]/,
	        number: /[diefg]/,
	        numeric_arg: /[bcdiefguxX]/,
	        json: /[j]/,
	        not_json: /[^j]/,
	        text: /^[^\x25]+/,
	        modulo: /^\x25{2}/,
	        placeholder: /^\x25(?:([1-9]\d*)\$|\(([^\)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
	        key: /^([a-z_][a-z_\d]*)/i,
	        key_access: /^\.([a-z_][a-z_\d]*)/i,
	        index_access: /^\[(\d+)\]/,
	        sign: /^[\+\-]/
	    }
	
	    function sprintf(key) {
	        // `arguments` is not an array, but should be fine for this call
	        return sprintf_format(sprintf_parse(key), arguments)
	    }
	
	    function vsprintf(fmt, argv) {
	        return sprintf.apply(null, [fmt].concat(argv || []))
	    }
	
	    function sprintf_format(parse_tree, argv) {
	        var cursor = 1, tree_length = parse_tree.length, arg, output = '', i, k, match, pad, pad_character, pad_length, is_positive, sign
	        for (i = 0; i < tree_length; i++) {
	            if (typeof parse_tree[i] === 'string') {
	                output += parse_tree[i]
	            }
	            else if (Array.isArray(parse_tree[i])) {
	                match = parse_tree[i] // convenience purposes only
	                if (match[2]) { // keyword argument
	                    arg = argv[cursor]
	                    for (k = 0; k < match[2].length; k++) {
	                        if (!arg.hasOwnProperty(match[2][k])) {
	                            throw new Error(sprintf('[sprintf] property "%s" does not exist', match[2][k]))
	                        }
	                        arg = arg[match[2][k]]
	                    }
	                }
	                else if (match[1]) { // positional argument (explicit)
	                    arg = argv[match[1]]
	                }
	                else { // positional argument (implicit)
	                    arg = argv[cursor++]
	                }
	
	                if (re.not_type.test(match[8]) && re.not_primitive.test(match[8]) && arg instanceof Function) {
	                    arg = arg()
	                }
	
	                if (re.numeric_arg.test(match[8]) && (typeof arg !== 'number' && isNaN(arg))) {
	                    throw new TypeError(sprintf('[sprintf] expecting number but found %T', arg))
	                }
	
	                if (re.number.test(match[8])) {
	                    is_positive = arg >= 0
	                }
	
	                switch (match[8]) {
	                    case 'b':
	                        arg = parseInt(arg, 10).toString(2)
	                        break
	                    case 'c':
	                        arg = String.fromCharCode(parseInt(arg, 10))
	                        break
	                    case 'd':
	                    case 'i':
	                        arg = parseInt(arg, 10)
	                        break
	                    case 'j':
	                        arg = JSON.stringify(arg, null, match[6] ? parseInt(match[6]) : 0)
	                        break
	                    case 'e':
	                        arg = match[7] ? parseFloat(arg).toExponential(match[7]) : parseFloat(arg).toExponential()
	                        break
	                    case 'f':
	                        arg = match[7] ? parseFloat(arg).toFixed(match[7]) : parseFloat(arg)
	                        break
	                    case 'g':
	                        arg = match[7] ? String(Number(arg.toPrecision(match[7]))) : parseFloat(arg)
	                        break
	                    case 'o':
	                        arg = (parseInt(arg, 10) >>> 0).toString(8)
	                        break
	                    case 's':
	                        arg = String(arg)
	                        arg = (match[7] ? arg.substring(0, match[7]) : arg)
	                        break
	                    case 't':
	                        arg = String(!!arg)
	                        arg = (match[7] ? arg.substring(0, match[7]) : arg)
	                        break
	                    case 'T':
	                        arg = Object.prototype.toString.call(arg).slice(8, -1).toLowerCase()
	                        arg = (match[7] ? arg.substring(0, match[7]) : arg)
	                        break
	                    case 'u':
	                        arg = parseInt(arg, 10) >>> 0
	                        break
	                    case 'v':
	                        arg = arg.valueOf()
	                        arg = (match[7] ? arg.substring(0, match[7]) : arg)
	                        break
	                    case 'x':
	                        arg = (parseInt(arg, 10) >>> 0).toString(16)
	                        break
	                    case 'X':
	                        arg = (parseInt(arg, 10) >>> 0).toString(16).toUpperCase()
	                        break
	                }
	                if (re.json.test(match[8])) {
	                    output += arg
	                }
	                else {
	                    if (re.number.test(match[8]) && (!is_positive || match[3])) {
	                        sign = is_positive ? '+' : '-'
	                        arg = arg.toString().replace(re.sign, '')
	                    }
	                    else {
	                        sign = ''
	                    }
	                    pad_character = match[4] ? match[4] === '0' ? '0' : match[4].charAt(1) : ' '
	                    pad_length = match[6] - (sign + arg).length
	                    pad = match[6] ? (pad_length > 0 ? pad_character.repeat(pad_length) : '') : ''
	                    output += match[5] ? sign + arg + pad : (pad_character === '0' ? sign + pad + arg : pad + sign + arg)
	                }
	            }
	        }
	        return output
	    }
	
	    var sprintf_cache = Object.create(null)
	
	    function sprintf_parse(fmt) {
	        if (sprintf_cache[fmt]) {
	            return sprintf_cache[fmt]
	        }
	
	        var _fmt = fmt, match, parse_tree = [], arg_names = 0
	        while (_fmt) {
	            if ((match = re.text.exec(_fmt)) !== null) {
	                parse_tree.push(match[0])
	            }
	            else if ((match = re.modulo.exec(_fmt)) !== null) {
	                parse_tree.push('%')
	            }
	            else if ((match = re.placeholder.exec(_fmt)) !== null) {
	                if (match[2]) {
	                    arg_names |= 1
	                    var field_list = [], replacement_field = match[2], field_match = []
	                    if ((field_match = re.key.exec(replacement_field)) !== null) {
	                        field_list.push(field_match[1])
	                        while ((replacement_field = replacement_field.substring(field_match[0].length)) !== '') {
	                            if ((field_match = re.key_access.exec(replacement_field)) !== null) {
	                                field_list.push(field_match[1])
	                            }
	                            else if ((field_match = re.index_access.exec(replacement_field)) !== null) {
	                                field_list.push(field_match[1])
	                            }
	                            else {
	                                throw new SyntaxError('[sprintf] failed to parse named argument key')
	                            }
	                        }
	                    }
	                    else {
	                        throw new SyntaxError('[sprintf] failed to parse named argument key')
	                    }
	                    match[2] = field_list
	                }
	                else {
	                    arg_names |= 2
	                }
	                if (arg_names === 3) {
	                    throw new Error('[sprintf] mixing positional and named placeholders is not (yet) supported')
	                }
	                parse_tree.push(match)
	            }
	            else {
	                throw new SyntaxError('[sprintf] unexpected placeholder')
	            }
	            _fmt = _fmt.substring(match[0].length)
	        }
	        return sprintf_cache[fmt] = parse_tree
	    }
	
	    /**
	     * export to either browser or node.js
	     */
	    /* eslint-disable quote-props */
	    if (true) {
	        exports['sprintf'] = sprintf
	        exports['vsprintf'] = vsprintf
	    }
	    if (typeof window !== 'undefined') {
	        window['sprintf'] = sprintf
	        window['vsprintf'] = vsprintf
	
	        if ("function" === 'function' && __webpack_require__(1578)['amd']) {
	            !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	                return {
	                    'sprintf': sprintf,
	                    'vsprintf': vsprintf
	                }
	            }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	        }
	    }
	    /* eslint-enable quote-props */
	}()


/***/ },
/* 1542 */,
/* 1543 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(1278);
	
	/**
	 * Parses inline style.
	 *
	 * Example: 'color:red' => { color: 'red' }
	 *
	 * @param  {String}      style      - The inline style.
	 * @param  {Function}    [iterator] - The iterator function.
	 * @return {null|Object}
	 */
	module.exports = function parseInlineStyle(style, iterator) {
	  if (!style || typeof style !== 'string') return null;
	
	  // make sure to wrap declarations in placeholder
	  var declarations = parse('p{' + style + '}').stylesheet.rules[0].declarations;
	  var declaration, property, value;
	
	  var output = null;
	  var hasIterator = typeof iterator === 'function';
	
	  for (var i = 0, len = declarations.length; i < len; i++) {
	    declaration = declarations[i];
	    property = declaration.property;
	    value = declaration.value;
	
	    if (hasIterator) {
	      iterator(property, value, declaration);
	    } else if (value) {
	      output || (output = {});
	      output[property] = value;
	    }
	  }
	
	  return output;
	};


/***/ },
/* 1544 */,
/* 1545 */,
/* 1546 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * UAParser.js v0.7.17
	 * Lightweight JavaScript-based User-Agent string parser
	 * https://github.com/faisalman/ua-parser-js
	 *
	 * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
	 * Dual licensed under GPLv2 & MIT
	 */
	
	(function (window, undefined) {
	
	    'use strict';
	
	    //////////////
	    // Constants
	    /////////////
	
	
	    var LIBVERSION  = '0.7.17',
	        EMPTY       = '',
	        UNKNOWN     = '?',
	        FUNC_TYPE   = 'function',
	        UNDEF_TYPE  = 'undefined',
	        OBJ_TYPE    = 'object',
	        STR_TYPE    = 'string',
	        MAJOR       = 'major', // deprecated
	        MODEL       = 'model',
	        NAME        = 'name',
	        TYPE        = 'type',
	        VENDOR      = 'vendor',
	        VERSION     = 'version',
	        ARCHITECTURE= 'architecture',
	        CONSOLE     = 'console',
	        MOBILE      = 'mobile',
	        TABLET      = 'tablet',
	        SMARTTV     = 'smarttv',
	        WEARABLE    = 'wearable',
	        EMBEDDED    = 'embedded';
	
	
	    ///////////
	    // Helper
	    //////////
	
	
	    var util = {
	        extend : function (regexes, extensions) {
	            var margedRegexes = {};
	            for (var i in regexes) {
	                if (extensions[i] && extensions[i].length % 2 === 0) {
	                    margedRegexes[i] = extensions[i].concat(regexes[i]);
	                } else {
	                    margedRegexes[i] = regexes[i];
	                }
	            }
	            return margedRegexes;
	        },
	        has : function (str1, str2) {
	          if (typeof str1 === "string") {
	            return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
	          } else {
	            return false;
	          }
	        },
	        lowerize : function (str) {
	            return str.toLowerCase();
	        },
	        major : function (version) {
	            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g,'').split(".")[0] : undefined;
	        },
	        trim : function (str) {
	          return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
	        }
	    };
	
	
	    ///////////////
	    // Map helper
	    //////////////
	
	
	    var mapper = {
	
	        rgx : function (ua, arrays) {
	
	            //var result = {},
	            var i = 0, j, k, p, q, matches, match;//, args = arguments;
	
	            /*// construct object barebones
	            for (p = 0; p < args[1].length; p++) {
	                q = args[1][p];
	                result[typeof q === OBJ_TYPE ? q[0] : q] = undefined;
	            }*/
	
	            // loop through all regexes maps
	            while (i < arrays.length && !matches) {
	
	                var regex = arrays[i],       // even sequence (0,2,4,..)
	                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
	                j = k = 0;
	
	                // try matching uastring with regexes
	                while (j < regex.length && !matches) {
	
	                    matches = regex[j++].exec(ua);
	
	                    if (!!matches) {
	                        for (p = 0; p < props.length; p++) {
	                            match = matches[++k];
	                            q = props[p];
	                            // check if given property is actually array
	                            if (typeof q === OBJ_TYPE && q.length > 0) {
	                                if (q.length == 2) {
	                                    if (typeof q[1] == FUNC_TYPE) {
	                                        // assign modified match
	                                        this[q[0]] = q[1].call(this, match);
	                                    } else {
	                                        // assign given value, ignore regex match
	                                        this[q[0]] = q[1];
	                                    }
	                                } else if (q.length == 3) {
	                                    // check whether function or regex
	                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
	                                        // call function (usually string mapper)
	                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
	                                    } else {
	                                        // sanitize match using given regex
	                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
	                                    }
	                                } else if (q.length == 4) {
	                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
	                                }
	                            } else {
	                                this[q] = match ? match : undefined;
	                            }
	                        }
	                    }
	                }
	                i += 2;
	            }
	            // console.log(this);
	            //return this;
	        },
	
	        str : function (str, map) {
	
	            for (var i in map) {
	                // check if array
	                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
	                    for (var j = 0; j < map[i].length; j++) {
	                        if (util.has(map[i][j], str)) {
	                            return (i === UNKNOWN) ? undefined : i;
	                        }
	                    }
	                } else if (util.has(map[i], str)) {
	                    return (i === UNKNOWN) ? undefined : i;
	                }
	            }
	            return str;
	        }
	    };
	
	
	    ///////////////
	    // String map
	    //////////////
	
	
	    var maps = {
	
	        browser : {
	            oldsafari : {
	                version : {
	                    '1.0'   : '/8',
	                    '1.2'   : '/1',
	                    '1.3'   : '/3',
	                    '2.0'   : '/412',
	                    '2.0.2' : '/416',
	                    '2.0.3' : '/417',
	                    '2.0.4' : '/419',
	                    '?'     : '/'
	                }
	            }
	        },
	
	        device : {
	            amazon : {
	                model : {
	                    'Fire Phone' : ['SD', 'KF']
	                }
	            },
	            sprint : {
	                model : {
	                    'Evo Shift 4G' : '7373KT'
	                },
	                vendor : {
	                    'HTC'       : 'APA',
	                    'Sprint'    : 'Sprint'
	                }
	            }
	        },
	
	        os : {
	            windows : {
	                version : {
	                    'ME'        : '4.90',
	                    'NT 3.11'   : 'NT3.51',
	                    'NT 4.0'    : 'NT4.0',
	                    '2000'      : 'NT 5.0',
	                    'XP'        : ['NT 5.1', 'NT 5.2'],
	                    'Vista'     : 'NT 6.0',
	                    '7'         : 'NT 6.1',
	                    '8'         : 'NT 6.2',
	                    '8.1'       : 'NT 6.3',
	                    '10'        : ['NT 6.4', 'NT 10.0'],
	                    'RT'        : 'ARM'
	                }
	            }
	        }
	    };
	
	
	    //////////////
	    // Regex map
	    /////////////
	
	
	    var regexes = {
	
	        browser : [[
	
	            // Presto based
	            /(opera\smini)\/([\w\.-]+)/i,                                       // Opera Mini
	            /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,                      // Opera Mobi/Tablet
	            /(opera).+version\/([\w\.]+)/i,                                     // Opera > 9.80
	            /(opera)[\/\s]+([\w\.]+)/i                                          // Opera < 9.80
	            ], [NAME, VERSION], [
	
	            /(opios)[\/\s]+([\w\.]+)/i                                          // Opera mini on iphone >= 8.0
	            ], [[NAME, 'Opera Mini'], VERSION], [
	
	            /\s(opr)\/([\w\.]+)/i                                               // Opera Webkit
	            ], [[NAME, 'Opera'], VERSION], [
	
	            // Mixed
	            /(kindle)\/([\w\.]+)/i,                                             // Kindle
	            /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]+)*/i,
	                                                                                // Lunascape/Maxthon/Netfront/Jasmine/Blazer
	
	            // Trident based
	            /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,
	                                                                                // Avant/IEMobile/SlimBrowser/Baidu
	            /(?:ms|\()(ie)\s([\w\.]+)/i,                                        // Internet Explorer
	
	            // Webkit/KHTML based
	            /(rekonq)\/([\w\.]+)*/i,                                            // Rekonq
	            /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser)\/([\w\.-]+)/i
	                                                                                // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser
	            ], [NAME, VERSION], [
	
	            /(trident).+rv[:\s]([\w\.]+).+like\sgecko/i                         // IE11
	            ], [[NAME, 'IE'], VERSION], [
	
	            /(edge)\/((\d+)?[\w\.]+)/i                                          // Microsoft Edge
	            ], [NAME, VERSION], [
	
	            /(yabrowser)\/([\w\.]+)/i                                           // Yandex
	            ], [[NAME, 'Yandex'], VERSION], [
	
	            /(puffin)\/([\w\.]+)/i                                              // Puffin
	            ], [[NAME, 'Puffin'], VERSION], [
	
	            /((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i
	                                                                                // UCBrowser
	            ], [[NAME, 'UCBrowser'], VERSION], [
	
	            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
	            ], [[NAME, /_/g, ' '], VERSION], [
	
	            /(micromessenger)\/([\w\.]+)/i                                      // WeChat
	            ], [[NAME, 'WeChat'], VERSION], [
	
	            /(QQ)\/([\d\.]+)/i                                                  // QQ, aka ShouQ
	            ], [NAME, VERSION], [
	
	            /m?(qqbrowser)[\/\s]?([\w\.]+)/i                                    // QQBrowser
	            ], [NAME, VERSION], [
	
	            /xiaomi\/miuibrowser\/([\w\.]+)/i                                   // MIUI Browser
	            ], [VERSION, [NAME, 'MIUI Browser']], [
	
	            /;fbav\/([\w\.]+);/i                                                // Facebook App for iOS & Android
	            ], [VERSION, [NAME, 'Facebook']], [
	
	            /headlesschrome(?:\/([\w\.]+)|\s)/i                                 // Chrome Headless
	            ], [VERSION, [NAME, 'Chrome Headless']], [
	
	            /\swv\).+(chrome)\/([\w\.]+)/i                                      // Chrome WebView
	            ], [[NAME, /(.+)/, '$1 WebView'], VERSION], [
	
	            /((?:oculus|samsung)browser)\/([\w\.]+)/i
	            ], [[NAME, /(.+(?:g|us))(.+)/, '$1 $2'], VERSION], [                // Oculus / Samsung Browser
	
	            /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i        // Android Browser
	            ], [VERSION, [NAME, 'Android Browser']], [
	
	            /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i
	                                                                                // Chrome/OmniWeb/Arora/Tizen/Nokia
	            ], [NAME, VERSION], [
	
	            /(dolfin)\/([\w\.]+)/i                                              // Dolphin
	            ], [[NAME, 'Dolphin'], VERSION], [
	
	            /((?:android.+)crmo|crios)\/([\w\.]+)/i                             // Chrome for Android/iOS
	            ], [[NAME, 'Chrome'], VERSION], [
	
	            /(coast)\/([\w\.]+)/i                                               // Opera Coast
	            ], [[NAME, 'Opera Coast'], VERSION], [
	
	            /fxios\/([\w\.-]+)/i                                                // Firefox for iOS
	            ], [VERSION, [NAME, 'Firefox']], [
	
	            /version\/([\w\.]+).+?mobile\/\w+\s(safari)/i                       // Mobile Safari
	            ], [VERSION, [NAME, 'Mobile Safari']], [
	
	            /version\/([\w\.]+).+?(mobile\s?safari|safari)/i                    // Safari & Safari Mobile
	            ], [VERSION, NAME], [
	
	            /webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i  // Google Search Appliance on iOS
	            ], [[NAME, 'GSA'], VERSION], [
	
	            /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i                     // Safari < 3.0
	            ], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [
	
	            /(konqueror)\/([\w\.]+)/i,                                          // Konqueror
	            /(webkit|khtml)\/([\w\.]+)/i
	            ], [NAME, VERSION], [
	
	            // Gecko based
	            /(navigator|netscape)\/([\w\.-]+)/i                                 // Netscape
	            ], [[NAME, 'Netscape'], VERSION], [
	            /(swiftfox)/i,                                                      // Swiftfox
	            /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
	                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
	            /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix)\/([\w\.-]+)/i,
	                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
	            /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,                          // Mozilla
	
	            // Other
	            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
	                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
	            /(links)\s\(([\w\.]+)/i,                                            // Links
	            /(gobrowser)\/?([\w\.]+)*/i,                                        // GoBrowser
	            /(ice\s?browser)\/v?([\w\._]+)/i,                                   // ICE Browser
	            /(mosaic)[\/\s]([\w\.]+)/i                                          // Mosaic
	            ], [NAME, VERSION]
	
	            /* /////////////////////
	            // Media players BEGIN
	            ////////////////////////
	
	            , [
	
	            /(apple(?:coremedia|))\/((\d+)[\w\._]+)/i,                          // Generic Apple CoreMedia
	            /(coremedia) v((\d+)[\w\._]+)/i
	            ], [NAME, VERSION], [
	
	            /(aqualung|lyssna|bsplayer)\/((\d+)?[\w\.-]+)/i                     // Aqualung/Lyssna/BSPlayer
	            ], [NAME, VERSION], [
	
	            /(ares|ossproxy)\s((\d+)[\w\.-]+)/i                                 // Ares/OSSProxy
	            ], [NAME, VERSION], [
	
	            /(audacious|audimusicstream|amarok|bass|core|dalvik|gnomemplayer|music on console|nsplayer|psp-internetradioplayer|videos)\/((\d+)[\w\.-]+)/i,
	                                                                                // Audacious/AudiMusicStream/Amarok/BASS/OpenCORE/Dalvik/GnomeMplayer/MoC
	                                                                                // NSPlayer/PSP-InternetRadioPlayer/Videos
	            /(clementine|music player daemon)\s((\d+)[\w\.-]+)/i,               // Clementine/MPD
	            /(lg player|nexplayer)\s((\d+)[\d\.]+)/i,
	            /player\/(nexplayer|lg player)\s((\d+)[\w\.-]+)/i                   // NexPlayer/LG Player
	            ], [NAME, VERSION], [
	            /(nexplayer)\s((\d+)[\w\.-]+)/i                                     // Nexplayer
	            ], [NAME, VERSION], [
	
	            /(flrp)\/((\d+)[\w\.-]+)/i                                          // Flip Player
	            ], [[NAME, 'Flip Player'], VERSION], [
	
	            /(fstream|nativehost|queryseekspider|ia-archiver|facebookexternalhit)/i
	                                                                                // FStream/NativeHost/QuerySeekSpider/IA Archiver/facebookexternalhit
	            ], [NAME], [
	
	            /(gstreamer) souphttpsrc (?:\([^\)]+\)){0,1} libsoup\/((\d+)[\w\.-]+)/i
	                                                                                // Gstreamer
	            ], [NAME, VERSION], [
	
	            /(htc streaming player)\s[\w_]+\s\/\s((\d+)[\d\.]+)/i,              // HTC Streaming Player
	            /(java|python-urllib|python-requests|wget|libcurl)\/((\d+)[\w\.-_]+)/i,
	                                                                                // Java/urllib/requests/wget/cURL
	            /(lavf)((\d+)[\d\.]+)/i                                             // Lavf (FFMPEG)
	            ], [NAME, VERSION], [
	
	            /(htc_one_s)\/((\d+)[\d\.]+)/i                                      // HTC One S
	            ], [[NAME, /_/g, ' '], VERSION], [
	
	            /(mplayer)(?:\s|\/)(?:(?:sherpya-){0,1}svn)(?:-|\s)(r\d+(?:-\d+[\w\.-]+){0,1})/i
	                                                                                // MPlayer SVN
	            ], [NAME, VERSION], [
	
	            /(mplayer)(?:\s|\/|[unkow-]+)((\d+)[\w\.-]+)/i                      // MPlayer
	            ], [NAME, VERSION], [
	
	            /(mplayer)/i,                                                       // MPlayer (no other info)
	            /(yourmuze)/i,                                                      // YourMuze
	            /(media player classic|nero showtime)/i                             // Media Player Classic/Nero ShowTime
	            ], [NAME], [
	
	            /(nero (?:home|scout))\/((\d+)[\w\.-]+)/i                           // Nero Home/Nero Scout
	            ], [NAME, VERSION], [
	
	            /(nokia\d+)\/((\d+)[\w\.-]+)/i                                      // Nokia
	            ], [NAME, VERSION], [
	
	            /\s(songbird)\/((\d+)[\w\.-]+)/i                                    // Songbird/Philips-Songbird
	            ], [NAME, VERSION], [
	
	            /(winamp)3 version ((\d+)[\w\.-]+)/i,                               // Winamp
	            /(winamp)\s((\d+)[\w\.-]+)/i,
	            /(winamp)mpeg\/((\d+)[\w\.-]+)/i
	            ], [NAME, VERSION], [
	
	            /(ocms-bot|tapinradio|tunein radio|unknown|winamp|inlight radio)/i  // OCMS-bot/tap in radio/tunein/unknown/winamp (no other info)
	                                                                                // inlight radio
	            ], [NAME], [
	
	            /(quicktime|rma|radioapp|radioclientapplication|soundtap|totem|stagefright|streamium)\/((\d+)[\w\.-]+)/i
	                                                                                // QuickTime/RealMedia/RadioApp/RadioClientApplication/
	                                                                                // SoundTap/Totem/Stagefright/Streamium
	            ], [NAME, VERSION], [
	
	            /(smp)((\d+)[\d\.]+)/i                                              // SMP
	            ], [NAME, VERSION], [
	
	            /(vlc) media player - version ((\d+)[\w\.]+)/i,                     // VLC Videolan
	            /(vlc)\/((\d+)[\w\.-]+)/i,
	            /(xbmc|gvfs|xine|xmms|irapp)\/((\d+)[\w\.-]+)/i,                    // XBMC/gvfs/Xine/XMMS/irapp
	            /(foobar2000)\/((\d+)[\d\.]+)/i,                                    // Foobar2000
	            /(itunes)\/((\d+)[\d\.]+)/i                                         // iTunes
	            ], [NAME, VERSION], [
	
	            /(wmplayer)\/((\d+)[\w\.-]+)/i,                                     // Windows Media Player
	            /(windows-media-player)\/((\d+)[\w\.-]+)/i
	            ], [[NAME, /-/g, ' '], VERSION], [
	
	            /windows\/((\d+)[\w\.-]+) upnp\/[\d\.]+ dlnadoc\/[\d\.]+ (home media server)/i
	                                                                                // Windows Media Server
	            ], [VERSION, [NAME, 'Windows']], [
	
	            /(com\.riseupradioalarm)\/((\d+)[\d\.]*)/i                          // RiseUP Radio Alarm
	            ], [NAME, VERSION], [
	
	            /(rad.io)\s((\d+)[\d\.]+)/i,                                        // Rad.io
	            /(radio.(?:de|at|fr))\s((\d+)[\d\.]+)/i
	            ], [[NAME, 'rad.io'], VERSION]
	
	            //////////////////////
	            // Media players END
	            ////////////////////*/
	
	        ],
	
	        cpu : [[
	
	            /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i                     // AMD64
	            ], [[ARCHITECTURE, 'amd64']], [
	
	            /(ia32(?=;))/i                                                      // IA32 (quicktime)
	            ], [[ARCHITECTURE, util.lowerize]], [
	
	            /((?:i[346]|x)86)[;\)]/i                                            // IA32
	            ], [[ARCHITECTURE, 'ia32']], [
	
	            // PocketPC mistakenly identified as PowerPC
	            /windows\s(ce|mobile);\sppc;/i
	            ], [[ARCHITECTURE, 'arm']], [
	
	            /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i                           // PowerPC
	            ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [
	
	            /(sun4\w)[;\)]/i                                                    // SPARC
	            ], [[ARCHITECTURE, 'sparc']], [
	
	            /((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i
	                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
	            ], [[ARCHITECTURE, util.lowerize]]
	        ],
	
	        device : [[
	
	            /\((ipad|playbook);[\w\s\);-]+(rim|apple)/i                         // iPad/PlayBook
	            ], [MODEL, VENDOR, [TYPE, TABLET]], [
	
	            /applecoremedia\/[\w\.]+ \((ipad)/                                  // iPad
	            ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [
	
	            /(apple\s{0,1}tv)/i                                                 // Apple TV
	            ], [[MODEL, 'Apple TV'], [VENDOR, 'Apple']], [
	
	            /(archos)\s(gamepad2?)/i,                                           // Archos
	            /(hp).+(touchpad)/i,                                                // HP TouchPad
	            /(hp).+(tablet)/i,                                                  // HP Tablet
	            /(kindle)\/([\w\.]+)/i,                                             // Kindle
	            /\s(nook)[\w\s]+build\/(\w+)/i,                                     // Nook
	            /(dell)\s(strea[kpr\s\d]*[\dko])/i                                  // Dell Streak
	            ], [VENDOR, MODEL, [TYPE, TABLET]], [
	
	            /(kf[A-z]+)\sbuild\/[\w\.]+.*silk\//i                               // Kindle Fire HD
	            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
	            /(sd|kf)[0349hijorstuw]+\sbuild\/[\w\.]+.*silk\//i                  // Fire Phone
	            ], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [
	
	            /\((ip[honed|\s\w*]+);.+(apple)/i                                   // iPod/iPhone
	            ], [MODEL, VENDOR, [TYPE, MOBILE]], [
	            /\((ip[honed|\s\w*]+);/i                                            // iPod/iPhone
	            ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [
	
	            /(blackberry)[\s-]?(\w+)/i,                                         // BlackBerry
	            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]+)*/i,
	                                                                                // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
	            /(hp)\s([\w\s]+\w)/i,                                               // HP iPAQ
	            /(asus)-?(\w+)/i                                                    // Asus
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	            /\(bb10;\s(\w+)/i                                                   // BlackBerry 10
	            ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [
	                                                                                // Asus Tablets
	            /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i
	            ], [MODEL, [VENDOR, 'Asus'], [TYPE, TABLET]], [
	
	            /(sony)\s(tablet\s[ps])\sbuild\//i,                                  // Sony
	            /(sony)?(?:sgp.+)\sbuild\//i
	            ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Tablet'], [TYPE, TABLET]], [
	            /android.+\s([c-g]\d{4}|so[-l]\w+)\sbuild\//i
	            ], [MODEL, [VENDOR, 'Sony'], [TYPE, MOBILE]], [
	
	            /\s(ouya)\s/i,                                                      // Ouya
	            /(nintendo)\s([wids3u]+)/i                                          // Nintendo
	            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [
	
	            /android.+;\s(shield)\sbuild/i                                      // Nvidia
	            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [
	
	            /(playstation\s[34portablevi]+)/i                                   // Playstation
	            ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [
	
	            /(sprint\s(\w+))/i                                                  // Sprint Phones
	            ], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [
	
	            /(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i                         // Lenovo tablets
	            ], [VENDOR, MODEL, [TYPE, TABLET]], [
	
	            /(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,                               // HTC
	            /(zte)-(\w+)*/i,                                                    // ZTE
	            /(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]+)*/i
	                                                                                // Alcatel/GeeksPhone/Lenovo/Nexian/Panasonic/Sony
	            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [
	
	            /(nexus\s9)/i                                                       // HTC Nexus 9
	            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [
	
	            /d\/huawei([\w\s-]+)[;\)]/i,
	            /(nexus\s6p)/i                                                      // Huawei
	            ], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [
	
	            /(microsoft);\s(lumia[\s\w]+)/i                                     // Microsoft Lumia
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	
	            /[\s\(;](xbox(?:\sone)?)[\s\);]/i                                   // Microsoft Xbox
	            ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [
	            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
	            ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [
	
	                                                                                // Motorola
	            /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?(:?\s4g)?)[\w\s]+build\//i,
	            /mot[\s-]?(\w+)*/i,
	            /(XT\d{3,4}) build\//i,
	            /(nexus\s6)/i
	            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [
	            /android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i
	            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [
	
	            /hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i            // HbbTV devices
	            ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [
	
	            /hbbtv.+maple;(\d+)/i
	            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [
	
	            /\(dtv[\);].+(aquos)/i                                              // Sharp
	            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [
	
	            /android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,
	            /((SM-T\w+))/i
	            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [                  // Samsung
	            /smart-tv.+(samsung)/i
	            ], [VENDOR, [TYPE, SMARTTV], MODEL], [
	            /((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,
	            /(sam[sung]*)[\s-]*(\w+-?[\w-]*)*/i,
	            /sec-((sgh\w+))/i
	            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [
	
	            /sie-(\w+)*/i                                                       // Siemens
	            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [
	
	            /(maemo|nokia).*(n900|lumia\s\d+)/i,                                // Nokia
	            /(nokia)[\s_-]?([\w-]+)*/i
	            ], [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [
	
	            /android\s3\.[\s\w;-]{10}(a\d{3})/i                                 // Acer
	            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [
	
	            /android.+([vl]k\-?\d{3})\s+build/i                                 // LG Tablet
	            ], [MODEL, [VENDOR, 'LG'], [TYPE, TABLET]], [
	            /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i                     // LG Tablet
	            ], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]], [
	            /(lg) netcast\.tv/i                                                 // LG SmartTV
	            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
	            /(nexus\s[45])/i,                                                   // LG
	            /lg[e;\s\/-]+(\w+)*/i,
	            /android.+lg(\-?[\d\w]+)\s+build/i
	            ], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [
	
	            /android.+(ideatab[a-z0-9\-\s]+)/i                                  // Lenovo
	            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [
	
	            /linux;.+((jolla));/i                                               // Jolla
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	
	            /((pebble))app\/[\d\.]+\s/i                                         // Pebble
	            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
	
	            /android.+;\s(oppo)\s?([\w\s]+)\sbuild/i                            // OPPO
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	
	            /crkey/i                                                            // Google Chromecast
	            ], [[MODEL, 'Chromecast'], [VENDOR, 'Google']], [
	
	            /android.+;\s(glass)\s\d/i                                          // Google Glass
	            ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [
	
	            /android.+;\s(pixel c)\s/i                                          // Google Pixel C
	            ], [MODEL, [VENDOR, 'Google'], [TYPE, TABLET]], [
	
	            /android.+;\s(pixel xl|pixel)\s/i                                   // Google Pixel
	            ], [MODEL, [VENDOR, 'Google'], [TYPE, MOBILE]], [
	
	            /android.+(\w+)\s+build\/hm\1/i,                                    // Xiaomi Hongmi 'numeric' models
	            /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,               // Xiaomi Hongmi
	            /android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d\w)?)\s+build/i,    // Xiaomi Mi
	            /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+)?)\s+build/i      // Redmi Phones
	            ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [
	            /android.+(mi[\s\-_]*(?:pad)?(?:[\s_]*[\w\s]+)?)\s+build/i          // Mi Pad tablets
	            ],[[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, TABLET]], [
	            /android.+;\s(m[1-5]\snote)\sbuild/i                                // Meizu Tablet
	            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, TABLET]], [
	
	            /android.+a000(1)\s+build/i                                         // OnePlus
	            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [
	
	            /android.+[;\/]\s*(RCT[\d\w]+)\s+build/i                            // RCA Tablets
	            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [
	
	            /android.+[;\/]\s*(Venue[\d\s]*)\s+build/i                          // Dell Venue Tablets
	            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [
	
	            /android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i                         // Verizon Tablet
	            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [
	
	            /android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i     // Barnes & Noble Tablet
	            ], [[VENDOR, 'Barnes & Noble'], MODEL, [TYPE, TABLET]], [
	
	            /android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i                           // Barnes & Noble Tablet
	            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [
	
	            /android.+[;\/]\s*(zte)?.+(k\d{2})\s+build/i                        // ZTE K Series Tablet
	            ], [[VENDOR, 'ZTE'], MODEL, [TYPE, TABLET]], [
	
	            /android.+[;\/]\s*(gen\d{3})\s+build.*49h/i                         // Swiss GEN Mobile
	            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [
	
	            /android.+[;\/]\s*(zur\d{3})\s+build/i                              // Swiss ZUR Tablet
	            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [
	
	            /android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i                         // Zeki Tablets
	            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [
	
	            /(android).+[;\/]\s+([YR]\d{2}x?.*)\s+build/i,
	            /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(.+)\s+build/i          // Dragon Touch Tablet
	            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [
	
	            /android.+[;\/]\s*(NS-?.+)\s+build/i                                // Insignia Tablets
	            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [
	
	            /android.+[;\/]\s*((NX|Next)-?.+)\s+build/i                         // NextBook Tablets
	            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [
	
	            /android.+[;\/]\s*(Xtreme\_?)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i
	            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [                    // Voice Xtreme Phones
	
	            /android.+[;\/]\s*(LVTEL\-?)?(V1[12])\s+build/i                     // LvTel Phones
	            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [
	
	            /android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i          // Envizen Tablets
	            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [
	
	            /android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(.*\b)\s+build/i             // Le Pan Tablets
	            ], [VENDOR, MODEL, [TYPE, TABLET]], [
	
	            /android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i                         // MachSpeed Tablets
	            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [
	
	            /android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i                // Trinity Tablets
	            ], [VENDOR, MODEL, [TYPE, TABLET]], [
	
	            /android.+[;\/]\s*TU_(1491)\s+build/i                               // Rotor Tablets
	            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [
	
	            /android.+(KS(.+))\s+build/i                                        // Amazon Kindle Tablets
	            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
	
	            /android.+(Gigaset)[\s\-]+(Q.+)\s+build/i                           // Gigaset Tablets
	            ], [VENDOR, MODEL, [TYPE, TABLET]], [
	
	            /\s(tablet|tab)[;\/]/i,                                             // Unidentifiable Tablet
	            /\s(mobile)(?:[;\/]|\ssafari)/i                                     // Unidentifiable Mobile
	            ], [[TYPE, util.lowerize], VENDOR, MODEL], [
	
	            /(android.+)[;\/].+build/i                                          // Generic Android Device
	            ], [MODEL, [VENDOR, 'Generic']]
	
	
	        /*//////////////////////////
	            // TODO: move to string map
	            ////////////////////////////
	
	            /(C6603)/i                                                          // Sony Xperia Z C6603
	            ], [[MODEL, 'Xperia Z C6603'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
	            /(C6903)/i                                                          // Sony Xperia Z 1
	            ], [[MODEL, 'Xperia Z 1'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
	
	            /(SM-G900[F|H])/i                                                   // Samsung Galaxy S5
	            ], [[MODEL, 'Galaxy S5'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-G7102)/i                                                       // Samsung Galaxy Grand 2
	            ], [[MODEL, 'Galaxy Grand 2'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-G530H)/i                                                       // Samsung Galaxy Grand Prime
	            ], [[MODEL, 'Galaxy Grand Prime'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-G313HZ)/i                                                      // Samsung Galaxy V
	            ], [[MODEL, 'Galaxy V'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-T805)/i                                                        // Samsung Galaxy Tab S 10.5
	            ], [[MODEL, 'Galaxy Tab S 10.5'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
	            /(SM-G800F)/i                                                       // Samsung Galaxy S5 Mini
	            ], [[MODEL, 'Galaxy S5 Mini'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-T311)/i                                                        // Samsung Galaxy Tab 3 8.0
	            ], [[MODEL, 'Galaxy Tab 3 8.0'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
	
	            /(T3C)/i                                                            // Advan Vandroid T3C
	            ], [MODEL, [VENDOR, 'Advan'], [TYPE, TABLET]], [
	            /(ADVAN T1J\+)/i                                                    // Advan Vandroid T1J+
	            ], [[MODEL, 'Vandroid T1J+'], [VENDOR, 'Advan'], [TYPE, TABLET]], [
	            /(ADVAN S4A)/i                                                      // Advan Vandroid S4A
	            ], [[MODEL, 'Vandroid S4A'], [VENDOR, 'Advan'], [TYPE, MOBILE]], [
	
	            /(V972M)/i                                                          // ZTE V972M
	            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
	
	            /(i-mobile)\s(IQ\s[\d\.]+)/i                                        // i-mobile IQ
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	            /(IQ6.3)/i                                                          // i-mobile IQ IQ 6.3
	            ], [[MODEL, 'IQ 6.3'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
	            /(i-mobile)\s(i-style\s[\d\.]+)/i                                   // i-mobile i-STYLE
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	            /(i-STYLE2.1)/i                                                     // i-mobile i-STYLE 2.1
	            ], [[MODEL, 'i-STYLE 2.1'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
	
	            /(mobiistar touch LAI 512)/i                                        // mobiistar touch LAI 512
	            ], [[MODEL, 'Touch LAI 512'], [VENDOR, 'mobiistar'], [TYPE, MOBILE]], [
	
	            /////////////
	            // END TODO
	            ///////////*/
	
	        ],
	
	        engine : [[
	
	            /windows.+\sedge\/([\w\.]+)/i                                       // EdgeHTML
	            ], [VERSION, [NAME, 'EdgeHTML']], [
	
	            /(presto)\/([\w\.]+)/i,                                             // Presto
	            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,     // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m
	            /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,                          // KHTML/Tasman/Links
	            /(icab)[\/\s]([23]\.[\d\.]+)/i                                      // iCab
	            ], [NAME, VERSION], [
	
	            /rv\:([\w\.]+).*(gecko)/i                                           // Gecko
	            ], [VERSION, NAME]
	        ],
	
	        os : [[
	
	            // Windows based
	            /microsoft\s(windows)\s(vista|xp)/i                                 // Windows (iTunes)
	            ], [NAME, VERSION], [
	            /(windows)\snt\s6\.2;\s(arm)/i,                                     // Windows RT
	            /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s]+\w)*/i,                  // Windows Phone
	            /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i
	            ], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [
	            /(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i
	            ], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [
	
	            // Mobile/Embedded OS
	            /\((bb)(10);/i                                                      // BlackBerry 10
	            ], [[NAME, 'BlackBerry'], VERSION], [
	            /(blackberry)\w*\/?([\w\.]+)*/i,                                    // Blackberry
	            /(tizen)[\/\s]([\w\.]+)/i,                                          // Tizen
	            /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]+)*/i,
	                                                                                // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki
	            /linux;.+(sailfish);/i                                              // Sailfish OS
	            ], [NAME, VERSION], [
	            /(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]+)*/i                 // Symbian
	            ], [[NAME, 'Symbian'], VERSION], [
	            /\((series40);/i                                                    // Series 40
	            ], [NAME], [
	            /mozilla.+\(mobile;.+gecko.+firefox/i                               // Firefox OS
	            ], [[NAME, 'Firefox OS'], VERSION], [
	
	            // Console
	            /(nintendo|playstation)\s([wids34portablevu]+)/i,                   // Nintendo/Playstation
	
	            // GNU/Linux based
	            /(mint)[\/\s\(]?(\w+)*/i,                                           // Mint
	            /(mageia|vectorlinux)[;\s]/i,                                       // Mageia/VectorLinux
	            /(joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]+)*/i,
	                                                                                // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
	                                                                                // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
	            /(hurd|linux)\s?([\w\.]+)*/i,                                       // Hurd/Linux
	            /(gnu)\s?([\w\.]+)*/i                                               // GNU
	            ], [NAME, VERSION], [
	
	            /(cros)\s[\w]+\s([\w\.]+\w)/i                                       // Chromium OS
	            ], [[NAME, 'Chromium OS'], VERSION],[
	
	            // Solaris
	            /(sunos)\s?([\w\.]+\d)*/i                                           // Solaris
	            ], [[NAME, 'Solaris'], VERSION], [
	
	            // BSD based
	            /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]+)*/i                   // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
	            ], [NAME, VERSION],[
	
	            /(haiku)\s(\w+)/i                                                  // Haiku
	            ], [NAME, VERSION],[
	
	            /cfnetwork\/.+darwin/i,
	            /ip[honead]+(?:.*os\s([\w]+)\slike\smac|;\sopera)/i                 // iOS
	            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [
	
	            /(mac\sos\sx)\s?([\w\s\.]+\w)*/i,
	            /(macintosh|mac(?=_powerpc)\s)/i                                    // Mac OS
	            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [
	
	            // Other
	            /((?:open)?solaris)[\/\s-]?([\w\.]+)*/i,                            // Solaris
	            /(aix)\s((\d)(?=\.|\)|\s)[\w\.]*)*/i,                               // AIX
	            /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i,
	                                                                                // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS
	            /(unix)\s?([\w\.]+)*/i                                              // UNIX
	            ], [NAME, VERSION]
	        ]
	    };
	
	
	    /////////////////
	    // Constructor
	    ////////////////
	    /*
	    var Browser = function (name, version) {
	        this[NAME] = name;
	        this[VERSION] = version;
	    };
	    var CPU = function (arch) {
	        this[ARCHITECTURE] = arch;
	    };
	    var Device = function (vendor, model, type) {
	        this[VENDOR] = vendor;
	        this[MODEL] = model;
	        this[TYPE] = type;
	    };
	    var Engine = Browser;
	    var OS = Browser;
	    */
	    var UAParser = function (uastring, extensions) {
	
	        if (typeof uastring === 'object') {
	            extensions = uastring;
	            uastring = undefined;
	        }
	
	        if (!(this instanceof UAParser)) {
	            return new UAParser(uastring, extensions).getResult();
	        }
	
	        var ua = uastring || ((window && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
	        var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;
	        //var browser = new Browser();
	        //var cpu = new CPU();
	        //var device = new Device();
	        //var engine = new Engine();
	        //var os = new OS();
	
	        this.getBrowser = function () {
	            var browser = { name: undefined, version: undefined };
	            mapper.rgx.call(browser, ua, rgxmap.browser);
	            browser.major = util.major(browser.version); // deprecated
	            return browser;
	        };
	        this.getCPU = function () {
	            var cpu = { architecture: undefined };
	            mapper.rgx.call(cpu, ua, rgxmap.cpu);
	            return cpu;
	        };
	        this.getDevice = function () {
	            var device = { vendor: undefined, model: undefined, type: undefined };
	            mapper.rgx.call(device, ua, rgxmap.device);
	            return device;
	        };
	        this.getEngine = function () {
	            var engine = { name: undefined, version: undefined };
	            mapper.rgx.call(engine, ua, rgxmap.engine);
	            return engine;
	        };
	        this.getOS = function () {
	            var os = { name: undefined, version: undefined };
	            mapper.rgx.call(os, ua, rgxmap.os);
	            return os;
	        };
	        this.getResult = function () {
	            return {
	                ua      : this.getUA(),
	                browser : this.getBrowser(),
	                engine  : this.getEngine(),
	                os      : this.getOS(),
	                device  : this.getDevice(),
	                cpu     : this.getCPU()
	            };
	        };
	        this.getUA = function () {
	            return ua;
	        };
	        this.setUA = function (uastring) {
	            ua = uastring;
	            //browser = new Browser();
	            //cpu = new CPU();
	            //device = new Device();
	            //engine = new Engine();
	            //os = new OS();
	            return this;
	        };
	        return this;
	    };
	
	    UAParser.VERSION = LIBVERSION;
	    UAParser.BROWSER = {
	        NAME    : NAME,
	        MAJOR   : MAJOR, // deprecated
	        VERSION : VERSION
	    };
	    UAParser.CPU = {
	        ARCHITECTURE : ARCHITECTURE
	    };
	    UAParser.DEVICE = {
	        MODEL   : MODEL,
	        VENDOR  : VENDOR,
	        TYPE    : TYPE,
	        CONSOLE : CONSOLE,
	        MOBILE  : MOBILE,
	        SMARTTV : SMARTTV,
	        TABLET  : TABLET,
	        WEARABLE: WEARABLE,
	        EMBEDDED: EMBEDDED
	    };
	    UAParser.ENGINE = {
	        NAME    : NAME,
	        VERSION : VERSION
	    };
	    UAParser.OS = {
	        NAME    : NAME,
	        VERSION : VERSION
	    };
	    //UAParser.Utils = util;
	
	    ///////////
	    // Export
	    //////////
	
	
	    // check js environment
	    if (typeof(exports) !== UNDEF_TYPE) {
	        // nodejs env
	        if (typeof module !== UNDEF_TYPE && module.exports) {
	            exports = module.exports = UAParser;
	        }
	        // TODO: test!!!!!!!!
	        /*
	        if (require && require.main === module && process) {
	            // cli
	            var jsonize = function (arr) {
	                var res = [];
	                for (var i in arr) {
	                    res.push(new UAParser(arr[i]).getResult());
	                }
	                process.stdout.write(JSON.stringify(res, null, 2) + '\n');
	            };
	            if (process.stdin.isTTY) {
	                // via args
	                jsonize(process.argv.slice(2));
	            } else {
	                // via pipe
	                var str = '';
	                process.stdin.on('readable', function() {
	                    var read = process.stdin.read();
	                    if (read !== null) {
	                        str += read;
	                    }
	                });
	                process.stdin.on('end', function () {
	                    jsonize(str.replace(/\n$/, '').split('\n'));
	                });
	            }
	        }
	        */
	        exports.UAParser = UAParser;
	    } else {
	        // requirejs env (optional)
	        if ("function" === FUNC_TYPE && __webpack_require__(1579)) {
	            !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	                return UAParser;
	            }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	        } else if (window) {
	            // browser env
	            window.UAParser = UAParser;
	        }
	    }
	
	    // jQuery/Zepto specific (optional)
	    // Note:
	    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
	    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
	    //   and we should catch that.
	    var $ = window && (window.jQuery || window.Zepto);
	    if (typeof $ !== UNDEF_TYPE) {
	        var parser = new UAParser();
	        $.ua = parser.getResult();
	        $.ua.get = function () {
	            return parser.getUA();
	        };
	        $.ua.set = function (uastring) {
	            parser.setUA(uastring);
	            var result = parser.getResult();
	            for (var prop in result) {
	                $.ua[prop] = result[prop];
	            }
	        };
	    }
	
	})(typeof window === 'object' ? window : this);


/***/ },
/* 1547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createUncontrollable;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(35);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utils = __webpack_require__(1548);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function createUncontrollable(mixin, set) {
	
	  return uncontrollable;
	
	  function uncontrollable(Component, controlledValues) {
	    var _class, _temp;
	
	    var methods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	    var displayName = Component.displayName || Component.name || 'Component',
	        basePropTypes = utils.getType(Component).propTypes,
	        isCompositeComponent = utils.isReactComponent(Component),
	        controlledProps = Object.keys(controlledValues),
	        propTypes;
	
	    var OMIT_PROPS = ['valueLink', 'checkedLink'].concat(controlledProps.map(utils.defaultKey));
	
	    propTypes = utils.uncontrolledPropTypes(controlledValues, basePropTypes, displayName);
	
	    (0, _invariant2.default)(isCompositeComponent || !methods.length, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', '));
	
	    methods = utils.transform(methods, function (obj, method) {
	      obj[method] = function () {
	        var _refs$inner;
	
	        return (_refs$inner = this.refs.inner)[method].apply(_refs$inner, arguments);
	      };
	    }, {});
	
	    var component = (_temp = _class = function (_React$Component) {
	      _inherits(component, _React$Component);
	
	      function component() {
	        _classCallCheck(this, component);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	      }
	
	      component.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return !mixin.shouldComponentUpdate || mixin.shouldComponentUpdate.apply(this, args);
	      };
	
	      component.prototype.componentWillMount = function componentWillMount() {
	        var _this2 = this;
	
	        var props = this.props;
	
	        this._values = {};
	
	        controlledProps.forEach(function (key) {
	          _this2._values[key] = props[utils.defaultKey(key)];
	        });
	      };
	
	      /**
	       * If a prop switches from controlled to Uncontrolled
	       * reset its value to the defaultValue
	       */
	
	
	      component.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        var _this3 = this;
	
	        var props = this.props;
	
	        if (mixin.componentWillReceiveProps) {
	          mixin.componentWillReceiveProps.call(this, nextProps);
	        }
	
	        controlledProps.forEach(function (key) {
	          if (utils.getValue(nextProps, key) === undefined && utils.getValue(props, key) !== undefined) {
	            _this3._values[key] = nextProps[utils.defaultKey(key)];
	          }
	        });
	      };
	
	      component.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.unmounted = true;
	      };
	
	      component.prototype.getControlledInstance = function getControlledInstance() {
	        return this.refs.inner;
	      };
	
	      component.prototype.render = function render() {
	        var _this4 = this;
	
	        var newProps = {},
	            props = omitProps(this.props);
	
	        utils.each(controlledValues, function (handle, propName) {
	          var linkPropName = utils.getLinkName(propName),
	              prop = _this4.props[propName];
	
	          if (linkPropName && !isProp(_this4.props, propName) && isProp(_this4.props, linkPropName)) {
	            prop = _this4.props[linkPropName].value;
	          }
	
	          newProps[propName] = prop !== undefined ? prop : _this4._values[propName];
	
	          newProps[handle] = setAndNotify.bind(_this4, propName);
	        });
	
	        newProps = _extends({}, props, newProps, {
	          ref: isCompositeComponent ? 'inner' : null
	        });
	
	        return _react2.default.createElement(Component, newProps);
	      };
	
	      return component;
	    }(_react2.default.Component), _class.displayName = 'Uncontrolled(' + displayName + ')', _class.propTypes = propTypes, _temp);
	
	    _extends(component.prototype, methods);
	
	    component.ControlledComponent = Component;
	
	    /**
	     * useful when wrapping a Component and you want to control
	     * everything
	     */
	    component.deferControlTo = function (newComponent) {
	      var additions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var nextMethods = arguments[2];
	
	      return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
	    };
	
	    return component;
	
	    function setAndNotify(propName, value) {
	      var linkName = utils.getLinkName(propName),
	          handler = this.props[controlledValues[propName]];
	
	      if (linkName && isProp(this.props, linkName) && !handler) {
	        handler = this.props[linkName].requestChange;
	      }
	
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      set(this, propName, handler, value, args);
	    }
	
	    function isProp(props, prop) {
	      return props[prop] !== undefined;
	    }
	
	    function omitProps(props) {
	      var result = {};
	
	      utils.each(props, function (value, key) {
	        if (OMIT_PROPS.indexOf(key) === -1) result[key] = value;
	      });
	
	      return result;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.version = undefined;
	exports.uncontrolledPropTypes = uncontrolledPropTypes;
	exports.getType = getType;
	exports.getValue = getValue;
	exports.getLinkName = getLinkName;
	exports.defaultKey = defaultKey;
	exports.chain = chain;
	exports.transform = transform;
	exports.each = each;
	exports.has = has;
	exports.isReactComponent = isReactComponent;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(35);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function readOnlyPropType(handler, name) {
	  return function (props, propName) {
	    if (props[propName] !== undefined) {
	      if (!props[handler]) {
	        return new Error('You have provided a `' + propName + '` prop to ' + '`' + name + '` without an `' + handler + '` handler. This will render a read-only field. ' + 'If the field should be mutable use `' + defaultKey(propName) + '`. Otherwise, set `' + handler + '`');
	      }
	    }
	  };
	}
	
	function uncontrolledPropTypes(controlledValues, basePropTypes, displayName) {
	  var propTypes = {};
	
	  if (false) {
	    transform(controlledValues, function (obj, handler, prop) {
	      (0, _invariant2.default)(typeof handler === 'string' && handler.trim().length, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop);
	
	      obj[prop] = readOnlyPropType(handler, displayName);
	    }, propTypes);
	  }
	
	  return propTypes;
	}
	
	var version = exports.version = _react2.default.version.split('.').map(parseFloat);
	
	function getType(component) {
	  if (version[0] >= 15 || version[0] === 0 && version[1] >= 13) return component;
	
	  return component.type;
	}
	
	function getValue(props, name) {
	  var linkPropName = getLinkName(name);
	
	  if (linkPropName && !isProp(props, name) && isProp(props, linkPropName)) return props[linkPropName].value;
	
	  return props[name];
	}
	
	function isProp(props, prop) {
	  return props[prop] !== undefined;
	}
	
	function getLinkName(name) {
	  return name === 'value' ? 'valueLink' : name === 'checked' ? 'checkedLink' : null;
	}
	
	function defaultKey(key) {
	  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
	}
	
	function chain(thisArg, a, b) {
	  return function chainedFunction() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    a && a.call.apply(a, [thisArg].concat(args));
	    b && b.call.apply(b, [thisArg].concat(args));
	  };
	}
	
	function transform(obj, cb, seed) {
	  each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
	  return seed;
	}
	
	function each(obj, cb, thisArg) {
	  if (Array.isArray(obj)) return obj.forEach(cb, thisArg);
	
	  for (var key in obj) {
	    if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
	  }
	}
	
	function has(o, k) {
	  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
	}
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	function isReactComponent(component) {
	  return !!(component && component.prototype && component.prototype.isReactComponent);
	}

/***/ },
/* 1549 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d38e244a0c222dc302ad6e39e8b68f7f.png";

/***/ },
/* 1550 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a8aa3f8be0931ab064008f81df7ca4be.png";

/***/ },
/* 1551 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bcbbe5786be093919bea4ae986379d1a.png";

/***/ },
/* 1552 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjEiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MSA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzUxXzI3MzQpIj4KPHBhdGggZD0iTTI5IDYwQzIxLjM4NiA2MCAxNC4yMzEgNTcuMDM2IDguODQ2IDUxLjY1NEMzLjQ2MSA0Ni4yNzIgMC41IDM5LjExNCAwLjUgMzEuNTAzQzAuNSAyMy44ODkgMy40NjQgMTYuNzM0IDguODQ2IDExLjM0OUMxNC4yMjggNS45NjQgMjEuMzg2IDMgMjkgM0MzNi42MTQgMyA0My43NjkgNS45NjQgNDkuMTU0IDExLjM0OUM1NC41MzkgMTYuNzM0IDU3LjUgMjMuODg5IDU3LjUgMzEuNTAzQzU3LjUgMzkuMTE3IDU0LjUzNiA0Ni4yNzIgNDkuMTU0IDUxLjY1NEM0My43NzIgNTcuMDM2IDM2LjYxNCA2MCAyOSA2MFpNMjkgNkMxNC45MzkgNiAzLjUgMTcuNDM5IDMuNSAzMS41QzMuNSA0NS41NjEgMTQuOTM5IDU3IDI5IDU3QzQzLjA2MSA1NyA1NC41IDQ1LjU2MSA1NC41IDMxLjVDNTQuNSAxNy40MzkgNDMuMDYxIDYgMjkgNloiIGZpbGw9IiMwNDU2N0QiLz4KPHBhdGggZD0iTTIzIDQzLjQ5OTlDMjIuNjE2IDQzLjQ5OTkgMjIuMjMyIDQzLjM1MjkgMjEuOTM4IDQzLjA2MTlMMTIuOTM4IDM0LjA2MTlDMTIuMzUzIDMzLjQ3NjkgMTIuMzUzIDMyLjUyNTkgMTIuOTM4IDMxLjk0MDlDMTMuNTIzIDMxLjM1NTkgMTQuNDc0IDMxLjM1NTkgMTUuMDU5IDMxLjk0MDlMMjIuOTk3IDM5Ljg3ODlMNDIuOTM1IDE5Ljk0MDlDNDMuNTIgMTkuMzU1OSA0NC40NzEgMTkuMzU1OSA0NS4wNTYgMTkuOTQwOUM0NS42NDEgMjAuNTI1OSA0NS42NDEgMjEuNDc2OSA0NS4wNTYgMjIuMDYxOUwyNC4wNTYgNDMuMDYxOUMyMy43NjIgNDMuMzU1OSAyMy4zNzggNDMuNDk5OSAyMi45OTQgNDMuNDk5OUgyM1oiIGZpbGw9IiMwNDU2N0QiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF81MV8yNzM0Ij4KPHJlY3Qgd2lkdGg9IjYwIiBoZWlnaHQ9IjYwIiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC41KSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo="

/***/ },
/* 1553 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAyMCAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuNSAxLjVMMTAgMTBMMTQuMjUgNS43NUwxOC41IDEuNSIgc3Ryb2tlPSIjMDA1ODdDIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"

/***/ },
/* 1554 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0ZWQgYnkgSWNvTW9vbi5pbyAtLT4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KPHBhdGggZD0iTTUuNSAxNy41Yy0wLjEyOCAwLTAuMjU2LTAuMDQ5LTAuMzU0LTAuMTQ2bC01LTVjLTAuMTk1LTAuMTk1LTAuMTk1LTAuNTEyIDAtMC43MDdzMC41MTItMC4xOTUgMC43MDcgMGw0LjY0NiA0LjY0NiAxMy42NDYtMTMuNjQ2YzAuMTk1LTAuMTk1IDAuNTEyLTAuMTk1IDAuNzA3IDBzMC4xOTUgMC41MTIgMCAwLjcwN2wtMTQgMTRjLTAuMDk4IDAuMDk4LTAuMjI2IDAuMTQ2LTAuMzU0IDAuMTQ2eiIgZmlsbD0iIzAwMDAwMCI+PC9wYXRoPgo8L3N2Zz4K"

/***/ },
/* 1555 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0ZWQgYnkgSWNvTW9vbi5pbyAtLT4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KPHBhdGggZD0iTTAgNmMwLTAuMTI4IDAuMDQ5LTAuMjU2IDAuMTQ2LTAuMzU0IDAuMTk1LTAuMTk1IDAuNTEyLTAuMTk1IDAuNzA3IDBsOC42NDYgOC42NDYgOC42NDYtOC42NDZjMC4xOTUtMC4xOTUgMC41MTItMC4xOTUgMC43MDcgMHMwLjE5NSAwLjUxMiAwIDAuNzA3bC05IDljLTAuMTk1IDAuMTk1LTAuNTEyIDAuMTk1LTAuNzA3IDBsLTktOWMtMC4wOTgtMC4wOTgtMC4xNDYtMC4yMjYtMC4xNDYtMC4zNTR6IiBmaWxsPSIjMDAwMDAwIj48L3BhdGg+Cjwvc3ZnPgo="

/***/ },
/* 1556 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0ZWQgYnkgSWNvTW9vbi5pbyAtLT4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KPHBhdGggZD0iTTE0IDIwYzAuMTI4IDAgMC4yNTYtMC4wNDkgMC4zNTQtMC4xNDYgMC4xOTUtMC4xOTUgMC4xOTUtMC41MTIgMC0wLjcwN2wtOC42NDYtOC42NDYgOC42NDYtOC42NDZjMC4xOTUtMC4xOTUgMC4xOTUtMC41MTIgMC0wLjcwN3MtMC41MTItMC4xOTUtMC43MDcgMGwtOSA5Yy0wLjE5NSAwLjE5NS0wLjE5NSAwLjUxMiAwIDAuNzA3bDkgOWMwLjA5OCAwLjA5OCAwLjIyNiAwLjE0NiAwLjM1NCAwLjE0NnoiIGZpbGw9IiMwMDAwMDAiPjwvcGF0aD4KPC9zdmc+Cg=="

/***/ },
/* 1557 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0ZWQgYnkgSWNvTW9vbi5pbyAtLT4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KPHBhdGggZD0iTTUgMjBjLTAuMTI4IDAtMC4yNTYtMC4wNDktMC4zNTQtMC4xNDYtMC4xOTUtMC4xOTUtMC4xOTUtMC41MTIgMC0wLjcwN2w4LjY0Ni04LjY0Ni04LjY0Ni04LjY0NmMtMC4xOTUtMC4xOTUtMC4xOTUtMC41MTIgMC0wLjcwN3MwLjUxMi0wLjE5NSAwLjcwNyAwbDkgOWMwLjE5NSAwLjE5NSAwLjE5NSAwLjUxMiAwIDAuNzA3bC05IDljLTAuMDk4IDAuMDk4LTAuMjI2IDAuMTQ2LTAuMzU0IDAuMTQ2eiIgZmlsbD0iIzAwMDAwMCI+PC9wYXRoPgo8L3N2Zz4K"

/***/ },
/* 1558 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0ZWQgYnkgSWNvTW9vbi5pbyAtLT4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KPHBhdGggZD0iTTAgMTVjMCAwLjEyOCAwLjA0OSAwLjI1NiAwLjE0NiAwLjM1NCAwLjE5NSAwLjE5NSAwLjUxMiAwLjE5NSAwLjcwNyAwbDguNjQ2LTguNjQ2IDguNjQ2IDguNjQ2YzAuMTk1IDAuMTk1IDAuNTEyIDAuMTk1IDAuNzA3IDBzMC4xOTUtMC41MTIgMC0wLjcwN2wtOS05Yy0wLjE5NS0wLjE5NS0wLjUxMi0wLjE5NS0wLjcwNyAwbC05IDljLTAuMDk4IDAuMDk4LTAuMTQ2IDAuMjI2LTAuMTQ2IDAuMzU0eiIgZmlsbD0iIzAwMDAwMCI+PC9wYXRoPgo8L3N2Zz4K"

/***/ },
/* 1559 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0ZWQgYnkgSWNvTW9vbi5pbyAtLT4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KPHBhdGggZD0iTTE2LjAwNiAxNmgtMTAuMDA2Yy0zLjMwOCAwLTYtMi42OTItNi02czIuNjkyLTYgNi02YzEuNjAyIDAgMy4xMzcgMC42NDMgNC4yNiAxLjc3NSAwLjA4OC0wLjE5NCAwLjE5Ni0wLjM4IDAuMzI1LTAuNTU1IDAuNTY0LTAuNzY0IDEuNDY3LTEuMjIgMi40MTUtMS4yMiAxLjY1NCAwIDMgMS4zNDYgMyAzIDAgMC4zNTEtMC4wNjEgMC42OTQtMC4xNzggMS4wMTcgMC4wNjEtMC4wMDMgMC4xMjItMC4wMDQgMC4xODQtMC4wMDQgMi4yMDIgMCAzLjk5NCAxLjc5MiAzLjk5NCAzLjk5NHMtMS43OTIgMy45OTQtMy45OTQgMy45OTR6TTYgNWMtMi43NTcgMC01IDIuMjQzLTUgNXMyLjI0MyA1IDUgNWgxMC4wMDZjMS42NTEgMCAyLjk5NC0xLjM0MyAyLjk5NC0yLjk5NHMtMS4zNDMtMi45OTQtMi45OTQtMi45OTRjLTAuMzU0IDAtMC42OTkgMC4wNjEtMS4wMjYgMC4xOC0wLjIxOCAwLjA4MC0wLjQ2Mi0wLjAwMS0wLjU5LTAuMTk1cy0wLjEwNC0wLjQ1IDAuMDU2LTAuNjE5YzAuMzU3LTAuMzc2IDAuNTU0LTAuODY1IDAuNTU0LTEuMzc5IDAtMS4xMDMtMC44OTctMi0yLTItMC42NDIgMC0xLjIyOSAwLjI5Ny0xLjYxIDAuODE0LTAuMjMgMC4zMTItMC4zNjUgMC42NzgtMC4zODggMS4wNTctMC4wMTMgMC4yMTItMC4xNTkgMC4zOTMtMC4zNjMgMC40NXMtMC40MjMtMC4wMjAtMC41NDUtMC4xOTNjLTAuMTEtMC4xNTYtMC4yMjktMC4zMDctMC4zNTQtMC40NDctMC45NDktMS4wNjgtMi4zMTItMS42ODEtMy43NC0xLjY4MXoiIGZpbGw9IiMwMDAwMDAiPjwvcGF0aD4KPC9zdmc+Cg=="

/***/ },
/* 1560 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0ZWQgYnkgSWNvTW9vbi5pbyAtLT4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KPHBhdGggZD0iTTE4LjUgM2gtMTdjLTAuODI3IDAtMS41IDAuNjczLTEuNSAxLjV2MTFjMCAwLjgyNyAwLjY3MyAxLjUgMS41IDEuNWgxN2MwLjgyNyAwIDEuNS0wLjY3MyAxLjUtMS41di0xMWMwLTAuODI3LTAuNjczLTEuNS0xLjUtMS41ek0xLjUgNGgxN2MwLjI3NiAwIDAuNSAwLjIyNCAwLjUgMC41djAuNWgtMTh2LTAuNWMwLTAuMjc2IDAuMjI0LTAuNSAwLjUtMC41ek0xOSA2djNoLTE4di0zaDE4ek0xOC41IDE2aC0xN2MtMC4yNzYgMC0wLjUtMC4yMjQtMC41LTAuNXYtNS41aDE4djUuNWMwIDAuMjc2LTAuMjI0IDAuNS0wLjUgMC41eiIgZmlsbD0iIzAwMDAwMCI+PC9wYXRoPgo8cGF0aCBkPSJNMTcgMTRoMXYxaC0xdi0xeiIgZmlsbD0iIzAwMDAwMCI+PC9wYXRoPgo8cGF0aCBkPSJNMTMgMTRoM3YxaC0zdi0xeiIgZmlsbD0iIzAwMDAwMCI+PC9wYXRoPgo8cGF0aCBkPSJNMTAgMTRoMnYxaC0ydi0xeiIgZmlsbD0iIzAwMDAwMCI+PC9wYXRoPgo8L3N2Zz4K"

/***/ },
/* 1561 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0ZWQgYnkgSWNvTW9vbi5pbyAtLT4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KPHBhdGggZD0iTTEwLjcwNyAxMC41bDguNjQ2LTguNjQ2YzAuMTk1LTAuMTk1IDAuMTk1LTAuNTEyIDAtMC43MDdzLTAuNTEyLTAuMTk1LTAuNzA3IDBsLTguNjQ2IDguNjQ2LTguNjQ2LTguNjQ2Yy0wLjE5NS0wLjE5NS0wLjUxMi0wLjE5NS0wLjcwNyAwcy0wLjE5NSAwLjUxMiAwIDAuNzA3bDguNjQ2IDguNjQ2LTguNjQ2IDguNjQ2Yy0wLjE5NSAwLjE5NS0wLjE5NSAwLjUxMiAwIDAuNzA3IDAuMDk4IDAuMDk4IDAuMjI2IDAuMTQ2IDAuMzU0IDAuMTQ2czAuMjU2LTAuMDQ5IDAuMzU0LTAuMTQ2bDguNjQ2LTguNjQ2IDguNjQ2IDguNjQ2YzAuMDk4IDAuMDk4IDAuMjI2IDAuMTQ2IDAuMzU0IDAuMTQ2czAuMjU2LTAuMDQ5IDAuMzU0LTAuMTQ2YzAuMTk1LTAuMTk1IDAuMTk1LTAuNTEyIDAtMC43MDdsLTguNjQ2LTguNjQ2eiIgZmlsbD0iIzAwMDAwMCI+PC9wYXRoPgo8L3N2Zz4K"

/***/ },
/* 1562 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0ZWQgYnkgSWNvTW9vbi5pbyAtLT4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KPHBhdGggZD0iTTE3Ljg1NCA1LjY0NmwtNC41LTQuNWMtMC4wOTQtMC4wOTQtMC4yMjEtMC4xNDYtMC4zNTQtMC4xNDZoLTkuNWMtMC44MjcgMC0xLjUgMC42NzMtMS41IDEuNXYxNmMwIDAuODI3IDAuNjczIDEuNSAxLjUgMS41aDEzYzAuODI3IDAgMS41LTAuNjczIDEuNS0xLjV2LTEyLjVjMC0wLjEzMy0wLjA1My0wLjI2LTAuMTQ2LTAuMzU0ek0xNi43OTMgNmgtMy4yOTNjLTAuMjc2IDAtMC41LTAuMjI0LTAuNS0wLjV2LTMuMjkzbDMuNzkzIDMuNzkzek0xNi41IDE5aC0xM2MtMC4yNzYgMC0wLjUtMC4yMjQtMC41LTAuNXYtMTZjMC0wLjI3NiAwLjIyNC0wLjUgMC41LTAuNWg4LjV2My41YzAgMC44MjcgMC42NzMgMS41IDEuNSAxLjVoMy41djExLjVjMCAwLjI3Ni0wLjIyNCAwLjUtMC41IDAuNXoiIGZpbGw9IiMwMDAwMDAiPjwvcGF0aD4KPHBhdGggZD0iTTEyIDEyLjA4NnYtMS4wODZjMC0xLjEwMy0wLjg5Ny0yLTItMnMtMiAwLjg5Ny0yIDJ2MS4wODZjLTAuNTgyIDAuMjA2LTEgMC43NjItMSAxLjQxNHYyYzAgMC44MjcgMC42NzMgMS41IDEuNSAxLjVoM2MwLjgyNyAwIDEuNS0wLjY3MyAxLjUtMS41di0yYzAtMC42NTItMC40MTgtMS4yMDgtMS0xLjQxNHpNMTAgMTBjMC41NTEgMCAxIDAuNDQ5IDEgMXYxaC0ydi0xYzAtMC41NTEgMC40NDktMSAxLTF6TTEyIDE1LjVjMCAwLjI3Ni0wLjIyNCAwLjUtMC41IDAuNWgtM2MtMC4yNzYgMC0wLjUtMC4yMjQtMC41LTAuNXYtMmMwLTAuMjc2IDAuMjI0LTAuNSAwLjUtMC41aDNjMC4yNzYgMCAwLjUgMC4yMjQgMC41IDAuNXYyeiIgZmlsbD0iIzAwMDAwMCI+PC9wYXRoPgo8L3N2Zz4K"

/***/ },
/* 1563 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0ZWQgYnkgSWNvTW9vbi5pbyAtLT4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KPHBhdGggZD0iTTE3Ljg1NCA1LjY0NmwtNC41LTQuNWMtMC4wOTQtMC4wOTQtMC4yMjEtMC4xNDYtMC4zNTQtMC4xNDZoLTkuNWMtMC44MjcgMC0xLjUgMC42NzMtMS41IDEuNXYxNmMwIDAuODI3IDAuNjczIDEuNSAxLjUgMS41aDEzYzAuODI3IDAgMS41LTAuNjczIDEuNS0xLjV2LTEyLjVjMC0wLjEzMy0wLjA1My0wLjI2LTAuMTQ2LTAuMzU0ek0xNi43OTMgNmgtMy4yOTNjLTAuMjc2IDAtMC41LTAuMjI0LTAuNS0wLjV2LTMuMjkzbDMuNzkzIDMuNzkzek0xNi41IDE5aC0xM2MtMC4yNzYgMC0wLjUtMC4yMjQtMC41LTAuNXYtMTZjMC0wLjI3NiAwLjIyNC0wLjUgMC41LTAuNWg4LjV2My41YzAgMC44MjcgMC42NzMgMS41IDEuNSAxLjVoMy41djExLjVjMCAwLjI3Ni0wLjIyNCAwLjUtMC41IDAuNXoiIGZpbGw9IiMwMDAwMDAiPjwvcGF0aD4KPHBhdGggZD0iTTExLjUgMTNoLTIuNXYtMi41YzAtMC4yNzYtMC4yMjQtMC41LTAuNS0wLjVzLTAuNSAwLjIyNC0wLjUgMC41djIuNWgtMi41Yy0wLjI3NiAwLTAuNSAwLjIyNC0wLjUgMC41czAuMjI0IDAuNSAwLjUgMC41aDIuNXYyLjVjMCAwLjI3NiAwLjIyNCAwLjUgMC41IDAuNXMwLjUtMC4yMjQgMC41LTAuNXYtMi41aDIuNWMwLjI3NiAwIDAuNS0wLjIyNCAwLjUtMC41cy0wLjIyNC0wLjUtMC41LTAuNXoiIGZpbGw9IiMwMDAwMDAiPjwvcGF0aD4KPC9zdmc+Cg=="

/***/ },
/* 1564 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 1565 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0ZWQgYnkgSWNvTW9vbi5pbyAtLT4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KPHBhdGggZD0iTTE2LjUgMjBoLTEzYy0wLjgyNyAwLTEuNS0wLjY3My0xLjUtMS41di0xNmMwLTAuODI3IDAuNjczLTEuNSAxLjUtMS41aDEzYzAuODI3IDAgMS41IDAuNjczIDEuNSAxLjV2MTZjMCAwLjgyNy0wLjY3MyAxLjUtMS41IDEuNXpNMy41IDJjLTAuMjc2IDAtMC41IDAuMjI0LTAuNSAwLjV2MTZjMCAwLjI3NiAwLjIyNCAwLjUgMC41IDAuNWgxM2MwLjI3NiAwIDAuNS0wLjIyNCAwLjUtMC41di0xNmMwLTAuMjc2LTAuMjI0LTAuNS0wLjUtMC41aC0xM3oiIGZpbGw9IiMwMDAwMDAiPjwvcGF0aD4KPHBhdGggZD0iTTEyLjUgNWgtN2MtMC4yNzYgMC0wLjUtMC4yMjQtMC41LTAuNXMwLjIyNC0wLjUgMC41LTAuNWg3YzAuMjc2IDAgMC41IDAuMjI0IDAuNSAwLjVzLTAuMjI0IDAuNS0wLjUgMC41eiIgZmlsbD0iIzAwMDAwMCI+PC9wYXRoPgo8cGF0aCBkPSJNMTQuNSA3aC05Yy0wLjI3NiAwLTAuNS0wLjIyNC0wLjUtMC41czAuMjI0LTAuNSAwLjUtMC41aDljMC4yNzYgMCAwLjUgMC4yMjQgMC41IDAuNXMtMC4yMjQgMC41LTAuNSAwLjV6IiBmaWxsPSIjMDAwMDAwIj48L3BhdGg+CjxwYXRoIGQ9Ik0xNC41IDloLTljLTAuMjc2IDAtMC41LTAuMjI0LTAuNS0wLjVzMC4yMjQtMC41IDAuNS0wLjVoOWMwLjI3NiAwIDAuNSAwLjIyNCAwLjUgMC41cy0wLjIyNCAwLjUtMC41IDAuNXoiIGZpbGw9IiMwMDAwMDAiPjwvcGF0aD4KPHBhdGggZD0iTTEwLjUgMTFoLTVjLTAuMjc2IDAtMC41LTAuMjI0LTAuNS0wLjVzMC4yMjQtMC41IDAuNS0wLjVoNWMwLjI3NiAwIDAuNSAwLjIyNCAwLjUgMC41cy0wLjIyNCAwLjUtMC41IDAuNXoiIGZpbGw9IiMwMDAwMDAiPjwvcGF0aD4KPHBhdGggZD0iTTE0LjUgMTVoLTljLTAuMjc2IDAtMC41LTAuMjI0LTAuNS0wLjVzMC4yMjQtMC41IDAuNS0wLjVoOWMwLjI3NiAwIDAuNSAwLjIyNCAwLjUgMC41cy0wLjIyNCAwLjUtMC41IDAuNXoiIGZpbGw9IiMwMDAwMDAiPjwvcGF0aD4KPHBhdGggZD0iTTEyLjUgMTdoLTdjLTAuMjc2IDAtMC41LTAuMjI0LTAuNS0wLjVzMC4yMjQtMC41IDAuNS0wLjVoN2MwLjI3NiAwIDAuNSAwLjIyNCAwLjUgMC41cy0wLjIyNCAwLjUtMC41IDAuNXoiIGZpbGw9IiMwMDAwMDAiPjwvcGF0aD4KPC9zdmc+Cg=="

/***/ },
/* 1566 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48IS0tISBGb250IEF3ZXNvbWUgUHJvIDYuMi4xIGJ5IEBmb250YXdlc29tZSAtIGh0dHBzOi8vZm9udGF3ZXNvbWUuY29tIExpY2Vuc2UgLSBodHRwczovL2ZvbnRhd2Vzb21lLmNvbS9saWNlbnNlIChDb21tZXJjaWFsIExpY2Vuc2UpIENvcHlyaWdodCAyMDIyIEZvbnRpY29ucywgSW5jLiAtLT48cGF0aCBkPSJNMTgzIDI5NWwtODEuMzggODEuMzhsLTQ3LjAzLTQ3LjAzYy02LjEyNy02LjExNy0xNC4yOS05LjM2Ny0yMi42My05LjM2N2MtNC4xMTcgMC04LjI3OSAuODA4Ni0xMi4yNSAyLjQzYy0xMS45NyA0Ljk1My0xOS43NSAxNi42My0xOS43NSAyOS41NnYxMzUuMUMuMDAxMyA1MDEuMyAxMC43NSA1MTIgMjQgNTEyaDEzNmMxMi45NCAwIDI0LjYzLTcuNzk3IDI5LjU2LTE5Ljc1YzQuOTY5LTExLjk3IDIuMjE5LTI1LjcyLTYuOTM4LTM0Ljg3bC00Ny4wMy00Ny4wM2w4MS4zOC04MS4zOGM5LjM3NS05LjM3NSA5LjM3NS0yNC41NiAwLTMzLjk0UzE5Mi40IDI4NS43IDE4MyAyOTV6TTQ4Ny4xIDBoLTEzNmMtMTIuOTQgMC0yNC42MyA3Ljc5Ny0yOS41NiAxOS43NWMtNC45NjkgMTEuOTctMi4yMTkgMjUuNzIgNi45MzggMzQuODdsNDcuMDQgNDcuMDNsLTgxLjM4IDgxLjM4Yy05LjM3NSA5LjM3NS05LjM3NSAyNC41NiAwIDMzLjk0czI0LjU2IDkuMzc1IDMzLjk0IDBsODEuMzgtODEuMzhsNDcuMDMgNDcuMDNjNi4xMjcgNi4xMTcgMTQuMyA5LjM1IDIyLjYzIDkuMzVjNC4xMTcgMCA4LjI3NS0uNzkxOCAxMi4yNC0yLjQxM0M1MDQuMiAxODQuNiA1MTIgMTcyLjkgNTEyIDE1OS4xVjIzLjFDNTEyIDEwLjc1IDUwMS4zIDAgNDg3LjEgMHoiLz48L3N2Zz4="

/***/ },
/* 1567 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 1568 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0ZWQgYnkgSWNvTW9vbi5pbyAtLT4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KPHBhdGggZD0iTTkuNSAxOWMtMC4wODQgMC0wLjE2Ny0wLjAyMS0wLjI0My0wLjA2My0wLjA5NC0wLjA1Mi0yLjMyNi0xLjMwMS00LjU5Mi0zLjM0Ny0xLjM0MS0xLjIxLTIuNDExLTIuNDQ4LTMuMTgzLTMuNjgtMC45ODQtMS41NzEtMS40ODItMy4xMzktMS40ODItNC42NiAwLTIuODk1IDIuMzU1LTUuMjUgNS4yNS01LjI1IDAuOTggMCAyLjAyMSAwLjM2NyAyLjkzMSAxLjAzNCAwLjUzMiAwLjM5IDAuOTg1IDAuODYgMS4zMTkgMS4zNTkgMC4zMzQtMC40OTkgMC43ODctMC45NjkgMS4zMTktMS4zNTkgMC45MS0wLjY2NyAxLjk1MS0xLjAzNCAyLjkzMS0xLjAzNCAyLjg5NSAwIDUuMjUgMi4zNTUgNS4yNSA1LjI1IDAgMS41MjEtMC40OTkgMy4wODktMS40ODIgNC42Ni0wLjc3MSAxLjIzMi0xLjg0MiAyLjQ3LTMuMTgyIDMuNjgtMi4yNjYgMi4wNDYtNC40OTggMy4yOTUtNC41OTIgMy4zNDctMC4wNzYgMC4wNDItMC4xNTkgMC4wNjMtMC4yNDMgMC4wNjN6TTUuMjUgM2MtMi4zNDMgMC00LjI1IDEuOTA3LTQuMjUgNC4yNSAwIDMuMDQwIDIuMzUgNS44MDIgNC4zMjEgNy41ODUgMS43NiAxLjU5MiAzLjU0NCAyLjcwOCA0LjE3OSAzLjA4NyAwLjYzNS0wLjM3OSAyLjQxOS0xLjQ5NSA0LjE3OS0zLjA4NyAxLjk3MS0xLjc4MiA0LjMyMS00LjU0NSA0LjMyMS03LjU4NSAwLTIuMzQzLTEuOTA3LTQuMjUtNC4yNS00LjI1LTEuNzAzIDAtMy4zNTcgMS40MDEtMy43NzYgMi42NTgtMC4wNjggMC4yMDQtMC4yNTkgMC4zNDItMC40NzQgMC4zNDJzLTAuNDA2LTAuMTM4LTAuNDc0LTAuMzQyYy0wLjQxOS0xLjI1Ny0yLjA3My0yLjY1OC0zLjc3Ni0yLjY1OHoiIGZpbGw9IiMwMDAwMDAiPjwvcGF0aD4KPC9zdmc+Cg=="

/***/ },
/* 1569 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 1570 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 1571 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 1572 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0ZWQgYnkgSWNvTW9vbi5pbyAtLT4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KPHBhdGggZD0iTTkuNSAxNGMtMS45MyAwLTMuNS0xLjU3LTMuNS0zLjVzMS41Ny0zLjUgMy41LTMuNSAzLjUgMS41NyAzLjUgMy41LTEuNTcgMy41LTMuNSAzLjV6TTkuNSA4Yy0xLjM3OCAwLTIuNSAxLjEyMi0yLjUgMi41czEuMTIyIDIuNSAyLjUgMi41IDIuNS0xLjEyMiAyLjUtMi41LTEuMTIyLTIuNS0yLjUtMi41eiIgZmlsbD0iIzAwMDAwMCI+PC9wYXRoPgo8cGF0aCBkPSJNMy41IDExaC0zYy0wLjI3NiAwLTAuNS0wLjIyNC0wLjUtMC41czAuMjI0LTAuNSAwLjUtMC41aDIuNTE5YzAuMjU2LTMuMzUxIDMuMDY1LTYgNi40ODEtNiAyLjE4MiAwIDQuMjA3IDEuMDg2IDUuNDE2IDIuOTA2IDAuMTUzIDAuMjMgMC4wOTAgMC41NC0wLjE0IDAuNjkzcy0wLjU0IDAuMDkwLTAuNjkzLTAuMTRjLTEuMDI0LTEuNTQtMi43MzctMi40NTktNC41ODQtMi40NTktMy4wMzMgMC01LjUgMi40NjctNS41IDUuNSAwIDAuMjc2LTAuMjI0IDAuNS0wLjUgMC41eiIgZmlsbD0iIzAwMDAwMCI+PC9wYXRoPgo8cGF0aCBkPSJNOS41IDE3Yy0yLjE4MiAwLTQuMjA3LTEuMDg2LTUuNDE2LTIuOTA2LTAuMTUzLTAuMjMtMC4wOTAtMC41NCAwLjE0LTAuNjkzczAuNTQtMC4wOTAgMC42OTMgMC4xNGMxLjAyNCAxLjU0IDIuNzM3IDIuNDU5IDQuNTg0IDIuNDU5IDMuMDMzIDAgNS41LTIuNDY3IDUuNS01LjUgMC0wLjI3NiAwLjIyNC0wLjUgMC41LTAuNWgzYzAuMjc2IDAgMC41IDAuMjI0IDAuNSAwLjVzLTAuMjI0IDAuNS0wLjUgMC41aC0yLjUxOWMtMC4yNTYgMy4zNTEtMy4wNjUgNi02LjQ4MSA2eiIgZmlsbD0iIzAwMDAwMCI+PC9wYXRoPgo8L3N2Zz4K"

/***/ },
/* 1573 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48IS0tISBGb250IEF3ZXNvbWUgUHJvIDYuMi4xIGJ5IEBmb250YXdlc29tZSAtIGh0dHBzOi8vZm9udGF3ZXNvbWUuY29tIExpY2Vuc2UgLSBodHRwczovL2ZvbnRhd2Vzb21lLmNvbS9saWNlbnNlIChDb21tZXJjaWFsIExpY2Vuc2UpIENvcHlyaWdodCAyMDIyIEZvbnRpY29ucywgSW5jLiAtLT48cGF0aCBkPSJNNDg4LjEgMjMuMDNjLTkuMzc1LTkuMzc1LTI0LjU2LTkuMzc1LTMzLjk0IDBsLTgxLjM4IDgxLjM4bC00Ny4wMy00Ny4wM2MtNi4xMjctNi4xMTctMTQuMy05LjM1LTIyLjYzLTkuMzVjLTQuMTE3IDAtOC4yNzUgLjc5MTgtMTIuMjQgMi40MTNjLTExLjk3IDQuOTUzLTE5Ljc1IDE2LjYzLTE5Ljc1IDI5LjU2djEzNS4xYzAgMTMuMjUgMTAuNzQgMjMuMSAyNCAyMy4xaDEzNmMxMi45NCAwIDI0LjYzLTcuNzk3IDI5LjU2LTE5Ljc1YzQuOTY5LTExLjk3IDIuMjE5LTI1LjcyLTYuOTM4LTM0Ljg3bC00Ny4wNC00Ny4wM2w4MS4zOC04MS4zOEM0OTguMyA0Ny41OSA0OTguMyAzMi40MSA0ODguMSAyMy4wM3pNMjE1LjEgMjcyaC0xMzZjLTEyLjk0IDAtMjQuNjMgNy43OTctMjkuNTYgMTkuNzVDNDUuNDcgMzAzLjcgNDguMjIgMzE3LjUgNTcuMzcgMzI2LjZsNDcuMDQgNDcuMDNsLTgxLjM4IDgxLjM4Yy05LjM3NSA5LjM3NS05LjM3NSAyNC41NiAwIDMzLjk0czI0LjU2IDkuMzc1IDMzLjk0IDBsODEuMzgtODEuMzhsNDcuMDMgNDcuMDNjNi4xMjcgNi4xMTcgMTQuMjkgOS4zNjcgMjIuNjMgOS4zNjdjNC4xMTcgMCA4LjI3OS0uODA4NiAxMi4yNS0yLjQzYzExLjk3LTQuOTUzIDE5Ljc1LTE2LjYzIDE5Ljc1LTI5LjU2VjI5NkMyMzkuMSAyODIuNyAyMjkuMyAyNzIgMjE1LjEgMjcyeiIvPjwvc3ZnPg=="

/***/ },
/* 1574 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 1575 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "src/images/logos/logo-invoice.svg";

/***/ },
/* 1576 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },
/* 1577 */
/***/ function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ },
/* 1578 */
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 1579 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 1580 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 1581 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var forOf = __webpack_require__(__webpack_module_template_argument_0__);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ },
/* 1582 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(__webpack_module_template_argument_0__);
	var toLength = __webpack_require__(__webpack_module_template_argument_1__);
	var toAbsoluteIndex = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 1583 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(__webpack_module_template_argument_0__);
	var IObject = __webpack_require__(__webpack_module_template_argument_1__);
	var toObject = __webpack_require__(__webpack_module_template_argument_2__);
	var toLength = __webpack_require__(__webpack_module_template_argument_3__);
	var asc = __webpack_require__(__webpack_module_template_argument_4__);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ },
/* 1584 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var isArray = __webpack_require__(__webpack_module_template_argument_1__);
	var SPECIES = __webpack_require__(__webpack_module_template_argument_2__)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ },
/* 1585 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(__webpack_module_template_argument_0__);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ },
/* 1586 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	var TAG = __webpack_require__(__webpack_module_template_argument_1__)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 1587 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__, __webpack_module_template_argument_10__, __webpack_module_template_argument_11__) {

	'use strict';
	var dP = __webpack_require__(__webpack_module_template_argument_0__).f;
	var create = __webpack_require__(__webpack_module_template_argument_1__);
	var redefineAll = __webpack_require__(__webpack_module_template_argument_2__);
	var ctx = __webpack_require__(__webpack_module_template_argument_3__);
	var anInstance = __webpack_require__(__webpack_module_template_argument_4__);
	var forOf = __webpack_require__(__webpack_module_template_argument_5__);
	var $iterDefine = __webpack_require__(__webpack_module_template_argument_6__);
	var step = __webpack_require__(__webpack_module_template_argument_7__);
	var setSpecies = __webpack_require__(__webpack_module_template_argument_8__);
	var DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_9__);
	var fastKey = __webpack_require__(__webpack_module_template_argument_10__).fastKey;
	var validate = __webpack_require__(__webpack_module_template_argument_11__);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ },
/* 1588 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(__webpack_module_template_argument_0__);
	var from = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ },
/* 1589 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	var $defineProperty = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 1590 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 1591 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(__webpack_module_template_argument_0__)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 1592 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var document = __webpack_require__(__webpack_module_template_argument_1__).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 1593 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(__webpack_module_template_argument_0__);
	var gOPS = __webpack_require__(__webpack_module_template_argument_1__);
	var pIE = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 1594 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var ctx = __webpack_require__(__webpack_module_template_argument_0__);
	var call = __webpack_require__(__webpack_module_template_argument_1__);
	var isArrayIter = __webpack_require__(__webpack_module_template_argument_2__);
	var anObject = __webpack_require__(__webpack_module_template_argument_3__);
	var toLength = __webpack_require__(__webpack_module_template_argument_4__);
	var getIterFn = __webpack_require__(__webpack_module_template_argument_5__);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ },
/* 1595 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var dP = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = __webpack_require__(__webpack_module_template_argument_2__) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 1596 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var document = __webpack_require__(__webpack_module_template_argument_0__).document;
	module.exports = document && document.documentElement;


/***/ },
/* 1597 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	module.exports = !__webpack_require__(__webpack_module_template_argument_0__) && !__webpack_require__(__webpack_module_template_argument_1__)(function () {
	  return Object.defineProperty(__webpack_require__(__webpack_module_template_argument_2__)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 1598 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 1599 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(__webpack_module_template_argument_0__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_1__)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 1600 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 1601 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ },
/* 1602 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 1603 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	var create = __webpack_require__(__webpack_module_template_argument_0__);
	var descriptor = __webpack_require__(__webpack_module_template_argument_1__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_2__);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(__webpack_module_template_argument_3__)(IteratorPrototype, __webpack_require__(__webpack_module_template_argument_4__)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 1604 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__) {

	'use strict';
	var LIBRARY = __webpack_require__(__webpack_module_template_argument_0__);
	var $export = __webpack_require__(__webpack_module_template_argument_1__);
	var redefine = __webpack_require__(__webpack_module_template_argument_2__);
	var hide = __webpack_require__(__webpack_module_template_argument_3__);
	var has = __webpack_require__(__webpack_module_template_argument_4__);
	var Iterators = __webpack_require__(__webpack_module_template_argument_5__);
	var $iterCreate = __webpack_require__(__webpack_module_template_argument_6__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_7__);
	var getPrototypeOf = __webpack_require__(__webpack_module_template_argument_8__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_9__)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 1605 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var ITERATOR = __webpack_require__(__webpack_module_template_argument_0__)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 1606 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var META = __webpack_require__(__webpack_module_template_argument_0__)('meta');
	var isObject = __webpack_require__(__webpack_module_template_argument_1__);
	var has = __webpack_require__(__webpack_module_template_argument_2__);
	var setDesc = __webpack_require__(__webpack_module_template_argument_3__).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(__webpack_module_template_argument_4__)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 1607 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var macrotask = __webpack_require__(__webpack_module_template_argument_1__).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(__webpack_module_template_argument_2__)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    var promise = Promise.resolve();
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ },
/* 1608 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(__webpack_module_template_argument_0__);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ },
/* 1609 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(__webpack_module_template_argument_0__);
	var gOPS = __webpack_require__(__webpack_module_template_argument_1__);
	var pIE = __webpack_require__(__webpack_module_template_argument_2__);
	var toObject = __webpack_require__(__webpack_module_template_argument_3__);
	var IObject = __webpack_require__(__webpack_module_template_argument_4__);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(__webpack_module_template_argument_5__)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ },
/* 1610 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var dPs = __webpack_require__(__webpack_module_template_argument_1__);
	var enumBugKeys = __webpack_require__(__webpack_module_template_argument_2__);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_3__)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(__webpack_module_template_argument_4__)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(__webpack_module_template_argument_5__).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 1611 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_1__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_2__);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(__webpack_module_template_argument_3__) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 1612 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var dP = __webpack_require__(__webpack_module_template_argument_0__);
	var anObject = __webpack_require__(__webpack_module_template_argument_1__);
	var getKeys = __webpack_require__(__webpack_module_template_argument_2__);
	
	module.exports = __webpack_require__(__webpack_module_template_argument_3__) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 1613 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	var pIE = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_2__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_3__);
	var has = __webpack_require__(__webpack_module_template_argument_4__);
	var IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_5__);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(__webpack_module_template_argument_6__) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 1614 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(__webpack_module_template_argument_0__);
	var gOPN = __webpack_require__(__webpack_module_template_argument_1__).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 1615 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(__webpack_module_template_argument_0__);
	var hiddenKeys = __webpack_require__(__webpack_module_template_argument_1__).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 1616 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(__webpack_module_template_argument_0__);
	var toObject = __webpack_require__(__webpack_module_template_argument_1__);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_2__)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 1617 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var has = __webpack_require__(__webpack_module_template_argument_0__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_1__);
	var arrayIndexOf = __webpack_require__(__webpack_module_template_argument_2__)(false);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_3__)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 1618 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(__webpack_module_template_argument_0__);
	var enumBugKeys = __webpack_require__(__webpack_module_template_argument_1__);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 1619 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var core = __webpack_require__(__webpack_module_template_argument_1__);
	var fails = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 1620 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var getKeys = __webpack_require__(__webpack_module_template_argument_0__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_1__);
	var isEnum = __webpack_require__(__webpack_module_template_argument_2__).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) if (isEnum.call(O, key = keys[i++])) {
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};


/***/ },
/* 1621 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var isObject = __webpack_require__(__webpack_module_template_argument_1__);
	var newPromiseCapability = __webpack_require__(__webpack_module_template_argument_2__);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ },
/* 1622 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var aFunction = __webpack_require__(__webpack_module_template_argument_1__);
	var ctx = __webpack_require__(__webpack_module_template_argument_2__);
	var forOf = __webpack_require__(__webpack_module_template_argument_3__);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ },
/* 1623 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ },
/* 1624 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var anObject = __webpack_require__(__webpack_module_template_argument_1__);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(__webpack_module_template_argument_2__)(Function.call, __webpack_require__(__webpack_module_template_argument_3__).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 1625 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var def = __webpack_require__(__webpack_module_template_argument_0__).f;
	var has = __webpack_require__(__webpack_module_template_argument_1__);
	var TAG = __webpack_require__(__webpack_module_template_argument_2__)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 1626 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var shared = __webpack_require__(__webpack_module_template_argument_0__)('keys');
	var uid = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 1627 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ },
/* 1628 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var aFunction = __webpack_require__(__webpack_module_template_argument_1__);
	var SPECIES = __webpack_require__(__webpack_module_template_argument_2__)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ },
/* 1629 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var defined = __webpack_require__(__webpack_module_template_argument_1__);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 1630 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var ctx = __webpack_require__(__webpack_module_template_argument_0__);
	var invoke = __webpack_require__(__webpack_module_template_argument_1__);
	var html = __webpack_require__(__webpack_module_template_argument_2__);
	var cel = __webpack_require__(__webpack_module_template_argument_3__);
	var global = __webpack_require__(__webpack_module_template_argument_4__);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(__webpack_module_template_argument_5__)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ },
/* 1631 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 1632 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(__webpack_module_template_argument_0__);
	var defined = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 1633 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 1634 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 1635 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 1636 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ },
/* 1637 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var core = __webpack_require__(__webpack_module_template_argument_1__);
	var LIBRARY = __webpack_require__(__webpack_module_template_argument_2__);
	var wksExt = __webpack_require__(__webpack_module_template_argument_3__);
	var defineProperty = __webpack_require__(__webpack_module_template_argument_4__).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 1638 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	exports.f = __webpack_require__(__webpack_module_template_argument_0__);


/***/ },
/* 1639 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var store = __webpack_require__(__webpack_module_template_argument_0__)('wks');
	var uid = __webpack_require__(__webpack_module_template_argument_1__);
	var Symbol = __webpack_require__(__webpack_module_template_argument_2__).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 1640 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var classof = __webpack_require__(__webpack_module_template_argument_0__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_1__)('iterator');
	var Iterators = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = __webpack_require__(__webpack_module_template_argument_3__).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 1641 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__) {

	'use strict';
	var ctx = __webpack_require__(__webpack_module_template_argument_0__);
	var $export = __webpack_require__(__webpack_module_template_argument_1__);
	var toObject = __webpack_require__(__webpack_module_template_argument_2__);
	var call = __webpack_require__(__webpack_module_template_argument_3__);
	var isArrayIter = __webpack_require__(__webpack_module_template_argument_4__);
	var toLength = __webpack_require__(__webpack_module_template_argument_5__);
	var createProperty = __webpack_require__(__webpack_module_template_argument_6__);
	var getIterFn = __webpack_require__(__webpack_module_template_argument_7__);
	
	$export($export.S + $export.F * !__webpack_require__(__webpack_module_template_argument_8__)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 1642 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	var addToUnscopables = __webpack_require__(__webpack_module_template_argument_0__);
	var step = __webpack_require__(__webpack_module_template_argument_1__);
	var Iterators = __webpack_require__(__webpack_module_template_argument_2__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_3__);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(__webpack_module_template_argument_4__)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 1643 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(__webpack_module_template_argument_1__) });


/***/ },
/* 1644 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(__webpack_module_template_argument_1__) });


/***/ },
/* 1645 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(__webpack_module_template_argument_1__) });


/***/ },
/* 1646 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(__webpack_module_template_argument_1__), 'Object', { defineProperty: __webpack_require__(__webpack_module_template_argument_2__).f });


/***/ },
/* 1647 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(__webpack_module_template_argument_0__);
	var $getPrototypeOf = __webpack_require__(__webpack_module_template_argument_1__);
	
	__webpack_require__(__webpack_module_template_argument_2__)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 1648 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(__webpack_module_template_argument_0__);
	var $keys = __webpack_require__(__webpack_module_template_argument_1__);
	
	__webpack_require__(__webpack_module_template_argument_2__)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ },
/* 1649 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(__webpack_module_template_argument_1__).set });


/***/ },
/* 1650 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__, __webpack_module_template_argument_10__, __webpack_module_template_argument_11__, __webpack_module_template_argument_12__, __webpack_module_template_argument_13__, __webpack_module_template_argument_14__, __webpack_module_template_argument_15__, __webpack_module_template_argument_16__, __webpack_module_template_argument_17__, __webpack_module_template_argument_18__, __webpack_module_template_argument_19__, __webpack_module_template_argument_20__) {

	'use strict';
	var LIBRARY = __webpack_require__(__webpack_module_template_argument_0__);
	var global = __webpack_require__(__webpack_module_template_argument_1__);
	var ctx = __webpack_require__(__webpack_module_template_argument_2__);
	var classof = __webpack_require__(__webpack_module_template_argument_3__);
	var $export = __webpack_require__(__webpack_module_template_argument_4__);
	var isObject = __webpack_require__(__webpack_module_template_argument_5__);
	var aFunction = __webpack_require__(__webpack_module_template_argument_6__);
	var anInstance = __webpack_require__(__webpack_module_template_argument_7__);
	var forOf = __webpack_require__(__webpack_module_template_argument_8__);
	var speciesConstructor = __webpack_require__(__webpack_module_template_argument_9__);
	var task = __webpack_require__(__webpack_module_template_argument_10__).set;
	var microtask = __webpack_require__(__webpack_module_template_argument_11__)();
	var newPromiseCapabilityModule = __webpack_require__(__webpack_module_template_argument_12__);
	var perform = __webpack_require__(__webpack_module_template_argument_13__);
	var promiseResolve = __webpack_require__(__webpack_module_template_argument_14__);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(__webpack_module_template_argument_15__)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value);
	            if (domain) domain.exit();
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(__webpack_module_template_argument_16__)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(__webpack_module_template_argument_17__)($Promise, PROMISE);
	__webpack_require__(__webpack_module_template_argument_18__)(PROMISE);
	Wrapper = __webpack_require__(__webpack_module_template_argument_19__)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(__webpack_module_template_argument_20__)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ },
/* 1651 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	var strong = __webpack_require__(__webpack_module_template_argument_0__);
	var validate = __webpack_require__(__webpack_module_template_argument_1__);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(__webpack_module_template_argument_2__)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ },
/* 1652 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	var $at = __webpack_require__(__webpack_module_template_argument_0__)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(__webpack_module_template_argument_1__)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 1653 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__, __webpack_module_template_argument_10__, __webpack_module_template_argument_11__, __webpack_module_template_argument_12__, __webpack_module_template_argument_13__, __webpack_module_template_argument_14__, __webpack_module_template_argument_15__, __webpack_module_template_argument_16__, __webpack_module_template_argument_17__, __webpack_module_template_argument_18__, __webpack_module_template_argument_19__, __webpack_module_template_argument_20__, __webpack_module_template_argument_21__, __webpack_module_template_argument_22__, __webpack_module_template_argument_23__, __webpack_module_template_argument_24__, __webpack_module_template_argument_25__, __webpack_module_template_argument_26__, __webpack_module_template_argument_27__, __webpack_module_template_argument_28__, __webpack_module_template_argument_29__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var has = __webpack_require__(__webpack_module_template_argument_1__);
	var DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_2__);
	var $export = __webpack_require__(__webpack_module_template_argument_3__);
	var redefine = __webpack_require__(__webpack_module_template_argument_4__);
	var META = __webpack_require__(__webpack_module_template_argument_5__).KEY;
	var $fails = __webpack_require__(__webpack_module_template_argument_6__);
	var shared = __webpack_require__(__webpack_module_template_argument_7__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_8__);
	var uid = __webpack_require__(__webpack_module_template_argument_9__);
	var wks = __webpack_require__(__webpack_module_template_argument_10__);
	var wksExt = __webpack_require__(__webpack_module_template_argument_11__);
	var wksDefine = __webpack_require__(__webpack_module_template_argument_12__);
	var enumKeys = __webpack_require__(__webpack_module_template_argument_13__);
	var isArray = __webpack_require__(__webpack_module_template_argument_14__);
	var anObject = __webpack_require__(__webpack_module_template_argument_15__);
	var isObject = __webpack_require__(__webpack_module_template_argument_16__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_17__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_18__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_19__);
	var _create = __webpack_require__(__webpack_module_template_argument_20__);
	var gOPNExt = __webpack_require__(__webpack_module_template_argument_21__);
	var $GOPD = __webpack_require__(__webpack_module_template_argument_22__);
	var $DP = __webpack_require__(__webpack_module_template_argument_23__);
	var $keys = __webpack_require__(__webpack_module_template_argument_24__);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(__webpack_module_template_argument_25__).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(__webpack_module_template_argument_26__).f = $propertyIsEnumerable;
	  __webpack_require__(__webpack_module_template_argument_27__).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(__webpack_module_template_argument_28__)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(__webpack_module_template_argument_29__)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 1654 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var $entries = __webpack_require__(__webpack_module_template_argument_1__)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ },
/* 1655 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var core = __webpack_require__(__webpack_module_template_argument_1__);
	var global = __webpack_require__(__webpack_module_template_argument_2__);
	var speciesConstructor = __webpack_require__(__webpack_module_template_argument_3__);
	var promiseResolve = __webpack_require__(__webpack_module_template_argument_4__);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ },
/* 1656 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var newPromiseCapability = __webpack_require__(__webpack_module_template_argument_1__);
	var perform = __webpack_require__(__webpack_module_template_argument_2__);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ },
/* 1657 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(__webpack_module_template_argument_0__)('Set');


/***/ },
/* 1658 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(__webpack_module_template_argument_0__)('Set');


/***/ },
/* 1659 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(__webpack_module_template_argument_1__)('Set') });


/***/ },
/* 1660 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	__webpack_require__(__webpack_module_template_argument_0__)('asyncIterator');


/***/ },
/* 1661 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	__webpack_require__(__webpack_module_template_argument_0__)('observable');


/***/ }
]);


/** WEBPACK FOOTER **
 ** app.a4f6f49b926d02ce1e2f.js
 **/